var _objectSpread = require("/codebuild/output/src3856751355/src/noble-app-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _defineProperty = require("/codebuild/output/src3856751355/src/noble-app-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _get = require("/codebuild/output/src3856751355/src/noble-app-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");
var _assertThisInitialized = require("/codebuild/output/src3856751355/src/noble-app-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");
var _construct = require("/codebuild/output/src3856751355/src/noble-app-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/construct");
var _slicedToArray = require("/codebuild/output/src3856751355/src/noble-app-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _toConsumableArray = require("/codebuild/output/src3856751355/src/noble-app-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _classCallCheck = require("/codebuild/output/src3856751355/src/noble-app-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/codebuild/output/src3856751355/src/noble-app-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/codebuild/output/src3856751355/src/noble-app-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/codebuild/output/src3856751355/src/noble-app-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/codebuild/output/src3856751355/src/noble-app-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _wrapNativeSuper = require("/codebuild/output/src3856751355/src/noble-app-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e367) { throw _e367; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e368) { didErr = true; err = _e368; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/*!
 * @license Copyright (c) 2003-2022, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md.
 */
!function (t) {
  var e = t.en = t.en || {};
  e.dictionary = Object.assign(e.dictionary || {}, {
    "%0 of %1": "%0 of %1",
    "Align center": "Align center",
    "Align left": "Align left",
    "Align right": "Align right",
    Aquamarine: "Aquamarine",
    Big: "Big",
    Black: "Black",
    "Block quote": "Block quote",
    Blue: "Blue",
    Bold: "Bold",
    "Break text": "Break text",
    "Bulleted List": "Bulleted List",
    Cancel: "Cancel",
    "Centered image": "Centered image",
    "Change image text alternative": "Change image text alternative",
    "Choose heading": "Choose heading",
    Column: "Column",
    "Decrease indent": "Decrease indent",
    Default: "Default",
    "Delete column": "Delete column",
    "Delete row": "Delete row",
    "Dim grey": "Dim grey",
    "Document colors": "Document colors",
    Downloadable: "Downloadable",
    "Dropdown toolbar": "Dropdown toolbar",
    "Edit block": "Edit block",
    "Edit link": "Edit link",
    "Edit source": "Edit source",
    "Editor toolbar": "Editor toolbar",
    "Empty snippet content": "Empty snippet content",
    "Enter image caption": "Enter image caption",
    "Font Color": "Font Color",
    "Font Family": "Font Family",
    "Font Size": "Font Size",
    "Full size image": "Full size image",
    Green: "Green",
    Grey: "Grey",
    "Header column": "Header column",
    "Header row": "Header row",
    Heading: "Heading",
    "Heading 1": "Heading 1",
    "Heading 2": "Heading 2",
    "Heading 3": "Heading 3",
    "Heading 4": "Heading 4",
    "Heading 5": "Heading 5",
    "Heading 6": "Heading 6",
    "HTML snippet": "HTML snippet",
    Huge: "Huge",
    "Image toolbar": "Image toolbar",
    "image widget": "image widget",
    "In line": "In line",
    "Increase indent": "Increase indent",
    "Insert column left": "Insert column left",
    "Insert column right": "Insert column right",
    "Insert HTML": "Insert HTML",
    "Insert image": "Insert image",
    "Insert media": "Insert media",
    "Insert paragraph after block": "Insert paragraph after block",
    "Insert paragraph before block": "Insert paragraph before block",
    "Insert row above": "Insert row above",
    "Insert row below": "Insert row below",
    "Insert table": "Insert table",
    Italic: "Italic",
    Justify: "Justify",
    "Left aligned image": "Left aligned image",
    "Light blue": "Light blue",
    "Light green": "Light green",
    "Light grey": "Light grey",
    Link: "Link",
    "Link URL": "Link URL",
    "Media URL": "Media URL",
    "media widget": "media widget",
    "Merge cell down": "Merge cell down",
    "Merge cell left": "Merge cell left",
    "Merge cell right": "Merge cell right",
    "Merge cell up": "Merge cell up",
    "Merge cells": "Merge cells",
    Next: "Next",
    "No preview available": "No preview available",
    "Numbered List": "Numbered List",
    "Open in a new tab": "Open in a new tab",
    "Open link in new tab": "Open link in new tab",
    Orange: "Orange",
    Paragraph: "Paragraph",
    "Paste raw HTML here...": "Paste raw HTML here...",
    "Paste the media URL in the input.": "Paste the media URL in the input.",
    Previous: "Previous",
    Purple: "Purple",
    Red: "Red",
    Redo: "Redo",
    "Remove color": "Remove color",
    "Rich Text Editor": "Rich Text Editor",
    "Rich Text Editor, %0": "Rich Text Editor, %0",
    "Right aligned image": "Right aligned image",
    Row: "Row",
    Save: "Save",
    "Save changes": "Save changes",
    "Select all": "Select all",
    "Select column": "Select column",
    "Select row": "Select row",
    "Show more items": "Show more items",
    "Side image": "Side image",
    Small: "Small",
    "Split cell horizontally": "Split cell horizontally",
    "Split cell vertically": "Split cell vertically",
    "Table toolbar": "Table toolbar",
    "Text alignment": "Text alignment",
    "Text alignment toolbar": "Text alignment toolbar",
    "Text alternative": "Text alternative",
    "The URL must not be empty.": "The URL must not be empty.",
    "This link has no URL": "This link has no URL",
    "This media URL is not supported.": "This media URL is not supported.",
    Tiny: "Tiny",
    "Tip: Paste the URL into the content to embed faster.": "Tip: Paste the URL into the content to embed faster.",
    "Toggle caption off": "Toggle caption off",
    "Toggle caption on": "Toggle caption on",
    Turquoise: "Turquoise",
    Underline: "Underline",
    Undo: "Undo",
    Unlink: "Unlink",
    "Upload failed": "Upload failed",
    "Upload in progress": "Upload in progress",
    White: "White",
    "Widget toolbar": "Widget toolbar",
    "Wrap text": "Wrap text",
    Yellow: "Yellow"
  });
}(window.CKEDITOR_TRANSLATIONS || (window.CKEDITOR_TRANSLATIONS = {})), function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define([], e) : "object" == typeof exports ? exports.ClassicEditor = e() : t.ClassicEditor = e();
}(window, function () {
  return function (t) {
    var e = {};
    function n(o) {
      if (e[o]) return e[o].exports;
      var i = e[o] = {
        i: o,
        l: !1,
        exports: {}
      };
      return t[o].call(i.exports, i, i.exports, n), i.l = !0, i.exports;
    }
    return n.m = t, n.c = e, n.d = function (t, e, o) {
      n.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: o
      });
    }, n.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, n.t = function (t, e) {
      if (1 & e && (t = n(t)), 8 & e) return t;
      if (4 & e && "object" == typeof t && t && t.__esModule) return t;
      var o = Object.create(null);
      if (n.r(o), Object.defineProperty(o, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var i in t) n.d(o, i, function (e) {
        return t[e];
      }.bind(null, i));
      return o;
    }, n.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return n.d(e, "a", e), e;
    }, n.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, n.p = "", n(n.s = 65);
  }([function (t, e, n) {
    "use strict";

    n.d(e, "a", function () {
      return o;
    }), n.d(e, "b", function () {
      return i;
    });
    var o = /*#__PURE__*/function (_Error) {
      _inherits(o, _Error);
      function o(t, e, n) {
        var _this;
        _classCallCheck(this, o);
        _this = _possibleConstructorReturn(this, _getPrototypeOf(o).call(this, "".concat(t).concat(n ? " ".concat(JSON.stringify(n)) : "").concat(r(t)))), _this.name = "CKEditorError", _this.context = e, _this.data = n;
        return _this;
      }
      _createClass(o, [{
        key: "is",
        value: function is(t) {
          return "CKEditorError" === t;
        }
      }], [{
        key: "rethrowUnexpectedError",
        value: function rethrowUnexpectedError(t, e) {
          if (t.is && t.is("CKEditorError")) throw t;
          var n = new o(t.message, e);
          throw n.stack = t.stack, n;
        }
      }]);
      return o;
    }(_wrapNativeSuper(Error));
    function i(t, e) {
      var _console;
      (_console = console).warn.apply(_console, _toConsumableArray(s(t, e)));
    }
    function r(t) {
      return "\nRead more: https://ckeditor.com/docs/ckeditor5/latest/framework/guides/support/error-codes.html#error-".concat(t);
    }
    function s(t, e) {
      var n = r(t);
      return e ? [t, e, n] : [t, n];
    }
  }, function (t, e, n) {
    "use strict";

    var o,
      i = function i() {
        return void 0 === o && (o = Boolean(window && document && document.all && !window.atob)), o;
      },
      r = function () {
        var t = {};
        return function (e) {
          if (void 0 === t[e]) {
            var n = document.querySelector(e);
            if (window.HTMLIFrameElement && n instanceof window.HTMLIFrameElement) try {
              n = n.contentDocument.head;
            } catch (t) {
              n = null;
            }
            t[e] = n;
          }
          return t[e];
        };
      }(),
      s = [];
    function a(t) {
      for (var e = -1, n = 0; n < s.length; n++) if (s[n].identifier === t) {
        e = n;
        break;
      }
      return e;
    }
    function c(t, e) {
      for (var n = {}, o = [], i = 0; i < t.length; i++) {
        var r = t[i],
          c = e.base ? r[0] + e.base : r[0],
          l = n[c] || 0,
          d = "".concat(c, " ").concat(l);
        n[c] = l + 1;
        var h = a(d),
          u = {
            css: r[1],
            media: r[2],
            sourceMap: r[3]
          };
        -1 !== h ? (s[h].references++, s[h].updater(u)) : s.push({
          identifier: d,
          updater: f(u, e),
          references: 1
        }), o.push(d);
      }
      return o;
    }
    function l(t) {
      var e = document.createElement("style"),
        o = t.attributes || {};
      if (void 0 === o.nonce) {
        var i = n.nc;
        i && (o.nonce = i);
      }
      if (Object.keys(o).forEach(function (t) {
        e.setAttribute(t, o[t]);
      }), "function" == typeof t.insert) t.insert(e);else {
        var s = r(t.insert || "head");
        if (!s) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
        s.appendChild(e);
      }
      return e;
    }
    var d,
      h = (d = [], function (t, e) {
        return d[t] = e, d.filter(Boolean).join("\n");
      });
    function u(t, e, n, o) {
      var i = n ? "" : o.media ? "@media ".concat(o.media, " {").concat(o.css, "}") : o.css;
      if (t.styleSheet) t.styleSheet.cssText = h(e, i);else {
        var r = document.createTextNode(i),
          s = t.childNodes;
        s[e] && t.removeChild(s[e]), s.length ? t.insertBefore(r, s[e]) : t.appendChild(r);
      }
    }
    function g(t, e, n) {
      var o = n.css,
        i = n.media,
        r = n.sourceMap;
      if (i ? t.setAttribute("media", i) : t.removeAttribute("media"), r && "undefined" != typeof btoa && (o += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(r)))), " */")), t.styleSheet) t.styleSheet.cssText = o;else {
        for (; t.firstChild;) t.removeChild(t.firstChild);
        t.appendChild(document.createTextNode(o));
      }
    }
    var m = null,
      p = 0;
    function f(t, e) {
      var n, o, i;
      if (e.singleton) {
        var r = p++;
        n = m || (m = l(e)), o = u.bind(null, n, r, !1), i = u.bind(null, n, r, !0);
      } else n = l(e), o = g.bind(null, n, e), i = function i() {
        !function (t) {
          if (null === t.parentNode) return !1;
          t.parentNode.removeChild(t);
        }(n);
      };
      return o(t), function (e) {
        if (e) {
          if (e.css === t.css && e.media === t.media && e.sourceMap === t.sourceMap) return;
          o(t = e);
        } else i();
      };
    }
    t.exports = function (t, e) {
      (e = e || {}).singleton || "boolean" == typeof e.singleton || (e.singleton = i());
      var n = c(t = t || [], e);
      return function (t) {
        if (t = t || [], "[object Array]" === Object.prototype.toString.call(t)) {
          for (var o = 0; o < n.length; o++) {
            var i = a(n[o]);
            s[i].references--;
          }
          for (var r = c(t, e), l = 0; l < n.length; l++) {
            var d = a(n[l]);
            0 === s[d].references && (s[d].updater(), s.splice(d, 1));
          }
          n = r;
        }
      };
    };
  }, function (t, e, n) {
    "use strict";

    function o(t, e) {
      return function (t) {
        if (Array.isArray(t)) return t;
      }(t) || function (t, e) {
        var n = t && ("undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"]);
        if (null == n) return;
        var o,
          i,
          r = [],
          s = !0,
          a = !1;
        try {
          for (n = n.call(t); !(s = (o = n.next()).done) && (r.push(o.value), !e || r.length !== e); s = !0);
        } catch (t) {
          a = !0, i = t;
        } finally {
          try {
            s || null == n.return || n.return();
          } finally {
            if (a) throw i;
          }
        }
        return r;
      }(t, e) || function (t, e) {
        if (!t) return;
        if ("string" == typeof t) return i(t, e);
        var n = Object.prototype.toString.call(t).slice(8, -1);
        "Object" === n && t.constructor && (n = t.constructor.name);
        if ("Map" === n || "Set" === n) return Array.from(t);
        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return i(t, e);
      }(t, e) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }
    function i(t, e) {
      (null == e || e > t.length) && (e = t.length);
      for (var n = 0, o = new Array(e); n < e; n++) o[n] = t[n];
      return o;
    }
    t.exports = function (t) {
      var e = o(t, 4),
        n = e[1],
        i = e[3];
      if (!i) return n;
      if ("function" == typeof btoa) {
        var r = btoa(unescape(encodeURIComponent(JSON.stringify(i)))),
          s = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(r),
          a = "/*# ".concat(s, " */"),
          c = i.sources.map(function (t) {
            return "/*# sourceURL=".concat(i.sourceRoot || "").concat(t, " */");
          });
        return [n].concat(c).concat([a]).join("\n");
      }
      return [n].join("\n");
    };
  }, function (t, e, n) {
    "use strict";

    t.exports = function (t) {
      var e = [];
      return e.toString = function () {
        return this.map(function (e) {
          var n = t(e);
          return e[2] ? "@media ".concat(e[2], " {").concat(n, "}") : n;
        }).join("");
      }, e.i = function (t, n, o) {
        "string" == typeof t && (t = [[null, t, ""]]);
        var i = {};
        if (o) for (var r = 0; r < this.length; r++) {
          var s = this[r][0];
          null != s && (i[s] = !0);
        }
        for (var a = 0; a < t.length; a++) {
          var c = [].concat(t[a]);
          o && i[c[0]] || (n && (c[2] ? c[2] = "".concat(n, " and ").concat(c[2]) : c[2] = n), e.push(c));
        }
      }, e;
    };
  },, function (t, e, n) {
    "use strict";

    var o = n(9),
      i = "object" == typeof self && self && self.Object === Object && self,
      r = o.a || i || Function("return this")();
    e.a = r;
  }, function (t, e, n) {
    "use strict";

    (function (t) {
      var o = n(5),
        i = n(64),
        r = "object" == typeof exports && exports && !exports.nodeType && exports,
        s = r && "object" == typeof t && t && !t.nodeType && t,
        a = s && s.exports === r ? o.a.Buffer : void 0,
        c = (a ? a.isBuffer : void 0) || i.a;
      e.a = c;
    }).call(this, n(11)(t));
  }, function (t, e, n) {
    "use strict";

    (function (t) {
      var o = n(9),
        i = "object" == typeof exports && exports && !exports.nodeType && exports,
        r = i && "object" == typeof t && t && !t.nodeType && t,
        s = r && r.exports === i && o.a.process,
        a = function () {
          try {
            var t = r && r.require && r.require("util").types;
            return t || s && s.binding && s.binding("util");
          } catch (t) {}
        }();
      e.a = a;
    }).call(this, n(11)(t));
  }, function (t, e, n) {
    "use strict";

    (function (t) {
      var e = n(0);
      var o = "29.0.0";
      var i = "object" == typeof window ? window : t;
      if (i.CKEDITOR_VERSION) throw new e.a("ckeditor-duplicated-modules", null);
      i.CKEDITOR_VERSION = o;
    }).call(this, n(63));
  }, function (t, e, n) {
    "use strict";

    (function (t) {
      var n = "object" == typeof t && t && t.Object === Object && t;
      e.a = n;
    }).call(this, n(63));
  }, function (t, e, n) {
    "use strict";

    (function (t) {
      var o = n(5),
        i = "object" == typeof exports && exports && !exports.nodeType && exports,
        r = i && "object" == typeof t && t && !t.nodeType && t,
        s = r && r.exports === i ? o.a.Buffer : void 0,
        a = s ? s.allocUnsafe : void 0;
      e.a = function (t, e) {
        if (e) return t.slice();
        var n = t.length,
          o = a ? a(n) : new t.constructor(n);
        return t.copy(o), o;
      };
    }).call(this, n(11)(t));
  }, function (t, e) {
    t.exports = function (t) {
      if (!t.webpackPolyfill) {
        var e = Object.create(t);
        e.children || (e.children = []), Object.defineProperty(e, "loaded", {
          enumerable: !0,
          get: function get() {
            return e.l;
          }
        }), Object.defineProperty(e, "id", {
          enumerable: !0,
          get: function get() {
            return e.i;
          }
        }), Object.defineProperty(e, "exports", {
          enumerable: !0
        }), e.webpackPolyfill = 1;
      }
      return e;
    };
  }, function (t, e, n) {
    "use strict";

    var o = n(2),
      i = n.n(o),
      r = n(3),
      s = n.n(r)()(i.a);
    s.push([t.i, ".ck-hidden{display:none!important}.ck.ck-reset,.ck.ck-reset_all,.ck.ck-reset_all *{box-sizing:border-box;width:auto;height:auto;position:static}:root{--ck-z-default:1;--ck-z-modal:calc(var(--ck-z-default) + 999)}.ck-transitions-disabled,.ck-transitions-disabled *{transition:none!important}:root{--ck-color-base-foreground:#fafafa;--ck-color-base-background:#fff;--ck-color-base-border:#c4c4c4;--ck-color-base-action:#61b045;--ck-color-base-focus:#6cb5f9;--ck-color-base-text:#333;--ck-color-base-active:#198cf0;--ck-color-base-active-focus:#0e7fe1;--ck-color-base-error:#db3700;--ck-color-focus-border-coordinates:208,79%,51%;--ck-color-focus-border:hsl(var(--ck-color-focus-border-coordinates));--ck-color-focus-outer-shadow:#bcdefb;--ck-color-focus-disabled-shadow:rgba(119,186,248,0.3);--ck-color-focus-error-shadow:rgba(255,64,31,0.3);--ck-color-text:var(--ck-color-base-text);--ck-color-shadow-drop:rgba(0,0,0,0.15);--ck-color-shadow-drop-active:rgba(0,0,0,0.2);--ck-color-shadow-inner:rgba(0,0,0,0.1);--ck-color-button-default-background:transparent;--ck-color-button-default-hover-background:#e6e6e6;--ck-color-button-default-active-background:#d9d9d9;--ck-color-button-default-active-shadow:#bfbfbf;--ck-color-button-default-disabled-background:transparent;--ck-color-button-on-background:#dedede;--ck-color-button-on-hover-background:#c4c4c4;--ck-color-button-on-active-background:#bababa;--ck-color-button-on-active-shadow:#a1a1a1;--ck-color-button-on-disabled-background:#dedede;--ck-color-button-action-background:var(--ck-color-base-action);--ck-color-button-action-hover-background:#579e3d;--ck-color-button-action-active-background:#53973b;--ck-color-button-action-active-shadow:#498433;--ck-color-button-action-disabled-background:#7ec365;--ck-color-button-action-text:var(--ck-color-base-background);--ck-color-button-save:#008a00;--ck-color-button-cancel:#db3700;--ck-color-switch-button-off-background:#b0b0b0;--ck-color-switch-button-off-hover-background:#a3a3a3;--ck-color-switch-button-on-background:var(--ck-color-button-action-background);--ck-color-switch-button-on-hover-background:#579e3d;--ck-color-switch-button-inner-background:var(--ck-color-base-background);--ck-color-switch-button-inner-shadow:rgba(0,0,0,0.1);--ck-color-dropdown-panel-background:var(--ck-color-base-background);--ck-color-dropdown-panel-border:var(--ck-color-base-border);--ck-color-input-background:var(--ck-color-base-background);--ck-color-input-border:#c7c7c7;--ck-color-input-error-border:var(--ck-color-base-error);--ck-color-input-text:var(--ck-color-base-text);--ck-color-input-disabled-background:#f2f2f2;--ck-color-input-disabled-border:#c7c7c7;--ck-color-input-disabled-text:#757575;--ck-color-list-background:var(--ck-color-base-background);--ck-color-list-button-hover-background:var(--ck-color-button-default-hover-background);--ck-color-list-button-on-background:var(--ck-color-base-active);--ck-color-list-button-on-background-focus:var(--ck-color-base-active-focus);--ck-color-list-button-on-text:var(--ck-color-base-background);--ck-color-panel-background:var(--ck-color-base-background);--ck-color-panel-border:var(--ck-color-base-border);--ck-color-toolbar-background:var(--ck-color-base-foreground);--ck-color-toolbar-border:var(--ck-color-base-border);--ck-color-tooltip-background:var(--ck-color-base-text);--ck-color-tooltip-text:var(--ck-color-base-background);--ck-color-engine-placeholder-text:#707070;--ck-color-upload-bar-background:#6cb5f9;--ck-color-link-default:#0000f0;--ck-color-link-selected-background:rgba(31,177,255,0.1);--ck-color-link-fake-selection:rgba(31,177,255,0.3);--ck-disabled-opacity:.5;--ck-focus-outer-shadow-geometry:0 0 0 3px;--ck-focus-outer-shadow:var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-outer-shadow);--ck-focus-disabled-outer-shadow:var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-disabled-shadow);--ck-focus-error-outer-shadow:var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-error-shadow);--ck-focus-ring:1px solid var(--ck-color-focus-border);--ck-font-size-base:13px;--ck-line-height-base:1.84615;--ck-font-face:Helvetica,Arial,Tahoma,Verdana,Sans-Serif;--ck-font-size-tiny:0.7em;--ck-font-size-small:0.75em;--ck-font-size-normal:1em;--ck-font-size-big:1.4em;--ck-font-size-large:1.8em;--ck-ui-component-min-height:2.3em}.ck.ck-reset,.ck.ck-reset_all,.ck.ck-reset_all *{margin:0;padding:0;border:0;background:transparent;text-decoration:none;vertical-align:middle;transition:none;word-wrap:break-word}.ck.ck-reset_all,.ck.ck-reset_all *{border-collapse:collapse;font:normal normal normal var(--ck-font-size-base)/var(--ck-line-height-base) var(--ck-font-face);color:var(--ck-color-text);text-align:left;white-space:nowrap;cursor:auto;float:none}.ck.ck-reset_all .ck-rtl *{text-align:right}.ck.ck-reset_all iframe{vertical-align:inherit}.ck.ck-reset_all textarea{white-space:pre-wrap}.ck.ck-reset_all input[type=password],.ck.ck-reset_all input[type=text],.ck.ck-reset_all textarea{cursor:text}.ck.ck-reset_all input[type=password][disabled],.ck.ck-reset_all input[type=text][disabled],.ck.ck-reset_all textarea[disabled]{cursor:default}.ck.ck-reset_all fieldset{padding:10px;border:2px groove #dfdee3}.ck.ck-reset_all button::-moz-focus-inner{padding:0;border:0}.ck[dir=rtl],.ck[dir=rtl] .ck{text-align:right}:root{--ck-border-radius:2px;--ck-inner-shadow:2px 2px 3px var(--ck-color-shadow-inner) inset;--ck-drop-shadow:0 1px 2px 1px var(--ck-color-shadow-drop);--ck-drop-shadow-active:0 3px 6px 1px var(--ck-color-shadow-drop-active);--ck-spacing-unit:0.6em;--ck-spacing-large:calc(var(--ck-spacing-unit)*1.5);--ck-spacing-standard:var(--ck-spacing-unit);--ck-spacing-medium:calc(var(--ck-spacing-unit)*0.8);--ck-spacing-small:calc(var(--ck-spacing-unit)*0.5);--ck-spacing-tiny:calc(var(--ck-spacing-unit)*0.3);--ck-spacing-extra-tiny:calc(var(--ck-spacing-unit)*0.16)}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/globals/_hidden.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/globals/_reset.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/globals/_zindex.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/globals/_transition.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_colors.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_disabled.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_focus.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_fonts.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_reset.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_rounded.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_shadow.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_spacing.css"],
      names: [],
      mappings: "AAQA,WAGC,sBACD,CCPA,iDAGC,qBAAsB,CACtB,UAAW,CACX,WAAY,CACZ,eACD,CCPA,MACC,gBAAiB,CACjB,4CACD,CCAA,oDAEC,yBACD,CCNA,MACC,kCAAmD,CACnD,+BAAoD,CACpD,8BAAgD,CAChD,8BAAmD,CACnD,6BAAmD,CACnD,yBAA+C,CAC/C,8BAAmD,CACnD,oCAAuD,CACvD,6BAAkD,CAIlD,+CAAwD,CACxD,qEAA+E,CAC/E,qCAAwD,CACxD,sDAA8D,CAC9D,iDAAyD,CACzD,yCAAqD,CACrD,uCAAsD,CACtD,6CAA0D,CAC1D,uCAAsD,CAItD,gDAAuD,CACvD,kDAA+D,CAC/D,mDAAgE,CAChE,+CAA6D,CAC7D,yDAA8D,CAE9D,uCAAuD,CACvD,6CAA4D,CAC5D,8CAA4D,CAC5D,0CAAyD,CACzD,gDAA8D,CAE9D,+DAAsE,CACtE,iDAAkE,CAClE,kDAAkE,CAClE,8CAA+D,CAC/D,oDAAoE,CACpE,6DAAsE,CAEtE,8BAAoD,CACpD,gCAAqD,CAErD,+CAA4D,CAC5D,qDAAiE,CACjE,+EAAqF,CACrF,oDAAmE,CACnE,yEAA8E,CAC9E,qDAAgE,CAIhE,oEAA2E,CAC3E,4DAAoE,CAIpE,2DAAoE,CACpE,+BAAiD,CACjD,wDAAgE,CAChE,+CAA0D,CAC1D,4CAA2D,CAC3D,wCAAwD,CACxD,sCAAsD,CAItD,0DAAmE,CACnE,uFAA6F,CAC7F,gEAAuE,CACvE,4EAAiF,CACjF,8DAAsE,CAItE,2DAAoE,CACpE,mDAA6D,CAI7D,6DAAsE,CACtE,qDAA+D,CAI/D,uDAAgE,CAChE,uDAAiE,CAIjE,0CAAyD,CAIzD,wCAA2D,CAI3D,+BAAoD,CACpD,wDAAmE,CACnE,mDAAgE,CCpGhE,wBAAyB,CCAzB,0CAA2C,CAK3C,gGAAiG,CAKjG,4GAA6G,CAK7G,sGAAuG,CAKvG,sDAAuD,CCvBvD,wBAAyB,CACzB,6BAA8B,CAC9B,wDAA6D,CAE7D,yBAA0B,CAC1B,2BAA4B,CAC5B,yBAA0B,CAC1B,wBAAyB,CACzB,0BAA2B,CCJ3B,kCJoGD,CI9FA,iDAIC,QAAS,CACT,SAAU,CACV,QAAS,CACT,sBAAuB,CACvB,oBAAqB,CACrB,qBAAsB,CACtB,eAAgB,CAGhB,oBACD,CAKA,oCAGC,wBAAyB,CACzB,iGAAkG,CAClG,0BAA2B,CAC3B,eAAgB,CAChB,kBAAmB,CACnB,WAAY,CACZ,UACD,CAGC,2BACC,gBACD,CAEA,wBAEC,sBACD,CAEA,0BACC,oBACD,CAEA,kGAGC,WACD,CAEA,gIAGC,cACD,CAEA,0BACC,YAAa,CACb,yBACD,CAEA,0CAEC,SAAU,CACV,QACD,CAMD,8BAEC,gBACD,CCnFA,MACC,sBAAuB,CCAvB,gEAAiE,CAKjE,0DAA2D,CAK3D,wEAAyE,CCbzE,uBAA8B,CAC9B,mDAA2D,CAC3D,4CAAkD,CAClD,oDAA4D,CAC5D,mDAA2D,CAC3D,kDAA2D,CAC3D,yDFFD",
      sourcesContent: ["/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A class which hides an element in DOM.\n */\n.ck-hidden {\n\t/* Override selector specificity. Otherwise, all elements with some display\n\tstyle defined will override this one, which is not a desired result. */\n\tdisplay: none !important;\n}\n", "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-reset,\n.ck.ck-reset_all,\n.ck.ck-reset_all * {\n\tbox-sizing: border-box;\n\twidth: auto;\n\theight: auto;\n\tposition: static;\n}\n", "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-z-default: 1;\n\t--ck-z-modal: calc( var(--ck-z-default) + 999 );\n}\n", "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A class that disables all transitions of the element and its children.\n */\n.ck-transitions-disabled,\n.ck-transitions-disabled * {\n\ttransition: none !important;\n}\n", "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-base-foreground: \t\t\t\t\t\t\t\thsl(0, 0%, 98%);\n\t--ck-color-base-background: \t\t\t\t\t\t\t\thsl(0, 0%, 100%);\n\t--ck-color-base-border: \t\t\t\t\t\t\t\t\thsl(0, 0%, 77%);\n\t--ck-color-base-action: \t\t\t\t\t\t\t\t\thsl(104, 44%, 48%);\n\t--ck-color-base-focus: \t\t\t\t\t\t\t\t\t\thsl(209, 92%, 70%);\n\t--ck-color-base-text: \t\t\t\t\t\t\t\t\t\thsl(0, 0%, 20%);\n\t--ck-color-base-active: \t\t\t\t\t\t\t\t\thsl(208, 88%, 52%);\n\t--ck-color-base-active-focus:\t\t\t\t\t\t\t\thsl(208, 88%, 47%);\n\t--ck-color-base-error:\t\t\t\t\t\t\t\t\t\thsl(15, 100%, 43%);\n\n\t/* -- Generic colors ------------------------------------------------------------------------ */\n\n\t--ck-color-focus-border-coordinates: \t\t\t\t\t\t208, 79%, 51%;\n\t--ck-color-focus-border: \t\t\t\t\t\t\t\t\thsl(var(--ck-color-focus-border-coordinates));\n\t--ck-color-focus-outer-shadow:\t\t\t\t\t\t\t\thsl(207, 89%, 86%);\n\t--ck-color-focus-disabled-shadow:\t\t\t\t\t\t\thsla(209, 90%, 72%,.3);\n\t--ck-color-focus-error-shadow:\t\t\t\t\t\t\t\thsla(9,100%,56%,.3);\n\t--ck-color-text: \t\t\t\t\t\t\t\t\t\t\tvar(--ck-color-base-text);\n\t--ck-color-shadow-drop: \t\t\t\t\t\t\t\t\thsla(0, 0%, 0%, 0.15);\n\t--ck-color-shadow-drop-active:\t\t\t\t\t\t\t\thsla(0, 0%, 0%, 0.2);\n\t--ck-color-shadow-inner: \t\t\t\t\t\t\t\t\thsla(0, 0%, 0%, 0.1);\n\n\t/* -- Buttons ------------------------------------------------------------------------------- */\n\n\t--ck-color-button-default-background: \t\t\t\t\t\ttransparent;\n\t--ck-color-button-default-hover-background: \t\t\t\thsl(0, 0%, 90%);\n\t--ck-color-button-default-active-background: \t\t\t\thsl(0, 0%, 85%);\n\t--ck-color-button-default-active-shadow: \t\t\t\t\thsl(0, 0%, 75%);\n\t--ck-color-button-default-disabled-background: \t\t\t\ttransparent;\n\n\t--ck-color-button-on-background: \t\t\t\t\t\t\thsl(0, 0%, 87%);\n\t--ck-color-button-on-hover-background: \t\t\t\t\t\thsl(0, 0%, 77%);\n\t--ck-color-button-on-active-background: \t\t\t\t\thsl(0, 0%, 73%);\n\t--ck-color-button-on-active-shadow: \t\t\t\t\t\thsl(0, 0%, 63%);\n\t--ck-color-button-on-disabled-background: \t\t\t\t\thsl(0, 0%, 87%);\n\n\t--ck-color-button-action-background: \t\t\t\t\t\tvar(--ck-color-base-action);\n\t--ck-color-button-action-hover-background: \t\t\t\t\thsl(104, 44%, 43%);\n\t--ck-color-button-action-active-background: \t\t\t\thsl(104, 44%, 41%);\n\t--ck-color-button-action-active-shadow: \t\t\t\t\thsl(104, 44%, 36%);\n\t--ck-color-button-action-disabled-background: \t\t\t\thsl(104, 44%, 58%);\n\t--ck-color-button-action-text: \t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\n\t--ck-color-button-save: \t\t\t\t\t\t\t\t\thsl(120, 100%, 27%);\n\t--ck-color-button-cancel: \t\t\t\t\t\t\t\t\thsl(15, 100%, 43%);\n\n\t--ck-color-switch-button-off-background:\t\t\t\t\thsl(0, 0%, 69%);\n\t--ck-color-switch-button-off-hover-background:\t\t\t\thsl(0, 0%, 64%);\n\t--ck-color-switch-button-on-background:\t\t\t\t\t\tvar(--ck-color-button-action-background);\n\t--ck-color-switch-button-on-hover-background:\t\t\t\thsl(104, 44%, 43%);\n\t--ck-color-switch-button-inner-background:\t\t\t\t\tvar(--ck-color-base-background);\n\t--ck-color-switch-button-inner-shadow:\t\t\t\t\t\thsla(0, 0%, 0%, 0.1);\n\n\t/* -- Dropdown ------------------------------------------------------------------------------ */\n\n\t--ck-color-dropdown-panel-background: \t\t\t\t\t\tvar(--ck-color-base-background);\n\t--ck-color-dropdown-panel-border: \t\t\t\t\t\t\tvar(--ck-color-base-border);\n\n\t/* -- Input --------------------------------------------------------------------------------- */\n\n\t--ck-color-input-background: \t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\t--ck-color-input-border: \t\t\t\t\t\t\t\t\thsl(0, 0%, 78%);\n\t--ck-color-input-error-border:\t\t\t\t\t\t\t\tvar(--ck-color-base-error);\n\t--ck-color-input-text: \t\t\t\t\t\t\t\t\t\tvar(--ck-color-base-text);\n\t--ck-color-input-disabled-background: \t\t\t\t\t\thsl(0, 0%, 95%);\n\t--ck-color-input-disabled-border: \t\t\t\t\t\t\thsl(0, 0%, 78%);\n\t--ck-color-input-disabled-text: \t\t\t\t\t\t\thsl(0, 0%, 46%);\n\n\t/* -- List ---------------------------------------------------------------------------------- */\n\n\t--ck-color-list-background: \t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\t--ck-color-list-button-hover-background: \t\t\t\t\tvar(--ck-color-button-default-hover-background);\n\t--ck-color-list-button-on-background: \t\t\t\t\t\tvar(--ck-color-base-active);\n\t--ck-color-list-button-on-background-focus: \t\t\t\tvar(--ck-color-base-active-focus);\n\t--ck-color-list-button-on-text:\t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\n\t/* -- Panel --------------------------------------------------------------------------------- */\n\n\t--ck-color-panel-background: \t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\t--ck-color-panel-border: \t\t\t\t\t\t\t\t\tvar(--ck-color-base-border);\n\n\t/* -- Toolbar ------------------------------------------------------------------------------- */\n\n\t--ck-color-toolbar-background: \t\t\t\t\t\t\t\tvar(--ck-color-base-foreground);\n\t--ck-color-toolbar-border: \t\t\t\t\t\t\t\t\tvar(--ck-color-base-border);\n\n\t/* -- Tooltip ------------------------------------------------------------------------------- */\n\n\t--ck-color-tooltip-background: \t\t\t\t\t\t\t\tvar(--ck-color-base-text);\n\t--ck-color-tooltip-text: \t\t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\n\t/* -- Engine -------------------------------------------------------------------------------- */\n\n\t--ck-color-engine-placeholder-text: \t\t\t\t\t\thsl(0, 0%, 44%);\n\n\t/* -- Upload -------------------------------------------------------------------------------- */\n\n\t--ck-color-upload-bar-background:\t\t \t\t\t\t\thsl(209, 92%, 70%);\n\n\t/* -- Link -------------------------------------------------------------------------------- */\n\n\t--ck-color-link-default:\t\t\t\t\t\t\t\t\thsl(240, 100%, 47%);\n\t--ck-color-link-selected-background:\t\t\t\t\t\thsla(201, 100%, 56%, 0.1);\n\t--ck-color-link-fake-selection:\t\t\t\t\t\t\t\thsla(201, 100%, 56%, 0.3);\n}\n", "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t/**\n\t * An opacity value of disabled UI item.\n\t */\n\t--ck-disabled-opacity: .5;\n}\n", "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t/**\n\t * The geometry of the of focused element's outer shadow.\n\t */\n\t--ck-focus-outer-shadow-geometry: 0 0 0 3px;\n\n\t/**\n\t * A visual style of focused element's outer shadow.\n\t */\n\t--ck-focus-outer-shadow: var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-outer-shadow);\n\n\t/**\n\t * A visual style of focused element's outer shadow (when disabled).\n\t */\n\t--ck-focus-disabled-outer-shadow: var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-disabled-shadow);\n\n\t/**\n\t * A visual style of focused element's outer shadow (when has errors).\n\t */\n\t--ck-focus-error-outer-shadow: var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-error-shadow);\n\n\t/**\n\t * A visual style of focused element's border or outline.\n\t */\n\t--ck-focus-ring: 1px solid var(--ck-color-focus-border);\n}\n", "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-font-size-base: 13px;\n\t--ck-line-height-base: 1.84615;\n\t--ck-font-face: Helvetica, Arial, Tahoma, Verdana, Sans-Serif;\n\n\t--ck-font-size-tiny: 0.7em;\n\t--ck-font-size-small: 0.75em;\n\t--ck-font-size-normal: 1em;\n\t--ck-font-size-big: 1.4em;\n\t--ck-font-size-large: 1.8em;\n}\n", '/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t/* This is super-important. This is **manually** adjusted so a button without an icon\n\tis never smaller than a button with icon, additionally making sure that text-less buttons\n\tare perfect squares. The value is also shared by other components which should stay "in-line"\n\twith buttons. */\n\t--ck-ui-component-min-height: 2.3em;\n}\n\n/**\n * Resets an element, ignoring its children.\n */\n.ck.ck-reset,\n.ck.ck-reset_all,\n.ck.ck-reset_all * {\n\t/* Do not include inheritable rules here. */\n\tmargin: 0;\n\tpadding: 0;\n\tborder: 0;\n\tbackground: transparent;\n\ttext-decoration: none;\n\tvertical-align: middle;\n\ttransition: none;\n\n\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/105 */\n\tword-wrap: break-word;\n}\n\n/**\n * Resets an element AND its children.\n */\n.ck.ck-reset_all,\n.ck.ck-reset_all * {\n\t/* These are rule inherited by all children elements. */\n\tborder-collapse: collapse;\n\tfont: normal normal normal var(--ck-font-size-base)/var(--ck-line-height-base) var(--ck-font-face);\n\tcolor: var(--ck-color-text);\n\ttext-align: left;\n\twhite-space: nowrap;\n\tcursor: auto;\n\tfloat: none;\n}\n\n.ck.ck-reset_all {\n\t& .ck-rtl * {\n\t\ttext-align: right;\n\t}\n\n\t& iframe {\n\t\t/* For IE */\n\t\tvertical-align: inherit;\n\t}\n\n\t& textarea {\n\t\twhite-space: pre-wrap;\n\t}\n\n\t& textarea,\n\t& input[type="text"],\n\t& input[type="password"] {\n\t\tcursor: text;\n\t}\n\n\t& textarea[disabled],\n\t& input[type="text"][disabled],\n\t& input[type="password"][disabled] {\n\t\tcursor: default;\n\t}\n\n\t& fieldset {\n\t\tpadding: 10px;\n\t\tborder: 2px groove hsl(255, 7%, 88%);\n\t}\n\n\t& button::-moz-focus-inner {\n\t\t/* See http://stackoverflow.com/questions/5517744/remove-extra-button-spacing-padding-in-firefox */\n\t\tpadding: 0;\n\t\tborder: 0\n\t}\n}\n\n/**\n * Default UI rules for RTL languages.\n */\n.ck[dir="rtl"],\n.ck[dir="rtl"] .ck {\n\ttext-align: right;\n}\n', "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Default border-radius value.\n */\n:root{\n\t--ck-border-radius: 2px;\n}\n", "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t/**\n\t * A visual style of element's inner shadow (i.e. input).\n\t */\n\t--ck-inner-shadow: 2px 2px 3px var(--ck-color-shadow-inner) inset;\n\n\t/**\n\t * A visual style of element's drop shadow (i.e. panel).\n\t */\n\t--ck-drop-shadow: 0 1px 2px 1px var(--ck-color-shadow-drop);\n\n\t/**\n\t * A visual style of element's active shadow (i.e. comment or suggestion).\n\t */\n\t--ck-drop-shadow-active: 0 3px 6px 1px var(--ck-color-shadow-drop-active);\n}\n", "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-spacing-unit: \t\t\t\t\t\t0.6em;\n\t--ck-spacing-large: \t\t\t\t\tcalc(var(--ck-spacing-unit) * 1.5);\n\t--ck-spacing-standard: \t\t\t\t\tvar(--ck-spacing-unit);\n\t--ck-spacing-medium: \t\t\t\t\tcalc(var(--ck-spacing-unit) * 0.8);\n\t--ck-spacing-small: \t\t\t\t\tcalc(var(--ck-spacing-unit) * 0.5);\n\t--ck-spacing-tiny: \t\t\t\t\t\tcalc(var(--ck-spacing-unit) * 0.3);\n\t--ck-spacing-extra-tiny: \t\t\t\tcalc(var(--ck-spacing-unit) * 0.16);\n}\n"],
      sourceRoot: ""
    }]), e.a = s;
  }, function (t, e, n) {
    "use strict";

    var o = n(2),
      i = n.n(o),
      r = n(3),
      s = n.n(r)()(i.a);
    s.push([t.i, ".ck.ck-icon{vertical-align:middle}:root{--ck-icon-size:calc(var(--ck-line-height-base)*var(--ck-font-size-normal))}.ck.ck-icon{width:var(--ck-icon-size);height:var(--ck-icon-size);font-size:.8333350694em;will-change:transform}.ck.ck-icon,.ck.ck-icon *{color:inherit;cursor:inherit}.ck.ck-icon :not([fill]){fill:currentColor}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/icon/icon.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/icon/icon.css"],
      names: [],
      mappings: "AAKA,YACC,qBACD,CCFA,MACC,0EACD,CAEA,YACC,yBAA0B,CAC1B,0BAA2B,CAG3B,uBAAwB,CAQxB,qBAcD,CAZC,0BARA,aAAc,CAGd,cAgBA,CAJC,yBAEC,iBACD",
      sourcesContent: ["/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-icon {\n\tvertical-align: middle;\n}\n", '/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-icon-size: calc(var(--ck-line-height-base) * var(--ck-font-size-normal));\n}\n\n.ck.ck-icon {\n\twidth: var(--ck-icon-size);\n\theight: var(--ck-icon-size);\n\n\t/* Multiplied by the height of the line in "px" should give SVG "viewport" dimensions */\n\tfont-size: .8333350694em;\n\n\tcolor: inherit;\n\n\t/* Inherit cursor style (#5). */\n\tcursor: inherit;\n\n\t/* This will prevent blurry icons on Firefox. See #340. */\n\twill-change: transform;\n\n\t& * {\n\t\t/* Inherit cursor style (#5). */\n\t\tcursor: inherit;\n\n\t\t/* Allows dynamic coloring of the icons. */\n\t\tcolor: inherit;\n\n\t\t&:not([fill]) {\n\t\t\t/* Needed by FF. */\n\t\t\tfill: currentColor;\n\t\t}\n\t}\n}\n'],
      sourceRoot: ""
    }]), e.a = s;
  }, function (t, e, n) {
    "use strict";

    var o = n(2),
      i = n.n(o),
      r = n(3),
      s = n.n(r)()(i.a);
    s.push([t.i, '.ck.ck-tooltip,.ck.ck-tooltip .ck-tooltip__text:after{position:absolute;pointer-events:none;-webkit-backface-visibility:hidden}.ck.ck-tooltip{visibility:hidden;opacity:0;display:none;z-index:var(--ck-z-modal)}.ck.ck-tooltip .ck-tooltip__text{display:inline-block}.ck.ck-tooltip .ck-tooltip__text:after{content:"";width:0;height:0}:root{--ck-tooltip-arrow-size:5px}.ck.ck-tooltip{left:50%;top:0;transition:opacity .2s ease-in-out .2s}.ck.ck-tooltip .ck-tooltip__text{border-radius:0}.ck-rounded-corners .ck.ck-tooltip .ck-tooltip__text,.ck.ck-tooltip .ck-tooltip__text.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-tooltip .ck-tooltip__text{font-size:.9em;line-height:1.5;color:var(--ck-color-tooltip-text);padding:var(--ck-spacing-small) var(--ck-spacing-medium);background:var(--ck-color-tooltip-background);position:relative;left:-50%}.ck.ck-tooltip .ck-tooltip__text:after{transition:opacity .2s ease-in-out .2s;border-style:solid;left:50%}.ck.ck-tooltip.ck-tooltip_s,.ck.ck-tooltip.ck-tooltip_se,.ck.ck-tooltip.ck-tooltip_sw{bottom:calc(var(--ck-tooltip-arrow-size)*-1);transform:translateY(100%)}.ck.ck-tooltip.ck-tooltip_s .ck-tooltip__text:after,.ck.ck-tooltip.ck-tooltip_se .ck-tooltip__text:after,.ck.ck-tooltip.ck-tooltip_sw .ck-tooltip__text:after{top:calc(var(--ck-tooltip-arrow-size)*-1 + 1px);transform:translateX(-50%);border-left-color:transparent;border-bottom-color:var(--ck-color-tooltip-background);border-right-color:transparent;border-top-color:transparent;border-left-width:var(--ck-tooltip-arrow-size);border-bottom-width:var(--ck-tooltip-arrow-size);border-right-width:var(--ck-tooltip-arrow-size);border-top-width:0}.ck.ck-tooltip.ck-tooltip_sw{right:50%;left:auto}.ck.ck-tooltip.ck-tooltip_sw .ck-tooltip__text{left:auto;right:calc(var(--ck-tooltip-arrow-size)*-2)}.ck.ck-tooltip.ck-tooltip_sw .ck-tooltip__text:after{left:auto;right:0}.ck.ck-tooltip.ck-tooltip_se{left:50%;right:auto}.ck.ck-tooltip.ck-tooltip_se .ck-tooltip__text{right:auto;left:calc(var(--ck-tooltip-arrow-size)*-2)}.ck.ck-tooltip.ck-tooltip_se .ck-tooltip__text:after{right:auto;left:0;transform:translateX(50%)}.ck.ck-tooltip.ck-tooltip_n{top:calc(var(--ck-tooltip-arrow-size)*-1);transform:translateY(-100%)}.ck.ck-tooltip.ck-tooltip_n .ck-tooltip__text:after{bottom:calc(var(--ck-tooltip-arrow-size)*-1);transform:translateX(-50%);border-left-color:transparent;border-bottom-color:transparent;border-right-color:transparent;border-top-color:var(--ck-color-tooltip-background);border-left-width:var(--ck-tooltip-arrow-size);border-bottom-width:0;border-right-width:var(--ck-tooltip-arrow-size);border-top-width:var(--ck-tooltip-arrow-size)}.ck.ck-tooltip.ck-tooltip_e{left:calc(100% + var(--ck-tooltip-arrow-size));top:50%}.ck.ck-tooltip.ck-tooltip_e .ck-tooltip__text{left:0;transform:translateY(-50%)}.ck.ck-tooltip.ck-tooltip_e .ck-tooltip__text:after{left:calc(var(--ck-tooltip-arrow-size)*-1);top:calc(50% - var(--ck-tooltip-arrow-size)*1);border-left-color:transparent;border-bottom-color:transparent;border-right-color:var(--ck-color-tooltip-background);border-top-color:transparent;border-left-width:0;border-bottom-width:var(--ck-tooltip-arrow-size);border-right-width:var(--ck-tooltip-arrow-size);border-top-width:var(--ck-tooltip-arrow-size)}.ck.ck-tooltip.ck-tooltip_w{right:calc(100% + var(--ck-tooltip-arrow-size));left:auto;top:50%}.ck.ck-tooltip.ck-tooltip_w .ck-tooltip__text{left:0;transform:translateY(-50%)}.ck.ck-tooltip.ck-tooltip_w .ck-tooltip__text:after{left:100%;top:calc(50% - var(--ck-tooltip-arrow-size)*1);border-left-color:var(--ck-color-tooltip-background);border-bottom-color:transparent;border-right-color:transparent;border-top-color:transparent;border-left-width:var(--ck-tooltip-arrow-size);border-bottom-width:var(--ck-tooltip-arrow-size);border-right-width:0;border-top-width:var(--ck-tooltip-arrow-size)}', "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/tooltip/tooltip.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/tooltip/tooltip.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css"],
      names: [],
      mappings: "AAKA,sDAEC,iBAAkB,CAGlB,mBAAoB,CAIpB,kCACD,CAEA,eAEC,iBAAkB,CAClB,SAAU,CACV,YAAa,CACb,yBAWD,CATC,iCACC,oBAOD,CALC,uCACC,UAAW,CACX,OAAQ,CACR,QACD,CCxBF,MACC,2BACD,CAEA,eACC,QAAS,CAMT,KAAM,CAON,sCAwKD,CAtKC,iCChBA,eDqCA,CArBA,yGCZC,qCDiCD,CArBA,iCAGC,cAAe,CACf,eAAgB,CAChB,kCAAmC,CACnC,wDAAyD,CACzD,6CAA8C,CAC9C,iBAAkB,CAClB,SAYD,CAVC,uCAMC,sCAAuC,CACvC,kBAAmB,CACnB,QACD,CAYD,sFAGC,4CAA+C,CAC/C,0BASD,CAPC,8JAEC,+CAAkD,CAClD,0BAA6B,CAC7B,6BAAoF,CAApF,sDAAoF,CAApF,8BAAoF,CAApF,4BAAoF,CACpF,8CAAsG,CAAtG,gDAAsG,CAAtG,+CAAsG,CAAtG,kBACD,CAaD,6BACC,SAAU,CACV,SAWD,CATC,+CACC,SAAU,CACV,2CACD,CAEA,qDACC,SAAU,CACV,OACD,CAYD,6BACC,QAAS,CACT,UAYD,CAVC,+CACC,UAAW,CACX,0CACD,CAEA,qDACC,UAAW,CACX,MAAO,CACP,yBACD,CAYD,4BACC,yCAA4C,CAC5C,2BAQD,CANC,oDACC,4CAA+C,CAC/C,0BAA6B,CAC7B,6BAAoF,CAApF,+BAAoF,CAApF,8BAAoF,CAApF,mDAAoF,CACpF,8CAAsG,CAAtG,qBAAsG,CAAtG,+CAAsG,CAAtG,6CACD,CAUD,4BACC,8CAA+C,CAC/C,OAaD,CAXC,8CACC,MAAO,CACP,0BAQD,CANC,oDACC,0CAA6C,CAC7C,8CAAiD,CACjD,6BAAoF,CAApF,+BAAoF,CAApF,qDAAoF,CAApF,4BAAoF,CACpF,mBAAsG,CAAtG,gDAAsG,CAAtG,+CAAsG,CAAtG,6CACD,CAWF,4BACC,+CAAgD,CAChD,SAAU,CACV,OAaD,CAXC,8CACC,MAAO,CACP,0BAQD,CANC,oDACC,SAAU,CACV,8CAAiD,CACjD,oDAAoF,CAApF,+BAAoF,CAApF,8BAAoF,CAApF,4BAAoF,CACpF,8CAAsG,CAAtG,gDAAsG,CAAtG,oBAAsG,CAAtG,6CACD",
      sourcesContent: ['/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-tooltip,\n.ck.ck-tooltip .ck-tooltip__text::after {\n\tposition: absolute;\n\n\t/* Without this, hovering the tooltip could keep it visible. */\n\tpointer-events: none;\n\n\t/* This is to get rid of flickering when transitioning opacity in Chrome.\n\tIt\'s weird but it works. */\n\t-webkit-backface-visibility: hidden;\n}\n\n.ck.ck-tooltip {\n\t/* Tooltip is hidden by default. */\n\tvisibility: hidden;\n\topacity: 0;\n\tdisplay: none;\n\tz-index: var(--ck-z-modal);\n\n\t& .ck-tooltip__text {\n\t\tdisplay: inline-block;\n\n\t\t&::after {\n\t\t\tcontent: "";\n\t\t\twidth: 0;\n\t\t\theight: 0;\n\t\t}\n\t}\n}\n', '/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n\n:root {\n\t--ck-tooltip-arrow-size: 5px;\n}\n\n.ck.ck-tooltip {\n\tleft: 50%;\n\n\t/*\n\t * Prevent blurry tooltips in LoDPI environments.\n\t * See https://github.com/ckeditor/ckeditor5/issues/1802.\n\t */\n\ttop: 0;\n\n\t/*\n\t * For the transition to work, the tooltip must be controlled\n\t * using visibility+opacity. A delay prevents a "tooltip avalanche"\n\t * i.e. when scanning the toolbar with mouse cursor.\n\t */\n\ttransition: opacity .2s ease-in-out .2s;\n\n\t& .ck-tooltip__text {\n\t\t@mixin ck-rounded-corners;\n\n\t\tfont-size: .9em;\n\t\tline-height: 1.5;\n\t\tcolor: var(--ck-color-tooltip-text);\n\t\tpadding: var(--ck-spacing-small) var(--ck-spacing-medium);\n\t\tbackground: var(--ck-color-tooltip-background);\n\t\tposition: relative;\n\t\tleft: -50%;\n\n\t\t&::after {\n\t\t\t/*\n\t\t\t * For the transition to work, the tooltip must be controlled\n\t\t\t * using visibility+opacity. A delay prevents a "tooltip avalanche"\n\t\t\t * i.e. when scanning the toolbar with mouse cursor.\n\t\t\t */\n\t\t\ttransition: opacity .2s ease-in-out .2s;\n\t\t\tborder-style: solid;\n\t\t\tleft: 50%;\n\t\t}\n\t}\n\n\t/**\n\t * A class that displays the tooltip south of the element.\n\t *\n\t *       [element]\n\t *           ^\n\t *     +-----------+\n\t *     |  Tooltip  |\n\t *     +-----------+\n\t */\n\t&.ck-tooltip_s,\n\t&.ck-tooltip_sw,\n\t&.ck-tooltip_se {\n\t\tbottom: calc(-1 * var(--ck-tooltip-arrow-size));\n\t\ttransform: translateY( 100% );\n\n\t\t& .ck-tooltip__text::after {\n\t\t\t/* 1px addresses gliches in rendering causing gap between the triangle and the text */\n\t\t\ttop: calc(-1 * var(--ck-tooltip-arrow-size) + 1px);\n\t\t\ttransform: translateX( -50% );\n\t\t\tborder-color: transparent transparent var(--ck-color-tooltip-background) transparent;\n\t\t\tborder-width: 0 var(--ck-tooltip-arrow-size) var(--ck-tooltip-arrow-size) var(--ck-tooltip-arrow-size);\n\t\t}\n\t}\n\n\t/**\n\t * A class that displays the tooltip south-west of the element.\n\t *\n\t *        [element]\n\t *            ^\n\t *  +-----------+\n\t *  |  Tooltip  |\n\t *  +-----------+\n\t */\n\n\t&.ck-tooltip_sw {\n\t\tright: 50%;\n\t\tleft: auto;\n\n\t\t& .ck-tooltip__text {\n\t\t\tleft: auto;\n\t\t\tright: calc( -2 * var(--ck-tooltip-arrow-size));\n\t\t}\n\n\t\t& .ck-tooltip__text::after {\n\t\t\tleft: auto;\n\t\t\tright: 0;\n\t\t}\n\t}\n\n\t/**\n\t * A class that displays the tooltip south-east of the element.\n\t *\n\t *  [element]\n\t *      ^\n\t *    +-----------+\n\t *    |  Tooltip  |\n\t *    +-----------+\n\t */\n\t&.ck-tooltip_se {\n\t\tleft: 50%;\n\t\tright: auto;\n\n\t\t& .ck-tooltip__text {\n\t\t\tright: auto;\n\t\t\tleft: calc( -2 * var(--ck-tooltip-arrow-size));\n\t\t}\n\n\t\t& .ck-tooltip__text::after {\n\t\t\tright: auto;\n\t\t\tleft: 0;\n\t\t\ttransform: translateX( 50% );\n\t\t}\n\t}\n\n\t/**\n\t * A class that displays the tooltip north of the element.\n\t *\n\t *     +-----------+\n\t *     |  Tooltip  |\n\t *     +-----------+\n\t *           V\n\t *       [element]\n\t */\n\t&.ck-tooltip_n {\n\t\ttop: calc(-1 * var(--ck-tooltip-arrow-size));\n\t\ttransform: translateY( -100% );\n\n\t\t& .ck-tooltip__text::after {\n\t\t\tbottom: calc(-1 * var(--ck-tooltip-arrow-size));\n\t\t\ttransform: translateX( -50% );\n\t\t\tborder-color: var(--ck-color-tooltip-background) transparent transparent transparent;\n\t\t\tborder-width: var(--ck-tooltip-arrow-size) var(--ck-tooltip-arrow-size) 0 var(--ck-tooltip-arrow-size);\n\t\t}\n\t}\n\n\t/**\n\t * A class that displays the tooltip east of the element.\n\t *\n\t *                +----------+\n\t *    [element] < |   east   |\n\t *                +----------+\n\t */\n\t&.ck-tooltip_e {\n\t\tleft: calc(100% + var(--ck-tooltip-arrow-size));\n\t\ttop: 50%;\n\n\t\t& .ck-tooltip__text {\n\t\t\tleft: 0;\n\t\t\ttransform: translateY( -50% );\n\n\t\t\t&::after {\n\t\t\t\tleft: calc(-1 * var(--ck-tooltip-arrow-size));\n\t\t\t\ttop: calc(50% - 1 * var(--ck-tooltip-arrow-size));\n\t\t\t\tborder-color: transparent var(--ck-color-tooltip-background) transparent transparent;\n\t\t\t\tborder-width: var(--ck-tooltip-arrow-size) var(--ck-tooltip-arrow-size) var(--ck-tooltip-arrow-size) 0;\n\t\t\t}\n\t\t}\n\t}\n\n\t/**\n\t * A class that displays the tooltip west of the element.\n\t *\n\t *    +----------+\n\t *    |   west   | > [element]\n\t *    +----------+\n\t */\n\t&.ck-tooltip_w {\n\t\tright: calc(100% + var(--ck-tooltip-arrow-size));\n\t\tleft: auto;\n\t\ttop: 50%;\n\n\t\t& .ck-tooltip__text {\n\t\t\tleft: 0;\n\t\t\ttransform: translateY( -50% );\n\n\t\t\t&::after {\n\t\t\t\tleft: 100%;\n\t\t\t\ttop: calc(50% - 1 * var(--ck-tooltip-arrow-size));\n\t\t\t\tborder-color: transparent transparent transparent var(--ck-color-tooltip-background);\n\t\t\t\tborder-width: var(--ck-tooltip-arrow-size) 0 var(--ck-tooltip-arrow-size) var(--ck-tooltip-arrow-size);\n\t\t\t}\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n"],
      sourceRoot: ""
    }]), e.a = s;
  }, function (t, e, n) {
    "use strict";

    var o = n(2),
      i = n.n(o),
      r = n(3),
      s = n.n(r)()(i.a);
    s.push([t.i, ".ck.ck-button,a.ck.ck-button{-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.ck.ck-button .ck-tooltip,a.ck.ck-button .ck-tooltip{display:block}@media (hover:none){.ck.ck-button .ck-tooltip,a.ck.ck-button .ck-tooltip{display:none}}.ck.ck-button,a.ck.ck-button{position:relative;display:inline-flex;align-items:center;justify-content:left}.ck.ck-button .ck-button__label,a.ck.ck-button .ck-button__label{display:none}.ck.ck-button.ck-button_with-text .ck-button__label,a.ck.ck-button.ck-button_with-text .ck-button__label{display:inline-block}.ck.ck-button:not(.ck-button_with-text),a.ck.ck-button:not(.ck-button_with-text){justify-content:center}.ck.ck-button:hover .ck-tooltip,a.ck.ck-button:hover .ck-tooltip{visibility:visible;opacity:1}.ck.ck-button:focus:not(:hover) .ck-tooltip,a.ck.ck-button:focus:not(:hover) .ck-tooltip{display:none}.ck.ck-button,a.ck.ck-button{background:var(--ck-color-button-default-background)}.ck.ck-button:not(.ck-disabled):hover,a.ck.ck-button:not(.ck-disabled):hover{background:var(--ck-color-button-default-hover-background)}.ck.ck-button:not(.ck-disabled):active,a.ck.ck-button:not(.ck-disabled):active{background:var(--ck-color-button-default-active-background);box-shadow:inset 0 2px 2px var(--ck-color-button-default-active-shadow)}.ck.ck-button.ck-disabled,a.ck.ck-button.ck-disabled{background:var(--ck-color-button-default-disabled-background)}.ck.ck-button,a.ck.ck-button{border-radius:0}.ck-rounded-corners .ck.ck-button,.ck-rounded-corners a.ck.ck-button,.ck.ck-button.ck-rounded-corners,a.ck.ck-button.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-button,a.ck.ck-button{white-space:nowrap;cursor:default;vertical-align:middle;padding:var(--ck-spacing-tiny);text-align:center;min-width:var(--ck-ui-component-min-height);min-height:var(--ck-ui-component-min-height);line-height:1;font-size:inherit;border:1px solid transparent;transition:box-shadow .2s ease-in-out,border .2s ease-in-out;-webkit-appearance:none}.ck.ck-button:active,.ck.ck-button:focus,a.ck.ck-button:active,a.ck.ck-button:focus{outline:none;border:var(--ck-focus-ring);box-shadow:var(--ck-focus-outer-shadow),0 0}.ck.ck-button .ck-button__icon use,.ck.ck-button .ck-button__icon use *,a.ck.ck-button .ck-button__icon use,a.ck.ck-button .ck-button__icon use *{color:inherit}.ck.ck-button .ck-button__label,a.ck.ck-button .ck-button__label{font-size:inherit;font-weight:inherit;color:inherit;cursor:inherit;vertical-align:middle}[dir=ltr] .ck.ck-button .ck-button__label,[dir=ltr] a.ck.ck-button .ck-button__label{text-align:left}[dir=rtl] .ck.ck-button .ck-button__label,[dir=rtl] a.ck.ck-button .ck-button__label{text-align:right}.ck.ck-button .ck-button__keystroke,a.ck.ck-button .ck-button__keystroke{color:inherit}[dir=ltr] .ck.ck-button .ck-button__keystroke,[dir=ltr] a.ck.ck-button .ck-button__keystroke{margin-left:var(--ck-spacing-large)}[dir=rtl] .ck.ck-button .ck-button__keystroke,[dir=rtl] a.ck.ck-button .ck-button__keystroke{margin-right:var(--ck-spacing-large)}.ck.ck-button .ck-button__keystroke,a.ck.ck-button .ck-button__keystroke{font-weight:700;opacity:.7}.ck.ck-button.ck-disabled:active,.ck.ck-button.ck-disabled:focus,a.ck.ck-button.ck-disabled:active,a.ck.ck-button.ck-disabled:focus{box-shadow:var(--ck-focus-disabled-outer-shadow),0 0}.ck.ck-button.ck-disabled .ck-button__icon,a.ck.ck-button.ck-disabled .ck-button__icon{opacity:var(--ck-disabled-opacity)}.ck.ck-button.ck-disabled .ck-button__label,a.ck.ck-button.ck-disabled .ck-button__label{opacity:var(--ck-disabled-opacity)}.ck.ck-button.ck-disabled .ck-button__keystroke,a.ck.ck-button.ck-disabled .ck-button__keystroke{opacity:.3}.ck.ck-button.ck-button_with-text,a.ck.ck-button.ck-button_with-text{padding:var(--ck-spacing-tiny) var(--ck-spacing-standard)}[dir=ltr] .ck.ck-button.ck-button_with-text .ck-button__icon,[dir=ltr] a.ck.ck-button.ck-button_with-text .ck-button__icon{margin-left:calc(var(--ck-spacing-small)*-1);margin-right:var(--ck-spacing-small)}[dir=rtl] .ck.ck-button.ck-button_with-text .ck-button__icon,[dir=rtl] a.ck.ck-button.ck-button_with-text .ck-button__icon{margin-right:calc(var(--ck-spacing-small)*-1);margin-left:var(--ck-spacing-small)}.ck.ck-button.ck-button_with-keystroke .ck-button__label,a.ck.ck-button.ck-button_with-keystroke .ck-button__label{flex-grow:1}.ck.ck-button.ck-on,a.ck.ck-button.ck-on{background:var(--ck-color-button-on-background)}.ck.ck-button.ck-on:not(.ck-disabled):hover,a.ck.ck-button.ck-on:not(.ck-disabled):hover{background:var(--ck-color-button-on-hover-background)}.ck.ck-button.ck-on:not(.ck-disabled):active,a.ck.ck-button.ck-on:not(.ck-disabled):active{background:var(--ck-color-button-on-active-background);box-shadow:inset 0 2px 2px var(--ck-color-button-on-active-shadow)}.ck.ck-button.ck-on.ck-disabled,a.ck.ck-button.ck-on.ck-disabled{background:var(--ck-color-button-on-disabled-background)}.ck.ck-button.ck-button-save,a.ck.ck-button.ck-button-save{color:var(--ck-color-button-save)}.ck.ck-button.ck-button-cancel,a.ck.ck-button.ck-button-cancel{color:var(--ck-color-button-cancel)}.ck.ck-button-action,a.ck.ck-button-action{background:var(--ck-color-button-action-background)}.ck.ck-button-action:not(.ck-disabled):hover,a.ck.ck-button-action:not(.ck-disabled):hover{background:var(--ck-color-button-action-hover-background)}.ck.ck-button-action:not(.ck-disabled):active,a.ck.ck-button-action:not(.ck-disabled):active{background:var(--ck-color-button-action-active-background);box-shadow:inset 0 2px 2px var(--ck-color-button-action-active-shadow)}.ck.ck-button-action.ck-disabled,a.ck.ck-button-action.ck-disabled{background:var(--ck-color-button-action-disabled-background)}.ck.ck-button-action,a.ck.ck-button-action{color:var(--ck-color-button-action-text)}.ck.ck-button-bold,a.ck.ck-button-bold{font-weight:700}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/button/button.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_unselectable.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/tooltip/mixins/_tooltip.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/button/button.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/mixins/_button.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_focus.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_disabled.css"],
      names: [],
      mappings: "AAQA,6BCCC,qBAAsB,CACtB,wBAAyB,CACzB,oBAAqB,CACrB,gBD6BD,CE/BC,qDACC,aAqBD,CAHC,oBAnBD,qDAoBE,YAEF,CADC,CFvBF,6BAKC,iBAAkB,CAClB,mBAAoB,CACpB,kBAAmB,CACnB,oBAyBD,CAvBC,iEACC,YACD,CAGC,yGACC,oBACD,CAID,iFACC,sBACD,CEkBA,iEACC,kBAAmB,CACnB,SACD,CAbA,yFACC,YACD,CC7BD,6BCAC,oDD0ID,CCvIE,6EACC,0DACD,CAEA,+EACC,2DAA4C,CAC5C,uEACD,CAID,qDACC,6DACD,CDhBD,6BEDC,eF2ID,CA1IA,wIEGE,qCFuIF,CA1IA,6BAKC,kBAAmB,CACnB,cAAe,CACf,qBAAsB,CACtB,8BAA+B,CAC/B,iBAAkB,CAGlB,2CAA4C,CAC5C,4CAA6C,CAI7C,aAAc,CAGd,iBAAkB,CAGlB,4BAA6B,CAG7B,4DAA8D,CAG9D,uBA6GD,CA3GC,oFGjCA,YAAa,CACb,2BAA2B,CCF3B,2CJsCA,CAIC,kJAEC,aACD,CAGD,iEAEC,iBAAkB,CAClB,mBAAoB,CACpB,aAAc,CACd,cAAe,CAIf,qBASD,CAlBA,qFAYE,eAMF,CAlBA,qFAgBE,gBAEF,CAEA,yEACC,aAYD,CAbA,6FAIE,mCASF,CAbA,6FAQE,oCAKF,CAbA,yEAWC,eAAiB,CACjB,UACD,CAIC,oIIrFD,oDJyFC,CAEA,uFK3FD,kCL6FC,CAGA,yFKhGD,kCLkGC,CAEA,iGACC,UACD,CAGD,qEACC,yDAcD,CAXC,2HAEE,4CAA+C,CAC/C,oCAOF,CAVA,2HAOE,6CAAgD,CAChD,mCAEF,CAKA,mHACC,WACD,CAID,yCC/HA,+CDiIA,CC9HC,yFACC,qDACD,CAEA,2FACC,sDAA4C,CAC5C,kEACD,CAID,iEACC,wDACD,CDmHA,2DACC,iCACD,CAEA,+DACC,mCACD,CAID,2CC7IC,mDDkJD,CC/IE,2FACC,yDACD,CAEA,6FACC,0DAA4C,CAC5C,sEACD,CAID,mEACC,4DACD,CD6HD,2CAIC,wCACD,CAEA,uCAEC,eACD",
      sourcesContent: ['/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../mixins/_unselectable.css";\n@import "../tooltip/mixins/_tooltip.css";\n\n.ck.ck-button,\na.ck.ck-button {\n\t@mixin ck-unselectable;\n\t@mixin ck-tooltip_enabled;\n\n\tposition: relative;\n\tdisplay: inline-flex;\n\talign-items: center;\n\tjustify-content: left;\n\n\t& .ck-button__label {\n\t\tdisplay: none;\n\t}\n\n\t&.ck-button_with-text {\n\t\t& .ck-button__label {\n\t\t\tdisplay: inline-block;\n\t\t}\n\t}\n\n\t/* Center the icon horizontally in a button without text. */\n\t&:not(.ck-button_with-text)  {\n\t\tjustify-content: center;\n\t}\n\n\t&:hover {\n\t\t@mixin ck-tooltip_visible;\n\t}\n\n\t/* Get rid of the native focus outline around the tooltip when focused (but not :hover). */\n\t&:focus:not(:hover) {\n\t\t@mixin ck-tooltip_disabled;\n\t}\n}\n', "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Makes element unselectable.\n */\n@define-mixin ck-unselectable {\n\t-moz-user-select: none;\n\t-webkit-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none\n}\n", "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Enables the tooltip, which is the tooltip is in DOM but\n * not yet displayed.\n */\n@define-mixin ck-tooltip_enabled {\n\t& .ck-tooltip {\n\t\tdisplay: block;\n\n\t\t/*\n\t\t * Don't display tooltips in devices which don't support :hover.\n\t\t * In fact, it's all about iOS, which forces user to click UI elements twice to execute\n\t\t * the primary action, when tooltips are enabled.\n\t\t *\n\t\t * Q: OK, but why not the following query?\n\t\t *\n\t\t *   @media (hover) {\n\t\t *       display: block;\n\t\t *   }\n\t\t *\n\t\t * A: Because FF does not support it and it would completely disable tooltips\n\t\t * in that browser.\n\t\t *\n\t\t * More in https://github.com/ckeditor/ckeditor5/issues/920.\n\t\t */\n\t\t@media (hover:none) {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n\n/**\n * Disables the tooltip making it disappear from DOM.\n */\n@define-mixin ck-tooltip_disabled {\n\t& .ck-tooltip {\n\t\tdisplay: none;\n\t}\n}\n\n/**\n * Shows the tooltip, which is already in DOM.\n * Requires `ck-tooltip_enabled` first.\n */\n@define-mixin ck-tooltip_visible {\n\t& .ck-tooltip {\n\t\tvisibility: visible;\n\t\topacity: 1;\n\t}\n}\n", '/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_focus.css";\n@import "../../../mixins/_shadow.css";\n@import "../../../mixins/_disabled.css";\n@import "../../../mixins/_rounded.css";\n@import "../../mixins/_button.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n.ck.ck-button,\na.ck.ck-button {\n\t@mixin ck-button-colors --ck-color-button-default;\n\t@mixin ck-rounded-corners;\n\n\twhite-space: nowrap;\n\tcursor: default;\n\tvertical-align: middle;\n\tpadding: var(--ck-spacing-tiny);\n\ttext-align: center;\n\n\t/* A very important piece of styling. Go to variable declaration to learn more. */\n\tmin-width: var(--ck-ui-component-min-height);\n\tmin-height: var(--ck-ui-component-min-height);\n\n\t/* Normalize the height of the line. Removing this will break consistent height\n\tamong text and text-less buttons (with icons). */\n\tline-height: 1;\n\n\t/* Enable font size inheritance, which allows fluid UI scaling. */\n\tfont-size: inherit;\n\n\t/* Avoid flickering when the foucs border shows up. */\n\tborder: 1px solid transparent;\n\n\t/* Apply some smooth transition to the box-shadow and border. */\n\ttransition: box-shadow .2s ease-in-out, border .2s ease-in-out;\n\n\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/189 */\n\t-webkit-appearance: none;\n\n\t&:active,\n\t&:focus {\n\t\t@mixin ck-focus-ring;\n\t\t@mixin ck-box-shadow var(--ck-focus-outer-shadow);\n\t}\n\n\t/* Allow icon coloring using the text "color" property. */\n\t& .ck-button__icon {\n\t\t& use,\n\t\t& use * {\n\t\t\tcolor: inherit;\n\t\t}\n\t}\n\n\t& .ck-button__label {\n\t\t/* Enable font size inheritance, which allows fluid UI scaling. */\n\t\tfont-size: inherit;\n\t\tfont-weight: inherit;\n\t\tcolor: inherit;\n\t\tcursor: inherit;\n\n\t\t/* Must be consistent with .ck-icon\'s vertical align. Otherwise, buttons with and\n\t\twithout labels (but with icons) have different sizes in Chrome */\n\t\tvertical-align: middle;\n\n\t\t@mixin ck-dir ltr {\n\t\t\ttext-align: left;\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\ttext-align: right;\n\t\t}\n\t}\n\n\t& .ck-button__keystroke {\n\t\tcolor: inherit;\n\n\t\t@mixin ck-dir ltr {\n\t\t\tmargin-left: var(--ck-spacing-large);\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\tmargin-right: var(--ck-spacing-large);\n\t\t}\n\n\t\tfont-weight: bold;\n\t\topacity: .7;\n\t}\n\n\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/70 */\n\t&.ck-disabled {\n\t\t&:active,\n\t\t&:focus {\n\t\t\t/* The disabled button should have a slightly less visible shadow when focused. */\n\t\t\t@mixin ck-box-shadow var(--ck-focus-disabled-outer-shadow);\n\t\t}\n\n\t\t& .ck-button__icon {\n\t\t\t@mixin ck-disabled;\n\t\t}\n\n\t\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/98 */\n\t\t& .ck-button__label {\n\t\t\t@mixin ck-disabled;\n\t\t}\n\n\t\t& .ck-button__keystroke {\n\t\t\topacity: .3;\n\t\t}\n\t}\n\n\t&.ck-button_with-text {\n\t\tpadding: var(--ck-spacing-tiny) var(--ck-spacing-standard);\n\n\t\t/* stylelint-disable-next-line no-descending-specificity */\n\t\t& .ck-button__icon {\n\t\t\t@mixin ck-dir ltr {\n\t\t\t\tmargin-left: calc(-1 * var(--ck-spacing-small));\n\t\t\t\tmargin-right: var(--ck-spacing-small);\n\t\t\t}\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tmargin-right: calc(-1 * var(--ck-spacing-small));\n\t\t\t\tmargin-left: var(--ck-spacing-small);\n\t\t\t}\n\t\t}\n\t}\n\n\t&.ck-button_with-keystroke {\n\t\t/* stylelint-disable-next-line no-descending-specificity */\n\t\t& .ck-button__label {\n\t\t\tflex-grow: 1;\n\t\t}\n\t}\n\n\t/* A style of the button which is currently on, e.g. its feature is active. */\n\t&.ck-on {\n\t\t@mixin ck-button-colors --ck-color-button-on;\n\t}\n\n\t&.ck-button-save {\n\t\tcolor: var(--ck-color-button-save);\n\t}\n\n\t&.ck-button-cancel {\n\t\tcolor: var(--ck-color-button-cancel);\n\t}\n}\n\n/* A style of the button which handles the primary action. */\n.ck.ck-button-action,\na.ck.ck-button-action {\n\t@mixin ck-button-colors --ck-color-button-action;\n\n\tcolor: var(--ck-color-button-action-text);\n}\n\n.ck.ck-button-bold,\na.ck.ck-button-bold {\n\tfont-weight: bold;\n}\n', "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements a button of given background color.\n *\n * @param {String} $background - Background color of the button.\n * @param {String} $border - Border color of the button.\n */\n@define-mixin ck-button-colors $prefix {\n\tbackground: var($(prefix)-background);\n\n\t&:not(.ck-disabled) {\n\t\t&:hover {\n\t\t\tbackground: var($(prefix)-hover-background);\n\t\t}\n\n\t\t&:active {\n\t\t\tbackground: var($(prefix)-active-background);\n\t\t\tbox-shadow: inset 0 2px 2px var($(prefix)-active-shadow);\n\t\t}\n\t}\n\n\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/98 */\n\t&.ck-disabled {\n\t\tbackground: var($(prefix)-disabled-background);\n\t}\n}\n", "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A visual style of focused element's border.\n */\n@define-mixin ck-focus-ring {\n\t/* Disable native outline. */\n\toutline: none;\n\tborder: var(--ck-focus-ring)\n}\n", "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n", "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A class which indicates that an element holding it is disabled.\n */\n@define-mixin ck-disabled {\n\topacity: var(--ck-disabled-opacity);\n}\n"],
      sourceRoot: ""
    }]), e.a = s;
  }, function (t, e, n) {
    "use strict";

    var o = n(2),
      i = n.n(o),
      r = n(3),
      s = n.n(r)()(i.a);
    s.push([t.i, ".ck.ck-button.ck-switchbutton .ck-button__toggle,.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{display:block}:root{--ck-switch-button-toggle-width:2.6153846154em;--ck-switch-button-toggle-inner-size:1.0769230769em;--ck-switch-button-toggle-spacing:1px;--ck-switch-button-translation:calc(var(--ck-switch-button-toggle-width) - var(--ck-switch-button-toggle-inner-size) - var(--ck-switch-button-toggle-spacing)*2)}[dir=ltr] .ck.ck-button.ck-switchbutton .ck-button__label{margin-right:calc(var(--ck-spacing-large)*2)}[dir=rtl] .ck.ck-button.ck-switchbutton .ck-button__label{margin-left:calc(var(--ck-spacing-large)*2)}.ck.ck-button.ck-switchbutton .ck-button__toggle{border-radius:0}.ck-rounded-corners .ck.ck-button.ck-switchbutton .ck-button__toggle,.ck.ck-button.ck-switchbutton .ck-button__toggle.ck-rounded-corners{border-radius:var(--ck-border-radius)}[dir=ltr] .ck.ck-button.ck-switchbutton .ck-button__toggle{margin-left:auto}[dir=rtl] .ck.ck-button.ck-switchbutton .ck-button__toggle{margin-right:auto}.ck.ck-button.ck-switchbutton .ck-button__toggle{transition:background .4s ease;width:var(--ck-switch-button-toggle-width);background:var(--ck-color-switch-button-off-background)}.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{border-radius:0}.ck-rounded-corners .ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner,.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner.ck-rounded-corners{border-radius:var(--ck-border-radius);border-radius:calc(var(--ck-border-radius)*0.5)}.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{margin:var(--ck-switch-button-toggle-spacing);width:var(--ck-switch-button-toggle-inner-size);height:var(--ck-switch-button-toggle-inner-size);background:var(--ck-color-switch-button-inner-background);transition:all .3s ease}.ck.ck-button.ck-switchbutton .ck-button__toggle:hover{background:var(--ck-color-switch-button-off-hover-background)}.ck.ck-button.ck-switchbutton .ck-button__toggle:hover .ck-button__toggle__inner{box-shadow:0 0 0 5px var(--ck-color-switch-button-inner-shadow)}.ck.ck-button.ck-switchbutton.ck-disabled .ck-button__toggle{opacity:var(--ck-disabled-opacity)}.ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle{background:var(--ck-color-switch-button-on-background)}.ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle:hover{background:var(--ck-color-switch-button-on-hover-background)}[dir=ltr] .ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle .ck-button__toggle__inner{transform:translateX(var(--ck-switch-button-translation))}[dir=rtl] .ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle .ck-button__toggle__inner{transform:translateX(calc(var(--ck-switch-button-translation)*-1))}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/button/switchbutton.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/button/switchbutton.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_disabled.css"],
      names: [],
      mappings: "AASE,4HACC,aACD,CCCF,MAEC,8CAA+C,CAE/C,mDAAoD,CACpD,qCAAsC,CACtC,gKAKD,CAGC,0DAGE,4CAOF,CAVA,0DAQE,2CAEF,CAEA,iDC3BA,eDoEA,CAzCA,yICvBC,qCDgED,CAzCA,2DAKE,gBAoCF,CAzCA,2DAUE,iBA+BF,CAzCA,iDAcC,8BAAiC,CAEjC,0CAA2C,CAC3C,uDAwBD,CAtBC,2EC9CD,eD2DC,CAbA,6LC1CA,qCAAsC,CD4CpC,+CAWF,CAbA,2EAMC,6CAA8C,CAC9C,+CAAgD,CAChD,gDAAiD,CACjD,yDAA0D,CAG1D,uBACD,CAEA,uDACC,6DAKD,CAHC,iFACC,+DACD,CAIF,6DExEA,kCF0EA,CAEA,uDACC,sDAkBD,CAhBC,6DACC,4DACD,CAEA,2FAKE,yDAMF,CAXA,2FASE,kEAEF",
      sourcesContent: ["/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-button.ck-switchbutton {\n\t& .ck-button__toggle {\n\t\tdisplay: block;\n\n\t\t& .ck-button__toggle__inner {\n\t\t\tdisplay: block;\n\t\t}\n\t}\n}\n", '/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_disabled.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n/* Note: To avoid rendering issues (aliasing) but to preserve the responsive nature\nof the component, floating–point numbers have been used which, for the default font size\n(see: --ck-font-size-base), will generate simple integers. */\n:root {\n\t/* 34px at 13px font-size */\n\t--ck-switch-button-toggle-width: 2.6153846154em;\n\t/* 14px at 13px font-size */\n\t--ck-switch-button-toggle-inner-size: 1.0769230769em;\n\t--ck-switch-button-toggle-spacing: 1px;\n\t--ck-switch-button-translation: calc(\n\t\tvar(--ck-switch-button-toggle-width) -\n\t\tvar(--ck-switch-button-toggle-inner-size) -\n\t\t2 * var(--ck-switch-button-toggle-spacing)\n\t);\n}\n\n.ck.ck-button.ck-switchbutton {\n\t& .ck-button__label {\n\t\t@mixin ck-dir ltr {\n\t\t\t/* Separate the label from the switch */\n\t\t\tmargin-right: calc(2 * var(--ck-spacing-large));\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\t/* Separate the label from the switch */\n\t\t\tmargin-left: calc(2 * var(--ck-spacing-large));\n\t\t}\n\t}\n\n\t& .ck-button__toggle {\n\t\t@mixin ck-rounded-corners;\n\n\t\t@mixin ck-dir ltr {\n\t\t\t/* Make sure the toggle is always to the right as far as possible. */\n\t\t\tmargin-left: auto;\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\t/* Make sure the toggle is always to the left as far as possible. */\n\t\t\tmargin-right: auto;\n\t\t}\n\n\t\t/* Gently animate the background color of the toggle switch */\n\t\ttransition: background 400ms ease;\n\n\t\twidth: var(--ck-switch-button-toggle-width);\n\t\tbackground: var(--ck-color-switch-button-off-background);\n\n\t\t& .ck-button__toggle__inner {\n\t\t\t@mixin ck-rounded-corners {\n\t\t\t\tborder-radius: calc(.5 * var(--ck-border-radius));\n\t\t\t}\n\n\t\t\t/* Leave some tiny bit of space around the inner part of the switch */\n\t\t\tmargin: var(--ck-switch-button-toggle-spacing);\n\t\t\twidth: var(--ck-switch-button-toggle-inner-size);\n\t\t\theight: var(--ck-switch-button-toggle-inner-size);\n\t\t\tbackground: var(--ck-color-switch-button-inner-background);\n\n\t\t\t/* Gently animate the inner part of the toggle switch */\n\t\t\ttransition: all 300ms ease;\n\t\t}\n\n\t\t&:hover {\n\t\t\tbackground: var(--ck-color-switch-button-off-hover-background);\n\n\t\t\t& .ck-button__toggle__inner {\n\t\t\t\tbox-shadow: 0 0 0 5px var(--ck-color-switch-button-inner-shadow);\n\t\t\t}\n\t\t}\n\t}\n\n\t&.ck-disabled .ck-button__toggle {\n\t\t@mixin ck-disabled;\n\t}\n\n\t&.ck-on .ck-button__toggle {\n\t\tbackground: var(--ck-color-switch-button-on-background);\n\n\t\t&:hover {\n\t\t\tbackground: var(--ck-color-switch-button-on-hover-background);\n\t\t}\n\n\t\t& .ck-button__toggle__inner {\n\t\t\t/*\n\t\t\t * Move the toggle switch to the right. It will be animated.\n\t\t\t */\n\t\t\t@mixin ck-dir ltr {\n\t\t\t\ttransform: translateX( var( --ck-switch-button-translation ) );\n\t\t\t}\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\ttransform: translateX( calc( -1 * var( --ck-switch-button-translation ) ) );\n\t\t\t}\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A class which indicates that an element holding it is disabled.\n */\n@define-mixin ck-disabled {\n\topacity: var(--ck-disabled-opacity);\n}\n"],
      sourceRoot: ""
    }]), e.a = s;
  }, function (t, e, n) {
    "use strict";

    var o = n(2),
      i = n.n(o),
      r = n(3),
      s = n.n(r)()(i.a);
    s.push([t.i, ".ck.ck-color-grid{display:grid}:root{--ck-color-grid-tile-size:24px;--ck-color-color-grid-check-icon:#000}.ck.ck-color-grid{grid-gap:5px;padding:8px}.ck.ck-color-grid__tile{width:var(--ck-color-grid-tile-size);height:var(--ck-color-grid-tile-size);min-width:var(--ck-color-grid-tile-size);min-height:var(--ck-color-grid-tile-size);padding:0;transition:box-shadow .2s ease;border:0}.ck.ck-color-grid__tile.ck-disabled{cursor:unset;transition:unset}.ck.ck-color-grid__tile.ck-color-table__color-tile_bordered{box-shadow:0 0 0 1px var(--ck-color-base-border)}.ck.ck-color-grid__tile .ck.ck-icon{display:none;color:var(--ck-color-color-grid-check-icon)}.ck.ck-color-grid__tile.ck-on{box-shadow:inset 0 0 0 1px var(--ck-color-base-background),0 0 0 2px var(--ck-color-base-text)}.ck.ck-color-grid__tile.ck-on .ck.ck-icon{display:block}.ck.ck-color-grid__tile.ck-on,.ck.ck-color-grid__tile:focus:not(.ck-disabled),.ck.ck-color-grid__tile:hover:not(.ck-disabled){border:0}.ck.ck-color-grid__tile:focus:not(.ck-disabled),.ck.ck-color-grid__tile:hover:not(.ck-disabled){box-shadow:inset 0 0 0 1px var(--ck-color-base-background),0 0 0 2px var(--ck-color-focus-border)}.ck.ck-color-grid__label{padding:0 var(--ck-spacing-standard)}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/colorgrid/colorgrid.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/colorgrid/colorgrid.css"],
      names: [],
      mappings: "AAKA,kBACC,YACD,CCAA,MACC,8BAA+B,CAK/B,qCACD,CAEA,kBACC,YAAa,CACb,WACD,CAEA,wBACC,oCAAqC,CACrC,qCAAsC,CACtC,wCAAyC,CACzC,yCAA0C,CAC1C,SAAU,CACV,8BAA+B,CAC/B,QAmCD,CAjCC,oCACC,YAAa,CACb,gBACD,CAEA,4DACC,gDACD,CAEA,oCACC,YAAa,CACb,2CACD,CAEA,8BACC,8FAKD,CAHC,0CACC,aACD,CAGD,8HAIC,QACD,CAEA,gGAEC,iGACD,CAGD,yBACC,oCACD",
      sourcesContent: ["/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-color-grid {\n\tdisplay: grid;\n}\n", '/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n\n:root {\n\t--ck-color-grid-tile-size: 24px;\n\n\t/* Not using global colors here because these may change but some colors in a pallette\n\t * require special treatment. For instance, this ensures no matter what the UI text color is,\n\t * the check icon will look good on the black color tile. */\n\t--ck-color-color-grid-check-icon: hsl(0, 0%, 0%);\n}\n\n.ck.ck-color-grid {\n\tgrid-gap: 5px;\n\tpadding: 8px;\n}\n\n.ck.ck-color-grid__tile {\n\twidth: var(--ck-color-grid-tile-size);\n\theight: var(--ck-color-grid-tile-size);\n\tmin-width: var(--ck-color-grid-tile-size);\n\tmin-height: var(--ck-color-grid-tile-size);\n\tpadding: 0;\n\ttransition: .2s ease box-shadow;\n\tborder: 0;\n\n\t&.ck-disabled {\n\t\tcursor: unset;\n\t\ttransition: unset;\n\t}\n\n\t&.ck-color-table__color-tile_bordered {\n\t\tbox-shadow: 0 0 0 1px var(--ck-color-base-border);\n\t}\n\n\t& .ck.ck-icon {\n\t\tdisplay: none;\n\t\tcolor: var(--ck-color-color-grid-check-icon);\n\t}\n\n\t&.ck-on {\n\t\tbox-shadow: inset 0 0 0 1px var(--ck-color-base-background), 0 0 0 2px var(--ck-color-base-text);\n\n\t\t& .ck.ck-icon {\n\t\t\tdisplay: block;\n\t\t}\n\t}\n\n\t&.ck-on,\n\t&:focus:not( .ck-disabled ),\n\t&:hover:not( .ck-disabled ) {\n\t\t/* Disable the default .ck-button\'s border ring. */\n\t\tborder: 0;\n\t}\n\n\t&:focus:not( .ck-disabled ),\n\t&:hover:not( .ck-disabled ) {\n\t\tbox-shadow: inset 0 0 0 1px var(--ck-color-base-background), 0 0 0 2px var(--ck-color-focus-border);\n\t}\n}\n\n.ck.ck-color-grid__label {\n\tpadding: 0 var(--ck-spacing-standard);\n}\n'],
      sourceRoot: ""
    }]), e.a = s;
  }, function (t, e, n) {
    "use strict";

    var o = n(2),
      i = n.n(o),
      r = n(3),
      s = n.n(r)()(i.a);
    s.push([t.i, '.ck.ck-splitbutton{font-size:inherit}.ck.ck-splitbutton .ck-splitbutton__action:focus{z-index:calc(var(--ck-z-default) + 1)}.ck.ck-splitbutton.ck-splitbutton_open>.ck-button .ck-tooltip{display:none}:root{--ck-color-split-button-hover-background:#ebebeb;--ck-color-split-button-hover-border:#b3b3b3}[dir=ltr] .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__action,[dir=ltr] .ck.ck-splitbutton:hover>.ck-splitbutton__action{border-top-right-radius:unset;border-bottom-right-radius:unset}[dir=rtl] .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__action,[dir=rtl] .ck.ck-splitbutton:hover>.ck-splitbutton__action{border-top-left-radius:unset;border-bottom-left-radius:unset}.ck.ck-splitbutton>.ck-splitbutton__arrow{min-width:unset}[dir=ltr] .ck.ck-splitbutton>.ck-splitbutton__arrow{border-top-left-radius:unset;border-bottom-left-radius:unset}[dir=rtl] .ck.ck-splitbutton>.ck-splitbutton__arrow{border-top-right-radius:unset;border-bottom-right-radius:unset}.ck.ck-splitbutton>.ck-splitbutton__arrow svg{width:var(--ck-dropdown-arrow-size)}.ck.ck-splitbutton.ck-splitbutton_open>.ck-button:not(.ck-on):not(.ck-disabled):not(:hover),.ck.ck-splitbutton:hover>.ck-button:not(.ck-on):not(.ck-disabled):not(:hover){background:var(--ck-color-split-button-hover-background)}.ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):after,.ck.ck-splitbutton:hover>.ck-splitbutton__arrow:not(.ck-disabled):after{content:"";position:absolute;width:1px;height:100%;background-color:var(--ck-color-split-button-hover-border)}[dir=ltr] .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):after,[dir=ltr] .ck.ck-splitbutton:hover>.ck-splitbutton__arrow:not(.ck-disabled):after{left:-1px}[dir=rtl] .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):after,[dir=rtl] .ck.ck-splitbutton:hover>.ck-splitbutton__arrow:not(.ck-disabled):after{right:-1px}.ck.ck-splitbutton.ck-splitbutton_open{border-radius:0}.ck-rounded-corners .ck.ck-splitbutton.ck-splitbutton_open,.ck.ck-splitbutton.ck-splitbutton_open.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck-rounded-corners .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__action,.ck.ck-splitbutton.ck-splitbutton_open.ck-rounded-corners>.ck-splitbutton__action{border-bottom-left-radius:0}.ck-rounded-corners .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow,.ck.ck-splitbutton.ck-splitbutton_open.ck-rounded-corners>.ck-splitbutton__arrow{border-bottom-right-radius:0}', "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/dropdown/splitbutton.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/tooltip/mixins/_tooltip.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/dropdown/splitbutton.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css"],
      names: [],
      mappings: "AAOA,mBAEC,iBAUD,CARC,iDACC,qCACD,CC0BA,8DACC,YACD,CClCD,MACC,gDAAyD,CACzD,4CACD,CAMC,oIAIE,6BAA8B,CAC9B,gCAQF,CAbA,oIAUE,4BAA6B,CAC7B,+BAEF,CAEA,0CAGC,eAiBD,CApBA,oDAOE,4BAA6B,CAC7B,+BAYF,CApBA,oDAaE,6BAA8B,CAC9B,gCAMF,CAHC,8CACC,mCACD,CASA,0KACC,wDACD,CAIA,8JACC,UAAW,CACX,iBAAkB,CAClB,SAAU,CACV,WAAY,CACZ,0DACD,CAGC,kLACC,SACD,CAIA,kLACC,UACD,CAMF,uCC7EA,eDuFA,CAVA,qHCzEC,qCDmFD,CARE,qKACC,2BACD,CAEA,mKACC,4BACD",
      sourcesContent: ['/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../tooltip/mixins/_tooltip.css";\n\n.ck.ck-splitbutton {\n\t/* Enable font size inheritance, which allows fluid UI scaling. */\n\tfont-size: inherit;\n\n\t& .ck-splitbutton__action:focus {\n\t\tz-index: calc(var(--ck-z-default) + 1);\n\t}\n\n\t/* Disable tooltips for the buttons when the button is "open" */\n\t&.ck-splitbutton_open > .ck-button {\n\t\t@mixin ck-tooltip_disabled;\n\t}\n}\n\n', "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Enables the tooltip, which is the tooltip is in DOM but\n * not yet displayed.\n */\n@define-mixin ck-tooltip_enabled {\n\t& .ck-tooltip {\n\t\tdisplay: block;\n\n\t\t/*\n\t\t * Don't display tooltips in devices which don't support :hover.\n\t\t * In fact, it's all about iOS, which forces user to click UI elements twice to execute\n\t\t * the primary action, when tooltips are enabled.\n\t\t *\n\t\t * Q: OK, but why not the following query?\n\t\t *\n\t\t *   @media (hover) {\n\t\t *       display: block;\n\t\t *   }\n\t\t *\n\t\t * A: Because FF does not support it and it would completely disable tooltips\n\t\t * in that browser.\n\t\t *\n\t\t * More in https://github.com/ckeditor/ckeditor5/issues/920.\n\t\t */\n\t\t@media (hover:none) {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n\n/**\n * Disables the tooltip making it disappear from DOM.\n */\n@define-mixin ck-tooltip_disabled {\n\t& .ck-tooltip {\n\t\tdisplay: none;\n\t}\n}\n\n/**\n * Shows the tooltip, which is already in DOM.\n * Requires `ck-tooltip_enabled` first.\n */\n@define-mixin ck-tooltip_visible {\n\t& .ck-tooltip {\n\t\tvisibility: visible;\n\t\topacity: 1;\n\t}\n}\n", '/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n\n:root {\n\t--ck-color-split-button-hover-background: hsl(0, 0%, 92%);\n\t--ck-color-split-button-hover-border: hsl(0, 0%, 70%);\n}\n\n.ck.ck-splitbutton {\n\t/*\n\t * Note: ck-rounded and ck-dir mixins don\'t go together (because they both use @nest).\n\t */\n\t&:hover > .ck-splitbutton__action,\n\t&.ck-splitbutton_open > .ck-splitbutton__action {\n\t\t@nest [dir="ltr"] & {\n\t\t\t/* Don\'t round the action button on the right side */\n\t\t\tborder-top-right-radius: unset;\n\t\t\tborder-bottom-right-radius: unset;\n\t\t}\n\n\t\t@nest [dir="rtl"] & {\n\t\t\t/* Don\'t round the action button on the left side */\n\t\t\tborder-top-left-radius: unset;\n\t\t\tborder-bottom-left-radius: unset;\n\t\t}\n\t}\n\n\t& > .ck-splitbutton__arrow {\n\t\t/* It\'s a text-less button and since the icon is positioned absolutely in such situation,\n\t\tit must get some arbitrary min-width. */\n\t\tmin-width: unset;\n\n\t\t@nest [dir="ltr"] & {\n\t\t\t/* Don\'t round the arrow button on the left side */\n\t\t\tborder-top-left-radius: unset;\n\t\t\tborder-bottom-left-radius: unset;\n\t\t}\n\n\t\t@nest [dir="rtl"] & {\n\t\t\t/* Don\'t round the arrow button on the right side */\n\t\t\tborder-top-right-radius: unset;\n\t\t\tborder-bottom-right-radius: unset;\n\t\t}\n\n\t\t& svg {\n\t\t\twidth: var(--ck-dropdown-arrow-size);\n\t\t}\n\t}\n\n\t/* When the split button is "open" (the arrow is on) or being hovered, it should get some styling\n\tas a whole. The background of both buttons should stand out and there should be a visual\n\tseparation between both buttons. */\n\t&.ck-splitbutton_open,\n\t&:hover {\n\t\t/* When the split button hovered as a whole, not as individual buttons. */\n\t\t& > .ck-button:not(.ck-on):not(.ck-disabled):not(:hover) {\n\t\t\tbackground: var(--ck-color-split-button-hover-background);\n\t\t}\n\n\t\t/* Splitbutton separator needs to be set with the ::after pseudoselector\n\t\tto display properly the borders on focus */\n\t\t& > .ck-splitbutton__arrow:not(.ck-disabled)::after {\n\t\t\tcontent: \'\';\n\t\t\tposition: absolute;\n\t\t\twidth: 1px;\n\t\t\theight: 100%;\n\t\t\tbackground-color: var(--ck-color-split-button-hover-border);\n\t\t}\n\n\t\t@nest [dir="ltr"] & {\n\t\t\t& > .ck-splitbutton__arrow:not(.ck-disabled)::after {\n\t\t\t\tleft: -1px;\n\t\t\t}\n\t\t}\n\n\t\t@nest [dir="rtl"] & {\n\t\t\t& > .ck-splitbutton__arrow:not(.ck-disabled)::after {\n\t\t\t\tright: -1px;\n\t\t\t}\n\t\t}\n\t}\n\n\t/* Don\'t round the bottom left and right corners of the buttons when "open"\n\thttps://github.com/ckeditor/ckeditor5/issues/816 */\n\t&.ck-splitbutton_open {\n\t\t@mixin ck-rounded-corners {\n\t\t\t& > .ck-splitbutton__action {\n\t\t\t\tborder-bottom-left-radius: 0;\n\t\t\t}\n\n\t\t\t& > .ck-splitbutton__arrow {\n\t\t\t\tborder-bottom-right-radius: 0;\n\t\t\t}\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n"],
      sourceRoot: ""
    }]), e.a = s;
  }, function (t, e, n) {
    "use strict";

    var o = n(2),
      i = n.n(o),
      r = n(3),
      s = n.n(r)()(i.a);
    s.push([t.i, ":root{--ck-dropdown-max-width:75vw}.ck.ck-dropdown{display:inline-block;position:relative}.ck.ck-dropdown .ck-dropdown__arrow{pointer-events:none;z-index:var(--ck-z-default)}.ck.ck-dropdown .ck-button.ck-dropdown__button{width:100%}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-on .ck-tooltip{display:none}.ck.ck-dropdown .ck-dropdown__panel{-webkit-backface-visibility:hidden;display:none;z-index:var(--ck-z-modal);max-width:var(--ck-dropdown-max-width);position:absolute}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel-visible{display:inline-block}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_n,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_ne,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nme,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nmw,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nw{bottom:100%}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_s,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_se,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sme,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_smw,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sw{top:100%;bottom:auto}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_ne,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_se{left:0}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nw,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sw{right:0}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_n,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_s{left:50%;transform:translateX(-50%)}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nmw,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_smw{left:75%;transform:translateX(-75%)}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nme,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sme{left:25%;transform:translateX(-25%)}.ck.ck-toolbar .ck-dropdown__panel{z-index:calc(var(--ck-z-modal) + 1)}:root{--ck-dropdown-arrow-size:calc(var(--ck-icon-size)*0.5)}.ck.ck-dropdown{font-size:inherit}.ck.ck-dropdown .ck-dropdown__arrow{width:var(--ck-dropdown-arrow-size)}[dir=ltr] .ck.ck-dropdown .ck-dropdown__arrow{right:var(--ck-spacing-standard);margin-left:var(--ck-spacing-standard)}[dir=rtl] .ck.ck-dropdown .ck-dropdown__arrow{left:var(--ck-spacing-standard);margin-right:var(--ck-spacing-small)}.ck.ck-dropdown.ck-disabled .ck-dropdown__arrow{opacity:var(--ck-disabled-opacity)}[dir=ltr] .ck.ck-dropdown .ck-button.ck-dropdown__button:not(.ck-button_with-text){padding-left:var(--ck-spacing-small)}[dir=rtl] .ck.ck-dropdown .ck-button.ck-dropdown__button:not(.ck-button_with-text){padding-right:var(--ck-spacing-small)}.ck.ck-dropdown .ck-button.ck-dropdown__button .ck-button__label{width:7em;overflow:hidden;text-overflow:ellipsis}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-disabled .ck-button__label{opacity:var(--ck-disabled-opacity)}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-on{border-bottom-left-radius:0;border-bottom-right-radius:0}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-dropdown__button_label-width_auto .ck-button__label{width:auto}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-off:active,.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-on:active{box-shadow:none}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-off:active:focus,.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-on:active:focus{box-shadow:var(--ck-focus-outer-shadow),0 0}.ck.ck-dropdown__panel{border-radius:0}.ck-rounded-corners .ck.ck-dropdown__panel,.ck.ck-dropdown__panel.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-dropdown__panel{box-shadow:var(--ck-drop-shadow),0 0;background:var(--ck-color-dropdown-panel-background);border:1px solid var(--ck-color-dropdown-panel-border);bottom:0;min-width:100%}.ck.ck-dropdown__panel.ck-dropdown__panel_se{border-top-left-radius:0}.ck.ck-dropdown__panel.ck-dropdown__panel_sw{border-top-right-radius:0}.ck.ck-dropdown__panel.ck-dropdown__panel_ne{border-bottom-left-radius:0}.ck.ck-dropdown__panel.ck-dropdown__panel_nw{border-bottom-right-radius:0}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/dropdown/dropdown.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/tooltip/mixins/_tooltip.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/dropdown/dropdown.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_disabled.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css"],
      names: [],
      mappings: "AAOA,MACC,4BACD,CAEA,gBACC,oBAAqB,CACrB,iBAqFD,CAnFC,oCACC,mBAAoB,CACpB,2BACD,CAGA,+CACC,UAOD,CCUA,iEACC,YACD,CDVA,oCAGC,kCAAmC,CAEnC,YAAa,CACb,yBAA0B,CAC1B,sCAAuC,CAEvC,iBAyDD,CAvDC,+DACC,oBACD,CAEA,mSAKC,WACD,CAEA,mSASC,QAAS,CACT,WACD,CAEA,oHAEC,MACD,CAEA,oHAEC,OACD,CAEA,kHAGC,QAAS,CACT,0BACD,CAEA,sHAGC,QAAS,CACT,0BACD,CAEA,sHAGC,QAAS,CACT,0BACD,CAQF,mCACC,mCACD,CEhGA,MACC,sDACD,CAEA,gBAEC,iBA2ED,CAzEC,oCACC,mCACD,CAGC,8CACC,gCAAiC,CAGjC,sCACD,CAIA,8CACC,+BAAgC,CAGhC,oCACD,CAGD,gDC/BA,kCDiCA,CAIE,mFAEC,oCACD,CAIA,mFAEC,qCACD,CAID,iEACC,SAAU,CACV,eAAgB,CAChB,sBACD,CAGA,6EC1DD,kCD4DC,CAGA,qDACC,2BAA4B,CAC5B,4BACD,CAEA,sGACC,UACD,CAGA,yHAEC,eAKD,CAHC,qIE7EF,2CF+EE,CAKH,uBGlFC,eH8GD,CA5BA,qFG9EE,qCH0GF,CA5BA,uBEpFC,oCAA8B,CFwF9B,oDAAqD,CACrD,sDAAuD,CACvD,QAAS,CAGT,cAmBD,CAfC,6CACC,wBACD,CAEA,6CACC,yBACD,CAEA,6CACC,2BACD,CAEA,6CACC,4BACD",
      sourcesContent: ["/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import \"../tooltip/mixins/_tooltip.css\";\n\n:root {\n\t--ck-dropdown-max-width: 75vw;\n}\n\n.ck.ck-dropdown {\n\tdisplay: inline-block;\n\tposition: relative;\n\n\t& .ck-dropdown__arrow {\n\t\tpointer-events: none;\n\t\tz-index: var(--ck-z-default);\n\t}\n\n\t/* Dropdown button should span horizontally, e.g. in vertical toolbars */\n\t& .ck-button.ck-dropdown__button {\n\t\twidth: 100%;\n\n\t\t/* Disable main button's tooltip when the dropdown is open. Otherwise the panel may\n\t\tpartially cover the tooltip */\n\t\t&.ck-on {\n\t\t\t@mixin ck-tooltip_disabled;\n\t\t}\n\t}\n\n\t& .ck-dropdown__panel {\n\t\t/* This is to get rid of flickering when the tooltip is shown under the panel,\n\t\twhich looks like the panel moves vertically a pixel down and up. */\n\t\t-webkit-backface-visibility: hidden;\n\n\t\tdisplay: none;\n\t\tz-index: var(--ck-z-modal);\n\t\tmax-width: var(--ck-dropdown-max-width);\n\n\t\tposition: absolute;\n\n\t\t&.ck-dropdown__panel-visible {\n\t\t\tdisplay: inline-block;\n\t\t}\n\n\t\t&.ck-dropdown__panel_ne,\n\t\t&.ck-dropdown__panel_nw,\n\t\t&.ck-dropdown__panel_n,\n\t\t&.ck-dropdown__panel_nmw,\n\t\t&.ck-dropdown__panel_nme {\n\t\t\tbottom: 100%;\n\t\t}\n\n\t\t&.ck-dropdown__panel_se,\n\t\t&.ck-dropdown__panel_sw,\n\t\t&.ck-dropdown__panel_smw,\n\t\t&.ck-dropdown__panel_sme,\n\t\t&.ck-dropdown__panel_s {\n\t\t\t/*\n\t\t\t * Using transform: translate3d( 0, 100%, 0 ) causes blurry dropdown on Chrome 67-78+ on non-retina displays.\n\t\t\t * See https://github.com/ckeditor/ckeditor5/issues/1053.\n\t\t\t */\n\t\t\ttop: 100%;\n\t\t\tbottom: auto;\n\t\t}\n\n\t\t&.ck-dropdown__panel_ne,\n\t\t&.ck-dropdown__panel_se {\n\t\t\tleft: 0px;\n\t\t}\n\n\t\t&.ck-dropdown__panel_nw,\n\t\t&.ck-dropdown__panel_sw {\n\t\t\tright: 0px;\n\t\t}\n\n\t\t&.ck-dropdown__panel_s,\n\t\t&.ck-dropdown__panel_n {\n\t\t\t/* Positioning panels relative to the center of the button */\n\t\t\tleft: 50%;\n\t\t\ttransform: translateX(-50%);\n\t\t}\n\n\t\t&.ck-dropdown__panel_nmw,\n\t\t&.ck-dropdown__panel_smw {\n\t\t\t/* Positioning panels relative to the middle-west of the button */\n\t\t\tleft: 75%;\n\t\t\ttransform: translateX(-75%);\n\t\t}\n\n\t\t&.ck-dropdown__panel_nme,\n\t\t&.ck-dropdown__panel_sme {\n\t\t\t/* Positioning panels relative to the middle-east of the button */\n\t\t\tleft: 25%;\n\t\t\ttransform: translateX(-25%);\n\t\t}\n\t}\n}\n\n/*\n * Toolbar dropdown panels should be always above the UI (eg. other dropdown panels) from the editor's content.\n * See https://github.com/ckeditor/ckeditor5/issues/7874\n */\n.ck.ck-toolbar .ck-dropdown__panel {\n\tz-index: calc( var(--ck-z-modal) + 1 );\n}\n", "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Enables the tooltip, which is the tooltip is in DOM but\n * not yet displayed.\n */\n@define-mixin ck-tooltip_enabled {\n\t& .ck-tooltip {\n\t\tdisplay: block;\n\n\t\t/*\n\t\t * Don't display tooltips in devices which don't support :hover.\n\t\t * In fact, it's all about iOS, which forces user to click UI elements twice to execute\n\t\t * the primary action, when tooltips are enabled.\n\t\t *\n\t\t * Q: OK, but why not the following query?\n\t\t *\n\t\t *   @media (hover) {\n\t\t *       display: block;\n\t\t *   }\n\t\t *\n\t\t * A: Because FF does not support it and it would completely disable tooltips\n\t\t * in that browser.\n\t\t *\n\t\t * More in https://github.com/ckeditor/ckeditor5/issues/920.\n\t\t */\n\t\t@media (hover:none) {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n\n/**\n * Disables the tooltip making it disappear from DOM.\n */\n@define-mixin ck-tooltip_disabled {\n\t& .ck-tooltip {\n\t\tdisplay: none;\n\t}\n}\n\n/**\n * Shows the tooltip, which is already in DOM.\n * Requires `ck-tooltip_enabled` first.\n */\n@define-mixin ck-tooltip_visible {\n\t& .ck-tooltip {\n\t\tvisibility: visible;\n\t\topacity: 1;\n\t}\n}\n", '/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_disabled.css";\n@import "../../../mixins/_shadow.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n:root {\n\t--ck-dropdown-arrow-size: calc(0.5 * var(--ck-icon-size));\n}\n\n.ck.ck-dropdown {\n\t/* Enable font size inheritance, which allows fluid UI scaling. */\n\tfont-size: inherit;\n\n\t& .ck-dropdown__arrow {\n\t\twidth: var(--ck-dropdown-arrow-size);\n\t}\n\n\t@mixin ck-dir ltr {\n\t\t& .ck-dropdown__arrow {\n\t\t\tright: var(--ck-spacing-standard);\n\n\t\t\t/* A space to accommodate the triangle. */\n\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t}\n\t}\n\n\t@mixin ck-dir rtl {\n\t\t& .ck-dropdown__arrow {\n\t\t\tleft: var(--ck-spacing-standard);\n\n\t\t\t/* A space to accommodate the triangle. */\n\t\t\tmargin-right: var(--ck-spacing-small);\n\t\t}\n\t}\n\n\t&.ck-disabled .ck-dropdown__arrow {\n\t\t@mixin ck-disabled;\n\t}\n\n\t& .ck-button.ck-dropdown__button {\n\t\t@mixin ck-dir ltr {\n\t\t\t&:not(.ck-button_with-text) {\n\t\t\t\t/* Make sure dropdowns with just an icon have the right inner spacing */\n\t\t\t\tpadding-left: var(--ck-spacing-small);\n\t\t\t}\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\t&:not(.ck-button_with-text) {\n\t\t\t\t/* Make sure dropdowns with just an icon have the right inner spacing */\n\t\t\t\tpadding-right: var(--ck-spacing-small);\n\t\t\t}\n\t\t}\n\n\t\t/* #23 */\n\t\t& .ck-button__label {\n\t\t\twidth: 7em;\n\t\t\toverflow: hidden;\n\t\t\ttext-overflow: ellipsis;\n\t\t}\n\n\t\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/70 */\n\t\t&.ck-disabled .ck-button__label {\n\t\t\t@mixin ck-disabled;\n\t\t}\n\n\t\t/* https://github.com/ckeditor/ckeditor5/issues/816 */\n\t\t&.ck-on {\n\t\t\tborder-bottom-left-radius: 0;\n\t\t\tborder-bottom-right-radius: 0;\n\t\t}\n\n\t\t&.ck-dropdown__button_label-width_auto .ck-button__label {\n\t\t\twidth: auto;\n\t\t}\n\n\t\t/* https://github.com/ckeditor/ckeditor5/issues/8699 */\n\t\t&.ck-off:active,\n\t\t&.ck-on:active {\n\t\t\tbox-shadow: none;\n\t\t\t\n\t\t\t&:focus {\n\t\t\t\t@mixin ck-box-shadow var(--ck-focus-outer-shadow);\n\t\t\t}\n\t\t}\n\t}\n}\n\n.ck.ck-dropdown__panel {\n\t@mixin ck-rounded-corners;\n\t@mixin ck-drop-shadow;\n\n\tbackground: var(--ck-color-dropdown-panel-background);\n\tborder: 1px solid var(--ck-color-dropdown-panel-border);\n\tbottom: 0;\n\n\t/* Make sure the panel is at least as wide as the drop-down\'s button. */\n\tmin-width: 100%;\n\n\t/* Disabled corner border radius to be consistent with the .dropdown__button\n\thttps://github.com/ckeditor/ckeditor5/issues/816 */\n\t&.ck-dropdown__panel_se {\n\t\tborder-top-left-radius: 0;\n\t}\n\n\t&.ck-dropdown__panel_sw {\n\t\tborder-top-right-radius: 0;\n\t}\n\n\t&.ck-dropdown__panel_ne {\n\t\tborder-bottom-left-radius: 0;\n\t}\n\n\t&.ck-dropdown__panel_nw {\n\t\tborder-bottom-right-radius: 0;\n\t}\n}\n', "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A class which indicates that an element holding it is disabled.\n */\n@define-mixin ck-disabled {\n\topacity: var(--ck-disabled-opacity);\n}\n", "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n", "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n"],
      sourceRoot: ""
    }]), e.a = s;
  }, function (t, e, n) {
    "use strict";

    var o = n(2),
      i = n.n(o),
      r = n(3),
      s = n.n(r)()(i.a);
    s.push([t.i, ".ck.ck-toolbar{-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none;display:flex;flex-flow:row nowrap;align-items:center}.ck.ck-toolbar>.ck-toolbar__items{display:flex;flex-flow:row wrap;align-items:center;flex-grow:1}.ck.ck-toolbar .ck.ck-toolbar__separator{display:inline-block}.ck.ck-toolbar .ck.ck-toolbar__separator:first-child,.ck.ck-toolbar .ck.ck-toolbar__separator:last-child{display:none}.ck.ck-toolbar .ck-toolbar__line-break{flex-basis:100%}.ck.ck-toolbar.ck-toolbar_grouping>.ck-toolbar__items{flex-wrap:nowrap}.ck.ck-toolbar.ck-toolbar_vertical>.ck-toolbar__items{flex-direction:column}.ck.ck-toolbar.ck-toolbar_floating>.ck-toolbar__items{flex-wrap:nowrap}.ck.ck-toolbar>.ck.ck-toolbar__grouped-dropdown>.ck-dropdown__button .ck-dropdown__arrow{display:none}.ck.ck-toolbar{border-radius:0}.ck-rounded-corners .ck.ck-toolbar,.ck.ck-toolbar.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-toolbar{background:var(--ck-color-toolbar-background);padding:0 var(--ck-spacing-small);border:1px solid var(--ck-color-toolbar-border)}.ck.ck-toolbar .ck.ck-toolbar__separator{align-self:stretch;width:1px;min-width:1px;background:var(--ck-color-toolbar-border);margin-top:var(--ck-spacing-small);margin-bottom:var(--ck-spacing-small)}.ck.ck-toolbar .ck-toolbar__line-break{height:0}.ck.ck-toolbar>.ck-toolbar__items>:not(.ck-toolbar__line-break){margin-right:var(--ck-spacing-small)}.ck.ck-toolbar>.ck-toolbar__items:empty+.ck.ck-toolbar__separator{display:none}.ck.ck-toolbar>.ck-toolbar__items>:not(.ck-toolbar__line-break),.ck.ck-toolbar>.ck.ck-toolbar__grouped-dropdown{margin-top:var(--ck-spacing-small);margin-bottom:var(--ck-spacing-small)}.ck.ck-toolbar.ck-toolbar_vertical{padding:0}.ck.ck-toolbar.ck-toolbar_vertical>.ck-toolbar__items>.ck{width:100%;margin:0;border-radius:0;border:0}.ck.ck-toolbar.ck-toolbar_compact{padding:0}.ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>*{margin:0}.ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>:not(:first-child):not(:last-child){border-radius:0}.ck.ck-toolbar>.ck.ck-toolbar__grouped-dropdown>.ck.ck-button.ck-dropdown__button{padding-left:var(--ck-spacing-tiny)}.ck-toolbar-container .ck.ck-toolbar{border:0}.ck.ck-toolbar[dir=rtl]>.ck-toolbar__items>.ck,[dir=rtl] .ck.ck-toolbar>.ck-toolbar__items>.ck{margin-right:0}.ck.ck-toolbar[dir=rtl]:not(.ck-toolbar_compact)>.ck-toolbar__items>.ck,[dir=rtl] .ck.ck-toolbar:not(.ck-toolbar_compact)>.ck-toolbar__items>.ck{margin-left:var(--ck-spacing-small)}.ck.ck-toolbar[dir=rtl]>.ck-toolbar__items>.ck:last-child,[dir=rtl] .ck.ck-toolbar>.ck-toolbar__items>.ck:last-child{margin-left:0}.ck.ck-toolbar[dir=rtl].ck-toolbar_compact>.ck-toolbar__items>.ck:first-child,[dir=rtl] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:first-child{border-top-left-radius:0;border-bottom-left-radius:0}.ck.ck-toolbar[dir=rtl].ck-toolbar_compact>.ck-toolbar__items>.ck:last-child,[dir=rtl] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:last-child{border-top-right-radius:0;border-bottom-right-radius:0}.ck.ck-toolbar[dir=rtl]>.ck.ck-toolbar__separator,[dir=rtl] .ck.ck-toolbar>.ck.ck-toolbar__separator{margin-left:var(--ck-spacing-small)}.ck.ck-toolbar[dir=rtl].ck-toolbar_grouping>.ck-toolbar__items:not(:empty):not(:only-child),[dir=rtl] .ck.ck-toolbar.ck-toolbar_grouping>.ck-toolbar__items:not(:empty):not(:only-child){margin-left:var(--ck-spacing-small)}.ck.ck-toolbar[dir=ltr]>.ck-toolbar__items>.ck:last-child,[dir=ltr] .ck.ck-toolbar>.ck-toolbar__items>.ck:last-child{margin-right:0}.ck.ck-toolbar[dir=ltr].ck-toolbar_compact>.ck-toolbar__items>.ck:first-child,[dir=ltr] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:first-child{border-top-right-radius:0;border-bottom-right-radius:0}.ck.ck-toolbar[dir=ltr].ck-toolbar_compact>.ck-toolbar__items>.ck:last-child,[dir=ltr] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:last-child{border-top-left-radius:0;border-bottom-left-radius:0}.ck.ck-toolbar[dir=ltr]>.ck.ck-toolbar__separator,[dir=ltr] .ck.ck-toolbar>.ck.ck-toolbar__separator{margin-right:var(--ck-spacing-small)}.ck.ck-toolbar[dir=ltr].ck-toolbar_grouping>.ck-toolbar__items:not(:empty):not(:only-child),[dir=ltr] .ck.ck-toolbar.ck-toolbar_grouping>.ck-toolbar__items:not(:empty):not(:only-child){margin-right:var(--ck-spacing-small)}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/toolbar/toolbar.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_unselectable.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/toolbar/toolbar.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css"],
      names: [],
      mappings: "AAOA,eCEC,qBAAsB,CACtB,wBAAyB,CACzB,oBAAqB,CACrB,gBAAgB,CDFhB,YAAa,CACb,oBAAqB,CACrB,kBA6CD,CA3CC,kCACC,YAAa,CACb,kBAAmB,CACnB,kBAAmB,CACnB,WAED,CAEA,yCACC,oBAWD,CAJC,yGAEC,YACD,CAGD,uCACC,eACD,CAEA,sDACC,gBACD,CAEA,sDACC,qBACD,CAEA,sDACC,gBACD,CAGC,yFACC,YACD,CE/CF,eCGC,eD0FD,CA7FA,qECOE,qCDsFF,CA7FA,eAGC,6CAA8C,CAC9C,iCAAkC,CAClC,+CAwFD,CAtFC,yCACC,kBAAmB,CACnB,SAAU,CACV,aAAc,CACd,yCAA0C,CAM1C,kCAAmC,CACnC,qCACD,CAEA,uCACC,QACD,CAGC,gEAEC,oCACD,CAIA,kEACC,YACD,CAGD,gHAGC,kCAAmC,CACnC,qCACD,CAEA,mCAEC,SAgBD,CAbC,0DAEC,UAAW,CAGX,QAAS,CAGT,eAAgB,CAGhB,QACD,CAGD,kCAEC,SAWD,CATC,uDAEC,QAMD,CAHC,yFACC,eACD,CASD,kFACC,mCACD,CAvFF,qCA2FE,QAEF,CAYC,+FACC,cACD,CAEA,iJAEC,mCACD,CAEA,qHACC,aACD,CAIC,6JACC,wBAAyB,CACzB,2BACD,CAGA,2JACC,yBAA0B,CAC1B,4BACD,CAID,qGACC,mCACD,CAGA,yLACC,mCACD,CAWA,qHACC,cACD,CAIC,6JACC,yBAA0B,CAC1B,4BACD,CAGA,2JACC,wBAAyB,CACzB,2BACD,CAID,qGACC,oCACD,CAGA,yLACC,oCACD",
      sourcesContent: ['/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../mixins/_unselectable.css";\n\n.ck.ck-toolbar {\n\t@mixin ck-unselectable;\n\n\tdisplay: flex;\n\tflex-flow: row nowrap;\n\talign-items: center;\n\n\t& > .ck-toolbar__items {\n\t\tdisplay: flex;\n\t\tflex-flow: row wrap;\n\t\talign-items: center;\n\t\tflex-grow: 1;\n\n\t}\n\n\t& .ck.ck-toolbar__separator {\n\t\tdisplay: inline-block;\n\n\t\t/*\n\t\t * A leading or trailing separator makes no sense (separates from nothing on one side).\n\t\t * For instance, it can happen when toolbar items (also separators) are getting grouped one by one and\n\t\t * moved to another toolbar in the dropdown.\n\t\t */\n\t\t&:first-child,\n\t\t&:last-child {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\t& .ck-toolbar__line-break {\n\t\tflex-basis: 100%;\n\t}\n\n\t&.ck-toolbar_grouping > .ck-toolbar__items {\n\t\tflex-wrap: nowrap;\n\t}\n\n\t&.ck-toolbar_vertical > .ck-toolbar__items {\n\t\tflex-direction: column;\n\t}\n\n\t&.ck-toolbar_floating > .ck-toolbar__items {\n\t\tflex-wrap: nowrap;\n\t}\n\n\t& > .ck.ck-toolbar__grouped-dropdown {\n\t\t& > .ck-dropdown__button .ck-dropdown__arrow {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Makes element unselectable.\n */\n@define-mixin ck-unselectable {\n\t-moz-user-select: none;\n\t-webkit-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none\n}\n", '/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n.ck.ck-toolbar {\n\t@mixin ck-rounded-corners;\n\n\tbackground: var(--ck-color-toolbar-background);\n\tpadding: 0 var(--ck-spacing-small);\n\tborder: 1px solid var(--ck-color-toolbar-border);\n\n\t& .ck.ck-toolbar__separator {\n\t\talign-self: stretch;\n\t\twidth: 1px;\n\t\tmin-width: 1px;\n\t\tbackground: var(--ck-color-toolbar-border);\n\n\t\t/*\n\t\t * These margins make the separators look better in balloon toolbars (when aligned with the "tip").\n\t\t * See https://github.com/ckeditor/ckeditor5/issues/7493.\n\t\t */\n\t\tmargin-top: var(--ck-spacing-small);\n\t\tmargin-bottom: var(--ck-spacing-small);\n\t}\n\n\t& .ck-toolbar__line-break {\n\t\theight: 0;\n\t}\n\n\t& > .ck-toolbar__items {\n\t\t& > *:not(.ck-toolbar__line-break) {\n\t\t\t/* (#11) Separate toolbar items. */\n\t\t\tmargin-right: var(--ck-spacing-small);\n\t\t}\n\n\t\t/* Don\'t display a separator after an empty items container, for instance,\n\t\twhen all items were grouped */\n\t\t&:empty + .ck.ck-toolbar__separator {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\t& > .ck-toolbar__items > *:not(.ck-toolbar__line-break),\n\t& > .ck.ck-toolbar__grouped-dropdown {\n\t\t/* Make sure items wrapped to the next line have v-spacing */\n\t\tmargin-top: var(--ck-spacing-small);\n\t\tmargin-bottom: var(--ck-spacing-small);\n\t}\n\n\t&.ck-toolbar_vertical {\n\t\t/* Items in a vertical toolbar span the entire width. */\n\t\tpadding: 0;\n\n\t\t/* Specificity matters here. See https://github.com/ckeditor/ckeditor5-theme-lark/issues/168. */\n\t\t& > .ck-toolbar__items > .ck {\n\t\t\t/* Items in a vertical toolbar should span the horizontal space. */\n\t\t\twidth: 100%;\n\n\t\t\t/* Items in a vertical toolbar should have no margin. */\n\t\t\tmargin: 0;\n\n\t\t\t/* Items in a vertical toolbar span the entire width so rounded corners are pointless. */\n\t\t\tborder-radius: 0;\n\n\t\t\t/* Items in a vertical toolbar span the entire width so any border is pointless. */\n\t\t\tborder: 0;\n\t\t}\n\t}\n\n\t&.ck-toolbar_compact {\n\t\t/* No spacing around items. */\n\t\tpadding: 0;\n\n\t\t& > .ck-toolbar__items > * {\n\t\t\t/* Compact toolbar items have no spacing between them. */\n\t\t\tmargin: 0;\n\n\t\t\t/* "Middle" children should have no rounded corners. */\n\t\t\t&:not(:first-child):not(:last-child) {\n\t\t\t\tborder-radius: 0;\n\t\t\t}\n\t\t}\n\t}\n\n\t& > .ck.ck-toolbar__grouped-dropdown {\n\t\t/*\n\t\t * Dropdown button has asymmetric padding to fit the arrow.\n\t\t * This button has no arrow so let\'s revert that padding back to normal.\n\t\t */\n\t\t& > .ck.ck-button.ck-dropdown__button {\n\t\t\tpadding-left: var(--ck-spacing-tiny);\n\t\t}\n\t}\n\n\t@nest .ck-toolbar-container & {\n\t\tborder: 0;\n\t}\n}\n\n/* stylelint-disable */\n\n/*\n * Styles for RTL toolbars.\n *\n * Note: In some cases (e.g. a decoupled editor), the toolbar has its own "dir"\n * because its parent is not controlled by the editor framework.\n */\n[dir="rtl"] .ck.ck-toolbar,\n.ck.ck-toolbar[dir="rtl"] {\n\t& > .ck-toolbar__items > .ck {\n\t\tmargin-right: 0;\n\t}\n\n\t&:not(.ck-toolbar_compact) > .ck-toolbar__items > .ck {\n\t\t/* (#11) Separate toolbar items. */\n\t\tmargin-left: var(--ck-spacing-small);\n\t}\n\n\t& > .ck-toolbar__items > .ck:last-child {\n\t\tmargin-left: 0;\n\t}\n\n\t&.ck-toolbar_compact > .ck-toolbar__items > .ck {\n\t\t/* No rounded corners on the right side of the first child. */\n\t\t&:first-child {\n\t\t\tborder-top-left-radius: 0;\n\t\t\tborder-bottom-left-radius: 0;\n\t\t}\n\n\t\t/* No rounded corners on the left side of the last child. */\n\t\t&:last-child {\n\t\t\tborder-top-right-radius: 0;\n\t\t\tborder-bottom-right-radius: 0;\n\t\t}\n\t}\n\n\t/* Separate the the separator form the grouping dropdown when some items are grouped. */\n\t& > .ck.ck-toolbar__separator {\n\t\tmargin-left: var(--ck-spacing-small);\n\t}\n\n\t/* Some spacing between the items and the separator before the grouped items dropdown. */\n\t&.ck-toolbar_grouping > .ck-toolbar__items:not(:empty):not(:only-child) {\n\t\tmargin-left: var(--ck-spacing-small);\n\t}\n}\n\n/*\n * Styles for LTR toolbars.\n *\n * Note: In some cases (e.g. a decoupled editor), the toolbar has its own "dir"\n * because its parent is not controlled by the editor framework.\n */\n[dir="ltr"] .ck.ck-toolbar,\n.ck.ck-toolbar[dir="ltr"] {\n\t& > .ck-toolbar__items > .ck:last-child {\n\t\tmargin-right: 0;\n\t}\n\n\t&.ck-toolbar_compact > .ck-toolbar__items > .ck {\n\t\t/* No rounded corners on the right side of the first child. */\n\t\t&:first-child {\n\t\t\tborder-top-right-radius: 0;\n\t\t\tborder-bottom-right-radius: 0;\n\t\t}\n\n\t\t/* No rounded corners on the left side of the last child. */\n\t\t&:last-child {\n\t\t\tborder-top-left-radius: 0;\n\t\t\tborder-bottom-left-radius: 0;\n\t\t}\n\t}\n\n\t/* Separate the the separator form the grouping dropdown when some items are grouped. */\n\t& > .ck.ck-toolbar__separator {\n\t\tmargin-right: var(--ck-spacing-small);\n\t}\n\n\t/* Some spacing between the items and the separator before the grouped items dropdown. */\n\t&.ck-toolbar_grouping > .ck-toolbar__items:not(:empty):not(:only-child) {\n\t\tmargin-right: var(--ck-spacing-small);\n\t}\n}\n\n/* stylelint-enable */\n', "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n"],
      sourceRoot: ""
    }]), e.a = s;
  }, function (t, e, n) {
    "use strict";

    var o = n(2),
      i = n.n(o),
      r = n(3),
      s = n.n(r)()(i.a);
    s.push([t.i, ".ck.ck-list{-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none;display:flex;flex-direction:column}.ck.ck-list .ck-list__item,.ck.ck-list .ck-list__separator{display:block}.ck.ck-list .ck-list__item>:focus{position:relative;z-index:var(--ck-z-default)}.ck.ck-list{border-radius:0}.ck-rounded-corners .ck.ck-list,.ck.ck-list.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-list{list-style-type:none;background:var(--ck-color-list-background)}.ck.ck-list__item{cursor:default;min-width:12em}.ck.ck-list__item .ck-button{min-height:unset;width:100%;text-align:left;border-radius:0;padding:calc(var(--ck-line-height-base)*0.2*var(--ck-font-size-base)) calc(var(--ck-line-height-base)*0.4*var(--ck-font-size-base))}.ck.ck-list__item .ck-button .ck-button__label{line-height:calc(var(--ck-line-height-base)*1.2*var(--ck-font-size-base))}.ck.ck-list__item .ck-button:active{box-shadow:none}.ck.ck-list__item .ck-button.ck-on{background:var(--ck-color-list-button-on-background);color:var(--ck-color-list-button-on-text)}.ck.ck-list__item .ck-button.ck-on:active{box-shadow:none}.ck.ck-list__item .ck-button.ck-on:hover:not(.ck-disabled){background:var(--ck-color-list-button-on-background-focus)}.ck.ck-list__item .ck-button.ck-on:focus:not(.ck-disabled){border-color:var(--ck-color-base-background)}.ck.ck-list__item .ck-button:hover:not(.ck-disabled){background:var(--ck-color-list-button-hover-background)}.ck.ck-list__item .ck-switchbutton.ck-on{background:var(--ck-color-list-background);color:inherit}.ck.ck-list__item .ck-switchbutton.ck-on:hover:not(.ck-disabled){background:var(--ck-color-list-button-hover-background);color:inherit}.ck.ck-list__separator{height:1px;width:100%;background:var(--ck-color-base-border)}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/list/list.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_unselectable.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/list/list.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css"],
      names: [],
      mappings: "AAOA,YCEC,qBAAsB,CACtB,wBAAyB,CACzB,oBAAqB,CACrB,gBAAgB,CDFhB,YAAa,CACb,qBAcD,CAZC,2DAEC,aACD,CAKA,kCACC,iBAAkB,CAClB,2BACD,CEfD,YCEC,eDGD,CALA,+DCME,qCDDF,CALA,YAGC,oBAAqB,CACrB,0CACD,CAEA,kBACC,cAAe,CACf,cA2DD,CAzDC,6BACC,gBAAiB,CACjB,UAAW,CACX,eAAgB,CAChB,eAAgB,CAKhB,mIAiCD,CA7BC,+CAEC,yEACD,CAEA,oCACC,eACD,CAEA,mCACC,oDAAqD,CACrD,yCAaD,CAXC,0CACC,eACD,CAEA,2DACC,0DACD,CAEA,2DACC,4CACD,CAGD,qDACC,uDACD,CAMA,yCACC,0CAA2C,CAC3C,aAMD,CAJC,iEACC,uDAAwD,CACxD,aACD,CAKH,uBACC,UAAW,CACX,UAAW,CACX,sCACD",
      sourcesContent: ['/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../mixins/_unselectable.css";\n\n.ck.ck-list {\n\t@mixin ck-unselectable;\n\n\tdisplay: flex;\n\tflex-direction: column;\n\n\t& .ck-list__item,\n\t& .ck-list__separator {\n\t\tdisplay: block;\n\t}\n\n\t/* Make sure that whatever child of the list item gets focus, it remains on the\n\ttop. Thanks to that, styles like box-shadow, outline, etc. are not masked by\n\tadjacent list items. */\n\t& .ck-list__item > *:focus {\n\t\tposition: relative;\n\t\tz-index: var(--ck-z-default);\n\t}\n}\n', "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Makes element unselectable.\n */\n@define-mixin ck-unselectable {\n\t-moz-user-select: none;\n\t-webkit-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none\n}\n", '/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_disabled.css";\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_shadow.css";\n\n.ck.ck-list {\n\t@mixin ck-rounded-corners;\n\n\tlist-style-type: none;\n\tbackground: var(--ck-color-list-background);\n}\n\n.ck.ck-list__item {\n\tcursor: default;\n\tmin-width: 12em;\n\n\t& .ck-button {\n\t\tmin-height: unset;\n\t\twidth: 100%;\n\t\ttext-align: left;\n\t\tborder-radius: 0;\n\n\t\t/* List items should have the same height. Use absolute units to make sure it is so\n\t\t   because e.g. different heading styles may have different height\n\t\t   https://github.com/ckeditor/ckeditor5-heading/issues/63 */\n\t\tpadding:\n\t\t\tcalc(.2 * var(--ck-line-height-base) * var(--ck-font-size-base))\n\t\t\tcalc(.4 * var(--ck-line-height-base) * var(--ck-font-size-base));\n\n\t\t& .ck-button__label {\n\t\t\t/* https://github.com/ckeditor/ckeditor5-heading/issues/63 */\n\t\t\tline-height: calc(1.2 * var(--ck-line-height-base) * var(--ck-font-size-base));\n\t\t}\n\n\t\t&:active {\n\t\t\tbox-shadow: none;\n\t\t}\n\n\t\t&.ck-on {\n\t\t\tbackground: var(--ck-color-list-button-on-background);\n\t\t\tcolor: var(--ck-color-list-button-on-text);\n\n\t\t\t&:active {\n\t\t\t\tbox-shadow: none;\n\t\t\t}\n\n\t\t\t&:hover:not(.ck-disabled) {\n\t\t\t\tbackground: var(--ck-color-list-button-on-background-focus);\n\t\t\t}\n\n\t\t\t&:focus:not(.ck-disabled) {\n\t\t\t\tborder-color: var(--ck-color-base-background);\n\t\t\t}\n\t\t}\n\n\t\t&:hover:not(.ck-disabled) {\n\t\t\tbackground: var(--ck-color-list-button-hover-background);\n\t\t}\n\t}\n\n\t/* It\'s unnecessary to change the background/text of a switch toggle; it has different ways\n\tof conveying its state (like the switcher) */\n\t& .ck-switchbutton {\n\t\t&.ck-on {\n\t\t\tbackground: var(--ck-color-list-background);\n\t\t\tcolor: inherit;\n\n\t\t\t&:hover:not(.ck-disabled) {\n\t\t\t\tbackground: var(--ck-color-list-button-hover-background);\n\t\t\t\tcolor: inherit;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.ck.ck-list__separator {\n\theight: 1px;\n\twidth: 100%;\n\tbackground: var(--ck-color-base-border);\n}\n', "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n"],
      sourceRoot: ""
    }]), e.a = s;
  }, function (t, e, n) {
    "use strict";

    var o = n(2),
      i = n.n(o),
      r = n(3),
      s = n.n(r)()(i.a);
    s.push([t.i, ":root{--ck-toolbar-dropdown-max-width:60vw}.ck.ck-toolbar-dropdown>.ck-dropdown__panel{width:max-content;max-width:var(--ck-toolbar-dropdown-max-width)}.ck.ck-toolbar-dropdown>.ck-dropdown__panel .ck-button:focus{z-index:calc(var(--ck-z-default) + 1)}.ck.ck-toolbar-dropdown .ck-toolbar{border:0}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/dropdown/toolbardropdown.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/dropdown/toolbardropdown.css"],
      names: [],
      mappings: "AAKA,MACC,oCACD,CAEA,4CAEC,iBAAkB,CAClB,8CAOD,CAJE,6DACC,qCACD,CCZF,oCACC,QACD",
      sourcesContent: ["/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-toolbar-dropdown-max-width: 60vw;\n}\n\n.ck.ck-toolbar-dropdown > .ck-dropdown__panel {\n\t/* https://github.com/ckeditor/ckeditor5/issues/5586 */\n\twidth: max-content;\n\tmax-width: var(--ck-toolbar-dropdown-max-width);\n\n\t& .ck-button {\n\t\t&:focus {\n\t\t\tz-index: calc(var(--ck-z-default) + 1);\n\t\t}\n\t}\n}\n", "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-toolbar-dropdown .ck-toolbar {\n\tborder: 0;\n}\n"],
      sourceRoot: ""
    }]), e.a = s;
  }, function (t, e, n) {
    "use strict";

    var o = n(2),
      i = n.n(o),
      r = n(3),
      s = n.n(r)()(i.a);
    s.push([t.i, ".ck.ck-dropdown .ck-dropdown__panel .ck-list{border-radius:0}.ck-rounded-corners .ck.ck-dropdown .ck-dropdown__panel .ck-list,.ck.ck-dropdown .ck-dropdown__panel .ck-list.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0}.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:first-child .ck-button{border-radius:0}.ck-rounded-corners .ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:first-child .ck-button,.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:first-child .ck-button.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0;border-bottom-left-radius:0;border-bottom-right-radius:0}.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:last-child .ck-button{border-radius:0}.ck-rounded-corners .ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:last-child .ck-button,.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:last-child .ck-button.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0;border-top-right-radius:0}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/dropdown/listdropdown.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css"],
      names: [],
      mappings: "AAOA,6CCIC,eDqBD,CAzBA,iICQE,qCAAsC,CDJtC,wBAqBF,CAfE,mFCND,eDYC,CANA,6MCFA,qCAAsC,CDIpC,wBAAyB,CACzB,2BAA4B,CAC5B,4BAEF,CAEA,kFCdD,eDmBC,CALA,2MCVA,qCAAsC,CDYpC,wBAAyB,CACzB,yBAEF",
      sourcesContent: ['/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n\n.ck.ck-dropdown .ck-dropdown__panel .ck-list {\n\t/* Disabled radius of top-left border to be consistent with .dropdown__button\n\thttps://github.com/ckeditor/ckeditor5/issues/816 */\n\t@mixin ck-rounded-corners {\n\t\tborder-top-left-radius: 0;\n\t}\n\n\t/* Make sure the button belonging to the first/last child of the list goes well with the\n\tborder radius of the entire panel. */\n\t& .ck-list__item {\n\t\t&:first-child .ck-button {\n\t\t\t@mixin ck-rounded-corners {\n\t\t\t\tborder-top-left-radius: 0;\n\t\t\t\tborder-bottom-left-radius: 0;\n\t\t\t\tborder-bottom-right-radius: 0;\n\t\t\t}\n\t\t}\n\n\t\t&:last-child .ck-button {\n\t\t\t@mixin ck-rounded-corners {\n\t\t\t\tborder-top-left-radius: 0;\n\t\t\t\tborder-top-right-radius: 0;\n\t\t\t}\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n"],
      sourceRoot: ""
    }]), e.a = s;
  }, function (t, e, n) {
    "use strict";

    var o = n(2),
      i = n.n(o),
      r = n(3),
      s = n.n(r)()(i.a);
    s.push([t.i, ":root{--ck-color-editable-blur-selection:#d9d9d9}.ck.ck-editor__editable:not(.ck-editor__nested-editable){border-radius:0}.ck-rounded-corners .ck.ck-editor__editable:not(.ck-editor__nested-editable),.ck.ck-editor__editable:not(.ck-editor__nested-editable).ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-editor__editable:not(.ck-editor__nested-editable).ck-focused{outline:none;border:var(--ck-focus-ring);box-shadow:var(--ck-inner-shadow),0 0}.ck.ck-editor__editable_inline{overflow:auto;padding:0 var(--ck-spacing-standard);border:1px solid transparent}.ck.ck-editor__editable_inline[dir=ltr]{text-align:left}.ck.ck-editor__editable_inline[dir=rtl]{text-align:right}.ck.ck-editor__editable_inline>:first-child{margin-top:var(--ck-spacing-large)}.ck.ck-editor__editable_inline>:last-child{margin-bottom:var(--ck-spacing-large)}.ck.ck-editor__editable_inline.ck-blurred ::selection{background:var(--ck-color-editable-blur-selection)}.ck.ck-balloon-panel.ck-toolbar-container[class*=arrow_n]:after{border-bottom-color:var(--ck-color-base-foreground)}.ck.ck-balloon-panel.ck-toolbar-container[class*=arrow_s]:after{border-top-color:var(--ck-color-base-foreground)}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/editorui/editorui.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_focus.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css"],
      names: [],
      mappings: "AAWA,MACC,0CACD,CAEA,yDCJC,eDWD,CAPA,yJCAE,qCDOF,CAJC,oEERA,YAAa,CACb,2BAA2B,CCF3B,qCHYA,CAGD,+BACC,aAAc,CACd,oCAAqC,CACrC,4BA4BD,CA1BC,wCACC,eACD,CAEA,wCACC,gBACD,CAGA,4CACC,kCACD,CAGA,2CAKC,qCACD,CAGA,sDACC,kDACD,CAKA,gEACC,mDACD,CAIA,gEACC,gDACD",
      sourcesContent: ['/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_disabled.css";\n@import "../../../mixins/_shadow.css";\n@import "../../../mixins/_focus.css";\n@import "../../mixins/_button.css";\n\n:root {\n\t--ck-color-editable-blur-selection: hsl(0, 0%, 85%);\n}\n\n.ck.ck-editor__editable:not(.ck-editor__nested-editable) {\n\t@mixin ck-rounded-corners;\n\n\t&.ck-focused {\n\t\t@mixin ck-focus-ring;\n\t\t@mixin ck-box-shadow var(--ck-inner-shadow);\n\t}\n}\n\n.ck.ck-editor__editable_inline {\n\toverflow: auto;\n\tpadding: 0 var(--ck-spacing-standard);\n\tborder: 1px solid transparent;\n\n\t&[dir="ltr"] {\n\t\ttext-align: left;\n\t}\n\n\t&[dir="rtl"] {\n\t\ttext-align: right;\n\t}\n\n\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/116 */\n\t& > *:first-child {\n\t\tmargin-top: var(--ck-spacing-large);\n\t}\n\n\t/* https://github.com/ckeditor/ckeditor5/issues/847 */\n\t& > *:last-child {\n\t\t/*\n\t\t * This value should match with the default margins of the block elements (like .media or .image)\n\t\t * to avoid a content jumping when the fake selection container shows up (See https://github.com/ckeditor/ckeditor5/issues/9825).\n\t\t */\n\t\tmargin-bottom: var(--ck-spacing-large);\n\t}\n\n\t/* https://github.com/ckeditor/ckeditor5/issues/6517 */\n\t&.ck-blurred ::selection {\n\t\tbackground: var(--ck-color-editable-blur-selection);\n\t}\n}\n\n/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/111 */\n.ck.ck-balloon-panel.ck-toolbar-container[class*="arrow_n"] {\n\t&::after {\n\t\tborder-bottom-color: var(--ck-color-base-foreground);\n\t}\n}\n\n.ck.ck-balloon-panel.ck-toolbar-container[class*="arrow_s"] {\n\t&::after {\n\t\tborder-top-color: var(--ck-color-base-foreground);\n\t}\n}\n', "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A visual style of focused element's border.\n */\n@define-mixin ck-focus-ring {\n\t/* Disable native outline. */\n\toutline: none;\n\tborder: var(--ck-focus-ring)\n}\n", "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"],
      sourceRoot: ""
    }]), e.a = s;
  }, function (t, e, n) {
    "use strict";

    var o = n(2),
      i = n.n(o),
      r = n(3),
      s = n.n(r)()(i.a);
    s.push([t.i, ".ck.ck-label{display:block}.ck.ck-voice-label{display:none}.ck.ck-label{font-weight:700}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/label/label.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/label/label.css"],
      names: [],
      mappings: "AAKA,aACC,aACD,CAEA,mBACC,YACD,CCNA,aACC,eACD",
      sourcesContent: ["/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-label {\n\tdisplay: block;\n}\n\n.ck.ck-voice-label {\n\tdisplay: none;\n}\n", "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-label {\n\tfont-weight: bold;\n}\n"],
      sourceRoot: ""
    }]), e.a = s;
  }, function (t, e, n) {
    "use strict";

    var o = n(2),
      i = n.n(o),
      r = n(3),
      s = n.n(r)()(i.a);
    s.push([t.i, ".ck.ck-form__header{display:flex;flex-direction:row;flex-wrap:nowrap;align-items:center;justify-content:space-between}:root{--ck-form-header-height:38px}.ck.ck-form__header{padding:var(--ck-spacing-small) var(--ck-spacing-large);height:var(--ck-form-header-height);line-height:var(--ck-form-header-height);border-bottom:1px solid var(--ck-color-base-border)}.ck.ck-form__header .ck-form__header__label{font-weight:700}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/formheader/formheader.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/formheader/formheader.css"],
      names: [],
      mappings: "AAKA,oBACC,YAAa,CACb,kBAAmB,CACnB,gBAAiB,CACjB,kBAAmB,CACnB,6BACD,CCNA,MACC,4BACD,CAEA,oBACC,uDAAwD,CACxD,mCAAoC,CACpC,wCAAyC,CACzC,mDAKD,CAHC,4CACC,eACD",
      sourcesContent: ["/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-form__header {\n\tdisplay: flex;\n\tflex-direction: row;\n\tflex-wrap: nowrap;\n\talign-items: center;\n\tjustify-content: space-between;\n}\n", "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-form-header-height: 38px;\n}\n\n.ck.ck-form__header {\n\tpadding: var(--ck-spacing-small) var(--ck-spacing-large);\n\theight: var(--ck-form-header-height);\n\tline-height: var(--ck-form-header-height);\n\tborder-bottom: 1px solid var(--ck-color-base-border);\n\n\t& .ck-form__header__label {\n\t\tfont-weight: bold;\n\t}\n}\n"],
      sourceRoot: ""
    }]), e.a = s;
  }, function (t, e, n) {
    "use strict";

    var o = n(2),
      i = n.n(o),
      r = n(3),
      s = n.n(r)()(i.a);
    s.push([t.i, ":root{--ck-input-text-width:18em}.ck.ck-input-text{border-radius:0}.ck-rounded-corners .ck.ck-input-text,.ck.ck-input-text.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-input-text{background:var(--ck-color-input-background);border:1px solid var(--ck-color-input-border);padding:var(--ck-spacing-extra-tiny) var(--ck-spacing-medium);min-width:var(--ck-input-text-width);min-height:var(--ck-ui-component-min-height);transition:box-shadow .1s ease-in-out,border .1s ease-in-out}.ck.ck-input-text:focus{outline:none;border:var(--ck-focus-ring);box-shadow:var(--ck-focus-outer-shadow),0 0}.ck.ck-input-text[readonly]{border:1px solid var(--ck-color-input-disabled-border);background:var(--ck-color-input-disabled-background);color:var(--ck-color-input-disabled-text)}.ck.ck-input-text[readonly]:focus{box-shadow:var(--ck-focus-disabled-outer-shadow),0 0}.ck.ck-input-text.ck-error{border-color:var(--ck-color-input-error-border);animation:ck-text-input-shake .3s ease both}.ck.ck-input-text.ck-error:focus{box-shadow:var(--ck-focus-error-outer-shadow),0 0}@keyframes ck-text-input-shake{20%{transform:translateX(-2px)}40%{transform:translateX(2px)}60%{transform:translateX(-1px)}80%{transform:translateX(1px)}}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/inputtext/inputtext.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_focus.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css"],
      names: [],
      mappings: "AASA,MACC,0BACD,CAEA,kBCFC,eDwCD,CAtCA,2ECEE,qCDoCF,CAtCA,kBAGC,2CAA4C,CAC5C,6CAA8C,CAC9C,6DAA8D,CAC9D,oCAAqC,CAGrC,4CAA6C,CAG7C,4DA0BD,CAxBC,wBEjBA,YAAa,CACb,2BAA2B,CCF3B,2CHqBA,CAEA,4BACC,sDAAuD,CACvD,oDAAqD,CACrD,yCAMD,CAJC,kCG5BD,oDH+BC,CAGD,2BACC,+CAAgD,CAChD,2CAKD,CAHC,iCGtCD,iDHwCC,CAIF,+BACC,IACC,0BACD,CAEA,IACC,yBACD,CAEA,IACC,0BACD,CAEA,IACC,yBACD,CACD",
      sourcesContent: ['/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_focus.css";\n@import "../../../mixins/_shadow.css";\n\n:root {\n\t--ck-input-text-width: 18em;\n}\n\n.ck.ck-input-text {\n\t@mixin ck-rounded-corners;\n\n\tbackground: var(--ck-color-input-background);\n\tborder: 1px solid var(--ck-color-input-border);\n\tpadding: var(--ck-spacing-extra-tiny) var(--ck-spacing-medium);\n\tmin-width: var(--ck-input-text-width);\n\n\t/* This is important to stay of the same height as surrounding buttons */\n\tmin-height: var(--ck-ui-component-min-height);\n\n\t/* Apply some smooth transition to the box-shadow and border. */\n\ttransition: box-shadow .1s ease-in-out, border .1s ease-in-out;\n\n\t&:focus {\n\t\t@mixin ck-focus-ring;\n\t\t@mixin ck-box-shadow var(--ck-focus-outer-shadow);\n\t}\n\n\t&[readonly] {\n\t\tborder: 1px solid var(--ck-color-input-disabled-border);\n\t\tbackground: var(--ck-color-input-disabled-background);\n\t\tcolor: var(--ck-color-input-disabled-text);\n\n\t\t&:focus {\n\t\t\t/* The read-only input should have a slightly less visible shadow when focused. */\n\t\t\t@mixin ck-box-shadow var(--ck-focus-disabled-outer-shadow);\n\t\t}\n\t}\n\n\t&.ck-error {\n\t\tborder-color: var(--ck-color-input-error-border);\n\t\tanimation: ck-text-input-shake .3s ease both;\n\n\t\t&:focus {\n\t\t\t@mixin ck-box-shadow var(--ck-focus-error-outer-shadow);\n\t\t}\n\t}\n}\n\n@keyframes ck-text-input-shake {\n\t20% {\n\t\ttransform: translateX(-2px);\n\t}\n\n\t40% {\n\t\ttransform: translateX(2px);\n\t}\n\n\t60% {\n\t\ttransform: translateX(-1px);\n\t}\n\n\t80% {\n\t\ttransform: translateX(1px);\n\t}\n}\n', "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A visual style of focused element's border.\n */\n@define-mixin ck-focus-ring {\n\t/* Disable native outline. */\n\toutline: none;\n\tborder: var(--ck-focus-ring)\n}\n", "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"],
      sourceRoot: ""
    }]), e.a = s;
  }, function (t, e, n) {
    "use strict";

    var o = n(2),
      i = n.n(o),
      r = n(3),
      s = n.n(r)()(i.a);
    s.push([t.i, ".ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper{display:flex;position:relative}.ck.ck-labeled-field-view .ck.ck-label{display:block;position:absolute}:root{--ck-labeled-field-view-transition:.1s cubic-bezier(0,0,0.24,0.95);--ck-labeled-field-empty-unfocused-max-width:100% - 2 * var(--ck-spacing-medium);--ck-color-labeled-field-label-background:var(--ck-color-base-background)}.ck.ck-labeled-field-view{border-radius:0}.ck-rounded-corners .ck.ck-labeled-field-view,.ck.ck-labeled-field-view.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper{width:100%}.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{top:0}[dir=ltr] .ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{left:0}[dir=rtl] .ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{right:0}.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{pointer-events:none;transform-origin:0 0;transform:translate(var(--ck-spacing-medium),-6px) scale(.75);background:var(--ck-color-labeled-field-label-background);padding:0 calc(var(--ck-font-size-tiny)*0.5);line-height:normal;font-weight:400;text-overflow:ellipsis;overflow:hidden;max-width:100%;transition:transform var(--ck-labeled-field-view-transition),padding var(--ck-labeled-field-view-transition),background var(--ck-labeled-field-view-transition)}.ck.ck-labeled-field-view.ck-error .ck-input:not([readonly])+.ck.ck-label,.ck.ck-labeled-field-view.ck-error>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{color:var(--ck-color-base-error)}.ck.ck-labeled-field-view .ck-labeled-field-view__status{font-size:var(--ck-font-size-small);margin-top:var(--ck-spacing-small);white-space:normal}.ck.ck-labeled-field-view .ck-labeled-field-view__status.ck-labeled-field-view__status_error{color:var(--ck-color-base-error)}.ck.ck-labeled-field-view.ck-disabled>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label,.ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{color:var(--ck-color-input-disabled-text)}[dir=ltr] .ck.ck-labeled-field-view.ck-disabled>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label,[dir=ltr] .ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{transform:translate(var(--ck-spacing-medium),calc(var(--ck-font-size-base)*0.6)) scale(1)}[dir=rtl] .ck.ck-labeled-field-view.ck-disabled>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label,[dir=rtl] .ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{transform:translate(calc(var(--ck-spacing-medium)*-1),calc(var(--ck-font-size-base)*0.6)) scale(1)}.ck.ck-labeled-field-view.ck-disabled>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label,.ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{max-width:calc(var(--ck-labeled-field-empty-unfocused-max-width));background:transparent;padding:0}.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck-dropdown>.ck.ck-button{background:transparent}.ck.ck-labeled-field-view.ck-labeled-field-view_empty>.ck.ck-labeled-field-view__input-wrapper>.ck-dropdown>.ck-button>.ck-button__label{opacity:0}.ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder)>.ck.ck-labeled-field-view__input-wrapper>.ck-dropdown+.ck-label{max-width:calc(var(--ck-labeled-field-empty-unfocused-max-width) - var(--ck-dropdown-arrow-size) - var(--ck-spacing-standard))}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/labeledfield/labeledfieldview.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/labeledfield/labeledfieldview.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css"],
      names: [],
      mappings: "AAMC,mEACC,YAAa,CACb,iBACD,CAEA,uCACC,aAAc,CACd,iBACD,CCND,MACC,kEAAsE,CACtE,gFAAiF,CACjF,yEACD,CAEA,0BCHC,eD4GD,CAzGA,2FCCE,qCDwGF,CAtGC,mEACC,UAmCD,CAjCC,gFACC,KA+BD,CAhCA,0FAIE,MA4BF,CAhCA,0FAQE,OAwBF,CAhCA,gFAWC,mBAAoB,CACpB,oBAAqB,CAGrB,6DAA+D,CAE/D,yDAA0D,CAC1D,4CAA8C,CAC9C,kBAAoB,CACpB,eAAmB,CAGnB,sBAAuB,CACvB,eAAgB,CAEhB,cAAe,CAEf,+JAID,CAQA,mKACC,gCACD,CAGD,yDACC,mCAAoC,CACpC,kCAAmC,CAInC,kBAKD,CAHC,6FACC,gCACD,CAID,4OAEC,yCACD,CAIA,wSAGE,yFAYF,CAfA,wSAOE,kGAQF,CAfA,oRAWC,iEAAkE,CAElE,sBAAuB,CACvB,SACD,CAKA,8FACC,sBACD,CAGA,yIACC,SACD,CAGA,kMACC,8HACD",
      sourcesContent: ["/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-labeled-field-view {\n\t& > .ck.ck-labeled-field-view__input-wrapper {\n\t\tdisplay: flex;\n\t\tposition: relative;\n\t}\n\n\t& .ck.ck-label {\n\t\tdisplay: block;\n\t\tposition: absolute;\n\t}\n}\n", '/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n@import "../../../mixins/_rounded.css";\n\n:root {\n\t--ck-labeled-field-view-transition: .1s cubic-bezier(0, 0, 0.24, 0.95);\n\t--ck-labeled-field-empty-unfocused-max-width: 100% - 2 * var(--ck-spacing-medium);\n\t--ck-color-labeled-field-label-background: var(--ck-color-base-background);\n}\n\n.ck.ck-labeled-field-view {\n\t@mixin ck-rounded-corners;\n\n\t& > .ck.ck-labeled-field-view__input-wrapper {\n\t\twidth: 100%;\n\n\t\t& > .ck.ck-label {\n\t\t\ttop: 0px;\n\n\t\t\t@mixin ck-dir ltr {\n\t\t\t\tleft: 0px;\n\t\t\t}\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tright: 0px;\n\t\t\t}\n\n\t\t\tpointer-events: none;\n\t\t\ttransform-origin: 0 0;\n\n\t\t\t/* By default, display the label scaled down above the field. */\n\t\t\ttransform: translate(var(--ck-spacing-medium), -6px) scale(.75);\n\n\t\t\tbackground: var(--ck-color-labeled-field-label-background);\n\t\t\tpadding: 0 calc(.5 * var(--ck-font-size-tiny));\n\t\t\tline-height: initial;\n\t\t\tfont-weight: normal;\n\n\t\t\t/* Prevent overflow when the label is longer than the input */\n\t\t\ttext-overflow: ellipsis;\n\t\t\toverflow: hidden;\n\n\t\t\tmax-width: 100%;\n\n\t\t\ttransition:\n\t\t\t\ttransform var(--ck-labeled-field-view-transition),\n\t\t\t\tpadding var(--ck-labeled-field-view-transition),\n\t\t\t\tbackground var(--ck-labeled-field-view-transition);\n\t\t}\n\t}\n\n\t&.ck-error {\n\t\t& > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label {\n\t\t\tcolor: var(--ck-color-base-error);\n\t\t}\n\n\t\t& .ck-input:not([readonly]) + .ck.ck-label {\n\t\t\tcolor: var(--ck-color-base-error);\n\t\t}\n\t}\n\n\t& .ck-labeled-field-view__status {\n\t\tfont-size: var(--ck-font-size-small);\n\t\tmargin-top: var(--ck-spacing-small);\n\n\t\t/* Let the info wrap to the next line to avoid stretching the layout horizontally.\n\t\tThe status could be very long. */\n\t\twhite-space: normal;\n\n\t\t&.ck-labeled-field-view__status_error {\n\t\t\tcolor: var(--ck-color-base-error);\n\t\t}\n\t}\n\n\t/* Disabled fields and fields that have no focus should fade out. */\n\t&.ck-disabled > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label,\n\t&.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused) > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label {\n\t\tcolor: var(--ck-color-input-disabled-text);\n\t}\n\n\t/* Fields that are disabled or not focused and without a placeholder should have full-sized labels. */\n\t/* stylelint-disable-next-line no-descending-specificity */\n\t&.ck-disabled > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label,\n\t&.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder) > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label {\n\t\t@mixin ck-dir ltr {\n\t\t\ttransform: translate(var(--ck-spacing-medium), calc(0.6 * var(--ck-font-size-base))) scale(1);\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\ttransform: translate(calc(-1 * var(--ck-spacing-medium)), calc(0.6 * var(--ck-font-size-base))) scale(1);\n\t\t}\n\n\t\t/* Compensate for the default translate position. */\n\t\tmax-width: calc(var(--ck-labeled-field-empty-unfocused-max-width));\n\n\t\tbackground: transparent;\n\t\tpadding: 0;\n\t}\n\n\t/*------ DropdownView integration ----------------------------------------------------------------------------------- */\n\n\t/* Make sure dropdown\' background color in any of dropdown\'s state does not collide with labeled field. */\n\t& > .ck.ck-labeled-field-view__input-wrapper > .ck-dropdown > .ck.ck-button {\n\t\tbackground: transparent;\n\t}\n\n\t/* When the dropdown is "empty", the labeled field label replaces its label. */\n\t&.ck-labeled-field-view_empty > .ck.ck-labeled-field-view__input-wrapper > .ck-dropdown > .ck-button > .ck-button__label {\n\t\topacity: 0;\n\t}\n\n\t/* Make sure the label of the empty, unfocused input does not cover the dropdown arrow. */\n\t&.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder) > .ck.ck-labeled-field-view__input-wrapper > .ck-dropdown + .ck-label {\n\t\tmax-width: calc(var(--ck-labeled-field-empty-unfocused-max-width) - var(--ck-dropdown-arrow-size) - var(--ck-spacing-standard));\n\t}\n}\n', "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n"],
      sourceRoot: ""
    }]), e.a = s;
  }, function (t, e, n) {
    "use strict";

    var o = n(2),
      i = n.n(o),
      r = n(3),
      s = n.n(r)()(i.a);
    s.push([t.i, ':root{--ck-balloon-panel-arrow-z-index:calc(var(--ck-z-default) - 3)}.ck.ck-balloon-panel{display:none;position:absolute;z-index:var(--ck-z-modal)}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:after,.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:before{content:"";position:absolute}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:before{z-index:var(--ck-balloon-panel-arrow-z-index)}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:after{z-index:calc(var(--ck-balloon-panel-arrow-z-index) + 1)}.ck.ck-balloon-panel[class*=arrow_n]:before{z-index:var(--ck-balloon-panel-arrow-z-index)}.ck.ck-balloon-panel[class*=arrow_n]:after{z-index:calc(var(--ck-balloon-panel-arrow-z-index) + 1)}.ck.ck-balloon-panel[class*=arrow_s]:before{z-index:var(--ck-balloon-panel-arrow-z-index)}.ck.ck-balloon-panel[class*=arrow_s]:after{z-index:calc(var(--ck-balloon-panel-arrow-z-index) + 1)}.ck.ck-balloon-panel.ck-balloon-panel_visible{display:block}:root{--ck-balloon-arrow-offset:2px;--ck-balloon-arrow-height:10px;--ck-balloon-arrow-half-width:8px;--ck-balloon-arrow-drop-shadow:0 2px 2px var(--ck-color-shadow-drop)}.ck.ck-balloon-panel{border-radius:0}.ck-rounded-corners .ck.ck-balloon-panel,.ck.ck-balloon-panel.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-balloon-panel{box-shadow:var(--ck-drop-shadow),0 0;min-height:15px;background:var(--ck-color-panel-background);border:1px solid var(--ck-color-panel-border)}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:after,.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:before{width:0;height:0;border-style:solid}.ck.ck-balloon-panel[class*=arrow_n]:after,.ck.ck-balloon-panel[class*=arrow_n]:before{border-left-width:var(--ck-balloon-arrow-half-width);border-bottom-width:var(--ck-balloon-arrow-height);border-right-width:var(--ck-balloon-arrow-half-width);border-top-width:0}.ck.ck-balloon-panel[class*=arrow_n]:before{border-bottom-color:var(--ck-color-panel-border)}.ck.ck-balloon-panel[class*=arrow_n]:after,.ck.ck-balloon-panel[class*=arrow_n]:before{border-left-color:transparent;border-right-color:transparent;border-top-color:transparent}.ck.ck-balloon-panel[class*=arrow_n]:after{border-bottom-color:var(--ck-color-panel-background);margin-top:var(--ck-balloon-arrow-offset)}.ck.ck-balloon-panel[class*=arrow_s]:after,.ck.ck-balloon-panel[class*=arrow_s]:before{border-left-width:var(--ck-balloon-arrow-half-width);border-bottom-width:0;border-right-width:var(--ck-balloon-arrow-half-width);border-top-width:var(--ck-balloon-arrow-height)}.ck.ck-balloon-panel[class*=arrow_s]:before{border-top-color:var(--ck-color-panel-border);filter:drop-shadow(var(--ck-balloon-arrow-drop-shadow))}.ck.ck-balloon-panel[class*=arrow_s]:after,.ck.ck-balloon-panel[class*=arrow_s]:before{border-left-color:transparent;border-bottom-color:transparent;border-right-color:transparent}.ck.ck-balloon-panel[class*=arrow_s]:after{border-top-color:var(--ck-color-panel-background);margin-bottom:var(--ck-balloon-arrow-offset)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_n:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_n:before{left:50%;margin-left:calc(var(--ck-balloon-arrow-half-width)*-1);top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_nw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_nw:before{left:calc(var(--ck-balloon-arrow-half-width)*2);top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_ne:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_ne:before{right:calc(var(--ck-balloon-arrow-half-width)*2);top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_s:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_s:before{left:50%;margin-left:calc(var(--ck-balloon-arrow-half-width)*-1);bottom:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_sw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_sw:before{left:calc(var(--ck-balloon-arrow-half-width)*2);bottom:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_se:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_se:before{right:calc(var(--ck-balloon-arrow-half-width)*2);bottom:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_sme:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_sme:before{right:25%;margin-right:calc(var(--ck-balloon-arrow-half-width)*2);bottom:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_smw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_smw:before{left:25%;margin-left:calc(var(--ck-balloon-arrow-half-width)*2);bottom:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_nme:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_nme:before{right:25%;margin-right:calc(var(--ck-balloon-arrow-half-width)*2);top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_nmw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_nmw:before{left:25%;margin-left:calc(var(--ck-balloon-arrow-half-width)*2);top:calc(var(--ck-balloon-arrow-height)*-1)}', "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/panel/balloonpanel.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/panel/balloonpanel.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css"],
      names: [],
      mappings: "AAKA,MAEC,8DACD,CAEA,qBACC,YAAa,CACb,iBAAkB,CAElB,yBAyCD,CAtCE,+GAEC,UAAW,CACX,iBACD,CAEA,wDACC,6CACD,CAEA,uDACC,uDACD,CAIA,4CACC,6CACD,CAEA,2CACC,uDACD,CAIA,4CACC,6CACD,CAEA,2CACC,uDACD,CAGD,8CACC,aACD,CC9CD,MACC,6BAA8B,CAC9B,8BAA+B,CAC/B,iCAAkC,CAClC,oEACD,CAEA,qBCJC,eD4ID,CAxIA,iFCAE,qCDwIF,CAxIA,qBENC,oCAA8B,CFU9B,eAAgB,CAEhB,2CAA4C,CAC5C,6CAiID,CA9HE,+GAEC,OAAQ,CACR,QAAS,CACT,kBACD,CAIA,uFAEC,oDAAoH,CAApH,kDAAoH,CAApH,qDAAoH,CAApH,kBACD,CAEA,4CACC,gDACD,CAEA,uFAHC,6BAA8E,CAA9E,8BAA8E,CAA9E,4BAMD,CAHA,2CACC,oDAAkF,CAClF,yCACD,CAIA,uFAEC,oDAAoH,CAApH,qBAAoH,CAApH,qDAAoH,CAApH,+CACD,CAEA,4CACC,6CAAkE,CAClE,uDACD,CAEA,uFAJC,6BAAkE,CAAlE,+BAAkE,CAAlE,8BAOD,CAHA,2CACC,iDAAkF,CAClF,4CACD,CAIA,yGAEC,QAAS,CACT,uDAA0D,CAC1D,2CACD,CAIA,2GAEC,+CAAkD,CAClD,2CACD,CAIA,2GAEC,gDAAmD,CACnD,2CACD,CAIA,yGAEC,QAAS,CACT,uDAA0D,CAC1D,8CACD,CAIA,2GAEC,+CAAkD,CAClD,8CACD,CAIA,2GAEC,gDAAmD,CACnD,8CACD,CAIA,6GAEC,SAAU,CACV,uDAA0D,CAC1D,8CACD,CAIA,6GAEC,QAAS,CACT,sDAAyD,CACzD,8CACD,CAIA,6GAEC,SAAU,CACV,uDAA0D,CAC1D,2CACD,CAIA,6GAEC,QAAS,CACT,sDAAyD,CACzD,2CACD",
      sourcesContent: ['/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t/* Make sure the balloon arrow does not float over its children. */\n\t--ck-balloon-panel-arrow-z-index: calc(var(--ck-z-default) - 3);\n}\n\n.ck.ck-balloon-panel {\n\tdisplay: none;\n\tposition: absolute;\n\n\tz-index: var(--ck-z-modal);\n\n\t&.ck-balloon-panel_with-arrow {\n\t\t&::before,\n\t\t&::after {\n\t\t\tcontent: "";\n\t\t\tposition: absolute;\n\t\t}\n\n\t\t&::before {\n\t\t\tz-index: var(--ck-balloon-panel-arrow-z-index);\n\t\t}\n\n\t\t&::after {\n\t\t\tz-index: calc(var(--ck-balloon-panel-arrow-z-index) + 1);\n\t\t}\n\t}\n\n\t&[class*="arrow_n"] {\n\t\t&::before {\n\t\t\tz-index: var(--ck-balloon-panel-arrow-z-index);\n\t\t}\n\n\t\t&::after {\n\t\t\tz-index: calc(var(--ck-balloon-panel-arrow-z-index) + 1);\n\t\t}\n\t}\n\n\t&[class*="arrow_s"] {\n\t\t&::before {\n\t\t\tz-index: var(--ck-balloon-panel-arrow-z-index);\n\t\t}\n\n\t\t&::after {\n\t\t\tz-index: calc(var(--ck-balloon-panel-arrow-z-index) + 1);\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_visible {\n\t\tdisplay: block;\n\t}\n}\n', '/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_shadow.css";\n\n:root {\n\t--ck-balloon-arrow-offset: 2px;\n\t--ck-balloon-arrow-height: 10px;\n\t--ck-balloon-arrow-half-width: 8px;\n\t--ck-balloon-arrow-drop-shadow: 0 2px 2px var(--ck-color-shadow-drop);\n}\n\n.ck.ck-balloon-panel {\n\t@mixin ck-rounded-corners;\n\t@mixin ck-drop-shadow;\n\n\tmin-height: 15px;\n\n\tbackground: var(--ck-color-panel-background);\n\tborder: 1px solid var(--ck-color-panel-border);\n\n\t&.ck-balloon-panel_with-arrow {\n\t\t&::before,\n\t\t&::after {\n\t\t\twidth: 0;\n\t\t\theight: 0;\n\t\t\tborder-style: solid;\n\t\t}\n\t}\n\n\t&[class*="arrow_n"] {\n\t\t&::before,\n\t\t&::after {\n\t\t\tborder-width: 0 var(--ck-balloon-arrow-half-width) var(--ck-balloon-arrow-height) var(--ck-balloon-arrow-half-width);\n\t\t}\n\n\t\t&::before {\n\t\t\tborder-color: transparent transparent var(--ck-color-panel-border) transparent;\n\t\t}\n\n\t\t&::after {\n\t\t\tborder-color: transparent transparent var(--ck-color-panel-background) transparent;\n\t\t\tmargin-top: var(--ck-balloon-arrow-offset);\n\t\t}\n\t}\n\n\t&[class*="arrow_s"] {\n\t\t&::before,\n\t\t&::after {\n\t\t\tborder-width: var(--ck-balloon-arrow-height) var(--ck-balloon-arrow-half-width) 0 var(--ck-balloon-arrow-half-width);\n\t\t}\n\n\t\t&::before {\n\t\t\tborder-color: var(--ck-color-panel-border) transparent transparent;\n\t\t\tfilter: drop-shadow(var(--ck-balloon-arrow-drop-shadow));\n\t\t}\n\n\t\t&::after {\n\t\t\tborder-color: var(--ck-color-panel-background) transparent transparent transparent;\n\t\t\tmargin-bottom: var(--ck-balloon-arrow-offset);\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_n {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: 50%;\n\t\t\tmargin-left: calc(-1 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_nw {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_ne {\n\t\t&::before,\n\t\t&::after {\n\t\t\tright: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_s {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: 50%;\n\t\t\tmargin-left: calc(-1 * var(--ck-balloon-arrow-half-width));\n\t\t\tbottom: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_sw {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\tbottom: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_se {\n\t\t&::before,\n\t\t&::after {\n\t\t\tright: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\tbottom: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_sme {\n\t\t&::before,\n\t\t&::after {\n\t\t\tright: 25%;\n\t\t\tmargin-right: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\tbottom: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_smw {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: 25%;\n\t\t\tmargin-left: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\tbottom: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_nme {\n\t\t&::before,\n\t\t&::after {\n\t\t\tright: 25%;\n\t\t\tmargin-right: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_nmw {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: 25%;\n\t\t\tmargin-left: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"],
      sourceRoot: ""
    }]), e.a = s;
  }, function (t, e, n) {
    "use strict";

    var o = n(2),
      i = n.n(o),
      r = n(3),
      s = n.n(r)()(i.a);
    s.push([t.i, ".ck .ck-balloon-rotator__navigation{display:flex;align-items:center;justify-content:center}.ck .ck-balloon-rotator__content .ck-toolbar{justify-content:center}.ck .ck-balloon-rotator__navigation{background:var(--ck-color-toolbar-background);border-bottom:1px solid var(--ck-color-toolbar-border);padding:0 var(--ck-spacing-small)}.ck .ck-balloon-rotator__navigation>*{margin-right:var(--ck-spacing-small);margin-top:var(--ck-spacing-small);margin-bottom:var(--ck-spacing-small)}.ck .ck-balloon-rotator__navigation .ck-balloon-rotator__counter{margin-right:var(--ck-spacing-standard);margin-left:var(--ck-spacing-small)}.ck .ck-balloon-rotator__content .ck.ck-annotation-wrapper{box-shadow:none}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/panel/balloonrotator.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/panel/balloonrotator.css"],
      names: [],
      mappings: "AAKA,oCACC,YAAa,CACb,kBAAmB,CACnB,sBACD,CAKA,6CACC,sBACD,CCXA,oCACC,6CAA8C,CAC9C,sDAAuD,CACvD,iCAgBD,CAbC,sCACC,oCAAqC,CACrC,kCAAmC,CACnC,qCACD,CAGA,iEACC,uCAAwC,CAGxC,mCACD,CAMA,2DACC,eACD",
      sourcesContent: ["/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-balloon-rotator__navigation {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n/* Buttons inside a toolbar should be centered when rotator bar is wider.\n * See: https://github.com/ckeditor/ckeditor5-ui/issues/495\n */\n.ck .ck-balloon-rotator__content .ck-toolbar {\n\tjustify-content: center;\n}\n", "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-balloon-rotator__navigation {\n\tbackground: var(--ck-color-toolbar-background);\n\tborder-bottom: 1px solid var(--ck-color-toolbar-border);\n\tpadding: 0 var(--ck-spacing-small);\n\n\t/* Let's keep similar appearance to `ck-toolbar`. */\n\t& > * {\n\t\tmargin-right: var(--ck-spacing-small);\n\t\tmargin-top: var(--ck-spacing-small);\n\t\tmargin-bottom: var(--ck-spacing-small);\n\t}\n\n\t/* Gives counter more breath than buttons. */\n\t& .ck-balloon-rotator__counter {\n\t\tmargin-right: var(--ck-spacing-standard);\n\n\t\t/* We need to use smaller margin because of previous button's right margin. */\n\t\tmargin-left: var(--ck-spacing-small);\n\t}\n}\n\n.ck .ck-balloon-rotator__content {\n\n\t/* Disable default annotation shadow inside rotator with fake panels. */\n\t& .ck.ck-annotation-wrapper {\n\t\tbox-shadow: none;\n\t}\n}\n"],
      sourceRoot: ""
    }]), e.a = s;
  }, function (t, e, n) {
    "use strict";

    var o = n(2),
      i = n.n(o),
      r = n(3),
      s = n.n(r)()(i.a);
    s.push([t.i, ".ck .ck-fake-panel{position:absolute;z-index:calc(var(--ck-z-modal) - 1)}.ck .ck-fake-panel div{position:absolute}.ck .ck-fake-panel div:first-child{z-index:2}.ck .ck-fake-panel div:nth-child(2){z-index:1}:root{--ck-balloon-fake-panel-offset-horizontal:6px;--ck-balloon-fake-panel-offset-vertical:6px}.ck .ck-fake-panel div{box-shadow:var(--ck-drop-shadow),0 0;min-height:15px;background:var(--ck-color-panel-background);border:1px solid var(--ck-color-panel-border);border-radius:var(--ck-border-radius);width:100%;height:100%}.ck .ck-fake-panel div:first-child{margin-left:var(--ck-balloon-fake-panel-offset-horizontal);margin-top:var(--ck-balloon-fake-panel-offset-vertical)}.ck .ck-fake-panel div:nth-child(2){margin-left:calc(var(--ck-balloon-fake-panel-offset-horizontal)*2);margin-top:calc(var(--ck-balloon-fake-panel-offset-vertical)*2)}.ck .ck-fake-panel div:nth-child(3){margin-left:calc(var(--ck-balloon-fake-panel-offset-horizontal)*3);margin-top:calc(var(--ck-balloon-fake-panel-offset-vertical)*3)}.ck .ck-balloon-panel_arrow_s+.ck-fake-panel,.ck .ck-balloon-panel_arrow_se+.ck-fake-panel,.ck .ck-balloon-panel_arrow_sw+.ck-fake-panel{--ck-balloon-fake-panel-offset-vertical:-6px}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/panel/fakepanel.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/panel/fakepanel.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css"],
      names: [],
      mappings: "AAKA,mBACC,iBAAkB,CAGlB,mCACD,CAEA,uBACC,iBACD,CAEA,mCACC,SACD,CAEA,oCACC,SACD,CCfA,MACC,6CAA8C,CAC9C,2CACD,CAGA,uBCJC,oCAA8B,CDO9B,eAAgB,CAEhB,2CAA4C,CAC5C,6CAA8C,CAC9C,qCAAsC,CAEtC,UAAW,CACX,WACD,CAEA,mCACC,0DAA2D,CAC3D,uDACD,CAEA,oCACC,kEAAqE,CACrE,+DACD,CACA,oCACC,kEAAqE,CACrE,+DACD,CAGA,yIAGC,4CACD",
      sourcesContent: ["/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-fake-panel {\n\tposition: absolute;\n\n\t/* Fake panels should be placed under main balloon content. */\n\tz-index: calc(var(--ck-z-modal) - 1);\n}\n\n.ck .ck-fake-panel div {\n\tposition: absolute;\n}\n\n.ck .ck-fake-panel div:nth-child( 1 ) {\n\tz-index: 2;\n}\n\n.ck .ck-fake-panel div:nth-child( 2 ) {\n\tz-index: 1;\n}\n", '/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_shadow.css";\n\n:root {\n\t--ck-balloon-fake-panel-offset-horizontal: 6px;\n\t--ck-balloon-fake-panel-offset-vertical: 6px;\n}\n\n/* Let\'s use `.ck-balloon-panel` appearance. See: balloonpanel.css. */\n.ck .ck-fake-panel div {\n\t@mixin ck-drop-shadow;\n\n\tmin-height: 15px;\n\n\tbackground: var(--ck-color-panel-background);\n\tborder: 1px solid var(--ck-color-panel-border);\n\tborder-radius: var(--ck-border-radius);\n\n\twidth: 100%;\n\theight: 100%;\n}\n\n.ck .ck-fake-panel div:nth-child( 1 ) {\n\tmargin-left: var(--ck-balloon-fake-panel-offset-horizontal);\n\tmargin-top: var(--ck-balloon-fake-panel-offset-vertical);\n}\n\n.ck .ck-fake-panel div:nth-child( 2 ) {\n\tmargin-left: calc(var(--ck-balloon-fake-panel-offset-horizontal) * 2);\n\tmargin-top: calc(var(--ck-balloon-fake-panel-offset-vertical) * 2);\n}\n.ck .ck-fake-panel div:nth-child( 3 ) {\n\tmargin-left: calc(var(--ck-balloon-fake-panel-offset-horizontal) * 3);\n\tmargin-top: calc(var(--ck-balloon-fake-panel-offset-vertical) * 3);\n}\n\n/* If balloon is positioned above element, we need to move fake panel to the top. */\n.ck .ck-balloon-panel_arrow_s + .ck-fake-panel,\n.ck .ck-balloon-panel_arrow_se + .ck-fake-panel,\n.ck .ck-balloon-panel_arrow_sw + .ck-fake-panel {\n\t--ck-balloon-fake-panel-offset-vertical: -6px;\n}\n', "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"],
      sourceRoot: ""
    }]), e.a = s;
  }, function (t, e, n) {
    "use strict";

    var o = n(2),
      i = n.n(o),
      r = n(3),
      s = n.n(r)()(i.a);
    s.push([t.i, ".ck.ck-sticky-panel .ck-sticky-panel__content_sticky{z-index:var(--ck-z-modal);position:fixed;top:0}.ck.ck-sticky-panel .ck-sticky-panel__content_sticky_bottom-limit{top:auto;position:absolute}.ck.ck-sticky-panel .ck-sticky-panel__content_sticky{box-shadow:var(--ck-drop-shadow),0 0;border-width:0 1px 1px;border-top-left-radius:0;border-top-right-radius:0}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/panel/stickypanel.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/panel/stickypanel.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css"],
      names: [],
      mappings: "AAMC,qDACC,yBAA0B,CAC1B,cAAe,CACf,KACD,CAEA,kEACC,QAAS,CACT,iBACD,CCPA,qDCCA,oCAA8B,CDE7B,sBAAuB,CACvB,wBAAyB,CACzB,yBACD",
      sourcesContent: ["/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-sticky-panel {\n\t& .ck-sticky-panel__content_sticky {\n\t\tz-index: var(--ck-z-modal); /* #315 */\n\t\tposition: fixed;\n\t\ttop: 0;\n\t}\n\n\t& .ck-sticky-panel__content_sticky_bottom-limit {\n\t\ttop: auto;\n\t\tposition: absolute;\n\t}\n}\n", '/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_shadow.css";\n\n.ck.ck-sticky-panel {\n\t& .ck-sticky-panel__content_sticky {\n\t\t@mixin ck-drop-shadow;\n\n\t\tborder-width: 0 1px 1px;\n\t\tborder-top-left-radius: 0;\n\t\tborder-top-right-radius: 0;\n\t}\n}\n', "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"],
      sourceRoot: ""
    }]), e.a = s;
  }, function (t, e, n) {
    "use strict";

    var o = n(2),
      i = n.n(o),
      r = n(3),
      s = n.n(r)()(i.a);
    s.push([t.i, ".ck.ck-block-toolbar-button{position:absolute;z-index:var(--ck-z-default)}:root{--ck-color-block-toolbar-button:var(--ck-color-text);--ck-block-toolbar-button-size:var(--ck-font-size-normal)}.ck.ck-block-toolbar-button{color:var(--ck-color-block-toolbar-button);font-size:var(--ck-block-toolbar-size)}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/toolbar/blocktoolbar.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/toolbar/blocktoolbar.css"],
      names: [],
      mappings: "AAKA,4BACC,iBAAkB,CAClB,2BACD,CCHA,MACC,oDAAqD,CACrD,yDACD,CAEA,4BACC,0CAA2C,CAC3C,sCACD",
      sourcesContent: ["/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-block-toolbar-button {\n\tposition: absolute;\n\tz-index: var(--ck-z-default);\n}\n", "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-block-toolbar-button: var(--ck-color-text);\n\t--ck-block-toolbar-button-size: var(--ck-font-size-normal);\n}\n\n.ck.ck-block-toolbar-button {\n\tcolor: var(--ck-color-block-toolbar-button);\n\tfont-size: var(--ck-block-toolbar-size);\n}\n"],
      sourceRoot: ""
    }]), e.a = s;
  }, function (t, e, n) {
    "use strict";

    var o = n(2),
      i = n.n(o),
      r = n(3),
      s = n.n(r)()(i.a);
    s.push([t.i, ".ck.ck-placeholder,.ck .ck-placeholder{position:relative}.ck.ck-placeholder:before,.ck .ck-placeholder:before{position:absolute;left:0;right:0;content:attr(data-placeholder);pointer-events:none}.ck.ck-read-only .ck-placeholder:before{display:none}.ck.ck-placeholder:before,.ck .ck-placeholder:before{cursor:text;color:var(--ck-color-engine-placeholder-text)}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-engine/theme/placeholder.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-engine/placeholder.css"],
      names: [],
      mappings: "AAMA,uCAEC,iBAWD,CATC,qDACC,iBAAkB,CAClB,MAAO,CACP,OAAQ,CACR,8BAA+B,CAG/B,mBACD,CAKA,wCACC,YACD,CClBA,qDACC,WAAY,CACZ,6CACD",
      sourcesContent: ["/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/* See ckeditor/ckeditor5#936. */\n.ck.ck-placeholder,\n.ck .ck-placeholder {\n\tposition: relative;\n\n\t&::before {\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\tright: 0;\n\t\tcontent: attr(data-placeholder);\n\n\t\t/* See ckeditor/ckeditor5#469. */\n\t\tpointer-events: none;\n\t}\n}\n\n/* See ckeditor/ckeditor5#1987. */\n.ck.ck-read-only .ck-placeholder {\n\t&::before {\n\t\tdisplay: none;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/* See ckeditor/ckeditor5#936. */\n.ck.ck-placeholder, .ck .ck-placeholder {\n\t&::before {\n\t\tcursor: text;\n\t\tcolor: var(--ck-color-engine-placeholder-text);\n\t}\n}\n"],
      sourceRoot: ""
    }]), e.a = s;
  }, function (t, e, n) {
    "use strict";

    var o = n(2),
      i = n.n(o),
      r = n(3),
      s = n.n(r)()(i.a);
    s.push([t.i, ".ck.ck-editor{position:relative}.ck.ck-editor .ck-editor__top .ck-sticky-panel .ck-toolbar{z-index:var(--ck-z-modal)}.ck.ck-editor__top .ck-sticky-panel .ck-toolbar{border-radius:0}.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar,.ck.ck-editor__top .ck-sticky-panel .ck-toolbar.ck-rounded-corners{border-radius:var(--ck-border-radius);border-bottom-left-radius:0;border-bottom-right-radius:0}.ck.ck-editor__top .ck-sticky-panel .ck-toolbar{border-bottom-width:0}.ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content_sticky .ck-toolbar{border-bottom-width:1px;border-radius:0}.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content_sticky .ck-toolbar,.ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content_sticky .ck-toolbar.ck-rounded-corners{border-radius:var(--ck-border-radius);border-radius:0}.ck.ck-editor__main>.ck-editor__editable{background:var(--ck-color-base-background);border-radius:0}.ck-rounded-corners .ck.ck-editor__main>.ck-editor__editable,.ck.ck-editor__main>.ck-editor__editable.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0;border-top-right-radius:0}.ck.ck-editor__main>.ck-editor__editable:not(.ck-focused){border-color:var(--ck-color-base-border)}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-editor-classic/theme/classiceditor.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-editor-classic/classiceditor.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css"],
      names: [],
      mappings: "AAKA,cAIC,iBAMD,CAJC,2DAEC,yBACD,CCLC,gDCED,eDKC,CAPA,uICMA,qCAAsC,CDJpC,2BAA4B,CAC5B,4BAIF,CAPA,gDAMC,qBACD,CAEA,iFACC,uBAAwB,CCR1B,eDaC,CANA,yMCHA,qCAAsC,CDOpC,eAEF,CAKF,yCAEC,0CAA2C,CCpB3C,eD8BD,CAZA,yHCdE,qCAAsC,CDmBtC,wBAAyB,CACzB,yBAMF,CAHC,0DACC,wCACD",
      sourcesContent: ["/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-editor {\n\t/* All the elements within `.ck-editor` are positioned relatively to it.\n\t If any element needs to be positioned with respect to the <body>, etc.,\n\t it must land outside of the `.ck-editor` in DOM. */\n\tposition: relative;\n\n\t& .ck-editor__top .ck-sticky-panel .ck-toolbar {\n\t\t/* https://github.com/ckeditor/ckeditor5-editor-classic/issues/62 */\n\t\tz-index: var(--ck-z-modal);\n\t}\n}\n", '/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../mixins/_rounded.css";\n\n.ck.ck-editor__top {\n\t& .ck-sticky-panel {\n\t\t& .ck-toolbar {\n\t\t\t@mixin ck-rounded-corners {\n\t\t\t\tborder-bottom-left-radius: 0;\n\t\t\t\tborder-bottom-right-radius: 0;\n\t\t\t}\n\n\t\t\tborder-bottom-width: 0;\n\t\t}\n\n\t\t& .ck-sticky-panel__content_sticky .ck-toolbar {\n\t\t\tborder-bottom-width: 1px;\n\n\t\t\t@mixin ck-rounded-corners {\n\t\t\t\tborder-radius: 0;\n\t\t\t}\n\t\t}\n\t}\n}\n\n/* Note: Use ck-editor__main to make sure these styles don\'t apply to other editor types */\n.ck.ck-editor__main > .ck-editor__editable {\n\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/113 */\n\tbackground: var(--ck-color-base-background);\n\n\t@mixin ck-rounded-corners {\n\t\tborder-top-left-radius: 0;\n\t\tborder-top-right-radius: 0;\n\t}\n\n\t&:not(.ck-focused) {\n\t\tborder-color: var(--ck-color-base-border);\n\t}\n}\n', "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n"],
      sourceRoot: ""
    }]), e.a = s;
  }, function (t, e, n) {
    "use strict";

    var o = n(2),
      i = n.n(o),
      r = n(3),
      s = n.n(r)()(i.a);
    s.push([t.i, ".ck-content blockquote{overflow:hidden;padding-right:1.5em;padding-left:1.5em;margin-left:0;margin-right:0;font-style:italic;border-left:5px solid #ccc}.ck-content[dir=rtl] blockquote{border-left:0;border-right:5px solid #ccc}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-block-quote/theme/blockquote.css"],
      names: [],
      mappings: "AAKA,uBAEC,eAAgB,CAGhB,mBAAoB,CACpB,kBAAmB,CAEnB,aAAc,CACd,cAAe,CACf,iBAAkB,CAClB,0BACD,CAEA,gCACC,aAAc,CACd,2BACD",
      sourcesContent: ['/**\n * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-content blockquote {\n\t/* See #12 */\n\toverflow: hidden;\n\n\t/* https://github.com/ckeditor/ckeditor5-block-quote/issues/15 */\n\tpadding-right: 1.5em;\n\tpadding-left: 1.5em;\n\n\tmargin-left: 0;\n\tmargin-right: 0;\n\tfont-style: italic;\n\tborder-left: solid 5px hsl(0, 0%, 80%);\n}\n\n.ck-content[dir="rtl"] blockquote {\n\tborder-left: 0;\n\tborder-right: solid 5px hsl(0, 0%, 80%);\n}\n'],
      sourceRoot: ""
    }]), e.a = s;
  }, function (t, e, n) {
    "use strict";

    var o = n(2),
      i = n.n(o),
      r = n(3),
      s = n.n(r)()(i.a);
    s.push([t.i, '.ck .ck-widget .ck-widget__type-around__button{display:block;position:absolute;overflow:hidden;z-index:var(--ck-z-default)}.ck .ck-widget .ck-widget__type-around__button svg{position:absolute;top:50%;left:50%;z-index:calc(var(--ck-z-default) + 2)}.ck .ck-widget .ck-widget__type-around__button.ck-widget__type-around__button_before{top:calc(var(--ck-widget-outline-thickness)*-0.5);left:min(10%,30px);transform:translateY(-50%)}.ck .ck-widget .ck-widget__type-around__button.ck-widget__type-around__button_after{bottom:calc(var(--ck-widget-outline-thickness)*-0.5);right:min(10%,30px);transform:translateY(50%)}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:after,.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__button:hover:after{content:"";display:block;position:absolute;top:1px;left:1px;z-index:calc(var(--ck-z-default) + 1)}.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__fake-caret{display:none;position:absolute;left:0;right:0}.ck .ck-widget:hover>.ck-widget__type-around>.ck-widget__type-around__fake-caret{left:calc(var(--ck-widget-outline-thickness)*-1);right:calc(var(--ck-widget-outline-thickness)*-1)}.ck .ck-widget.ck-widget_type-around_show-fake-caret_before>.ck-widget__type-around>.ck-widget__type-around__fake-caret{top:calc(var(--ck-widget-outline-thickness)*-1 - 1px);display:block}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after>.ck-widget__type-around>.ck-widget__type-around__fake-caret{bottom:calc(var(--ck-widget-outline-thickness)*-1 - 1px);display:block}.ck.ck-editor__editable.ck-read-only .ck-widget__type-around,.ck.ck-editor__editable.ck-restricted-editing_mode_restricted .ck-widget__type-around,.ck.ck-editor__editable.ck-widget__type-around_disabled .ck-widget__type-around{display:none}:root{--ck-widget-type-around-button-size:20px;--ck-color-widget-type-around-button-active:var(--ck-color-focus-border);--ck-color-widget-type-around-button-hover:var(--ck-color-widget-hover-border);--ck-color-widget-type-around-button-blurred-editable:var(--ck-color-widget-blurred-border);--ck-color-widget-type-around-button-radar-start-alpha:0;--ck-color-widget-type-around-button-radar-end-alpha:.3;--ck-color-widget-type-around-button-icon:var(--ck-color-base-background)}.ck .ck-widget .ck-widget__type-around__button{width:var(--ck-widget-type-around-button-size);height:var(--ck-widget-type-around-button-size);background:var(--ck-color-widget-type-around-button);border-radius:100px;transition:opacity var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),background var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);opacity:0;pointer-events:none}.ck .ck-widget .ck-widget__type-around__button svg{width:10px;height:8px;transform:translate(-50%,-50%);transition:transform .5s ease;margin-top:1px}.ck .ck-widget .ck-widget__type-around__button svg *{stroke-dasharray:10;stroke-dashoffset:0;fill:none;stroke:var(--ck-color-widget-type-around-button-icon);stroke-width:1.5px;stroke-linecap:round;stroke-linejoin:round}.ck .ck-widget .ck-widget__type-around__button svg line{stroke-dasharray:7}.ck .ck-widget .ck-widget__type-around__button:hover{animation:ck-widget-type-around-button-sonar 1s ease infinite}.ck .ck-widget .ck-widget__type-around__button:hover svg polyline{animation:ck-widget-type-around-arrow-dash 2s linear}.ck .ck-widget .ck-widget__type-around__button:hover svg line{animation:ck-widget-type-around-arrow-tip-dash 2s linear}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button,.ck .ck-widget:hover>.ck-widget__type-around>.ck-widget__type-around__button{opacity:1;pointer-events:auto}.ck .ck-widget:not(.ck-widget_selected)>.ck-widget__type-around>.ck-widget__type-around__button{background:var(--ck-color-widget-type-around-button-hover)}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button,.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__button:hover{background:var(--ck-color-widget-type-around-button-active)}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:after,.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__button:hover:after{width:calc(var(--ck-widget-type-around-button-size) - 2px);height:calc(var(--ck-widget-type-around-button-size) - 2px);border-radius:100px;background:linear-gradient(135deg,hsla(0,0%,100%,0),hsla(0,0%,100%,.3))}.ck .ck-widget.ck-widget_with-selection-handle>.ck-widget__type-around>.ck-widget__type-around__button_before{margin-left:20px}.ck .ck-widget .ck-widget__type-around__fake-caret{pointer-events:none;height:1px;animation:ck-widget-type-around-fake-caret-pulse 1s linear infinite normal forwards;outline:1px solid hsla(0,0%,100%,.5);background:var(--ck-color-base-text)}.ck .ck-widget.ck-widget_selected.ck-widget_type-around_show-fake-caret_after,.ck .ck-widget.ck-widget_selected.ck-widget_type-around_show-fake-caret_before{outline-color:transparent}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_selected:hover,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_selected:hover{outline-color:var(--ck-color-widget-hover-border)}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after>.ck-widget__type-around>.ck-widget__type-around__button,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before>.ck-widget__type-around>.ck-widget__type-around__button{opacity:0;pointer-events:none}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_with-selection-handle.ck-widget_selected:hover>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_with-selection-handle.ck-widget_selected:hover>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle{opacity:0}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_selected.ck-widget_with-resizer>.ck-widget__resizer,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_selected.ck-widget_with-resizer>.ck-widget__resizer{opacity:0}.ck[dir=rtl] .ck-widget.ck-widget_with-selection-handle .ck-widget__type-around>.ck-widget__type-around__button_before{margin-left:0;margin-right:20px}.ck-editor__nested-editable.ck-editor__editable_selected .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button,.ck-editor__nested-editable.ck-editor__editable_selected .ck-widget:hover>.ck-widget__type-around>.ck-widget__type-around__button{opacity:0;pointer-events:none}.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:not(:hover){background:var(--ck-color-widget-type-around-button-blurred-editable)}.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:not(:hover) svg *{stroke:#999}@keyframes ck-widget-type-around-arrow-dash{0%{stroke-dashoffset:10}20%,to{stroke-dashoffset:0}}@keyframes ck-widget-type-around-arrow-tip-dash{0%,20%{stroke-dashoffset:7}40%,to{stroke-dashoffset:0}}@keyframes ck-widget-type-around-button-sonar{0%{box-shadow:0 0 0 0 hsla(var(--ck-color-focus-border-coordinates),var(--ck-color-widget-type-around-button-radar-start-alpha))}50%{box-shadow:0 0 0 5px hsla(var(--ck-color-focus-border-coordinates),var(--ck-color-widget-type-around-button-radar-end-alpha))}to{box-shadow:0 0 0 5px hsla(var(--ck-color-focus-border-coordinates),var(--ck-color-widget-type-around-button-radar-start-alpha))}}@keyframes ck-widget-type-around-fake-caret-pulse{0%{opacity:1}49%{opacity:1}50%{opacity:0}99%{opacity:0}to{opacity:1}}', "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-widget/theme/widgettypearound.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-widget/widgettypearound.css"],
      names: [],
      mappings: "AASC,+CACC,aAAc,CACd,iBAAkB,CAClB,eAAgB,CAChB,2BAwBD,CAtBC,mDACC,iBAAkB,CAClB,OAAQ,CACR,QAAS,CACT,qCACD,CAEA,qFAEC,iDAAoD,CACpD,kBAAoB,CAEpB,0BACD,CAEA,oFAEC,oDAAuD,CACvD,mBAAqB,CAErB,yBACD,CAUA,mLACC,UAAW,CACX,aAAc,CACd,iBAAkB,CAClB,OAAQ,CACR,QAAS,CACT,qCACD,CAMD,2EACC,YAAa,CACb,iBAAkB,CAClB,MAAO,CACP,OACD,CAOA,iFACC,gDAAqD,CACrD,iDACD,CAKA,wHACC,qDAA0D,CAC1D,aACD,CAKA,uHACC,wDAA6D,CAC7D,aACD,CAoBD,mOACC,YACD,CC3GA,MACC,wCAAyC,CACzC,wEAAyE,CACzE,8EAA+E,CAC/E,2FAA4F,CAC5F,wDAAyD,CACzD,uDAAwD,CACxD,yEACD,CAgBC,+CACC,8CAA+C,CAC/C,+CAAgD,CAChD,oDAAqD,CACrD,mBAAoB,CACpB,uMAAyM,CAb1M,SAAU,CACV,mBA0DA,CA1CC,mDACC,UAAW,CACX,UAAW,CACX,8BAA+B,CAC/B,6BAA8B,CAC9B,cAgBD,CAdC,qDACC,mBAAoB,CACpB,mBAAoB,CAEpB,SAAU,CACV,qDAAsD,CACtD,kBAAmB,CACnB,oBAAqB,CACrB,qBACD,CAEA,wDACC,kBACD,CAGD,qDAIC,6DAcD,CARE,kEACC,oDACD,CAEA,8DACC,wDACD,CAUF,uKAvED,SAAU,CACV,mBAwEC,CAOD,gGACC,0DACD,CAOA,uKAEC,2DAQD,CANC,mLACC,0DAA2D,CAC3D,2DAA4D,CAC5D,mBAAoB,CACpB,uEACD,CAOD,8GACC,gBACD,CAKA,mDACC,mBAAoB,CACpB,UAAW,CACX,mFAAoF,CAMpF,oCAAwC,CACxC,oCACD,CAOC,6JAEC,yBACD,CAUA,yKACC,iDACD,CAMA,uOAlJD,SAAU,CACV,mBAmJC,CASE,0jBACC,SACD,CASF,mPACC,SACD,CASF,uHACC,aAAc,CACd,iBACD,CAYG,iRAlMF,SAAU,CACV,mBAmME,CAQH,kIACC,qEAKD,CAHC,wIACC,WACD,CAGD,4CACC,GACC,oBACD,CACA,OACC,mBACD,CACD,CAEA,gDACC,OACC,mBACD,CACA,OACC,mBACD,CACD,CAEA,8CACC,GACC,6HACD,CACA,IACC,6HACD,CACA,GACC,+HACD,CACD,CAEA,kDACC,GACC,SACD,CACA,IACC,SACD,CACA,IACC,SACD,CACA,IACC,SACD,CACA,GACC,SACD,CACD",
      sourcesContent: ['/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-widget {\n\t/*\n\t * Styles of the type around buttons\n\t */\n\t& .ck-widget__type-around__button {\n\t\tdisplay: block;\n\t\tposition: absolute;\n\t\toverflow: hidden;\n\t\tz-index: var(--ck-z-default);\n\n\t\t& svg {\n\t\t\tposition: absolute;\n\t\t\ttop: 50%;\n\t\t\tleft: 50%;\n\t\t\tz-index: calc(var(--ck-z-default) + 2);\n\t\t}\n\n\t\t&.ck-widget__type-around__button_before {\n\t\t\t/* Place it in the middle of the outline */\n\t\t\ttop: calc(-0.5 * var(--ck-widget-outline-thickness));\n\t\t\tleft: min(10%, 30px);\n\n\t\t\ttransform: translateY(-50%);\n\t\t}\n\n\t\t&.ck-widget__type-around__button_after {\n\t\t\t/* Place it in the middle of the outline */\n\t\t\tbottom: calc(-0.5 * var(--ck-widget-outline-thickness));\n\t\t\tright: min(10%, 30px);\n\n\t\t\ttransform: translateY(50%);\n\t\t}\n\t}\n\n\t/*\n\t * Styles for the buttons when:\n\t * - the widget is selected,\n\t * - or the button is being hovered (regardless of the widget state).\n\t */\n\t&.ck-widget_selected > .ck-widget__type-around > .ck-widget__type-around__button,\n\t& > .ck-widget__type-around > .ck-widget__type-around__button:hover {\n\t\t&::after {\n\t\t\tcontent: "";\n\t\t\tdisplay: block;\n\t\t\tposition: absolute;\n\t\t\ttop: 1px;\n\t\t\tleft: 1px;\n\t\t\tz-index: calc(var(--ck-z-default) + 1);\n\t\t}\n\t}\n\n\t/*\n\t * Styles for the horizontal "fake caret" which is displayed when the user navigates using the keyboard.\n\t */\n\t& > .ck-widget__type-around > .ck-widget__type-around__fake-caret {\n\t\tdisplay: none;\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\tright: 0;\n\t}\n\n\t/*\n\t * When the widget is hovered the "fake caret" would normally be narrower than the\n\t * extra outline displayed around the widget. Let\'s extend the "fake caret" to match\n\t * the full width of the widget.\n\t */\n\t&:hover > .ck-widget__type-around > .ck-widget__type-around__fake-caret {\n\t\tleft: calc( -1 * var(--ck-widget-outline-thickness) );\n\t\tright: calc( -1 * var(--ck-widget-outline-thickness) );\n\t}\n\n\t/*\n\t * Styles for the horizontal "fake caret" when it should be displayed before the widget (backward keyboard navigation).\n\t */\n\t&.ck-widget_type-around_show-fake-caret_before > .ck-widget__type-around > .ck-widget__type-around__fake-caret {\n\t\ttop: calc( -1 * var(--ck-widget-outline-thickness) - 1px );\n\t\tdisplay: block;\n\t}\n\n\t/*\n\t * Styles for the horizontal "fake caret" when it should be displayed after the widget (forward keyboard navigation).\n\t */\n\t&.ck-widget_type-around_show-fake-caret_after > .ck-widget__type-around > .ck-widget__type-around__fake-caret {\n\t\tbottom: calc( -1 * var(--ck-widget-outline-thickness) - 1px );\n\t\tdisplay: block;\n\t}\n}\n\n/*\n * Integration with the read-only mode of the editor.\n */\n.ck.ck-editor__editable.ck-read-only .ck-widget__type-around {\n\tdisplay: none;\n}\n\n/*\n * Integration with the restricted editing mode (feature) of the editor.\n */\n.ck.ck-editor__editable.ck-restricted-editing_mode_restricted .ck-widget__type-around {\n\tdisplay: none;\n}\n\n/*\n * Integration with the #isEnabled property of the WidgetTypeAround plugin.\n */\n.ck.ck-editor__editable.ck-widget__type-around_disabled .ck-widget__type-around {\n\tdisplay: none;\n}\n', '/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-widget-type-around-button-size: 20px;\n\t--ck-color-widget-type-around-button-active: var(--ck-color-focus-border);\n\t--ck-color-widget-type-around-button-hover: var(--ck-color-widget-hover-border);\n\t--ck-color-widget-type-around-button-blurred-editable: var(--ck-color-widget-blurred-border);\n\t--ck-color-widget-type-around-button-radar-start-alpha: 0;\n\t--ck-color-widget-type-around-button-radar-end-alpha: .3;\n\t--ck-color-widget-type-around-button-icon: var(--ck-color-base-background);\n}\n\n@define-mixin ck-widget-type-around-button-visible {\n\topacity: 1;\n\tpointer-events: auto;\n}\n\n@define-mixin ck-widget-type-around-button-hidden {\n\topacity: 0;\n\tpointer-events: none;\n}\n\n.ck .ck-widget {\n\t/*\n\t * Styles of the type around buttons\n\t */\n\t& .ck-widget__type-around__button {\n\t\twidth: var(--ck-widget-type-around-button-size);\n\t\theight: var(--ck-widget-type-around-button-size);\n\t\tbackground: var(--ck-color-widget-type-around-button);\n\t\tborder-radius: 100px;\n\t\ttransition: opacity var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve), background var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);\n\n\t\t@mixin ck-widget-type-around-button-hidden;\n\n\t\t& svg {\n\t\t\twidth: 10px;\n\t\t\theight: 8px;\n\t\t\ttransform: translate(-50%,-50%);\n\t\t\ttransition: transform .5s ease;\n\t\t\tmargin-top: 1px;\n\n\t\t\t& * {\n\t\t\t\tstroke-dasharray: 10;\n\t\t\t\tstroke-dashoffset: 0;\n\n\t\t\t\tfill: none;\n\t\t\t\tstroke: var(--ck-color-widget-type-around-button-icon);\n\t\t\t\tstroke-width: 1.5px;\n\t\t\t\tstroke-linecap: round;\n\t\t\t\tstroke-linejoin: round;\n\t\t\t}\n\n\t\t\t& line {\n\t\t\t\tstroke-dasharray: 7;\n\t\t\t}\n\t\t}\n\n\t\t&:hover {\n\t\t\t/*\n\t\t\t * Display the "sonar" around the button when hovered.\n\t\t\t */\n\t\t\tanimation: ck-widget-type-around-button-sonar 1s ease infinite;\n\n\t\t\t/*\n\t\t\t * Animate active button\'s icon.\n\t\t\t */\n\t\t\t& svg {\n\t\t\t\t& polyline {\n\t\t\t\t\tanimation: ck-widget-type-around-arrow-dash 2s linear;\n\t\t\t\t}\n\n\t\t\t\t& line {\n\t\t\t\t\tanimation: ck-widget-type-around-arrow-tip-dash 2s linear;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t/*\n\t * Show type around buttons when the widget gets selected or being hovered.\n\t */\n\t&.ck-widget_selected,\n\t&:hover {\n\t\t& > .ck-widget__type-around > .ck-widget__type-around__button {\n\t\t\t@mixin ck-widget-type-around-button-visible;\n\t\t}\n\t}\n\n\t/*\n\t * Styles for the buttons when the widget is NOT selected (but the buttons are visible\n\t * and still can be hovered).\n\t */\n\t&:not(.ck-widget_selected) > .ck-widget__type-around > .ck-widget__type-around__button {\n\t\tbackground: var(--ck-color-widget-type-around-button-hover);\n\t}\n\n\t/*\n\t * Styles for the buttons when:\n\t * - the widget is selected,\n\t * - or the button is being hovered (regardless of the widget state).\n\t */\n\t&.ck-widget_selected > .ck-widget__type-around > .ck-widget__type-around__button,\n\t& > .ck-widget__type-around > .ck-widget__type-around__button:hover {\n\t\tbackground: var(--ck-color-widget-type-around-button-active);\n\n\t\t&::after {\n\t\t\twidth: calc(var(--ck-widget-type-around-button-size) - 2px);\n\t\t\theight: calc(var(--ck-widget-type-around-button-size) - 2px);\n\t\t\tborder-radius: 100px;\n\t\t\tbackground: linear-gradient(135deg, hsla(0,0%,100%,0) 0%, hsla(0,0%,100%,.3) 100%);\n\t\t}\n\t}\n\n\t/*\n\t * Styles for the "before" button when the widget has a selection handle. Because some space\n\t * is consumed by the handle, the button must be moved slightly to the right to let it breathe.\n\t */\n\t&.ck-widget_with-selection-handle > .ck-widget__type-around > .ck-widget__type-around__button_before {\n\t\tmargin-left: 20px;\n\t}\n\n\t/*\n\t * Styles for the horizontal "fake caret" which is displayed when the user navigates using the keyboard.\n\t */\n\t& .ck-widget__type-around__fake-caret {\n\t\tpointer-events: none;\n\t\theight: 1px;\n\t\tanimation: ck-widget-type-around-fake-caret-pulse linear 1s infinite normal forwards;\n\n\t\t/*\n\t\t * The semi-transparent-outline+background combo improves the contrast\n\t\t * when the background underneath the fake caret is dark.\n\t\t */\n\t\toutline: solid 1px hsla(0, 0%, 100%, .5);\n\t\tbackground: var(--ck-color-base-text);\n\t}\n\n\t/*\n\t * Styles of the widget when the "fake caret" is blinking (e.g. upon keyboard navigation).\n\t * Despite the widget being physically selected in the model, its outline should disappear.\n\t */\n\t&.ck-widget_selected {\n\t\t&.ck-widget_type-around_show-fake-caret_before,\n\t\t&.ck-widget_type-around_show-fake-caret_after {\n\t\t\toutline-color: transparent;\n\t\t}\n\t}\n\n\t&.ck-widget_type-around_show-fake-caret_before,\n\t&.ck-widget_type-around_show-fake-caret_after {\n\t\t/*\n\t\t * When the "fake caret" is visible we simulate that the widget is not selected\n\t\t * (despite being physically selected), so the outline color should be for the\n\t\t * unselected widget.\n\t\t */\n\t\t&.ck-widget_selected:hover {\n\t\t\toutline-color: var(--ck-color-widget-hover-border);\n\t\t}\n\n\t\t/*\n\t\t * Styles of the type around buttons when the "fake caret" is blinking (e.g. upon keyboard navigation).\n\t\t * In this state, the type around buttons would collide with the fake carets so they should disappear.\n\t\t */\n\t\t& > .ck-widget__type-around > .ck-widget__type-around__button {\n\t\t\t@mixin ck-widget-type-around-button-hidden;\n\t\t}\n\n\t\t/*\n\t\t * Fake horizontal caret integration with the selection handle. When the caret is visible, simply\n\t\t * hide the handle because it intersects with the caret (and does not make much sense anyway).\n\t\t */\n\t\t&.ck-widget_with-selection-handle {\n\t\t\t&.ck-widget_selected,\n\t\t\t&.ck-widget_selected:hover {\n\t\t\t\t& > .ck-widget__selection-handle {\n\t\t\t\t\topacity: 0\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t/*\n\t\t * Fake horizontal caret integration with the resize UI. When the caret is visible, simply\n\t\t * hide the resize UI because it creates too much noise. It can be visible when the user\n\t\t * hovers the widget, though.\n\t\t */\n\t\t&.ck-widget_selected.ck-widget_with-resizer > .ck-widget__resizer {\n\t\t\topacity: 0\n\t\t}\n\t}\n}\n\n/*\n * Styles for the "before" button when the widget has a selection handle in an RTL environment.\n * The selection handler is aligned to the right side of the widget so there is no need to create\n * additional space for it next to the "before" button.\n */\n.ck[dir="rtl"] .ck-widget.ck-widget_with-selection-handle .ck-widget__type-around > .ck-widget__type-around__button_before {\n\tmargin-left: 0;\n\tmargin-right: 20px;\n}\n\n/*\n * Hide type around buttons when the widget is selected as a child of a selected\n * nested editable (e.g. mulit-cell table selection).\n *\n * See https://github.com/ckeditor/ckeditor5/issues/7263.\n */\n.ck-editor__nested-editable.ck-editor__editable_selected {\n\t& .ck-widget {\n\t\t&.ck-widget_selected,\n\t\t&:hover {\n\t\t\t& > .ck-widget__type-around > .ck-widget__type-around__button {\n\t\t\t\t@mixin ck-widget-type-around-button-hidden;\n\t\t\t}\n\t\t}\n\t}\n}\n\n/*\n * Styles for the buttons when the widget is selected but the user clicked outside of the editor (blurred the editor).\n */\n.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected > .ck-widget__type-around > .ck-widget__type-around__button:not(:hover) {\n\tbackground: var(--ck-color-widget-type-around-button-blurred-editable);\n\n\t& svg * {\n\t\tstroke: hsl(0,0%,60%);\n\t}\n}\n\n@keyframes ck-widget-type-around-arrow-dash {\n\t0% {\n\t\tstroke-dashoffset: 10;\n\t}\n\t20%, 100% {\n\t\tstroke-dashoffset: 0;\n\t}\n}\n\n@keyframes ck-widget-type-around-arrow-tip-dash {\n\t0%, 20% {\n\t\tstroke-dashoffset: 7;\n\t}\n\t40%, 100% {\n\t\tstroke-dashoffset: 0;\n\t}\n}\n\n@keyframes ck-widget-type-around-button-sonar {\n\t0% {\n\t\tbox-shadow: 0 0 0 0 hsla(var(--ck-color-focus-border-coordinates), var(--ck-color-widget-type-around-button-radar-start-alpha));\n\t}\n\t50% {\n\t\tbox-shadow: 0 0 0 5px hsla(var(--ck-color-focus-border-coordinates), var(--ck-color-widget-type-around-button-radar-end-alpha));\n\t}\n\t100% {\n\t\tbox-shadow: 0 0 0 5px hsla(var(--ck-color-focus-border-coordinates), var(--ck-color-widget-type-around-button-radar-start-alpha));\n\t}\n}\n\n@keyframes ck-widget-type-around-fake-caret-pulse {\n\t0% {\n\t\topacity: 1;\n\t}\n\t49% {\n\t\topacity: 1;\n\t}\n\t50% {\n\t\topacity: 0;\n\t}\n\t99% {\n\t\topacity: 0;\n\t}\n\t100% {\n\t\topacity: 1;\n\t}\n}\n'],
      sourceRoot: ""
    }]), e.a = s;
  }, function (t, e, n) {
    "use strict";

    var o = n(2),
      i = n.n(o),
      r = n(3),
      s = n.n(r)()(i.a);
    s.push([t.i, ":root{--ck-color-resizer:var(--ck-color-focus-border);--ck-color-resizer-tooltip-background:#262626;--ck-color-resizer-tooltip-text:#f2f2f2;--ck-resizer-border-radius:var(--ck-border-radius);--ck-resizer-tooltip-offset:10px;--ck-resizer-tooltip-height:calc(var(--ck-spacing-small)*2 + 10px)}.ck .ck-widget,.ck .ck-widget.ck-widget_with-selection-handle{position:relative}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle{position:absolute}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle .ck-icon{display:block}.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_with-selection-handle:hover>.ck-widget__selection-handle{visibility:visible}.ck .ck-size-view{background:var(--ck-color-resizer-tooltip-background);color:var(--ck-color-resizer-tooltip-text);border:1px solid var(--ck-color-resizer-tooltip-text);border-radius:var(--ck-resizer-border-radius);font-size:var(--ck-font-size-tiny);display:block;padding:0 var(--ck-spacing-small);height:var(--ck-resizer-tooltip-height);line-height:var(--ck-resizer-tooltip-height)}.ck .ck-size-view.ck-orientation-above-center,.ck .ck-size-view.ck-orientation-bottom-left,.ck .ck-size-view.ck-orientation-bottom-right,.ck .ck-size-view.ck-orientation-top-left,.ck .ck-size-view.ck-orientation-top-right{position:absolute}.ck .ck-size-view.ck-orientation-top-left{top:var(--ck-resizer-tooltip-offset);left:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-top-right{top:var(--ck-resizer-tooltip-offset);right:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-bottom-right{bottom:var(--ck-resizer-tooltip-offset);right:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-bottom-left{bottom:var(--ck-resizer-tooltip-offset);left:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-above-center{top:calc(var(--ck-resizer-tooltip-height)*-1);left:50%;transform:translate(-50%)}:root{--ck-widget-outline-thickness:3px;--ck-widget-handler-icon-size:16px;--ck-widget-handler-animation-duration:200ms;--ck-widget-handler-animation-curve:ease;--ck-color-widget-blurred-border:#dedede;--ck-color-widget-hover-border:#ffc83d;--ck-color-widget-editable-focus-background:var(--ck-color-base-background);--ck-color-widget-drag-handler-icon-color:var(--ck-color-base-background)}.ck .ck-widget{outline-width:var(--ck-widget-outline-thickness);outline-style:solid;outline-color:transparent;transition:outline-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve)}.ck .ck-widget.ck-widget_selected,.ck .ck-widget.ck-widget_selected:hover{outline:var(--ck-widget-outline-thickness) solid var(--ck-color-focus-border)}.ck .ck-widget:hover{outline-color:var(--ck-color-widget-hover-border)}.ck .ck-editor__nested-editable{border:1px solid transparent}.ck .ck-editor__nested-editable.ck-editor__nested-editable_focused,.ck .ck-editor__nested-editable:focus{outline:none;border:var(--ck-focus-ring);box-shadow:var(--ck-inner-shadow),0 0;background-color:var(--ck-color-widget-editable-focus-background)}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle{padding:4px;box-sizing:border-box;background-color:initial;opacity:0;transition:background-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),visibility var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),opacity var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);border-radius:var(--ck-border-radius) var(--ck-border-radius) 0 0;transform:translateY(-100%);left:calc(0px - var(--ck-widget-outline-thickness));top:0}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle .ck-icon{width:var(--ck-widget-handler-icon-size);height:var(--ck-widget-handler-icon-size);color:var(--ck-color-widget-drag-handler-icon-color)}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle .ck-icon .ck-icon__selected-indicator{opacity:0;transition:opacity .3s var(--ck-widget-handler-animation-curve)}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle:hover .ck-icon .ck-icon__selected-indicator{opacity:1}.ck .ck-widget.ck-widget_with-selection-handle:hover>.ck-widget__selection-handle{opacity:1;background-color:var(--ck-color-widget-hover-border)}.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected:hover>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle{opacity:1;background-color:var(--ck-color-focus-border)}.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected:hover>.ck-widget__selection-handle .ck-icon .ck-icon__selected-indicator,.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle .ck-icon .ck-icon__selected-indicator{opacity:1}.ck[dir=rtl] .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle{left:auto;right:calc(0px - var(--ck-widget-outline-thickness))}.ck.ck-editor__editable.ck-read-only .ck-widget{transition:none}.ck.ck-editor__editable.ck-read-only .ck-widget:not(.ck-widget_selected){--ck-widget-outline-thickness:0px}.ck.ck-editor__editable.ck-read-only .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle,.ck.ck-editor__editable.ck-read-only .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle:hover{background:var(--ck-color-widget-blurred-border)}.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected:hover{outline-color:var(--ck-color-widget-blurred-border)}.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected.ck-widget_with-selection-handle>.ck-widget__selection-handle,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected.ck-widget_with-selection-handle>.ck-widget__selection-handle:hover,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected:hover.ck-widget_with-selection-handle>.ck-widget__selection-handle,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected:hover.ck-widget_with-selection-handle>.ck-widget__selection-handle:hover{background:var(--ck-color-widget-blurred-border)}.ck.ck-editor__editable>.ck-widget.ck-widget_with-selection-handle:first-child,.ck.ck-editor__editable blockquote>.ck-widget.ck-widget_with-selection-handle:first-child{margin-top:calc(1em + var(--ck-widget-handler-icon-size))}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-widget/theme/widget.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-widget/widget.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_focus.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css"],
      names: [],
      mappings: "AAKA,MACC,+CAAgD,CAChD,6CAAsD,CACtD,uCAAgD,CAEhD,kDAAmD,CACnD,gCAAiC,CACjC,kEACD,CAOA,8DAEC,iBAqBD,CAnBC,4EACC,iBAOD,CALC,qFAGC,aACD,CASD,iLACC,kBACD,CAGD,kBACC,qDAAsD,CACtD,0CAA2C,CAC3C,qDAAsD,CACtD,6CAA8C,CAC9C,kCAAmC,CACnC,aAAc,CACd,iCAAkC,CAClC,uCAAwC,CACxC,4CAoCD,CAlCC,8NAKC,iBACD,CAEA,0CACC,oCAAqC,CACrC,qCACD,CAEA,2CACC,oCAAqC,CACrC,sCACD,CAEA,8CACC,uCAAwC,CACxC,sCACD,CAEA,6CACC,uCAAwC,CACxC,qCACD,CAGA,8CACC,6CAAgD,CAChD,QAAS,CACT,yBACD,CCjFD,MACC,iCAAkC,CAClC,kCAAmC,CACnC,4CAA6C,CAC7C,wCAAyC,CAEzC,wCAAiD,CACjD,sCAAkD,CAClD,2EAA4E,CAC5E,yEACD,CAEA,eACC,gDAAiD,CACjD,mBAAoB,CACpB,yBAA0B,CAC1B,6GAUD,CARC,0EAEC,6EACD,CAEA,qBACC,iDACD,CAGD,gCACC,4BAWD,CAPC,yGC/BA,YAAa,CACb,2BAA2B,CCF3B,qCAA8B,CFqC7B,iEACD,CAIA,4EACC,WAAY,CACZ,qBAAsB,CAGtB,wBAA6B,CAC7B,SAAU,CAMV,6SAG6F,CAG7F,iEAAkE,CAGlE,2BAA4B,CAC5B,mDAAoD,CACpD,KAqBD,CAnBC,qFAEC,wCAAyC,CACzC,yCAA0C,CAC1C,oDASD,CANC,kHACC,SAAU,CAGV,+DACD,CAID,wHACC,SACD,CAID,kFACC,SAAU,CACV,oDACD,CAKC,oMACC,SAAU,CACV,6CAMD,CAHC,gRACC,SACD,CAOH,qFACC,SAAU,CACV,oDACD,CAGA,gDAEC,eAkBD,CAhBC,yEAOC,iCACD,CAGC,gOAEC,gDACD,CAOD,wIAEC,mDAQD,CALE,ghBAEC,gDACD,CAKH,yKAOC,yDACD",
      sourcesContent: ["/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-resizer: var(--ck-color-focus-border);\n\t--ck-color-resizer-tooltip-background: hsl(0, 0%, 15%);\n\t--ck-color-resizer-tooltip-text: hsl(0, 0%, 95%);\n\n\t--ck-resizer-border-radius: var(--ck-border-radius);\n\t--ck-resizer-tooltip-offset: 10px;\n\t--ck-resizer-tooltip-height: calc(var(--ck-spacing-small) * 2 + 10px);\n}\n\n.ck .ck-widget {\n\t/* This is neccessary for type around UI to be positioned properly. */\n\tposition: relative;\n}\n\n.ck .ck-widget.ck-widget_with-selection-handle {\n\t/* Make the widget wrapper a relative positioning container for the drag handle. */\n\tposition: relative;\n\n\t& .ck-widget__selection-handle {\n\t\tposition: absolute;\n\n\t\t& .ck-icon {\n\t\t\t/* Make sure the icon in not a subject to font-size or line-height to avoid\n\t\t\tunnecessary spacing around it. */\n\t\t\tdisplay: block;\n\t\t}\n\t}\n\n\t/* Show the selection handle on mouse hover over the widget, but not for nested widgets. */\n\t&:hover > .ck-widget__selection-handle {\n\t\tvisibility: visible;\n\t}\n\n\t/* Show the selection handle when the widget is selected, but not for nested widgets. */\n\t&.ck-widget_selected > .ck-widget__selection-handle {\n\t\tvisibility: visible;\n\t}\n}\n\n.ck .ck-size-view {\n\tbackground: var(--ck-color-resizer-tooltip-background);\n\tcolor: var(--ck-color-resizer-tooltip-text);\n\tborder: 1px solid var(--ck-color-resizer-tooltip-text);\n\tborder-radius: var(--ck-resizer-border-radius);\n\tfont-size: var(--ck-font-size-tiny);\n\tdisplay: block;\n\tpadding: 0 var(--ck-spacing-small);\n\theight: var(--ck-resizer-tooltip-height);\n\tline-height: var(--ck-resizer-tooltip-height);\n\n\t&.ck-orientation-top-left,\n\t&.ck-orientation-top-right,\n\t&.ck-orientation-bottom-right,\n\t&.ck-orientation-bottom-left,\n\t&.ck-orientation-above-center {\n\t\tposition: absolute;\n\t}\n\n\t&.ck-orientation-top-left {\n\t\ttop: var(--ck-resizer-tooltip-offset);\n\t\tleft: var(--ck-resizer-tooltip-offset);\n\t}\n\n\t&.ck-orientation-top-right {\n\t\ttop: var(--ck-resizer-tooltip-offset);\n\t\tright: var(--ck-resizer-tooltip-offset);\n\t}\n\n\t&.ck-orientation-bottom-right {\n\t\tbottom: var(--ck-resizer-tooltip-offset);\n\t\tright: var(--ck-resizer-tooltip-offset);\n\t}\n\n\t&.ck-orientation-bottom-left {\n\t\tbottom: var(--ck-resizer-tooltip-offset);\n\t\tleft: var(--ck-resizer-tooltip-offset);\n\t}\n\n\t/* Class applied if the widget is too small to contain the size label */\n\t&.ck-orientation-above-center {\n\t\ttop: calc(var(--ck-resizer-tooltip-height) * -1);\n\t\tleft: 50%;\n\t\ttransform: translate(-50%);\n\t}\n}\n", '/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../mixins/_focus.css";\n@import "../mixins/_shadow.css";\n\n:root {\n\t--ck-widget-outline-thickness: 3px;\n\t--ck-widget-handler-icon-size: 16px;\n\t--ck-widget-handler-animation-duration: 200ms;\n\t--ck-widget-handler-animation-curve: ease;\n\n\t--ck-color-widget-blurred-border: hsl(0, 0%, 87%);\n\t--ck-color-widget-hover-border: hsl(43, 100%, 62%);\n\t--ck-color-widget-editable-focus-background: var(--ck-color-base-background);\n\t--ck-color-widget-drag-handler-icon-color: var(--ck-color-base-background);\n}\n\n.ck .ck-widget {\n\toutline-width: var(--ck-widget-outline-thickness);\n\toutline-style: solid;\n\toutline-color: transparent;\n\ttransition: outline-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);\n\n\t&.ck-widget_selected,\n\t&.ck-widget_selected:hover {\n\t\toutline: var(--ck-widget-outline-thickness) solid var(--ck-color-focus-border);\n\t}\n\n\t&:hover {\n\t\toutline-color: var(--ck-color-widget-hover-border);\n\t}\n}\n\n.ck .ck-editor__nested-editable {\n\tborder: 1px solid transparent;\n\n\t/* The :focus style is applied before .ck-editor__nested-editable_focused class is rendered in the view.\n\tThese styles show a different border for a blink of an eye, so `:focus` need to have same styles applied. */\n\t&.ck-editor__nested-editable_focused,\n\t&:focus {\n\t\t@mixin ck-focus-ring;\n\t\t@mixin ck-box-shadow var(--ck-inner-shadow);\n\n\t\tbackground-color: var(--ck-color-widget-editable-focus-background);\n\t}\n}\n\n.ck .ck-widget.ck-widget_with-selection-handle {\n\t& .ck-widget__selection-handle {\n\t\tpadding: 4px;\n\t\tbox-sizing: border-box;\n\n\t\t/* Background and opacity will be animated as the handler shows up or the widget gets selected. */\n\t\tbackground-color: transparent;\n\t\topacity: 0;\n\n\t\t/* Transition:\n\t\t   * background-color for the .ck-widget_selected state change,\n\t\t   * visibility for hiding the handler,\n\t\t   * opacity for the proper look of the icon when the handler disappears. */\n\t\ttransition:\n\t\t\tbackground-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),\n\t\t\tvisibility var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),\n\t\t\topacity var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);\n\n\t\t/* Make only top corners round. */\n\t\tborder-radius: var(--ck-border-radius) var(--ck-border-radius) 0 0;\n\n\t\t/* Place the drag handler outside the widget wrapper. */\n\t\ttransform: translateY(-100%);\n\t\tleft: calc(0px - var(--ck-widget-outline-thickness));\n\t\ttop: 0;\n\n\t\t& .ck-icon {\n\t\t\t/* Make sure the dimensions of the icon are independent of the fon-size of the content. */\n\t\t\twidth: var(--ck-widget-handler-icon-size);\n\t\t\theight: var(--ck-widget-handler-icon-size);\n\t\t\tcolor: var(--ck-color-widget-drag-handler-icon-color);\n\n\t\t\t/* The "selected" part of the icon is invisible by default */\n\t\t\t& .ck-icon__selected-indicator {\n\t\t\t\topacity: 0;\n\n\t\t\t\t/* Note: The animation is longer on purpose. Simply feels better. */\n\t\t\t\ttransition: opacity 300ms var(--ck-widget-handler-animation-curve);\n\t\t\t}\n\t\t}\n\n\t\t/* Advertise using the look of the icon that once clicked the handler, the widget will be selected. */\n\t\t&:hover .ck-icon .ck-icon__selected-indicator {\n\t\t\topacity: 1;\n\t\t}\n\t}\n\n\t/* Show the selection handler on mouse hover over the widget, but not for nested widgets. */\n\t&:hover > .ck-widget__selection-handle {\n\t\topacity: 1;\n\t\tbackground-color: var(--ck-color-widget-hover-border);\n\t}\n\n\t/* Show the selection handler when the widget is selected, but not for nested widgets. */\n\t&.ck-widget_selected,\n\t&.ck-widget_selected:hover {\n\t\t& > .ck-widget__selection-handle {\n\t\t\topacity: 1;\n\t\t\tbackground-color: var(--ck-color-focus-border);\n\n\t\t\t/* When the widget is selected, notify the user using the proper look of the icon. */\n\t\t\t& .ck-icon .ck-icon__selected-indicator {\n\t\t\t\topacity: 1;\n\t\t\t}\n\t\t}\n\t}\n}\n\n/* In a RTL environment, align the selection handler to the right side of the widget */\n/* stylelint-disable-next-line no-descending-specificity */\n.ck[dir="rtl"] .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle {\n\tleft: auto;\n\tright: calc(0px - var(--ck-widget-outline-thickness));\n}\n\n/* https://github.com/ckeditor/ckeditor5/issues/6415 */\n.ck.ck-editor__editable.ck-read-only .ck-widget {\n\t/* Prevent the :hover outline from showing up because of the used outline-color transition. */\n\ttransition: none;\n\n\t&:not(.ck-widget_selected) {\n\t\t/* Disable visual effects of hover/active widget when CKEditor is in readOnly mode.\n\t\t * See: https://github.com/ckeditor/ckeditor5/issues/1261\n\t\t *\n\t\t * Leave the unit because this custom property is used in calc() by other features.\n\t\t * See: https://github.com/ckeditor/ckeditor5/issues/6775\n\t\t */\n\t\t--ck-widget-outline-thickness: 0px;\n\t}\n\n\t&.ck-widget_with-selection-handle {\n\t\t& .ck-widget__selection-handle,\n\t\t& .ck-widget__selection-handle:hover {\n\t\t\tbackground: var(--ck-color-widget-blurred-border);\n\t\t}\n\t}\n}\n\n/* Style the widget when it\'s selected but the editable it belongs to lost focus. */\n/* stylelint-disable-next-line no-descending-specificity */\n.ck.ck-editor__editable.ck-blurred .ck-widget {\n\t&.ck-widget_selected,\n\t&.ck-widget_selected:hover {\n\t\toutline-color: var(--ck-color-widget-blurred-border);\n\n\t\t&.ck-widget_with-selection-handle {\n\t\t\t& > .ck-widget__selection-handle,\n\t\t\t& > .ck-widget__selection-handle:hover {\n\t\t\t\tbackground: var(--ck-color-widget-blurred-border);\n\t\t\t}\n\t\t}\n\t}\n}\n\n.ck.ck-editor__editable > .ck-widget.ck-widget_with-selection-handle:first-child,\n.ck.ck-editor__editable blockquote > .ck-widget.ck-widget_with-selection-handle:first-child {\n\t/* Do not crop selection handler if a widget is a first-child in the blockquote or in the root editable.\n\tIn fact, anything with overflow: hidden.\n\thttps://github.com/ckeditor/ckeditor5-block-quote/issues/28\n\thttps://github.com/ckeditor/ckeditor5-widget/issues/44\n\thttps://github.com/ckeditor/ckeditor5-widget/issues/66 */\n\tmargin-top: calc(1em + var(--ck-widget-handler-icon-size));\n}\n', "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A visual style of focused element's border.\n */\n@define-mixin ck-focus-ring {\n\t/* Disable native outline. */\n\toutline: none;\n\tborder: var(--ck-focus-ring)\n}\n", "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"],
      sourceRoot: ""
    }]), e.a = s;
  }, function (t, e, n) {
    "use strict";

    var o = n(2),
      i = n.n(o),
      r = n(3),
      s = n.n(r)()(i.a);
    s.push([t.i, '.ck.ck-editor__editable .ck.ck-clipboard-drop-target-position{display:inline;position:relative;pointer-events:none}.ck.ck-editor__editable .ck.ck-clipboard-drop-target-position span{position:absolute;width:0}.ck.ck-editor__editable .ck-widget:-webkit-drag>.ck-widget__selection-handle,.ck.ck-editor__editable .ck-widget:-webkit-drag>.ck-widget__type-around{display:none}:root{--ck-clipboard-drop-target-dot-width:12px;--ck-clipboard-drop-target-dot-height:8px;--ck-clipboard-drop-target-color:var(--ck-color-focus-border)}.ck.ck-editor__editable .ck.ck-clipboard-drop-target-position span{bottom:calc(var(--ck-clipboard-drop-target-dot-height)*-0.5);top:calc(var(--ck-clipboard-drop-target-dot-height)*-0.5);border:1px solid var(--ck-clipboard-drop-target-color);background:var(--ck-clipboard-drop-target-color);margin-left:-1px}.ck.ck-editor__editable .ck.ck-clipboard-drop-target-position span:after{content:"";width:0;height:0;display:block;position:absolute;left:50%;top:calc(var(--ck-clipboard-drop-target-dot-height)*-0.5);transform:translateX(-50%);border-left:calc(var(--ck-clipboard-drop-target-dot-width)*0.5) solid transparent;border-bottom:0 solid transparent;border-right:calc(var(--ck-clipboard-drop-target-dot-width)*0.5) solid transparent;border-top:calc(var(--ck-clipboard-drop-target-dot-height)) solid var(--ck-clipboard-drop-target-color)}.ck.ck-editor__editable .ck-widget.ck-clipboard-drop-target-range{outline:var(--ck-widget-outline-thickness) solid var(--ck-clipboard-drop-target-color)!important}.ck.ck-editor__editable .ck-widget:-webkit-drag{zoom:.6;outline:none!important}', "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-clipboard/theme/clipboard.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-clipboard/clipboard.css"],
      names: [],
      mappings: "AASC,8DACC,cAAe,CACf,iBAAkB,CAClB,mBAMD,CAJC,mEACC,iBAAkB,CAClB,OACD,CAWA,qJACC,YACD,CCzBF,MACC,yCAA0C,CAC1C,yCAA0C,CAC1C,6DACD,CAOE,mEACC,4DAA8D,CAC9D,yDAA2D,CAC3D,sDAAuD,CACvD,gDAAiD,CACjD,gBAkBD,CAfC,yEACC,UAAW,CACX,OAAQ,CACR,QAAS,CAET,aAAc,CACd,iBAAkB,CAClB,QAAS,CACT,yDAA2D,CAE3D,0BAA2B,CAG3B,iFAAmB,CAAnB,iCAAmB,CAAnB,kFAAmB,CAAnB,uGACD,CA2DF,kEACC,gGACD,CAKA,gDACC,OAAS,CACT,sBACD",
      sourcesContent: ["/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-editor__editable {\n\t/*\n\t * Vertical drop target (in text).\n\t */\n\t& .ck.ck-clipboard-drop-target-position {\n\t\tdisplay: inline;\n\t\tposition: relative;\n\t\tpointer-events: none;\n\n\t\t& span {\n\t\t\tposition: absolute;\n\t\t\twidth: 0;\n\t\t}\n\t}\n\n\t/*\n\t * Styles of the widget being dragged (its preview).\n\t */\n\t& .ck-widget:-webkit-drag {\n\t\t& > .ck-widget__selection-handle {\n\t\t\tdisplay: none;\n\t\t}\n\n\t\t& > .ck-widget__type-around {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n", '/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-clipboard-drop-target-dot-width: 12px;\n\t--ck-clipboard-drop-target-dot-height: 8px;\n\t--ck-clipboard-drop-target-color: var(--ck-color-focus-border)\n}\n\n.ck.ck-editor__editable {\n\t/*\n\t * Vertical drop target (in text).\n\t */\n\t& .ck.ck-clipboard-drop-target-position {\n\t\t& span {\n\t\t\tbottom: calc(-.5 * var(--ck-clipboard-drop-target-dot-height));\n\t\t\ttop: calc(-.5 * var(--ck-clipboard-drop-target-dot-height));\n\t\t\tborder: 1px solid var(--ck-clipboard-drop-target-color);\n\t\t\tbackground: var(--ck-clipboard-drop-target-color);\n\t\t\tmargin-left: -1px;\n\n\t\t\t/* The triangle above the marker */\n\t\t\t&::after {\n\t\t\t\tcontent: "";\n\t\t\t\twidth: 0;\n\t\t\t\theight: 0;\n\n\t\t\t\tdisplay: block;\n\t\t\t\tposition: absolute;\n\t\t\t\tleft: 50%;\n\t\t\t\ttop: calc(var(--ck-clipboard-drop-target-dot-height) * -.5);\n\n\t\t\t\ttransform: translateX(-50%);\n\t\t\t\tborder-color: var(--ck-clipboard-drop-target-color) transparent transparent transparent;\n\t\t\t\tborder-width: calc(var(--ck-clipboard-drop-target-dot-height)) calc(.5 * var(--ck-clipboard-drop-target-dot-width)) 0 calc(.5 * var(--ck-clipboard-drop-target-dot-width));\n\t\t\t\tborder-style: solid;\n\t\t\t}\n\t\t}\n\t}\n\n\t/*\n\t// Horizontal drop target (between blocks).\n\t& .ck.ck-clipboard-drop-target-position {\n\t\tdisplay: block;\n\t\tposition: relative;\n\t\twidth: 100%;\n\t\theight: 0;\n\t\tmargin: 0;\n\t\ttext-align: initial;\n\n\t\t& .ck-clipboard-drop-target__line {\n\t\t\tposition: absolute;\n\t\t\twidth: 100%;\n\t\t\theight: 0;\n\t\t\tborder: 1px solid var(--ck-clipboard-drop-target-color);\n\t\t\tmargin-top: -1px;\n\n\t\t\t&::before {\n\t\t\t\tcontent: "";\n\t\t\t\twidth: 0;\n\t\t\t\theight: 0;\n\n\t\t\t\tdisplay: block;\n\t\t\t\tposition: absolute;\n\t\t\t\tleft: calc(-1 * var(--ck-clipboard-drop-target-dot-size));\n\t\t\t\ttop: 0;\n\n\t\t\t\ttransform: translateY(-50%);\n\t\t\t\tborder-color: transparent transparent transparent var(--ck-clipboard-drop-target-color);\n\t\t\t\tborder-width: var(--ck-clipboard-drop-target-dot-size) 0 var(--ck-clipboard-drop-target-dot-size) calc(2 * var(--ck-clipboard-drop-target-dot-size));\n\t\t\t\tborder-style: solid;\n\t\t\t}\n\n\t\t\t&::after {\n\t\t\t\tcontent: "";\n\t\t\t\twidth: 0;\n\t\t\t\theight: 0;\n\n\t\t\t\tdisplay: block;\n\t\t\t\tposition: absolute;\n\t\t\t\tright: calc(-1 * var(--ck-clipboard-drop-target-dot-size));\n\t\t\t\ttop: 0;\n\n\t\t\t\ttransform: translateY(-50%);\n\t\t\t\tborder-color: transparent var(--ck-clipboard-drop-target-color) transparent transparent;\n\t\t\t\tborder-width: var(--ck-clipboard-drop-target-dot-size) calc(2 * var(--ck-clipboard-drop-target-dot-size)) var(--ck-clipboard-drop-target-dot-size) 0;\n\t\t\t\tborder-style: solid;\n\t\t\t}\n\t\t}\n\t}\n\t*/\n\n\t/*\n\t * Styles of the widget that it a drop target.\n\t */\n\t& .ck-widget.ck-clipboard-drop-target-range {\n\t\toutline: var(--ck-widget-outline-thickness) solid var(--ck-clipboard-drop-target-color) !important;\n\t}\n\n\t/*\n\t * Styles of the widget being dragged (its preview).\n\t */\n\t& .ck-widget:-webkit-drag {\n\t\tzoom: 0.6;\n\t\toutline: none !important;\n\t}\n}\n'],
      sourceRoot: ""
    }]), e.a = s;
  }, function (t, e, n) {
    "use strict";

    var o = n(2),
      i = n.n(o),
      r = n(3),
      s = n.n(r)()(i.a);
    s.push([t.i, ".ck .ck-button.ck-color-table__remove-color{display:flex;align-items:center;width:100%}label.ck.ck-color-grid__label{font-weight:unset}.ck .ck-button.ck-color-table__remove-color{padding:calc(var(--ck-spacing-standard)/2) var(--ck-spacing-standard);border-bottom-left-radius:0;border-bottom-right-radius:0}.ck .ck-button.ck-color-table__remove-color:not(:focus){border-bottom:1px solid var(--ck-color-base-border)}[dir=ltr] .ck .ck-button.ck-color-table__remove-color .ck.ck-icon{margin-right:var(--ck-spacing-standard)}[dir=rtl] .ck .ck-button.ck-color-table__remove-color .ck.ck-icon{margin-left:var(--ck-spacing-standard)}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-font/theme/fontcolor.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-font/fontcolor.css"],
      names: [],
      mappings: "AAKA,4CACC,YAAa,CACb,kBAAmB,CACnB,UACD,CAEA,8BACC,iBACD,CCNA,4CACC,qEAAyE,CACzE,2BAA4B,CAC5B,4BAeD,CAbC,wDACC,mDACD,CAEA,kEAEE,uCAMF,CARA,kEAME,sCAEF",
      sourcesContent: ["/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-button.ck-color-table__remove-color {\n\tdisplay: flex;\n\talign-items: center;\n\twidth: 100%;\n}\n\nlabel.ck.ck-color-grid__label {\n\tfont-weight: unset;\n}\n", '/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n.ck .ck-button.ck-color-table__remove-color {\n\tpadding: calc(var(--ck-spacing-standard) / 2 ) var(--ck-spacing-standard);\n\tborder-bottom-left-radius: 0;\n\tborder-bottom-right-radius: 0;\n\n\t&:not(:focus) {\n\t\tborder-bottom: 1px solid var(--ck-color-base-border);\n\t}\n\n\t& .ck.ck-icon {\n\t\t@mixin ck-dir ltr {\n\t\t\tmargin-right: var(--ck-spacing-standard);\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t}\n\t}\n}\n\n'],
      sourceRoot: ""
    }]), e.a = s;
  }, function (t, e, n) {
    "use strict";

    var o = n(2),
      i = n.n(o),
      r = n(3),
      s = n.n(r)()(i.a);
    s.push([t.i, ".ck-content .text-tiny{font-size:.7em}.ck-content .text-small{font-size:.85em}.ck-content .text-big{font-size:1.4em}.ck-content .text-huge{font-size:1.8em}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-font/theme/fontsize.css"],
      names: [],
      mappings: "AAUC,uBACC,cACD,CAEA,wBACC,eACD,CAEA,sBACC,eACD,CAEA,uBACC,eACD",
      sourcesContent: ['/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/* The values should be synchronized with the "FONT_SIZE_PRESET_UNITS" object in the "/src/fontsize/utils.js" file. */\n\n/* Styles should be prefixed with the `.ck-content` class.\nSee https://github.com/ckeditor/ckeditor5/issues/6636 */\n.ck-content {\n\t& .text-tiny {\n\t\tfont-size: .7em;\n\t}\n\n\t& .text-small {\n\t\tfont-size: .85em;\n\t}\n\n\t& .text-big {\n\t\tfont-size: 1.4em;\n\t}\n\n\t& .text-huge {\n\t\tfont-size: 1.8em;\n\t}\n}\n'],
      sourceRoot: ""
    }]), e.a = s;
  }, function (t, e, n) {
    "use strict";

    var o = n(2),
      i = n.n(o),
      r = n(3),
      s = n.n(r)()(i.a);
    s.push([t.i, ".ck.ck-heading_heading1{font-size:20px}.ck.ck-heading_heading2{font-size:17px}.ck.ck-heading_heading3{font-size:14px}.ck[class*=ck-heading_heading]{font-weight:700}.ck.ck-dropdown.ck-heading-dropdown .ck-dropdown__button .ck-button__label{width:8em}.ck.ck-dropdown.ck-heading-dropdown .ck-dropdown__panel .ck-list__item{min-width:18em}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-heading/theme/heading.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-heading/heading.css"],
      names: [],
      mappings: "AAKA,wBACC,cACD,CAEA,wBACC,cACD,CAEA,wBACC,cACD,CAEA,+BACC,eACD,CCZC,2EACC,SACD,CAEA,uEACC,cACD",
      sourcesContent: ['/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-heading_heading1 {\n\tfont-size: 20px;\n}\n\n.ck.ck-heading_heading2 {\n\tfont-size: 17px;\n}\n\n.ck.ck-heading_heading3 {\n\tfont-size: 14px;\n}\n\n.ck[class*="ck-heading_heading"] {\n\tfont-weight: bold;\n}\n', "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/* Resize dropdown's button label. */\n.ck.ck-dropdown.ck-heading-dropdown {\n\t& .ck-dropdown__button .ck-button__label {\n\t\twidth: 8em;\n\t}\n\n\t& .ck-dropdown__panel .ck-list__item {\n\t\tmin-width: 18em;\n\t}\n}\n"],
      sourceRoot: ""
    }]), e.a = s;
  }, function (t, e, n) {
    "use strict";

    var o = n(2),
      i = n.n(o),
      r = n(3),
      s = n.n(r)()(i.a);
    s.push([t.i, ".ck .ck-widget_with-resizer{position:relative}.ck .ck-widget__resizer{display:none;position:absolute;pointer-events:none;left:0;top:0}.ck-focused .ck-widget_with-resizer.ck-widget_selected>.ck-widget__resizer{display:block}.ck .ck-widget__resizer__handle{position:absolute;pointer-events:all}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-bottom-right,.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-top-left{cursor:nwse-resize}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-bottom-left,.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-top-right{cursor:nesw-resize}:root{--ck-resizer-size:10px;--ck-resizer-offset:calc(var(--ck-resizer-size)/-2 - 2px);--ck-resizer-border-width:1px}.ck .ck-widget__resizer{outline:1px solid var(--ck-color-resizer)}.ck .ck-widget__resizer__handle{width:var(--ck-resizer-size);height:var(--ck-resizer-size);background:var(--ck-color-focus-border);border:var(--ck-resizer-border-width) solid #fff;border-radius:var(--ck-resizer-border-radius)}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-top-left{top:var(--ck-resizer-offset);left:var(--ck-resizer-offset)}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-top-right{top:var(--ck-resizer-offset);right:var(--ck-resizer-offset)}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-bottom-right{bottom:var(--ck-resizer-offset);right:var(--ck-resizer-offset)}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-bottom-left{bottom:var(--ck-resizer-offset);left:var(--ck-resizer-offset)}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-widget/theme/widgetresize.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-widget/widgetresize.css"],
      names: [],
      mappings: "AAKA,4BAEC,iBACD,CAEA,wBACC,YAAa,CACb,iBAAkB,CAGlB,mBAAoB,CAEpB,MAAO,CACP,KACD,CAGC,2EACC,aACD,CAGD,gCACC,iBAAkB,CAGlB,kBAWD,CATC,4IAEC,kBACD,CAEA,4IAEC,kBACD,CCpCD,MACC,sBAAuB,CAGvB,yDAAiE,CACjE,6BACD,CAEA,wBACC,yCACD,CAEA,gCACC,4BAA6B,CAC7B,6BAA8B,CAC9B,uCAAwC,CACxC,gDAA6D,CAC7D,6CAqBD,CAnBC,oEACC,4BAA6B,CAC7B,6BACD,CAEA,qEACC,4BAA6B,CAC7B,8BACD,CAEA,wEACC,+BAAgC,CAChC,8BACD,CAEA,uEACC,+BAAgC,CAChC,6BACD",
      sourcesContent: ["/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-widget_with-resizer {\n\t/* Make the widget wrapper a relative positioning container for the drag handle. */\n\tposition: relative;\n}\n\n.ck .ck-widget__resizer {\n\tdisplay: none;\n\tposition: absolute;\n\n\t/* The wrapper itself should not interfere with the pointer device, only the handles should. */\n\tpointer-events: none;\n\n\tleft: 0;\n\ttop: 0;\n}\n\n.ck-focused .ck-widget_with-resizer.ck-widget_selected {\n\t& > .ck-widget__resizer {\n\t\tdisplay: block;\n\t}\n}\n\n.ck .ck-widget__resizer__handle {\n\tposition: absolute;\n\n\t/* Resizers are the only UI elements that should interfere with a pointer device. */\n\tpointer-events: all;\n\n\t&.ck-widget__resizer__handle-top-left,\n\t&.ck-widget__resizer__handle-bottom-right {\n\t\tcursor: nwse-resize;\n\t}\n\n\t&.ck-widget__resizer__handle-top-right,\n\t&.ck-widget__resizer__handle-bottom-left {\n\t\tcursor: nesw-resize;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-resizer-size: 10px;\n\n\t/* Set the resizer with a 50% offset. */\n\t--ck-resizer-offset: calc( ( var(--ck-resizer-size) / -2 ) - 2px);\n\t--ck-resizer-border-width: 1px;\n}\n\n.ck .ck-widget__resizer {\n\toutline: 1px solid var(--ck-color-resizer);\n}\n\n.ck .ck-widget__resizer__handle {\n\twidth: var(--ck-resizer-size);\n\theight: var(--ck-resizer-size);\n\tbackground: var(--ck-color-focus-border);\n\tborder: var(--ck-resizer-border-width) solid hsl(0, 0%, 100%);\n\tborder-radius: var(--ck-resizer-border-radius);\n\n\t&.ck-widget__resizer__handle-top-left {\n\t\ttop: var(--ck-resizer-offset);\n\t\tleft: var(--ck-resizer-offset);\n\t}\n\n\t&.ck-widget__resizer__handle-top-right {\n\t\ttop: var(--ck-resizer-offset);\n\t\tright: var(--ck-resizer-offset);\n\t}\n\n\t&.ck-widget__resizer__handle-bottom-right {\n\t\tbottom: var(--ck-resizer-offset);\n\t\tright: var(--ck-resizer-offset);\n\t}\n\n\t&.ck-widget__resizer__handle-bottom-left {\n\t\tbottom: var(--ck-resizer-offset);\n\t\tleft: var(--ck-resizer-offset);\n\t}\n}\n"],
      sourceRoot: ""
    }]), e.a = s;
  }, function (t, e, n) {
    "use strict";

    var o = n(2),
      i = n.n(o),
      r = n(3),
      s = n.n(r)()(i.a);
    s.push([t.i, ".ck.ck-text-alternative-form{display:flex;flex-direction:row;flex-wrap:nowrap}.ck.ck-text-alternative-form .ck-labeled-field-view{display:inline-block}.ck.ck-text-alternative-form .ck-label{display:none}@media screen and (max-width:600px){.ck.ck-text-alternative-form{flex-wrap:wrap}.ck.ck-text-alternative-form .ck-labeled-field-view{flex-basis:100%}.ck.ck-text-alternative-form .ck-button{flex-basis:50%}}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-image/theme/textalternativeform.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css"],
      names: [],
      mappings: "AAOA,6BACC,YAAa,CACb,kBAAmB,CACnB,gBAqBD,CAnBC,oDACC,oBACD,CAEA,uCACC,YACD,CCZA,oCDCD,6BAcE,cAUF,CARE,oDACC,eACD,CAEA,wCACC,cACD,CCrBD",
      sourcesContent: ['/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck.ck-text-alternative-form {\n\tdisplay: flex;\n\tflex-direction: row;\n\tflex-wrap: nowrap;\n\n\t& .ck-labeled-field-view {\n\t\tdisplay: inline-block;\n\t}\n\n\t& .ck-label {\n\t\tdisplay: none;\n\t}\n\n\t@mixin ck-media-phone {\n\t\tflex-wrap: wrap;\n\n\t\t& .ck-labeled-field-view {\n\t\t\tflex-basis: 100%;\n\t\t}\n\n\t\t& .ck-button {\n\t\t\tflex-basis: 50%;\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-phone {\n\t@media screen and (max-width: 600px) {\n\t\t@mixin-content;\n\t}\n}\n"],
      sourceRoot: ""
    }]), e.a = s;
  }, function (t, e, n) {
    "use strict";

    var o = n(2),
      i = n.n(o),
      r = n(3),
      s = n.n(r)()(i.a);
    s.push([t.i, '.ck-vertical-form .ck-button:after{content:"";width:0;position:absolute;right:-1px;top:var(--ck-spacing-small);bottom:var(--ck-spacing-small);z-index:1}@media screen and (max-width:600px){.ck.ck-responsive-form .ck-button:after{content:"";width:0;position:absolute;right:-1px;top:var(--ck-spacing-small);bottom:var(--ck-spacing-small);z-index:1}}.ck-vertical-form>.ck-button:nth-last-child(2):after{border-right:1px solid var(--ck-color-base-border)}.ck.ck-responsive-form{padding:var(--ck-spacing-large)}.ck.ck-responsive-form:focus{outline:none}[dir=ltr] .ck.ck-responsive-form>:not(:first-child),[dir=rtl] .ck.ck-responsive-form>:not(:last-child){margin-left:var(--ck-spacing-standard)}@media screen and (max-width:600px){.ck.ck-responsive-form{padding:0;width:calc(var(--ck-input-text-width)*0.8)}.ck.ck-responsive-form .ck-labeled-field-view{margin:var(--ck-spacing-large) var(--ck-spacing-large) 0}.ck.ck-responsive-form .ck-labeled-field-view .ck-input-text{min-width:0;width:100%}.ck.ck-responsive-form .ck-labeled-field-view .ck-labeled-field-view__error{white-space:normal}.ck.ck-responsive-form>.ck-button:last-child,.ck.ck-responsive-form>.ck-button:nth-last-child(2){padding:var(--ck-spacing-standard);margin-top:var(--ck-spacing-large);border-radius:0;border:0;border-top:1px solid var(--ck-color-base-border)}[dir=ltr] .ck.ck-responsive-form>.ck-button:last-child,[dir=ltr] .ck.ck-responsive-form>.ck-button:nth-last-child(2),[dir=rtl] .ck.ck-responsive-form>.ck-button:last-child,[dir=rtl] .ck.ck-responsive-form>.ck-button:nth-last-child(2){margin-left:0}.ck.ck-responsive-form>.ck-button:nth-last-child(2):after,[dir=rtl] .ck.ck-responsive-form>.ck-button:last-child:last-of-type,[dir=rtl] .ck.ck-responsive-form>.ck-button:nth-last-child(2):last-of-type{border-right:1px solid var(--ck-color-base-border)}}', "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/responsive-form/responsiveform.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/responsive-form/responsiveform.css"],
      names: [],
      mappings: "AAOA,mCACC,UAAW,CACX,OAAQ,CACR,iBAAkB,CAClB,UAAW,CACX,2BAA4B,CAC5B,8BAA+B,CAC/B,SACD,CCTC,oCDaC,wCACC,UAAW,CACX,OAAQ,CACR,iBAAkB,CAClB,UAAW,CACX,2BAA4B,CAC5B,8BAA+B,CAC/B,SACD,CCnBD,CCAD,qDACC,kDACD,CAEA,uBACC,+BAkED,CAhEC,6BAEC,YACD,CASC,uGACC,sCACD,CDvBD,oCCMD,uBAqBE,SAAU,CACV,0CA6CF,CA3CE,8CACC,wDAWD,CATC,6DACC,WAAY,CACZ,UACD,CAGA,4EACC,kBACD,CAID,iGAEC,kCAAmC,CACnC,kCAAmC,CAEnC,eAAgB,CAChB,QAAS,CACT,gDAaD,CApBA,0OAcE,aAMF,CAGC,yMACC,kDACD,CDpEF",
      sourcesContent: ['/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck-vertical-form .ck-button::after {\n\tcontent: "";\n\twidth: 0;\n\tposition: absolute;\n\tright: -1px;\n\ttop: var(--ck-spacing-small);\n\tbottom: var(--ck-spacing-small);\n\tz-index: 1;\n}\n\n.ck.ck-responsive-form {\n\t@mixin ck-media-phone {\n\t\t& .ck-button::after {\n\t\t\tcontent: "";\n\t\t\twidth: 0;\n\t\t\tposition: absolute;\n\t\t\tright: -1px;\n\t\t\ttop: var(--ck-spacing-small);\n\t\t\tbottom: var(--ck-spacing-small);\n\t\t\tz-index: 1;\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-phone {\n\t@media screen and (max-width: 600px) {\n\t\t@mixin-content;\n\t}\n}\n", '/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n.ck-vertical-form > .ck-button:nth-last-child(2)::after {\n\tborder-right: 1px solid var(--ck-color-base-border);\n}\n\n.ck.ck-responsive-form {\n\tpadding: var(--ck-spacing-large);\n\n\t&:focus {\n\t\t/* See: https://github.com/ckeditor/ckeditor5/issues/4773 */\n\t\toutline: none;\n\t}\n\n\t@mixin ck-dir ltr {\n\t\t& > :not(:first-child) {\n\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t}\n\t}\n\n\t@mixin ck-dir rtl {\n\t\t& > :not(:last-child) {\n\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t}\n\t}\n\n\t@mixin ck-media-phone {\n\t\tpadding: 0;\n\t\twidth: calc(.8 * var(--ck-input-text-width));\n\n\t\t& .ck-labeled-field-view {\n\t\t\tmargin: var(--ck-spacing-large) var(--ck-spacing-large) 0;\n\n\t\t\t& .ck-input-text {\n\t\t\t\tmin-width: 0;\n\t\t\t\twidth: 100%;\n\t\t\t}\n\n\t\t\t/* Let the long error messages wrap in the narrow form. */\n\t\t\t& .ck-labeled-field-view__error {\n\t\t\t\twhite-space: normal;\n\t\t\t}\n\t\t}\n\n\t\t/* Styles for two last buttons in the form (save&cancel, edit&unlink, etc.). */\n\t\t& > .ck-button:nth-last-child(1),\n\t\t& > .ck-button:nth-last-child(2) {\n\t\t\tpadding: var(--ck-spacing-standard);\n\t\t\tmargin-top: var(--ck-spacing-large);\n\n\t\t\tborder-radius: 0;\n\t\t\tborder: 0;\n\t\t\tborder-top: 1px solid var(--ck-color-base-border);\n\n\t\t\t@mixin ck-dir ltr {\n\t\t\t\tmargin-left: 0;\n\t\t\t}\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tmargin-left: 0;\n\n\t\t\t\t&:last-of-type {\n\t\t\t\t\tborder-right: 1px solid var(--ck-color-base-border);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t& > .ck-button:nth-last-child(2) {\n\t\t\t&::after {\n\t\t\t\tborder-right: 1px solid var(--ck-color-base-border);\n\t\t\t}\n\t\t}\n\t}\n}\n'],
      sourceRoot: ""
    }]), e.a = s;
  }, function (t, e, n) {
    "use strict";

    var o = n(2),
      i = n.n(o),
      r = n(3),
      s = n.n(r)()(i.a);
    s.push([t.i, ".ck-content .image{display:table;clear:both;text-align:center;margin:.9em auto;min-width:50px}.ck-content .image img{display:block;margin:0 auto;max-width:100%;min-width:100%}.ck-content .image-inline{display:inline-flex;max-width:100%;align-items:flex-start}.ck-content .image-inline img{flex-grow:1;flex-shrink:1;max-width:100%}.ck.ck-editor__editable .image>figcaption.ck-placeholder:before{padding-left:inherit;padding-right:inherit;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ck.ck-editor__editable .image-inline.ck-widget_selected,.ck.ck-editor__editable .image.ck-widget_selected{z-index:1}.ck.ck-editor__editable .image-inline.ck-widget_selected ::selection{display:none}.ck.ck-editor__editable td .image-inline img,.ck.ck-editor__editable th .image-inline img{max-width:none}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-image/theme/image.css"],
      names: [],
      mappings: "AAMC,mBACC,aAAc,CACd,UAAW,CACX,iBAAkB,CAKlB,gBAAkB,CAGlB,cAeD,CAbC,uBAEC,aAAc,CAGd,aAAc,CAGd,cAAe,CAGf,cACD,CAGD,0BAMC,mBAAoB,CAGpB,cAAe,CAGf,sBAUD,CARC,8BAEC,WAAY,CACZ,aAAc,CAGd,cACD,CAUD,gEACC,oBAAqB,CACrB,qBAAsB,CAMtB,kBAAmB,CACnB,eAAgB,CAChB,sBACD,CAWA,2GACC,SAUD,CAHC,qEACC,YACD,CAOA,0FACC,cACD",
      sourcesContent: ['/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-content {\n\t& .image {\n\t\tdisplay: table;\n\t\tclear: both;\n\t\ttext-align: center;\n\n\t\t/* Make sure there is some space between the content and the image. Center image by default. */\n\t\t/* The first value should be equal to --ck-spacing-large variable if used in the editor context\n\t \tto avoid the content jumping (See https://github.com/ckeditor/ckeditor5/issues/9825). */\n\t\tmargin: 0.9em auto;\n\n\t\t/* Make sure the caption will be displayed properly (See: https://github.com/ckeditor/ckeditor5/issues/1870). */\n\t\tmin-width: 50px;\n\n\t\t& img {\n\t\t\t/* Prevent unnecessary margins caused by line-height (see #44). */\n\t\t\tdisplay: block;\n\n\t\t\t/* Center the image if its width is smaller than the content\'s width. */\n\t\t\tmargin: 0 auto;\n\n\t\t\t/* Make sure the image never exceeds the size of the parent container (ckeditor/ckeditor5-ui#67). */\n\t\t\tmax-width: 100%;\n\n\t\t\t/* Make sure the image is never smaller than the parent container (See: https://github.com/ckeditor/ckeditor5/issues/9300). */\n\t\t\tmin-width: 100%\n\t\t}\n\t}\n\n\t& .image-inline {\n\t\t/*\n\t\t * Normally, the .image-inline would have "display: inline-block" and "img { width: 100% }" (to follow the wrapper while resizing).\n\t\t * Unfortunately, together with "srcset", it gets automatically stretched up to the width of the editing root.\n\t\t * This strange behavior does not happen with inline-flex.\n\t\t */\n\t\tdisplay: inline-flex;\n\n\t\t/* While being resized, don\'t allow the image to exceed the width of the editing root. */\n\t\tmax-width: 100%;\n\n\t\t/* This is required by Safari to resize images in a sensible way. Without this, the browser breaks the ratio. */\n\t\talign-items: flex-start;\n\n\t\t& img {\n\t\t\t/* This is necessary for the img to span the entire .image-inline wrapper and to resize properly. */\n\t\t\tflex-grow: 1;\n\t\t\tflex-shrink: 1;\n\n\t\t\t/* Prevents overflowing the editing root boundaries when an inline image is very wide. */\n\t\t\tmax-width: 100%;\n\t\t}\n\t}\n}\n\n.ck.ck-editor__editable {\n\t/*\n\t * Inhertit the content styles padding of the <figcaption> in case the integration overrides `text-align: center`\n\t * of `.image` (e.g. to the left/right). This ensures the placeholder stays at the padding just like the native\n\t * caret does, and not at the edge of <figcaption>.\n\t */\n\t& .image > figcaption.ck-placeholder::before {\n\t\tpadding-left: inherit;\n\t\tpadding-right: inherit;\n\n\t\t/*\n\t\t * Make sure the image caption placeholder doesn\'t overflow the placeholder area.\n\t\t * See https://github.com/ckeditor/ckeditor5/issues/9162.\n\t\t */\n\t\twhite-space: nowrap;\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t}\n\n\n\t/*\n\t * Make sure the selected inline image always stays on top of its siblings.\n\t * See https://github.com/ckeditor/ckeditor5/issues/9108.\n\t */\n\t& .image.ck-widget_selected {\n\t\tz-index: 1;\n\t}\n\n\t& .image-inline.ck-widget_selected {\n\t\tz-index: 1;\n\n\t\t/*\n\t\t * Make sure the native browser selection style is not displayed.\n\t\t * Inline image widgets have their own styles for the selected state and\n\t\t * leaving this up to the browser is asking for a visual collision.\n\t\t */\n\t\t& ::selection {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\t/* The inline image nested in the table should have its original size if not resized.\n\tSee https://github.com/ckeditor/ckeditor5/issues/9117. */\n\t& td,\n\t& th {\n\t\t& .image-inline img {\n\t\t\tmax-width: none;\n\t\t}\n\t}\n}\n'],
      sourceRoot: ""
    }]), e.a = s;
  }, function (t, e, n) {
    "use strict";

    var o = n(2),
      i = n.n(o),
      r = n(3),
      s = n.n(r)()(i.a);
    s.push([t.i, ":root{--ck-color-image-caption-background:#f7f7f7;--ck-color-image-caption-text:#333;--ck-color-image-caption-highligted-background:hsl(52deg 100% 50%)}.ck-content .image>figcaption{display:table-caption;caption-side:bottom;word-break:break-word;color:var(--ck-color-image-caption-text);background-color:var(--ck-color-image-caption-background);padding:.6em;font-size:.75em;outline-offset:-1px}.ck.ck-editor__editable .image>figcaption.image__caption_highlighted{animation:ck-image-caption-highlight .6s ease-out}@keyframes ck-image-caption-highlight{0%{background-color:var(--ck-color-image-caption-highligted-background)}to{background-color:var(--ck-color-image-caption-background)}}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-image/theme/imagecaption.css"],
      names: [],
      mappings: "AAKA,MACC,2CAAoD,CACpD,kCAA8C,CAC9C,kEACD,CAGA,8BACC,qBAAsB,CACtB,mBAAoB,CACpB,qBAAsB,CACtB,wCAAyC,CACzC,yDAA0D,CAC1D,YAAa,CACb,eAAgB,CAChB,mBACD,CAGA,qEACC,iDACD,CAEA,sCACC,GACC,oEACD,CAEA,GACC,yDACD,CACD",
      sourcesContent: ["/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-image-caption-background: hsl(0, 0%, 97%);\n\t--ck-color-image-caption-text: hsl(0, 0%, 20%);\n\t--ck-color-image-caption-highligted-background: hsl(52deg 100% 50%);\n}\n\n/* Content styles */\n.ck-content .image > figcaption {\n\tdisplay: table-caption;\n\tcaption-side: bottom;\n\tword-break: break-word;\n\tcolor: var(--ck-color-image-caption-text);\n\tbackground-color: var(--ck-color-image-caption-background);\n\tpadding: .6em;\n\tfont-size: .75em;\n\toutline-offset: -1px;\n}\n\n/* Editing styles */\n.ck.ck-editor__editable .image > figcaption.image__caption_highlighted {\n\tanimation: ck-image-caption-highlight .6s ease-out;\n}\n\n@keyframes ck-image-caption-highlight {\n\t0% {\n\t\tbackground-color: var(--ck-color-image-caption-highligted-background);\n\t}\n\n\t100% {\n\t\tbackground-color: var(--ck-color-image-caption-background);\n\t}\n}\n"],
      sourceRoot: ""
    }]), e.a = s;
  }, function (t, e, n) {
    "use strict";

    var o = n(2),
      i = n.n(o),
      r = n(3),
      s = n.n(r)()(i.a);
    s.push([t.i, ":root{--ck-image-style-spacing:1.5em;--ck-inline-image-style-spacing:calc(var(--ck-image-style-spacing)/2)}.ck-content .image-style-block-align-left,.ck-content .image-style-block-align-right{max-width:calc(100% - var(--ck-image-style-spacing))}.ck-content .image-style-align-left,.ck-content .image-style-align-right{clear:none}.ck-content .image-style-side{float:right;margin-left:var(--ck-image-style-spacing);max-width:50%}.ck-content .image-style-align-left{float:left;margin-right:var(--ck-image-style-spacing)}.ck-content .image-style-align-center{margin-left:auto;margin-right:auto}.ck-content .image-style-align-right{float:right;margin-left:var(--ck-image-style-spacing)}.ck-content .image-style-block-align-right{margin-right:0;margin-left:auto}.ck-content .image-style-block-align-left{margin-left:0;margin-right:auto}.ck-content p+.image-style-align-left,.ck-content p+.image-style-align-right,.ck-content p+.image-style-side{margin-top:0}.ck-content .image-inline.image-style-align-left,.ck-content .image-inline.image-style-align-right{margin-top:var(--ck-inline-image-style-spacing);margin-bottom:var(--ck-inline-image-style-spacing)}.ck-content .image-inline.image-style-align-left{margin-right:var(--ck-inline-image-style-spacing)}.ck-content .image-inline.image-style-align-right{margin-left:var(--ck-inline-image-style-spacing)}.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open>.ck-splitbutton__action:not(.ck-disabled),.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled),.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):not(:hover),.ck.ck-splitbutton.ck-splitbutton_flatten:hover>.ck-splitbutton__action:not(.ck-disabled),.ck.ck-splitbutton.ck-splitbutton_flatten:hover>.ck-splitbutton__arrow:not(.ck-disabled),.ck.ck-splitbutton.ck-splitbutton_flatten:hover>.ck-splitbutton__arrow:not(.ck-disabled):not(:hover){background-color:var(--ck-color-button-on-background)}.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open>.ck-splitbutton__action:not(.ck-disabled):after,.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):after,.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):not(:hover):after,.ck.ck-splitbutton.ck-splitbutton_flatten:hover>.ck-splitbutton__action:not(.ck-disabled):after,.ck.ck-splitbutton.ck-splitbutton_flatten:hover>.ck-splitbutton__arrow:not(.ck-disabled):after,.ck.ck-splitbutton.ck-splitbutton_flatten:hover>.ck-splitbutton__arrow:not(.ck-disabled):not(:hover):after{display:none}.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open:hover>.ck-splitbutton__action:not(.ck-disabled),.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open:hover>.ck-splitbutton__arrow:not(.ck-disabled),.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open:hover>.ck-splitbutton__arrow:not(.ck-disabled):not(:hover){background-color:var(--ck-color-button-on-hover-background)}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-image/theme/imagestyle.css"],
      names: [],
      mappings: "AAKA,MACC,8BAA+B,CAC/B,qEACD,CAMC,qFAEC,oDACD,CAIA,yEAEC,UACD,CAEA,8BACC,WAAY,CACZ,yCAA0C,CAC1C,aACD,CAEA,oCACC,UAAW,CACX,0CACD,CAEA,sCACC,gBAAiB,CACjB,iBACD,CAEA,qCACC,WAAY,CACZ,yCACD,CAEA,2CACC,cAAe,CACf,gBACD,CAEA,0CACC,aAAc,CACd,iBACD,CAGA,6GAGC,YACD,CAGC,mGAEC,+CAAgD,CAChD,kDACD,CAEA,iDACC,iDACD,CAEA,kDACC,gDACD,CAUC,0lBAGC,qDAKD,CAHC,8nBACC,YACD,CAKD,oVAGC,2DACD",
      sourcesContent: ["/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-image-style-spacing: 1.5em;\n\t--ck-inline-image-style-spacing: calc(var(--ck-image-style-spacing) / 2);\n}\n\n.ck-content {\n\t/* Provides a minimal side margin for the left and right aligned images, so that the user has a visual feedback\n\tconfirming successful application of the style if image width exceeds the editor's size.\n\tSee https://github.com/ckeditor/ckeditor5/issues/9342 */\n\t& .image-style-block-align-left,\n\t& .image-style-block-align-right {\n\t\tmax-width: calc(100% - var(--ck-image-style-spacing));\n\t}\n\n\t/* Allows displaying multiple floating images in the same line.\n\tSee https://github.com/ckeditor/ckeditor5/issues/9183#issuecomment-804988132 */\n\t& .image-style-align-left,\n\t& .image-style-align-right {\n\t\tclear: none;\n\t}\n\n\t& .image-style-side {\n\t\tfloat: right;\n\t\tmargin-left: var(--ck-image-style-spacing);\n\t\tmax-width: 50%;\n\t}\n\n\t& .image-style-align-left {\n\t\tfloat: left;\n\t\tmargin-right: var(--ck-image-style-spacing);\n\t}\n\n\t& .image-style-align-center {\n\t\tmargin-left: auto;\n\t\tmargin-right: auto;\n\t}\n\n\t& .image-style-align-right {\n\t\tfloat: right;\n\t\tmargin-left: var(--ck-image-style-spacing);\n\t}\n\n\t& .image-style-block-align-right {\n\t\tmargin-right: 0;\n\t\tmargin-left: auto;\n\t}\n\n\t& .image-style-block-align-left {\n\t\tmargin-left: 0;\n\t\tmargin-right: auto;\n\t}\n\n\t/* Simulates margin collapsing with the preceding paragraph, which does not work for the floating elements. */\n\t& p + .image-style-align-left,\n\t& p + .image-style-align-right,\n\t& p + .image-style-side {\n\t\tmargin-top: 0;\n\t}\n\n\t& .image-inline {\n\t\t&.image-style-align-left,\n\t\t&.image-style-align-right {\n\t\t\tmargin-top: var(--ck-inline-image-style-spacing);\n\t\t\tmargin-bottom: var(--ck-inline-image-style-spacing);\n\t\t}\n\n\t\t&.image-style-align-left {\n\t\t\tmargin-right: var(--ck-inline-image-style-spacing);\n\t\t}\n\n\t\t&.image-style-align-right {\n\t\t\tmargin-left: var(--ck-inline-image-style-spacing);\n\t\t}\n\t}\n}\n\n.ck.ck-splitbutton {\n\t/* The button should display as a regular drop-down if the action button\n\tis forced to fire the same action as the arrow button. */\n\t&.ck-splitbutton_flatten {\n\t\t&:hover,\n\t\t&.ck-splitbutton_open {\n\t\t\t& > .ck-splitbutton__action:not(.ck-disabled),\n\t\t\t& > .ck-splitbutton__arrow:not(.ck-disabled),\n\t\t\t& > .ck-splitbutton__arrow:not(.ck-disabled):not(:hover) {\n\t\t\t\tbackground-color: var(--ck-color-button-on-background);\n\n\t\t\t\t&::after {\n\t\t\t\t\tdisplay: none;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t&.ck-splitbutton_open:hover {\n\t\t\t& > .ck-splitbutton__action:not(.ck-disabled),\n\t\t\t& > .ck-splitbutton__arrow:not(.ck-disabled),\n\t\t\t& > .ck-splitbutton__arrow:not(.ck-disabled):not(:hover) {\n\t\t\t\tbackground-color: var(--ck-color-button-on-hover-background);\n\t\t\t}\n\t\t}\n\t}\n}\n"],
      sourceRoot: ""
    }]), e.a = s;
  }, function (t, e, n) {
    "use strict";

    var o = n(2),
      i = n.n(o),
      r = n(3),
      s = n.n(r)()(i.a);
    s.push([t.i, ".ck.ck-editor__editable .image,.ck.ck-editor__editable .image-inline{position:relative}.ck.ck-editor__editable .image-inline .ck-progress-bar,.ck.ck-editor__editable .image .ck-progress-bar{position:absolute;top:0;left:0}.ck.ck-editor__editable .image-inline.ck-appear,.ck.ck-editor__editable .image.ck-appear{animation:fadeIn .7s}.ck.ck-editor__editable .image-inline .ck-progress-bar,.ck.ck-editor__editable .image .ck-progress-bar{height:2px;width:0;background:var(--ck-color-upload-bar-background);transition:width .1s}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-image/theme/imageuploadprogress.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-image/imageuploadprogress.css"],
      names: [],
      mappings: "AAMC,qEAEC,iBACD,CAGA,uGAEC,iBAAkB,CAClB,KAAM,CACN,MACD,CCRC,yFACC,oBACD,CAID,uGAEC,UAAW,CACX,OAAQ,CACR,gDAAiD,CACjD,oBACD,CAGD,kBACC,GAAO,SAAY,CACnB,GAAO,SAAY,CACpB",
      sourcesContent: ["/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-editor__editable {\n\t& .image,\n\t& .image-inline {\n\t\tposition: relative;\n\t}\n\n\t/* Upload progress bar. */\n\t& .image .ck-progress-bar,\n\t& .image-inline .ck-progress-bar {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tleft: 0;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-editor__editable {\n\t& .image,\n\t& .image-inline {\n\t\t/* Showing animation. */\n\t\t&.ck-appear {\n\t\t\tanimation: fadeIn 700ms;\n\t\t}\n\t}\n\n\t/* Upload progress bar. */\n\t& .image .ck-progress-bar,\n\t& .image-inline .ck-progress-bar {\n\t\theight: 2px;\n\t\twidth: 0;\n\t\tbackground: var(--ck-color-upload-bar-background);\n\t\ttransition: width 100ms;\n\t}\n}\n\n@keyframes fadeIn {\n\tfrom { opacity: 0; }\n\tto   { opacity: 1; }\n}\n"],
      sourceRoot: ""
    }]), e.a = s;
  }, function (t, e, n) {
    "use strict";

    var o = n(2),
      i = n.n(o),
      r = n(3),
      s = n.n(r)()(i.a);
    s.push([t.i, '.ck-image-upload-complete-icon{display:block;position:absolute;top:min(var(--ck-spacing-medium),6%);right:min(var(--ck-spacing-medium),6%);border-radius:50%;z-index:1}.ck-image-upload-complete-icon:after{content:"";position:absolute}:root{--ck-color-image-upload-icon:#fff;--ck-color-image-upload-icon-background:#008a00;--ck-image-upload-icon-size:20;--ck-image-upload-icon-width:2px;--ck-image-upload-icon-is-visible:clamp(0px,100% - 50px,1px)}.ck-image-upload-complete-icon{opacity:0;background:var(--ck-color-image-upload-icon-background);animation-name:ck-upload-complete-icon-show,ck-upload-complete-icon-hide;animation-fill-mode:forwards,forwards;animation-duration:.5s,.5s;font-size:calc(1px*var(--ck-image-upload-icon-size));animation-delay:0ms,3s;overflow:hidden;width:calc(var(--ck-image-upload-icon-is-visible)*var(--ck-image-upload-icon-size));height:calc(var(--ck-image-upload-icon-is-visible)*var(--ck-image-upload-icon-size))}.ck-image-upload-complete-icon:after{left:25%;top:50%;opacity:0;height:0;width:0;transform:scaleX(-1) rotate(135deg);transform-origin:left top;border-top:var(--ck-image-upload-icon-width) solid var(--ck-color-image-upload-icon);border-right:var(--ck-image-upload-icon-width) solid var(--ck-color-image-upload-icon);animation-name:ck-upload-complete-icon-check;animation-duration:.5s;animation-delay:.5s;animation-fill-mode:forwards;box-sizing:border-box}@keyframes ck-upload-complete-icon-show{0%{opacity:0}to{opacity:1}}@keyframes ck-upload-complete-icon-hide{0%{opacity:1}to{opacity:0}}@keyframes ck-upload-complete-icon-check{0%{opacity:1;width:0;height:0}33%{width:.3em;height:0}to{opacity:1;width:.3em;height:.45em}}', "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-image/theme/imageuploadicon.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-image/imageuploadicon.css"],
      names: [],
      mappings: "AAKA,+BACC,aAAc,CACd,iBAAkB,CAMlB,oCAAsC,CACtC,sCAAwC,CACxC,iBAAkB,CAClB,SAMD,CAJC,qCACC,UAAW,CACX,iBACD,CChBD,MACC,iCAA8C,CAC9C,+CAA4D,CAG5D,8BAA+B,CAC/B,gCAAiC,CACjC,4DACD,CAEA,+BACC,SAAU,CACV,uDAAwD,CACxD,wEAA0E,CAC1E,qCAAuC,CACvC,0BAAgC,CAGhC,oDAAuD,CAGvD,sBAA4B,CAM5B,eAAgB,CAChB,mFAAsF,CACtF,oFAyBD,CAtBC,qCAEC,QAAS,CAET,OAAQ,CACR,SAAU,CACV,QAAS,CACT,OAAQ,CAER,mCAAoC,CACpC,yBAA0B,CAC1B,oFAAqF,CACrF,sFAAuF,CAEvF,4CAA6C,CAC7C,sBAAyB,CACzB,mBAAsB,CACtB,4BAA6B,CAG7B,qBACD,CAGD,wCACC,GACC,SACD,CAEA,GACC,SACD,CACD,CAEA,wCACC,GACC,SACD,CAEA,GACC,SACD,CACD,CAEA,yCACC,GACC,SAAU,CACV,OAAQ,CACR,QACD,CACA,IACC,UAAY,CACZ,QACD,CACA,GACC,SAAU,CACV,UAAY,CACZ,YACD,CACD",
      sourcesContent: ['/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-image-upload-complete-icon {\n\tdisplay: block;\n\tposition: absolute;\n\n\t/*\n\t * Smaller images should have the icon closer to the border.\n\t * Match the icon position with the linked image indicator brought by the link image feature.\n\t */\n\ttop: min(var(--ck-spacing-medium), 6%);\n\tright: min(var(--ck-spacing-medium), 6%);\n\tborder-radius: 50%;\n\tz-index: 1;\n\n\t&::after {\n\t\tcontent: "";\n\t\tposition: absolute;\n\t}\n}\n', '/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-image-upload-icon: hsl(0, 0%, 100%);\n\t--ck-color-image-upload-icon-background: hsl(120, 100%, 27%);\n\n\t/* Match the icon size with the linked image indicator brought by the link image feature. */\n\t--ck-image-upload-icon-size: 20;\n\t--ck-image-upload-icon-width: 2px;\n\t--ck-image-upload-icon-is-visible: clamp(0px, 100% - 50px, 1px);\n}\n\n.ck-image-upload-complete-icon {\n\topacity: 0;\n\tbackground: var(--ck-color-image-upload-icon-background);\n\tanimation-name: ck-upload-complete-icon-show, ck-upload-complete-icon-hide;\n\tanimation-fill-mode: forwards, forwards;\n\tanimation-duration: 500ms, 500ms;\n\n\t/* To make animation scalable. */\n\tfont-size: calc(1px * var(--ck-image-upload-icon-size));\n\n\t/* Hide completed upload icon after 3 seconds. */\n\tanimation-delay: 0ms, 3000ms;\n\n\t/*\n\t * Use CSS math to simulate container queries.\n\t * https://css-tricks.com/the-raven-technique-one-step-closer-to-container-queries/#what-about-showing-and-hiding-things\n\t */\n\toverflow: hidden;\n\twidth: calc(var(--ck-image-upload-icon-is-visible) * var(--ck-image-upload-icon-size));\n\theight: calc(var(--ck-image-upload-icon-is-visible) * var(--ck-image-upload-icon-size));\n\n\t/* This is check icon element made from border-width mixed with animations. */\n\t&::after {\n\t\t/* Because of border transformation we need to "hard code" left position. */\n\t\tleft: 25%;\n\n\t\ttop: 50%;\n\t\topacity: 0;\n\t\theight: 0;\n\t\twidth: 0;\n\n\t\ttransform: scaleX(-1) rotate(135deg);\n\t\ttransform-origin: left top;\n\t\tborder-top: var(--ck-image-upload-icon-width) solid var(--ck-color-image-upload-icon);\n\t\tborder-right: var(--ck-image-upload-icon-width) solid var(--ck-color-image-upload-icon);\n\n\t\tanimation-name: ck-upload-complete-icon-check;\n\t\tanimation-duration: 500ms;\n\t\tanimation-delay: 500ms;\n\t\tanimation-fill-mode: forwards;\n\n\t\t/* #1095. While reset is not providing proper box-sizing for pseudoelements, we need to handle it. */\n\t\tbox-sizing: border-box;\n\t}\n}\n\n@keyframes ck-upload-complete-icon-show {\n\tfrom {\n\t\topacity: 0;\n\t}\n\n\tto {\n\t\topacity: 1;\n\t}\n}\n\n@keyframes ck-upload-complete-icon-hide {\n\tfrom {\n\t\topacity: 1;\n\t}\n\n\tto {\n\t\topacity: 0;\n\t}\n}\n\n@keyframes ck-upload-complete-icon-check {\n\t0% {\n\t\topacity: 1;\n\t\twidth: 0;\n\t\theight: 0;\n\t}\n\t33% {\n\t\twidth: 0.3em;\n\t\theight: 0;\n\t}\n\t100% {\n\t\topacity: 1;\n\t\twidth: 0.3em;\n\t\theight: 0.45em;\n\t}\n}\n'],
      sourceRoot: ""
    }]), e.a = s;
  }, function (t, e, n) {
    "use strict";

    var o = n(2),
      i = n.n(o),
      r = n(3),
      s = n.n(r)()(i.a);
    s.push([t.i, '.ck .ck-upload-placeholder-loader{position:absolute;display:flex;align-items:center;justify-content:center;top:0;left:0}.ck .ck-upload-placeholder-loader:before{content:"";position:relative}:root{--ck-color-upload-placeholder-loader:#b3b3b3;--ck-upload-placeholder-loader-size:32px}.ck .ck-image-upload-placeholder{width:100%;margin:0}.ck .ck-upload-placeholder-loader{width:100%;height:100%}.ck .ck-upload-placeholder-loader:before{width:var(--ck-upload-placeholder-loader-size);height:var(--ck-upload-placeholder-loader-size);border-radius:50%;border-top:3px solid var(--ck-color-upload-placeholder-loader);border-right:2px solid transparent;animation:ck-upload-placeholder-loader 1s linear infinite}@keyframes ck-upload-placeholder-loader{to{transform:rotate(1turn)}}', "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-image/theme/imageuploadloader.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-image/imageuploadloader.css"],
      names: [],
      mappings: "AAKA,kCACC,iBAAkB,CAClB,YAAa,CACb,kBAAmB,CACnB,sBAAuB,CACvB,KAAM,CACN,MAMD,CAJC,yCACC,UAAW,CACX,iBACD,CCXD,MACC,4CAAqD,CACrD,wCACD,CAEA,iCAEC,UAAW,CACX,QACD,CAEA,kCACC,UAAW,CACX,WAUD,CARC,yCACC,8CAA+C,CAC/C,+CAAgD,CAChD,iBAAkB,CAClB,8DAA+D,CAC/D,kCAAmC,CACnC,yDACD,CAGD,wCACC,GACC,uBACD,CACD",
      sourcesContent: ["/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-upload-placeholder-loader {\n\tposition: absolute;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\ttop: 0;\n\tleft: 0;\n\n\t&::before {\n\t\tcontent: '';\n\t\tposition: relative;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-upload-placeholder-loader: hsl(0, 0%, 70%);\n\t--ck-upload-placeholder-loader-size: 32px;\n}\n\n.ck .ck-image-upload-placeholder {\n\t/* We need to control the full width of the SVG gray background. */\n\twidth: 100%;\n\tmargin: 0;\n}\n\n.ck .ck-upload-placeholder-loader {\n\twidth: 100%;\n\theight: 100%;\n\n\t&::before {\n\t\twidth: var(--ck-upload-placeholder-loader-size);\n\t\theight: var(--ck-upload-placeholder-loader-size);\n\t\tborder-radius: 50%;\n\t\tborder-top: 3px solid var(--ck-color-upload-placeholder-loader);\n\t\tborder-right: 2px solid transparent;\n\t\tanimation: ck-upload-placeholder-loader 1s linear infinite;\n\t}\n}\n\n@keyframes ck-upload-placeholder-loader {\n\tto {\n\t\ttransform: rotate( 360deg );\n\t}\n}\n"],
      sourceRoot: ""
    }]), e.a = s;
  }, function (t, e, n) {
    "use strict";

    var o = n(2),
      i = n.n(o),
      r = n(3),
      s = n.n(r)()(i.a);
    s.push([t.i, ".ck .ck-link_selected{background:var(--ck-color-link-selected-background)}.ck .ck-link_selected span.image-inline{outline:var(--ck-widget-outline-thickness) solid var(--ck-color-link-selected-background)}.ck .ck-fake-link-selection{background:var(--ck-color-link-fake-selection)}.ck .ck-fake-link-selection_collapsed{height:100%;border-right:1px solid var(--ck-color-base-text);margin-right:-1px;outline:1px solid hsla(0,0%,100%,.5)}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-link/link.css"],
      names: [],
      mappings: "AAMA,sBACC,mDAMD,CAHC,wCACC,yFACD,CAOD,4BACC,8CACD,CAGA,sCACC,WAAY,CACZ,gDAAiD,CACjD,iBAAkB,CAClB,oCACD",
      sourcesContent: ['/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/* Class added to span element surrounding currently selected link. */\n.ck .ck-link_selected {\n\tbackground: var(--ck-color-link-selected-background);\n\n\t/* Give linked inline images some outline to let the user know they are also part of the link. */\n\t& span.image-inline {\n\t\toutline: var(--ck-widget-outline-thickness) solid var(--ck-color-link-selected-background);\n\t}\n}\n\n/*\n * Classes used by the "fake visual selection" displayed in the content when an input\n * in the link UI has focus (the browser does not render the native selection in this state).\n */\n.ck .ck-fake-link-selection {\n\tbackground: var(--ck-color-link-fake-selection);\n}\n\n/* A collapsed fake visual selection. */\n.ck .ck-fake-link-selection_collapsed {\n\theight: 100%;\n\tborder-right: 1px solid var(--ck-color-base-text);\n\tmargin-right: -1px;\n\toutline: solid 1px hsla(0, 0%, 100%, .5);\n}\n'],
      sourceRoot: ""
    }]), e.a = s;
  }, function (t, e, n) {
    "use strict";

    var o = n(2),
      i = n.n(o),
      r = n(3),
      s = n.n(r)()(i.a);
    s.push([t.i, ".ck.ck-link-form{display:flex}.ck.ck-link-form .ck-label{display:none}@media screen and (max-width:600px){.ck.ck-link-form{flex-wrap:wrap}.ck.ck-link-form .ck-labeled-field-view{flex-basis:100%}.ck.ck-link-form .ck-button{flex-basis:50%}}.ck.ck-link-form_layout-vertical{display:block}.ck.ck-link-form_layout-vertical .ck-button.ck-button-cancel,.ck.ck-link-form_layout-vertical .ck-button.ck-button-save{margin-top:var(--ck-spacing-medium)}.ck.ck-link-form_layout-vertical{padding:0;min-width:var(--ck-input-text-width)}.ck.ck-link-form_layout-vertical .ck-labeled-field-view{margin:var(--ck-spacing-large) var(--ck-spacing-large) var(--ck-spacing-small)}.ck.ck-link-form_layout-vertical .ck-labeled-field-view .ck-input-text{min-width:0;width:100%}.ck.ck-link-form_layout-vertical .ck-button{padding:var(--ck-spacing-standard);margin:0;border-radius:0;border:0;border-top:1px solid var(--ck-color-base-border);width:50%}[dir=ltr] .ck.ck-link-form_layout-vertical .ck-button,[dir=rtl] .ck.ck-link-form_layout-vertical .ck-button{margin-left:0}[dir=rtl] .ck.ck-link-form_layout-vertical .ck-button:last-of-type{border-right:1px solid var(--ck-color-base-border)}.ck.ck-link-form_layout-vertical .ck.ck-list{margin:var(--ck-spacing-standard) var(--ck-spacing-large)}.ck.ck-link-form_layout-vertical .ck.ck-list .ck-button.ck-switchbutton{border:0;padding:0;width:100%}.ck.ck-link-form_layout-vertical .ck.ck-list .ck-button.ck-switchbutton:hover{background:none}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-link/theme/linkform.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-link/linkform.css"],
      names: [],
      mappings: "AAOA,iBACC,YAiBD,CAfC,2BACC,YACD,CCNA,oCDCD,iBAQE,cAUF,CARE,wCACC,eACD,CAEA,4BACC,cACD,CCfD,CDuBD,iCACC,aAYD,CALE,wHAEC,mCACD,CE/BF,iCACC,SAAU,CACV,oCA8CD,CA5CC,wDACC,8EAMD,CAJC,uEACC,WAAY,CACZ,UACD,CAGD,4CACC,kCAAmC,CACnC,QAAS,CACT,eAAgB,CAChB,QAAS,CACT,gDAAiD,CACjD,SAaD,CAnBA,4GAaE,aAMF,CAJE,mEACC,kDACD,CAKF,6CACC,yDAWD,CATC,wEACC,QAAS,CACT,SAAU,CACV,UAKD,CAHC,8EACC,eACD",
      sourcesContent: ['/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck.ck-link-form {\n\tdisplay: flex;\n\n\t& .ck-label {\n\t\tdisplay: none;\n\t}\n\n\t@mixin ck-media-phone {\n\t\tflex-wrap: wrap;\n\n\t\t& .ck-labeled-field-view {\n\t\t\tflex-basis: 100%;\n\t\t}\n\n\t\t& .ck-button {\n\t\t\tflex-basis: 50%;\n\t\t}\n\t}\n}\n\n/*\n * Style link form differently when manual decorators are available.\n * See: https://github.com/ckeditor/ckeditor5-link/issues/186.\n */\n.ck.ck-link-form_layout-vertical {\n\tdisplay: block;\n\n\t/*\n\t * Whether the form is in the responsive mode or not, if there are decorator buttons\n\t * keep the top margin of action buttons medium.\n\t */\n\t& .ck-button {\n\t\t&.ck-button-save,\n\t\t&.ck-button-cancel {\n\t\t\tmargin-top: var(--ck-spacing-medium);\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-phone {\n\t@media screen and (max-width: 600px) {\n\t\t@mixin-content;\n\t}\n}\n", '/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n/*\n * Style link form differently when manual decorators are available.\n * See: https://github.com/ckeditor/ckeditor5-link/issues/186.\n */\n.ck.ck-link-form_layout-vertical {\n\tpadding: 0;\n\tmin-width: var(--ck-input-text-width);\n\n\t& .ck-labeled-field-view {\n\t\tmargin: var(--ck-spacing-large) var(--ck-spacing-large) var(--ck-spacing-small);\n\n\t\t& .ck-input-text {\n\t\t\tmin-width: 0;\n\t\t\twidth: 100%;\n\t\t}\n\t}\n\n\t& .ck-button {\n\t\tpadding: var(--ck-spacing-standard);\n\t\tmargin: 0;\n\t\tborder-radius: 0;\n\t\tborder: 0;\n\t\tborder-top: 1px solid var(--ck-color-base-border);\n\t\twidth: 50%;\n\n\t\t@mixin ck-dir ltr {\n\t\t\tmargin-left: 0;\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\tmargin-left: 0;\n\n\t\t\t&:last-of-type {\n\t\t\t\tborder-right: 1px solid var(--ck-color-base-border);\n\t\t\t}\n\t\t}\n\t}\n\n\t/* Using additional `.ck` class for stronger CSS specificity than `.ck.ck-link-form > :not(:first-child)`. */\n\t& .ck.ck-list {\n\t\tmargin: var(--ck-spacing-standard) var(--ck-spacing-large);\n\n\t\t& .ck-button.ck-switchbutton {\n\t\t\tborder: 0;\n\t\t\tpadding: 0;\n\t\t\twidth: 100%;\n\n\t\t\t&:hover {\n\t\t\t\tbackground: none;\n\t\t\t}\n\t\t}\n\t}\n}\n'],
      sourceRoot: ""
    }]), e.a = s;
  }, function (t, e, n) {
    "use strict";

    var o = n(2),
      i = n.n(o),
      r = n(3),
      s = n.n(r)()(i.a);
    s.push([t.i, ".ck.ck-link-actions{display:flex;flex-direction:row;flex-wrap:nowrap}.ck.ck-link-actions .ck-link-actions__preview{display:inline-block}.ck.ck-link-actions .ck-link-actions__preview .ck-button__label{overflow:hidden}@media screen and (max-width:600px){.ck.ck-link-actions{flex-wrap:wrap}.ck.ck-link-actions .ck-link-actions__preview{flex-basis:100%}.ck.ck-link-actions .ck-button:not(.ck-link-actions__preview){flex-basis:50%}}.ck.ck-link-actions .ck-button.ck-link-actions__preview{padding-left:0;padding-right:0}.ck.ck-link-actions .ck-button.ck-link-actions__preview .ck-button__label{padding:0 var(--ck-spacing-medium);color:var(--ck-color-link-default);text-overflow:ellipsis;cursor:pointer;max-width:var(--ck-input-text-width);min-width:3em;text-align:center}.ck.ck-link-actions .ck-button.ck-link-actions__preview .ck-button__label:hover{text-decoration:underline}.ck.ck-link-actions .ck-button.ck-link-actions__preview,.ck.ck-link-actions .ck-button.ck-link-actions__preview:active,.ck.ck-link-actions .ck-button.ck-link-actions__preview:focus,.ck.ck-link-actions .ck-button.ck-link-actions__preview:hover{background:none}.ck.ck-link-actions .ck-button.ck-link-actions__preview:active{box-shadow:none}.ck.ck-link-actions .ck-button.ck-link-actions__preview:focus .ck-button__label{text-decoration:underline}[dir=ltr] .ck.ck-link-actions .ck-button:not(:first-child),[dir=rtl] .ck.ck-link-actions .ck-button:not(:last-child){margin-left:var(--ck-spacing-standard)}@media screen and (max-width:600px){.ck.ck-link-actions .ck-button.ck-link-actions__preview{margin:var(--ck-spacing-standard) var(--ck-spacing-standard) 0}.ck.ck-link-actions .ck-button.ck-link-actions__preview .ck-button__label{min-width:0;max-width:100%}[dir=ltr] .ck.ck-link-actions .ck-button:not(.ck-link-actions__preview),[dir=rtl] .ck.ck-link-actions .ck-button:not(.ck-link-actions__preview){margin-left:0}}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-link/theme/linkactions.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-link/linkactions.css"],
      names: [],
      mappings: "AAOA,oBACC,YAAa,CACb,kBAAmB,CACnB,gBAqBD,CAnBC,8CACC,oBAKD,CAHC,gEACC,eACD,CCXD,oCDCD,oBAcE,cAUF,CARE,8CACC,eACD,CAEA,8DACC,cACD,CCrBD,CCKA,wDACC,cAAe,CACf,eAmCD,CAjCC,0EACC,kCAAmC,CACnC,kCAAmC,CACnC,sBAAuB,CACvB,cAAe,CAIf,oCAAqC,CACrC,aAAc,CACd,iBAKD,CAHC,gFACC,yBACD,CAGD,mPAIC,eACD,CAEA,+DACC,eACD,CAGC,gFACC,yBACD,CAWD,qHACC,sCACD,CDvDD,oCC2DC,wDACC,8DAMD,CAJC,0EACC,WAAY,CACZ,cACD,CAGD,gJAME,aAEF,CD1ED",
      sourcesContent: ['/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck.ck-link-actions {\n\tdisplay: flex;\n\tflex-direction: row;\n\tflex-wrap: nowrap;\n\n\t& .ck-link-actions__preview {\n\t\tdisplay: inline-block;\n\n\t\t& .ck-button__label {\n\t\t\toverflow: hidden;\n\t\t}\n\t}\n\n\t@mixin ck-media-phone {\n\t\tflex-wrap: wrap;\n\n\t\t& .ck-link-actions__preview {\n\t\t\tflex-basis: 100%;\n\t\t}\n\n\t\t& .ck-button:not(.ck-link-actions__preview) {\n\t\t\tflex-basis: 50%;\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-phone {\n\t@media screen and (max-width: 600px) {\n\t\t@mixin-content;\n\t}\n}\n", '/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/components/tooltip/mixins/_tooltip.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_unselectable.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n@import "../mixins/_focus.css";\n@import "../mixins/_shadow.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck.ck-link-actions {\n\t& .ck-button.ck-link-actions__preview {\n\t\tpadding-left: 0;\n\t\tpadding-right: 0;\n\n\t\t& .ck-button__label {\n\t\t\tpadding: 0 var(--ck-spacing-medium);\n\t\t\tcolor: var(--ck-color-link-default);\n\t\t\ttext-overflow: ellipsis;\n\t\t\tcursor: pointer;\n\n\t\t\t/* Match the box model of the link editor form\'s input so the balloon\n\t\t\tdoes not change width when moving between actions and the form. */\n\t\t\tmax-width: var(--ck-input-text-width);\n\t\t\tmin-width: 3em;\n\t\t\ttext-align: center;\n\n\t\t\t&:hover {\n\t\t\t\ttext-decoration: underline;\n\t\t\t}\n\t\t}\n\n\t\t&,\n\t\t&:hover,\n\t\t&:focus,\n\t\t&:active {\n\t\t\tbackground: none;\n\t\t}\n\n\t\t&:active {\n\t\t\tbox-shadow: none;\n\t\t}\n\n\t\t&:focus {\n\t\t\t& .ck-button__label {\n\t\t\t\ttext-decoration: underline;\n\t\t\t}\n\t\t}\n\t}\n\n\t@mixin ck-dir ltr {\n\t\t& .ck-button:not(:first-child) {\n\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t}\n\t}\n\n\t@mixin ck-dir rtl {\n\t\t& .ck-button:not(:last-child) {\n\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t}\n\t}\n\n\t@mixin ck-media-phone {\n\t\t& .ck-button.ck-link-actions__preview {\n\t\t\tmargin: var(--ck-spacing-standard) var(--ck-spacing-standard) 0;\n\n\t\t\t& .ck-button__label {\n\t\t\t\tmin-width: 0;\n\t\t\t\tmax-width: 100%;\n\t\t\t}\n\t\t}\n\n\t\t& .ck-button:not(.ck-link-actions__preview) {\n\t\t\t@mixin ck-dir ltr {\n\t\t\t\tmargin-left: 0;\n\t\t\t}\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tmargin-left: 0;\n\t\t\t}\n\t\t}\n\t}\n}\n'],
      sourceRoot: ""
    }]), e.a = s;
  }, function (t, e, n) {
    "use strict";

    var o = n(2),
      i = n.n(o),
      r = n(3),
      s = n.n(r)()(i.a);
    s.push([t.i, '.ck-media__wrapper .ck-media__placeholder{display:flex;flex-direction:column;align-items:center}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url .ck-tooltip{display:block}@media (hover:none){.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url .ck-tooltip{display:none}}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url{max-width:100%;position:relative}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url:hover .ck-tooltip{visibility:visible;opacity:1}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url .ck-media__placeholder__url__text{overflow:hidden;display:block}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="goo.gl/maps"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="google.com/maps"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="maps.app.goo.gl"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="maps.google.com"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck-media__placeholder__icon *{display:none}.ck-editor__editable:not(.ck-read-only) .ck-media__wrapper>:not(.ck-media__placeholder),.ck-editor__editable:not(.ck-read-only) .ck-widget:not(.ck-widget_selected) .ck-media__placeholder{pointer-events:none}:root{--ck-media-embed-placeholder-icon-size:3em;--ck-color-media-embed-placeholder-url-text:#757575;--ck-color-media-embed-placeholder-url-text-hover:var(--ck-color-base-text)}.ck-media__wrapper{margin:0 auto}.ck-media__wrapper .ck-media__placeholder{padding:calc(var(--ck-spacing-standard)*3);background:var(--ck-color-base-foreground)}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__icon{min-width:var(--ck-media-embed-placeholder-icon-size);height:var(--ck-media-embed-placeholder-icon-size);margin-bottom:var(--ck-spacing-large);background-position:50%;background-size:cover}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__icon .ck-icon{width:100%;height:100%}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url__text{color:var(--ck-color-media-embed-placeholder-url-text);white-space:nowrap;text-align:center;font-style:italic;text-overflow:ellipsis}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url__text:hover{color:var(--ck-color-media-embed-placeholder-url-text-hover);cursor:pointer;text-decoration:underline}.ck-media__wrapper[data-oembed-url*="open.spotify.com"]{max-width:300px;max-height:380px}.ck-media__wrapper[data-oembed-url*="goo.gl/maps"] .ck-media__placeholder__icon,.ck-media__wrapper[data-oembed-url*="google.com/maps"] .ck-media__placeholder__icon,.ck-media__wrapper[data-oembed-url*="maps.app.goo.gl"] .ck-media__placeholder__icon,.ck-media__wrapper[data-oembed-url*="maps.google.com"] .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,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)}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder{background:#4268b3}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAyNCIgaGVpZ2h0PSIxMDI0IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik05NjcuNDg0IDBINTYuNTE3QzI1LjMwNCAwIDAgMjUuMzA0IDAgNTYuNTE3djkxMC45NjZDMCA5OTguNjk0IDI1LjI5NyAxMDI0IDU2LjUyMiAxMDI0SDU0N1Y2MjhINDE0VjQ3M2gxMzNWMzU5LjAyOWMwLTEzMi4yNjIgODAuNzczLTIwNC4yODIgMTk4Ljc1Ni0yMDQuMjgyIDU2LjUxMyAwIDEwNS4wODYgNC4yMDggMTE5LjI0NCA2LjA4OVYyOTlsLTgxLjYxNi4wMzdjLTYzLjk5MyAwLTc2LjM4NCAzMC40OTItNzYuMzg0IDc1LjIzNlY0NzNoMTUzLjQ4N2wtMTkuOTg2IDE1NUg3MDd2Mzk2aDI2MC40ODRjMzEuMjEzIDAgNTYuNTE2LTI1LjMwMyA1Ni41MTYtNTYuNTE2VjU2LjUxNUMxMDI0IDI1LjMwMyA5OTguNjk3IDAgOTY3LjQ4NCAwIiBmaWxsPSIjRkZGRkZFIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=)}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder .ck-media__placeholder__url__text{color:#cdf}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder .ck-media__placeholder__url__text:hover{color:#fff}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder{background:linear-gradient(-135deg,#1400c7,#b800b1,#f50000)}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,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)}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder .ck-media__placeholder__url__text{color:#ffe0fe}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder .ck-media__placeholder__url__text:hover{color:#fff}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder{background:linear-gradient(90deg,#71c6f4,#0d70a5)}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0MDAgNDAwIj48cGF0aCBkPSJNNDAwIDIwMGMwIDExMC41LTg5LjUgMjAwLTIwMCAyMDBTMCAzMTAuNSAwIDIwMCA4OS41IDAgMjAwIDBzMjAwIDg5LjUgMjAwIDIwMHpNMTYzLjQgMzA1LjVjODguNyAwIDEzNy4yLTczLjUgMTM3LjItMTM3LjIgMC0yLjEgMC00LjItLjEtNi4yIDkuNC02LjggMTcuNi0xNS4zIDI0LjEtMjUtOC42IDMuOC0xNy45IDYuNC0yNy43IDcuNiAxMC02IDE3LjYtMTUuNCAyMS4yLTI2LjctOS4zIDUuNS0xOS42IDkuNS0zMC42IDExLjctOC44LTkuNC0yMS4zLTE1LjItMzUuMi0xNS4yLTI2LjYgMC00OC4yIDIxLjYtNDguMiA0OC4yIDAgMy44LjQgNy41IDEuMyAxMS00MC4xLTItNzUuNi0yMS4yLTk5LjQtNTAuNC00LjEgNy4xLTYuNSAxNS40LTYuNSAyNC4yIDAgMTYuNyA4LjUgMzEuNSAyMS41IDQwLjEtNy45LS4yLTE1LjMtMi40LTIxLjgtNnYuNmMwIDIzLjQgMTYuNiA0Mi44IDM4LjcgNDcuMy00IDEuMS04LjMgMS43LTEyLjcgMS43LTMuMSAwLTYuMS0uMy05LjEtLjkgNi4xIDE5LjIgMjMuOSAzMy4xIDQ1IDMzLjUtMTYuNSAxMi45LTM3LjMgMjAuNi01OS45IDIwLjYtMy45IDAtNy43LS4yLTExLjUtLjcgMjEuMSAxMy44IDQ2LjUgMjEuOCA3My43IDIxLjgiIGZpbGw9IiNmZmYiLz48L3N2Zz4=)}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder .ck-media__placeholder__url__text{color:#b8e6ff}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder .ck-media__placeholder__url__text:hover{color:#fff}', "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-media-embed/theme/mediaembedediting.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/tooltip/mixins/_tooltip.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-media-embed/mediaembedediting.css"],
      names: [],
      mappings: "AAQC,0CACC,YAAa,CACb,qBAAsB,CACtB,kBAmBD,CCpBA,kFACC,aAqBD,CAHC,oBAnBD,kFAoBE,YAEF,CADC,CDlBA,sEAIC,cAAe,CAEf,iBAUD,CCoBD,wFACC,kBAAmB,CACnB,SACD,CD3BE,wGACC,eAAgB,CAChB,aACD,CAWD,6kBACC,YACD,CAYF,2LACC,mBACD,CElDA,MACC,0CAA2C,CAE3C,mDAA4D,CAC5D,2EACD,CAEA,mBACC,aA+FD,CA7FC,0CACC,0CAA+C,CAC/C,0CA4BD,CA1BC,uEACC,qDAAsD,CACtD,kDAAmD,CACnD,qCAAsC,CACtC,uBAA2B,CAC3B,qBAMD,CAJC,gFACC,UAAW,CACX,WACD,CAGD,4EACC,sDAAuD,CACvD,kBAAmB,CACnB,iBAAkB,CAClB,iBAAkB,CAClB,sBAOD,CALC,kFACC,4DAA6D,CAC7D,cAAe,CACf,yBACD,CAIF,wDACC,eAAgB,CAChB,gBACD,CAEA,4UAIC,gvGACD,CAEA,2EACC,kBAaD,CAXC,wGACC,orBACD,CAEA,6GACC,UAKD,CAHC,mHACC,UACD,CAIF,4EACC,2DAcD,CAZC,yGACC,4jHACD,CAGA,8GACC,aAKD,CAHC,oHACC,UACD,CAIF,6EAEC,iDAaD,CAXC,0GACC,48BACD,CAEA,+GACC,aAKD,CAHC,qHACC,UACD",
      sourcesContent: ['/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/components/tooltip/mixins/_tooltip.css";\n\n.ck-media__wrapper {\n\t& .ck-media__placeholder {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\n\t\t& .ck-media__placeholder__url {\n\t\t\t@mixin ck-tooltip_enabled;\n\n\t\t\t/* Otherwise the URL will overflow when the content is very narrow. */\n\t\t\tmax-width: 100%;\n\n\t\t\tposition: relative;\n\n\t\t\t&:hover {\n\t\t\t\t@mixin ck-tooltip_visible;\n\t\t\t}\n\n\t\t\t& .ck-media__placeholder__url__text {\n\t\t\t\toverflow: hidden;\n\t\t\t\tdisplay: block;\n\t\t\t}\n\t\t}\n\t}\n\n\t&[data-oembed-url*="twitter.com"],\n\t&[data-oembed-url*="google.com/maps"],\n\t&[data-oembed-url*="goo.gl/maps"],\n\t&[data-oembed-url*="maps.google.com"],\n\t&[data-oembed-url*="maps.app.goo.gl"],\n\t&[data-oembed-url*="facebook.com"],\n\t&[data-oembed-url*="instagram.com"] {\n\t\t& .ck-media__placeholder__icon * {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n\n/* Disable all mouse interaction as long as the editor is not read–only.\n   https://github.com/ckeditor/ckeditor5-media-embed/issues/58 */\n.ck-editor__editable:not(.ck-read-only) .ck-media__wrapper > *:not(.ck-media__placeholder) {\n\tpointer-events: none;\n}\n\n/* Disable all mouse interaction when the widget is not selected (e.g. to avoid opening links by accident).\n   https://github.com/ckeditor/ckeditor5-media-embed/issues/18 */\n.ck-editor__editable:not(.ck-read-only) .ck-widget:not(.ck-widget_selected) .ck-media__placeholder {\n\tpointer-events: none;\n}\n', "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Enables the tooltip, which is the tooltip is in DOM but\n * not yet displayed.\n */\n@define-mixin ck-tooltip_enabled {\n\t& .ck-tooltip {\n\t\tdisplay: block;\n\n\t\t/*\n\t\t * Don't display tooltips in devices which don't support :hover.\n\t\t * In fact, it's all about iOS, which forces user to click UI elements twice to execute\n\t\t * the primary action, when tooltips are enabled.\n\t\t *\n\t\t * Q: OK, but why not the following query?\n\t\t *\n\t\t *   @media (hover) {\n\t\t *       display: block;\n\t\t *   }\n\t\t *\n\t\t * A: Because FF does not support it and it would completely disable tooltips\n\t\t * in that browser.\n\t\t *\n\t\t * More in https://github.com/ckeditor/ckeditor5/issues/920.\n\t\t */\n\t\t@media (hover:none) {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n\n/**\n * Disables the tooltip making it disappear from DOM.\n */\n@define-mixin ck-tooltip_disabled {\n\t& .ck-tooltip {\n\t\tdisplay: none;\n\t}\n}\n\n/**\n * Shows the tooltip, which is already in DOM.\n * Requires `ck-tooltip_enabled` first.\n */\n@define-mixin ck-tooltip_visible {\n\t& .ck-tooltip {\n\t\tvisibility: visible;\n\t\topacity: 1;\n\t}\n}\n", '/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-media-embed-placeholder-icon-size: 3em;\n\n\t--ck-color-media-embed-placeholder-url-text: hsl(0, 0%, 46%);\n\t--ck-color-media-embed-placeholder-url-text-hover: var(--ck-color-base-text);\n}\n\n.ck-media__wrapper {\n\tmargin: 0 auto;\n\n\t& .ck-media__placeholder {\n\t\tpadding: calc( 3 * var(--ck-spacing-standard) );\n\t\tbackground: var(--ck-color-base-foreground);\n\n\t\t& .ck-media__placeholder__icon {\n\t\t\tmin-width: var(--ck-media-embed-placeholder-icon-size);\n\t\t\theight: var(--ck-media-embed-placeholder-icon-size);\n\t\t\tmargin-bottom: var(--ck-spacing-large);\n\t\t\tbackground-position: center;\n\t\t\tbackground-size: cover;\n\n\t\t\t& .ck-icon {\n\t\t\t\twidth: 100%;\n\t\t\t\theight: 100%;\n\t\t\t}\n\t\t}\n\n\t\t& .ck-media__placeholder__url__text {\n\t\t\tcolor: var(--ck-color-media-embed-placeholder-url-text);\n\t\t\twhite-space: nowrap;\n\t\t\ttext-align: center;\n\t\t\tfont-style: italic;\n\t\t\ttext-overflow: ellipsis;\n\n\t\t\t&:hover {\n\t\t\t\tcolor: var(--ck-color-media-embed-placeholder-url-text-hover);\n\t\t\t\tcursor: pointer;\n\t\t\t\ttext-decoration: underline;\n\t\t\t}\n\t\t}\n\t}\n\n\t&[data-oembed-url*="open.spotify.com"] {\n\t\tmax-width: 300px;\n\t\tmax-height: 380px;\n\t}\n\n\t&[data-oembed-url*="google.com/maps"] .ck-media__placeholder__icon,\n\t&[data-oembed-url*="goo.gl/maps"] .ck-media__placeholder__icon,\n\t&[data-oembed-url*="maps.google.com"] .ck-media__placeholder__icon,\n\t&[data-oembed-url*="maps.app.goo.gl"] .ck-media__placeholder__icon {\n\t\tbackground-image: url(data:image/svg+xml;base64,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);\n\t}\n\n\t&[data-oembed-url*="facebook.com"] .ck-media__placeholder {\n\t\tbackground: hsl(220, 46%, 48%);\n\n\t\t& .ck-media__placeholder__icon {\n\t\t\tbackground-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHdpZHRoPSIxMDI0cHgiIGhlaWdodD0iMTAyNHB4IiB2aWV3Qm94PSIwIDAgMTAyNCAxMDI0IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPiAgICAgICAgPHRpdGxlPkZpbGwgMTwvdGl0bGU+ICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPiAgICA8ZGVmcz48L2RlZnM+ICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPiAgICAgICAgPGcgaWQ9ImZMb2dvX1doaXRlIiBmaWxsPSIjRkZGRkZFIj4gICAgICAgICAgICA8cGF0aCBkPSJNOTY3LjQ4NCwwIEw1Ni41MTcsMCBDMjUuMzA0LDAgMCwyNS4zMDQgMCw1Ni41MTcgTDAsOTY3LjQ4MyBDMCw5OTguNjk0IDI1LjI5NywxMDI0IDU2LjUyMiwxMDI0IEw1NDcsMTAyNCBMNTQ3LDYyOCBMNDE0LDYyOCBMNDE0LDQ3MyBMNTQ3LDQ3MyBMNTQ3LDM1OS4wMjkgQzU0NywyMjYuNzY3IDYyNy43NzMsMTU0Ljc0NyA3NDUuNzU2LDE1NC43NDcgQzgwMi4yNjksMTU0Ljc0NyA4NTAuODQyLDE1OC45NTUgODY1LDE2MC44MzYgTDg2NSwyOTkgTDc4My4zODQsMjk5LjAzNyBDNzE5LjM5MSwyOTkuMDM3IDcwNywzMjkuNTI5IDcwNywzNzQuMjczIEw3MDcsNDczIEw4NjAuNDg3LDQ3MyBMODQwLjUwMSw2MjggTDcwNyw2MjggTDcwNywxMDI0IEw5NjcuNDg0LDEwMjQgQzk5OC42OTcsMTAyNCAxMDI0LDk5OC42OTcgMTAyNCw5NjcuNDg0IEwxMDI0LDU2LjUxNSBDMTAyNCwyNS4zMDMgOTk4LjY5NywwIDk2Ny40ODQsMCIgaWQ9IkZpbGwtMSI+PC9wYXRoPiAgICAgICAgPC9nPiAgICA8L2c+PC9zdmc+);\n\t\t}\n\n\t\t& .ck-media__placeholder__url__text {\n\t\t\tcolor: hsl(220, 100%, 90%);\n\n\t\t\t&:hover {\n\t\t\t\tcolor: hsl(0, 0%, 100%);\n\t\t\t}\n\t\t}\n\t}\n\n\t&[data-oembed-url*="instagram.com"] .ck-media__placeholder {\n\t\tbackground: linear-gradient(-135deg,hsl(246, 100%, 39%),hsl(302, 100%, 36%),hsl(0, 100%, 48%));\n\n\t\t& .ck-media__placeholder__icon {\n\t\t\tbackground-image: url(data:image/svg+xml;base64,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);\n\t\t}\n\n\t\t/* stylelint-disable-next-line no-descending-specificity */\n\t\t& .ck-media__placeholder__url__text {\n\t\t\tcolor: hsl(302, 100%, 94%);\n\n\t\t\t&:hover {\n\t\t\t\tcolor: hsl(0, 0%, 100%);\n\t\t\t}\n\t\t}\n\t}\n\n\t&[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder {\n\t\t/* Use gradient to contrast with focused widget (ckeditor/ckeditor5-media-embed#22). */\n\t\tbackground: linear-gradient( to right, hsl(201, 85%, 70%), hsl(201, 85%, 35%) );\n\n\t\t& .ck-media__placeholder__icon {\n\t\t\tbackground-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48c3ZnIHZlcnNpb249IjEuMSIgaWQ9IldoaXRlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDQwMCA0MDAiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDQwMCA0MDA7IiB4bWw6c3BhY2U9InByZXNlcnZlIj48c3R5bGUgdHlwZT0idGV4dC9jc3MiPi5zdDB7ZmlsbDojRkZGRkZGO308L3N0eWxlPjxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik00MDAsMjAwYzAsMTEwLjUtODkuNSwyMDAtMjAwLDIwMFMwLDMxMC41LDAsMjAwUzg5LjUsMCwyMDAsMFM0MDAsODkuNSw0MDAsMjAweiBNMTYzLjQsMzA1LjVjODguNywwLDEzNy4yLTczLjUsMTM3LjItMTM3LjJjMC0yLjEsMC00LjItMC4xLTYuMmM5LjQtNi44LDE3LjYtMTUuMywyNC4xLTI1Yy04LjYsMy44LTE3LjksNi40LTI3LjcsNy42YzEwLTYsMTcuNi0xNS40LDIxLjItMjYuN2MtOS4zLDUuNS0xOS42LDkuNS0zMC42LDExLjdjLTguOC05LjQtMjEuMy0xNS4yLTM1LjItMTUuMmMtMjYuNiwwLTQ4LjIsMjEuNi00OC4yLDQ4LjJjMCwzLjgsMC40LDcuNSwxLjMsMTFjLTQwLjEtMi03NS42LTIxLjItOTkuNC01MC40Yy00LjEsNy4xLTYuNSwxNS40LTYuNSwyNC4yYzAsMTYuNyw4LjUsMzEuNSwyMS41LDQwLjFjLTcuOS0wLjItMTUuMy0yLjQtMjEuOC02YzAsMC4yLDAsMC40LDAsMC42YzAsMjMuNCwxNi42LDQyLjgsMzguNyw0Ny4zYy00LDEuMS04LjMsMS43LTEyLjcsMS43Yy0zLjEsMC02LjEtMC4zLTkuMS0wLjljNi4xLDE5LjIsMjMuOSwzMy4xLDQ1LDMzLjVjLTE2LjUsMTIuOS0zNy4zLDIwLjYtNTkuOSwyMC42Yy0zLjksMC03LjctMC4yLTExLjUtMC43QzExMC44LDI5Ny41LDEzNi4yLDMwNS41LDE2My40LDMwNS41Ii8+PC9zdmc+);\n\t\t}\n\n\t\t& .ck-media__placeholder__url__text {\n\t\t\tcolor: hsl(201, 100%, 86%);\n\n\t\t\t&:hover {\n\t\t\t\tcolor: hsl(0, 0%, 100%);\n\t\t\t}\n\t\t}\n\t}\n}\n'],
      sourceRoot: ""
    }]), e.a = s;
  }, function (t, e, n) {
    "use strict";

    var o = n(2),
      i = n.n(o),
      r = n(3),
      s = n.n(r)()(i.a);
    s.push([t.i, ".ck.ck-media-form{display:flex;align-items:flex-start;flex-direction:row;flex-wrap:nowrap}.ck.ck-media-form .ck-labeled-field-view{display:inline-block}.ck.ck-media-form .ck-label{display:none}@media screen and (max-width:600px){.ck.ck-media-form{flex-wrap:wrap}.ck.ck-media-form .ck-labeled-field-view{flex-basis:100%}.ck.ck-media-form .ck-button{flex-basis:50%}}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-media-embed/theme/mediaform.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css"],
      names: [],
      mappings: "AAOA,kBACC,YAAa,CACb,sBAAuB,CACvB,kBAAmB,CACnB,gBAqBD,CAnBC,yCACC,oBACD,CAEA,4BACC,YACD,CCbA,oCDCD,kBAeE,cAUF,CARE,yCACC,eACD,CAEA,6BACC,cACD,CCtBD",
      sourcesContent: ['/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck.ck-media-form {\n\tdisplay: flex;\n\talign-items: flex-start;\n\tflex-direction: row;\n\tflex-wrap: nowrap;\n\n\t& .ck-labeled-field-view {\n\t\tdisplay: inline-block;\n\t}\n\n\t& .ck-label {\n\t\tdisplay: none;\n\t}\n\n\t@mixin ck-media-phone {\n\t\tflex-wrap: wrap;\n\n\t\t& .ck-labeled-field-view {\n\t\t\tflex-basis: 100%;\n\t\t}\n\n\t\t& .ck-button {\n\t\t\tflex-basis: 50%;\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-phone {\n\t@media screen and (max-width: 600px) {\n\t\t@mixin-content;\n\t}\n}\n"],
      sourceRoot: ""
    }]), e.a = s;
  }, function (t, e, n) {
    "use strict";

    var o = n(2),
      i = n.n(o),
      r = n(3),
      s = n.n(r)()(i.a);
    s.push([t.i, ".ck-content .media{clear:both;margin:.9em 0;display:block;min-width:15em}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-media-embed/theme/mediaembed.css"],
      names: [],
      mappings: "AAKA,mBAGC,UAAW,CAKX,aAAe,CAIf,aAAc,CAId,cACD",
      sourcesContent: ['/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-content .media {\n\t/* Don\'t allow floated content overlap the media.\n\thttps://github.com/ckeditor/ckeditor5-media-embed/issues/53 */\n\tclear: both;\n\n\t/* Make sure there is some space between the content and the media. */\n\t/* The first value should be equal to --ck-spacing-large variable if used in the editor context\n\tto avoid the content jumping (See https://github.com/ckeditor/ckeditor5/issues/9825). */\n\tmargin: 0.9em 0;\n\n\t/* Make sure media is not overriden with Bootstrap default `flex` value.\n\tSee: https://github.com/ckeditor/ckeditor5/issues/1373. */\n\tdisplay: block;\n\n\t/* Give the media some minimal width in the content to prevent them\n\tfrom being "squashed" in tight spaces, e.g. in table cells (#44) */\n\tmin-width: 15em;\n}\n'],
      sourceRoot: ""
    }]), e.a = s;
  }, function (t, e, n) {
    "use strict";

    var o = n(2),
      i = n.n(o),
      r = n(3),
      s = n.n(r)()(i.a);
    s.push([t.i, ":root{--ck-color-table-focused-cell-background:rgba(158,207,250,0.3)}.ck-widget.table td.ck-editor__nested-editable.ck-editor__nested-editable_focused,.ck-widget.table td.ck-editor__nested-editable:focus,.ck-widget.table th.ck-editor__nested-editable.ck-editor__nested-editable_focused,.ck-widget.table th.ck-editor__nested-editable:focus{background:var(--ck-color-table-focused-cell-background);border-style:none;outline:1px solid var(--ck-color-focus-border);outline-offset:-1px}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-table/tableediting.css"],
      names: [],
      mappings: "AAKA,MACC,8DACD,CAKE,8QAGC,wDAAyD,CAKzD,iBAAkB,CAClB,8CAA+C,CAC/C,mBACD",
      sourcesContent: ["/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-table-focused-cell-background: hsla(208, 90%, 80%, .3);\n}\n\n.ck-widget.table {\n\t& td,\n\t& th {\n\t\t&.ck-editor__nested-editable.ck-editor__nested-editable_focused,\n\t\t&.ck-editor__nested-editable:focus {\n\t\t\t/* A very slight background to highlight the focused cell */\n\t\t\tbackground: var(--ck-color-table-focused-cell-background);\n\n\t\t\t/* Fixes the problem where surrounding cells cover the focused cell's border.\n\t\t\tIt does not fix the problem in all places but the UX is improved.\n\t\t\tSee https://github.com/ckeditor/ckeditor5-table/issues/29. */\n\t\t\tborder-style: none;\n\t\t\toutline: 1px solid var(--ck-color-focus-border);\n\t\t\toutline-offset: -1px; /* progressive enhancement - no IE support */\n\t\t}\n\t}\n}\n"],
      sourceRoot: ""
    }]), e.a = s;
  }, function (t, e, n) {
    "use strict";

    var o = n(2),
      i = n.n(o),
      r = n(3),
      s = n.n(r)()(i.a);
    s.push([t.i, ".ck .ck-insert-table-dropdown__grid{display:flex;flex-direction:row;flex-wrap:wrap}:root{--ck-insert-table-dropdown-padding:10px;--ck-insert-table-dropdown-box-height:11px;--ck-insert-table-dropdown-box-width:12px;--ck-insert-table-dropdown-box-margin:1px}.ck .ck-insert-table-dropdown__grid{width:calc(var(--ck-insert-table-dropdown-box-width)*10 + var(--ck-insert-table-dropdown-box-margin)*20 + var(--ck-insert-table-dropdown-padding)*2);padding:var(--ck-insert-table-dropdown-padding) var(--ck-insert-table-dropdown-padding) 0}.ck .ck-insert-table-dropdown__label{text-align:center}.ck .ck-insert-table-dropdown-grid-box{width:var(--ck-insert-table-dropdown-box-width);height:var(--ck-insert-table-dropdown-box-height);margin:var(--ck-insert-table-dropdown-box-margin);border:1px solid var(--ck-color-base-border);border-radius:1px}.ck .ck-insert-table-dropdown-grid-box.ck-on{border-color:var(--ck-color-focus-border);background:var(--ck-color-focus-outer-shadow)}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-table/theme/inserttable.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-table/inserttable.css"],
      names: [],
      mappings: "AAKA,oCACC,YAAa,CACb,kBAAmB,CACnB,cACD,CCJA,MACC,uCAAwC,CACxC,0CAA2C,CAC3C,yCAA0C,CAC1C,yCACD,CAEA,oCAEC,oJAA2J,CAC3J,yFACD,CAEA,qCACC,iBACD,CAEA,uCACC,+CAAgD,CAChD,iDAAkD,CAClD,iDAAkD,CAClD,4CAA6C,CAC7C,iBAMD,CAJC,6CACC,yCAA0C,CAC1C,6CACD",
      sourcesContent: ["/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-insert-table-dropdown__grid {\n\tdisplay: flex;\n\tflex-direction: row;\n\tflex-wrap: wrap;\n}\n", "/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-insert-table-dropdown-padding: 10px;\n\t--ck-insert-table-dropdown-box-height: 11px;\n\t--ck-insert-table-dropdown-box-width: 12px;\n\t--ck-insert-table-dropdown-box-margin: 1px;\n}\n\n.ck .ck-insert-table-dropdown__grid {\n\t/* The width of a container should match 10 items in a row so there will be a 10x10 grid. */\n\twidth: calc(var(--ck-insert-table-dropdown-box-width) * 10 + var(--ck-insert-table-dropdown-box-margin) * 20 + var(--ck-insert-table-dropdown-padding) * 2);\n\tpadding: var(--ck-insert-table-dropdown-padding) var(--ck-insert-table-dropdown-padding) 0;\n}\n\n.ck .ck-insert-table-dropdown__label {\n\ttext-align: center;\n}\n\n.ck .ck-insert-table-dropdown-grid-box {\n\twidth: var(--ck-insert-table-dropdown-box-width);\n\theight: var(--ck-insert-table-dropdown-box-height);\n\tmargin: var(--ck-insert-table-dropdown-box-margin);\n\tborder: 1px solid var(--ck-color-base-border);\n\tborder-radius: 1px;\n\n\t&.ck-on {\n\t\tborder-color: var(--ck-color-focus-border);\n\t\tbackground: var(--ck-color-focus-outer-shadow);\n\t}\n}\n\n"],
      sourceRoot: ""
    }]), e.a = s;
  }, function (t, e, n) {
    "use strict";

    var o = n(2),
      i = n.n(o),
      r = n(3),
      s = n.n(r)()(i.a);
    s.push([t.i, ':root{--ck-table-selected-cell-background:rgba(158,207,250,0.3)}.ck.ck-editor__editable .table table td.ck-editor__editable_selected,.ck.ck-editor__editable .table table th.ck-editor__editable_selected{position:relative;caret-color:transparent;outline:unset;box-shadow:unset}.ck.ck-editor__editable .table table td.ck-editor__editable_selected:after,.ck.ck-editor__editable .table table th.ck-editor__editable_selected:after{content:"";pointer-events:none;background-color:var(--ck-table-selected-cell-background);position:absolute;top:0;left:0;right:0;bottom:0}.ck.ck-editor__editable .table table td.ck-editor__editable_selected ::selection,.ck.ck-editor__editable .table table td.ck-editor__editable_selected:focus,.ck.ck-editor__editable .table table th.ck-editor__editable_selected ::selection,.ck.ck-editor__editable .table table th.ck-editor__editable_selected:focus{background-color:initial}.ck.ck-editor__editable .table table td.ck-editor__editable_selected .ck-widget_selected,.ck.ck-editor__editable .table table th.ck-editor__editable_selected .ck-widget_selected{outline:unset}', "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-table/tableselection.css"],
      names: [],
      mappings: "AAKA,MACC,yDACD,CAGC,0IAEC,iBAAkB,CAClB,uBAAwB,CACxB,aAAc,CACd,gBAsBD,CAnBC,sJACC,UAAW,CACX,mBAAoB,CACpB,yDAA0D,CAC1D,iBAAkB,CAClB,KAAM,CACN,MAAO,CACP,OAAQ,CACR,QACD,CAEA,wTAEC,wBACD,CAEA,kLACC,aACD",
      sourcesContent: ["/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-table-selected-cell-background: hsla(208, 90%, 80%, .3);\n}\n\n.ck.ck-editor__editable .table table {\n\t& td.ck-editor__editable_selected,\n\t& th.ck-editor__editable_selected {\n\t\tposition: relative;\n\t\tcaret-color: transparent;\n\t\toutline: unset;\n\t\tbox-shadow: unset;\n\n\t\t/* https://github.com/ckeditor/ckeditor5/issues/6446 */\n\t\t&:after {\n\t\t\tcontent: '';\n\t\t\tpointer-events: none;\n\t\t\tbackground-color: var(--ck-table-selected-cell-background);\n\t\t\tposition: absolute;\n\t\t\ttop: 0;\n\t\t\tleft: 0;\n\t\t\tright: 0;\n\t\t\tbottom: 0;\n\t\t}\n\n\t\t& ::selection,\n\t\t&:focus {\n\t\t\tbackground-color: transparent;\n\t\t}\n\n\t\t& .ck-widget_selected {\n\t\t\toutline: unset;\n\t\t}\n\t}\n}\n"],
      sourceRoot: ""
    }]), e.a = s;
  }, function (t, e, n) {
    "use strict";

    var o = n(2),
      i = n.n(o),
      r = n(3),
      s = n.n(r)()(i.a);
    s.push([t.i, ".ck-content .table{margin:.9em auto;display:table}.ck-content .table table{border-collapse:collapse;border-spacing:0;width:100%;height:100%;border:1px double #b3b3b3}.ck-content .table table td,.ck-content .table table th{min-width:2em;padding:.4em;border:1px solid #bfbfbf}.ck-content .table table th{font-weight:700;background:hsla(0,0%,0%,5%)}.ck-content[dir=rtl] .table th{text-align:right}.ck-content[dir=ltr] .table th{text-align:left}.ck-editor__editable .ck-table-bogus-paragraph{display:inline-block;width:100%}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-table/theme/table.css"],
      names: [],
      mappings: "AAKA,mBAIC,gBAAkB,CAClB,aAgCD,CA9BC,yBAEC,wBAAyB,CACzB,gBAAiB,CAIjB,UAAW,CACX,WAAY,CAIZ,yBAiBD,CAfC,wDAEC,aAAc,CACd,YAAa,CAKb,wBACD,CAEA,4BACC,eAAiB,CACjB,2BACD,CAMF,+BACC,gBACD,CAEA,+BACC,eACD,CAEA,+CAKC,oBAAqB,CAMrB,UACD",
      sourcesContent: ['/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-content .table {\n\t/* Give the table widget some air and center it horizontally */\n\t/* The first value should be equal to --ck-spacing-large variable if used in the editor context\n\tto avoid the content jumping (See https://github.com/ckeditor/ckeditor5/issues/9825). */\n\tmargin: 0.9em auto;\n\tdisplay: table;\n\n\t& table {\n\t\t/* The table cells should have slight borders */\n\t\tborder-collapse: collapse;\n\t\tborder-spacing: 0;\n\n\t\t/* Table width and height are set on the parent <figure>. Make sure the table inside stretches\n\t\tto the full dimensions of the container (https://github.com/ckeditor/ckeditor5/issues/6186). */\n\t\twidth: 100%;\n\t\theight: 100%;\n\n\t\t/* The outer border of the table should be slightly darker than the inner lines.\n\t\tAlso see https://github.com/ckeditor/ckeditor5-table/issues/50. */\n\t\tborder: 1px double hsl(0, 0%, 70%);\n\n\t\t& td,\n\t\t& th {\n\t\t\tmin-width: 2em;\n\t\t\tpadding: .4em;\n\n\t\t\t/* The border is inherited from .ck-editor__nested-editable styles, so theoretically it\'s not necessary here.\n\t\t\tHowever, the border is a content style, so it should use .ck-content (so it works outside the editor).\n\t\t\tHence, the duplication. See https://github.com/ckeditor/ckeditor5/issues/6314 */\n\t\t\tborder: 1px solid hsl(0, 0%, 75%);\n\t\t}\n\n\t\t& th {\n\t\t\tfont-weight: bold;\n\t\t\tbackground: hsla(0, 0%, 0%, 5%);\n\t\t}\n\t}\n}\n\n/* Text alignment of the table header should match the editor settings and override the native browser styling,\nwhen content is available outside the ediitor. See https://github.com/ckeditor/ckeditor5/issues/6638 */\n.ck-content[dir="rtl"] .table th {\n\ttext-align: right;\n}\n\n.ck-content[dir="ltr"] .table th {\n\ttext-align: left;\n}\n\n.ck-editor__editable .ck-table-bogus-paragraph {\n\t/*\n\t * Use display:inline-block to force Chrome/Safari to limit text mutations to this element.\n\t * See https://github.com/ckeditor/ckeditor5/issues/6062.\n\t */\n\tdisplay: inline-block;\n\n\t/*\n\t * Inline HTML elements nested in the span should always be dimensioned in relation to the whole cell width.\n\t * See https://github.com/ckeditor/ckeditor5/issues/9117.\n\t */\n\twidth: 100%;\n}\n'],
      sourceRoot: ""
    }]), e.a = s;
  }, function (t, e, n) {
    "use strict";

    var o = n(2),
      i = n.n(o),
      r = n(3),
      s = n.n(r)()(i.a);
    s.push([t.i, ".ck-widget.raw-html-embed{margin:.9em auto;position:relative;display:flow-root;min-width:15em;font-style:normal}.ck-widget.raw-html-embed:before{position:absolute;z-index:1}.ck-widget.raw-html-embed .raw-html-embed__buttons-wrapper{position:absolute;display:flex;flex-direction:column}.ck-widget.raw-html-embed .raw-html-embed__preview{position:relative;overflow:hidden;display:flex}.ck-widget.raw-html-embed .raw-html-embed__preview-content{width:100%;position:relative;margin:auto;display:table;border-collapse:initial;border-spacing:7px}.ck-widget.raw-html-embed .raw-html-embed__preview-placeholder{position:absolute;left:0;top:0;right:0;bottom:0;display:flex;align-items:center;justify-content:center}:root{--ck-html-embed-content-width:calc(100% - var(--ck-icon-size)*1.5);--ck-html-embed-source-height:10em;--ck-html-embed-unfocused-outline-width:1px;--ck-html-embed-content-min-height:calc(var(--ck-icon-size) + var(--ck-spacing-standard));--ck-html-embed-source-disabled-background:var(--ck-color-base-foreground);--ck-html-embed-source-disabled-color:hsl(0deg 0% 45%)}.ck-widget.raw-html-embed{font-size:var(--ck-font-size-base);background-color:var(--ck-color-base-foreground)}.ck-widget.raw-html-embed:not(.ck-widget_selected):not(:hover){outline:var(--ck-html-embed-unfocused-outline-width) dashed var(--ck-color-widget-blurred-border)}.ck-widget.raw-html-embed[dir=ltr]{text-align:left}.ck-widget.raw-html-embed[dir=rtl]{text-align:right}.ck-widget.raw-html-embed:before{content:attr(data-html-embed-label);top:calc(var(--ck-html-embed-unfocused-outline-width)*-1);left:var(--ck-spacing-standard);background:hsl(0deg 0% 60%);transition:background var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);padding:calc(var(--ck-spacing-tiny) + var(--ck-html-embed-unfocused-outline-width)) var(--ck-spacing-small) var(--ck-spacing-tiny);border-radius:0 0 var(--ck-border-radius) var(--ck-border-radius);color:var(--ck-color-base-background);font-size:var(--ck-font-size-tiny);font-family:var(--ck-font-face)}.ck-widget.raw-html-embed[dir=rtl]:before{left:auto;right:var(--ck-spacing-standard)}.ck-widget.raw-html-embed[dir=ltr] .ck-widget__type-around .ck-widget__type-around__button.ck-widget__type-around__button_before{margin-left:50px}.ck.ck-editor__editable.ck-blurred .ck-widget.raw-html-embed.ck-widget_selected:before{top:0;padding:var(--ck-spacing-tiny) var(--ck-spacing-small)}.ck.ck-editor__editable:not(.ck-blurred) .ck-widget.raw-html-embed.ck-widget_selected:before{top:0;padding:var(--ck-spacing-tiny) var(--ck-spacing-small);background:var(--ck-color-focus-border)}.ck.ck-editor__editable .ck-widget.raw-html-embed:not(.ck-widget_selected):hover:before{top:0;padding:var(--ck-spacing-tiny) var(--ck-spacing-small)}.ck-widget.raw-html-embed .raw-html-embed__content-wrapper{padding:var(--ck-spacing-standard)}.ck-widget.raw-html-embed .raw-html-embed__buttons-wrapper{top:var(--ck-spacing-standard);right:var(--ck-spacing-standard)}.ck-widget.raw-html-embed .raw-html-embed__buttons-wrapper .ck-button.raw-html-embed__save-button{color:var(--ck-color-button-save)}.ck-widget.raw-html-embed .raw-html-embed__buttons-wrapper .ck-button.raw-html-embed__cancel-button{color:var(--ck-color-button-cancel)}.ck-widget.raw-html-embed .raw-html-embed__buttons-wrapper .ck-button:not(:first-child){margin-top:var(--ck-spacing-small)}.ck-widget.raw-html-embed[dir=rtl] .raw-html-embed__buttons-wrapper{left:var(--ck-spacing-standard);right:auto}.ck-widget.raw-html-embed .raw-html-embed__source{box-sizing:border-box;height:var(--ck-html-embed-source-height);width:var(--ck-html-embed-content-width);resize:none;min-width:0;padding:var(--ck-spacing-standard);font-family:monospace;tab-size:4;white-space:pre-wrap;font-size:var(--ck-font-size-base);text-align:left;direction:ltr}.ck-widget.raw-html-embed .raw-html-embed__source[disabled]{background:var(--ck-html-embed-source-disabled-background);color:var(--ck-html-embed-source-disabled-color);-webkit-text-fill-color:var(--ck-html-embed-source-disabled-color);opacity:1}.ck-widget.raw-html-embed .raw-html-embed__preview{min-height:var(--ck-html-embed-content-min-height);width:var(--ck-html-embed-content-width)}.ck-editor__editable:not(.ck-read-only) .ck-widget.raw-html-embed .raw-html-embed__preview{pointer-events:none}.ck-widget.raw-html-embed .raw-html-embed__preview-content{box-sizing:border-box;text-align:center;background-color:var(--ck-color-base-foreground)}.ck-widget.raw-html-embed .raw-html-embed__preview-content>*{margin-left:auto;margin-right:auto}.ck-widget.raw-html-embed .raw-html-embed__preview-placeholder{color:var(--ck-html-embed-source-disabled-color)}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-html-embed/theme/htmlembed.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-html-embed/htmlembed.css"],
      names: [],
      mappings: "AAMA,0BAIC,gBAAkB,CAClB,iBAAkB,CAClB,iBAAkB,CAIlB,cAAe,CAGf,iBAgDD,CA5CC,iCACC,iBAAkB,CAGlB,SACD,CAKA,2DACC,iBAAkB,CAClB,YAAa,CACb,qBACD,CAEA,mDACC,iBAAkB,CAClB,eAAgB,CAChB,YACD,CAEA,2DACC,UAAW,CACX,iBAAkB,CAClB,WAAY,CAGZ,aAAc,CACd,uBAAyB,CACzB,kBACD,CAEA,+DACC,iBAAkB,CAClB,MAAO,CACP,KAAM,CACN,OAAQ,CACR,QAAS,CAET,YAAa,CACb,kBAAmB,CACnB,sBACD,CC7DD,MACC,kEAAqE,CACrE,kCAAmC,CACnC,2CAA4C,CAC5C,yFAA0F,CAE1F,0EAA2E,CAC3E,sDACD,CAGA,0BACC,kCAAmC,CACnC,gDA0ID,CAxIC,+DACC,iGACD,CAGA,mCACC,eACD,CAEA,mCACC,gBACD,CAIA,iCACC,mCAAoC,CACpC,yDAA4D,CAC5D,+BAAgC,CAChC,2BAA4B,CAC5B,0GAA2G,CAC3G,kIAAmI,CACnI,iEAAkE,CAClE,qCAAsC,CACtC,kCAAmC,CACnC,+BACD,CAEA,0CACC,SAAU,CACV,gCACD,CAGA,iIACC,gBACD,CAxCD,uFA2CE,KAAQ,CACR,sDAgGF,CA5IA,6FAgDE,KAAM,CACN,sDAAuD,CACvD,uCA0FF,CA5IA,wFAsDE,KAAQ,CACR,sDAqFF,CAhFC,2DACC,kCACD,CAGA,2DACC,8BAA+B,CAC/B,gCAaD,CAXC,kGACC,iCACD,CAEA,oGACC,mCACD,CAEA,wFACC,kCACD,CAGD,oEACC,+BAAgC,CAChC,UACD,CAGA,kDACC,qBAAsB,CACtB,yCAA0C,CAC1C,wCAAyC,CACzC,WAAY,CACZ,WAAY,CACZ,kCAAmC,CAEnC,qBAAsB,CACtB,UAAW,CACX,oBAAqB,CACrB,kCAAmC,CAGnC,eAAgB,CAChB,aAUD,CARC,4DACC,0DAA2D,CAC3D,gDAAiD,CAGjD,kEAAmE,CACnE,SACD,CAID,mDACC,kDAAmD,CACnD,wCAMD,CARA,2FAME,mBAEF,CAEA,2DACC,qBAAsB,CACtB,iBAAkB,CAClB,gDAMD,CAJC,6DACC,gBAAiB,CACjB,iBACD,CAGD,+DACC,gDACD",
      sourcesContent: ['/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/* The feature container. */\n.ck-widget.raw-html-embed {\n\t/* Give the embed some air. */\n\t/* The first value should be equal to --ck-spacing-large variable if used in the editor context\n\tto avoid the content jumping (See https://github.com/ckeditor/ckeditor5/issues/9825). */\n\tmargin: 0.9em auto;\n\tposition: relative;\n\tdisplay: flow-root;\n\n\t/* Give the html embed some minimal width in the content to prevent them\n\tfrom being "squashed" in tight spaces, e.g. in table cells (https://github.com/ckeditor/ckeditor5/issues/8331) */\n\tmin-width: 15em;\n\n\t/* Don\'t inherit the style, e.g. when in a block quote. */\n\tfont-style: normal;\n\n\t/* ----- Emebed label in the upper left corner ----------------------------------------------- */\n\n\t&::before {\n\t\tposition: absolute;\n\n\t\t/* Make sure the content does not cover the label. */\n\t\tz-index: 1;\n\t}\n\n\t/* ----- Emebed internals --------------------------------------------------------------------- */\n\n\t/* The switch mode button wrapper. */\n\t& .raw-html-embed__buttons-wrapper {\n\t\tposition: absolute;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t}\n\n\t& .raw-html-embed__preview {\n\t\tposition: relative;\n\t\toverflow: hidden;\n\t\tdisplay: flex;\n\t}\n\n\t& .raw-html-embed__preview-content {\n\t\twidth: 100%;\n\t\tposition: relative;\n\t\tmargin: auto;\n\n\t\t/* Gives spacing to the small renderable elements, so they always cover the placeholder. */\n\t\tdisplay: table;\n\t\tborder-collapse: separate;\n\t\tborder-spacing: 7px;\n\t}\n\n\t& .raw-html-embed__preview-placeholder {\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\ttop: 0;\n\t\tright: 0;\n\t\tbottom: 0;\n\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t}\n}\n', '/*\n * Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-html-embed-content-width: calc(100% - 1.5 * var(--ck-icon-size));\n\t--ck-html-embed-source-height: 10em;\n\t--ck-html-embed-unfocused-outline-width: 1px;\n\t--ck-html-embed-content-min-height: calc(var(--ck-icon-size) + var(--ck-spacing-standard));\n\n\t--ck-html-embed-source-disabled-background: var(--ck-color-base-foreground);\n\t--ck-html-embed-source-disabled-color: hsl(0deg 0% 45%);\n}\n\n/* The feature container. */\n.ck-widget.raw-html-embed {\n\tfont-size: var(--ck-font-size-base);\n\tbackground-color: var(--ck-color-base-foreground);\n\n\t&:not(.ck-widget_selected):not(:hover) {\n\t\toutline: var(--ck-html-embed-unfocused-outline-width) dashed var(--ck-color-widget-blurred-border);\n\t}\n\n\t/* HTML embed widget itself should respect UI language direction */\n\t&[dir="ltr"] {\n\t\ttext-align: left;\n\t}\n\n\t&[dir="rtl"] {\n\t\ttext-align: right;\n\t}\n\n\t/* ----- Embed label in the upper left corner ----------------------------------------------- */\n\n\t&::before {\n\t\tcontent: attr(data-html-embed-label);\n\t\ttop: calc(-1 * var(--ck-html-embed-unfocused-outline-width));\n\t\tleft: var(--ck-spacing-standard);\n\t\tbackground: hsl(0deg 0% 60%);\n\t\ttransition: background var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);\n\t\tpadding: calc(var(--ck-spacing-tiny) + var(--ck-html-embed-unfocused-outline-width)) var(--ck-spacing-small) var(--ck-spacing-tiny);\n\t\tborder-radius: 0 0 var(--ck-border-radius) var(--ck-border-radius);\n\t\tcolor: var(--ck-color-base-background);\n\t\tfont-size: var(--ck-font-size-tiny);\n\t\tfont-family: var(--ck-font-face);\n\t}\n\n\t&[dir="rtl"]::before {\n\t\tleft: auto;\n\t\tright: var(--ck-spacing-standard);\n\t}\n\n\t/* Make space for label but it only collides in LTR languages */\n\t&[dir="ltr"] .ck-widget__type-around .ck-widget__type-around__button.ck-widget__type-around__button_before {\n\t\tmargin-left: 50px;\n\t}\n\n\t@nest .ck.ck-editor__editable.ck-blurred &.ck-widget_selected::before {\n\t\ttop: 0px;\n\t\tpadding: var(--ck-spacing-tiny) var(--ck-spacing-small);\n\t}\n\n\t@nest .ck.ck-editor__editable:not(.ck-blurred) &.ck-widget_selected::before {\n\t\ttop: 0;\n\t\tpadding: var(--ck-spacing-tiny) var(--ck-spacing-small);\n\t\tbackground: var(--ck-color-focus-border);\n\t}\n\n\t@nest .ck.ck-editor__editable &:not(.ck-widget_selected):hover::before {\n\t\ttop: 0px;\n\t\tpadding: var(--ck-spacing-tiny) var(--ck-spacing-small);\n\t}\n\n\t/* ----- Emebed internals --------------------------------------------------------------------- */\n\n\t& .raw-html-embed__content-wrapper {\n\t\tpadding: var(--ck-spacing-standard);\n\t}\n\n\t/* The switch mode button wrapper. */\n\t& .raw-html-embed__buttons-wrapper {\n\t\ttop: var(--ck-spacing-standard);\n\t\tright: var(--ck-spacing-standard);\n\n\t\t& .ck-button.raw-html-embed__save-button {\n\t\t\tcolor: var(--ck-color-button-save);\n\t\t}\n\n\t\t& .ck-button.raw-html-embed__cancel-button {\n\t\t\tcolor: var(--ck-color-button-cancel);\n\t\t}\n\n\t\t& .ck-button:not(:first-child) {\n\t\t\tmargin-top: var(--ck-spacing-small);\n\t\t}\n\t}\n\n\t&[dir="rtl"] .raw-html-embed__buttons-wrapper {\n\t\tleft: var(--ck-spacing-standard);\n\t\tright: auto;\n\t}\n\n\t/* The edit source element. */\n\t& .raw-html-embed__source {\n\t\tbox-sizing: border-box;\n\t\theight: var(--ck-html-embed-source-height);\n\t\twidth: var(--ck-html-embed-content-width);\n\t\tresize: none;\n\t\tmin-width: 0;\n\t\tpadding: var(--ck-spacing-standard);\n\n\t\tfont-family: monospace;\n\t\ttab-size: 4;\n\t\twhite-space: pre-wrap;\n\t\tfont-size: var(--ck-font-size-base); /* Safari needs this. */\n\n\t\t/* HTML code is direction–agnostic. */\n\t\ttext-align: left;\n\t\tdirection: ltr;\n\n\t\t&[disabled] {\n\t\t\tbackground: var(--ck-html-embed-source-disabled-background);\n\t\t\tcolor: var(--ck-html-embed-source-disabled-color);\n\n\t\t\t/* Safari needs this for the proper text color in disabled input (https://github.com/ckeditor/ckeditor5/issues/8320). */\n\t\t\t-webkit-text-fill-color: var(--ck-html-embed-source-disabled-color);\n\t\t\topacity: 1;\n\t\t}\n\t}\n\n\t/* The preview data container. */\n\t& .raw-html-embed__preview {\n\t\tmin-height: var(--ck-html-embed-content-min-height);\n\t\twidth: var(--ck-html-embed-content-width);\n\n\t\t/* Disable all mouse interaction as long as the editor is not read–only. */\n\t\t@nest .ck-editor__editable:not(.ck-read-only) & {\n\t\t\tpointer-events: none;\n\t\t}\n\t}\n\n\t& .raw-html-embed__preview-content {\n\t\tbox-sizing: border-box;\n\t\ttext-align: center;\n\t\tbackground-color: var(--ck-color-base-foreground);\n\n\t\t& > * {\n\t\t\tmargin-left: auto;\n\t\t\tmargin-right: auto;\n\t\t}\n\t}\n\n\t& .raw-html-embed__preview-placeholder {\n\t\tcolor: var(--ck-html-embed-source-disabled-color)\n\t}\n}\n'],
      sourceRoot: ""
    }]), e.a = s;
  }, function (t, e) {
    var n;
    n = function () {
      return this;
    }();
    try {
      n = n || new Function("return this")();
    } catch (t) {
      "object" == typeof window && (n = window);
    }
    t.exports = n;
  }, function (t, e, n) {
    "use strict";

    e.a = function () {
      return !1;
    };
  }, function (t, e, n) {
    "use strict";

    var _marked = /*#__PURE__*/_regeneratorRuntime().mark(Mc),
      _marked2 = /*#__PURE__*/_regeneratorRuntime().mark(Ic),
      _marked3 = /*#__PURE__*/_regeneratorRuntime().mark(Xu);
    n.r(e);
    var o = function o() {
      return function t() {
        t.called = !0;
      };
    };
    var i = function i(t, e) {
      _classCallCheck(this, i);
      this.source = t, this.name = e, this.path = [], this.stop = o(), this.off = o();
    };
    var r = new Array(256).fill().map(function (t, e) {
      return ("0" + e.toString(16)).slice(-2);
    });
    function s() {
      var t = 4294967296 * Math.random() >>> 0,
        e = 4294967296 * Math.random() >>> 0,
        n = 4294967296 * Math.random() >>> 0,
        o = 4294967296 * Math.random() >>> 0;
      return "e" + r[t >> 0 & 255] + r[t >> 8 & 255] + r[t >> 16 & 255] + r[t >> 24 & 255] + r[e >> 0 & 255] + r[e >> 8 & 255] + r[e >> 16 & 255] + r[e >> 24 & 255] + r[n >> 0 & 255] + r[n >> 8 & 255] + r[n >> 16 & 255] + r[n >> 24 & 255] + r[o >> 0 & 255] + r[o >> 8 & 255] + r[o >> 16 & 255] + r[o >> 24 & 255];
    }
    var a = {
        get: function get(t) {
          return "number" != typeof t ? this[t] || this.normal : t;
        },
        highest: 1e5,
        high: 1e3,
        normal: 0,
        low: -1e3,
        lowest: -1e5
      },
      c = (n(8), n(0));
    var l = Symbol("listeningTo"),
      d = Symbol("emitterId");
    var h = {
      on: function on(t, e) {
        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        this.listenTo(this, t, e, n);
      },
      once: function once(t, e, n) {
        var o = !1;
        this.listenTo(this, t, function (t) {
          for (var _len = arguments.length, n = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            n[_key - 1] = arguments[_key];
          }
          o || (o = !0, t.off(), e.call.apply(e, [this, t].concat(n)));
        }, n);
      },
      off: function off(t, e) {
        this.stopListening(this, t, e);
      },
      listenTo: function listenTo(t, e, n) {
        var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var i, r;
        this[l] || (this[l] = {});
        var s = this[l];
        g(t) || u(t);
        var a = g(t);
        (i = s[a]) || (i = s[a] = {
          emitter: t,
          callbacks: {}
        }), (r = i.callbacks[e]) || (r = i.callbacks[e] = []), r.push(n), function (t, e, n, o, i) {
          e._addEventListener ? e._addEventListener(n, o, i) : t._addEventListener.call(e, n, o, i);
        }(this, t, e, n, o);
      },
      stopListening: function stopListening(t, e, n) {
        var o = this[l];
        var i = t && g(t);
        var r = o && i && o[i],
          s = r && e && r.callbacks[e];
        if (!(!o || t && !r || e && !s)) if (n) {
          b(this, t, e, n);
          -1 !== s.indexOf(n) && (1 === s.length ? delete r.callbacks[e] : b(this, t, e, n));
        } else if (s) {
          for (; n = s.pop();) b(this, t, e, n);
          delete r.callbacks[e];
        } else if (r) {
          for (e in r.callbacks) this.stopListening(t, e);
          delete o[i];
        } else {
          for (i in o) this.stopListening(o[i].emitter);
          delete this[l];
        }
      },
      fire: function fire(t) {
        try {
          var _n2 = t instanceof i ? t : new i(this, t),
            _o2 = _n2.name;
          var _r2 = f(this, _o2);
          for (var _len2 = arguments.length, e = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            e[_key2 - 1] = arguments[_key2];
          }
          if (_n2.path.push(this), _r2) {
            var _t2 = [_n2].concat(e);
            _r2 = Array.from(_r2);
            for (var _e3 = 0; _e3 < _r2.length && (_r2[_e3].callback.apply(this, _t2), _n2.off.called && (delete _n2.off.called, this._removeEventListener(_o2, _r2[_e3].callback)), !_n2.stop.called); _e3++);
          }
          if (this._delegations) {
            var _t3 = this._delegations.get(_o2),
              _i2 = this._delegations.get("*");
            _t3 && k(_t3, _n2, e), _i2 && k(_i2, _n2, e);
          }
          return _n2.return;
        } catch (t) {
          c.a.rethrowUnexpectedError(t, this);
        }
      },
      delegate: function delegate() {
        var _this2 = this;
        for (var _len3 = arguments.length, t = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          t[_key3] = arguments[_key3];
        }
        return {
          to: function to(e, n) {
            _this2._delegations || (_this2._delegations = new Map()), t.forEach(function (t) {
              var o = _this2._delegations.get(t);
              o ? o.set(e, n) : _this2._delegations.set(t, new Map([[e, n]]));
            });
          }
        };
      },
      stopDelegating: function stopDelegating(t, e) {
        if (this._delegations) if (t) {
          if (e) {
            var _n3 = this._delegations.get(t);
            _n3 && _n3.delete(e);
          } else this._delegations.delete(t);
        } else this._delegations.clear();
      },
      _addEventListener: function _addEventListener(t, e, n) {
        !function (t, e) {
          var n = m(t);
          if (n[e]) return;
          var o = e,
            i = null;
          var r = [];
          for (; "" !== o && !n[o];) n[o] = {
            callbacks: [],
            childEvents: []
          }, r.push(n[o]), i && n[o].childEvents.push(i), i = o, o = o.substr(0, o.lastIndexOf(":"));
          if ("" !== o) {
            var _iterator = _createForOfIteratorHelper(r),
              _step;
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var _t4 = _step.value;
                _t4.callbacks = n[o].callbacks.slice();
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
            n[o].childEvents.push(i);
          }
        }(this, t);
        var o = p(this, t),
          i = a.get(n.priority),
          r = {
            callback: e,
            priority: i
          };
        var _iterator2 = _createForOfIteratorHelper(o),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _t5 = _step2.value;
            var _e4 = !1;
            for (var _n5 = 0; _n5 < _t5.length; _n5++) if (_t5[_n5].priority < i) {
              _t5.splice(_n5, 0, r), _e4 = !0;
              break;
            }
            _e4 || _t5.push(r);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      },
      _removeEventListener: function _removeEventListener(t, e) {
        var n = p(this, t);
        var _iterator3 = _createForOfIteratorHelper(n),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var _t6 = _step3.value;
            for (var _n7 = 0; _n7 < _t6.length; _n7++) _t6[_n7].callback == e && (_t6.splice(_n7, 1), _n7--);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }
    };
    function u(t, e) {
      t[d] || (t[d] = e || s());
    }
    function g(t) {
      return t[d];
    }
    function m(t) {
      return t._events || Object.defineProperty(t, "_events", {
        value: {}
      }), t._events;
    }
    function p(t, e) {
      var n = m(t)[e];
      if (!n) return [];
      var o = [n.callbacks];
      for (var _e6 = 0; _e6 < n.childEvents.length; _e6++) {
        var _i3 = p(t, n.childEvents[_e6]);
        o = o.concat(_i3);
      }
      return o;
    }
    function f(t, e) {
      var n;
      return t._events && (n = t._events[e]) && n.callbacks.length ? n.callbacks : e.indexOf(":") > -1 ? f(t, e.substr(0, e.lastIndexOf(":"))) : null;
    }
    function k(t, e, n) {
      var _iterator4 = _createForOfIteratorHelper(t),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _step4$value = _slicedToArray(_step4.value, 2),
            _o3 = _step4$value[0],
            _r3 = _step4$value[1];
          _r3 ? "function" == typeof _r3 && (_r3 = _r3(e.name)) : _r3 = e.name;
          var _t7 = new i(e.source, _r3);
          _t7.path = _toConsumableArray(e.path), _o3.fire.apply(_o3, [_t7].concat(_toConsumableArray(n)));
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }
    function b(t, e, n, o) {
      e._removeEventListener ? e._removeEventListener(n, o) : t._removeEventListener.call(e, n, o);
    }
    var w = function w(t) {
        var e = typeof t;
        return null != t && ("object" == e || "function" == e);
      },
      C = n(5),
      A = C.a.Symbol,
      _ = Object.prototype,
      v = _.hasOwnProperty,
      y = _.toString,
      x = A ? A.toStringTag : void 0;
    var E = function E(t) {
        var e = v.call(t, x),
          n = t[x];
        try {
          t[x] = void 0;
          var o = !0;
        } catch (t) {}
        var i = y.call(t);
        return o && (e ? t[x] = n : delete t[x]), i;
      },
      D = Object.prototype.toString;
    var M = function M(t) {
        return D.call(t);
      },
      I = A ? A.toStringTag : void 0;
    var T = function T(t) {
      return null == t ? void 0 === t ? "[object Undefined]" : "[object Null]" : I && I in Object(t) ? E(t) : M(t);
    };
    var S,
      N = function N(t) {
        if (!w(t)) return !1;
        var e = T(t);
        return "[object Function]" == e || "[object GeneratorFunction]" == e || "[object AsyncFunction]" == e || "[object Proxy]" == e;
      },
      B = C.a["__core-js_shared__"],
      P = (S = /[^.]+$/.exec(B && B.keys && B.keys.IE_PROTO || "")) ? "Symbol(src)_1." + S : "";
    var z = function z(t) {
        return !!P && P in t;
      },
      L = Function.prototype.toString;
    var O = function O(t) {
        if (null != t) {
          try {
            return L.call(t);
          } catch (t) {}
          try {
            return t + "";
          } catch (t) {}
        }
        return "";
      },
      R = /^\[object .+?Constructor\]$/,
      j = Function.prototype,
      F = Object.prototype,
      V = j.toString,
      U = F.hasOwnProperty,
      H = RegExp("^" + V.call(U).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
    var G = function G(t) {
      return !(!w(t) || z(t)) && (N(t) ? H : R).test(O(t));
    };
    var W = function W(t, e) {
      return null == t ? void 0 : t[e];
    };
    var q = function q(t, e) {
        var n = W(t, e);
        return G(n) ? n : void 0;
      },
      K = function () {
        try {
          var t = q(Object, "defineProperty");
          return t({}, "", {}), t;
        } catch (t) {}
      }();
    var Y = function Y(t, e, n) {
      "__proto__" == e && K ? K(t, e, {
        configurable: !0,
        enumerable: !0,
        value: n,
        writable: !0
      }) : t[e] = n;
    };
    var Q = function Q(t, e) {
        return t === e || t != t && e != e;
      },
      $ = Object.prototype.hasOwnProperty;
    var J = function J(t, e, n) {
      var o = t[e];
      $.call(t, e) && Q(o, n) && (void 0 !== n || e in t) || Y(t, e, n);
    };
    var Z = function Z(t, e, n, o) {
      var i = !n;
      n || (n = {});
      for (var r = -1, s = e.length; ++r < s;) {
        var a = e[r],
          c = o ? o(n[a], t[a], a, n, t) : void 0;
        void 0 === c && (c = t[a]), i ? Y(n, a, c) : J(n, a, c);
      }
      return n;
    };
    var X = function X(t) {
      return t;
    };
    var tt = function tt(t, e, n) {
        switch (n.length) {
          case 0:
            return t.call(e);
          case 1:
            return t.call(e, n[0]);
          case 2:
            return t.call(e, n[0], n[1]);
          case 3:
            return t.call(e, n[0], n[1], n[2]);
        }
        return t.apply(e, n);
      },
      et = Math.max;
    var nt = function nt(t, e, n) {
      return e = et(void 0 === e ? t.length - 1 : e, 0), function () {
        for (var o = arguments, i = -1, r = et(o.length - e, 0), s = Array(r); ++i < r;) s[i] = o[e + i];
        i = -1;
        for (var a = Array(e + 1); ++i < e;) a[i] = o[i];
        return a[e] = n(s), tt(t, this, a);
      };
    };
    var ot = function ot(t) {
        return function () {
          return t;
        };
      },
      it = K ? function (t, e) {
        return K(t, "toString", {
          configurable: !0,
          enumerable: !1,
          value: ot(e),
          writable: !0
        });
      } : X,
      rt = Date.now;
    var st = function (t) {
      var e = 0,
        n = 0;
      return function () {
        var o = rt(),
          i = 16 - (o - n);
        if (n = o, i > 0) {
          if (++e >= 800) return arguments[0];
        } else e = 0;
        return t.apply(void 0, arguments);
      };
    }(it);
    var at = function at(t, e) {
      return st(nt(t, e, X), t + "");
    };
    var ct = function ct(t) {
      return "number" == typeof t && t > -1 && t % 1 == 0 && t <= 9007199254740991;
    };
    var lt = function lt(t) {
        return null != t && ct(t.length) && !N(t);
      },
      dt = /^(?:0|[1-9]\d*)$/;
    var ht = function ht(t, e) {
      var n = typeof t;
      return !!(e = null == e ? 9007199254740991 : e) && ("number" == n || "symbol" != n && dt.test(t)) && t > -1 && t % 1 == 0 && t < e;
    };
    var ut = function ut(t, e, n) {
      if (!w(n)) return !1;
      var o = typeof e;
      return !!("number" == o ? lt(n) && ht(e, n.length) : "string" == o && e in n) && Q(n[e], t);
    };
    var gt = function gt(t) {
      return at(function (e, n) {
        var o = -1,
          i = n.length,
          r = i > 1 ? n[i - 1] : void 0,
          s = i > 2 ? n[2] : void 0;
        for (r = t.length > 3 && "function" == typeof r ? (i--, r) : void 0, s && ut(n[0], n[1], s) && (r = i < 3 ? void 0 : r, i = 1), e = Object(e); ++o < i;) {
          var a = n[o];
          a && t(e, a, o, r);
        }
        return e;
      });
    };
    var mt = function mt(t, e) {
      for (var n = -1, o = Array(t); ++n < t;) o[n] = e(n);
      return o;
    };
    var pt = function pt(t) {
      return null != t && "object" == typeof t;
    };
    var ft = function ft(t) {
        return pt(t) && "[object Arguments]" == T(t);
      },
      kt = Object.prototype,
      bt = kt.hasOwnProperty,
      wt = kt.propertyIsEnumerable,
      Ct = ft(function () {
        return arguments;
      }()) ? ft : function (t) {
        return pt(t) && bt.call(t, "callee") && !wt.call(t, "callee");
      },
      At = Array.isArray,
      _t = n(6),
      vt = {};
    vt["[object Float32Array]"] = vt["[object Float64Array]"] = vt["[object Int8Array]"] = vt["[object Int16Array]"] = vt["[object Int32Array]"] = vt["[object Uint8Array]"] = vt["[object Uint8ClampedArray]"] = vt["[object Uint16Array]"] = vt["[object Uint32Array]"] = !0, vt["[object Arguments]"] = vt["[object Array]"] = vt["[object ArrayBuffer]"] = vt["[object Boolean]"] = vt["[object DataView]"] = vt["[object Date]"] = vt["[object Error]"] = vt["[object Function]"] = vt["[object Map]"] = vt["[object Number]"] = vt["[object Object]"] = vt["[object RegExp]"] = vt["[object Set]"] = vt["[object String]"] = vt["[object WeakMap]"] = !1;
    var yt = function yt(t) {
      return pt(t) && ct(t.length) && !!vt[T(t)];
    };
    var xt = function xt(t) {
        return function (e) {
          return t(e);
        };
      },
      Et = n(7),
      Dt = Et.a && Et.a.isTypedArray,
      Mt = Dt ? xt(Dt) : yt,
      It = Object.prototype.hasOwnProperty;
    var Tt = function Tt(t, e) {
        var n = At(t),
          o = !n && Ct(t),
          i = !n && !o && Object(_t.a)(t),
          r = !n && !o && !i && Mt(t),
          s = n || o || i || r,
          a = s ? mt(t.length, String) : [],
          c = a.length;
        for (var l in t) !e && !It.call(t, l) || s && ("length" == l || i && ("offset" == l || "parent" == l) || r && ("buffer" == l || "byteLength" == l || "byteOffset" == l) || ht(l, c)) || a.push(l);
        return a;
      },
      St = Object.prototype;
    var Nt = function Nt(t) {
      var e = t && t.constructor;
      return t === ("function" == typeof e && e.prototype || St);
    };
    var Bt = function Bt(t) {
        var e = [];
        if (null != t) for (var n in Object(t)) e.push(n);
        return e;
      },
      Pt = Object.prototype.hasOwnProperty;
    var zt = function zt(t) {
      if (!w(t)) return Bt(t);
      var e = Nt(t),
        n = [];
      for (var o in t) ("constructor" != o || !e && Pt.call(t, o)) && n.push(o);
      return n;
    };
    var Lt = function Lt(t) {
        return lt(t) ? Tt(t, !0) : zt(t);
      },
      Ot = gt(function (t, e) {
        Z(e, Lt(e), t);
      });
    var Rt = Symbol("observableProperties"),
      jt = Symbol("boundObservables"),
      Ft = Symbol("boundProperties"),
      Vt = Symbol("decoratedMethods"),
      Ut = Symbol("decoratedOriginal"),
      Ht = {
        set: function set(t, e) {
          var _this3 = this;
          if (w(t)) return void Object.keys(t).forEach(function (e) {
            _this3.set(e, t[e]);
          }, this);
          Wt(this);
          var n = this[Rt];
          if (t in this && !n.has(t)) throw new c.a("observable-set-cannot-override", this);
          Object.defineProperty(this, t, {
            enumerable: !0,
            configurable: !0,
            get: function get() {
              return n.get(t);
            },
            set: function set(e) {
              var o = n.get(t);
              var i = this.fire("set:" + t, t, e, o);
              void 0 === i && (i = e), o === i && n.has(t) || (n.set(t, i), this.fire("change:" + t, t, i, o));
            }
          }), this[t] = e;
        },
        bind: function bind() {
          var _this4 = this;
          for (var _len4 = arguments.length, t = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
            t[_key4] = arguments[_key4];
          }
          if (!t.length || !Yt(t)) throw new c.a("observable-bind-wrong-properties", this);
          if (new Set(t).size !== t.length) throw new c.a("observable-bind-duplicate-properties", this);
          Wt(this);
          var e = this[Ft];
          t.forEach(function (t) {
            if (e.has(t)) throw new c.a("observable-bind-rebind", _this4);
          });
          var n = new Map();
          return t.forEach(function (t) {
            var o = {
              property: t,
              to: []
            };
            e.set(t, o), n.set(t, o);
          }), {
            to: qt,
            toMany: Kt,
            _observable: this,
            _bindProperties: t,
            _to: [],
            _bindings: n
          };
        },
        unbind: function unbind() {
          var _this5 = this;
          if (!this[Rt]) return;
          var e = this[Ft],
            n = this[jt];
          for (var _len5 = arguments.length, t = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
            t[_key5] = arguments[_key5];
          }
          if (t.length) {
            if (!Yt(t)) throw new c.a("observable-unbind-wrong-properties", this);
            t.forEach(function (t) {
              var o = e.get(t);
              if (!o) return;
              var i, r, s, a;
              o.to.forEach(function (t) {
                i = t[0], r = t[1], s = n.get(i), a = s[r], a.delete(o), a.size || delete s[r], Object.keys(s).length || (n.delete(i), _this5.stopListening(i, "change"));
              }), e.delete(t);
            });
          } else n.forEach(function (t, e) {
            _this5.stopListening(e, "change");
          }), n.clear(), e.clear();
        },
        decorate: function decorate(t) {
          var _this6 = this;
          var e = this[t];
          if (!e) throw new c.a("observablemixin-cannot-decorate-undefined", this, {
            object: this,
            methodName: t
          });
          this.on(t, function (t, n) {
            t.return = e.apply(_this6, n);
          }), this[t] = function () {
            for (var _len6 = arguments.length, e = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
              e[_key6] = arguments[_key6];
            }
            return this.fire(t, e);
          }, this[t][Ut] = e, this[Vt] || (this[Vt] = []), this[Vt].push(t);
        }
      };
    Ot(Ht, h), Ht.stopListening = function (t, e, n) {
      if (!t && this[Vt]) {
        var _iterator5 = _createForOfIteratorHelper(this[Vt]),
          _step5;
        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var _t8 = _step5.value;
            this[_t8] = this[_t8][Ut];
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
        delete this[Vt];
      }
      h.stopListening.call(this, t, e, n);
    };
    var Gt = Ht;
    function Wt(t) {
      t[Rt] || (Object.defineProperty(t, Rt, {
        value: new Map()
      }), Object.defineProperty(t, jt, {
        value: new Map()
      }), Object.defineProperty(t, Ft, {
        value: new Map()
      }));
    }
    function qt() {
      var _this7 = this;
      var e = function () {
          for (var _len7 = arguments.length, t = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
            t[_key7] = arguments[_key7];
          }
          if (!t.length) throw new c.a("observable-bind-to-parse-error", null);
          var e = {
            to: []
          };
          var n;
          "function" == typeof t[t.length - 1] && (e.callback = t.pop());
          return t.forEach(function (t) {
            if ("string" == typeof t) n.properties.push(t);else {
              if ("object" != typeof t) throw new c.a("observable-bind-to-parse-error", null);
              n = {
                observable: t,
                properties: []
              }, e.to.push(n);
            }
          }), e;
        }.apply(void 0, arguments),
        n = Array.from(this._bindings.keys()),
        o = n.length;
      if (!e.callback && e.to.length > 1) throw new c.a("observable-bind-to-no-callback", this);
      if (o > 1 && e.callback) throw new c.a("observable-bind-to-extra-callback", this);
      var i;
      e.to.forEach(function (t) {
        if (t.properties.length && t.properties.length !== o) throw new c.a("observable-bind-to-properties-length", _this7);
        t.properties.length || (t.properties = _this7._bindProperties);
      }), this._to = e.to, e.callback && (this._bindings.get(n[0]).callback = e.callback), i = this._observable, this._to.forEach(function (t) {
        var e = i[jt];
        var n;
        e.get(t.observable) || i.listenTo(t.observable, "change", function (o, r) {
          n = e.get(t.observable)[r], n && n.forEach(function (t) {
            Qt(i, t.property);
          });
        });
      }), function (t) {
        var e;
        t._bindings.forEach(function (n, o) {
          t._to.forEach(function (i) {
            e = i.properties[n.callback ? 0 : t._bindProperties.indexOf(o)], n.to.push([i.observable, e]), function (t, e, n, o) {
              var i = t[jt],
                r = i.get(n),
                s = r || {};
              s[o] || (s[o] = new Set());
              s[o].add(e), r || i.set(n, s);
            }(t._observable, n, i.observable, e);
          });
        });
      }(this), this._bindProperties.forEach(function (t) {
        Qt(_this7._observable, t);
      });
    }
    function Kt(t, e, n) {
      if (this._bindings.size > 1) throw new c.a("observable-bind-to-many-not-one-binding", this);
      this.to.apply(this, _toConsumableArray(function (t, e) {
        var n = t.map(function (t) {
          return [t, e];
        });
        return Array.prototype.concat.apply([], n);
      }(t, e)).concat([n]));
    }
    function Yt(t) {
      return t.every(function (t) {
        return "string" == typeof t;
      });
    }
    function Qt(t, e) {
      var n = t[Ft].get(e);
      var o;
      n.callback ? o = n.callback.apply(t, n.to.map(function (t) {
        return t[0][t[1]];
      })) : (o = n.to[0], o = o[0][o[1]]), Object.prototype.hasOwnProperty.call(t, e) ? t[e] = o : t.set(e, o);
    }
    function $t(t) {
      for (var _len8 = arguments.length, e = new Array(_len8 > 1 ? _len8 - 1 : 0), _key8 = 1; _key8 < _len8; _key8++) {
        e[_key8 - 1] = arguments[_key8];
      }
      e.forEach(function (e) {
        Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e)).forEach(function (n) {
          if (n in t.prototype) return;
          var o = Object.getOwnPropertyDescriptor(e, n);
          o.enumerable = !1, Object.defineProperty(t.prototype, n, o);
        });
      });
    }
    var Jt = /*#__PURE__*/function () {
      function Jt(t) {
        _classCallCheck(this, Jt);
        this.editor = t, this.set("isEnabled", !0), this._disableStack = new Set();
      }
      _createClass(Jt, [{
        key: "forceDisabled",
        value: function forceDisabled(t) {
          this._disableStack.add(t), 1 == this._disableStack.size && (this.on("set:isEnabled", Zt, {
            priority: "highest"
          }), this.isEnabled = !1);
        }
      }, {
        key: "clearForceDisabled",
        value: function clearForceDisabled(t) {
          this._disableStack.delete(t), 0 == this._disableStack.size && (this.off("set:isEnabled", Zt), this.isEnabled = !0);
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.stopListening();
        }
      }], [{
        key: "isContextPlugin",
        get: function get() {
          return !1;
        }
      }]);
      return Jt;
    }();
    function Zt(t) {
      t.return = !1, t.stop();
    }
    $t(Jt, Gt);
    var Xt = /*#__PURE__*/function () {
      function Xt(t) {
        var _this8 = this;
        _classCallCheck(this, Xt);
        this.editor = t, this.set("value", void 0), this.set("isEnabled", !1), this._disableStack = new Set(), this.decorate("execute"), this.listenTo(this.editor.model.document, "change", function () {
          _this8.refresh();
        }), this.on("execute", function (t) {
          _this8.isEnabled || t.stop();
        }, {
          priority: "high"
        }), this.listenTo(t, "change:isReadOnly", function (t, e, n) {
          n ? _this8.forceDisabled("readOnlyMode") : _this8.clearForceDisabled("readOnlyMode");
        });
      }
      _createClass(Xt, [{
        key: "refresh",
        value: function refresh() {
          this.isEnabled = !0;
        }
      }, {
        key: "forceDisabled",
        value: function forceDisabled(t) {
          this._disableStack.add(t), 1 == this._disableStack.size && (this.on("set:isEnabled", te, {
            priority: "highest"
          }), this.isEnabled = !1);
        }
      }, {
        key: "clearForceDisabled",
        value: function clearForceDisabled(t) {
          this._disableStack.delete(t), 0 == this._disableStack.size && (this.off("set:isEnabled", te), this.refresh());
        }
      }, {
        key: "execute",
        value: function execute() {}
      }, {
        key: "destroy",
        value: function destroy() {
          this.stopListening();
        }
      }]);
      return Xt;
    }();
    function te(t) {
      t.return = !1, t.stop();
    }
    $t(Xt, Gt);
    var ee = /*#__PURE__*/function (_Xt) {
      _inherits(ee, _Xt);
      function ee(t) {
        var _this9;
        _classCallCheck(this, ee);
        _this9 = _possibleConstructorReturn(this, _getPrototypeOf(ee).call(this, t)), _this9._childCommands = [];
        return _this9;
      }
      _createClass(ee, [{
        key: "refresh",
        value: function refresh() {}
      }, {
        key: "execute",
        value: function execute() {
          var e = this._getFirstEnabledCommand();
          for (var _len9 = arguments.length, t = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
            t[_key9] = arguments[_key9];
          }
          return null != e && e.execute(t);
        }
      }, {
        key: "registerChildCommand",
        value: function registerChildCommand(t) {
          var _this10 = this;
          this._childCommands.push(t), t.on("change:isEnabled", function () {
            return _this10._checkEnabled();
          }), this._checkEnabled();
        }
      }, {
        key: "_checkEnabled",
        value: function _checkEnabled() {
          this.isEnabled = !!this._getFirstEnabledCommand();
        }
      }, {
        key: "_getFirstEnabledCommand",
        value: function _getFirstEnabledCommand() {
          return this._childCommands.find(function (t) {
            return t.isEnabled;
          });
        }
      }]);
      return ee;
    }(Xt);
    var ne = function ne(t, e) {
        return function (n) {
          return t(e(n));
        };
      },
      oe = ne(Object.getPrototypeOf, Object),
      ie = Function.prototype,
      re = Object.prototype,
      se = ie.toString,
      ae = re.hasOwnProperty,
      ce = se.call(Object);
    var le = function le(t) {
      if (!pt(t) || "[object Object]" != T(t)) return !1;
      var e = oe(t);
      if (null === e) return !0;
      var n = ae.call(e, "constructor") && e.constructor;
      return "function" == typeof n && n instanceof n && se.call(n) == ce;
    };
    var de = function de() {
      this.__data__ = [], this.size = 0;
    };
    var he = function he(t, e) {
        for (var n = t.length; n--;) if (Q(t[n][0], e)) return n;
        return -1;
      },
      ue = Array.prototype.splice;
    var ge = function ge(t) {
      var e = this.__data__,
        n = he(e, t);
      return !(n < 0) && (n == e.length - 1 ? e.pop() : ue.call(e, n, 1), --this.size, !0);
    };
    var me = function me(t) {
      var e = this.__data__,
        n = he(e, t);
      return n < 0 ? void 0 : e[n][1];
    };
    var pe = function pe(t) {
      return he(this.__data__, t) > -1;
    };
    var fe = function fe(t, e) {
      var n = this.__data__,
        o = he(n, t);
      return o < 0 ? (++this.size, n.push([t, e])) : n[o][1] = e, this;
    };
    function ke(t) {
      var e = -1,
        n = null == t ? 0 : t.length;
      for (this.clear(); ++e < n;) {
        var o = t[e];
        this.set(o[0], o[1]);
      }
    }
    ke.prototype.clear = de, ke.prototype.delete = ge, ke.prototype.get = me, ke.prototype.has = pe, ke.prototype.set = fe;
    var be = ke;
    var we = function we() {
      this.__data__ = new be(), this.size = 0;
    };
    var Ce = function Ce(t) {
      var e = this.__data__,
        n = e.delete(t);
      return this.size = e.size, n;
    };
    var Ae = function Ae(t) {
      return this.__data__.get(t);
    };
    var _e = function _e(t) {
        return this.__data__.has(t);
      },
      ve = q(C.a, "Map"),
      ye = q(Object, "create");
    var xe = function xe() {
      this.__data__ = ye ? ye(null) : {}, this.size = 0;
    };
    var Ee = function Ee(t) {
        var e = this.has(t) && delete this.__data__[t];
        return this.size -= e ? 1 : 0, e;
      },
      De = Object.prototype.hasOwnProperty;
    var Me = function Me(t) {
        var e = this.__data__;
        if (ye) {
          var n = e[t];
          return "__lodash_hash_undefined__" === n ? void 0 : n;
        }
        return De.call(e, t) ? e[t] : void 0;
      },
      Ie = Object.prototype.hasOwnProperty;
    var Te = function Te(t) {
      var e = this.__data__;
      return ye ? void 0 !== e[t] : Ie.call(e, t);
    };
    var Se = function Se(t, e) {
      var n = this.__data__;
      return this.size += this.has(t) ? 0 : 1, n[t] = ye && void 0 === e ? "__lodash_hash_undefined__" : e, this;
    };
    function Ne(t) {
      var e = -1,
        n = null == t ? 0 : t.length;
      for (this.clear(); ++e < n;) {
        var o = t[e];
        this.set(o[0], o[1]);
      }
    }
    Ne.prototype.clear = xe, Ne.prototype.delete = Ee, Ne.prototype.get = Me, Ne.prototype.has = Te, Ne.prototype.set = Se;
    var Be = Ne;
    var Pe = function Pe() {
      this.size = 0, this.__data__ = {
        hash: new Be(),
        map: new (ve || be)(),
        string: new Be()
      };
    };
    var ze = function ze(t) {
      var e = typeof t;
      return "string" == e || "number" == e || "symbol" == e || "boolean" == e ? "__proto__" !== t : null === t;
    };
    var Le = function Le(t, e) {
      var n = t.__data__;
      return ze(e) ? n["string" == typeof e ? "string" : "hash"] : n.map;
    };
    var Oe = function Oe(t) {
      var e = Le(this, t).delete(t);
      return this.size -= e ? 1 : 0, e;
    };
    var Re = function Re(t) {
      return Le(this, t).get(t);
    };
    var je = function je(t) {
      return Le(this, t).has(t);
    };
    var Fe = function Fe(t, e) {
      var n = Le(this, t),
        o = n.size;
      return n.set(t, e), this.size += n.size == o ? 0 : 1, this;
    };
    function Ve(t) {
      var e = -1,
        n = null == t ? 0 : t.length;
      for (this.clear(); ++e < n;) {
        var o = t[e];
        this.set(o[0], o[1]);
      }
    }
    Ve.prototype.clear = Pe, Ve.prototype.delete = Oe, Ve.prototype.get = Re, Ve.prototype.has = je, Ve.prototype.set = Fe;
    var Ue = Ve;
    var He = function He(t, e) {
      var n = this.__data__;
      if (n instanceof be) {
        var o = n.__data__;
        if (!ve || o.length < 199) return o.push([t, e]), this.size = ++n.size, this;
        n = this.__data__ = new Ue(o);
      }
      return n.set(t, e), this.size = n.size, this;
    };
    function Ge(t) {
      var e = this.__data__ = new be(t);
      this.size = e.size;
    }
    Ge.prototype.clear = we, Ge.prototype.delete = Ce, Ge.prototype.get = Ae, Ge.prototype.has = _e, Ge.prototype.set = He;
    var We = Ge;
    var qe = function qe(t, e) {
        for (var n = -1, o = null == t ? 0 : t.length; ++n < o && !1 !== e(t[n], n, t););
        return t;
      },
      Ke = ne(Object.keys, Object),
      Ye = Object.prototype.hasOwnProperty;
    var Qe = function Qe(t) {
      if (!Nt(t)) return Ke(t);
      var e = [];
      for (var n in Object(t)) Ye.call(t, n) && "constructor" != n && e.push(n);
      return e;
    };
    var $e = function $e(t) {
      return lt(t) ? Tt(t) : Qe(t);
    };
    var Je = function Je(t, e) {
      return t && Z(e, $e(e), t);
    };
    var Ze = function Ze(t, e) {
        return t && Z(e, Lt(e), t);
      },
      Xe = n(10);
    var tn = function tn(t, e) {
      var n = -1,
        o = t.length;
      for (e || (e = Array(o)); ++n < o;) e[n] = t[n];
      return e;
    };
    var en = function en(t, e) {
      for (var n = -1, o = null == t ? 0 : t.length, i = 0, r = []; ++n < o;) {
        var s = t[n];
        e(s, n, t) && (r[i++] = s);
      }
      return r;
    };
    var nn = function nn() {
        return [];
      },
      on = Object.prototype.propertyIsEnumerable,
      rn = Object.getOwnPropertySymbols,
      sn = rn ? function (t) {
        return null == t ? [] : (t = Object(t), en(rn(t), function (e) {
          return on.call(t, e);
        }));
      } : nn;
    var an = function an(t, e) {
      return Z(t, sn(t), e);
    };
    var cn = function cn(t, e) {
        for (var n = -1, o = e.length, i = t.length; ++n < o;) t[i + n] = e[n];
        return t;
      },
      ln = Object.getOwnPropertySymbols ? function (t) {
        for (var e = []; t;) cn(e, sn(t)), t = oe(t);
        return e;
      } : nn;
    var dn = function dn(t, e) {
      return Z(t, ln(t), e);
    };
    var hn = function hn(t, e, n) {
      var o = e(t);
      return At(t) ? o : cn(o, n(t));
    };
    var un = function un(t) {
      return hn(t, $e, sn);
    };
    var gn = function gn(t) {
        return hn(t, Lt, ln);
      },
      mn = q(C.a, "DataView"),
      pn = q(C.a, "Promise"),
      fn = q(C.a, "Set"),
      kn = q(C.a, "WeakMap"),
      bn = "[object Map]",
      wn = "[object Promise]",
      Cn = "[object Set]",
      An = "[object WeakMap]",
      _n = "[object DataView]",
      vn = O(mn),
      yn = O(ve),
      xn = O(pn),
      En = O(fn),
      Dn = O(kn),
      Mn = T;
    (mn && Mn(new mn(new ArrayBuffer(1))) != _n || ve && Mn(new ve()) != bn || pn && Mn(pn.resolve()) != wn || fn && Mn(new fn()) != Cn || kn && Mn(new kn()) != An) && (Mn = function Mn(t) {
      var e = T(t),
        n = "[object Object]" == e ? t.constructor : void 0,
        o = n ? O(n) : "";
      if (o) switch (o) {
        case vn:
          return _n;
        case yn:
          return bn;
        case xn:
          return wn;
        case En:
          return Cn;
        case Dn:
          return An;
      }
      return e;
    });
    var In = Mn,
      Tn = Object.prototype.hasOwnProperty;
    var Sn = function Sn(t) {
        var e = t.length,
          n = new t.constructor(e);
        return e && "string" == typeof t[0] && Tn.call(t, "index") && (n.index = t.index, n.input = t.input), n;
      },
      Nn = C.a.Uint8Array;
    var Bn = function Bn(t) {
      var e = new t.constructor(t.byteLength);
      return new Nn(e).set(new Nn(t)), e;
    };
    var Pn = function Pn(t, e) {
        var n = e ? Bn(t.buffer) : t.buffer;
        return new t.constructor(n, t.byteOffset, t.byteLength);
      },
      zn = /\w*$/;
    var Ln = function Ln(t) {
        var e = new t.constructor(t.source, zn.exec(t));
        return e.lastIndex = t.lastIndex, e;
      },
      On = A ? A.prototype : void 0,
      Rn = On ? On.valueOf : void 0;
    var jn = function jn(t) {
      return Rn ? Object(Rn.call(t)) : {};
    };
    var Fn = function Fn(t, e) {
      var n = e ? Bn(t.buffer) : t.buffer;
      return new t.constructor(n, t.byteOffset, t.length);
    };
    var Vn = function Vn(t, e, n) {
        var o = t.constructor;
        switch (e) {
          case "[object ArrayBuffer]":
            return Bn(t);
          case "[object Boolean]":
          case "[object Date]":
            return new o(+t);
          case "[object DataView]":
            return Pn(t, n);
          case "[object Float32Array]":
          case "[object Float64Array]":
          case "[object Int8Array]":
          case "[object Int16Array]":
          case "[object Int32Array]":
          case "[object Uint8Array]":
          case "[object Uint8ClampedArray]":
          case "[object Uint16Array]":
          case "[object Uint32Array]":
            return Fn(t, n);
          case "[object Map]":
            return new o();
          case "[object Number]":
          case "[object String]":
            return new o(t);
          case "[object RegExp]":
            return Ln(t);
          case "[object Set]":
            return new o();
          case "[object Symbol]":
            return jn(t);
        }
      },
      Un = Object.create,
      Hn = function () {
        function t() {}
        return function (e) {
          if (!w(e)) return {};
          if (Un) return Un(e);
          t.prototype = e;
          var n = new t();
          return t.prototype = void 0, n;
        };
      }();
    var Gn = function Gn(t) {
      return "function" != typeof t.constructor || Nt(t) ? {} : Hn(oe(t));
    };
    var Wn = function Wn(t) {
        return pt(t) && "[object Map]" == In(t);
      },
      qn = Et.a && Et.a.isMap,
      Kn = qn ? xt(qn) : Wn;
    var Yn = function Yn(t) {
        return pt(t) && "[object Set]" == In(t);
      },
      Qn = Et.a && Et.a.isSet,
      $n = Qn ? xt(Qn) : Yn,
      Jn = "[object Arguments]",
      Zn = "[object Function]",
      Xn = "[object Object]",
      to = {};
    to[Jn] = to["[object Array]"] = to["[object ArrayBuffer]"] = to["[object DataView]"] = to["[object Boolean]"] = to["[object Date]"] = to["[object Float32Array]"] = to["[object Float64Array]"] = to["[object Int8Array]"] = to["[object Int16Array]"] = to["[object Int32Array]"] = to["[object Map]"] = to["[object Number]"] = to["[object Object]"] = to["[object RegExp]"] = to["[object Set]"] = to["[object String]"] = to["[object Symbol]"] = to["[object Uint8Array]"] = to["[object Uint8ClampedArray]"] = to["[object Uint16Array]"] = to["[object Uint32Array]"] = !0, to["[object Error]"] = to[Zn] = to["[object WeakMap]"] = !1;
    var eo = function t(e, n, o, i, r, s) {
      var a,
        c = 1 & n,
        l = 2 & n,
        d = 4 & n;
      if (o && (a = r ? o(e, i, r, s) : o(e)), void 0 !== a) return a;
      if (!w(e)) return e;
      var h = At(e);
      if (h) {
        if (a = Sn(e), !c) return tn(e, a);
      } else {
        var u = In(e),
          g = u == Zn || "[object GeneratorFunction]" == u;
        if (Object(_t.a)(e)) return Object(Xe.a)(e, c);
        if (u == Xn || u == Jn || g && !r) {
          if (a = l || g ? {} : Gn(e), !c) return l ? dn(e, Ze(a, e)) : an(e, Je(a, e));
        } else {
          if (!to[u]) return r ? e : {};
          a = Vn(e, u, c);
        }
      }
      s || (s = new We());
      var m = s.get(e);
      if (m) return m;
      s.set(e, a), $n(e) ? e.forEach(function (i) {
        a.add(t(i, n, o, i, e, s));
      }) : Kn(e) && e.forEach(function (i, r) {
        a.set(r, t(i, n, o, r, e, s));
      });
      var p = h ? void 0 : (d ? l ? gn : un : l ? Lt : $e)(e);
      return qe(p || e, function (i, r) {
        p && (i = e[r = i]), J(a, r, t(i, n, o, r, e, s));
      }), a;
    };
    var no = function no(t, e) {
      return eo(t, 5, e = "function" == typeof e ? e : void 0);
    };
    var oo = function oo(t) {
      return pt(t) && 1 === t.nodeType && !le(t);
    };
    var io = /*#__PURE__*/function () {
      function io(t, e) {
        _classCallCheck(this, io);
        this._config = {}, e && this.define(ro(e)), t && this._setObjectToTarget(this._config, t);
      }
      _createClass(io, [{
        key: "set",
        value: function set(t, e) {
          this._setToTarget(this._config, t, e);
        }
      }, {
        key: "define",
        value: function define(t, e) {
          this._setToTarget(this._config, t, e, !0);
        }
      }, {
        key: "get",
        value: function get(t) {
          return this._getFromSource(this._config, t);
        }
      }, {
        key: "names",
        value: /*#__PURE__*/_regeneratorRuntime().mark(function names() {
          var _i4, _Object$keys, _t9;
          return _regeneratorRuntime().wrap(function names$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _i4 = 0, _Object$keys = Object.keys(this._config);
              case 1:
                if (!(_i4 < _Object$keys.length)) {
                  _context.next = 8;
                  break;
                }
                _t9 = _Object$keys[_i4];
                _context.next = 5;
                return _t9;
              case 5:
                _i4++;
                _context.next = 1;
                break;
              case 8:
              case "end":
                return _context.stop();
            }
          }, names, this);
        })
      }, {
        key: "_setToTarget",
        value: function _setToTarget(t, e, n) {
          var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
          if (le(e)) return void this._setObjectToTarget(t, e, o);
          var i = e.split(".");
          e = i.pop();
          var _iterator6 = _createForOfIteratorHelper(i),
            _step6;
          try {
            for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
              var _e7 = _step6.value;
              le(t[_e7]) || (t[_e7] = {}), t = t[_e7];
            }
          } catch (err) {
            _iterator6.e(err);
          } finally {
            _iterator6.f();
          }
          if (le(n)) return le(t[e]) || (t[e] = {}), t = t[e], void this._setObjectToTarget(t, n, o);
          o && void 0 !== t[e] || (t[e] = n);
        }
      }, {
        key: "_getFromSource",
        value: function _getFromSource(t, e) {
          var n = e.split(".");
          e = n.pop();
          var _iterator7 = _createForOfIteratorHelper(n),
            _step7;
          try {
            for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
              var _e8 = _step7.value;
              if (!le(t[_e8])) {
                t = null;
                break;
              }
              t = t[_e8];
            }
          } catch (err) {
            _iterator7.e(err);
          } finally {
            _iterator7.f();
          }
          return t ? ro(t[e]) : void 0;
        }
      }, {
        key: "_setObjectToTarget",
        value: function _setObjectToTarget(t, e, n) {
          var _this11 = this;
          Object.keys(e).forEach(function (o) {
            _this11._setToTarget(t, o, e[o], n);
          });
        }
      }]);
      return io;
    }();
    function ro(t) {
      return no(t, so);
    }
    function so(t) {
      return oo(t) ? t : void 0;
    }
    function ao(t) {
      return !(!t || !t[Symbol.iterator]);
    }
    var co = /*#__PURE__*/function () {
      function co() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        _classCallCheck(this, co);
        var n = ao(t);
        if (n || (e = t), this._items = [], this._itemMap = new Map(), this._idProperty = e.idProperty || "id", this._bindToExternalToInternalMap = new WeakMap(), this._bindToInternalToExternalMap = new WeakMap(), this._skippedIndexesFromExternal = [], n) {
          var _iterator8 = _createForOfIteratorHelper(t),
            _step8;
          try {
            for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
              var _e9 = _step8.value;
              this._items.push(_e9), this._itemMap.set(this._getItemIdBeforeAdding(_e9), _e9);
            }
          } catch (err) {
            _iterator8.e(err);
          } finally {
            _iterator8.f();
          }
        }
      }
      _createClass(co, [{
        key: "add",
        value: function add(t, e) {
          return this.addMany([t], e);
        }
      }, {
        key: "addMany",
        value: function addMany(t, e) {
          if (void 0 === e) e = this._items.length;else if (e > this._items.length || e < 0) throw new c.a("collection-add-item-invalid-index", this);
          for (var _n9 = 0; _n9 < t.length; _n9++) {
            var _o4 = t[_n9],
              _i5 = this._getItemIdBeforeAdding(_o4),
              _r4 = e + _n9;
            this._items.splice(_r4, 0, _o4), this._itemMap.set(_i5, _o4), this.fire("add", _o4, _r4);
          }
          return this.fire("change", {
            added: t,
            removed: [],
            index: e
          }), this;
        }
      }, {
        key: "get",
        value: function get(t) {
          var e;
          if ("string" == typeof t) e = this._itemMap.get(t);else {
            if ("number" != typeof t) throw new c.a("collection-get-invalid-arg", this);
            e = this._items[t];
          }
          return e || null;
        }
      }, {
        key: "has",
        value: function has(t) {
          if ("string" == typeof t) return this._itemMap.has(t);
          {
            var _e10 = t[this._idProperty];
            return this._itemMap.has(_e10);
          }
        }
      }, {
        key: "getIndex",
        value: function getIndex(t) {
          var e;
          return e = "string" == typeof t ? this._itemMap.get(t) : t, this._items.indexOf(e);
        }
      }, {
        key: "remove",
        value: function remove(t) {
          var _this$_remove = this._remove(t),
            _this$_remove2 = _slicedToArray(_this$_remove, 2),
            e = _this$_remove2[0],
            n = _this$_remove2[1];
          return this.fire("change", {
            added: [],
            removed: [e],
            index: n
          }), e;
        }
      }, {
        key: "map",
        value: function map(t, e) {
          return this._items.map(t, e);
        }
      }, {
        key: "find",
        value: function find(t, e) {
          return this._items.find(t, e);
        }
      }, {
        key: "filter",
        value: function filter(t, e) {
          return this._items.filter(t, e);
        }
      }, {
        key: "clear",
        value: function clear() {
          this._bindToCollection && (this.stopListening(this._bindToCollection), this._bindToCollection = null);
          var t = Array.from(this._items);
          for (; this.length;) this._remove(0);
          this.fire("change", {
            added: [],
            removed: t,
            index: 0
          });
        }
      }, {
        key: "bindTo",
        value: function bindTo(t) {
          var _this12 = this;
          if (this._bindToCollection) throw new c.a("collection-bind-to-rebind", this);
          return this._bindToCollection = t, {
            as: function as(t) {
              _this12._setUpBindToBinding(function (e) {
                return new t(e);
              });
            },
            using: function using(t) {
              "function" == typeof t ? _this12._setUpBindToBinding(function (e) {
                return t(e);
              }) : _this12._setUpBindToBinding(function (e) {
                return e[t];
              });
            }
          };
        }
      }, {
        key: "_setUpBindToBinding",
        value: function _setUpBindToBinding(t) {
          var _this13 = this;
          var e = this._bindToCollection,
            n = function n(_n11, o, i) {
              var r = e._bindToCollection == _this13,
                s = e._bindToInternalToExternalMap.get(o);
              if (r && s) _this13._bindToExternalToInternalMap.set(o, s), _this13._bindToInternalToExternalMap.set(s, o);else {
                var _n10 = t(o);
                if (!_n10) return void _this13._skippedIndexesFromExternal.push(i);
                var _r5 = i;
                var _iterator9 = _createForOfIteratorHelper(_this13._skippedIndexesFromExternal),
                  _step9;
                try {
                  for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
                    var _t12 = _step9.value;
                    i > _t12 && _r5--;
                  }
                } catch (err) {
                  _iterator9.e(err);
                } finally {
                  _iterator9.f();
                }
                var _iterator10 = _createForOfIteratorHelper(e._skippedIndexesFromExternal),
                  _step10;
                try {
                  for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
                    var _t13 = _step10.value;
                    _r5 >= _t13 && _r5++;
                  }
                } catch (err) {
                  _iterator10.e(err);
                } finally {
                  _iterator10.f();
                }
                _this13._bindToExternalToInternalMap.set(o, _n10), _this13._bindToInternalToExternalMap.set(_n10, o), _this13.add(_n10, _r5);
                for (var _t11 = 0; _t11 < e._skippedIndexesFromExternal.length; _t11++) _r5 <= e._skippedIndexesFromExternal[_t11] && e._skippedIndexesFromExternal[_t11]++;
              }
            };
          var _iterator11 = _createForOfIteratorHelper(e),
            _step11;
          try {
            for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
              var _t14 = _step11.value;
              n(0, _t14, e.getIndex(_t14));
            }
          } catch (err) {
            _iterator11.e(err);
          } finally {
            _iterator11.f();
          }
          this.listenTo(e, "add", n), this.listenTo(e, "remove", function (t, e, n) {
            var o = _this13._bindToExternalToInternalMap.get(e);
            o && _this13.remove(o), _this13._skippedIndexesFromExternal = _this13._skippedIndexesFromExternal.reduce(function (t, e) {
              return n < e && t.push(e - 1), n > e && t.push(e), t;
            }, []);
          });
        }
      }, {
        key: "_getItemIdBeforeAdding",
        value: function _getItemIdBeforeAdding(t) {
          var e = this._idProperty;
          var n;
          if (e in t) {
            if (n = t[e], "string" != typeof n) throw new c.a("collection-add-invalid-id", this);
            if (this.get(n)) throw new c.a("collection-add-item-already-exists", this);
          } else t[e] = n = s();
          return n;
        }
      }, {
        key: "_remove",
        value: function _remove(t) {
          var e,
            n,
            o,
            i = !1;
          var r = this._idProperty;
          if ("string" == typeof t ? (n = t, o = this._itemMap.get(n), i = !o, o && (e = this._items.indexOf(o))) : "number" == typeof t ? (e = t, o = this._items[e], i = !o, o && (n = o[r])) : (o = t, n = o[r], e = this._items.indexOf(o), i = -1 == e || !this._itemMap.get(n)), i) throw new c.a("collection-remove-404", this);
          this._items.splice(e, 1), this._itemMap.delete(n);
          var s = this._bindToInternalToExternalMap.get(o);
          return this._bindToInternalToExternalMap.delete(o), this._bindToExternalToInternalMap.delete(s), this.fire("remove", o, e), [o, e];
        }
      }, {
        key: Symbol.iterator,
        value: function value() {
          return this._items[Symbol.iterator]();
        }
      }, {
        key: "length",
        get: function get() {
          return this._items.length;
        }
      }, {
        key: "first",
        get: function get() {
          return this._items[0] || null;
        }
      }, {
        key: "last",
        get: function get() {
          return this._items[this.length - 1] || null;
        }
      }]);
      return co;
    }();
    $t(co, h);
    var lo = /*#__PURE__*/function () {
      function lo(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
        _classCallCheck(this, lo);
        this._context = t, this._plugins = new Map(), this._availablePlugins = new Map();
        var _iterator12 = _createForOfIteratorHelper(e),
          _step12;
        try {
          for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
            var _t15 = _step12.value;
            _t15.pluginName && this._availablePlugins.set(_t15.pluginName, _t15);
          }
        } catch (err) {
          _iterator12.e(err);
        } finally {
          _iterator12.f();
        }
        this._contextPlugins = new Map();
        var _iterator13 = _createForOfIteratorHelper(n),
          _step13;
        try {
          for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
            var _step13$value = _slicedToArray(_step13.value, 2),
              _t16 = _step13$value[0],
              _e11 = _step13$value[1];
            this._contextPlugins.set(_t16, _e11), this._contextPlugins.set(_e11, _t16), _t16.pluginName && this._availablePlugins.set(_t16.pluginName, _t16);
          }
        } catch (err) {
          _iterator13.e(err);
        } finally {
          _iterator13.f();
        }
      }
      _createClass(lo, [{
        key: Symbol.iterator,
        value: /*#__PURE__*/_regeneratorRuntime().mark(function value() {
          var _iterator14, _step14, _t17;
          return _regeneratorRuntime().wrap(function value$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _iterator14 = _createForOfIteratorHelper(this._plugins);
                _context2.prev = 1;
                _iterator14.s();
              case 3:
                if ((_step14 = _iterator14.n()).done) {
                  _context2.next = 11;
                  break;
                }
                _t17 = _step14.value;
                _context2.t0 = "function" == typeof _t17[0];
                if (!_context2.t0) {
                  _context2.next = 9;
                  break;
                }
                _context2.next = 9;
                return _t17;
              case 9:
                _context2.next = 3;
                break;
              case 11:
                _context2.next = 16;
                break;
              case 13:
                _context2.prev = 13;
                _context2.t1 = _context2["catch"](1);
                _iterator14.e(_context2.t1);
              case 16:
                _context2.prev = 16;
                _iterator14.f();
                return _context2.finish(16);
              case 19:
              case "end":
                return _context2.stop();
            }
          }, value, this, [[1, 13, 16, 19]]);
        })
      }, {
        key: "get",
        value: function get(t) {
          var e = this._plugins.get(t);
          if (!e) {
            var _e12 = t;
            throw "function" == typeof t && (_e12 = t.pluginName || t.name), new c.a("plugincollection-plugin-not-loaded", this._context, {
              plugin: _e12
            });
          }
          return e;
        }
      }, {
        key: "has",
        value: function has(t) {
          return this._plugins.has(t);
        }
      }, {
        key: "init",
        value: function init(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
          var o = this,
            i = this._context;
          !function t(e) {
            var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Set();
            e.forEach(function (e) {
              a(e) && (n.has(e) || (n.add(e), e.pluginName && !o._availablePlugins.has(e.pluginName) && o._availablePlugins.set(e.pluginName, e), e.requires && t(e.requires, n)));
            });
          }(t), u(t);
          var r = _toConsumableArray(function t(e) {
            var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Set();
            return e.map(function (t) {
              return a(t) ? t : o._availablePlugins.get(t);
            }).reduce(function (e, o) {
              return n.has(o) ? e : (n.add(o), o.requires && (u(o.requires, o), t(o.requires, n).forEach(function (t) {
                return e.add(t);
              })), e.add(o));
            }, new Set());
          }(t.filter(function (t) {
            return !d(t, e);
          })));
          !function (t, e) {
            var _iterator15 = _createForOfIteratorHelper(e),
              _step15;
            try {
              for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
                var _n12 = _step15.value;
                if ("function" != typeof _n12) throw new c.a("plugincollection-replace-plugin-invalid-type", null, {
                  pluginItem: _n12
                });
                var _e13 = _n12.pluginName;
                if (!_e13) throw new c.a("plugincollection-replace-plugin-missing-name", null, {
                  pluginItem: _n12
                });
                if (_n12.requires && _n12.requires.length) throw new c.a("plugincollection-plugin-for-replacing-cannot-have-dependencies", null, {
                  pluginName: _e13
                });
                var _i6 = o._availablePlugins.get(_e13);
                if (!_i6) throw new c.a("plugincollection-plugin-for-replacing-not-exist", null, {
                  pluginName: _e13
                });
                var _r6 = t.indexOf(_i6);
                if (-1 === _r6) {
                  if (o._contextPlugins.has(_i6)) return;
                  throw new c.a("plugincollection-plugin-for-replacing-not-loaded", null, {
                    pluginName: _e13
                  });
                }
                if (_i6.requires && _i6.requires.length) throw new c.a("plugincollection-replaced-plugin-cannot-have-dependencies", null, {
                  pluginName: _e13
                });
                t.splice(_r6, 1, _n12), o._availablePlugins.set(_e13, _n12);
              }
            } catch (err) {
              _iterator15.e(err);
            } finally {
              _iterator15.f();
            }
          }(r, n);
          var s = function (t) {
            return t.map(function (t) {
              var e = o._contextPlugins.get(t) || new t(i);
              return o._add(t, e), e;
            });
          }(r);
          return g(s, "init").then(function () {
            return g(s, "afterInit");
          }).then(function () {
            return s;
          });
          function a(t) {
            return "function" == typeof t;
          }
          function l(t) {
            return a(t) && t.isContextPlugin;
          }
          function d(t, e) {
            return e.some(function (e) {
              return e === t || h(t) === e || h(e) === t;
            });
          }
          function h(t) {
            return a(t) ? t.pluginName || t.name : t;
          }
          function u(t) {
            var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            t.map(function (t) {
              return a(t) ? t : o._availablePlugins.get(t) || t;
            }).forEach(function (t) {
              !function (t, e) {
                if (a(t)) return;
                if (e) throw new c.a("plugincollection-soft-required", i, {
                  missingPlugin: t,
                  requiredBy: h(e)
                });
                throw new c.a("plugincollection-plugin-not-found", i, {
                  plugin: t
                });
              }(t, n), function (t, e) {
                if (!l(e)) return;
                if (l(t)) return;
                throw new c.a("plugincollection-context-required", i, {
                  plugin: h(t),
                  requiredBy: h(e)
                });
              }(t, n), function (t, n) {
                if (!n) return;
                if (!d(t, e)) return;
                throw new c.a("plugincollection-required", i, {
                  plugin: h(t),
                  requiredBy: h(n)
                });
              }(t, n);
            });
          }
          function g(t, e) {
            return t.reduce(function (t, n) {
              return n[e] ? o._contextPlugins.has(n) ? t : t.then(n[e].bind(n)) : t;
            }, Promise.resolve());
          }
        }
      }, {
        key: "destroy",
        value: function destroy() {
          var t = [];
          var _iterator16 = _createForOfIteratorHelper(this),
            _step16;
          try {
            for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
              var _step16$value = _slicedToArray(_step16.value, 2),
                _e14 = _step16$value[1];
              "function" != typeof _e14.destroy || this._contextPlugins.has(_e14) || t.push(_e14.destroy());
            }
          } catch (err) {
            _iterator16.e(err);
          } finally {
            _iterator16.f();
          }
          return Promise.all(t);
        }
      }, {
        key: "_add",
        value: function _add(t, e) {
          this._plugins.set(t, e);
          var n = t.pluginName;
          if (n) {
            if (this._plugins.has(n)) throw new c.a("plugincollection-plugin-name-conflict", null, {
              pluginName: n,
              plugin1: this._plugins.get(n).constructor,
              plugin2: t
            });
            this._plugins.set(n, e);
          }
        }
      }]);
      return lo;
    }();
    function ho(t) {
      return Array.isArray(t) ? t : [t];
    }
    function uo(t, e) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      if ("number" != typeof n) throw new c.a("translation-service-quantity-not-a-number", null, {
        quantity: n
      });
      var o = Object.keys(window.CKEDITOR_TRANSLATIONS).length;
      1 === o && (t = Object.keys(window.CKEDITOR_TRANSLATIONS)[0]);
      var i = e.id || e.string;
      if (0 === o || !function (t, e) {
        return !!window.CKEDITOR_TRANSLATIONS[t] && !!window.CKEDITOR_TRANSLATIONS[t].dictionary[e];
      }(t, i)) return 1 !== n ? e.plural : e.string;
      var r = window.CKEDITOR_TRANSLATIONS[t].dictionary,
        s = window.CKEDITOR_TRANSLATIONS[t].getPluralForm || function (t) {
          return 1 === t ? 0 : 1;
        };
      if ("string" == typeof r[i]) return r[i];
      var a = Number(s(n));
      return r[i][a];
    }
    $t(lo, h), window.CKEDITOR_TRANSLATIONS || (window.CKEDITOR_TRANSLATIONS = {});
    var go = ["ar", "ara", "fa", "per", "fas", "he", "heb", "ku", "kur", "ug", "uig"];
    function mo(t) {
      return go.includes(t) ? "rtl" : "ltr";
    }
    var po = /*#__PURE__*/function () {
      function po() {
        var _this14 = this;
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        _classCallCheck(this, po);
        this.uiLanguage = t.uiLanguage || "en", this.contentLanguage = t.contentLanguage || this.uiLanguage, this.uiLanguageDirection = mo(this.uiLanguage), this.contentLanguageDirection = mo(this.contentLanguage), this.t = function (t, e) {
          return _this14._t(t, e);
        };
      }
      _createClass(po, [{
        key: "_t",
        value: function _t(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
          e = ho(e), "string" == typeof t && (t = {
            string: t
          });
          var n = !!t.plural ? e[0] : 1;
          return function (t, e) {
            return t.replace(/%(\d+)/g, function (t, n) {
              return n < e.length ? e[n] : t;
            });
          }(uo(this.uiLanguage, t, n), e);
        }
      }, {
        key: "language",
        get: function get() {
          return console.warn("locale-deprecated-language-property: The Locale#language property has been deprecated and will be removed in the near future. Please use #uiLanguage and #contentLanguage properties instead."), this.uiLanguage;
        }
      }]);
      return po;
    }();
    var fo = /*#__PURE__*/function () {
      function fo(t) {
        _classCallCheck(this, fo);
        this.config = new io(t, this.constructor.defaultConfig);
        var e = this.constructor.builtinPlugins;
        this.config.define("plugins", e), this.plugins = new lo(this, e);
        var n = this.config.get("language") || {};
        this.locale = new po({
          uiLanguage: "string" == typeof n ? n : n.ui,
          contentLanguage: this.config.get("language.content")
        }), this.t = this.locale.t, this.editors = new co(), this._contextOwner = null;
      }
      _createClass(fo, [{
        key: "initPlugins",
        value: function initPlugins() {
          var t = this.config.get("plugins") || [],
            e = this.config.get("substitutePlugins") || [];
          var _iterator17 = _createForOfIteratorHelper(t.concat(e)),
            _step17;
          try {
            for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
              var _n13 = _step17.value;
              if ("function" != typeof _n13) throw new c.a("context-initplugins-constructor-only", null, {
                Plugin: _n13
              });
              if (!0 !== _n13.isContextPlugin) throw new c.a("context-initplugins-invalid-plugin", null, {
                Plugin: _n13
              });
            }
          } catch (err) {
            _iterator17.e(err);
          } finally {
            _iterator17.f();
          }
          return this.plugins.init(t, [], e);
        }
      }, {
        key: "destroy",
        value: function destroy() {
          var _this15 = this;
          return Promise.all(Array.from(this.editors, function (t) {
            return t.destroy();
          })).then(function () {
            return _this15.plugins.destroy();
          });
        }
      }, {
        key: "_addEditor",
        value: function _addEditor(t, e) {
          if (this._contextOwner) throw new c.a("context-addeditor-private-context");
          this.editors.add(t), e && (this._contextOwner = t);
        }
      }, {
        key: "_removeEditor",
        value: function _removeEditor(t) {
          return this.editors.has(t) && this.editors.remove(t), this._contextOwner === t ? this.destroy() : Promise.resolve();
        }
      }, {
        key: "_getEditorConfig",
        value: function _getEditorConfig() {
          var t = {};
          var _iterator18 = _createForOfIteratorHelper(this.config.names()),
            _step18;
          try {
            for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
              var _e15 = _step18.value;
              ["plugins", "removePlugins", "extraPlugins"].includes(_e15) || (t[_e15] = this.config.get(_e15));
            }
          } catch (err) {
            _iterator18.e(err);
          } finally {
            _iterator18.f();
          }
          return t;
        }
      }], [{
        key: "create",
        value: function create(t) {
          var _this16 = this;
          return new Promise(function (e) {
            var n = new _this16(t);
            e(n.initPlugins().then(function () {
              return n;
            }));
          });
        }
      }]);
      return fo;
    }();
    var ko = /*#__PURE__*/function () {
      function ko(t) {
        _classCallCheck(this, ko);
        this.context = t;
      }
      _createClass(ko, [{
        key: "destroy",
        value: function destroy() {
          this.stopListening();
        }
      }], [{
        key: "isContextPlugin",
        get: function get() {
          return !0;
        }
      }]);
      return ko;
    }();
    function bo(t, e) {
      var n = Math.min(t.length, e.length);
      for (var _o6 = 0; _o6 < n; _o6++) if (t[_o6] != e[_o6]) return _o6;
      return t.length == e.length ? "same" : t.length < e.length ? "prefix" : "extension";
    }
    $t(ko, Gt);
    var wo = function wo(t) {
      return eo(t, 4);
    };
    var Co = /*#__PURE__*/function () {
      function Co(t) {
        _classCallCheck(this, Co);
        this.document = t, this.parent = null;
      }
      _createClass(Co, [{
        key: "isAttached",
        value: function isAttached() {
          return this.root.is("rootElement");
        }
      }, {
        key: "getPath",
        value: function getPath() {
          var t = [];
          var e = this;
          for (; e.parent;) t.unshift(e.index), e = e.parent;
          return t;
        }
      }, {
        key: "getAncestors",
        value: function getAncestors() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            includeSelf: !1,
            parentFirst: !1
          };
          var e = [];
          var n = t.includeSelf ? this : this.parent;
          for (; n;) e[t.parentFirst ? "push" : "unshift"](n), n = n.parent;
          return e;
        }
      }, {
        key: "getCommonAncestor",
        value: function getCommonAncestor(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var n = this.getAncestors(e),
            o = t.getAncestors(e);
          var i = 0;
          for (; n[i] == o[i] && n[i];) i++;
          return 0 === i ? null : n[i - 1];
        }
      }, {
        key: "isBefore",
        value: function isBefore(t) {
          if (this == t) return !1;
          if (this.root !== t.root) return !1;
          var e = this.getPath(),
            n = t.getPath(),
            o = bo(e, n);
          switch (o) {
            case "prefix":
              return !0;
            case "extension":
              return !1;
            default:
              return e[o] < n[o];
          }
        }
      }, {
        key: "isAfter",
        value: function isAfter(t) {
          return this != t && this.root === t.root && !this.isBefore(t);
        }
      }, {
        key: "_remove",
        value: function _remove() {
          this.parent._removeChildren(this.index);
        }
      }, {
        key: "_fireChange",
        value: function _fireChange(t, e) {
          this.fire("change:" + t, e), this.parent && this.parent._fireChange(t, e);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = wo(this);
          return delete t.parent, t;
        }
      }, {
        key: "is",
        value: function is(t) {
          return "node" === t || "view:node" === t;
        }
      }, {
        key: "index",
        get: function get() {
          var t;
          if (!this.parent) return null;
          if (-1 == (t = this.parent.getChildIndex(this))) throw new c.a("view-node-not-found-in-parent", this);
          return t;
        }
      }, {
        key: "nextSibling",
        get: function get() {
          var t = this.index;
          return null !== t && this.parent.getChild(t + 1) || null;
        }
      }, {
        key: "previousSibling",
        get: function get() {
          var t = this.index;
          return null !== t && this.parent.getChild(t - 1) || null;
        }
      }, {
        key: "root",
        get: function get() {
          var t = this;
          for (; t.parent;) t = t.parent;
          return t;
        }
      }]);
      return Co;
    }();
    $t(Co, h);
    var Ao = /*#__PURE__*/function (_Co) {
      _inherits(Ao, _Co);
      function Ao(t, e) {
        var _this17;
        _classCallCheck(this, Ao);
        _this17 = _possibleConstructorReturn(this, _getPrototypeOf(Ao).call(this, t)), _this17._textData = e;
        return _this17;
      }
      _createClass(Ao, [{
        key: "is",
        value: function is(t) {
          return "$text" === t || "view:$text" === t || "text" === t || "view:text" === t || "node" === t || "view:node" === t;
        }
      }, {
        key: "isSimilar",
        value: function isSimilar(t) {
          return t instanceof Ao && (this === t || this.data === t.data);
        }
      }, {
        key: "_clone",
        value: function _clone() {
          return new Ao(this.document, this.data);
        }
      }, {
        key: "data",
        get: function get() {
          return this._textData;
        }
      }, {
        key: "_data",
        get: function get() {
          return this.data;
        },
        set: function set(t) {
          this._fireChange("text", this), this._textData = t;
        }
      }]);
      return Ao;
    }(Co);
    var _o = /*#__PURE__*/function () {
      function _o(t, e, n) {
        _classCallCheck(this, _o);
        if (this.textNode = t, e < 0 || e > t.data.length) throw new c.a("view-textproxy-wrong-offsetintext", this);
        if (n < 0 || e + n > t.data.length) throw new c.a("view-textproxy-wrong-length", this);
        this.data = t.data.substring(e, e + n), this.offsetInText = e;
      }
      _createClass(_o, [{
        key: "is",
        value: function is(t) {
          return "$textProxy" === t || "view:$textProxy" === t || "textProxy" === t || "view:textProxy" === t;
        }
      }, {
        key: "getAncestors",
        value: function getAncestors() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            includeSelf: !1,
            parentFirst: !1
          };
          var e = [];
          var n = t.includeSelf ? this.textNode : this.parent;
          for (; null !== n;) e[t.parentFirst ? "push" : "unshift"](n), n = n.parent;
          return e;
        }
      }, {
        key: "offsetSize",
        get: function get() {
          return this.data.length;
        }
      }, {
        key: "isPartial",
        get: function get() {
          return this.data.length !== this.textNode.data.length;
        }
      }, {
        key: "parent",
        get: function get() {
          return this.textNode.parent;
        }
      }, {
        key: "root",
        get: function get() {
          return this.textNode.root;
        }
      }, {
        key: "document",
        get: function get() {
          return this.textNode.document;
        }
      }]);
      return _o;
    }();
    function vo(t) {
      return ao(t) ? new Map(t) : function (t) {
        var e = new Map();
        for (var _n15 in t) e.set(_n15, t[_n15]);
        return e;
      }(t);
    }
    var yo = /*#__PURE__*/function () {
      function yo() {
        _classCallCheck(this, yo);
        this._patterns = [], this.add.apply(this, arguments);
      }
      _createClass(yo, [{
        key: "add",
        value: function add() {
          for (var _len10 = arguments.length, t = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
            t[_key10] = arguments[_key10];
          }
          for (var _i7 = 0, _t18 = t; _i7 < _t18.length; _i7++) {
            var _e16 = _t18[_i7];
            ("string" == typeof _e16 || _e16 instanceof RegExp) && (_e16 = {
              name: _e16
            }), this._patterns.push(_e16);
          }
        }
      }, {
        key: "match",
        value: function match() {
          for (var _len11 = arguments.length, t = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
            t[_key11] = arguments[_key11];
          }
          for (var _i8 = 0, _t19 = t; _i8 < _t19.length; _i8++) {
            var _e17 = _t19[_i8];
            var _iterator19 = _createForOfIteratorHelper(this._patterns),
              _step19;
            try {
              for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
                var _t20 = _step19.value;
                var _n16 = xo(_e17, _t20);
                if (_n16) return {
                  element: _e17,
                  pattern: _t20,
                  match: _n16
                };
              }
            } catch (err) {
              _iterator19.e(err);
            } finally {
              _iterator19.f();
            }
          }
          return null;
        }
      }, {
        key: "matchAll",
        value: function matchAll() {
          var e = [];
          for (var _len12 = arguments.length, t = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
            t[_key12] = arguments[_key12];
          }
          for (var _i9 = 0, _t21 = t; _i9 < _t21.length; _i9++) {
            var _n17 = _t21[_i9];
            var _iterator20 = _createForOfIteratorHelper(this._patterns),
              _step20;
            try {
              for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
                var _t22 = _step20.value;
                var _o7 = xo(_n17, _t22);
                _o7 && e.push({
                  element: _n17,
                  pattern: _t22,
                  match: _o7
                });
              }
            } catch (err) {
              _iterator20.e(err);
            } finally {
              _iterator20.f();
            }
          }
          return e.length > 0 ? e : null;
        }
      }, {
        key: "getElementName",
        value: function getElementName() {
          if (1 !== this._patterns.length) return null;
          var t = this._patterns[0],
            e = t.name;
          return "function" == typeof t || !e || e instanceof RegExp ? null : e;
        }
      }]);
      return yo;
    }();
    function xo(t, e) {
      if ("function" == typeof e) return e(t);
      var n = {};
      return e.name && (n.name = function (t, e) {
        if (t instanceof RegExp) return t.test(e);
        return t === e;
      }(e.name, t.name), !n.name) || e.attributes && (n.attributes = function (t, e) {
        return Eo(t, e.getAttributeKeys(), function (t) {
          return e.getAttribute(t);
        });
      }(e.attributes, t), !n.attributes) ? null : !(e.classes && (n.classes = function (t, e) {
        return Eo(t, e.getClassNames());
      }(e.classes, t), !n.classes)) && !(e.styles && (n.styles = function (t, e) {
        return Eo(t, e.getStyleNames(!0), function (t) {
          return e.getStyle(t);
        });
      }(e.styles, t), !n.styles)) && n;
    }
    function Eo(t, e, n) {
      var o = function (t) {
          if (Array.isArray(t)) return t.map(function (t) {
            return le(t) ? (void 0 !== t.key && void 0 !== t.value || Object(c.b)("matcher-pattern-missing-key-or-value", t), [t.key, t.value]) : [t, !0];
          });
          if (le(t)) return Object.entries(t);
          return [[t, !0]];
        }(t),
        i = Array.from(e),
        r = [];
      return o.forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          t = _ref2[0],
          e = _ref2[1];
        i.forEach(function (o) {
          (function (t, e) {
            return !0 === t || t === e || t instanceof RegExp && t.test(e);
          })(t, o) && function (t, e, n) {
            if (!0 === t) return !0;
            var o = n(e);
            return t === o || t instanceof RegExp && t.test(o);
          }(e, o, n) && r.push(o);
        });
      }), !o.length || r.length < o.length ? null : r;
    }
    var Do = function Do(t) {
        return "symbol" == typeof t || pt(t) && "[object Symbol]" == T(t);
      },
      Mo = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      Io = /^\w*$/;
    var To = function To(t, e) {
      if (At(t)) return !1;
      var n = typeof t;
      return !("number" != n && "symbol" != n && "boolean" != n && null != t && !Do(t)) || Io.test(t) || !Mo.test(t) || null != e && t in Object(e);
    };
    function So(t, e) {
      if ("function" != typeof t || null != e && "function" != typeof e) throw new TypeError("Expected a function");
      var n = function n() {
        var o = arguments,
          i = e ? e.apply(this, o) : o[0],
          r = n.cache;
        if (r.has(i)) return r.get(i);
        var s = t.apply(this, o);
        return n.cache = r.set(i, s) || r, s;
      };
      return n.cache = new (So.Cache || Ue)(), n;
    }
    So.Cache = Ue;
    var No = So;
    var Bo = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
      Po = /\\(\\)?/g,
      zo = function (t) {
        var e = No(t, function (t) {
            return 500 === n.size && n.clear(), t;
          }),
          n = e.cache;
        return e;
      }(function (t) {
        var e = [];
        return 46 === t.charCodeAt(0) && e.push(""), t.replace(Bo, function (t, n, o, i) {
          e.push(o ? i.replace(Po, "$1") : n || t);
        }), e;
      });
    var Lo = function Lo(t, e) {
        for (var n = -1, o = null == t ? 0 : t.length, i = Array(o); ++n < o;) i[n] = e(t[n], n, t);
        return i;
      },
      Oo = A ? A.prototype : void 0,
      Ro = Oo ? Oo.toString : void 0;
    var jo = function t(e) {
      if ("string" == typeof e) return e;
      if (At(e)) return Lo(e, t) + "";
      if (Do(e)) return Ro ? Ro.call(e) : "";
      var n = e + "";
      return "0" == n && 1 / e == -Infinity ? "-0" : n;
    };
    var Fo = function Fo(t) {
      return null == t ? "" : jo(t);
    };
    var Vo = function Vo(t, e) {
      return At(t) ? t : To(t, e) ? [t] : zo(Fo(t));
    };
    var Uo = function Uo(t) {
      var e = null == t ? 0 : t.length;
      return e ? t[e - 1] : void 0;
    };
    var Ho = function Ho(t) {
      if ("string" == typeof t || Do(t)) return t;
      var e = t + "";
      return "0" == e && 1 / t == -Infinity ? "-0" : e;
    };
    var Go = function Go(t, e) {
      for (var n = 0, o = (e = Vo(e, t)).length; null != t && n < o;) t = t[Ho(e[n++])];
      return n && n == o ? t : void 0;
    };
    var Wo = function Wo(t, e, n) {
      var o = -1,
        i = t.length;
      e < 0 && (e = -e > i ? 0 : i + e), (n = n > i ? i : n) < 0 && (n += i), i = e > n ? 0 : n - e >>> 0, e >>>= 0;
      for (var r = Array(i); ++o < i;) r[o] = t[o + e];
      return r;
    };
    var qo = function qo(t, e) {
      return e.length < 2 ? t : Go(t, Wo(e, 0, -1));
    };
    var Ko = function Ko(t, e) {
      return e = Vo(e, t), null == (t = qo(t, e)) || delete t[Ho(Uo(e))];
    };
    var Yo = function Yo(t, e) {
      return null == t || Ko(t, e);
    };
    var Qo = function Qo(t, e, n) {
      var o = null == t ? void 0 : Go(t, e);
      return void 0 === o ? n : o;
    };
    var $o = function $o(t, e, n) {
      (void 0 !== n && !Q(t[e], n) || void 0 === n && !(e in t)) && Y(t, e, n);
    };
    var Jo = function (t) {
      return function (e, n, o) {
        for (var i = -1, r = Object(e), s = o(e), a = s.length; a--;) {
          var c = s[t ? a : ++i];
          if (!1 === n(r[c], c, r)) break;
        }
        return e;
      };
    }();
    var Zo = function Zo(t) {
      return pt(t) && lt(t);
    };
    var Xo = function Xo(t, e) {
      if (("constructor" !== e || "function" != typeof t[e]) && "__proto__" != e) return t[e];
    };
    var ti = function ti(t) {
      return Z(t, Lt(t));
    };
    var ei = function ei(t, e, n, o, i, r, s) {
      var a = Xo(t, n),
        c = Xo(e, n),
        l = s.get(c);
      if (l) $o(t, n, l);else {
        var d = r ? r(a, c, n + "", t, e, s) : void 0,
          h = void 0 === d;
        if (h) {
          var u = At(c),
            g = !u && Object(_t.a)(c),
            m = !u && !g && Mt(c);
          d = c, u || g || m ? At(a) ? d = a : Zo(a) ? d = tn(a) : g ? (h = !1, d = Object(Xe.a)(c, !0)) : m ? (h = !1, d = Fn(c, !0)) : d = [] : le(c) || Ct(c) ? (d = a, Ct(a) ? d = ti(a) : w(a) && !N(a) || (d = Gn(c))) : h = !1;
        }
        h && (s.set(c, d), i(d, c, o, r, s), s.delete(c)), $o(t, n, d);
      }
    };
    var ni = function t(e, n, o, i, r) {
        e !== n && Jo(n, function (s, a) {
          if (r || (r = new We()), w(s)) ei(e, n, a, o, t, i, r);else {
            var c = i ? i(Xo(e, a), s, a + "", e, n, r) : void 0;
            void 0 === c && (c = s), $o(e, a, c);
          }
        }, Lt);
      },
      oi = gt(function (t, e, n) {
        ni(t, e, n);
      });
    var ii = function ii(t, e, n, o) {
      if (!w(t)) return t;
      for (var i = -1, r = (e = Vo(e, t)).length, s = r - 1, a = t; null != a && ++i < r;) {
        var c = Ho(e[i]),
          l = n;
        if ("__proto__" === c || "constructor" === c || "prototype" === c) return t;
        if (i != s) {
          var d = a[c];
          void 0 === (l = o ? o(d, c, a) : void 0) && (l = w(d) ? d : ht(e[i + 1]) ? [] : {});
        }
        J(a, c, l), a = a[c];
      }
      return t;
    };
    var ri = function ri(t, e, n) {
      return null == t ? t : ii(t, e, n);
    };
    var si = /*#__PURE__*/function () {
      function si(t) {
        _classCallCheck(this, si);
        this._styles = {}, this._styleProcessor = t;
      }
      _createClass(si, [{
        key: "setTo",
        value: function setTo(t) {
          this.clear();
          var e = Array.from(function (t) {
            var e = null,
              n = 0,
              o = 0,
              i = null;
            var r = new Map();
            if ("" === t) return r;
            ";" != t.charAt(t.length - 1) && (t += ";");
            for (var _s3 = 0; _s3 < t.length; _s3++) {
              var _a2 = t.charAt(_s3);
              if (null === e) switch (_a2) {
                case ":":
                  i || (i = t.substr(n, _s3 - n), o = _s3 + 1);
                  break;
                case '"':
                case "'":
                  e = _a2;
                  break;
                case ";":
                  {
                    var _e18 = t.substr(o, _s3 - o);
                    i && r.set(i.trim(), _e18.trim()), i = null, n = _s3 + 1;
                    break;
                  }
              } else _a2 === e && (e = null);
            }
            return r;
          }(t).entries());
          for (var _i10 = 0, _e19 = e; _i10 < _e19.length; _i10++) {
            var _e19$_i = _slicedToArray(_e19[_i10], 2),
              _t23 = _e19$_i[0],
              _n18 = _e19$_i[1];
            this._styleProcessor.toNormalizedForm(_t23, _n18, this._styles);
          }
        }
      }, {
        key: "has",
        value: function has(t) {
          if (this.isEmpty) return !1;
          var e = this._styleProcessor.getReducedForm(t, this._styles).find(function (_ref3) {
            var _ref4 = _slicedToArray(_ref3, 1),
              e = _ref4[0];
            return e === t;
          });
          return Array.isArray(e);
        }
      }, {
        key: "set",
        value: function set(t, e) {
          if (w(t)) for (var _i11 = 0, _Object$entries = Object.entries(t); _i11 < _Object$entries.length; _i11++) {
            var _Object$entries$_i = _slicedToArray(_Object$entries[_i11], 2),
              _e20 = _Object$entries$_i[0],
              _n19 = _Object$entries$_i[1];
            this._styleProcessor.toNormalizedForm(_e20, _n19, this._styles);
          } else this._styleProcessor.toNormalizedForm(t, e, this._styles);
        }
      }, {
        key: "remove",
        value: function remove(t) {
          var e = ci(t);
          Yo(this._styles, e), delete this._styles[t], this._cleanEmptyObjectsOnPath(e);
        }
      }, {
        key: "getNormalized",
        value: function getNormalized(t) {
          return this._styleProcessor.getNormalized(t, this._styles);
        }
      }, {
        key: "toString",
        value: function toString() {
          return this.isEmpty ? "" : this._getStylesEntries().map(function (t) {
            return t.join(":");
          }).sort().join(";") + ";";
        }
      }, {
        key: "getAsString",
        value: function getAsString(t) {
          if (this.isEmpty) return;
          if (this._styles[t] && !w(this._styles[t])) return this._styles[t];
          var e = this._styleProcessor.getReducedForm(t, this._styles).find(function (_ref5) {
            var _ref6 = _slicedToArray(_ref5, 1),
              e = _ref6[0];
            return e === t;
          });
          return Array.isArray(e) ? e[1] : void 0;
        }
      }, {
        key: "getStyleNames",
        value: function getStyleNames() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
          if (this.isEmpty) return [];
          if (t) return this._styleProcessor.getStyleNames(this._styles);
          return this._getStylesEntries().map(function (_ref7) {
            var _ref8 = _slicedToArray(_ref7, 1),
              t = _ref8[0];
            return t;
          });
        }
      }, {
        key: "clear",
        value: function clear() {
          this._styles = {};
        }
      }, {
        key: "_getStylesEntries",
        value: function _getStylesEntries() {
          var t = [],
            e = Object.keys(this._styles);
          for (var _i12 = 0, _e21 = e; _i12 < _e21.length; _i12++) {
            var _n20 = _e21[_i12];
            t.push.apply(t, _toConsumableArray(this._styleProcessor.getReducedForm(_n20, this._styles)));
          }
          return t;
        }
      }, {
        key: "_cleanEmptyObjectsOnPath",
        value: function _cleanEmptyObjectsOnPath(t) {
          var e = t.split(".");
          if (!(e.length > 1)) return;
          var n = e.splice(0, e.length - 1).join("."),
            o = Qo(this._styles, n);
          if (!o) return;
          !Array.from(Object.keys(o)).length && this.remove(n);
        }
      }, {
        key: "isEmpty",
        get: function get() {
          var t = Object.entries(this._styles);
          return !Array.from(t).length;
        }
      }, {
        key: "size",
        get: function get() {
          return this.isEmpty ? 0 : this.getStyleNames().length;
        }
      }]);
      return si;
    }();
    var ai = /*#__PURE__*/function () {
      function ai() {
        _classCallCheck(this, ai);
        this._normalizers = new Map(), this._extractors = new Map(), this._reducers = new Map(), this._consumables = new Map();
      }
      _createClass(ai, [{
        key: "toNormalizedForm",
        value: function toNormalizedForm(t, e, n) {
          if (w(e)) li(n, ci(t), e);else if (this._normalizers.has(t)) {
            var _o9 = this._normalizers.get(t),
              _o8 = _o9(e),
              _i13 = _o8.path,
              _r7 = _o8.value;
            li(n, _i13, _r7);
          } else li(n, t, e);
        }
      }, {
        key: "getNormalized",
        value: function getNormalized(t, e) {
          if (!t) return oi({}, e);
          if (void 0 !== e[t]) return e[t];
          if (this._extractors.has(t)) {
            var _n21 = this._extractors.get(t);
            if ("string" == typeof _n21) return Qo(e, _n21);
            var _o10 = _n21(t, e);
            if (_o10) return _o10;
          }
          return Qo(e, ci(t));
        }
      }, {
        key: "getReducedForm",
        value: function getReducedForm(t, e) {
          var n = this.getNormalized(t, e);
          if (void 0 === n) return [];
          if (this._reducers.has(t)) {
            return this._reducers.get(t)(n);
          }
          return [[t, n]];
        }
      }, {
        key: "getStyleNames",
        value: function getStyleNames(t) {
          var _this18 = this;
          var e = Array.from(this._consumables.keys()).filter(function (e) {
              var n = _this18.getNormalized(e, t);
              return n && "object" == typeof n ? Object.keys(n).length : n;
            }),
            n = new Set([].concat(_toConsumableArray(e), _toConsumableArray(Object.keys(t))));
          return Array.from(n.values());
        }
      }, {
        key: "getRelatedStyles",
        value: function getRelatedStyles(t) {
          return this._consumables.get(t) || [];
        }
      }, {
        key: "setNormalizer",
        value: function setNormalizer(t, e) {
          this._normalizers.set(t, e);
        }
      }, {
        key: "setExtractor",
        value: function setExtractor(t, e) {
          this._extractors.set(t, e);
        }
      }, {
        key: "setReducer",
        value: function setReducer(t, e) {
          this._reducers.set(t, e);
        }
      }, {
        key: "setStyleRelation",
        value: function setStyleRelation(t, e) {
          this._mapStyleNames(t, e);
          var _iterator21 = _createForOfIteratorHelper(e),
            _step21;
          try {
            for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
              var _n22 = _step21.value;
              this._mapStyleNames(_n22, [t]);
            }
          } catch (err) {
            _iterator21.e(err);
          } finally {
            _iterator21.f();
          }
        }
      }, {
        key: "_mapStyleNames",
        value: function _mapStyleNames(t, e) {
          var _this$_consumables$ge;
          this._consumables.has(t) || this._consumables.set(t, []), (_this$_consumables$ge = this._consumables.get(t)).push.apply(_this$_consumables$ge, _toConsumableArray(e));
        }
      }]);
      return ai;
    }();
    function ci(t) {
      return t.replace("-", ".");
    }
    function li(t, e, n) {
      var o = n;
      w(n) && (o = oi({}, Qo(t, e), n)), ri(t, e, o);
    }
    var di = /*#__PURE__*/function (_Co2) {
      _inherits(di, _Co2);
      function di(t, e, n, o) {
        var _this19;
        _classCallCheck(this, di);
        if (_this19 = _possibleConstructorReturn(this, _getPrototypeOf(di).call(this, t)), _this19.name = e, _this19._attrs = function (t) {
          t = vo(t);
          var _iterator22 = _createForOfIteratorHelper(t),
            _step22;
          try {
            for (_iterator22.s(); !(_step22 = _iterator22.n()).done;) {
              var _step22$value = _slicedToArray(_step22.value, 2),
                _e22 = _step22$value[0],
                _n23 = _step22$value[1];
              null === _n23 ? t.delete(_e22) : "string" != typeof _n23 && t.set(_e22, String(_n23));
            }
          } catch (err) {
            _iterator22.e(err);
          } finally {
            _iterator22.f();
          }
          return t;
        }(n), _this19._children = [], o && _this19._insertChild(0, o), _this19._classes = new Set(), _this19._attrs.has("class")) {
          var _t24 = _this19._attrs.get("class");
          hi(_this19._classes, _t24), _this19._attrs.delete("class");
        }
        _this19._styles = new si(_this19.document.stylesProcessor), _this19._attrs.has("style") && (_this19._styles.setTo(_this19._attrs.get("style")), _this19._attrs.delete("style")), _this19._customProperties = new Map(), _this19._isAllowedInsideAttributeElement = !1;
        return _possibleConstructorReturn(_this19);
      }
      _createClass(di, [{
        key: "is",
        value: function is(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          return e ? e === this.name && ("element" === t || "view:element" === t) : "element" === t || "view:element" === t || "node" === t || "view:node" === t;
        }
      }, {
        key: "getChild",
        value: function getChild(t) {
          return this._children[t];
        }
      }, {
        key: "getChildIndex",
        value: function getChildIndex(t) {
          return this._children.indexOf(t);
        }
      }, {
        key: "getChildren",
        value: function getChildren() {
          return this._children[Symbol.iterator]();
        }
      }, {
        key: "getAttributeKeys",
        value: /*#__PURE__*/_regeneratorRuntime().mark(function getAttributeKeys() {
          return _regeneratorRuntime().wrap(function getAttributeKeys$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                _context3.t0 = this._classes.size > 0;
                if (!_context3.t0) {
                  _context3.next = 4;
                  break;
                }
                _context3.next = 4;
                return "class";
              case 4:
                _context3.t1 = this._styles.isEmpty;
                if (_context3.t1) {
                  _context3.next = 8;
                  break;
                }
                _context3.next = 8;
                return "style";
              case 8:
                return _context3.delegateYield(this._attrs.keys(), "t2", 9);
              case 9:
              case "end":
                return _context3.stop();
            }
          }, getAttributeKeys, this);
        })
      }, {
        key: "getAttributes",
        value: /*#__PURE__*/_regeneratorRuntime().mark(function getAttributes() {
          return _regeneratorRuntime().wrap(function getAttributes$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.delegateYield(this._attrs.entries(), "t0", 1);
              case 1:
                _context4.t1 = this._classes.size > 0;
                if (!_context4.t1) {
                  _context4.next = 5;
                  break;
                }
                _context4.next = 5;
                return ["class", this.getAttribute("class")];
              case 5:
                _context4.t2 = this._styles.isEmpty;
                if (_context4.t2) {
                  _context4.next = 9;
                  break;
                }
                _context4.next = 9;
                return ["style", this.getAttribute("style")];
              case 9:
              case "end":
                return _context4.stop();
            }
          }, getAttributes, this);
        })
      }, {
        key: "getAttribute",
        value: function getAttribute(t) {
          if ("class" == t) return this._classes.size > 0 ? _toConsumableArray(this._classes).join(" ") : void 0;
          if ("style" == t) {
            var _t25 = this._styles.toString();
            return "" == _t25 ? void 0 : _t25;
          }
          return this._attrs.get(t);
        }
      }, {
        key: "hasAttribute",
        value: function hasAttribute(t) {
          return "class" == t ? this._classes.size > 0 : "style" == t ? !this._styles.isEmpty : this._attrs.has(t);
        }
      }, {
        key: "isSimilar",
        value: function isSimilar(t) {
          if (!(t instanceof di)) return !1;
          if (this === t) return !0;
          if (this.name != t.name) return !1;
          if (this.isAllowedInsideAttributeElement != t.isAllowedInsideAttributeElement) return !1;
          if (this._attrs.size !== t._attrs.size || this._classes.size !== t._classes.size || this._styles.size !== t._styles.size) return !1;
          var _iterator23 = _createForOfIteratorHelper(this._attrs),
            _step23;
          try {
            for (_iterator23.s(); !(_step23 = _iterator23.n()).done;) {
              var _step23$value = _slicedToArray(_step23.value, 2),
                _e23 = _step23$value[0],
                _n24 = _step23$value[1];
              if (!t._attrs.has(_e23) || t._attrs.get(_e23) !== _n24) return !1;
            }
          } catch (err) {
            _iterator23.e(err);
          } finally {
            _iterator23.f();
          }
          var _iterator24 = _createForOfIteratorHelper(this._classes),
            _step24;
          try {
            for (_iterator24.s(); !(_step24 = _iterator24.n()).done;) {
              var _e24 = _step24.value;
              if (!t._classes.has(_e24)) return !1;
            }
          } catch (err) {
            _iterator24.e(err);
          } finally {
            _iterator24.f();
          }
          var _iterator25 = _createForOfIteratorHelper(this._styles.getStyleNames()),
            _step25;
          try {
            for (_iterator25.s(); !(_step25 = _iterator25.n()).done;) {
              var _e25 = _step25.value;
              if (!t._styles.has(_e25) || t._styles.getAsString(_e25) !== this._styles.getAsString(_e25)) return !1;
            }
          } catch (err) {
            _iterator25.e(err);
          } finally {
            _iterator25.f();
          }
          return !0;
        }
      }, {
        key: "hasClass",
        value: function hasClass() {
          for (var _len13 = arguments.length, t = new Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {
            t[_key13] = arguments[_key13];
          }
          for (var _i14 = 0, _t26 = t; _i14 < _t26.length; _i14++) {
            var _e26 = _t26[_i14];
            if (!this._classes.has(_e26)) return !1;
          }
          return !0;
        }
      }, {
        key: "getClassNames",
        value: function getClassNames() {
          return this._classes.keys();
        }
      }, {
        key: "getStyle",
        value: function getStyle(t) {
          return this._styles.getAsString(t);
        }
      }, {
        key: "getNormalizedStyle",
        value: function getNormalizedStyle(t) {
          return this._styles.getNormalized(t);
        }
      }, {
        key: "getStyleNames",
        value: function getStyleNames() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
          return this._styles.getStyleNames(t);
        }
      }, {
        key: "hasStyle",
        value: function hasStyle() {
          for (var _len14 = arguments.length, t = new Array(_len14), _key14 = 0; _key14 < _len14; _key14++) {
            t[_key14] = arguments[_key14];
          }
          for (var _i15 = 0, _t27 = t; _i15 < _t27.length; _i15++) {
            var _e27 = _t27[_i15];
            if (!this._styles.has(_e27)) return !1;
          }
          return !0;
        }
      }, {
        key: "findAncestor",
        value: function findAncestor() {
          for (var _len15 = arguments.length, t = new Array(_len15), _key15 = 0; _key15 < _len15; _key15++) {
            t[_key15] = arguments[_key15];
          }
          var e = _construct(yo, t);
          var n = this.parent;
          for (; n;) {
            if (e.match(n)) return n;
            n = n.parent;
          }
          return null;
        }
      }, {
        key: "getCustomProperty",
        value: function getCustomProperty(t) {
          return this._customProperties.get(t);
        }
      }, {
        key: "getCustomProperties",
        value: /*#__PURE__*/_regeneratorRuntime().mark(function getCustomProperties() {
          return _regeneratorRuntime().wrap(function getCustomProperties$(_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.delegateYield(this._customProperties.entries(), "t0", 1);
              case 1:
              case "end":
                return _context5.stop();
            }
          }, getCustomProperties, this);
        })
      }, {
        key: "getIdentity",
        value: function getIdentity() {
          var t = Array.from(this._classes).sort().join(","),
            e = this._styles.toString(),
            n = Array.from(this._attrs).map(function (t) {
              return "".concat(t[0], "=\"").concat(t[1], "\"");
            }).sort().join(" ");
          return this.name + ("" == t ? "" : " class=\"".concat(t, "\"")) + (e ? " style=\"".concat(e, "\"") : "") + ("" == n ? "" : " ".concat(n));
        }
      }, {
        key: "_clone",
        value: function _clone() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
          var e = [];
          if (t) {
            var _iterator26 = _createForOfIteratorHelper(this.getChildren()),
              _step26;
            try {
              for (_iterator26.s(); !(_step26 = _iterator26.n()).done;) {
                var _n25 = _step26.value;
                e.push(_n25._clone(t));
              }
            } catch (err) {
              _iterator26.e(err);
            } finally {
              _iterator26.f();
            }
          }
          var n = new this.constructor(this.document, this.name, this._attrs, e);
          return n._classes = new Set(this._classes), n._styles.set(this._styles.getNormalized()), n._customProperties = new Map(this._customProperties), n.getFillerOffset = this.getFillerOffset, n._isAllowedInsideAttributeElement = this.isAllowedInsideAttributeElement, n;
        }
      }, {
        key: "_appendChild",
        value: function _appendChild(t) {
          return this._insertChild(this.childCount, t);
        }
      }, {
        key: "_insertChild",
        value: function _insertChild(t, e) {
          this._fireChange("children", this);
          var n = 0;
          var o = function (t, e) {
            if ("string" == typeof e) return [new Ao(t, e)];
            ao(e) || (e = [e]);
            return Array.from(e).map(function (e) {
              return "string" == typeof e ? new Ao(t, e) : e instanceof _o ? new Ao(t, e.data) : e;
            });
          }(this.document, e);
          var _iterator27 = _createForOfIteratorHelper(o),
            _step27;
          try {
            for (_iterator27.s(); !(_step27 = _iterator27.n()).done;) {
              var _e28 = _step27.value;
              null !== _e28.parent && _e28._remove(), _e28.parent = this, _e28.document = this.document, this._children.splice(t, 0, _e28), t++, n++;
            }
          } catch (err) {
            _iterator27.e(err);
          } finally {
            _iterator27.f();
          }
          return n;
        }
      }, {
        key: "_removeChildren",
        value: function _removeChildren(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
          this._fireChange("children", this);
          for (var _n27 = t; _n27 < t + e; _n27++) this._children[_n27].parent = null;
          return this._children.splice(t, e);
        }
      }, {
        key: "_setAttribute",
        value: function _setAttribute(t, e) {
          e = String(e), this._fireChange("attributes", this), "class" == t ? hi(this._classes, e) : "style" == t ? this._styles.setTo(e) : this._attrs.set(t, e);
        }
      }, {
        key: "_removeAttribute",
        value: function _removeAttribute(t) {
          return this._fireChange("attributes", this), "class" == t ? this._classes.size > 0 && (this._classes.clear(), !0) : "style" == t ? !this._styles.isEmpty && (this._styles.clear(), !0) : this._attrs.delete(t);
        }
      }, {
        key: "_addClass",
        value: function _addClass(t) {
          this._fireChange("attributes", this);
          var _iterator28 = _createForOfIteratorHelper(ho(t)),
            _step28;
          try {
            for (_iterator28.s(); !(_step28 = _iterator28.n()).done;) {
              var _e29 = _step28.value;
              this._classes.add(_e29);
            }
          } catch (err) {
            _iterator28.e(err);
          } finally {
            _iterator28.f();
          }
        }
      }, {
        key: "_removeClass",
        value: function _removeClass(t) {
          this._fireChange("attributes", this);
          var _iterator29 = _createForOfIteratorHelper(ho(t)),
            _step29;
          try {
            for (_iterator29.s(); !(_step29 = _iterator29.n()).done;) {
              var _e30 = _step29.value;
              this._classes.delete(_e30);
            }
          } catch (err) {
            _iterator29.e(err);
          } finally {
            _iterator29.f();
          }
        }
      }, {
        key: "_setStyle",
        value: function _setStyle(t, e) {
          this._fireChange("attributes", this), this._styles.set(t, e);
        }
      }, {
        key: "_removeStyle",
        value: function _removeStyle(t) {
          this._fireChange("attributes", this);
          var _iterator30 = _createForOfIteratorHelper(ho(t)),
            _step30;
          try {
            for (_iterator30.s(); !(_step30 = _iterator30.n()).done;) {
              var _e31 = _step30.value;
              this._styles.remove(_e31);
            }
          } catch (err) {
            _iterator30.e(err);
          } finally {
            _iterator30.f();
          }
        }
      }, {
        key: "_setCustomProperty",
        value: function _setCustomProperty(t, e) {
          this._customProperties.set(t, e);
        }
      }, {
        key: "_removeCustomProperty",
        value: function _removeCustomProperty(t) {
          return this._customProperties.delete(t);
        }
      }, {
        key: "childCount",
        get: function get() {
          return this._children.length;
        }
      }, {
        key: "isEmpty",
        get: function get() {
          return 0 === this._children.length;
        }
      }, {
        key: "isAllowedInsideAttributeElement",
        get: function get() {
          return this._isAllowedInsideAttributeElement;
        }
      }]);
      return di;
    }(Co);
    function hi(t, e) {
      var n = e.split(/\s+/);
      t.clear(), n.forEach(function (e) {
        return t.add(e);
      });
    }
    var ui = /*#__PURE__*/function (_di) {
      _inherits(ui, _di);
      function ui(t, e, n, o) {
        var _this20;
        _classCallCheck(this, ui);
        _this20 = _possibleConstructorReturn(this, _getPrototypeOf(ui).call(this, t, e, n, o)), _this20.getFillerOffset = gi;
        return _this20;
      }
      _createClass(ui, [{
        key: "is",
        value: function is(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          return e ? e === this.name && ("containerElement" === t || "view:containerElement" === t || "element" === t || "view:element" === t) : "containerElement" === t || "view:containerElement" === t || "element" === t || "view:element" === t || "node" === t || "view:node" === t;
        }
      }]);
      return ui;
    }(di);
    function gi() {
      var t = _toConsumableArray(this.getChildren()),
        e = t[this.childCount - 1];
      if (e && e.is("element", "br")) return this.childCount;
      var _iterator31 = _createForOfIteratorHelper(t),
        _step31;
      try {
        for (_iterator31.s(); !(_step31 = _iterator31.n()).done;) {
          var _e32 = _step31.value;
          if (!_e32.is("uiElement")) return null;
        }
      } catch (err) {
        _iterator31.e(err);
      } finally {
        _iterator31.f();
      }
      return this.childCount;
    }
    var mi = /*#__PURE__*/function (_ui) {
      _inherits(mi, _ui);
      function mi(t, e, n, o) {
        var _this21;
        _classCallCheck(this, mi);
        _this21 = _possibleConstructorReturn(this, _getPrototypeOf(mi).call(this, t, e, n, o)), _this21.set("isReadOnly", !1), _this21.set("isFocused", !1), _this21.bind("isReadOnly").to(t), _this21.bind("isFocused").to(t, "isFocused", function (e) {
          return e && t.selection.editableElement == _assertThisInitialized(_assertThisInitialized(_this21));
        }), _this21.listenTo(t.selection, "change", function () {
          _this21.isFocused = t.isFocused && t.selection.editableElement == _assertThisInitialized(_assertThisInitialized(_this21));
        });
        return _this21;
      }
      _createClass(mi, [{
        key: "is",
        value: function is(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          return e ? e === this.name && ("editableElement" === t || "view:editableElement" === t || "containerElement" === t || "view:containerElement" === t || "element" === t || "view:element" === t) : "editableElement" === t || "view:editableElement" === t || "containerElement" === t || "view:containerElement" === t || "element" === t || "view:element" === t || "node" === t || "view:node" === t;
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.stopListening();
        }
      }]);
      return mi;
    }(ui);
    $t(mi, Gt);
    var pi = Symbol("rootName");
    var fi = /*#__PURE__*/function (_mi) {
      _inherits(fi, _mi);
      function fi(t, e) {
        var _this22;
        _classCallCheck(this, fi);
        _this22 = _possibleConstructorReturn(this, _getPrototypeOf(fi).call(this, t, e)), _this22.rootName = "main";
        return _this22;
      }
      _createClass(fi, [{
        key: "is",
        value: function is(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          return e ? e === this.name && ("rootElement" === t || "view:rootElement" === t || "editableElement" === t || "view:editableElement" === t || "containerElement" === t || "view:containerElement" === t || "element" === t || "view:element" === t) : "rootElement" === t || "view:rootElement" === t || "editableElement" === t || "view:editableElement" === t || "containerElement" === t || "view:containerElement" === t || "element" === t || "view:element" === t || "node" === t || "view:node" === t;
        }
      }, {
        key: "rootName",
        get: function get() {
          return this.getCustomProperty(pi);
        },
        set: function set(t) {
          this._setCustomProperty(pi, t);
        }
      }, {
        key: "_name",
        set: function set(t) {
          this.name = t;
        }
      }]);
      return fi;
    }(mi);
    var ki = /*#__PURE__*/function () {
      function ki() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        _classCallCheck(this, ki);
        if (!t.boundaries && !t.startPosition) throw new c.a("view-tree-walker-no-start-position", null);
        if (t.direction && "forward" != t.direction && "backward" != t.direction) throw new c.a("view-tree-walker-unknown-direction", t.startPosition, {
          direction: t.direction
        });
        this.boundaries = t.boundaries || null, t.startPosition ? this.position = bi._createAt(t.startPosition) : this.position = bi._createAt(t.boundaries["backward" == t.direction ? "end" : "start"]), this.direction = t.direction || "forward", this.singleCharacters = !!t.singleCharacters, this.shallow = !!t.shallow, this.ignoreElementEnd = !!t.ignoreElementEnd, this._boundaryStartParent = this.boundaries ? this.boundaries.start.parent : null, this._boundaryEndParent = this.boundaries ? this.boundaries.end.parent : null;
      }
      _createClass(ki, [{
        key: Symbol.iterator,
        value: function value() {
          return this;
        }
      }, {
        key: "skip",
        value: function skip(t) {
          var e, n, o;
          do {
            var _this$next;
            o = this.position, (_this$next = this.next(), e = _this$next.done, n = _this$next.value, _this$next);
          } while (!e && t(n));
          e || (this.position = o);
        }
      }, {
        key: "next",
        value: function next() {
          return "forward" == this.direction ? this._next() : this._previous();
        }
      }, {
        key: "_next",
        value: function _next() {
          var t = this.position.clone();
          var e = this.position,
            n = t.parent;
          if (null === n.parent && t.offset === n.childCount) return {
            done: !0
          };
          if (n === this._boundaryEndParent && t.offset == this.boundaries.end.offset) return {
            done: !0
          };
          var o;
          if (n instanceof Ao) {
            if (t.isAtEnd) return this.position = bi._createAfter(n), this._next();
            o = n.data[t.offset];
          } else o = n.getChild(t.offset);
          if (o instanceof di) return this.shallow ? t.offset++ : t = new bi(o, 0), this.position = t, this._formatReturnValue("elementStart", o, e, t, 1);
          if (o instanceof Ao) {
            if (this.singleCharacters) return t = new bi(o, 0), this.position = t, this._next();
            {
              var _n28,
                _i16 = o.data.length;
              return o == this._boundaryEndParent ? (_i16 = this.boundaries.end.offset, _n28 = new _o(o, 0, _i16), t = bi._createAfter(_n28)) : (_n28 = new _o(o, 0, o.data.length), t.offset++), this.position = t, this._formatReturnValue("text", _n28, e, t, _i16);
            }
          }
          if ("string" == typeof o) {
            var _o11;
            if (this.singleCharacters) _o11 = 1;else {
              _o11 = (n === this._boundaryEndParent ? this.boundaries.end.offset : n.data.length) - t.offset;
            }
            var _i17 = new _o(n, t.offset, _o11);
            return t.offset += _o11, this.position = t, this._formatReturnValue("text", _i17, e, t, _o11);
          }
          return t = bi._createAfter(n), this.position = t, this.ignoreElementEnd ? this._next() : this._formatReturnValue("elementEnd", n, e, t);
        }
      }, {
        key: "_previous",
        value: function _previous() {
          var t = this.position.clone();
          var e = this.position,
            n = t.parent;
          if (null === n.parent && 0 === t.offset) return {
            done: !0
          };
          if (n == this._boundaryStartParent && t.offset == this.boundaries.start.offset) return {
            done: !0
          };
          var o;
          if (n instanceof Ao) {
            if (t.isAtStart) return this.position = bi._createBefore(n), this._previous();
            o = n.data[t.offset - 1];
          } else o = n.getChild(t.offset - 1);
          if (o instanceof di) return this.shallow ? (t.offset--, this.position = t, this._formatReturnValue("elementStart", o, e, t, 1)) : (t = new bi(o, o.childCount), this.position = t, this.ignoreElementEnd ? this._previous() : this._formatReturnValue("elementEnd", o, e, t));
          if (o instanceof Ao) {
            if (this.singleCharacters) return t = new bi(o, o.data.length), this.position = t, this._previous();
            {
              var _n29,
                _i18 = o.data.length;
              if (o == this._boundaryStartParent) {
                var _e33 = this.boundaries.start.offset;
                _n29 = new _o(o, _e33, o.data.length - _e33), _i18 = _n29.data.length, t = bi._createBefore(_n29);
              } else _n29 = new _o(o, 0, o.data.length), t.offset--;
              return this.position = t, this._formatReturnValue("text", _n29, e, t, _i18);
            }
          }
          if ("string" == typeof o) {
            var _o12;
            if (this.singleCharacters) _o12 = 1;else {
              var _e34 = n === this._boundaryStartParent ? this.boundaries.start.offset : 0;
              _o12 = t.offset - _e34;
            }
            t.offset -= _o12;
            var _i19 = new _o(n, t.offset, _o12);
            return this.position = t, this._formatReturnValue("text", _i19, e, t, _o12);
          }
          return t = bi._createBefore(n), this.position = t, this._formatReturnValue("elementStart", n, e, t, 1);
        }
      }, {
        key: "_formatReturnValue",
        value: function _formatReturnValue(t, e, n, o, i) {
          return e instanceof _o && (e.offsetInText + e.data.length == e.textNode.data.length && ("forward" != this.direction || this.boundaries && this.boundaries.end.isEqual(this.position) ? n = bi._createAfter(e.textNode) : (o = bi._createAfter(e.textNode), this.position = o)), 0 === e.offsetInText && ("backward" != this.direction || this.boundaries && this.boundaries.start.isEqual(this.position) ? n = bi._createBefore(e.textNode) : (o = bi._createBefore(e.textNode), this.position = o))), {
            done: !1,
            value: {
              type: t,
              item: e,
              previousPosition: n,
              nextPosition: o,
              length: i
            }
          };
        }
      }]);
      return ki;
    }();
    var bi = /*#__PURE__*/function () {
      function bi(t, e) {
        _classCallCheck(this, bi);
        this.parent = t, this.offset = e;
      }
      _createClass(bi, [{
        key: "getShiftedBy",
        value: function getShiftedBy(t) {
          var e = bi._createAt(this),
            n = e.offset + t;
          return e.offset = n < 0 ? 0 : n, e;
        }
      }, {
        key: "getLastMatchingPosition",
        value: function getLastMatchingPosition(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          e.startPosition = this;
          var n = new ki(e);
          return n.skip(t), n.position;
        }
      }, {
        key: "getAncestors",
        value: function getAncestors() {
          return this.parent.is("documentFragment") ? [this.parent] : this.parent.getAncestors({
            includeSelf: !0
          });
        }
      }, {
        key: "getCommonAncestor",
        value: function getCommonAncestor(t) {
          var e = this.getAncestors(),
            n = t.getAncestors();
          var o = 0;
          for (; e[o] == n[o] && e[o];) o++;
          return 0 === o ? null : e[o - 1];
        }
      }, {
        key: "is",
        value: function is(t) {
          return "position" === t || "view:position" === t;
        }
      }, {
        key: "isEqual",
        value: function isEqual(t) {
          return this.parent == t.parent && this.offset == t.offset;
        }
      }, {
        key: "isBefore",
        value: function isBefore(t) {
          return "before" == this.compareWith(t);
        }
      }, {
        key: "isAfter",
        value: function isAfter(t) {
          return "after" == this.compareWith(t);
        }
      }, {
        key: "compareWith",
        value: function compareWith(t) {
          if (this.root !== t.root) return "different";
          if (this.isEqual(t)) return "same";
          var e = this.parent.is("node") ? this.parent.getPath() : [],
            n = t.parent.is("node") ? t.parent.getPath() : [];
          e.push(this.offset), n.push(t.offset);
          var o = bo(e, n);
          switch (o) {
            case "prefix":
              return "before";
            case "extension":
              return "after";
            default:
              return e[o] < n[o] ? "before" : "after";
          }
        }
      }, {
        key: "getWalker",
        value: function getWalker() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          return t.startPosition = this, new ki(t);
        }
      }, {
        key: "clone",
        value: function clone() {
          return new bi(this.parent, this.offset);
        }
      }, {
        key: "nodeAfter",
        get: function get() {
          return this.parent.is("$text") ? null : this.parent.getChild(this.offset) || null;
        }
      }, {
        key: "nodeBefore",
        get: function get() {
          return this.parent.is("$text") ? null : this.parent.getChild(this.offset - 1) || null;
        }
      }, {
        key: "isAtStart",
        get: function get() {
          return 0 === this.offset;
        }
      }, {
        key: "isAtEnd",
        get: function get() {
          var t = this.parent.is("$text") ? this.parent.data.length : this.parent.childCount;
          return this.offset === t;
        }
      }, {
        key: "root",
        get: function get() {
          return this.parent.root;
        }
      }, {
        key: "editableElement",
        get: function get() {
          var t = this.parent;
          for (; !(t instanceof mi);) {
            if (!t.parent) return null;
            t = t.parent;
          }
          return t;
        }
      }], [{
        key: "_createAt",
        value: function _createAt(t, e) {
          if (t instanceof bi) return new this(t.parent, t.offset);
          {
            var _n30 = t;
            if ("end" == e) e = _n30.is("$text") ? _n30.data.length : _n30.childCount;else {
              if ("before" == e) return this._createBefore(_n30);
              if ("after" == e) return this._createAfter(_n30);
              if (0 !== e && !e) throw new c.a("view-createpositionat-offset-required", _n30);
            }
            return new bi(_n30, e);
          }
        }
      }, {
        key: "_createAfter",
        value: function _createAfter(t) {
          if (t.is("$textProxy")) return new bi(t.textNode, t.offsetInText + t.data.length);
          if (!t.parent) throw new c.a("view-position-after-root", t, {
            root: t
          });
          return new bi(t.parent, t.index + 1);
        }
      }, {
        key: "_createBefore",
        value: function _createBefore(t) {
          if (t.is("$textProxy")) return new bi(t.textNode, t.offsetInText);
          if (!t.parent) throw new c.a("view-position-before-root", t, {
            root: t
          });
          return new bi(t.parent, t.index);
        }
      }]);
      return bi;
    }();
    var wi = /*#__PURE__*/function () {
      function wi(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        _classCallCheck(this, wi);
        this.start = t.clone(), this.end = e ? e.clone() : t.clone();
      }
      _createClass(wi, [{
        key: Symbol.iterator,
        value: /*#__PURE__*/_regeneratorRuntime().mark(function value() {
          return _regeneratorRuntime().wrap(function value$(_context6) {
            while (1) switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.delegateYield(new ki({
                  boundaries: this,
                  ignoreElementEnd: !0
                }), "t0", 1);
              case 1:
              case "end":
                return _context6.stop();
            }
          }, value, this);
        })
      }, {
        key: "getEnlarged",
        value: function getEnlarged() {
          var t = this.start.getLastMatchingPosition(Ci, {
              direction: "backward"
            }),
            e = this.end.getLastMatchingPosition(Ci);
          return t.parent.is("$text") && t.isAtStart && (t = bi._createBefore(t.parent)), e.parent.is("$text") && e.isAtEnd && (e = bi._createAfter(e.parent)), new wi(t, e);
        }
      }, {
        key: "getTrimmed",
        value: function getTrimmed() {
          var t = this.start.getLastMatchingPosition(Ci);
          if (t.isAfter(this.end) || t.isEqual(this.end)) return new wi(t, t);
          var e = this.end.getLastMatchingPosition(Ci, {
            direction: "backward"
          });
          var n = t.nodeAfter,
            o = e.nodeBefore;
          return n && n.is("$text") && (t = new bi(n, 0)), o && o.is("$text") && (e = new bi(o, o.data.length)), new wi(t, e);
        }
      }, {
        key: "isEqual",
        value: function isEqual(t) {
          return this == t || this.start.isEqual(t.start) && this.end.isEqual(t.end);
        }
      }, {
        key: "containsPosition",
        value: function containsPosition(t) {
          return t.isAfter(this.start) && t.isBefore(this.end);
        }
      }, {
        key: "containsRange",
        value: function containsRange(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          t.isCollapsed && (e = !1);
          var n = this.containsPosition(t.start) || e && this.start.isEqual(t.start),
            o = this.containsPosition(t.end) || e && this.end.isEqual(t.end);
          return n && o;
        }
      }, {
        key: "getDifference",
        value: function getDifference(t) {
          var e = [];
          return this.isIntersecting(t) ? (this.containsPosition(t.start) && e.push(new wi(this.start, t.start)), this.containsPosition(t.end) && e.push(new wi(t.end, this.end))) : e.push(this.clone()), e;
        }
      }, {
        key: "getIntersection",
        value: function getIntersection(t) {
          if (this.isIntersecting(t)) {
            var _e35 = this.start,
              _n31 = this.end;
            return this.containsPosition(t.start) && (_e35 = t.start), this.containsPosition(t.end) && (_n31 = t.end), new wi(_e35, _n31);
          }
          return null;
        }
      }, {
        key: "getWalker",
        value: function getWalker() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          return t.boundaries = this, new ki(t);
        }
      }, {
        key: "getCommonAncestor",
        value: function getCommonAncestor() {
          return this.start.getCommonAncestor(this.end);
        }
      }, {
        key: "getContainedElement",
        value: function getContainedElement() {
          if (this.isCollapsed) return null;
          var t = this.start.nodeAfter,
            e = this.end.nodeBefore;
          return this.start.parent.is("$text") && this.start.isAtEnd && this.start.parent.nextSibling && (t = this.start.parent.nextSibling), this.end.parent.is("$text") && this.end.isAtStart && this.end.parent.previousSibling && (e = this.end.parent.previousSibling), t && t.is("element") && t === e ? t : null;
        }
      }, {
        key: "clone",
        value: function clone() {
          return new wi(this.start, this.end);
        }
      }, {
        key: "getItems",
        value: function getItems() {
          var _this23 = this;
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          return /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
            var e, _iterator32, _step32, _t28;
            return _regeneratorRuntime().wrap(function _callee$(_context7) {
              while (1) switch (_context7.prev = _context7.next) {
                case 0:
                  t.boundaries = _this23, t.ignoreElementEnd = !0;
                  e = new ki(t);
                  _iterator32 = _createForOfIteratorHelper(e);
                  _context7.prev = 3;
                  _iterator32.s();
                case 5:
                  if ((_step32 = _iterator32.n()).done) {
                    _context7.next = 11;
                    break;
                  }
                  _t28 = _step32.value;
                  _context7.next = 9;
                  return _t28.item;
                case 9:
                  _context7.next = 5;
                  break;
                case 11:
                  _context7.next = 16;
                  break;
                case 13:
                  _context7.prev = 13;
                  _context7.t0 = _context7["catch"](3);
                  _iterator32.e(_context7.t0);
                case 16:
                  _context7.prev = 16;
                  _iterator32.f();
                  return _context7.finish(16);
                case 19:
                case "end":
                  return _context7.stop();
              }
            }, _callee, null, [[3, 13, 16, 19]]);
          })();
        }
      }, {
        key: "getPositions",
        value: function getPositions() {
          var _this24 = this;
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          return /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
            var e, _iterator33, _step33, _t29;
            return _regeneratorRuntime().wrap(function _callee2$(_context8) {
              while (1) switch (_context8.prev = _context8.next) {
                case 0:
                  t.boundaries = _this24;
                  e = new ki(t);
                  _context8.next = 4;
                  return e.position;
                case 4:
                  _iterator33 = _createForOfIteratorHelper(e);
                  _context8.prev = 5;
                  _iterator33.s();
                case 7:
                  if ((_step33 = _iterator33.n()).done) {
                    _context8.next = 13;
                    break;
                  }
                  _t29 = _step33.value;
                  _context8.next = 11;
                  return _t29.nextPosition;
                case 11:
                  _context8.next = 7;
                  break;
                case 13:
                  _context8.next = 18;
                  break;
                case 15:
                  _context8.prev = 15;
                  _context8.t0 = _context8["catch"](5);
                  _iterator33.e(_context8.t0);
                case 18:
                  _context8.prev = 18;
                  _iterator33.f();
                  return _context8.finish(18);
                case 21:
                case "end":
                  return _context8.stop();
              }
            }, _callee2, null, [[5, 15, 18, 21]]);
          })();
        }
      }, {
        key: "is",
        value: function is(t) {
          return "range" === t || "view:range" === t;
        }
      }, {
        key: "isIntersecting",
        value: function isIntersecting(t) {
          return this.start.isBefore(t.end) && this.end.isAfter(t.start);
        }
      }, {
        key: "isCollapsed",
        get: function get() {
          return this.start.isEqual(this.end);
        }
      }, {
        key: "isFlat",
        get: function get() {
          return this.start.parent === this.end.parent;
        }
      }, {
        key: "root",
        get: function get() {
          return this.start.root;
        }
      }], [{
        key: "_createFromParentsAndOffsets",
        value: function _createFromParentsAndOffsets(t, e, n, o) {
          return new this(new bi(t, e), new bi(n, o));
        }
      }, {
        key: "_createFromPositionAndShift",
        value: function _createFromPositionAndShift(t, e) {
          var n = t,
            o = t.getShiftedBy(e);
          return e > 0 ? new this(n, o) : new this(o, n);
        }
      }, {
        key: "_createIn",
        value: function _createIn(t) {
          return this._createFromParentsAndOffsets(t, 0, t, t.childCount);
        }
      }, {
        key: "_createOn",
        value: function _createOn(t) {
          var e = t.is("$textProxy") ? t.offsetSize : 1;
          return this._createFromPositionAndShift(bi._createBefore(t), e);
        }
      }]);
      return wi;
    }();
    function Ci(t) {
      return !(!t.item.is("attributeElement") && !t.item.is("uiElement"));
    }
    function Ai(t) {
      var e = 0;
      var _iterator34 = _createForOfIteratorHelper(t),
        _step34;
      try {
        for (_iterator34.s(); !(_step34 = _iterator34.n()).done;) {
          var _n32 = _step34.value;
          e++;
        }
      } catch (err) {
        _iterator34.e(err);
      } finally {
        _iterator34.f();
      }
      return e;
    }
    var _i = /*#__PURE__*/function () {
      function _i() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var e = arguments.length > 1 ? arguments[1] : undefined;
        var n = arguments.length > 2 ? arguments[2] : undefined;
        _classCallCheck(this, _i);
        this._ranges = [], this._lastRangeBackward = !1, this._isFake = !1, this._fakeSelectionLabel = "", this.setTo(t, e, n);
      }
      _createClass(_i, [{
        key: "getRanges",
        value: /*#__PURE__*/_regeneratorRuntime().mark(function getRanges() {
          var _iterator35, _step35, _t30;
          return _regeneratorRuntime().wrap(function getRanges$(_context9) {
            while (1) switch (_context9.prev = _context9.next) {
              case 0:
                _iterator35 = _createForOfIteratorHelper(this._ranges);
                _context9.prev = 1;
                _iterator35.s();
              case 3:
                if ((_step35 = _iterator35.n()).done) {
                  _context9.next = 9;
                  break;
                }
                _t30 = _step35.value;
                _context9.next = 7;
                return _t30.clone();
              case 7:
                _context9.next = 3;
                break;
              case 9:
                _context9.next = 14;
                break;
              case 11:
                _context9.prev = 11;
                _context9.t0 = _context9["catch"](1);
                _iterator35.e(_context9.t0);
              case 14:
                _context9.prev = 14;
                _iterator35.f();
                return _context9.finish(14);
              case 17:
              case "end":
                return _context9.stop();
            }
          }, getRanges, this, [[1, 11, 14, 17]]);
        })
      }, {
        key: "getFirstRange",
        value: function getFirstRange() {
          var t = null;
          var _iterator36 = _createForOfIteratorHelper(this._ranges),
            _step36;
          try {
            for (_iterator36.s(); !(_step36 = _iterator36.n()).done;) {
              var _e36 = _step36.value;
              t && !_e36.start.isBefore(t.start) || (t = _e36);
            }
          } catch (err) {
            _iterator36.e(err);
          } finally {
            _iterator36.f();
          }
          return t ? t.clone() : null;
        }
      }, {
        key: "getLastRange",
        value: function getLastRange() {
          var t = null;
          var _iterator37 = _createForOfIteratorHelper(this._ranges),
            _step37;
          try {
            for (_iterator37.s(); !(_step37 = _iterator37.n()).done;) {
              var _e37 = _step37.value;
              t && !_e37.end.isAfter(t.end) || (t = _e37);
            }
          } catch (err) {
            _iterator37.e(err);
          } finally {
            _iterator37.f();
          }
          return t ? t.clone() : null;
        }
      }, {
        key: "getFirstPosition",
        value: function getFirstPosition() {
          var t = this.getFirstRange();
          return t ? t.start.clone() : null;
        }
      }, {
        key: "getLastPosition",
        value: function getLastPosition() {
          var t = this.getLastRange();
          return t ? t.end.clone() : null;
        }
      }, {
        key: "isEqual",
        value: function isEqual(t) {
          if (this.isFake != t.isFake) return !1;
          if (this.isFake && this.fakeSelectionLabel != t.fakeSelectionLabel) return !1;
          if (this.rangeCount != t.rangeCount) return !1;
          if (0 === this.rangeCount) return !0;
          if (!this.anchor.isEqual(t.anchor) || !this.focus.isEqual(t.focus)) return !1;
          var _iterator38 = _createForOfIteratorHelper(this._ranges),
            _step38;
          try {
            for (_iterator38.s(); !(_step38 = _iterator38.n()).done;) {
              var _e38 = _step38.value;
              var _n33 = !1;
              var _iterator39 = _createForOfIteratorHelper(t._ranges),
                _step39;
              try {
                for (_iterator39.s(); !(_step39 = _iterator39.n()).done;) {
                  var _o13 = _step39.value;
                  if (_e38.isEqual(_o13)) {
                    _n33 = !0;
                    break;
                  }
                }
              } catch (err) {
                _iterator39.e(err);
              } finally {
                _iterator39.f();
              }
              if (!_n33) return !1;
            }
          } catch (err) {
            _iterator38.e(err);
          } finally {
            _iterator38.f();
          }
          return !0;
        }
      }, {
        key: "isSimilar",
        value: function isSimilar(t) {
          if (this.isBackward != t.isBackward) return !1;
          var e = Ai(this.getRanges());
          if (e != Ai(t.getRanges())) return !1;
          if (0 == e) return !0;
          var _iterator40 = _createForOfIteratorHelper(this.getRanges()),
            _step40;
          try {
            for (_iterator40.s(); !(_step40 = _iterator40.n()).done;) {
              var _e39 = _step40.value;
              _e39 = _e39.getTrimmed();
              var _n34 = !1;
              var _iterator41 = _createForOfIteratorHelper(t.getRanges()),
                _step41;
              try {
                for (_iterator41.s(); !(_step41 = _iterator41.n()).done;) {
                  var _o14 = _step41.value;
                  if (_o14 = _o14.getTrimmed(), _e39.start.isEqual(_o14.start) && _e39.end.isEqual(_o14.end)) {
                    _n34 = !0;
                    break;
                  }
                }
              } catch (err) {
                _iterator41.e(err);
              } finally {
                _iterator41.f();
              }
              if (!_n34) return !1;
            }
          } catch (err) {
            _iterator40.e(err);
          } finally {
            _iterator40.f();
          }
          return !0;
        }
      }, {
        key: "getSelectedElement",
        value: function getSelectedElement() {
          return 1 !== this.rangeCount ? null : this.getFirstRange().getContainedElement();
        }
      }, {
        key: "setTo",
        value: function setTo(t, e, n) {
          if (null === t) this._setRanges([]), this._setFakeOptions(e);else if (t instanceof _i || t instanceof vi) this._setRanges(t.getRanges(), t.isBackward), this._setFakeOptions({
            fake: t.isFake,
            label: t.fakeSelectionLabel
          });else if (t instanceof wi) this._setRanges([t], e && e.backward), this._setFakeOptions(e);else if (t instanceof bi) this._setRanges([new wi(t)]), this._setFakeOptions(e);else if (t instanceof Co) {
            var _o15 = !!n && !!n.backward;
            var _i20;
            if (void 0 === e) throw new c.a("view-selection-setto-required-second-parameter", this);
            _i20 = "in" == e ? wi._createIn(t) : "on" == e ? wi._createOn(t) : new wi(bi._createAt(t, e)), this._setRanges([_i20], _o15), this._setFakeOptions(n);
          } else {
            if (!ao(t)) throw new c.a("view-selection-setto-not-selectable", this);
            this._setRanges(t, e && e.backward), this._setFakeOptions(e);
          }
          this.fire("change");
        }
      }, {
        key: "setFocus",
        value: function setFocus(t, e) {
          if (null === this.anchor) throw new c.a("view-selection-setfocus-no-ranges", this);
          var n = bi._createAt(t, e);
          if ("same" == n.compareWith(this.focus)) return;
          var o = this.anchor;
          this._ranges.pop(), "before" == n.compareWith(o) ? this._addRange(new wi(n, o), !0) : this._addRange(new wi(o, n)), this.fire("change");
        }
      }, {
        key: "is",
        value: function is(t) {
          return "selection" === t || "view:selection" === t;
        }
      }, {
        key: "_setRanges",
        value: function _setRanges(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          t = Array.from(t), this._ranges = [];
          var _iterator42 = _createForOfIteratorHelper(t),
            _step42;
          try {
            for (_iterator42.s(); !(_step42 = _iterator42.n()).done;) {
              var _e40 = _step42.value;
              this._addRange(_e40);
            }
          } catch (err) {
            _iterator42.e(err);
          } finally {
            _iterator42.f();
          }
          this._lastRangeBackward = !!e;
        }
      }, {
        key: "_setFakeOptions",
        value: function _setFakeOptions() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          this._isFake = !!t.fake, this._fakeSelectionLabel = t.fake && t.label || "";
        }
      }, {
        key: "_addRange",
        value: function _addRange(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          if (!(t instanceof wi)) throw new c.a("view-selection-add-range-not-range", this);
          this._pushRange(t), this._lastRangeBackward = !!e;
        }
      }, {
        key: "_pushRange",
        value: function _pushRange(t) {
          var _iterator43 = _createForOfIteratorHelper(this._ranges),
            _step43;
          try {
            for (_iterator43.s(); !(_step43 = _iterator43.n()).done;) {
              var _e41 = _step43.value;
              if (t.isIntersecting(_e41)) throw new c.a("view-selection-range-intersects", this, {
                addedRange: t,
                intersectingRange: _e41
              });
            }
          } catch (err) {
            _iterator43.e(err);
          } finally {
            _iterator43.f();
          }
          this._ranges.push(new wi(t.start, t.end));
        }
      }, {
        key: "isFake",
        get: function get() {
          return this._isFake;
        }
      }, {
        key: "fakeSelectionLabel",
        get: function get() {
          return this._fakeSelectionLabel;
        }
      }, {
        key: "anchor",
        get: function get() {
          if (!this._ranges.length) return null;
          var t = this._ranges[this._ranges.length - 1];
          return (this._lastRangeBackward ? t.end : t.start).clone();
        }
      }, {
        key: "focus",
        get: function get() {
          if (!this._ranges.length) return null;
          var t = this._ranges[this._ranges.length - 1];
          return (this._lastRangeBackward ? t.start : t.end).clone();
        }
      }, {
        key: "isCollapsed",
        get: function get() {
          return 1 === this.rangeCount && this._ranges[0].isCollapsed;
        }
      }, {
        key: "rangeCount",
        get: function get() {
          return this._ranges.length;
        }
      }, {
        key: "isBackward",
        get: function get() {
          return !this.isCollapsed && this._lastRangeBackward;
        }
      }, {
        key: "editableElement",
        get: function get() {
          return this.anchor ? this.anchor.editableElement : null;
        }
      }]);
      return _i;
    }();
    $t(_i, h);
    var vi = /*#__PURE__*/function () {
      function vi() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var e = arguments.length > 1 ? arguments[1] : undefined;
        var n = arguments.length > 2 ? arguments[2] : undefined;
        _classCallCheck(this, vi);
        this._selection = new _i(), this._selection.delegate("change").to(this), this._selection.setTo(t, e, n);
      }
      _createClass(vi, [{
        key: "getRanges",
        value: /*#__PURE__*/_regeneratorRuntime().mark(function getRanges() {
          return _regeneratorRuntime().wrap(function getRanges$(_context10) {
            while (1) switch (_context10.prev = _context10.next) {
              case 0:
                return _context10.delegateYield(this._selection.getRanges(), "t0", 1);
              case 1:
              case "end":
                return _context10.stop();
            }
          }, getRanges, this);
        })
      }, {
        key: "getFirstRange",
        value: function getFirstRange() {
          return this._selection.getFirstRange();
        }
      }, {
        key: "getLastRange",
        value: function getLastRange() {
          return this._selection.getLastRange();
        }
      }, {
        key: "getFirstPosition",
        value: function getFirstPosition() {
          return this._selection.getFirstPosition();
        }
      }, {
        key: "getLastPosition",
        value: function getLastPosition() {
          return this._selection.getLastPosition();
        }
      }, {
        key: "getSelectedElement",
        value: function getSelectedElement() {
          return this._selection.getSelectedElement();
        }
      }, {
        key: "isEqual",
        value: function isEqual(t) {
          return this._selection.isEqual(t);
        }
      }, {
        key: "isSimilar",
        value: function isSimilar(t) {
          return this._selection.isSimilar(t);
        }
      }, {
        key: "is",
        value: function is(t) {
          return "selection" === t || "documentSelection" == t || "view:selection" == t || "view:documentSelection" == t;
        }
      }, {
        key: "_setTo",
        value: function _setTo(t, e, n) {
          this._selection.setTo(t, e, n);
        }
      }, {
        key: "_setFocus",
        value: function _setFocus(t, e) {
          this._selection.setFocus(t, e);
        }
      }, {
        key: "isFake",
        get: function get() {
          return this._selection.isFake;
        }
      }, {
        key: "fakeSelectionLabel",
        get: function get() {
          return this._selection.fakeSelectionLabel;
        }
      }, {
        key: "anchor",
        get: function get() {
          return this._selection.anchor;
        }
      }, {
        key: "focus",
        get: function get() {
          return this._selection.focus;
        }
      }, {
        key: "isCollapsed",
        get: function get() {
          return this._selection.isCollapsed;
        }
      }, {
        key: "rangeCount",
        get: function get() {
          return this._selection.rangeCount;
        }
      }, {
        key: "isBackward",
        get: function get() {
          return this._selection.isBackward;
        }
      }, {
        key: "editableElement",
        get: function get() {
          return this._selection.editableElement;
        }
      }, {
        key: "_ranges",
        get: function get() {
          return this._selection._ranges;
        }
      }]);
      return vi;
    }();
    $t(vi, h);
    var yi = /*#__PURE__*/function (_i21) {
      _inherits(yi, _i21);
      function yi(t, e, n) {
        var _this25;
        _classCallCheck(this, yi);
        _this25 = _possibleConstructorReturn(this, _getPrototypeOf(yi).call(this, t, e)), _this25.startRange = n, _this25._eventPhase = "none", _this25._currentTarget = null;
        return _this25;
      }
      _createClass(yi, [{
        key: "eventPhase",
        get: function get() {
          return this._eventPhase;
        }
      }, {
        key: "currentTarget",
        get: function get() {
          return this._currentTarget;
        }
      }]);
      return yi;
    }(i);
    var xi = Symbol("bubbling contexts");
    var Ei = {
      fire: function fire(t) {
        try {
          var _n35 = t instanceof i ? t : new i(this, t),
            _o16 = Ti(this);
          if (!_o16.size) return;
          for (var _len16 = arguments.length, e = new Array(_len16 > 1 ? _len16 - 1 : 0), _key16 = 1; _key16 < _len16; _key16++) {
            e[_key16 - 1] = arguments[_key16];
          }
          if (Di(_n35, "capturing", this), Mi.apply(void 0, [_o16, "$capture", _n35].concat(e))) return _n35.return;
          var _r8 = _n35.startRange || this.selection.getFirstRange(),
            _s4 = _r8 ? _r8.getContainedElement() : null,
            _a3 = !!_s4 && Boolean(Ii(_o16, _s4));
          var _c2 = _s4 || function (t) {
            if (!t) return null;
            var e = t.start.parent,
              n = t.end.parent,
              o = e.getPath(),
              i = n.getPath();
            return o.length > i.length ? e : n;
          }(_r8);
          if (Di(_n35, "atTarget", _c2), !_a3) {
            if (Mi.apply(void 0, [_o16, "$text", _n35].concat(e))) return _n35.return;
            Di(_n35, "bubbling", _c2);
          }
          for (; _c2;) {
            if (_c2.is("rootElement")) {
              if (Mi.apply(void 0, [_o16, "$root", _n35].concat(e))) return _n35.return;
            } else if (_c2.is("element") && Mi.apply(void 0, [_o16, _c2.name, _n35].concat(e))) return _n35.return;
            if (Mi.apply(void 0, [_o16, _c2, _n35].concat(e))) return _n35.return;
            _c2 = _c2.parent, Di(_n35, "bubbling", _c2);
          }
          return Di(_n35, "bubbling", this), Mi.apply(void 0, [_o16, "$document", _n35].concat(e)), _n35.return;
        } catch (t) {
          c.a.rethrowUnexpectedError(t, this);
        }
      },
      _addEventListener: function _addEventListener(t, e, n) {
        var o = ho(n.context || "$document"),
          i = Ti(this);
        var _iterator44 = _createForOfIteratorHelper(o),
          _step44;
        try {
          for (_iterator44.s(); !(_step44 = _iterator44.n()).done;) {
            var _r9 = _step44.value;
            var _o17 = i.get(_r9);
            _o17 || (_o17 = Object.create(h), i.set(_r9, _o17)), this.listenTo(_o17, t, e, n);
          }
        } catch (err) {
          _iterator44.e(err);
        } finally {
          _iterator44.f();
        }
      },
      _removeEventListener: function _removeEventListener(t, e) {
        var n = Ti(this);
        var _iterator45 = _createForOfIteratorHelper(n.values()),
          _step45;
        try {
          for (_iterator45.s(); !(_step45 = _iterator45.n()).done;) {
            var _o18 = _step45.value;
            this.stopListening(_o18, t, e);
          }
        } catch (err) {
          _iterator45.e(err);
        } finally {
          _iterator45.f();
        }
      }
    };
    function Di(t, e, n) {
      t instanceof yi && (t._eventPhase = e, t._currentTarget = n);
    }
    function Mi(t, e, n) {
      var i = "string" == typeof e ? t.get(e) : Ii(t, e);
      for (var _len17 = arguments.length, o = new Array(_len17 > 3 ? _len17 - 3 : 0), _key17 = 3; _key17 < _len17; _key17++) {
        o[_key17 - 3] = arguments[_key17];
      }
      return !!i && (i.fire.apply(i, [n].concat(o)), n.stop.called);
    }
    function Ii(t, e) {
      var _iterator46 = _createForOfIteratorHelper(t),
        _step46;
      try {
        for (_iterator46.s(); !(_step46 = _iterator46.n()).done;) {
          var _step46$value = _slicedToArray(_step46.value, 2),
            _n36 = _step46$value[0],
            _o19 = _step46$value[1];
          if ("function" == typeof _n36 && _n36(e)) return _o19;
        }
      } catch (err) {
        _iterator46.e(err);
      } finally {
        _iterator46.f();
      }
      return null;
    }
    function Ti(t) {
      return t[xi] || (t[xi] = new Map()), t[xi];
    }
    var Si = /*#__PURE__*/function () {
      function Si(t) {
        _classCallCheck(this, Si);
        this.selection = new vi(), this.roots = new co({
          idProperty: "rootName"
        }), this.stylesProcessor = t, this.set("isReadOnly", !1), this.set("isFocused", !1), this.set("isComposing", !1), this._postFixers = new Set();
      }
      _createClass(Si, [{
        key: "getRoot",
        value: function getRoot() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "main";
          return this.roots.get(t);
        }
      }, {
        key: "registerPostFixer",
        value: function registerPostFixer(t) {
          this._postFixers.add(t);
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.roots.map(function (t) {
            return t.destroy();
          }), this.stopListening();
        }
      }, {
        key: "_callPostFixers",
        value: function _callPostFixers(t) {
          var e = !1;
          do {
            var _iterator47 = _createForOfIteratorHelper(this._postFixers),
              _step47;
            try {
              for (_iterator47.s(); !(_step47 = _iterator47.n()).done;) {
                var _n37 = _step47.value;
                if (e = _n37(t), e) break;
              }
            } catch (err) {
              _iterator47.e(err);
            } finally {
              _iterator47.f();
            }
          } while (e);
        }
      }]);
      return Si;
    }();
    $t(Si, Ei), $t(Si, Gt);
    var Ni = /*#__PURE__*/function (_di2) {
      _inherits(Ni, _di2);
      function Ni(t, e, n, o) {
        var _this26;
        _classCallCheck(this, Ni);
        _this26 = _possibleConstructorReturn(this, _getPrototypeOf(Ni).call(this, t, e, n, o)), _this26.getFillerOffset = Bi, _this26._priority = 10, _this26._id = null, _this26._clonesGroup = null;
        return _this26;
      }
      _createClass(Ni, [{
        key: "getElementsWithSameId",
        value: function getElementsWithSameId() {
          if (null === this.id) throw new c.a("attribute-element-get-elements-with-same-id-no-id", this);
          return new Set(this._clonesGroup);
        }
      }, {
        key: "is",
        value: function is(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          return e ? e === this.name && ("attributeElement" === t || "view:attributeElement" === t || "element" === t || "view:element" === t) : "attributeElement" === t || "view:attributeElement" === t || "element" === t || "view:element" === t || "node" === t || "view:node" === t;
        }
      }, {
        key: "isSimilar",
        value: function isSimilar(t) {
          return null !== this.id || null !== t.id ? this.id === t.id : _get(_getPrototypeOf(Ni.prototype), "isSimilar", this).call(this, t) && this.priority == t.priority;
        }
      }, {
        key: "_clone",
        value: function _clone(t) {
          var e = _get(_getPrototypeOf(Ni.prototype), "_clone", this).call(this, t);
          return e._priority = this._priority, e._id = this._id, e;
        }
      }, {
        key: "priority",
        get: function get() {
          return this._priority;
        }
      }, {
        key: "id",
        get: function get() {
          return this._id;
        }
      }]);
      return Ni;
    }(di);
    function Bi() {
      if (Pi(this)) return null;
      var t = this.parent;
      for (; t && t.is("attributeElement");) {
        if (Pi(t) > 1) return null;
        t = t.parent;
      }
      return !t || Pi(t) > 1 ? null : this.childCount;
    }
    function Pi(t) {
      return Array.from(t.getChildren()).filter(function (t) {
        return !t.is("uiElement");
      }).length;
    }
    Ni.DEFAULT_PRIORITY = 10;
    var zi = /*#__PURE__*/function (_di3) {
      _inherits(zi, _di3);
      function zi(t, e, n, o) {
        var _this27;
        _classCallCheck(this, zi);
        _this27 = _possibleConstructorReturn(this, _getPrototypeOf(zi).call(this, t, e, n, o)), _this27._isAllowedInsideAttributeElement = !0, _this27.getFillerOffset = Li;
        return _this27;
      }
      _createClass(zi, [{
        key: "is",
        value: function is(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          return e ? e === this.name && ("emptyElement" === t || "view:emptyElement" === t || "element" === t || "view:element" === t) : "emptyElement" === t || "view:emptyElement" === t || "element" === t || "view:element" === t || "node" === t || "view:node" === t;
        }
      }, {
        key: "_insertChild",
        value: function _insertChild(t, e) {
          if (e && (e instanceof Co || Array.from(e).length > 0)) throw new c.a("view-emptyelement-cannot-add", [this, e]);
        }
      }]);
      return zi;
    }(di);
    function Li() {
      return null;
    }
    var Oi = navigator.userAgent.toLowerCase();
    var Ri = {
      isMac: function (t) {
        return t.indexOf("macintosh") > -1;
      }(Oi),
      isGecko: function (t) {
        return !!t.match(/gecko\/\d+/);
      }(Oi),
      isSafari: function (t) {
        return t.indexOf(" applewebkit/") > -1 && -1 === t.indexOf("chrome");
      }(Oi),
      isAndroid: function (t) {
        return t.indexOf("android") > -1;
      }(Oi),
      isBlink: function (t) {
        return t.indexOf("chrome/") > -1 && t.indexOf("edge/") < 0;
      }(Oi),
      features: {
        isRegExpUnicodePropertySupported: function () {
          var t = !1;
          try {
            t = 0 === "ć".search(new RegExp("[\\p{L}]", "u"));
          } catch (t) {}
          return t;
        }()
      }
    };
    var ji = {
        ctrl: "⌃",
        cmd: "⌘",
        alt: "⌥",
        shift: "⇧"
      },
      Fi = {
        ctrl: "Ctrl+",
        alt: "Alt+",
        shift: "Shift+"
      },
      Vi = function () {
        var t = {
          arrowleft: 37,
          arrowup: 38,
          arrowright: 39,
          arrowdown: 40,
          backspace: 8,
          delete: 46,
          enter: 13,
          space: 32,
          esc: 27,
          tab: 9,
          ctrl: 1114112,
          shift: 2228224,
          alt: 4456448,
          cmd: 8912896
        };
        for (var _e43 = 65; _e43 <= 90; _e43++) {
          var _n38 = String.fromCharCode(_e43);
          t[_n38.toLowerCase()] = _e43;
        }
        for (var _e45 = 48; _e45 <= 57; _e45++) t[_e45 - 48] = _e45;
        for (var _e47 = 112; _e47 <= 123; _e47++) t["f" + (_e47 - 111)] = _e47;
        return t;
      }(),
      Ui = Object.fromEntries(Object.entries(Vi).map(function (_ref9) {
        var _ref10 = _slicedToArray(_ref9, 2),
          t = _ref10[0],
          e = _ref10[1];
        return [e, t.charAt(0).toUpperCase() + t.slice(1)];
      }));
    function Hi(t) {
      var e;
      if ("string" == typeof t) {
        if (e = Vi[t.toLowerCase()], !e) throw new c.a("keyboard-unknown-key", null, {
          key: t
        });
      } else e = t.keyCode + (t.altKey ? Vi.alt : 0) + (t.ctrlKey ? Vi.ctrl : 0) + (t.shiftKey ? Vi.shift : 0) + (t.metaKey ? Vi.cmd : 0);
      return e;
    }
    function Gi(t) {
      return "string" == typeof t && (t = function (t) {
        return t.split("+").map(function (t) {
          return t.trim();
        });
      }(t)), t.map(function (t) {
        return "string" == typeof t ? function (t) {
          if (t.endsWith("!")) return Hi(t.slice(0, -1));
          var e = Hi(t);
          return Ri.isMac && e == Vi.ctrl ? Vi.cmd : e;
        }(t) : t;
      }).reduce(function (t, e) {
        return e + t;
      }, 0);
    }
    function Wi(t) {
      var e = Gi(t);
      return Object.entries(Ri.isMac ? ji : Fi).reduce(function (t, _ref11) {
        var _ref12 = _slicedToArray(_ref11, 2),
          n = _ref12[0],
          o = _ref12[1];
        return 0 != (e & Vi[n]) && (e &= ~Vi[n], t += o), t;
      }, "") + (e ? Ui[e] : "");
    }
    function qi(t, e) {
      var n = "ltr" === e;
      switch (t) {
        case Vi.arrowleft:
          return n ? "left" : "right";
        case Vi.arrowright:
          return n ? "right" : "left";
        case Vi.arrowup:
          return "up";
        case Vi.arrowdown:
          return "down";
      }
    }
    function Ki(t, e) {
      var n = qi(t, e);
      return "down" === n || "right" === n;
    }
    var Yi = /*#__PURE__*/function (_di4) {
      _inherits(Yi, _di4);
      function Yi(t, e, n, o) {
        var _this28;
        _classCallCheck(this, Yi);
        _this28 = _possibleConstructorReturn(this, _getPrototypeOf(Yi).call(this, t, e, n, o)), _this28._isAllowedInsideAttributeElement = !0, _this28.getFillerOffset = $i;
        return _this28;
      }
      _createClass(Yi, [{
        key: "is",
        value: function is(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          return e ? e === this.name && ("uiElement" === t || "view:uiElement" === t || "element" === t || "view:element" === t) : "uiElement" === t || "view:uiElement" === t || "element" === t || "view:element" === t || "node" === t || "view:node" === t;
        }
      }, {
        key: "_insertChild",
        value: function _insertChild(t, e) {
          if (e && (e instanceof Co || Array.from(e).length > 0)) throw new c.a("view-uielement-cannot-add", this);
        }
      }, {
        key: "render",
        value: function render(t) {
          return this.toDomElement(t);
        }
      }, {
        key: "toDomElement",
        value: function toDomElement(t) {
          var e = t.createElement(this.name);
          var _iterator48 = _createForOfIteratorHelper(this.getAttributeKeys()),
            _step48;
          try {
            for (_iterator48.s(); !(_step48 = _iterator48.n()).done;) {
              var _t31 = _step48.value;
              e.setAttribute(_t31, this.getAttribute(_t31));
            }
          } catch (err) {
            _iterator48.e(err);
          } finally {
            _iterator48.f();
          }
          return e;
        }
      }]);
      return Yi;
    }(di);
    function Qi(t) {
      t.document.on("arrowKey", function (e, n) {
        return function (t, e, n) {
          if (e.keyCode == Vi.arrowright) {
            var _t32 = e.domTarget.ownerDocument.defaultView.getSelection(),
              _o20 = 1 == _t32.rangeCount && _t32.getRangeAt(0).collapsed;
            if (_o20 || e.shiftKey) {
              var _e48 = _t32.focusNode,
                _i22 = _t32.focusOffset,
                _r10 = n.domPositionToView(_e48, _i22);
              if (null === _r10) return;
              var _s5 = !1;
              var _a4 = _r10.getLastMatchingPosition(function (t) {
                return t.item.is("uiElement") && (_s5 = !0), !(!t.item.is("uiElement") && !t.item.is("attributeElement"));
              });
              if (_s5) {
                var _e49 = n.viewPositionToDom(_a4);
                _o20 ? _t32.collapse(_e49.parent, _e49.offset) : _t32.extend(_e49.parent, _e49.offset);
              }
            }
          }
        }(0, n, t.domConverter);
      }, {
        priority: "low"
      });
    }
    function $i() {
      return null;
    }
    var Ji = /*#__PURE__*/function (_di5) {
      _inherits(Ji, _di5);
      function Ji(t, e, n, o) {
        var _this29;
        _classCallCheck(this, Ji);
        _this29 = _possibleConstructorReturn(this, _getPrototypeOf(Ji).call(this, t, e, n, o)), _this29._isAllowedInsideAttributeElement = !0, _this29.getFillerOffset = Zi;
        return _this29;
      }
      _createClass(Ji, [{
        key: "is",
        value: function is(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          return e ? e === this.name && ("rawElement" === t || "view:rawElement" === t || "element" === t || "view:element" === t) : "rawElement" === t || "view:rawElement" === t || t === this.name || t === "view:" + this.name || "element" === t || "view:element" === t || "node" === t || "view:node" === t;
        }
      }, {
        key: "_insertChild",
        value: function _insertChild(t, e) {
          if (e && (e instanceof Co || Array.from(e).length > 0)) throw new c.a("view-rawelement-cannot-add", [this, e]);
        }
      }]);
      return Ji;
    }(di);
    function Zi() {
      return null;
    }
    var Xi = /*#__PURE__*/function () {
      function Xi(t, e) {
        _classCallCheck(this, Xi);
        this.document = t, this._children = [], e && this._insertChild(0, e);
      }
      _createClass(Xi, [{
        key: Symbol.iterator,
        value: function value() {
          return this._children[Symbol.iterator]();
        }
      }, {
        key: "is",
        value: function is(t) {
          return "documentFragment" === t || "view:documentFragment" === t;
        }
      }, {
        key: "_appendChild",
        value: function _appendChild(t) {
          return this._insertChild(this.childCount, t);
        }
      }, {
        key: "getChild",
        value: function getChild(t) {
          return this._children[t];
        }
      }, {
        key: "getChildIndex",
        value: function getChildIndex(t) {
          return this._children.indexOf(t);
        }
      }, {
        key: "getChildren",
        value: function getChildren() {
          return this._children[Symbol.iterator]();
        }
      }, {
        key: "_insertChild",
        value: function _insertChild(t, e) {
          this._fireChange("children", this);
          var n = 0;
          var o = function (t, e) {
            if ("string" == typeof e) return [new Ao(t, e)];
            ao(e) || (e = [e]);
            return Array.from(e).map(function (e) {
              return "string" == typeof e ? new Ao(t, e) : e instanceof _o ? new Ao(t, e.data) : e;
            });
          }(this.document, e);
          var _iterator49 = _createForOfIteratorHelper(o),
            _step49;
          try {
            for (_iterator49.s(); !(_step49 = _iterator49.n()).done;) {
              var _e50 = _step49.value;
              null !== _e50.parent && _e50._remove(), _e50.parent = this, this._children.splice(t, 0, _e50), t++, n++;
            }
          } catch (err) {
            _iterator49.e(err);
          } finally {
            _iterator49.f();
          }
          return n;
        }
      }, {
        key: "_removeChildren",
        value: function _removeChildren(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
          this._fireChange("children", this);
          for (var _n40 = t; _n40 < t + e; _n40++) this._children[_n40].parent = null;
          return this._children.splice(t, e);
        }
      }, {
        key: "_fireChange",
        value: function _fireChange(t, e) {
          this.fire("change:" + t, e);
        }
      }, {
        key: "childCount",
        get: function get() {
          return this._children.length;
        }
      }, {
        key: "isEmpty",
        get: function get() {
          return 0 === this.childCount;
        }
      }, {
        key: "root",
        get: function get() {
          return this;
        }
      }, {
        key: "parent",
        get: function get() {
          return null;
        }
      }]);
      return Xi;
    }();
    $t(Xi, h);
    var tr = /*#__PURE__*/function () {
      function tr(t) {
        _classCallCheck(this, tr);
        this.document = t, this._cloneGroups = new Map();
      }
      _createClass(tr, [{
        key: "setSelection",
        value: function setSelection(t, e, n) {
          this.document.selection._setTo(t, e, n);
        }
      }, {
        key: "setSelectionFocus",
        value: function setSelectionFocus(t, e) {
          this.document.selection._setFocus(t, e);
        }
      }, {
        key: "createDocumentFragment",
        value: function createDocumentFragment(t) {
          return new Xi(this.document, t);
        }
      }, {
        key: "createText",
        value: function createText(t) {
          return new Ao(this.document, t);
        }
      }, {
        key: "createAttributeElement",
        value: function createAttributeElement(t, e) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          var o = new Ni(this.document, t, e);
          return "number" == typeof n.priority && (o._priority = n.priority), n.id && (o._id = n.id), o;
        }
      }, {
        key: "createContainerElement",
        value: function createContainerElement(t, e) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          var o = new ui(this.document, t, e);
          return void 0 !== n.isAllowedInsideAttributeElement && (o._isAllowedInsideAttributeElement = n.isAllowedInsideAttributeElement), o;
        }
      }, {
        key: "createEditableElement",
        value: function createEditableElement(t, e) {
          var n = new mi(this.document, t, e);
          return n._document = this.document, n;
        }
      }, {
        key: "createEmptyElement",
        value: function createEmptyElement(t, e) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          var o = new zi(this.document, t, e);
          return void 0 !== n.isAllowedInsideAttributeElement && (o._isAllowedInsideAttributeElement = n.isAllowedInsideAttributeElement), o;
        }
      }, {
        key: "createUIElement",
        value: function createUIElement(t, e, n) {
          var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
          var i = new Yi(this.document, t, e);
          return n && (i.render = n), void 0 !== o.isAllowedInsideAttributeElement && (i._isAllowedInsideAttributeElement = o.isAllowedInsideAttributeElement), i;
        }
      }, {
        key: "createRawElement",
        value: function createRawElement(t, e, n) {
          var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
          var i = new Ji(this.document, t, e);
          return i.render = n || function () {}, void 0 !== o.isAllowedInsideAttributeElement && (i._isAllowedInsideAttributeElement = o.isAllowedInsideAttributeElement), i;
        }
      }, {
        key: "setAttribute",
        value: function setAttribute(t, e, n) {
          n._setAttribute(t, e);
        }
      }, {
        key: "removeAttribute",
        value: function removeAttribute(t, e) {
          e._removeAttribute(t);
        }
      }, {
        key: "addClass",
        value: function addClass(t, e) {
          e._addClass(t);
        }
      }, {
        key: "removeClass",
        value: function removeClass(t, e) {
          e._removeClass(t);
        }
      }, {
        key: "setStyle",
        value: function setStyle(t, e, n) {
          le(t) && void 0 === n && (n = e), n._setStyle(t, e);
        }
      }, {
        key: "removeStyle",
        value: function removeStyle(t, e) {
          e._removeStyle(t);
        }
      }, {
        key: "setCustomProperty",
        value: function setCustomProperty(t, e, n) {
          n._setCustomProperty(t, e);
        }
      }, {
        key: "removeCustomProperty",
        value: function removeCustomProperty(t, e) {
          return e._removeCustomProperty(t);
        }
      }, {
        key: "breakAttributes",
        value: function breakAttributes(t) {
          return t instanceof bi ? this._breakAttributes(t) : this._breakAttributesRange(t);
        }
      }, {
        key: "breakContainer",
        value: function breakContainer(t) {
          var e = t.parent;
          if (!e.is("containerElement")) throw new c.a("view-writer-break-non-container-element", this.document);
          if (!e.parent) throw new c.a("view-writer-break-root", this.document);
          if (t.isAtStart) return bi._createBefore(e);
          if (!t.isAtEnd) {
            var _n41 = e._clone(!1);
            this.insert(bi._createAfter(e), _n41);
            var _o21 = new wi(t, bi._createAt(e, "end")),
              _i23 = new bi(_n41, 0);
            this.move(_o21, _i23);
          }
          return bi._createAfter(e);
        }
      }, {
        key: "mergeAttributes",
        value: function mergeAttributes(t) {
          var e = t.offset,
            n = t.parent;
          if (n.is("$text")) return t;
          if (n.is("attributeElement") && 0 === n.childCount) {
            var _t33 = n.parent,
              _e51 = n.index;
            return n._remove(), this._removeFromClonedElementsGroup(n), this.mergeAttributes(new bi(_t33, _e51));
          }
          var o = n.getChild(e - 1),
            i = n.getChild(e);
          if (!o || !i) return t;
          if (o.is("$text") && i.is("$text")) return rr(o, i);
          if (o.is("attributeElement") && i.is("attributeElement") && o.isSimilar(i)) {
            var _t34 = o.childCount;
            return o._appendChild(i.getChildren()), i._remove(), this._removeFromClonedElementsGroup(i), this.mergeAttributes(new bi(o, _t34));
          }
          return t;
        }
      }, {
        key: "mergeContainers",
        value: function mergeContainers(t) {
          var e = t.nodeBefore,
            n = t.nodeAfter;
          if (!(e && n && e.is("containerElement") && n.is("containerElement"))) throw new c.a("view-writer-merge-containers-invalid-position", this.document);
          var o = e.getChild(e.childCount - 1),
            i = o instanceof Ao ? bi._createAt(o, "end") : bi._createAt(e, "end");
          return this.move(wi._createIn(n), bi._createAt(e, "end")), this.remove(wi._createOn(n)), i;
        }
      }, {
        key: "insert",
        value: function insert(t, e) {
          sr(e = ao(e) ? _toConsumableArray(e) : [e], this.document);
          var n = e.reduce(function (t, e) {
            var n = t[t.length - 1],
              o = !(e.is("uiElement") && e.isAllowedInsideAttributeElement);
            return n && n.breakAttributes == o ? n.nodes.push(e) : t.push({
              breakAttributes: o,
              nodes: [e]
            }), t;
          }, []);
          var o = null,
            i = t;
          var _iterator50 = _createForOfIteratorHelper(n),
            _step50;
          try {
            for (_iterator50.s(); !(_step50 = _iterator50.n()).done;) {
              var _step50$value = _step50.value,
                _t35 = _step50$value.nodes,
                _e52 = _step50$value.breakAttributes;
              var _n42 = this._insertNodes(i, _t35, _e52);
              o || (o = _n42.start), i = _n42.end;
            }
          } catch (err) {
            _iterator50.e(err);
          } finally {
            _iterator50.f();
          }
          return o ? new wi(o, i) : new wi(t);
        }
      }, {
        key: "remove",
        value: function remove(t) {
          var e = t instanceof wi ? t : wi._createOn(t);
          if (lr(e, this.document), e.isCollapsed) return new Xi(this.document);
          var _this$_breakAttribute = this._breakAttributesRange(e, !0),
            n = _this$_breakAttribute.start,
            o = _this$_breakAttribute.end,
            i = n.parent,
            r = o.offset - n.offset,
            s = i._removeChildren(n.offset, r);
          var _iterator51 = _createForOfIteratorHelper(s),
            _step51;
          try {
            for (_iterator51.s(); !(_step51 = _iterator51.n()).done;) {
              var _t36 = _step51.value;
              this._removeFromClonedElementsGroup(_t36);
            }
          } catch (err) {
            _iterator51.e(err);
          } finally {
            _iterator51.f();
          }
          var a = this.mergeAttributes(n);
          return e.start = a, e.end = a.clone(), new Xi(this.document, s);
        }
      }, {
        key: "clear",
        value: function clear(t, e) {
          lr(t, this.document);
          var n = t.getWalker({
            direction: "backward",
            ignoreElementEnd: !0
          });
          var _iterator52 = _createForOfIteratorHelper(n),
            _step52;
          try {
            for (_iterator52.s(); !(_step52 = _iterator52.n()).done;) {
              var _o22 = _step52.value;
              var _n43 = _o22.item;
              var _i24 = void 0;
              if (_n43.is("element") && e.isSimilar(_n43)) _i24 = wi._createOn(_n43);else if (!_o22.nextPosition.isAfter(t.start) && _n43.is("$textProxy")) {
                var _t37 = _n43.getAncestors().find(function (t) {
                  return t.is("element") && e.isSimilar(t);
                });
                _t37 && (_i24 = wi._createIn(_t37));
              }
              _i24 && (_i24.end.isAfter(t.end) && (_i24.end = t.end), _i24.start.isBefore(t.start) && (_i24.start = t.start), this.remove(_i24));
            }
          } catch (err) {
            _iterator52.e(err);
          } finally {
            _iterator52.f();
          }
        }
      }, {
        key: "move",
        value: function move(t, e) {
          var n;
          if (e.isAfter(t.end)) {
            var _o23 = (e = this._breakAttributes(e, !0)).parent,
              _i25 = _o23.childCount;
            t = this._breakAttributesRange(t, !0), n = this.remove(t), e.offset += _o23.childCount - _i25;
          } else n = this.remove(t);
          return this.insert(e, n);
        }
      }, {
        key: "wrap",
        value: function wrap(t, e) {
          if (!(e instanceof Ni)) throw new c.a("view-writer-wrap-invalid-attribute", this.document);
          if (lr(t, this.document), t.isCollapsed) {
            var _o24 = t.start;
            _o24.parent.is("element") && (n = _o24.parent, !Array.from(n.getChildren()).some(function (t) {
              return !t.is("uiElement");
            })) && (_o24 = _o24.getLastMatchingPosition(function (t) {
              return t.item.is("uiElement");
            })), _o24 = this._wrapPosition(_o24, e);
            var _i26 = this.document.selection;
            return _i26.isCollapsed && _i26.getFirstPosition().isEqual(t.start) && this.setSelection(_o24), new wi(_o24);
          }
          return this._wrapRange(t, e);
          var n;
        }
      }, {
        key: "unwrap",
        value: function unwrap(t, e) {
          if (!(e instanceof Ni)) throw new c.a("view-writer-unwrap-invalid-attribute", this.document);
          if (lr(t, this.document), t.isCollapsed) return t;
          var _this$_breakAttribute2 = this._breakAttributesRange(t, !0),
            n = _this$_breakAttribute2.start,
            o = _this$_breakAttribute2.end,
            i = n.parent,
            r = this._unwrapChildren(i, n.offset, o.offset, e),
            s = this.mergeAttributes(r.start);
          s.isEqual(r.start) || r.end.offset--;
          var a = this.mergeAttributes(r.end);
          return new wi(s, a);
        }
      }, {
        key: "rename",
        value: function rename(t, e) {
          var n = new ui(this.document, t, e.getAttributes());
          return this.insert(bi._createAfter(e), n), this.move(wi._createIn(e), bi._createAt(n, 0)), this.remove(wi._createOn(e)), n;
        }
      }, {
        key: "clearClonedElementsGroup",
        value: function clearClonedElementsGroup(t) {
          this._cloneGroups.delete(t);
        }
      }, {
        key: "createPositionAt",
        value: function createPositionAt(t, e) {
          return bi._createAt(t, e);
        }
      }, {
        key: "createPositionAfter",
        value: function createPositionAfter(t) {
          return bi._createAfter(t);
        }
      }, {
        key: "createPositionBefore",
        value: function createPositionBefore(t) {
          return bi._createBefore(t);
        }
      }, {
        key: "createRange",
        value: function createRange(t, e) {
          return new wi(t, e);
        }
      }, {
        key: "createRangeOn",
        value: function createRangeOn(t) {
          return wi._createOn(t);
        }
      }, {
        key: "createRangeIn",
        value: function createRangeIn(t) {
          return wi._createIn(t);
        }
      }, {
        key: "createSelection",
        value: function createSelection(t, e, n) {
          return new _i(t, e, n);
        }
      }, {
        key: "_insertNodes",
        value: function _insertNodes(t, e, n) {
          var o, i;
          if (o = n ? er(t) : t.parent.is("$text") ? t.parent.parent : t.parent, !o) throw new c.a("view-writer-invalid-position-container", this.document);
          i = n ? this._breakAttributes(t, !0) : t.parent.is("$text") ? ir(t) : t;
          var r = o._insertChild(i.offset, e);
          var _iterator53 = _createForOfIteratorHelper(e),
            _step53;
          try {
            for (_iterator53.s(); !(_step53 = _iterator53.n()).done;) {
              var _t38 = _step53.value;
              this._addToClonedElementsGroup(_t38);
            }
          } catch (err) {
            _iterator53.e(err);
          } finally {
            _iterator53.f();
          }
          var s = i.getShiftedBy(r),
            a = this.mergeAttributes(i);
          a.isEqual(i) || s.offset--;
          var l = this.mergeAttributes(s);
          return new wi(a, l);
        }
      }, {
        key: "_wrapChildren",
        value: function _wrapChildren(t, e, n, o) {
          var i = e;
          var r = [];
          for (; i < n;) {
            var _e53 = t.getChild(i),
              _n44 = _e53.is("$text"),
              _s6 = _e53.is("attributeElement"),
              _a5 = _e53.isAllowedInsideAttributeElement;
            if (_s6 && this._wrapAttributeElement(o, _e53)) r.push(new bi(t, i));else if (_n44 || _a5 || _s6 && nr(o, _e53)) {
              var _n45 = o._clone();
              _e53._remove(), _n45._appendChild(_e53), t._insertChild(i, _n45), this._addToClonedElementsGroup(_n45), r.push(new bi(t, i));
            } else _s6 && this._wrapChildren(_e53, 0, _e53.childCount, o);
            i++;
          }
          var s = 0;
          for (var _i27 = 0, _r11 = r; _i27 < _r11.length; _i27++) {
            var _t39 = _r11[_i27];
            if (_t39.offset -= s, _t39.offset == e) continue;
            this.mergeAttributes(_t39).isEqual(_t39) || (s++, n--);
          }
          return wi._createFromParentsAndOffsets(t, e, t, n);
        }
      }, {
        key: "_unwrapChildren",
        value: function _unwrapChildren(t, e, n, o) {
          var i = e;
          var r = [];
          for (; i < n;) {
            var _e54 = t.getChild(i);
            if (_e54.is("attributeElement")) {
              if (_e54.isSimilar(o)) {
                var _o25 = _e54.getChildren(),
                  _s7 = _e54.childCount;
                _e54._remove(), t._insertChild(i, _o25), this._removeFromClonedElementsGroup(_e54), r.push(new bi(t, i), new bi(t, i + _s7)), i += _s7, n += _s7 - 1;
              } else this._unwrapAttributeElement(o, _e54) ? (r.push(new bi(t, i), new bi(t, i + 1)), i++) : (this._unwrapChildren(_e54, 0, _e54.childCount, o), i++);
            } else i++;
          }
          var s = 0;
          for (var _i28 = 0, _r12 = r; _i28 < _r12.length; _i28++) {
            var _t40 = _r12[_i28];
            if (_t40.offset -= s, _t40.offset == e || _t40.offset == n) continue;
            this.mergeAttributes(_t40).isEqual(_t40) || (s++, n--);
          }
          return wi._createFromParentsAndOffsets(t, e, t, n);
        }
      }, {
        key: "_wrapRange",
        value: function _wrapRange(t, e) {
          var _this$_breakAttribute3 = this._breakAttributesRange(t, !0),
            n = _this$_breakAttribute3.start,
            o = _this$_breakAttribute3.end,
            i = n.parent,
            r = this._wrapChildren(i, n.offset, o.offset, e),
            s = this.mergeAttributes(r.start);
          s.isEqual(r.start) || r.end.offset--;
          var a = this.mergeAttributes(r.end);
          return new wi(s, a);
        }
      }, {
        key: "_wrapPosition",
        value: function _wrapPosition(t, e) {
          if (e.isSimilar(t.parent)) return or(t.clone());
          t.parent.is("$text") && (t = ir(t));
          var n = this.createAttributeElement();
          n._priority = Number.POSITIVE_INFINITY, n.isSimilar = function () {
            return !1;
          }, t.parent._insertChild(t.offset, n);
          var o = new wi(t, t.getShiftedBy(1));
          this.wrap(o, e);
          var i = new bi(n.parent, n.index);
          n._remove();
          var r = i.nodeBefore,
            s = i.nodeAfter;
          return r instanceof Ao && s instanceof Ao ? rr(r, s) : or(i);
        }
      }, {
        key: "_wrapAttributeElement",
        value: function _wrapAttributeElement(t, e) {
          if (!dr(t, e)) return !1;
          if (t.name !== e.name || t.priority !== e.priority) return !1;
          var _iterator54 = _createForOfIteratorHelper(t.getAttributeKeys()),
            _step54;
          try {
            for (_iterator54.s(); !(_step54 = _iterator54.n()).done;) {
              var _n46 = _step54.value;
              if ("class" !== _n46 && "style" !== _n46 && e.hasAttribute(_n46) && e.getAttribute(_n46) !== t.getAttribute(_n46)) return !1;
            }
          } catch (err) {
            _iterator54.e(err);
          } finally {
            _iterator54.f();
          }
          var _iterator55 = _createForOfIteratorHelper(t.getStyleNames()),
            _step55;
          try {
            for (_iterator55.s(); !(_step55 = _iterator55.n()).done;) {
              var _n47 = _step55.value;
              if (e.hasStyle(_n47) && e.getStyle(_n47) !== t.getStyle(_n47)) return !1;
            }
          } catch (err) {
            _iterator55.e(err);
          } finally {
            _iterator55.f();
          }
          var _iterator56 = _createForOfIteratorHelper(t.getAttributeKeys()),
            _step56;
          try {
            for (_iterator56.s(); !(_step56 = _iterator56.n()).done;) {
              var _n48 = _step56.value;
              "class" !== _n48 && "style" !== _n48 && (e.hasAttribute(_n48) || this.setAttribute(_n48, t.getAttribute(_n48), e));
            }
          } catch (err) {
            _iterator56.e(err);
          } finally {
            _iterator56.f();
          }
          var _iterator57 = _createForOfIteratorHelper(t.getStyleNames()),
            _step57;
          try {
            for (_iterator57.s(); !(_step57 = _iterator57.n()).done;) {
              var _n49 = _step57.value;
              e.hasStyle(_n49) || this.setStyle(_n49, t.getStyle(_n49), e);
            }
          } catch (err) {
            _iterator57.e(err);
          } finally {
            _iterator57.f();
          }
          var _iterator58 = _createForOfIteratorHelper(t.getClassNames()),
            _step58;
          try {
            for (_iterator58.s(); !(_step58 = _iterator58.n()).done;) {
              var _n50 = _step58.value;
              e.hasClass(_n50) || this.addClass(_n50, e);
            }
          } catch (err) {
            _iterator58.e(err);
          } finally {
            _iterator58.f();
          }
          return !0;
        }
      }, {
        key: "_unwrapAttributeElement",
        value: function _unwrapAttributeElement(t, e) {
          if (!dr(t, e)) return !1;
          if (t.name !== e.name || t.priority !== e.priority) return !1;
          var _iterator59 = _createForOfIteratorHelper(t.getAttributeKeys()),
            _step59;
          try {
            for (_iterator59.s(); !(_step59 = _iterator59.n()).done;) {
              var _n51 = _step59.value;
              if ("class" !== _n51 && "style" !== _n51 && (!e.hasAttribute(_n51) || e.getAttribute(_n51) !== t.getAttribute(_n51))) return !1;
            }
          } catch (err) {
            _iterator59.e(err);
          } finally {
            _iterator59.f();
          }
          if (!e.hasClass.apply(e, _toConsumableArray(t.getClassNames()))) return !1;
          var _iterator60 = _createForOfIteratorHelper(t.getStyleNames()),
            _step60;
          try {
            for (_iterator60.s(); !(_step60 = _iterator60.n()).done;) {
              var _n52 = _step60.value;
              if (!e.hasStyle(_n52) || e.getStyle(_n52) !== t.getStyle(_n52)) return !1;
            }
          } catch (err) {
            _iterator60.e(err);
          } finally {
            _iterator60.f();
          }
          var _iterator61 = _createForOfIteratorHelper(t.getAttributeKeys()),
            _step61;
          try {
            for (_iterator61.s(); !(_step61 = _iterator61.n()).done;) {
              var _n53 = _step61.value;
              "class" !== _n53 && "style" !== _n53 && this.removeAttribute(_n53, e);
            }
          } catch (err) {
            _iterator61.e(err);
          } finally {
            _iterator61.f();
          }
          return this.removeClass(Array.from(t.getClassNames()), e), this.removeStyle(Array.from(t.getStyleNames()), e), !0;
        }
      }, {
        key: "_breakAttributesRange",
        value: function _breakAttributesRange(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          var n = t.start,
            o = t.end;
          if (lr(t, this.document), t.isCollapsed) {
            var _n54 = this._breakAttributes(t.start, e);
            return new wi(_n54, _n54);
          }
          var i = this._breakAttributes(o, e),
            r = i.parent.childCount,
            s = this._breakAttributes(n, e);
          return i.offset += i.parent.childCount - r, new wi(s, i);
        }
      }, {
        key: "_breakAttributes",
        value: function _breakAttributes(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          var n = t.offset,
            o = t.parent;
          if (t.parent.is("emptyElement")) throw new c.a("view-writer-cannot-break-empty-element", this.document);
          if (t.parent.is("uiElement")) throw new c.a("view-writer-cannot-break-ui-element", this.document);
          if (t.parent.is("rawElement")) throw new c.a("view-writer-cannot-break-raw-element", this.document);
          if (!e && o.is("$text") && cr(o.parent)) return t.clone();
          if (cr(o)) return t.clone();
          if (o.is("$text")) return this._breakAttributes(ir(t), e);
          if (n == o.childCount) {
            var _t41 = new bi(o.parent, o.index + 1);
            return this._breakAttributes(_t41, e);
          }
          if (0 === n) {
            var _t42 = new bi(o.parent, o.index);
            return this._breakAttributes(_t42, e);
          }
          {
            var _t43 = o.index + 1,
              _i29 = o._clone();
            o.parent._insertChild(_t43, _i29), this._addToClonedElementsGroup(_i29);
            var _r13 = o.childCount - n,
              _s8 = o._removeChildren(n, _r13);
            _i29._appendChild(_s8);
            var _a6 = new bi(o.parent, _t43);
            return this._breakAttributes(_a6, e);
          }
        }
      }, {
        key: "_addToClonedElementsGroup",
        value: function _addToClonedElementsGroup(t) {
          if (!t.root.is("rootElement")) return;
          if (t.is("element")) {
            var _iterator62 = _createForOfIteratorHelper(t.getChildren()),
              _step62;
            try {
              for (_iterator62.s(); !(_step62 = _iterator62.n()).done;) {
                var _e55 = _step62.value;
                this._addToClonedElementsGroup(_e55);
              }
            } catch (err) {
              _iterator62.e(err);
            } finally {
              _iterator62.f();
            }
          }
          var e = t.id;
          if (!e) return;
          var n = this._cloneGroups.get(e);
          n || (n = new Set(), this._cloneGroups.set(e, n)), n.add(t), t._clonesGroup = n;
        }
      }, {
        key: "_removeFromClonedElementsGroup",
        value: function _removeFromClonedElementsGroup(t) {
          if (t.is("element")) {
            var _iterator63 = _createForOfIteratorHelper(t.getChildren()),
              _step63;
            try {
              for (_iterator63.s(); !(_step63 = _iterator63.n()).done;) {
                var _e56 = _step63.value;
                this._removeFromClonedElementsGroup(_e56);
              }
            } catch (err) {
              _iterator63.e(err);
            } finally {
              _iterator63.f();
            }
          }
          var e = t.id;
          if (!e) return;
          var n = this._cloneGroups.get(e);
          n && n.delete(t);
        }
      }]);
      return tr;
    }();
    function er(t) {
      var e = t.parent;
      for (; !cr(e);) {
        if (!e) return;
        e = e.parent;
      }
      return e;
    }
    function nr(t, e) {
      return t.priority < e.priority || !(t.priority > e.priority) && t.getIdentity() < e.getIdentity();
    }
    function or(t) {
      var e = t.nodeBefore;
      if (e && e.is("$text")) return new bi(e, e.data.length);
      var n = t.nodeAfter;
      return n && n.is("$text") ? new bi(n, 0) : t;
    }
    function ir(t) {
      if (t.offset == t.parent.data.length) return new bi(t.parent.parent, t.parent.index + 1);
      if (0 === t.offset) return new bi(t.parent.parent, t.parent.index);
      var e = t.parent.data.slice(t.offset);
      return t.parent._data = t.parent.data.slice(0, t.offset), t.parent.parent._insertChild(t.parent.index + 1, new Ao(t.root.document, e)), new bi(t.parent.parent, t.parent.index + 1);
    }
    function rr(t, e) {
      var n = t.data.length;
      return t._data += e.data, e._remove(), new bi(t, n);
    }
    function sr(t, e) {
      var _iterator64 = _createForOfIteratorHelper(t),
        _step64;
      try {
        var _loop = function _loop() {
          var n = _step64.value;
          if (!ar.some(function (t) {
            return n instanceof t;
          })) throw new c.a("view-writer-insert-invalid-node-type", e);
          n.is("$text") || sr(n.getChildren(), e);
        };
        for (_iterator64.s(); !(_step64 = _iterator64.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator64.e(err);
      } finally {
        _iterator64.f();
      }
    }
    var ar = [Ao, Ni, ui, zi, Ji, Yi];
    function cr(t) {
      return t && (t.is("containerElement") || t.is("documentFragment"));
    }
    function lr(t, e) {
      var n = er(t.start),
        o = er(t.end);
      if (!n || !o || n !== o) throw new c.a("view-writer-invalid-range-container", e);
    }
    function dr(t, e) {
      return null === t.id && null === e.id;
    }
    function hr(t) {
      return "[object Text]" == Object.prototype.toString.call(t);
    }
    var ur = function ur(t) {
        return t.createTextNode(" ");
      },
      gr = function gr(t) {
        var e = t.createElement("span");
        return e.dataset.ckeFiller = !0, e.innerHTML = " ", e;
      },
      mr = function mr(t) {
        var e = t.createElement("br");
        return e.dataset.ckeFiller = !0, e;
      },
      pr = "⁠".repeat(7);
    function fr(t) {
      return hr(t) && t.data.substr(0, 7) === pr;
    }
    function kr(t) {
      return 7 == t.data.length && fr(t);
    }
    function br(t) {
      return fr(t) ? t.data.slice(7) : t.data;
    }
    function wr(t, e) {
      if (e.keyCode == Vi.arrowleft) {
        var _t44 = e.domTarget.ownerDocument.defaultView.getSelection();
        if (1 == _t44.rangeCount && _t44.getRangeAt(0).collapsed) {
          var _e57 = _t44.getRangeAt(0).startContainer,
            _n55 = _t44.getRangeAt(0).startOffset;
          fr(_e57) && _n55 <= 7 && _t44.collapse(_e57, 0);
        }
      }
    }
    function Cr(t, e, n) {
      var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
      n = n || function (t, e) {
        return t === e;
      }, Array.isArray(t) || (t = Array.prototype.slice.call(t)), Array.isArray(e) || (e = Array.prototype.slice.call(e));
      var i = function (t, e, n) {
        var o = Ar(t, e, n);
        if (-1 === o) return {
          firstIndex: -1,
          lastIndexOld: -1,
          lastIndexNew: -1
        };
        var i = _r(t, o),
          r = _r(e, o),
          s = Ar(i, r, n),
          a = t.length - s,
          c = e.length - s;
        return {
          firstIndex: o,
          lastIndexOld: a,
          lastIndexNew: c
        };
      }(t, e, n);
      return o ? function (t, e) {
        var n = t.firstIndex,
          o = t.lastIndexOld,
          i = t.lastIndexNew;
        if (-1 === n) return Array(e).fill("equal");
        var r = [];
        n > 0 && (r = r.concat(Array(n).fill("equal")));
        i - n > 0 && (r = r.concat(Array(i - n).fill("insert")));
        o - n > 0 && (r = r.concat(Array(o - n).fill("delete")));
        i < e && (r = r.concat(Array(e - i).fill("equal")));
        return r;
      }(i, e.length) : function (t, e) {
        var n = [],
          o = e.firstIndex,
          i = e.lastIndexOld,
          r = e.lastIndexNew;
        r - o > 0 && n.push({
          index: o,
          type: "insert",
          values: t.slice(o, r)
        });
        i - o > 0 && n.push({
          index: o + (r - o),
          type: "delete",
          howMany: i - o
        });
        return n;
      }(e, i);
    }
    function Ar(t, e, n) {
      for (var _o27 = 0; _o27 < Math.max(t.length, e.length); _o27++) if (void 0 === t[_o27] || void 0 === e[_o27] || !n(t[_o27], e[_o27])) return _o27;
      return -1;
    }
    function _r(t, e) {
      return t.slice(e).reverse();
    }
    function vr(t, e, n) {
      n = n || function (t, e) {
        return t === e;
      };
      var o = t.length,
        i = e.length;
      if (o > 200 || i > 200 || o + i > 300) return vr.fastDiff(t, e, n, !0);
      var r, s;
      if (i < o) {
        var _n56 = t;
        t = e, e = _n56, r = "delete", s = "insert";
      } else r = "insert", s = "delete";
      var a = t.length,
        c = e.length,
        l = c - a,
        d = {},
        h = {};
      function u(o) {
        var i = (void 0 !== h[o - 1] ? h[o - 1] : -1) + 1,
          l = void 0 !== h[o + 1] ? h[o + 1] : -1,
          u = i > l ? -1 : 1;
        d[o + u] && (d[o] = d[o + u].slice(0)), d[o] || (d[o] = []), d[o].push(i > l ? r : s);
        var g = Math.max(i, l),
          m = g - o;
        for (; m < a && g < c && n(t[m], e[g]);) m++, g++, d[o].push("equal");
        return g;
      }
      var g,
        m = 0;
      do {
        for (g = -m; g < l; g++) h[g] = u(g);
        for (g = l + m; g > l; g--) h[g] = u(g);
        h[l] = u(l), m++;
      } while (h[l] !== c);
      return d[l].slice(1);
    }
    function yr(t, e, n) {
      t.insertBefore(n, t.childNodes[e] || null);
    }
    function xr(t) {
      var e = t.parentNode;
      e && e.removeChild(t);
    }
    function Er(t) {
      if (t) {
        if (t.defaultView) return t instanceof t.defaultView.Document;
        if (t.ownerDocument && t.ownerDocument.defaultView) return t instanceof t.ownerDocument.defaultView.Node;
      }
      return !1;
    }
    vr.fastDiff = Cr;
    var Dr = /*#__PURE__*/function () {
      function Dr(t, e) {
        _classCallCheck(this, Dr);
        this.domDocuments = new Set(), this.domConverter = t, this.markedAttributes = new Set(), this.markedChildren = new Set(), this.markedTexts = new Set(), this.selection = e, this.isFocused = !1, this._inlineFiller = null, this._fakeSelectionContainer = null;
      }
      _createClass(Dr, [{
        key: "markToSync",
        value: function markToSync(t, e) {
          if ("text" === t) this.domConverter.mapViewToDom(e.parent) && this.markedTexts.add(e);else {
            if (!this.domConverter.mapViewToDom(e)) return;
            if ("attributes" === t) this.markedAttributes.add(e);else {
              if ("children" !== t) throw new c.a("view-renderer-unknown-type", this);
              this.markedChildren.add(e);
            }
          }
        }
      }, {
        key: "render",
        value: function render() {
          var t;
          var _iterator65 = _createForOfIteratorHelper(this.markedChildren),
            _step65;
          try {
            for (_iterator65.s(); !(_step65 = _iterator65.n()).done;) {
              var _t45 = _step65.value;
              this._updateChildrenMappings(_t45);
            }
          } catch (err) {
            _iterator65.e(err);
          } finally {
            _iterator65.f();
          }
          this._inlineFiller && !this._isSelectionInInlineFiller() && this._removeInlineFiller(), this._inlineFiller ? t = this._getInlineFillerPosition() : this._needsInlineFillerAtSelection() && (t = this.selection.getFirstPosition(), this.markedChildren.add(t.parent));
          var _iterator66 = _createForOfIteratorHelper(this.markedAttributes),
            _step66;
          try {
            for (_iterator66.s(); !(_step66 = _iterator66.n()).done;) {
              var _t46 = _step66.value;
              this._updateAttrs(_t46);
            }
          } catch (err) {
            _iterator66.e(err);
          } finally {
            _iterator66.f();
          }
          var _iterator67 = _createForOfIteratorHelper(this.markedChildren),
            _step67;
          try {
            for (_iterator67.s(); !(_step67 = _iterator67.n()).done;) {
              var _e59 = _step67.value;
              this._updateChildren(_e59, {
                inlineFillerPosition: t
              });
            }
          } catch (err) {
            _iterator67.e(err);
          } finally {
            _iterator67.f();
          }
          var _iterator68 = _createForOfIteratorHelper(this.markedTexts),
            _step68;
          try {
            for (_iterator68.s(); !(_step68 = _iterator68.n()).done;) {
              var _e60 = _step68.value;
              !this.markedChildren.has(_e60.parent) && this.domConverter.mapViewToDom(_e60.parent) && this._updateText(_e60, {
                inlineFillerPosition: t
              });
            }
          } catch (err) {
            _iterator68.e(err);
          } finally {
            _iterator68.f();
          }
          if (t) {
            var _e58 = this.domConverter.viewPositionToDom(t),
              _n57 = _e58.parent.ownerDocument;
            fr(_e58.parent) ? this._inlineFiller = _e58.parent : this._inlineFiller = Mr(_n57, _e58.parent, _e58.offset);
          } else this._inlineFiller = null;
          this._updateFocus(), this._updateSelection(), this.markedTexts.clear(), this.markedAttributes.clear(), this.markedChildren.clear();
        }
      }, {
        key: "_updateChildrenMappings",
        value: function _updateChildrenMappings(t) {
          var e = this.domConverter.mapViewToDom(t);
          if (!e) return;
          var n = Array.from(this.domConverter.mapViewToDom(t).childNodes),
            o = Array.from(this.domConverter.viewChildrenToDom(t, e.ownerDocument, {
              withChildren: !1
            })),
            i = this._diffNodeLists(n, o),
            r = this._findReplaceActions(i, n, o);
          if (-1 !== r.indexOf("replace")) {
            var _e61 = {
              equal: 0,
              insert: 0,
              delete: 0
            };
            var _iterator69 = _createForOfIteratorHelper(r),
              _step69;
            try {
              for (_iterator69.s(); !(_step69 = _iterator69.n()).done;) {
                var _i30 = _step69.value;
                if ("replace" === _i30) {
                  var _i31 = _e61.equal + _e61.insert,
                    _r14 = _e61.equal + _e61.delete,
                    _s9 = t.getChild(_i31);
                  !_s9 || _s9.is("uiElement") || _s9.is("rawElement") || this._updateElementMappings(_s9, n[_r14]), xr(o[_i31]), _e61.equal++;
                } else _e61[_i30]++;
              }
            } catch (err) {
              _iterator69.e(err);
            } finally {
              _iterator69.f();
            }
          }
        }
      }, {
        key: "_updateElementMappings",
        value: function _updateElementMappings(t, e) {
          this.domConverter.unbindDomElement(e), this.domConverter.bindElements(e, t), this.markedChildren.add(t), this.markedAttributes.add(t);
        }
      }, {
        key: "_getInlineFillerPosition",
        value: function _getInlineFillerPosition() {
          var t = this.selection.getFirstPosition();
          return t.parent.is("$text") ? bi._createBefore(this.selection.getFirstPosition().parent) : t;
        }
      }, {
        key: "_isSelectionInInlineFiller",
        value: function _isSelectionInInlineFiller() {
          if (1 != this.selection.rangeCount || !this.selection.isCollapsed) return !1;
          var t = this.selection.getFirstPosition(),
            e = this.domConverter.viewPositionToDom(t);
          return !!(e && hr(e.parent) && fr(e.parent));
        }
      }, {
        key: "_removeInlineFiller",
        value: function _removeInlineFiller() {
          var t = this._inlineFiller;
          if (!fr(t)) throw new c.a("view-renderer-filler-was-lost", this);
          kr(t) ? t.parentNode.removeChild(t) : t.data = t.data.substr(7), this._inlineFiller = null;
        }
      }, {
        key: "_needsInlineFillerAtSelection",
        value: function _needsInlineFillerAtSelection() {
          if (1 != this.selection.rangeCount || !this.selection.isCollapsed) return !1;
          var t = this.selection.getFirstPosition(),
            e = t.parent,
            n = t.offset;
          if (!this.domConverter.mapViewToDom(e.root)) return !1;
          if (!e.is("element")) return !1;
          if (!function (t) {
            if ("false" == t.getAttribute("contenteditable")) return !1;
            var e = t.findAncestor(function (t) {
              return t.hasAttribute("contenteditable");
            });
            return !e || "true" == e.getAttribute("contenteditable");
          }(e)) return !1;
          if (n === e.getFillerOffset()) return !1;
          var o = t.nodeBefore,
            i = t.nodeAfter;
          return !(o instanceof Ao || i instanceof Ao);
        }
      }, {
        key: "_updateText",
        value: function _updateText(t, e) {
          var n = this.domConverter.findCorrespondingDomText(t),
            o = this.domConverter.viewToDom(t, n.ownerDocument),
            i = n.data;
          var r = o.data;
          var s = e.inlineFillerPosition;
          if (s && s.parent == t.parent && s.offset == t.index && (r = pr + r), i != r) {
            var _t47 = Cr(i, r);
            var _iterator70 = _createForOfIteratorHelper(_t47),
              _step70;
            try {
              for (_iterator70.s(); !(_step70 = _iterator70.n()).done;) {
                var _e62 = _step70.value;
                "insert" === _e62.type ? n.insertData(_e62.index, _e62.values.join("")) : n.deleteData(_e62.index, _e62.howMany);
              }
            } catch (err) {
              _iterator70.e(err);
            } finally {
              _iterator70.f();
            }
          }
        }
      }, {
        key: "_updateAttrs",
        value: function _updateAttrs(t) {
          var e = this.domConverter.mapViewToDom(t);
          if (!e) return;
          var n = Array.from(e.attributes).map(function (t) {
              return t.name;
            }),
            o = t.getAttributeKeys();
          var _iterator71 = _createForOfIteratorHelper(o),
            _step71;
          try {
            for (_iterator71.s(); !(_step71 = _iterator71.n()).done;) {
              var _n58 = _step71.value;
              e.setAttribute(_n58, t.getAttribute(_n58));
            }
          } catch (err) {
            _iterator71.e(err);
          } finally {
            _iterator71.f();
          }
          var _iterator72 = _createForOfIteratorHelper(n),
            _step72;
          try {
            for (_iterator72.s(); !(_step72 = _iterator72.n()).done;) {
              var _o28 = _step72.value;
              t.hasAttribute(_o28) || e.removeAttribute(_o28);
            }
          } catch (err) {
            _iterator72.e(err);
          } finally {
            _iterator72.f();
          }
        }
      }, {
        key: "_updateChildren",
        value: function _updateChildren(t, e) {
          var n = this.domConverter.mapViewToDom(t);
          if (!n) return;
          var o = e.inlineFillerPosition,
            i = this.domConverter.mapViewToDom(t).childNodes,
            r = Array.from(this.domConverter.viewChildrenToDom(t, n.ownerDocument, {
              bind: !0,
              inlineFillerPosition: o
            }));
          o && o.parent === t && Mr(n.ownerDocument, r, o.offset);
          var s = this._diffNodeLists(i, r);
          var a = 0;
          var c = new Set();
          var _iterator73 = _createForOfIteratorHelper(s),
            _step73;
          try {
            for (_iterator73.s(); !(_step73 = _iterator73.n()).done;) {
              var _t48 = _step73.value;
              "delete" === _t48 ? (c.add(i[a]), xr(i[a])) : "equal" === _t48 && a++;
            }
          } catch (err) {
            _iterator73.e(err);
          } finally {
            _iterator73.f();
          }
          a = 0;
          var _iterator74 = _createForOfIteratorHelper(s),
            _step74;
          try {
            for (_iterator74.s(); !(_step74 = _iterator74.n()).done;) {
              var _t49 = _step74.value;
              "insert" === _t49 ? (yr(n, a, r[a]), a++) : "equal" === _t49 && (this._markDescendantTextToSync(this.domConverter.domToView(r[a])), a++);
            }
          } catch (err) {
            _iterator74.e(err);
          } finally {
            _iterator74.f();
          }
          var _iterator75 = _createForOfIteratorHelper(c),
            _step75;
          try {
            for (_iterator75.s(); !(_step75 = _iterator75.n()).done;) {
              var _t50 = _step75.value;
              _t50.parentNode || this.domConverter.unbindDomElement(_t50);
            }
          } catch (err) {
            _iterator75.e(err);
          } finally {
            _iterator75.f();
          }
        }
      }, {
        key: "_diffNodeLists",
        value: function _diffNodeLists(t, e) {
          return vr(t = function (t, e) {
            var n = Array.from(t);
            if (0 == n.length || !e) return n;
            n[n.length - 1] == e && n.pop();
            return n;
          }(t, this._fakeSelectionContainer), e, Tr.bind(null, this.domConverter));
        }
      }, {
        key: "_findReplaceActions",
        value: function _findReplaceActions(t, e, n) {
          if (-1 === t.indexOf("insert") || -1 === t.indexOf("delete")) return t;
          var o = [],
            i = [],
            r = [];
          var s = {
            equal: 0,
            insert: 0,
            delete: 0
          };
          var _iterator76 = _createForOfIteratorHelper(t),
            _step76;
          try {
            for (_iterator76.s(); !(_step76 = _iterator76.n()).done;) {
              var _a7 = _step76.value;
              "insert" === _a7 ? r.push(n[s.equal + s.insert]) : "delete" === _a7 ? i.push(e[s.equal + s.delete]) : (o = o.concat(vr(i, r, Ir).map(function (t) {
                return "equal" === t ? "replace" : t;
              })), o.push("equal"), i = [], r = []), s[_a7]++;
            }
          } catch (err) {
            _iterator76.e(err);
          } finally {
            _iterator76.f();
          }
          return o.concat(vr(i, r, Ir).map(function (t) {
            return "equal" === t ? "replace" : t;
          }));
        }
      }, {
        key: "_markDescendantTextToSync",
        value: function _markDescendantTextToSync(t) {
          if (t) if (t.is("$text")) this.markedTexts.add(t);else if (t.is("element")) {
            var _iterator77 = _createForOfIteratorHelper(t.getChildren()),
              _step77;
            try {
              for (_iterator77.s(); !(_step77 = _iterator77.n()).done;) {
                var _e63 = _step77.value;
                this._markDescendantTextToSync(_e63);
              }
            } catch (err) {
              _iterator77.e(err);
            } finally {
              _iterator77.f();
            }
          }
        }
      }, {
        key: "_updateSelection",
        value: function _updateSelection() {
          if (0 === this.selection.rangeCount) return this._removeDomSelection(), void this._removeFakeSelection();
          var t = this.domConverter.mapViewToDom(this.selection.editableElement);
          this.isFocused && t && (this.selection.isFake ? this._updateFakeSelection(t) : (this._removeFakeSelection(), this._updateDomSelection(t)));
        }
      }, {
        key: "_updateFakeSelection",
        value: function _updateFakeSelection(t) {
          var e = t.ownerDocument;
          this._fakeSelectionContainer || (this._fakeSelectionContainer = function (t) {
            var e = t.createElement("div");
            return e.className = "ck-fake-selection-container", Object.assign(e.style, {
              position: "fixed",
              top: 0,
              left: "-9999px",
              width: "42px"
            }), e.textContent = " ", e;
          }(e));
          var n = this._fakeSelectionContainer;
          if (this.domConverter.bindFakeSelection(n, this.selection), !this._fakeSelectionNeedsUpdate(t)) return;
          n.parentElement && n.parentElement == t || t.appendChild(n), n.textContent = this.selection.fakeSelectionLabel || " ";
          var o = e.getSelection(),
            i = e.createRange();
          o.removeAllRanges(), i.selectNodeContents(n), o.addRange(i);
        }
      }, {
        key: "_updateDomSelection",
        value: function _updateDomSelection(t) {
          var e = t.ownerDocument.defaultView.getSelection();
          if (!this._domSelectionNeedsUpdate(e)) return;
          var n = this.domConverter.viewPositionToDom(this.selection.anchor),
            o = this.domConverter.viewPositionToDom(this.selection.focus);
          e.collapse(n.parent, n.offset), e.extend(o.parent, o.offset), Ri.isGecko && function (t, e) {
            var n = t.parent;
            if (n.nodeType != Node.ELEMENT_NODE || t.offset != n.childNodes.length - 1) return;
            var o = n.childNodes[t.offset];
            o && "BR" == o.tagName && e.addRange(e.getRangeAt(0));
          }(o, e);
        }
      }, {
        key: "_domSelectionNeedsUpdate",
        value: function _domSelectionNeedsUpdate(t) {
          if (!this.domConverter.isDomSelectionCorrect(t)) return !0;
          var e = t && this.domConverter.domSelectionToView(t);
          return (!e || !this.selection.isEqual(e)) && !(!this.selection.isCollapsed && this.selection.isSimilar(e));
        }
      }, {
        key: "_fakeSelectionNeedsUpdate",
        value: function _fakeSelectionNeedsUpdate(t) {
          var e = this._fakeSelectionContainer,
            n = t.ownerDocument.getSelection();
          return !e || e.parentElement !== t || n.anchorNode !== e && !e.contains(n.anchorNode) || e.textContent !== this.selection.fakeSelectionLabel;
        }
      }, {
        key: "_removeDomSelection",
        value: function _removeDomSelection() {
          var _iterator78 = _createForOfIteratorHelper(this.domDocuments),
            _step78;
          try {
            for (_iterator78.s(); !(_step78 = _iterator78.n()).done;) {
              var _t51 = _step78.value;
              if (_t51.getSelection().rangeCount) {
                var _e64 = _t51.activeElement,
                  _n59 = this.domConverter.mapDomToView(_e64);
                _e64 && _n59 && _t51.getSelection().removeAllRanges();
              }
            }
          } catch (err) {
            _iterator78.e(err);
          } finally {
            _iterator78.f();
          }
        }
      }, {
        key: "_removeFakeSelection",
        value: function _removeFakeSelection() {
          var t = this._fakeSelectionContainer;
          t && t.remove();
        }
      }, {
        key: "_updateFocus",
        value: function _updateFocus() {
          if (this.isFocused) {
            var _t52 = this.selection.editableElement;
            _t52 && this.domConverter.focus(_t52);
          }
        }
      }]);
      return Dr;
    }();
    function Mr(t, e, n) {
      var o = e instanceof Array ? e : e.childNodes,
        i = o[n];
      if (hr(i)) return i.data = pr + i.data, i;
      {
        var _i32 = t.createTextNode(pr);
        return Array.isArray(e) ? o.splice(n, 0, _i32) : yr(e, n, _i32), _i32;
      }
    }
    function Ir(t, e) {
      return Er(t) && Er(e) && !hr(t) && !hr(e) && t.nodeType !== Node.COMMENT_NODE && e.nodeType !== Node.COMMENT_NODE && t.tagName.toLowerCase() === e.tagName.toLowerCase();
    }
    function Tr(t, e, n) {
      return e === n || (hr(e) && hr(n) ? e.data === n.data : !(!t.isBlockFiller(e) || !t.isBlockFiller(n)));
    }
    $t(Dr, Gt);
    var Sr = {
      window: window,
      document: document
    };
    function Nr(t) {
      var e = 0;
      for (; t.previousSibling;) t = t.previousSibling, e++;
      return e;
    }
    function Br(t) {
      var e = [];
      for (; t && t.nodeType != Node.DOCUMENT_NODE;) e.unshift(t), t = t.parentNode;
      return e;
    }
    var Pr = mr(document),
      zr = ur(document),
      Lr = gr(document);
    var Or = /*#__PURE__*/function () {
      function Or(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        _classCallCheck(this, Or);
        this.document = t, this.blockFillerMode = e.blockFillerMode || "br", this.preElements = ["pre"], this.blockElements = ["address", "article", "aside", "blockquote", "caption", "center", "dd", "details", "dir", "div", "dl", "dt", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "header", "hgroup", "legend", "li", "main", "menu", "nav", "ol", "p", "pre", "section", "summary", "table", "tbody", "td", "tfoot", "th", "thead", "tr", "ul"], this._domToViewMapping = new WeakMap(), this._viewToDomMapping = new WeakMap(), this._fakeSelectionMapping = new WeakMap(), this._rawContentElementMatcher = new yo(), this._encounteredRawContentDomNodes = new WeakSet();
      }
      _createClass(Or, [{
        key: "bindFakeSelection",
        value: function bindFakeSelection(t, e) {
          this._fakeSelectionMapping.set(t, new _i(e));
        }
      }, {
        key: "fakeSelectionToView",
        value: function fakeSelectionToView(t) {
          return this._fakeSelectionMapping.get(t);
        }
      }, {
        key: "bindElements",
        value: function bindElements(t, e) {
          this._domToViewMapping.set(t, e), this._viewToDomMapping.set(e, t);
        }
      }, {
        key: "unbindDomElement",
        value: function unbindDomElement(t) {
          var e = this._domToViewMapping.get(t);
          if (e) {
            this._domToViewMapping.delete(t), this._viewToDomMapping.delete(e);
            var _iterator79 = _createForOfIteratorHelper(t.childNodes),
              _step79;
            try {
              for (_iterator79.s(); !(_step79 = _iterator79.n()).done;) {
                var _e65 = _step79.value;
                this.unbindDomElement(_e65);
              }
            } catch (err) {
              _iterator79.e(err);
            } finally {
              _iterator79.f();
            }
          }
        }
      }, {
        key: "bindDocumentFragments",
        value: function bindDocumentFragments(t, e) {
          this._domToViewMapping.set(t, e), this._viewToDomMapping.set(e, t);
        }
      }, {
        key: "viewToDom",
        value: function viewToDom(t, e) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          if (t.is("$text")) {
            var _n60 = this._processDataFromViewText(t);
            return e.createTextNode(_n60);
          }
          {
            if (this.mapViewToDom(t)) return this.mapViewToDom(t);
            var _o29;
            if (t.is("documentFragment")) _o29 = e.createDocumentFragment(), n.bind && this.bindDocumentFragments(_o29, t);else {
              if (t.is("uiElement")) return _o29 = t.render(e), n.bind && this.bindElements(_o29, t), _o29;
              _o29 = t.hasAttribute("xmlns") ? e.createElementNS(t.getAttribute("xmlns"), t.name) : e.createElement(t.name), t.is("rawElement") && t.render(_o29), n.bind && this.bindElements(_o29, t);
              var _iterator80 = _createForOfIteratorHelper(t.getAttributeKeys()),
                _step80;
              try {
                for (_iterator80.s(); !(_step80 = _iterator80.n()).done;) {
                  var _e66 = _step80.value;
                  _o29.setAttribute(_e66, t.getAttribute(_e66));
                }
              } catch (err) {
                _iterator80.e(err);
              } finally {
                _iterator80.f();
              }
            }
            if (!1 !== n.withChildren) {
              var _iterator81 = _createForOfIteratorHelper(this.viewChildrenToDom(t, e, n)),
                _step81;
              try {
                for (_iterator81.s(); !(_step81 = _iterator81.n()).done;) {
                  var _i33 = _step81.value;
                  _o29.appendChild(_i33);
                }
              } catch (err) {
                _iterator81.e(err);
              } finally {
                _iterator81.f();
              }
            }
            return _o29;
          }
        }
      }, {
        key: "viewChildrenToDom",
        value: function viewChildrenToDom(t, e) {
          var _this30 = this;
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          return /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
            var o, i, _iterator82, _step82, _r15;
            return _regeneratorRuntime().wrap(function _callee3$(_context11) {
              while (1) switch (_context11.prev = _context11.next) {
                case 0:
                  o = t.getFillerOffset && t.getFillerOffset();
                  i = 0;
                  _iterator82 = _createForOfIteratorHelper(t.getChildren());
                  _context11.prev = 3;
                  _iterator82.s();
                case 5:
                  if ((_step82 = _iterator82.n()).done) {
                    _context11.next = 16;
                    break;
                  }
                  _r15 = _step82.value;
                  _context11.t0 = o === i;
                  if (!_context11.t0) {
                    _context11.next = 11;
                    break;
                  }
                  _context11.next = 11;
                  return _this30._getBlockFiller(e);
                case 11:
                  _context11.next = 13;
                  return _this30.viewToDom(_r15, e, n);
                case 13:
                  i++;
                case 14:
                  _context11.next = 5;
                  break;
                case 16:
                  _context11.next = 21;
                  break;
                case 18:
                  _context11.prev = 18;
                  _context11.t1 = _context11["catch"](3);
                  _iterator82.e(_context11.t1);
                case 21:
                  _context11.prev = 21;
                  _iterator82.f();
                  return _context11.finish(21);
                case 24:
                  _context11.t2 = o === i;
                  if (!_context11.t2) {
                    _context11.next = 28;
                    break;
                  }
                  _context11.next = 28;
                  return _this30._getBlockFiller(e);
                case 28:
                case "end":
                  return _context11.stop();
              }
            }, _callee3, null, [[3, 18, 21, 24]]);
          })();
        }
      }, {
        key: "viewRangeToDom",
        value: function viewRangeToDom(t) {
          var e = this.viewPositionToDom(t.start),
            n = this.viewPositionToDom(t.end),
            o = document.createRange();
          return o.setStart(e.parent, e.offset), o.setEnd(n.parent, n.offset), o;
        }
      }, {
        key: "viewPositionToDom",
        value: function viewPositionToDom(t) {
          var e = t.parent;
          if (e.is("$text")) {
            var _n61 = this.findCorrespondingDomText(e);
            if (!_n61) return null;
            var _o30 = t.offset;
            return fr(_n61) && (_o30 += 7), {
              parent: _n61,
              offset: _o30
            };
          }
          {
            var _n62, _o31, _i34;
            if (0 === t.offset) {
              if (_n62 = this.mapViewToDom(e), !_n62) return null;
              _i34 = _n62.childNodes[0];
            } else {
              var _e67 = t.nodeBefore;
              if (_o31 = _e67.is("$text") ? this.findCorrespondingDomText(_e67) : this.mapViewToDom(t.nodeBefore), !_o31) return null;
              _n62 = _o31.parentNode, _i34 = _o31.nextSibling;
            }
            if (hr(_i34) && fr(_i34)) return {
              parent: _i34,
              offset: 7
            };
            return {
              parent: _n62,
              offset: _o31 ? Nr(_o31) + 1 : 0
            };
          }
        }
      }, {
        key: "domToView",
        value: function domToView(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          if (this.isBlockFiller(t)) return null;
          var n = this.getHostViewElement(t);
          if (n) return n;
          if (hr(t)) {
            if (kr(t)) return null;
            {
              var _e68 = this._processDataFromDomText(t);
              return "" === _e68 ? null : new Ao(this.document, _e68);
            }
          }
          if (this.isComment(t)) return null;
          {
            if (this.mapDomToView(t)) return this.mapDomToView(t);
            var _n63;
            if (this.isDocumentFragment(t)) _n63 = new Xi(this.document), e.bind && this.bindDocumentFragments(t, _n63);else {
              var _o32 = e.keepOriginalCase ? t.tagName : t.tagName.toLowerCase();
              _n63 = new di(this.document, _o32), e.bind && this.bindElements(t, _n63);
              var _i35 = t.attributes;
              for (var _t54 = _i35.length - 1; _t54 >= 0; _t54--) _n63._setAttribute(_i35[_t54].name, _i35[_t54].value);
              if (!1 !== e.withChildren && this._rawContentElementMatcher.match(_n63)) return _n63._setCustomProperty("$rawContent", t.innerHTML), this._encounteredRawContentDomNodes.add(t), _n63;
            }
            if (!1 !== e.withChildren) {
              var _iterator83 = _createForOfIteratorHelper(this.domChildrenToView(t, e)),
                _step83;
              try {
                for (_iterator83.s(); !(_step83 = _iterator83.n()).done;) {
                  var _o33 = _step83.value;
                  _n63._appendChild(_o33);
                }
              } catch (err) {
                _iterator83.e(err);
              } finally {
                _iterator83.f();
              }
            }
            return _n63;
          }
        }
      }, {
        key: "domChildrenToView",
        value: function domChildrenToView(t) {
          var _this31 = this;
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          return /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
            var _n65, _o34, _i36;
            return _regeneratorRuntime().wrap(function _callee4$(_context12) {
              while (1) switch (_context12.prev = _context12.next) {
                case 0:
                  _n65 = 0;
                case 1:
                  if (!(_n65 < t.childNodes.length)) {
                    _context12.next = 10;
                    break;
                  }
                  _o34 = t.childNodes[_n65], _i36 = _this31.domToView(_o34, e);
                  _context12.t0 = null !== _i36;
                  if (!_context12.t0) {
                    _context12.next = 7;
                    break;
                  }
                  _context12.next = 7;
                  return _i36;
                case 7:
                  _n65++;
                  _context12.next = 1;
                  break;
                case 10:
                case "end":
                  return _context12.stop();
              }
            }, _callee4);
          })();
        }
      }, {
        key: "domSelectionToView",
        value: function domSelectionToView(t) {
          if (1 === t.rangeCount) {
            var _e69 = t.getRangeAt(0).startContainer;
            hr(_e69) && (_e69 = _e69.parentNode);
            var _n66 = this.fakeSelectionToView(_e69);
            if (_n66) return _n66;
          }
          var e = this.isDomSelectionBackward(t),
            n = [];
          for (var _e71 = 0; _e71 < t.rangeCount; _e71++) {
            var _o35 = t.getRangeAt(_e71),
              _i37 = this.domRangeToView(_o35);
            _i37 && n.push(_i37);
          }
          return new _i(n, {
            backward: e
          });
        }
      }, {
        key: "domRangeToView",
        value: function domRangeToView(t) {
          var e = this.domPositionToView(t.startContainer, t.startOffset),
            n = this.domPositionToView(t.endContainer, t.endOffset);
          return e && n ? new wi(e, n) : null;
        }
      }, {
        key: "domPositionToView",
        value: function domPositionToView(t, e) {
          if (this.isBlockFiller(t)) return this.domPositionToView(t.parentNode, Nr(t));
          var n = this.mapDomToView(t);
          if (n && (n.is("uiElement") || n.is("rawElement"))) return bi._createBefore(n);
          if (hr(t)) {
            if (kr(t)) return this.domPositionToView(t.parentNode, Nr(t));
            var _n67 = this.findCorrespondingViewText(t);
            var _o36 = e;
            return _n67 ? (fr(t) && (_o36 -= 7, _o36 = _o36 < 0 ? 0 : _o36), new bi(_n67, _o36)) : null;
          }
          if (0 === e) {
            var _e72 = this.mapDomToView(t);
            if (_e72) return new bi(_e72, 0);
          } else {
            var _n68 = t.childNodes[e - 1],
              _o37 = hr(_n68) ? this.findCorrespondingViewText(_n68) : this.mapDomToView(_n68);
            if (_o37 && _o37.parent) return new bi(_o37.parent, _o37.index + 1);
          }
          return null;
        }
      }, {
        key: "mapDomToView",
        value: function mapDomToView(t) {
          return this.getHostViewElement(t) || this._domToViewMapping.get(t);
        }
      }, {
        key: "findCorrespondingViewText",
        value: function findCorrespondingViewText(t) {
          if (kr(t)) return null;
          var e = this.getHostViewElement(t);
          if (e) return e;
          var n = t.previousSibling;
          if (n) {
            if (!this.isElement(n)) return null;
            var _t55 = this.mapDomToView(n);
            if (_t55) {
              return _t55.nextSibling instanceof Ao ? _t55.nextSibling : null;
            }
          } else {
            var _e73 = this.mapDomToView(t.parentNode);
            if (_e73) {
              var _t56 = _e73.getChild(0);
              return _t56 instanceof Ao ? _t56 : null;
            }
          }
          return null;
        }
      }, {
        key: "mapViewToDom",
        value: function mapViewToDom(t) {
          return this._viewToDomMapping.get(t);
        }
      }, {
        key: "findCorrespondingDomText",
        value: function findCorrespondingDomText(t) {
          var e = t.previousSibling;
          return e && this.mapViewToDom(e) ? this.mapViewToDom(e).nextSibling : !e && t.parent && this.mapViewToDom(t.parent) ? this.mapViewToDom(t.parent).childNodes[0] : null;
        }
      }, {
        key: "focus",
        value: function focus(t) {
          var e = this.mapViewToDom(t);
          if (e && e.ownerDocument.activeElement !== e) {
            var _Sr$window = Sr.window,
              _t57 = _Sr$window.scrollX,
              _n69 = _Sr$window.scrollY,
              _o38 = [];
            jr(e, function (t) {
              var e = t.scrollLeft,
                n = t.scrollTop;
              _o38.push([e, n]);
            }), e.focus(), jr(e, function (t) {
              var _o38$shift = _o38.shift(),
                _o38$shift2 = _slicedToArray(_o38$shift, 2),
                e = _o38$shift2[0],
                n = _o38$shift2[1];
              t.scrollLeft = e, t.scrollTop = n;
            }), Sr.window.scrollTo(_t57, _n69);
          }
        }
      }, {
        key: "isElement",
        value: function isElement(t) {
          return t && t.nodeType == Node.ELEMENT_NODE;
        }
      }, {
        key: "isDocumentFragment",
        value: function isDocumentFragment(t) {
          return t && t.nodeType == Node.DOCUMENT_FRAGMENT_NODE;
        }
      }, {
        key: "isComment",
        value: function isComment(t) {
          return t && t.nodeType == Node.COMMENT_NODE;
        }
      }, {
        key: "isBlockFiller",
        value: function isBlockFiller(t) {
          return "br" == this.blockFillerMode ? t.isEqualNode(Pr) : !("BR" !== t.tagName || !Fr(t, this.blockElements) || 1 !== t.parentNode.childNodes.length) || t.isEqualNode(Lr) || function (t, e) {
            return t.isEqualNode(zr) && Fr(t, e) && 1 === t.parentNode.childNodes.length;
          }(t, this.blockElements);
        }
      }, {
        key: "isDomSelectionBackward",
        value: function isDomSelectionBackward(t) {
          if (t.isCollapsed) return !1;
          var e = document.createRange();
          e.setStart(t.anchorNode, t.anchorOffset), e.setEnd(t.focusNode, t.focusOffset);
          var n = e.collapsed;
          return e.detach(), n;
        }
      }, {
        key: "getHostViewElement",
        value: function getHostViewElement(t) {
          var e = Br(t);
          for (e.pop(); e.length;) {
            var _t58 = e.pop(),
              _n70 = this._domToViewMapping.get(_t58);
            if (_n70 && (_n70.is("uiElement") || _n70.is("rawElement"))) return _n70;
          }
          return null;
        }
      }, {
        key: "isDomSelectionCorrect",
        value: function isDomSelectionCorrect(t) {
          return this._isDomSelectionPositionCorrect(t.anchorNode, t.anchorOffset) && this._isDomSelectionPositionCorrect(t.focusNode, t.focusOffset);
        }
      }, {
        key: "registerRawContentMatcher",
        value: function registerRawContentMatcher(t) {
          this._rawContentElementMatcher.add(t);
        }
      }, {
        key: "_getBlockFiller",
        value: function _getBlockFiller(t) {
          switch (this.blockFillerMode) {
            case "nbsp":
              return ur(t);
            case "markedNbsp":
              return gr(t);
            case "br":
              return mr(t);
          }
        }
      }, {
        key: "_isDomSelectionPositionCorrect",
        value: function _isDomSelectionPositionCorrect(t, e) {
          if (hr(t) && fr(t) && e < 7) return !1;
          if (this.isElement(t) && fr(t.childNodes[e])) return !1;
          var n = this.mapDomToView(t);
          return !n || !n.is("uiElement") && !n.is("rawElement");
        }
      }, {
        key: "_processDataFromViewText",
        value: function _processDataFromViewText(t) {
          var _this32 = this;
          var e = t.data;
          if (t.getAncestors().some(function (t) {
            return _this32.preElements.includes(t.name);
          })) return e;
          if (" " == e.charAt(0)) {
            var _n71 = this._getTouchingViewTextNode(t, !1);
            !(_n71 && this._nodeEndsWithSpace(_n71)) && _n71 || (e = " " + e.substr(1));
          }
          if (" " == e.charAt(e.length - 1)) {
            var _n72 = this._getTouchingViewTextNode(t, !0);
            " " != e.charAt(e.length - 2) && _n72 && " " != _n72.data.charAt(0) || (e = e.substr(0, e.length - 1) + " ");
          }
          return e.replace(/ {2}/g, "  ");
        }
      }, {
        key: "_nodeEndsWithSpace",
        value: function _nodeEndsWithSpace(t) {
          var _this33 = this;
          if (t.getAncestors().some(function (t) {
            return _this33.preElements.includes(t.name);
          })) return !1;
          var e = this._processDataFromViewText(t);
          return " " == e.charAt(e.length - 1);
        }
      }, {
        key: "_processDataFromDomText",
        value: function _processDataFromDomText(t) {
          var e = t.data;
          if (Rr(t, this.preElements)) return br(t);
          e = e.replace(/[ \n\t\r]{1,}/g, " ");
          var n = this._getTouchingInlineDomNode(t, !1),
            o = this._getTouchingInlineDomNode(t, !0),
            i = this._checkShouldLeftTrimDomText(t, n),
            r = this._checkShouldRightTrimDomText(t, o);
          return i && (e = e.replace(/^ /, "")), r && (e = e.replace(/ $/, "")), e = br(new Text(e)), e = e.replace(/ \u00A0/g, "  "), (/( |\u00A0)\u00A0$/.test(e) || !o || o.data && " " == o.data.charAt(0)) && (e = e.replace(/\u00A0$/, " ")), i && (e = e.replace(/^\u00A0/, " ")), e;
        }
      }, {
        key: "_checkShouldLeftTrimDomText",
        value: function _checkShouldLeftTrimDomText(t, e) {
          return !e || !!oo(e) || !this._encounteredRawContentDomNodes.has(t.previousSibling) && /[^\S\u00A0]/.test(e.data.charAt(e.data.length - 1));
        }
      }, {
        key: "_checkShouldRightTrimDomText",
        value: function _checkShouldRightTrimDomText(t, e) {
          return !e && !fr(t);
        }
      }, {
        key: "_getTouchingViewTextNode",
        value: function _getTouchingViewTextNode(t, e) {
          var n = new ki({
            startPosition: e ? bi._createAfter(t) : bi._createBefore(t),
            direction: e ? "forward" : "backward"
          });
          var _iterator84 = _createForOfIteratorHelper(n),
            _step84;
          try {
            for (_iterator84.s(); !(_step84 = _iterator84.n()).done;) {
              var _t59 = _step84.value;
              if (_t59.item.is("containerElement")) return null;
              if (_t59.item.is("element", "br")) return null;
              if (_t59.item.is("$textProxy")) return _t59.item;
            }
          } catch (err) {
            _iterator84.e(err);
          } finally {
            _iterator84.f();
          }
          return null;
        }
      }, {
        key: "_getTouchingInlineDomNode",
        value: function _getTouchingInlineDomNode(t, e) {
          if (!t.parentNode) return null;
          var n = e ? "nextNode" : "previousNode",
            o = t.ownerDocument,
            i = Br(t)[0],
            r = o.createTreeWalker(i, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT, {
              acceptNode: function acceptNode(t) {
                return hr(t) || "BR" == t.tagName ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
              }
            });
          r.currentNode = t;
          var s = r[n]();
          if (null !== s) {
            var _e74 = function (t, e) {
              var n = Br(t),
                o = Br(e);
              var i = 0;
              for (; n[i] == o[i] && n[i];) i++;
              return 0 === i ? null : n[i - 1];
            }(t, s);
            if (_e74 && !Rr(t, this.blockElements, _e74) && !Rr(s, this.blockElements, _e74)) return s;
          }
          return null;
        }
      }]);
      return Or;
    }();
    function Rr(t, e, n) {
      var o = Br(t);
      return n && (o = o.slice(o.indexOf(n) + 1)), o.some(function (t) {
        return t.tagName && e.includes(t.tagName.toLowerCase());
      });
    }
    function jr(t, e) {
      for (; t && t != Sr.document;) e(t), t = t.parentNode;
    }
    function Fr(t, e) {
      var n = t.parentNode;
      return n && n.tagName && e.includes(n.tagName.toLowerCase());
    }
    function Vr(t) {
      var e = Object.prototype.toString.apply(t);
      return "[object Window]" == e || "[object global]" == e;
    }
    var Ur = Ot({}, h, {
      listenTo: function listenTo(t) {
        var _h$listenTo;
        for (var _len18 = arguments.length, e = new Array(_len18 > 1 ? _len18 - 1 : 0), _key18 = 1; _key18 < _len18; _key18++) {
          e[_key18 - 1] = arguments[_key18];
        }
        if (Er(t) || Vr(t)) {
          var _n73 = this._getProxyEmitter(t) || new Hr(t);
          _n73.attach.apply(_n73, e), t = _n73;
        }
        (_h$listenTo = h.listenTo).call.apply(_h$listenTo, [this, t].concat(e));
      },
      stopListening: function stopListening(t, e, n) {
        if (Er(t) || Vr(t)) {
          var _e75 = this._getProxyEmitter(t);
          if (!_e75) return;
          t = _e75;
        }
        h.stopListening.call(this, t, e, n), t instanceof Hr && t.detach(e);
      },
      _getProxyEmitter: function _getProxyEmitter(t) {
        return e = this, n = Gr(t), e[l] && e[l][n] ? e[l][n].emitter : null;
        var e, n;
      }
    });
    var Hr = function Hr(t) {
      _classCallCheck(this, Hr);
      u(this, Gr(t)), this._domNode = t;
    };
    function Gr(t) {
      return t["data-ck-expando"] || (t["data-ck-expando"] = s());
    }
    Ot(Hr.prototype, h, {
      attach: function attach(t, e) {
        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        if (this._domListeners && this._domListeners[t]) return;
        var o = {
            capture: !!n.useCapture,
            passive: !!n.usePassive
          },
          i = this._createDomListener(t, o);
        this._domNode.addEventListener(t, i, o), this._domListeners || (this._domListeners = {}), this._domListeners[t] = i;
      },
      detach: function detach(t) {
        var e;
        !this._domListeners[t] || (e = this._events[t]) && e.callbacks.length || this._domListeners[t].removeListener();
      },
      _createDomListener: function _createDomListener(t, e) {
        var _this34 = this;
        var n = function n(e) {
          _this34.fire(t, e);
        };
        return n.removeListener = function () {
          _this34._domNode.removeEventListener(t, n, e), delete _this34._domListeners[t];
        }, n;
      }
    });
    var Wr = /*#__PURE__*/function () {
      function Wr(t) {
        _classCallCheck(this, Wr);
        this.view = t, this.document = t.document, this.isEnabled = !1;
      }
      _createClass(Wr, [{
        key: "enable",
        value: function enable() {
          this.isEnabled = !0;
        }
      }, {
        key: "disable",
        value: function disable() {
          this.isEnabled = !1;
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.disable(), this.stopListening();
        }
      }, {
        key: "checkShouldIgnoreEventFromTarget",
        value: function checkShouldIgnoreEventFromTarget(t) {
          return t && 3 === t.nodeType && (t = t.parentNode), !(!t || 1 !== t.nodeType) && t.matches("[data-cke-ignore-events], [data-cke-ignore-events] *");
        }
      }]);
      return Wr;
    }();
    $t(Wr, Ur);
    var qr = function qr(t) {
      return this.__data__.set(t, "__lodash_hash_undefined__"), this;
    };
    var Kr = function Kr(t) {
      return this.__data__.has(t);
    };
    function Yr(t) {
      var e = -1,
        n = null == t ? 0 : t.length;
      for (this.__data__ = new Ue(); ++e < n;) this.add(t[e]);
    }
    Yr.prototype.add = Yr.prototype.push = qr, Yr.prototype.has = Kr;
    var Qr = Yr;
    var $r = function $r(t, e) {
      for (var n = -1, o = null == t ? 0 : t.length; ++n < o;) if (e(t[n], n, t)) return !0;
      return !1;
    };
    var Jr = function Jr(t, e) {
      return t.has(e);
    };
    var Zr = function Zr(t, e, n, o, i, r) {
      var s = 1 & n,
        a = t.length,
        c = e.length;
      if (a != c && !(s && c > a)) return !1;
      var l = r.get(t),
        d = r.get(e);
      if (l && d) return l == e && d == t;
      var h = -1,
        u = !0,
        g = 2 & n ? new Qr() : void 0;
      for (r.set(t, e), r.set(e, t); ++h < a;) {
        var m = t[h],
          p = e[h];
        if (o) var f = s ? o(p, m, h, e, t, r) : o(m, p, h, t, e, r);
        if (void 0 !== f) {
          if (f) continue;
          u = !1;
          break;
        }
        if (g) {
          if (!$r(e, function (t, e) {
            if (!Jr(g, e) && (m === t || i(m, t, n, o, r))) return g.push(e);
          })) {
            u = !1;
            break;
          }
        } else if (m !== p && !i(m, p, n, o, r)) {
          u = !1;
          break;
        }
      }
      return r.delete(t), r.delete(e), u;
    };
    var Xr = function Xr(t) {
      var e = -1,
        n = Array(t.size);
      return t.forEach(function (t, o) {
        n[++e] = [o, t];
      }), n;
    };
    var ts = function ts(t) {
        var e = -1,
          n = Array(t.size);
        return t.forEach(function (t) {
          n[++e] = t;
        }), n;
      },
      es = A ? A.prototype : void 0,
      ns = es ? es.valueOf : void 0;
    var os = function os(t, e, n, o, i, r, s) {
        switch (n) {
          case "[object DataView]":
            if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset) return !1;
            t = t.buffer, e = e.buffer;
          case "[object ArrayBuffer]":
            return !(t.byteLength != e.byteLength || !r(new Nn(t), new Nn(e)));
          case "[object Boolean]":
          case "[object Date]":
          case "[object Number]":
            return Q(+t, +e);
          case "[object Error]":
            return t.name == e.name && t.message == e.message;
          case "[object RegExp]":
          case "[object String]":
            return t == e + "";
          case "[object Map]":
            var a = Xr;
          case "[object Set]":
            var c = 1 & o;
            if (a || (a = ts), t.size != e.size && !c) return !1;
            var l = s.get(t);
            if (l) return l == e;
            o |= 2, s.set(t, e);
            var d = Zr(a(t), a(e), o, i, r, s);
            return s.delete(t), d;
          case "[object Symbol]":
            if (ns) return ns.call(t) == ns.call(e);
        }
        return !1;
      },
      is = Object.prototype.hasOwnProperty;
    var rs = function rs(t, e, n, o, i, r) {
        var s = 1 & n,
          a = un(t),
          c = a.length;
        if (c != un(e).length && !s) return !1;
        for (var l = c; l--;) {
          var d = a[l];
          if (!(s ? d in e : is.call(e, d))) return !1;
        }
        var h = r.get(t),
          u = r.get(e);
        if (h && u) return h == e && u == t;
        var g = !0;
        r.set(t, e), r.set(e, t);
        for (var m = s; ++l < c;) {
          var p = t[d = a[l]],
            f = e[d];
          if (o) var k = s ? o(f, p, d, e, t, r) : o(p, f, d, t, e, r);
          if (!(void 0 === k ? p === f || i(p, f, n, o, r) : k)) {
            g = !1;
            break;
          }
          m || (m = "constructor" == d);
        }
        if (g && !m) {
          var b = t.constructor,
            w = e.constructor;
          b == w || !("constructor" in t) || !("constructor" in e) || "function" == typeof b && b instanceof b && "function" == typeof w && w instanceof w || (g = !1);
        }
        return r.delete(t), r.delete(e), g;
      },
      ss = "[object Arguments]",
      as = "[object Array]",
      cs = "[object Object]",
      ls = Object.prototype.hasOwnProperty;
    var ds = function ds(t, e, n, o, i, r) {
      var s = At(t),
        a = At(e),
        c = s ? as : In(t),
        l = a ? as : In(e),
        d = (c = c == ss ? cs : c) == cs,
        h = (l = l == ss ? cs : l) == cs,
        u = c == l;
      if (u && Object(_t.a)(t)) {
        if (!Object(_t.a)(e)) return !1;
        s = !0, d = !1;
      }
      if (u && !d) return r || (r = new We()), s || Mt(t) ? Zr(t, e, n, o, i, r) : os(t, e, c, n, o, i, r);
      if (!(1 & n)) {
        var g = d && ls.call(t, "__wrapped__"),
          m = h && ls.call(e, "__wrapped__");
        if (g || m) {
          var p = g ? t.value() : t,
            f = m ? e.value() : e;
          return r || (r = new We()), i(p, f, n, o, r);
        }
      }
      return !!u && (r || (r = new We()), rs(t, e, n, o, i, r));
    };
    var hs = function t(e, n, o, i, r) {
      return e === n || (null == e || null == n || !pt(e) && !pt(n) ? e != e && n != n : ds(e, n, o, i, t, r));
    };
    var us = function us(t, e, n) {
      var o = (n = "function" == typeof n ? n : void 0) ? n(t, e) : void 0;
      return void 0 === o ? hs(t, e, void 0, n) : !!o;
    };
    var gs = /*#__PURE__*/function (_Wr) {
      _inherits(gs, _Wr);
      function gs(t) {
        var _this35;
        _classCallCheck(this, gs);
        _this35 = _possibleConstructorReturn(this, _getPrototypeOf(gs).call(this, t)), _this35._config = {
          childList: !0,
          characterData: !0,
          characterDataOldValue: !0,
          subtree: !0
        }, _this35.domConverter = t.domConverter, _this35.renderer = t._renderer, _this35._domElements = [], _this35._mutationObserver = new window.MutationObserver(_this35._onMutations.bind(_assertThisInitialized(_assertThisInitialized(_this35))));
        return _this35;
      }
      _createClass(gs, [{
        key: "flush",
        value: function flush() {
          this._onMutations(this._mutationObserver.takeRecords());
        }
      }, {
        key: "observe",
        value: function observe(t) {
          this._domElements.push(t), this.isEnabled && this._mutationObserver.observe(t, this._config);
        }
      }, {
        key: "enable",
        value: function enable() {
          _get(_getPrototypeOf(gs.prototype), "enable", this).call(this);
          var _iterator85 = _createForOfIteratorHelper(this._domElements),
            _step85;
          try {
            for (_iterator85.s(); !(_step85 = _iterator85.n()).done;) {
              var _t60 = _step85.value;
              this._mutationObserver.observe(_t60, this._config);
            }
          } catch (err) {
            _iterator85.e(err);
          } finally {
            _iterator85.f();
          }
        }
      }, {
        key: "disable",
        value: function disable() {
          _get(_getPrototypeOf(gs.prototype), "disable", this).call(this), this._mutationObserver.disconnect();
        }
      }, {
        key: "destroy",
        value: function destroy() {
          _get(_getPrototypeOf(gs.prototype), "destroy", this).call(this), this._mutationObserver.disconnect();
        }
      }, {
        key: "_onMutations",
        value: function _onMutations(t) {
          if (0 === t.length) return;
          var e = this.domConverter,
            n = new Map(),
            o = new Set();
          var _iterator86 = _createForOfIteratorHelper(t),
            _step86;
          try {
            for (_iterator86.s(); !(_step86 = _iterator86.n()).done;) {
              var _n75 = _step86.value;
              if ("childList" === _n75.type) {
                var _t62 = e.mapDomToView(_n75.target);
                if (_t62 && (_t62.is("uiElement") || _t62.is("rawElement"))) continue;
                _t62 && !this._isBogusBrMutation(_n75) && o.add(_t62);
              }
            }
          } catch (err) {
            _iterator86.e(err);
          } finally {
            _iterator86.f();
          }
          var _iterator87 = _createForOfIteratorHelper(t),
            _step87;
          try {
            for (_iterator87.s(); !(_step87 = _iterator87.n()).done;) {
              var _i38 = _step87.value;
              var _t63 = e.mapDomToView(_i38.target);
              if ((!_t63 || !_t63.is("uiElement") && !_t63.is("rawElement")) && "characterData" === _i38.type) {
                var _t64 = e.findCorrespondingViewText(_i38.target);
                _t64 && !o.has(_t64.parent) ? n.set(_t64, {
                  type: "text",
                  oldText: _t64.data,
                  newText: br(_i38.target),
                  node: _t64
                }) : !_t64 && fr(_i38.target) && o.add(e.mapDomToView(_i38.target.parentNode));
              }
            }
          } catch (err) {
            _iterator87.e(err);
          } finally {
            _iterator87.f();
          }
          var i = [];
          var _iterator88 = _createForOfIteratorHelper(n.values()),
            _step88;
          try {
            for (_iterator88.s(); !(_step88 = _iterator88.n()).done;) {
              var _t65 = _step88.value;
              this.renderer.markToSync("text", _t65.node), i.push(_t65);
            }
          } catch (err) {
            _iterator88.e(err);
          } finally {
            _iterator88.f();
          }
          var _iterator89 = _createForOfIteratorHelper(o),
            _step89;
          try {
            for (_iterator89.s(); !(_step89 = _iterator89.n()).done;) {
              var _t66 = _step89.value;
              var _n76 = e.mapViewToDom(_t66),
                _o39 = Array.from(_t66.getChildren()),
                _r16 = Array.from(e.domChildrenToView(_n76, {
                  withChildren: !1
                }));
              us(_o39, _r16, a) || (this.renderer.markToSync("children", _t66), i.push({
                type: "children",
                oldChildren: _o39,
                newChildren: _r16,
                node: _t66
              }));
            }
          } catch (err) {
            _iterator89.e(err);
          } finally {
            _iterator89.f();
          }
          var r = t[0].target.ownerDocument.getSelection();
          var s = null;
          if (r && r.anchorNode) {
            var _t61 = e.domPositionToView(r.anchorNode, r.anchorOffset),
              _n74 = e.domPositionToView(r.focusNode, r.focusOffset);
            _t61 && _n74 && (s = new _i(_t61), s.setFocus(_n74));
          }
          function a(t, e) {
            if (!Array.isArray(t)) return t === e || !(!t.is("$text") || !e.is("$text")) && t.data === e.data;
          }
          i.length && (this.document.fire("mutations", i, s), this.view.forceRender());
        }
      }, {
        key: "_isBogusBrMutation",
        value: function _isBogusBrMutation(t) {
          var e = null;
          return null === t.nextSibling && 0 === t.removedNodes.length && 1 == t.addedNodes.length && (e = this.domConverter.domToView(t.addedNodes[0], {
            withChildren: !1
          })), e && e.is("element", "br");
        }
      }]);
      return gs;
    }(Wr);
    var ms = /*#__PURE__*/function () {
      function ms(t, e, n) {
        _classCallCheck(this, ms);
        this.view = t, this.document = t.document, this.domEvent = e, this.domTarget = e.target, Ot(this, n);
      }
      _createClass(ms, [{
        key: "preventDefault",
        value: function preventDefault() {
          this.domEvent.preventDefault();
        }
      }, {
        key: "stopPropagation",
        value: function stopPropagation() {
          this.domEvent.stopPropagation();
        }
      }, {
        key: "target",
        get: function get() {
          return this.view.domConverter.mapDomToView(this.domTarget);
        }
      }]);
      return ms;
    }();
    var ps = /*#__PURE__*/function (_Wr2) {
      _inherits(ps, _Wr2);
      function ps(t) {
        var _this36;
        _classCallCheck(this, ps);
        _this36 = _possibleConstructorReturn(this, _getPrototypeOf(ps).call(this, t)), _this36.useCapture = !1;
        return _this36;
      }
      _createClass(ps, [{
        key: "observe",
        value: function observe(t) {
          var _this37 = this;
          ("string" == typeof this.domEventType ? [this.domEventType] : this.domEventType).forEach(function (e) {
            _this37.listenTo(t, e, function (t, e) {
              _this37.isEnabled && !_this37.checkShouldIgnoreEventFromTarget(e.target) && _this37.onDomEvent(e);
            }, {
              useCapture: _this37.useCapture
            });
          });
        }
      }, {
        key: "fire",
        value: function fire(t, e, n) {
          this.isEnabled && this.document.fire(t, new ms(this.view, e, n));
        }
      }]);
      return ps;
    }(Wr);
    var fs = /*#__PURE__*/function (_ps) {
      _inherits(fs, _ps);
      function fs(t) {
        var _this38;
        _classCallCheck(this, fs);
        _this38 = _possibleConstructorReturn(this, _getPrototypeOf(fs).call(this, t)), _this38.domEventType = ["keydown", "keyup"];
        return _this38;
      }
      _createClass(fs, [{
        key: "onDomEvent",
        value: function onDomEvent(t) {
          this.fire(t.type, t, {
            keyCode: t.keyCode,
            altKey: t.altKey,
            ctrlKey: t.ctrlKey,
            shiftKey: t.shiftKey,
            metaKey: t.metaKey,
            get keystroke() {
              return Hi(this);
            }
          });
        }
      }]);
      return fs;
    }(ps);
    var ks = function ks() {
        return C.a.Date.now();
      },
      bs = /\s/;
    var ws = function ws(t) {
        for (var e = t.length; e-- && bs.test(t.charAt(e)););
        return e;
      },
      Cs = /^\s+/;
    var As = function As(t) {
        return t ? t.slice(0, ws(t) + 1).replace(Cs, "") : t;
      },
      _s = /^[-+]0x[0-9a-f]+$/i,
      vs = /^0b[01]+$/i,
      ys = /^0o[0-7]+$/i,
      xs = parseInt;
    var Es = function Es(t) {
        if ("number" == typeof t) return t;
        if (Do(t)) return NaN;
        if (w(t)) {
          var e = "function" == typeof t.valueOf ? t.valueOf() : t;
          t = w(e) ? e + "" : e;
        }
        if ("string" != typeof t) return 0 === t ? t : +t;
        t = As(t);
        var n = vs.test(t);
        return n || ys.test(t) ? xs(t.slice(2), n ? 2 : 8) : _s.test(t) ? NaN : +t;
      },
      Ds = Math.max,
      Ms = Math.min;
    var Is = function Is(t, e, n) {
      var o,
        i,
        r,
        s,
        a,
        c,
        l = 0,
        d = !1,
        h = !1,
        u = !0;
      if ("function" != typeof t) throw new TypeError("Expected a function");
      function g(e) {
        var n = o,
          r = i;
        return o = i = void 0, l = e, s = t.apply(r, n);
      }
      function m(t) {
        return l = t, a = setTimeout(f, e), d ? g(t) : s;
      }
      function p(t) {
        var n = t - c;
        return void 0 === c || n >= e || n < 0 || h && t - l >= r;
      }
      function f() {
        var t = ks();
        if (p(t)) return k(t);
        a = setTimeout(f, function (t) {
          var n = e - (t - c);
          return h ? Ms(n, r - (t - l)) : n;
        }(t));
      }
      function k(t) {
        return a = void 0, u && o ? g(t) : (o = i = void 0, s);
      }
      function b() {
        var t = ks(),
          n = p(t);
        if (o = arguments, i = this, c = t, n) {
          if (void 0 === a) return m(c);
          if (h) return clearTimeout(a), a = setTimeout(f, e), g(c);
        }
        return void 0 === a && (a = setTimeout(f, e)), s;
      }
      return e = Es(e) || 0, w(n) && (d = !!n.leading, r = (h = "maxWait" in n) ? Ds(Es(n.maxWait) || 0, e) : r, u = "trailing" in n ? !!n.trailing : u), b.cancel = function () {
        void 0 !== a && clearTimeout(a), l = 0, o = c = i = a = void 0;
      }, b.flush = function () {
        return void 0 === a ? s : k(ks());
      }, b;
    };
    var Ts = /*#__PURE__*/function (_Wr3) {
      _inherits(Ts, _Wr3);
      function Ts(t) {
        var _this39;
        _classCallCheck(this, Ts);
        _this39 = _possibleConstructorReturn(this, _getPrototypeOf(Ts).call(this, t)), _this39._fireSelectionChangeDoneDebounced = Is(function (t) {
          return _this39.document.fire("selectionChangeDone", t);
        }, 200);
        return _this39;
      }
      _createClass(Ts, [{
        key: "observe",
        value: function observe() {
          var _this40 = this;
          var t = this.document;
          t.on("arrowKey", function (e, n) {
            t.selection.isFake && _this40.isEnabled && n.preventDefault();
          }, {
            context: "$capture"
          }), t.on("arrowKey", function (e, n) {
            t.selection.isFake && _this40.isEnabled && _this40._handleSelectionMove(n.keyCode);
          }, {
            priority: "lowest"
          });
        }
      }, {
        key: "destroy",
        value: function destroy() {
          _get(_getPrototypeOf(Ts.prototype), "destroy", this).call(this), this._fireSelectionChangeDoneDebounced.cancel();
        }
      }, {
        key: "_handleSelectionMove",
        value: function _handleSelectionMove(t) {
          var e = this.document.selection,
            n = new _i(e.getRanges(), {
              backward: e.isBackward,
              fake: !1
            });
          t != Vi.arrowleft && t != Vi.arrowup || n.setTo(n.getFirstPosition()), t != Vi.arrowright && t != Vi.arrowdown || n.setTo(n.getLastPosition());
          var o = {
            oldSelection: e,
            newSelection: n,
            domSelection: null
          };
          this.document.fire("selectionChange", o), this._fireSelectionChangeDoneDebounced(o);
        }
      }]);
      return Ts;
    }(Wr);
    var Ss = /*#__PURE__*/function (_Wr4) {
      _inherits(Ss, _Wr4);
      function Ss(t) {
        var _this41;
        _classCallCheck(this, Ss);
        _this41 = _possibleConstructorReturn(this, _getPrototypeOf(Ss).call(this, t)), _this41.mutationObserver = t.getObserver(gs), _this41.selection = _this41.document.selection, _this41.domConverter = t.domConverter, _this41._documents = new WeakSet(), _this41._fireSelectionChangeDoneDebounced = Is(function (t) {
          return _this41.document.fire("selectionChangeDone", t);
        }, 200), _this41._clearInfiniteLoopInterval = setInterval(function () {
          return _this41._clearInfiniteLoop();
        }, 1e3), _this41._loopbackCounter = 0;
        return _this41;
      }
      _createClass(Ss, [{
        key: "observe",
        value: function observe(t) {
          var _this42 = this;
          var e = t.ownerDocument;
          this._documents.has(e) || (this.listenTo(e, "selectionchange", function (t, n) {
            _this42._handleSelectionChange(n, e);
          }), this._documents.add(e));
        }
      }, {
        key: "destroy",
        value: function destroy() {
          _get(_getPrototypeOf(Ss.prototype), "destroy", this).call(this), clearInterval(this._clearInfiniteLoopInterval), this._fireSelectionChangeDoneDebounced.cancel();
        }
      }, {
        key: "_handleSelectionChange",
        value: function _handleSelectionChange(t, e) {
          if (!this.isEnabled) return;
          var n = e.defaultView.getSelection();
          if (this.checkShouldIgnoreEventFromTarget(n.anchorNode)) return;
          this.mutationObserver.flush();
          var o = this.domConverter.domSelectionToView(n);
          if (0 != o.rangeCount) {
            if (this.view.hasDomSelection = !0, !(this.selection.isEqual(o) && this.domConverter.isDomSelectionCorrect(n) || ++this._loopbackCounter > 60)) if (this.selection.isSimilar(o)) this.view.forceRender();else {
              var _t67 = {
                oldSelection: this.selection,
                newSelection: o,
                domSelection: n
              };
              this.document.fire("selectionChange", _t67), this._fireSelectionChangeDoneDebounced(_t67);
            }
          } else this.view.hasDomSelection = !1;
        }
      }, {
        key: "_clearInfiniteLoop",
        value: function _clearInfiniteLoop() {
          this._loopbackCounter = 0;
        }
      }]);
      return Ss;
    }(Wr);
    var Ns = /*#__PURE__*/function (_ps2) {
      _inherits(Ns, _ps2);
      function Ns(t) {
        var _this43;
        _classCallCheck(this, Ns);
        _this43 = _possibleConstructorReturn(this, _getPrototypeOf(Ns).call(this, t)), _this43.domEventType = ["focus", "blur"], _this43.useCapture = !0;
        var e = _this43.document;
        e.on("focus", function () {
          e.isFocused = !0, _this43._renderTimeoutId = setTimeout(function () {
            return t.change(function () {});
          }, 50);
        }), e.on("blur", function (n, o) {
          var i = e.selection.editableElement;
          null !== i && i !== o.target || (e.isFocused = !1, t.change(function () {}));
        });
        return _this43;
      }
      _createClass(Ns, [{
        key: "onDomEvent",
        value: function onDomEvent(t) {
          this.fire(t.type, t);
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this._renderTimeoutId && clearTimeout(this._renderTimeoutId), _get(_getPrototypeOf(Ns.prototype), "destroy", this).call(this);
        }
      }]);
      return Ns;
    }(ps);
    var Bs = /*#__PURE__*/function (_ps3) {
      _inherits(Bs, _ps3);
      function Bs(t) {
        var _this44;
        _classCallCheck(this, Bs);
        _this44 = _possibleConstructorReturn(this, _getPrototypeOf(Bs).call(this, t)), _this44.domEventType = ["compositionstart", "compositionupdate", "compositionend"];
        var e = _this44.document;
        e.on("compositionstart", function () {
          e.isComposing = !0;
        }), e.on("compositionend", function () {
          e.isComposing = !1;
        });
        return _this44;
      }
      _createClass(Bs, [{
        key: "onDomEvent",
        value: function onDomEvent(t) {
          this.fire(t.type, t);
        }
      }]);
      return Bs;
    }(ps);
    var Ps = /*#__PURE__*/function (_ps4) {
      _inherits(Ps, _ps4);
      function Ps(t) {
        var _this45;
        _classCallCheck(this, Ps);
        _this45 = _possibleConstructorReturn(this, _getPrototypeOf(Ps).call(this, t)), _this45.domEventType = ["beforeinput"];
        return _this45;
      }
      _createClass(Ps, [{
        key: "onDomEvent",
        value: function onDomEvent(t) {
          this.fire(t.type, t);
        }
      }]);
      return Ps;
    }(ps);
    var zs = /*#__PURE__*/function () {
      function zs() {
        _classCallCheck(this, zs);
        this._replacedElements = [];
      }
      _createClass(zs, [{
        key: "replace",
        value: function replace(t, e) {
          this._replacedElements.push({
            element: t,
            newElement: e
          }), t.style.display = "none", e && t.parentNode.insertBefore(e, t.nextSibling);
        }
      }, {
        key: "restore",
        value: function restore() {
          this._replacedElements.forEach(function (_ref13) {
            var t = _ref13.element,
              e = _ref13.newElement;
            t.style.display = "", e && e.remove();
          }), this._replacedElements = [];
        }
      }]);
      return zs;
    }();
    var Ls = function Ls(t) {
      return "string" == typeof t || !At(t) && pt(t) && "[object String]" == T(t);
    };
    function Os(t, e) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
      var i = n && n.xmlns,
        r = i ? t.createElementNS(i, e) : t.createElement(e);
      for (var _t69 in n) r.setAttribute(_t69, n[_t69]);
      !Ls(o) && ao(o) || (o = [o]);
      var _iterator90 = _createForOfIteratorHelper(o),
        _step90;
      try {
        for (_iterator90.s(); !(_step90 = _iterator90.n()).done;) {
          var _e76 = _step90.value;
          Ls(_e76) && (_e76 = t.createTextNode(_e76)), r.appendChild(_e76);
        }
      } catch (err) {
        _iterator90.e(err);
      } finally {
        _iterator90.f();
      }
      return r;
    }
    function Rs(t) {
      return "[object Range]" == Object.prototype.toString.apply(t);
    }
    function js(t) {
      var e = t.ownerDocument.defaultView.getComputedStyle(t);
      return {
        top: parseInt(e.borderTopWidth, 10),
        right: parseInt(e.borderRightWidth, 10),
        bottom: parseInt(e.borderBottomWidth, 10),
        left: parseInt(e.borderLeftWidth, 10)
      };
    }
    var Fs = ["top", "right", "bottom", "left", "width", "height"];
    var Vs = /*#__PURE__*/function () {
      function Vs(t) {
        _classCallCheck(this, Vs);
        var e = Rs(t);
        if (Object.defineProperty(this, "_source", {
          value: t._source || t,
          writable: !0,
          enumerable: !1
        }), oo(t) || e) {
          if (e) {
            var _e77 = Vs.getDomRangeRects(t);
            Us(this, Vs.getBoundingRect(_e77));
          } else Us(this, t.getBoundingClientRect());
        } else if (Vr(t)) {
          var _e78 = t.innerWidth,
            _n77 = t.innerHeight;
          Us(this, {
            top: 0,
            right: _e78,
            bottom: _n77,
            left: 0,
            width: _e78,
            height: _n77
          });
        } else Us(this, t);
      }
      _createClass(Vs, [{
        key: "clone",
        value: function clone() {
          return new Vs(this);
        }
      }, {
        key: "moveTo",
        value: function moveTo(t, e) {
          return this.top = e, this.right = t + this.width, this.bottom = e + this.height, this.left = t, this;
        }
      }, {
        key: "moveBy",
        value: function moveBy(t, e) {
          return this.top += e, this.right += t, this.left += t, this.bottom += e, this;
        }
      }, {
        key: "getIntersection",
        value: function getIntersection(t) {
          var e = {
            top: Math.max(this.top, t.top),
            right: Math.min(this.right, t.right),
            bottom: Math.min(this.bottom, t.bottom),
            left: Math.max(this.left, t.left)
          };
          return e.width = e.right - e.left, e.height = e.bottom - e.top, e.width < 0 || e.height < 0 ? null : new Vs(e);
        }
      }, {
        key: "getIntersectionArea",
        value: function getIntersectionArea(t) {
          var e = this.getIntersection(t);
          return e ? e.getArea() : 0;
        }
      }, {
        key: "getArea",
        value: function getArea() {
          return this.width * this.height;
        }
      }, {
        key: "getVisible",
        value: function getVisible() {
          var t = this._source;
          var e = this.clone();
          if (!Hs(t)) {
            var _n78 = t.parentNode || t.commonAncestorContainer;
            for (; _n78 && !Hs(_n78);) {
              var _t70 = new Vs(_n78),
                _o40 = e.getIntersection(_t70);
              if (!_o40) return null;
              _o40.getArea() < e.getArea() && (e = _o40), _n78 = _n78.parentNode;
            }
          }
          return e;
        }
      }, {
        key: "isEqual",
        value: function isEqual(t) {
          for (var _i39 = 0, _Fs = Fs; _i39 < _Fs.length; _i39++) {
            var _e79 = _Fs[_i39];
            if (this[_e79] !== t[_e79]) return !1;
          }
          return !0;
        }
      }, {
        key: "contains",
        value: function contains(t) {
          var e = this.getIntersection(t);
          return !(!e || !e.isEqual(t));
        }
      }, {
        key: "excludeScrollbarsAndBorders",
        value: function excludeScrollbarsAndBorders() {
          var t = this._source;
          var e, n, o;
          if (Vr(t)) e = t.innerWidth - t.document.documentElement.clientWidth, n = t.innerHeight - t.document.documentElement.clientHeight, o = t.getComputedStyle(t.document.documentElement).direction;else {
            var _i40 = js(this._source);
            e = t.offsetWidth - t.clientWidth - _i40.left - _i40.right, n = t.offsetHeight - t.clientHeight - _i40.top - _i40.bottom, o = t.ownerDocument.defaultView.getComputedStyle(t).direction, this.left += _i40.left, this.top += _i40.top, this.right -= _i40.right, this.bottom -= _i40.bottom, this.width = this.right - this.left, this.height = this.bottom - this.top;
          }
          return this.width -= e, "ltr" === o ? this.right -= e : this.left += e, this.height -= n, this.bottom -= n, this;
        }
      }], [{
        key: "getDomRangeRects",
        value: function getDomRangeRects(t) {
          var e = [],
            n = Array.from(t.getClientRects());
          if (n.length) {
            var _iterator91 = _createForOfIteratorHelper(n),
              _step91;
            try {
              for (_iterator91.s(); !(_step91 = _iterator91.n()).done;) {
                var _t71 = _step91.value;
                e.push(new Vs(_t71));
              }
            } catch (err) {
              _iterator91.e(err);
            } finally {
              _iterator91.f();
            }
          } else {
            var _n79 = t.startContainer;
            hr(_n79) && (_n79 = _n79.parentNode);
            var _o41 = new Vs(_n79.getBoundingClientRect());
            _o41.right = _o41.left, _o41.width = 0, e.push(_o41);
          }
          return e;
        }
      }, {
        key: "getBoundingRect",
        value: function getBoundingRect(t) {
          var e = {
            left: Number.POSITIVE_INFINITY,
            top: Number.POSITIVE_INFINITY,
            right: Number.NEGATIVE_INFINITY,
            bottom: Number.NEGATIVE_INFINITY
          };
          var n = 0;
          var _iterator92 = _createForOfIteratorHelper(t),
            _step92;
          try {
            for (_iterator92.s(); !(_step92 = _iterator92.n()).done;) {
              var _o42 = _step92.value;
              n++, e.left = Math.min(e.left, _o42.left), e.top = Math.min(e.top, _o42.top), e.right = Math.max(e.right, _o42.right), e.bottom = Math.max(e.bottom, _o42.bottom);
            }
          } catch (err) {
            _iterator92.e(err);
          } finally {
            _iterator92.f();
          }
          return 0 == n ? null : (e.width = e.right - e.left, e.height = e.bottom - e.top, new Vs(e));
        }
      }]);
      return Vs;
    }();
    function Us(t, e) {
      var _iterator93 = _createForOfIteratorHelper(Fs),
        _step93;
      try {
        for (_iterator93.s(); !(_step93 = _iterator93.n()).done;) {
          var _n80 = _step93.value;
          t[_n80] = e[_n80];
        }
      } catch (err) {
        _iterator93.e(err);
      } finally {
        _iterator93.f();
      }
    }
    function Hs(t) {
      return !!oo(t) && t === t.ownerDocument.body;
    }
    var Gs = /*#__PURE__*/function () {
      function Gs(t, e) {
        _classCallCheck(this, Gs);
        Gs._observerInstance || Gs._createObserver(), this._element = t, this._callback = e, Gs._addElementCallback(t, e), Gs._observerInstance.observe(t);
      }
      _createClass(Gs, [{
        key: "destroy",
        value: function destroy() {
          Gs._deleteElementCallback(this._element, this._callback);
        }
      }], [{
        key: "_addElementCallback",
        value: function _addElementCallback(t, e) {
          Gs._elementCallbacks || (Gs._elementCallbacks = new Map());
          var n = Gs._elementCallbacks.get(t);
          n || (n = new Set(), Gs._elementCallbacks.set(t, n)), n.add(e);
        }
      }, {
        key: "_deleteElementCallback",
        value: function _deleteElementCallback(t, e) {
          var n = Gs._getElementCallbacks(t);
          n && (n.delete(e), n.size || (Gs._elementCallbacks.delete(t), Gs._observerInstance.unobserve(t))), Gs._elementCallbacks && !Gs._elementCallbacks.size && (Gs._observerInstance = null, Gs._elementCallbacks = null);
        }
      }, {
        key: "_getElementCallbacks",
        value: function _getElementCallbacks(t) {
          return Gs._elementCallbacks ? Gs._elementCallbacks.get(t) : null;
        }
      }, {
        key: "_createObserver",
        value: function _createObserver() {
          var t;
          t = "function" == typeof Sr.window.ResizeObserver ? Sr.window.ResizeObserver : Ws, Gs._observerInstance = new t(function (t) {
            var _iterator94 = _createForOfIteratorHelper(t),
              _step94;
            try {
              for (_iterator94.s(); !(_step94 = _iterator94.n()).done;) {
                var _e80 = _step94.value;
                var _t72 = Gs._getElementCallbacks(_e80.target);
                if (_t72) {
                  var _iterator95 = _createForOfIteratorHelper(_t72),
                    _step95;
                  try {
                    for (_iterator95.s(); !(_step95 = _iterator95.n()).done;) {
                      var _n81 = _step95.value;
                      _n81(_e80);
                    }
                  } catch (err) {
                    _iterator95.e(err);
                  } finally {
                    _iterator95.f();
                  }
                }
              }
            } catch (err) {
              _iterator94.e(err);
            } finally {
              _iterator94.f();
            }
          });
        }
      }]);
      return Gs;
    }();
    Gs._observerInstance = null, Gs._elementCallbacks = null;
    var Ws = /*#__PURE__*/function () {
      function Ws(t) {
        _classCallCheck(this, Ws);
        this._callback = t, this._elements = new Set(), this._previousRects = new Map(), this._periodicCheckTimeout = null;
      }
      _createClass(Ws, [{
        key: "observe",
        value: function observe(t) {
          this._elements.add(t), this._checkElementRectsAndExecuteCallback(), 1 === this._elements.size && this._startPeriodicCheck();
        }
      }, {
        key: "unobserve",
        value: function unobserve(t) {
          this._elements.delete(t), this._previousRects.delete(t), this._elements.size || this._stopPeriodicCheck();
        }
      }, {
        key: "_startPeriodicCheck",
        value: function _startPeriodicCheck() {
          var _this46 = this;
          var t = function t() {
            _this46._checkElementRectsAndExecuteCallback(), _this46._periodicCheckTimeout = setTimeout(t, 100);
          };
          this.listenTo(Sr.window, "resize", function () {
            _this46._checkElementRectsAndExecuteCallback();
          }), this._periodicCheckTimeout = setTimeout(t, 100);
        }
      }, {
        key: "_stopPeriodicCheck",
        value: function _stopPeriodicCheck() {
          clearTimeout(this._periodicCheckTimeout), this.stopListening(), this._previousRects.clear();
        }
      }, {
        key: "_checkElementRectsAndExecuteCallback",
        value: function _checkElementRectsAndExecuteCallback() {
          var t = [];
          var _iterator96 = _createForOfIteratorHelper(this._elements),
            _step96;
          try {
            for (_iterator96.s(); !(_step96 = _iterator96.n()).done;) {
              var _e81 = _step96.value;
              this._hasRectChanged(_e81) && t.push({
                target: _e81,
                contentRect: this._previousRects.get(_e81)
              });
            }
          } catch (err) {
            _iterator96.e(err);
          } finally {
            _iterator96.f();
          }
          t.length && this._callback(t);
        }
      }, {
        key: "_hasRectChanged",
        value: function _hasRectChanged(t) {
          if (!t.ownerDocument.body.contains(t)) return !1;
          var e = new Vs(t),
            n = this._previousRects.get(t),
            o = !n || !n.isEqual(e);
          return this._previousRects.set(t, e), o;
        }
      }]);
      return Ws;
    }();
    function qs(t) {
      return function (e) {
        return e + t;
      };
    }
    function Ks(t) {
      var e = t.next();
      return e.done ? null : e.value;
    }
    $t(Ws, Ur);
    var Ys = /*#__PURE__*/function () {
      function Ys() {
        _classCallCheck(this, Ys);
        this.set("isFocused", !1), this.set("focusedElement", null), this._elements = new Set(), this._nextEventLoopTimeout = null;
      }
      _createClass(Ys, [{
        key: "add",
        value: function add(t) {
          var _this47 = this;
          if (this._elements.has(t)) throw new c.a("focustracker-add-element-already-exist", this);
          this.listenTo(t, "focus", function () {
            return _this47._focus(t);
          }, {
            useCapture: !0
          }), this.listenTo(t, "blur", function () {
            return _this47._blur();
          }, {
            useCapture: !0
          }), this._elements.add(t);
        }
      }, {
        key: "remove",
        value: function remove(t) {
          t === this.focusedElement && this._blur(t), this._elements.has(t) && (this.stopListening(t), this._elements.delete(t));
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.stopListening();
        }
      }, {
        key: "_focus",
        value: function _focus(t) {
          clearTimeout(this._nextEventLoopTimeout), this.focusedElement = t, this.isFocused = !0;
        }
      }, {
        key: "_blur",
        value: function _blur() {
          var _this48 = this;
          clearTimeout(this._nextEventLoopTimeout), this._nextEventLoopTimeout = setTimeout(function () {
            _this48.focusedElement = null, _this48.isFocused = !1;
          }, 0);
        }
      }]);
      return Ys;
    }();
    $t(Ys, Ur), $t(Ys, Gt);
    var Qs = /*#__PURE__*/function () {
      function Qs() {
        _classCallCheck(this, Qs);
        this._listener = Object.create(Ur);
      }
      _createClass(Qs, [{
        key: "listenTo",
        value: function listenTo(t) {
          var _this49 = this;
          this._listener.listenTo(t, "keydown", function (t, e) {
            _this49._listener.fire("_keydown:" + Hi(e), e);
          });
        }
      }, {
        key: "set",
        value: function set(t, e) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          var o = Gi(t),
            i = n.priority;
          this._listener.listenTo(this._listener, "_keydown:" + o, function (t, n) {
            e(n, function () {
              n.preventDefault(), n.stopPropagation(), t.stop();
            }), t.return = !0;
          }, {
            priority: i
          });
        }
      }, {
        key: "press",
        value: function press(t) {
          return !!this._listener.fire("_keydown:" + Hi(t), t);
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this._listener.stopListening();
        }
      }]);
      return Qs;
    }();
    var $s = /*#__PURE__*/function (_Wr5) {
      _inherits($s, _Wr5);
      function $s(t) {
        var _this50;
        _classCallCheck(this, $s);
        _this50 = _possibleConstructorReturn(this, _getPrototypeOf($s).call(this, t)), _this50.document.on("keydown", function (t, e) {
          if (_this50.isEnabled && ((n = e.keyCode) == Vi.arrowright || n == Vi.arrowleft || n == Vi.arrowup || n == Vi.arrowdown)) {
            var _n82 = new yi(_this50.document, "arrowKey", _this50.document.selection.getFirstRange());
            _this50.document.fire(_n82, e), _n82.stop.called && t.stop();
          }
          var n;
        });
        return _this50;
      }
      _createClass($s, [{
        key: "observe",
        value: function observe() {}
      }]);
      return $s;
    }(Wr);
    function Js(_ref14) {
      var t = _ref14.target,
        _ref14$viewportOffset = _ref14.viewportOffset,
        e = _ref14$viewportOffset === void 0 ? 0 : _ref14$viewportOffset;
      var n = ia(t);
      var o = n,
        i = null;
      for (; o;) {
        var _r17 = void 0;
        _r17 = ra(o == n ? t : i), Xs(_r17, function () {
          return sa(t, o);
        });
        var _s10 = sa(t, o);
        if (Zs(o, _s10, e), o.parent != o) {
          if (i = o.frameElement, o = o.parent, !i) return;
        } else o = null;
      }
    }
    function Zs(t, e, n) {
      var o = e.clone().moveBy(0, n),
        i = e.clone().moveBy(0, -n),
        r = new Vs(t).excludeScrollbarsAndBorders();
      if (![i, o].every(function (t) {
        return r.contains(t);
      })) {
        var _s11 = t.scrollX,
          _a8 = t.scrollY;
        ea(i, r) ? _a8 -= r.top - e.top + n : ta(o, r) && (_a8 += e.bottom - r.bottom + n), na(e, r) ? _s11 -= r.left - e.left + n : oa(e, r) && (_s11 += e.right - r.right + n), t.scrollTo(_s11, _a8);
      }
    }
    function Xs(t, e) {
      var n = ia(t);
      var o, i;
      for (; t != n.document.body;) i = e(), o = new Vs(t).excludeScrollbarsAndBorders(), o.contains(i) || (ea(i, o) ? t.scrollTop -= o.top - i.top : ta(i, o) && (t.scrollTop += i.bottom - o.bottom), na(i, o) ? t.scrollLeft -= o.left - i.left : oa(i, o) && (t.scrollLeft += i.right - o.right)), t = t.parentNode;
    }
    function ta(t, e) {
      return t.bottom > e.bottom;
    }
    function ea(t, e) {
      return t.top < e.top;
    }
    function na(t, e) {
      return t.left < e.left;
    }
    function oa(t, e) {
      return t.right > e.right;
    }
    function ia(t) {
      return Rs(t) ? t.startContainer.ownerDocument.defaultView : t.ownerDocument.defaultView;
    }
    function ra(t) {
      if (Rs(t)) {
        var _e82 = t.commonAncestorContainer;
        return hr(_e82) && (_e82 = _e82.parentNode), _e82;
      }
      return t.parentNode;
    }
    function sa(t, e) {
      var n = ia(t),
        o = new Vs(t);
      if (n === e) return o;
      {
        var _t73 = n;
        for (; _t73 != e;) {
          var _e83 = _t73.frameElement,
            _n83 = new Vs(_e83).excludeScrollbarsAndBorders();
          o.moveBy(_n83.left, _n83.top), _t73 = _t73.parent;
        }
      }
      return o;
    }
    Object.assign({}, {
      scrollViewportToShowTarget: Js,
      scrollAncestorsToShowTarget: function scrollAncestorsToShowTarget(t) {
        Xs(ra(t), function () {
          return new Vs(t);
        });
      }
    });
    var aa = /*#__PURE__*/function () {
      function aa(t) {
        var _this51 = this;
        _classCallCheck(this, aa);
        this.document = new Si(t), this.domConverter = new Or(this.document), this.domRoots = new Map(), this.set("isRenderingInProgress", !1), this.set("hasDomSelection", !1), this._renderer = new Dr(this.domConverter, this.document.selection), this._renderer.bind("isFocused").to(this.document), this._initialDomRootAttributes = new WeakMap(), this._observers = new Map(), this._ongoingChange = !1, this._postFixersInProgress = !1, this._renderingDisabled = !1, this._hasChangedSinceTheLastRendering = !1, this._writer = new tr(this.document), this.addObserver(gs), this.addObserver(Ss), this.addObserver(Ns), this.addObserver(fs), this.addObserver(Ts), this.addObserver(Bs), this.addObserver($s), Ri.isAndroid && this.addObserver(Ps), this.document.on("arrowKey", wr, {
          priority: "low"
        }), Qi(this), this.on("render", function () {
          _this51._render(), _this51.document.fire("layoutChanged"), _this51._hasChangedSinceTheLastRendering = !1;
        }), this.listenTo(this.document.selection, "change", function () {
          _this51._hasChangedSinceTheLastRendering = !0;
        }), this.listenTo(this.document, "change:isFocused", function () {
          _this51._hasChangedSinceTheLastRendering = !0;
        });
      }
      _createClass(aa, [{
        key: "attachDomRoot",
        value: function attachDomRoot(t) {
          var _this52 = this;
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "main";
          var n = this.document.getRoot(e);
          n._name = t.tagName.toLowerCase();
          var o = {};
          for (var _i41 = 0, _Array$from = Array.from(t.attributes); _i41 < _Array$from.length; _i41++) {
            var _Array$from$_i = _Array$from[_i41],
              _e84 = _Array$from$_i.name,
              _i42 = _Array$from$_i.value;
            o[_e84] = _i42, "class" === _e84 ? this._writer.addClass(_i42.split(" "), n) : this._writer.setAttribute(_e84, _i42, n);
          }
          this._initialDomRootAttributes.set(t, o);
          var i = function i() {
            _this52._writer.setAttribute("contenteditable", !n.isReadOnly, n), n.isReadOnly ? _this52._writer.addClass("ck-read-only", n) : _this52._writer.removeClass("ck-read-only", n);
          };
          i(), this.domRoots.set(e, t), this.domConverter.bindElements(t, n), this._renderer.markToSync("children", n), this._renderer.markToSync("attributes", n), this._renderer.domDocuments.add(t.ownerDocument), n.on("change:children", function (t, e) {
            return _this52._renderer.markToSync("children", e);
          }), n.on("change:attributes", function (t, e) {
            return _this52._renderer.markToSync("attributes", e);
          }), n.on("change:text", function (t, e) {
            return _this52._renderer.markToSync("text", e);
          }), n.on("change:isReadOnly", function () {
            return _this52.change(i);
          }), n.on("change", function () {
            _this52._hasChangedSinceTheLastRendering = !0;
          });
          var _iterator97 = _createForOfIteratorHelper(this._observers.values()),
            _step97;
          try {
            for (_iterator97.s(); !(_step97 = _iterator97.n()).done;) {
              var _n84 = _step97.value;
              _n84.observe(t, e);
            }
          } catch (err) {
            _iterator97.e(err);
          } finally {
            _iterator97.f();
          }
        }
      }, {
        key: "detachDomRoot",
        value: function detachDomRoot(t) {
          var e = this.domRoots.get(t);
          Array.from(e.attributes).forEach(function (_ref15) {
            var t = _ref15.name;
            return e.removeAttribute(t);
          });
          var n = this._initialDomRootAttributes.get(e);
          for (var _t75 in n) e.setAttribute(_t75, n[_t75]);
          this.domRoots.delete(t), this.domConverter.unbindDomElement(e);
        }
      }, {
        key: "getDomRoot",
        value: function getDomRoot() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "main";
          return this.domRoots.get(t);
        }
      }, {
        key: "addObserver",
        value: function addObserver(t) {
          var e = this._observers.get(t);
          if (e) return e;
          e = new t(this), this._observers.set(t, e);
          var _iterator98 = _createForOfIteratorHelper(this.domRoots),
            _step98;
          try {
            for (_iterator98.s(); !(_step98 = _iterator98.n()).done;) {
              var _step98$value = _slicedToArray(_step98.value, 2),
                _t76 = _step98$value[0],
                _n85 = _step98$value[1];
              e.observe(_n85, _t76);
            }
          } catch (err) {
            _iterator98.e(err);
          } finally {
            _iterator98.f();
          }
          return e.enable(), e;
        }
      }, {
        key: "getObserver",
        value: function getObserver(t) {
          return this._observers.get(t);
        }
      }, {
        key: "disableObservers",
        value: function disableObservers() {
          var _iterator99 = _createForOfIteratorHelper(this._observers.values()),
            _step99;
          try {
            for (_iterator99.s(); !(_step99 = _iterator99.n()).done;) {
              var _t77 = _step99.value;
              _t77.disable();
            }
          } catch (err) {
            _iterator99.e(err);
          } finally {
            _iterator99.f();
          }
        }
      }, {
        key: "enableObservers",
        value: function enableObservers() {
          var _iterator100 = _createForOfIteratorHelper(this._observers.values()),
            _step100;
          try {
            for (_iterator100.s(); !(_step100 = _iterator100.n()).done;) {
              var _t78 = _step100.value;
              _t78.enable();
            }
          } catch (err) {
            _iterator100.e(err);
          } finally {
            _iterator100.f();
          }
        }
      }, {
        key: "scrollToTheSelection",
        value: function scrollToTheSelection() {
          var t = this.document.selection.getFirstRange();
          t && Js({
            target: this.domConverter.viewRangeToDom(t),
            viewportOffset: 20
          });
        }
      }, {
        key: "focus",
        value: function focus() {
          if (!this.document.isFocused) {
            var _t79 = this.document.selection.editableElement;
            _t79 && (this.domConverter.focus(_t79), this.forceRender());
          }
        }
      }, {
        key: "change",
        value: function change(t) {
          if (this.isRenderingInProgress || this._postFixersInProgress) throw new c.a("cannot-change-view-tree", this);
          try {
            if (this._ongoingChange) return t(this._writer);
            this._ongoingChange = !0;
            var _e85 = t(this._writer);
            return this._ongoingChange = !1, !this._renderingDisabled && this._hasChangedSinceTheLastRendering && (this._postFixersInProgress = !0, this.document._callPostFixers(this._writer), this._postFixersInProgress = !1, this.fire("render")), _e85;
          } catch (t) {
            c.a.rethrowUnexpectedError(t, this);
          }
        }
      }, {
        key: "forceRender",
        value: function forceRender() {
          this._hasChangedSinceTheLastRendering = !0, this.change(function () {});
        }
      }, {
        key: "destroy",
        value: function destroy() {
          var _iterator101 = _createForOfIteratorHelper(this._observers.values()),
            _step101;
          try {
            for (_iterator101.s(); !(_step101 = _iterator101.n()).done;) {
              var _t80 = _step101.value;
              _t80.destroy();
            }
          } catch (err) {
            _iterator101.e(err);
          } finally {
            _iterator101.f();
          }
          this.document.destroy(), this.stopListening();
        }
      }, {
        key: "createPositionAt",
        value: function createPositionAt(t, e) {
          return bi._createAt(t, e);
        }
      }, {
        key: "createPositionAfter",
        value: function createPositionAfter(t) {
          return bi._createAfter(t);
        }
      }, {
        key: "createPositionBefore",
        value: function createPositionBefore(t) {
          return bi._createBefore(t);
        }
      }, {
        key: "createRange",
        value: function createRange(t, e) {
          return new wi(t, e);
        }
      }, {
        key: "createRangeOn",
        value: function createRangeOn(t) {
          return wi._createOn(t);
        }
      }, {
        key: "createRangeIn",
        value: function createRangeIn(t) {
          return wi._createIn(t);
        }
      }, {
        key: "createSelection",
        value: function createSelection(t, e, n) {
          return new _i(t, e, n);
        }
      }, {
        key: "_disableRendering",
        value: function _disableRendering(t) {
          this._renderingDisabled = t, 0 == t && this.change(function () {});
        }
      }, {
        key: "_render",
        value: function _render() {
          this.isRenderingInProgress = !0, this.disableObservers(), this._renderer.render(), this.enableObservers(), this.isRenderingInProgress = !1;
        }
      }]);
      return aa;
    }();
    $t(aa, Gt);
    var ca = /*#__PURE__*/function () {
      function ca(t) {
        _classCallCheck(this, ca);
        this.parent = null, this._attrs = vo(t);
      }
      _createClass(ca, [{
        key: "isAttached",
        value: function isAttached() {
          return this.root.is("rootElement");
        }
      }, {
        key: "getPath",
        value: function getPath() {
          var t = [];
          var e = this;
          for (; e.parent;) t.unshift(e.startOffset), e = e.parent;
          return t;
        }
      }, {
        key: "getAncestors",
        value: function getAncestors() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            includeSelf: !1,
            parentFirst: !1
          };
          var e = [];
          var n = t.includeSelf ? this : this.parent;
          for (; n;) e[t.parentFirst ? "push" : "unshift"](n), n = n.parent;
          return e;
        }
      }, {
        key: "getCommonAncestor",
        value: function getCommonAncestor(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var n = this.getAncestors(e),
            o = t.getAncestors(e);
          var i = 0;
          for (; n[i] == o[i] && n[i];) i++;
          return 0 === i ? null : n[i - 1];
        }
      }, {
        key: "isBefore",
        value: function isBefore(t) {
          if (this == t) return !1;
          if (this.root !== t.root) return !1;
          var e = this.getPath(),
            n = t.getPath(),
            o = bo(e, n);
          switch (o) {
            case "prefix":
              return !0;
            case "extension":
              return !1;
            default:
              return e[o] < n[o];
          }
        }
      }, {
        key: "isAfter",
        value: function isAfter(t) {
          return this != t && this.root === t.root && !this.isBefore(t);
        }
      }, {
        key: "hasAttribute",
        value: function hasAttribute(t) {
          return this._attrs.has(t);
        }
      }, {
        key: "getAttribute",
        value: function getAttribute(t) {
          return this._attrs.get(t);
        }
      }, {
        key: "getAttributes",
        value: function getAttributes() {
          return this._attrs.entries();
        }
      }, {
        key: "getAttributeKeys",
        value: function getAttributeKeys() {
          return this._attrs.keys();
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = {};
          return this._attrs.size && (t.attributes = Array.from(this._attrs).reduce(function (t, e) {
            return t[e[0]] = e[1], t;
          }, {})), t;
        }
      }, {
        key: "is",
        value: function is(t) {
          return "node" === t || "model:node" === t;
        }
      }, {
        key: "_clone",
        value: function _clone() {
          return new ca(this._attrs);
        }
      }, {
        key: "_remove",
        value: function _remove() {
          this.parent._removeChildren(this.index);
        }
      }, {
        key: "_setAttribute",
        value: function _setAttribute(t, e) {
          this._attrs.set(t, e);
        }
      }, {
        key: "_setAttributesTo",
        value: function _setAttributesTo(t) {
          this._attrs = vo(t);
        }
      }, {
        key: "_removeAttribute",
        value: function _removeAttribute(t) {
          return this._attrs.delete(t);
        }
      }, {
        key: "_clearAttributes",
        value: function _clearAttributes() {
          this._attrs.clear();
        }
      }, {
        key: "index",
        get: function get() {
          var t;
          if (!this.parent) return null;
          if (null === (t = this.parent.getChildIndex(this))) throw new c.a("model-node-not-found-in-parent", this);
          return t;
        }
      }, {
        key: "startOffset",
        get: function get() {
          var t;
          if (!this.parent) return null;
          if (null === (t = this.parent.getChildStartOffset(this))) throw new c.a("model-node-not-found-in-parent", this);
          return t;
        }
      }, {
        key: "offsetSize",
        get: function get() {
          return 1;
        }
      }, {
        key: "endOffset",
        get: function get() {
          return this.parent ? this.startOffset + this.offsetSize : null;
        }
      }, {
        key: "nextSibling",
        get: function get() {
          var t = this.index;
          return null !== t && this.parent.getChild(t + 1) || null;
        }
      }, {
        key: "previousSibling",
        get: function get() {
          var t = this.index;
          return null !== t && this.parent.getChild(t - 1) || null;
        }
      }, {
        key: "root",
        get: function get() {
          var t = this;
          for (; t.parent;) t = t.parent;
          return t;
        }
      }]);
      return ca;
    }();
    var la = /*#__PURE__*/function (_ca) {
      _inherits(la, _ca);
      function la(t, e) {
        var _this53;
        _classCallCheck(this, la);
        _this53 = _possibleConstructorReturn(this, _getPrototypeOf(la).call(this, e)), _this53._data = t || "";
        return _this53;
      }
      _createClass(la, [{
        key: "is",
        value: function is(t) {
          return "$text" === t || "model:$text" === t || "text" === t || "model:text" === t || "node" === t || "model:node" === t;
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = _get(_getPrototypeOf(la.prototype), "toJSON", this).call(this);
          return t.data = this.data, t;
        }
      }, {
        key: "_clone",
        value: function _clone() {
          return new la(this.data, this.getAttributes());
        }
      }, {
        key: "offsetSize",
        get: function get() {
          return this.data.length;
        }
      }, {
        key: "data",
        get: function get() {
          return this._data;
        }
      }], [{
        key: "fromJSON",
        value: function fromJSON(t) {
          return new la(t.data, t.attributes);
        }
      }]);
      return la;
    }(ca);
    var da = /*#__PURE__*/function () {
      function da(t, e, n) {
        _classCallCheck(this, da);
        if (this.textNode = t, e < 0 || e > t.offsetSize) throw new c.a("model-textproxy-wrong-offsetintext", this);
        if (n < 0 || e + n > t.offsetSize) throw new c.a("model-textproxy-wrong-length", this);
        this.data = t.data.substring(e, e + n), this.offsetInText = e;
      }
      _createClass(da, [{
        key: "is",
        value: function is(t) {
          return "$textProxy" === t || "model:$textProxy" === t || "textProxy" === t || "model:textProxy" === t;
        }
      }, {
        key: "getPath",
        value: function getPath() {
          var t = this.textNode.getPath();
          return t.length > 0 && (t[t.length - 1] += this.offsetInText), t;
        }
      }, {
        key: "getAncestors",
        value: function getAncestors() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            includeSelf: !1,
            parentFirst: !1
          };
          var e = [];
          var n = t.includeSelf ? this : this.parent;
          for (; n;) e[t.parentFirst ? "push" : "unshift"](n), n = n.parent;
          return e;
        }
      }, {
        key: "hasAttribute",
        value: function hasAttribute(t) {
          return this.textNode.hasAttribute(t);
        }
      }, {
        key: "getAttribute",
        value: function getAttribute(t) {
          return this.textNode.getAttribute(t);
        }
      }, {
        key: "getAttributes",
        value: function getAttributes() {
          return this.textNode.getAttributes();
        }
      }, {
        key: "getAttributeKeys",
        value: function getAttributeKeys() {
          return this.textNode.getAttributeKeys();
        }
      }, {
        key: "startOffset",
        get: function get() {
          return null !== this.textNode.startOffset ? this.textNode.startOffset + this.offsetInText : null;
        }
      }, {
        key: "offsetSize",
        get: function get() {
          return this.data.length;
        }
      }, {
        key: "endOffset",
        get: function get() {
          return null !== this.startOffset ? this.startOffset + this.offsetSize : null;
        }
      }, {
        key: "isPartial",
        get: function get() {
          return this.offsetSize !== this.textNode.offsetSize;
        }
      }, {
        key: "parent",
        get: function get() {
          return this.textNode.parent;
        }
      }, {
        key: "root",
        get: function get() {
          return this.textNode.root;
        }
      }]);
      return da;
    }();
    var ha = /*#__PURE__*/function () {
      function ha(t) {
        _classCallCheck(this, ha);
        this._nodes = [], t && this._insertNodes(0, t);
      }
      _createClass(ha, [{
        key: Symbol.iterator,
        value: function value() {
          return this._nodes[Symbol.iterator]();
        }
      }, {
        key: "getNode",
        value: function getNode(t) {
          return this._nodes[t] || null;
        }
      }, {
        key: "getNodeIndex",
        value: function getNodeIndex(t) {
          var e = this._nodes.indexOf(t);
          return -1 == e ? null : e;
        }
      }, {
        key: "getNodeStartOffset",
        value: function getNodeStartOffset(t) {
          var e = this.getNodeIndex(t);
          return null === e ? null : this._nodes.slice(0, e).reduce(function (t, e) {
            return t + e.offsetSize;
          }, 0);
        }
      }, {
        key: "indexToOffset",
        value: function indexToOffset(t) {
          if (t == this._nodes.length) return this.maxOffset;
          var e = this._nodes[t];
          if (!e) throw new c.a("model-nodelist-index-out-of-bounds", this);
          return this.getNodeStartOffset(e);
        }
      }, {
        key: "offsetToIndex",
        value: function offsetToIndex(t) {
          var e = 0;
          var _iterator102 = _createForOfIteratorHelper(this._nodes),
            _step102;
          try {
            for (_iterator102.s(); !(_step102 = _iterator102.n()).done;) {
              var _n86 = _step102.value;
              if (t >= e && t < e + _n86.offsetSize) return this.getNodeIndex(_n86);
              e += _n86.offsetSize;
            }
          } catch (err) {
            _iterator102.e(err);
          } finally {
            _iterator102.f();
          }
          if (e != t) throw new c.a("model-nodelist-offset-out-of-bounds", this, {
            offset: t,
            nodeList: this
          });
          return this.length;
        }
      }, {
        key: "_insertNodes",
        value: function _insertNodes(t, e) {
          var _this$_nodes;
          var _iterator103 = _createForOfIteratorHelper(e),
            _step103;
          try {
            for (_iterator103.s(); !(_step103 = _iterator103.n()).done;) {
              var _t81 = _step103.value;
              if (!(_t81 instanceof ca)) throw new c.a("model-nodelist-insertnodes-not-node", this);
            }
          } catch (err) {
            _iterator103.e(err);
          } finally {
            _iterator103.f();
          }
          (_this$_nodes = this._nodes).splice.apply(_this$_nodes, [t, 0].concat(_toConsumableArray(e)));
        }
      }, {
        key: "_removeNodes",
        value: function _removeNodes(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
          return this._nodes.splice(t, e);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          return this._nodes.map(function (t) {
            return t.toJSON();
          });
        }
      }, {
        key: "length",
        get: function get() {
          return this._nodes.length;
        }
      }, {
        key: "maxOffset",
        get: function get() {
          return this._nodes.reduce(function (t, e) {
            return t + e.offsetSize;
          }, 0);
        }
      }]);
      return ha;
    }();
    var ua = /*#__PURE__*/function (_ca2) {
      _inherits(ua, _ca2);
      function ua(t, e, n) {
        var _this54;
        _classCallCheck(this, ua);
        _this54 = _possibleConstructorReturn(this, _getPrototypeOf(ua).call(this, e)), _this54.name = t, _this54._children = new ha(), n && _this54._insertChild(0, n);
        return _this54;
      }
      _createClass(ua, [{
        key: "is",
        value: function is(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          return e ? e === this.name && ("element" === t || "model:element" === t) : "element" === t || "model:element" === t || "node" === t || "model:node" === t;
        }
      }, {
        key: "getChild",
        value: function getChild(t) {
          return this._children.getNode(t);
        }
      }, {
        key: "getChildren",
        value: function getChildren() {
          return this._children[Symbol.iterator]();
        }
      }, {
        key: "getChildIndex",
        value: function getChildIndex(t) {
          return this._children.getNodeIndex(t);
        }
      }, {
        key: "getChildStartOffset",
        value: function getChildStartOffset(t) {
          return this._children.getNodeStartOffset(t);
        }
      }, {
        key: "offsetToIndex",
        value: function offsetToIndex(t) {
          return this._children.offsetToIndex(t);
        }
      }, {
        key: "getNodeByPath",
        value: function getNodeByPath(t) {
          var e = this;
          var _iterator104 = _createForOfIteratorHelper(t),
            _step104;
          try {
            for (_iterator104.s(); !(_step104 = _iterator104.n()).done;) {
              var _n87 = _step104.value;
              e = e.getChild(e.offsetToIndex(_n87));
            }
          } catch (err) {
            _iterator104.e(err);
          } finally {
            _iterator104.f();
          }
          return e;
        }
      }, {
        key: "findAncestor",
        value: function findAncestor(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            includeSelf: !1
          };
          var n = e.includeSelf ? this : this.parent;
          for (; n;) {
            if (n.name === t) return n;
            n = n.parent;
          }
          return null;
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = _get(_getPrototypeOf(ua.prototype), "toJSON", this).call(this);
          if (t.name = this.name, this._children.length > 0) {
            t.children = [];
            var _iterator105 = _createForOfIteratorHelper(this._children),
              _step105;
            try {
              for (_iterator105.s(); !(_step105 = _iterator105.n()).done;) {
                var _e86 = _step105.value;
                t.children.push(_e86.toJSON());
              }
            } catch (err) {
              _iterator105.e(err);
            } finally {
              _iterator105.f();
            }
          }
          return t;
        }
      }, {
        key: "_clone",
        value: function _clone() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
          var e = t ? Array.from(this._children).map(function (t) {
            return t._clone(!0);
          }) : null;
          return new ua(this.name, this.getAttributes(), e);
        }
      }, {
        key: "_appendChild",
        value: function _appendChild(t) {
          this._insertChild(this.childCount, t);
        }
      }, {
        key: "_insertChild",
        value: function _insertChild(t, e) {
          var n = function (t) {
            if ("string" == typeof t) return [new la(t)];
            ao(t) || (t = [t]);
            return Array.from(t).map(function (t) {
              return "string" == typeof t ? new la(t) : t instanceof da ? new la(t.data, t.getAttributes()) : t;
            });
          }(e);
          var _iterator106 = _createForOfIteratorHelper(n),
            _step106;
          try {
            for (_iterator106.s(); !(_step106 = _iterator106.n()).done;) {
              var _t82 = _step106.value;
              null !== _t82.parent && _t82._remove(), _t82.parent = this;
            }
          } catch (err) {
            _iterator106.e(err);
          } finally {
            _iterator106.f();
          }
          this._children._insertNodes(t, n);
        }
      }, {
        key: "_removeChildren",
        value: function _removeChildren(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
          var n = this._children._removeNodes(t, e);
          var _iterator107 = _createForOfIteratorHelper(n),
            _step107;
          try {
            for (_iterator107.s(); !(_step107 = _iterator107.n()).done;) {
              var _t83 = _step107.value;
              _t83.parent = null;
            }
          } catch (err) {
            _iterator107.e(err);
          } finally {
            _iterator107.f();
          }
          return n;
        }
      }, {
        key: "childCount",
        get: function get() {
          return this._children.length;
        }
      }, {
        key: "maxOffset",
        get: function get() {
          return this._children.maxOffset;
        }
      }, {
        key: "isEmpty",
        get: function get() {
          return 0 === this.childCount;
        }
      }], [{
        key: "fromJSON",
        value: function fromJSON(t) {
          var e = null;
          if (t.children) {
            e = [];
            var _iterator108 = _createForOfIteratorHelper(t.children),
              _step108;
            try {
              for (_iterator108.s(); !(_step108 = _iterator108.n()).done;) {
                var _n88 = _step108.value;
                _n88.name ? e.push(ua.fromJSON(_n88)) : e.push(la.fromJSON(_n88));
              }
            } catch (err) {
              _iterator108.e(err);
            } finally {
              _iterator108.f();
            }
          }
          return new ua(t.name, t.attributes, e);
        }
      }]);
      return ua;
    }(ca);
    var ga = /*#__PURE__*/function () {
      function ga() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        _classCallCheck(this, ga);
        if (!t.boundaries && !t.startPosition) throw new c.a("model-tree-walker-no-start-position", null);
        var e = t.direction || "forward";
        if ("forward" != e && "backward" != e) throw new c.a("model-tree-walker-unknown-direction", t, {
          direction: e
        });
        this.direction = e, this.boundaries = t.boundaries || null, t.startPosition ? this.position = t.startPosition.clone() : this.position = pa._createAt(this.boundaries["backward" == this.direction ? "end" : "start"]), this.position.stickiness = "toNone", this.singleCharacters = !!t.singleCharacters, this.shallow = !!t.shallow, this.ignoreElementEnd = !!t.ignoreElementEnd, this._boundaryStartParent = this.boundaries ? this.boundaries.start.parent : null, this._boundaryEndParent = this.boundaries ? this.boundaries.end.parent : null, this._visitedParent = this.position.parent;
      }
      _createClass(ga, [{
        key: Symbol.iterator,
        value: function value() {
          return this;
        }
      }, {
        key: "skip",
        value: function skip(t) {
          var e, n, o, i;
          do {
            var _this$next2;
            o = this.position, i = this._visitedParent, (_this$next2 = this.next(), e = _this$next2.done, n = _this$next2.value, _this$next2);
          } while (!e && t(n));
          e || (this.position = o, this._visitedParent = i);
        }
      }, {
        key: "next",
        value: function next() {
          return "forward" == this.direction ? this._next() : this._previous();
        }
      }, {
        key: "_next",
        value: function _next() {
          var t = this.position,
            e = this.position.clone(),
            n = this._visitedParent;
          if (null === n.parent && e.offset === n.maxOffset) return {
            done: !0
          };
          if (n === this._boundaryEndParent && e.offset == this.boundaries.end.offset) return {
            done: !0
          };
          var o = e.parent,
            i = fa(e, o),
            r = i || ka(e, o, i);
          if (r instanceof ua) return this.shallow ? e.offset++ : (e.path.push(0), this._visitedParent = r), this.position = e, ma("elementStart", r, t, e, 1);
          if (r instanceof la) {
            var _o43;
            if (this.singleCharacters) _o43 = 1;else {
              var _t84 = r.endOffset;
              this._boundaryEndParent == n && this.boundaries.end.offset < _t84 && (_t84 = this.boundaries.end.offset), _o43 = _t84 - e.offset;
            }
            var _i43 = e.offset - r.startOffset,
              _s12 = new da(r, _i43, _o43);
            return e.offset += _o43, this.position = e, ma("text", _s12, t, e, _o43);
          }
          return e.path.pop(), e.offset++, this.position = e, this._visitedParent = n.parent, this.ignoreElementEnd ? this._next() : ma("elementEnd", n, t, e);
        }
      }, {
        key: "_previous",
        value: function _previous() {
          var t = this.position,
            e = this.position.clone(),
            n = this._visitedParent;
          if (null === n.parent && 0 === e.offset) return {
            done: !0
          };
          if (n == this._boundaryStartParent && e.offset == this.boundaries.start.offset) return {
            done: !0
          };
          var o = e.parent,
            i = fa(e, o),
            r = i || ba(e, o, i);
          if (r instanceof ua) return e.offset--, this.shallow ? (this.position = e, ma("elementStart", r, t, e, 1)) : (e.path.push(r.maxOffset), this.position = e, this._visitedParent = r, this.ignoreElementEnd ? this._previous() : ma("elementEnd", r, t, e));
          if (r instanceof la) {
            var _o44;
            if (this.singleCharacters) _o44 = 1;else {
              var _t85 = r.startOffset;
              this._boundaryStartParent == n && this.boundaries.start.offset > _t85 && (_t85 = this.boundaries.start.offset), _o44 = e.offset - _t85;
            }
            var _i44 = e.offset - r.startOffset,
              _s13 = new da(r, _i44 - _o44, _o44);
            return e.offset -= _o44, this.position = e, ma("text", _s13, t, e, _o44);
          }
          return e.path.pop(), this.position = e, this._visitedParent = n.parent, ma("elementStart", n, t, e, 1);
        }
      }]);
      return ga;
    }();
    function ma(t, e, n, o, i) {
      return {
        done: !1,
        value: {
          type: t,
          item: e,
          previousPosition: n,
          nextPosition: o,
          length: i
        }
      };
    }
    var pa = /*#__PURE__*/function () {
      function pa(t, e) {
        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "toNone";
        _classCallCheck(this, pa);
        if (!t.is("element") && !t.is("documentFragment")) throw new c.a("model-position-root-invalid", t);
        if (!(e instanceof Array) || 0 === e.length) throw new c.a("model-position-path-incorrect-format", t, {
          path: e
        });
        t.is("rootElement") ? e = e.slice() : (e = [].concat(_toConsumableArray(t.getPath()), _toConsumableArray(e)), t = t.root), this.root = t, this.path = e, this.stickiness = n;
      }
      _createClass(pa, [{
        key: "compareWith",
        value: function compareWith(t) {
          if (this.root != t.root) return "different";
          var e = bo(this.path, t.path);
          switch (e) {
            case "same":
              return "same";
            case "prefix":
              return "before";
            case "extension":
              return "after";
            default:
              return this.path[e] < t.path[e] ? "before" : "after";
          }
        }
      }, {
        key: "getLastMatchingPosition",
        value: function getLastMatchingPosition(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          e.startPosition = this;
          var n = new ga(e);
          return n.skip(t), n.position;
        }
      }, {
        key: "getParentPath",
        value: function getParentPath() {
          return this.path.slice(0, -1);
        }
      }, {
        key: "getAncestors",
        value: function getAncestors() {
          var t = this.parent;
          return t.is("documentFragment") ? [t] : t.getAncestors({
            includeSelf: !0
          });
        }
      }, {
        key: "findAncestor",
        value: function findAncestor(t) {
          var e = this.parent;
          return e.is("element") ? e.findAncestor(t, {
            includeSelf: !0
          }) : null;
        }
      }, {
        key: "getCommonPath",
        value: function getCommonPath(t) {
          if (this.root != t.root) return [];
          var e = bo(this.path, t.path),
            n = "string" == typeof e ? Math.min(this.path.length, t.path.length) : e;
          return this.path.slice(0, n);
        }
      }, {
        key: "getCommonAncestor",
        value: function getCommonAncestor(t) {
          var e = this.getAncestors(),
            n = t.getAncestors();
          var o = 0;
          for (; e[o] == n[o] && e[o];) o++;
          return 0 === o ? null : e[o - 1];
        }
      }, {
        key: "getShiftedBy",
        value: function getShiftedBy(t) {
          var e = this.clone(),
            n = e.offset + t;
          return e.offset = n < 0 ? 0 : n, e;
        }
      }, {
        key: "isAfter",
        value: function isAfter(t) {
          return "after" == this.compareWith(t);
        }
      }, {
        key: "isBefore",
        value: function isBefore(t) {
          return "before" == this.compareWith(t);
        }
      }, {
        key: "isEqual",
        value: function isEqual(t) {
          return "same" == this.compareWith(t);
        }
      }, {
        key: "isTouching",
        value: function isTouching(t) {
          var e = null,
            n = null;
          switch (this.compareWith(t)) {
            case "same":
              return !0;
            case "before":
              e = pa._createAt(this), n = pa._createAt(t);
              break;
            case "after":
              e = pa._createAt(t), n = pa._createAt(this);
              break;
            default:
              return !1;
          }
          var o = e.parent;
          for (; e.path.length + n.path.length;) {
            if (e.isEqual(n)) return !0;
            if (e.path.length > n.path.length) {
              if (e.offset !== o.maxOffset) return !1;
              e.path = e.path.slice(0, -1), o = o.parent, e.offset++;
            } else {
              if (0 !== n.offset) return !1;
              n.path = n.path.slice(0, -1);
            }
          }
        }
      }, {
        key: "is",
        value: function is(t) {
          return "position" === t || "model:position" === t;
        }
      }, {
        key: "hasSameParentAs",
        value: function hasSameParentAs(t) {
          if (this.root !== t.root) return !1;
          return "same" == bo(this.getParentPath(), t.getParentPath());
        }
      }, {
        key: "getTransformedByOperation",
        value: function getTransformedByOperation(t) {
          var e;
          switch (t.type) {
            case "insert":
              e = this._getTransformedByInsertOperation(t);
              break;
            case "move":
            case "remove":
            case "reinsert":
              e = this._getTransformedByMoveOperation(t);
              break;
            case "split":
              e = this._getTransformedBySplitOperation(t);
              break;
            case "merge":
              e = this._getTransformedByMergeOperation(t);
              break;
            default:
              e = pa._createAt(this);
          }
          return e;
        }
      }, {
        key: "_getTransformedByInsertOperation",
        value: function _getTransformedByInsertOperation(t) {
          return this._getTransformedByInsertion(t.position, t.howMany);
        }
      }, {
        key: "_getTransformedByMoveOperation",
        value: function _getTransformedByMoveOperation(t) {
          return this._getTransformedByMove(t.sourcePosition, t.targetPosition, t.howMany);
        }
      }, {
        key: "_getTransformedBySplitOperation",
        value: function _getTransformedBySplitOperation(t) {
          var e = t.movedRange;
          return e.containsPosition(this) || e.start.isEqual(this) && "toNext" == this.stickiness ? this._getCombined(t.splitPosition, t.moveTargetPosition) : t.graveyardPosition ? this._getTransformedByMove(t.graveyardPosition, t.insertionPosition, 1) : this._getTransformedByInsertion(t.insertionPosition, 1);
        }
      }, {
        key: "_getTransformedByMergeOperation",
        value: function _getTransformedByMergeOperation(t) {
          var e = t.movedRange;
          var n;
          return e.containsPosition(this) || e.start.isEqual(this) ? (n = this._getCombined(t.sourcePosition, t.targetPosition), t.sourcePosition.isBefore(t.targetPosition) && (n = n._getTransformedByDeletion(t.deletionPosition, 1))) : n = this.isEqual(t.deletionPosition) ? pa._createAt(t.deletionPosition) : this._getTransformedByMove(t.deletionPosition, t.graveyardPosition, 1), n;
        }
      }, {
        key: "_getTransformedByDeletion",
        value: function _getTransformedByDeletion(t, e) {
          var n = pa._createAt(this);
          if (this.root != t.root) return n;
          if ("same" == bo(t.getParentPath(), this.getParentPath())) {
            if (t.offset < this.offset) {
              if (t.offset + e > this.offset) return null;
              n.offset -= e;
            }
          } else if ("prefix" == bo(t.getParentPath(), this.getParentPath())) {
            var _o45 = t.path.length - 1;
            if (t.offset <= this.path[_o45]) {
              if (t.offset + e > this.path[_o45]) return null;
              n.path[_o45] -= e;
            }
          }
          return n;
        }
      }, {
        key: "_getTransformedByInsertion",
        value: function _getTransformedByInsertion(t, e) {
          var n = pa._createAt(this);
          if (this.root != t.root) return n;
          if ("same" == bo(t.getParentPath(), this.getParentPath())) (t.offset < this.offset || t.offset == this.offset && "toPrevious" != this.stickiness) && (n.offset += e);else if ("prefix" == bo(t.getParentPath(), this.getParentPath())) {
            var _o46 = t.path.length - 1;
            t.offset <= this.path[_o46] && (n.path[_o46] += e);
          }
          return n;
        }
      }, {
        key: "_getTransformedByMove",
        value: function _getTransformedByMove(t, e, n) {
          if (e = e._getTransformedByDeletion(t, n), t.isEqual(e)) return pa._createAt(this);
          var o = this._getTransformedByDeletion(t, n);
          return null === o || t.isEqual(this) && "toNext" == this.stickiness || t.getShiftedBy(n).isEqual(this) && "toPrevious" == this.stickiness ? this._getCombined(t, e) : o._getTransformedByInsertion(e, n);
        }
      }, {
        key: "_getCombined",
        value: function _getCombined(t, e) {
          var n = t.path.length - 1,
            o = pa._createAt(e);
          return o.stickiness = this.stickiness, o.offset = o.offset + this.path[n] - t.offset, o.path = [].concat(_toConsumableArray(o.path), _toConsumableArray(this.path.slice(n + 1))), o;
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          return {
            root: this.root.toJSON(),
            path: Array.from(this.path),
            stickiness: this.stickiness
          };
        }
      }, {
        key: "clone",
        value: function clone() {
          return new this.constructor(this.root, this.path, this.stickiness);
        }
      }, {
        key: "offset",
        get: function get() {
          return this.path[this.path.length - 1];
        },
        set: function set(t) {
          this.path[this.path.length - 1] = t;
        }
      }, {
        key: "parent",
        get: function get() {
          var t = this.root;
          for (var _e88 = 0; _e88 < this.path.length - 1; _e88++) if (t = t.getChild(t.offsetToIndex(this.path[_e88])), !t) throw new c.a("model-position-path-incorrect", this, {
            position: this
          });
          if (t.is("$text")) throw new c.a("model-position-path-incorrect", this, {
            position: this
          });
          return t;
        }
      }, {
        key: "index",
        get: function get() {
          return this.parent.offsetToIndex(this.offset);
        }
      }, {
        key: "textNode",
        get: function get() {
          return fa(this, this.parent);
        }
      }, {
        key: "nodeAfter",
        get: function get() {
          var t = this.parent;
          return ka(this, t, fa(this, t));
        }
      }, {
        key: "nodeBefore",
        get: function get() {
          var t = this.parent;
          return ba(this, t, fa(this, t));
        }
      }, {
        key: "isAtStart",
        get: function get() {
          return 0 === this.offset;
        }
      }, {
        key: "isAtEnd",
        get: function get() {
          return this.offset == this.parent.maxOffset;
        }
      }], [{
        key: "_createAt",
        value: function _createAt(t, e) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "toNone";
          if (t instanceof pa) return new pa(t.root, t.path, t.stickiness);
          {
            var _o47 = t;
            if ("end" == e) e = _o47.maxOffset;else {
              if ("before" == e) return this._createBefore(_o47, n);
              if ("after" == e) return this._createAfter(_o47, n);
              if (0 !== e && !e) throw new c.a("model-createpositionat-offset-required", [this, t]);
            }
            if (!_o47.is("element") && !_o47.is("documentFragment")) throw new c.a("model-position-parent-incorrect", [this, t]);
            var _i45 = _o47.getPath();
            return _i45.push(e), new this(_o47.root, _i45, n);
          }
        }
      }, {
        key: "_createAfter",
        value: function _createAfter(t, e) {
          if (!t.parent) throw new c.a("model-position-after-root", [this, t], {
            root: t
          });
          return this._createAt(t.parent, t.endOffset, e);
        }
      }, {
        key: "_createBefore",
        value: function _createBefore(t, e) {
          if (!t.parent) throw new c.a("model-position-before-root", t, {
            root: t
          });
          return this._createAt(t.parent, t.startOffset, e);
        }
      }, {
        key: "fromJSON",
        value: function fromJSON(t, e) {
          if ("$graveyard" === t.root) {
            var _n89 = new pa(e.graveyard, t.path);
            return _n89.stickiness = t.stickiness, _n89;
          }
          if (!e.getRoot(t.root)) throw new c.a("model-position-fromjson-no-root", e, {
            rootName: t.root
          });
          return new pa(e.getRoot(t.root), t.path, t.stickiness);
        }
      }]);
      return pa;
    }();
    function fa(t, e) {
      var n = e.getChild(e.offsetToIndex(t.offset));
      return n && n.is("$text") && n.startOffset < t.offset ? n : null;
    }
    function ka(t, e, n) {
      return null !== n ? null : e.getChild(e.offsetToIndex(t.offset));
    }
    function ba(t, e, n) {
      return null !== n ? null : e.getChild(e.offsetToIndex(t.offset) - 1);
    }
    var wa = /*#__PURE__*/function () {
      function wa(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        _classCallCheck(this, wa);
        this.start = pa._createAt(t), this.end = e ? pa._createAt(e) : pa._createAt(t), this.start.stickiness = this.isCollapsed ? "toNone" : "toNext", this.end.stickiness = this.isCollapsed ? "toNone" : "toPrevious";
      }
      _createClass(wa, [{
        key: Symbol.iterator,
        value: /*#__PURE__*/_regeneratorRuntime().mark(function value() {
          return _regeneratorRuntime().wrap(function value$(_context13) {
            while (1) switch (_context13.prev = _context13.next) {
              case 0:
                return _context13.delegateYield(new ga({
                  boundaries: this,
                  ignoreElementEnd: !0
                }), "t0", 1);
              case 1:
              case "end":
                return _context13.stop();
            }
          }, value, this);
        })
      }, {
        key: "containsPosition",
        value: function containsPosition(t) {
          return t.isAfter(this.start) && t.isBefore(this.end);
        }
      }, {
        key: "containsRange",
        value: function containsRange(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          t.isCollapsed && (e = !1);
          var n = this.containsPosition(t.start) || e && this.start.isEqual(t.start),
            o = this.containsPosition(t.end) || e && this.end.isEqual(t.end);
          return n && o;
        }
      }, {
        key: "containsItem",
        value: function containsItem(t) {
          var e = pa._createBefore(t);
          return this.containsPosition(e) || this.start.isEqual(e);
        }
      }, {
        key: "is",
        value: function is(t) {
          return "range" === t || "model:range" === t;
        }
      }, {
        key: "isEqual",
        value: function isEqual(t) {
          return this.start.isEqual(t.start) && this.end.isEqual(t.end);
        }
      }, {
        key: "isIntersecting",
        value: function isIntersecting(t) {
          return this.start.isBefore(t.end) && this.end.isAfter(t.start);
        }
      }, {
        key: "getDifference",
        value: function getDifference(t) {
          var e = [];
          return this.isIntersecting(t) ? (this.containsPosition(t.start) && e.push(new wa(this.start, t.start)), this.containsPosition(t.end) && e.push(new wa(t.end, this.end))) : e.push(new wa(this.start, this.end)), e;
        }
      }, {
        key: "getIntersection",
        value: function getIntersection(t) {
          if (this.isIntersecting(t)) {
            var _e89 = this.start,
              _n90 = this.end;
            return this.containsPosition(t.start) && (_e89 = t.start), this.containsPosition(t.end) && (_n90 = t.end), new wa(_e89, _n90);
          }
          return null;
        }
      }, {
        key: "getJoined",
        value: function getJoined(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          var n = this.isIntersecting(t);
          if (n || (n = this.start.isBefore(t.start) ? e ? this.end.isTouching(t.start) : this.end.isEqual(t.start) : e ? t.end.isTouching(this.start) : t.end.isEqual(this.start)), !n) return null;
          var o = this.start,
            i = this.end;
          return t.start.isBefore(o) && (o = t.start), t.end.isAfter(i) && (i = t.end), new wa(o, i);
        }
      }, {
        key: "getMinimalFlatRanges",
        value: function getMinimalFlatRanges() {
          var t = [],
            e = this.start.getCommonPath(this.end).length,
            n = pa._createAt(this.start);
          var o = n.parent;
          for (; n.path.length > e + 1;) {
            var _e90 = o.maxOffset - n.offset;
            0 !== _e90 && t.push(new wa(n, n.getShiftedBy(_e90))), n.path = n.path.slice(0, -1), n.offset++, o = o.parent;
          }
          for (; n.path.length <= this.end.path.length;) {
            var _e91 = this.end.path[n.path.length - 1],
              _o48 = _e91 - n.offset;
            0 !== _o48 && t.push(new wa(n, n.getShiftedBy(_o48))), n.offset = _e91, n.path.push(0);
          }
          return t;
        }
      }, {
        key: "getWalker",
        value: function getWalker() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          return t.boundaries = this, new ga(t);
        }
      }, {
        key: "getItems",
        value: function getItems() {
          var _this55 = this;
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          return /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
            var e, _iterator109, _step109, _t86;
            return _regeneratorRuntime().wrap(function _callee5$(_context14) {
              while (1) switch (_context14.prev = _context14.next) {
                case 0:
                  t.boundaries = _this55, t.ignoreElementEnd = !0;
                  e = new ga(t);
                  _iterator109 = _createForOfIteratorHelper(e);
                  _context14.prev = 3;
                  _iterator109.s();
                case 5:
                  if ((_step109 = _iterator109.n()).done) {
                    _context14.next = 11;
                    break;
                  }
                  _t86 = _step109.value;
                  _context14.next = 9;
                  return _t86.item;
                case 9:
                  _context14.next = 5;
                  break;
                case 11:
                  _context14.next = 16;
                  break;
                case 13:
                  _context14.prev = 13;
                  _context14.t0 = _context14["catch"](3);
                  _iterator109.e(_context14.t0);
                case 16:
                  _context14.prev = 16;
                  _iterator109.f();
                  return _context14.finish(16);
                case 19:
                case "end":
                  return _context14.stop();
              }
            }, _callee5, null, [[3, 13, 16, 19]]);
          })();
        }
      }, {
        key: "getPositions",
        value: function getPositions() {
          var _this56 = this;
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          return /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
            var e, _iterator110, _step110, _t87;
            return _regeneratorRuntime().wrap(function _callee6$(_context15) {
              while (1) switch (_context15.prev = _context15.next) {
                case 0:
                  t.boundaries = _this56;
                  e = new ga(t);
                  _context15.next = 4;
                  return e.position;
                case 4:
                  _iterator110 = _createForOfIteratorHelper(e);
                  _context15.prev = 5;
                  _iterator110.s();
                case 7:
                  if ((_step110 = _iterator110.n()).done) {
                    _context15.next = 13;
                    break;
                  }
                  _t87 = _step110.value;
                  _context15.next = 11;
                  return _t87.nextPosition;
                case 11:
                  _context15.next = 7;
                  break;
                case 13:
                  _context15.next = 18;
                  break;
                case 15:
                  _context15.prev = 15;
                  _context15.t0 = _context15["catch"](5);
                  _iterator110.e(_context15.t0);
                case 18:
                  _context15.prev = 18;
                  _iterator110.f();
                  return _context15.finish(18);
                case 21:
                case "end":
                  return _context15.stop();
              }
            }, _callee6, null, [[5, 15, 18, 21]]);
          })();
        }
      }, {
        key: "getTransformedByOperation",
        value: function getTransformedByOperation(t) {
          switch (t.type) {
            case "insert":
              return this._getTransformedByInsertOperation(t);
            case "move":
            case "remove":
            case "reinsert":
              return this._getTransformedByMoveOperation(t);
            case "split":
              return [this._getTransformedBySplitOperation(t)];
            case "merge":
              return [this._getTransformedByMergeOperation(t)];
          }
          return [new wa(this.start, this.end)];
        }
      }, {
        key: "getTransformedByOperations",
        value: function getTransformedByOperations(t) {
          var e = [new wa(this.start, this.end)];
          var _iterator111 = _createForOfIteratorHelper(t),
            _step111;
          try {
            for (_iterator111.s(); !(_step111 = _iterator111.n()).done;) {
              var _n92 = _step111.value;
              for (var _t92 = 0; _t92 < e.length; _t92++) {
                var _o51 = e[_t92].getTransformedByOperation(_n92);
                e.splice.apply(e, [_t92, 1].concat(_toConsumableArray(_o51))), _t92 += _o51.length - 1;
              }
            }
          } catch (err) {
            _iterator111.e(err);
          } finally {
            _iterator111.f();
          }
          for (var _t89 = 0; _t89 < e.length; _t89++) {
            var _n91 = e[_t89];
            for (var _o50 = _t89 + 1; _o50 < e.length; _o50++) {
              var _t90 = e[_o50];
              (_n91.containsRange(_t90) || _t90.containsRange(_n91) || _n91.isEqual(_t90)) && e.splice(_o50, 1);
            }
          }
          return e;
        }
      }, {
        key: "getCommonAncestor",
        value: function getCommonAncestor() {
          return this.start.getCommonAncestor(this.end);
        }
      }, {
        key: "getContainedElement",
        value: function getContainedElement() {
          if (this.isCollapsed) return null;
          var t = this.start.nodeAfter,
            e = this.end.nodeBefore;
          return t && t.is("element") && t === e ? t : null;
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          return {
            start: this.start.toJSON(),
            end: this.end.toJSON()
          };
        }
      }, {
        key: "clone",
        value: function clone() {
          return new this.constructor(this.start, this.end);
        }
      }, {
        key: "_getTransformedByInsertOperation",
        value: function _getTransformedByInsertOperation(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          return this._getTransformedByInsertion(t.position, t.howMany, e);
        }
      }, {
        key: "_getTransformedByMoveOperation",
        value: function _getTransformedByMoveOperation(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          var n = t.sourcePosition,
            o = t.howMany,
            i = t.targetPosition;
          return this._getTransformedByMove(n, i, o, e);
        }
      }, {
        key: "_getTransformedBySplitOperation",
        value: function _getTransformedBySplitOperation(t) {
          var e = this.start._getTransformedBySplitOperation(t);
          var n = this.end._getTransformedBySplitOperation(t);
          return this.end.isEqual(t.insertionPosition) && (n = this.end.getShiftedBy(1)), e.root != n.root && (n = this.end.getShiftedBy(-1)), new wa(e, n);
        }
      }, {
        key: "_getTransformedByMergeOperation",
        value: function _getTransformedByMergeOperation(t) {
          if (this.start.isEqual(t.targetPosition) && this.end.isEqual(t.deletionPosition)) return new wa(this.start);
          var e = this.start._getTransformedByMergeOperation(t),
            n = this.end._getTransformedByMergeOperation(t);
          return e.root != n.root && (n = this.end.getShiftedBy(-1)), e.isAfter(n) ? (t.sourcePosition.isBefore(t.targetPosition) ? (e = pa._createAt(n), e.offset = 0) : (t.deletionPosition.isEqual(e) || (n = t.deletionPosition), e = t.targetPosition), new wa(e, n)) : new wa(e, n);
        }
      }, {
        key: "_getTransformedByInsertion",
        value: function _getTransformedByInsertion(t, e) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
          if (n && this.containsPosition(t)) return [new wa(this.start, t), new wa(t.getShiftedBy(e), this.end._getTransformedByInsertion(t, e))];
          {
            var _n93 = new wa(this.start, this.end);
            return _n93.start = _n93.start._getTransformedByInsertion(t, e), _n93.end = _n93.end._getTransformedByInsertion(t, e), [_n93];
          }
        }
      }, {
        key: "_getTransformedByMove",
        value: function _getTransformedByMove(t, e, n) {
          var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
          if (this.isCollapsed) {
            var _o52 = this.start._getTransformedByMove(t, e, n);
            return [new wa(_o52)];
          }
          var i = wa._createFromPositionAndShift(t, n),
            r = e._getTransformedByDeletion(t, n);
          if (this.containsPosition(e) && !o && (i.containsPosition(this.start) || i.containsPosition(this.end))) {
            var _o53 = this.start._getTransformedByMove(t, e, n),
              _i46 = this.end._getTransformedByMove(t, e, n);
            return [new wa(_o53, _i46)];
          }
          var s;
          var a = this.getDifference(i);
          var c = null;
          var l = this.getIntersection(i);
          if (1 == a.length ? c = new wa(a[0].start._getTransformedByDeletion(t, n), a[0].end._getTransformedByDeletion(t, n)) : 2 == a.length && (c = new wa(this.start, this.end._getTransformedByDeletion(t, n))), s = c ? c._getTransformedByInsertion(r, n, null !== l || o) : [], l) {
            var _t93 = new wa(l.start._getCombined(i.start, r), l.end._getCombined(i.start, r));
            2 == s.length ? s.splice(1, 0, _t93) : s.push(_t93);
          }
          return s;
        }
      }, {
        key: "_getTransformedByDeletion",
        value: function _getTransformedByDeletion(t, e) {
          var n = this.start._getTransformedByDeletion(t, e),
            o = this.end._getTransformedByDeletion(t, e);
          return null == n && null == o ? null : (null == n && (n = t), null == o && (o = t), new wa(n, o));
        }
      }, {
        key: "isCollapsed",
        get: function get() {
          return this.start.isEqual(this.end);
        }
      }, {
        key: "isFlat",
        get: function get() {
          return "same" == bo(this.start.getParentPath(), this.end.getParentPath());
        }
      }, {
        key: "root",
        get: function get() {
          return this.start.root;
        }
      }], [{
        key: "_createFromPositionAndShift",
        value: function _createFromPositionAndShift(t, e) {
          var n = t,
            o = t.getShiftedBy(e);
          return e > 0 ? new this(n, o) : new this(o, n);
        }
      }, {
        key: "_createIn",
        value: function _createIn(t) {
          return new this(pa._createAt(t, 0), pa._createAt(t, t.maxOffset));
        }
      }, {
        key: "_createOn",
        value: function _createOn(t) {
          return this._createFromPositionAndShift(pa._createBefore(t), t.offsetSize);
        }
      }, {
        key: "_createFromRanges",
        value: function _createFromRanges(t) {
          if (0 === t.length) throw new c.a("range-create-from-ranges-empty-array", null);
          if (1 == t.length) return t[0].clone();
          var e = t[0];
          t.sort(function (t, e) {
            return t.start.isAfter(e.start) ? 1 : -1;
          });
          var n = t.indexOf(e),
            o = new this(e.start, e.end);
          if (n > 0) for (var _e93 = n - 1; t[_e93].end.isEqual(o.start); _e93++) o.start = pa._createAt(t[_e93].start);
          for (var _e95 = n + 1; _e95 < t.length && t[_e95].start.isEqual(o.end); _e95++) o.end = pa._createAt(t[_e95].end);
          return o;
        }
      }, {
        key: "fromJSON",
        value: function fromJSON(t, e) {
          return new this(pa.fromJSON(t.start, e), pa.fromJSON(t.end, e));
        }
      }]);
      return wa;
    }();
    var Ca = /*#__PURE__*/function () {
      function Ca() {
        var _this57 = this;
        _classCallCheck(this, Ca);
        this._modelToViewMapping = new WeakMap(), this._viewToModelMapping = new WeakMap(), this._viewToModelLengthCallbacks = new Map(), this._markerNameToElements = new Map(), this._elementToMarkerNames = new Map(), this._unboundMarkerNames = new Set(), this.on("modelToViewPosition", function (t, e) {
          if (e.viewPosition) return;
          var n = _this57._modelToViewMapping.get(e.modelPosition.parent);
          e.viewPosition = _this57.findPositionIn(n, e.modelPosition.offset);
        }, {
          priority: "low"
        }), this.on("viewToModelPosition", function (t, e) {
          if (e.modelPosition) return;
          var n = _this57.findMappedViewAncestor(e.viewPosition),
            o = _this57._viewToModelMapping.get(n),
            i = _this57._toModelOffset(e.viewPosition.parent, e.viewPosition.offset, n);
          e.modelPosition = pa._createAt(o, i);
        }, {
          priority: "low"
        });
      }
      _createClass(Ca, [{
        key: "bindElements",
        value: function bindElements(t, e) {
          this._modelToViewMapping.set(t, e), this._viewToModelMapping.set(e, t);
        }
      }, {
        key: "unbindViewElement",
        value: function unbindViewElement(t) {
          var e = this.toModelElement(t);
          if (this._viewToModelMapping.delete(t), this._elementToMarkerNames.has(t)) {
            var _iterator112 = _createForOfIteratorHelper(this._elementToMarkerNames.get(t)),
              _step112;
            try {
              for (_iterator112.s(); !(_step112 = _iterator112.n()).done;) {
                var _e96 = _step112.value;
                this._unboundMarkerNames.add(_e96);
              }
            } catch (err) {
              _iterator112.e(err);
            } finally {
              _iterator112.f();
            }
          }
          this._modelToViewMapping.get(e) == t && this._modelToViewMapping.delete(e);
        }
      }, {
        key: "unbindModelElement",
        value: function unbindModelElement(t) {
          var e = this.toViewElement(t);
          this._modelToViewMapping.delete(t), this._viewToModelMapping.get(e) == t && this._viewToModelMapping.delete(e);
        }
      }, {
        key: "bindElementToMarker",
        value: function bindElementToMarker(t, e) {
          var n = this._markerNameToElements.get(e) || new Set();
          n.add(t);
          var o = this._elementToMarkerNames.get(t) || new Set();
          o.add(e), this._markerNameToElements.set(e, n), this._elementToMarkerNames.set(t, o);
        }
      }, {
        key: "unbindElementFromMarkerName",
        value: function unbindElementFromMarkerName(t, e) {
          var n = this._markerNameToElements.get(e);
          n && (n.delete(t), 0 == n.size && this._markerNameToElements.delete(e));
          var o = this._elementToMarkerNames.get(t);
          o && (o.delete(e), 0 == o.size && this._elementToMarkerNames.delete(t));
        }
      }, {
        key: "flushUnboundMarkerNames",
        value: function flushUnboundMarkerNames() {
          var t = Array.from(this._unboundMarkerNames);
          return this._unboundMarkerNames.clear(), t;
        }
      }, {
        key: "clearBindings",
        value: function clearBindings() {
          this._modelToViewMapping = new WeakMap(), this._viewToModelMapping = new WeakMap(), this._markerNameToElements = new Map(), this._elementToMarkerNames = new Map(), this._unboundMarkerNames = new Set();
        }
      }, {
        key: "toModelElement",
        value: function toModelElement(t) {
          return this._viewToModelMapping.get(t);
        }
      }, {
        key: "toViewElement",
        value: function toViewElement(t) {
          return this._modelToViewMapping.get(t);
        }
      }, {
        key: "toModelRange",
        value: function toModelRange(t) {
          return new wa(this.toModelPosition(t.start), this.toModelPosition(t.end));
        }
      }, {
        key: "toViewRange",
        value: function toViewRange(t) {
          return new wi(this.toViewPosition(t.start), this.toViewPosition(t.end));
        }
      }, {
        key: "toModelPosition",
        value: function toModelPosition(t) {
          var e = {
            viewPosition: t,
            mapper: this
          };
          return this.fire("viewToModelPosition", e), e.modelPosition;
        }
      }, {
        key: "toViewPosition",
        value: function toViewPosition(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            isPhantom: !1
          };
          var n = {
            modelPosition: t,
            mapper: this,
            isPhantom: e.isPhantom
          };
          return this.fire("modelToViewPosition", n), n.viewPosition;
        }
      }, {
        key: "markerNameToElements",
        value: function markerNameToElements(t) {
          var e = this._markerNameToElements.get(t);
          if (!e) return null;
          var n = new Set();
          var _iterator113 = _createForOfIteratorHelper(e),
            _step113;
          try {
            for (_iterator113.s(); !(_step113 = _iterator113.n()).done;) {
              var _t94 = _step113.value;
              if (_t94.is("attributeElement")) {
                var _iterator114 = _createForOfIteratorHelper(_t94.getElementsWithSameId()),
                  _step114;
                try {
                  for (_iterator114.s(); !(_step114 = _iterator114.n()).done;) {
                    var _e97 = _step114.value;
                    n.add(_e97);
                  }
                } catch (err) {
                  _iterator114.e(err);
                } finally {
                  _iterator114.f();
                }
              } else n.add(_t94);
            }
          } catch (err) {
            _iterator113.e(err);
          } finally {
            _iterator113.f();
          }
          return n;
        }
      }, {
        key: "registerViewToModelLength",
        value: function registerViewToModelLength(t, e) {
          this._viewToModelLengthCallbacks.set(t, e);
        }
      }, {
        key: "findMappedViewAncestor",
        value: function findMappedViewAncestor(t) {
          var e = t.parent;
          for (; !this._viewToModelMapping.has(e);) e = e.parent;
          return e;
        }
      }, {
        key: "_toModelOffset",
        value: function _toModelOffset(t, e, n) {
          if (n != t) {
            return this._toModelOffset(t.parent, t.index, n) + this._toModelOffset(t, e, t);
          }
          if (t.is("$text")) return e;
          var o = 0;
          for (var _n95 = 0; _n95 < e; _n95++) o += this.getModelLength(t.getChild(_n95));
          return o;
        }
      }, {
        key: "getModelLength",
        value: function getModelLength(t) {
          if (this._viewToModelLengthCallbacks.get(t.name)) {
            return this._viewToModelLengthCallbacks.get(t.name)(t);
          }
          if (this._viewToModelMapping.has(t)) return 1;
          if (t.is("$text")) return t.data.length;
          if (t.is("uiElement")) return 0;
          {
            var _e98 = 0;
            var _iterator115 = _createForOfIteratorHelper(t.getChildren()),
              _step115;
            try {
              for (_iterator115.s(); !(_step115 = _iterator115.n()).done;) {
                var _n96 = _step115.value;
                _e98 += this.getModelLength(_n96);
              }
            } catch (err) {
              _iterator115.e(err);
            } finally {
              _iterator115.f();
            }
            return _e98;
          }
        }
      }, {
        key: "findPositionIn",
        value: function findPositionIn(t, e) {
          var n,
            o = 0,
            i = 0,
            r = 0;
          if (t.is("$text")) return new bi(t, e);
          for (; i < e;) n = t.getChild(r), o = this.getModelLength(n), i += o, r++;
          return i == e ? this._moveViewPositionToTextNode(new bi(t, r)) : this.findPositionIn(n, e - (i - o));
        }
      }, {
        key: "_moveViewPositionToTextNode",
        value: function _moveViewPositionToTextNode(t) {
          var e = t.nodeBefore,
            n = t.nodeAfter;
          return e instanceof Ao ? new bi(e, e.data.length) : n instanceof Ao ? new bi(n, 0) : t;
        }
      }]);
      return Ca;
    }();
    $t(Ca, h);
    var Aa = /*#__PURE__*/function () {
      function Aa() {
        _classCallCheck(this, Aa);
        this._consumable = new Map(), this._textProxyRegistry = new Map();
      }
      _createClass(Aa, [{
        key: "add",
        value: function add(t, e) {
          e = _a(e), t instanceof da && (t = this._getSymbolForTextProxy(t)), this._consumable.has(t) || this._consumable.set(t, new Map()), this._consumable.get(t).set(e, !0);
        }
      }, {
        key: "consume",
        value: function consume(t, e) {
          return e = _a(e), t instanceof da && (t = this._getSymbolForTextProxy(t)), !!this.test(t, e) && (this._consumable.get(t).set(e, !1), !0);
        }
      }, {
        key: "test",
        value: function test(t, e) {
          e = _a(e), t instanceof da && (t = this._getSymbolForTextProxy(t));
          var n = this._consumable.get(t);
          if (void 0 === n) return null;
          var o = n.get(e);
          return void 0 === o ? null : o;
        }
      }, {
        key: "revert",
        value: function revert(t, e) {
          e = _a(e), t instanceof da && (t = this._getSymbolForTextProxy(t));
          var n = this.test(t, e);
          return !1 === n ? (this._consumable.get(t).set(e, !0), !0) : !0 !== n && null;
        }
      }, {
        key: "_getSymbolForTextProxy",
        value: function _getSymbolForTextProxy(t) {
          var e = null;
          var n = this._textProxyRegistry.get(t.startOffset);
          if (n) {
            var _o54 = n.get(t.endOffset);
            _o54 && (e = _o54.get(t.parent));
          }
          return e || (e = this._addSymbolForTextProxy(t.startOffset, t.endOffset, t.parent)), e;
        }
      }, {
        key: "_addSymbolForTextProxy",
        value: function _addSymbolForTextProxy(t, e, n) {
          var o = Symbol("textProxySymbol");
          var i, r;
          return i = this._textProxyRegistry.get(t), i || (i = new Map(), this._textProxyRegistry.set(t, i)), r = i.get(e), r || (r = new Map(), i.set(e, r)), r.set(n, o), o;
        }
      }]);
      return Aa;
    }();
    function _a(t) {
      var e = t.split(":");
      return "addMarker" == e[0] || "removeMarker" == e[0] ? t : e.length > 1 ? e[0] + ":" + e[1] : e[0];
    }
    var va = /*#__PURE__*/function () {
      function va(t) {
        _classCallCheck(this, va);
        this.conversionApi = Object.assign({
          dispatcher: this
        }, t), this._reconversionEventsMapping = new Map();
      }
      _createClass(va, [{
        key: "convertChanges",
        value: function convertChanges(t, e, n) {
          var _iterator116 = _createForOfIteratorHelper(t.getMarkersToRemove()),
            _step116;
          try {
            for (_iterator116.s(); !(_step116 = _iterator116.n()).done;) {
              var _e99 = _step116.value;
              this.convertMarkerRemove(_e99.name, _e99.range, n);
            }
          } catch (err) {
            _iterator116.e(err);
          } finally {
            _iterator116.f();
          }
          var o = this._mapChangesWithAutomaticReconversion(t);
          var _iterator117 = _createForOfIteratorHelper(o),
            _step117;
          try {
            for (_iterator117.s(); !(_step117 = _iterator117.n()).done;) {
              var _t95 = _step117.value;
              "insert" === _t95.type ? this.convertInsert(wa._createFromPositionAndShift(_t95.position, _t95.length), n) : "remove" === _t95.type ? this.convertRemove(_t95.position, _t95.length, _t95.name, n) : "reconvert" === _t95.type ? this.reconvertElement(_t95.element, n) : this.convertAttribute(_t95.range, _t95.attributeKey, _t95.attributeOldValue, _t95.attributeNewValue, n);
            }
          } catch (err) {
            _iterator117.e(err);
          } finally {
            _iterator117.f();
          }
          var _iterator118 = _createForOfIteratorHelper(this.conversionApi.mapper.flushUnboundMarkerNames()),
            _step118;
          try {
            for (_iterator118.s(); !(_step118 = _iterator118.n()).done;) {
              var _t96 = _step118.value;
              var _o55 = e.get(_t96).getRange();
              this.convertMarkerRemove(_t96, _o55, n), this.convertMarkerAdd(_t96, _o55, n);
            }
          } catch (err) {
            _iterator118.e(err);
          } finally {
            _iterator118.f();
          }
          var _iterator119 = _createForOfIteratorHelper(t.getMarkersToAdd()),
            _step119;
          try {
            for (_iterator119.s(); !(_step119 = _iterator119.n()).done;) {
              var _e100 = _step119.value;
              this.convertMarkerAdd(_e100.name, _e100.range, n);
            }
          } catch (err) {
            _iterator119.e(err);
          } finally {
            _iterator119.f();
          }
        }
      }, {
        key: "convertInsert",
        value: function convertInsert(t, e) {
          this.conversionApi.writer = e, this.conversionApi.consumable = this._createInsertConsumable(t);
          var _iterator120 = _createForOfIteratorHelper(Array.from(t).map(xa)),
            _step120;
          try {
            for (_iterator120.s(); !(_step120 = _iterator120.n()).done;) {
              var _e101 = _step120.value;
              this._convertInsertWithAttributes(_e101);
            }
          } catch (err) {
            _iterator120.e(err);
          } finally {
            _iterator120.f();
          }
          this._clearConversionApi();
        }
      }, {
        key: "convertRemove",
        value: function convertRemove(t, e, n, o) {
          this.conversionApi.writer = o, this.fire("remove:" + n, {
            position: t,
            length: e
          }, this.conversionApi), this._clearConversionApi();
        }
      }, {
        key: "convertAttribute",
        value: function convertAttribute(t, e, n, o, i) {
          this.conversionApi.writer = i, this.conversionApi.consumable = this._createConsumableForRange(t, "attribute:".concat(e));
          var _iterator121 = _createForOfIteratorHelper(t),
            _step121;
          try {
            for (_iterator121.s(); !(_step121 = _iterator121.n()).done;) {
              var _i47 = _step121.value;
              var _t97 = {
                item: _i47.item,
                range: wa._createFromPositionAndShift(_i47.previousPosition, _i47.length),
                attributeKey: e,
                attributeOldValue: n,
                attributeNewValue: o
              };
              this._testAndFire("attribute:".concat(e), _t97);
            }
          } catch (err) {
            _iterator121.e(err);
          } finally {
            _iterator121.f();
          }
          this._clearConversionApi();
        }
      }, {
        key: "reconvertElement",
        value: function reconvertElement(t, e) {
          var n = wa._createOn(t);
          this.conversionApi.writer = e, this.conversionApi.consumable = this._createInsertConsumable(n);
          var o = this.conversionApi.mapper,
            i = o.toViewElement(t);
          e.remove(i), this._convertInsertWithAttributes({
            item: t,
            range: n
          });
          var r = o.toViewElement(t);
          var _iterator122 = _createForOfIteratorHelper(wa._createIn(t)),
            _step122;
          try {
            for (_iterator122.s(); !(_step122 = _iterator122.n()).done;) {
              var _n97 = _step122.value;
              var _t98 = _n97.item,
                _i48 = Ea(_t98, o);
              _i48 ? _i48.root !== r.root && e.move(e.createRangeOn(_i48), o.toViewPosition(pa._createBefore(_t98))) : this._convertInsertWithAttributes(xa(_n97));
            }
          } catch (err) {
            _iterator122.e(err);
          } finally {
            _iterator122.f();
          }
          o.unbindViewElement(i), this._clearConversionApi();
        }
      }, {
        key: "convertSelection",
        value: function convertSelection(t, e, n) {
          var o = Array.from(e.getMarkersAtPosition(t.getFirstPosition()));
          if (this.conversionApi.writer = n, this.conversionApi.consumable = this._createSelectionConsumable(t, o), this.fire("selection", {
            selection: t
          }, this.conversionApi), t.isCollapsed) {
            var _iterator123 = _createForOfIteratorHelper(o),
              _step123;
            try {
              for (_iterator123.s(); !(_step123 = _iterator123.n()).done;) {
                var _e102 = _step123.value;
                var _n98 = _e102.getRange();
                if (!ya(t.getFirstPosition(), _e102, this.conversionApi.mapper)) continue;
                var _o56 = {
                  item: t,
                  markerName: _e102.name,
                  markerRange: _n98
                };
                this.conversionApi.consumable.test(t, "addMarker:" + _e102.name) && this.fire("addMarker:" + _e102.name, _o56, this.conversionApi);
              }
            } catch (err) {
              _iterator123.e(err);
            } finally {
              _iterator123.f();
            }
            var _iterator124 = _createForOfIteratorHelper(t.getAttributeKeys()),
              _step124;
            try {
              for (_iterator124.s(); !(_step124 = _iterator124.n()).done;) {
                var _e103 = _step124.value;
                var _n99 = {
                  item: t,
                  range: t.getFirstRange(),
                  attributeKey: _e103,
                  attributeOldValue: null,
                  attributeNewValue: t.getAttribute(_e103)
                };
                this.conversionApi.consumable.test(t, "attribute:" + _n99.attributeKey) && this.fire("attribute:" + _n99.attributeKey + ":$text", _n99, this.conversionApi);
              }
            } catch (err) {
              _iterator124.e(err);
            } finally {
              _iterator124.f();
            }
            this._clearConversionApi();
          } else this._clearConversionApi();
        }
      }, {
        key: "convertMarkerAdd",
        value: function convertMarkerAdd(t, e, n) {
          if ("$graveyard" == e.root.rootName) return;
          this.conversionApi.writer = n;
          var o = "addMarker:" + t,
            i = new Aa();
          if (i.add(e, o), this.conversionApi.consumable = i, this.fire(o, {
            markerName: t,
            markerRange: e
          }, this.conversionApi), i.test(e, o)) {
            this.conversionApi.consumable = this._createConsumableForRange(e, o);
            var _iterator125 = _createForOfIteratorHelper(e.getItems()),
              _step125;
            try {
              for (_iterator125.s(); !(_step125 = _iterator125.n()).done;) {
                var _n100 = _step125.value;
                if (!this.conversionApi.consumable.test(_n100, o)) continue;
                var _i49 = {
                  item: _n100,
                  range: wa._createOn(_n100),
                  markerName: t,
                  markerRange: e
                };
                this.fire(o, _i49, this.conversionApi);
              }
            } catch (err) {
              _iterator125.e(err);
            } finally {
              _iterator125.f();
            }
            this._clearConversionApi();
          } else this._clearConversionApi();
        }
      }, {
        key: "convertMarkerRemove",
        value: function convertMarkerRemove(t, e, n) {
          "$graveyard" != e.root.rootName && (this.conversionApi.writer = n, this.fire("removeMarker:" + t, {
            markerName: t,
            markerRange: e
          }, this.conversionApi), this._clearConversionApi());
        }
      }, {
        key: "_mapReconversionTriggerEvent",
        value: function _mapReconversionTriggerEvent(t, e) {
          this._reconversionEventsMapping.set(e, t);
        }
      }, {
        key: "_createInsertConsumable",
        value: function _createInsertConsumable(t) {
          var e = new Aa();
          var _iterator126 = _createForOfIteratorHelper(t),
            _step126;
          try {
            for (_iterator126.s(); !(_step126 = _iterator126.n()).done;) {
              var _n101 = _step126.value;
              var _t99 = _n101.item;
              e.add(_t99, "insert");
              var _iterator127 = _createForOfIteratorHelper(_t99.getAttributeKeys()),
                _step127;
              try {
                for (_iterator127.s(); !(_step127 = _iterator127.n()).done;) {
                  var _n102 = _step127.value;
                  e.add(_t99, "attribute:" + _n102);
                }
              } catch (err) {
                _iterator127.e(err);
              } finally {
                _iterator127.f();
              }
            }
          } catch (err) {
            _iterator126.e(err);
          } finally {
            _iterator126.f();
          }
          return e;
        }
      }, {
        key: "_createConsumableForRange",
        value: function _createConsumableForRange(t, e) {
          var n = new Aa();
          var _iterator128 = _createForOfIteratorHelper(t.getItems()),
            _step128;
          try {
            for (_iterator128.s(); !(_step128 = _iterator128.n()).done;) {
              var _o57 = _step128.value;
              n.add(_o57, e);
            }
          } catch (err) {
            _iterator128.e(err);
          } finally {
            _iterator128.f();
          }
          return n;
        }
      }, {
        key: "_createSelectionConsumable",
        value: function _createSelectionConsumable(t, e) {
          var n = new Aa();
          n.add(t, "selection");
          var _iterator129 = _createForOfIteratorHelper(e),
            _step129;
          try {
            for (_iterator129.s(); !(_step129 = _iterator129.n()).done;) {
              var _o58 = _step129.value;
              n.add(t, "addMarker:" + _o58.name);
            }
          } catch (err) {
            _iterator129.e(err);
          } finally {
            _iterator129.f();
          }
          var _iterator130 = _createForOfIteratorHelper(t.getAttributeKeys()),
            _step130;
          try {
            for (_iterator130.s(); !(_step130 = _iterator130.n()).done;) {
              var _e104 = _step130.value;
              n.add(t, "attribute:" + _e104);
            }
          } catch (err) {
            _iterator130.e(err);
          } finally {
            _iterator130.f();
          }
          return n;
        }
      }, {
        key: "_testAndFire",
        value: function _testAndFire(t, e) {
          this.conversionApi.consumable.test(e.item, t) && this.fire(function (t, e) {
            var n = e.item.name || "$text";
            return "".concat(t, ":").concat(n);
          }(t, e), e, this.conversionApi);
        }
      }, {
        key: "_clearConversionApi",
        value: function _clearConversionApi() {
          delete this.conversionApi.writer, delete this.conversionApi.consumable;
        }
      }, {
        key: "_convertInsertWithAttributes",
        value: function _convertInsertWithAttributes(t) {
          this._testAndFire("insert", t);
          var _iterator131 = _createForOfIteratorHelper(t.item.getAttributeKeys()),
            _step131;
          try {
            for (_iterator131.s(); !(_step131 = _iterator131.n()).done;) {
              var _e105 = _step131.value;
              t.attributeKey = _e105, t.attributeOldValue = null, t.attributeNewValue = t.item.getAttribute(_e105), this._testAndFire("attribute:".concat(_e105), t);
            }
          } catch (err) {
            _iterator131.e(err);
          } finally {
            _iterator131.f();
          }
        }
      }, {
        key: "_mapChangesWithAutomaticReconversion",
        value: function _mapChangesWithAutomaticReconversion(t) {
          var e = new Set(),
            n = [];
          var _iterator132 = _createForOfIteratorHelper(t.getChanges()),
            _step132;
          try {
            for (_iterator132.s(); !(_step132 = _iterator132.n()).done;) {
              var _o59 = _step132.value;
              var _t100 = _o59.position || _o59.range.start,
                _i50 = _t100.parent;
              if (fa(_t100, _i50)) {
                n.push(_o59);
                continue;
              }
              var _r18 = "attribute" === _o59.type ? ka(_t100, _i50, null) : _i50;
              if (_r18.is("$text")) {
                n.push(_o59);
                continue;
              }
              var _s14 = void 0;
              if (_s14 = "attribute" === _o59.type ? "attribute:".concat(_o59.attributeKey, ":").concat(_r18.name) : "".concat(_o59.type, ":").concat(_o59.name), this._isReconvertTriggerEvent(_s14, _r18.name)) {
                if (e.has(_r18)) continue;
                e.add(_r18), n.push({
                  type: "reconvert",
                  element: _r18
                });
              } else n.push(_o59);
            }
          } catch (err) {
            _iterator132.e(err);
          } finally {
            _iterator132.f();
          }
          return n;
        }
      }, {
        key: "_isReconvertTriggerEvent",
        value: function _isReconvertTriggerEvent(t, e) {
          return this._reconversionEventsMapping.get(t) === e;
        }
      }]);
      return va;
    }();
    function ya(t, e, n) {
      var o = e.getRange(),
        i = Array.from(t.getAncestors());
      i.shift(), i.reverse();
      return !i.some(function (t) {
        if (o.containsItem(t)) {
          return !!n.toViewElement(t).getCustomProperty("addHighlight");
        }
      });
    }
    function xa(t) {
      return {
        item: t.item,
        range: wa._createFromPositionAndShift(t.previousPosition, t.length)
      };
    }
    function Ea(t, e) {
      if (t.is("textProxy")) {
        var _n103 = e.toViewPosition(pa._createBefore(t)).parent;
        return _n103.is("$text") ? _n103 : null;
      }
      return e.toViewElement(t);
    }
    $t(va, h);
    var Da = /*#__PURE__*/function () {
      function Da(t, e, n) {
        _classCallCheck(this, Da);
        this._lastRangeBackward = !1, this._ranges = [], this._attrs = new Map(), t && this.setTo(t, e, n);
      }
      _createClass(Da, [{
        key: "isEqual",
        value: function isEqual(t) {
          if (this.rangeCount != t.rangeCount) return !1;
          if (0 === this.rangeCount) return !0;
          if (!this.anchor.isEqual(t.anchor) || !this.focus.isEqual(t.focus)) return !1;
          var _iterator133 = _createForOfIteratorHelper(this._ranges),
            _step133;
          try {
            for (_iterator133.s(); !(_step133 = _iterator133.n()).done;) {
              var _e106 = _step133.value;
              var _n104 = !1;
              var _iterator134 = _createForOfIteratorHelper(t._ranges),
                _step134;
              try {
                for (_iterator134.s(); !(_step134 = _iterator134.n()).done;) {
                  var _o60 = _step134.value;
                  if (_e106.isEqual(_o60)) {
                    _n104 = !0;
                    break;
                  }
                }
              } catch (err) {
                _iterator134.e(err);
              } finally {
                _iterator134.f();
              }
              if (!_n104) return !1;
            }
          } catch (err) {
            _iterator133.e(err);
          } finally {
            _iterator133.f();
          }
          return !0;
        }
      }, {
        key: "getRanges",
        value: /*#__PURE__*/_regeneratorRuntime().mark(function getRanges() {
          var _iterator135, _step135, _t101;
          return _regeneratorRuntime().wrap(function getRanges$(_context16) {
            while (1) switch (_context16.prev = _context16.next) {
              case 0:
                _iterator135 = _createForOfIteratorHelper(this._ranges);
                _context16.prev = 1;
                _iterator135.s();
              case 3:
                if ((_step135 = _iterator135.n()).done) {
                  _context16.next = 9;
                  break;
                }
                _t101 = _step135.value;
                _context16.next = 7;
                return new wa(_t101.start, _t101.end);
              case 7:
                _context16.next = 3;
                break;
              case 9:
                _context16.next = 14;
                break;
              case 11:
                _context16.prev = 11;
                _context16.t0 = _context16["catch"](1);
                _iterator135.e(_context16.t0);
              case 14:
                _context16.prev = 14;
                _iterator135.f();
                return _context16.finish(14);
              case 17:
              case "end":
                return _context16.stop();
            }
          }, getRanges, this, [[1, 11, 14, 17]]);
        })
      }, {
        key: "getFirstRange",
        value: function getFirstRange() {
          var t = null;
          var _iterator136 = _createForOfIteratorHelper(this._ranges),
            _step136;
          try {
            for (_iterator136.s(); !(_step136 = _iterator136.n()).done;) {
              var _e107 = _step136.value;
              t && !_e107.start.isBefore(t.start) || (t = _e107);
            }
          } catch (err) {
            _iterator136.e(err);
          } finally {
            _iterator136.f();
          }
          return t ? new wa(t.start, t.end) : null;
        }
      }, {
        key: "getLastRange",
        value: function getLastRange() {
          var t = null;
          var _iterator137 = _createForOfIteratorHelper(this._ranges),
            _step137;
          try {
            for (_iterator137.s(); !(_step137 = _iterator137.n()).done;) {
              var _e108 = _step137.value;
              t && !_e108.end.isAfter(t.end) || (t = _e108);
            }
          } catch (err) {
            _iterator137.e(err);
          } finally {
            _iterator137.f();
          }
          return t ? new wa(t.start, t.end) : null;
        }
      }, {
        key: "getFirstPosition",
        value: function getFirstPosition() {
          var t = this.getFirstRange();
          return t ? t.start.clone() : null;
        }
      }, {
        key: "getLastPosition",
        value: function getLastPosition() {
          var t = this.getLastRange();
          return t ? t.end.clone() : null;
        }
      }, {
        key: "setTo",
        value: function setTo(t, e, n) {
          if (null === t) this._setRanges([]);else if (t instanceof Da) this._setRanges(t.getRanges(), t.isBackward);else if (t && "function" == typeof t.getRanges) this._setRanges(t.getRanges(), t.isBackward);else if (t instanceof wa) this._setRanges([t], !!e && !!e.backward);else if (t instanceof pa) this._setRanges([new wa(t)]);else if (t instanceof ca) {
            var _o61 = !!n && !!n.backward;
            var _i51;
            if ("in" == e) _i51 = wa._createIn(t);else if ("on" == e) _i51 = wa._createOn(t);else {
              if (void 0 === e) throw new c.a("model-selection-setto-required-second-parameter", [this, t]);
              _i51 = new wa(pa._createAt(t, e));
            }
            this._setRanges([_i51], _o61);
          } else {
            if (!ao(t)) throw new c.a("model-selection-setto-not-selectable", [this, t]);
            this._setRanges(t, e && !!e.backward);
          }
        }
      }, {
        key: "_setRanges",
        value: function _setRanges(t) {
          var _this58 = this;
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          var n = (t = Array.from(t)).some(function (e) {
            if (!(e instanceof wa)) throw new c.a("model-selection-set-ranges-not-range", [_this58, t]);
            return _this58._ranges.every(function (t) {
              return !t.isEqual(e);
            });
          });
          if (t.length !== this._ranges.length || n) {
            this._removeAllRanges();
            var _iterator138 = _createForOfIteratorHelper(t),
              _step138;
            try {
              for (_iterator138.s(); !(_step138 = _iterator138.n()).done;) {
                var _e109 = _step138.value;
                this._pushRange(_e109);
              }
            } catch (err) {
              _iterator138.e(err);
            } finally {
              _iterator138.f();
            }
            this._lastRangeBackward = !!e, this.fire("change:range", {
              directChange: !0
            });
          }
        }
      }, {
        key: "setFocus",
        value: function setFocus(t, e) {
          if (null === this.anchor) throw new c.a("model-selection-setfocus-no-ranges", [this, t]);
          var n = pa._createAt(t, e);
          if ("same" == n.compareWith(this.focus)) return;
          var o = this.anchor;
          this._ranges.length && this._popRange(), "before" == n.compareWith(o) ? (this._pushRange(new wa(n, o)), this._lastRangeBackward = !0) : (this._pushRange(new wa(o, n)), this._lastRangeBackward = !1), this.fire("change:range", {
            directChange: !0
          });
        }
      }, {
        key: "getAttribute",
        value: function getAttribute(t) {
          return this._attrs.get(t);
        }
      }, {
        key: "getAttributes",
        value: function getAttributes() {
          return this._attrs.entries();
        }
      }, {
        key: "getAttributeKeys",
        value: function getAttributeKeys() {
          return this._attrs.keys();
        }
      }, {
        key: "hasAttribute",
        value: function hasAttribute(t) {
          return this._attrs.has(t);
        }
      }, {
        key: "removeAttribute",
        value: function removeAttribute(t) {
          this.hasAttribute(t) && (this._attrs.delete(t), this.fire("change:attribute", {
            attributeKeys: [t],
            directChange: !0
          }));
        }
      }, {
        key: "setAttribute",
        value: function setAttribute(t, e) {
          this.getAttribute(t) !== e && (this._attrs.set(t, e), this.fire("change:attribute", {
            attributeKeys: [t],
            directChange: !0
          }));
        }
      }, {
        key: "getSelectedElement",
        value: function getSelectedElement() {
          return 1 !== this.rangeCount ? null : this.getFirstRange().getContainedElement();
        }
      }, {
        key: "is",
        value: function is(t) {
          return "selection" === t || "model:selection" === t;
        }
      }, {
        key: "getSelectedBlocks",
        value: /*#__PURE__*/_regeneratorRuntime().mark(function getSelectedBlocks() {
          var t, _iterator139, _step139, _e110, _n105, _iterator140, _step140, _n106, _o63, _o62;
          return _regeneratorRuntime().wrap(function getSelectedBlocks$(_context17) {
            while (1) switch (_context17.prev = _context17.next) {
              case 0:
                t = new WeakSet();
                _iterator139 = _createForOfIteratorHelper(this.getRanges());
                _context17.prev = 2;
                _iterator139.s();
              case 4:
                if ((_step139 = _iterator139.n()).done) {
                  _context17.next = 38;
                  break;
                }
                _e110 = _step139.value;
                _n105 = Ta(_e110.start, t);
                _context17.t0 = _n105 && Sa(_n105, _e110);
                if (!_context17.t0) {
                  _context17.next = 11;
                  break;
                }
                _context17.next = 11;
                return _n105;
              case 11:
                _iterator140 = _createForOfIteratorHelper(_e110.getWalker());
                _context17.prev = 12;
                _iterator140.s();
              case 14:
                if ((_step140 = _iterator140.n()).done) {
                  _context17.next = 23;
                  break;
                }
                _n106 = _step140.value;
                _o63 = _n106.item;
                _context17.t1 = "elementEnd" == _n106.type && Ia(_o63, t, _e110);
                if (!_context17.t1) {
                  _context17.next = 21;
                  break;
                }
                _context17.next = 21;
                return _o63;
              case 21:
                _context17.next = 14;
                break;
              case 23:
                _context17.next = 28;
                break;
              case 25:
                _context17.prev = 25;
                _context17.t2 = _context17["catch"](12);
                _iterator140.e(_context17.t2);
              case 28:
                _context17.prev = 28;
                _iterator140.f();
                return _context17.finish(28);
              case 31:
                _o62 = Ta(_e110.end, t);
                _context17.t3 = _o62 && !_e110.end.isTouching(pa._createAt(_o62, 0)) && Sa(_o62, _e110);
                if (!_context17.t3) {
                  _context17.next = 36;
                  break;
                }
                _context17.next = 36;
                return _o62;
              case 36:
                _context17.next = 4;
                break;
              case 38:
                _context17.next = 43;
                break;
              case 40:
                _context17.prev = 40;
                _context17.t4 = _context17["catch"](2);
                _iterator139.e(_context17.t4);
              case 43:
                _context17.prev = 43;
                _iterator139.f();
                return _context17.finish(43);
              case 46:
              case "end":
                return _context17.stop();
            }
          }, getSelectedBlocks, this, [[2, 40, 43, 46], [12, 25, 28, 31]]);
        })
      }, {
        key: "containsEntireContent",
        value: function containsEntireContent() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.anchor.root;
          var e = pa._createAt(t, 0),
            n = pa._createAt(t, "end");
          return e.isTouching(this.getFirstPosition()) && n.isTouching(this.getLastPosition());
        }
      }, {
        key: "_pushRange",
        value: function _pushRange(t) {
          this._checkRange(t), this._ranges.push(new wa(t.start, t.end));
        }
      }, {
        key: "_checkRange",
        value: function _checkRange(t) {
          for (var _e112 = 0; _e112 < this._ranges.length; _e112++) if (t.isIntersecting(this._ranges[_e112])) throw new c.a("model-selection-range-intersects", [this, t], {
            addedRange: t,
            intersectingRange: this._ranges[_e112]
          });
        }
      }, {
        key: "_removeAllRanges",
        value: function _removeAllRanges() {
          for (; this._ranges.length > 0;) this._popRange();
        }
      }, {
        key: "_popRange",
        value: function _popRange() {
          this._ranges.pop();
        }
      }, {
        key: "anchor",
        get: function get() {
          if (this._ranges.length > 0) {
            var _t102 = this._ranges[this._ranges.length - 1];
            return this._lastRangeBackward ? _t102.end : _t102.start;
          }
          return null;
        }
      }, {
        key: "focus",
        get: function get() {
          if (this._ranges.length > 0) {
            var _t103 = this._ranges[this._ranges.length - 1];
            return this._lastRangeBackward ? _t103.start : _t103.end;
          }
          return null;
        }
      }, {
        key: "isCollapsed",
        get: function get() {
          return 1 === this._ranges.length && this._ranges[0].isCollapsed;
        }
      }, {
        key: "rangeCount",
        get: function get() {
          return this._ranges.length;
        }
      }, {
        key: "isBackward",
        get: function get() {
          return !this.isCollapsed && this._lastRangeBackward;
        }
      }]);
      return Da;
    }();
    function Ma(t, e) {
      return !e.has(t) && (e.add(t), t.root.document.model.schema.isBlock(t) && t.parent);
    }
    function Ia(t, e, n) {
      return Ma(t, e) && Sa(t, n);
    }
    function Ta(t, e) {
      var n = t.parent.root.document.model.schema,
        o = t.parent.getAncestors({
          parentFirst: !0,
          includeSelf: !0
        });
      var i = !1;
      var r = o.find(function (t) {
        return !i && (i = n.isLimit(t), !i && Ma(t, e));
      });
      return o.forEach(function (t) {
        return e.add(t);
      }), r;
    }
    function Sa(t, e) {
      var n = function (t) {
        var e = t.root.document.model.schema;
        var n = t.parent;
        for (; n;) {
          if (e.isBlock(n)) return n;
          n = n.parent;
        }
      }(t);
      if (!n) return !0;
      return !e.containsRange(wa._createOn(n), !0);
    }
    $t(Da, h);
    var Na = /*#__PURE__*/function (_wa) {
      _inherits(Na, _wa);
      function Na(t, e) {
        var _this59;
        _classCallCheck(this, Na);
        _this59 = _possibleConstructorReturn(this, _getPrototypeOf(Na).call(this, t, e)), Ba.call(_assertThisInitialized(_assertThisInitialized(_this59)));
        return _this59;
      }
      _createClass(Na, [{
        key: "detach",
        value: function detach() {
          this.stopListening();
        }
      }, {
        key: "is",
        value: function is(t) {
          return "liveRange" === t || "model:liveRange" === t || "range" == t || "model:range" === t;
        }
      }, {
        key: "toRange",
        value: function toRange() {
          return new wa(this.start, this.end);
        }
      }], [{
        key: "fromRange",
        value: function fromRange(t) {
          return new Na(t.start, t.end);
        }
      }]);
      return Na;
    }(wa);
    function Ba() {
      var _this60 = this;
      this.listenTo(this.root.document.model, "applyOperation", function (t, e) {
        var n = e[0];
        n.isDocumentOperation && Pa.call(_this60, n);
      }, {
        priority: "low"
      });
    }
    function Pa(t) {
      var e = this.getTransformedByOperation(t),
        n = wa._createFromRanges(e),
        o = !n.isEqual(this),
        i = function (t, e) {
          switch (e.type) {
            case "insert":
              return t.containsPosition(e.position);
            case "move":
            case "remove":
            case "reinsert":
            case "merge":
              return t.containsPosition(e.sourcePosition) || t.start.isEqual(e.sourcePosition) || t.containsPosition(e.targetPosition);
            case "split":
              return t.containsPosition(e.splitPosition) || t.containsPosition(e.insertionPosition);
          }
          return !1;
        }(this, t);
      var r = null;
      if (o) {
        "$graveyard" == n.root.rootName && (r = "remove" == t.type ? t.sourcePosition : t.deletionPosition);
        var _e113 = this.toRange();
        this.start = n.start, this.end = n.end, this.fire("change:range", _e113, {
          deletionPosition: r
        });
      } else i && this.fire("change:content", this.toRange(), {
        deletionPosition: r
      });
    }
    $t(Na, h);
    var za = "selection:";
    var La = /*#__PURE__*/function () {
      function La(t) {
        _classCallCheck(this, La);
        this._selection = new Oa(t), this._selection.delegate("change:range").to(this), this._selection.delegate("change:attribute").to(this), this._selection.delegate("change:marker").to(this);
      }
      _createClass(La, [{
        key: "getRanges",
        value: function getRanges() {
          return this._selection.getRanges();
        }
      }, {
        key: "getFirstPosition",
        value: function getFirstPosition() {
          return this._selection.getFirstPosition();
        }
      }, {
        key: "getLastPosition",
        value: function getLastPosition() {
          return this._selection.getLastPosition();
        }
      }, {
        key: "getFirstRange",
        value: function getFirstRange() {
          return this._selection.getFirstRange();
        }
      }, {
        key: "getLastRange",
        value: function getLastRange() {
          return this._selection.getLastRange();
        }
      }, {
        key: "getSelectedBlocks",
        value: function getSelectedBlocks() {
          return this._selection.getSelectedBlocks();
        }
      }, {
        key: "getSelectedElement",
        value: function getSelectedElement() {
          return this._selection.getSelectedElement();
        }
      }, {
        key: "containsEntireContent",
        value: function containsEntireContent(t) {
          return this._selection.containsEntireContent(t);
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this._selection.destroy();
        }
      }, {
        key: "getAttributeKeys",
        value: function getAttributeKeys() {
          return this._selection.getAttributeKeys();
        }
      }, {
        key: "getAttributes",
        value: function getAttributes() {
          return this._selection.getAttributes();
        }
      }, {
        key: "getAttribute",
        value: function getAttribute(t) {
          return this._selection.getAttribute(t);
        }
      }, {
        key: "hasAttribute",
        value: function hasAttribute(t) {
          return this._selection.hasAttribute(t);
        }
      }, {
        key: "refresh",
        value: function refresh() {
          this._selection._updateMarkers(), this._selection._updateAttributes(!1);
        }
      }, {
        key: "observeMarkers",
        value: function observeMarkers(t) {
          this._selection.observeMarkers(t);
        }
      }, {
        key: "is",
        value: function is(t) {
          return "selection" === t || "model:selection" == t || "documentSelection" == t || "model:documentSelection" == t;
        }
      }, {
        key: "_setFocus",
        value: function _setFocus(t, e) {
          this._selection.setFocus(t, e);
        }
      }, {
        key: "_setTo",
        value: function _setTo(t, e, n) {
          this._selection.setTo(t, e, n);
        }
      }, {
        key: "_setAttribute",
        value: function _setAttribute(t, e) {
          this._selection.setAttribute(t, e);
        }
      }, {
        key: "_removeAttribute",
        value: function _removeAttribute(t) {
          this._selection.removeAttribute(t);
        }
      }, {
        key: "_getStoredAttributes",
        value: function _getStoredAttributes() {
          return this._selection._getStoredAttributes();
        }
      }, {
        key: "_overrideGravity",
        value: function _overrideGravity() {
          return this._selection.overrideGravity();
        }
      }, {
        key: "_restoreGravity",
        value: function _restoreGravity(t) {
          this._selection.restoreGravity(t);
        }
      }, {
        key: "isCollapsed",
        get: function get() {
          return this._selection.isCollapsed;
        }
      }, {
        key: "anchor",
        get: function get() {
          return this._selection.anchor;
        }
      }, {
        key: "focus",
        get: function get() {
          return this._selection.focus;
        }
      }, {
        key: "rangeCount",
        get: function get() {
          return this._selection.rangeCount;
        }
      }, {
        key: "hasOwnRange",
        get: function get() {
          return this._selection.hasOwnRange;
        }
      }, {
        key: "isBackward",
        get: function get() {
          return this._selection.isBackward;
        }
      }, {
        key: "isGravityOverridden",
        get: function get() {
          return this._selection.isGravityOverridden;
        }
      }, {
        key: "markers",
        get: function get() {
          return this._selection.markers;
        }
      }, {
        key: "_ranges",
        get: function get() {
          return this._selection._ranges;
        }
      }], [{
        key: "_getStoreAttributeKey",
        value: function _getStoreAttributeKey(t) {
          return za + t;
        }
      }, {
        key: "_isStoreAttributeKey",
        value: function _isStoreAttributeKey(t) {
          return t.startsWith(za);
        }
      }]);
      return La;
    }();
    $t(La, h);
    var Oa = /*#__PURE__*/function (_Da) {
      _inherits(Oa, _Da);
      function Oa(t) {
        var _this61;
        _classCallCheck(this, Oa);
        _this61 = _possibleConstructorReturn(this, _getPrototypeOf(Oa).call(this)), _this61.markers = new co({
          idProperty: "name"
        }), _this61._model = t.model, _this61._document = t, _this61._attributePriority = new Map(), _this61._selectionRestorePosition = null, _this61._hasChangedRange = !1, _this61._overriddenGravityRegister = new Set(), _this61._observedMarkers = new Set(), _this61.listenTo(_this61._model, "applyOperation", function (t, e) {
          var n = e[0];
          n.isDocumentOperation && "marker" != n.type && "rename" != n.type && "noop" != n.type && (0 == _this61._ranges.length && _this61._selectionRestorePosition && _this61._fixGraveyardSelection(_this61._selectionRestorePosition), _this61._selectionRestorePosition = null, _this61._hasChangedRange && (_this61._hasChangedRange = !1, _this61.fire("change:range", {
            directChange: !1
          })));
        }, {
          priority: "lowest"
        }), _this61.on("change:range", function () {
          var _iterator141 = _createForOfIteratorHelper(_this61.getRanges()),
            _step141;
          try {
            for (_iterator141.s(); !(_step141 = _iterator141.n()).done;) {
              var _t104 = _step141.value;
              if (!_this61._document._validateSelectionRange(_t104)) throw new c.a("document-selection-wrong-position", _assertThisInitialized(_assertThisInitialized(_this61)), {
                range: _t104
              });
            }
          } catch (err) {
            _iterator141.e(err);
          } finally {
            _iterator141.f();
          }
        }), _this61.listenTo(_this61._model.markers, "update", function (t, e, n, o) {
          _this61._updateMarker(e, o);
        }), _this61.listenTo(_this61._document, "change", function (t, e) {
          !function (t, e) {
            var n = t.document.differ;
            var _iterator142 = _createForOfIteratorHelper(n.getChanges()),
              _step142;
            try {
              var _loop2 = function _loop2() {
                var o = _step142.value;
                if ("insert" != o.type) return "continue";
                var n = o.position.parent;
                o.length === n.maxOffset && t.enqueueChange(e, function (t) {
                  var e = Array.from(n.getAttributeKeys()).filter(function (t) {
                    return t.startsWith(za);
                  });
                  var _iterator143 = _createForOfIteratorHelper(e),
                    _step143;
                  try {
                    for (_iterator143.s(); !(_step143 = _iterator143.n()).done;) {
                      var _o64 = _step143.value;
                      t.removeAttribute(_o64, n);
                    }
                  } catch (err) {
                    _iterator143.e(err);
                  } finally {
                    _iterator143.f();
                  }
                });
              };
              for (_iterator142.s(); !(_step142 = _iterator142.n()).done;) {
                var _ret = _loop2();
                if (_ret === "continue") continue;
              }
            } catch (err) {
              _iterator142.e(err);
            } finally {
              _iterator142.f();
            }
          }(_this61._model, e);
        });
        return _this61;
      }
      _createClass(Oa, [{
        key: "destroy",
        value: function destroy() {
          for (var _t106 = 0; _t106 < this._ranges.length; _t106++) this._ranges[_t106].detach();
          this.stopListening();
        }
      }, {
        key: "getRanges",
        value: /*#__PURE__*/_regeneratorRuntime().mark(function getRanges() {
          return _regeneratorRuntime().wrap(function getRanges$(_context18) {
            while (1) switch (_context18.prev = _context18.next) {
              case 0:
                if (!this._ranges.length) {
                  _context18.next = 4;
                  break;
                }
                return _context18.delegateYield(_get(_getPrototypeOf(Oa.prototype), "getRanges", this).call(this), "t0", 2);
              case 2:
                _context18.next = 6;
                break;
              case 4:
                _context18.next = 6;
                return this._document._getDefaultRange();
              case 6:
              case "end":
                return _context18.stop();
            }
          }, getRanges, this);
        })
      }, {
        key: "getFirstRange",
        value: function getFirstRange() {
          return _get(_getPrototypeOf(Oa.prototype), "getFirstRange", this).call(this) || this._document._getDefaultRange();
        }
      }, {
        key: "getLastRange",
        value: function getLastRange() {
          return _get(_getPrototypeOf(Oa.prototype), "getLastRange", this).call(this) || this._document._getDefaultRange();
        }
      }, {
        key: "setTo",
        value: function setTo(t, e, n) {
          _get(_getPrototypeOf(Oa.prototype), "setTo", this).call(this, t, e, n), this._updateAttributes(!0), this._updateMarkers();
        }
      }, {
        key: "setFocus",
        value: function setFocus(t, e) {
          _get(_getPrototypeOf(Oa.prototype), "setFocus", this).call(this, t, e), this._updateAttributes(!0), this._updateMarkers();
        }
      }, {
        key: "setAttribute",
        value: function setAttribute(t, e) {
          if (this._setAttribute(t, e)) {
            var _e114 = [t];
            this.fire("change:attribute", {
              attributeKeys: _e114,
              directChange: !0
            });
          }
        }
      }, {
        key: "removeAttribute",
        value: function removeAttribute(t) {
          if (this._removeAttribute(t)) {
            var _e115 = [t];
            this.fire("change:attribute", {
              attributeKeys: _e115,
              directChange: !0
            });
          }
        }
      }, {
        key: "overrideGravity",
        value: function overrideGravity() {
          var t = s();
          return this._overriddenGravityRegister.add(t), 1 === this._overriddenGravityRegister.size && this._updateAttributes(!0), t;
        }
      }, {
        key: "restoreGravity",
        value: function restoreGravity(t) {
          if (!this._overriddenGravityRegister.has(t)) throw new c.a("document-selection-gravity-wrong-restore", this, {
            uid: t
          });
          this._overriddenGravityRegister.delete(t), this.isGravityOverridden || this._updateAttributes(!0);
        }
      }, {
        key: "observeMarkers",
        value: function observeMarkers(t) {
          this._observedMarkers.add(t), this._updateMarkers();
        }
      }, {
        key: "_popRange",
        value: function _popRange() {
          this._ranges.pop().detach();
        }
      }, {
        key: "_pushRange",
        value: function _pushRange(t) {
          var e = this._prepareRange(t);
          e && this._ranges.push(e);
        }
      }, {
        key: "_prepareRange",
        value: function _prepareRange(t) {
          var _this62 = this;
          if (this._checkRange(t), t.root == this._document.graveyard) return;
          var e = Na.fromRange(t);
          return e.on("change:range", function (t, n, o) {
            if (_this62._hasChangedRange = !0, e.root == _this62._document.graveyard) {
              _this62._selectionRestorePosition = o.deletionPosition;
              var _t107 = _this62._ranges.indexOf(e);
              _this62._ranges.splice(_t107, 1), e.detach();
            }
          }), e;
        }
      }, {
        key: "_updateMarkers",
        value: function _updateMarkers() {
          if (!this._observedMarkers.size) return;
          var t = [];
          var e = !1;
          var _iterator144 = _createForOfIteratorHelper(this._model.markers),
            _step144;
          try {
            for (_iterator144.s(); !(_step144 = _iterator144.n()).done;) {
              var _e116 = _step144.value;
              var _n109 = _e116.name.split(":", 1)[0];
              if (!this._observedMarkers.has(_n109)) continue;
              var _o65 = _e116.getRange();
              var _iterator145 = _createForOfIteratorHelper(this.getRanges()),
                _step145;
              try {
                for (_iterator145.s(); !(_step145 = _iterator145.n()).done;) {
                  var _n110 = _step145.value;
                  _o65.containsRange(_n110, !_n110.isCollapsed) && t.push(_e116);
                }
              } catch (err) {
                _iterator145.e(err);
              } finally {
                _iterator145.f();
              }
            }
          } catch (err) {
            _iterator144.e(err);
          } finally {
            _iterator144.f();
          }
          var n = Array.from(this.markers);
          for (var _i52 = 0, _t108 = t; _i52 < _t108.length; _i52++) {
            var _n107 = _t108[_i52];
            this.markers.has(_n107) || (this.markers.add(_n107), e = !0);
          }
          for (var _i53 = 0, _Array$from2 = Array.from(this.markers); _i53 < _Array$from2.length; _i53++) {
            var _n108 = _Array$from2[_i53];
            t.includes(_n108) || (this.markers.remove(_n108), e = !0);
          }
          e && this.fire("change:marker", {
            oldMarkers: n,
            directChange: !1
          });
        }
      }, {
        key: "_updateMarker",
        value: function _updateMarker(t, e) {
          var n = t.name.split(":", 1)[0];
          if (!this._observedMarkers.has(n)) return;
          var o = !1;
          var i = Array.from(this.markers),
            r = this.markers.has(t);
          if (e) {
            var _n111 = !1;
            var _iterator146 = _createForOfIteratorHelper(this.getRanges()),
              _step146;
            try {
              for (_iterator146.s(); !(_step146 = _iterator146.n()).done;) {
                var _t109 = _step146.value;
                if (e.containsRange(_t109, !_t109.isCollapsed)) {
                  _n111 = !0;
                  break;
                }
              }
            } catch (err) {
              _iterator146.e(err);
            } finally {
              _iterator146.f();
            }
            _n111 && !r ? (this.markers.add(t), o = !0) : !_n111 && r && (this.markers.remove(t), o = !0);
          } else r && (this.markers.remove(t), o = !0);
          o && this.fire("change:marker", {
            oldMarkers: i,
            directChange: !1
          });
        }
      }, {
        key: "_updateAttributes",
        value: function _updateAttributes(t) {
          var e = vo(this._getSurroundingAttributes()),
            n = vo(this.getAttributes());
          if (t) this._attributePriority = new Map(), this._attrs = new Map();else {
            var _iterator147 = _createForOfIteratorHelper(this._attributePriority),
              _step147;
            try {
              for (_iterator147.s(); !(_step147 = _iterator147.n()).done;) {
                var _step147$value = _slicedToArray(_step147.value, 2),
                  _t110 = _step147$value[0],
                  _e117 = _step147$value[1];
                "low" == _e117 && (this._attrs.delete(_t110), this._attributePriority.delete(_t110));
              }
            } catch (err) {
              _iterator147.e(err);
            } finally {
              _iterator147.f();
            }
          }
          this._setAttributesTo(e);
          var o = [];
          var _iterator148 = _createForOfIteratorHelper(this.getAttributes()),
            _step148;
          try {
            for (_iterator148.s(); !(_step148 = _iterator148.n()).done;) {
              var _step148$value = _slicedToArray(_step148.value, 2),
                _t111 = _step148$value[0],
                _e118 = _step148$value[1];
              n.has(_t111) && n.get(_t111) === _e118 || o.push(_t111);
            }
          } catch (err) {
            _iterator148.e(err);
          } finally {
            _iterator148.f();
          }
          var _iterator149 = _createForOfIteratorHelper(n),
            _step149;
          try {
            for (_iterator149.s(); !(_step149 = _iterator149.n()).done;) {
              var _step149$value = _slicedToArray(_step149.value, 1),
                _t112 = _step149$value[0];
              this.hasAttribute(_t112) || o.push(_t112);
            }
          } catch (err) {
            _iterator149.e(err);
          } finally {
            _iterator149.f();
          }
          o.length > 0 && this.fire("change:attribute", {
            attributeKeys: o,
            directChange: !1
          });
        }
      }, {
        key: "_setAttribute",
        value: function _setAttribute(t, e) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
          var o = n ? "normal" : "low";
          if ("low" == o && "normal" == this._attributePriority.get(t)) return !1;
          return _get(_getPrototypeOf(Oa.prototype), "getAttribute", this).call(this, t) !== e && (this._attrs.set(t, e), this._attributePriority.set(t, o), !0);
        }
      }, {
        key: "_removeAttribute",
        value: function _removeAttribute(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
          var n = e ? "normal" : "low";
          return ("low" != n || "normal" != this._attributePriority.get(t)) && (this._attributePriority.set(t, n), !!_get(_getPrototypeOf(Oa.prototype), "hasAttribute", this).call(this, t) && (this._attrs.delete(t), !0));
        }
      }, {
        key: "_setAttributesTo",
        value: function _setAttributesTo(t) {
          var e = new Set();
          var _iterator150 = _createForOfIteratorHelper(this.getAttributes()),
            _step150;
          try {
            for (_iterator150.s(); !(_step150 = _iterator150.n()).done;) {
              var _step150$value = _slicedToArray(_step150.value, 2),
                _e119 = _step150$value[0],
                _n112 = _step150$value[1];
              t.get(_e119) !== _n112 && this._removeAttribute(_e119, !1);
            }
          } catch (err) {
            _iterator150.e(err);
          } finally {
            _iterator150.f();
          }
          var _iterator151 = _createForOfIteratorHelper(t),
            _step151;
          try {
            for (_iterator151.s(); !(_step151 = _iterator151.n()).done;) {
              var _step151$value = _slicedToArray(_step151.value, 2),
                _n113 = _step151$value[0],
                _o66 = _step151$value[1];
              this._setAttribute(_n113, _o66, !1) && e.add(_n113);
            }
          } catch (err) {
            _iterator151.e(err);
          } finally {
            _iterator151.f();
          }
          return e;
        }
      }, {
        key: "_getStoredAttributes",
        value: /*#__PURE__*/_regeneratorRuntime().mark(function _getStoredAttributes() {
          var t, _iterator152, _step152, _e120, _n114;
          return _regeneratorRuntime().wrap(function _getStoredAttributes$(_context19) {
            while (1) switch (_context19.prev = _context19.next) {
              case 0:
                t = this.getFirstPosition().parent;
                if (!(this.isCollapsed && t.isEmpty)) {
                  _context19.next = 21;
                  break;
                }
                _iterator152 = _createForOfIteratorHelper(t.getAttributeKeys());
                _context19.prev = 3;
                _iterator152.s();
              case 5:
                if ((_step152 = _iterator152.n()).done) {
                  _context19.next = 13;
                  break;
                }
                _e120 = _step152.value;
                if (!_e120.startsWith(za)) {
                  _context19.next = 11;
                  break;
                }
                _n114 = _e120.substr(za.length);
                _context19.next = 11;
                return [_n114, t.getAttribute(_e120)];
              case 11:
                _context19.next = 5;
                break;
              case 13:
                _context19.next = 18;
                break;
              case 15:
                _context19.prev = 15;
                _context19.t0 = _context19["catch"](3);
                _iterator152.e(_context19.t0);
              case 18:
                _context19.prev = 18;
                _iterator152.f();
                return _context19.finish(18);
              case 21:
              case "end":
                return _context19.stop();
            }
          }, _getStoredAttributes, this, [[3, 15, 18, 21]]);
        })
      }, {
        key: "_getSurroundingAttributes",
        value: function _getSurroundingAttributes() {
          var t = this.getFirstPosition(),
            e = this._model.schema;
          var n = null;
          if (this.isCollapsed) {
            var _o67 = t.textNode ? t.textNode : t.nodeBefore,
              _i54 = t.textNode ? t.textNode : t.nodeAfter;
            if (this.isGravityOverridden || (n = Ra(_o67)), n || (n = Ra(_i54)), !this.isGravityOverridden && !n) {
              var _t113 = _o67;
              for (; _t113 && !e.isInline(_t113) && !n;) _t113 = _t113.previousSibling, n = Ra(_t113);
            }
            if (!n) {
              var _t114 = _i54;
              for (; _t114 && !e.isInline(_t114) && !n;) _t114 = _t114.nextSibling, n = Ra(_t114);
            }
            n || (n = this._getStoredAttributes());
          } else {
            var _t115 = this.getFirstRange();
            var _iterator153 = _createForOfIteratorHelper(_t115),
              _step153;
            try {
              for (_iterator153.s(); !(_step153 = _iterator153.n()).done;) {
                var _o68 = _step153.value;
                if (_o68.item.is("element") && e.isObject(_o68.item)) break;
                if ("text" == _o68.type) {
                  n = _o68.item.getAttributes();
                  break;
                }
              }
            } catch (err) {
              _iterator153.e(err);
            } finally {
              _iterator153.f();
            }
          }
          return n;
        }
      }, {
        key: "_fixGraveyardSelection",
        value: function _fixGraveyardSelection(t) {
          var e = this._model.schema.getNearestSelectionRange(t);
          e && this._pushRange(e);
        }
      }, {
        key: "isCollapsed",
        get: function get() {
          return 0 === this._ranges.length ? this._document._getDefaultRange().isCollapsed : _get(_getPrototypeOf(Oa.prototype), "isCollapsed", this);
        }
      }, {
        key: "anchor",
        get: function get() {
          return _get(_getPrototypeOf(Oa.prototype), "anchor", this) || this._document._getDefaultRange().start;
        }
      }, {
        key: "focus",
        get: function get() {
          return _get(_getPrototypeOf(Oa.prototype), "focus", this) || this._document._getDefaultRange().end;
        }
      }, {
        key: "rangeCount",
        get: function get() {
          return this._ranges.length ? this._ranges.length : 1;
        }
      }, {
        key: "hasOwnRange",
        get: function get() {
          return this._ranges.length > 0;
        }
      }, {
        key: "isGravityOverridden",
        get: function get() {
          return !!this._overriddenGravityRegister.size;
        }
      }]);
      return Oa;
    }(Da);
    function Ra(t) {
      return t instanceof da || t instanceof la ? t.getAttributes() : null;
    }
    var ja = /*#__PURE__*/function () {
      function ja(t) {
        _classCallCheck(this, ja);
        this._dispatchers = t;
      }
      _createClass(ja, [{
        key: "add",
        value: function add(t) {
          var _iterator154 = _createForOfIteratorHelper(this._dispatchers),
            _step154;
          try {
            for (_iterator154.s(); !(_step154 = _iterator154.n()).done;) {
              var _e121 = _step154.value;
              t(_e121);
            }
          } catch (err) {
            _iterator154.e(err);
          } finally {
            _iterator154.f();
          }
          return this;
        }
      }]);
      return ja;
    }();
    var Fa = function Fa(t) {
      return eo(t, 5);
    };
    var Va = /*#__PURE__*/function (_ja) {
      _inherits(Va, _ja);
      function Va() {
        _classCallCheck(this, Va);
        return _possibleConstructorReturn(this, _getPrototypeOf(Va).apply(this, arguments));
      }
      _createClass(Va, [{
        key: "elementToElement",
        value: function elementToElement(t) {
          return this.add(function (t) {
            return (t = Fa(t)).view = Ga(t.view, "container"), function (e) {
              var n;
              if (e.on("insert:" + t.model, (n = t.view, function (t, e, o) {
                var i = n(e.item, o);
                if (!i) return;
                if (!o.consumable.consume(e.item, "insert")) return;
                var r = o.mapper.toViewPosition(e.range.start);
                o.mapper.bindElements(e.item, i), o.writer.insert(r, i);
              }), {
                priority: t.converterPriority || "normal"
              }), t.triggerBy) {
                if (t.triggerBy.attributes) {
                  var _iterator155 = _createForOfIteratorHelper(t.triggerBy.attributes),
                    _step155;
                  try {
                    for (_iterator155.s(); !(_step155 = _iterator155.n()).done;) {
                      var _n115 = _step155.value;
                      e._mapReconversionTriggerEvent(t.model, "attribute:".concat(_n115, ":").concat(t.model));
                    }
                  } catch (err) {
                    _iterator155.e(err);
                  } finally {
                    _iterator155.f();
                  }
                }
                if (t.triggerBy.children) {
                  var _iterator156 = _createForOfIteratorHelper(t.triggerBy.children),
                    _step156;
                  try {
                    for (_iterator156.s(); !(_step156 = _iterator156.n()).done;) {
                      var _n116 = _step156.value;
                      e._mapReconversionTriggerEvent(t.model, "insert:".concat(_n116)), e._mapReconversionTriggerEvent(t.model, "remove:".concat(_n116));
                    }
                  } catch (err) {
                    _iterator156.e(err);
                  } finally {
                    _iterator156.f();
                  }
                }
              }
            };
          }(t));
        }
      }, {
        key: "attributeToElement",
        value: function attributeToElement(t) {
          return this.add(function (t) {
            t = Fa(t);
            var e = "attribute:" + (t.model.key ? t.model.key : t.model);
            t.model.name && (e += ":" + t.model.name);
            if (t.model.values) {
              var _iterator157 = _createForOfIteratorHelper(t.model.values),
                _step157;
              try {
                for (_iterator157.s(); !(_step157 = _iterator157.n()).done;) {
                  var _e122 = _step157.value;
                  t.view[_e122] = Ga(t.view[_e122], "attribute");
                }
              } catch (err) {
                _iterator157.e(err);
              } finally {
                _iterator157.f();
              }
            } else t.view = Ga(t.view, "attribute");
            var n = Wa(t);
            return function (o) {
              o.on(e, function (t) {
                return function (e, n, o) {
                  var i = t(n.attributeOldValue, o),
                    r = t(n.attributeNewValue, o);
                  if (!i && !r) return;
                  if (!o.consumable.consume(n.item, e.name)) return;
                  var s = o.writer,
                    a = s.document.selection;
                  if (n.item instanceof Da || n.item instanceof La) s.wrap(a.getFirstRange(), r);else {
                    var _t116 = o.mapper.toViewRange(n.range);
                    null !== n.attributeOldValue && i && (_t116 = s.unwrap(_t116, i)), null !== n.attributeNewValue && r && s.wrap(_t116, r);
                  }
                };
              }(n), {
                priority: t.converterPriority || "normal"
              });
            };
          }(t));
        }
      }, {
        key: "attributeToAttribute",
        value: function attributeToAttribute(t) {
          return this.add(function (t) {
            t = Fa(t);
            var e = "attribute:" + (t.model.key ? t.model.key : t.model);
            t.model.name && (e += ":" + t.model.name);
            if (t.model.values) {
              var _iterator158 = _createForOfIteratorHelper(t.model.values),
                _step158;
              try {
                for (_iterator158.s(); !(_step158 = _iterator158.n()).done;) {
                  var _e123 = _step158.value;
                  t.view[_e123] = qa(t.view[_e123]);
                }
              } catch (err) {
                _iterator158.e(err);
              } finally {
                _iterator158.f();
              }
            } else t.view = qa(t.view);
            var n = Wa(t);
            return function (o) {
              var i;
              o.on(e, (i = n, function (t, e, n) {
                var o = i(e.attributeOldValue, n),
                  r = i(e.attributeNewValue, n);
                if (!o && !r) return;
                if (!n.consumable.consume(e.item, t.name)) return;
                var s = n.mapper.toViewElement(e.item),
                  a = n.writer;
                if (!s) throw new c.a("conversion-attribute-to-attribute-on-text", [e, n]);
                if (null !== e.attributeOldValue && o) if ("class" == o.key) {
                  var _t117 = ho(o.value);
                  var _iterator159 = _createForOfIteratorHelper(_t117),
                    _step159;
                  try {
                    for (_iterator159.s(); !(_step159 = _iterator159.n()).done;) {
                      var _e124 = _step159.value;
                      a.removeClass(_e124, s);
                    }
                  } catch (err) {
                    _iterator159.e(err);
                  } finally {
                    _iterator159.f();
                  }
                } else if ("style" == o.key) {
                  var _t118 = Object.keys(o.value);
                  for (var _i55 = 0, _t119 = _t118; _i55 < _t119.length; _i55++) {
                    var _e125 = _t119[_i55];
                    a.removeStyle(_e125, s);
                  }
                } else a.removeAttribute(o.key, s);
                if (null !== e.attributeNewValue && r) if ("class" == r.key) {
                  var _t120 = ho(r.value);
                  var _iterator160 = _createForOfIteratorHelper(_t120),
                    _step160;
                  try {
                    for (_iterator160.s(); !(_step160 = _iterator160.n()).done;) {
                      var _e126 = _step160.value;
                      a.addClass(_e126, s);
                    }
                  } catch (err) {
                    _iterator160.e(err);
                  } finally {
                    _iterator160.f();
                  }
                } else if ("style" == r.key) {
                  var _t121 = Object.keys(r.value);
                  for (var _i56 = 0, _t122 = _t121; _i56 < _t122.length; _i56++) {
                    var _e127 = _t122[_i56];
                    a.setStyle(_e127, r.value[_e127], s);
                  }
                } else a.setAttribute(r.key, r.value, s);
              }), {
                priority: t.converterPriority || "normal"
              });
            };
          }(t));
        }
      }, {
        key: "markerToElement",
        value: function markerToElement(t) {
          return this.add(function (t) {
            return (t = Fa(t)).view = Ga(t.view, "ui"), function (e) {
              var n;
              e.on("addMarker:" + t.model, (n = t.view, function (t, e, o) {
                e.isOpening = !0;
                var i = n(e, o);
                e.isOpening = !1;
                var r = n(e, o);
                if (!i || !r) return;
                var s = e.markerRange;
                if (s.isCollapsed && !o.consumable.consume(s, t.name)) return;
                var _iterator161 = _createForOfIteratorHelper(s),
                  _step161;
                try {
                  for (_iterator161.s(); !(_step161 = _iterator161.n()).done;) {
                    var _e128 = _step161.value;
                    if (!o.consumable.consume(_e128.item, t.name)) return;
                  }
                } catch (err) {
                  _iterator161.e(err);
                } finally {
                  _iterator161.f();
                }
                var a = o.mapper,
                  c = o.writer;
                c.insert(a.toViewPosition(s.start), i), o.mapper.bindElementToMarker(i, e.markerName), s.isCollapsed || (c.insert(a.toViewPosition(s.end), r), o.mapper.bindElementToMarker(r, e.markerName)), t.stop();
              }), {
                priority: t.converterPriority || "normal"
              }), e.on("removeMarker:" + t.model, (t.view, function (t, e, n) {
                var o = n.mapper.markerNameToElements(e.markerName);
                if (o) {
                  var _iterator162 = _createForOfIteratorHelper(o),
                    _step162;
                  try {
                    for (_iterator162.s(); !(_step162 = _iterator162.n()).done;) {
                      var _t123 = _step162.value;
                      n.mapper.unbindElementFromMarkerName(_t123, e.markerName), n.writer.clear(n.writer.createRangeOn(_t123), _t123);
                    }
                  } catch (err) {
                    _iterator162.e(err);
                  } finally {
                    _iterator162.f();
                  }
                  n.writer.clearClonedElementsGroup(e.markerName), t.stop();
                }
              }), {
                priority: t.converterPriority || "normal"
              });
            };
          }(t));
        }
      }, {
        key: "markerToHighlight",
        value: function markerToHighlight(t) {
          return this.add(function (t) {
            return function (e) {
              var n;
              e.on("addMarker:" + t.model, (n = t.view, function (t, e, o) {
                if (!e.item) return;
                if (!(e.item instanceof Da || e.item instanceof La || e.item.is("$textProxy"))) return;
                var i = Ka(n, e, o);
                if (!i) return;
                if (!o.consumable.consume(e.item, t.name)) return;
                var r = o.writer,
                  s = Ua(r, i),
                  a = r.document.selection;
                if (e.item instanceof Da || e.item instanceof La) r.wrap(a.getFirstRange(), s, a);else {
                  var _t124 = o.mapper.toViewRange(e.range),
                    _n117 = r.wrap(_t124, s);
                  var _iterator163 = _createForOfIteratorHelper(_n117.getItems()),
                    _step163;
                  try {
                    for (_iterator163.s(); !(_step163 = _iterator163.n()).done;) {
                      var _t125 = _step163.value;
                      if (_t125.is("attributeElement") && _t125.isSimilar(s)) {
                        o.mapper.bindElementToMarker(_t125, e.markerName);
                        break;
                      }
                    }
                  } catch (err) {
                    _iterator163.e(err);
                  } finally {
                    _iterator163.f();
                  }
                }
              }), {
                priority: t.converterPriority || "normal"
              }), e.on("addMarker:" + t.model, function (t) {
                return function (e, n, o) {
                  if (!n.item) return;
                  if (!(n.item instanceof ua)) return;
                  var i = Ka(t, n, o);
                  if (!i) return;
                  if (!o.consumable.test(n.item, e.name)) return;
                  var r = o.mapper.toViewElement(n.item);
                  if (r && r.getCustomProperty("addHighlight")) {
                    o.consumable.consume(n.item, e.name);
                    var _iterator164 = _createForOfIteratorHelper(wa._createIn(n.item)),
                      _step164;
                    try {
                      for (_iterator164.s(); !(_step164 = _iterator164.n()).done;) {
                        var _t126 = _step164.value;
                        o.consumable.consume(_t126.item, e.name);
                      }
                    } catch (err) {
                      _iterator164.e(err);
                    } finally {
                      _iterator164.f();
                    }
                    r.getCustomProperty("addHighlight")(r, i, o.writer), o.mapper.bindElementToMarker(r, n.markerName);
                  }
                };
              }(t.view), {
                priority: t.converterPriority || "normal"
              }), e.on("removeMarker:" + t.model, function (t) {
                return function (e, n, o) {
                  if (n.markerRange.isCollapsed) return;
                  var i = Ka(t, n, o);
                  if (!i) return;
                  var r = Ua(o.writer, i),
                    s = o.mapper.markerNameToElements(n.markerName);
                  if (s) {
                    var _iterator165 = _createForOfIteratorHelper(s),
                      _step165;
                    try {
                      for (_iterator165.s(); !(_step165 = _iterator165.n()).done;) {
                        var _t127 = _step165.value;
                        o.mapper.unbindElementFromMarkerName(_t127, n.markerName), _t127.is("attributeElement") ? o.writer.unwrap(o.writer.createRangeOn(_t127), r) : _t127.getCustomProperty("removeHighlight")(_t127, i.id, o.writer);
                      }
                    } catch (err) {
                      _iterator165.e(err);
                    } finally {
                      _iterator165.f();
                    }
                    o.writer.clearClonedElementsGroup(n.markerName), e.stop();
                  }
                };
              }(t.view), {
                priority: t.converterPriority || "normal"
              });
            };
          }(t));
        }
      }, {
        key: "markerToData",
        value: function markerToData(t) {
          return this.add(function (t) {
            var e = (t = Fa(t)).model;
            t.view || (t.view = function (n) {
              return {
                group: e,
                name: n.substr(t.model.length + 1)
              };
            });
            return function (n) {
              var o;
              n.on("addMarker:" + e, (o = t.view, function (t, e, n) {
                var i = o(e.markerName, n);
                if (!i) return;
                var r = e.markerRange;
                n.consumable.consume(r, t.name) && (Ha(r, !1, n, e, i), Ha(r, !0, n, e, i), t.stop());
              }), {
                priority: t.converterPriority || "normal"
              }), n.on("removeMarker:" + e, function (t) {
                return function (e, n, o) {
                  var i = t(n.markerName, o);
                  if (!i) return;
                  var r = o.mapper.markerNameToElements(n.markerName);
                  if (r) {
                    var _iterator166 = _createForOfIteratorHelper(r),
                      _step166;
                    try {
                      for (_iterator166.s(); !(_step166 = _iterator166.n()).done;) {
                        var _t128 = _step166.value;
                        o.mapper.unbindElementFromMarkerName(_t128, n.markerName), _t128.is("containerElement") ? (s("data-".concat(i.group, "-start-before"), _t128), s("data-".concat(i.group, "-start-after"), _t128), s("data-".concat(i.group, "-end-before"), _t128), s("data-".concat(i.group, "-end-after"), _t128)) : o.writer.clear(o.writer.createRangeOn(_t128), _t128);
                      }
                    } catch (err) {
                      _iterator166.e(err);
                    } finally {
                      _iterator166.f();
                    }
                    o.writer.clearClonedElementsGroup(n.markerName), e.stop();
                  }
                  function s(t, e) {
                    if (e.hasAttribute(t)) {
                      var _n118 = new Set(e.getAttribute(t).split(","));
                      _n118.delete(i.name), 0 == _n118.size ? o.writer.removeAttribute(t, e) : o.writer.setAttribute(t, Array.from(_n118).join(","), e);
                    }
                  }
                };
              }(t.view), {
                priority: t.converterPriority || "normal"
              });
            };
          }(t));
        }
      }]);
      return Va;
    }(ja);
    function Ua(t, e) {
      var n = t.createAttributeElement("span", e.attributes);
      return e.classes && n._addClass(e.classes), "number" == typeof e.priority && (n._priority = e.priority), n._id = e.id, n;
    }
    function Ha(t, e, n, o, i) {
      var r = e ? t.start : t.end,
        s = r.nodeAfter && r.nodeAfter.is("element") ? r.nodeAfter : null,
        a = r.nodeBefore && r.nodeBefore.is("element") ? r.nodeBefore : null;
      if (s || a) {
        var _t129, _r19;
        e && s || !e && !a ? (_t129 = s, _r19 = !0) : (_t129 = a, _r19 = !1);
        var _c3 = n.mapper.toViewElement(_t129);
        if (_c3) return void function (t, e, n, o, i, r) {
          var s = "data-".concat(r.group, "-").concat(e ? "start" : "end", "-").concat(n ? "before" : "after"),
            a = t.hasAttribute(s) ? t.getAttribute(s).split(",") : [];
          a.unshift(r.name), o.writer.setAttribute(s, a.join(","), t), o.mapper.bindElementToMarker(t, i.markerName);
        }(_c3, e, _r19, n, o, i);
      }
      !function (t, e, n, o, i) {
        var r = "".concat(i.group, "-").concat(e ? "start" : "end"),
          s = i.name ? {
            name: i.name
          } : null,
          a = n.writer.createUIElement(r, s);
        n.writer.insert(t, a), n.mapper.bindElementToMarker(a, o.markerName);
      }(n.mapper.toViewPosition(r), e, n, o, i);
    }
    function Ga(t, e) {
      return "function" == typeof t ? t : function (n, o) {
        return function (t, e, n) {
          "string" == typeof t && (t = {
            name: t
          });
          var o;
          var i = e.writer,
            r = Object.assign({}, t.attributes);
          if ("container" == n) o = i.createContainerElement(t.name, r);else if ("attribute" == n) {
            var _e129 = {
              priority: t.priority || Ni.DEFAULT_PRIORITY
            };
            o = i.createAttributeElement(t.name, r, _e129);
          } else o = i.createUIElement(t.name, r);
          if (t.styles) {
            var _e130 = Object.keys(t.styles);
            for (var _i57 = 0, _e131 = _e130; _i57 < _e131.length; _i57++) {
              var _n119 = _e131[_i57];
              i.setStyle(_n119, t.styles[_n119], o);
            }
          }
          if (t.classes) {
            var _e132 = t.classes;
            if ("string" == typeof _e132) i.addClass(_e132, o);else {
              var _iterator167 = _createForOfIteratorHelper(_e132),
                _step167;
              try {
                for (_iterator167.s(); !(_step167 = _iterator167.n()).done;) {
                  var _t130 = _step167.value;
                  i.addClass(_t130, o);
                }
              } catch (err) {
                _iterator167.e(err);
              } finally {
                _iterator167.f();
              }
            }
          }
          return o;
        }(t, o, e);
      };
    }
    function Wa(t) {
      return t.model.values ? function (e, n) {
        var o = t.view[e];
        return o ? o(e, n) : null;
      } : t.view;
    }
    function qa(t) {
      return "string" == typeof t ? function (e) {
        return {
          key: t,
          value: e
        };
      } : "object" == typeof t ? t.value ? function () {
        return t;
      } : function (e) {
        return {
          key: t.key,
          value: e
        };
      } : t;
    }
    function Ka(t, e, n) {
      var o = "function" == typeof t ? t(e, n) : t;
      return o ? (o.priority || (o.priority = 10), o.id || (o.id = e.markerName), o) : null;
    }
    function Ya(t) {
      var _t$model = t.model,
        e = _t$model.schema,
        n = _t$model.document;
      var _iterator168 = _createForOfIteratorHelper(n.getRootNames()),
        _step168;
      try {
        for (_iterator168.s(); !(_step168 = _iterator168.n()).done;) {
          var _o69 = _step168.value;
          var _i58 = n.getRoot(_o69);
          if (_i58.isEmpty && !e.checkChild(_i58, "$text") && e.checkChild(_i58, "paragraph")) return t.insertElement("paragraph", _i58), !0;
        }
      } catch (err) {
        _iterator168.e(err);
      } finally {
        _iterator168.f();
      }
      return !1;
    }
    function Qa(t, e, n) {
      var o = n.createContext(t);
      return !!n.checkChild(o, "paragraph") && !!n.checkChild(o.push("paragraph"), e);
    }
    function $a(t, e) {
      var n = e.createElement("paragraph");
      return e.insert(n, t), e.createPositionAt(n, 0);
    }
    var Ja = /*#__PURE__*/function (_ja2) {
      _inherits(Ja, _ja2);
      function Ja() {
        _classCallCheck(this, Ja);
        return _possibleConstructorReturn(this, _getPrototypeOf(Ja).apply(this, arguments));
      }
      _createClass(Ja, [{
        key: "elementToElement",
        value: function elementToElement(t) {
          return this.add(Za(t));
        }
      }, {
        key: "elementToAttribute",
        value: function elementToAttribute(t) {
          return this.add(function (t) {
            ec(t = Fa(t));
            var e = nc(t, !1),
              n = Xa(t.view),
              o = n ? "element:" + n : "element";
            return function (n) {
              n.on(o, e, {
                priority: t.converterPriority || "low"
              });
            };
          }(t));
        }
      }, {
        key: "attributeToAttribute",
        value: function attributeToAttribute(t) {
          return this.add(function (t) {
            t = Fa(t);
            var e = null;
            ("string" == typeof t.view || t.view.key) && (e = function (t) {
              "string" == typeof t.view && (t.view = {
                key: t.view
              });
              var e = t.view.key;
              var n;
              if ("class" == e || "style" == e) {
                n = _defineProperty({}, "class" == e ? "classes" : "styles", t.view.value);
              } else {
                n = {
                  attributes: _defineProperty({}, e, void 0 === t.view.value ? /[\s\S]*/ : t.view.value)
                };
              }
              t.view.name && (n.name = t.view.name);
              return t.view = n, e;
            }(t));
            ec(t, e);
            var n = nc(t, !0);
            return function (e) {
              e.on("element", n, {
                priority: t.converterPriority || "low"
              });
            };
          }(t));
        }
      }, {
        key: "elementToMarker",
        value: function elementToMarker(t) {
          return Object(c.b)("upcast-helpers-element-to-marker-deprecated"), this.add(function (t) {
            return function (t) {
              var e = t.model;
              t.model = function (t, n) {
                var o = "string" == typeof e ? e : e(t, n);
                return n.writer.createElement("$marker", {
                  "data-name": o
                });
              };
            }(t = Fa(t)), Za(t);
          }(t));
        }
      }, {
        key: "dataToMarker",
        value: function dataToMarker(t) {
          return this.add(function (t) {
            (t = Fa(t)).model || (t.model = function (e) {
              return e ? t.view + ":" + e : t.view;
            });
            var e = tc(oc(t, "start")),
              n = tc(oc(t, "end"));
            return function (o) {
              o.on("element:" + t.view + "-start", e, {
                priority: t.converterPriority || "normal"
              }), o.on("element:" + t.view + "-end", n, {
                priority: t.converterPriority || "normal"
              });
              var i = a.get("low"),
                r = a.get("highest"),
                s = a.get(t.converterPriority) / r;
              o.on("element", function (t) {
                return function (e, n, o) {
                  var i = "data-".concat(t.view);
                  function r(e, i) {
                    var _iterator169 = _createForOfIteratorHelper(i),
                      _step169;
                    try {
                      for (_iterator169.s(); !(_step169 = _iterator169.n()).done;) {
                        var _r20 = _step169.value;
                        var _i59 = t.model(_r20, o),
                          _s15 = o.writer.createElement("$marker", {
                            "data-name": _i59
                          });
                        o.writer.insert(_s15, e), n.modelCursor.isEqual(e) ? n.modelCursor = n.modelCursor.getShiftedBy(1) : n.modelCursor = n.modelCursor._getTransformedByInsertion(e, 1), n.modelRange = n.modelRange._getTransformedByInsertion(e, 1)[0];
                      }
                    } catch (err) {
                      _iterator169.e(err);
                    } finally {
                      _iterator169.f();
                    }
                  }
                  (o.consumable.test(n.viewItem, {
                    attributes: i + "-end-after"
                  }) || o.consumable.test(n.viewItem, {
                    attributes: i + "-start-after"
                  }) || o.consumable.test(n.viewItem, {
                    attributes: i + "-end-before"
                  }) || o.consumable.test(n.viewItem, {
                    attributes: i + "-start-before"
                  })) && (n.modelRange || Object.assign(n, o.convertChildren(n.viewItem, n.modelCursor)), o.consumable.consume(n.viewItem, {
                    attributes: i + "-end-after"
                  }) && r(n.modelRange.end, n.viewItem.getAttribute(i + "-end-after").split(",")), o.consumable.consume(n.viewItem, {
                    attributes: i + "-start-after"
                  }) && r(n.modelRange.end, n.viewItem.getAttribute(i + "-start-after").split(",")), o.consumable.consume(n.viewItem, {
                    attributes: i + "-end-before"
                  }) && r(n.modelRange.start, n.viewItem.getAttribute(i + "-end-before").split(",")), o.consumable.consume(n.viewItem, {
                    attributes: i + "-start-before"
                  }) && r(n.modelRange.start, n.viewItem.getAttribute(i + "-start-before").split(",")));
                };
              }(t), {
                priority: i + s
              });
            };
          }(t));
        }
      }]);
      return Ja;
    }(ja);
    function Za(t) {
      var e = tc(t = Fa(t)),
        n = Xa(t.view),
        o = n ? "element:" + n : "element";
      return function (n) {
        n.on(o, e, {
          priority: t.converterPriority || "normal"
        });
      };
    }
    function Xa(t) {
      return "string" == typeof t ? t : "object" == typeof t && "string" == typeof t.name ? t.name : null;
    }
    function tc(t) {
      var e = new yo(t.view);
      return function (n, o, i) {
        var r = e.match(o.viewItem);
        if (!r) return;
        var s = r.match;
        if (s.name = !0, !i.consumable.test(o.viewItem, s)) return;
        var a = function (t, e, n) {
          return t instanceof Function ? t(e, n) : n.writer.createElement(t);
        }(t.model, o.viewItem, i);
        a && i.safeInsert(a, o.modelCursor) && (i.consumable.consume(o.viewItem, s), i.convertChildren(o.viewItem, a), i.updateConversionResult(a, o));
      };
    }
    function ec(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var n = null === e || function (t) {
          return t.getAttribute(e);
        },
        o = "object" != typeof t.model ? t.model : t.model.key,
        i = "object" != typeof t.model || void 0 === t.model.value ? n : t.model.value;
      t.model = {
        key: o,
        value: i
      };
    }
    function nc(t, e) {
      var n = new yo(t.view);
      return function (o, i, r) {
        var s = n.match(i.viewItem);
        if (!s) return;
        if (!function (t, e) {
          var n = "function" == typeof t ? t(e) : t;
          if ("object" == typeof n && !Xa(n)) return !1;
          return !n.classes && !n.attributes && !n.styles;
        }(t.view, i.viewItem) ? delete s.match.name : s.match.name = !0, !r.consumable.test(i.viewItem, s.match)) return;
        var a = t.model.key,
          c = "function" == typeof t.model.value ? t.model.value(i.viewItem, r) : t.model.value;
        if (null === c) return;
        i.modelRange || Object.assign(i, r.convertChildren(i.viewItem, i.modelCursor));
        (function (t, e, n, o) {
          var i = !1;
          for (var _i60 = 0, _Array$from3 = Array.from(t.getItems({
              shallow: n
            })); _i60 < _Array$from3.length; _i60++) {
            var _r21 = _Array$from3[_i60];
            o.schema.checkAttribute(_r21, e.key) && (i = !0, _r21.hasAttribute(e.key) || o.writer.setAttribute(e.key, e.value, _r21));
          }
          return i;
        })(i.modelRange, {
          key: a,
          value: c
        }, e, r) && r.consumable.consume(i.viewItem, s.match);
      };
    }
    function oc(t, e) {
      var n = {};
      return n.view = t.view + "-" + e, n.model = function (e, n) {
        var o = e.getAttribute("name"),
          i = t.model(o, n);
        return n.writer.createElement("$marker", {
          "data-name": i
        });
      }, n;
    }
    var ic = /*#__PURE__*/function () {
      function ic(t, e) {
        var _this63 = this;
        _classCallCheck(this, ic);
        this.model = t, this.view = new aa(e), this.mapper = new Ca(), this.downcastDispatcher = new va({
          mapper: this.mapper,
          schema: t.schema
        });
        var n = this.model.document,
          o = n.selection,
          i = this.model.markers;
        this.listenTo(this.model, "_beforeChanges", function () {
          _this63.view._disableRendering(!0);
        }, {
          priority: "highest"
        }), this.listenTo(this.model, "_afterChanges", function () {
          _this63.view._disableRendering(!1);
        }, {
          priority: "lowest"
        }), this.listenTo(n, "change", function () {
          _this63.view.change(function (t) {
            _this63.downcastDispatcher.convertChanges(n.differ, i, t), _this63.downcastDispatcher.convertSelection(o, i, t);
          });
        }, {
          priority: "low"
        }), this.listenTo(this.view.document, "selectionChange", function (t, e) {
          return function (n, o) {
            var i = o.newSelection,
              r = [];
            var _iterator170 = _createForOfIteratorHelper(i.getRanges()),
              _step170;
            try {
              for (_iterator170.s(); !(_step170 = _iterator170.n()).done;) {
                var _t131 = _step170.value;
                r.push(e.toModelRange(_t131));
              }
            } catch (err) {
              _iterator170.e(err);
            } finally {
              _iterator170.f();
            }
            var s = t.createSelection(r, {
              backward: i.isBackward
            });
            s.isEqual(t.document.selection) || t.change(function (t) {
              t.setSelection(s);
            });
          };
        }(this.model, this.mapper)), this.downcastDispatcher.on("insert:$text", function (t, e, n) {
          if (!n.consumable.consume(e.item, "insert")) return;
          var o = n.writer,
            i = n.mapper.toViewPosition(e.range.start),
            r = o.createText(e.item.data);
          o.insert(i, r);
        }, {
          priority: "lowest"
        }), this.downcastDispatcher.on("remove", function (t, e, n) {
          var o = n.mapper.toViewPosition(e.position),
            i = e.position.getShiftedBy(e.length),
            r = n.mapper.toViewPosition(i, {
              isPhantom: !0
            }),
            s = n.writer.createRange(o, r),
            a = n.writer.remove(s.getTrimmed());
          var _iterator171 = _createForOfIteratorHelper(n.writer.createRangeIn(a).getItems()),
            _step171;
          try {
            for (_iterator171.s(); !(_step171 = _iterator171.n()).done;) {
              var _t132 = _step171.value;
              n.mapper.unbindViewElement(_t132);
            }
          } catch (err) {
            _iterator171.e(err);
          } finally {
            _iterator171.f();
          }
        }, {
          priority: "low"
        }), this.downcastDispatcher.on("selection", function (t, e, n) {
          var o = n.writer,
            i = o.document.selection;
          var _iterator172 = _createForOfIteratorHelper(i.getRanges()),
            _step172;
          try {
            for (_iterator172.s(); !(_step172 = _iterator172.n()).done;) {
              var _t133 = _step172.value;
              _t133.isCollapsed && _t133.end.parent.isAttached() && n.writer.mergeAttributes(_t133.start);
            }
          } catch (err) {
            _iterator172.e(err);
          } finally {
            _iterator172.f();
          }
          o.setSelection(null);
        }, {
          priority: "high"
        }), this.downcastDispatcher.on("selection", function (t, e, n) {
          var o = e.selection;
          if (o.isCollapsed) return;
          if (!n.consumable.consume(o, "selection")) return;
          var i = [];
          var _iterator173 = _createForOfIteratorHelper(o.getRanges()),
            _step173;
          try {
            for (_iterator173.s(); !(_step173 = _iterator173.n()).done;) {
              var _t134 = _step173.value;
              var _e133 = n.mapper.toViewRange(_t134);
              i.push(_e133);
            }
          } catch (err) {
            _iterator173.e(err);
          } finally {
            _iterator173.f();
          }
          n.writer.setSelection(i, {
            backward: o.isBackward
          });
        }, {
          priority: "low"
        }), this.downcastDispatcher.on("selection", function (t, e, n) {
          var o = e.selection;
          if (!o.isCollapsed) return;
          if (!n.consumable.consume(o, "selection")) return;
          var i = n.writer,
            r = o.getFirstPosition(),
            s = n.mapper.toViewPosition(r),
            a = i.breakAttributes(s);
          i.setSelection(a);
        }, {
          priority: "low"
        }), this.view.document.roots.bindTo(this.model.document.roots).using(function (t) {
          if ("$graveyard" == t.rootName) return null;
          var e = new fi(_this63.view.document, t.name);
          return e.rootName = t.rootName, _this63.mapper.bindElements(t, e), e;
        });
      }
      _createClass(ic, [{
        key: "destroy",
        value: function destroy() {
          this.view.destroy(), this.stopListening();
        }
      }]);
      return ic;
    }();
    $t(ic, Gt);
    var rc = /*#__PURE__*/function () {
      function rc() {
        _classCallCheck(this, rc);
        this._commands = new Map();
      }
      _createClass(rc, [{
        key: "add",
        value: function add(t, e) {
          this._commands.set(t, e);
        }
      }, {
        key: "get",
        value: function get(t) {
          return this._commands.get(t);
        }
      }, {
        key: "execute",
        value: function execute(t) {
          var n = this.get(t);
          if (!n) throw new c.a("commandcollection-command-not-found", this, {
            commandName: t
          });
          for (var _len19 = arguments.length, e = new Array(_len19 > 1 ? _len19 - 1 : 0), _key19 = 1; _key19 < _len19; _key19++) {
            e[_key19 - 1] = arguments[_key19];
          }
          return n.execute.apply(n, e);
        }
      }, {
        key: "names",
        value: /*#__PURE__*/_regeneratorRuntime().mark(function names() {
          return _regeneratorRuntime().wrap(function names$(_context20) {
            while (1) switch (_context20.prev = _context20.next) {
              case 0:
                return _context20.delegateYield(this._commands.keys(), "t0", 1);
              case 1:
              case "end":
                return _context20.stop();
            }
          }, names, this);
        })
      }, {
        key: "commands",
        value: /*#__PURE__*/_regeneratorRuntime().mark(function commands() {
          return _regeneratorRuntime().wrap(function commands$(_context21) {
            while (1) switch (_context21.prev = _context21.next) {
              case 0:
                return _context21.delegateYield(this._commands.values(), "t0", 1);
              case 1:
              case "end":
                return _context21.stop();
            }
          }, commands, this);
        })
      }, {
        key: Symbol.iterator,
        value: function value() {
          return this._commands[Symbol.iterator]();
        }
      }, {
        key: "destroy",
        value: function destroy() {
          var _iterator174 = _createForOfIteratorHelper(this.commands()),
            _step174;
          try {
            for (_iterator174.s(); !(_step174 = _iterator174.n()).done;) {
              var _t135 = _step174.value;
              _t135.destroy();
            }
          } catch (err) {
            _iterator174.e(err);
          } finally {
            _iterator174.f();
          }
        }
      }]);
      return rc;
    }();
    var sc = /*#__PURE__*/function () {
      function sc() {
        _classCallCheck(this, sc);
        this._consumables = new Map();
      }
      _createClass(sc, [{
        key: "add",
        value: function add(t, e) {
          var n;
          t.is("$text") || t.is("documentFragment") ? this._consumables.set(t, !0) : (this._consumables.has(t) ? n = this._consumables.get(t) : (n = new ac(t), this._consumables.set(t, n)), n.add(e));
        }
      }, {
        key: "test",
        value: function test(t, e) {
          var n = this._consumables.get(t);
          return void 0 === n ? null : t.is("$text") || t.is("documentFragment") ? n : n.test(e);
        }
      }, {
        key: "consume",
        value: function consume(t, e) {
          return !!this.test(t, e) && (t.is("$text") || t.is("documentFragment") ? this._consumables.set(t, !1) : this._consumables.get(t).consume(e), !0);
        }
      }, {
        key: "revert",
        value: function revert(t, e) {
          var n = this._consumables.get(t);
          void 0 !== n && (t.is("$text") || t.is("documentFragment") ? this._consumables.set(t, !0) : n.revert(e));
        }
      }], [{
        key: "consumablesFromElement",
        value: function consumablesFromElement(t) {
          var e = {
              element: t,
              name: !0,
              attributes: [],
              classes: [],
              styles: []
            },
            n = t.getAttributeKeys();
          var _iterator175 = _createForOfIteratorHelper(n),
            _step175;
          try {
            for (_iterator175.s(); !(_step175 = _iterator175.n()).done;) {
              var _t136 = _step175.value;
              "style" != _t136 && "class" != _t136 && e.attributes.push(_t136);
            }
          } catch (err) {
            _iterator175.e(err);
          } finally {
            _iterator175.f();
          }
          var o = t.getClassNames();
          var _iterator176 = _createForOfIteratorHelper(o),
            _step176;
          try {
            for (_iterator176.s(); !(_step176 = _iterator176.n()).done;) {
              var _t137 = _step176.value;
              e.classes.push(_t137);
            }
          } catch (err) {
            _iterator176.e(err);
          } finally {
            _iterator176.f();
          }
          var i = t.getStyleNames();
          var _iterator177 = _createForOfIteratorHelper(i),
            _step177;
          try {
            for (_iterator177.s(); !(_step177 = _iterator177.n()).done;) {
              var _t138 = _step177.value;
              e.styles.push(_t138);
            }
          } catch (err) {
            _iterator177.e(err);
          } finally {
            _iterator177.f();
          }
          return e;
        }
      }, {
        key: "createFrom",
        value: function createFrom(t, e) {
          if (e || (e = new sc(t)), t.is("$text")) return e.add(t), e;
          t.is("element") && e.add(t, sc.consumablesFromElement(t)), t.is("documentFragment") && e.add(t);
          var _iterator178 = _createForOfIteratorHelper(t.getChildren()),
            _step178;
          try {
            for (_iterator178.s(); !(_step178 = _iterator178.n()).done;) {
              var _n121 = _step178.value;
              e = sc.createFrom(_n121, e);
            }
          } catch (err) {
            _iterator178.e(err);
          } finally {
            _iterator178.f();
          }
          return e;
        }
      }]);
      return sc;
    }();
    var ac = /*#__PURE__*/function () {
      function ac(t) {
        _classCallCheck(this, ac);
        this.element = t, this._canConsumeName = null, this._consumables = {
          attributes: new Map(),
          styles: new Map(),
          classes: new Map()
        };
      }
      _createClass(ac, [{
        key: "add",
        value: function add(t) {
          t.name && (this._canConsumeName = !0);
          for (var _e135 in this._consumables) _e135 in t && this._add(_e135, t[_e135]);
        }
      }, {
        key: "test",
        value: function test(t) {
          if (t.name && !this._canConsumeName) return this._canConsumeName;
          for (var _e137 in this._consumables) if (_e137 in t) {
            var _n122 = this._test(_e137, t[_e137]);
            if (!0 !== _n122) return _n122;
          }
          return !0;
        }
      }, {
        key: "consume",
        value: function consume(t) {
          t.name && (this._canConsumeName = !1);
          for (var _e139 in this._consumables) _e139 in t && this._consume(_e139, t[_e139]);
        }
      }, {
        key: "revert",
        value: function revert(t) {
          t.name && (this._canConsumeName = !0);
          for (var _e141 in this._consumables) _e141 in t && this._revert(_e141, t[_e141]);
        }
      }, {
        key: "_add",
        value: function _add(t, e) {
          var n = At(e) ? e : [e],
            o = this._consumables[t];
          var _iterator179 = _createForOfIteratorHelper(n),
            _step179;
          try {
            for (_iterator179.s(); !(_step179 = _iterator179.n()).done;) {
              var _e142 = _step179.value;
              if ("attributes" === t && ("class" === _e142 || "style" === _e142)) throw new c.a("viewconsumable-invalid-attribute", this);
              if (o.set(_e142, !0), "styles" === t) {
                var _iterator180 = _createForOfIteratorHelper(this.element.document.stylesProcessor.getRelatedStyles(_e142)),
                  _step180;
                try {
                  for (_iterator180.s(); !(_step180 = _iterator180.n()).done;) {
                    var _t139 = _step180.value;
                    o.set(_t139, !0);
                  }
                } catch (err) {
                  _iterator180.e(err);
                } finally {
                  _iterator180.f();
                }
              }
            }
          } catch (err) {
            _iterator179.e(err);
          } finally {
            _iterator179.f();
          }
        }
      }, {
        key: "_test",
        value: function _test(t, e) {
          var n = At(e) ? e : [e],
            o = this._consumables[t];
          var _iterator181 = _createForOfIteratorHelper(n),
            _step181;
          try {
            for (_iterator181.s(); !(_step181 = _iterator181.n()).done;) {
              var _e143 = _step181.value;
              if ("attributes" !== t || "class" !== _e143 && "style" !== _e143) {
                var _t140 = o.get(_e143);
                if (void 0 === _t140) return null;
                if (!_t140) return !1;
              } else {
                var _t141 = "class" == _e143 ? "classes" : "styles",
                  _n123 = this._test(_t141, _toConsumableArray(this._consumables[_t141].keys()));
                if (!0 !== _n123) return _n123;
              }
            }
          } catch (err) {
            _iterator181.e(err);
          } finally {
            _iterator181.f();
          }
          return !0;
        }
      }, {
        key: "_consume",
        value: function _consume(t, e) {
          var n = At(e) ? e : [e],
            o = this._consumables[t];
          var _iterator182 = _createForOfIteratorHelper(n),
            _step182;
          try {
            for (_iterator182.s(); !(_step182 = _iterator182.n()).done;) {
              var _e144 = _step182.value;
              if ("attributes" !== t || "class" !== _e144 && "style" !== _e144) {
                if (o.set(_e144, !1), "styles" == t) {
                  var _iterator183 = _createForOfIteratorHelper(this.element.document.stylesProcessor.getRelatedStyles(_e144)),
                    _step183;
                  try {
                    for (_iterator183.s(); !(_step183 = _iterator183.n()).done;) {
                      var _t142 = _step183.value;
                      o.set(_t142, !1);
                    }
                  } catch (err) {
                    _iterator183.e(err);
                  } finally {
                    _iterator183.f();
                  }
                }
              } else {
                var _t143 = "class" == _e144 ? "classes" : "styles";
                this._consume(_t143, _toConsumableArray(this._consumables[_t143].keys()));
              }
            }
          } catch (err) {
            _iterator182.e(err);
          } finally {
            _iterator182.f();
          }
        }
      }, {
        key: "_revert",
        value: function _revert(t, e) {
          var n = At(e) ? e : [e],
            o = this._consumables[t];
          var _iterator184 = _createForOfIteratorHelper(n),
            _step184;
          try {
            for (_iterator184.s(); !(_step184 = _iterator184.n()).done;) {
              var _e145 = _step184.value;
              if ("attributes" !== t || "class" !== _e145 && "style" !== _e145) {
                !1 === o.get(_e145) && o.set(_e145, !0);
              } else {
                var _t144 = "class" == _e145 ? "classes" : "styles";
                this._revert(_t144, _toConsumableArray(this._consumables[_t144].keys()));
              }
            }
          } catch (err) {
            _iterator184.e(err);
          } finally {
            _iterator184.f();
          }
        }
      }]);
      return ac;
    }();
    var cc = /*#__PURE__*/function () {
      function cc() {
        var _this64 = this;
        _classCallCheck(this, cc);
        this._sourceDefinitions = {}, this._attributeProperties = {}, this.decorate("checkChild"), this.decorate("checkAttribute"), this.on("checkAttribute", function (t, e) {
          e[0] = new lc(e[0]);
        }, {
          priority: "highest"
        }), this.on("checkChild", function (t, e) {
          e[0] = new lc(e[0]), e[1] = _this64.getDefinition(e[1]);
        }, {
          priority: "highest"
        });
      }
      _createClass(cc, [{
        key: "register",
        value: function register(t, e) {
          if (this._sourceDefinitions[t]) throw new c.a("schema-cannot-register-item-twice", this, {
            itemName: t
          });
          this._sourceDefinitions[t] = [Object.assign({}, e)], this._clearCache();
        }
      }, {
        key: "extend",
        value: function extend(t, e) {
          if (!this._sourceDefinitions[t]) throw new c.a("schema-cannot-extend-missing-item", this, {
            itemName: t
          });
          this._sourceDefinitions[t].push(Object.assign({}, e)), this._clearCache();
        }
      }, {
        key: "getDefinitions",
        value: function getDefinitions() {
          return this._compiledDefinitions || this._compile(), this._compiledDefinitions;
        }
      }, {
        key: "getDefinition",
        value: function getDefinition(t) {
          var e;
          return e = "string" == typeof t ? t : t.is && (t.is("$text") || t.is("$textProxy")) ? "$text" : t.name, this.getDefinitions()[e];
        }
      }, {
        key: "isRegistered",
        value: function isRegistered(t) {
          return !!this.getDefinition(t);
        }
      }, {
        key: "isBlock",
        value: function isBlock(t) {
          var e = this.getDefinition(t);
          return !(!e || !e.isBlock);
        }
      }, {
        key: "isLimit",
        value: function isLimit(t) {
          var e = this.getDefinition(t);
          return !!e && !(!e.isLimit && !e.isObject);
        }
      }, {
        key: "isObject",
        value: function isObject(t) {
          var e = this.getDefinition(t);
          return !!e && !!(e.isObject || e.isLimit && e.isSelectable && e.isContent);
        }
      }, {
        key: "isInline",
        value: function isInline(t) {
          var e = this.getDefinition(t);
          return !(!e || !e.isInline);
        }
      }, {
        key: "isSelectable",
        value: function isSelectable(t) {
          var e = this.getDefinition(t);
          return !!e && !(!e.isSelectable && !e.isObject);
        }
      }, {
        key: "isContent",
        value: function isContent(t) {
          var e = this.getDefinition(t);
          return !!e && !(!e.isContent && !e.isObject);
        }
      }, {
        key: "checkChild",
        value: function checkChild(t, e) {
          return !!e && this._checkContextMatch(e, t);
        }
      }, {
        key: "checkAttribute",
        value: function checkAttribute(t, e) {
          var n = this.getDefinition(t.last);
          return !!n && n.allowAttributes.includes(e);
        }
      }, {
        key: "checkMerge",
        value: function checkMerge(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          if (t instanceof pa) {
            var _e146 = t.nodeBefore,
              _n124 = t.nodeAfter;
            if (!(_e146 instanceof ua)) throw new c.a("schema-check-merge-no-element-before", this);
            if (!(_n124 instanceof ua)) throw new c.a("schema-check-merge-no-element-after", this);
            return this.checkMerge(_e146, _n124);
          }
          var _iterator185 = _createForOfIteratorHelper(e.getChildren()),
            _step185;
          try {
            for (_iterator185.s(); !(_step185 = _iterator185.n()).done;) {
              var _n125 = _step185.value;
              if (!this.checkChild(t, _n125)) return !1;
            }
          } catch (err) {
            _iterator185.e(err);
          } finally {
            _iterator185.f();
          }
          return !0;
        }
      }, {
        key: "addChildCheck",
        value: function addChildCheck(t) {
          this.on("checkChild", function (e, _ref16) {
            var _ref17 = _slicedToArray(_ref16, 2),
              n = _ref17[0],
              o = _ref17[1];
            if (!o) return;
            var i = t(n, o);
            "boolean" == typeof i && (e.stop(), e.return = i);
          }, {
            priority: "high"
          });
        }
      }, {
        key: "addAttributeCheck",
        value: function addAttributeCheck(t) {
          this.on("checkAttribute", function (e, _ref18) {
            var _ref19 = _slicedToArray(_ref18, 2),
              n = _ref19[0],
              o = _ref19[1];
            var i = t(n, o);
            "boolean" == typeof i && (e.stop(), e.return = i);
          }, {
            priority: "high"
          });
        }
      }, {
        key: "setAttributeProperties",
        value: function setAttributeProperties(t, e) {
          this._attributeProperties[t] = Object.assign(this.getAttributeProperties(t), e);
        }
      }, {
        key: "getAttributeProperties",
        value: function getAttributeProperties(t) {
          return this._attributeProperties[t] || {};
        }
      }, {
        key: "getLimitElement",
        value: function getLimitElement(t) {
          var e;
          if (t instanceof pa) e = t.parent;else {
            e = (t instanceof wa ? [t] : Array.from(t.getRanges())).reduce(function (t, e) {
              var n = e.getCommonAncestor();
              return t ? t.getCommonAncestor(n, {
                includeSelf: !0
              }) : n;
            }, null);
          }
          for (; !this.isLimit(e) && e.parent;) e = e.parent;
          return e;
        }
      }, {
        key: "checkAttributeInSelection",
        value: function checkAttributeInSelection(t, e) {
          if (t.isCollapsed) {
            var _n126 = [].concat(_toConsumableArray(t.getFirstPosition().getAncestors()), [new la("", t.getAttributes())]);
            return this.checkAttribute(_n126, e);
          }
          {
            var _n127 = t.getRanges();
            var _iterator186 = _createForOfIteratorHelper(_n127),
              _step186;
            try {
              for (_iterator186.s(); !(_step186 = _iterator186.n()).done;) {
                var _t145 = _step186.value;
                var _iterator187 = _createForOfIteratorHelper(_t145),
                  _step187;
                try {
                  for (_iterator187.s(); !(_step187 = _iterator187.n()).done;) {
                    var _n128 = _step187.value;
                    if (this.checkAttribute(_n128.item, e)) return !0;
                  }
                } catch (err) {
                  _iterator187.e(err);
                } finally {
                  _iterator187.f();
                }
              }
            } catch (err) {
              _iterator186.e(err);
            } finally {
              _iterator186.f();
            }
          }
          return !1;
        }
      }, {
        key: "getValidRanges",
        value: /*#__PURE__*/_regeneratorRuntime().mark(function getValidRanges(t, e) {
          var _iterator189, _step189, _n129;
          return _regeneratorRuntime().wrap(function getValidRanges$(_context23) {
            while (1) switch (_context23.prev = _context23.next) {
              case 0:
                t = /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(t) {
                  var _iterator188, _step188, _e147;
                  return _regeneratorRuntime().wrap(function _callee7$(_context22) {
                    while (1) switch (_context22.prev = _context22.next) {
                      case 0:
                        _iterator188 = _createForOfIteratorHelper(t);
                        _context22.prev = 1;
                        _iterator188.s();
                      case 3:
                        if ((_step188 = _iterator188.n()).done) {
                          _context22.next = 8;
                          break;
                        }
                        _e147 = _step188.value;
                        return _context22.delegateYield(_e147.getMinimalFlatRanges(), "t0", 6);
                      case 6:
                        _context22.next = 3;
                        break;
                      case 8:
                        _context22.next = 13;
                        break;
                      case 10:
                        _context22.prev = 10;
                        _context22.t1 = _context22["catch"](1);
                        _iterator188.e(_context22.t1);
                      case 13:
                        _context22.prev = 13;
                        _iterator188.f();
                        return _context22.finish(13);
                      case 16:
                      case "end":
                        return _context22.stop();
                    }
                  }, _callee7, null, [[1, 10, 13, 16]]);
                })(t);
                _iterator189 = _createForOfIteratorHelper(t);
                _context23.prev = 2;
                _iterator189.s();
              case 4:
                if ((_step189 = _iterator189.n()).done) {
                  _context23.next = 9;
                  break;
                }
                _n129 = _step189.value;
                return _context23.delegateYield(this._getValidRangesForRange(_n129, e), "t0", 7);
              case 7:
                _context23.next = 4;
                break;
              case 9:
                _context23.next = 14;
                break;
              case 11:
                _context23.prev = 11;
                _context23.t1 = _context23["catch"](2);
                _iterator189.e(_context23.t1);
              case 14:
                _context23.prev = 14;
                _iterator189.f();
                return _context23.finish(14);
              case 17:
              case "end":
                return _context23.stop();
            }
          }, getValidRanges, this, [[2, 11, 14, 17]]);
        })
      }, {
        key: "getNearestSelectionRange",
        value: function getNearestSelectionRange(t) {
          var _this65 = this;
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "both";
          if (this.checkChild(t, "$text")) return new wa(t);
          var n, o;
          var i = t.getAncestors().reverse().find(function (t) {
            return _this65.isLimit(t);
          }) || t.root;
          "both" != e && "backward" != e || (n = new ga({
            boundaries: wa._createIn(i),
            startPosition: t,
            direction: "backward"
          })), "both" != e && "forward" != e || (o = new ga({
            boundaries: wa._createIn(i),
            startPosition: t
          }));
          var _iterator190 = _createForOfIteratorHelper( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(t, e) {
              var n, _e148, _t146;
              return _regeneratorRuntime().wrap(function _callee8$(_context24) {
                while (1) switch (_context24.prev = _context24.next) {
                  case 0:
                    n = !1;
                  case 1:
                    if (n) {
                      _context24.next = 18;
                      break;
                    }
                    if (!(n = !0, t)) {
                      _context24.next = 9;
                      break;
                    }
                    _e148 = t.next();
                    _context24.t0 = _e148.done;
                    if (_context24.t0) {
                      _context24.next = 9;
                      break;
                    }
                    n = !1;
                    _context24.next = 9;
                    return {
                      walker: t,
                      value: _e148.value
                    };
                  case 9:
                    if (!e) {
                      _context24.next = 16;
                      break;
                    }
                    _t146 = e.next();
                    _context24.t1 = _t146.done;
                    if (_context24.t1) {
                      _context24.next = 16;
                      break;
                    }
                    n = !1;
                    _context24.next = 16;
                    return {
                      walker: e,
                      value: _t146.value
                    };
                  case 16:
                    _context24.next = 1;
                    break;
                  case 18:
                  case "end":
                    return _context24.stop();
                }
              }, _callee8);
            })(n, o)),
            _step190;
          try {
            for (_iterator190.s(); !(_step190 = _iterator190.n()).done;) {
              var _t147 = _step190.value;
              var _e149 = _t147.walker == n ? "elementEnd" : "elementStart",
                _o70 = _t147.value;
              if (_o70.type == _e149 && this.isObject(_o70.item)) return wa._createOn(_o70.item);
              if (this.checkChild(_o70.nextPosition, "$text")) return new wa(_o70.nextPosition);
            }
          } catch (err) {
            _iterator190.e(err);
          } finally {
            _iterator190.f();
          }
          return null;
        }
      }, {
        key: "findAllowedParent",
        value: function findAllowedParent(t, e) {
          var n = t.parent;
          for (; n;) {
            if (this.checkChild(n, e)) return n;
            if (this.isLimit(n)) return null;
            n = n.parent;
          }
          return null;
        }
      }, {
        key: "removeDisallowedAttributes",
        value: function removeDisallowedAttributes(t, e) {
          var _iterator191 = _createForOfIteratorHelper(t),
            _step191;
          try {
            for (_iterator191.s(); !(_step191 = _iterator191.n()).done;) {
              var _n130 = _step191.value;
              if (_n130.is("$text")) _c(this, _n130, e);else {
                var _t148 = wa._createIn(_n130).getPositions();
                var _iterator192 = _createForOfIteratorHelper(_t148),
                  _step192;
                try {
                  for (_iterator192.s(); !(_step192 = _iterator192.n()).done;) {
                    var _n131 = _step192.value;
                    _c(this, _n131.nodeBefore || _n131.parent, e);
                  }
                } catch (err) {
                  _iterator192.e(err);
                } finally {
                  _iterator192.f();
                }
              }
            }
          } catch (err) {
            _iterator191.e(err);
          } finally {
            _iterator191.f();
          }
        }
      }, {
        key: "createContext",
        value: function createContext(t) {
          return new lc(t);
        }
      }, {
        key: "_clearCache",
        value: function _clearCache() {
          this._compiledDefinitions = null;
        }
      }, {
        key: "_compile",
        value: function _compile() {
          var t = {},
            e = this._sourceDefinitions,
            n = Object.keys(e);
          for (var _i61 = 0, _n132 = n; _i61 < _n132.length; _i61++) {
            var _o71 = _n132[_i61];
            t[_o71] = dc(e[_o71], _o71);
          }
          for (var _i62 = 0, _n133 = n; _i62 < _n133.length; _i62++) {
            var _e150 = _n133[_i62];
            hc(t, _e150);
          }
          for (var _i63 = 0, _n134 = n; _i63 < _n134.length; _i63++) {
            var _e151 = _n134[_i63];
            uc(t, _e151);
          }
          for (var _i64 = 0, _n135 = n; _i64 < _n135.length; _i64++) {
            var _e152 = _n135[_i64];
            gc(t, _e152);
          }
          for (var _i65 = 0, _n136 = n; _i65 < _n136.length; _i65++) {
            var _e153 = _n136[_i65];
            mc(t, _e153), pc(t, _e153);
          }
          for (var _i66 = 0, _n137 = n; _i66 < _n137.length; _i66++) {
            var _e154 = _n137[_i66];
            fc(t, _e154), kc(t, _e154), bc(t, _e154);
          }
          this._compiledDefinitions = t;
        }
      }, {
        key: "_checkContextMatch",
        value: function _checkContextMatch(t, e) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : e.length - 1;
          var o = e.getItem(n);
          if (t.allowIn.includes(o.name)) {
            if (0 == n) return !0;
            {
              var _t149 = this.getDefinition(o);
              return this._checkContextMatch(_t149, e, n - 1);
            }
          }
          return !1;
        }
      }, {
        key: "_getValidRangesForRange",
        value: /*#__PURE__*/_regeneratorRuntime().mark(function _getValidRangesForRange(t, e) {
          var n, o, _iterator193, _step193, _i67;
          return _regeneratorRuntime().wrap(function _getValidRangesForRange$(_context25) {
            while (1) switch (_context25.prev = _context25.next) {
              case 0:
                n = t.start, o = t.start;
                _iterator193 = _createForOfIteratorHelper(t.getItems({
                  shallow: !0
                }));
                _context25.prev = 2;
                _iterator193.s();
              case 4:
                if ((_step193 = _iterator193.n()).done) {
                  _context25.next = 19;
                  break;
                }
                _i67 = _step193.value;
                _context25.t0 = _i67.is("element");
                if (!_context25.t0) {
                  _context25.next = 9;
                  break;
                }
                return _context25.delegateYield(this._getValidRangesForRange(wa._createIn(_i67), e), "t1", 9);
              case 9:
                _context25.t2 = this.checkAttribute(_i67, e);
                if (_context25.t2) {
                  _context25.next = 16;
                  break;
                }
                _context25.t3 = n.isEqual(o);
                if (_context25.t3) {
                  _context25.next = 15;
                  break;
                }
                _context25.next = 15;
                return new wa(n, o);
              case 15:
                n = pa._createAfter(_i67);
              case 16:
                o = pa._createAfter(_i67);
              case 17:
                _context25.next = 4;
                break;
              case 19:
                _context25.next = 24;
                break;
              case 21:
                _context25.prev = 21;
                _context25.t4 = _context25["catch"](2);
                _iterator193.e(_context25.t4);
              case 24:
                _context25.prev = 24;
                _iterator193.f();
                return _context25.finish(24);
              case 27:
                _context25.t5 = n.isEqual(o);
                if (_context25.t5) {
                  _context25.next = 31;
                  break;
                }
                _context25.next = 31;
                return new wa(n, o);
              case 31:
              case "end":
                return _context25.stop();
            }
          }, _getValidRangesForRange, this, [[2, 21, 24, 27]]);
        })
      }]);
      return cc;
    }();
    $t(cc, Gt);
    var lc = /*#__PURE__*/function () {
      function lc(t) {
        _classCallCheck(this, lc);
        if (t instanceof lc) return t;
        "string" == typeof t ? t = [t] : Array.isArray(t) || (t = t.getAncestors({
          includeSelf: !0
        })), this._items = t.map(Ac);
      }
      _createClass(lc, [{
        key: Symbol.iterator,
        value: function value() {
          return this._items[Symbol.iterator]();
        }
      }, {
        key: "push",
        value: function push(t) {
          var e = new lc([t]);
          return e._items = [].concat(_toConsumableArray(this._items), _toConsumableArray(e._items)), e;
        }
      }, {
        key: "getItem",
        value: function getItem(t) {
          return this._items[t];
        }
      }, {
        key: "getNames",
        value: /*#__PURE__*/_regeneratorRuntime().mark(function getNames() {
          return _regeneratorRuntime().wrap(function getNames$(_context26) {
            while (1) switch (_context26.prev = _context26.next) {
              case 0:
                return _context26.delegateYield(this._items.map(function (t) {
                  return t.name;
                }), "t0", 1);
              case 1:
              case "end":
                return _context26.stop();
            }
          }, getNames, this);
        })
      }, {
        key: "endsWith",
        value: function endsWith(t) {
          return Array.from(this.getNames()).join(" ").endsWith(t);
        }
      }, {
        key: "startsWith",
        value: function startsWith(t) {
          return Array.from(this.getNames()).join(" ").startsWith(t);
        }
      }, {
        key: "length",
        get: function get() {
          return this._items.length;
        }
      }, {
        key: "last",
        get: function get() {
          return this._items[this._items.length - 1];
        }
      }]);
      return lc;
    }();
    function dc(t, e) {
      var n = {
        name: e,
        allowIn: [],
        allowContentOf: [],
        allowWhere: [],
        allowAttributes: [],
        allowAttributesOf: [],
        allowChildren: [],
        inheritTypesFrom: []
      };
      return function (t, e) {
        var _iterator194 = _createForOfIteratorHelper(t),
          _step194;
        try {
          for (_iterator194.s(); !(_step194 = _iterator194.n()).done;) {
            var _n138 = _step194.value;
            var _t150 = Object.keys(_n138).filter(function (t) {
              return t.startsWith("is");
            });
            var _iterator195 = _createForOfIteratorHelper(_t150),
              _step195;
            try {
              for (_iterator195.s(); !(_step195 = _iterator195.n()).done;) {
                var _o72 = _step195.value;
                e[_o72] = _n138[_o72];
              }
            } catch (err) {
              _iterator195.e(err);
            } finally {
              _iterator195.f();
            }
          }
        } catch (err) {
          _iterator194.e(err);
        } finally {
          _iterator194.f();
        }
      }(t, n), wc(t, n, "allowIn"), wc(t, n, "allowContentOf"), wc(t, n, "allowWhere"), wc(t, n, "allowAttributes"), wc(t, n, "allowAttributesOf"), wc(t, n, "allowChildren"), wc(t, n, "inheritTypesFrom"), function (t, e) {
        var _iterator196 = _createForOfIteratorHelper(t),
          _step196;
        try {
          for (_iterator196.s(); !(_step196 = _iterator196.n()).done;) {
            var _n139 = _step196.value;
            var _t151 = _n139.inheritAllFrom;
            _t151 && (e.allowContentOf.push(_t151), e.allowWhere.push(_t151), e.allowAttributesOf.push(_t151), e.inheritTypesFrom.push(_t151));
          }
        } catch (err) {
          _iterator196.e(err);
        } finally {
          _iterator196.f();
        }
      }(t, n), n;
    }
    function hc(t, e) {
      var n = t[e];
      var _iterator197 = _createForOfIteratorHelper(n.allowChildren),
        _step197;
      try {
        for (_iterator197.s(); !(_step197 = _iterator197.n()).done;) {
          var _o73 = _step197.value;
          var _n140 = t[_o73];
          _n140 && _n140.allowIn.push(e);
        }
      } catch (err) {
        _iterator197.e(err);
      } finally {
        _iterator197.f();
      }
      n.allowChildren.length = 0;
    }
    function uc(t, e) {
      var _iterator198 = _createForOfIteratorHelper(t[e].allowContentOf),
        _step198;
      try {
        for (_iterator198.s(); !(_step198 = _iterator198.n()).done;) {
          var _n141 = _step198.value;
          if (t[_n141]) {
            Cc(t, _n141).forEach(function (t) {
              t.allowIn.push(e);
            });
          }
        }
      } catch (err) {
        _iterator198.e(err);
      } finally {
        _iterator198.f();
      }
      delete t[e].allowContentOf;
    }
    function gc(t, e) {
      var _iterator199 = _createForOfIteratorHelper(t[e].allowWhere),
        _step199;
      try {
        for (_iterator199.s(); !(_step199 = _iterator199.n()).done;) {
          var _n142 = _step199.value;
          var _o74 = t[_n142];
          if (_o74) {
            var _t$e$allowIn;
            var _n143 = _o74.allowIn;
            (_t$e$allowIn = t[e].allowIn).push.apply(_t$e$allowIn, _toConsumableArray(_n143));
          }
        }
      } catch (err) {
        _iterator199.e(err);
      } finally {
        _iterator199.f();
      }
      delete t[e].allowWhere;
    }
    function mc(t, e) {
      var _iterator200 = _createForOfIteratorHelper(t[e].allowAttributesOf),
        _step200;
      try {
        for (_iterator200.s(); !(_step200 = _iterator200.n()).done;) {
          var _n144 = _step200.value;
          var _o75 = t[_n144];
          if (_o75) {
            var _t$e$allowAttributes;
            var _n145 = _o75.allowAttributes;
            (_t$e$allowAttributes = t[e].allowAttributes).push.apply(_t$e$allowAttributes, _toConsumableArray(_n145));
          }
        }
      } catch (err) {
        _iterator200.e(err);
      } finally {
        _iterator200.f();
      }
      delete t[e].allowAttributesOf;
    }
    function pc(t, e) {
      var n = t[e];
      var _iterator201 = _createForOfIteratorHelper(n.inheritTypesFrom),
        _step201;
      try {
        for (_iterator201.s(); !(_step201 = _iterator201.n()).done;) {
          var _e155 = _step201.value;
          var _o76 = t[_e155];
          if (_o76) {
            var _t152 = Object.keys(_o76).filter(function (t) {
              return t.startsWith("is");
            });
            var _iterator202 = _createForOfIteratorHelper(_t152),
              _step202;
            try {
              for (_iterator202.s(); !(_step202 = _iterator202.n()).done;) {
                var _e156 = _step202.value;
                _e156 in n || (n[_e156] = _o76[_e156]);
              }
            } catch (err) {
              _iterator202.e(err);
            } finally {
              _iterator202.f();
            }
          }
        }
      } catch (err) {
        _iterator201.e(err);
      } finally {
        _iterator201.f();
      }
      delete n.inheritTypesFrom;
    }
    function fc(t, e) {
      var n = t[e],
        o = n.allowIn.filter(function (e) {
          return t[e];
        });
      n.allowIn = Array.from(new Set(o));
    }
    function kc(t, e) {
      var n = t[e];
      var _iterator203 = _createForOfIteratorHelper(n.allowIn),
        _step203;
      try {
        for (_iterator203.s(); !(_step203 = _iterator203.n()).done;) {
          var _o77 = _step203.value;
          t[_o77].allowChildren.push(e);
        }
      } catch (err) {
        _iterator203.e(err);
      } finally {
        _iterator203.f();
      }
    }
    function bc(t, e) {
      var n = t[e];
      n.allowAttributes = Array.from(new Set(n.allowAttributes));
    }
    function wc(t, e, n) {
      var _iterator204 = _createForOfIteratorHelper(t),
        _step204;
      try {
        for (_iterator204.s(); !(_step204 = _iterator204.n()).done;) {
          var _e$n;
          var _o78 = _step204.value;
          "string" == typeof _o78[n] ? e[n].push(_o78[n]) : Array.isArray(_o78[n]) && (_e$n = e[n]).push.apply(_e$n, _toConsumableArray(_o78[n]));
        }
      } catch (err) {
        _iterator204.e(err);
      } finally {
        _iterator204.f();
      }
    }
    function Cc(t, e) {
      var n = t[e];
      return (o = t, Object.keys(o).map(function (t) {
        return o[t];
      })).filter(function (t) {
        return t.allowIn.includes(n.name);
      });
      var o;
    }
    function Ac(t) {
      return "string" == typeof t || t.is("documentFragment") ? {
        name: "string" == typeof t ? t : "$documentFragment",
        getAttributeKeys: /*#__PURE__*/_regeneratorRuntime().mark(function getAttributeKeys() {
          return _regeneratorRuntime().wrap(function getAttributeKeys$(_context27) {
            while (1) switch (_context27.prev = _context27.next) {
              case 0:
              case "end":
                return _context27.stop();
            }
          }, getAttributeKeys);
        }),
        getAttribute: function getAttribute() {}
      } : {
        name: t.is("element") ? t.name : "$text",
        getAttributeKeys: /*#__PURE__*/_regeneratorRuntime().mark(function getAttributeKeys() {
          return _regeneratorRuntime().wrap(function getAttributeKeys$(_context28) {
            while (1) switch (_context28.prev = _context28.next) {
              case 0:
                return _context28.delegateYield(t.getAttributeKeys(), "t0", 1);
              case 1:
              case "end":
                return _context28.stop();
            }
          }, getAttributeKeys);
        }),
        getAttribute: function getAttribute(e) {
          return t.getAttribute(e);
        }
      };
    }
    function _c(t, e, n) {
      var _iterator205 = _createForOfIteratorHelper(e.getAttributeKeys()),
        _step205;
      try {
        for (_iterator205.s(); !(_step205 = _iterator205.n()).done;) {
          var _o79 = _step205.value;
          t.checkAttribute(e, _o79) || n.removeAttribute(_o79, e);
        }
      } catch (err) {
        _iterator205.e(err);
      } finally {
        _iterator205.f();
      }
    }
    var vc = /*#__PURE__*/function () {
      function vc() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        _classCallCheck(this, vc);
        this._splitParts = new Map(), this._cursorParents = new Map(), this._modelCursor = null, this.conversionApi = Object.assign({}, t), this.conversionApi.convertItem = this._convertItem.bind(this), this.conversionApi.convertChildren = this._convertChildren.bind(this), this.conversionApi.safeInsert = this._safeInsert.bind(this), this.conversionApi.updateConversionResult = this._updateConversionResult.bind(this), this.conversionApi.splitToAllowedParent = this._splitToAllowedParent.bind(this), this.conversionApi.getSplitParts = this._getSplitParts.bind(this);
      }
      _createClass(vc, [{
        key: "convert",
        value: function convert(t, e) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ["$root"];
          this.fire("viewCleanup", t), this._modelCursor = function (t, e) {
            var n;
            var _iterator206 = _createForOfIteratorHelper(new lc(t)),
              _step206;
            try {
              for (_iterator206.s(); !(_step206 = _iterator206.n()).done;) {
                var _o80 = _step206.value;
                var _t153 = {};
                var _iterator207 = _createForOfIteratorHelper(_o80.getAttributeKeys()),
                  _step207;
                try {
                  for (_iterator207.s(); !(_step207 = _iterator207.n()).done;) {
                    var _e157 = _step207.value;
                    _t153[_e157] = _o80.getAttribute(_e157);
                  }
                } catch (err) {
                  _iterator207.e(err);
                } finally {
                  _iterator207.f();
                }
                var _i68 = e.createElement(_o80.name, _t153);
                n && e.append(_i68, n), n = pa._createAt(_i68, 0);
              }
            } catch (err) {
              _iterator206.e(err);
            } finally {
              _iterator206.f();
            }
            return n;
          }(n, e), this.conversionApi.writer = e, this.conversionApi.consumable = sc.createFrom(t), this.conversionApi.store = {};
          var _this$_convertItem = this._convertItem(t, this._modelCursor),
            o = _this$_convertItem.modelRange,
            i = e.createDocumentFragment();
          if (o) {
            this._removeEmptyElements();
            for (var _i69 = 0, _Array$from4 = Array.from(this._modelCursor.parent.getChildren()); _i69 < _Array$from4.length; _i69++) {
              var _t154 = _Array$from4[_i69];
              e.append(_t154, i);
            }
            i.markers = function (t, e) {
              var n = new Set(),
                o = new Map(),
                i = wa._createIn(t).getItems();
              var _iterator208 = _createForOfIteratorHelper(i),
                _step208;
              try {
                for (_iterator208.s(); !(_step208 = _iterator208.n()).done;) {
                  var _t155 = _step208.value;
                  "$marker" == _t155.name && n.add(_t155);
                }
              } catch (err) {
                _iterator208.e(err);
              } finally {
                _iterator208.f();
              }
              var _iterator209 = _createForOfIteratorHelper(n),
                _step209;
              try {
                for (_iterator209.s(); !(_step209 = _iterator209.n()).done;) {
                  var _t156 = _step209.value;
                  var _n146 = _t156.getAttribute("data-name"),
                    _i70 = e.createPositionBefore(_t156);
                  o.has(_n146) ? o.get(_n146).end = _i70.clone() : o.set(_n146, new wa(_i70.clone())), e.remove(_t156);
                }
              } catch (err) {
                _iterator209.e(err);
              } finally {
                _iterator209.f();
              }
              return o;
            }(i, e);
          }
          return this._modelCursor = null, this._splitParts.clear(), this._cursorParents.clear(), this.conversionApi.writer = null, this.conversionApi.store = null, i;
        }
      }, {
        key: "_convertItem",
        value: function _convertItem(t, e) {
          var n = Object.assign({
            viewItem: t,
            modelCursor: e,
            modelRange: null
          });
          if (t.is("element") ? this.fire("element:" + t.name, n, this.conversionApi) : t.is("$text") ? this.fire("text", n, this.conversionApi) : this.fire("documentFragment", n, this.conversionApi), n.modelRange && !(n.modelRange instanceof wa)) throw new c.a("view-conversion-dispatcher-incorrect-result", this);
          return {
            modelRange: n.modelRange,
            modelCursor: n.modelCursor
          };
        }
      }, {
        key: "_convertChildren",
        value: function _convertChildren(t, e) {
          var n = e.is("position") ? e : pa._createAt(e, 0);
          var o = new wa(n);
          for (var _i71 = 0, _Array$from5 = Array.from(t.getChildren()); _i71 < _Array$from5.length; _i71++) {
            var _e158 = _Array$from5[_i71];
            var _t157 = this._convertItem(_e158, n);
            _t157.modelRange instanceof wa && (o.end = _t157.modelRange.end, n = _t157.modelCursor);
          }
          return {
            modelRange: o,
            modelCursor: n
          };
        }
      }, {
        key: "_safeInsert",
        value: function _safeInsert(t, e) {
          var n = this._splitToAllowedParent(t, e);
          return !!n && (this.conversionApi.writer.insert(t, n.position), !0);
        }
      }, {
        key: "_updateConversionResult",
        value: function _updateConversionResult(t, e) {
          var n = this._getSplitParts(t),
            o = this.conversionApi.writer;
          e.modelRange || (e.modelRange = o.createRange(o.createPositionBefore(t), o.createPositionAfter(n[n.length - 1])));
          var i = this._cursorParents.get(t);
          e.modelCursor = i ? o.createPositionAt(i, 0) : e.modelRange.end;
        }
      }, {
        key: "_splitToAllowedParent",
        value: function _splitToAllowedParent(t, e) {
          var _this$conversionApi = this.conversionApi,
            n = _this$conversionApi.schema,
            o = _this$conversionApi.writer;
          var i = n.findAllowedParent(e, t);
          if (i) {
            if (i === e.parent) return {
              position: e
            };
            this._modelCursor.parent.getAncestors().includes(i) && (i = null);
          }
          if (!i) return Qa(e, t, n) ? {
            position: $a(e, o)
          } : null;
          var r = this.conversionApi.writer.split(e, i),
            s = [];
          var _iterator210 = _createForOfIteratorHelper(r.range.getWalker()),
            _step210;
          try {
            for (_iterator210.s(); !(_step210 = _iterator210.n()).done;) {
              var _t158 = _step210.value;
              if ("elementEnd" == _t158.type) s.push(_t158.item);else {
                var _e159 = s.pop(),
                  _n147 = _t158.item;
                this._registerSplitPair(_e159, _n147);
              }
            }
          } catch (err) {
            _iterator210.e(err);
          } finally {
            _iterator210.f();
          }
          var a = r.range.end.parent;
          return this._cursorParents.set(t, a), {
            position: r.position,
            cursorParent: a
          };
        }
      }, {
        key: "_registerSplitPair",
        value: function _registerSplitPair(t, e) {
          this._splitParts.has(t) || this._splitParts.set(t, [t]);
          var n = this._splitParts.get(t);
          this._splitParts.set(e, n), n.push(e);
        }
      }, {
        key: "_getSplitParts",
        value: function _getSplitParts(t) {
          var e;
          return e = this._splitParts.has(t) ? this._splitParts.get(t) : [t], e;
        }
      }, {
        key: "_removeEmptyElements",
        value: function _removeEmptyElements() {
          var t = !1;
          var _iterator211 = _createForOfIteratorHelper(this._splitParts.keys()),
            _step211;
          try {
            for (_iterator211.s(); !(_step211 = _iterator211.n()).done;) {
              var _e160 = _step211.value;
              _e160.isEmpty && (this.conversionApi.writer.remove(_e160), this._splitParts.delete(_e160), t = !0);
            }
          } catch (err) {
            _iterator211.e(err);
          } finally {
            _iterator211.f();
          }
          t && this._removeEmptyElements();
        }
      }]);
      return vc;
    }();
    $t(vc, h);
    var yc = /*#__PURE__*/function () {
      function yc() {
        _classCallCheck(this, yc);
      }
      _createClass(yc, [{
        key: "getHtml",
        value: function getHtml(t) {
          var e = document.implementation.createHTMLDocument("").createElement("div");
          return e.appendChild(t), e.innerHTML;
        }
      }]);
      return yc;
    }();
    var xc = /*#__PURE__*/function () {
      function xc(t) {
        _classCallCheck(this, xc);
        this._domParser = new DOMParser(), this._domConverter = new Or(t, {
          blockFillerMode: "nbsp"
        }), this._htmlWriter = new yc();
      }
      _createClass(xc, [{
        key: "toData",
        value: function toData(t) {
          var e = this._domConverter.viewToDom(t, document);
          return this._htmlWriter.getHtml(e);
        }
      }, {
        key: "toView",
        value: function toView(t) {
          var e = this._toDom(t);
          return this._domConverter.domToView(e);
        }
      }, {
        key: "registerRawContentMatcher",
        value: function registerRawContentMatcher(t) {
          this._domConverter.registerRawContentMatcher(t);
        }
      }, {
        key: "useFillerType",
        value: function useFillerType(t) {
          this._domConverter.blockFillerMode = "marked" == t ? "markedNbsp" : "nbsp";
        }
      }, {
        key: "_toDom",
        value: function _toDom(t) {
          var e = this._domParser.parseFromString(t, "text/html"),
            n = e.createDocumentFragment();
          var o = e.firstChild;
          for (; !o.isSameNode(e.documentElement);) {
            var _t159 = o;
            o = o.nextSibling, _t159.nodeType == Node.COMMENT_NODE && n.appendChild(_t159);
          }
          var i = e.body.childNodes;
          for (; i.length > 0;) n.appendChild(i[0]);
          return n;
        }
      }]);
      return xc;
    }();
    var Ec = /*#__PURE__*/function () {
      function Ec(t, e) {
        var _this66 = this;
        _classCallCheck(this, Ec);
        this.model = t, this.mapper = new Ca(), this.downcastDispatcher = new va({
          mapper: this.mapper,
          schema: t.schema
        }), this.downcastDispatcher.on("insert:$text", function (t, e, n) {
          if (!n.consumable.consume(e.item, "insert")) return;
          var o = n.writer,
            i = n.mapper.toViewPosition(e.range.start),
            r = o.createText(e.item.data);
          o.insert(i, r);
        }, {
          priority: "lowest"
        }), this.upcastDispatcher = new vc({
          schema: t.schema
        }), this.viewDocument = new Si(e), this.stylesProcessor = e, this.htmlProcessor = new xc(this.viewDocument), this.processor = this.htmlProcessor, this._viewWriter = new tr(this.viewDocument), this.upcastDispatcher.on("text", function (t, e, _ref20) {
          var n = _ref20.schema,
            o = _ref20.consumable,
            i = _ref20.writer;
          var r = e.modelCursor;
          if (!o.test(e.viewItem)) return;
          if (!n.checkChild(r, "$text")) {
            if (!Qa(r, "$text", n)) return;
            r = $a(r, i);
          }
          o.consume(e.viewItem);
          var s = i.createText(e.viewItem.data);
          i.insert(s, r), e.modelRange = i.createRange(r, r.getShiftedBy(s.offsetSize)), e.modelCursor = e.modelRange.end;
        }, {
          priority: "lowest"
        }), this.upcastDispatcher.on("element", function (t, e, n) {
          if (!e.modelRange && n.consumable.consume(e.viewItem, {
            name: !0
          })) {
            var _n$convertChildren = n.convertChildren(e.viewItem, e.modelCursor),
              _t160 = _n$convertChildren.modelRange,
              _o81 = _n$convertChildren.modelCursor;
            e.modelRange = _t160, e.modelCursor = _o81;
          }
        }, {
          priority: "lowest"
        }), this.upcastDispatcher.on("documentFragment", function (t, e, n) {
          if (!e.modelRange && n.consumable.consume(e.viewItem, {
            name: !0
          })) {
            var _n$convertChildren2 = n.convertChildren(e.viewItem, e.modelCursor),
              _t161 = _n$convertChildren2.modelRange,
              _o82 = _n$convertChildren2.modelCursor;
            e.modelRange = _t161, e.modelCursor = _o82;
          }
        }, {
          priority: "lowest"
        }), this.decorate("init"), this.decorate("set"), this.on("init", function () {
          _this66.fire("ready");
        }, {
          priority: "lowest"
        }), this.on("ready", function () {
          _this66.model.enqueueChange("transparent", Ya);
        }, {
          priority: "lowest"
        });
      }
      _createClass(Ec, [{
        key: "get",
        value: function get() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var _t$rootName = t.rootName,
            e = _t$rootName === void 0 ? "main" : _t$rootName,
            _t$trim = t.trim,
            n = _t$trim === void 0 ? "empty" : _t$trim;
          if (!this._checkIfRootsExists([e])) throw new c.a("datacontroller-get-non-existent-root", this);
          var o = this.model.document.getRoot(e);
          return "empty" !== n || this.model.hasContent(o, {
            ignoreWhitespaces: !0
          }) ? this.stringify(o, t) : "";
        }
      }, {
        key: "stringify",
        value: function stringify(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var n = this.toView(t, e);
          return this.processor.toData(n);
        }
      }, {
        key: "toView",
        value: function toView(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var n = this.viewDocument,
            o = this._viewWriter;
          this.mapper.clearBindings();
          var i = wa._createIn(t),
            r = new Xi(n);
          this.mapper.bindElements(t, r), this.downcastDispatcher.conversionApi.options = e, this.downcastDispatcher.convertInsert(i, o);
          var s = t.is("documentFragment") ? Array.from(t.markers) : function (t) {
            var e = [],
              n = t.root.document;
            if (!n) return [];
            var o = wa._createIn(t);
            var _iterator212 = _createForOfIteratorHelper(n.model.markers),
              _step212;
            try {
              for (_iterator212.s(); !(_step212 = _iterator212.n()).done;) {
                var _t162 = _step212.value;
                var _n148 = _t162.getRange(),
                  _i72 = _n148.isCollapsed,
                  _r22 = _n148.start.isEqual(o.start) || _n148.end.isEqual(o.end);
                if (_i72 && _r22) e.push([_t162.name, _n148]);else {
                  var _i73 = o.getIntersection(_n148);
                  _i73 && e.push([_t162.name, _i73]);
                }
              }
            } catch (err) {
              _iterator212.e(err);
            } finally {
              _iterator212.f();
            }
            return e;
          }(t);
          var _iterator213 = _createForOfIteratorHelper(s),
            _step213;
          try {
            for (_iterator213.s(); !(_step213 = _iterator213.n()).done;) {
              var _step213$value = _slicedToArray(_step213.value, 2),
                _t163 = _step213$value[0],
                _e161 = _step213$value[1];
              this.downcastDispatcher.convertMarkerAdd(_t163, _e161, o);
            }
          } catch (err) {
            _iterator213.e(err);
          } finally {
            _iterator213.f();
          }
          return delete this.downcastDispatcher.conversionApi.options, r;
        }
      }, {
        key: "init",
        value: function init(t) {
          var _this67 = this;
          if (this.model.document.version) throw new c.a("datacontroller-init-document-not-empty", this);
          var e = {};
          if ("string" == typeof t ? e.main = t : e = t, !this._checkIfRootsExists(Object.keys(e))) throw new c.a("datacontroller-init-non-existent-root", this);
          return this.model.enqueueChange("transparent", function (t) {
            for (var _i74 = 0, _Object$keys2 = Object.keys(e); _i74 < _Object$keys2.length; _i74++) {
              var _n149 = _Object$keys2[_i74];
              var _o83 = _this67.model.document.getRoot(_n149);
              t.insert(_this67.parse(e[_n149], _o83), _o83, 0);
            }
          }), Promise.resolve();
        }
      }, {
        key: "set",
        value: function set(t) {
          var _this68 = this;
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var n = {};
          if ("string" == typeof t ? n.main = t : n = t, !this._checkIfRootsExists(Object.keys(n))) throw new c.a("datacontroller-set-non-existent-root", this);
          var o = e.batchType || "default";
          this.model.enqueueChange(o, function (t) {
            t.setSelection(null), t.removeSelectionAttribute(_this68.model.document.selection.getAttributeKeys());
            for (var _i75 = 0, _Object$keys3 = Object.keys(n); _i75 < _Object$keys3.length; _i75++) {
              var _e162 = _Object$keys3[_i75];
              var _o84 = _this68.model.document.getRoot(_e162);
              t.remove(t.createRangeIn(_o84)), t.insert(_this68.parse(n[_e162], _o84), _o84, 0);
            }
          });
        }
      }, {
        key: "parse",
        value: function parse(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "$root";
          var n = this.processor.toView(t);
          return this.toModel(n, e);
        }
      }, {
        key: "toModel",
        value: function toModel(t) {
          var _this69 = this;
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "$root";
          return this.model.change(function (n) {
            return _this69.upcastDispatcher.convert(t, n, e);
          });
        }
      }, {
        key: "addStyleProcessorRules",
        value: function addStyleProcessorRules(t) {
          t(this.stylesProcessor);
        }
      }, {
        key: "registerRawContentMatcher",
        value: function registerRawContentMatcher(t) {
          this.processor && this.processor !== this.htmlProcessor && this.processor.registerRawContentMatcher(t), this.htmlProcessor.registerRawContentMatcher(t);
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.stopListening();
        }
      }, {
        key: "_checkIfRootsExists",
        value: function _checkIfRootsExists(t) {
          var _iterator214 = _createForOfIteratorHelper(t),
            _step214;
          try {
            for (_iterator214.s(); !(_step214 = _iterator214.n()).done;) {
              var _e163 = _step214.value;
              if (!this.model.document.getRootNames().includes(_e163)) return !1;
            }
          } catch (err) {
            _iterator214.e(err);
          } finally {
            _iterator214.f();
          }
          return !0;
        }
      }]);
      return Ec;
    }();
    $t(Ec, Gt);
    var Dc = /*#__PURE__*/function () {
      function Dc(t, e) {
        _classCallCheck(this, Dc);
        this._helpers = new Map(), this._downcast = ho(t), this._createConversionHelpers({
          name: "downcast",
          dispatchers: this._downcast,
          isDowncast: !0
        }), this._upcast = ho(e), this._createConversionHelpers({
          name: "upcast",
          dispatchers: this._upcast,
          isDowncast: !1
        });
      }
      _createClass(Dc, [{
        key: "addAlias",
        value: function addAlias(t, e) {
          var n = this._downcast.includes(e);
          if (!this._upcast.includes(e) && !n) throw new c.a("conversion-add-alias-dispatcher-not-registered", this);
          this._createConversionHelpers({
            name: t,
            dispatchers: [e],
            isDowncast: n
          });
        }
      }, {
        key: "for",
        value: function _for(t) {
          if (!this._helpers.has(t)) throw new c.a("conversion-for-unknown-group", this);
          return this._helpers.get(t);
        }
      }, {
        key: "elementToElement",
        value: function elementToElement(t) {
          this.for("downcast").elementToElement(t);
          var _iterator215 = _createForOfIteratorHelper(Mc(t)),
            _step215;
          try {
            for (_iterator215.s(); !(_step215 = _iterator215.n()).done;) {
              var _step215$value = _step215.value,
                _e164 = _step215$value.model,
                _n150 = _step215$value.view;
              this.for("upcast").elementToElement({
                model: _e164,
                view: _n150,
                converterPriority: t.converterPriority
              });
            }
          } catch (err) {
            _iterator215.e(err);
          } finally {
            _iterator215.f();
          }
        }
      }, {
        key: "attributeToElement",
        value: function attributeToElement(t) {
          this.for("downcast").attributeToElement(t);
          var _iterator216 = _createForOfIteratorHelper(Mc(t)),
            _step216;
          try {
            for (_iterator216.s(); !(_step216 = _iterator216.n()).done;) {
              var _step216$value = _step216.value,
                _e165 = _step216$value.model,
                _n151 = _step216$value.view;
              this.for("upcast").elementToAttribute({
                view: _n151,
                model: _e165,
                converterPriority: t.converterPriority
              });
            }
          } catch (err) {
            _iterator216.e(err);
          } finally {
            _iterator216.f();
          }
        }
      }, {
        key: "attributeToAttribute",
        value: function attributeToAttribute(t) {
          this.for("downcast").attributeToAttribute(t);
          var _iterator217 = _createForOfIteratorHelper(Mc(t)),
            _step217;
          try {
            for (_iterator217.s(); !(_step217 = _iterator217.n()).done;) {
              var _step217$value = _step217.value,
                _e166 = _step217$value.model,
                _n152 = _step217$value.view;
              this.for("upcast").attributeToAttribute({
                view: _n152,
                model: _e166
              });
            }
          } catch (err) {
            _iterator217.e(err);
          } finally {
            _iterator217.f();
          }
        }
      }, {
        key: "_createConversionHelpers",
        value: function _createConversionHelpers(_ref21) {
          var t = _ref21.name,
            e = _ref21.dispatchers,
            n = _ref21.isDowncast;
          if (this._helpers.has(t)) throw new c.a("conversion-group-exists", this);
          var o = n ? new Va(e) : new Ja(e);
          this._helpers.set(t, o);
        }
      }]);
      return Dc;
    }();
    function Mc(t) {
      var _iterator218, _step218, _e167, _n153, _o85, _i76;
      return _regeneratorRuntime().wrap(function Mc$(_context29) {
        while (1) switch (_context29.prev = _context29.next) {
          case 0:
            if (!t.model.values) {
              _context29.next = 20;
              break;
            }
            _iterator218 = _createForOfIteratorHelper(t.model.values);
            _context29.prev = 2;
            _iterator218.s();
          case 4:
            if ((_step218 = _iterator218.n()).done) {
              _context29.next = 10;
              break;
            }
            _e167 = _step218.value;
            _n153 = {
              key: t.model.key,
              value: _e167
            }, _o85 = t.view[_e167], _i76 = t.upcastAlso ? t.upcastAlso[_e167] : void 0;
            return _context29.delegateYield(Ic(_n153, _o85, _i76), "t0", 8);
          case 8:
            _context29.next = 4;
            break;
          case 10:
            _context29.next = 15;
            break;
          case 12:
            _context29.prev = 12;
            _context29.t1 = _context29["catch"](2);
            _iterator218.e(_context29.t1);
          case 15:
            _context29.prev = 15;
            _iterator218.f();
            return _context29.finish(15);
          case 18:
            _context29.next = 21;
            break;
          case 20:
            return _context29.delegateYield(Ic(t.model, t.view, t.upcastAlso), "t2", 21);
          case 21:
          case "end":
            return _context29.stop();
        }
      }, _marked, null, [[2, 12, 15, 18]]);
    }
    function Ic(t, e, n) {
      var _iterator219, _step219, _e168;
      return _regeneratorRuntime().wrap(function Ic$(_context30) {
        while (1) switch (_context30.prev = _context30.next) {
          case 0:
            _context30.next = 2;
            return {
              model: t,
              view: e
            };
          case 2:
            if (!n) {
              _context30.next = 20;
              break;
            }
            _iterator219 = _createForOfIteratorHelper(ho(n));
            _context30.prev = 4;
            _iterator219.s();
          case 6:
            if ((_step219 = _iterator219.n()).done) {
              _context30.next = 12;
              break;
            }
            _e168 = _step219.value;
            _context30.next = 10;
            return {
              model: t,
              view: _e168
            };
          case 10:
            _context30.next = 6;
            break;
          case 12:
            _context30.next = 17;
            break;
          case 14:
            _context30.prev = 14;
            _context30.t0 = _context30["catch"](4);
            _iterator219.e(_context30.t0);
          case 17:
            _context30.prev = 17;
            _iterator219.f();
            return _context30.finish(17);
          case 20:
          case "end":
            return _context30.stop();
        }
      }, _marked2, null, [[4, 14, 17, 20]]);
    }
    var Tc = /*#__PURE__*/function () {
      function Tc() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "default";
        _classCallCheck(this, Tc);
        this.operations = [], this.type = t;
      }
      _createClass(Tc, [{
        key: "addOperation",
        value: function addOperation(t) {
          return t.batch = this, this.operations.push(t), t;
        }
      }, {
        key: "baseVersion",
        get: function get() {
          var _iterator220 = _createForOfIteratorHelper(this.operations),
            _step220;
          try {
            for (_iterator220.s(); !(_step220 = _iterator220.n()).done;) {
              var _t164 = _step220.value;
              if (null !== _t164.baseVersion) return _t164.baseVersion;
            }
          } catch (err) {
            _iterator220.e(err);
          } finally {
            _iterator220.f();
          }
          return null;
        }
      }]);
      return Tc;
    }();
    var Sc = /*#__PURE__*/function () {
      function Sc(t) {
        _classCallCheck(this, Sc);
        this.baseVersion = t, this.isDocumentOperation = null !== this.baseVersion, this.batch = null;
      }
      _createClass(Sc, [{
        key: "_validate",
        value: function _validate() {}
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = Object.assign({}, this);
          return t.__className = this.constructor.className, delete t.batch, delete t.isDocumentOperation, t;
        }
      }], [{
        key: "fromJSON",
        value: function fromJSON(t) {
          return new this(t.baseVersion);
        }
      }, {
        key: "className",
        get: function get() {
          return "Operation";
        }
      }]);
      return Sc;
    }();
    var Nc = /*#__PURE__*/function () {
      function Nc(t) {
        _classCallCheck(this, Nc);
        this.markers = new Map(), this._children = new ha(), t && this._insertChild(0, t);
      }
      _createClass(Nc, [{
        key: Symbol.iterator,
        value: function value() {
          return this.getChildren();
        }
      }, {
        key: "is",
        value: function is(t) {
          return "documentFragment" === t || "model:documentFragment" === t;
        }
      }, {
        key: "getChild",
        value: function getChild(t) {
          return this._children.getNode(t);
        }
      }, {
        key: "getChildren",
        value: function getChildren() {
          return this._children[Symbol.iterator]();
        }
      }, {
        key: "getChildIndex",
        value: function getChildIndex(t) {
          return this._children.getNodeIndex(t);
        }
      }, {
        key: "getChildStartOffset",
        value: function getChildStartOffset(t) {
          return this._children.getNodeStartOffset(t);
        }
      }, {
        key: "getPath",
        value: function getPath() {
          return [];
        }
      }, {
        key: "getNodeByPath",
        value: function getNodeByPath(t) {
          var e = this;
          var _iterator221 = _createForOfIteratorHelper(t),
            _step221;
          try {
            for (_iterator221.s(); !(_step221 = _iterator221.n()).done;) {
              var _n154 = _step221.value;
              e = e.getChild(e.offsetToIndex(_n154));
            }
          } catch (err) {
            _iterator221.e(err);
          } finally {
            _iterator221.f();
          }
          return e;
        }
      }, {
        key: "offsetToIndex",
        value: function offsetToIndex(t) {
          return this._children.offsetToIndex(t);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = [];
          var _iterator222 = _createForOfIteratorHelper(this._children),
            _step222;
          try {
            for (_iterator222.s(); !(_step222 = _iterator222.n()).done;) {
              var _e169 = _step222.value;
              t.push(_e169.toJSON());
            }
          } catch (err) {
            _iterator222.e(err);
          } finally {
            _iterator222.f();
          }
          return t;
        }
      }, {
        key: "_appendChild",
        value: function _appendChild(t) {
          this._insertChild(this.childCount, t);
        }
      }, {
        key: "_insertChild",
        value: function _insertChild(t, e) {
          var n = function (t) {
            if ("string" == typeof t) return [new la(t)];
            ao(t) || (t = [t]);
            return Array.from(t).map(function (t) {
              return "string" == typeof t ? new la(t) : t instanceof da ? new la(t.data, t.getAttributes()) : t;
            });
          }(e);
          var _iterator223 = _createForOfIteratorHelper(n),
            _step223;
          try {
            for (_iterator223.s(); !(_step223 = _iterator223.n()).done;) {
              var _t165 = _step223.value;
              null !== _t165.parent && _t165._remove(), _t165.parent = this;
            }
          } catch (err) {
            _iterator223.e(err);
          } finally {
            _iterator223.f();
          }
          this._children._insertNodes(t, n);
        }
      }, {
        key: "_removeChildren",
        value: function _removeChildren(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
          var n = this._children._removeNodes(t, e);
          var _iterator224 = _createForOfIteratorHelper(n),
            _step224;
          try {
            for (_iterator224.s(); !(_step224 = _iterator224.n()).done;) {
              var _t166 = _step224.value;
              _t166.parent = null;
            }
          } catch (err) {
            _iterator224.e(err);
          } finally {
            _iterator224.f();
          }
          return n;
        }
      }, {
        key: "childCount",
        get: function get() {
          return this._children.length;
        }
      }, {
        key: "maxOffset",
        get: function get() {
          return this._children.maxOffset;
        }
      }, {
        key: "isEmpty",
        get: function get() {
          return 0 === this.childCount;
        }
      }, {
        key: "root",
        get: function get() {
          return this;
        }
      }, {
        key: "parent",
        get: function get() {
          return null;
        }
      }], [{
        key: "fromJSON",
        value: function fromJSON(t) {
          var e = [];
          var _iterator225 = _createForOfIteratorHelper(t),
            _step225;
          try {
            for (_iterator225.s(); !(_step225 = _iterator225.n()).done;) {
              var _n155 = _step225.value;
              _n155.name ? e.push(ua.fromJSON(_n155)) : e.push(la.fromJSON(_n155));
            }
          } catch (err) {
            _iterator225.e(err);
          } finally {
            _iterator225.f();
          }
          return new Nc(e);
        }
      }]);
      return Nc;
    }();
    function Bc(t, e) {
      var n = (e = Lc(e)).reduce(function (t, e) {
          return t + e.offsetSize;
        }, 0),
        o = t.parent;
      Rc(t);
      var i = t.index;
      return o._insertChild(i, e), Oc(o, i + e.length), Oc(o, i), new wa(t, t.getShiftedBy(n));
    }
    function Pc(t) {
      if (!t.isFlat) throw new c.a("operation-utils-remove-range-not-flat", this);
      var e = t.start.parent;
      Rc(t.start), Rc(t.end);
      var n = e._removeChildren(t.start.index, t.end.index - t.start.index);
      return Oc(e, t.start.index), n;
    }
    function zc(t, e) {
      if (!t.isFlat) throw new c.a("operation-utils-move-range-not-flat", this);
      var n = Pc(t);
      return Bc(e = e._getTransformedByDeletion(t.start, t.end.offset - t.start.offset), n);
    }
    function Lc(t) {
      var e = [];
      t instanceof Array || (t = [t]);
      for (var _n157 = 0; _n157 < t.length; _n157++) if ("string" == typeof t[_n157]) e.push(new la(t[_n157]));else if (t[_n157] instanceof da) e.push(new la(t[_n157].data, t[_n157].getAttributes()));else if (t[_n157] instanceof Nc || t[_n157] instanceof ha) {
        var _iterator226 = _createForOfIteratorHelper(t[_n157]),
          _step226;
        try {
          for (_iterator226.s(); !(_step226 = _iterator226.n()).done;) {
            var _o86 = _step226.value;
            e.push(_o86);
          }
        } catch (err) {
          _iterator226.e(err);
        } finally {
          _iterator226.f();
        }
      } else t[_n157] instanceof ca && e.push(t[_n157]);
      for (var _t168 = 1; _t168 < e.length; _t168++) {
        var _n158 = e[_t168],
          _o87 = e[_t168 - 1];
        _n158 instanceof la && _o87 instanceof la && jc(_n158, _o87) && (e.splice(_t168 - 1, 2, new la(_o87.data + _n158.data, _o87.getAttributes())), _t168--);
      }
      return e;
    }
    function Oc(t, e) {
      var n = t.getChild(e - 1),
        o = t.getChild(e);
      if (n && o && n.is("$text") && o.is("$text") && jc(n, o)) {
        var _i77 = new la(n.data + o.data, n.getAttributes());
        t._removeChildren(e - 1, 2), t._insertChild(e - 1, _i77);
      }
    }
    function Rc(t) {
      var e = t.textNode,
        n = t.parent;
      if (e) {
        var _o88 = t.offset - e.startOffset,
          _i78 = e.index;
        n._removeChildren(_i78, 1);
        var _r23 = new la(e.data.substr(0, _o88), e.getAttributes()),
          _s16 = new la(e.data.substr(_o88), e.getAttributes());
        n._insertChild(_i78, [_r23, _s16]);
      }
    }
    function jc(t, e) {
      var n = t.getAttributes(),
        o = e.getAttributes();
      var _iterator227 = _createForOfIteratorHelper(n),
        _step227;
      try {
        for (_iterator227.s(); !(_step227 = _iterator227.n()).done;) {
          var _t169 = _step227.value;
          if (_t169[1] !== e.getAttribute(_t169[0])) return !1;
          o.next();
        }
      } catch (err) {
        _iterator227.e(err);
      } finally {
        _iterator227.f();
      }
      return o.next().done;
    }
    var Fc = function Fc(t, e) {
      return hs(t, e);
    };
    var Vc = /*#__PURE__*/function (_Sc) {
      _inherits(Vc, _Sc);
      function Vc(t, e, n, o, i) {
        var _this70;
        _classCallCheck(this, Vc);
        _this70 = _possibleConstructorReturn(this, _getPrototypeOf(Vc).call(this, i)), _this70.range = t.clone(), _this70.key = e, _this70.oldValue = void 0 === n ? null : n, _this70.newValue = void 0 === o ? null : o;
        return _this70;
      }
      _createClass(Vc, [{
        key: "clone",
        value: function clone() {
          return new Vc(this.range, this.key, this.oldValue, this.newValue, this.baseVersion);
        }
      }, {
        key: "getReversed",
        value: function getReversed() {
          return new Vc(this.range, this.key, this.newValue, this.oldValue, this.baseVersion + 1);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = _get(_getPrototypeOf(Vc.prototype), "toJSON", this).call(this);
          return t.range = this.range.toJSON(), t;
        }
      }, {
        key: "_validate",
        value: function _validate() {
          if (!this.range.isFlat) throw new c.a("attribute-operation-range-not-flat", this);
          var _iterator228 = _createForOfIteratorHelper(this.range.getItems({
              shallow: !0
            })),
            _step228;
          try {
            for (_iterator228.s(); !(_step228 = _iterator228.n()).done;) {
              var _t170 = _step228.value;
              if (null !== this.oldValue && !Fc(_t170.getAttribute(this.key), this.oldValue)) throw new c.a("attribute-operation-wrong-old-value", this, {
                item: _t170,
                key: this.key,
                value: this.oldValue
              });
              if (null === this.oldValue && null !== this.newValue && _t170.hasAttribute(this.key)) throw new c.a("attribute-operation-attribute-exists", this, {
                node: _t170,
                key: this.key
              });
            }
          } catch (err) {
            _iterator228.e(err);
          } finally {
            _iterator228.f();
          }
        }
      }, {
        key: "_execute",
        value: function _execute() {
          Fc(this.oldValue, this.newValue) || function (t, e, n) {
            Rc(t.start), Rc(t.end);
            var _iterator229 = _createForOfIteratorHelper(t.getItems({
                shallow: !0
              })),
              _step229;
            try {
              for (_iterator229.s(); !(_step229 = _iterator229.n()).done;) {
                var _o89 = _step229.value;
                var _t171 = _o89.is("$textProxy") ? _o89.textNode : _o89;
                null !== n ? _t171._setAttribute(e, n) : _t171._removeAttribute(e), Oc(_t171.parent, _t171.index);
              }
            } catch (err) {
              _iterator229.e(err);
            } finally {
              _iterator229.f();
            }
            Oc(t.end.parent, t.end.index);
          }(this.range, this.key, this.newValue);
        }
      }, {
        key: "type",
        get: function get() {
          return null === this.oldValue ? "addAttribute" : null === this.newValue ? "removeAttribute" : "changeAttribute";
        }
      }], [{
        key: "fromJSON",
        value: function fromJSON(t, e) {
          return new Vc(wa.fromJSON(t.range, e), t.key, t.oldValue, t.newValue, t.baseVersion);
        }
      }, {
        key: "className",
        get: function get() {
          return "AttributeOperation";
        }
      }]);
      return Vc;
    }(Sc);
    var Uc = /*#__PURE__*/function (_Sc2) {
      _inherits(Uc, _Sc2);
      function Uc(t, e) {
        var _this71;
        _classCallCheck(this, Uc);
        _this71 = _possibleConstructorReturn(this, _getPrototypeOf(Uc).call(this, null)), _this71.sourcePosition = t.clone(), _this71.howMany = e;
        return _this71;
      }
      _createClass(Uc, [{
        key: "toJSON",
        value: function toJSON() {
          var t = _get(_getPrototypeOf(Uc.prototype), "toJSON", this).call(this);
          return t.sourcePosition = this.sourcePosition.toJSON(), t;
        }
      }, {
        key: "_validate",
        value: function _validate() {
          if (this.sourcePosition.root.document) throw new c.a("detach-operation-on-document-node", this);
        }
      }, {
        key: "_execute",
        value: function _execute() {
          Pc(wa._createFromPositionAndShift(this.sourcePosition, this.howMany));
        }
      }, {
        key: "type",
        get: function get() {
          return "detach";
        }
      }], [{
        key: "className",
        get: function get() {
          return "DetachOperation";
        }
      }]);
      return Uc;
    }(Sc);
    var Hc = /*#__PURE__*/function (_Sc3) {
      _inherits(Hc, _Sc3);
      function Hc(t, e, n, o) {
        var _this72;
        _classCallCheck(this, Hc);
        _this72 = _possibleConstructorReturn(this, _getPrototypeOf(Hc).call(this, o)), _this72.sourcePosition = t.clone(), _this72.sourcePosition.stickiness = "toNext", _this72.howMany = e, _this72.targetPosition = n.clone(), _this72.targetPosition.stickiness = "toNone";
        return _this72;
      }
      _createClass(Hc, [{
        key: "clone",
        value: function clone() {
          return new this.constructor(this.sourcePosition, this.howMany, this.targetPosition, this.baseVersion);
        }
      }, {
        key: "getMovedRangeStart",
        value: function getMovedRangeStart() {
          return this.targetPosition._getTransformedByDeletion(this.sourcePosition, this.howMany);
        }
      }, {
        key: "getReversed",
        value: function getReversed() {
          var t = this.sourcePosition._getTransformedByInsertion(this.targetPosition, this.howMany);
          return new this.constructor(this.getMovedRangeStart(), this.howMany, t, this.baseVersion + 1);
        }
      }, {
        key: "_validate",
        value: function _validate() {
          var t = this.sourcePosition.parent,
            e = this.targetPosition.parent,
            n = this.sourcePosition.offset,
            o = this.targetPosition.offset;
          if (n + this.howMany > t.maxOffset) throw new c.a("move-operation-nodes-do-not-exist", this);
          if (t === e && n < o && o < n + this.howMany) throw new c.a("move-operation-range-into-itself", this);
          if (this.sourcePosition.root == this.targetPosition.root && "prefix" == bo(this.sourcePosition.getParentPath(), this.targetPosition.getParentPath())) {
            var _t172 = this.sourcePosition.path.length - 1;
            if (this.targetPosition.path[_t172] >= n && this.targetPosition.path[_t172] < n + this.howMany) throw new c.a("move-operation-node-into-itself", this);
          }
        }
      }, {
        key: "_execute",
        value: function _execute() {
          zc(wa._createFromPositionAndShift(this.sourcePosition, this.howMany), this.targetPosition);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = _get(_getPrototypeOf(Hc.prototype), "toJSON", this).call(this);
          return t.sourcePosition = this.sourcePosition.toJSON(), t.targetPosition = this.targetPosition.toJSON(), t;
        }
      }, {
        key: "type",
        get: function get() {
          return "$graveyard" == this.targetPosition.root.rootName ? "remove" : "$graveyard" == this.sourcePosition.root.rootName ? "reinsert" : "move";
        }
      }], [{
        key: "fromJSON",
        value: function fromJSON(t, e) {
          var n = pa.fromJSON(t.sourcePosition, e),
            o = pa.fromJSON(t.targetPosition, e);
          return new this(n, t.howMany, o, t.baseVersion);
        }
      }, {
        key: "className",
        get: function get() {
          return "MoveOperation";
        }
      }]);
      return Hc;
    }(Sc);
    var Gc = /*#__PURE__*/function (_Sc4) {
      _inherits(Gc, _Sc4);
      function Gc(t, e, n) {
        var _this73;
        _classCallCheck(this, Gc);
        _this73 = _possibleConstructorReturn(this, _getPrototypeOf(Gc).call(this, n)), _this73.position = t.clone(), _this73.position.stickiness = "toNone", _this73.nodes = new ha(Lc(e)), _this73.shouldReceiveAttributes = !1;
        return _this73;
      }
      _createClass(Gc, [{
        key: "clone",
        value: function clone() {
          var t = new ha(_toConsumableArray(this.nodes).map(function (t) {
              return t._clone(!0);
            })),
            e = new Gc(this.position, t, this.baseVersion);
          return e.shouldReceiveAttributes = this.shouldReceiveAttributes, e;
        }
      }, {
        key: "getReversed",
        value: function getReversed() {
          var t = this.position.root.document.graveyard,
            e = new pa(t, [0]);
          return new Hc(this.position, this.nodes.maxOffset, e, this.baseVersion + 1);
        }
      }, {
        key: "_validate",
        value: function _validate() {
          var t = this.position.parent;
          if (!t || t.maxOffset < this.position.offset) throw new c.a("insert-operation-position-invalid", this);
        }
      }, {
        key: "_execute",
        value: function _execute() {
          var t = this.nodes;
          this.nodes = new ha(_toConsumableArray(t).map(function (t) {
            return t._clone(!0);
          })), Bc(this.position, t);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = _get(_getPrototypeOf(Gc.prototype), "toJSON", this).call(this);
          return t.position = this.position.toJSON(), t.nodes = this.nodes.toJSON(), t;
        }
      }, {
        key: "type",
        get: function get() {
          return "insert";
        }
      }, {
        key: "howMany",
        get: function get() {
          return this.nodes.maxOffset;
        }
      }], [{
        key: "fromJSON",
        value: function fromJSON(t, e) {
          var n = [];
          var _iterator230 = _createForOfIteratorHelper(t.nodes),
            _step230;
          try {
            for (_iterator230.s(); !(_step230 = _iterator230.n()).done;) {
              var _e170 = _step230.value;
              _e170.name ? n.push(ua.fromJSON(_e170)) : n.push(la.fromJSON(_e170));
            }
          } catch (err) {
            _iterator230.e(err);
          } finally {
            _iterator230.f();
          }
          var o = new Gc(pa.fromJSON(t.position, e), n, t.baseVersion);
          return o.shouldReceiveAttributes = t.shouldReceiveAttributes, o;
        }
      }, {
        key: "className",
        get: function get() {
          return "InsertOperation";
        }
      }]);
      return Gc;
    }(Sc);
    var Wc = /*#__PURE__*/function (_Sc5) {
      _inherits(Wc, _Sc5);
      function Wc(t, e, n, o, i, r) {
        var _this74;
        _classCallCheck(this, Wc);
        _this74 = _possibleConstructorReturn(this, _getPrototypeOf(Wc).call(this, r)), _this74.name = t, _this74.oldRange = e ? e.clone() : null, _this74.newRange = n ? n.clone() : null, _this74.affectsData = i, _this74._markers = o;
        return _this74;
      }
      _createClass(Wc, [{
        key: "clone",
        value: function clone() {
          return new Wc(this.name, this.oldRange, this.newRange, this._markers, this.affectsData, this.baseVersion);
        }
      }, {
        key: "getReversed",
        value: function getReversed() {
          return new Wc(this.name, this.newRange, this.oldRange, this._markers, this.affectsData, this.baseVersion + 1);
        }
      }, {
        key: "_execute",
        value: function _execute() {
          var t = this.newRange ? "_set" : "_remove";
          this._markers[t](this.name, this.newRange, !0, this.affectsData);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = _get(_getPrototypeOf(Wc.prototype), "toJSON", this).call(this);
          return this.oldRange && (t.oldRange = this.oldRange.toJSON()), this.newRange && (t.newRange = this.newRange.toJSON()), delete t._markers, t;
        }
      }, {
        key: "type",
        get: function get() {
          return "marker";
        }
      }], [{
        key: "fromJSON",
        value: function fromJSON(t, e) {
          return new Wc(t.name, t.oldRange ? wa.fromJSON(t.oldRange, e) : null, t.newRange ? wa.fromJSON(t.newRange, e) : null, e.model.markers, t.affectsData, t.baseVersion);
        }
      }, {
        key: "className",
        get: function get() {
          return "MarkerOperation";
        }
      }]);
      return Wc;
    }(Sc);
    var qc = /*#__PURE__*/function (_Sc6) {
      _inherits(qc, _Sc6);
      function qc(t, e, n, o) {
        var _this75;
        _classCallCheck(this, qc);
        _this75 = _possibleConstructorReturn(this, _getPrototypeOf(qc).call(this, o)), _this75.position = t, _this75.position.stickiness = "toNext", _this75.oldName = e, _this75.newName = n;
        return _this75;
      }
      _createClass(qc, [{
        key: "clone",
        value: function clone() {
          return new qc(this.position.clone(), this.oldName, this.newName, this.baseVersion);
        }
      }, {
        key: "getReversed",
        value: function getReversed() {
          return new qc(this.position.clone(), this.newName, this.oldName, this.baseVersion + 1);
        }
      }, {
        key: "_validate",
        value: function _validate() {
          var t = this.position.nodeAfter;
          if (!(t instanceof ua)) throw new c.a("rename-operation-wrong-position", this);
          if (t.name !== this.oldName) throw new c.a("rename-operation-wrong-name", this);
        }
      }, {
        key: "_execute",
        value: function _execute() {
          this.position.nodeAfter.name = this.newName;
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = _get(_getPrototypeOf(qc.prototype), "toJSON", this).call(this);
          return t.position = this.position.toJSON(), t;
        }
      }, {
        key: "type",
        get: function get() {
          return "rename";
        }
      }], [{
        key: "fromJSON",
        value: function fromJSON(t, e) {
          return new qc(pa.fromJSON(t.position, e), t.oldName, t.newName, t.baseVersion);
        }
      }, {
        key: "className",
        get: function get() {
          return "RenameOperation";
        }
      }]);
      return qc;
    }(Sc);
    var Kc = /*#__PURE__*/function (_Sc7) {
      _inherits(Kc, _Sc7);
      function Kc(t, e, n, o, i) {
        var _this76;
        _classCallCheck(this, Kc);
        _this76 = _possibleConstructorReturn(this, _getPrototypeOf(Kc).call(this, i)), _this76.root = t, _this76.key = e, _this76.oldValue = n, _this76.newValue = o;
        return _this76;
      }
      _createClass(Kc, [{
        key: "clone",
        value: function clone() {
          return new Kc(this.root, this.key, this.oldValue, this.newValue, this.baseVersion);
        }
      }, {
        key: "getReversed",
        value: function getReversed() {
          return new Kc(this.root, this.key, this.newValue, this.oldValue, this.baseVersion + 1);
        }
      }, {
        key: "_validate",
        value: function _validate() {
          if (this.root != this.root.root || this.root.is("documentFragment")) throw new c.a("rootattribute-operation-not-a-root", this, {
            root: this.root,
            key: this.key
          });
          if (null !== this.oldValue && this.root.getAttribute(this.key) !== this.oldValue) throw new c.a("rootattribute-operation-wrong-old-value", this, {
            root: this.root,
            key: this.key
          });
          if (null === this.oldValue && null !== this.newValue && this.root.hasAttribute(this.key)) throw new c.a("rootattribute-operation-attribute-exists", this, {
            root: this.root,
            key: this.key
          });
        }
      }, {
        key: "_execute",
        value: function _execute() {
          null !== this.newValue ? this.root._setAttribute(this.key, this.newValue) : this.root._removeAttribute(this.key);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = _get(_getPrototypeOf(Kc.prototype), "toJSON", this).call(this);
          return t.root = this.root.toJSON(), t;
        }
      }, {
        key: "type",
        get: function get() {
          return null === this.oldValue ? "addRootAttribute" : null === this.newValue ? "removeRootAttribute" : "changeRootAttribute";
        }
      }], [{
        key: "fromJSON",
        value: function fromJSON(t, e) {
          if (!e.getRoot(t.root)) throw new c.a("rootattribute-operation-fromjson-no-root", this, {
            rootName: t.root
          });
          return new Kc(e.getRoot(t.root), t.key, t.oldValue, t.newValue, t.baseVersion);
        }
      }, {
        key: "className",
        get: function get() {
          return "RootAttributeOperation";
        }
      }]);
      return Kc;
    }(Sc);
    var Yc = /*#__PURE__*/function (_Sc8) {
      _inherits(Yc, _Sc8);
      function Yc(t, e, n, o, i) {
        var _this77;
        _classCallCheck(this, Yc);
        _this77 = _possibleConstructorReturn(this, _getPrototypeOf(Yc).call(this, i)), _this77.sourcePosition = t.clone(), _this77.sourcePosition.stickiness = "toPrevious", _this77.howMany = e, _this77.targetPosition = n.clone(), _this77.targetPosition.stickiness = "toNext", _this77.graveyardPosition = o.clone();
        return _this77;
      }
      _createClass(Yc, [{
        key: "clone",
        value: function clone() {
          return new this.constructor(this.sourcePosition, this.howMany, this.targetPosition, this.graveyardPosition, this.baseVersion);
        }
      }, {
        key: "getReversed",
        value: function getReversed() {
          var t = this.targetPosition._getTransformedByMergeOperation(this),
            e = this.sourcePosition.path.slice(0, -1),
            n = new pa(this.sourcePosition.root, e)._getTransformedByMergeOperation(this);
          return new Qc(t, this.howMany, n, this.graveyardPosition, this.baseVersion + 1);
        }
      }, {
        key: "_validate",
        value: function _validate() {
          var t = this.sourcePosition.parent,
            e = this.targetPosition.parent;
          if (!t.parent) throw new c.a("merge-operation-source-position-invalid", this);
          if (!e.parent) throw new c.a("merge-operation-target-position-invalid", this);
          if (this.howMany != t.maxOffset) throw new c.a("merge-operation-how-many-invalid", this);
        }
      }, {
        key: "_execute",
        value: function _execute() {
          var t = this.sourcePosition.parent;
          zc(wa._createIn(t), this.targetPosition), zc(wa._createOn(t), this.graveyardPosition);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = _get(_getPrototypeOf(Yc.prototype), "toJSON", this).call(this);
          return t.sourcePosition = t.sourcePosition.toJSON(), t.targetPosition = t.targetPosition.toJSON(), t.graveyardPosition = t.graveyardPosition.toJSON(), t;
        }
      }, {
        key: "type",
        get: function get() {
          return "merge";
        }
      }, {
        key: "deletionPosition",
        get: function get() {
          return new pa(this.sourcePosition.root, this.sourcePosition.path.slice(0, -1));
        }
      }, {
        key: "movedRange",
        get: function get() {
          var t = this.sourcePosition.getShiftedBy(Number.POSITIVE_INFINITY);
          return new wa(this.sourcePosition, t);
        }
      }], [{
        key: "fromJSON",
        value: function fromJSON(t, e) {
          var n = pa.fromJSON(t.sourcePosition, e),
            o = pa.fromJSON(t.targetPosition, e),
            i = pa.fromJSON(t.graveyardPosition, e);
          return new this(n, t.howMany, o, i, t.baseVersion);
        }
      }, {
        key: "className",
        get: function get() {
          return "MergeOperation";
        }
      }]);
      return Yc;
    }(Sc);
    var Qc = /*#__PURE__*/function (_Sc9) {
      _inherits(Qc, _Sc9);
      function Qc(t, e, n, o, i) {
        var _this78;
        _classCallCheck(this, Qc);
        _this78 = _possibleConstructorReturn(this, _getPrototypeOf(Qc).call(this, i)), _this78.splitPosition = t.clone(), _this78.splitPosition.stickiness = "toNext", _this78.howMany = e, _this78.insertionPosition = n, _this78.graveyardPosition = o ? o.clone() : null, _this78.graveyardPosition && (_this78.graveyardPosition.stickiness = "toNext");
        return _this78;
      }
      _createClass(Qc, [{
        key: "clone",
        value: function clone() {
          return new this.constructor(this.splitPosition, this.howMany, this.insertionPosition, this.graveyardPosition, this.baseVersion);
        }
      }, {
        key: "getReversed",
        value: function getReversed() {
          var t = this.splitPosition.root.document.graveyard,
            e = new pa(t, [0]);
          return new Yc(this.moveTargetPosition, this.howMany, this.splitPosition, e, this.baseVersion + 1);
        }
      }, {
        key: "_validate",
        value: function _validate() {
          var t = this.splitPosition.parent,
            e = this.splitPosition.offset;
          if (!t || t.maxOffset < e) throw new c.a("split-operation-position-invalid", this);
          if (!t.parent) throw new c.a("split-operation-split-in-root", this);
          if (this.howMany != t.maxOffset - this.splitPosition.offset) throw new c.a("split-operation-how-many-invalid", this);
          if (this.graveyardPosition && !this.graveyardPosition.nodeAfter) throw new c.a("split-operation-graveyard-position-invalid", this);
        }
      }, {
        key: "_execute",
        value: function _execute() {
          var t = this.splitPosition.parent;
          if (this.graveyardPosition) zc(wa._createFromPositionAndShift(this.graveyardPosition, 1), this.insertionPosition);else {
            var _e171 = t._clone();
            Bc(this.insertionPosition, _e171);
          }
          zc(new wa(pa._createAt(t, this.splitPosition.offset), pa._createAt(t, t.maxOffset)), this.moveTargetPosition);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = _get(_getPrototypeOf(Qc.prototype), "toJSON", this).call(this);
          return t.splitPosition = this.splitPosition.toJSON(), t.insertionPosition = this.insertionPosition.toJSON(), this.graveyardPosition && (t.graveyardPosition = this.graveyardPosition.toJSON()), t;
        }
      }, {
        key: "type",
        get: function get() {
          return "split";
        }
      }, {
        key: "moveTargetPosition",
        get: function get() {
          var t = this.insertionPosition.path.slice();
          return t.push(0), new pa(this.insertionPosition.root, t);
        }
      }, {
        key: "movedRange",
        get: function get() {
          var t = this.splitPosition.getShiftedBy(Number.POSITIVE_INFINITY);
          return new wa(this.splitPosition, t);
        }
      }], [{
        key: "getInsertionPosition",
        value: function getInsertionPosition(t) {
          var e = t.path.slice(0, -1);
          return e[e.length - 1]++, new pa(t.root, e, "toPrevious");
        }
      }, {
        key: "fromJSON",
        value: function fromJSON(t, e) {
          var n = pa.fromJSON(t.splitPosition, e),
            o = pa.fromJSON(t.insertionPosition, e),
            i = t.graveyardPosition ? pa.fromJSON(t.graveyardPosition, e) : null;
          return new this(n, t.howMany, o, i, t.baseVersion);
        }
      }, {
        key: "className",
        get: function get() {
          return "SplitOperation";
        }
      }]);
      return Qc;
    }(Sc);
    var $c = /*#__PURE__*/function (_ua) {
      _inherits($c, _ua);
      function $c(t, e) {
        var _this79;
        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "main";
        _classCallCheck(this, $c);
        _this79 = _possibleConstructorReturn(this, _getPrototypeOf($c).call(this, e)), _this79._document = t, _this79.rootName = n;
        return _this79;
      }
      _createClass($c, [{
        key: "is",
        value: function is(t, e) {
          return e ? e === this.name && ("rootElement" === t || "model:rootElement" === t || "element" === t || "model:element" === t) : "rootElement" === t || "model:rootElement" === t || "element" === t || "model:element" === t || "node" === t || "model:node" === t;
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          return this.rootName;
        }
      }, {
        key: "document",
        get: function get() {
          return this._document;
        }
      }]);
      return $c;
    }(ua);
    var Jc = /*#__PURE__*/function () {
      function Jc(t, e) {
        _classCallCheck(this, Jc);
        this.model = t, this.batch = e;
      }
      _createClass(Jc, [{
        key: "createText",
        value: function createText(t, e) {
          return new la(t, e);
        }
      }, {
        key: "createElement",
        value: function createElement(t, e) {
          return new ua(t, e);
        }
      }, {
        key: "createDocumentFragment",
        value: function createDocumentFragment() {
          return new Nc();
        }
      }, {
        key: "cloneElement",
        value: function cloneElement(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
          return t._clone(e);
        }
      }, {
        key: "insert",
        value: function insert(t, e) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
          if (this._assertWriterUsedCorrectly(), t instanceof la && "" == t.data) return;
          var o = pa._createAt(e, n);
          if (t.parent) {
            if (nl(t.root, o.root)) return void this.move(wa._createOn(t), o);
            if (t.root.document) throw new c.a("model-writer-insert-forbidden-move", this);
            this.remove(t);
          }
          var i = o.root.document ? o.root.document.version : null,
            r = new Gc(o, t, i);
          if (t instanceof la && (r.shouldReceiveAttributes = !0), this.batch.addOperation(r), this.model.applyOperation(r), t instanceof Nc) {
            var _iterator231 = _createForOfIteratorHelper(t.markers),
              _step231;
            try {
              for (_iterator231.s(); !(_step231 = _iterator231.n()).done;) {
                var _step231$value = _slicedToArray(_step231.value, 2),
                  _e172 = _step231$value[0],
                  _n159 = _step231$value[1];
                var _t173 = pa._createAt(_n159.root, 0),
                  _i79 = {
                    range: new wa(_n159.start._getCombined(_t173, o), _n159.end._getCombined(_t173, o)),
                    usingOperation: !0,
                    affectsData: !0
                  };
                this.model.markers.has(_e172) ? this.updateMarker(_e172, _i79) : this.addMarker(_e172, _i79);
              }
            } catch (err) {
              _iterator231.e(err);
            } finally {
              _iterator231.f();
            }
          }
        }
      }, {
        key: "insertText",
        value: function insertText(t, e, n, o) {
          e instanceof Nc || e instanceof ua || e instanceof pa ? this.insert(this.createText(t), e, n) : this.insert(this.createText(t, e), n, o);
        }
      }, {
        key: "insertElement",
        value: function insertElement(t, e, n, o) {
          e instanceof Nc || e instanceof ua || e instanceof pa ? this.insert(this.createElement(t), e, n) : this.insert(this.createElement(t, e), n, o);
        }
      }, {
        key: "append",
        value: function append(t, e) {
          this.insert(t, e, "end");
        }
      }, {
        key: "appendText",
        value: function appendText(t, e, n) {
          e instanceof Nc || e instanceof ua ? this.insert(this.createText(t), e, "end") : this.insert(this.createText(t, e), n, "end");
        }
      }, {
        key: "appendElement",
        value: function appendElement(t, e, n) {
          e instanceof Nc || e instanceof ua ? this.insert(this.createElement(t), e, "end") : this.insert(this.createElement(t, e), n, "end");
        }
      }, {
        key: "setAttribute",
        value: function setAttribute(t, e, n) {
          if (this._assertWriterUsedCorrectly(), n instanceof wa) {
            var _o90 = n.getMinimalFlatRanges();
            var _iterator232 = _createForOfIteratorHelper(_o90),
              _step232;
            try {
              for (_iterator232.s(); !(_step232 = _iterator232.n()).done;) {
                var _n160 = _step232.value;
                Zc(this, t, e, _n160);
              }
            } catch (err) {
              _iterator232.e(err);
            } finally {
              _iterator232.f();
            }
          } else Xc(this, t, e, n);
        }
      }, {
        key: "setAttributes",
        value: function setAttributes(t, e) {
          var _iterator233 = _createForOfIteratorHelper(vo(t)),
            _step233;
          try {
            for (_iterator233.s(); !(_step233 = _iterator233.n()).done;) {
              var _step233$value = _slicedToArray(_step233.value, 2),
                _n161 = _step233$value[0],
                _o91 = _step233$value[1];
              this.setAttribute(_n161, _o91, e);
            }
          } catch (err) {
            _iterator233.e(err);
          } finally {
            _iterator233.f();
          }
        }
      }, {
        key: "removeAttribute",
        value: function removeAttribute(t, e) {
          if (this._assertWriterUsedCorrectly(), e instanceof wa) {
            var _n162 = e.getMinimalFlatRanges();
            var _iterator234 = _createForOfIteratorHelper(_n162),
              _step234;
            try {
              for (_iterator234.s(); !(_step234 = _iterator234.n()).done;) {
                var _e173 = _step234.value;
                Zc(this, t, null, _e173);
              }
            } catch (err) {
              _iterator234.e(err);
            } finally {
              _iterator234.f();
            }
          } else Xc(this, t, null, e);
        }
      }, {
        key: "clearAttributes",
        value: function clearAttributes(t) {
          var _this80 = this;
          this._assertWriterUsedCorrectly();
          var e = function e(t) {
            var _iterator235 = _createForOfIteratorHelper(t.getAttributeKeys()),
              _step235;
            try {
              for (_iterator235.s(); !(_step235 = _iterator235.n()).done;) {
                var _e174 = _step235.value;
                _this80.removeAttribute(_e174, t);
              }
            } catch (err) {
              _iterator235.e(err);
            } finally {
              _iterator235.f();
            }
          };
          if (t instanceof wa) {
            var _iterator236 = _createForOfIteratorHelper(t.getItems()),
              _step236;
            try {
              for (_iterator236.s(); !(_step236 = _iterator236.n()).done;) {
                var _n163 = _step236.value;
                e(_n163);
              }
            } catch (err) {
              _iterator236.e(err);
            } finally {
              _iterator236.f();
            }
          } else e(t);
        }
      }, {
        key: "move",
        value: function move(t, e, n) {
          if (this._assertWriterUsedCorrectly(), !(t instanceof wa)) throw new c.a("writer-move-invalid-range", this);
          if (!t.isFlat) throw new c.a("writer-move-range-not-flat", this);
          var o = pa._createAt(e, n);
          if (o.isEqual(t.start)) return;
          if (this._addOperationForAffectedMarkers("move", t), !nl(t.root, o.root)) throw new c.a("writer-move-different-document", this);
          var i = t.root.document ? t.root.document.version : null,
            r = new Hc(t.start, t.end.offset - t.start.offset, o, i);
          this.batch.addOperation(r), this.model.applyOperation(r);
        }
      }, {
        key: "remove",
        value: function remove(t) {
          this._assertWriterUsedCorrectly();
          var e = (t instanceof wa ? t : wa._createOn(t)).getMinimalFlatRanges().reverse();
          var _iterator237 = _createForOfIteratorHelper(e),
            _step237;
          try {
            for (_iterator237.s(); !(_step237 = _iterator237.n()).done;) {
              var _t174 = _step237.value;
              this._addOperationForAffectedMarkers("move", _t174), el(_t174.start, _t174.end.offset - _t174.start.offset, this.batch, this.model);
            }
          } catch (err) {
            _iterator237.e(err);
          } finally {
            _iterator237.f();
          }
        }
      }, {
        key: "merge",
        value: function merge(t) {
          this._assertWriterUsedCorrectly();
          var e = t.nodeBefore,
            n = t.nodeAfter;
          if (this._addOperationForAffectedMarkers("merge", t), !(e instanceof ua)) throw new c.a("writer-merge-no-element-before", this);
          if (!(n instanceof ua)) throw new c.a("writer-merge-no-element-after", this);
          t.root.document ? this._merge(t) : this._mergeDetached(t);
        }
      }, {
        key: "createPositionFromPath",
        value: function createPositionFromPath(t, e, n) {
          return this.model.createPositionFromPath(t, e, n);
        }
      }, {
        key: "createPositionAt",
        value: function createPositionAt(t, e) {
          return this.model.createPositionAt(t, e);
        }
      }, {
        key: "createPositionAfter",
        value: function createPositionAfter(t) {
          return this.model.createPositionAfter(t);
        }
      }, {
        key: "createPositionBefore",
        value: function createPositionBefore(t) {
          return this.model.createPositionBefore(t);
        }
      }, {
        key: "createRange",
        value: function createRange(t, e) {
          return this.model.createRange(t, e);
        }
      }, {
        key: "createRangeIn",
        value: function createRangeIn(t) {
          return this.model.createRangeIn(t);
        }
      }, {
        key: "createRangeOn",
        value: function createRangeOn(t) {
          return this.model.createRangeOn(t);
        }
      }, {
        key: "createSelection",
        value: function createSelection(t, e, n) {
          return this.model.createSelection(t, e, n);
        }
      }, {
        key: "_mergeDetached",
        value: function _mergeDetached(t) {
          var e = t.nodeBefore,
            n = t.nodeAfter;
          this.move(wa._createIn(n), pa._createAt(e, "end")), this.remove(n);
        }
      }, {
        key: "_merge",
        value: function _merge(t) {
          var e = pa._createAt(t.nodeBefore, "end"),
            n = pa._createAt(t.nodeAfter, 0),
            o = t.root.document.graveyard,
            i = new pa(o, [0]),
            r = t.root.document.version,
            s = new Yc(n, t.nodeAfter.maxOffset, e, i, r);
          this.batch.addOperation(s), this.model.applyOperation(s);
        }
      }, {
        key: "rename",
        value: function rename(t, e) {
          if (this._assertWriterUsedCorrectly(), !(t instanceof ua)) throw new c.a("writer-rename-not-element-instance", this);
          var n = t.root.document ? t.root.document.version : null,
            o = new qc(pa._createBefore(t), t.name, e, n);
          this.batch.addOperation(o), this.model.applyOperation(o);
        }
      }, {
        key: "split",
        value: function split(t, e) {
          this._assertWriterUsedCorrectly();
          var n,
            o,
            i = t.parent;
          if (!i.parent) throw new c.a("writer-split-element-no-parent", this);
          if (e || (e = i.parent), !t.parent.getAncestors({
            includeSelf: !0
          }).includes(e)) throw new c.a("writer-split-invalid-limit-element", this);
          do {
            var _e175 = i.root.document ? i.root.document.version : null,
              _r24 = i.maxOffset - t.offset,
              _s17 = Qc.getInsertionPosition(t),
              _a9 = new Qc(t, _r24, _s17, null, _e175);
            this.batch.addOperation(_a9), this.model.applyOperation(_a9), n || o || (n = i, o = t.parent.nextSibling), i = (t = this.createPositionAfter(t.parent)).parent;
          } while (i !== e);
          return {
            position: t,
            range: new wa(pa._createAt(n, "end"), pa._createAt(o, 0))
          };
        }
      }, {
        key: "wrap",
        value: function wrap(t, e) {
          if (this._assertWriterUsedCorrectly(), !t.isFlat) throw new c.a("writer-wrap-range-not-flat", this);
          var n = e instanceof ua ? e : new ua(e);
          if (n.childCount > 0) throw new c.a("writer-wrap-element-not-empty", this);
          if (null !== n.parent) throw new c.a("writer-wrap-element-attached", this);
          this.insert(n, t.start);
          var o = new wa(t.start.getShiftedBy(1), t.end.getShiftedBy(1));
          this.move(o, pa._createAt(n, 0));
        }
      }, {
        key: "unwrap",
        value: function unwrap(t) {
          if (this._assertWriterUsedCorrectly(), null === t.parent) throw new c.a("writer-unwrap-element-no-parent", this);
          this.move(wa._createIn(t), this.createPositionAfter(t)), this.remove(t);
        }
      }, {
        key: "addMarker",
        value: function addMarker(t, e) {
          if (this._assertWriterUsedCorrectly(), !e || "boolean" != typeof e.usingOperation) throw new c.a("writer-addmarker-no-usingoperation", this);
          var n = e.usingOperation,
            o = e.range,
            i = void 0 !== e.affectsData && e.affectsData;
          if (this.model.markers.has(t)) throw new c.a("writer-addmarker-marker-exists", this);
          if (!o) throw new c.a("writer-addmarker-no-range", this);
          return n ? (tl(this, t, null, o, i), this.model.markers.get(t)) : this.model.markers._set(t, o, n, i);
        }
      }, {
        key: "updateMarker",
        value: function updateMarker(t, e) {
          this._assertWriterUsedCorrectly();
          var n = "string" == typeof t ? t : t.name,
            o = this.model.markers.get(n);
          if (!o) throw new c.a("writer-updatemarker-marker-not-exists", this);
          if (!e) return void this.model.markers._refresh(o);
          var i = "boolean" == typeof e.usingOperation,
            r = "boolean" == typeof e.affectsData,
            s = r ? e.affectsData : o.affectsData;
          if (!i && !e.range && !r) throw new c.a("writer-updatemarker-wrong-options", this);
          var a = o.getRange(),
            l = e.range ? e.range : a;
          i && e.usingOperation !== o.managedUsingOperations ? e.usingOperation ? tl(this, n, null, l, s) : (tl(this, n, a, null, s), this.model.markers._set(n, l, void 0, s)) : o.managedUsingOperations ? tl(this, n, a, l, s) : this.model.markers._set(n, l, void 0, s);
        }
      }, {
        key: "removeMarker",
        value: function removeMarker(t) {
          this._assertWriterUsedCorrectly();
          var e = "string" == typeof t ? t : t.name;
          if (!this.model.markers.has(e)) throw new c.a("writer-removemarker-no-marker", this);
          var n = this.model.markers.get(e);
          if (!n.managedUsingOperations) return void this.model.markers._remove(e);
          tl(this, e, n.getRange(), null, n.affectsData);
        }
      }, {
        key: "setSelection",
        value: function setSelection(t, e, n) {
          this._assertWriterUsedCorrectly(), this.model.document.selection._setTo(t, e, n);
        }
      }, {
        key: "setSelectionFocus",
        value: function setSelectionFocus(t, e) {
          this._assertWriterUsedCorrectly(), this.model.document.selection._setFocus(t, e);
        }
      }, {
        key: "setSelectionAttribute",
        value: function setSelectionAttribute(t, e) {
          if (this._assertWriterUsedCorrectly(), "string" == typeof t) this._setSelectionAttribute(t, e);else {
            var _iterator238 = _createForOfIteratorHelper(vo(t)),
              _step238;
            try {
              for (_iterator238.s(); !(_step238 = _iterator238.n()).done;) {
                var _step238$value = _slicedToArray(_step238.value, 2),
                  _e176 = _step238$value[0],
                  _n164 = _step238$value[1];
                this._setSelectionAttribute(_e176, _n164);
              }
            } catch (err) {
              _iterator238.e(err);
            } finally {
              _iterator238.f();
            }
          }
        }
      }, {
        key: "removeSelectionAttribute",
        value: function removeSelectionAttribute(t) {
          if (this._assertWriterUsedCorrectly(), "string" == typeof t) this._removeSelectionAttribute(t);else {
            var _iterator239 = _createForOfIteratorHelper(t),
              _step239;
            try {
              for (_iterator239.s(); !(_step239 = _iterator239.n()).done;) {
                var _e177 = _step239.value;
                this._removeSelectionAttribute(_e177);
              }
            } catch (err) {
              _iterator239.e(err);
            } finally {
              _iterator239.f();
            }
          }
        }
      }, {
        key: "overrideSelectionGravity",
        value: function overrideSelectionGravity() {
          return this.model.document.selection._overrideGravity();
        }
      }, {
        key: "restoreSelectionGravity",
        value: function restoreSelectionGravity(t) {
          this.model.document.selection._restoreGravity(t);
        }
      }, {
        key: "_setSelectionAttribute",
        value: function _setSelectionAttribute(t, e) {
          var n = this.model.document.selection;
          if (n.isCollapsed && n.anchor.parent.isEmpty) {
            var _o92 = La._getStoreAttributeKey(t);
            this.setAttribute(_o92, e, n.anchor.parent);
          }
          n._setAttribute(t, e);
        }
      }, {
        key: "_removeSelectionAttribute",
        value: function _removeSelectionAttribute(t) {
          var e = this.model.document.selection;
          if (e.isCollapsed && e.anchor.parent.isEmpty) {
            var _n165 = La._getStoreAttributeKey(t);
            this.removeAttribute(_n165, e.anchor.parent);
          }
          e._removeAttribute(t);
        }
      }, {
        key: "_assertWriterUsedCorrectly",
        value: function _assertWriterUsedCorrectly() {
          if (this.model._currentWriter !== this) throw new c.a("writer-incorrect-use", this);
        }
      }, {
        key: "_addOperationForAffectedMarkers",
        value: function _addOperationForAffectedMarkers(t, e) {
          var _iterator240 = _createForOfIteratorHelper(this.model.markers),
            _step240;
          try {
            for (_iterator240.s(); !(_step240 = _iterator240.n()).done;) {
              var _n166 = _step240.value;
              if (!_n166.managedUsingOperations) continue;
              var _o93 = _n166.getRange();
              var _i80 = !1;
              if ("move" === t) _i80 = e.containsPosition(_o93.start) || e.start.isEqual(_o93.start) || e.containsPosition(_o93.end) || e.end.isEqual(_o93.end);else {
                var _t175 = e.nodeBefore,
                  _n167 = e.nodeAfter,
                  _r25 = _o93.start.parent == _t175 && _o93.start.isAtEnd,
                  _s18 = _o93.end.parent == _n167 && 0 == _o93.end.offset,
                  _a10 = _o93.end.nodeAfter == _n167,
                  _c4 = _o93.start.nodeAfter == _n167;
                _i80 = _r25 || _s18 || _a10 || _c4;
              }
              _i80 && this.updateMarker(_n166.name, {
                range: _o93
              });
            }
          } catch (err) {
            _iterator240.e(err);
          } finally {
            _iterator240.f();
          }
        }
      }]);
      return Jc;
    }();
    function Zc(t, e, n, o) {
      var i = t.model,
        r = i.document;
      var s,
        a,
        c,
        l = o.start;
      var _iterator241 = _createForOfIteratorHelper(o.getWalker({
          shallow: !0
        })),
        _step241;
      try {
        for (_iterator241.s(); !(_step241 = _iterator241.n()).done;) {
          var _t176 = _step241.value;
          c = _t176.item.getAttribute(e), s && a != c && (a != n && d(), l = s), s = _t176.nextPosition, a = c;
        }
      } catch (err) {
        _iterator241.e(err);
      } finally {
        _iterator241.f();
      }
      function d() {
        var o = new wa(l, s),
          c = o.root.document ? r.version : null,
          d = new Vc(o, e, a, n, c);
        t.batch.addOperation(d), i.applyOperation(d);
      }
      s instanceof pa && s != l && a != n && d();
    }
    function Xc(t, e, n, o) {
      var i = t.model,
        r = i.document,
        s = o.getAttribute(e);
      var a, c;
      if (s != n) {
        if (o.root === o) {
          var _t177 = o.document ? r.version : null;
          c = new Kc(o, e, s, n, _t177);
        } else {
          a = new wa(pa._createBefore(o), t.createPositionAfter(o));
          var _i81 = a.root.document ? r.version : null;
          c = new Vc(a, e, s, n, _i81);
        }
        t.batch.addOperation(c), i.applyOperation(c);
      }
    }
    function tl(t, e, n, o, i) {
      var r = t.model,
        s = r.document,
        a = new Wc(e, n, o, r.markers, i, s.version);
      t.batch.addOperation(a), r.applyOperation(a);
    }
    function el(t, e, n, o) {
      var i;
      if (t.root.document) {
        var _n168 = o.document,
          _r26 = new pa(_n168.graveyard, [0]);
        i = new Hc(t, e, _r26, _n168.version);
      } else i = new Uc(t, e);
      n.addOperation(i), o.applyOperation(i);
    }
    function nl(t, e) {
      return t === e || t instanceof $c && e instanceof $c;
    }
    var ol = /*#__PURE__*/function () {
      function ol(t) {
        _classCallCheck(this, ol);
        this._markerCollection = t, this._changesInElement = new Map(), this._elementSnapshots = new Map(), this._changedMarkers = new Map(), this._changeCount = 0, this._cachedChanges = null, this._cachedChangesWithGraveyard = null;
      }
      _createClass(ol, [{
        key: "refreshItem",
        value: function refreshItem(t) {
          if (this._isInInsertedElement(t.parent)) return;
          this._markRemove(t.parent, t.startOffset, t.offsetSize), this._markInsert(t.parent, t.startOffset, t.offsetSize);
          var e = wa._createOn(t);
          var _iterator242 = _createForOfIteratorHelper(this._markerCollection.getMarkersIntersectingRange(e)),
            _step242;
          try {
            for (_iterator242.s(); !(_step242 = _iterator242.n()).done;) {
              var _t178 = _step242.value;
              var _e178 = _t178.getRange();
              this.bufferMarkerChange(_t178.name, _e178, _e178, _t178.affectsData);
            }
          } catch (err) {
            _iterator242.e(err);
          } finally {
            _iterator242.f();
          }
          this._cachedChanges = null;
        }
      }, {
        key: "bufferOperation",
        value: function bufferOperation(t) {
          switch (t.type) {
            case "insert":
              if (this._isInInsertedElement(t.position.parent)) return;
              this._markInsert(t.position.parent, t.position.offset, t.nodes.maxOffset);
              break;
            case "addAttribute":
            case "removeAttribute":
            case "changeAttribute":
              var _iterator243 = _createForOfIteratorHelper(t.range.getItems({
                  shallow: !0
                })),
                _step243;
              try {
                for (_iterator243.s(); !(_step243 = _iterator243.n()).done;) {
                  var _e179 = _step243.value;
                  this._isInInsertedElement(_e179.parent) || this._markAttribute(_e179);
                }
              } catch (err) {
                _iterator243.e(err);
              } finally {
                _iterator243.f();
              }
              break;
            case "remove":
            case "move":
            case "reinsert":
              {
                if (t.sourcePosition.isEqual(t.targetPosition) || t.sourcePosition.getShiftedBy(t.howMany).isEqual(t.targetPosition)) return;
                var _e180 = this._isInInsertedElement(t.sourcePosition.parent),
                  _n169 = this._isInInsertedElement(t.targetPosition.parent);
                _e180 || this._markRemove(t.sourcePosition.parent, t.sourcePosition.offset, t.howMany), _n169 || this._markInsert(t.targetPosition.parent, t.getMovedRangeStart().offset, t.howMany);
                break;
              }
            case "rename":
              {
                if (this._isInInsertedElement(t.position.parent)) return;
                this._markRemove(t.position.parent, t.position.offset, 1), this._markInsert(t.position.parent, t.position.offset, 1);
                var _e181 = wa._createFromPositionAndShift(t.position, 1);
                var _iterator244 = _createForOfIteratorHelper(this._markerCollection.getMarkersIntersectingRange(_e181)),
                  _step244;
                try {
                  for (_iterator244.s(); !(_step244 = _iterator244.n()).done;) {
                    var _t179 = _step244.value;
                    var _e182 = _t179.getRange();
                    this.bufferMarkerChange(_t179.name, _e182, _e182, _t179.affectsData);
                  }
                } catch (err) {
                  _iterator244.e(err);
                } finally {
                  _iterator244.f();
                }
                break;
              }
            case "split":
              {
                var _e183 = t.splitPosition.parent;
                this._isInInsertedElement(_e183) || this._markRemove(_e183, t.splitPosition.offset, t.howMany), this._isInInsertedElement(t.insertionPosition.parent) || this._markInsert(t.insertionPosition.parent, t.insertionPosition.offset, 1), t.graveyardPosition && this._markRemove(t.graveyardPosition.parent, t.graveyardPosition.offset, 1);
                break;
              }
            case "merge":
              {
                var _e184 = t.sourcePosition.parent;
                this._isInInsertedElement(_e184.parent) || this._markRemove(_e184.parent, _e184.startOffset, 1);
                var _n170 = t.graveyardPosition.parent;
                this._markInsert(_n170, t.graveyardPosition.offset, 1);
                var _o94 = t.targetPosition.parent;
                this._isInInsertedElement(_o94) || this._markInsert(_o94, t.targetPosition.offset, _e184.maxOffset);
                break;
              }
          }
          this._cachedChanges = null;
        }
      }, {
        key: "bufferMarkerChange",
        value: function bufferMarkerChange(t, e, n, o) {
          var i = this._changedMarkers.get(t);
          i ? (i.newRange = n, i.affectsData = o, null == i.oldRange && null == i.newRange && this._changedMarkers.delete(t)) : this._changedMarkers.set(t, {
            oldRange: e,
            newRange: n,
            affectsData: o
          });
        }
      }, {
        key: "getMarkersToRemove",
        value: function getMarkersToRemove() {
          var t = [];
          var _iterator245 = _createForOfIteratorHelper(this._changedMarkers),
            _step245;
          try {
            for (_iterator245.s(); !(_step245 = _iterator245.n()).done;) {
              var _step245$value = _slicedToArray(_step245.value, 2),
                _e185 = _step245$value[0],
                _n171 = _step245$value[1];
              null != _n171.oldRange && t.push({
                name: _e185,
                range: _n171.oldRange
              });
            }
          } catch (err) {
            _iterator245.e(err);
          } finally {
            _iterator245.f();
          }
          return t;
        }
      }, {
        key: "getMarkersToAdd",
        value: function getMarkersToAdd() {
          var t = [];
          var _iterator246 = _createForOfIteratorHelper(this._changedMarkers),
            _step246;
          try {
            for (_iterator246.s(); !(_step246 = _iterator246.n()).done;) {
              var _step246$value = _slicedToArray(_step246.value, 2),
                _e186 = _step246$value[0],
                _n172 = _step246$value[1];
              null != _n172.newRange && t.push({
                name: _e186,
                range: _n172.newRange
              });
            }
          } catch (err) {
            _iterator246.e(err);
          } finally {
            _iterator246.f();
          }
          return t;
        }
      }, {
        key: "getChangedMarkers",
        value: function getChangedMarkers() {
          return Array.from(this._changedMarkers).map(function (t) {
            return {
              name: t[0],
              data: {
                oldRange: t[1].oldRange,
                newRange: t[1].newRange
              }
            };
          });
        }
      }, {
        key: "hasDataChanges",
        value: function hasDataChanges() {
          var _iterator247 = _createForOfIteratorHelper(this._changedMarkers),
            _step247;
          try {
            for (_iterator247.s(); !(_step247 = _iterator247.n()).done;) {
              var _step247$value = _slicedToArray(_step247.value, 2),
                _t180 = _step247$value[1];
              if (_t180.affectsData) return !0;
            }
          } catch (err) {
            _iterator247.e(err);
          } finally {
            _iterator247.f();
          }
          return this._changesInElement.size > 0;
        }
      }, {
        key: "getChanges",
        value: function getChanges() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            includeChangesInGraveyard: !1
          };
          if (this._cachedChanges) return t.includeChangesInGraveyard ? this._cachedChangesWithGraveyard.slice() : this._cachedChanges.slice();
          var e = [];
          var _iterator248 = _createForOfIteratorHelper(this._changesInElement.keys()),
            _step248;
          try {
            for (_iterator248.s(); !(_step248 = _iterator248.n()).done;) {
              var _t183 = _step248.value;
              var _n175 = this._changesInElement.get(_t183).sort(function (t, e) {
                  return t.offset === e.offset ? t.type != e.type ? "remove" == t.type ? -1 : 1 : 0 : t.offset < e.offset ? -1 : 1;
                }),
                _o96 = this._elementSnapshots.get(_t183),
                _i83 = il(_t183.getChildren()),
                _r28 = rl(_o96.length, _n175);
              var _s20 = 0,
                _a12 = 0;
              var _iterator250 = _createForOfIteratorHelper(_r28),
                _step250;
              try {
                for (_iterator250.s(); !(_step250 = _iterator250.n()).done;) {
                  var _n176 = _step250.value;
                  if ("i" === _n176) e.push(this._getInsertDiff(_t183, _s20, _i83[_s20].name)), _s20++;else if ("r" === _n176) e.push(this._getRemoveDiff(_t183, _s20, _o96[_a12].name)), _a12++;else if ("a" === _n176) {
                    var _e188;
                    var _n177 = _i83[_s20].attributes,
                      _r29 = _o96[_a12].attributes;
                    var _c5 = void 0;
                    if ("$text" == _i83[_s20].name) _c5 = new wa(pa._createAt(_t183, _s20), pa._createAt(_t183, _s20 + 1));else {
                      var _e187 = _t183.offsetToIndex(_s20);
                      _c5 = new wa(pa._createAt(_t183, _s20), pa._createAt(_t183.getChild(_e187), 0));
                    }
                    (_e188 = e).push.apply(_e188, _toConsumableArray(this._getAttributesDiff(_c5, _r29, _n177))), _s20++, _a12++;
                  } else _s20++, _a12++;
                }
              } catch (err) {
                _iterator250.e(err);
              } finally {
                _iterator250.f();
              }
            }
          } catch (err) {
            _iterator248.e(err);
          } finally {
            _iterator248.f();
          }
          e.sort(function (t, e) {
            return t.position.root != e.position.root ? t.position.root.rootName < e.position.root.rootName ? -1 : 1 : t.position.isEqual(e.position) ? t.changeCount - e.changeCount : t.position.isBefore(e.position) ? -1 : 1;
          });
          for (var _t182 = 1, _n174 = 0; _t182 < e.length; _t182++) {
            var _o95 = e[_n174],
              _i82 = e[_t182],
              _r27 = "remove" == _o95.type && "remove" == _i82.type && "$text" == _o95.name && "$text" == _i82.name && _o95.position.isEqual(_i82.position),
              _s19 = "insert" == _o95.type && "insert" == _i82.type && "$text" == _o95.name && "$text" == _i82.name && _o95.position.parent == _i82.position.parent && _o95.position.offset + _o95.length == _i82.position.offset,
              _a11 = "attribute" == _o95.type && "attribute" == _i82.type && _o95.position.parent == _i82.position.parent && _o95.range.isFlat && _i82.range.isFlat && _o95.position.offset + _o95.length == _i82.position.offset && _o95.attributeKey == _i82.attributeKey && _o95.attributeOldValue == _i82.attributeOldValue && _o95.attributeNewValue == _i82.attributeNewValue;
            _r27 || _s19 || _a11 ? (_o95.length++, _a11 && (_o95.range.end = _o95.range.end.getShiftedBy(1)), e[_t182] = null) : _n174 = _t182;
          }
          e = e.filter(function (t) {
            return t;
          });
          var _iterator249 = _createForOfIteratorHelper(e),
            _step249;
          try {
            for (_iterator249.s(); !(_step249 = _iterator249.n()).done;) {
              var _t184 = _step249.value;
              delete _t184.changeCount, "attribute" == _t184.type && (delete _t184.position, delete _t184.length);
            }
          } catch (err) {
            _iterator249.e(err);
          } finally {
            _iterator249.f();
          }
          return this._changeCount = 0, this._cachedChangesWithGraveyard = e.slice(), this._cachedChanges = e.filter(sl), t.includeChangesInGraveyard ? this._cachedChangesWithGraveyard : this._cachedChanges;
        }
      }, {
        key: "reset",
        value: function reset() {
          this._changesInElement.clear(), this._elementSnapshots.clear(), this._changedMarkers.clear(), this._cachedChanges = null;
        }
      }, {
        key: "_markInsert",
        value: function _markInsert(t, e, n) {
          var o = {
            type: "insert",
            offset: e,
            howMany: n,
            count: this._changeCount++
          };
          this._markChange(t, o);
        }
      }, {
        key: "_markRemove",
        value: function _markRemove(t, e, n) {
          var o = {
            type: "remove",
            offset: e,
            howMany: n,
            count: this._changeCount++
          };
          this._markChange(t, o), this._removeAllNestedChanges(t, e, n);
        }
      }, {
        key: "_markAttribute",
        value: function _markAttribute(t) {
          var e = {
            type: "attribute",
            offset: t.startOffset,
            howMany: t.offsetSize,
            count: this._changeCount++
          };
          this._markChange(t.parent, e);
        }
      }, {
        key: "_markChange",
        value: function _markChange(t, e) {
          this._makeSnapshot(t);
          var n = this._getChangesForElement(t);
          this._handleChange(e, n), n.push(e);
          for (var _t186 = 0; _t186 < n.length; _t186++) n[_t186].howMany < 1 && (n.splice(_t186, 1), _t186--);
        }
      }, {
        key: "_getChangesForElement",
        value: function _getChangesForElement(t) {
          var e;
          return this._changesInElement.has(t) ? e = this._changesInElement.get(t) : (e = [], this._changesInElement.set(t, e)), e;
        }
      }, {
        key: "_makeSnapshot",
        value: function _makeSnapshot(t) {
          this._elementSnapshots.has(t) || this._elementSnapshots.set(t, il(t.getChildren()));
        }
      }, {
        key: "_handleChange",
        value: function _handleChange(t, e) {
          t.nodesToHandle = t.howMany;
          var _iterator251 = _createForOfIteratorHelper(e),
            _step251;
          try {
            for (_iterator251.s(); !(_step251 = _iterator251.n()).done;) {
              var _n178 = _step251.value;
              var _o97 = t.offset + t.howMany,
                _i84 = _n178.offset + _n178.howMany;
              if ("insert" == t.type && ("insert" == _n178.type && (t.offset <= _n178.offset ? _n178.offset += t.howMany : t.offset < _i84 && (_n178.howMany += t.nodesToHandle, t.nodesToHandle = 0)), "remove" == _n178.type && t.offset < _n178.offset && (_n178.offset += t.howMany), "attribute" == _n178.type)) if (t.offset <= _n178.offset) _n178.offset += t.howMany;else if (t.offset < _i84) {
                var _i85 = _n178.howMany;
                _n178.howMany = t.offset - _n178.offset, e.unshift({
                  type: "attribute",
                  offset: _o97,
                  howMany: _i85 - _n178.howMany,
                  count: this._changeCount++
                });
              }
              if ("remove" == t.type) {
                if ("insert" == _n178.type) if (_o97 <= _n178.offset) _n178.offset -= t.howMany;else if (_o97 <= _i84) {
                  if (t.offset < _n178.offset) {
                    var _e189 = _o97 - _n178.offset;
                    _n178.offset = t.offset, _n178.howMany -= _e189, t.nodesToHandle -= _e189;
                  } else _n178.howMany -= t.nodesToHandle, t.nodesToHandle = 0;
                } else if (t.offset <= _n178.offset) t.nodesToHandle -= _n178.howMany, _n178.howMany = 0;else if (t.offset < _i84) {
                  var _e190 = _i84 - t.offset;
                  _n178.howMany -= _e190, t.nodesToHandle -= _e190;
                }
                if ("remove" == _n178.type && (_o97 <= _n178.offset ? _n178.offset -= t.howMany : t.offset < _n178.offset && (t.nodesToHandle += _n178.howMany, _n178.howMany = 0)), "attribute" == _n178.type) if (_o97 <= _n178.offset) _n178.offset -= t.howMany;else if (t.offset < _n178.offset) {
                  var _e191 = _o97 - _n178.offset;
                  _n178.offset = t.offset, _n178.howMany -= _e191;
                } else if (t.offset < _i84) if (_o97 <= _i84) {
                  var _o98 = _n178.howMany;
                  _n178.howMany = t.offset - _n178.offset;
                  var _i86 = _o98 - _n178.howMany - t.nodesToHandle;
                  e.unshift({
                    type: "attribute",
                    offset: t.offset,
                    howMany: _i86,
                    count: this._changeCount++
                  });
                } else _n178.howMany -= _i84 - t.offset;
              }
              if ("attribute" == t.type) {
                if ("insert" == _n178.type) if (t.offset < _n178.offset && _o97 > _n178.offset) {
                  if (_o97 > _i84) {
                    var _t187 = {
                      type: "attribute",
                      offset: _i84,
                      howMany: _o97 - _i84,
                      count: this._changeCount++
                    };
                    this._handleChange(_t187, e), e.push(_t187);
                  }
                  t.nodesToHandle = _n178.offset - t.offset, t.howMany = t.nodesToHandle;
                } else t.offset >= _n178.offset && t.offset < _i84 && (_o97 > _i84 ? (t.nodesToHandle = _o97 - _i84, t.offset = _i84) : t.nodesToHandle = 0);
                if ("remove" == _n178.type && t.offset < _n178.offset && _o97 > _n178.offset) {
                  var _i87 = {
                    type: "attribute",
                    offset: _n178.offset,
                    howMany: _o97 - _n178.offset,
                    count: this._changeCount++
                  };
                  this._handleChange(_i87, e), e.push(_i87), t.nodesToHandle = _n178.offset - t.offset, t.howMany = t.nodesToHandle;
                }
                "attribute" == _n178.type && (t.offset >= _n178.offset && _o97 <= _i84 ? (t.nodesToHandle = 0, t.howMany = 0, t.offset = 0) : t.offset <= _n178.offset && _o97 >= _i84 && (_n178.howMany = 0));
              }
            }
          } catch (err) {
            _iterator251.e(err);
          } finally {
            _iterator251.f();
          }
          t.howMany = t.nodesToHandle, delete t.nodesToHandle;
        }
      }, {
        key: "_getInsertDiff",
        value: function _getInsertDiff(t, e, n) {
          return {
            type: "insert",
            position: pa._createAt(t, e),
            name: n,
            length: 1,
            changeCount: this._changeCount++
          };
        }
      }, {
        key: "_getRemoveDiff",
        value: function _getRemoveDiff(t, e, n) {
          return {
            type: "remove",
            position: pa._createAt(t, e),
            name: n,
            length: 1,
            changeCount: this._changeCount++
          };
        }
      }, {
        key: "_getAttributesDiff",
        value: function _getAttributesDiff(t, e, n) {
          var o = [];
          n = new Map(n);
          var _iterator252 = _createForOfIteratorHelper(e),
            _step252;
          try {
            for (_iterator252.s(); !(_step252 = _iterator252.n()).done;) {
              var _step252$value = _slicedToArray(_step252.value, 2),
                _i88 = _step252$value[0],
                _r30 = _step252$value[1];
              var _e192 = n.has(_i88) ? n.get(_i88) : null;
              _e192 !== _r30 && o.push({
                type: "attribute",
                position: t.start,
                range: t.clone(),
                length: 1,
                attributeKey: _i88,
                attributeOldValue: _r30,
                attributeNewValue: _e192,
                changeCount: this._changeCount++
              }), n.delete(_i88);
            }
          } catch (err) {
            _iterator252.e(err);
          } finally {
            _iterator252.f();
          }
          var _iterator253 = _createForOfIteratorHelper(n),
            _step253;
          try {
            for (_iterator253.s(); !(_step253 = _iterator253.n()).done;) {
              var _step253$value = _slicedToArray(_step253.value, 2),
                _e193 = _step253$value[0],
                _i89 = _step253$value[1];
              o.push({
                type: "attribute",
                position: t.start,
                range: t.clone(),
                length: 1,
                attributeKey: _e193,
                attributeOldValue: null,
                attributeNewValue: _i89,
                changeCount: this._changeCount++
              });
            }
          } catch (err) {
            _iterator253.e(err);
          } finally {
            _iterator253.f();
          }
          return o;
        }
      }, {
        key: "_isInInsertedElement",
        value: function _isInInsertedElement(t) {
          var e = t.parent;
          if (!e) return !1;
          var n = this._changesInElement.get(e),
            o = t.startOffset;
          if (n) {
            var _iterator254 = _createForOfIteratorHelper(n),
              _step254;
            try {
              for (_iterator254.s(); !(_step254 = _iterator254.n()).done;) {
                var _t188 = _step254.value;
                if ("insert" == _t188.type && o >= _t188.offset && o < _t188.offset + _t188.howMany) return !0;
              }
            } catch (err) {
              _iterator254.e(err);
            } finally {
              _iterator254.f();
            }
          }
          return this._isInInsertedElement(e);
        }
      }, {
        key: "_removeAllNestedChanges",
        value: function _removeAllNestedChanges(t, e, n) {
          var o = new wa(pa._createAt(t, e), pa._createAt(t, e + n));
          var _iterator255 = _createForOfIteratorHelper(o.getItems({
              shallow: !0
            })),
            _step255;
          try {
            for (_iterator255.s(); !(_step255 = _iterator255.n()).done;) {
              var _t189 = _step255.value;
              _t189.is("element") && (this._elementSnapshots.delete(_t189), this._changesInElement.delete(_t189), this._removeAllNestedChanges(_t189, 0, _t189.maxOffset));
            }
          } catch (err) {
            _iterator255.e(err);
          } finally {
            _iterator255.f();
          }
        }
      }, {
        key: "isEmpty",
        get: function get() {
          return 0 == this._changesInElement.size && 0 == this._changedMarkers.size;
        }
      }]);
      return ol;
    }();
    function il(t) {
      var e = [];
      var _iterator256 = _createForOfIteratorHelper(t),
        _step256;
      try {
        for (_iterator256.s(); !(_step256 = _iterator256.n()).done;) {
          var _n179 = _step256.value;
          if (_n179.is("$text")) for (var _t191 = 0; _t191 < _n179.data.length; _t191++) e.push({
            name: "$text",
            attributes: new Map(_n179.getAttributes())
          });else e.push({
            name: _n179.name,
            attributes: new Map(_n179.getAttributes())
          });
        }
      } catch (err) {
        _iterator256.e(err);
      } finally {
        _iterator256.f();
      }
      return e;
    }
    function rl(t, e) {
      var n = [];
      var o = 0,
        i = 0;
      var _iterator257 = _createForOfIteratorHelper(e),
        _step257;
      try {
        for (_iterator257.s(); !(_step257 = _iterator257.n()).done;) {
          var _t192 = _step257.value;
          if (_t192.offset > o) {
            for (var _e197 = 0; _e197 < _t192.offset - o; _e197++) n.push("e");
            i += _t192.offset - o;
          }
          if ("insert" == _t192.type) {
            for (var _e199 = 0; _e199 < _t192.howMany; _e199++) n.push("i");
            o = _t192.offset + _t192.howMany;
          } else if ("remove" == _t192.type) {
            for (var _e201 = 0; _e201 < _t192.howMany; _e201++) n.push("r");
            o = _t192.offset, i += _t192.howMany;
          } else n.push.apply(n, _toConsumableArray("a".repeat(_t192.howMany).split(""))), o = _t192.offset + _t192.howMany, i += _t192.howMany;
        }
      } catch (err) {
        _iterator257.e(err);
      } finally {
        _iterator257.f();
      }
      if (i < t) for (var _e195 = 0; _e195 < t - i - o; _e195++) n.push("e");
      return n;
    }
    function sl(t) {
      var e = t.position && "$graveyard" == t.position.root.rootName,
        n = t.range && "$graveyard" == t.range.root.rootName;
      return !e && !n;
    }
    var al = /*#__PURE__*/function () {
      function al() {
        _classCallCheck(this, al);
        this._operations = [], this._undoPairs = new Map(), this._undoneOperations = new Set();
      }
      _createClass(al, [{
        key: "addOperation",
        value: function addOperation(t) {
          this._operations.includes(t) || this._operations.push(t);
        }
      }, {
        key: "getOperations",
        value: function getOperations() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Number.NEGATIVE_INFINITY;
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.POSITIVE_INFINITY;
          var n = [];
          var _iterator258 = _createForOfIteratorHelper(this._operations),
            _step258;
          try {
            for (_iterator258.s(); !(_step258 = _iterator258.n()).done;) {
              var _o99 = _step258.value;
              _o99.baseVersion >= t && _o99.baseVersion < e && n.push(_o99);
            }
          } catch (err) {
            _iterator258.e(err);
          } finally {
            _iterator258.f();
          }
          return n;
        }
      }, {
        key: "getOperation",
        value: function getOperation(t) {
          var _iterator259 = _createForOfIteratorHelper(this._operations),
            _step259;
          try {
            for (_iterator259.s(); !(_step259 = _iterator259.n()).done;) {
              var _e202 = _step259.value;
              if (_e202.baseVersion == t) return _e202;
            }
          } catch (err) {
            _iterator259.e(err);
          } finally {
            _iterator259.f();
          }
        }
      }, {
        key: "setOperationAsUndone",
        value: function setOperationAsUndone(t, e) {
          this._undoPairs.set(e, t), this._undoneOperations.add(t);
        }
      }, {
        key: "isUndoingOperation",
        value: function isUndoingOperation(t) {
          return this._undoPairs.has(t);
        }
      }, {
        key: "isUndoneOperation",
        value: function isUndoneOperation(t) {
          return this._undoneOperations.has(t);
        }
      }, {
        key: "getUndoneOperation",
        value: function getUndoneOperation(t) {
          return this._undoPairs.get(t);
        }
      }]);
      return al;
    }();
    function cl(t, e) {
      return !!(n = t.charAt(e - 1)) && 1 == n.length && /[\ud800-\udbff]/.test(n) && function (t) {
        return !!t && 1 == t.length && /[\udc00-\udfff]/.test(t);
      }(t.charAt(e));
      var n;
    }
    function ll(t, e) {
      return !!(n = t.charAt(e)) && 1 == n.length && /[\u0300-\u036f\u1ab0-\u1aff\u1dc0-\u1dff\u20d0-\u20ff\ufe20-\ufe2f]/.test(n);
      var n;
    }
    var dl = "$graveyard";
    var hl = /*#__PURE__*/function () {
      function hl(t) {
        var _this81 = this;
        _classCallCheck(this, hl);
        this.model = t, this.version = 0, this.history = new al(this), this.selection = new La(this), this.roots = new co({
          idProperty: "rootName"
        }), this.differ = new ol(t.markers), this._postFixers = new Set(), this._hasSelectionChangedFromTheLastChangeBlock = !1, this.createRoot("$root", dl), this.listenTo(t, "applyOperation", function (t, e) {
          var n = e[0];
          if (n.isDocumentOperation && n.baseVersion !== _this81.version) throw new c.a("model-document-applyoperation-wrong-version", _this81, {
            operation: n
          });
        }, {
          priority: "highest"
        }), this.listenTo(t, "applyOperation", function (t, e) {
          var n = e[0];
          n.isDocumentOperation && _this81.differ.bufferOperation(n);
        }, {
          priority: "high"
        }), this.listenTo(t, "applyOperation", function (t, e) {
          var n = e[0];
          n.isDocumentOperation && (_this81.version++, _this81.history.addOperation(n));
        }, {
          priority: "low"
        }), this.listenTo(this.selection, "change", function () {
          _this81._hasSelectionChangedFromTheLastChangeBlock = !0;
        }), this.listenTo(t.markers, "update", function (t, e, n, o) {
          _this81.differ.bufferMarkerChange(e.name, n, o, e.affectsData), null === n && e.on("change", function (t, n) {
            _this81.differ.bufferMarkerChange(e.name, n, e.getRange(), e.affectsData);
          });
        });
      }
      _createClass(hl, [{
        key: "createRoot",
        value: function createRoot() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "$root";
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "main";
          if (this.roots.get(e)) throw new c.a("model-document-createroot-name-exists", this, {
            name: e
          });
          var n = new $c(this, t, e);
          return this.roots.add(n), n;
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.selection.destroy(), this.stopListening();
        }
      }, {
        key: "getRoot",
        value: function getRoot() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "main";
          return this.roots.get(t);
        }
      }, {
        key: "getRootNames",
        value: function getRootNames() {
          return Array.from(this.roots, function (t) {
            return t.rootName;
          }).filter(function (t) {
            return t != dl;
          });
        }
      }, {
        key: "registerPostFixer",
        value: function registerPostFixer(t) {
          this._postFixers.add(t);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = wo(this);
          return t.selection = "[engine.model.DocumentSelection]", t.model = "[engine.model.Model]", t;
        }
      }, {
        key: "_handleChangeBlock",
        value: function _handleChangeBlock(t) {
          this._hasDocumentChangedFromTheLastChangeBlock() && (this._callPostFixers(t), this.selection.refresh(), this.differ.hasDataChanges() ? this.fire("change:data", t.batch) : this.fire("change", t.batch), this.selection.refresh(), this.differ.reset()), this._hasSelectionChangedFromTheLastChangeBlock = !1;
        }
      }, {
        key: "_hasDocumentChangedFromTheLastChangeBlock",
        value: function _hasDocumentChangedFromTheLastChangeBlock() {
          return !this.differ.isEmpty || this._hasSelectionChangedFromTheLastChangeBlock;
        }
      }, {
        key: "_getDefaultRoot",
        value: function _getDefaultRoot() {
          var _iterator260 = _createForOfIteratorHelper(this.roots),
            _step260;
          try {
            for (_iterator260.s(); !(_step260 = _iterator260.n()).done;) {
              var _t193 = _step260.value;
              if (_t193 !== this.graveyard) return _t193;
            }
          } catch (err) {
            _iterator260.e(err);
          } finally {
            _iterator260.f();
          }
          return this.graveyard;
        }
      }, {
        key: "_getDefaultRange",
        value: function _getDefaultRange() {
          var t = this._getDefaultRoot(),
            e = this.model,
            n = e.schema,
            o = e.createPositionFromPath(t, [0]);
          return n.getNearestSelectionRange(o) || e.createRange(o);
        }
      }, {
        key: "_validateSelectionRange",
        value: function _validateSelectionRange(t) {
          return ul(t.start) && ul(t.end);
        }
      }, {
        key: "_callPostFixers",
        value: function _callPostFixers(t) {
          var e = !1;
          do {
            var _iterator261 = _createForOfIteratorHelper(this._postFixers),
              _step261;
            try {
              for (_iterator261.s(); !(_step261 = _iterator261.n()).done;) {
                var _n180 = _step261.value;
                if (this.selection.refresh(), e = _n180(t), e) break;
              }
            } catch (err) {
              _iterator261.e(err);
            } finally {
              _iterator261.f();
            }
          } while (e);
        }
      }, {
        key: "graveyard",
        get: function get() {
          return this.getRoot(dl);
        }
      }]);
      return hl;
    }();
    function ul(t) {
      var e = t.textNode;
      if (e) {
        var _n181 = e.data,
          _o100 = t.offset - e.startOffset;
        return !cl(_n181, _o100) && !ll(_n181, _o100);
      }
      return !0;
    }
    $t(hl, h);
    var gl = /*#__PURE__*/function () {
      function gl() {
        _classCallCheck(this, gl);
        this._markers = new Map();
      }
      _createClass(gl, [{
        key: Symbol.iterator,
        value: function value() {
          return this._markers.values();
        }
      }, {
        key: "has",
        value: function has(t) {
          return this._markers.has(t);
        }
      }, {
        key: "get",
        value: function get(t) {
          return this._markers.get(t) || null;
        }
      }, {
        key: "_set",
        value: function _set(t, e) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
          var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
          var i = t instanceof ml ? t.name : t;
          if (i.includes(",")) throw new c.a("markercollection-incorrect-marker-name", this);
          var r = this._markers.get(i);
          if (r) {
            var _t194 = r.getRange();
            var _s21 = !1;
            return _t194.isEqual(e) || (r._attachLiveRange(Na.fromRange(e)), _s21 = !0), n != r.managedUsingOperations && (r._managedUsingOperations = n, _s21 = !0), "boolean" == typeof o && o != r.affectsData && (r._affectsData = o, _s21 = !0), _s21 && this.fire("update:" + i, r, _t194, e), r;
          }
          var s = Na.fromRange(e),
            a = new ml(i, s, n, o);
          return this._markers.set(i, a), this.fire("update:" + i, a, null, e), a;
        }
      }, {
        key: "_remove",
        value: function _remove(t) {
          var e = t instanceof ml ? t.name : t,
            n = this._markers.get(e);
          return !!n && (this._markers.delete(e), this.fire("update:" + e, n, n.getRange(), null), this._destroyMarker(n), !0);
        }
      }, {
        key: "_refresh",
        value: function _refresh(t) {
          var e = t instanceof ml ? t.name : t,
            n = this._markers.get(e);
          if (!n) throw new c.a("markercollection-refresh-marker-not-exists", this);
          var o = n.getRange();
          this.fire("update:" + e, n, o, o, n.managedUsingOperations, n.affectsData);
        }
      }, {
        key: "getMarkersAtPosition",
        value: /*#__PURE__*/_regeneratorRuntime().mark(function getMarkersAtPosition(t) {
          var _iterator262, _step262, _e203;
          return _regeneratorRuntime().wrap(function getMarkersAtPosition$(_context31) {
            while (1) switch (_context31.prev = _context31.next) {
              case 0:
                _iterator262 = _createForOfIteratorHelper(this);
                _context31.prev = 1;
                _iterator262.s();
              case 3:
                if ((_step262 = _iterator262.n()).done) {
                  _context31.next = 11;
                  break;
                }
                _e203 = _step262.value;
                _context31.t0 = _e203.getRange().containsPosition(t);
                if (!_context31.t0) {
                  _context31.next = 9;
                  break;
                }
                _context31.next = 9;
                return _e203;
              case 9:
                _context31.next = 3;
                break;
              case 11:
                _context31.next = 16;
                break;
              case 13:
                _context31.prev = 13;
                _context31.t1 = _context31["catch"](1);
                _iterator262.e(_context31.t1);
              case 16:
                _context31.prev = 16;
                _iterator262.f();
                return _context31.finish(16);
              case 19:
              case "end":
                return _context31.stop();
            }
          }, getMarkersAtPosition, this, [[1, 13, 16, 19]]);
        })
      }, {
        key: "getMarkersIntersectingRange",
        value: /*#__PURE__*/_regeneratorRuntime().mark(function getMarkersIntersectingRange(t) {
          var _iterator263, _step263, _e204;
          return _regeneratorRuntime().wrap(function getMarkersIntersectingRange$(_context32) {
            while (1) switch (_context32.prev = _context32.next) {
              case 0:
                _iterator263 = _createForOfIteratorHelper(this);
                _context32.prev = 1;
                _iterator263.s();
              case 3:
                if ((_step263 = _iterator263.n()).done) {
                  _context32.next = 11;
                  break;
                }
                _e204 = _step263.value;
                _context32.t0 = null !== _e204.getRange().getIntersection(t);
                if (!_context32.t0) {
                  _context32.next = 9;
                  break;
                }
                _context32.next = 9;
                return _e204;
              case 9:
                _context32.next = 3;
                break;
              case 11:
                _context32.next = 16;
                break;
              case 13:
                _context32.prev = 13;
                _context32.t1 = _context32["catch"](1);
                _iterator263.e(_context32.t1);
              case 16:
                _context32.prev = 16;
                _iterator263.f();
                return _context32.finish(16);
              case 19:
              case "end":
                return _context32.stop();
            }
          }, getMarkersIntersectingRange, this, [[1, 13, 16, 19]]);
        })
      }, {
        key: "destroy",
        value: function destroy() {
          var _iterator264 = _createForOfIteratorHelper(this._markers.values()),
            _step264;
          try {
            for (_iterator264.s(); !(_step264 = _iterator264.n()).done;) {
              var _t195 = _step264.value;
              this._destroyMarker(_t195);
            }
          } catch (err) {
            _iterator264.e(err);
          } finally {
            _iterator264.f();
          }
          this._markers = null, this.stopListening();
        }
      }, {
        key: "getMarkersGroup",
        value: /*#__PURE__*/_regeneratorRuntime().mark(function getMarkersGroup(t) {
          var _iterator265, _step265, _e205;
          return _regeneratorRuntime().wrap(function getMarkersGroup$(_context33) {
            while (1) switch (_context33.prev = _context33.next) {
              case 0:
                _iterator265 = _createForOfIteratorHelper(this._markers.values());
                _context33.prev = 1;
                _iterator265.s();
              case 3:
                if ((_step265 = _iterator265.n()).done) {
                  _context33.next = 11;
                  break;
                }
                _e205 = _step265.value;
                _context33.t0 = _e205.name.startsWith(t + ":");
                if (!_context33.t0) {
                  _context33.next = 9;
                  break;
                }
                _context33.next = 9;
                return _e205;
              case 9:
                _context33.next = 3;
                break;
              case 11:
                _context33.next = 16;
                break;
              case 13:
                _context33.prev = 13;
                _context33.t1 = _context33["catch"](1);
                _iterator265.e(_context33.t1);
              case 16:
                _context33.prev = 16;
                _iterator265.f();
                return _context33.finish(16);
              case 19:
              case "end":
                return _context33.stop();
            }
          }, getMarkersGroup, this, [[1, 13, 16, 19]]);
        })
      }, {
        key: "_destroyMarker",
        value: function _destroyMarker(t) {
          t.stopListening(), t._detachLiveRange();
        }
      }]);
      return gl;
    }();
    $t(gl, h);
    var ml = /*#__PURE__*/function () {
      function ml(t, e, n, o) {
        _classCallCheck(this, ml);
        this.name = t, this._liveRange = this._attachLiveRange(e), this._managedUsingOperations = n, this._affectsData = o;
      }
      _createClass(ml, [{
        key: "getStart",
        value: function getStart() {
          if (!this._liveRange) throw new c.a("marker-destroyed", this);
          return this._liveRange.start.clone();
        }
      }, {
        key: "getEnd",
        value: function getEnd() {
          if (!this._liveRange) throw new c.a("marker-destroyed", this);
          return this._liveRange.end.clone();
        }
      }, {
        key: "getRange",
        value: function getRange() {
          if (!this._liveRange) throw new c.a("marker-destroyed", this);
          return this._liveRange.toRange();
        }
      }, {
        key: "is",
        value: function is(t) {
          return "marker" === t || "model:marker" === t;
        }
      }, {
        key: "_attachLiveRange",
        value: function _attachLiveRange(t) {
          return this._liveRange && this._detachLiveRange(), t.delegate("change:range").to(this), t.delegate("change:content").to(this), this._liveRange = t, t;
        }
      }, {
        key: "_detachLiveRange",
        value: function _detachLiveRange() {
          this._liveRange.stopDelegating("change:range", this), this._liveRange.stopDelegating("change:content", this), this._liveRange.detach(), this._liveRange = null;
        }
      }, {
        key: "managedUsingOperations",
        get: function get() {
          if (!this._liveRange) throw new c.a("marker-destroyed", this);
          return this._managedUsingOperations;
        }
      }, {
        key: "affectsData",
        get: function get() {
          if (!this._liveRange) throw new c.a("marker-destroyed", this);
          return this._affectsData;
        }
      }]);
      return ml;
    }();
    $t(ml, h);
    var pl = /*#__PURE__*/function (_Sc10) {
      _inherits(pl, _Sc10);
      function pl() {
        _classCallCheck(this, pl);
        return _possibleConstructorReturn(this, _getPrototypeOf(pl).apply(this, arguments));
      }
      _createClass(pl, [{
        key: "clone",
        value: function clone() {
          return new pl(this.baseVersion);
        }
      }, {
        key: "getReversed",
        value: function getReversed() {
          return new pl(this.baseVersion + 1);
        }
      }, {
        key: "_execute",
        value: function _execute() {}
      }, {
        key: "type",
        get: function get() {
          return "noop";
        }
      }], [{
        key: "className",
        get: function get() {
          return "NoOperation";
        }
      }]);
      return pl;
    }(Sc);
    var fl = {};
    fl[Vc.className] = Vc, fl[Gc.className] = Gc, fl[Wc.className] = Wc, fl[Hc.className] = Hc, fl[pl.className] = pl, fl[Sc.className] = Sc, fl[qc.className] = qc, fl[Kc.className] = Kc, fl[Qc.className] = Qc, fl[Yc.className] = Yc;
    var kl = /*#__PURE__*/function (_pa) {
      _inherits(kl, _pa);
      function kl(t, e) {
        var _this82;
        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "toNone";
        _classCallCheck(this, kl);
        if (_this82 = _possibleConstructorReturn(this, _getPrototypeOf(kl).call(this, t, e, n)), !_this82.root.is("rootElement")) throw new c.a("model-liveposition-root-not-rootelement", t);
        bl.call(_assertThisInitialized(_assertThisInitialized(_this82)));
        return _possibleConstructorReturn(_this82);
      }
      _createClass(kl, [{
        key: "detach",
        value: function detach() {
          this.stopListening();
        }
      }, {
        key: "is",
        value: function is(t) {
          return "livePosition" === t || "model:livePosition" === t || "position" == t || "model:position" === t;
        }
      }, {
        key: "toPosition",
        value: function toPosition() {
          return new pa(this.root, this.path.slice(), this.stickiness);
        }
      }], [{
        key: "fromPosition",
        value: function fromPosition(t, e) {
          return new this(t.root, t.path.slice(), e || t.stickiness);
        }
      }]);
      return kl;
    }(pa);
    function bl() {
      var _this83 = this;
      this.listenTo(this.root.document.model, "applyOperation", function (t, e) {
        var n = e[0];
        n.isDocumentOperation && wl.call(_this83, n);
      }, {
        priority: "low"
      });
    }
    function wl(t) {
      var e = this.getTransformedByOperation(t);
      if (!this.isEqual(e)) {
        var _t196 = this.toPosition();
        this.path = e.path, this.root = e.root, this.fire("change", _t196);
      }
    }
    $t(kl, h);
    var Cl = /*#__PURE__*/function () {
      function Cl(t, e, n) {
        _classCallCheck(this, Cl);
        this.model = t, this.writer = e, this.position = n, this.canMergeWith = new Set([this.position.parent]), this.schema = t.schema, this._documentFragment = e.createDocumentFragment(), this._documentFragmentPosition = e.createPositionAt(this._documentFragment, 0), this._firstNode = null, this._lastNode = null, this._lastAutoParagraph = null, this._filterAttributesOf = [], this._affectedStart = null, this._affectedEnd = null;
      }
      _createClass(Cl, [{
        key: "handleNodes",
        value: function handleNodes(t) {
          for (var _i90 = 0, _Array$from6 = Array.from(t); _i90 < _Array$from6.length; _i90++) {
            var _e206 = _Array$from6[_i90];
            this._handleNode(_e206);
          }
          this._insertPartialFragment(), this._lastAutoParagraph && this._updateLastNodeFromAutoParagraph(this._lastAutoParagraph), this._mergeOnRight(), this.schema.removeDisallowedAttributes(this._filterAttributesOf, this.writer), this._filterAttributesOf = [];
        }
      }, {
        key: "_updateLastNodeFromAutoParagraph",
        value: function _updateLastNodeFromAutoParagraph(t) {
          var e = this.writer.createPositionAfter(this._lastNode),
            n = this.writer.createPositionAfter(t);
          if (n.isAfter(e)) {
            if (this._lastNode = t, this.position.parent != t || !this.position.isAtEnd) throw new c.a("insertcontent-invalid-insertion-position", this);
            this.position = n, this._setAffectedBoundaries(this.position);
          }
        }
      }, {
        key: "getSelectionRange",
        value: function getSelectionRange() {
          return this.nodeToSelect ? wa._createOn(this.nodeToSelect) : this.model.schema.getNearestSelectionRange(this.position);
        }
      }, {
        key: "getAffectedRange",
        value: function getAffectedRange() {
          return this._affectedStart ? new wa(this._affectedStart, this._affectedEnd) : null;
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this._affectedStart && this._affectedStart.detach(), this._affectedEnd && this._affectedEnd.detach();
        }
      }, {
        key: "_handleNode",
        value: function _handleNode(t) {
          if (this.schema.isObject(t)) return void this._handleObject(t);
          var e = this._checkAndAutoParagraphToAllowedPosition(t);
          e || (e = this._checkAndSplitToAllowedPosition(t), e) ? (this._appendToFragment(t), this._firstNode || (this._firstNode = t), this._lastNode = t) : this._handleDisallowedNode(t);
        }
      }, {
        key: "_insertPartialFragment",
        value: function _insertPartialFragment() {
          if (this._documentFragment.isEmpty) return;
          var t = kl.fromPosition(this.position, "toNext");
          this._setAffectedBoundaries(this.position), this._documentFragment.getChild(0) == this._firstNode && (this.writer.insert(this._firstNode, this.position), this._mergeOnLeft(), this.position = t.toPosition()), this._documentFragment.isEmpty || this.writer.insert(this._documentFragment, this.position), this._documentFragmentPosition = this.writer.createPositionAt(this._documentFragment, 0), this.position = t.toPosition(), t.detach();
        }
      }, {
        key: "_handleObject",
        value: function _handleObject(t) {
          this._checkAndSplitToAllowedPosition(t) ? this._appendToFragment(t) : this._tryAutoparagraphing(t);
        }
      }, {
        key: "_handleDisallowedNode",
        value: function _handleDisallowedNode(t) {
          t.is("element") ? this.handleNodes(t.getChildren()) : this._tryAutoparagraphing(t);
        }
      }, {
        key: "_appendToFragment",
        value: function _appendToFragment(t) {
          if (!this.schema.checkChild(this.position, t)) throw new c.a("insertcontent-wrong-position", this, {
            node: t,
            position: this.position
          });
          this.writer.insert(t, this._documentFragmentPosition), this._documentFragmentPosition = this._documentFragmentPosition.getShiftedBy(t.offsetSize), this.schema.isObject(t) && !this.schema.checkChild(this.position, "$text") ? this.nodeToSelect = t : this.nodeToSelect = null, this._filterAttributesOf.push(t);
        }
      }, {
        key: "_setAffectedBoundaries",
        value: function _setAffectedBoundaries(t) {
          this._affectedStart || (this._affectedStart = kl.fromPosition(t, "toPrevious")), this._affectedEnd && !this._affectedEnd.isBefore(t) || (this._affectedEnd && this._affectedEnd.detach(), this._affectedEnd = kl.fromPosition(t, "toNext"));
        }
      }, {
        key: "_mergeOnLeft",
        value: function _mergeOnLeft() {
          var t = this._firstNode;
          if (!(t instanceof ua)) return;
          if (!this._canMergeLeft(t)) return;
          var e = kl._createBefore(t);
          e.stickiness = "toNext";
          var n = kl.fromPosition(this.position, "toNext");
          this._affectedStart.isEqual(e) && (this._affectedStart.detach(), this._affectedStart = kl._createAt(e.nodeBefore, "end", "toPrevious")), this._firstNode === this._lastNode && (this._firstNode = e.nodeBefore, this._lastNode = e.nodeBefore), this.writer.merge(e), e.isEqual(this._affectedEnd) && this._firstNode === this._lastNode && (this._affectedEnd.detach(), this._affectedEnd = kl._createAt(e.nodeBefore, "end", "toNext")), this.position = n.toPosition(), n.detach(), this._filterAttributesOf.push(this.position.parent), e.detach();
        }
      }, {
        key: "_mergeOnRight",
        value: function _mergeOnRight() {
          var t = this._lastNode;
          if (!(t instanceof ua)) return;
          if (!this._canMergeRight(t)) return;
          var e = kl._createAfter(t);
          if (e.stickiness = "toNext", !this.position.isEqual(e)) throw new c.a("insertcontent-invalid-insertion-position", this);
          this.position = pa._createAt(e.nodeBefore, "end");
          var n = kl.fromPosition(this.position, "toPrevious");
          this._affectedEnd.isEqual(e) && (this._affectedEnd.detach(), this._affectedEnd = kl._createAt(e.nodeBefore, "end", "toNext")), this._firstNode === this._lastNode && (this._firstNode = e.nodeBefore, this._lastNode = e.nodeBefore), this.writer.merge(e), e.getShiftedBy(-1).isEqual(this._affectedStart) && this._firstNode === this._lastNode && (this._affectedStart.detach(), this._affectedStart = kl._createAt(e.nodeBefore, 0, "toPrevious")), this.position = n.toPosition(), n.detach(), this._filterAttributesOf.push(this.position.parent), e.detach();
        }
      }, {
        key: "_canMergeLeft",
        value: function _canMergeLeft(t) {
          var e = t.previousSibling;
          return e instanceof ua && this.canMergeWith.has(e) && this.model.schema.checkMerge(e, t);
        }
      }, {
        key: "_canMergeRight",
        value: function _canMergeRight(t) {
          var e = t.nextSibling;
          return e instanceof ua && this.canMergeWith.has(e) && this.model.schema.checkMerge(t, e);
        }
      }, {
        key: "_tryAutoparagraphing",
        value: function _tryAutoparagraphing(t) {
          var e = this.writer.createElement("paragraph");
          this._getAllowedIn(this.position.parent, e) && this.schema.checkChild(e, t) && (e._appendChild(t), this._handleNode(e));
        }
      }, {
        key: "_checkAndAutoParagraphToAllowedPosition",
        value: function _checkAndAutoParagraphToAllowedPosition(t) {
          if (this.schema.checkChild(this.position.parent, t)) return !0;
          if (!this.schema.checkChild(this.position.parent, "paragraph") || !this.schema.checkChild("paragraph", t)) return !1;
          this._insertPartialFragment();
          var e = this.writer.createElement("paragraph");
          return this.writer.insert(e, this.position), this._setAffectedBoundaries(this.position), this._lastAutoParagraph = e, this.position = this.writer.createPositionAt(e, 0), !0;
        }
      }, {
        key: "_checkAndSplitToAllowedPosition",
        value: function _checkAndSplitToAllowedPosition(t) {
          var e = this._getAllowedIn(this.position.parent, t);
          if (!e) return !1;
          for (e != this.position.parent && this._insertPartialFragment(); e != this.position.parent;) if (this.position.isAtStart) {
            var _t197 = this.position.parent;
            this.position = this.writer.createPositionBefore(_t197), _t197.isEmpty && _t197.parent === e && this.writer.remove(_t197);
          } else if (this.position.isAtEnd) this.position = this.writer.createPositionAfter(this.position.parent);else {
            var _t198 = this.writer.createPositionAfter(this.position.parent);
            this._setAffectedBoundaries(this.position), this.writer.split(this.position), this.position = _t198, this.canMergeWith.add(this.position.nodeAfter);
          }
          return !0;
        }
      }, {
        key: "_getAllowedIn",
        value: function _getAllowedIn(t, e) {
          return this.schema.checkChild(t, e) ? t : this.schema.isLimit(t) ? null : this._getAllowedIn(t.parent, e);
        }
      }]);
      return Cl;
    }();
    function Al(t, e) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      if (e.isCollapsed) return;
      var o = e.getFirstRange();
      if ("$graveyard" == o.root.rootName) return;
      var i = t.schema;
      t.change(function (t) {
        if (!n.doNotResetEntireContent && function (t, e) {
          var n = t.getLimitElement(e);
          if (!e.containsEntireContent(n)) return !1;
          var o = e.getFirstRange();
          if (o.start.parent == o.end.parent) return !1;
          return t.checkChild(n, "paragraph");
        }(i, e)) return void function (t, e) {
          var n = t.model.schema.getLimitElement(e);
          t.remove(t.createRangeIn(n)), xl(t, t.createPositionAt(n, 0), e);
        }(t, e);
        var _ref22 = function (t) {
            var e = t.root.document.model,
              n = t.start;
            var o = t.end;
            if (e.hasContent(t, {
              ignoreMarkers: !0
            })) {
              var _n182 = function (t) {
                var e = t.parent,
                  n = e.root.document.model.schema,
                  o = e.getAncestors({
                    parentFirst: !0,
                    includeSelf: !0
                  });
                var _iterator266 = _createForOfIteratorHelper(o),
                  _step266;
                try {
                  for (_iterator266.s(); !(_step266 = _iterator266.n()).done;) {
                    var _t199 = _step266.value;
                    if (n.isLimit(_t199)) return null;
                    if (n.isBlock(_t199)) return _t199;
                  }
                } catch (err) {
                  _iterator266.e(err);
                } finally {
                  _iterator266.f();
                }
              }(o);
              if (_n182 && o.isTouching(e.createPositionAt(_n182, 0))) {
                var _n183 = e.createSelection(t);
                e.modifySelection(_n183, {
                  direction: "backward"
                });
                var _i91 = _n183.getLastPosition(),
                  _r31 = e.createRange(_i91, o);
                e.hasContent(_r31, {
                  ignoreMarkers: !0
                }) || (o = _i91);
              }
            }
            return [kl.fromPosition(n, "toPrevious"), kl.fromPosition(o, "toNext")];
          }(o),
          _ref23 = _slicedToArray(_ref22, 2),
          r = _ref23[0],
          s = _ref23[1];
        r.isTouching(s) || t.remove(t.createRange(r, s)), n.leaveUnmerged || (!function (t, e, n) {
          var o = t.model;
          if (!yl(t.model.schema, e, n)) return;
          var _ref24 = function (t, e) {
              var n = t.getAncestors(),
                o = e.getAncestors();
              var i = 0;
              for (; n[i] && n[i] == o[i];) i++;
              return [n[i], o[i]];
            }(e, n),
            _ref25 = _slicedToArray(_ref24, 2),
            i = _ref25[0],
            r = _ref25[1];
          if (!i || !r) return;
          !o.hasContent(i, {
            ignoreMarkers: !0
          }) && o.hasContent(r, {
            ignoreMarkers: !0
          }) ? vl(t, e, n, i.parent) : _l(t, e, n, i.parent);
        }(t, r, s), i.removeDisallowedAttributes(r.parent.getChildren(), t)), El(t, e, r), !n.doNotAutoparagraph && function (t, e) {
          var n = t.checkChild(e, "$text"),
            o = t.checkChild(e, "paragraph");
          return !n && o;
        }(i, r) && xl(t, r, e), r.detach(), s.detach();
      });
    }
    function _l(t, e, n, o) {
      var i = e.parent,
        r = n.parent;
      if (i != o && r != o) {
        for (e = t.createPositionAfter(i), (n = t.createPositionBefore(r)).isEqual(e) || t.insert(r, e), t.merge(e); n.parent.isEmpty;) {
          var _e207 = n.parent;
          n = t.createPositionBefore(_e207), t.remove(_e207);
        }
        yl(t.model.schema, e, n) && _l(t, e, n, o);
      }
    }
    function vl(t, e, n, o) {
      var i = e.parent,
        r = n.parent;
      if (i != o && r != o) {
        for (e = t.createPositionAfter(i), (n = t.createPositionBefore(r)).isEqual(e) || t.insert(i, n); e.parent.isEmpty;) {
          var _n184 = e.parent;
          e = t.createPositionBefore(_n184), t.remove(_n184);
        }
        n = t.createPositionBefore(r), function (t, e) {
          var n = e.nodeBefore,
            o = e.nodeAfter;
          n.name != o.name && t.rename(n, o.name);
          t.clearAttributes(n), t.setAttributes(Object.fromEntries(o.getAttributes()), n), t.merge(e);
        }(t, n), yl(t.model.schema, e, n) && vl(t, e, n, o);
      }
    }
    function yl(t, e, n) {
      var o = e.parent,
        i = n.parent;
      return o != i && !t.isLimit(o) && !t.isLimit(i) && function (t, e, n) {
        var o = new wa(t, e);
        var _iterator267 = _createForOfIteratorHelper(o.getWalker()),
          _step267;
        try {
          for (_iterator267.s(); !(_step267 = _iterator267.n()).done;) {
            var _t200 = _step267.value;
            if (n.isLimit(_t200.item)) return !1;
          }
        } catch (err) {
          _iterator267.e(err);
        } finally {
          _iterator267.f();
        }
        return !0;
      }(e, n, t);
    }
    function xl(t, e, n) {
      var o = t.createElement("paragraph");
      t.insert(o, e), El(t, n, t.createPositionAt(o, 0));
    }
    function El(t, e, n) {
      e instanceof La ? t.setSelection(n) : e.setTo(n);
    }
    var Dl = ' ,.?!:;"-()';
    function Ml(t, e) {
      var n = t.isForward,
        o = t.walker,
        i = t.unit,
        r = t.schema,
        s = e.type,
        a = e.item,
        c = e.nextPosition;
      if ("text" == s) return "word" === t.unit ? function (t, e) {
        var n = t.position.textNode;
        if (n) {
          var _o101 = t.position.offset - n.startOffset;
          for (; !Tl(n.data, _o101, e) && !Sl(n, _o101, e);) {
            t.next();
            var _i92 = e ? t.position.nodeAfter : t.position.nodeBefore;
            if (_i92 && _i92.is("$text")) {
              var _o102 = _i92.data.charAt(e ? 0 : _i92.data.length - 1);
              Dl.includes(_o102) || (t.next(), n = t.position.textNode);
            }
            _o101 = t.position.offset - n.startOffset;
          }
        }
        return t.position;
      }(o, n) : function (t, e) {
        var n = t.position.textNode;
        if (n) {
          var _o103 = n.data;
          var _i93 = t.position.offset - n.startOffset;
          for (; cl(_o103, _i93) || "character" == e && ll(_o103, _i93);) t.next(), _i93 = t.position.offset - n.startOffset;
        }
        return t.position;
      }(o, i);
      if (s == (n ? "elementStart" : "elementEnd")) {
        if (r.isSelectable(a)) return pa._createAt(a, n ? "after" : "before");
        if (r.checkChild(c, "$text")) return c;
      } else {
        if (r.isLimit(a)) return void o.skip(function () {
          return !0;
        });
        if (r.checkChild(c, "$text")) return c;
      }
    }
    function Il(t, e) {
      var n = t.root,
        o = pa._createAt(n, e ? "end" : 0);
      return e ? new wa(t, o) : new wa(o, t);
    }
    function Tl(t, e, n) {
      var o = e + (n ? 0 : -1);
      return Dl.includes(t.charAt(o));
    }
    function Sl(t, e, n) {
      return e === (n ? t.endOffset : 0);
    }
    function Nl(t, e) {
      var n = [];
      Array.from(t.getItems({
        direction: "backward"
      })).map(function (t) {
        return e.createRangeOn(t);
      }).filter(function (e) {
        return (e.start.isAfter(t.start) || e.start.isEqual(t.start)) && (e.end.isBefore(t.end) || e.end.isEqual(t.end));
      }).forEach(function (t) {
        n.push(t.start.parent), e.remove(t);
      }), n.forEach(function (t) {
        var n = t;
        for (; n.parent && n.isEmpty;) {
          var _t201 = e.createRangeOn(n);
          n = n.parent, e.remove(_t201);
        }
      });
    }
    function Bl(t) {
      t.document.registerPostFixer(function (e) {
        return function (t, e) {
          var n = e.document.selection,
            o = e.schema,
            i = [];
          var r = !1;
          var _iterator268 = _createForOfIteratorHelper(n.getRanges()),
            _step268;
          try {
            for (_iterator268.s(); !(_step268 = _iterator268.n()).done;) {
              var _t203 = _step268.value;
              var _e208 = Pl(_t203, o);
              _e208 && !_e208.isEqual(_t203) ? (i.push(_e208), r = !0) : i.push(_t203);
            }
          } catch (err) {
            _iterator268.e(err);
          } finally {
            _iterator268.f();
          }
          r && t.setSelection(function (t) {
            var e = [];
            e.push(t.shift());
            var _iterator269 = _createForOfIteratorHelper(t),
              _step269;
            try {
              for (_iterator269.s(); !(_step269 = _iterator269.n()).done;) {
                var _n185 = _step269.value;
                var _t202 = e.pop();
                if (_n185.isEqual(_t202)) e.push(_t202);else if (_n185.isIntersecting(_t202)) {
                  var _o104 = _t202.start.isAfter(_n185.start) ? _n185.start : _t202.start,
                    _i94 = _t202.end.isAfter(_n185.end) ? _t202.end : _n185.end,
                    _r32 = new wa(_o104, _i94);
                  e.push(_r32);
                } else e.push(_t202), e.push(_n185);
              }
            } catch (err) {
              _iterator269.e(err);
            } finally {
              _iterator269.f();
            }
            return e;
          }(i), {
            backward: n.isBackward
          });
        }(e, t);
      });
    }
    function Pl(t, e) {
      return t.isCollapsed ? function (t, e) {
        var n = t.start,
          o = e.getNearestSelectionRange(n);
        if (!o) return null;
        if (!o.isCollapsed) return o;
        var i = o.start;
        if (n.isEqual(i)) return null;
        return new wa(i);
      }(t, e) : function (t, e) {
        var n = t.start,
          o = t.end,
          i = e.checkChild(n, "$text"),
          r = e.checkChild(o, "$text"),
          s = e.getLimitElement(n),
          a = e.getLimitElement(o);
        if (s === a) {
          if (i && r) return null;
          if (function (t, e, n) {
            var o = t.nodeAfter && !n.isLimit(t.nodeAfter) || n.checkChild(t, "$text"),
              i = e.nodeBefore && !n.isLimit(e.nodeBefore) || n.checkChild(e, "$text");
            return o || i;
          }(n, o, e)) {
            var _t204 = n.nodeAfter && e.isSelectable(n.nodeAfter) ? null : e.getNearestSelectionRange(n, "forward"),
              _i95 = o.nodeBefore && e.isSelectable(o.nodeBefore) ? null : e.getNearestSelectionRange(o, "backward"),
              _r33 = _t204 ? _t204.start : n,
              _s22 = _i95 ? _i95.end : o;
            return new wa(_r33, _s22);
          }
        }
        var c = s && !s.is("rootElement"),
          l = a && !a.is("rootElement");
        if (c || l) {
          var _t205 = n.nodeAfter && o.nodeBefore && n.nodeAfter.parent === o.nodeBefore.parent,
            _i96 = c && (!_t205 || !Ll(n.nodeAfter, e)),
            _r34 = l && (!_t205 || !Ll(o.nodeBefore, e));
          var _d2 = n,
            _h2 = o;
          return _i96 && (_d2 = pa._createBefore(zl(s, e))), _r34 && (_h2 = pa._createAfter(zl(a, e))), new wa(_d2, _h2);
        }
        return null;
      }(t, e);
    }
    function zl(t, e) {
      var n = t,
        o = n;
      for (; e.isLimit(o) && o.parent;) n = o, o = o.parent;
      return n;
    }
    function Ll(t, e) {
      return t && e.isSelectable(t);
    }
    var Ol = /*#__PURE__*/function () {
      function Ol() {
        var _this84 = this;
        _classCallCheck(this, Ol);
        this.markers = new gl(), this.document = new hl(this), this.schema = new cc(), this._pendingChanges = [], this._currentWriter = null, ["insertContent", "deleteContent", "modifySelection", "getSelectedContent", "applyOperation"].forEach(function (t) {
          return _this84.decorate(t);
        }), this.on("applyOperation", function (t, e) {
          e[0]._validate();
        }, {
          priority: "highest"
        }), this.schema.register("$root", {
          isLimit: !0
        }), this.schema.register("$block", {
          allowIn: "$root",
          isBlock: !0
        }), this.schema.register("$text", {
          allowIn: "$block",
          isInline: !0,
          isContent: !0
        }), this.schema.register("$clipboardHolder", {
          allowContentOf: "$root",
          allowChildren: "$text",
          isLimit: !0
        }), this.schema.register("$documentFragment", {
          allowContentOf: "$root",
          allowChildren: "$text",
          isLimit: !0
        }), this.schema.register("$marker"), this.schema.addChildCheck(function (t, e) {
          if ("$marker" === e.name) return !0;
        }), Bl(this), this.document.registerPostFixer(Ya);
      }
      _createClass(Ol, [{
        key: "change",
        value: function change(t) {
          try {
            return 0 === this._pendingChanges.length ? (this._pendingChanges.push({
              batch: new Tc(),
              callback: t
            }), this._runPendingChanges()[0]) : t(this._currentWriter);
          } catch (t) {
            c.a.rethrowUnexpectedError(t, this);
          }
        }
      }, {
        key: "enqueueChange",
        value: function enqueueChange(t, e) {
          try {
            "string" == typeof t ? t = new Tc(t) : "function" == typeof t && (e = t, t = new Tc()), this._pendingChanges.push({
              batch: t,
              callback: e
            }), 1 == this._pendingChanges.length && this._runPendingChanges();
          } catch (t) {
            c.a.rethrowUnexpectedError(t, this);
          }
        }
      }, {
        key: "applyOperation",
        value: function applyOperation(t) {
          t._execute();
        }
      }, {
        key: "insertContent",
        value: function insertContent(t, e, n) {
          return function (t, e, n, o) {
            return t.change(function (i) {
              var r;
              r = n ? n instanceof Da || n instanceof La ? n : i.createSelection(n, o) : t.document.selection, r.isCollapsed || t.deleteContent(r, {
                doNotAutoparagraph: !0
              });
              var s = new Cl(t, i, r.anchor);
              var a;
              a = e.is("documentFragment") ? e.getChildren() : [e], s.handleNodes(a);
              var c = s.getSelectionRange();
              c && (r instanceof La ? i.setSelection(c) : r.setTo(c));
              var l = s.getAffectedRange() || t.createRange(r.anchor);
              return s.destroy(), l;
            });
          }(this, t, e, n);
        }
      }, {
        key: "deleteContent",
        value: function deleteContent(t, e) {
          Al(this, t, e);
        }
      }, {
        key: "modifySelection",
        value: function modifySelection(t, e) {
          !function (t, e) {
            var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            var o = t.schema,
              i = "backward" != n.direction,
              r = n.unit ? n.unit : "character",
              s = e.focus,
              a = new ga({
                boundaries: Il(s, i),
                singleCharacters: !0,
                direction: i ? "forward" : "backward"
              }),
              c = {
                walker: a,
                schema: o,
                isForward: i,
                unit: r
              };
            var l;
            var _loop3 = function _loop3() {
              if (l.done) return {
                v: void 0
              };
              var n = Ml(c, l.value);
              if (n) return {
                v: void (e instanceof La ? t.change(function (t) {
                  t.setSelectionFocus(n);
                }) : e.setFocus(n))
              };
            };
            for (; l = a.next();) {
              var _ret2 = _loop3();
              if (typeof _ret2 === "object") return _ret2.v;
            }
          }(this, t, e);
        }
      }, {
        key: "getSelectedContent",
        value: function getSelectedContent(t) {
          return function (t, e) {
            return t.change(function (t) {
              var n = t.createDocumentFragment(),
                o = e.getFirstRange();
              if (!o || o.isCollapsed) return n;
              var i = o.start.root,
                r = o.start.getCommonPath(o.end),
                s = i.getNodeByPath(r);
              var a;
              a = o.start.parent == o.end.parent ? o : t.createRange(t.createPositionAt(s, o.start.path[r.length]), t.createPositionAt(s, o.end.path[r.length] + 1));
              var c = a.end.offset - a.start.offset;
              var _iterator270 = _createForOfIteratorHelper(a.getItems({
                  shallow: !0
                })),
                _step270;
              try {
                for (_iterator270.s(); !(_step270 = _iterator270.n()).done;) {
                  var _e210 = _step270.value;
                  _e210.is("$textProxy") ? t.appendText(_e210.data, _e210.getAttributes(), n) : t.append(t.cloneElement(_e210, !0), n);
                }
              } catch (err) {
                _iterator270.e(err);
              } finally {
                _iterator270.f();
              }
              if (a != o) {
                var _e209 = o._getTransformedByMove(a.start, t.createPositionAt(n, 0), c)[0],
                  _i97 = t.createRange(t.createPositionAt(n, 0), _e209.start);
                Nl(t.createRange(_e209.end, t.createPositionAt(n, "end")), t), Nl(_i97, t);
              }
              return n;
            });
          }(this, t);
        }
      }, {
        key: "hasContent",
        value: function hasContent(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var n = t instanceof ua ? wa._createIn(t) : t;
          if (n.isCollapsed) return !1;
          var _e$ignoreWhitespaces = e.ignoreWhitespaces,
            o = _e$ignoreWhitespaces === void 0 ? !1 : _e$ignoreWhitespaces,
            _e$ignoreMarkers = e.ignoreMarkers,
            i = _e$ignoreMarkers === void 0 ? !1 : _e$ignoreMarkers;
          if (!i) {
            var _iterator271 = _createForOfIteratorHelper(this.markers.getMarkersIntersectingRange(n)),
              _step271;
            try {
              for (_iterator271.s(); !(_step271 = _iterator271.n()).done;) {
                var _t206 = _step271.value;
                if (_t206.affectsData) return !0;
              }
            } catch (err) {
              _iterator271.e(err);
            } finally {
              _iterator271.f();
            }
          }
          var _iterator272 = _createForOfIteratorHelper(n.getItems()),
            _step272;
          try {
            for (_iterator272.s(); !(_step272 = _iterator272.n()).done;) {
              var _t207 = _step272.value;
              if (this.schema.isContent(_t207)) {
                if (!_t207.is("$textProxy")) return !0;
                if (!o) return !0;
                if (-1 !== _t207.data.search(/\S/)) return !0;
              }
            }
          } catch (err) {
            _iterator272.e(err);
          } finally {
            _iterator272.f();
          }
          return !1;
        }
      }, {
        key: "createPositionFromPath",
        value: function createPositionFromPath(t, e, n) {
          return new pa(t, e, n);
        }
      }, {
        key: "createPositionAt",
        value: function createPositionAt(t, e) {
          return pa._createAt(t, e);
        }
      }, {
        key: "createPositionAfter",
        value: function createPositionAfter(t) {
          return pa._createAfter(t);
        }
      }, {
        key: "createPositionBefore",
        value: function createPositionBefore(t) {
          return pa._createBefore(t);
        }
      }, {
        key: "createRange",
        value: function createRange(t, e) {
          return new wa(t, e);
        }
      }, {
        key: "createRangeIn",
        value: function createRangeIn(t) {
          return wa._createIn(t);
        }
      }, {
        key: "createRangeOn",
        value: function createRangeOn(t) {
          return wa._createOn(t);
        }
      }, {
        key: "createSelection",
        value: function createSelection(t, e, n) {
          return new Da(t, e, n);
        }
      }, {
        key: "createBatch",
        value: function createBatch(t) {
          return new Tc(t);
        }
      }, {
        key: "createOperationFromJSON",
        value: function createOperationFromJSON(t) {
          return /*#__PURE__*/function () {
            function _class() {
              _classCallCheck(this, _class);
            }
            _createClass(_class, null, [{
              key: "fromJSON",
              value: function fromJSON(t, e) {
                return fl[t.__className].fromJSON(t, e);
              }
            }]);
            return _class;
          }().fromJSON(t, this.document);
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.document.destroy(), this.stopListening();
        }
      }, {
        key: "_runPendingChanges",
        value: function _runPendingChanges() {
          var t = [];
          for (this.fire("_beforeChanges"); this._pendingChanges.length;) {
            var _e211 = this._pendingChanges[0].batch;
            this._currentWriter = new Jc(this, _e211);
            var _n186 = this._pendingChanges[0].callback(this._currentWriter);
            t.push(_n186), this.document._handleChangeBlock(this._currentWriter), this._pendingChanges.shift(), this._currentWriter = null;
          }
          return this.fire("_afterChanges"), t;
        }
      }]);
      return Ol;
    }();
    $t(Ol, Gt);
    var Rl = /*#__PURE__*/function (_Qs) {
      _inherits(Rl, _Qs);
      function Rl(t) {
        var _this85;
        _classCallCheck(this, Rl);
        _this85 = _possibleConstructorReturn(this, _getPrototypeOf(Rl).call(this)), _this85.editor = t;
        return _this85;
      }
      _createClass(Rl, [{
        key: "set",
        value: function set(t, e) {
          var _this86 = this;
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          if ("string" == typeof e) {
            var _t208 = e;
            e = function e(_e212, n) {
              _this86.editor.execute(_t208), n();
            };
          }
          _get(_getPrototypeOf(Rl.prototype), "set", this).call(this, t, e, n);
        }
      }]);
      return Rl;
    }(Qs);
    var jl = /*#__PURE__*/function () {
      function jl() {
        var _this87 = this;
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        _classCallCheck(this, jl);
        this._context = t.context || new fo({
          language: t.language
        }), this._context._addEditor(this, !t.context);
        var e = Array.from(this.constructor.builtinPlugins || []);
        this.config = new io(t, this.constructor.defaultConfig), this.config.define("plugins", e), this.config.define(this._context._getEditorConfig()), this.plugins = new lo(this, e, this._context.plugins), this.locale = this._context.locale, this.t = this.locale.t, this.commands = new rc(), this.set("state", "initializing"), this.once("ready", function () {
          return _this87.state = "ready";
        }, {
          priority: "high"
        }), this.once("destroy", function () {
          return _this87.state = "destroyed";
        }, {
          priority: "high"
        }), this.set("isReadOnly", !1), this.model = new Ol();
        var n = new ai();
        this.data = new Ec(this.model, n), this.editing = new ic(this.model, n), this.editing.view.document.bind("isReadOnly").to(this), this.conversion = new Dc([this.editing.downcastDispatcher, this.data.downcastDispatcher], this.data.upcastDispatcher), this.conversion.addAlias("dataDowncast", this.data.downcastDispatcher), this.conversion.addAlias("editingDowncast", this.editing.downcastDispatcher), this.keystrokes = new Rl(this), this.keystrokes.listenTo(this.editing.view.document);
      }
      _createClass(jl, [{
        key: "initPlugins",
        value: function initPlugins() {
          var t = this.config,
            e = t.get("plugins"),
            n = t.get("removePlugins") || [],
            o = t.get("extraPlugins") || [],
            i = t.get("substitutePlugins") || [];
          return this.plugins.init(e.concat(o), n, i);
        }
      }, {
        key: "destroy",
        value: function destroy() {
          var _this88 = this;
          var t = Promise.resolve();
          return "initializing" == this.state && (t = new Promise(function (t) {
            return _this88.once("ready", t);
          })), t.then(function () {
            _this88.fire("destroy"), _this88.stopListening(), _this88.commands.destroy();
          }).then(function () {
            return _this88.plugins.destroy();
          }).then(function () {
            _this88.model.destroy(), _this88.data.destroy(), _this88.editing.destroy(), _this88.keystrokes.destroy();
          }).then(function () {
            return _this88._context._removeEditor(_this88);
          });
        }
      }, {
        key: "execute",
        value: function execute() {
          try {
            var _this$commands;
            return (_this$commands = this.commands).execute.apply(_this$commands, arguments);
          } catch (t) {
            c.a.rethrowUnexpectedError(t, this);
          }
        }
      }, {
        key: "focus",
        value: function focus() {
          this.editing.view.focus();
        }
      }]);
      return jl;
    }();
    $t(jl, Gt);
    var Fl = /*#__PURE__*/function () {
      function Fl(t) {
        _classCallCheck(this, Fl);
        this.editor = t, this._components = new Map();
      }
      _createClass(Fl, [{
        key: "names",
        value: /*#__PURE__*/_regeneratorRuntime().mark(function names() {
          var _iterator273, _step273, _t209;
          return _regeneratorRuntime().wrap(function names$(_context34) {
            while (1) switch (_context34.prev = _context34.next) {
              case 0:
                _iterator273 = _createForOfIteratorHelper(this._components.values());
                _context34.prev = 1;
                _iterator273.s();
              case 3:
                if ((_step273 = _iterator273.n()).done) {
                  _context34.next = 9;
                  break;
                }
                _t209 = _step273.value;
                _context34.next = 7;
                return _t209.originalName;
              case 7:
                _context34.next = 3;
                break;
              case 9:
                _context34.next = 14;
                break;
              case 11:
                _context34.prev = 11;
                _context34.t0 = _context34["catch"](1);
                _iterator273.e(_context34.t0);
              case 14:
                _context34.prev = 14;
                _iterator273.f();
                return _context34.finish(14);
              case 17:
              case "end":
                return _context34.stop();
            }
          }, names, this, [[1, 11, 14, 17]]);
        })
      }, {
        key: "add",
        value: function add(t, e) {
          this._components.set(Vl(t), {
            callback: e,
            originalName: t
          });
        }
      }, {
        key: "create",
        value: function create(t) {
          if (!this.has(t)) throw new c.a("componentfactory-item-missing", this, {
            name: t
          });
          return this._components.get(Vl(t)).callback(this.editor.locale);
        }
      }, {
        key: "has",
        value: function has(t) {
          return this._components.has(Vl(t));
        }
      }]);
      return Fl;
    }();
    function Vl(t) {
      return String(t).toLowerCase();
    }
    var Ul = /*#__PURE__*/function () {
      function Ul(t) {
        var _this89 = this;
        _classCallCheck(this, Ul);
        this.editor = t, this.componentFactory = new Fl(t), this.focusTracker = new Ys(), this._editableElementsMap = new Map(), this.listenTo(t.editing.view.document, "layoutChanged", function () {
          return _this89.update();
        });
      }
      _createClass(Ul, [{
        key: "update",
        value: function update() {
          this.fire("update");
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.stopListening(), this.focusTracker.destroy();
          var _iterator274 = _createForOfIteratorHelper(this._editableElementsMap.values()),
            _step274;
          try {
            for (_iterator274.s(); !(_step274 = _iterator274.n()).done;) {
              var _t210 = _step274.value;
              _t210.ckeditorInstance = null;
            }
          } catch (err) {
            _iterator274.e(err);
          } finally {
            _iterator274.f();
          }
          this._editableElementsMap = new Map();
        }
      }, {
        key: "setEditableElement",
        value: function setEditableElement(t, e) {
          this._editableElementsMap.set(t, e), e.ckeditorInstance || (e.ckeditorInstance = this.editor);
        }
      }, {
        key: "getEditableElement",
        value: function getEditableElement() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "main";
          return this._editableElementsMap.get(t);
        }
      }, {
        key: "getEditableElementsNames",
        value: function getEditableElementsNames() {
          return this._editableElementsMap.keys();
        }
      }, {
        key: "element",
        get: function get() {
          return null;
        }
      }, {
        key: "_editableElements",
        get: function get() {
          return console.warn("editor-ui-deprecated-editable-elements: The EditorUI#_editableElements property has been deprecated and will be removed in the near future.", {
            editorUI: this
          }), this._editableElementsMap;
        }
      }]);
      return Ul;
    }();
    $t(Ul, h);
    var Hl = {
      setData: function setData(t) {
        this.data.set(t);
      },
      getData: function getData(t) {
        return this.data.get(t);
      }
    };
    var Gl = {
      updateSourceElement: function updateSourceElement() {
        if (!this.sourceElement) throw new c.a("editor-missing-sourceelement", this);
        var t, e;
        t = this.sourceElement, e = this.data.get(), t instanceof HTMLTextAreaElement && (t.value = e), t.innerHTML = e;
      }
    };
    var Wl = /*#__PURE__*/function (_ko) {
      _inherits(Wl, _ko);
      function Wl() {
        _classCallCheck(this, Wl);
        return _possibleConstructorReturn(this, _getPrototypeOf(Wl).apply(this, arguments));
      }
      _createClass(Wl, [{
        key: "init",
        value: function init() {
          this.set("hasAny", !1), this._actions = new co({
            idProperty: "_id"
          }), this._actions.delegate("add", "remove").to(this);
        }
      }, {
        key: "add",
        value: function add(t) {
          if ("string" != typeof t) throw new c.a("pendingactions-add-invalid-message", this);
          var e = Object.create(Gt);
          return e.set("message", t), this._actions.add(e), this.hasAny = !0, e;
        }
      }, {
        key: "remove",
        value: function remove(t) {
          this._actions.remove(t), this.hasAny = !!this._actions.length;
        }
      }, {
        key: Symbol.iterator,
        value: function value() {
          return this._actions[Symbol.iterator]();
        }
      }, {
        key: "first",
        get: function get() {
          return this._actions.get(0);
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "PendingActions";
        }
      }]);
      return Wl;
    }(ko);
    var ql = {
      cancel: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m11.591 10.177 4.243 4.242a1 1 0 0 1-1.415 1.415l-4.242-4.243-4.243 4.243a1 1 0 0 1-1.414-1.415l4.243-4.242L4.52 5.934A1 1 0 0 1 5.934 4.52l4.243 4.243 4.242-4.243a1 1 0 1 1 1.415 1.414l-4.243 4.243z"/></svg>',
      caption: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 16h9a1 1 0 0 1 0 2H2a1 1 0 0 1 0-2z"/><path d="M17 1a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h14zm0 1.5H3a.5.5 0 0 0-.492.41L2.5 3v9a.5.5 0 0 0 .41.492L3 12.5h14a.5.5 0 0 0 .492-.41L17.5 12V3a.5.5 0 0 0-.41-.492L17 2.5z" fill-opacity=".6"/></svg>',
      check: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6.972 16.615a.997.997 0 0 1-.744-.292l-4.596-4.596a1 1 0 1 1 1.414-1.414l3.926 3.926 9.937-9.937a1 1 0 0 1 1.414 1.415L7.717 16.323a.997.997 0 0 1-.745.292z"/></svg>',
      eraser: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m8.636 9.531-2.758 3.94a.5.5 0 0 0 .122.696l3.224 2.284h1.314l2.636-3.736L8.636 9.53zm.288 8.451L5.14 15.396a2 2 0 0 1-.491-2.786l6.673-9.53a2 2 0 0 1 2.785-.49l3.742 2.62a2 2 0 0 1 .491 2.785l-7.269 10.053-2.147-.066z"/><path d="M4 18h5.523v-1H4zm-2 0h1v-1H2z"/></svg>',
      lowVision: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M5.085 6.22 2.943 4.078a.75.75 0 1 1 1.06-1.06l2.592 2.59A11.094 11.094 0 0 1 10 5.068c4.738 0 8.578 3.101 8.578 5.083 0 1.197-1.401 2.803-3.555 3.887l1.714 1.713a.75.75 0 0 1-.09 1.138.488.488 0 0 1-.15.084.75.75 0 0 1-.821-.16L6.17 7.304c-.258.11-.51.233-.757.365l6.239 6.24-.006.005.78.78c-.388.094-.78.166-1.174.215l-1.11-1.11h.011L4.55 8.197a7.2 7.2 0 0 0-.665.514l-.112.098 4.897 4.897-.005.006 1.276 1.276a10.164 10.164 0 0 1-1.477-.117l-.479-.479-.009.009-4.863-4.863-.022.031a2.563 2.563 0 0 0-.124.2c-.043.077-.08.158-.108.241a.534.534 0 0 0-.028.133.29.29 0 0 0 .008.072.927.927 0 0 0 .082.226c.067.133.145.26.234.379l3.242 3.365.025.01.59.623c-3.265-.918-5.59-3.155-5.59-4.668 0-1.194 1.448-2.838 3.663-3.93zm7.07.531a4.632 4.632 0 0 1 1.108 5.992l.345.344.046-.018a9.313 9.313 0 0 0 2-1.112c.256-.187.5-.392.727-.613.137-.134.27-.277.392-.431.072-.091.141-.185.203-.286.057-.093.107-.19.148-.292a.72.72 0 0 0 .036-.12.29.29 0 0 0 .008-.072.492.492 0 0 0-.028-.133.999.999 0 0 0-.036-.096 2.165 2.165 0 0 0-.071-.145 2.917 2.917 0 0 0-.125-.2 3.592 3.592 0 0 0-.263-.335 5.444 5.444 0 0 0-.53-.523 7.955 7.955 0 0 0-1.054-.768 9.766 9.766 0 0 0-1.879-.891c-.337-.118-.68-.219-1.027-.301zm-2.85.21-.069.002a.508.508 0 0 0-.254.097.496.496 0 0 0-.104.679.498.498 0 0 0 .326.199l.045.005c.091.003.181.003.272.012a2.45 2.45 0 0 1 2.017 1.513c.024.061.043.125.069.185a.494.494 0 0 0 .45.287h.008a.496.496 0 0 0 .35-.158.482.482 0 0 0 .13-.335.638.638 0 0 0-.048-.219 3.379 3.379 0 0 0-.36-.723 3.438 3.438 0 0 0-2.791-1.543l-.028-.001h-.013z"/></svg>',
      image: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6.91 10.54c.26-.23.64-.21.88.03l3.36 3.14 2.23-2.06a.64.64 0 0 1 .87 0l2.52 2.97V4.5H3.2v10.12l3.71-4.08zm10.27-7.51c.6 0 1.09.47 1.09 1.05v11.84c0 .59-.49 1.06-1.09 1.06H2.79c-.6 0-1.09-.47-1.09-1.06V4.08c0-.58.49-1.05 1.1-1.05h14.38zm-5.22 5.56a1.96 1.96 0 1 1 3.4-1.96 1.96 1.96 0 0 1-3.4 1.96z"/></svg>',
      alignBottom: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m9.239 13.938-2.88-1.663a.75.75 0 0 1 .75-1.3L9 12.067V4.75a.75.75 0 1 1 1.5 0v7.318l1.89-1.093a.75.75 0 0 1 .75 1.3l-2.879 1.663a.752.752 0 0 1-.511.187.752.752 0 0 1-.511-.187zM4.25 17a.75.75 0 1 1 0-1.5h10.5a.75.75 0 0 1 0 1.5H4.25z"/></svg>',
      alignMiddle: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M9.75 11.875a.752.752 0 0 1 .508.184l2.883 1.666a.75.75 0 0 1-.659 1.344l-.091-.044-1.892-1.093.001 4.318a.75.75 0 1 1-1.5 0v-4.317l-1.89 1.092a.75.75 0 0 1-.75-1.3l2.879-1.663a.752.752 0 0 1 .51-.187zM15.25 9a.75.75 0 1 1 0 1.5H4.75a.75.75 0 1 1 0-1.5h10.5zM9.75.375a.75.75 0 0 1 .75.75v4.318l1.89-1.093.092-.045a.75.75 0 0 1 .659 1.344l-2.883 1.667a.752.752 0 0 1-.508.184.752.752 0 0 1-.511-.187L6.359 5.65a.75.75 0 0 1 .75-1.299L9 5.442V1.125a.75.75 0 0 1 .75-.75z"/></svg>',
      alignTop: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m10.261 7.062 2.88 1.663a.75.75 0 0 1-.75 1.3L10.5 8.933v7.317a.75.75 0 1 1-1.5 0V8.932l-1.89 1.093a.75.75 0 0 1-.75-1.3l2.879-1.663a.752.752 0 0 1 .511-.187.752.752 0 0 1 .511.187zM15.25 4a.75.75 0 1 1 0 1.5H4.75a.75.75 0 0 1 0-1.5h10.5z"/></svg>',
      alignLeft: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 4c0 .414.336.75.75.75h9.929a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0-8c0 .414.336.75.75.75h9.929a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75z"/></svg>',
      alignCenter: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm2.286 4c0 .414.336.75.75.75h9.928a.75.75 0 1 0 0-1.5H5.036a.75.75 0 0 0-.75.75zm0-8c0 .414.336.75.75.75h9.928a.75.75 0 1 0 0-1.5H5.036a.75.75 0 0 0-.75.75z"/></svg>',
      alignRight: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M18 3.75a.75.75 0 0 1-.75.75H2.75a.75.75 0 1 1 0-1.5h14.5a.75.75 0 0 1 .75.75zm0 8a.75.75 0 0 1-.75.75H2.75a.75.75 0 1 1 0-1.5h14.5a.75.75 0 0 1 .75.75zm0 4a.75.75 0 0 1-.75.75H7.321a.75.75 0 1 1 0-1.5h9.929a.75.75 0 0 1 .75.75zm0-8a.75.75 0 0 1-.75.75H7.321a.75.75 0 1 1 0-1.5h9.929a.75.75 0 0 1 .75.75z"/></svg>',
      alignJustify: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 4c0 .414.336.75.75.75h9.929a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0-8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75z"/></svg>',
      objectLeft: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm11.5 9H18v1.5h-4.5zm0-3H18v1.5h-4.5zm0-3H18v1.5h-4.5zM2 15h16v1.5H2z"/><path d="M12.003 7v5.5a1 1 0 0 1-1 1H2.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H3.5V12h6.997V7.5z"/></svg>',
      objectCenter: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm0 12h16v1.5H2z"/><path d="M15.003 7v5.5a1 1 0 0 1-1 1H5.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H6.5V12h6.997V7.5z"/></svg>',
      objectRight: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm0 12h16v1.5H2zm0-9h5v1.5H2zm0 3h5v1.5H2zm0 3h5v1.5H2z"/><path d="M18.003 7v5.5a1 1 0 0 1-1 1H8.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H9.5V12h6.997V7.5z"/></svg>',
      objectFullWidth: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm0 12h16v1.5H2z"/><path d="M18 7v5.5a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1zm-1.505.5H3.504V12h12.991V7.5z"/></svg>',
      objectInline: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm11.5 9H18v1.5h-4.5zM2 15h16v1.5H2z"/><path d="M12.003 7v5.5a1 1 0 0 1-1 1H2.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H3.5V12h6.997V7.5z"/></svg>',
      objectBlockLeft: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm0 12h16v1.5H2z"/><path d="M12.003 7v5.5a1 1 0 0 1-1 1H2.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H3.5V12h6.997V7.5z"/></svg>',
      objectBlockRight: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm0 12h16v1.5H2z"/><path d="M18.003 7v5.5a1 1 0 0 1-1 1H8.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H9.5V12h6.997V7.5z"/></svg>',
      objectSizeFull: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.5 17v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zM1 15.5v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm0-2v1h-1v-1h1zm-19 0v1H0v-1h1zM14.5 2v1h-1V2h1zm2 0v1h-1V2h1zm2 0v1h-1V2h1zm-8 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm8 0v1h-1V2h1zm-10 0v1h-1V2h1z"/><path d="M18.095 2H1.905C.853 2 0 2.895 0 4v12c0 1.105.853 2 1.905 2h16.19C19.147 18 20 17.105 20 16V4c0-1.105-.853-2-1.905-2zm0 1.5c.263 0 .476.224.476.5v12c0 .276-.213.5-.476.5H1.905a.489.489 0 0 1-.476-.5V4c0-.276.213-.5.476-.5h16.19z"/></svg>',
      objectSizeLarge: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.5 17v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zM1 15.5v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm0-2v1h-1v-1h1zm-19 0v1H0v-1h1zM14.5 2v1h-1V2h1zm2 0v1h-1V2h1zm2 0v1h-1V2h1zm-8 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm8 0v1h-1V2h1zm-10 0v1h-1V2h1z"/><path d="M13 6H2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zm0 1.5a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5V8a.5.5 0 0 1 .5-.5h11z"/></svg>',
      objectSizeSmall: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.5 17v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zM1 15.5v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm0-2v1h-1v-1h1zm-19 0v1H0v-1h1zM14.5 2v1h-1V2h1zm2 0v1h-1V2h1zm2 0v1h-1V2h1zm-8 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm8 0v1h-1V2h1zm-10 0v1h-1V2h1z"/><path d="M7 10H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2zm0 1.5a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h5z"/></svg>',
      objectSizeMedium: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.5 17v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zM1 15.5v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm0-2v1h-1v-1h1zm-19 0v1H0v-1h1zM14.5 2v1h-1V2h1zm2 0v1h-1V2h1zm2 0v1h-1V2h1zm-8 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm8 0v1h-1V2h1zm-10 0v1h-1V2h1z"/><path d="M10 8H2a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2zm0 1.5a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-6a.5.5 0 0 1 .5-.5h8z"/></svg>',
      pencil: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m7.3 17.37-.061.088a1.518 1.518 0 0 1-.934.535l-4.178.663-.806-4.153a1.495 1.495 0 0 1 .187-1.058l.056-.086L8.77 2.639c.958-1.351 2.803-1.076 4.296-.03 1.497 1.047 2.387 2.693 1.433 4.055L7.3 17.37zM9.14 4.728l-5.545 8.346 3.277 2.294 5.544-8.346L9.14 4.728zM6.07 16.512l-3.276-2.295.53 2.73 2.746-.435zM9.994 3.506 13.271 5.8c.316-.452-.16-1.333-1.065-1.966-.905-.634-1.895-.78-2.212-.328zM8 18.5 9.375 17H19v1.5H8z"/></svg>',
      pilcrow: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6.999 2H15a1 1 0 0 1 0 2h-1.004v13a1 1 0 1 1-2 0V4H8.999v13a1 1 0 1 1-2 0v-7A4 4 0 0 1 3 6a4 4 0 0 1 3.999-4z"/></svg>',
      quote: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3 10.423a6.5 6.5 0 0 1 6.056-6.408l.038.67C6.448 5.423 5.354 7.663 5.22 10H9c.552 0 .5.432.5.986v4.511c0 .554-.448.503-1 .503h-5c-.552 0-.5-.449-.5-1.003v-4.574zm8 0a6.5 6.5 0 0 1 6.056-6.408l.038.67c-2.646.739-3.74 2.979-3.873 5.315H17c.552 0 .5.432.5.986v4.511c0 .554-.448.503-1 .503h-5c-.552 0-.5-.449-.5-1.003v-4.574z"/></svg>',
      threeVerticalDots: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><circle cx="9.5" cy="4.5" r="1.5"/><circle cx="9.5" cy="10.5" r="1.5"/><circle cx="9.5" cy="16.5" r="1.5"/></svg>'
    };
    function Kl(_ref26) {
      var t = _ref26.emitter,
        e = _ref26.activator,
        n = _ref26.callback,
        o = _ref26.contextElements;
      t.listenTo(document, "mousedown", function (t, i) {
        if (!e()) return;
        var r = "function" == typeof i.composedPath ? i.composedPath() : [];
        var _iterator275 = _createForOfIteratorHelper(o),
          _step275;
        try {
          for (_iterator275.s(); !(_step275 = _iterator275.n()).done;) {
            var _t211 = _step275.value;
            if (_t211.contains(i.target) || r.includes(_t211)) return;
          }
        } catch (err) {
          _iterator275.e(err);
        } finally {
          _iterator275.f();
        }
        n();
      });
    }
    function Yl(t) {
      t.set("_isCssTransitionsDisabled", !1), t.disableCssTransitions = function () {
        t._isCssTransitionsDisabled = !0;
      }, t.enableCssTransitions = function () {
        t._isCssTransitionsDisabled = !1;
      }, t.extendTemplate({
        attributes: {
          class: [t.bindTemplate.if("_isCssTransitionsDisabled", "ck-transitions-disabled")]
        }
      });
    }
    function Ql(_ref27) {
      var t = _ref27.view;
      t.listenTo(t.element, "submit", function (e, n) {
        n.preventDefault(), t.fire("submit");
      }, {
        useCapture: !0
      });
    }
    var $l = /*#__PURE__*/function (_co) {
      _inherits($l, _co);
      function $l() {
        var _this90;
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        _classCallCheck(this, $l);
        _this90 = _possibleConstructorReturn(this, _getPrototypeOf($l).call(this, t, {
          idProperty: "viewUid"
        })), _this90.on("add", function (t, e, n) {
          _this90._renderViewIntoCollectionParent(e, n);
        }), _this90.on("remove", function (t, e) {
          e.element && _this90._parentElement && e.element.remove();
        }), _this90._parentElement = null;
        return _this90;
      }
      _createClass($l, [{
        key: "destroy",
        value: function destroy() {
          this.map(function (t) {
            return t.destroy();
          });
        }
      }, {
        key: "setParent",
        value: function setParent(t) {
          this._parentElement = t;
          var _iterator276 = _createForOfIteratorHelper(this),
            _step276;
          try {
            for (_iterator276.s(); !(_step276 = _iterator276.n()).done;) {
              var _t212 = _step276.value;
              this._renderViewIntoCollectionParent(_t212);
            }
          } catch (err) {
            _iterator276.e(err);
          } finally {
            _iterator276.f();
          }
        }
      }, {
        key: "delegate",
        value: function delegate() {
          var _this91 = this;
          for (var _len20 = arguments.length, t = new Array(_len20), _key20 = 0; _key20 < _len20; _key20++) {
            t[_key20] = arguments[_key20];
          }
          if (!t.length || !t.every(function (t) {
            return "string" == typeof t;
          })) throw new c.a("ui-viewcollection-delegate-wrong-events", this);
          return {
            to: function to(e) {
              var _iterator277 = _createForOfIteratorHelper(_this91),
                _step277;
              try {
                for (_iterator277.s(); !(_step277 = _iterator277.n()).done;) {
                  var _n189 = _step277.value;
                  for (var _i100 = 0, _t215 = t; _i100 < _t215.length; _i100++) {
                    var _o105 = _t215[_i100];
                    _n189.delegate(_o105).to(e);
                  }
                }
              } catch (err) {
                _iterator277.e(err);
              } finally {
                _iterator277.f();
              }
              _this91.on("add", function (n, o) {
                for (var _i98 = 0, _t213 = t; _i98 < _t213.length; _i98++) {
                  var _n187 = _t213[_i98];
                  o.delegate(_n187).to(e);
                }
              }), _this91.on("remove", function (n, o) {
                for (var _i99 = 0, _t214 = t; _i99 < _t214.length; _i99++) {
                  var _n188 = _t214[_i99];
                  o.stopDelegating(_n188, e);
                }
              });
            }
          };
        }
      }, {
        key: "_renderViewIntoCollectionParent",
        value: function _renderViewIntoCollectionParent(t, e) {
          t.isRendered || t.render(), t.element && this._parentElement && this._parentElement.insertBefore(t.element, this._parentElement.children[e]);
        }
      }]);
      return $l;
    }(co);
    var Jl = n(1),
      Zl = n.n(Jl),
      Xl = n(12),
      td = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Zl()(Xl.a, td), Xl.a.locals;
    var ed = /*#__PURE__*/function () {
      function ed(t) {
        _classCallCheck(this, ed);
        this.element = null, this.isRendered = !1, this.locale = t, this.t = t && t.t, this._viewCollections = new co(), this._unboundChildren = this.createCollection(), this._viewCollections.on("add", function (e, n) {
          n.locale = t;
        }), this.decorate("render");
      }
      _createClass(ed, [{
        key: "createCollection",
        value: function createCollection(t) {
          var e = new $l(t);
          return this._viewCollections.add(e), e;
        }
      }, {
        key: "registerChild",
        value: function registerChild(t) {
          ao(t) || (t = [t]);
          var _iterator278 = _createForOfIteratorHelper(t),
            _step278;
          try {
            for (_iterator278.s(); !(_step278 = _iterator278.n()).done;) {
              var _e213 = _step278.value;
              this._unboundChildren.add(_e213);
            }
          } catch (err) {
            _iterator278.e(err);
          } finally {
            _iterator278.f();
          }
        }
      }, {
        key: "deregisterChild",
        value: function deregisterChild(t) {
          ao(t) || (t = [t]);
          var _iterator279 = _createForOfIteratorHelper(t),
            _step279;
          try {
            for (_iterator279.s(); !(_step279 = _iterator279.n()).done;) {
              var _e214 = _step279.value;
              this._unboundChildren.remove(_e214);
            }
          } catch (err) {
            _iterator279.e(err);
          } finally {
            _iterator279.f();
          }
        }
      }, {
        key: "setTemplate",
        value: function setTemplate(t) {
          this.template = new nd(t);
        }
      }, {
        key: "extendTemplate",
        value: function extendTemplate(t) {
          nd.extend(this.template, t);
        }
      }, {
        key: "render",
        value: function render() {
          if (this.isRendered) throw new c.a("ui-view-render-already-rendered", this);
          this.template && (this.element = this.template.render(), this.registerChild(this.template.getViews())), this.isRendered = !0;
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.stopListening(), this._viewCollections.map(function (t) {
            return t.destroy();
          }), this.template && this.template._revertData && this.template.revert(this.element);
        }
      }, {
        key: "bindTemplate",
        get: function get() {
          return this._bindTemplate ? this._bindTemplate : this._bindTemplate = nd.bind(this, this);
        }
      }]);
      return ed;
    }();
    $t(ed, Ur), $t(ed, Gt);
    var nd = /*#__PURE__*/function () {
      function nd(t) {
        _classCallCheck(this, nd);
        Object.assign(this, ud(hd(t))), this._isRendered = !1, this._revertData = null;
      }
      _createClass(nd, [{
        key: "render",
        value: function render() {
          var t = this._renderNode({
            intoFragment: !0
          });
          return this._isRendered = !0, t;
        }
      }, {
        key: "apply",
        value: function apply(t) {
          return this._revertData = {
            children: [],
            bindings: [],
            attributes: {}
          }, this._renderNode({
            node: t,
            isApplying: !0,
            revertData: this._revertData
          }), t;
        }
      }, {
        key: "revert",
        value: function revert(t) {
          if (!this._revertData) throw new c.a("ui-template-revert-not-applied", [this, t]);
          this._revertTemplateFromNode(t, this._revertData);
        }
      }, {
        key: "getViews",
        value: /*#__PURE__*/_regeneratorRuntime().mark(function getViews() {
          return _regeneratorRuntime().wrap(function getViews$(_context36) {
            while (1) switch (_context36.prev = _context36.next) {
              case 0:
                return _context36.delegateYield( /*#__PURE__*/_regeneratorRuntime().mark(function t(e) {
                  var _iterator280, _step280, _n190;
                  return _regeneratorRuntime().wrap(function t$(_context35) {
                    while (1) switch (_context35.prev = _context35.next) {
                      case 0:
                        if (!e.children) {
                          _context35.next = 24;
                          break;
                        }
                        _iterator280 = _createForOfIteratorHelper(e.children);
                        _context35.prev = 2;
                        _iterator280.s();
                      case 4:
                        if ((_step280 = _iterator280.n()).done) {
                          _context35.next = 16;
                          break;
                        }
                        _n190 = _step280.value;
                        if (!bd(_n190)) {
                          _context35.next = 11;
                          break;
                        }
                        _context35.next = 9;
                        return _n190;
                      case 9:
                        _context35.next = 14;
                        break;
                      case 11:
                        _context35.t0 = wd(_n190);
                        if (!_context35.t0) {
                          _context35.next = 14;
                          break;
                        }
                        return _context35.delegateYield(t(_n190), "t1", 14);
                      case 14:
                        _context35.next = 4;
                        break;
                      case 16:
                        _context35.next = 21;
                        break;
                      case 18:
                        _context35.prev = 18;
                        _context35.t2 = _context35["catch"](2);
                        _iterator280.e(_context35.t2);
                      case 21:
                        _context35.prev = 21;
                        _iterator280.f();
                        return _context35.finish(21);
                      case 24:
                      case "end":
                        return _context35.stop();
                    }
                  }, t, null, [[2, 18, 21, 24]]);
                })(this), "t0", 1);
              case 1:
              case "end":
                return _context36.stop();
            }
          }, getViews, this);
        })
      }, {
        key: "_renderNode",
        value: function _renderNode(t) {
          var e;
          if (e = t.node ? this.tag && this.text : this.tag ? this.text : !this.text, e) throw new c.a("ui-template-wrong-syntax", this);
          return this.text ? this._renderText(t) : this._renderElement(t);
        }
      }, {
        key: "_renderElement",
        value: function _renderElement(t) {
          var e = t.node;
          return e || (e = t.node = document.createElementNS(this.ns || "http://www.w3.org/1999/xhtml", this.tag)), this._renderAttributes(t), this._renderElementChildren(t), this._setUpListeners(t), e;
        }
      }, {
        key: "_renderText",
        value: function _renderText(t) {
          var e = t.node;
          return e ? t.revertData.text = e.textContent : e = t.node = document.createTextNode(""), sd(this.text) ? this._bindToObservable({
            schema: this.text,
            updater: cd(e),
            data: t
          }) : e.textContent = this.text.join(""), e;
        }
      }, {
        key: "_renderAttributes",
        value: function _renderAttributes(t) {
          var e, n, o, i;
          if (!this.attributes) return;
          var r = t.node,
            s = t.revertData;
          for (e in this.attributes) if (o = r.getAttribute(e), n = this.attributes[e], s && (s.attributes[e] = o), i = w(n[0]) && n[0].ns ? n[0].ns : null, sd(n)) {
            var _a13 = i ? n[0].value : n;
            s && Ad(e) && _a13.unshift(o), this._bindToObservable({
              schema: _a13,
              updater: ld(r, e, i),
              data: t
            });
          } else "style" == e && "string" != typeof n[0] ? this._renderStyleAttribute(n[0], t) : (s && o && Ad(e) && n.unshift(o), n = n.map(function (t) {
            return t && t.value || t;
          }).reduce(function (t, e) {
            return t.concat(e);
          }, []).reduce(md, ""), kd(n) || r.setAttributeNS(i, e, n));
        }
      }, {
        key: "_renderStyleAttribute",
        value: function _renderStyleAttribute(t, e) {
          var n = e.node;
          for (var _o107 in t) {
            var _i101 = t[_o107];
            sd(_i101) ? this._bindToObservable({
              schema: [_i101],
              updater: dd(n, _o107),
              data: e
            }) : n.style[_o107] = _i101;
          }
        }
      }, {
        key: "_renderElementChildren",
        value: function _renderElementChildren(t) {
          var e = t.node,
            n = t.intoFragment ? document.createDocumentFragment() : e,
            o = t.isApplying;
          var i = 0;
          var _iterator281 = _createForOfIteratorHelper(this.children),
            _step281;
          try {
            for (_iterator281.s(); !(_step281 = _iterator281.n()).done;) {
              var _r35 = _step281.value;
              if (Cd(_r35)) {
                if (!o) {
                  _r35.setParent(e);
                  var _iterator282 = _createForOfIteratorHelper(_r35),
                    _step282;
                  try {
                    for (_iterator282.s(); !(_step282 = _iterator282.n()).done;) {
                      var _t216 = _step282.value;
                      n.appendChild(_t216.element);
                    }
                  } catch (err) {
                    _iterator282.e(err);
                  } finally {
                    _iterator282.f();
                  }
                }
              } else if (bd(_r35)) o || (_r35.isRendered || _r35.render(), n.appendChild(_r35.element));else if (Er(_r35)) n.appendChild(_r35);else if (o) {
                var _e215 = {
                  children: [],
                  bindings: [],
                  attributes: {}
                };
                t.revertData.children.push(_e215), _r35._renderNode({
                  node: n.childNodes[i++],
                  isApplying: !0,
                  revertData: _e215
                });
              } else n.appendChild(_r35.render());
            }
          } catch (err) {
            _iterator281.e(err);
          } finally {
            _iterator281.f();
          }
          t.intoFragment && e.appendChild(n);
        }
      }, {
        key: "_setUpListeners",
        value: function _setUpListeners(t) {
          var _this92 = this;
          if (this.eventListeners) {
            var _loop4 = function _loop4(_e216) {
              var n = _this92.eventListeners[_e216].map(function (n) {
                var _e216$split = _e216.split("@"),
                  _e216$split2 = _slicedToArray(_e216$split, 2),
                  o = _e216$split2[0],
                  i = _e216$split2[1];
                return n.activateDomEventListener(o, i, t);
              });
              t.revertData && t.revertData.bindings.push(n);
            };
            for (var _e216 in this.eventListeners) {
              _loop4(_e216);
            }
          }
        }
      }, {
        key: "_bindToObservable",
        value: function _bindToObservable(_ref28) {
          var t = _ref28.schema,
            e = _ref28.updater,
            n = _ref28.data;
          var o = n.revertData;
          ad(t, e, n);
          var i = t.filter(function (t) {
            return !kd(t);
          }).filter(function (t) {
            return t.observable;
          }).map(function (o) {
            return o.activateAttributeListener(t, e, n);
          });
          o && o.bindings.push(i);
        }
      }, {
        key: "_revertTemplateFromNode",
        value: function _revertTemplateFromNode(t, e) {
          var _iterator283 = _createForOfIteratorHelper(e.bindings),
            _step283;
          try {
            for (_iterator283.s(); !(_step283 = _iterator283.n()).done;) {
              var _t217 = _step283.value;
              var _iterator284 = _createForOfIteratorHelper(_t217),
                _step284;
              try {
                for (_iterator284.s(); !(_step284 = _iterator284.n()).done;) {
                  var _e217 = _step284.value;
                  _e217();
                }
              } catch (err) {
                _iterator284.e(err);
              } finally {
                _iterator284.f();
              }
            }
          } catch (err) {
            _iterator283.e(err);
          } finally {
            _iterator283.f();
          }
          if (e.text) t.textContent = e.text;else {
            for (var _n192 in e.attributes) {
              var _o108 = e.attributes[_n192];
              null === _o108 ? t.removeAttribute(_n192) : t.setAttribute(_n192, _o108);
            }
            for (var _n194 = 0; _n194 < e.children.length; ++_n194) this._revertTemplateFromNode(t.childNodes[_n194], e.children[_n194]);
          }
        }
      }], [{
        key: "bind",
        value: function bind(t, e) {
          return {
            to: function to(n, o) {
              return new id({
                eventNameOrFunction: n,
                attribute: n,
                observable: t,
                emitter: e,
                callback: o
              });
            },
            if: function _if(n, o, i) {
              return new rd({
                observable: t,
                emitter: e,
                attribute: n,
                valueIfTrue: o,
                callback: i
              });
            }
          };
        }
      }, {
        key: "extend",
        value: function extend(t, e) {
          if (t._isRendered) throw new c.a("template-extend-render", [this, t]);
          fd(t, ud(hd(e)));
        }
      }]);
      return nd;
    }();
    $t(nd, h);
    var od = /*#__PURE__*/function () {
      function od(t) {
        _classCallCheck(this, od);
        Object.assign(this, t);
      }
      _createClass(od, [{
        key: "getValue",
        value: function getValue(t) {
          var e = this.observable[this.attribute];
          return this.callback ? this.callback(e, t) : e;
        }
      }, {
        key: "activateAttributeListener",
        value: function activateAttributeListener(t, e, n) {
          var _this93 = this;
          var o = function o() {
            return ad(t, e, n);
          };
          return this.emitter.listenTo(this.observable, "change:" + this.attribute, o), function () {
            _this93.emitter.stopListening(_this93.observable, "change:" + _this93.attribute, o);
          };
        }
      }]);
      return od;
    }();
    var id = /*#__PURE__*/function (_od) {
      _inherits(id, _od);
      function id() {
        _classCallCheck(this, id);
        return _possibleConstructorReturn(this, _getPrototypeOf(id).apply(this, arguments));
      }
      _createClass(id, [{
        key: "activateDomEventListener",
        value: function activateDomEventListener(t, e, n) {
          var _this94 = this;
          var o = function o(t, n) {
            e && !n.target.matches(e) || ("function" == typeof _this94.eventNameOrFunction ? _this94.eventNameOrFunction(n) : _this94.observable.fire(_this94.eventNameOrFunction, n));
          };
          return this.emitter.listenTo(n.node, t, o), function () {
            _this94.emitter.stopListening(n.node, t, o);
          };
        }
      }]);
      return id;
    }(od);
    var rd = /*#__PURE__*/function (_od2) {
      _inherits(rd, _od2);
      function rd() {
        _classCallCheck(this, rd);
        return _possibleConstructorReturn(this, _getPrototypeOf(rd).apply(this, arguments));
      }
      _createClass(rd, [{
        key: "getValue",
        value: function getValue(t) {
          return !kd(_get(_getPrototypeOf(rd.prototype), "getValue", this).call(this, t)) && (this.valueIfTrue || !0);
        }
      }]);
      return rd;
    }(od);
    function sd(t) {
      return !!t && (t.value && (t = t.value), Array.isArray(t) ? t.some(sd) : t instanceof od);
    }
    function ad(t, e, _ref29) {
      var n = _ref29.node;
      var o = function (t, e) {
        return t.map(function (t) {
          return t instanceof od ? t.getValue(e) : t;
        });
      }(t, n);
      o = 1 == t.length && t[0] instanceof rd ? o[0] : o.reduce(md, ""), kd(o) ? e.remove() : e.set(o);
    }
    function cd(t) {
      return {
        set: function set(e) {
          t.textContent = e;
        },
        remove: function remove() {
          t.textContent = "";
        }
      };
    }
    function ld(t, e, n) {
      return {
        set: function set(o) {
          t.setAttributeNS(n, e, o);
        },
        remove: function remove() {
          t.removeAttributeNS(n, e);
        }
      };
    }
    function dd(t, e) {
      return {
        set: function set(n) {
          t.style[e] = n;
        },
        remove: function remove() {
          t.style[e] = null;
        }
      };
    }
    function hd(t) {
      return no(t, function (t) {
        if (t && (t instanceof od || wd(t) || bd(t) || Cd(t))) return t;
      });
    }
    function ud(t) {
      if ("string" == typeof t ? t = function (t) {
        return {
          text: [t]
        };
      }(t) : t.text && function (t) {
        t.text = ho(t.text);
      }(t), t.on && (t.eventListeners = function (t) {
        for (var _e219 in t) gd(t, _e219);
        return t;
      }(t.on), delete t.on), !t.text) {
        t.attributes && function (t) {
          for (var _e221 in t) t[_e221].value && (t[_e221].value = ho(t[_e221].value)), gd(t, _e221);
        }(t.attributes);
        var _e222 = [];
        if (t.children) if (Cd(t.children)) _e222.push(t.children);else {
          var _iterator285 = _createForOfIteratorHelper(t.children),
            _step285;
          try {
            for (_iterator285.s(); !(_step285 = _iterator285.n()).done;) {
              var _n195 = _step285.value;
              wd(_n195) || bd(_n195) || Er(_n195) ? _e222.push(_n195) : _e222.push(new nd(_n195));
            }
          } catch (err) {
            _iterator285.e(err);
          } finally {
            _iterator285.f();
          }
        }
        t.children = _e222;
      }
      return t;
    }
    function gd(t, e) {
      t[e] = ho(t[e]);
    }
    function md(t, e) {
      return kd(e) ? t : kd(t) ? e : "".concat(t, " ").concat(e);
    }
    function pd(t, e) {
      for (var _n197 in e) {
        var _t$_n;
        t[_n197] ? (_t$_n = t[_n197]).push.apply(_t$_n, _toConsumableArray(e[_n197])) : t[_n197] = e[_n197];
      }
    }
    function fd(t, e) {
      var _t$text;
      if (e.attributes && (t.attributes || (t.attributes = {}), pd(t.attributes, e.attributes)), e.eventListeners && (t.eventListeners || (t.eventListeners = {}), pd(t.eventListeners, e.eventListeners)), e.text && (_t$text = t.text).push.apply(_t$text, _toConsumableArray(e.text)), e.children && e.children.length) {
        if (t.children.length != e.children.length) throw new c.a("ui-template-extend-children-mismatch", t);
        var _n198 = 0;
        var _iterator286 = _createForOfIteratorHelper(e.children),
          _step286;
        try {
          for (_iterator286.s(); !(_step286 = _iterator286.n()).done;) {
            var _o109 = _step286.value;
            fd(t.children[_n198++], _o109);
          }
        } catch (err) {
          _iterator286.e(err);
        } finally {
          _iterator286.f();
        }
      }
    }
    function kd(t) {
      return !t && 0 !== t;
    }
    function bd(t) {
      return t instanceof ed;
    }
    function wd(t) {
      return t instanceof nd;
    }
    function Cd(t) {
      return t instanceof $l;
    }
    function Ad(t) {
      return "class" == t || "style" == t;
    }
    var _d = /*#__PURE__*/function (_$l) {
      _inherits(_d, _$l);
      function _d(t) {
        var _this95;
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        _classCallCheck(this, _d);
        _this95 = _possibleConstructorReturn(this, _getPrototypeOf(_d).call(this, e)), _this95.locale = t;
        return _this95;
      }
      _createClass(_d, [{
        key: "attachToDom",
        value: function attachToDom() {
          this._bodyCollectionContainer = new nd({
            tag: "div",
            attributes: {
              class: ["ck", "ck-reset_all", "ck-body", "ck-rounded-corners"],
              dir: this.locale.uiLanguageDirection
            },
            children: this
          }).render();
          var t = document.querySelector(".ck-body-wrapper");
          t || (t = Os(document, "div", {
            class: "ck-body-wrapper"
          }), document.body.appendChild(t)), t.appendChild(this._bodyCollectionContainer);
        }
      }, {
        key: "detachFromDom",
        value: function detachFromDom() {
          _get(_getPrototypeOf(_d.prototype), "destroy", this).call(this), this._bodyCollectionContainer && this._bodyCollectionContainer.remove();
          var t = document.querySelector(".ck-body-wrapper");
          t && 0 == t.childElementCount && t.remove();
        }
      }]);
      return _d;
    }($l);
    var vd = n(13),
      yd = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Zl()(vd.a, yd), vd.a.locals;
    var xd = /*#__PURE__*/function (_ed) {
      _inherits(xd, _ed);
      function xd() {
        var _this96;
        _classCallCheck(this, xd);
        _this96 = _possibleConstructorReturn(this, _getPrototypeOf(xd).call(this));
        var t = _this96.bindTemplate;
        _this96.set("content", ""), _this96.set("viewBox", "0 0 20 20"), _this96.set("fillColor", ""), _this96.setTemplate({
          tag: "svg",
          ns: "http://www.w3.org/2000/svg",
          attributes: {
            class: ["ck", "ck-icon"],
            viewBox: t.to("viewBox")
          }
        });
        return _this96;
      }
      _createClass(xd, [{
        key: "render",
        value: function render() {
          var _this97 = this;
          _get(_getPrototypeOf(xd.prototype), "render", this).call(this), this._updateXMLContent(), this._colorFillPaths(), this.on("change:content", function () {
            _this97._updateXMLContent(), _this97._colorFillPaths();
          }), this.on("change:fillColor", function () {
            _this97._colorFillPaths();
          });
        }
      }, {
        key: "_updateXMLContent",
        value: function _updateXMLContent() {
          if (this.content) {
            var _t218 = new DOMParser().parseFromString(this.content.trim(), "image/svg+xml").querySelector("svg"),
              _e223 = _t218.getAttribute("viewBox");
            for (_e223 && (this.viewBox = _e223), this.element.innerHTML = ""; _t218.childNodes.length > 0;) this.element.appendChild(_t218.childNodes[0]);
          }
        }
      }, {
        key: "_colorFillPaths",
        value: function _colorFillPaths() {
          var _this98 = this;
          this.fillColor && this.element.querySelectorAll(".ck-icon__fill").forEach(function (t) {
            t.style.fill = _this98.fillColor;
          });
        }
      }]);
      return xd;
    }(ed);
    var Ed = n(14),
      Dd = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Zl()(Ed.a, Dd), Ed.a.locals;
    var Md = /*#__PURE__*/function (_ed2) {
      _inherits(Md, _ed2);
      function Md(t) {
        var _this99;
        _classCallCheck(this, Md);
        _this99 = _possibleConstructorReturn(this, _getPrototypeOf(Md).call(this, t)), _this99.set("text", ""), _this99.set("position", "s");
        var e = _this99.bindTemplate;
        _this99.setTemplate({
          tag: "span",
          attributes: {
            class: ["ck", "ck-tooltip", e.to("position", function (t) {
              return "ck-tooltip_" + t;
            }), e.if("text", "ck-hidden", function (t) {
              return !t.trim();
            })]
          },
          children: [{
            tag: "span",
            attributes: {
              class: ["ck", "ck-tooltip__text"]
            },
            children: [{
              text: e.to("text")
            }]
          }]
        });
        return _this99;
      }
      return Md;
    }(ed);
    var Id = n(15),
      Td = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Zl()(Id.a, Td), Id.a.locals;
    var Sd = /*#__PURE__*/function (_ed3) {
      _inherits(Sd, _ed3);
      function Sd(t) {
        var _this100;
        _classCallCheck(this, Sd);
        _this100 = _possibleConstructorReturn(this, _getPrototypeOf(Sd).call(this, t));
        var e = _this100.bindTemplate,
          n = s();
        _this100.set("class"), _this100.set("labelStyle"), _this100.set("icon"), _this100.set("isEnabled", !0), _this100.set("isOn", !1), _this100.set("isVisible", !0), _this100.set("isToggleable", !1), _this100.set("keystroke"), _this100.set("label"), _this100.set("tabindex", -1), _this100.set("tooltip"), _this100.set("tooltipPosition", "s"), _this100.set("type", "button"), _this100.set("withText", !1), _this100.set("withKeystroke", !1), _this100.children = _this100.createCollection(), _this100.tooltipView = _this100._createTooltipView(), _this100.labelView = _this100._createLabelView(n), _this100.iconView = new xd(), _this100.iconView.extendTemplate({
          attributes: {
            class: "ck-button__icon"
          }
        }), _this100.keystrokeView = _this100._createKeystrokeView(), _this100.bind("_tooltipString").to(_assertThisInitialized(_assertThisInitialized(_this100)), "tooltip", _assertThisInitialized(_assertThisInitialized(_this100)), "label", _assertThisInitialized(_assertThisInitialized(_this100)), "keystroke", _this100._getTooltipString.bind(_assertThisInitialized(_assertThisInitialized(_this100)))), _this100.setTemplate({
          tag: "button",
          attributes: {
            class: ["ck", "ck-button", e.to("class"), e.if("isEnabled", "ck-disabled", function (t) {
              return !t;
            }), e.if("isVisible", "ck-hidden", function (t) {
              return !t;
            }), e.to("isOn", function (t) {
              return t ? "ck-on" : "ck-off";
            }), e.if("withText", "ck-button_with-text"), e.if("withKeystroke", "ck-button_with-keystroke")],
            type: e.to("type", function (t) {
              return t || "button";
            }),
            tabindex: e.to("tabindex"),
            "aria-labelledby": "ck-editor__aria-label_".concat(n),
            "aria-disabled": e.if("isEnabled", !0, function (t) {
              return !t;
            }),
            "aria-pressed": e.to("isOn", function (t) {
              return !!_this100.isToggleable && String(t);
            })
          },
          children: _this100.children,
          on: {
            mousedown: e.to(function (t) {
              t.preventDefault();
            }),
            click: e.to(function (t) {
              _this100.isEnabled ? _this100.fire("execute") : t.preventDefault();
            })
          }
        });
        return _this100;
      }
      _createClass(Sd, [{
        key: "render",
        value: function render() {
          _get(_getPrototypeOf(Sd.prototype), "render", this).call(this), this.icon && (this.iconView.bind("content").to(this, "icon"), this.children.add(this.iconView)), this.children.add(this.tooltipView), this.children.add(this.labelView), this.withKeystroke && this.children.add(this.keystrokeView);
        }
      }, {
        key: "focus",
        value: function focus() {
          this.element.focus();
        }
      }, {
        key: "_createTooltipView",
        value: function _createTooltipView() {
          var t = new Md();
          return t.bind("text").to(this, "_tooltipString"), t.bind("position").to(this, "tooltipPosition"), t;
        }
      }, {
        key: "_createLabelView",
        value: function _createLabelView(t) {
          var e = new ed(),
            n = this.bindTemplate;
          return e.setTemplate({
            tag: "span",
            attributes: {
              class: ["ck", "ck-button__label"],
              style: n.to("labelStyle"),
              id: "ck-editor__aria-label_".concat(t)
            },
            children: [{
              text: this.bindTemplate.to("label")
            }]
          }), e;
        }
      }, {
        key: "_createKeystrokeView",
        value: function _createKeystrokeView() {
          var t = new ed();
          return t.setTemplate({
            tag: "span",
            attributes: {
              class: ["ck", "ck-button__keystroke"]
            },
            children: [{
              text: this.bindTemplate.to("keystroke", function (t) {
                return Wi(t);
              })
            }]
          }), t;
        }
      }, {
        key: "_getTooltipString",
        value: function _getTooltipString(t, e, n) {
          return t ? "string" == typeof t ? t : (n && (n = Wi(n)), t instanceof Function ? t(e, n) : "".concat(e).concat(n ? " (".concat(n, ")") : "")) : "";
        }
      }]);
      return Sd;
    }(ed);
    var Nd = n(16),
      Bd = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Zl()(Nd.a, Bd), Nd.a.locals;
    var Pd = /*#__PURE__*/function (_Sd) {
      _inherits(Pd, _Sd);
      function Pd(t) {
        var _this101;
        _classCallCheck(this, Pd);
        _this101 = _possibleConstructorReturn(this, _getPrototypeOf(Pd).call(this, t)), _this101.isToggleable = !0, _this101.toggleSwitchView = _this101._createToggleView(), _this101.extendTemplate({
          attributes: {
            class: "ck-switchbutton"
          }
        });
        return _this101;
      }
      _createClass(Pd, [{
        key: "render",
        value: function render() {
          _get(_getPrototypeOf(Pd.prototype), "render", this).call(this), this.children.add(this.toggleSwitchView);
        }
      }, {
        key: "_createToggleView",
        value: function _createToggleView() {
          var t = new ed();
          return t.setTemplate({
            tag: "span",
            attributes: {
              class: ["ck", "ck-button__toggle"]
            },
            children: [{
              tag: "span",
              attributes: {
                class: ["ck", "ck-button__toggle__inner"]
              }
            }]
          }), t;
        }
      }]);
      return Pd;
    }(Sd);
    function zd(t) {
      return "string" == typeof t ? {
        model: t,
        label: t,
        hasBorder: !1,
        view: {
          name: "span",
          styles: {
            color: t
          }
        }
      } : {
        model: t.color,
        label: t.label || t.color,
        hasBorder: void 0 !== t.hasBorder && t.hasBorder,
        view: {
          name: "span",
          styles: {
            color: "".concat(t.color)
          }
        }
      };
    }
    var Ld = /*#__PURE__*/function (_Sd2) {
      _inherits(Ld, _Sd2);
      function Ld(t) {
        var _this102;
        _classCallCheck(this, Ld);
        _this102 = _possibleConstructorReturn(this, _getPrototypeOf(Ld).call(this, t));
        var e = _this102.bindTemplate;
        _this102.set("color"), _this102.set("hasBorder"), _this102.icon = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path class="ck-icon__fill" d="M16.935 5.328a2 2 0 0 1 0 2.829l-7.778 7.778a2 2 0 0 1-2.829 0L3.5 13.107a1.999 1.999 0 1 1 2.828-2.829l.707.707a1 1 0 0 0 1.414 0l5.658-5.657a2 2 0 0 1 2.828 0z"/><path d="M14.814 6.035 8.448 12.4a1 1 0 0 1-1.414 0l-1.413-1.415A1 1 0 1 0 4.207 12.4l2.829 2.829a1 1 0 0 0 1.414 0l7.778-7.778a1 1 0 1 0-1.414-1.415z"/></svg>', _this102.extendTemplate({
          attributes: {
            style: {
              backgroundColor: e.to("color")
            },
            class: ["ck", "ck-color-grid__tile", e.if("hasBorder", "ck-color-table__color-tile_bordered")]
          }
        });
        return _this102;
      }
      _createClass(Ld, [{
        key: "render",
        value: function render() {
          _get(_getPrototypeOf(Ld.prototype), "render", this).call(this), this.iconView.fillColor = "hsl(0, 0%, 100%)";
        }
      }]);
      return Ld;
    }(Sd);
    var Od = /*#__PURE__*/function () {
      function Od(t) {
        var _this103 = this;
        _classCallCheck(this, Od);
        if (Object.assign(this, t), t.actions && t.keystrokeHandler) {
          var _loop5 = function _loop5(_e224) {
            var n = t.actions[_e224];
            "string" == typeof n && (n = [n]);
            var _iterator287 = _createForOfIteratorHelper(n),
              _step287;
            try {
              for (_iterator287.s(); !(_step287 = _iterator287.n()).done;) {
                var _o110 = _step287.value;
                t.keystrokeHandler.set(_o110, function (t, n) {
                  _this103[_e224](), n();
                });
              }
            } catch (err) {
              _iterator287.e(err);
            } finally {
              _iterator287.f();
            }
          };
          for (var _e224 in t.actions) {
            _loop5(_e224);
          }
        }
      }
      _createClass(Od, [{
        key: "focusFirst",
        value: function focusFirst() {
          this._focus(this.first);
        }
      }, {
        key: "focusLast",
        value: function focusLast() {
          this._focus(this.last);
        }
      }, {
        key: "focusNext",
        value: function focusNext() {
          this._focus(this.next);
        }
      }, {
        key: "focusPrevious",
        value: function focusPrevious() {
          this._focus(this.previous);
        }
      }, {
        key: "_focus",
        value: function _focus(t) {
          t && t.focus();
        }
      }, {
        key: "_getFocusableItem",
        value: function _getFocusableItem(t) {
          var e = this.current,
            n = this.focusables.length;
          if (!n) return null;
          if (null === e) return this[1 === t ? "first" : "last"];
          var o = (e + n + t) % n;
          do {
            var _e225 = this.focusables.get(o);
            if (Rd(_e225)) return _e225;
            o = (o + n + t) % n;
          } while (o !== e);
          return null;
        }
      }, {
        key: "first",
        get: function get() {
          return this.focusables.find(Rd) || null;
        }
      }, {
        key: "last",
        get: function get() {
          return this.focusables.filter(Rd).slice(-1)[0] || null;
        }
      }, {
        key: "next",
        get: function get() {
          return this._getFocusableItem(1);
        }
      }, {
        key: "previous",
        get: function get() {
          return this._getFocusableItem(-1);
        }
      }, {
        key: "current",
        get: function get() {
          var _this104 = this;
          var t = null;
          return null === this.focusTracker.focusedElement ? null : (this.focusables.find(function (e, n) {
            var o = e.element === _this104.focusTracker.focusedElement;
            return o && (t = n), o;
          }), t);
        }
      }]);
      return Od;
    }();
    function Rd(t) {
      return !(!t.focus || "none" == Sr.window.getComputedStyle(t.element).display);
    }
    var jd = n(17),
      Fd = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Zl()(jd.a, Fd), jd.a.locals;
    var Vd = /*#__PURE__*/function (_ed4) {
      _inherits(Vd, _ed4);
      function Vd(t, e) {
        var _this105;
        _classCallCheck(this, Vd);
        _this105 = _possibleConstructorReturn(this, _getPrototypeOf(Vd).call(this, t));
        var n = e && e.colorDefinitions || [],
          o = {};
        e && e.columns && (o.gridTemplateColumns = "repeat( ".concat(e.columns, ", 1fr)")), _this105.set("selectedColor"), _this105.items = _this105.createCollection(), _this105.focusTracker = new Ys(), _this105.keystrokes = new Qs(), _this105._focusCycler = new Od({
          focusables: _this105.items,
          focusTracker: _this105.focusTracker,
          keystrokeHandler: _this105.keystrokes,
          actions: {
            focusPrevious: "arrowleft",
            focusNext: "arrowright"
          }
        }), _this105.items.on("add", function (t, e) {
          e.isOn = e.color === _this105.selectedColor;
        }), n.forEach(function (t) {
          var e = new Ld();
          e.set({
            color: t.color,
            label: t.label,
            tooltip: !0,
            hasBorder: t.options.hasBorder
          }), e.on("execute", function () {
            _this105.fire("execute", {
              value: t.color,
              hasBorder: t.options.hasBorder,
              label: t.label
            });
          }), _this105.items.add(e);
        }), _this105.setTemplate({
          tag: "div",
          children: _this105.items,
          attributes: {
            class: ["ck", "ck-color-grid"],
            style: o
          }
        }), _this105.on("change:selectedColor", function (t, e, n) {
          var _iterator288 = _createForOfIteratorHelper(_this105.items),
            _step288;
          try {
            for (_iterator288.s(); !(_step288 = _iterator288.n()).done;) {
              var _t219 = _step288.value;
              _t219.isOn = _t219.color === n;
            }
          } catch (err) {
            _iterator288.e(err);
          } finally {
            _iterator288.f();
          }
        });
        return _this105;
      }
      _createClass(Vd, [{
        key: "focus",
        value: function focus() {
          this.items.length && this.items.first.focus();
        }
      }, {
        key: "focusLast",
        value: function focusLast() {
          this.items.length && this.items.last.focus();
        }
      }, {
        key: "render",
        value: function render() {
          var _this106 = this;
          _get(_getPrototypeOf(Vd.prototype), "render", this).call(this);
          var _iterator289 = _createForOfIteratorHelper(this.items),
            _step289;
          try {
            for (_iterator289.s(); !(_step289 = _iterator289.n()).done;) {
              var _t220 = _step289.value;
              this.focusTracker.add(_t220.element);
            }
          } catch (err) {
            _iterator289.e(err);
          } finally {
            _iterator289.f();
          }
          this.items.on("add", function (t, e) {
            _this106.focusTracker.add(e.element);
          }), this.items.on("remove", function (t, e) {
            _this106.focusTracker.remove(e.element);
          }), this.keystrokes.listenTo(this.element);
        }
      }]);
      return Vd;
    }(ed);
    var Ud = '<svg viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg"><path d="M.941 4.523a.75.75 0 1 1 1.06-1.06l3.006 3.005 3.005-3.005a.75.75 0 1 1 1.06 1.06l-3.549 3.55a.75.75 0 0 1-1.168-.136L.941 4.523z"/></svg>';
    var Hd = /*#__PURE__*/function (_Sd3) {
      _inherits(Hd, _Sd3);
      function Hd(t) {
        var _this107;
        _classCallCheck(this, Hd);
        _this107 = _possibleConstructorReturn(this, _getPrototypeOf(Hd).call(this, t)), _this107.arrowView = _this107._createArrowView(), _this107.extendTemplate({
          attributes: {
            "aria-haspopup": !0
          }
        }), _this107.delegate("execute").to(_assertThisInitialized(_assertThisInitialized(_this107)), "open");
        return _this107;
      }
      _createClass(Hd, [{
        key: "render",
        value: function render() {
          _get(_getPrototypeOf(Hd.prototype), "render", this).call(this), this.children.add(this.arrowView);
        }
      }, {
        key: "_createArrowView",
        value: function _createArrowView() {
          var t = new xd();
          return t.content = Ud, t.extendTemplate({
            attributes: {
              class: "ck-dropdown__arrow"
            }
          }), t;
        }
      }]);
      return Hd;
    }(Sd);
    var Gd = n(18),
      Wd = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Zl()(Gd.a, Wd), Gd.a.locals;
    var qd = /*#__PURE__*/function (_ed5) {
      _inherits(qd, _ed5);
      function qd(t) {
        var _this108;
        _classCallCheck(this, qd);
        _this108 = _possibleConstructorReturn(this, _getPrototypeOf(qd).call(this, t));
        var e = _this108.bindTemplate;
        _this108.set("class"), _this108.set("icon"), _this108.set("isEnabled", !0), _this108.set("isOn", !1), _this108.set("isToggleable", !1), _this108.set("isVisible", !0), _this108.set("keystroke"), _this108.set("label"), _this108.set("tabindex", -1), _this108.set("tooltip"), _this108.set("tooltipPosition", "s"), _this108.set("type", "button"), _this108.set("withText", !1), _this108.children = _this108.createCollection(), _this108.actionView = _this108._createActionView(), _this108.arrowView = _this108._createArrowView(), _this108.keystrokes = new Qs(), _this108.focusTracker = new Ys(), _this108.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-splitbutton", e.to("class"), e.if("isVisible", "ck-hidden", function (t) {
              return !t;
            }), _this108.arrowView.bindTemplate.if("isOn", "ck-splitbutton_open")]
          },
          children: _this108.children
        });
        return _this108;
      }
      _createClass(qd, [{
        key: "render",
        value: function render() {
          var _this109 = this;
          _get(_getPrototypeOf(qd.prototype), "render", this).call(this), this.children.add(this.actionView), this.children.add(this.arrowView), this.focusTracker.add(this.actionView.element), this.focusTracker.add(this.arrowView.element), this.keystrokes.listenTo(this.element), this.keystrokes.set("arrowright", function (t, e) {
            _this109.focusTracker.focusedElement === _this109.actionView.element && (_this109.arrowView.focus(), e());
          }), this.keystrokes.set("arrowleft", function (t, e) {
            _this109.focusTracker.focusedElement === _this109.arrowView.element && (_this109.actionView.focus(), e());
          });
        }
      }, {
        key: "focus",
        value: function focus() {
          this.actionView.focus();
        }
      }, {
        key: "_createActionView",
        value: function _createActionView() {
          var t = new Sd();
          return t.bind("icon", "isEnabled", "isOn", "isToggleable", "keystroke", "label", "tabindex", "tooltip", "tooltipPosition", "type", "withText").to(this), t.extendTemplate({
            attributes: {
              class: "ck-splitbutton__action"
            }
          }), t.delegate("execute").to(this), t;
        }
      }, {
        key: "_createArrowView",
        value: function _createArrowView() {
          var t = new Sd(),
            e = t.bindTemplate;
          return t.icon = Ud, t.extendTemplate({
            attributes: {
              class: "ck-splitbutton__arrow",
              "aria-haspopup": !0,
              "aria-expanded": e.to("isOn", function (t) {
                return String(t);
              })
            }
          }), t.bind("isEnabled").to(this), t.delegate("execute").to(this, "open"), t;
        }
      }]);
      return qd;
    }(ed);
    var Kd = /*#__PURE__*/function (_ed6) {
      _inherits(Kd, _ed6);
      function Kd(t) {
        var _this110;
        _classCallCheck(this, Kd);
        _this110 = _possibleConstructorReturn(this, _getPrototypeOf(Kd).call(this, t));
        var e = _this110.bindTemplate;
        _this110.set("isVisible", !1), _this110.set("position", "se"), _this110.children = _this110.createCollection(), _this110.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-reset", "ck-dropdown__panel", e.to("position", function (t) {
              return "ck-dropdown__panel_".concat(t);
            }), e.if("isVisible", "ck-dropdown__panel-visible")]
          },
          children: _this110.children,
          on: {
            selectstart: e.to(function (t) {
              return t.preventDefault();
            })
          }
        });
        return _this110;
      }
      _createClass(Kd, [{
        key: "focus",
        value: function focus() {
          this.children.length && this.children.first.focus();
        }
      }, {
        key: "focusLast",
        value: function focusLast() {
          if (this.children.length) {
            var _t221 = this.children.last;
            "function" == typeof _t221.focusLast ? _t221.focusLast() : _t221.focus();
          }
        }
      }]);
      return Kd;
    }(ed);
    var Yd = n(19),
      Qd = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Zl()(Yd.a, Qd), Yd.a.locals;
    function $d(_ref30) {
      var t = _ref30.element,
        e = _ref30.target,
        n = _ref30.positions,
        o = _ref30.limiter,
        i = _ref30.fitInViewport;
      N(e) && (e = e()), N(o) && (o = o());
      var r = function (t) {
          return t && t.parentNode ? t.offsetParent === Sr.document.body ? null : t.offsetParent : null;
        }(t),
        s = new Vs(t),
        a = new Vs(e);
      var c, l;
      if (o || i) {
        var _t222 = function (t, e) {
          var n = e.elementRect,
            o = e.viewportRect,
            i = n.getArea(),
            r = function (t, _ref31) {
              var e = _ref31.targetRect,
                n = _ref31.elementRect,
                o = _ref31.limiterRect,
                i = _ref31.viewportRect;
              var r = [],
                s = n.getArea();
              var _iterator290 = _createForOfIteratorHelper(t),
                _step290;
              try {
                for (_iterator290.s(); !(_step290 = _iterator290.n()).done;) {
                  var _a14 = _step290.value;
                  var _t223 = Jd(_a14, e, n);
                  if (!_t223) continue;
                  var _t224 = _slicedToArray(_t223, 2),
                    _c6 = _t224[0],
                    _l2 = _t224[1];
                  var _d3 = 0,
                    _h3 = 0;
                  if (o) if (i) {
                    var _t225 = o.getIntersection(i);
                    _t225 && (_d3 = _t225.getIntersectionArea(_l2));
                  } else _d3 = o.getIntersectionArea(_l2);
                  i && (_h3 = i.getIntersectionArea(_l2));
                  var _u2 = {
                    positionName: _c6,
                    positionRect: _l2,
                    limiterIntersectArea: _d3,
                    viewportIntersectArea: _h3
                  };
                  if (_d3 === s) return [_u2];
                  r.push(_u2);
                }
              } catch (err) {
                _iterator290.e(err);
              } finally {
                _iterator290.f();
              }
              return r;
            }(t, e);
          if (o) {
            var _t226 = Zd(r.filter(function (_ref32) {
              var t = _ref32.viewportIntersectArea;
              return t === i;
            }), i);
            if (_t226) return _t226;
          }
          return Zd(r, i);
        }(n, {
          targetRect: a,
          elementRect: s,
          limiterRect: o && new Vs(o).getVisible(),
          viewportRect: i && new Vs(Sr.window)
        });
        var _ref33 = _t222 || Jd(n[0], a, s);
        var _ref34 = _slicedToArray(_ref33, 2);
        l = _ref34[0];
        c = _ref34[1];
      } else {
        var _Jd = Jd(n[0], a, s);
        var _Jd2 = _slicedToArray(_Jd, 2);
        l = _Jd2[0];
        c = _Jd2[1];
      }
      var d = Xd(c);
      return r && (d = function (_ref35, n) {
        var t = _ref35.left,
          e = _ref35.top;
        var o = Xd(new Vs(n)),
          i = js(n);
        return t -= o.left, e -= o.top, t += n.scrollLeft, e += n.scrollTop, t -= i.left, e -= i.top, {
          left: t,
          top: e
        };
      }(d, r)), {
        left: d.left,
        top: d.top,
        name: l
      };
    }
    function Jd(t, e, n) {
      var o = t(e, n);
      if (!o) return null;
      var i = o.left,
        r = o.top,
        s = o.name;
      return [s, n.clone().moveTo(i, r)];
    }
    function Zd(t, e) {
      var n,
        o,
        i = 0;
      var _iterator291 = _createForOfIteratorHelper(t),
        _step291;
      try {
        for (_iterator291.s(); !(_step291 = _iterator291.n()).done;) {
          var _step291$value = _step291.value,
            _r36 = _step291$value.positionName,
            _s23 = _step291$value.positionRect,
            _a15 = _step291$value.limiterIntersectArea,
            _c7 = _step291$value.viewportIntersectArea;
          if (_a15 === e) return [_r36, _s23];
          var _t227 = Math.pow(_c7, 2) + Math.pow(_a15, 2);
          _t227 > i && (i = _t227, n = _s23, o = _r36);
        }
      } catch (err) {
        _iterator291.e(err);
      } finally {
        _iterator291.f();
      }
      return n ? [o, n] : null;
    }
    function Xd(_ref36) {
      var t = _ref36.left,
        e = _ref36.top;
      var _Sr$window2 = Sr.window,
        n = _Sr$window2.scrollX,
        o = _Sr$window2.scrollY;
      return {
        left: t + n,
        top: e + o
      };
    }
    var th = /*#__PURE__*/function (_ed7) {
      _inherits(th, _ed7);
      function th(t, e, n) {
        var _this111;
        _classCallCheck(this, th);
        _this111 = _possibleConstructorReturn(this, _getPrototypeOf(th).call(this, t));
        var o = _this111.bindTemplate;
        _this111.buttonView = e, _this111.panelView = n, _this111.set("isOpen", !1), _this111.set("isEnabled", !0), _this111.set("class"), _this111.set("id"), _this111.set("panelPosition", "auto"), _this111.keystrokes = new Qs(), _this111.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-dropdown", o.to("class"), o.if("isEnabled", "ck-disabled", function (t) {
              return !t;
            })],
            id: o.to("id"),
            "aria-describedby": o.to("ariaDescribedById")
          },
          children: [e, n]
        }), e.extendTemplate({
          attributes: {
            class: ["ck-dropdown__button"]
          }
        });
        return _this111;
      }
      _createClass(th, [{
        key: "render",
        value: function render() {
          var _this112 = this;
          _get(_getPrototypeOf(th.prototype), "render", this).call(this), this.listenTo(this.buttonView, "open", function () {
            _this112.isOpen = !_this112.isOpen;
          }), this.panelView.bind("isVisible").to(this, "isOpen"), this.on("change:isOpen", function () {
            _this112.isOpen && ("auto" === _this112.panelPosition ? _this112.panelView.position = th._getOptimalPosition({
              element: _this112.panelView.element,
              target: _this112.buttonView.element,
              fitInViewport: !0,
              positions: _this112._panelPositions
            }).name : _this112.panelView.position = _this112.panelPosition);
          }), this.keystrokes.listenTo(this.element);
          var t = function t(_t228, e) {
            _this112.isOpen && (_this112.buttonView.focus(), _this112.isOpen = !1, e());
          };
          this.keystrokes.set("arrowdown", function (t, e) {
            _this112.buttonView.isEnabled && !_this112.isOpen && (_this112.isOpen = !0, e());
          }), this.keystrokes.set("arrowright", function (t, e) {
            _this112.isOpen && e();
          }), this.keystrokes.set("arrowleft", t), this.keystrokes.set("esc", t);
        }
      }, {
        key: "focus",
        value: function focus() {
          this.buttonView.focus();
        }
      }, {
        key: "_panelPositions",
        get: function get() {
          var _th$defaultPanelPosit = th.defaultPanelPositions,
            t = _th$defaultPanelPosit.south,
            e = _th$defaultPanelPosit.north,
            n = _th$defaultPanelPosit.southEast,
            o = _th$defaultPanelPosit.southWest,
            i = _th$defaultPanelPosit.northEast,
            r = _th$defaultPanelPosit.northWest,
            s = _th$defaultPanelPosit.southMiddleEast,
            a = _th$defaultPanelPosit.southMiddleWest,
            c = _th$defaultPanelPosit.northMiddleEast,
            l = _th$defaultPanelPosit.northMiddleWest;
          return "rtl" !== this.locale.uiLanguageDirection ? [n, o, s, a, t, i, r, c, l, e] : [o, n, a, s, t, r, i, l, c, e];
        }
      }]);
      return th;
    }(ed);
    th.defaultPanelPositions = {
      south: function south(t, e) {
        return {
          top: t.bottom,
          left: t.left - (e.width - t.width) / 2,
          name: "s"
        };
      },
      southEast: function southEast(t) {
        return {
          top: t.bottom,
          left: t.left,
          name: "se"
        };
      },
      southWest: function southWest(t, e) {
        return {
          top: t.bottom,
          left: t.left - e.width + t.width,
          name: "sw"
        };
      },
      southMiddleEast: function southMiddleEast(t, e) {
        return {
          top: t.bottom,
          left: t.left - (e.width - t.width) / 4,
          name: "sme"
        };
      },
      southMiddleWest: function southMiddleWest(t, e) {
        return {
          top: t.bottom,
          left: t.left - 3 * (e.width - t.width) / 4,
          name: "smw"
        };
      },
      north: function north(t, e) {
        return {
          top: t.top - e.height,
          left: t.left - (e.width - t.width) / 2,
          name: "n"
        };
      },
      northEast: function northEast(t, e) {
        return {
          top: t.top - e.height,
          left: t.left,
          name: "ne"
        };
      },
      northWest: function northWest(t, e) {
        return {
          top: t.top - e.height,
          left: t.left - e.width + t.width,
          name: "nw"
        };
      },
      northMiddleEast: function northMiddleEast(t, e) {
        return {
          top: t.top - e.height,
          left: t.left - (e.width - t.width) / 4,
          name: "nme"
        };
      },
      northMiddleWest: function northMiddleWest(t, e) {
        return {
          top: t.top - e.height,
          left: t.left - 3 * (e.width - t.width) / 4,
          name: "nmw"
        };
      }
    }, th._getOptimalPosition = $d;
    var eh = /*#__PURE__*/function (_ed8) {
      _inherits(eh, _ed8);
      function eh(t) {
        var _this113;
        _classCallCheck(this, eh);
        _this113 = _possibleConstructorReturn(this, _getPrototypeOf(eh).call(this, t)), _this113.setTemplate({
          tag: "span",
          attributes: {
            class: ["ck", "ck-toolbar__separator"]
          }
        });
        return _this113;
      }
      return eh;
    }(ed);
    var nh = /*#__PURE__*/function (_ed9) {
      _inherits(nh, _ed9);
      function nh(t) {
        var _this114;
        _classCallCheck(this, nh);
        _this114 = _possibleConstructorReturn(this, _getPrototypeOf(nh).call(this, t)), _this114.setTemplate({
          tag: "span",
          attributes: {
            class: ["ck", "ck-toolbar__line-break"]
          }
        });
        return _this114;
      }
      return nh;
    }(ed);
    function oh(t) {
      return Array.isArray(t) ? {
        items: t,
        removeItems: []
      } : t ? Object.assign({
        items: [],
        removeItems: []
      }, t) : {
        items: [],
        removeItems: []
      };
    }
    var ih = n(20),
      rh = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Zl()(ih.a, rh), ih.a.locals;
    var sh = /*#__PURE__*/function (_ed10) {
      _inherits(sh, _ed10);
      function sh(t, e) {
        var _this115;
        _classCallCheck(this, sh);
        _this115 = _possibleConstructorReturn(this, _getPrototypeOf(sh).call(this, t));
        var n = _this115.bindTemplate,
          o = _this115.t;
        _this115.options = e || {}, _this115.set("ariaLabel", o("Editor toolbar")), _this115.set("maxWidth", "auto"), _this115.items = _this115.createCollection(), _this115.focusTracker = new Ys(), _this115.keystrokes = new Qs(), _this115.set("class"), _this115.set("isCompact", !1), _this115.itemsView = new ah(t), _this115.children = _this115.createCollection(), _this115.children.add(_this115.itemsView), _this115.focusables = _this115.createCollection();
        var i = "rtl" === t.uiLanguageDirection;
        _this115._focusCycler = new Od({
          focusables: _this115.focusables,
          focusTracker: _this115.focusTracker,
          keystrokeHandler: _this115.keystrokes,
          actions: {
            focusPrevious: [i ? "arrowright" : "arrowleft", "arrowup"],
            focusNext: [i ? "arrowleft" : "arrowright", "arrowdown"]
          }
        });
        var r = ["ck", "ck-toolbar", n.to("class"), n.if("isCompact", "ck-toolbar_compact")];
        var s;
        _this115.options.shouldGroupWhenFull && _this115.options.isFloating && r.push("ck-toolbar_floating"), _this115.setTemplate({
          tag: "div",
          attributes: {
            class: r,
            role: "toolbar",
            "aria-label": n.to("ariaLabel"),
            style: {
              maxWidth: n.to("maxWidth")
            }
          },
          children: _this115.children,
          on: {
            mousedown: (s = _assertThisInitialized(_assertThisInitialized(_this115)), s.bindTemplate.to(function (t) {
              t.target === s.element && t.preventDefault();
            }))
          }
        }), _this115._behavior = _this115.options.shouldGroupWhenFull ? new lh(_assertThisInitialized(_assertThisInitialized(_this115))) : new ch(_assertThisInitialized(_assertThisInitialized(_this115)));
        return _this115;
      }
      _createClass(sh, [{
        key: "render",
        value: function render() {
          var _this116 = this;
          _get(_getPrototypeOf(sh.prototype), "render", this).call(this);
          var _iterator292 = _createForOfIteratorHelper(this.items),
            _step292;
          try {
            for (_iterator292.s(); !(_step292 = _iterator292.n()).done;) {
              var _t229 = _step292.value;
              this.focusTracker.add(_t229.element);
            }
          } catch (err) {
            _iterator292.e(err);
          } finally {
            _iterator292.f();
          }
          this.items.on("add", function (t, e) {
            _this116.focusTracker.add(e.element);
          }), this.items.on("remove", function (t, e) {
            _this116.focusTracker.remove(e.element);
          }), this.keystrokes.listenTo(this.element), this._behavior.render(this);
        }
      }, {
        key: "destroy",
        value: function destroy() {
          return this._behavior.destroy(), _get(_getPrototypeOf(sh.prototype), "destroy", this).call(this);
        }
      }, {
        key: "focus",
        value: function focus() {
          this._focusCycler.focusFirst();
        }
      }, {
        key: "focusLast",
        value: function focusLast() {
          this._focusCycler.focusLast();
        }
      }, {
        key: "fillFromConfig",
        value: function fillFromConfig(t, e) {
          var _this117 = this;
          var n = oh(t),
            o = n.items.filter(function (t, o, i) {
              return "|" === t || -1 === n.removeItems.indexOf(t) && ("-" === t ? !_this117.options.shouldGroupWhenFull || (Object(c.b)("toolbarview-line-break-ignored-when-grouping-items", i), !1) : !!e.has(t) || (Object(c.b)("toolbarview-item-unavailable", {
                name: t
              }), !1));
            }),
            i = this._cleanSeparators(o).map(function (t) {
              return "|" === t ? new eh() : "-" === t ? new nh() : e.create(t);
            });
          this.items.addMany(i);
        }
      }, {
        key: "_cleanSeparators",
        value: function _cleanSeparators(t) {
          var e = function e(t) {
              return "-" !== t && "|" !== t;
            },
            n = t.length,
            o = t.findIndex(e),
            i = n - t.slice().reverse().findIndex(e);
          return t.slice(o, i).filter(function (t, n, o) {
            if (e(t)) return !0;
            return !(n > 0 && o[n - 1] === t);
          });
        }
      }]);
      return sh;
    }(ed);
    var ah = /*#__PURE__*/function (_ed11) {
      _inherits(ah, _ed11);
      function ah(t) {
        var _this118;
        _classCallCheck(this, ah);
        _this118 = _possibleConstructorReturn(this, _getPrototypeOf(ah).call(this, t)), _this118.children = _this118.createCollection(), _this118.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-toolbar__items"]
          },
          children: _this118.children
        });
        return _this118;
      }
      return ah;
    }(ed);
    var ch = /*#__PURE__*/function () {
      function ch(t) {
        _classCallCheck(this, ch);
        var e = t.bindTemplate;
        t.set("isVertical", !1), t.itemsView.children.bindTo(t.items).using(function (t) {
          return t;
        }), t.focusables.bindTo(t.items).using(function (t) {
          return t;
        }), t.extendTemplate({
          attributes: {
            class: [e.if("isVertical", "ck-toolbar_vertical")]
          }
        });
      }
      _createClass(ch, [{
        key: "render",
        value: function render() {}
      }, {
        key: "destroy",
        value: function destroy() {}
      }]);
      return ch;
    }();
    var lh = /*#__PURE__*/function () {
      function lh(t) {
        var _this119 = this;
        _classCallCheck(this, lh);
        this.view = t, this.viewChildren = t.children, this.viewFocusables = t.focusables, this.viewItemsView = t.itemsView, this.viewFocusTracker = t.focusTracker, this.viewLocale = t.locale, this.ungroupedItems = t.createCollection(), this.groupedItems = t.createCollection(), this.groupedItemsDropdown = this._createGroupedItemsDropdown(), this.resizeObserver = null, this.cachedPadding = null, this.shouldUpdateGroupingOnNextResize = !1, t.itemsView.children.bindTo(this.ungroupedItems).using(function (t) {
          return t;
        }), this.ungroupedItems.on("add", this._updateFocusCycleableItems.bind(this)), this.ungroupedItems.on("remove", this._updateFocusCycleableItems.bind(this)), t.children.on("add", this._updateFocusCycleableItems.bind(this)), t.children.on("remove", this._updateFocusCycleableItems.bind(this)), t.items.on("change", function (t, e) {
          var n = e.index;
          var _iterator293 = _createForOfIteratorHelper(e.removed),
            _step293;
          try {
            for (_iterator293.s(); !(_step293 = _iterator293.n()).done;) {
              var _t232 = _step293.value;
              n >= _this119.ungroupedItems.length ? _this119.groupedItems.remove(_t232) : _this119.ungroupedItems.remove(_t232);
            }
          } catch (err) {
            _iterator293.e(err);
          } finally {
            _iterator293.f();
          }
          for (var _t231 = n; _t231 < n + e.added.length; _t231++) {
            var _o111 = e.added[_t231 - n];
            _t231 > _this119.ungroupedItems.length ? _this119.groupedItems.add(_o111, _t231 - _this119.ungroupedItems.length) : _this119.ungroupedItems.add(_o111, _t231);
          }
          _this119._updateGrouping();
        }), t.extendTemplate({
          attributes: {
            class: ["ck-toolbar_grouping"]
          }
        });
      }
      _createClass(lh, [{
        key: "render",
        value: function render(t) {
          this.viewElement = t.element, this._enableGroupingOnResize(), this._enableGroupingOnMaxWidthChange(t);
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.groupedItemsDropdown.destroy(), this.resizeObserver.destroy();
        }
      }, {
        key: "_updateGrouping",
        value: function _updateGrouping() {
          if (!this.viewElement.ownerDocument.body.contains(this.viewElement)) return;
          if (!this.viewElement.offsetParent) return void (this.shouldUpdateGroupingOnNextResize = !0);
          var t = this.groupedItems.length;
          var e;
          for (; this._areItemsOverflowing;) this._groupLastItem(), e = !0;
          if (!e && this.groupedItems.length) {
            for (; this.groupedItems.length && !this._areItemsOverflowing;) this._ungroupFirstItem();
            this._areItemsOverflowing && this._groupLastItem();
          }
          this.groupedItems.length !== t && this.view.fire("groupedItemsUpdate");
        }
      }, {
        key: "_enableGroupingOnResize",
        value: function _enableGroupingOnResize() {
          var _this120 = this;
          var t;
          this.resizeObserver = new Gs(this.viewElement, function (e) {
            t && t === e.contentRect.width && !_this120.shouldUpdateGroupingOnNextResize || (_this120.shouldUpdateGroupingOnNextResize = !1, _this120._updateGrouping(), t = e.contentRect.width);
          }), this._updateGrouping();
        }
      }, {
        key: "_enableGroupingOnMaxWidthChange",
        value: function _enableGroupingOnMaxWidthChange(t) {
          var _this121 = this;
          t.on("change:maxWidth", function () {
            _this121._updateGrouping();
          });
        }
      }, {
        key: "_groupLastItem",
        value: function _groupLastItem() {
          this.groupedItems.length || (this.viewChildren.add(new eh()), this.viewChildren.add(this.groupedItemsDropdown), this.viewFocusTracker.add(this.groupedItemsDropdown.element)), this.groupedItems.add(this.ungroupedItems.remove(this.ungroupedItems.last), 0);
        }
      }, {
        key: "_ungroupFirstItem",
        value: function _ungroupFirstItem() {
          this.ungroupedItems.add(this.groupedItems.remove(this.groupedItems.first)), this.groupedItems.length || (this.viewChildren.remove(this.groupedItemsDropdown), this.viewChildren.remove(this.viewChildren.last), this.viewFocusTracker.remove(this.groupedItemsDropdown.element));
        }
      }, {
        key: "_createGroupedItemsDropdown",
        value: function _createGroupedItemsDropdown() {
          var t = this.viewLocale,
            e = t.t,
            n = wh(t);
          return n.class = "ck-toolbar__grouped-dropdown", n.panelPosition = "ltr" === t.uiLanguageDirection ? "sw" : "se", Ch(n, []), n.buttonView.set({
            label: e("Show more items"),
            tooltip: !0,
            tooltipPosition: "rtl" === t.uiLanguageDirection ? "se" : "sw",
            icon: ql.threeVerticalDots
          }), n.toolbarView.items.bindTo(this.groupedItems).using(function (t) {
            return t;
          }), n;
        }
      }, {
        key: "_updateFocusCycleableItems",
        value: function _updateFocusCycleableItems() {
          var _this122 = this;
          this.viewFocusables.clear(), this.ungroupedItems.map(function (t) {
            _this122.viewFocusables.add(t);
          }), this.groupedItems.length && this.viewFocusables.add(this.groupedItemsDropdown);
        }
      }, {
        key: "_areItemsOverflowing",
        get: function get() {
          if (!this.ungroupedItems.length) return !1;
          var t = this.viewElement,
            e = this.viewLocale.uiLanguageDirection,
            n = new Vs(t.lastChild),
            o = new Vs(t);
          if (!this.cachedPadding) {
            var _n199 = Sr.window.getComputedStyle(t),
              _o112 = "ltr" === e ? "paddingRight" : "paddingLeft";
            this.cachedPadding = Number.parseInt(_n199[_o112]);
          }
          return "ltr" === e ? n.right > o.right - this.cachedPadding : n.left < o.left + this.cachedPadding;
        }
      }]);
      return lh;
    }();
    var dh = n(21),
      hh = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Zl()(dh.a, hh), dh.a.locals;
    var uh = /*#__PURE__*/function (_ed12) {
      _inherits(uh, _ed12);
      function uh() {
        var _this123;
        _classCallCheck(this, uh);
        _this123 = _possibleConstructorReturn(this, _getPrototypeOf(uh).call(this)), _this123.items = _this123.createCollection(), _this123.focusTracker = new Ys(), _this123.keystrokes = new Qs(), _this123._focusCycler = new Od({
          focusables: _this123.items,
          focusTracker: _this123.focusTracker,
          keystrokeHandler: _this123.keystrokes,
          actions: {
            focusPrevious: "arrowup",
            focusNext: "arrowdown"
          }
        }), _this123.setTemplate({
          tag: "ul",
          attributes: {
            class: ["ck", "ck-reset", "ck-list"]
          },
          children: _this123.items
        });
        return _this123;
      }
      _createClass(uh, [{
        key: "render",
        value: function render() {
          var _this124 = this;
          _get(_getPrototypeOf(uh.prototype), "render", this).call(this);
          var _iterator294 = _createForOfIteratorHelper(this.items),
            _step294;
          try {
            for (_iterator294.s(); !(_step294 = _iterator294.n()).done;) {
              var _t233 = _step294.value;
              this.focusTracker.add(_t233.element);
            }
          } catch (err) {
            _iterator294.e(err);
          } finally {
            _iterator294.f();
          }
          this.items.on("add", function (t, e) {
            _this124.focusTracker.add(e.element);
          }), this.items.on("remove", function (t, e) {
            _this124.focusTracker.remove(e.element);
          }), this.keystrokes.listenTo(this.element);
        }
      }, {
        key: "focus",
        value: function focus() {
          this._focusCycler.focusFirst();
        }
      }, {
        key: "focusLast",
        value: function focusLast() {
          this._focusCycler.focusLast();
        }
      }]);
      return uh;
    }(ed);
    var gh = /*#__PURE__*/function (_ed13) {
      _inherits(gh, _ed13);
      function gh(t) {
        var _this125;
        _classCallCheck(this, gh);
        _this125 = _possibleConstructorReturn(this, _getPrototypeOf(gh).call(this, t)), _this125.children = _this125.createCollection(), _this125.setTemplate({
          tag: "li",
          attributes: {
            class: ["ck", "ck-list__item"]
          },
          children: _this125.children
        });
        return _this125;
      }
      _createClass(gh, [{
        key: "focus",
        value: function focus() {
          this.children.first.focus();
        }
      }]);
      return gh;
    }(ed);
    var mh = /*#__PURE__*/function (_ed14) {
      _inherits(mh, _ed14);
      function mh(t) {
        var _this126;
        _classCallCheck(this, mh);
        _this126 = _possibleConstructorReturn(this, _getPrototypeOf(mh).call(this, t)), _this126.setTemplate({
          tag: "li",
          attributes: {
            class: ["ck", "ck-list__separator"]
          }
        });
        return _this126;
      }
      return mh;
    }(ed);
    var ph = n(22),
      fh = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      },
      kh = (Zl()(ph.a, fh), ph.a.locals, n(23)),
      bh = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Zl()(kh.a, bh), kh.a.locals;
    function wh(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Hd;
      var n = new e(t),
        o = new Kd(t),
        i = new th(t, n, o);
      return n.bind("isEnabled").to(i), n instanceof Hd ? n.bind("isOn").to(i, "isOpen") : n.arrowView.bind("isOn").to(i, "isOpen"), function (t) {
        (function (t) {
          t.on("render", function () {
            Kl({
              emitter: t,
              activator: function activator() {
                return t.isOpen;
              },
              callback: function callback() {
                t.isOpen = !1;
              },
              contextElements: [t.element]
            });
          });
        })(t), function (t) {
          t.on("execute", function (e) {
            e.source instanceof Pd || (t.isOpen = !1);
          });
        }(t), function (t) {
          t.keystrokes.set("arrowdown", function (e, n) {
            t.isOpen && (t.panelView.focus(), n());
          }), t.keystrokes.set("arrowup", function (e, n) {
            t.isOpen && (t.panelView.focusLast(), n());
          });
        }(t);
      }(i), i;
    }
    function Ch(t, e) {
      var n = t.locale,
        o = n.t,
        i = t.toolbarView = new sh(n);
      i.set("ariaLabel", o("Dropdown toolbar")), t.extendTemplate({
        attributes: {
          class: ["ck-toolbar-dropdown"]
        }
      }), e.map(function (t) {
        return i.items.add(t);
      }), t.panelView.children.add(i), i.items.delegate("execute").to(t);
    }
    function Ah(t, e) {
      var n = t.locale,
        o = t.listView = new uh(n);
      o.items.bindTo(e).using(function (_ref37) {
        var t = _ref37.type,
          e = _ref37.model;
        if ("separator" === t) return new mh(n);
        if ("button" === t || "switchbutton" === t) {
          var _i103;
          var _o113 = new gh(n);
          var _i102;
          return _i102 = "button" === t ? new Sd(n) : new Pd(n), (_i103 = _i102).bind.apply(_i103, _toConsumableArray(Object.keys(e))).to(e), _i102.delegate("execute").to(_o113), _o113.children.add(_i102), _o113;
        }
      }), t.panelView.children.add(o), o.items.delegate("execute").to(t);
    }
    var _h = n(24),
      vh = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Zl()(_h.a, vh), _h.a.locals;
    var yh = /*#__PURE__*/function (_ed15) {
      _inherits(yh, _ed15);
      function yh(t) {
        var _this127;
        _classCallCheck(this, yh);
        _this127 = _possibleConstructorReturn(this, _getPrototypeOf(yh).call(this, t)), _this127.body = new _d(t);
        return _this127;
      }
      _createClass(yh, [{
        key: "render",
        value: function render() {
          _get(_getPrototypeOf(yh.prototype), "render", this).call(this), this.body.attachToDom();
        }
      }, {
        key: "destroy",
        value: function destroy() {
          return this.body.detachFromDom(), _get(_getPrototypeOf(yh.prototype), "destroy", this).call(this);
        }
      }]);
      return yh;
    }(ed);
    var xh = n(25),
      Eh = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Zl()(xh.a, Eh), xh.a.locals;
    var Dh = /*#__PURE__*/function (_ed16) {
      _inherits(Dh, _ed16);
      function Dh(t) {
        var _this128;
        _classCallCheck(this, Dh);
        _this128 = _possibleConstructorReturn(this, _getPrototypeOf(Dh).call(this, t)), _this128.set("text"), _this128.set("for"), _this128.id = "ck-editor__label_".concat(s());
        var e = _this128.bindTemplate;
        _this128.setTemplate({
          tag: "label",
          attributes: {
            class: ["ck", "ck-label"],
            id: _this128.id,
            for: e.to("for")
          },
          children: [{
            text: e.to("text")
          }]
        });
        return _this128;
      }
      return Dh;
    }(ed);
    var Mh = /*#__PURE__*/function (_yh) {
      _inherits(Mh, _yh);
      function Mh(t) {
        var _this129;
        _classCallCheck(this, Mh);
        _this129 = _possibleConstructorReturn(this, _getPrototypeOf(Mh).call(this, t)), _this129.top = _this129.createCollection(), _this129.main = _this129.createCollection(), _this129._voiceLabelView = _this129._createVoiceLabel(), _this129.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-reset", "ck-editor", "ck-rounded-corners"],
            role: "application",
            dir: t.uiLanguageDirection,
            lang: t.uiLanguage,
            "aria-labelledby": _this129._voiceLabelView.id
          },
          children: [_this129._voiceLabelView, {
            tag: "div",
            attributes: {
              class: ["ck", "ck-editor__top", "ck-reset_all"],
              role: "presentation"
            },
            children: _this129.top
          }, {
            tag: "div",
            attributes: {
              class: ["ck", "ck-editor__main"],
              role: "presentation"
            },
            children: _this129.main
          }]
        });
        return _this129;
      }
      _createClass(Mh, [{
        key: "_createVoiceLabel",
        value: function _createVoiceLabel() {
          var t = this.t,
            e = new Dh();
          return e.text = t("Rich Text Editor"), e.extendTemplate({
            attributes: {
              class: "ck-voice-label"
            }
          }), e;
        }
      }]);
      return Mh;
    }(yh);
    var Ih = /*#__PURE__*/function (_ed17) {
      _inherits(Ih, _ed17);
      function Ih(t, e, n) {
        var _this130;
        _classCallCheck(this, Ih);
        _this130 = _possibleConstructorReturn(this, _getPrototypeOf(Ih).call(this, t)), _this130.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-content", "ck-editor__editable", "ck-rounded-corners"],
            lang: t.contentLanguage,
            dir: t.contentLanguageDirection
          }
        }), _this130.name = null, _this130.set("isFocused", !1), _this130._editableElement = n, _this130._hasExternalElement = !!_this130._editableElement, _this130._editingView = e;
        return _this130;
      }
      _createClass(Ih, [{
        key: "render",
        value: function render() {
          var _this131 = this;
          _get(_getPrototypeOf(Ih.prototype), "render", this).call(this), this._hasExternalElement ? this.template.apply(this.element = this._editableElement) : this._editableElement = this.element, this.on("change:isFocused", function () {
            return _this131._updateIsFocusedClasses();
          }), this._updateIsFocusedClasses();
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this._hasExternalElement && this.template.revert(this._editableElement), _get(_getPrototypeOf(Ih.prototype), "destroy", this).call(this);
        }
      }, {
        key: "_updateIsFocusedClasses",
        value: function _updateIsFocusedClasses() {
          var t = this._editingView;
          function e(e) {
            t.change(function (n) {
              var o = t.document.getRoot(e.name);
              n.addClass(e.isFocused ? "ck-focused" : "ck-blurred", o), n.removeClass(e.isFocused ? "ck-blurred" : "ck-focused", o);
            });
          }
          t.isRenderingInProgress ? function n(o) {
            t.once("change:isRenderingInProgress", function (t, i, r) {
              r ? n(o) : e(o);
            });
          }(this) : e(this);
        }
      }]);
      return Ih;
    }(ed);
    var Th = /*#__PURE__*/function (_Ih) {
      _inherits(Th, _Ih);
      function Th(t, e, n) {
        var _this132;
        _classCallCheck(this, Th);
        _this132 = _possibleConstructorReturn(this, _getPrototypeOf(Th).call(this, t, e, n)), _this132.extendTemplate({
          attributes: {
            role: "textbox",
            class: "ck-editor__editable_inline"
          }
        });
        return _this132;
      }
      _createClass(Th, [{
        key: "render",
        value: function render() {
          var _this133 = this;
          _get(_getPrototypeOf(Th.prototype), "render", this).call(this);
          var t = this._editingView,
            e = this.t;
          t.change(function (n) {
            var o = t.document.getRoot(_this133.name);
            n.setAttribute("aria-label", e("Rich Text Editor, %0", _this133.name), o);
          });
        }
      }]);
      return Th;
    }(Ih);
    var Sh = n(26),
      Nh = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Zl()(Sh.a, Nh), Sh.a.locals;
    var Bh = n(27),
      Ph = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Zl()(Bh.a, Ph), Bh.a.locals;
    var zh = /*#__PURE__*/function (_ed18) {
      _inherits(zh, _ed18);
      function zh(t) {
        var _this134;
        _classCallCheck(this, zh);
        _this134 = _possibleConstructorReturn(this, _getPrototypeOf(zh).call(this, t)), _this134.set("value"), _this134.set("id"), _this134.set("placeholder"), _this134.set("isReadOnly", !1), _this134.set("hasError", !1), _this134.set("ariaDescribedById"), _this134.focusTracker = new Ys(), _this134.bind("isFocused").to(_this134.focusTracker), _this134.set("isEmpty", !0);
        var e = _this134.bindTemplate;
        _this134.setTemplate({
          tag: "input",
          attributes: {
            type: "text",
            class: ["ck", "ck-input", "ck-input-text", e.if("isFocused", "ck-input_focused"), e.if("isEmpty", "ck-input-text_empty"), e.if("hasError", "ck-error")],
            id: e.to("id"),
            placeholder: e.to("placeholder"),
            readonly: e.to("isReadOnly"),
            "aria-invalid": e.if("hasError", !0),
            "aria-describedby": e.to("ariaDescribedById")
          },
          on: {
            input: e.to("input"),
            change: e.to(_this134._updateIsEmpty.bind(_assertThisInitialized(_assertThisInitialized(_this134))))
          }
        });
        return _this134;
      }
      _createClass(zh, [{
        key: "render",
        value: function render() {
          var _this135 = this;
          _get(_getPrototypeOf(zh.prototype), "render", this).call(this), this.focusTracker.add(this.element), this._setDomElementValue(this.value), this._updateIsEmpty(), this.on("change:value", function (t, e, n) {
            _this135._setDomElementValue(n), _this135._updateIsEmpty();
          });
        }
      }, {
        key: "select",
        value: function select() {
          this.element.select();
        }
      }, {
        key: "focus",
        value: function focus() {
          this.element.focus();
        }
      }, {
        key: "_updateIsEmpty",
        value: function _updateIsEmpty() {
          this.isEmpty = !this.element.value;
        }
      }, {
        key: "_setDomElementValue",
        value: function _setDomElementValue(t) {
          this.element.value = t || 0 === t ? t : "";
        }
      }]);
      return zh;
    }(ed);
    var Lh = n(28),
      Oh = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Zl()(Lh.a, Oh), Lh.a.locals;
    var Rh = /*#__PURE__*/function (_ed19) {
      _inherits(Rh, _ed19);
      function Rh(t, e) {
        var _this136;
        _classCallCheck(this, Rh);
        _this136 = _possibleConstructorReturn(this, _getPrototypeOf(Rh).call(this, t));
        var n = "ck-labeled-field-view-".concat(s()),
          o = "ck-labeled-field-view-status-".concat(s());
        _this136.fieldView = e(_assertThisInitialized(_assertThisInitialized(_this136)), n, o), _this136.set("label"), _this136.set("isEnabled", !0), _this136.set("isEmpty", !0), _this136.set("isFocused", !1), _this136.set("errorText", null), _this136.set("infoText", null), _this136.set("class"), _this136.set("placeholder"), _this136.labelView = _this136._createLabelView(n), _this136.statusView = _this136._createStatusView(o), _this136.bind("_statusText").to(_assertThisInitialized(_assertThisInitialized(_this136)), "errorText", _assertThisInitialized(_assertThisInitialized(_this136)), "infoText", function (t, e) {
          return t || e;
        });
        var i = _this136.bindTemplate;
        _this136.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-labeled-field-view", i.to("class"), i.if("isEnabled", "ck-disabled", function (t) {
              return !t;
            }), i.if("isEmpty", "ck-labeled-field-view_empty"), i.if("isFocused", "ck-labeled-field-view_focused"), i.if("placeholder", "ck-labeled-field-view_placeholder"), i.if("errorText", "ck-error")]
          },
          children: [{
            tag: "div",
            attributes: {
              class: ["ck", "ck-labeled-field-view__input-wrapper"]
            },
            children: [_this136.fieldView, _this136.labelView]
          }, _this136.statusView]
        });
        return _this136;
      }
      _createClass(Rh, [{
        key: "_createLabelView",
        value: function _createLabelView(t) {
          var e = new Dh(this.locale);
          return e.for = t, e.bind("text").to(this, "label"), e;
        }
      }, {
        key: "_createStatusView",
        value: function _createStatusView(t) {
          var e = new ed(this.locale),
            n = this.bindTemplate;
          return e.setTemplate({
            tag: "div",
            attributes: {
              class: ["ck", "ck-labeled-field-view__status", n.if("errorText", "ck-labeled-field-view__status_error"), n.if("_statusText", "ck-hidden", function (t) {
                return !t;
              })],
              id: t,
              role: n.if("errorText", "alert")
            },
            children: [{
              text: n.to("_statusText")
            }]
          }), e;
        }
      }, {
        key: "focus",
        value: function focus() {
          this.fieldView.focus();
        }
      }]);
      return Rh;
    }(ed);
    function jh(t, e, n) {
      var o = new zh(t.locale);
      return o.set({
        id: e,
        ariaDescribedById: n
      }), o.bind("isReadOnly").to(t, "isEnabled", function (t) {
        return !t;
      }), o.bind("hasError").to(t, "errorText", function (t) {
        return !!t;
      }), o.on("input", function () {
        t.errorText = null;
      }), t.bind("isEmpty", "isFocused", "placeholder").to(o), o;
    }
    var Fh = /*#__PURE__*/function (_ko2) {
      _inherits(Fh, _ko2);
      function Fh() {
        _classCallCheck(this, Fh);
        return _possibleConstructorReturn(this, _getPrototypeOf(Fh).apply(this, arguments));
      }
      _createClass(Fh, [{
        key: "init",
        value: function init() {
          this.on("show:warning", function (t, e) {
            window.alert(e.message);
          }, {
            priority: "lowest"
          });
        }
      }, {
        key: "showSuccess",
        value: function showSuccess(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          this._showNotification({
            message: t,
            type: "success",
            namespace: e.namespace,
            title: e.title
          });
        }
      }, {
        key: "showInfo",
        value: function showInfo(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          this._showNotification({
            message: t,
            type: "info",
            namespace: e.namespace,
            title: e.title
          });
        }
      }, {
        key: "showWarning",
        value: function showWarning(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          this._showNotification({
            message: t,
            type: "warning",
            namespace: e.namespace,
            title: e.title
          });
        }
      }, {
        key: "_showNotification",
        value: function _showNotification(t) {
          var e = "show:".concat(t.type) + (t.namespace ? ":".concat(t.namespace) : "");
          this.fire(e, {
            message: t.message,
            type: t.type,
            title: t.title || ""
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "Notification";
        }
      }]);
      return Fh;
    }(ko);
    var Vh = function Vh(t, e) {
      _classCallCheck(this, Vh);
      e && Ot(this, e), t && this.set(t);
    };
    $t(Vh, Gt);
    var Uh = n(29),
      Hh = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Zl()(Uh.a, Hh), Uh.a.locals;
    var Gh = qs("px"),
      Wh = Sr.document.body;
    var qh = /*#__PURE__*/function (_ed20) {
      _inherits(qh, _ed20);
      function qh(t) {
        var _this137;
        _classCallCheck(this, qh);
        _this137 = _possibleConstructorReturn(this, _getPrototypeOf(qh).call(this, t));
        var e = _this137.bindTemplate;
        _this137.set("top", 0), _this137.set("left", 0), _this137.set("position", "arrow_nw"), _this137.set("isVisible", !1), _this137.set("withArrow", !0), _this137.set("class"), _this137.content = _this137.createCollection(), _this137.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-balloon-panel", e.to("position", function (t) {
              return "ck-balloon-panel_".concat(t);
            }), e.if("isVisible", "ck-balloon-panel_visible"), e.if("withArrow", "ck-balloon-panel_with-arrow"), e.to("class")],
            style: {
              top: e.to("top", Gh),
              left: e.to("left", Gh)
            }
          },
          children: _this137.content
        });
        return _this137;
      }
      _createClass(qh, [{
        key: "show",
        value: function show() {
          this.isVisible = !0;
        }
      }, {
        key: "hide",
        value: function hide() {
          this.isVisible = !1;
        }
      }, {
        key: "attachTo",
        value: function attachTo(t) {
          this.show();
          var e = qh.defaultPositions,
            n = Object.assign({}, {
              element: this.element,
              positions: [e.southArrowNorth, e.southArrowNorthMiddleWest, e.southArrowNorthMiddleEast, e.southArrowNorthWest, e.southArrowNorthEast, e.northArrowSouth, e.northArrowSouthMiddleWest, e.northArrowSouthMiddleEast, e.northArrowSouthWest, e.northArrowSouthEast],
              limiter: Wh,
              fitInViewport: !0
            }, t),
            o = qh._getOptimalPosition(n),
            i = parseInt(o.left),
            r = parseInt(o.top),
            s = o.name;
          Object.assign(this, {
            top: r,
            left: i,
            position: s
          });
        }
      }, {
        key: "pin",
        value: function pin(t) {
          var _this138 = this;
          this.unpin(), this._pinWhenIsVisibleCallback = function () {
            _this138.isVisible ? _this138._startPinning(t) : _this138._stopPinning();
          }, this._startPinning(t), this.listenTo(this, "change:isVisible", this._pinWhenIsVisibleCallback);
        }
      }, {
        key: "unpin",
        value: function unpin() {
          this._pinWhenIsVisibleCallback && (this._stopPinning(), this.stopListening(this, "change:isVisible", this._pinWhenIsVisibleCallback), this._pinWhenIsVisibleCallback = null, this.hide());
        }
      }, {
        key: "_startPinning",
        value: function _startPinning(t) {
          var _this139 = this;
          this.attachTo(t);
          var e = Kh(t.target),
            n = t.limiter ? Kh(t.limiter) : Wh;
          this.listenTo(Sr.document, "scroll", function (o, i) {
            var r = i.target,
              s = e && r.contains(e),
              a = n && r.contains(n);
            !s && !a && e && n || _this139.attachTo(t);
          }, {
            useCapture: !0
          }), this.listenTo(Sr.window, "resize", function () {
            _this139.attachTo(t);
          });
        }
      }, {
        key: "_stopPinning",
        value: function _stopPinning() {
          this.stopListening(Sr.document, "scroll"), this.stopListening(Sr.window, "resize");
        }
      }]);
      return qh;
    }(ed);
    function Kh(t) {
      return oo(t) ? t : Rs(t) ? t.commonAncestorContainer : "function" == typeof t ? Kh(t()) : null;
    }
    function Yh(t, e) {
      return t.top - e.height - qh.arrowVerticalOffset;
    }
    function Qh(t) {
      return t.bottom + qh.arrowVerticalOffset;
    }
    qh.arrowHorizontalOffset = 25, qh.arrowVerticalOffset = 10, qh._getOptimalPosition = $d, qh.defaultPositions = {
      northWestArrowSouthWest: function northWestArrowSouthWest(t, e) {
        return {
          top: Yh(t, e),
          left: t.left - qh.arrowHorizontalOffset,
          name: "arrow_sw"
        };
      },
      northWestArrowSouthMiddleWest: function northWestArrowSouthMiddleWest(t, e) {
        return {
          top: Yh(t, e),
          left: t.left - .25 * e.width - qh.arrowHorizontalOffset,
          name: "arrow_smw"
        };
      },
      northWestArrowSouth: function northWestArrowSouth(t, e) {
        return {
          top: Yh(t, e),
          left: t.left - e.width / 2,
          name: "arrow_s"
        };
      },
      northWestArrowSouthMiddleEast: function northWestArrowSouthMiddleEast(t, e) {
        return {
          top: Yh(t, e),
          left: t.left - .75 * e.width + qh.arrowHorizontalOffset,
          name: "arrow_sme"
        };
      },
      northWestArrowSouthEast: function northWestArrowSouthEast(t, e) {
        return {
          top: Yh(t, e),
          left: t.left - e.width + qh.arrowHorizontalOffset,
          name: "arrow_se"
        };
      },
      northArrowSouthWest: function northArrowSouthWest(t, e) {
        return {
          top: Yh(t, e),
          left: t.left + t.width / 2 - qh.arrowHorizontalOffset,
          name: "arrow_sw"
        };
      },
      northArrowSouthMiddleWest: function northArrowSouthMiddleWest(t, e) {
        return {
          top: Yh(t, e),
          left: t.left + t.width / 2 - .25 * e.width - qh.arrowHorizontalOffset,
          name: "arrow_smw"
        };
      },
      northArrowSouth: function northArrowSouth(t, e) {
        return {
          top: Yh(t, e),
          left: t.left + t.width / 2 - e.width / 2,
          name: "arrow_s"
        };
      },
      northArrowSouthMiddleEast: function northArrowSouthMiddleEast(t, e) {
        return {
          top: Yh(t, e),
          left: t.left + t.width / 2 - .75 * e.width + qh.arrowHorizontalOffset,
          name: "arrow_sme"
        };
      },
      northArrowSouthEast: function northArrowSouthEast(t, e) {
        return {
          top: Yh(t, e),
          left: t.left + t.width / 2 - e.width + qh.arrowHorizontalOffset,
          name: "arrow_se"
        };
      },
      northEastArrowSouthWest: function northEastArrowSouthWest(t, e) {
        return {
          top: Yh(t, e),
          left: t.right - qh.arrowHorizontalOffset,
          name: "arrow_sw"
        };
      },
      northEastArrowSouthMiddleWest: function northEastArrowSouthMiddleWest(t, e) {
        return {
          top: Yh(t, e),
          left: t.right - .25 * e.width - qh.arrowHorizontalOffset,
          name: "arrow_smw"
        };
      },
      northEastArrowSouth: function northEastArrowSouth(t, e) {
        return {
          top: Yh(t, e),
          left: t.right - e.width / 2,
          name: "arrow_s"
        };
      },
      northEastArrowSouthMiddleEast: function northEastArrowSouthMiddleEast(t, e) {
        return {
          top: Yh(t, e),
          left: t.right - .75 * e.width + qh.arrowHorizontalOffset,
          name: "arrow_sme"
        };
      },
      northEastArrowSouthEast: function northEastArrowSouthEast(t, e) {
        return {
          top: Yh(t, e),
          left: t.right - e.width + qh.arrowHorizontalOffset,
          name: "arrow_se"
        };
      },
      southWestArrowNorthWest: function southWestArrowNorthWest(t, e) {
        return {
          top: Qh(t),
          left: t.left - qh.arrowHorizontalOffset,
          name: "arrow_nw"
        };
      },
      southWestArrowNorthMiddleWest: function southWestArrowNorthMiddleWest(t, e) {
        return {
          top: Qh(t),
          left: t.left - .25 * e.width - qh.arrowHorizontalOffset,
          name: "arrow_nmw"
        };
      },
      southWestArrowNorth: function southWestArrowNorth(t, e) {
        return {
          top: Qh(t),
          left: t.left - e.width / 2,
          name: "arrow_n"
        };
      },
      southWestArrowNorthMiddleEast: function southWestArrowNorthMiddleEast(t, e) {
        return {
          top: Qh(t),
          left: t.left - .75 * e.width + qh.arrowHorizontalOffset,
          name: "arrow_nme"
        };
      },
      southWestArrowNorthEast: function southWestArrowNorthEast(t, e) {
        return {
          top: Qh(t),
          left: t.left - e.width + qh.arrowHorizontalOffset,
          name: "arrow_ne"
        };
      },
      southArrowNorthWest: function southArrowNorthWest(t, e) {
        return {
          top: Qh(t),
          left: t.left + t.width / 2 - qh.arrowHorizontalOffset,
          name: "arrow_nw"
        };
      },
      southArrowNorthMiddleWest: function southArrowNorthMiddleWest(t, e) {
        return {
          top: Qh(t),
          left: t.left + t.width / 2 - .25 * e.width - qh.arrowHorizontalOffset,
          name: "arrow_nmw"
        };
      },
      southArrowNorth: function southArrowNorth(t, e) {
        return {
          top: Qh(t),
          left: t.left + t.width / 2 - e.width / 2,
          name: "arrow_n"
        };
      },
      southArrowNorthMiddleEast: function southArrowNorthMiddleEast(t, e) {
        return {
          top: Qh(t),
          left: t.left + t.width / 2 - .75 * e.width + qh.arrowHorizontalOffset,
          name: "arrow_nme"
        };
      },
      southArrowNorthEast: function southArrowNorthEast(t, e) {
        return {
          top: Qh(t),
          left: t.left + t.width / 2 - e.width + qh.arrowHorizontalOffset,
          name: "arrow_ne"
        };
      },
      southEastArrowNorthWest: function southEastArrowNorthWest(t, e) {
        return {
          top: Qh(t),
          left: t.right - qh.arrowHorizontalOffset,
          name: "arrow_nw"
        };
      },
      southEastArrowNorthMiddleWest: function southEastArrowNorthMiddleWest(t, e) {
        return {
          top: Qh(t),
          left: t.right - .25 * e.width - qh.arrowHorizontalOffset,
          name: "arrow_nmw"
        };
      },
      southEastArrowNorth: function southEastArrowNorth(t, e) {
        return {
          top: Qh(t),
          left: t.right - e.width / 2,
          name: "arrow_n"
        };
      },
      southEastArrowNorthMiddleEast: function southEastArrowNorthMiddleEast(t, e) {
        return {
          top: Qh(t),
          left: t.right - .75 * e.width + qh.arrowHorizontalOffset,
          name: "arrow_nme"
        };
      },
      southEastArrowNorthEast: function southEastArrowNorthEast(t, e) {
        return {
          top: Qh(t),
          left: t.right - e.width + qh.arrowHorizontalOffset,
          name: "arrow_ne"
        };
      }
    };
    var $h = n(30),
      Jh = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      },
      Zh = (Zl()($h.a, Jh), $h.a.locals, n(31)),
      Xh = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Zl()(Zh.a, Xh), Zh.a.locals;
    var tu = qs("px");
    var eu = /*#__PURE__*/function (_Jt) {
      _inherits(eu, _Jt);
      _createClass(eu, null, [{
        key: "pluginName",
        get: function get() {
          return "ContextualBalloon";
        }
      }]);
      function eu(t) {
        var _this140;
        _classCallCheck(this, eu);
        _this140 = _possibleConstructorReturn(this, _getPrototypeOf(eu).call(this, t)), _this140.positionLimiter = function () {
          var t = _this140.editor.editing.view,
            e = t.document.selection.editableElement;
          return e ? t.domConverter.mapViewToDom(e.root) : null;
        }, _this140.set("visibleView", null), _this140.view = new qh(t.locale), t.ui.view.body.add(_this140.view), t.ui.focusTracker.add(_this140.view.element), _this140._viewToStack = new Map(), _this140._idToStack = new Map(), _this140.set("_numberOfStacks", 0), _this140.set("_singleViewMode", !1), _this140._rotatorView = _this140._createRotatorView(), _this140._fakePanelsView = _this140._createFakePanelsView();
        return _this140;
      }
      _createClass(eu, [{
        key: "hasView",
        value: function hasView(t) {
          return Array.from(this._viewToStack.keys()).includes(t);
        }
      }, {
        key: "add",
        value: function add(t) {
          if (this.hasView(t.view)) throw new c.a("contextualballoon-add-view-exist", [this, t]);
          var e = t.stackId || "main";
          if (!this._idToStack.has(e)) return this._idToStack.set(e, new Map([[t.view, t]])), this._viewToStack.set(t.view, this._idToStack.get(e)), this._numberOfStacks = this._idToStack.size, void (this._visibleStack && !t.singleViewMode || this.showStack(e));
          var n = this._idToStack.get(e);
          t.singleViewMode && this.showStack(e), n.set(t.view, t), this._viewToStack.set(t.view, n), n === this._visibleStack && this._showView(t);
        }
      }, {
        key: "remove",
        value: function remove(t) {
          if (!this.hasView(t)) throw new c.a("contextualballoon-remove-view-not-exist", [this, t]);
          var e = this._viewToStack.get(t);
          this._singleViewMode && this.visibleView === t && (this._singleViewMode = !1), this.visibleView === t && (1 === e.size ? this._idToStack.size > 1 ? this._showNextStack() : (this.view.hide(), this.visibleView = null, this._rotatorView.hideView()) : this._showView(Array.from(e.values())[e.size - 2])), 1 === e.size ? (this._idToStack.delete(this._getStackId(e)), this._numberOfStacks = this._idToStack.size) : e.delete(t), this._viewToStack.delete(t);
        }
      }, {
        key: "updatePosition",
        value: function updatePosition(t) {
          t && (this._visibleStack.get(this.visibleView).position = t), this.view.pin(this._getBalloonPosition()), this._fakePanelsView.updatePosition();
        }
      }, {
        key: "showStack",
        value: function showStack(t) {
          this.visibleStack = t;
          var e = this._idToStack.get(t);
          if (!e) throw new c.a("contextualballoon-showstack-stack-not-exist", this);
          this._visibleStack !== e && this._showView(Array.from(e.values()).pop());
        }
      }, {
        key: "_getStackId",
        value: function _getStackId(t) {
          return Array.from(this._idToStack.entries()).find(function (e) {
            return e[1] === t;
          })[0];
        }
      }, {
        key: "_showNextStack",
        value: function _showNextStack() {
          var t = Array.from(this._idToStack.values());
          var e = t.indexOf(this._visibleStack) + 1;
          t[e] || (e = 0), this.showStack(this._getStackId(t[e]));
        }
      }, {
        key: "_showPrevStack",
        value: function _showPrevStack() {
          var t = Array.from(this._idToStack.values());
          var e = t.indexOf(this._visibleStack) - 1;
          t[e] || (e = t.length - 1), this.showStack(this._getStackId(t[e]));
        }
      }, {
        key: "_createRotatorView",
        value: function _createRotatorView() {
          var _this141 = this;
          var t = new nu(this.editor.locale),
            e = this.editor.locale.t;
          return this.view.content.add(t), t.bind("isNavigationVisible").to(this, "_numberOfStacks", this, "_singleViewMode", function (t, e) {
            return !e && t > 1;
          }), t.on("change:isNavigationVisible", function () {
            return _this141.updatePosition();
          }, {
            priority: "low"
          }), t.bind("counter").to(this, "visibleView", this, "_numberOfStacks", function (t, n) {
            if (n < 2) return "";
            var o = Array.from(_this141._idToStack.values()).indexOf(_this141._visibleStack) + 1;
            return e("%0 of %1", [o, n]);
          }), t.buttonNextView.on("execute", function () {
            t.focusTracker.isFocused && _this141.editor.editing.view.focus(), _this141._showNextStack();
          }), t.buttonPrevView.on("execute", function () {
            t.focusTracker.isFocused && _this141.editor.editing.view.focus(), _this141._showPrevStack();
          }), t;
        }
      }, {
        key: "_createFakePanelsView",
        value: function _createFakePanelsView() {
          var t = new ou(this.editor.locale, this.view);
          return t.bind("numberOfPanels").to(this, "_numberOfStacks", this, "_singleViewMode", function (t, e) {
            return !e && t >= 2 ? Math.min(t - 1, 2) : 0;
          }), t.listenTo(this.view, "change:top", function () {
            return t.updatePosition();
          }), t.listenTo(this.view, "change:left", function () {
            return t.updatePosition();
          }), this.editor.ui.view.body.add(t), t;
        }
      }, {
        key: "_showView",
        value: function _showView(_ref38) {
          var t = _ref38.view,
            _ref38$balloonClassNa = _ref38.balloonClassName,
            e = _ref38$balloonClassNa === void 0 ? "" : _ref38$balloonClassNa,
            _ref38$withArrow = _ref38.withArrow,
            n = _ref38$withArrow === void 0 ? !0 : _ref38$withArrow,
            _ref38$singleViewMode = _ref38.singleViewMode,
            o = _ref38$singleViewMode === void 0 ? !1 : _ref38$singleViewMode;
          this.view.class = e, this.view.withArrow = n, this._rotatorView.showView(t), this.visibleView = t, this.view.pin(this._getBalloonPosition()), this._fakePanelsView.updatePosition(), o && (this._singleViewMode = !0);
        }
      }, {
        key: "_getBalloonPosition",
        value: function _getBalloonPosition() {
          var t = Array.from(this._visibleStack.values()).pop().position;
          return t && !t.limiter && (t = Object.assign({}, t, {
            limiter: this.positionLimiter
          })), t;
        }
      }, {
        key: "_visibleStack",
        get: function get() {
          return this._viewToStack.get(this.visibleView);
        }
      }]);
      return eu;
    }(Jt);
    var nu = /*#__PURE__*/function (_ed21) {
      _inherits(nu, _ed21);
      function nu(t) {
        var _this142;
        _classCallCheck(this, nu);
        _this142 = _possibleConstructorReturn(this, _getPrototypeOf(nu).call(this, t));
        var e = t.t,
          n = _this142.bindTemplate;
        _this142.set("isNavigationVisible", !0), _this142.focusTracker = new Ys(), _this142.buttonPrevView = _this142._createButtonView(e("Previous"), '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.463 5.187a.888.888 0 1 1 1.254 1.255L9.16 10l3.557 3.557a.888.888 0 1 1-1.254 1.255L7.26 10.61a.888.888 0 0 1 .16-1.382l4.043-4.042z"/></svg>'), _this142.buttonNextView = _this142._createButtonView(e("Next"), '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M8.537 14.813a.888.888 0 1 1-1.254-1.255L10.84 10 7.283 6.442a.888.888 0 1 1 1.254-1.255L12.74 9.39a.888.888 0 0 1-.16 1.382l-4.043 4.042z"/></svg>'), _this142.content = _this142.createCollection(), _this142.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-balloon-rotator"],
            "z-index": "-1"
          },
          children: [{
            tag: "div",
            attributes: {
              class: ["ck-balloon-rotator__navigation", n.to("isNavigationVisible", function (t) {
                return t ? "" : "ck-hidden";
              })]
            },
            children: [_this142.buttonPrevView, {
              tag: "span",
              attributes: {
                class: ["ck-balloon-rotator__counter"]
              },
              children: [{
                text: n.to("counter")
              }]
            }, _this142.buttonNextView]
          }, {
            tag: "div",
            attributes: {
              class: "ck-balloon-rotator__content"
            },
            children: _this142.content
          }]
        });
        return _this142;
      }
      _createClass(nu, [{
        key: "render",
        value: function render() {
          _get(_getPrototypeOf(nu.prototype), "render", this).call(this), this.focusTracker.add(this.element);
        }
      }, {
        key: "showView",
        value: function showView(t) {
          this.hideView(), this.content.add(t);
        }
      }, {
        key: "hideView",
        value: function hideView() {
          this.content.clear();
        }
      }, {
        key: "_createButtonView",
        value: function _createButtonView(t, e) {
          var n = new Sd(this.locale);
          return n.set({
            label: t,
            icon: e,
            tooltip: !0
          }), n;
        }
      }]);
      return nu;
    }(ed);
    var ou = /*#__PURE__*/function (_ed22) {
      _inherits(ou, _ed22);
      function ou(t, e) {
        var _this143;
        _classCallCheck(this, ou);
        _this143 = _possibleConstructorReturn(this, _getPrototypeOf(ou).call(this, t));
        var n = _this143.bindTemplate;
        _this143.set("top", 0), _this143.set("left", 0), _this143.set("height", 0), _this143.set("width", 0), _this143.set("numberOfPanels", 0), _this143.content = _this143.createCollection(), _this143._balloonPanelView = e, _this143.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck-fake-panel", n.to("numberOfPanels", function (t) {
              return t ? "" : "ck-hidden";
            })],
            style: {
              top: n.to("top", tu),
              left: n.to("left", tu),
              width: n.to("width", tu),
              height: n.to("height", tu)
            }
          },
          children: _this143.content
        }), _this143.on("change:numberOfPanels", function (t, e, n, o) {
          n > o ? _this143._addPanels(n - o) : _this143._removePanels(o - n), _this143.updatePosition();
        });
        return _this143;
      }
      _createClass(ou, [{
        key: "_addPanels",
        value: function _addPanels(t) {
          for (; t--;) {
            var _t234 = new ed();
            _t234.setTemplate({
              tag: "div"
            }), this.content.add(_t234), this.registerChild(_t234);
          }
        }
      }, {
        key: "_removePanels",
        value: function _removePanels(t) {
          for (; t--;) {
            var _t235 = this.content.last;
            this.content.remove(_t235), this.deregisterChild(_t235), _t235.destroy();
          }
        }
      }, {
        key: "updatePosition",
        value: function updatePosition() {
          if (this.numberOfPanels) {
            var _this$_balloonPanelVi = this._balloonPanelView,
              _t236 = _this$_balloonPanelVi.top,
              _e226 = _this$_balloonPanelVi.left,
              _Vs = new Vs(this._balloonPanelView.element),
              _n200 = _Vs.width,
              _o114 = _Vs.height;
            Object.assign(this, {
              top: _t236,
              left: _e226,
              width: _n200,
              height: _o114
            });
          }
        }
      }]);
      return ou;
    }(ed);
    var iu = n(32),
      ru = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Zl()(iu.a, ru), iu.a.locals;
    var su = qs("px");
    var au = /*#__PURE__*/function (_ed23) {
      _inherits(au, _ed23);
      function au(t) {
        var _this144;
        _classCallCheck(this, au);
        _this144 = _possibleConstructorReturn(this, _getPrototypeOf(au).call(this, t));
        var e = _this144.bindTemplate;
        _this144.set("isActive", !1), _this144.set("isSticky", !1), _this144.set("limiterElement", null), _this144.set("limiterBottomOffset", 50), _this144.set("viewportTopOffset", 0), _this144.set("_marginLeft", null), _this144.set("_isStickyToTheLimiter", !1), _this144.set("_hasViewportTopOffset", !1), _this144.content = _this144.createCollection(), _this144._contentPanelPlaceholder = new nd({
          tag: "div",
          attributes: {
            class: ["ck", "ck-sticky-panel__placeholder"],
            style: {
              display: e.to("isSticky", function (t) {
                return t ? "block" : "none";
              }),
              height: e.to("isSticky", function (t) {
                return t ? su(_this144._panelRect.height) : null;
              })
            }
          }
        }).render(), _this144._contentPanel = new nd({
          tag: "div",
          attributes: {
            class: ["ck", "ck-sticky-panel__content", e.if("isSticky", "ck-sticky-panel__content_sticky"), e.if("_isStickyToTheLimiter", "ck-sticky-panel__content_sticky_bottom-limit")],
            style: {
              width: e.to("isSticky", function (t) {
                return t ? su(_this144._contentPanelPlaceholder.getBoundingClientRect().width) : null;
              }),
              top: e.to("_hasViewportTopOffset", function (t) {
                return t ? su(_this144.viewportTopOffset) : null;
              }),
              bottom: e.to("_isStickyToTheLimiter", function (t) {
                return t ? su(_this144.limiterBottomOffset) : null;
              }),
              marginLeft: e.to("_marginLeft")
            }
          },
          children: _this144.content
        }).render(), _this144.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-sticky-panel"]
          },
          children: [_this144._contentPanelPlaceholder, _this144._contentPanel]
        });
        return _this144;
      }
      _createClass(au, [{
        key: "render",
        value: function render() {
          var _this145 = this;
          _get(_getPrototypeOf(au.prototype), "render", this).call(this), this._checkIfShouldBeSticky(), this.listenTo(Sr.window, "scroll", function () {
            _this145._checkIfShouldBeSticky();
          }), this.listenTo(this, "change:isActive", function () {
            _this145._checkIfShouldBeSticky();
          });
        }
      }, {
        key: "_checkIfShouldBeSticky",
        value: function _checkIfShouldBeSticky() {
          var t = this._panelRect = this._contentPanel.getBoundingClientRect();
          var e;
          this.limiterElement ? (e = this._limiterRect = this.limiterElement.getBoundingClientRect(), this.isSticky = this.isActive && e.top < this.viewportTopOffset && this._panelRect.height + this.limiterBottomOffset < e.height) : this.isSticky = !1, this.isSticky ? (this._isStickyToTheLimiter = e.bottom < t.height + this.limiterBottomOffset + this.viewportTopOffset, this._hasViewportTopOffset = !this._isStickyToTheLimiter && !!this.viewportTopOffset, this._marginLeft = this._isStickyToTheLimiter ? null : su(-Sr.window.scrollX)) : (this._isStickyToTheLimiter = !1, this._hasViewportTopOffset = !1, this._marginLeft = null);
        }
      }]);
      return au;
    }(ed);
    qs("px");
    var cu = n(33),
      lu = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Zl()(cu.a, lu), cu.a.locals;
    qs("px");
    qs("px");
    var du = n(34),
      hu = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Zl()(du.a, hu), du.a.locals;
    var uu = new WeakMap();
    function gu(t) {
      var e = t.view,
        n = t.element,
        o = t.text,
        _t$isDirectHost = t.isDirectHost,
        i = _t$isDirectHost === void 0 ? !0 : _t$isDirectHost,
        _t$keepOnFocus = t.keepOnFocus,
        r = _t$keepOnFocus === void 0 ? !1 : _t$keepOnFocus,
        s = e.document;
      uu.has(s) || (uu.set(s, new Map()), s.registerPostFixer(function (t) {
        return pu(s, t);
      })), uu.get(s).set(n, {
        text: o,
        isDirectHost: i,
        keepOnFocus: r,
        hostElement: i ? n : null
      }), e.change(function (t) {
        return pu(s, t);
      });
    }
    function mu(t, e) {
      return !!e.hasClass("ck-placeholder") && (t.removeClass("ck-placeholder", e), !0);
    }
    function pu(t, e) {
      var n = uu.get(t),
        o = [];
      var i = !1;
      var _iterator295 = _createForOfIteratorHelper(n),
        _step295;
      try {
        for (_iterator295.s(); !(_step295 = _iterator295.n()).done;) {
          var _step295$value = _slicedToArray(_step295.value, 2),
            _t237 = _step295$value[0],
            _r37 = _step295$value[1];
          _r37.isDirectHost && (o.push(_t237), fu(e, _t237, _r37) && (i = !0));
        }
      } catch (err) {
        _iterator295.e(err);
      } finally {
        _iterator295.f();
      }
      var _iterator296 = _createForOfIteratorHelper(n),
        _step296;
      try {
        for (_iterator296.s(); !(_step296 = _iterator296.n()).done;) {
          var _step296$value = _slicedToArray(_step296.value, 2),
            _t238 = _step296$value[0],
            _r38 = _step296$value[1];
          if (_r38.isDirectHost) continue;
          var _n201 = ku(_t238);
          _n201 && (o.includes(_n201) || (_r38.hostElement = _n201, fu(e, _t238, _r38) && (i = !0)));
        }
      } catch (err) {
        _iterator296.e(err);
      } finally {
        _iterator296.f();
      }
      return i;
    }
    function fu(t, e, n) {
      var o = n.text,
        i = n.isDirectHost,
        r = n.hostElement;
      var s = !1;
      r.getAttribute("data-placeholder") !== o && (t.setAttribute("data-placeholder", o, r), s = !0);
      return (i || 1 == e.childCount) && function (t, e) {
        if (!t.isAttached()) return !1;
        if (Array.from(t.getChildren()).some(function (t) {
          return !t.is("uiElement");
        })) return !1;
        if (e) return !0;
        var n = t.document;
        if (!n.isFocused) return !0;
        var o = n.selection.anchor;
        return o && o.parent !== t;
      }(r, n.keepOnFocus) ? function (t, e) {
        return !e.hasClass("ck-placeholder") && (t.addClass("ck-placeholder", e), !0);
      }(t, r) && (s = !0) : mu(t, r) && (s = !0), s;
    }
    function ku(t) {
      if (t.childCount) {
        var _e227 = t.getChild(0);
        if (_e227.is("element") && !_e227.is("uiElement")) return _e227;
      }
      return null;
    }
    var bu = new Map();
    function wu(t, e, n) {
      var o = bu.get(t);
      o || (o = new Map(), bu.set(t, o)), o.set(e, n);
    }
    function Cu(t) {
      return [t];
    }
    function Au(t, e) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var o = function (t, e) {
        var n = bu.get(t);
        return n && n.has(e) ? n.get(e) : Cu;
      }(t.constructor, e.constructor);
      try {
        return o(t = t.clone(), e, n);
      } catch (t) {
        throw t;
      }
    }
    function _u(t, e, n) {
      t = t.slice(), e = e.slice();
      var o = new vu(n.document, n.useRelations, n.forceWeakRemove);
      o.setOriginalOperations(t), o.setOriginalOperations(e);
      var i = o.originalOperations;
      if (0 == t.length || 0 == e.length) return {
        operationsA: t,
        operationsB: e,
        originalOperations: i
      };
      var r = new WeakMap();
      var _iterator297 = _createForOfIteratorHelper(t),
        _step297;
      try {
        for (_iterator297.s(); !(_step297 = _iterator297.n()).done;) {
          var _e229 = _step297.value;
          r.set(_e229, 0);
        }
      } catch (err) {
        _iterator297.e(err);
      } finally {
        _iterator297.f();
      }
      var s = {
        nextBaseVersionA: t[t.length - 1].baseVersion + 1,
        nextBaseVersionB: e[e.length - 1].baseVersion + 1,
        originalOperationsACount: t.length,
        originalOperationsBCount: e.length
      };
      var a = 0;
      for (; a < t.length;) {
        var _t239, _e228;
        var _n202 = t[a],
          _i104 = r.get(_n202);
        if (_i104 == e.length) {
          a++;
          continue;
        }
        var _s24 = e[_i104],
          _c8 = Au(_n202, _s24, o.getContext(_n202, _s24, !0)),
          _l3 = Au(_s24, _n202, o.getContext(_s24, _n202, !1));
        o.updateRelation(_n202, _s24), o.setOriginalOperations(_c8, _n202), o.setOriginalOperations(_l3, _s24);
        var _iterator298 = _createForOfIteratorHelper(_c8),
          _step298;
        try {
          for (_iterator298.s(); !(_step298 = _iterator298.n()).done;) {
            var _t240 = _step298.value;
            r.set(_t240, _i104 + _l3.length);
          }
        } catch (err) {
          _iterator298.e(err);
        } finally {
          _iterator298.f();
        }
        (_t239 = t).splice.apply(_t239, [a, 1].concat(_toConsumableArray(_c8))), (_e228 = e).splice.apply(_e228, [_i104, 1].concat(_toConsumableArray(_l3)));
      }
      if (n.padWithNoOps) {
        var _n203 = t.length - s.originalOperationsACount,
          _o115 = e.length - s.originalOperationsBCount;
        xu(t, _o115 - _n203), xu(e, _n203 - _o115);
      }
      return yu(t, s.nextBaseVersionB), yu(e, s.nextBaseVersionA), {
        operationsA: t,
        operationsB: e,
        originalOperations: i
      };
    }
    var vu = /*#__PURE__*/function () {
      function vu(t, e) {
        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
        _classCallCheck(this, vu);
        this.originalOperations = new Map(), this._history = t.history, this._useRelations = e, this._forceWeakRemove = !!n, this._relations = new Map();
      }
      _createClass(vu, [{
        key: "setOriginalOperations",
        value: function setOriginalOperations(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          var n = e ? this.originalOperations.get(e) : null;
          var _iterator299 = _createForOfIteratorHelper(t),
            _step299;
          try {
            for (_iterator299.s(); !(_step299 = _iterator299.n()).done;) {
              var _e230 = _step299.value;
              this.originalOperations.set(_e230, n || _e230);
            }
          } catch (err) {
            _iterator299.e(err);
          } finally {
            _iterator299.f();
          }
        }
      }, {
        key: "updateRelation",
        value: function updateRelation(t, e) {
          switch (t.constructor) {
            case Hc:
              switch (e.constructor) {
                case Yc:
                  t.targetPosition.isEqual(e.sourcePosition) || e.movedRange.containsPosition(t.targetPosition) ? this._setRelation(t, e, "insertAtSource") : t.targetPosition.isEqual(e.deletionPosition) ? this._setRelation(t, e, "insertBetween") : t.targetPosition.isAfter(e.sourcePosition) && this._setRelation(t, e, "moveTargetAfter");
                  break;
                case Hc:
                  t.targetPosition.isEqual(e.sourcePosition) || t.targetPosition.isBefore(e.sourcePosition) ? this._setRelation(t, e, "insertBefore") : this._setRelation(t, e, "insertAfter");
              }
              break;
            case Qc:
              switch (e.constructor) {
                case Yc:
                  t.splitPosition.isBefore(e.sourcePosition) && this._setRelation(t, e, "splitBefore");
                  break;
                case Hc:
                  if (t.splitPosition.isEqual(e.sourcePosition) || t.splitPosition.isBefore(e.sourcePosition)) this._setRelation(t, e, "splitBefore");else {
                    var _n204 = wa._createFromPositionAndShift(e.sourcePosition, e.howMany);
                    if (t.splitPosition.hasSameParentAs(e.sourcePosition) && _n204.containsPosition(t.splitPosition)) {
                      var _o116 = _n204.end.offset - t.splitPosition.offset,
                        _i105 = t.splitPosition.offset - _n204.start.offset;
                      this._setRelation(t, e, {
                        howMany: _o116,
                        offset: _i105
                      });
                    }
                  }
              }
              break;
            case Yc:
              switch (e.constructor) {
                case Yc:
                  t.targetPosition.isEqual(e.sourcePosition) || this._setRelation(t, e, "mergeTargetNotMoved"), t.sourcePosition.isEqual(e.targetPosition) && this._setRelation(t, e, "mergeSourceNotMoved"), t.sourcePosition.isEqual(e.sourcePosition) && this._setRelation(t, e, "mergeSameElement");
                  break;
                case Qc:
                  t.sourcePosition.isEqual(e.splitPosition) && this._setRelation(t, e, "splitAtSource");
              }
              break;
            case Wc:
              {
                var _n205 = t.newRange;
                if (!_n205) return;
                switch (e.constructor) {
                  case Hc:
                    {
                      var _o117 = wa._createFromPositionAndShift(e.sourcePosition, e.howMany),
                        _i106 = _o117.containsPosition(_n205.start) || _o117.start.isEqual(_n205.start),
                        _r39 = _o117.containsPosition(_n205.end) || _o117.end.isEqual(_n205.end);
                      !_i106 && !_r39 || _o117.containsRange(_n205) || this._setRelation(t, e, {
                        side: _i106 ? "left" : "right",
                        path: _i106 ? _n205.start.path.slice() : _n205.end.path.slice()
                      });
                      break;
                    }
                  case Yc:
                    {
                      var _o118 = _n205.start.isEqual(e.targetPosition),
                        _i107 = _n205.start.isEqual(e.deletionPosition),
                        _r40 = _n205.end.isEqual(e.deletionPosition),
                        _s25 = _n205.end.isEqual(e.sourcePosition);
                      (_o118 || _i107 || _r40 || _s25) && this._setRelation(t, e, {
                        wasInLeftElement: _o118,
                        wasStartBeforeMergedElement: _i107,
                        wasEndBeforeMergedElement: _r40,
                        wasInRightElement: _s25
                      });
                      break;
                    }
                }
                break;
              }
          }
        }
      }, {
        key: "getContext",
        value: function getContext(t, e, n) {
          return {
            aIsStrong: n,
            aWasUndone: this._wasUndone(t),
            bWasUndone: this._wasUndone(e),
            abRelation: this._useRelations ? this._getRelation(t, e) : null,
            baRelation: this._useRelations ? this._getRelation(e, t) : null,
            forceWeakRemove: this._forceWeakRemove
          };
        }
      }, {
        key: "_wasUndone",
        value: function _wasUndone(t) {
          var e = this.originalOperations.get(t);
          return e.wasUndone || this._history.isUndoneOperation(e);
        }
      }, {
        key: "_getRelation",
        value: function _getRelation(t, e) {
          var n = this.originalOperations.get(e),
            o = this._history.getUndoneOperation(n);
          if (!o) return null;
          var i = this.originalOperations.get(t),
            r = this._relations.get(i);
          return r && r.get(o) || null;
        }
      }, {
        key: "_setRelation",
        value: function _setRelation(t, e, n) {
          var o = this.originalOperations.get(t),
            i = this.originalOperations.get(e);
          var r = this._relations.get(o);
          r || (r = new Map(), this._relations.set(o, r)), r.set(i, n);
        }
      }]);
      return vu;
    }();
    function yu(t, e) {
      var _iterator300 = _createForOfIteratorHelper(t),
        _step300;
      try {
        for (_iterator300.s(); !(_step300 = _iterator300.n()).done;) {
          var _n206 = _step300.value;
          _n206.baseVersion = e++;
        }
      } catch (err) {
        _iterator300.e(err);
      } finally {
        _iterator300.f();
      }
    }
    function xu(t, e) {
      for (var _n208 = 0; _n208 < e; _n208++) t.push(new pl(0));
    }
    function Eu(t, e, n) {
      var o = t.nodes.getNode(0).getAttribute(e);
      if (o == n) return null;
      var i = new wa(t.position, t.position.getShiftedBy(t.howMany));
      return new Vc(i, e, o, n, 0);
    }
    function Du(t, e) {
      return null === t.targetPosition._getTransformedByDeletion(e.sourcePosition, e.howMany);
    }
    function Mu(t, e) {
      var n = [];
      for (var _o120 = 0; _o120 < t.length; _o120++) {
        var _i108 = t[_o120],
          _r41 = new Hc(_i108.start, _i108.end.offset - _i108.start.offset, e, 0);
        n.push(_r41);
        for (var _e232 = _o120 + 1; _e232 < t.length; _e232++) t[_e232] = t[_e232]._getTransformedByMove(_r41.sourcePosition, _r41.targetPosition, _r41.howMany)[0];
        e = e._getTransformedByMove(_r41.sourcePosition, _r41.targetPosition, _r41.howMany);
      }
      return n;
    }
    wu(Vc, Vc, function (t, e, n) {
      if (t.key === e.key && t.range.start.hasSameParentAs(e.range.start)) {
        var _o121 = t.range.getDifference(e.range).map(function (e) {
            return new Vc(e, t.key, t.oldValue, t.newValue, 0);
          }),
          _i109 = t.range.getIntersection(e.range);
        return _i109 && n.aIsStrong && _o121.push(new Vc(_i109, e.key, e.newValue, t.newValue, 0)), 0 == _o121.length ? [new pl(0)] : _o121;
      }
      return [t];
    }), wu(Vc, Gc, function (t, e) {
      if (t.range.start.hasSameParentAs(e.position) && t.range.containsPosition(e.position)) {
        var _n209 = t.range._getTransformedByInsertion(e.position, e.howMany, !e.shouldReceiveAttributes).map(function (e) {
          return new Vc(e, t.key, t.oldValue, t.newValue, t.baseVersion);
        });
        if (e.shouldReceiveAttributes) {
          var _o122 = Eu(e, t.key, t.oldValue);
          _o122 && _n209.unshift(_o122);
        }
        return _n209;
      }
      return t.range = t.range._getTransformedByInsertion(e.position, e.howMany, !1)[0], [t];
    }), wu(Vc, Yc, function (t, e) {
      var n = [];
      t.range.start.hasSameParentAs(e.deletionPosition) && (t.range.containsPosition(e.deletionPosition) || t.range.start.isEqual(e.deletionPosition)) && n.push(wa._createFromPositionAndShift(e.graveyardPosition, 1));
      var o = t.range._getTransformedByMergeOperation(e);
      return o.isCollapsed || n.push(o), n.map(function (e) {
        return new Vc(e, t.key, t.oldValue, t.newValue, t.baseVersion);
      });
    }), wu(Vc, Hc, function (t, e) {
      return function (t, e) {
        var n = wa._createFromPositionAndShift(e.sourcePosition, e.howMany);
        var o = null,
          i = [];
        n.containsRange(t, !0) ? o = t : t.start.hasSameParentAs(n.start) ? (i = t.getDifference(n), o = t.getIntersection(n)) : i = [t];
        var r = [];
        var _iterator301 = _createForOfIteratorHelper(i),
          _step301;
        try {
          for (_iterator301.s(); !(_step301 = _iterator301.n()).done;) {
            var _t241 = _step301.value;
            _t241 = _t241._getTransformedByDeletion(e.sourcePosition, e.howMany);
            var _n210 = e.getMovedRangeStart(),
              _o123 = _t241.start.hasSameParentAs(_n210);
            _t241 = _t241._getTransformedByInsertion(_n210, e.howMany, _o123), r.push.apply(r, _toConsumableArray(_t241));
          }
        } catch (err) {
          _iterator301.e(err);
        } finally {
          _iterator301.f();
        }
        o && r.push(o._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany, !1)[0]);
        return r;
      }(t.range, e).map(function (e) {
        return new Vc(e, t.key, t.oldValue, t.newValue, t.baseVersion);
      });
    }), wu(Vc, Qc, function (t, e) {
      if (t.range.end.isEqual(e.insertionPosition)) return e.graveyardPosition || t.range.end.offset++, [t];
      if (t.range.start.hasSameParentAs(e.splitPosition) && t.range.containsPosition(e.splitPosition)) {
        var _n211 = t.clone();
        return _n211.range = new wa(e.moveTargetPosition.clone(), t.range.end._getCombined(e.splitPosition, e.moveTargetPosition)), t.range.end = e.splitPosition.clone(), t.range.end.stickiness = "toPrevious", [t, _n211];
      }
      return t.range = t.range._getTransformedBySplitOperation(e), [t];
    }), wu(Gc, Vc, function (t, e) {
      var n = [t];
      if (t.shouldReceiveAttributes && t.position.hasSameParentAs(e.range.start) && e.range.containsPosition(t.position)) {
        var _o124 = Eu(t, e.key, e.newValue);
        _o124 && n.push(_o124);
      }
      return n;
    }), wu(Gc, Gc, function (t, e, n) {
      return t.position.isEqual(e.position) && n.aIsStrong || (t.position = t.position._getTransformedByInsertOperation(e)), [t];
    }), wu(Gc, Hc, function (t, e) {
      return t.position = t.position._getTransformedByMoveOperation(e), [t];
    }), wu(Gc, Qc, function (t, e) {
      return t.position = t.position._getTransformedBySplitOperation(e), [t];
    }), wu(Gc, Yc, function (t, e) {
      return t.position = t.position._getTransformedByMergeOperation(e), [t];
    }), wu(Wc, Gc, function (t, e) {
      return t.oldRange && (t.oldRange = t.oldRange._getTransformedByInsertOperation(e)[0]), t.newRange && (t.newRange = t.newRange._getTransformedByInsertOperation(e)[0]), [t];
    }), wu(Wc, Wc, function (t, e, n) {
      if (t.name == e.name) {
        if (!n.aIsStrong) return [new pl(0)];
        t.oldRange = e.newRange ? e.newRange.clone() : null;
      }
      return [t];
    }), wu(Wc, Yc, function (t, e) {
      return t.oldRange && (t.oldRange = t.oldRange._getTransformedByMergeOperation(e)), t.newRange && (t.newRange = t.newRange._getTransformedByMergeOperation(e)), [t];
    }), wu(Wc, Hc, function (t, e, n) {
      if (t.oldRange && (t.oldRange = wa._createFromRanges(t.oldRange._getTransformedByMoveOperation(e))), t.newRange) {
        if (n.abRelation) {
          var _o125 = wa._createFromRanges(t.newRange._getTransformedByMoveOperation(e));
          if ("left" == n.abRelation.side && e.targetPosition.isEqual(t.newRange.start)) return t.newRange.start.path = n.abRelation.path, t.newRange.end = _o125.end, [t];
          if ("right" == n.abRelation.side && e.targetPosition.isEqual(t.newRange.end)) return t.newRange.start = _o125.start, t.newRange.end.path = n.abRelation.path, [t];
        }
        t.newRange = wa._createFromRanges(t.newRange._getTransformedByMoveOperation(e));
      }
      return [t];
    }), wu(Wc, Qc, function (t, e, n) {
      if (t.oldRange && (t.oldRange = t.oldRange._getTransformedBySplitOperation(e)), t.newRange) {
        if (n.abRelation) {
          var _o126 = t.newRange._getTransformedBySplitOperation(e);
          return t.newRange.start.isEqual(e.splitPosition) && n.abRelation.wasStartBeforeMergedElement ? t.newRange.start = pa._createAt(e.insertionPosition) : t.newRange.start.isEqual(e.splitPosition) && !n.abRelation.wasInLeftElement && (t.newRange.start = pa._createAt(e.moveTargetPosition)), t.newRange.end.isEqual(e.splitPosition) && n.abRelation.wasInRightElement ? t.newRange.end = pa._createAt(e.moveTargetPosition) : t.newRange.end.isEqual(e.splitPosition) && n.abRelation.wasEndBeforeMergedElement ? t.newRange.end = pa._createAt(e.insertionPosition) : t.newRange.end = _o126.end, [t];
        }
        t.newRange = t.newRange._getTransformedBySplitOperation(e);
      }
      return [t];
    }), wu(Yc, Gc, function (t, e) {
      return t.sourcePosition.hasSameParentAs(e.position) && (t.howMany += e.howMany), t.sourcePosition = t.sourcePosition._getTransformedByInsertOperation(e), t.targetPosition = t.targetPosition._getTransformedByInsertOperation(e), [t];
    }), wu(Yc, Yc, function (t, e, n) {
      if (t.sourcePosition.isEqual(e.sourcePosition) && t.targetPosition.isEqual(e.targetPosition)) {
        if (n.bWasUndone) {
          var _n212 = e.graveyardPosition.path.slice();
          return _n212.push(0), t.sourcePosition = new pa(e.graveyardPosition.root, _n212), t.howMany = 0, [t];
        }
        return [new pl(0)];
      }
      if (t.sourcePosition.isEqual(e.sourcePosition) && !t.targetPosition.isEqual(e.targetPosition) && !n.bWasUndone && "splitAtSource" != n.abRelation) {
        var _o127 = "$graveyard" == t.targetPosition.root.rootName,
          _i110 = "$graveyard" == e.targetPosition.root.rootName,
          _r42 = _o127 && !_i110;
        if (_i110 && !_o127 || !_r42 && n.aIsStrong) {
          var _n213 = e.targetPosition._getTransformedByMergeOperation(e),
            _o128 = t.targetPosition._getTransformedByMergeOperation(e);
          return [new Hc(_n213, t.howMany, _o128, 0)];
        }
        return [new pl(0)];
      }
      return t.sourcePosition.hasSameParentAs(e.targetPosition) && (t.howMany += e.howMany), t.sourcePosition = t.sourcePosition._getTransformedByMergeOperation(e), t.targetPosition = t.targetPosition._getTransformedByMergeOperation(e), t.graveyardPosition.isEqual(e.graveyardPosition) && n.aIsStrong || (t.graveyardPosition = t.graveyardPosition._getTransformedByMergeOperation(e)), [t];
    }), wu(Yc, Hc, function (t, e, n) {
      var o = wa._createFromPositionAndShift(e.sourcePosition, e.howMany);
      return "remove" == e.type && !n.bWasUndone && !n.forceWeakRemove && t.deletionPosition.hasSameParentAs(e.sourcePosition) && o.containsPosition(t.sourcePosition) ? [new pl(0)] : (t.sourcePosition.hasSameParentAs(e.targetPosition) && (t.howMany += e.howMany), t.sourcePosition.hasSameParentAs(e.sourcePosition) && (t.howMany -= e.howMany), t.sourcePosition = t.sourcePosition._getTransformedByMoveOperation(e), t.targetPosition = t.targetPosition._getTransformedByMoveOperation(e), t.graveyardPosition.isEqual(e.targetPosition) || (t.graveyardPosition = t.graveyardPosition._getTransformedByMoveOperation(e)), [t]);
    }), wu(Yc, Qc, function (t, e, n) {
      if (e.graveyardPosition && (t.graveyardPosition = t.graveyardPosition._getTransformedByDeletion(e.graveyardPosition, 1), t.deletionPosition.isEqual(e.graveyardPosition) && (t.howMany = e.howMany)), t.targetPosition.isEqual(e.splitPosition)) {
        var _o129 = 0 != e.howMany,
          _i111 = e.graveyardPosition && t.deletionPosition.isEqual(e.graveyardPosition);
        if (_o129 || _i111 || "mergeTargetNotMoved" == n.abRelation) return t.sourcePosition = t.sourcePosition._getTransformedBySplitOperation(e), [t];
      }
      if (t.sourcePosition.isEqual(e.splitPosition)) {
        if ("mergeSourceNotMoved" == n.abRelation) return t.howMany = 0, t.targetPosition = t.targetPosition._getTransformedBySplitOperation(e), [t];
        if ("mergeSameElement" == n.abRelation || t.sourcePosition.offset > 0) return t.sourcePosition = e.moveTargetPosition.clone(), t.targetPosition = t.targetPosition._getTransformedBySplitOperation(e), [t];
      }
      return t.sourcePosition.hasSameParentAs(e.splitPosition) && (t.howMany = e.splitPosition.offset), t.sourcePosition = t.sourcePosition._getTransformedBySplitOperation(e), t.targetPosition = t.targetPosition._getTransformedBySplitOperation(e), [t];
    }), wu(Hc, Gc, function (t, e) {
      var n = wa._createFromPositionAndShift(t.sourcePosition, t.howMany)._getTransformedByInsertOperation(e, !1)[0];
      return t.sourcePosition = n.start, t.howMany = n.end.offset - n.start.offset, t.targetPosition.isEqual(e.position) || (t.targetPosition = t.targetPosition._getTransformedByInsertOperation(e)), [t];
    }), wu(Hc, Hc, function (t, e, n) {
      var o = wa._createFromPositionAndShift(t.sourcePosition, t.howMany),
        i = wa._createFromPositionAndShift(e.sourcePosition, e.howMany);
      var r,
        s = n.aIsStrong,
        a = !n.aIsStrong;
      if ("insertBefore" == n.abRelation || "insertAfter" == n.baRelation ? a = !0 : "insertAfter" != n.abRelation && "insertBefore" != n.baRelation || (a = !1), r = t.targetPosition.isEqual(e.targetPosition) && a ? t.targetPosition._getTransformedByDeletion(e.sourcePosition, e.howMany) : t.targetPosition._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany), Du(t, e) && Du(e, t)) return [e.getReversed()];
      if (o.containsPosition(e.targetPosition) && o.containsRange(i, !0)) return o.start = o.start._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany), o.end = o.end._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany), Mu([o], r);
      if (i.containsPosition(t.targetPosition) && i.containsRange(o, !0)) return o.start = o.start._getCombined(e.sourcePosition, e.getMovedRangeStart()), o.end = o.end._getCombined(e.sourcePosition, e.getMovedRangeStart()), Mu([o], r);
      var c = bo(t.sourcePosition.getParentPath(), e.sourcePosition.getParentPath());
      if ("prefix" == c || "extension" == c) return o.start = o.start._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany), o.end = o.end._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany), Mu([o], r);
      "remove" != t.type || "remove" == e.type || n.aWasUndone || n.forceWeakRemove ? "remove" == t.type || "remove" != e.type || n.bWasUndone || n.forceWeakRemove || (s = !1) : s = !0;
      var l = [],
        d = o.getDifference(i);
      var _iterator302 = _createForOfIteratorHelper(d),
        _step302;
      try {
        for (_iterator302.s(); !(_step302 = _iterator302.n()).done;) {
          var _t242 = _step302.value;
          _t242.start = _t242.start._getTransformedByDeletion(e.sourcePosition, e.howMany), _t242.end = _t242.end._getTransformedByDeletion(e.sourcePosition, e.howMany);
          var _n214 = "same" == bo(_t242.start.getParentPath(), e.getMovedRangeStart().getParentPath()),
            _o130 = _t242._getTransformedByInsertion(e.getMovedRangeStart(), e.howMany, _n214);
          l.push.apply(l, _toConsumableArray(_o130));
        }
      } catch (err) {
        _iterator302.e(err);
      } finally {
        _iterator302.f();
      }
      var h = o.getIntersection(i);
      return null !== h && s && (h.start = h.start._getCombined(e.sourcePosition, e.getMovedRangeStart()), h.end = h.end._getCombined(e.sourcePosition, e.getMovedRangeStart()), 0 === l.length ? l.push(h) : 1 == l.length ? i.start.isBefore(o.start) || i.start.isEqual(o.start) ? l.unshift(h) : l.push(h) : l.splice(1, 0, h)), 0 === l.length ? [new pl(t.baseVersion)] : Mu(l, r);
    }), wu(Hc, Qc, function (t, e, n) {
      var o = t.targetPosition.clone();
      t.targetPosition.isEqual(e.insertionPosition) && e.graveyardPosition && "moveTargetAfter" != n.abRelation || (o = t.targetPosition._getTransformedBySplitOperation(e));
      var i = wa._createFromPositionAndShift(t.sourcePosition, t.howMany);
      if (i.end.isEqual(e.insertionPosition)) return e.graveyardPosition || t.howMany++, t.targetPosition = o, [t];
      if (i.start.hasSameParentAs(e.splitPosition) && i.containsPosition(e.splitPosition)) {
        var _t243 = new wa(e.splitPosition, i.end);
        _t243 = _t243._getTransformedBySplitOperation(e);
        return Mu([new wa(i.start, e.splitPosition), _t243], o);
      }
      t.targetPosition.isEqual(e.splitPosition) && "insertAtSource" == n.abRelation && (o = e.moveTargetPosition), t.targetPosition.isEqual(e.insertionPosition) && "insertBetween" == n.abRelation && (o = t.targetPosition);
      var r = [i._getTransformedBySplitOperation(e)];
      if (e.graveyardPosition) {
        var _o131 = i.start.isEqual(e.graveyardPosition) || i.containsPosition(e.graveyardPosition);
        t.howMany > 1 && _o131 && !n.aWasUndone && r.push(wa._createFromPositionAndShift(e.insertionPosition, 1));
      }
      return Mu(r, o);
    }), wu(Hc, Yc, function (t, e, n) {
      var o = wa._createFromPositionAndShift(t.sourcePosition, t.howMany);
      if (e.deletionPosition.hasSameParentAs(t.sourcePosition) && o.containsPosition(e.sourcePosition)) if ("remove" != t.type || n.forceWeakRemove) {
        if (1 == t.howMany) return n.bWasUndone ? (t.sourcePosition = e.graveyardPosition.clone(), t.targetPosition = t.targetPosition._getTransformedByMergeOperation(e), [t]) : [new pl(0)];
      } else if (!n.aWasUndone) {
        var _n215 = [];
        var _o132 = e.graveyardPosition.clone(),
          _i112 = e.targetPosition._getTransformedByMergeOperation(e);
        t.howMany > 1 && (_n215.push(new Hc(t.sourcePosition, t.howMany - 1, t.targetPosition, 0)), _o132 = _o132._getTransformedByMove(t.sourcePosition, t.targetPosition, t.howMany - 1), _i112 = _i112._getTransformedByMove(t.sourcePosition, t.targetPosition, t.howMany - 1));
        var _r43 = e.deletionPosition._getCombined(t.sourcePosition, t.targetPosition),
          _s26 = new Hc(_o132, 1, _r43, 0),
          _a16 = _s26.getMovedRangeStart().path.slice();
        _a16.push(0);
        var _c9 = new pa(_s26.targetPosition.root, _a16);
        _i112 = _i112._getTransformedByMove(_o132, _r43, 1);
        var _l4 = new Hc(_i112, e.howMany, _c9, 0);
        return _n215.push(_s26), _n215.push(_l4), _n215;
      }
      var i = wa._createFromPositionAndShift(t.sourcePosition, t.howMany)._getTransformedByMergeOperation(e);
      return t.sourcePosition = i.start, t.howMany = i.end.offset - i.start.offset, t.targetPosition = t.targetPosition._getTransformedByMergeOperation(e), [t];
    }), wu(qc, Gc, function (t, e) {
      return t.position = t.position._getTransformedByInsertOperation(e), [t];
    }), wu(qc, Yc, function (t, e) {
      return t.position.isEqual(e.deletionPosition) ? (t.position = e.graveyardPosition.clone(), t.position.stickiness = "toNext", [t]) : (t.position = t.position._getTransformedByMergeOperation(e), [t]);
    }), wu(qc, Hc, function (t, e) {
      return t.position = t.position._getTransformedByMoveOperation(e), [t];
    }), wu(qc, qc, function (t, e, n) {
      if (t.position.isEqual(e.position)) {
        if (!n.aIsStrong) return [new pl(0)];
        t.oldName = e.newName;
      }
      return [t];
    }), wu(qc, Qc, function (t, e) {
      if ("same" == bo(t.position.path, e.splitPosition.getParentPath()) && !e.graveyardPosition) {
        var _e233 = new qc(t.position.getShiftedBy(1), t.oldName, t.newName, 0);
        return [t, _e233];
      }
      return t.position = t.position._getTransformedBySplitOperation(e), [t];
    }), wu(Kc, Kc, function (t, e, n) {
      if (t.root === e.root && t.key === e.key) {
        if (!n.aIsStrong || t.newValue === e.newValue) return [new pl(0)];
        t.oldValue = e.newValue;
      }
      return [t];
    }), wu(Qc, Gc, function (t, e) {
      return t.splitPosition.hasSameParentAs(e.position) && t.splitPosition.offset < e.position.offset && (t.howMany += e.howMany), t.splitPosition = t.splitPosition._getTransformedByInsertOperation(e), t.insertionPosition = t.insertionPosition._getTransformedByInsertOperation(e), [t];
    }), wu(Qc, Yc, function (t, e, n) {
      if (!t.graveyardPosition && !n.bWasUndone && t.splitPosition.hasSameParentAs(e.sourcePosition)) {
        var _n216 = e.graveyardPosition.path.slice();
        _n216.push(0);
        var _o133 = new pa(e.graveyardPosition.root, _n216),
          _i113 = Qc.getInsertionPosition(new pa(e.graveyardPosition.root, _n216)),
          _r44 = new Qc(_o133, 0, _i113, null, 0);
        return t.splitPosition = t.splitPosition._getTransformedByMergeOperation(e), t.insertionPosition = Qc.getInsertionPosition(t.splitPosition), t.graveyardPosition = _r44.insertionPosition.clone(), t.graveyardPosition.stickiness = "toNext", [_r44, t];
      }
      return t.splitPosition.hasSameParentAs(e.deletionPosition) && !t.splitPosition.isAfter(e.deletionPosition) && t.howMany--, t.splitPosition.hasSameParentAs(e.targetPosition) && (t.howMany += e.howMany), t.splitPosition = t.splitPosition._getTransformedByMergeOperation(e), t.insertionPosition = Qc.getInsertionPosition(t.splitPosition), t.graveyardPosition && (t.graveyardPosition = t.graveyardPosition._getTransformedByMergeOperation(e)), [t];
    }), wu(Qc, Hc, function (t, e, n) {
      var o = wa._createFromPositionAndShift(e.sourcePosition, e.howMany);
      if (t.graveyardPosition) {
        var _i114 = o.start.isEqual(t.graveyardPosition) || o.containsPosition(t.graveyardPosition);
        if (!n.bWasUndone && _i114) {
          var _n217 = t.splitPosition._getTransformedByMoveOperation(e),
            _o134 = t.graveyardPosition._getTransformedByMoveOperation(e),
            _i115 = _o134.path.slice();
          _i115.push(0);
          var _r45 = new pa(_o134.root, _i115);
          return [new Hc(_n217, t.howMany, _r45, 0)];
        }
        t.graveyardPosition = t.graveyardPosition._getTransformedByMoveOperation(e);
      }
      var i = t.splitPosition.isEqual(e.targetPosition);
      if (i && ("insertAtSource" == n.baRelation || "splitBefore" == n.abRelation)) return t.howMany += e.howMany, t.splitPosition = t.splitPosition._getTransformedByDeletion(e.sourcePosition, e.howMany), t.insertionPosition = Qc.getInsertionPosition(t.splitPosition), [t];
      if (i && n.abRelation && n.abRelation.howMany) {
        var _n$abRelation = n.abRelation,
          _e234 = _n$abRelation.howMany,
          _o135 = _n$abRelation.offset;
        return t.howMany += _e234, t.splitPosition = t.splitPosition.getShiftedBy(_o135), [t];
      }
      if (t.splitPosition.hasSameParentAs(e.sourcePosition) && o.containsPosition(t.splitPosition)) {
        var _n218 = e.howMany - (t.splitPosition.offset - e.sourcePosition.offset);
        return t.howMany -= _n218, t.splitPosition.hasSameParentAs(e.targetPosition) && t.splitPosition.offset < e.targetPosition.offset && (t.howMany += e.howMany), t.splitPosition = e.sourcePosition.clone(), t.insertionPosition = Qc.getInsertionPosition(t.splitPosition), [t];
      }
      return e.sourcePosition.isEqual(e.targetPosition) || (t.splitPosition.hasSameParentAs(e.sourcePosition) && t.splitPosition.offset <= e.sourcePosition.offset && (t.howMany -= e.howMany), t.splitPosition.hasSameParentAs(e.targetPosition) && t.splitPosition.offset < e.targetPosition.offset && (t.howMany += e.howMany)), t.splitPosition.stickiness = "toNone", t.splitPosition = t.splitPosition._getTransformedByMoveOperation(e), t.splitPosition.stickiness = "toNext", t.graveyardPosition ? t.insertionPosition = t.insertionPosition._getTransformedByMoveOperation(e) : t.insertionPosition = Qc.getInsertionPosition(t.splitPosition), [t];
    }), wu(Qc, Qc, function (t, e, n) {
      if (t.splitPosition.isEqual(e.splitPosition)) {
        if (!t.graveyardPosition && !e.graveyardPosition) return [new pl(0)];
        if (t.graveyardPosition && e.graveyardPosition && t.graveyardPosition.isEqual(e.graveyardPosition)) return [new pl(0)];
        if ("splitBefore" == n.abRelation) return t.howMany = 0, t.graveyardPosition = t.graveyardPosition._getTransformedBySplitOperation(e), [t];
      }
      if (t.graveyardPosition && e.graveyardPosition && t.graveyardPosition.isEqual(e.graveyardPosition)) {
        var _o136 = "$graveyard" == t.splitPosition.root.rootName,
          _i116 = "$graveyard" == e.splitPosition.root.rootName,
          _r46 = _o136 && !_i116;
        if (_i116 && !_o136 || !_r46 && n.aIsStrong) {
          var _n219 = [];
          return e.howMany && _n219.push(new Hc(e.moveTargetPosition, e.howMany, e.splitPosition, 0)), t.howMany && _n219.push(new Hc(t.splitPosition, t.howMany, t.moveTargetPosition, 0)), _n219;
        }
        return [new pl(0)];
      }
      if (t.graveyardPosition && (t.graveyardPosition = t.graveyardPosition._getTransformedBySplitOperation(e)), t.splitPosition.isEqual(e.insertionPosition) && "splitBefore" == n.abRelation) return t.howMany++, [t];
      if (e.splitPosition.isEqual(t.insertionPosition) && "splitBefore" == n.baRelation) {
        var _n220 = e.insertionPosition.path.slice();
        _n220.push(0);
        var _o137 = new pa(e.insertionPosition.root, _n220);
        return [t, new Hc(t.insertionPosition, 1, _o137, 0)];
      }
      return t.splitPosition.hasSameParentAs(e.splitPosition) && t.splitPosition.offset < e.splitPosition.offset && (t.howMany -= e.howMany), t.splitPosition = t.splitPosition._getTransformedBySplitOperation(e), t.insertionPosition = Qc.getInsertionPosition(t.splitPosition), [t];
    });
    var Iu = /*#__PURE__*/function (_ps5) {
      _inherits(Iu, _ps5);
      function Iu(t) {
        var _this146;
        _classCallCheck(this, Iu);
        _this146 = _possibleConstructorReturn(this, _getPrototypeOf(Iu).call(this, t)), _this146.domEventType = "click";
        return _this146;
      }
      _createClass(Iu, [{
        key: "onDomEvent",
        value: function onDomEvent(t) {
          this.fire(t.type, t);
        }
      }]);
      return Iu;
    }(ps);
    var Tu = /*#__PURE__*/function (_ps6) {
      _inherits(Tu, _ps6);
      function Tu(t) {
        var _this147;
        _classCallCheck(this, Tu);
        _this147 = _possibleConstructorReturn(this, _getPrototypeOf(Tu).call(this, t)), _this147.domEventType = ["mousedown", "mouseup", "mouseover", "mouseout"];
        return _this147;
      }
      _createClass(Tu, [{
        key: "onDomEvent",
        value: function onDomEvent(t) {
          this.fire(t.type, t);
        }
      }]);
      return Tu;
    }(ps);
    var Su = /*#__PURE__*/function () {
      function Su(t) {
        _classCallCheck(this, Su);
        this.document = t;
      }
      _createClass(Su, [{
        key: "createDocumentFragment",
        value: function createDocumentFragment(t) {
          return new Xi(this.document, t);
        }
      }, {
        key: "createElement",
        value: function createElement(t, e, n) {
          return new di(this.document, t, e, n);
        }
      }, {
        key: "createText",
        value: function createText(t) {
          return new Ao(this.document, t);
        }
      }, {
        key: "clone",
        value: function clone(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          return t._clone(e);
        }
      }, {
        key: "appendChild",
        value: function appendChild(t, e) {
          return e._appendChild(t);
        }
      }, {
        key: "insertChild",
        value: function insertChild(t, e, n) {
          return n._insertChild(t, e);
        }
      }, {
        key: "removeChildren",
        value: function removeChildren(t, e, n) {
          return n._removeChildren(t, e);
        }
      }, {
        key: "remove",
        value: function remove(t) {
          var e = t.parent;
          return e ? this.removeChildren(e.getChildIndex(t), 1, e) : [];
        }
      }, {
        key: "replace",
        value: function replace(t, e) {
          var n = t.parent;
          if (n) {
            var _o138 = n.getChildIndex(t);
            return this.removeChildren(_o138, 1, n), this.insertChild(_o138, e, n), !0;
          }
          return !1;
        }
      }, {
        key: "unwrapElement",
        value: function unwrapElement(t) {
          var e = t.parent;
          if (e) {
            var _n221 = e.getChildIndex(t);
            this.remove(t), this.insertChild(_n221, t.getChildren(), e);
          }
        }
      }, {
        key: "rename",
        value: function rename(t, e) {
          var n = new di(this.document, t, e.getAttributes(), e.getChildren());
          return this.replace(e, n) ? n : null;
        }
      }, {
        key: "setAttribute",
        value: function setAttribute(t, e, n) {
          n._setAttribute(t, e);
        }
      }, {
        key: "removeAttribute",
        value: function removeAttribute(t, e) {
          e._removeAttribute(t);
        }
      }, {
        key: "addClass",
        value: function addClass(t, e) {
          e._addClass(t);
        }
      }, {
        key: "removeClass",
        value: function removeClass(t, e) {
          e._removeClass(t);
        }
      }, {
        key: "setStyle",
        value: function setStyle(t, e, n) {
          le(t) && void 0 === n && (n = e), n._setStyle(t, e);
        }
      }, {
        key: "removeStyle",
        value: function removeStyle(t, e) {
          e._removeStyle(t);
        }
      }, {
        key: "setCustomProperty",
        value: function setCustomProperty(t, e, n) {
          n._setCustomProperty(t, e);
        }
      }, {
        key: "removeCustomProperty",
        value: function removeCustomProperty(t, e) {
          return e._removeCustomProperty(t);
        }
      }, {
        key: "createPositionAt",
        value: function createPositionAt(t, e) {
          return bi._createAt(t, e);
        }
      }, {
        key: "createPositionAfter",
        value: function createPositionAfter(t) {
          return bi._createAfter(t);
        }
      }, {
        key: "createPositionBefore",
        value: function createPositionBefore(t) {
          return bi._createBefore(t);
        }
      }, {
        key: "createRange",
        value: function createRange(t, e) {
          return new wi(t, e);
        }
      }, {
        key: "createRangeOn",
        value: function createRangeOn(t) {
          return wi._createOn(t);
        }
      }, {
        key: "createRangeIn",
        value: function createRangeIn(t) {
          return wi._createIn(t);
        }
      }, {
        key: "createSelection",
        value: function createSelection(t, e, n) {
          return new _i(t, e, n);
        }
      }]);
      return Su;
    }();
    new Set(["black", "silver", "gray", "white", "maroon", "red", "purple", "fuchsia", "green", "lime", "olive", "yellow", "navy", "blue", "teal", "aqua", "orange", "aliceblue", "antiquewhite", "aquamarine", "azure", "beige", "bisque", "blanchedalmond", "blueviolet", "brown", "burlywood", "cadetblue", "chartreuse", "chocolate", "coral", "cornflowerblue", "cornsilk", "crimson", "cyan", "darkblue", "darkcyan", "darkgoldenrod", "darkgray", "darkgreen", "darkgrey", "darkkhaki", "darkmagenta", "darkolivegreen", "darkorange", "darkorchid", "darkred", "darksalmon", "darkseagreen", "darkslateblue", "darkslategray", "darkslategrey", "darkturquoise", "darkviolet", "deeppink", "deepskyblue", "dimgray", "dimgrey", "dodgerblue", "firebrick", "floralwhite", "forestgreen", "gainsboro", "ghostwhite", "gold", "goldenrod", "greenyellow", "grey", "honeydew", "hotpink", "indianred", "indigo", "ivory", "khaki", "lavender", "lavenderblush", "lawngreen", "lemonchiffon", "lightblue", "lightcoral", "lightcyan", "lightgoldenrodyellow", "lightgray", "lightgreen", "lightgrey", "lightpink", "lightsalmon", "lightseagreen", "lightskyblue", "lightslategray", "lightslategrey", "lightsteelblue", "lightyellow", "limegreen", "linen", "magenta", "mediumaquamarine", "mediumblue", "mediumorchid", "mediumpurple", "mediumseagreen", "mediumslateblue", "mediumspringgreen", "mediumturquoise", "mediumvioletred", "midnightblue", "mintcream", "mistyrose", "moccasin", "navajowhite", "oldlace", "olivedrab", "orangered", "orchid", "palegoldenrod", "palegreen", "paleturquoise", "palevioletred", "papayawhip", "peachpuff", "peru", "pink", "plum", "powderblue", "rosybrown", "royalblue", "saddlebrown", "salmon", "sandybrown", "seagreen", "seashell", "sienna", "skyblue", "slateblue", "slategray", "slategrey", "snow", "springgreen", "steelblue", "tan", "thistle", "tomato", "turquoise", "violet", "wheat", "whitesmoke", "yellowgreen", "rebeccapurple", "currentcolor", "transparent"]);
    var Nu = /^([+-]?[0-9]*([.][0-9]+)?(px|cm|mm|in|pc|pt|ch|em|ex|rem|vh|vw|vmin|vmax)|0)$/;
    function Bu(t) {
      return Nu.test(t);
    }
    var Pu = /^[+-]?[0-9]*([.][0-9]+)?%$/;
    var zu = /*#__PURE__*/function (_Ul) {
      _inherits(zu, _Ul);
      function zu(t, e) {
        var _this148;
        _classCallCheck(this, zu);
        _this148 = _possibleConstructorReturn(this, _getPrototypeOf(zu).call(this, t)), _this148.view = e, _this148._toolbarConfig = oh(t.config.get("toolbar")), _this148._elementReplacer = new zs();
        return _this148;
      }
      _createClass(zu, [{
        key: "init",
        value: function init(t) {
          var e = this.editor,
            n = this.view,
            o = e.editing.view,
            i = n.editable,
            r = o.document.getRoot();
          i.name = r.rootName, n.render();
          var s = i.element;
          this.setEditableElement(i.name, s), this.focusTracker.add(s), n.editable.bind("isFocused").to(this.focusTracker), o.attachDomRoot(s), t && this._elementReplacer.replace(t, this.element), this._initPlaceholder(), this._initToolbar(), this.fire("ready");
        }
      }, {
        key: "destroy",
        value: function destroy() {
          var t = this.view,
            e = this.editor.editing.view;
          this._elementReplacer.restore(), e.detachDomRoot(t.editable.name), t.destroy(), _get(_getPrototypeOf(zu.prototype), "destroy", this).call(this);
        }
      }, {
        key: "_initToolbar",
        value: function _initToolbar() {
          var t = this.editor,
            e = this.view,
            n = t.editing.view;
          e.stickyPanel.bind("isActive").to(this.focusTracker, "isFocused"), e.stickyPanel.limiterElement = e.element, this._toolbarConfig.viewportTopOffset && (e.stickyPanel.viewportTopOffset = this._toolbarConfig.viewportTopOffset), e.toolbar.fillFromConfig(this._toolbarConfig, this.componentFactory), function (_ref39) {
            var t = _ref39.origin,
              e = _ref39.originKeystrokeHandler,
              n = _ref39.originFocusTracker,
              o = _ref39.toolbar,
              i = _ref39.beforeFocus,
              r = _ref39.afterBlur;
            n.add(o.element), e.set("Alt+F10", function (t, e) {
              n.isFocused && !o.focusTracker.isFocused && (i && i(), o.focus(), e());
            }), o.keystrokes.set("Esc", function (e, n) {
              o.focusTracker.isFocused && (t.focus(), r && r(), n());
            });
          }({
            origin: n,
            originFocusTracker: this.focusTracker,
            originKeystrokeHandler: t.keystrokes,
            toolbar: e.toolbar
          });
        }
      }, {
        key: "_initPlaceholder",
        value: function _initPlaceholder() {
          var t = this.editor,
            e = t.editing.view,
            n = e.document.getRoot(),
            o = t.sourceElement,
            i = t.config.get("placeholder") || o && "textarea" === o.tagName.toLowerCase() && o.getAttribute("placeholder");
          i && gu({
            view: e,
            element: n,
            text: i,
            isDirectHost: !1,
            keepOnFocus: !0
          });
        }
      }, {
        key: "element",
        get: function get() {
          return this.view.element;
        }
      }]);
      return zu;
    }(Ul);
    var Lu = n(35),
      Ou = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Zl()(Lu.a, Ou), Lu.a.locals;
    var Ru = /*#__PURE__*/function (_Mh) {
      _inherits(Ru, _Mh);
      function Ru(t, e) {
        var _this149;
        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        _classCallCheck(this, Ru);
        _this149 = _possibleConstructorReturn(this, _getPrototypeOf(Ru).call(this, t)), _this149.stickyPanel = new au(t), _this149.toolbar = new sh(t, {
          shouldGroupWhenFull: n.shouldToolbarGroupWhenFull
        }), _this149.editable = new Th(t, e);
        return _this149;
      }
      _createClass(Ru, [{
        key: "render",
        value: function render() {
          _get(_getPrototypeOf(Ru.prototype), "render", this).call(this), this.stickyPanel.content.add(this.toolbar), this.top.add(this.stickyPanel), this.main.add(this.editable);
        }
      }]);
      return Ru;
    }(Mh);
    var ju = /*#__PURE__*/function (_jl) {
      _inherits(ju, _jl);
      function ju(t, e) {
        var _this150;
        _classCallCheck(this, ju);
        _this150 = _possibleConstructorReturn(this, _getPrototypeOf(ju).call(this, e)), oo(t) && (_this150.sourceElement = t), _this150.model.document.createRoot();
        var n = !_this150.config.get("toolbar.shouldNotGroupWhenFull"),
          o = new Ru(_this150.locale, _this150.editing.view, {
            shouldToolbarGroupWhenFull: n
          });
        _this150.ui = new zu(_assertThisInitialized(_assertThisInitialized(_this150)), o), function (t) {
          if (!N(t.updateSourceElement)) throw new c.a("attachtoform-missing-elementapi-interface", t);
          var e = t.sourceElement;
          if (e && "textarea" === e.tagName.toLowerCase() && e.form) {
            var _n222;
            var _o139 = e.form,
              _i117 = function _i117() {
                return t.updateSourceElement();
              };
            N(_o139.submit) && (_n222 = _o139.submit, _o139.submit = function () {
              _i117(), _n222.apply(_o139);
            }), _o139.addEventListener("submit", _i117), t.on("destroy", function () {
              _o139.removeEventListener("submit", _i117), _n222 && (_o139.submit = _n222);
            });
          }
        }(_assertThisInitialized(_assertThisInitialized(_this150)));
        return _this150;
      }
      _createClass(ju, [{
        key: "destroy",
        value: function destroy() {
          return this.sourceElement && this.updateSourceElement(), this.ui.destroy(), _get(_getPrototypeOf(ju.prototype), "destroy", this).call(this);
        }
      }], [{
        key: "create",
        value: function create(t) {
          var _this151 = this;
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          return new Promise(function (n) {
            var o = new _this151(t, e);
            n(o.initPlugins().then(function () {
              return o.ui.init(oo(t) ? t : null);
            }).then(function () {
              if (!oo(t) && e.initialData) throw new c.a("editor-create-initial-data", null);
              var n = void 0 !== e.initialData ? e.initialData : function (t) {
                return oo(t) ? (e = t, e instanceof HTMLTextAreaElement ? e.value : e.innerHTML) : t;
                var e;
              }(t);
              return o.data.init(n);
            }).then(function () {
              return o.fire("ready");
            }).then(function () {
              return o;
            }));
          });
        }
      }]);
      return ju;
    }(jl);
    $t(ju, Hl), $t(ju, Gl);
    var Fu = ["left", "right", "center", "justify"];
    function Vu(t) {
      return Fu.includes(t);
    }
    function Uu(t, e) {
      return "rtl" == e.contentLanguageDirection ? "right" === t : "left" === t;
    }
    function Hu(t) {
      var e = t.map(function (t) {
          var e;
          return e = "string" == typeof t ? {
            name: t
          } : t, e;
        }).filter(function (t) {
          var e = !!Fu.includes(t.name);
          return e || Object(c.b)("alignment-config-name-not-recognized", {
            option: t
          }), e;
        }),
        n = e.filter(function (t) {
          return !!t.className;
        }).length;
      if (n && n < e.length) throw new c.a("alignment-config-classnames-are-missing", {
        configuredOptions: t
      });
      return e.forEach(function (e, n, o) {
        var i = o.slice(n + 1);
        if (i.some(function (t) {
          return t.name == e.name;
        })) throw new c.a("alignment-config-name-already-defined", {
          option: e,
          configuredOptions: t
        });
        if (e.className) {
          if (i.some(function (t) {
            return t.className == e.className;
          })) throw new c.a("alignment-config-classname-already-defined", {
            option: e,
            configuredOptions: t
          });
        }
      }), e;
    }
    var Gu = "alignment";
    var Wu = /*#__PURE__*/function (_Xt2) {
      _inherits(Wu, _Xt2);
      function Wu() {
        _classCallCheck(this, Wu);
        return _possibleConstructorReturn(this, _getPrototypeOf(Wu).apply(this, arguments));
      }
      _createClass(Wu, [{
        key: "refresh",
        value: function refresh() {
          var t = this.editor.locale,
            e = Ks(this.editor.model.document.selection.getSelectedBlocks());
          this.isEnabled = !!e && this._canBeAligned(e), this.isEnabled && e.hasAttribute("alignment") ? this.value = e.getAttribute("alignment") : this.value = "rtl" === t.contentLanguageDirection ? "right" : "left";
        }
      }, {
        key: "execute",
        value: function execute() {
          var _this152 = this;
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var e = this.editor,
            n = e.locale,
            o = e.model,
            i = o.document,
            r = t.value;
          o.change(function (t) {
            var e = Array.from(i.selection.getSelectedBlocks()).filter(function (t) {
                return _this152._canBeAligned(t);
              }),
              o = e[0].getAttribute("alignment");
            Uu(r, n) || o === r || !r ? function (t, e) {
              var _iterator303 = _createForOfIteratorHelper(t),
                _step303;
              try {
                for (_iterator303.s(); !(_step303 = _iterator303.n()).done;) {
                  var _n223 = _step303.value;
                  e.removeAttribute(Gu, _n223);
                }
              } catch (err) {
                _iterator303.e(err);
              } finally {
                _iterator303.f();
              }
            }(e, t) : function (t, e, n) {
              var _iterator304 = _createForOfIteratorHelper(t),
                _step304;
              try {
                for (_iterator304.s(); !(_step304 = _iterator304.n()).done;) {
                  var _o140 = _step304.value;
                  e.setAttribute(Gu, n, _o140);
                }
              } catch (err) {
                _iterator304.e(err);
              } finally {
                _iterator304.f();
              }
            }(e, t, r);
          });
        }
      }, {
        key: "_canBeAligned",
        value: function _canBeAligned(t) {
          return this.editor.model.schema.checkAttribute(t, Gu);
        }
      }]);
      return Wu;
    }(Xt);
    var qu = /*#__PURE__*/function (_Jt2) {
      _inherits(qu, _Jt2);
      _createClass(qu, null, [{
        key: "pluginName",
        get: function get() {
          return "AlignmentEditing";
        }
      }]);
      function qu(t) {
        var _this153;
        _classCallCheck(this, qu);
        _this153 = _possibleConstructorReturn(this, _getPrototypeOf(qu).call(this, t)), t.config.define("alignment", {
          options: _toConsumableArray(Fu.map(function (t) {
            return {
              name: t
            };
          }))
        });
        return _this153;
      }
      _createClass(qu, [{
        key: "init",
        value: function init() {
          var t = this.editor,
            e = t.locale,
            n = t.model.schema,
            o = Hu(t.config.get("alignment.options")).filter(function (t) {
              return Vu(t.name) && !Uu(t.name, e);
            }),
            i = o.some(function (t) {
              return !!t.className;
            });
          n.extend("$block", {
            allowAttributes: "alignment"
          }), t.model.schema.setAttributeProperties("alignment", {
            isFormatting: !0
          }), i ? t.conversion.attributeToAttribute(function (t) {
            var e = {
              model: {
                key: "alignment",
                values: t.map(function (t) {
                  return t.name;
                })
              },
              view: {}
            };
            var _iterator305 = _createForOfIteratorHelper(t),
              _step305;
            try {
              for (_iterator305.s(); !(_step305 = _iterator305.n()).done;) {
                var _n224 = _step305.value;
                e.view[_n224.name] = {
                  key: "class",
                  value: _n224.className
                };
              }
            } catch (err) {
              _iterator305.e(err);
            } finally {
              _iterator305.f();
            }
            return e;
          }(o)) : t.conversion.for("downcast").attributeToAttribute(function (t) {
            var e = {
              model: {
                key: "alignment",
                values: t.map(function (t) {
                  return t.name;
                })
              },
              view: {}
            };
            var _iterator306 = _createForOfIteratorHelper(t),
              _step306;
            try {
              for (_iterator306.s(); !(_step306 = _iterator306.n()).done;) {
                var _n225 = _step306.value.name;
                e.view[_n225] = {
                  key: "style",
                  value: {
                    "text-align": _n225
                  }
                };
              }
            } catch (err) {
              _iterator306.e(err);
            } finally {
              _iterator306.f();
            }
            return e;
          }(o));
          var r = function (t) {
            var e = [];
            var _iterator307 = _createForOfIteratorHelper(t),
              _step307;
            try {
              for (_iterator307.s(); !(_step307 = _iterator307.n()).done;) {
                var _n226 = _step307.value.name;
                e.push({
                  view: {
                    key: "style",
                    value: {
                      "text-align": _n226
                    }
                  },
                  model: {
                    key: "alignment",
                    value: _n226
                  }
                });
              }
            } catch (err) {
              _iterator307.e(err);
            } finally {
              _iterator307.f();
            }
            return e;
          }(o);
          var _iterator308 = _createForOfIteratorHelper(r),
            _step308;
          try {
            for (_iterator308.s(); !(_step308 = _iterator308.n()).done;) {
              var _e235 = _step308.value;
              t.conversion.for("upcast").attributeToAttribute(_e235);
            }
          } catch (err) {
            _iterator308.e(err);
          } finally {
            _iterator308.f();
          }
          var s = function (t) {
            var e = [];
            var _iterator309 = _createForOfIteratorHelper(t),
              _step309;
            try {
              for (_iterator309.s(); !(_step309 = _iterator309.n()).done;) {
                var _n227 = _step309.value.name;
                e.push({
                  view: {
                    key: "align",
                    value: _n227
                  },
                  model: {
                    key: "alignment",
                    value: _n227
                  }
                });
              }
            } catch (err) {
              _iterator309.e(err);
            } finally {
              _iterator309.f();
            }
            return e;
          }(o);
          var _iterator310 = _createForOfIteratorHelper(s),
            _step310;
          try {
            for (_iterator310.s(); !(_step310 = _iterator310.n()).done;) {
              var _e236 = _step310.value;
              t.conversion.for("upcast").attributeToAttribute(_e236);
            }
          } catch (err) {
            _iterator310.e(err);
          } finally {
            _iterator310.f();
          }
          t.commands.add("alignment", new Wu(t));
        }
      }]);
      return qu;
    }(Jt);
    var Ku = new Map([["left", ql.alignLeft], ["right", ql.alignRight], ["center", ql.alignCenter], ["justify", ql.alignJustify]]);
    var Yu = /*#__PURE__*/function (_Jt3) {
      _inherits(Yu, _Jt3);
      function Yu() {
        _classCallCheck(this, Yu);
        return _possibleConstructorReturn(this, _getPrototypeOf(Yu).apply(this, arguments));
      }
      _createClass(Yu, [{
        key: "init",
        value: function init() {
          var _this154 = this;
          var t = this.editor,
            e = t.ui.componentFactory,
            n = t.t,
            o = Hu(t.config.get("alignment.options"));
          o.map(function (t) {
            return t.name;
          }).filter(Vu).forEach(function (t) {
            return _this154._addButton(t);
          }), e.add("alignment", function (t) {
            var i = wh(t),
              r = o.map(function (t) {
                return e.create("alignment:".concat(t.name));
              });
            Ch(i, r), i.buttonView.set({
              label: n("Text alignment"),
              tooltip: !0
            }), i.toolbarView.isVertical = !0, i.toolbarView.ariaLabel = n("Text alignment toolbar"), i.extendTemplate({
              attributes: {
                class: "ck-alignment-dropdown"
              }
            });
            var s = "rtl" === t.contentLanguageDirection ? Ku.get("right") : Ku.get("left");
            return i.buttonView.bind("icon").toMany(r, "isOn", function () {
              for (var _len21 = arguments.length, t = new Array(_len21), _key21 = 0; _key21 < _len21; _key21++) {
                t[_key21] = arguments[_key21];
              }
              var e = t.findIndex(function (t) {
                return t;
              });
              return e < 0 ? s : r[e].icon;
            }), i.bind("isEnabled").toMany(r, "isEnabled", function () {
              for (var _len22 = arguments.length, t = new Array(_len22), _key22 = 0; _key22 < _len22; _key22++) {
                t[_key22] = arguments[_key22];
              }
              return t.some(function (t) {
                return t;
              });
            }), i;
          });
        }
      }, {
        key: "_addButton",
        value: function _addButton(t) {
          var _this155 = this;
          var e = this.editor;
          e.ui.componentFactory.add("alignment:".concat(t), function (n) {
            var o = e.commands.get("alignment"),
              i = new Sd(n);
            return i.set({
              label: _this155.localizedOptionTitles[t],
              icon: Ku.get(t),
              tooltip: !0,
              isToggleable: !0
            }), i.bind("isEnabled").to(o), i.bind("isOn").to(o, "value", function (e) {
              return e === t;
            }), _this155.listenTo(i, "execute", function () {
              e.execute("alignment", {
                value: t
              }), e.editing.view.focus();
            }), i;
          });
        }
      }, {
        key: "localizedOptionTitles",
        get: function get() {
          var t = this.editor.t;
          return {
            left: t("Align left"),
            right: t("Align right"),
            center: t("Align center"),
            justify: t("Justify")
          };
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "AlignmentUI";
        }
      }]);
      return Yu;
    }(Jt);
    function Qu(t, e, n, o) {
      var i,
        r = null;
      "function" == typeof o ? i = o : (r = t.commands.get(o), i = function i() {
        t.execute(o);
      }), t.model.document.on("change:data", function (s, a) {
        if (r && !r.isEnabled || !e.isEnabled) return;
        var c = Ks(t.model.document.selection.getRanges());
        if (!c.isCollapsed) return;
        if ("transparent" == a.type) return;
        var l = Array.from(t.model.document.differ.getChanges()),
          d = l[0];
        if (1 != l.length || "insert" !== d.type || "$text" != d.name || 1 != d.length) return;
        var h = d.position.parent;
        if (h.is("element", "codeBlock")) return;
        if (h.is("element", "listItem") && "function" != typeof o && !["numberedList", "bulletedList", "todoList"].includes(o)) return;
        if (r && !0 === r.value) return;
        var u = h.getChild(0),
          g = t.model.createRangeOn(u);
        if (!g.containsRange(c) && !c.end.isEqual(g.end)) return;
        var m = n.exec(u.data.substr(0, c.end.offset));
        m && t.model.enqueueChange(function (e) {
          var n = e.createPositionAt(h, 0),
            o = e.createPositionAt(h, m[0].length),
            r = new Na(n, o);
          if (!1 !== i({
            match: m
          })) {
            e.remove(r);
            var _n228 = t.model.document.selection.getFirstRange(),
              _o141 = e.createRangeIn(h);
            !h.isEmpty || _o141.isEqual(_n228) || _o141.containsRange(_n228, !0) || e.remove(h);
          }
          r.detach();
        });
      });
    }
    function $u(t, e, n, o) {
      var i, r;
      n instanceof RegExp ? i = n : r = n, r = r || function (t) {
        var e;
        var n = [],
          o = [];
        for (; null !== (e = i.exec(t)) && !(e && e.length < 4);) {
          var _e237 = e,
            _t244 = _e237.index,
            _i118 = _e237[1],
            _r47 = _e237[2],
            _s27 = _e237[3];
          var _a17 = _i118 + _r47 + _s27;
          _t244 += e[0].length - _a17.length;
          var _c10 = [_t244, _t244 + _i118.length],
            _l5 = [_t244 + _i118.length + _r47.length, _t244 + _i118.length + _r47.length + _s27.length];
          n.push(_c10), n.push(_l5), o.push([_t244 + _i118.length, _t244 + _i118.length + _r47.length]);
        }
        return {
          remove: n,
          format: o
        };
      }, t.model.document.on("change:data", function (n, i) {
        if ("transparent" == i.type || !e.isEnabled) return;
        var s = t.model,
          a = s.document.selection;
        if (!a.isCollapsed) return;
        var c = Array.from(s.document.differ.getChanges()),
          l = c[0];
        if (1 != c.length || "insert" !== l.type || "$text" != l.name || 1 != l.length) return;
        var d = a.focus,
          h = d.parent,
          _ref40 = function (t, e) {
            var n = t.start;
            return {
              text: Array.from(t.getItems()).reduce(function (t, o) {
                return !o.is("$text") && !o.is("$textProxy") || o.getAttribute("code") ? (n = e.createPositionAfter(o), "") : t + o.data;
              }, ""),
              range: e.createRange(n, t.end)
            };
          }(s.createRange(s.createPositionAt(h, 0), d), s),
          u = _ref40.text,
          g = _ref40.range,
          m = r(u),
          p = Ju(g.start, m.format, s),
          f = Ju(g.start, m.remove, s);
        p.length && f.length && s.enqueueChange(function (t) {
          if (!1 !== o(t, p)) {
            var _iterator311 = _createForOfIteratorHelper(f.reverse()),
              _step311;
            try {
              for (_iterator311.s(); !(_step311 = _iterator311.n()).done;) {
                var _e238 = _step311.value;
                t.remove(_e238);
              }
            } catch (err) {
              _iterator311.e(err);
            } finally {
              _iterator311.f();
            }
          }
        });
      });
    }
    function Ju(t, e, n) {
      return e.filter(function (t) {
        return void 0 !== t[0] && void 0 !== t[1];
      }).map(function (e) {
        return n.createRange(t.getShiftedBy(e[0]), t.getShiftedBy(e[1]));
      });
    }
    function Zu(t, e) {
      return function (n, o) {
        if (!t.commands.get(e).isEnabled) return !1;
        var i = t.model.schema.getValidRanges(o, e);
        var _iterator312 = _createForOfIteratorHelper(i),
          _step312;
        try {
          for (_iterator312.s(); !(_step312 = _iterator312.n()).done;) {
            var _t245 = _step312.value;
            n.setAttribute(e, !0, _t245);
          }
        } catch (err) {
          _iterator312.e(err);
        } finally {
          _iterator312.f();
        }
        n.removeSelectionAttribute(e);
      };
    }
    function Xu(t, e) {
      var _iterator313, _step313, _n229;
      return _regeneratorRuntime().wrap(function Xu$(_context37) {
        while (1) switch (_context37.prev = _context37.next) {
          case 0:
            _iterator313 = _createForOfIteratorHelper(e);
            _context37.prev = 1;
            _iterator313.s();
          case 3:
            if ((_step313 = _iterator313.n()).done) {
              _context37.next = 11;
              break;
            }
            _n229 = _step313.value;
            _context37.t0 = _n229 && t.getAttributeProperties(_n229[0]).copyOnEnter;
            if (!_context37.t0) {
              _context37.next = 9;
              break;
            }
            _context37.next = 9;
            return _n229;
          case 9:
            _context37.next = 3;
            break;
          case 11:
            _context37.next = 16;
            break;
          case 13:
            _context37.prev = 13;
            _context37.t1 = _context37["catch"](1);
            _iterator313.e(_context37.t1);
          case 16:
            _context37.prev = 16;
            _iterator313.f();
            return _context37.finish(16);
          case 19:
          case "end":
            return _context37.stop();
        }
      }, _marked3, null, [[1, 13, 16, 19]]);
    }
    var tg = /*#__PURE__*/function (_Xt3) {
      _inherits(tg, _Xt3);
      function tg() {
        _classCallCheck(this, tg);
        return _possibleConstructorReturn(this, _getPrototypeOf(tg).apply(this, arguments));
      }
      _createClass(tg, [{
        key: "execute",
        value: function execute() {
          var _this156 = this;
          var t = this.editor.model,
            e = t.document;
          t.change(function (n) {
            !function (t, e, n, o) {
              var i = n.isCollapsed,
                r = n.getFirstRange(),
                s = r.start.parent,
                a = r.end.parent;
              if (o.isLimit(s) || o.isLimit(a)) return void (i || s != a || t.deleteContent(n));
              if (i) {
                var _t246 = Xu(e.model.schema, n.getAttributes());
                eg(e, r.start), e.setSelectionAttribute(_t246);
              } else {
                var _o142 = !(r.start.isAtStart && r.end.isAtEnd),
                  _i119 = s == a;
                t.deleteContent(n, {
                  leaveUnmerged: _o142
                }), _o142 && (_i119 ? eg(e, n.focus) : e.setSelection(a, 0));
              }
            }(_this156.editor.model, n, e.selection, t.schema), _this156.fire("afterExecute", {
              writer: n
            });
          });
        }
      }]);
      return tg;
    }(Xt);
    function eg(t, e) {
      t.split(e), t.setSelection(e.parent.nextSibling, 0);
    }
    var ng = /*#__PURE__*/function (_Wr6) {
      _inherits(ng, _Wr6);
      function ng(t) {
        var _this157;
        _classCallCheck(this, ng);
        _this157 = _possibleConstructorReturn(this, _getPrototypeOf(ng).call(this, t));
        var e = _this157.document;
        e.on("keydown", function (t, n) {
          if (_this157.isEnabled && n.keyCode == Vi.enter) {
            var _o143 = new yi(e, "enter", e.selection.getFirstRange());
            e.fire(_o143, new ms(e, n.domEvent, {
              isSoft: n.shiftKey
            })), _o143.stop.called && t.stop();
          }
        });
        return _this157;
      }
      _createClass(ng, [{
        key: "observe",
        value: function observe() {}
      }]);
      return ng;
    }(Wr);
    var og = /*#__PURE__*/function (_Jt4) {
      _inherits(og, _Jt4);
      function og() {
        _classCallCheck(this, og);
        return _possibleConstructorReturn(this, _getPrototypeOf(og).apply(this, arguments));
      }
      _createClass(og, [{
        key: "init",
        value: function init() {
          var t = this.editor,
            e = t.editing.view,
            n = e.document;
          e.addObserver(ng), t.commands.add("enter", new tg(t)), this.listenTo(n, "enter", function (n, o) {
            o.preventDefault(), o.isSoft || (t.execute("enter"), e.scrollToTheSelection());
          }, {
            priority: "low"
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "Enter";
        }
      }]);
      return og;
    }(Jt);
    var ig = /*#__PURE__*/function (_Xt4) {
      _inherits(ig, _Xt4);
      function ig() {
        _classCallCheck(this, ig);
        return _possibleConstructorReturn(this, _getPrototypeOf(ig).apply(this, arguments));
      }
      _createClass(ig, [{
        key: "execute",
        value: function execute() {
          var _this158 = this;
          var t = this.editor.model,
            e = t.document;
          t.change(function (n) {
            !function (t, e, n) {
              var o = n.isCollapsed,
                i = n.getFirstRange(),
                r = i.start.parent,
                s = i.end.parent,
                a = r == s;
              if (o) {
                var _o144 = Xu(t.schema, n.getAttributes());
                rg(t, e, i.end), e.removeSelectionAttribute(n.getAttributeKeys()), e.setSelectionAttribute(_o144);
              } else {
                var _o145 = !(i.start.isAtStart && i.end.isAtEnd);
                t.deleteContent(n, {
                  leaveUnmerged: _o145
                }), a ? rg(t, e, n.focus) : _o145 && e.setSelection(s, 0);
              }
            }(t, n, e.selection), _this158.fire("afterExecute", {
              writer: n
            });
          });
        }
      }, {
        key: "refresh",
        value: function refresh() {
          var t = this.editor.model,
            e = t.document;
          this.isEnabled = function (t, e) {
            if (e.rangeCount > 1) return !1;
            var n = e.anchor;
            if (!n || !t.checkChild(n, "softBreak")) return !1;
            var o = e.getFirstRange(),
              i = o.start.parent,
              r = o.end.parent;
            if ((sg(i, t) || sg(r, t)) && i !== r) return !1;
            return !0;
          }(t.schema, e.selection);
        }
      }]);
      return ig;
    }(Xt);
    function rg(t, e, n) {
      var o = e.createElement("softBreak");
      t.insertContent(o, n), e.setSelection(o, "after");
    }
    function sg(t, e) {
      return !t.is("rootElement") && (e.isLimit(t) || sg(t.parent, e));
    }
    var ag = /*#__PURE__*/function (_Jt5) {
      _inherits(ag, _Jt5);
      function ag() {
        _classCallCheck(this, ag);
        return _possibleConstructorReturn(this, _getPrototypeOf(ag).apply(this, arguments));
      }
      _createClass(ag, [{
        key: "init",
        value: function init() {
          var t = this.editor,
            e = t.model.schema,
            n = t.conversion,
            o = t.editing.view,
            i = o.document;
          e.register("softBreak", {
            allowWhere: "$text",
            isInline: !0
          }), n.for("upcast").elementToElement({
            model: "softBreak",
            view: "br"
          }), n.for("downcast").elementToElement({
            model: "softBreak",
            view: function view(t, _ref41) {
              var e = _ref41.writer;
              return e.createEmptyElement("br");
            }
          }), o.addObserver(ng), t.commands.add("shiftEnter", new ig(t)), this.listenTo(i, "enter", function (e, n) {
            n.preventDefault(), n.isSoft && (t.execute("shiftEnter"), o.scrollToTheSelection());
          }, {
            priority: "low"
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "ShiftEnter";
        }
      }]);
      return ag;
    }(Jt);
    var cg = /*#__PURE__*/function () {
      function cg(t) {
        var _this159 = this;
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;
        _classCallCheck(this, cg);
        this.model = t, this.size = 0, this.limit = e, this.isLocked = !1, this._changeCallback = function (t, e) {
          "transparent" != e.type && e !== _this159._batch && _this159._reset(!0);
        }, this._selectionChangeCallback = function () {
          _this159._reset();
        }, this.model.document.on("change", this._changeCallback), this.model.document.selection.on("change:range", this._selectionChangeCallback), this.model.document.selection.on("change:attribute", this._selectionChangeCallback);
      }
      _createClass(cg, [{
        key: "input",
        value: function input(t) {
          this.size += t, this.size >= this.limit && this._reset(!0);
        }
      }, {
        key: "lock",
        value: function lock() {
          this.isLocked = !0;
        }
      }, {
        key: "unlock",
        value: function unlock() {
          this.isLocked = !1;
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.model.document.off("change", this._changeCallback), this.model.document.selection.off("change:range", this._selectionChangeCallback), this.model.document.selection.off("change:attribute", this._selectionChangeCallback);
        }
      }, {
        key: "_reset",
        value: function _reset(t) {
          this.isLocked && !t || (this._batch = null, this.size = 0);
        }
      }, {
        key: "batch",
        get: function get() {
          return this._batch || (this._batch = this.model.createBatch()), this._batch;
        }
      }]);
      return cg;
    }();
    var lg = /*#__PURE__*/function (_Xt5) {
      _inherits(lg, _Xt5);
      function lg(t, e) {
        var _this160;
        _classCallCheck(this, lg);
        _this160 = _possibleConstructorReturn(this, _getPrototypeOf(lg).call(this, t)), _this160._buffer = new cg(t.model, e), _this160._batches = new WeakSet();
        return _this160;
      }
      _createClass(lg, [{
        key: "destroy",
        value: function destroy() {
          _get(_getPrototypeOf(lg.prototype), "destroy", this).call(this), this._buffer.destroy();
        }
      }, {
        key: "execute",
        value: function execute() {
          var _this161 = this;
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var e = this.editor.model,
            n = e.document,
            o = t.text || "",
            i = o.length,
            r = t.range ? e.createSelection(t.range) : n.selection,
            s = t.resultRange;
          e.enqueueChange(this._buffer.batch, function (t) {
            _this161._buffer.lock(), _this161._batches.add(_this161._buffer.batch), e.deleteContent(r), o && e.insertContent(t.createText(o, n.selection.getAttributes()), r), s ? t.setSelection(s) : r.is("documentSelection") || t.setSelection(r), _this161._buffer.unlock(), _this161._buffer.input(i);
          });
        }
      }, {
        key: "buffer",
        get: function get() {
          return this._buffer;
        }
      }]);
      return lg;
    }(Xt);
    var dg = [Hi("arrowUp"), Hi("arrowRight"), Hi("arrowDown"), Hi("arrowLeft"), 9, 16, 17, 18, 19, 20, 27, 33, 34, 35, 36, 45, 91, 93, 144, 145, 173, 174, 175, 176, 177, 178, 179, 255];
    for (var _t248 = 112; _t248 <= 135; _t248++) dg.push(_t248);
    function hg(t) {
      return !(!t.ctrlKey && !t.metaKey) || dg.includes(t.keyCode);
    }
    function ug(t) {
      if (t.newChildren.length - t.oldChildren.length != 1) return;
      var e = function (t, e) {
        var n = [];
        var o,
          i = 0;
        return t.forEach(function (t) {
          "equal" == t ? (r(), i++) : "insert" == t ? (s("insert") ? o.values.push(e[i]) : (r(), o = {
            type: "insert",
            index: i,
            values: [e[i]]
          }), i++) : s("delete") ? o.howMany++ : (r(), o = {
            type: "delete",
            index: i,
            howMany: 1
          });
        }), r(), n;
        function r() {
          o && (n.push(o), o = null);
        }
        function s(t) {
          return o && o.type == t;
        }
      }(vr(t.oldChildren, t.newChildren, gg), t.newChildren);
      if (e.length > 1) return;
      var n = e[0];
      return n.values[0] && n.values[0].is("$text") ? n : void 0;
    }
    function gg(t, e) {
      return t && t.is("$text") && e && e.is("$text") ? t.data === e.data : t === e;
    }
    var mg = /*#__PURE__*/function () {
      function mg(t) {
        _classCallCheck(this, mg);
        this.editor = t, this.editing = this.editor.editing;
      }
      _createClass(mg, [{
        key: "handle",
        value: function handle(t, e) {
          if (function (t) {
            if (0 == t.length) return !1;
            var _iterator314 = _createForOfIteratorHelper(t),
              _step314;
            try {
              for (_iterator314.s(); !(_step314 = _iterator314.n()).done;) {
                var _e239 = _step314.value;
                if ("children" === _e239.type && !ug(_e239)) return !0;
              }
            } catch (err) {
              _iterator314.e(err);
            } finally {
              _iterator314.f();
            }
            return !1;
          }(t)) this._handleContainerChildrenMutations(t, e);else {
            var _iterator315 = _createForOfIteratorHelper(t),
              _step315;
            try {
              for (_iterator315.s(); !(_step315 = _iterator315.n()).done;) {
                var _n230 = _step315.value;
                this._handleTextMutation(_n230, e), this._handleTextNodeInsertion(_n230);
              }
            } catch (err) {
              _iterator315.e(err);
            } finally {
              _iterator315.f();
            }
          }
        }
      }, {
        key: "_handleContainerChildrenMutations",
        value: function _handleContainerChildrenMutations(t, e) {
          var n = function (t) {
            var e = t.map(function (t) {
              return t.node;
            }).reduce(function (t, e) {
              return t.getCommonAncestor(e, {
                includeSelf: !0
              });
            });
            if (!e) return;
            return e.getAncestors({
              includeSelf: !0,
              parentFirst: !0
            }).find(function (t) {
              return t.is("containerElement") || t.is("rootElement");
            });
          }(t);
          if (!n) return;
          var o = this.editor.editing.view.domConverter.mapViewToDom(n),
            i = new Or(this.editor.editing.view.document),
            r = this.editor.data.toModel(i.domToView(o)).getChild(0),
            s = this.editor.editing.mapper.toModelElement(n);
          if (!s) return;
          var a = Array.from(r.getChildren()),
            c = Array.from(s.getChildren()),
            l = a[a.length - 1],
            d = c[c.length - 1],
            h = l && l.is("element", "softBreak"),
            u = d && !d.is("element", "softBreak");
          h && u && a.pop();
          var g = this.editor.model.schema;
          if (!pg(a, g) || !pg(c, g)) return;
          var m = a.map(function (t) {
              return t.is("$text") ? t.data : "@";
            }).join("").replace(/\u00A0/g, " "),
            p = c.map(function (t) {
              return t.is("$text") ? t.data : "@";
            }).join("").replace(/\u00A0/g, " ");
          if (p === m) return;
          var f = vr(p, m),
            _fg = fg(f),
            k = _fg.firstChangeAt,
            b = _fg.insertions,
            w = _fg.deletions;
          var C = null;
          e && (C = this.editing.mapper.toModelRange(e.getFirstRange()));
          var A = m.substr(k, b),
            _ = this.editor.model.createRange(this.editor.model.createPositionAt(s, k), this.editor.model.createPositionAt(s, k + w));
          this.editor.execute("input", {
            text: A,
            range: _,
            resultRange: C
          });
        }
      }, {
        key: "_handleTextMutation",
        value: function _handleTextMutation(t, e) {
          if ("text" != t.type) return;
          var n = t.newText.replace(/\u00A0/g, " "),
            o = t.oldText.replace(/\u00A0/g, " ");
          if (o === n) return;
          var i = vr(o, n),
            _fg2 = fg(i),
            r = _fg2.firstChangeAt,
            s = _fg2.insertions,
            a = _fg2.deletions;
          var c = null;
          e && (c = this.editing.mapper.toModelRange(e.getFirstRange()));
          var l = this.editing.view.createPositionAt(t.node, r),
            d = this.editing.mapper.toModelPosition(l),
            h = this.editor.model.createRange(d, d.getShiftedBy(a)),
            u = n.substr(r, s);
          this.editor.execute("input", {
            text: u,
            range: h,
            resultRange: c
          });
        }
      }, {
        key: "_handleTextNodeInsertion",
        value: function _handleTextNodeInsertion(t) {
          if ("children" != t.type) return;
          var e = ug(t),
            n = this.editing.view.createPositionAt(t.node, e.index),
            o = this.editing.mapper.toModelPosition(n),
            i = e.values[0].data;
          this.editor.execute("input", {
            text: i.replace(/\u00A0/g, " "),
            range: this.editor.model.createRange(o)
          });
        }
      }]);
      return mg;
    }();
    function pg(t, e) {
      return t.every(function (t) {
        return e.isInline(t);
      });
    }
    function fg(t) {
      var e = null,
        n = null;
      for (var _o147 = 0; _o147 < t.length; _o147++) {
        "equal" != t[_o147] && (e = null === e ? _o147 : e, n = _o147);
      }
      var o = 0,
        i = 0;
      for (var _r49 = e; _r49 <= n; _r49++) "insert" != t[_r49] && o++, "delete" != t[_r49] && i++;
      return {
        insertions: i,
        deletions: o,
        firstChangeAt: e
      };
    }
    var kg = /*#__PURE__*/function (_Jt6) {
      _inherits(kg, _Jt6);
      function kg() {
        _classCallCheck(this, kg);
        return _possibleConstructorReturn(this, _getPrototypeOf(kg).apply(this, arguments));
      }
      _createClass(kg, [{
        key: "init",
        value: function init() {
          var t = this.editor,
            e = new lg(t, t.config.get("typing.undoStep") || 20);
          t.commands.add("input", e), function (t) {
            var e = null;
            var n = t.model,
              o = t.editing.view,
              i = t.commands.get("input");
            function r(t) {
              var r = n.document,
                a = o.document.isComposing,
                c = e && e.isEqual(r.selection);
              e = null, i.isEnabled && (hg(t) || r.selection.isCollapsed || a && 229 === t.keyCode || !a && 229 === t.keyCode && c || s());
            }
            function s() {
              var t = i.buffer;
              t.lock();
              var e = t.batch;
              i._batches.add(e), n.enqueueChange(e, function () {
                n.deleteContent(n.document.selection);
              }), t.unlock();
            }
            Ri.isAndroid ? o.document.on("beforeinput", function (t, e) {
              return r(e);
            }, {
              priority: "lowest"
            }) : o.document.on("keydown", function (t, e) {
              return r(e);
            }, {
              priority: "lowest"
            }), o.document.on("compositionstart", function () {
              var t = n.document,
                e = 1 !== t.selection.rangeCount || t.selection.getFirstRange().isFlat;
              t.selection.isCollapsed || e || s();
            }, {
              priority: "lowest"
            }), o.document.on("compositionend", function () {
              e = n.createSelection(n.document.selection);
            }, {
              priority: "lowest"
            });
          }(t), function (t) {
            t.editing.view.document.on("mutations", function (e, n, o) {
              new mg(t).handle(n, o);
            });
          }(t);
        }
      }, {
        key: "isInput",
        value: function isInput(t) {
          return this.editor.commands.get("input")._batches.has(t);
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "Input";
        }
      }]);
      return kg;
    }(Jt);
    var bg = /*#__PURE__*/function (_Xt6) {
      _inherits(bg, _Xt6);
      function bg(t, e) {
        var _this162;
        _classCallCheck(this, bg);
        _this162 = _possibleConstructorReturn(this, _getPrototypeOf(bg).call(this, t)), _this162.direction = e, _this162._buffer = new cg(t.model, t.config.get("typing.undoStep"));
        return _this162;
      }
      _createClass(bg, [{
        key: "execute",
        value: function execute() {
          var _this163 = this;
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var e = this.editor.model,
            n = e.document;
          e.enqueueChange(this._buffer.batch, function (o) {
            _this163._buffer.lock();
            var i = o.createSelection(t.selection || n.selection),
              r = t.sequence || 1,
              s = i.isCollapsed;
            if (i.isCollapsed && e.modifySelection(i, {
              direction: _this163.direction,
              unit: t.unit
            }), _this163._shouldEntireContentBeReplacedWithParagraph(r)) return void _this163._replaceEntireContentWithParagraph(o);
            if (_this163._shouldReplaceFirstBlockWithParagraph(i, r)) return void _this163.editor.execute("paragraph", {
              selection: i
            });
            if (i.isCollapsed) return;
            var a = 0;
            i.getFirstRange().getMinimalFlatRanges().forEach(function (t) {
              a += Ai(t.getWalker({
                singleCharacters: !0,
                ignoreElementEnd: !0,
                shallow: !0
              }));
            }), e.deleteContent(i, {
              doNotResetEntireContent: s,
              direction: _this163.direction
            }), _this163._buffer.input(a), o.setSelection(i), _this163._buffer.unlock();
          });
        }
      }, {
        key: "_shouldEntireContentBeReplacedWithParagraph",
        value: function _shouldEntireContentBeReplacedWithParagraph(t) {
          if (t > 1) return !1;
          var e = this.editor.model,
            n = e.document.selection,
            o = e.schema.getLimitElement(n);
          if (!(n.isCollapsed && n.containsEntireContent(o))) return !1;
          if (!e.schema.checkChild(o, "paragraph")) return !1;
          var i = o.getChild(0);
          return !i || "paragraph" !== i.name;
        }
      }, {
        key: "_replaceEntireContentWithParagraph",
        value: function _replaceEntireContentWithParagraph(t) {
          var e = this.editor.model,
            n = e.document.selection,
            o = e.schema.getLimitElement(n),
            i = t.createElement("paragraph");
          t.remove(t.createRangeIn(o)), t.insert(i, o), t.setSelection(i, 0);
        }
      }, {
        key: "_shouldReplaceFirstBlockWithParagraph",
        value: function _shouldReplaceFirstBlockWithParagraph(t, e) {
          var n = this.editor.model;
          if (e > 1 || "backward" != this.direction) return !1;
          if (!t.isCollapsed) return !1;
          var o = t.getFirstPosition(),
            i = n.schema.getLimitElement(o),
            r = i.getChild(0);
          return o.parent == r && !!t.containsEntireContent(r) && !!n.schema.checkChild(i, "paragraph") && "paragraph" != r.name;
        }
      }, {
        key: "buffer",
        get: function get() {
          return this._buffer;
        }
      }]);
      return bg;
    }(Xt);
    var wg = /*#__PURE__*/function (_Wr7) {
      _inherits(wg, _Wr7);
      function wg(t) {
        var _this164;
        _classCallCheck(this, wg);
        _this164 = _possibleConstructorReturn(this, _getPrototypeOf(wg).call(this, t));
        var e = t.document;
        var n = 0;
        function o(t, n, o) {
          var i = new yi(e, "delete", e.selection.getFirstRange());
          e.fire(i, new ms(e, n, o)), i.stop.called && t.stop();
        }
        e.on("keyup", function (t, e) {
          e.keyCode != Vi.delete && e.keyCode != Vi.backspace || (n = 0);
        }), e.on("keydown", function (t, e) {
          var i = {};
          if (e.keyCode == Vi.delete) i.direction = "forward", i.unit = "character";else {
            if (e.keyCode != Vi.backspace) return;
            i.direction = "backward", i.unit = "codePoint";
          }
          var r = Ri.isMac ? e.altKey : e.ctrlKey;
          i.unit = r ? "word" : i.unit, i.sequence = ++n, o(t, e.domEvent, i);
        }), Ri.isAndroid && e.on("beforeinput", function (e, n) {
          if ("deleteContentBackward" != n.domEvent.inputType) return;
          var i = {
              unit: "codepoint",
              direction: "backward",
              sequence: 1
            },
            r = n.domTarget.ownerDocument.defaultView.getSelection();
          r.anchorNode == r.focusNode && r.anchorOffset + 1 != r.focusOffset && (i.selectionToRemove = t.domConverter.domSelectionToView(r)), o(e, n.domEvent, i);
        });
        return _this164;
      }
      _createClass(wg, [{
        key: "observe",
        value: function observe() {}
      }]);
      return wg;
    }(Wr);
    var Cg = /*#__PURE__*/function (_Jt7) {
      _inherits(Cg, _Jt7);
      function Cg() {
        _classCallCheck(this, Cg);
        return _possibleConstructorReturn(this, _getPrototypeOf(Cg).apply(this, arguments));
      }
      _createClass(Cg, [{
        key: "init",
        value: function init() {
          var t = this.editor,
            e = t.editing.view,
            n = e.document;
          e.addObserver(wg);
          var o = new bg(t, "forward");
          if (t.commands.add("deleteForward", o), t.commands.add("forwardDelete", o), t.commands.add("delete", new bg(t, "backward")), this.listenTo(n, "delete", function (n, o) {
            var i = {
              unit: o.unit,
              sequence: o.sequence
            };
            if (o.selectionToRemove) {
              var _e240 = t.model.createSelection(),
                _n231 = [];
              var _iterator316 = _createForOfIteratorHelper(o.selectionToRemove.getRanges()),
                _step316;
              try {
                for (_iterator316.s(); !(_step316 = _iterator316.n()).done;) {
                  var _e241 = _step316.value;
                  _n231.push(t.editing.mapper.toModelRange(_e241));
                }
              } catch (err) {
                _iterator316.e(err);
              } finally {
                _iterator316.f();
              }
              _e240.setTo(_n231), i.selection = _e240;
            }
            t.execute("forward" == o.direction ? "deleteForward" : "delete", i), o.preventDefault(), e.scrollToTheSelection();
          }, {
            priority: "low"
          }), Ri.isAndroid) {
            var _t249 = null;
            this.listenTo(n, "delete", function (e, n) {
              var o = n.domTarget.ownerDocument.defaultView.getSelection();
              _t249 = {
                anchorNode: o.anchorNode,
                anchorOffset: o.anchorOffset,
                focusNode: o.focusNode,
                focusOffset: o.focusOffset
              };
            }, {
              priority: "lowest"
            }), this.listenTo(n, "keyup", function (e, n) {
              if (_t249) {
                var _e242 = n.domTarget.ownerDocument.defaultView.getSelection();
                _e242.collapse(_t249.anchorNode, _t249.anchorOffset), _e242.extend(_t249.focusNode, _t249.focusOffset), _t249 = null;
              }
            });
          }
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "Delete";
        }
      }]);
      return Cg;
    }(Jt);
    var Ag = /*#__PURE__*/function (_Jt8) {
      _inherits(Ag, _Jt8);
      function Ag() {
        _classCallCheck(this, Ag);
        return _possibleConstructorReturn(this, _getPrototypeOf(Ag).apply(this, arguments));
      }
      _createClass(Ag, null, [{
        key: "requires",
        get: function get() {
          return [kg, Cg];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "Typing";
        }
      }]);
      return Ag;
    }(Jt);
    function _g(t, e) {
      var n = t.start;
      return {
        text: Array.from(t.getItems()).reduce(function (t, o) {
          return o.is("$text") || o.is("$textProxy") ? t + o.data : (n = e.createPositionAfter(o), "");
        }, ""),
        range: e.createRange(n, t.end)
      };
    }
    var vg = /*#__PURE__*/function () {
      function vg(t, e) {
        var _this165 = this;
        _classCallCheck(this, vg);
        this.model = t, this.testCallback = e, this.hasMatch = !1, this.set("isEnabled", !0), this.on("change:isEnabled", function () {
          _this165.isEnabled ? _this165._startListening() : (_this165.stopListening(t.document.selection), _this165.stopListening(t.document));
        }), this._startListening();
      }
      _createClass(vg, [{
        key: "_startListening",
        value: function _startListening() {
          var _this166 = this;
          var t = this.model.document;
          this.listenTo(t.selection, "change:range", function (e, _ref42) {
            var n = _ref42.directChange;
            n && (t.selection.isCollapsed ? _this166._evaluateTextBeforeSelection("selection") : _this166.hasMatch && (_this166.fire("unmatched"), _this166.hasMatch = !1));
          }), this.listenTo(t, "change:data", function (t, e) {
            "transparent" != e.type && _this166._evaluateTextBeforeSelection("data", {
              batch: e
            });
          });
        }
      }, {
        key: "_evaluateTextBeforeSelection",
        value: function _evaluateTextBeforeSelection(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var n = this.model,
            o = n.document.selection,
            i = n.createRange(n.createPositionAt(o.focus.parent, 0), o.focus),
            _g2 = _g(i, n),
            r = _g2.text,
            s = _g2.range,
            a = this.testCallback(r);
          if (!a && this.hasMatch && this.fire("unmatched"), this.hasMatch = !!a, a) {
            var _n232 = Object.assign(e, {
              text: r,
              range: s
            });
            "object" == typeof a && Object.assign(_n232, a), this.fire("matched:".concat(t), _n232);
          }
        }
      }]);
      return vg;
    }();
    $t(vg, Gt);
    var yg = /*#__PURE__*/function (_Jt9) {
      _inherits(yg, _Jt9);
      _createClass(yg, null, [{
        key: "pluginName",
        get: function get() {
          return "TwoStepCaretMovement";
        }
      }]);
      function yg(t) {
        var _this167;
        _classCallCheck(this, yg);
        _this167 = _possibleConstructorReturn(this, _getPrototypeOf(yg).call(this, t)), _this167.attributes = new Set(), _this167._overrideUid = null;
        return _this167;
      }
      _createClass(yg, [{
        key: "init",
        value: function init() {
          var _this168 = this;
          var t = this.editor,
            e = t.model,
            n = t.editing.view,
            o = t.locale,
            i = e.document.selection;
          this.listenTo(n.document, "arrowKey", function (t, e) {
            if (!i.isCollapsed) return;
            if (e.shiftKey || e.altKey || e.ctrlKey) return;
            var n = e.keyCode == Vi.arrowright,
              r = e.keyCode == Vi.arrowleft;
            if (!n && !r) return;
            var s = o.contentLanguageDirection;
            var a = !1;
            a = "ltr" === s && n || "rtl" === s && r ? _this168._handleForwardMovement(e) : _this168._handleBackwardMovement(e), !0 === a && t.stop();
          }, {
            context: "$text",
            priority: "highest"
          }), this._isNextGravityRestorationSkipped = !1, this.listenTo(i, "change:range", function (t, e) {
            _this168._isNextGravityRestorationSkipped ? _this168._isNextGravityRestorationSkipped = !1 : _this168._isGravityOverridden && (!e.directChange && Mg(i.getFirstPosition(), _this168.attributes) || _this168._restoreGravity());
          });
        }
      }, {
        key: "registerAttribute",
        value: function registerAttribute(t) {
          this.attributes.add(t);
        }
      }, {
        key: "_handleForwardMovement",
        value: function _handleForwardMovement(t) {
          var e = this.attributes,
            n = this.editor.model.document.selection,
            o = n.getFirstPosition();
          return !this._isGravityOverridden && (!o.isAtStart || !xg(n, e)) && (Mg(o, e) ? (Dg(t), this._overrideGravity(), !0) : void 0);
        }
      }, {
        key: "_handleBackwardMovement",
        value: function _handleBackwardMovement(t) {
          var e = this.attributes,
            n = this.editor.model,
            o = n.document.selection,
            i = o.getFirstPosition();
          return this._isGravityOverridden ? (Dg(t), this._restoreGravity(), Eg(n, e, i), !0) : i.isAtStart ? !!xg(o, e) && (Dg(t), Eg(n, e, i), !0) : function (t, e) {
            return Mg(t.getShiftedBy(-1), e);
          }(i, e) ? i.isAtEnd && !xg(o, e) && Mg(i, e) ? (Dg(t), Eg(n, e, i), !0) : (this._isNextGravityRestorationSkipped = !0, this._overrideGravity(), !1) : void 0;
        }
      }, {
        key: "_overrideGravity",
        value: function _overrideGravity() {
          this._overrideUid = this.editor.model.change(function (t) {
            return t.overrideSelectionGravity();
          });
        }
      }, {
        key: "_restoreGravity",
        value: function _restoreGravity() {
          var _this169 = this;
          this.editor.model.change(function (t) {
            t.restoreSelectionGravity(_this169._overrideUid), _this169._overrideUid = null;
          });
        }
      }, {
        key: "_isGravityOverridden",
        get: function get() {
          return !!this._overrideUid;
        }
      }]);
      return yg;
    }(Jt);
    function xg(t, e) {
      var _iterator317 = _createForOfIteratorHelper(e),
        _step317;
      try {
        for (_iterator317.s(); !(_step317 = _iterator317.n()).done;) {
          var _n233 = _step317.value;
          if (t.hasAttribute(_n233)) return !0;
        }
      } catch (err) {
        _iterator317.e(err);
      } finally {
        _iterator317.f();
      }
      return !1;
    }
    function Eg(t, e, n) {
      var o = n.nodeBefore;
      t.change(function (t) {
        o ? t.setSelectionAttribute(o.getAttributes()) : t.removeSelectionAttribute(e);
      });
    }
    function Dg(t) {
      t.preventDefault();
    }
    function Mg(t, e) {
      var n = t.nodeBefore,
        o = t.nodeAfter;
      var _iterator318 = _createForOfIteratorHelper(e),
        _step318;
      try {
        for (_iterator318.s(); !(_step318 = _iterator318.n()).done;) {
          var _t250 = _step318.value;
          var _e243 = n ? n.getAttribute(_t250) : void 0;
          if ((o ? o.getAttribute(_t250) : void 0) !== _e243) return !0;
        }
      } catch (err) {
        _iterator318.e(err);
      } finally {
        _iterator318.f();
      }
      return !1;
    }
    var Ig = /[\\^$.*+?()[\]{}|]/g,
      Tg = RegExp(Ig.source);
    var Sg = function Sg(t) {
      return (t = Fo(t)) && Tg.test(t) ? t.replace(Ig, "\\$&") : t;
    };
    var Ng = {
        copyright: {
          from: "(c)",
          to: "©"
        },
        registeredTrademark: {
          from: "(r)",
          to: "®"
        },
        trademark: {
          from: "(tm)",
          to: "™"
        },
        oneHalf: {
          from: "1/2",
          to: "½"
        },
        oneThird: {
          from: "1/3",
          to: "⅓"
        },
        twoThirds: {
          from: "2/3",
          to: "⅔"
        },
        oneForth: {
          from: "1/4",
          to: "¼"
        },
        threeQuarters: {
          from: "3/4",
          to: "¾"
        },
        lessThanOrEqual: {
          from: "<=",
          to: "≤"
        },
        greaterThanOrEqual: {
          from: ">=",
          to: "≥"
        },
        notEqual: {
          from: "!=",
          to: "≠"
        },
        arrowLeft: {
          from: "<-",
          to: "←"
        },
        arrowRight: {
          from: "->",
          to: "→"
        },
        horizontalEllipsis: {
          from: "...",
          to: "…"
        },
        enDash: {
          from: /(^| )(--)( )$/,
          to: [null, "–", null]
        },
        emDash: {
          from: /(^| )(---)( )$/,
          to: [null, "—", null]
        },
        quotesPrimary: {
          from: Rg('"'),
          to: [null, "“", null, "”"]
        },
        quotesSecondary: {
          from: Rg("'"),
          to: [null, "‘", null, "’"]
        },
        quotesPrimaryEnGb: {
          from: Rg("'"),
          to: [null, "‘", null, "’"]
        },
        quotesSecondaryEnGb: {
          from: Rg('"'),
          to: [null, "“", null, "”"]
        },
        quotesPrimaryPl: {
          from: Rg('"'),
          to: [null, "„", null, "”"]
        },
        quotesSecondaryPl: {
          from: Rg("'"),
          to: [null, "‚", null, "’"]
        }
      },
      Bg = {
        symbols: ["copyright", "registeredTrademark", "trademark"],
        mathematical: ["oneHalf", "oneThird", "twoThirds", "oneForth", "threeQuarters", "lessThanOrEqual", "greaterThanOrEqual", "notEqual", "arrowLeft", "arrowRight"],
        typography: ["horizontalEllipsis", "enDash", "emDash"],
        quotes: ["quotesPrimary", "quotesSecondary"]
      },
      Pg = ["symbols", "mathematical", "typography", "quotes"];
    function zg(t) {
      return "string" == typeof t ? new RegExp("(".concat(Sg(t), ")$")) : t;
    }
    function Lg(t) {
      return "string" == typeof t ? function () {
        return [t];
      } : t instanceof Array ? function () {
        return t;
      } : t;
    }
    function Og(t) {
      return (t.textNode ? t.textNode : t.nodeAfter).getAttributes();
    }
    function Rg(t) {
      return new RegExp("(^|\\s)(".concat(t, ")([^").concat(t, "]*)(").concat(t, ")$"));
    }
    function jg(t, e, n, o) {
      return o.createRange(Fg(t, e, n, !0, o), Fg(t, e, n, !1, o));
    }
    function Fg(t, e, n, o, i) {
      var r = t.textNode || (o ? t.nodeBefore : t.nodeAfter),
        s = null;
      for (; r && r.getAttribute(e) == n;) s = r, r = o ? r.previousSibling : r.nextSibling;
      return s ? i.createPositionAt(s, o ? "before" : "after") : t;
    }
    var Vg = /*#__PURE__*/function (_Xt7) {
      _inherits(Vg, _Xt7);
      function Vg() {
        _classCallCheck(this, Vg);
        return _possibleConstructorReturn(this, _getPrototypeOf(Vg).apply(this, arguments));
      }
      _createClass(Vg, [{
        key: "refresh",
        value: function refresh() {
          this.value = this._getValue(), this.isEnabled = this._checkEnabled();
        }
      }, {
        key: "execute",
        value: function execute() {
          var _this170 = this;
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var e = this.editor.model,
            n = e.schema,
            o = e.document.selection,
            i = Array.from(o.getSelectedBlocks()),
            r = void 0 === t.forceValue ? !this.value : t.forceValue;
          e.change(function (t) {
            if (r) {
              var _e244 = i.filter(function (t) {
                return Ug(t) || Gg(n, t);
              });
              _this170._applyQuote(t, _e244);
            } else _this170._removeQuote(t, i.filter(Ug));
          });
        }
      }, {
        key: "_getValue",
        value: function _getValue() {
          var t = Ks(this.editor.model.document.selection.getSelectedBlocks());
          return !(!t || !Ug(t));
        }
      }, {
        key: "_checkEnabled",
        value: function _checkEnabled() {
          if (this.value) return !0;
          var t = this.editor.model.document.selection,
            e = this.editor.model.schema,
            n = Ks(t.getSelectedBlocks());
          return !!n && Gg(e, n);
        }
      }, {
        key: "_removeQuote",
        value: function _removeQuote(t, e) {
          Hg(t, e).reverse().forEach(function (e) {
            if (e.start.isAtStart && e.end.isAtEnd) return void t.unwrap(e.start.parent);
            if (e.start.isAtStart) {
              var _n234 = t.createPositionBefore(e.start.parent);
              return void t.move(e, _n234);
            }
            e.end.isAtEnd || t.split(e.end);
            var n = t.createPositionAfter(e.end.parent);
            t.move(e, n);
          });
        }
      }, {
        key: "_applyQuote",
        value: function _applyQuote(t, e) {
          var n = [];
          Hg(t, e).reverse().forEach(function (e) {
            var o = Ug(e.start);
            o || (o = t.createElement("blockQuote"), t.wrap(e, o)), n.push(o);
          }), n.reverse().reduce(function (e, n) {
            return e.nextSibling == n ? (t.merge(t.createPositionAfter(e)), e) : n;
          });
        }
      }]);
      return Vg;
    }(Xt);
    function Ug(t) {
      return "blockQuote" == t.parent.name ? t.parent : null;
    }
    function Hg(t, e) {
      var n,
        o = 0;
      var i = [];
      for (; o < e.length;) {
        var _r50 = e[o],
          _s28 = e[o + 1];
        n || (n = t.createPositionBefore(_r50)), _s28 && _r50.nextSibling == _s28 || (i.push(t.createRange(n, t.createPositionAfter(_r50))), n = null), o++;
      }
      return i;
    }
    function Gg(t, e) {
      var n = t.checkChild(e.parent, "blockQuote"),
        o = t.checkChild(["$root", "blockQuote"], e);
      return n && o;
    }
    var Wg = /*#__PURE__*/function (_Jt10) {
      _inherits(Wg, _Jt10);
      function Wg() {
        _classCallCheck(this, Wg);
        return _possibleConstructorReturn(this, _getPrototypeOf(Wg).apply(this, arguments));
      }
      _createClass(Wg, [{
        key: "init",
        value: function init() {
          var t = this.editor,
            e = t.model.schema;
          t.commands.add("blockQuote", new Vg(t)), e.register("blockQuote", {
            allowWhere: "$block",
            allowContentOf: "$root"
          }), t.conversion.elementToElement({
            model: "blockQuote",
            view: "blockquote"
          }), t.model.document.registerPostFixer(function (n) {
            var o = t.model.document.differ.getChanges();
            var _iterator319 = _createForOfIteratorHelper(o),
              _step319;
            try {
              for (_iterator319.s(); !(_step319 = _iterator319.n()).done;) {
                var _t251 = _step319.value;
                if ("insert" == _t251.type) {
                  var _o148 = _t251.position.nodeAfter;
                  if (!_o148) continue;
                  if (_o148.is("element", "blockQuote") && _o148.isEmpty) return n.remove(_o148), !0;
                  if (_o148.is("element", "blockQuote") && !e.checkChild(_t251.position, _o148)) return n.unwrap(_o148), !0;
                  if (_o148.is("element")) {
                    var _t252 = n.createRangeIn(_o148);
                    var _iterator320 = _createForOfIteratorHelper(_t252.getItems()),
                      _step320;
                    try {
                      for (_iterator320.s(); !(_step320 = _iterator320.n()).done;) {
                        var _o149 = _step320.value;
                        if (_o149.is("element", "blockQuote") && !e.checkChild(n.createPositionBefore(_o149), _o149)) return n.unwrap(_o149), !0;
                      }
                    } catch (err) {
                      _iterator320.e(err);
                    } finally {
                      _iterator320.f();
                    }
                  }
                } else if ("remove" == _t251.type) {
                  var _e245 = _t251.position.parent;
                  if (_e245.is("element", "blockQuote") && _e245.isEmpty) return n.remove(_e245), !0;
                }
              }
            } catch (err) {
              _iterator319.e(err);
            } finally {
              _iterator319.f();
            }
            return !1;
          });
          var n = this.editor.editing.view.document,
            o = t.model.document.selection,
            i = t.commands.get("blockQuote");
          this.listenTo(n, "enter", function (e, n) {
            if (!o.isCollapsed || !i.value) return;
            o.getLastPosition().parent.isEmpty && (t.execute("blockQuote"), t.editing.view.scrollToTheSelection(), n.preventDefault(), e.stop());
          }, {
            context: "blockquote"
          }), this.listenTo(n, "delete", function (e, n) {
            if ("backward" != n.direction || !o.isCollapsed || !i.value) return;
            var r = o.getLastPosition().parent;
            r.isEmpty && !r.previousSibling && (t.execute("blockQuote"), t.editing.view.scrollToTheSelection(), n.preventDefault(), e.stop());
          }, {
            context: "blockquote"
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "BlockQuoteEditing";
        }
      }, {
        key: "requires",
        get: function get() {
          return [og, Cg];
        }
      }]);
      return Wg;
    }(Jt);
    var qg = n(36),
      Kg = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Zl()(qg.a, Kg), qg.a.locals;
    var Yg = /*#__PURE__*/function (_Jt11) {
      _inherits(Yg, _Jt11);
      function Yg() {
        _classCallCheck(this, Yg);
        return _possibleConstructorReturn(this, _getPrototypeOf(Yg).apply(this, arguments));
      }
      _createClass(Yg, [{
        key: "init",
        value: function init() {
          var _this171 = this;
          var t = this.editor,
            e = t.t;
          t.ui.componentFactory.add("blockQuote", function (n) {
            var o = t.commands.get("blockQuote"),
              i = new Sd(n);
            return i.set({
              label: e("Block quote"),
              icon: ql.quote,
              tooltip: !0,
              isToggleable: !0
            }), i.bind("isOn", "isEnabled").to(o, "value", "isEnabled"), _this171.listenTo(i, "execute", function () {
              t.execute("blockQuote"), t.editing.view.focus();
            }), i;
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "BlockQuoteUI";
        }
      }]);
      return Yg;
    }(Jt);
    var Qg = /*#__PURE__*/function (_Xt8) {
      _inherits(Qg, _Xt8);
      function Qg(t, e) {
        var _this172;
        _classCallCheck(this, Qg);
        _this172 = _possibleConstructorReturn(this, _getPrototypeOf(Qg).call(this, t)), _this172.attributeKey = e;
        return _this172;
      }
      _createClass(Qg, [{
        key: "refresh",
        value: function refresh() {
          var t = this.editor.model,
            e = t.document;
          this.value = this._getValueFromFirstAllowedNode(), this.isEnabled = t.schema.checkAttributeInSelection(e.selection, this.attributeKey);
        }
      }, {
        key: "execute",
        value: function execute() {
          var _this173 = this;
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var e = this.editor.model,
            n = e.document.selection,
            o = void 0 === t.forceValue ? !this.value : t.forceValue;
          e.change(function (t) {
            if (n.isCollapsed) o ? t.setSelectionAttribute(_this173.attributeKey, !0) : t.removeSelectionAttribute(_this173.attributeKey);else {
              var _i120 = e.schema.getValidRanges(n.getRanges(), _this173.attributeKey);
              var _iterator321 = _createForOfIteratorHelper(_i120),
                _step321;
              try {
                for (_iterator321.s(); !(_step321 = _iterator321.n()).done;) {
                  var _e246 = _step321.value;
                  o ? t.setAttribute(_this173.attributeKey, o, _e246) : t.removeAttribute(_this173.attributeKey, _e246);
                }
              } catch (err) {
                _iterator321.e(err);
              } finally {
                _iterator321.f();
              }
            }
          });
        }
      }, {
        key: "_getValueFromFirstAllowedNode",
        value: function _getValueFromFirstAllowedNode() {
          var t = this.editor.model,
            e = t.schema,
            n = t.document.selection;
          if (n.isCollapsed) return n.hasAttribute(this.attributeKey);
          var _iterator322 = _createForOfIteratorHelper(n.getRanges()),
            _step322;
          try {
            for (_iterator322.s(); !(_step322 = _iterator322.n()).done;) {
              var _t253 = _step322.value;
              var _iterator323 = _createForOfIteratorHelper(_t253.getItems()),
                _step323;
              try {
                for (_iterator323.s(); !(_step323 = _iterator323.n()).done;) {
                  var _n235 = _step323.value;
                  if (e.checkAttribute(_n235, this.attributeKey)) return _n235.hasAttribute(this.attributeKey);
                }
              } catch (err) {
                _iterator323.e(err);
              } finally {
                _iterator323.f();
              }
            }
          } catch (err) {
            _iterator322.e(err);
          } finally {
            _iterator322.f();
          }
          return !1;
        }
      }]);
      return Qg;
    }(Xt);
    var $g = "bold";
    var Jg = /*#__PURE__*/function (_Jt12) {
      _inherits(Jg, _Jt12);
      function Jg() {
        _classCallCheck(this, Jg);
        return _possibleConstructorReturn(this, _getPrototypeOf(Jg).apply(this, arguments));
      }
      _createClass(Jg, [{
        key: "init",
        value: function init() {
          var t = this.editor;
          t.model.schema.extend("$text", {
            allowAttributes: $g
          }), t.model.schema.setAttributeProperties($g, {
            isFormatting: !0,
            copyOnEnter: !0
          }), t.conversion.attributeToElement({
            model: $g,
            view: "strong",
            upcastAlso: ["b", function (t) {
              var e = t.getStyle("font-weight");
              return e ? "bold" == e || Number(e) >= 600 ? {
                name: !0,
                styles: ["font-weight"]
              } : void 0 : null;
            }]
          }), t.commands.add($g, new Qg(t, $g)), t.keystrokes.set("CTRL+B", $g);
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "BoldEditing";
        }
      }]);
      return Jg;
    }(Jt);
    var Zg = "bold";
    var Xg = /*#__PURE__*/function (_Jt13) {
      _inherits(Xg, _Jt13);
      function Xg() {
        _classCallCheck(this, Xg);
        return _possibleConstructorReturn(this, _getPrototypeOf(Xg).apply(this, arguments));
      }
      _createClass(Xg, [{
        key: "init",
        value: function init() {
          var _this174 = this;
          var t = this.editor,
            e = t.t;
          t.ui.componentFactory.add(Zg, function (n) {
            var o = t.commands.get(Zg),
              i = new Sd(n);
            return i.set({
              label: e("Bold"),
              icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10.187 17H5.773c-.637 0-1.092-.138-1.364-.415-.273-.277-.409-.718-.409-1.323V4.738c0-.617.14-1.062.419-1.332.279-.27.73-.406 1.354-.406h4.68c.69 0 1.288.041 1.793.124.506.083.96.242 1.36.478.341.197.644.447.906.75a3.262 3.262 0 0 1 .808 2.162c0 1.401-.722 2.426-2.167 3.075C15.05 10.175 16 11.315 16 13.01a3.756 3.756 0 0 1-2.296 3.504 6.1 6.1 0 0 1-1.517.377c-.571.073-1.238.11-2 .11zm-.217-6.217H7v4.087h3.069c1.977 0 2.965-.69 2.965-2.072 0-.707-.256-1.22-.768-1.537-.512-.319-1.277-.478-2.296-.478zM7 5.13v3.619h2.606c.729 0 1.292-.067 1.69-.2a1.6 1.6 0 0 0 .91-.765c.165-.267.247-.566.247-.897 0-.707-.26-1.176-.778-1.409-.519-.232-1.31-.348-2.375-.348H7z"/></svg>',
              keystroke: "CTRL+B",
              tooltip: !0,
              isToggleable: !0
            }), i.bind("isOn", "isEnabled").to(o, "value", "isEnabled"), _this174.listenTo(i, "execute", function () {
              t.execute(Zg), t.editing.view.focus();
            }), i;
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "BoldUI";
        }
      }]);
      return Xg;
    }(Jt);
    var tm = /*#__PURE__*/function () {
      function tm(t) {
        _classCallCheck(this, tm);
        this.files = function (t) {
          var e = t.files ? Array.from(t.files) : [],
            n = t.items ? Array.from(t.items) : [];
          if (e.length) return e;
          return n.filter(function (t) {
            return "file" === t.kind;
          }).map(function (t) {
            return t.getAsFile();
          });
        }(t), this._native = t;
      }
      _createClass(tm, [{
        key: "getData",
        value: function getData(t) {
          return this._native.getData(t);
        }
      }, {
        key: "setData",
        value: function setData(t, e) {
          this._native.setData(t, e);
        }
      }, {
        key: "types",
        get: function get() {
          return this._native.types;
        }
      }, {
        key: "effectAllowed",
        set: function set(t) {
          this._native.effectAllowed = t;
        },
        get: function get() {
          return this._native.effectAllowed;
        }
      }, {
        key: "dropEffect",
        set: function set(t) {
          this._native.dropEffect = t;
        },
        get: function get() {
          return this._native.dropEffect;
        }
      }, {
        key: "isCanceled",
        get: function get() {
          return "none" == this._native.dropEffect || !!this._native.mozUserCancelled;
        }
      }]);
      return tm;
    }();
    var em = /*#__PURE__*/function (_ps7) {
      _inherits(em, _ps7);
      function em(t) {
        var _this175;
        _classCallCheck(this, em);
        _this175 = _possibleConstructorReturn(this, _getPrototypeOf(em).call(this, t));
        var e = _this175.document;
        function n(t) {
          return function (n, o) {
            o.preventDefault();
            var r = o.dropRange ? [o.dropRange] : null,
              s = new i(e, t);
            e.fire(s, {
              dataTransfer: o.dataTransfer,
              method: n.name,
              targetRanges: r,
              target: o.target
            }), s.stop.called && o.stopPropagation();
          };
        }
        _this175.domEventType = ["paste", "copy", "cut", "drop", "dragover", "dragstart", "dragend", "dragenter", "dragleave"], _this175.listenTo(e, "paste", n("clipboardInput"), {
          priority: "low"
        }), _this175.listenTo(e, "drop", n("clipboardInput"), {
          priority: "low"
        }), _this175.listenTo(e, "dragover", n("dragging"), {
          priority: "low"
        });
        return _this175;
      }
      _createClass(em, [{
        key: "onDomEvent",
        value: function onDomEvent(t) {
          var e = {
            dataTransfer: new tm(t.clipboardData ? t.clipboardData : t.dataTransfer)
          };
          "drop" != t.type && "dragover" != t.type || (e.dropRange = function (t, e) {
            var n = e.target.ownerDocument,
              o = e.clientX,
              i = e.clientY;
            var r;
            n.caretRangeFromPoint && n.caretRangeFromPoint(o, i) ? r = n.caretRangeFromPoint(o, i) : e.rangeParent && (r = n.createRange(), r.setStart(e.rangeParent, e.rangeOffset), r.collapse(!0));
            if (r) return t.domConverter.domRangeToView(r);
            return null;
          }(this.view, t)), this.fire(t.type, t, e);
        }
      }]);
      return em;
    }(ps);
    var nm = ["figcaption", "li"];
    function om(t) {
      var e = "";
      if (t.is("$text") || t.is("$textProxy")) e = t.data;else if (t.is("element", "img") && t.hasAttribute("alt")) e = t.getAttribute("alt");else if (t.is("element", "br")) e = "\n";else {
        var _n236 = null;
        var _iterator324 = _createForOfIteratorHelper(t.getChildren()),
          _step324;
        try {
          for (_iterator324.s(); !(_step324 = _iterator324.n()).done;) {
            var _o150 = _step324.value;
            var _t254 = om(_o150);
            _n236 && (_n236.is("containerElement") || _o150.is("containerElement")) && (nm.includes(_n236.name) || nm.includes(_o150.name) ? e += "\n" : e += "\n\n"), e += _t254, _n236 = _o150;
          }
        } catch (err) {
          _iterator324.e(err);
        } finally {
          _iterator324.f();
        }
      }
      return e;
    }
    var im = /*#__PURE__*/function (_Jt14) {
      _inherits(im, _Jt14);
      function im() {
        _classCallCheck(this, im);
        return _possibleConstructorReturn(this, _getPrototypeOf(im).apply(this, arguments));
      }
      _createClass(im, [{
        key: "init",
        value: function init() {
          this.editor.editing.view.addObserver(em), this._setupPasteDrop(), this._setupCopyCut();
        }
      }, {
        key: "_setupPasteDrop",
        value: function _setupPasteDrop() {
          var _this176 = this;
          var t = this.editor,
            e = t.model,
            n = t.editing.view,
            o = n.document;
          this.listenTo(o, "clipboardInput", function (e) {
            t.isReadOnly && e.stop();
          }, {
            priority: "highest"
          }), this.listenTo(o, "clipboardInput", function (t, e) {
            var o = e.dataTransfer;
            var r = e.content || "";
            var s;
            r || (o.getData("text/html") ? r = function (t) {
              return t.replace(/<span(?: class="Apple-converted-space"|)>(\s+)<\/span>/g, function (t, e) {
                return 1 == e.length ? " " : e;
              });
            }(o.getData("text/html")) : o.getData("text/plain") && (((s = (s = o.getData("text/plain")).replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\r?\n\r?\n/g, "</p><p>").replace(/\r?\n/g, "<br>").replace(/^\s/, "&nbsp;").replace(/\s$/, "&nbsp;").replace(/\s\s/g, " &nbsp;")).includes("</p><p>") || s.includes("<br>")) && (s = "<p>".concat(s, "</p>")), r = s), r = _this176.editor.data.htmlProcessor.toView(r));
            var a = new i(_this176, "inputTransformation");
            _this176.fire(a, {
              content: r,
              dataTransfer: o,
              targetRanges: e.targetRanges,
              method: e.method
            }), a.stop.called && t.stop(), n.scrollToTheSelection();
          }, {
            priority: "low"
          }), this.listenTo(this, "inputTransformation", function (t, n) {
            if (n.content.isEmpty) return;
            var o = _this176.editor.data.toModel(n.content, "$clipboardHolder");
            0 != o.childCount && (t.stop(), e.change(function () {
              _this176.fire("contentInsertion", {
                content: o,
                method: n.method,
                dataTransfer: n.dataTransfer,
                targetRanges: n.targetRanges
              });
            }));
          }, {
            priority: "low"
          }), this.listenTo(this, "contentInsertion", function (t, n) {
            n.resultRange = e.insertContent(n.content);
          }, {
            priority: "low"
          });
        }
      }, {
        key: "_setupCopyCut",
        value: function _setupCopyCut() {
          var _this177 = this;
          var t = this.editor,
            e = t.model.document,
            n = t.editing.view.document;
          function o(o, i) {
            var r = i.dataTransfer;
            i.preventDefault();
            var s = t.data.toView(t.model.getSelectedContent(e.selection));
            n.fire("clipboardOutput", {
              dataTransfer: r,
              content: s,
              method: o.name
            });
          }
          this.listenTo(n, "copy", o, {
            priority: "low"
          }), this.listenTo(n, "cut", function (e, n) {
            t.isReadOnly ? n.preventDefault() : o(e, n);
          }, {
            priority: "low"
          }), this.listenTo(n, "clipboardOutput", function (n, o) {
            o.content.isEmpty || (o.dataTransfer.setData("text/html", _this177.editor.data.htmlProcessor.toData(o.content)), o.dataTransfer.setData("text/plain", om(o.content))), "cut" == o.method && t.model.deleteContent(e.selection);
          }, {
            priority: "low"
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "ClipboardPipeline";
        }
      }]);
      return im;
    }(Jt);
    var rm = /*#__PURE__*/function () {
      function rm() {
        _classCallCheck(this, rm);
        this._stack = [];
      }
      _createClass(rm, [{
        key: "add",
        value: function add(t, e) {
          var n = this._stack,
            o = n[0];
          this._insertDescriptor(t);
          var i = n[0];
          o === i || sm(o, i) || this.fire("change:top", {
            oldDescriptor: o,
            newDescriptor: i,
            writer: e
          });
        }
      }, {
        key: "remove",
        value: function remove(t, e) {
          var n = this._stack,
            o = n[0];
          this._removeDescriptor(t);
          var i = n[0];
          o === i || sm(o, i) || this.fire("change:top", {
            oldDescriptor: o,
            newDescriptor: i,
            writer: e
          });
        }
      }, {
        key: "_insertDescriptor",
        value: function _insertDescriptor(t) {
          var e = this._stack,
            n = e.findIndex(function (e) {
              return e.id === t.id;
            });
          if (sm(t, e[n])) return;
          n > -1 && e.splice(n, 1);
          var o = 0;
          for (; e[o] && am(e[o], t);) o++;
          e.splice(o, 0, t);
        }
      }, {
        key: "_removeDescriptor",
        value: function _removeDescriptor(t) {
          var e = this._stack,
            n = e.findIndex(function (e) {
              return e.id === t;
            });
          n > -1 && e.splice(n, 1);
        }
      }]);
      return rm;
    }();
    function sm(t, e) {
      return t && e && t.priority == e.priority && cm(t.classes) == cm(e.classes);
    }
    function am(t, e) {
      return t.priority > e.priority || !(t.priority < e.priority) && cm(t.classes) > cm(e.classes);
    }
    function cm(t) {
      return Array.isArray(t) ? t.sort().join(",") : t;
    }
    $t(rm, h);
    var lm = '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M4 0v1H1v3H0V.5A.5.5 0 0 1 .5 0H4zm8 0h3.5a.5.5 0 0 1 .5.5V4h-1V1h-3V0zM4 16H.5a.5.5 0 0 1-.5-.5V12h1v3h3v1zm8 0v-1h3v-3h1v3.5a.5.5 0 0 1-.5.5H12z"/><path fill-opacity=".256" d="M1 1h14v14H1z"/><g class="ck-icon__selected-indicator"><path d="M7 0h2v1H7V0zM0 7h1v2H0V7zm15 0h1v2h-1V7zm-8 8h2v1H7v-1z"/><path fill-opacity=".254" d="M1 1h14v14H1z"/></g></svg>';
    var dm = "ck-widget_selected";
    function hm(t) {
      return !!t.is("element") && !!t.getCustomProperty("widget");
    }
    function um(t, e) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      if (!t.is("containerElement")) throw new c.a("widget-to-widget-wrong-element-type", null, {
        element: t
      });
      return e.setAttribute("contenteditable", "false", t), e.addClass("ck-widget", t), e.setCustomProperty("widget", !0, t), t.getFillerOffset = Cm, n.label && function (t, e, n) {
        n.setCustomProperty("widgetLabel", e, t);
      }(t, n.label, e), n.hasSelectionHandle && function (t, e) {
        var n = e.createUIElement("div", {
          class: "ck ck-widget__selection-handle"
        }, function (t) {
          var e = this.toDomElement(t),
            n = new xd();
          return n.set("content", lm), n.render(), e.appendChild(n.element), e;
        });
        e.insert(e.createPositionAt(t, 0), n), e.addClass(["ck-widget_with-selection-handle"], t);
      }(t, e), pm(t, e, gm, mm), t;
    }
    function gm(t, e, n) {
      if (e.classes && n.addClass(ho(e.classes), t), e.attributes) for (var _o152 in e.attributes) n.setAttribute(_o152, e.attributes[_o152], t);
    }
    function mm(t, e, n) {
      if (e.classes && n.removeClass(ho(e.classes), t), e.attributes) for (var _o154 in e.attributes) n.removeAttribute(_o154, t);
    }
    function pm(t, e, n, o) {
      var i = new rm();
      i.on("change:top", function (e, i) {
        i.oldDescriptor && o(t, i.oldDescriptor, i.writer), i.newDescriptor && n(t, i.newDescriptor, i.writer);
      }), e.setCustomProperty("addHighlight", function (t, e, n) {
        return i.add(e, n);
      }, t), e.setCustomProperty("removeHighlight", function (t, e, n) {
        return i.remove(e, n);
      }, t);
    }
    function fm(t) {
      var e = t.getCustomProperty("widgetLabel");
      return e ? "function" == typeof e ? e() : e : "";
    }
    function km(t, e) {
      return e.addClass(["ck-editor__editable", "ck-editor__nested-editable"], t), e.setAttribute("contenteditable", t.isReadOnly ? "false" : "true", t), t.on("change:isReadOnly", function (n, o, i) {
        e.setAttribute("contenteditable", i ? "false" : "true", t);
      }), t.on("change:isFocused", function (n, o, i) {
        i ? e.addClass("ck-editor__nested-editable_focused", t) : e.removeClass("ck-editor__nested-editable_focused", t);
      }), t;
    }
    function bm(t, e) {
      var n = t.getSelectedElement();
      if (n) {
        var _o155 = vm(t);
        if (_o155) return e.createRange(e.createPositionAt(n, _o155));
        if (e.schema.isObject(n) && !e.schema.isInline(n)) return e.createRangeOn(n);
      }
      var o = t.getSelectedBlocks().next().value;
      if (o) {
        if (o.isEmpty) return e.createRange(e.createPositionAt(o, 0));
        var _n237 = e.createPositionAfter(o);
        return t.focus.isTouching(_n237) ? e.createRange(_n237) : e.createRange(e.createPositionBefore(o));
      }
      return e.createRange(t.focus);
    }
    function wm(t, e) {
      var n = new Vs(Sr.window),
        o = n.getIntersection(t),
        i = e.height + qh.arrowVerticalOffset;
      if (t.top - i > n.top || t.bottom + i < n.bottom) return null;
      var r = o || t,
        s = r.left + r.width / 2 - e.width / 2;
      return {
        top: Math.max(t.top, 0) + qh.arrowVerticalOffset,
        left: s,
        name: "arrow_n"
      };
    }
    function Cm() {
      return null;
    }
    var Am = "widget-type-around";
    function _m(t, e, n) {
      return t && hm(t) && !n.isInline(e);
    }
    function vm(t) {
      return t.getAttribute(Am);
    }
    var ym = n(37),
      xm = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Zl()(ym.a, xm), ym.a.locals;
    var Em = ["before", "after"],
      Dm = new DOMParser().parseFromString('<svg viewBox="0 0 10 8" xmlns="http://www.w3.org/2000/svg"><path d="M9.055.263v3.972h-6.77M1 4.216l2-2.038m-2 2 2 2.038"/></svg>', "image/svg+xml").firstChild,
      Mm = "ck-widget__type-around_disabled";
    var Im = /*#__PURE__*/function (_Jt15) {
      _inherits(Im, _Jt15);
      _createClass(Im, null, [{
        key: "pluginName",
        get: function get() {
          return "WidgetTypeAround";
        }
      }, {
        key: "requires",
        get: function get() {
          return [og, Cg];
        }
      }]);
      function Im(t) {
        var _this178;
        _classCallCheck(this, Im);
        _this178 = _possibleConstructorReturn(this, _getPrototypeOf(Im).call(this, t)), _this178._currentFakeCaretModelElement = null;
        return _this178;
      }
      _createClass(Im, [{
        key: "init",
        value: function init() {
          var t = this.editor,
            e = t.editing.view;
          this.on("change:isEnabled", function (n, o, i) {
            e.change(function (t) {
              var _iterator325 = _createForOfIteratorHelper(e.document.roots),
                _step325;
              try {
                for (_iterator325.s(); !(_step325 = _iterator325.n()).done;) {
                  var _n238 = _step325.value;
                  i ? t.removeClass(Mm, _n238) : t.addClass(Mm, _n238);
                }
              } catch (err) {
                _iterator325.e(err);
              } finally {
                _iterator325.f();
              }
            }), i || t.model.change(function (t) {
              t.removeSelectionAttribute(Am);
            });
          }), this._enableTypeAroundUIInjection(), this._enableInsertingParagraphsOnButtonClick(), this._enableInsertingParagraphsOnEnterKeypress(), this._enableInsertingParagraphsOnTypingKeystroke(), this._enableTypeAroundFakeCaretActivationUsingKeyboardArrows(), this._enableDeleteIntegration(), this._enableInsertContentIntegration(), this._enableDeleteContentIntegration();
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this._currentFakeCaretModelElement = null;
        }
      }, {
        key: "_insertParagraph",
        value: function _insertParagraph(t, e) {
          var n = this.editor,
            o = n.editing.view;
          n.execute("insertParagraph", {
            position: n.model.createPositionAt(t, e)
          }), o.focus(), o.scrollToTheSelection();
        }
      }, {
        key: "_listenToIfEnabled",
        value: function _listenToIfEnabled(t, e, n, o) {
          var _this179 = this;
          this.listenTo(t, e, function () {
            _this179.isEnabled && n.apply(void 0, arguments);
          }, o);
        }
      }, {
        key: "_insertParagraphAccordingToFakeCaretPosition",
        value: function _insertParagraphAccordingToFakeCaretPosition() {
          var t = this.editor.model.document.selection,
            e = vm(t);
          if (!e) return !1;
          var n = t.getSelectedElement();
          return this._insertParagraph(n, e), !0;
        }
      }, {
        key: "_enableTypeAroundUIInjection",
        value: function _enableTypeAroundUIInjection() {
          var t = this.editor,
            e = t.model.schema,
            n = t.locale.t,
            o = {
              before: n("Insert paragraph before block"),
              after: n("Insert paragraph after block")
            };
          t.editing.downcastDispatcher.on("insert", function (t, n, i) {
            var r = i.mapper.toViewElement(n.item);
            _m(r, n.item, e) && function (t, e, n) {
              var o = t.createUIElement("div", {
                class: "ck ck-reset_all ck-widget__type-around"
              }, function (t) {
                var n = this.toDomElement(t);
                return function (t, e) {
                  for (var _i121 = 0, _Em = Em; _i121 < _Em.length; _i121++) {
                    var _n239 = _Em[_i121];
                    var _o156 = new nd({
                      tag: "div",
                      attributes: {
                        class: ["ck", "ck-widget__type-around__button", "ck-widget__type-around__button_".concat(_n239)],
                        title: e[_n239]
                      },
                      children: [t.ownerDocument.importNode(Dm, !0)]
                    });
                    t.appendChild(_o156.render());
                  }
                }(n, e), function (t) {
                  var e = new nd({
                    tag: "div",
                    attributes: {
                      class: ["ck", "ck-widget__type-around__fake-caret"]
                    }
                  });
                  t.appendChild(e.render());
                }(n), n;
              });
              t.insert(t.createPositionAt(n, "end"), o);
            }(i.writer, o, r);
          }, {
            priority: "low"
          });
        }
      }, {
        key: "_enableTypeAroundFakeCaretActivationUsingKeyboardArrows",
        value: function _enableTypeAroundFakeCaretActivationUsingKeyboardArrows() {
          var _this180 = this;
          var t = this.editor,
            e = t.model,
            n = e.document.selection,
            o = e.schema,
            i = t.editing.view;
          function r(t) {
            return "ck-widget_type-around_show-fake-caret_".concat(t);
          }
          this._listenToIfEnabled(i.document, "arrowKey", function (t, e) {
            _this180._handleArrowKeyPress(t, e);
          }, {
            context: [hm, "$text"],
            priority: "high"
          }), this._listenToIfEnabled(n, "change:range", function (e, n) {
            n.directChange && t.model.change(function (t) {
              t.removeSelectionAttribute(Am);
            });
          }), this._listenToIfEnabled(e.document, "change:data", function () {
            var e = n.getSelectedElement();
            if (e) {
              if (_m(t.editing.mapper.toViewElement(e), e, o)) return;
            }
            t.model.change(function (t) {
              t.removeSelectionAttribute(Am);
            });
          }), this._listenToIfEnabled(t.editing.downcastDispatcher, "selection", function (t, e, n) {
            var i = n.writer;
            if (_this180._currentFakeCaretModelElement) {
              var _t255 = n.mapper.toViewElement(_this180._currentFakeCaretModelElement);
              _t255 && (i.removeClass(Em.map(r), _t255), _this180._currentFakeCaretModelElement = null);
            }
            var s = e.selection.getSelectedElement();
            if (!s) return;
            var a = n.mapper.toViewElement(s);
            if (!_m(a, s, o)) return;
            var c = vm(e.selection);
            c && (i.addClass(r(c), a), _this180._currentFakeCaretModelElement = s);
          }), this._listenToIfEnabled(t.ui.focusTracker, "change:isFocused", function (e, n, o) {
            o || t.model.change(function (t) {
              t.removeSelectionAttribute(Am);
            });
          });
        }
      }, {
        key: "_handleArrowKeyPress",
        value: function _handleArrowKeyPress(t, e) {
          var n = this.editor,
            o = n.model,
            i = o.document.selection,
            r = o.schema,
            s = n.editing.view,
            a = Ki(e.keyCode, n.locale.contentLanguageDirection),
            c = s.document.selection.getSelectedElement();
          var l;
          _m(c, n.editing.mapper.toModelElement(c), r) ? l = this._handleArrowKeyPressOnSelectedWidget(a) : i.isCollapsed && (l = this._handleArrowKeyPressWhenSelectionNextToAWidget(a)), l && (e.preventDefault(), t.stop());
        }
      }, {
        key: "_handleArrowKeyPressOnSelectedWidget",
        value: function _handleArrowKeyPressOnSelectedWidget(t) {
          var e = this.editor.model,
            n = vm(e.document.selection);
          return e.change(function (e) {
            if (!n) return e.setSelectionAttribute(Am, t ? "after" : "before"), !0;
            if (!(n === (t ? "after" : "before"))) return e.removeSelectionAttribute(Am), !0;
            return !1;
          });
        }
      }, {
        key: "_handleArrowKeyPressWhenSelectionNextToAWidget",
        value: function _handleArrowKeyPressWhenSelectionNextToAWidget(t) {
          var e = this.editor,
            n = e.model,
            o = n.schema,
            i = e.plugins.get("Widget"),
            r = i._getObjectElementNextToSelection(t);
          return !!_m(e.editing.mapper.toViewElement(r), r, o) && (n.change(function (e) {
            i._setSelectionOverElement(r), e.setSelectionAttribute(Am, t ? "before" : "after");
          }), !0);
        }
      }, {
        key: "_enableInsertingParagraphsOnButtonClick",
        value: function _enableInsertingParagraphsOnButtonClick() {
          var _this181 = this;
          var t = this.editor,
            e = t.editing.view;
          this._listenToIfEnabled(e.document, "mousedown", function (n, o) {
            var i = o.domTarget.closest(".ck-widget__type-around__button");
            if (!i) return;
            var r = function (t) {
                return t.classList.contains("ck-widget__type-around__button_before") ? "before" : "after";
              }(i),
              s = function (t, e) {
                var n = t.closest(".ck-widget");
                return e.mapDomToView(n);
              }(i, e.domConverter),
              a = t.editing.mapper.toModelElement(s);
            _this181._insertParagraph(a, r), o.preventDefault(), n.stop();
          });
        }
      }, {
        key: "_enableInsertingParagraphsOnEnterKeypress",
        value: function _enableInsertingParagraphsOnEnterKeypress() {
          var _this182 = this;
          var t = this.editor,
            e = t.model.document.selection,
            n = t.editing.view;
          this._listenToIfEnabled(n.document, "enter", function (n, o) {
            if ("atTarget" != n.eventPhase) return;
            var i = e.getSelectedElement(),
              r = t.editing.mapper.toViewElement(i),
              s = t.model.schema;
            var a;
            _this182._insertParagraphAccordingToFakeCaretPosition() ? a = !0 : _m(r, i, s) && (_this182._insertParagraph(i, o.isSoft ? "before" : "after"), a = !0), a && (o.preventDefault(), n.stop());
          }, {
            context: hm
          });
        }
      }, {
        key: "_enableInsertingParagraphsOnTypingKeystroke",
        value: function _enableInsertingParagraphsOnTypingKeystroke() {
          var _this183 = this;
          var t = this.editor.editing.view,
            e = [Vi.enter, Vi.delete, Vi.backspace];
          this._listenToIfEnabled(t.document, "keydown", function (t, n) {
            e.includes(n.keyCode) || hg(n) || _this183._insertParagraphAccordingToFakeCaretPosition();
          }, {
            priority: "high"
          });
        }
      }, {
        key: "_enableDeleteIntegration",
        value: function _enableDeleteIntegration() {
          var t = this.editor,
            e = t.editing.view,
            n = t.model,
            o = n.schema;
          this._listenToIfEnabled(e.document, "delete", function (e, i) {
            if ("atTarget" != e.eventPhase) return;
            var r = vm(n.document.selection);
            if (!r) return;
            var s = i.direction,
              a = n.document.selection.getSelectedElement(),
              c = "forward" == s;
            if ("before" === r === c) t.execute("delete", {
              selection: n.createSelection(a, "on")
            });else {
              var _e247 = o.getNearestSelectionRange(n.createPositionAt(a, r), s);
              if (_e247) if (_e247.isCollapsed) {
                var _i122 = n.createSelection(_e247.start);
                if (n.modifySelection(_i122, {
                  direction: s
                }), _i122.focus.isEqual(_e247.start)) {
                  var _t256 = function (t, e) {
                    var n = e;
                    var _iterator326 = _createForOfIteratorHelper(e.getAncestors({
                        parentFirst: !0
                      })),
                      _step326;
                    try {
                      for (_iterator326.s(); !(_step326 = _iterator326.n()).done;) {
                        var _o157 = _step326.value;
                        if (_o157.childCount > 1 || t.isLimit(_o157)) break;
                        n = _o157;
                      }
                    } catch (err) {
                      _iterator326.e(err);
                    } finally {
                      _iterator326.f();
                    }
                    return n;
                  }(o, _e247.start.parent);
                  n.deleteContent(n.createSelection(_t256, "on"), {
                    doNotAutoparagraph: !0
                  });
                } else n.change(function (n) {
                  n.setSelection(_e247), t.execute(c ? "deleteForward" : "delete");
                });
              } else n.change(function (n) {
                n.setSelection(_e247), t.execute(c ? "deleteForward" : "delete");
              });
            }
            i.preventDefault(), e.stop();
          }, {
            context: hm
          });
        }
      }, {
        key: "_enableInsertContentIntegration",
        value: function _enableInsertContentIntegration() {
          var t = this.editor,
            e = this.editor.model,
            n = e.document.selection;
          this._listenToIfEnabled(t.model, "insertContent", function (t, _ref43) {
            var _ref44 = _slicedToArray(_ref43, 2),
              o = _ref44[0],
              i = _ref44[1];
            if (i && !i.is("documentSelection")) return;
            var r = vm(n);
            return r ? (t.stop(), e.change(function (t) {
              var i = n.getSelectedElement(),
                s = e.createPositionAt(i, r),
                a = t.createSelection(s),
                c = e.insertContent(o, a);
              return t.setSelection(a), c;
            })) : void 0;
          }, {
            priority: "high"
          });
        }
      }, {
        key: "_enableDeleteContentIntegration",
        value: function _enableDeleteContentIntegration() {
          var t = this.editor,
            e = this.editor.model.document.selection;
          this._listenToIfEnabled(t.model, "deleteContent", function (t, _ref45) {
            var _ref46 = _slicedToArray(_ref45, 1),
              n = _ref46[0];
            if (n && !n.is("documentSelection")) return;
            vm(e) && t.stop();
          }, {
            priority: "high"
          });
        }
      }]);
      return Im;
    }(Jt);
    var Tm = n(38),
      Sm = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Zl()(Tm.a, Sm), Tm.a.locals;
    function Nm(t) {
      var e = t.model;
      return function (n, o) {
        var i = o.keyCode == Vi.arrowup,
          r = o.keyCode == Vi.arrowdown,
          s = o.shiftKey,
          a = e.document.selection;
        if (!i && !r) return;
        var c = r;
        if (s && function (t, e) {
          return !t.isCollapsed && t.isBackward == e;
        }(a, c)) return;
        var l = function (t, e, n) {
          var o = t.model;
          if (n) {
            var _t257 = e.isCollapsed ? e.focus : e.getLastPosition(),
              _n240 = Bm(o, _t257, "forward");
            if (!_n240) return null;
            var _i123 = o.createRange(_t257, _n240),
              _r51 = Pm(o.schema, _i123, "backward");
            return _r51 && _t257.isBefore(_r51) ? o.createRange(_t257, _r51) : null;
          }
          {
            var _t258 = e.isCollapsed ? e.focus : e.getFirstPosition(),
              _n241 = Bm(o, _t258, "backward");
            if (!_n241) return null;
            var _i124 = o.createRange(_n241, _t258),
              _r52 = Pm(o.schema, _i124, "forward");
            return _r52 && _t258.isAfter(_r52) ? o.createRange(_r52, _t258) : null;
          }
        }(t, a, c);
        l && !l.isCollapsed && function (t, e, n) {
          var o = t.model,
            i = t.view.domConverter;
          if (n) {
            var _t259 = o.createSelection(e.start);
            o.modifySelection(_t259), _t259.focus.isAtEnd || e.start.isEqual(_t259.focus) || (e = o.createRange(_t259.focus, e.end));
          }
          var r = t.mapper.toViewRange(e),
            s = i.viewRangeToDom(r),
            a = Vs.getDomRangeRects(s);
          var c;
          var _iterator327 = _createForOfIteratorHelper(a),
            _step327;
          try {
            for (_iterator327.s(); !(_step327 = _iterator327.n()).done;) {
              var _t260 = _step327.value;
              if (void 0 !== c) {
                if (Math.round(_t260.top) >= c) return !1;
                c = Math.max(c, Math.round(_t260.bottom));
              } else c = Math.round(_t260.bottom);
            }
          } catch (err) {
            _iterator327.e(err);
          } finally {
            _iterator327.f();
          }
          return !0;
        }(t, l, c) && (e.change(function (t) {
          var n = c ? l.end : l.start;
          if (s) {
            var _o158 = e.createSelection(a.anchor);
            _o158.setFocus(n), t.setSelection(_o158);
          } else t.setSelection(n);
        }), n.stop(), o.preventDefault(), o.stopPropagation());
      };
    }
    function Bm(t, e, n) {
      var o = t.schema,
        i = t.createRangeIn(e.root),
        r = "forward" == n ? "elementStart" : "elementEnd";
      var _iterator328 = _createForOfIteratorHelper(i.getWalker({
          startPosition: e,
          direction: n
        })),
        _step328;
      try {
        for (_iterator328.s(); !(_step328 = _iterator328.n()).done;) {
          var _step328$value = _step328.value,
            _t261 = _step328$value.previousPosition,
            _s29 = _step328$value.item,
            _a18 = _step328$value.type;
          if (o.isLimit(_s29) && !o.isInline(_s29)) return _t261;
          if (_a18 == r && o.isBlock(_s29)) return null;
        }
      } catch (err) {
        _iterator328.e(err);
      } finally {
        _iterator328.f();
      }
      return null;
    }
    function Pm(t, e, n) {
      var o = "backward" == n ? e.end : e.start;
      if (t.checkChild(o, "$text")) return o;
      var _iterator329 = _createForOfIteratorHelper(e.getWalker({
          direction: n
        })),
        _step329;
      try {
        for (_iterator329.s(); !(_step329 = _iterator329.n()).done;) {
          var _o159 = _step329.value.nextPosition;
          if (t.checkChild(_o159, "$text")) return _o159;
        }
      } catch (err) {
        _iterator329.e(err);
      } finally {
        _iterator329.f();
      }
    }
    var zm = /*#__PURE__*/function (_Jt16) {
      _inherits(zm, _Jt16);
      function zm() {
        _classCallCheck(this, zm);
        return _possibleConstructorReturn(this, _getPrototypeOf(zm).apply(this, arguments));
      }
      _createClass(zm, [{
        key: "init",
        value: function init() {
          var _this184 = this;
          var t = this.editor,
            e = t.editing.view,
            n = e.document;
          this._previouslySelected = new Set(), this.editor.editing.downcastDispatcher.on("selection", function (e, n, o) {
            var i = o.writer,
              r = n.selection;
            if (r.isCollapsed) return;
            var s = r.getSelectedElement();
            if (!s) return;
            var a = t.editing.mapper.toViewElement(s);
            hm(a) && o.consumable.consume(r, "selection") && i.setSelection(i.createRangeOn(a), {
              fake: !0,
              label: fm(a)
            });
          }), this.editor.editing.downcastDispatcher.on("selection", function (t, e, n) {
            _this184._clearPreviouslySelectedWidgets(n.writer);
            var o = n.writer,
              i = o.document.selection;
            var r = null;
            var _iterator330 = _createForOfIteratorHelper(i.getRanges()),
              _step330;
            try {
              for (_iterator330.s(); !(_step330 = _iterator330.n()).done;) {
                var _t262 = _step330.value;
                var _iterator331 = _createForOfIteratorHelper(_t262),
                  _step331;
                try {
                  for (_iterator331.s(); !(_step331 = _iterator331.n()).done;) {
                    var _e248 = _step331.value;
                    var _t263 = _e248.item;
                    hm(_t263) && !Lm(_t263, r) && (o.addClass(dm, _t263), _this184._previouslySelected.add(_t263), r = _t263);
                  }
                } catch (err) {
                  _iterator331.e(err);
                } finally {
                  _iterator331.f();
                }
              }
            } catch (err) {
              _iterator330.e(err);
            } finally {
              _iterator330.f();
            }
          }, {
            priority: "low"
          }), e.addObserver(Tu), this.listenTo(n, "mousedown", function () {
            return _this184._onMousedown.apply(_this184, arguments);
          }), this.listenTo(n, "arrowKey", function () {
            _this184._handleSelectionChangeOnArrowKeyPress.apply(_this184, arguments);
          }, {
            context: [hm, "$text"]
          }), this.listenTo(n, "arrowKey", function () {
            _this184._preventDefaultOnArrowKeyPress.apply(_this184, arguments);
          }, {
            context: "$root"
          }), this.listenTo(n, "arrowKey", Nm(this.editor.editing), {
            context: "$text"
          }), this.listenTo(n, "delete", function (t, e) {
            _this184._handleDelete("forward" == e.direction) && (e.preventDefault(), t.stop());
          }, {
            context: "$root"
          });
        }
      }, {
        key: "_onMousedown",
        value: function _onMousedown(t, e) {
          var n = this.editor,
            o = n.editing.view,
            i = o.document;
          var r = e.target;
          if (function (t) {
            for (; t;) {
              if (t.is("editableElement") && !t.is("rootElement")) return !0;
              if (hm(t)) return !1;
              t = t.parent;
            }
            return !1;
          }(r)) {
            if ((Ri.isSafari || Ri.isGecko) && e.domEvent.detail >= 3) {
              var _t264 = n.editing.mapper,
                _o160 = r.is("attributeElement") ? r.findAncestor(function (t) {
                  return !t.is("attributeElement");
                }) : r,
                _i125 = _t264.toModelElement(_o160);
              e.preventDefault(), this.editor.model.change(function (t) {
                t.setSelection(_i125, "in");
              });
            }
            return;
          }
          if (!hm(r) && (r = r.findAncestor(hm), !r)) return;
          Ri.isAndroid && e.preventDefault(), i.isFocused || o.focus();
          var s = n.editing.mapper.toModelElement(r);
          this._setSelectionOverElement(s);
        }
      }, {
        key: "_handleSelectionChangeOnArrowKeyPress",
        value: function _handleSelectionChangeOnArrowKeyPress(t, e) {
          var n = e.keyCode,
            o = this.editor.model,
            i = o.schema,
            r = o.document.selection,
            s = r.getSelectedElement(),
            a = Ki(n, this.editor.locale.contentLanguageDirection);
          if (s && i.isObject(s)) {
            var _n242 = a ? r.getLastPosition() : r.getFirstPosition(),
              _s30 = i.getNearestSelectionRange(_n242, a ? "forward" : "backward");
            return void (_s30 && (o.change(function (t) {
              t.setSelection(_s30);
            }), e.preventDefault(), t.stop()));
          }
          if (!r.isCollapsed) return;
          var c = this._getObjectElementNextToSelection(a);
          c && i.isObject(c) && (this._setSelectionOverElement(c), e.preventDefault(), t.stop());
        }
      }, {
        key: "_preventDefaultOnArrowKeyPress",
        value: function _preventDefaultOnArrowKeyPress(t, e) {
          var n = this.editor.model,
            o = n.schema,
            i = n.document.selection.getSelectedElement();
          i && o.isObject(i) && (e.preventDefault(), t.stop());
        }
      }, {
        key: "_handleDelete",
        value: function _handleDelete(t) {
          var _this185 = this;
          if (this.editor.isReadOnly) return;
          var e = this.editor.model.document.selection;
          if (!e.isCollapsed) return;
          var n = this._getObjectElementNextToSelection(t);
          return n ? (this.editor.model.change(function (t) {
            var o = e.anchor.parent;
            for (; o.isEmpty;) {
              var _e249 = o;
              o = _e249.parent, t.remove(_e249);
            }
            _this185._setSelectionOverElement(n);
          }), !0) : void 0;
        }
      }, {
        key: "_setSelectionOverElement",
        value: function _setSelectionOverElement(t) {
          this.editor.model.change(function (e) {
            e.setSelection(e.createRangeOn(t));
          });
        }
      }, {
        key: "_getObjectElementNextToSelection",
        value: function _getObjectElementNextToSelection(t) {
          var e = this.editor.model,
            n = e.schema,
            o = e.document.selection,
            i = e.createSelection(o);
          e.modifySelection(i, {
            direction: t ? "forward" : "backward"
          });
          var r = t ? i.focus.nodeBefore : i.focus.nodeAfter;
          return r && n.isObject(r) ? r : null;
        }
      }, {
        key: "_clearPreviouslySelectedWidgets",
        value: function _clearPreviouslySelectedWidgets(t) {
          var _iterator332 = _createForOfIteratorHelper(this._previouslySelected),
            _step332;
          try {
            for (_iterator332.s(); !(_step332 = _iterator332.n()).done;) {
              var _e250 = _step332.value;
              t.removeClass(dm, _e250);
            }
          } catch (err) {
            _iterator332.e(err);
          } finally {
            _iterator332.f();
          }
          this._previouslySelected.clear();
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "Widget";
        }
      }, {
        key: "requires",
        get: function get() {
          return [Im, Cg];
        }
      }]);
      return zm;
    }(Jt);
    function Lm(t, e) {
      return !!e && Array.from(t.getAncestors()).includes(e);
    }
    var Om = function Om(t, e, n) {
        var o = !0,
          i = !0;
        if ("function" != typeof t) throw new TypeError("Expected a function");
        return w(n) && (o = "leading" in n ? !!n.leading : o, i = "trailing" in n ? !!n.trailing : i), Is(t, e, {
          leading: o,
          maxWait: e,
          trailing: i
        });
      },
      Rm = n(39),
      jm = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Zl()(Rm.a, jm), Rm.a.locals;
    var Fm = /*#__PURE__*/function (_Jt17) {
      _inherits(Fm, _Jt17);
      function Fm() {
        _classCallCheck(this, Fm);
        return _possibleConstructorReturn(this, _getPrototypeOf(Fm).apply(this, arguments));
      }
      _createClass(Fm, [{
        key: "init",
        value: function init() {
          var _this186 = this;
          var t = this.editor,
            e = t.editing.view;
          this._draggedRange = null, this._draggingUid = "", this._draggableElement = null, this._updateDropMarkerThrottled = Om(function (t) {
            return _this186._updateDropMarker(t);
          }, 40), this._removeDropMarkerDelayed = Hm(function () {
            return _this186._removeDropMarker();
          }, 40), this._clearDraggableAttributesDelayed = Hm(function () {
            return _this186._clearDraggableAttributes();
          }, 40), e.addObserver(em), e.addObserver(Tu), this._setupDragging(), this._setupContentInsertionIntegration(), this._setupClipboardInputIntegration(), this._setupDropMarker(), this._setupDraggableAttributeHandling(), this.listenTo(t, "change:isReadOnly", function (t, e, n) {
            n ? _this186.forceDisabled("readOnlyMode") : _this186.clearForceDisabled("readOnlyMode");
          }), this.on("change:isEnabled", function (t, e, n) {
            n || _this186._finalizeDragging(!1);
          }), Ri.isAndroid && this.forceDisabled("noAndroidSupport");
        }
      }, {
        key: "destroy",
        value: function destroy() {
          return this._draggedRange && (this._draggedRange.detach(), this._draggedRange = null), this._updateDropMarkerThrottled.cancel(), this._removeDropMarkerDelayed.cancel(), this._clearDraggableAttributesDelayed.cancel(), _get(_getPrototypeOf(Fm.prototype), "destroy", this).call(this);
        }
      }, {
        key: "_setupDragging",
        value: function _setupDragging() {
          var _this187 = this;
          var t = this.editor,
            e = t.model,
            n = e.document,
            o = t.editing.view,
            i = o.document;
          this.listenTo(i, "dragstart", function (o, r) {
            var a = n.selection;
            if (r.target && r.target.is("editableElement")) return void r.preventDefault();
            var c = r.target ? Gm(r.target) : null;
            if (c) {
              var _n243 = t.editing.mapper.toModelElement(c);
              _this187._draggedRange = Na.fromRange(e.createRangeOn(_n243)), t.plugins.has("WidgetToolbarRepository") && t.plugins.get("WidgetToolbarRepository").forceDisabled("dragDrop");
            } else if (!i.selection.isCollapsed) {
              var _t265 = i.selection.getSelectedElement();
              _t265 && hm(_t265) || (_this187._draggedRange = Na.fromRange(a.getFirstRange()));
            }
            if (!_this187._draggedRange) return void r.preventDefault();
            _this187._draggingUid = s(), r.dataTransfer.effectAllowed = _this187.isEnabled ? "copyMove" : "copy", r.dataTransfer.setData("application/ckeditor5-dragging-uid", _this187._draggingUid);
            var l = e.createSelection(_this187._draggedRange.toRange()),
              d = t.data.toView(e.getSelectedContent(l));
            i.fire("clipboardOutput", {
              dataTransfer: r.dataTransfer,
              content: d,
              method: o.name
            }), _this187.isEnabled || (_this187._draggedRange.detach(), _this187._draggedRange = null, _this187._draggingUid = "");
          }, {
            priority: "low"
          }), this.listenTo(i, "dragend", function (t, e) {
            _this187._finalizeDragging(!e.dataTransfer.isCanceled && "move" == e.dataTransfer.dropEffect);
          }, {
            priority: "low"
          }), this.listenTo(i, "dragenter", function () {
            _this187.isEnabled && o.focus();
          }), this.listenTo(i, "dragleave", function () {
            _this187._removeDropMarkerDelayed();
          }), this.listenTo(i, "dragging", function (e, n) {
            if (!_this187.isEnabled) return void (n.dataTransfer.dropEffect = "none");
            _this187._removeDropMarkerDelayed.cancel();
            var o = Vm(t, n.targetRanges, n.target);
            _this187._draggedRange || (n.dataTransfer.dropEffect = "copy"), Ri.isGecko || ("copy" == n.dataTransfer.effectAllowed ? n.dataTransfer.dropEffect = "copy" : ["all", "copyMove"].includes(n.dataTransfer.effectAllowed) && (n.dataTransfer.dropEffect = "move")), o && _this187._updateDropMarkerThrottled(o);
          }, {
            priority: "low"
          });
        }
      }, {
        key: "_setupClipboardInputIntegration",
        value: function _setupClipboardInputIntegration() {
          var _this188 = this;
          var t = this.editor,
            e = t.editing.view.document;
          this.listenTo(e, "clipboardInput", function (e, n) {
            if ("drop" != n.method) return;
            var o = Vm(t, n.targetRanges, n.target);
            if (_this188._removeDropMarker(), !o) return _this188._finalizeDragging(!1), void e.stop();
            _this188._draggedRange && _this188._draggingUid != n.dataTransfer.getData("application/ckeditor5-dragging-uid") && (_this188._draggedRange.detach(), _this188._draggedRange = null, _this188._draggingUid = "");
            if ("move" == Um(n.dataTransfer) && _this188._draggedRange && _this188._draggedRange.containsRange(o, !0)) return _this188._finalizeDragging(!1), void e.stop();
            n.targetRanges = [t.editing.mapper.toViewRange(o)];
          }, {
            priority: "high"
          });
        }
      }, {
        key: "_setupContentInsertionIntegration",
        value: function _setupContentInsertionIntegration() {
          var _this189 = this;
          var t = this.editor.plugins.get(im);
          t.on("contentInsertion", function (t, e) {
            if (!_this189.isEnabled || "drop" !== e.method) return;
            var n = e.targetRanges.map(function (t) {
              return _this189.editor.editing.mapper.toModelRange(t);
            });
            _this189.editor.model.change(function (t) {
              return t.setSelection(n);
            });
          }, {
            priority: "high"
          }), t.on("contentInsertion", function (t, e) {
            if (!_this189.isEnabled || "drop" !== e.method) return;
            var n = "move" == Um(e.dataTransfer),
              o = !e.resultRange || !e.resultRange.isCollapsed;
            _this189._finalizeDragging(o && n);
          }, {
            priority: "lowest"
          });
        }
      }, {
        key: "_setupDraggableAttributeHandling",
        value: function _setupDraggableAttributeHandling() {
          var _this190 = this;
          var t = this.editor,
            e = t.editing.view,
            n = e.document;
          this.listenTo(n, "mousedown", function (o, i) {
            if (Ri.isAndroid || !i) return;
            _this190._clearDraggableAttributesDelayed.cancel();
            var r = Gm(i.target);
            if (Ri.isBlink && !t.isReadOnly && !r && !n.selection.isCollapsed) {
              var _t266 = n.selection.getSelectedElement();
              _t266 && hm(_t266) || (r = n.selection.editableElement);
            }
            r && (e.change(function (t) {
              t.setAttribute("draggable", "true", r);
            }), _this190._draggableElement = t.editing.mapper.toModelElement(r));
          }), this.listenTo(n, "mouseup", function () {
            Ri.isAndroid || _this190._clearDraggableAttributesDelayed();
          });
        }
      }, {
        key: "_clearDraggableAttributes",
        value: function _clearDraggableAttributes() {
          var _this191 = this;
          var t = this.editor.editing;
          t.view.change(function (e) {
            _this191._draggableElement && "$graveyard" != _this191._draggableElement.root.rootName && e.removeAttribute("draggable", t.mapper.toViewElement(_this191._draggableElement)), _this191._draggableElement = null;
          });
        }
      }, {
        key: "_setupDropMarker",
        value: function _setupDropMarker() {
          var t = this.editor;
          t.conversion.for("editingDowncast").markerToHighlight({
            model: "drop-target",
            view: {
              classes: ["ck-clipboard-drop-target-range"]
            }
          }), t.conversion.for("editingDowncast").markerToElement({
            model: "drop-target",
            view: function view(e, _ref47) {
              var n = _ref47.writer;
              if (t.model.schema.checkChild(e.markerRange.start, "$text")) return n.createUIElement("span", {
                class: "ck ck-clipboard-drop-target-position"
              }, function (t) {
                var e = this.toDomElement(t);
                return e.innerHTML = "&NoBreak;<span></span>&NoBreak;", e;
              });
            }
          });
        }
      }, {
        key: "_updateDropMarker",
        value: function _updateDropMarker(t) {
          var e = this.editor,
            n = e.model.markers;
          e.model.change(function (e) {
            n.has("drop-target") ? n.get("drop-target").getRange().isEqual(t) || e.updateMarker("drop-target", {
              range: t
            }) : e.addMarker("drop-target", {
              range: t,
              usingOperation: !1,
              affectsData: !1
            });
          });
        }
      }, {
        key: "_removeDropMarker",
        value: function _removeDropMarker() {
          var t = this.editor.model;
          this._removeDropMarkerDelayed.cancel(), this._updateDropMarkerThrottled.cancel(), t.markers.has("drop-target") && t.change(function (t) {
            t.removeMarker("drop-target");
          });
        }
      }, {
        key: "_finalizeDragging",
        value: function _finalizeDragging(t) {
          var e = this.editor,
            n = e.model;
          this._removeDropMarker(), this._clearDraggableAttributes(), e.plugins.has("WidgetToolbarRepository") && e.plugins.get("WidgetToolbarRepository").clearForceDisabled("dragDrop"), this._draggingUid = "", this._draggedRange && (t && this.isEnabled && n.deleteContent(n.createSelection(this._draggedRange), {
            doNotAutoparagraph: !0
          }), this._draggedRange.detach(), this._draggedRange = null);
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "DragDrop";
        }
      }, {
        key: "requires",
        get: function get() {
          return [im, zm];
        }
      }]);
      return Fm;
    }(Jt);
    function Vm(t, e, n) {
      var o = t.model,
        i = t.editing.mapper;
      var r = null;
      var s = e ? e[0].start : null;
      if (n.is("uiElement") && (n = n.parent), r = function (t, e) {
        var n = t.model,
          o = t.editing.mapper;
        if (hm(e)) return n.createRangeOn(o.toModelElement(e));
        if (!e.is("editableElement")) {
          var _t267 = e.findAncestor(function (t) {
            return hm(t) || t.is("editableElement");
          });
          if (hm(_t267)) return n.createRangeOn(o.toModelElement(_t267));
        }
        return null;
      }(t, n), r) return r;
      var a = function (t, e) {
          var n = t.editing.mapper,
            o = t.editing.view,
            i = n.toModelElement(e);
          if (i) return i;
          var r = o.createPositionBefore(e),
            s = n.findMappedViewAncestor(r);
          return n.toModelElement(s);
        }(t, n),
        c = s ? i.toModelPosition(s) : null;
      return c ? (r = function (t, e, n) {
        var o = t.model;
        if (!o.schema.checkChild(n, "$block")) return null;
        var i = o.createPositionAt(n, 0),
          r = e.path.slice(0, i.path.length),
          s = o.createPositionFromPath(e.root, r).nodeAfter;
        if (s && o.schema.isObject(s)) return o.createRangeOn(s);
        return null;
      }(t, c, a), r || (r = o.schema.getNearestSelectionRange(c, Ri.isGecko ? "forward" : "backward"), r || function (t, e) {
        var n = t.model;
        for (; e;) {
          if (n.schema.isObject(e)) return n.createRangeOn(e);
          e = e.parent;
        }
      }(t, c.parent))) : function (t, e) {
        var n = t.model,
          o = n.schema,
          i = n.createPositionAt(e, 0);
        return o.getNearestSelectionRange(i, "forward");
      }(t, a);
    }
    function Um(t) {
      return Ri.isGecko ? t.dropEffect : ["all", "copyMove"].includes(t.effectAllowed) ? "move" : "copy";
    }
    function Hm(t, e) {
      var n;
      function o() {
        for (var _len23 = arguments.length, i = new Array(_len23), _key23 = 0; _key23 < _len23; _key23++) {
          i[_key23] = arguments[_key23];
        }
        o.cancel(), n = setTimeout(function () {
          return t.apply(void 0, i);
        }, e);
      }
      return o.cancel = function () {
        clearTimeout(n);
      }, o;
    }
    function Gm(t) {
      if (t.is("editableElement")) return null;
      if (t.hasClass("ck-widget__selection-handle")) return t.findAncestor(hm);
      if (hm(t)) return t;
      var e = t.findAncestor(function (t) {
        return hm(t) || t.is("editableElement");
      });
      return hm(e) ? e : null;
    }
    var Wm = /*#__PURE__*/function (_Jt18) {
      _inherits(Wm, _Jt18);
      function Wm() {
        _classCallCheck(this, Wm);
        return _possibleConstructorReturn(this, _getPrototypeOf(Wm).apply(this, arguments));
      }
      _createClass(Wm, [{
        key: "init",
        value: function init() {
          var t = this.editor,
            e = t.model,
            n = t.editing.view,
            o = n.document,
            i = e.document.selection;
          var r = !1;
          n.addObserver(em), this.listenTo(o, "keydown", function (t, e) {
            r = e.shiftKey;
          }), t.plugins.get(im).on("contentInsertion", function (t, n) {
            (r || function (t, e) {
              if (t.childCount > 1) return !1;
              var n = t.getChild(0);
              if (e.isObject(n)) return !1;
              return 0 == _toConsumableArray(n.getAttributeKeys()).length;
            }(n.content, e.schema)) && e.change(function (t) {
              var o = Array.from(i.getAttributes()).filter(function (_ref48) {
                var _ref49 = _slicedToArray(_ref48, 1),
                  t = _ref49[0];
                return e.schema.getAttributeProperties(t).isFormatting;
              });
              i.isCollapsed || e.deleteContent(i, {
                doNotAutoparagraph: !0
              }), o.push.apply(o, _toConsumableArray(i.getAttributes()));
              var r = t.createRangeIn(n.content);
              var _iterator333 = _createForOfIteratorHelper(r.getItems()),
                _step333;
              try {
                for (_iterator333.s(); !(_step333 = _iterator333.n()).done;) {
                  var _e251 = _step333.value;
                  _e251.is("$textProxy") && t.setAttributes(o, _e251);
                }
              } catch (err) {
                _iterator333.e(err);
              } finally {
                _iterator333.f();
              }
            });
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "PastePlainText";
        }
      }, {
        key: "requires",
        get: function get() {
          return [im];
        }
      }]);
      return Wm;
    }(Jt);
    var qm = /*#__PURE__*/function (_Jt19) {
      _inherits(qm, _Jt19);
      function qm() {
        _classCallCheck(this, qm);
        return _possibleConstructorReturn(this, _getPrototypeOf(qm).apply(this, arguments));
      }
      _createClass(qm, null, [{
        key: "pluginName",
        get: function get() {
          return "Clipboard";
        }
      }, {
        key: "requires",
        get: function get() {
          return [im, Fm, Wm];
        }
      }]);
      return qm;
    }(Jt);
    var Km = /*#__PURE__*/function (_Xt9) {
      _inherits(Km, _Xt9);
      function Km() {
        _classCallCheck(this, Km);
        return _possibleConstructorReturn(this, _getPrototypeOf(Km).apply(this, arguments));
      }
      _createClass(Km, [{
        key: "execute",
        value: function execute() {
          var t = this.editor.model,
            e = t.document.selection;
          var n = t.schema.getLimitElement(e);
          if (e.containsEntireContent(n) || !Ym(t.schema, n)) do {
            if (n = n.parent, !n) return;
          } while (!Ym(t.schema, n));
          t.change(function (t) {
            t.setSelection(n, "in");
          });
        }
      }]);
      return Km;
    }(Xt);
    function Ym(t, e) {
      return t.isLimit(e) && (t.checkChild(e, "$text") || t.checkChild(e, "paragraph"));
    }
    var Qm = Gi("Ctrl+A");
    var $m = /*#__PURE__*/function (_Jt20) {
      _inherits($m, _Jt20);
      function $m() {
        _classCallCheck(this, $m);
        return _possibleConstructorReturn(this, _getPrototypeOf($m).apply(this, arguments));
      }
      _createClass($m, [{
        key: "init",
        value: function init() {
          var t = this.editor,
            e = t.editing.view.document;
          t.commands.add("selectAll", new Km(t)), this.listenTo(e, "keydown", function (e, n) {
            Hi(n) === Qm && (t.execute("selectAll"), n.preventDefault());
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "SelectAllEditing";
        }
      }]);
      return $m;
    }(Jt);
    var Jm = /*#__PURE__*/function (_Jt21) {
      _inherits(Jm, _Jt21);
      function Jm() {
        _classCallCheck(this, Jm);
        return _possibleConstructorReturn(this, _getPrototypeOf(Jm).apply(this, arguments));
      }
      _createClass(Jm, [{
        key: "init",
        value: function init() {
          var _this192 = this;
          var t = this.editor;
          t.ui.componentFactory.add("selectAll", function (e) {
            var n = t.commands.get("selectAll"),
              o = new Sd(e),
              i = e.t;
            return o.set({
              label: i("Select all"),
              icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M.75 15.5a.75.75 0 0 1 .75.75V18l.008.09A.5.5 0 0 0 2 18.5h1.75a.75.75 0 1 1 0 1.5H1.5l-.144-.007a1.5 1.5 0 0 1-1.35-1.349L0 18.5v-2.25a.75.75 0 0 1 .75-.75zm18.5 0a.75.75 0 0 1 .75.75v2.25l-.007.144a1.5 1.5 0 0 1-1.349 1.35L18.5 20h-2.25a.75.75 0 1 1 0-1.5H18a.5.5 0 0 0 .492-.41L18.5 18v-1.75a.75.75 0 0 1 .75-.75zm-10.45 3c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2H7.2a.2.2 0 0 1-.2-.2v-1.1c0-.11.09-.2.2-.2h1.6zm4 0c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2h-1.6a.2.2 0 0 1-.2-.2v-1.1c0-.11.09-.2.2-.2h1.6zm.45-5.5a.75.75 0 1 1 0 1.5h-8.5a.75.75 0 1 1 0-1.5h8.5zM1.3 11c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2H.2a.2.2 0 0 1-.2-.2v-1.6c0-.11.09-.2.2-.2h1.1zm18.5 0c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2h-1.1a.2.2 0 0 1-.2-.2v-1.6c0-.11.09-.2.2-.2h1.1zm-4.55-2a.75.75 0 1 1 0 1.5H4.75a.75.75 0 1 1 0-1.5h10.5zM1.3 7c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2H.2a.2.2 0 0 1-.2-.2V7.2c0-.11.09-.2.2-.2h1.1zm18.5 0c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2h-1.1a.2.2 0 0 1-.2-.2V7.2c0-.11.09-.2.2-.2h1.1zm-4.55-2a.75.75 0 1 1 0 1.5h-2.5a.75.75 0 1 1 0-1.5h2.5zm-5 0a.75.75 0 1 1 0 1.5h-5.5a.75.75 0 0 1 0-1.5h5.5zm-6.5-5a.75.75 0 0 1 0 1.5H2a.5.5 0 0 0-.492.41L1.5 2v1.75a.75.75 0 0 1-1.5 0V1.5l.007-.144A1.5 1.5 0 0 1 1.356.006L1.5 0h2.25zM18.5 0l.144.007a1.5 1.5 0 0 1 1.35 1.349L20 1.5v2.25a.75.75 0 1 1-1.5 0V2l-.008-.09A.5.5 0 0 0 18 1.5h-1.75a.75.75 0 1 1 0-1.5h2.25zM8.8 0c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2H7.2a.2.2 0 0 1-.2-.2V.2c0-.11.09-.2.2-.2h1.6zm4 0c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2h-1.6a.2.2 0 0 1-.2-.2V.2c0-.11.09-.2.2-.2h1.6z"/></svg>',
              keystroke: "Ctrl+A",
              tooltip: !0
            }), o.bind("isOn", "isEnabled").to(n, "value", "isEnabled"), _this192.listenTo(o, "execute", function () {
              t.execute("selectAll"), t.editing.view.focus();
            }), o;
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "SelectAllUI";
        }
      }]);
      return Jm;
    }(Jt);
    var Zm = /*#__PURE__*/function (_Jt22) {
      _inherits(Zm, _Jt22);
      function Zm() {
        _classCallCheck(this, Zm);
        return _possibleConstructorReturn(this, _getPrototypeOf(Zm).apply(this, arguments));
      }
      _createClass(Zm, null, [{
        key: "requires",
        get: function get() {
          return [$m, Jm];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "SelectAll";
        }
      }]);
      return Zm;
    }(Jt);
    var Xm = /*#__PURE__*/function (_Xt10) {
      _inherits(Xm, _Xt10);
      function Xm(t) {
        var _this193;
        _classCallCheck(this, Xm);
        _this193 = _possibleConstructorReturn(this, _getPrototypeOf(Xm).call(this, t)), _this193._stack = [], _this193._createdBatches = new WeakSet(), _this193.refresh(), _this193.listenTo(t.data, "set", function (t, e) {
          e[1] = _objectSpread({}, e[1]);
          var n = e[1];
          n.batchType || (n.batchType = "transparent");
        }, {
          priority: "high"
        }), _this193.listenTo(t.data, "set", function (t, e) {
          "transparent" === e[1].batchType && _this193.clearStack();
        });
        return _this193;
      }
      _createClass(Xm, [{
        key: "refresh",
        value: function refresh() {
          this.isEnabled = this._stack.length > 0;
        }
      }, {
        key: "addBatch",
        value: function addBatch(t) {
          var e = this.editor.model.document.selection,
            n = {
              ranges: e.hasOwnRange ? Array.from(e.getRanges()) : [],
              isBackward: e.isBackward
            };
          this._stack.push({
            batch: t,
            selection: n
          }), this.refresh();
        }
      }, {
        key: "clearStack",
        value: function clearStack() {
          this._stack = [], this.refresh();
        }
      }, {
        key: "_restoreSelection",
        value: function _restoreSelection(t, e, n) {
          var o = this.editor.model,
            i = o.document,
            r = [],
            s = t.map(function (t) {
              return t.getTransformedByOperations(n);
            }),
            a = s.flat();
          var _iterator334 = _createForOfIteratorHelper(s),
            _step334;
          try {
            for (_iterator334.s(); !(_step334 = _iterator334.n()).done;) {
              var _t268 = _step334.value;
              var _e252 = _t268.filter(function (t) {
                return t.root != i.graveyard;
              }).filter(function (t) {
                return !ep(t, a);
              });
              _e252.length && (tp(_e252), r.push(_e252[0]));
            }
          } catch (err) {
            _iterator334.e(err);
          } finally {
            _iterator334.f();
          }
          r.length && o.change(function (t) {
            t.setSelection(r, {
              backward: e
            });
          });
        }
      }, {
        key: "_undo",
        value: function _undo(t, e) {
          var n = this.editor.model,
            o = n.document;
          this._createdBatches.add(e);
          var i = t.operations.slice().filter(function (t) {
            return t.isDocumentOperation;
          });
          i.reverse();
          var _iterator335 = _createForOfIteratorHelper(i),
            _step335;
          try {
            for (_iterator335.s(); !(_step335 = _iterator335.n()).done;) {
              var _t269 = _step335.value;
              var _i126 = _t269.baseVersion + 1,
                _r53 = Array.from(o.history.getOperations(_i126)),
                _s31 = _u([_t269.getReversed()], _r53, {
                  useRelations: !0,
                  document: this.editor.model.document,
                  padWithNoOps: !1,
                  forceWeakRemove: !0
                }).operationsA;
              var _iterator336 = _createForOfIteratorHelper(_s31),
                _step336;
              try {
                for (_iterator336.s(); !(_step336 = _iterator336.n()).done;) {
                  var _i127 = _step336.value;
                  e.addOperation(_i127), n.applyOperation(_i127), o.history.setOperationAsUndone(_t269, _i127);
                }
              } catch (err) {
                _iterator336.e(err);
              } finally {
                _iterator336.f();
              }
            }
          } catch (err) {
            _iterator335.e(err);
          } finally {
            _iterator335.f();
          }
        }
      }]);
      return Xm;
    }(Xt);
    function tp(t) {
      t.sort(function (t, e) {
        return t.start.isBefore(e.start) ? -1 : 1;
      });
      for (var _e254 = 1; _e254 < t.length; _e254++) {
        var _n244 = t[_e254 - 1].getJoined(t[_e254], !0);
        _n244 && (_e254--, t.splice(_e254, 2, _n244));
      }
    }
    function ep(t, e) {
      return e.some(function (e) {
        return e !== t && e.containsRange(t, !0);
      });
    }
    var np = /*#__PURE__*/function (_Xm) {
      _inherits(np, _Xm);
      function np() {
        _classCallCheck(this, np);
        return _possibleConstructorReturn(this, _getPrototypeOf(np).apply(this, arguments));
      }
      _createClass(np, [{
        key: "execute",
        value: function execute() {
          var _this194 = this;
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
          var e = t ? this._stack.findIndex(function (e) {
              return e.batch == t;
            }) : this._stack.length - 1,
            n = this._stack.splice(e, 1)[0],
            o = this.editor.model.createBatch("transparent");
          this.editor.model.enqueueChange(o, function () {
            _this194._undo(n.batch, o);
            var t = _this194.editor.model.document.history.getOperations(n.batch.baseVersion);
            _this194._restoreSelection(n.selection.ranges, n.selection.isBackward, t), _this194.fire("revert", n.batch, o);
          }), this.refresh();
        }
      }]);
      return np;
    }(Xm);
    var op = /*#__PURE__*/function (_Xm2) {
      _inherits(op, _Xm2);
      function op() {
        _classCallCheck(this, op);
        return _possibleConstructorReturn(this, _getPrototypeOf(op).apply(this, arguments));
      }
      _createClass(op, [{
        key: "execute",
        value: function execute() {
          var _this195 = this;
          var t = this._stack.pop(),
            e = this.editor.model.createBatch("transparent");
          this.editor.model.enqueueChange(e, function () {
            var n = t.batch.operations[t.batch.operations.length - 1].baseVersion + 1,
              o = _this195.editor.model.document.history.getOperations(n);
            _this195._restoreSelection(t.selection.ranges, t.selection.isBackward, o), _this195._undo(t.batch, e);
          }), this.refresh();
        }
      }]);
      return op;
    }(Xm);
    var ip = /*#__PURE__*/function (_Jt23) {
      _inherits(ip, _Jt23);
      _createClass(ip, null, [{
        key: "pluginName",
        get: function get() {
          return "UndoEditing";
        }
      }]);
      function ip(t) {
        var _this196;
        _classCallCheck(this, ip);
        _this196 = _possibleConstructorReturn(this, _getPrototypeOf(ip).call(this, t)), _this196._batchRegistry = new WeakSet();
        return _this196;
      }
      _createClass(ip, [{
        key: "init",
        value: function init() {
          var _this197 = this;
          var t = this.editor;
          this._undoCommand = new np(t), this._redoCommand = new op(t), t.commands.add("undo", this._undoCommand), t.commands.add("redo", this._redoCommand), this.listenTo(t.model, "applyOperation", function (t, e) {
            var n = e[0];
            if (!n.isDocumentOperation) return;
            var o = n.batch,
              i = _this197._redoCommand._createdBatches.has(o),
              r = _this197._undoCommand._createdBatches.has(o);
            _this197._batchRegistry.has(o) || "transparent" == o.type && !i && !r || (i ? _this197._undoCommand.addBatch(o) : r || (_this197._undoCommand.addBatch(o), _this197._redoCommand.clearStack()), _this197._batchRegistry.add(o));
          }, {
            priority: "highest"
          }), this.listenTo(this._undoCommand, "revert", function (t, e, n) {
            _this197._redoCommand.addBatch(n);
          }), t.keystrokes.set("CTRL+Z", "undo"), t.keystrokes.set("CTRL+Y", "redo"), t.keystrokes.set("CTRL+SHIFT+Z", "redo");
        }
      }]);
      return ip;
    }(Jt);
    var rp = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m5.042 9.367 2.189 1.837a.75.75 0 0 1-.965 1.149l-3.788-3.18a.747.747 0 0 1-.21-.284.75.75 0 0 1 .17-.945L6.23 4.762a.75.75 0 1 1 .964 1.15L4.863 7.866h8.917A.75.75 0 0 1 14 7.9a4 4 0 1 1-1.477 7.718l.344-1.489a2.5 2.5 0 1 0 1.094-4.73l.008-.032H5.042z"/></svg>',
      sp = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m14.958 9.367-2.189 1.837a.75.75 0 0 0 .965 1.149l3.788-3.18a.747.747 0 0 0 .21-.284.75.75 0 0 0-.17-.945L13.77 4.762a.75.75 0 1 0-.964 1.15l2.331 1.955H6.22A.75.75 0 0 0 6 7.9a4 4 0 1 0 1.477 7.718l-.344-1.489A2.5 2.5 0 1 1 6.039 9.4l-.008-.032h8.927z"/></svg>';
    var ap = /*#__PURE__*/function (_Jt24) {
      _inherits(ap, _Jt24);
      function ap() {
        _classCallCheck(this, ap);
        return _possibleConstructorReturn(this, _getPrototypeOf(ap).apply(this, arguments));
      }
      _createClass(ap, [{
        key: "init",
        value: function init() {
          var t = this.editor,
            e = t.locale,
            n = t.t,
            o = "ltr" == e.uiLanguageDirection ? rp : sp,
            i = "ltr" == e.uiLanguageDirection ? sp : rp;
          this._addButton("undo", n("Undo"), "CTRL+Z", o), this._addButton("redo", n("Redo"), "CTRL+Y", i);
        }
      }, {
        key: "_addButton",
        value: function _addButton(t, e, n, o) {
          var _this198 = this;
          var i = this.editor;
          i.ui.componentFactory.add(t, function (r) {
            var s = i.commands.get(t),
              a = new Sd(r);
            return a.set({
              label: e,
              icon: o,
              keystroke: n,
              tooltip: !0
            }), a.bind("isEnabled").to(s, "isEnabled"), _this198.listenTo(a, "execute", function () {
              i.execute(t), i.editing.view.focus();
            }), a;
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "UndoUI";
        }
      }]);
      return ap;
    }(Jt);
    var cp = /*#__PURE__*/function (_Jt25) {
      _inherits(cp, _Jt25);
      function cp() {
        _classCallCheck(this, cp);
        return _possibleConstructorReturn(this, _getPrototypeOf(cp).apply(this, arguments));
      }
      _createClass(cp, null, [{
        key: "requires",
        get: function get() {
          return [ip, ap];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "Undo";
        }
      }]);
      return cp;
    }(Jt);
    var lp = /*#__PURE__*/function (_Xt11) {
      _inherits(lp, _Xt11);
      function lp(t, e) {
        var _this199;
        _classCallCheck(this, lp);
        _this199 = _possibleConstructorReturn(this, _getPrototypeOf(lp).call(this, t)), _this199.attributeKey = e;
        return _this199;
      }
      _createClass(lp, [{
        key: "refresh",
        value: function refresh() {
          var t = this.editor.model,
            e = t.document;
          this.value = e.selection.getAttribute(this.attributeKey), this.isEnabled = t.schema.checkAttributeInSelection(e.selection, this.attributeKey);
        }
      }, {
        key: "execute",
        value: function execute() {
          var _this200 = this;
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var e = this.editor.model,
            n = e.document.selection,
            o = t.value;
          e.change(function (t) {
            if (n.isCollapsed) o ? t.setSelectionAttribute(_this200.attributeKey, o) : t.removeSelectionAttribute(_this200.attributeKey);else {
              var _i128 = e.schema.getValidRanges(n.getRanges(), _this200.attributeKey);
              var _iterator337 = _createForOfIteratorHelper(_i128),
                _step337;
              try {
                for (_iterator337.s(); !(_step337 = _iterator337.n()).done;) {
                  var _e255 = _step337.value;
                  o ? t.setAttribute(_this200.attributeKey, o, _e255) : t.removeAttribute(_this200.attributeKey, _e255);
                }
              } catch (err) {
                _iterator337.e(err);
              } finally {
                _iterator337.f();
              }
            }
          });
        }
      }]);
      return lp;
    }(Xt);
    var dp = /*#__PURE__*/function (_co2) {
      _inherits(dp, _co2);
      function dp(t) {
        var _this201;
        _classCallCheck(this, dp);
        _this201 = _possibleConstructorReturn(this, _getPrototypeOf(dp).call(this, t)), _this201.set("isEmpty", !0), _this201.on("change", function () {
          _this201.set("isEmpty", 0 === _this201.length);
        });
        return _this201;
      }
      _createClass(dp, [{
        key: "add",
        value: function add(t, e) {
          this.find(function (e) {
            return e.color === t.color;
          }) || _get(_getPrototypeOf(dp.prototype), "add", this).call(this, t, e);
        }
      }, {
        key: "hasColor",
        value: function hasColor(t) {
          return !!this.find(function (e) {
            return e.color === t;
          });
        }
      }]);
      return dp;
    }(co);
    $t(dp, Gt);
    var hp = n(40),
      up = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Zl()(hp.a, up), hp.a.locals;
    var gp = /*#__PURE__*/function (_ed24) {
      _inherits(gp, _ed24);
      function gp(t, _ref50) {
        var _this202;
        var e = _ref50.colors,
          n = _ref50.columns,
          o = _ref50.removeButtonLabel,
          i = _ref50.documentColorsLabel,
          r = _ref50.documentColorsCount;
        _classCallCheck(this, gp);
        _this202 = _possibleConstructorReturn(this, _getPrototypeOf(gp).call(this, t)), _this202.items = _this202.createCollection(), _this202.colorDefinitions = e, _this202.focusTracker = new Ys(), _this202.keystrokes = new Qs(), _this202.set("selectedColor"), _this202.removeButtonLabel = o, _this202.columns = n, _this202.documentColors = new dp(), _this202.documentColorsCount = r, _this202._focusCycler = new Od({
          focusables: _this202.items,
          focusTracker: _this202.focusTracker,
          keystrokeHandler: _this202.keystrokes,
          actions: {
            focusPrevious: "arrowup",
            focusNext: "arrowdown"
          }
        }), _this202._documentColorsLabel = i, _this202.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-color-table"]
          },
          children: _this202.items
        }), _this202.items.add(_this202._removeColorButton());
        return _this202;
      }
      _createClass(gp, [{
        key: "updateDocumentColors",
        value: function updateDocumentColors(t, e) {
          var n = t.document,
            o = this.documentColorsCount;
          this.documentColors.clear();
          var _iterator338 = _createForOfIteratorHelper(n.getRootNames()),
            _step338;
          try {
            for (_iterator338.s(); !(_step338 = _iterator338.n()).done;) {
              var _i129 = _step338.value;
              var _r54 = n.getRoot(_i129),
                _s32 = t.createRangeIn(_r54);
              var _iterator339 = _createForOfIteratorHelper(_s32.getItems()),
                _step339;
              try {
                for (_iterator339.s(); !(_step339 = _iterator339.n()).done;) {
                  var _t270 = _step339.value;
                  if (_t270.is("$textProxy") && _t270.hasAttribute(e) && (this._addColorToDocumentColors(_t270.getAttribute(e)), this.documentColors.length >= o)) return;
                }
              } catch (err) {
                _iterator339.e(err);
              } finally {
                _iterator339.f();
              }
            }
          } catch (err) {
            _iterator338.e(err);
          } finally {
            _iterator338.f();
          }
        }
      }, {
        key: "updateSelectedColors",
        value: function updateSelectedColors() {
          var t = this.documentColorsGrid,
            e = this.staticColorsGrid,
            n = this.selectedColor;
          e.selectedColor = n, t && (t.selectedColor = n);
        }
      }, {
        key: "render",
        value: function render() {
          _get(_getPrototypeOf(gp.prototype), "render", this).call(this);
          var _iterator340 = _createForOfIteratorHelper(this.items),
            _step340;
          try {
            for (_iterator340.s(); !(_step340 = _iterator340.n()).done;) {
              var _t271 = _step340.value;
              this.focusTracker.add(_t271.element);
            }
          } catch (err) {
            _iterator340.e(err);
          } finally {
            _iterator340.f();
          }
          this.keystrokes.listenTo(this.element);
        }
      }, {
        key: "appendGrids",
        value: function appendGrids() {
          if (!this.staticColorsGrid && (this.staticColorsGrid = this._createStaticColorsGrid(), this.items.add(this.staticColorsGrid), this.documentColorsCount)) {
            var _t272 = nd.bind(this.documentColors, this.documentColors),
              _e256 = new Dh(this.locale);
            _e256.text = this._documentColorsLabel, _e256.extendTemplate({
              attributes: {
                class: ["ck", "ck-color-grid__label", _t272.if("isEmpty", "ck-hidden")]
              }
            }), this.items.add(_e256), this.documentColorsGrid = this._createDocumentColorsGrid(), this.items.add(this.documentColorsGrid);
          }
        }
      }, {
        key: "focus",
        value: function focus() {
          this._focusCycler.focusFirst();
        }
      }, {
        key: "focusLast",
        value: function focusLast() {
          this._focusCycler.focusLast();
        }
      }, {
        key: "_removeColorButton",
        value: function _removeColorButton() {
          var _this203 = this;
          var t = new Sd();
          return t.set({
            withText: !0,
            icon: ql.eraser,
            tooltip: !0,
            label: this.removeButtonLabel
          }), t.class = "ck-color-table__remove-color", t.on("execute", function () {
            _this203.fire("execute", {
              value: null
            });
          }), t;
        }
      }, {
        key: "_createStaticColorsGrid",
        value: function _createStaticColorsGrid() {
          var t = new Vd(this.locale, {
            colorDefinitions: this.colorDefinitions,
            columns: this.columns
          });
          return t.delegate("execute").to(this), t;
        }
      }, {
        key: "_createDocumentColorsGrid",
        value: function _createDocumentColorsGrid() {
          var _this204 = this;
          var t = nd.bind(this.documentColors, this.documentColors),
            e = new Vd(this.locale, {
              columns: this.columns
            });
          return e.delegate("execute").to(this), e.extendTemplate({
            attributes: {
              class: t.if("isEmpty", "ck-hidden")
            }
          }), e.items.bindTo(this.documentColors).using(function (t) {
            var e = new Ld();
            return e.set({
              color: t.color,
              hasBorder: t.options && t.options.hasBorder
            }), t.label && e.set({
              label: t.label,
              tooltip: !0
            }), e.on("execute", function () {
              _this204.fire("execute", {
                value: t.color
              });
            }), e;
          }), this.documentColors.on("change:isEmpty", function (t, n, o) {
            o && (e.selectedColor = null);
          }), e;
        }
      }, {
        key: "_addColorToDocumentColors",
        value: function _addColorToDocumentColors(t) {
          var e = this.colorDefinitions.find(function (e) {
            return e.color === t;
          });
          e ? this.documentColors.add(Object.assign({}, e)) : this.documentColors.add({
            color: t,
            label: t,
            options: {
              hasBorder: !1
            }
          });
        }
      }]);
      return gp;
    }(ed);
    var mp = "fontSize",
      pp = "fontFamily",
      fp = "fontColor";
    function kp(t, e) {
      var n = {
        model: {
          key: t,
          values: []
        },
        view: {},
        upcastAlso: {}
      };
      var _iterator341 = _createForOfIteratorHelper(e),
        _step341;
      try {
        for (_iterator341.s(); !(_step341 = _iterator341.n()).done;) {
          var _t273 = _step341.value;
          n.model.values.push(_t273.model), n.view[_t273.model] = _t273.view, _t273.upcastAlso && (n.upcastAlso[_t273.model] = _t273.upcastAlso);
        }
      } catch (err) {
        _iterator341.e(err);
      } finally {
        _iterator341.f();
      }
      return n;
    }
    function bp(t) {
      return function (e, _ref51) {
        var n = _ref51.writer;
        return n.createAttributeElement("span", {
          style: "".concat(t, ":").concat(e)
        }, {
          priority: 7
        });
      };
    }
    var wp = /*#__PURE__*/function (_lp) {
      _inherits(wp, _lp);
      function wp(t) {
        _classCallCheck(this, wp);
        return _possibleConstructorReturn(this, _getPrototypeOf(wp).call(this, t, fp));
      }
      return wp;
    }(lp);
    var Cp = /*#__PURE__*/function (_Jt26) {
      _inherits(Cp, _Jt26);
      _createClass(Cp, null, [{
        key: "pluginName",
        get: function get() {
          return "FontColorEditing";
        }
      }]);
      function Cp(t) {
        var _this205;
        _classCallCheck(this, Cp);
        var e;
        _this205 = _possibleConstructorReturn(this, _getPrototypeOf(Cp).call(this, t)), t.config.define(fp, {
          colors: [{
            color: "hsl(0, 0%, 0%)",
            label: "Black"
          }, {
            color: "hsl(0, 0%, 30%)",
            label: "Dim grey"
          }, {
            color: "hsl(0, 0%, 60%)",
            label: "Grey"
          }, {
            color: "hsl(0, 0%, 90%)",
            label: "Light grey"
          }, {
            color: "hsl(0, 0%, 100%)",
            label: "White",
            hasBorder: !0
          }, {
            color: "hsl(0, 75%, 60%)",
            label: "Red"
          }, {
            color: "hsl(30, 75%, 60%)",
            label: "Orange"
          }, {
            color: "hsl(60, 75%, 60%)",
            label: "Yellow"
          }, {
            color: "hsl(90, 75%, 60%)",
            label: "Light green"
          }, {
            color: "hsl(120, 75%, 60%)",
            label: "Green"
          }, {
            color: "hsl(150, 75%, 60%)",
            label: "Aquamarine"
          }, {
            color: "hsl(180, 75%, 60%)",
            label: "Turquoise"
          }, {
            color: "hsl(210, 75%, 60%)",
            label: "Light blue"
          }, {
            color: "hsl(240, 75%, 60%)",
            label: "Blue"
          }, {
            color: "hsl(270, 75%, 60%)",
            label: "Purple"
          }],
          columns: 5
        }), t.conversion.for("upcast").elementToAttribute({
          view: {
            name: "span",
            styles: {
              color: /[\s\S]+/
            }
          },
          model: {
            key: fp,
            value: (e = "color", function (t) {
              return t.getStyle(e).replace(/\s/g, "");
            })
          }
        }), t.conversion.for("upcast").elementToAttribute({
          view: {
            name: "font",
            attributes: {
              color: /^#?\w+$/
            }
          },
          model: {
            key: fp,
            value: function value(t) {
              return t.getAttribute("color");
            }
          }
        }), t.conversion.for("downcast").attributeToElement({
          model: fp,
          view: bp("color")
        }), t.commands.add(fp, new wp(t)), t.model.schema.extend("$text", {
          allowAttributes: fp
        }), t.model.schema.setAttributeProperties(fp, {
          isFormatting: !0,
          copyOnEnter: !0
        });
        return _this205;
      }
      return Cp;
    }(Jt);
    var Ap = /*#__PURE__*/function (_Jt27) {
      _inherits(Ap, _Jt27);
      function Ap(t, _ref52) {
        var _this206;
        var e = _ref52.commandName,
          n = _ref52.icon,
          o = _ref52.componentName,
          i = _ref52.dropdownLabel;
        _classCallCheck(this, Ap);
        _this206 = _possibleConstructorReturn(this, _getPrototypeOf(Ap).call(this, t)), _this206.commandName = e, _this206.componentName = o, _this206.icon = n, _this206.dropdownLabel = i, _this206.columns = t.config.get("".concat(_this206.componentName, ".columns")), _this206.colorTableView = void 0;
        return _this206;
      }
      _createClass(Ap, [{
        key: "init",
        value: function init() {
          var _this207 = this;
          var t = this.editor,
            e = t.locale,
            n = e.t,
            o = t.commands.get(this.commandName);
          var i = function (t, e) {
              var n = t.t,
                o = {
                  Black: n("Black"),
                  "Dim grey": n("Dim grey"),
                  Grey: n("Grey"),
                  "Light grey": n("Light grey"),
                  White: n("White"),
                  Red: n("Red"),
                  Orange: n("Orange"),
                  Yellow: n("Yellow"),
                  "Light green": n("Light green"),
                  Green: n("Green"),
                  Aquamarine: n("Aquamarine"),
                  Turquoise: n("Turquoise"),
                  "Light blue": n("Light blue"),
                  Blue: n("Blue"),
                  Purple: n("Purple")
                };
              return e.map(function (t) {
                var e = o[t.label];
                return e && e != t.label && (t.label = e), t;
              });
            }(e, t.config.get(this.componentName).colors.map(zd).filter(function (t) {
              return !!t;
            })),
            r = t.config.get("".concat(this.componentName, ".documentColors"));
          t.ui.componentFactory.add(this.componentName, function (e) {
            var s = wh(e);
            return _this207.colorTableView = function (_ref53) {
              var t = _ref53.dropdownView,
                e = _ref53.colors,
                n = _ref53.columns,
                o = _ref53.removeButtonLabel,
                i = _ref53.documentColorsLabel,
                r = _ref53.documentColorsCount;
              var s = t.locale,
                a = new gp(s, {
                  colors: e,
                  columns: n,
                  removeButtonLabel: o,
                  documentColorsLabel: i,
                  documentColorsCount: r
                });
              return t.colorTableView = a, t.panelView.children.add(a), a.delegate("execute").to(t, "execute"), a;
            }({
              dropdownView: s,
              colors: i.map(function (t) {
                return {
                  label: t.label,
                  color: t.model,
                  options: {
                    hasBorder: t.hasBorder
                  }
                };
              }),
              columns: _this207.columns,
              removeButtonLabel: n("Remove color"),
              documentColorsLabel: 0 !== r ? n("Document colors") : void 0,
              documentColorsCount: void 0 === r ? _this207.columns : r
            }), _this207.colorTableView.bind("selectedColor").to(o, "value"), s.buttonView.set({
              label: _this207.dropdownLabel,
              icon: _this207.icon,
              tooltip: !0
            }), s.extendTemplate({
              attributes: {
                class: "ck-color-ui-dropdown"
              }
            }), s.bind("isEnabled").to(o), s.on("execute", function (e, n) {
              t.execute(_this207.commandName, n), t.editing.view.focus();
            }), s.on("change:isOpen", function (e, n, o) {
              s.colorTableView.appendGrids(), o && (0 !== r && _this207.colorTableView.updateDocumentColors(t.model, _this207.componentName), _this207.colorTableView.updateSelectedColors());
            }), s;
          });
        }
      }]);
      return Ap;
    }(Jt);
    var _p = /*#__PURE__*/function (_Ap) {
      _inherits(_p, _Ap);
      function _p(t) {
        _classCallCheck(this, _p);
        var e = t.locale.t;
        return _possibleConstructorReturn(this, _getPrototypeOf(_p).call(this, t, {
          commandName: fp,
          componentName: fp,
          icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M12.4 10.3 10 4.5l-2.4 5.8h4.8zm.5 1.2H7.1L5.7 15H4.2l5-12h1.6l5 12h-1.5L13 11.5zm3.1 7H4a1 1 0 0 1 0-2h12a1 1 0 0 1 0 2z"/></svg>',
          dropdownLabel: e("Font Color")
        }));
      }
      _createClass(_p, null, [{
        key: "pluginName",
        get: function get() {
          return "FontColorUI";
        }
      }]);
      return _p;
    }(Ap);
    var vp = /*#__PURE__*/function (_lp2) {
      _inherits(vp, _lp2);
      function vp(t) {
        _classCallCheck(this, vp);
        return _possibleConstructorReturn(this, _getPrototypeOf(vp).call(this, t, pp));
      }
      return vp;
    }(lp);
    function yp(t) {
      return t.map(xp).filter(function (t) {
        return !!t;
      });
    }
    function xp(t) {
      return "object" == typeof t ? t : "default" === t ? {
        title: "Default",
        model: void 0
      } : "string" == typeof t ? function (t) {
        var e = t.replace(/"|'/g, "").split(","),
          n = e[0],
          o = e.map(Ep).join(", ");
        return {
          title: n,
          model: o,
          view: {
            name: "span",
            styles: {
              "font-family": o
            },
            priority: 7
          }
        };
      }(t) : void 0;
    }
    function Ep(t) {
      return (t = t.trim()).indexOf(" ") > 0 && (t = "'".concat(t, "'")), t;
    }
    var Dp = /*#__PURE__*/function (_Jt28) {
      _inherits(Dp, _Jt28);
      _createClass(Dp, null, [{
        key: "pluginName",
        get: function get() {
          return "FontFamilyEditing";
        }
      }]);
      function Dp(t) {
        var _this208;
        _classCallCheck(this, Dp);
        _this208 = _possibleConstructorReturn(this, _getPrototypeOf(Dp).call(this, t)), t.config.define(pp, {
          options: ["default", "Arial, Helvetica, sans-serif", "Courier New, Courier, monospace", "Georgia, serif", "Lucida Sans Unicode, Lucida Grande, sans-serif", "Tahoma, Geneva, sans-serif", "Times New Roman, Times, serif", "Trebuchet MS, Helvetica, sans-serif", "Verdana, Geneva, sans-serif"],
          supportAllValues: !1
        });
        return _this208;
      }
      _createClass(Dp, [{
        key: "init",
        value: function init() {
          var t = this.editor;
          t.model.schema.extend("$text", {
            allowAttributes: pp
          }), t.model.schema.setAttributeProperties(pp, {
            isFormatting: !0,
            copyOnEnter: !0
          });
          var e = yp(t.config.get("fontFamily.options")).filter(function (t) {
              return t.model;
            }),
            n = kp(pp, e);
          t.config.get("fontFamily.supportAllValues") ? (this._prepareAnyValueConverters(), this._prepareCompatibilityConverter()) : t.conversion.attributeToElement(n), t.commands.add(pp, new vp(t));
        }
      }, {
        key: "_prepareAnyValueConverters",
        value: function _prepareAnyValueConverters() {
          var t = this.editor;
          t.conversion.for("downcast").attributeToElement({
            model: pp,
            view: function view(t, _ref54) {
              var e = _ref54.writer;
              return e.createAttributeElement("span", {
                style: "font-family:" + t
              }, {
                priority: 7
              });
            }
          }), t.conversion.for("upcast").elementToAttribute({
            model: {
              key: pp,
              value: function value(t) {
                return t.getStyle("font-family");
              }
            },
            view: {
              name: "span",
              styles: {
                "font-family": /.*/
              }
            }
          });
        }
      }, {
        key: "_prepareCompatibilityConverter",
        value: function _prepareCompatibilityConverter() {
          this.editor.conversion.for("upcast").elementToAttribute({
            view: {
              name: "font",
              attributes: {
                face: /.*/
              }
            },
            model: {
              key: pp,
              value: function value(t) {
                return t.getAttribute("face");
              }
            }
          });
        }
      }]);
      return Dp;
    }(Jt);
    var Mp = /*#__PURE__*/function (_Jt29) {
      _inherits(Mp, _Jt29);
      function Mp() {
        _classCallCheck(this, Mp);
        return _possibleConstructorReturn(this, _getPrototypeOf(Mp).apply(this, arguments));
      }
      _createClass(Mp, [{
        key: "init",
        value: function init() {
          var _this209 = this;
          var t = this.editor,
            e = t.t,
            n = this._getLocalizedOptions(),
            o = t.commands.get(pp);
          t.ui.componentFactory.add(pp, function (i) {
            var r = wh(i);
            return Ah(r, function (t, e) {
              var n = new co();
              var _iterator342 = _createForOfIteratorHelper(t),
                _step342;
              try {
                var _loop6 = function _loop6() {
                  var o = _step342.value;
                  var t = {
                    type: "button",
                    model: new Vh({
                      commandName: pp,
                      commandParam: o.model,
                      label: o.title,
                      withText: !0
                    })
                  };
                  t.model.bind("isOn").to(e, "value", function (t) {
                    return t === o.model || !(!t || !o.model) && t.split(",")[0].replace(/'/g, "").toLowerCase() === o.model.toLowerCase();
                  }), o.view && o.view.styles && t.model.set("labelStyle", "font-family: ".concat(o.view.styles["font-family"])), n.add(t);
                };
                for (_iterator342.s(); !(_step342 = _iterator342.n()).done;) {
                  _loop6();
                }
              } catch (err) {
                _iterator342.e(err);
              } finally {
                _iterator342.f();
              }
              return n;
            }(n, o)), r.buttonView.set({
              label: e("Font Family"),
              icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.03 3h6.149a.75.75 0 1 1 0 1.5h-5.514L11.03 3zm1.27 3h4.879a.75.75 0 1 1 0 1.5h-4.244L12.3 6zm1.27 3h3.609a.75.75 0 1 1 0 1.5h-2.973L13.57 9zm-2.754 2.5L8.038 4.785 5.261 11.5h5.555zm.62 1.5H4.641l-1.666 4.028H1.312l5.789-14h1.875l5.789 14h-1.663L11.436 13z"/></svg>',
              tooltip: !0
            }), r.extendTemplate({
              attributes: {
                class: "ck-font-family-dropdown"
              }
            }), r.bind("isEnabled").to(o), _this209.listenTo(r, "execute", function (e) {
              t.execute(e.source.commandName, {
                value: e.source.commandParam
              }), t.editing.view.focus();
            }), r;
          });
        }
      }, {
        key: "_getLocalizedOptions",
        value: function _getLocalizedOptions() {
          var t = this.editor,
            e = t.t;
          return yp(t.config.get(pp).options).map(function (t) {
            return "Default" === t.title && (t.title = e("Default")), t;
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "FontFamilyUI";
        }
      }]);
      return Mp;
    }(Jt);
    var Ip = /*#__PURE__*/function (_lp3) {
      _inherits(Ip, _lp3);
      function Ip(t) {
        _classCallCheck(this, Ip);
        return _possibleConstructorReturn(this, _getPrototypeOf(Ip).call(this, t, mp));
      }
      return Ip;
    }(lp);
    function Tp(t) {
      return t.map(function (t) {
        return function (t) {
          if (e = t, "object" == typeof e && e.title && e.model && e.view) return Np(t);
          var e;
          var n = function (t) {
            return Sp[t] || Sp[t.model];
          }(t);
          if (n) return Np(n);
          if ("default" === t) return {
            model: void 0,
            title: "Default"
          };
          if (function (t) {
            var e;
            if ("object" == typeof t) {
              if (!t.model) throw new c.a("font-size-invalid-definition", null, t);
              e = parseFloat(t.model);
            } else e = parseFloat(t);
            return isNaN(e);
          }(t)) return;
          return function (t) {
            "number" != typeof t && "string" != typeof t || (t = {
              title: String(t),
              model: "".concat(parseFloat(t), "px")
            });
            return t.view = {
              name: "span",
              styles: {
                "font-size": t.model
              }
            }, Np(t);
          }(t);
        }(t);
      }).filter(function (t) {
        return !!t;
      });
    }
    var Sp = {
      get tiny() {
        return {
          title: "Tiny",
          model: "tiny",
          view: {
            name: "span",
            classes: "text-tiny",
            priority: 7
          }
        };
      },
      get small() {
        return {
          title: "Small",
          model: "small",
          view: {
            name: "span",
            classes: "text-small",
            priority: 7
          }
        };
      },
      get big() {
        return {
          title: "Big",
          model: "big",
          view: {
            name: "span",
            classes: "text-big",
            priority: 7
          }
        };
      },
      get huge() {
        return {
          title: "Huge",
          model: "huge",
          view: {
            name: "span",
            classes: "text-huge",
            priority: 7
          }
        };
      }
    };
    function Np(t) {
      return t.view.priority || (t.view.priority = 7), t;
    }
    var Bp = ["x-small", "x-small", "small", "medium", "large", "x-large", "xx-large", "xxx-large"];
    var Pp = /*#__PURE__*/function (_Jt30) {
      _inherits(Pp, _Jt30);
      _createClass(Pp, null, [{
        key: "pluginName",
        get: function get() {
          return "FontSizeEditing";
        }
      }]);
      function Pp(t) {
        var _this210;
        _classCallCheck(this, Pp);
        _this210 = _possibleConstructorReturn(this, _getPrototypeOf(Pp).call(this, t)), t.config.define(mp, {
          options: ["tiny", "small", "default", "big", "huge"],
          supportAllValues: !1
        });
        return _this210;
      }
      _createClass(Pp, [{
        key: "init",
        value: function init() {
          var t = this.editor;
          t.model.schema.extend("$text", {
            allowAttributes: mp
          }), t.model.schema.setAttributeProperties(mp, {
            isFormatting: !0,
            copyOnEnter: !0
          });
          var e = t.config.get("fontSize.supportAllValues"),
            n = Tp(this.editor.config.get("fontSize.options")).filter(function (t) {
              return t.model;
            }),
            o = kp(mp, n);
          e ? (this._prepareAnyValueConverters(o), this._prepareCompatibilityConverter()) : t.conversion.attributeToElement(o), t.commands.add(mp, new Ip(t));
        }
      }, {
        key: "_prepareAnyValueConverters",
        value: function _prepareAnyValueConverters(t) {
          var e = this.editor,
            n = t.model.values.filter(function (t) {
              return !Bu(String(t)) && (e = String(t), !Pu.test(e));
              var e;
            });
          if (n.length) throw new c.a("font-size-invalid-use-of-named-presets", null, {
            presets: n
          });
          e.conversion.for("downcast").attributeToElement({
            model: mp,
            view: function view(t, _ref55) {
              var e = _ref55.writer;
              if (t) return e.createAttributeElement("span", {
                style: "font-size:" + t
              }, {
                priority: 7
              });
            }
          }), e.conversion.for("upcast").elementToAttribute({
            model: {
              key: mp,
              value: function value(t) {
                return t.getStyle("font-size");
              }
            },
            view: {
              name: "span",
              styles: {
                "font-size": /.*/
              }
            }
          });
        }
      }, {
        key: "_prepareCompatibilityConverter",
        value: function _prepareCompatibilityConverter() {
          this.editor.conversion.for("upcast").elementToAttribute({
            view: {
              name: "font",
              attributes: {
                size: /^[+-]?\d{1,3}$/
              }
            },
            model: {
              key: mp,
              value: function value(t) {
                var e = t.getAttribute("size"),
                  n = "-" === e[0] || "+" === e[0];
                var o = parseInt(e, 10);
                n && (o = 3 + o);
                var i = Bp.length - 1,
                  r = Math.min(Math.max(o, 0), i);
                return Bp[r];
              }
            }
          });
        }
      }]);
      return Pp;
    }(Jt);
    var zp = n(41),
      Lp = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Zl()(zp.a, Lp), zp.a.locals;
    var Op = /*#__PURE__*/function (_Jt31) {
      _inherits(Op, _Jt31);
      function Op() {
        _classCallCheck(this, Op);
        return _possibleConstructorReturn(this, _getPrototypeOf(Op).apply(this, arguments));
      }
      _createClass(Op, [{
        key: "init",
        value: function init() {
          var _this211 = this;
          var t = this.editor,
            e = t.t,
            n = this._getLocalizedOptions(),
            o = t.commands.get(mp);
          t.ui.componentFactory.add(mp, function (i) {
            var r = wh(i);
            return Ah(r, function (t, e) {
              var n = new co();
              var _iterator343 = _createForOfIteratorHelper(t),
                _step343;
              try {
                var _loop7 = function _loop7() {
                  var o = _step343.value;
                  var t = {
                    type: "button",
                    model: new Vh({
                      commandName: mp,
                      commandParam: o.model,
                      label: o.title,
                      class: "ck-fontsize-option",
                      withText: !0
                    })
                  };
                  o.view && o.view.styles && t.model.set("labelStyle", "font-size:".concat(o.view.styles["font-size"])), o.view && o.view.classes && t.model.set("class", "".concat(t.model.class, " ").concat(o.view.classes)), t.model.bind("isOn").to(e, "value", function (t) {
                    return t === o.model;
                  }), n.add(t);
                };
                for (_iterator343.s(); !(_step343 = _iterator343.n()).done;) {
                  _loop7();
                }
              } catch (err) {
                _iterator343.e(err);
              } finally {
                _iterator343.f();
              }
              return n;
            }(n, o)), r.buttonView.set({
              label: e("Font Size"),
              icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M9.816 11.5 7.038 4.785 4.261 11.5h5.555zm.62 1.5H3.641l-1.666 4.028H.312l5.789-14h1.875l5.789 14h-1.663L10.436 13zm7.55 2.279.779-.779.707.707-2.265 2.265-2.193-2.265.707-.707.765.765V4.825c0-.042 0-.083.002-.123l-.77.77-.707-.707L17.207 2.5l2.265 2.265-.707.707-.782-.782c.002.043.003.089.003.135v10.454z"/></svg>',
              tooltip: !0
            }), r.extendTemplate({
              attributes: {
                class: ["ck-font-size-dropdown"]
              }
            }), r.bind("isEnabled").to(o), _this211.listenTo(r, "execute", function (e) {
              t.execute(e.source.commandName, {
                value: e.source.commandParam
              }), t.editing.view.focus();
            }), r;
          });
        }
      }, {
        key: "_getLocalizedOptions",
        value: function _getLocalizedOptions() {
          var t = this.editor,
            e = t.t,
            n = {
              Default: e("Default"),
              Tiny: e("Tiny"),
              Small: e("Small"),
              Big: e("Big"),
              Huge: e("Huge")
            };
          return Tp(t.config.get(mp).options).map(function (t) {
            var e = n[t.title];
            return e && e != t.title && (t = Object.assign({}, t, {
              title: e
            })), t;
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "FontSizeUI";
        }
      }]);
      return Op;
    }(Jt);
    var Rp = /*#__PURE__*/function (_Xt12) {
      _inherits(Rp, _Xt12);
      function Rp() {
        _classCallCheck(this, Rp);
        return _possibleConstructorReturn(this, _getPrototypeOf(Rp).apply(this, arguments));
      }
      _createClass(Rp, [{
        key: "refresh",
        value: function refresh() {
          var t = this.editor.model,
            e = Ks(t.document.selection.getSelectedBlocks());
          this.value = !!e && e.is("element", "paragraph"), this.isEnabled = !!e && jp(e, t.schema);
        }
      }, {
        key: "execute",
        value: function execute() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var e = this.editor.model,
            n = e.document;
          e.change(function (o) {
            var i = (t.selection || n.selection).getSelectedBlocks();
            var _iterator344 = _createForOfIteratorHelper(i),
              _step344;
            try {
              for (_iterator344.s(); !(_step344 = _iterator344.n()).done;) {
                var _t274 = _step344.value;
                !_t274.is("element", "paragraph") && jp(_t274, e.schema) && o.rename(_t274, "paragraph");
              }
            } catch (err) {
              _iterator344.e(err);
            } finally {
              _iterator344.f();
            }
          });
        }
      }]);
      return Rp;
    }(Xt);
    function jp(t, e) {
      return e.checkChild(t.parent, "paragraph") && !e.isObject(t);
    }
    var Fp = /*#__PURE__*/function (_Xt13) {
      _inherits(Fp, _Xt13);
      function Fp() {
        _classCallCheck(this, Fp);
        return _possibleConstructorReturn(this, _getPrototypeOf(Fp).apply(this, arguments));
      }
      _createClass(Fp, [{
        key: "execute",
        value: function execute(t) {
          var e = this.editor.model;
          var n = t.position;
          e.change(function (t) {
            var o = t.createElement("paragraph");
            if (!e.schema.checkChild(n.parent, o)) {
              var _i130 = e.schema.findAllowedParent(n, o);
              if (!_i130) return;
              n = t.split(n, _i130).position;
            }
            e.insertContent(o, n), t.setSelection(o, "in");
          });
        }
      }]);
      return Fp;
    }(Xt);
    var Vp = /*#__PURE__*/function (_Jt32) {
      _inherits(Vp, _Jt32);
      function Vp() {
        _classCallCheck(this, Vp);
        return _possibleConstructorReturn(this, _getPrototypeOf(Vp).apply(this, arguments));
      }
      _createClass(Vp, [{
        key: "init",
        value: function init() {
          var t = this.editor,
            e = t.model;
          t.commands.add("paragraph", new Rp(t)), t.commands.add("insertParagraph", new Fp(t)), e.schema.register("paragraph", {
            inheritAllFrom: "$block"
          }), t.conversion.elementToElement({
            model: "paragraph",
            view: "p"
          }), t.conversion.for("upcast").elementToElement({
            model: function model(t, _ref56) {
              var e = _ref56.writer;
              return Vp.paragraphLikeElements.has(t.name) ? t.isEmpty ? null : e.createElement("paragraph") : null;
            },
            view: /.+/,
            converterPriority: "low"
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "Paragraph";
        }
      }]);
      return Vp;
    }(Jt);
    Vp.paragraphLikeElements = new Set(["blockquote", "dd", "div", "dt", "h1", "h2", "h3", "h4", "h5", "h6", "li", "p", "td", "th"]);
    var Up = /*#__PURE__*/function (_Xt14) {
      _inherits(Up, _Xt14);
      function Up(t, e) {
        var _this212;
        _classCallCheck(this, Up);
        _this212 = _possibleConstructorReturn(this, _getPrototypeOf(Up).call(this, t)), _this212.modelElements = e;
        return _this212;
      }
      _createClass(Up, [{
        key: "refresh",
        value: function refresh() {
          var _this213 = this;
          var t = Ks(this.editor.model.document.selection.getSelectedBlocks());
          this.value = !!t && this.modelElements.includes(t.name) && t.name, this.isEnabled = !!t && this.modelElements.some(function (e) {
            return Hp(t, e, _this213.editor.model.schema);
          });
        }
      }, {
        key: "execute",
        value: function execute(t) {
          var e = this.editor.model,
            n = e.document,
            o = t.value;
          e.change(function (t) {
            var i = Array.from(n.selection.getSelectedBlocks()).filter(function (t) {
              return Hp(t, o, e.schema);
            });
            var _iterator345 = _createForOfIteratorHelper(i),
              _step345;
            try {
              for (_iterator345.s(); !(_step345 = _iterator345.n()).done;) {
                var _e257 = _step345.value;
                _e257.is("element", o) || t.rename(_e257, o);
              }
            } catch (err) {
              _iterator345.e(err);
            } finally {
              _iterator345.f();
            }
          });
        }
      }]);
      return Up;
    }(Xt);
    function Hp(t, e, n) {
      return n.checkChild(t.parent, e) && !n.isObject(t);
    }
    var Gp = "paragraph";
    var Wp = /*#__PURE__*/function (_Jt33) {
      _inherits(Wp, _Jt33);
      _createClass(Wp, null, [{
        key: "pluginName",
        get: function get() {
          return "HeadingEditing";
        }
      }]);
      function Wp(t) {
        var _this214;
        _classCallCheck(this, Wp);
        _this214 = _possibleConstructorReturn(this, _getPrototypeOf(Wp).call(this, t)), t.config.define("heading", {
          options: [{
            model: "paragraph",
            title: "Paragraph",
            class: "ck-heading_paragraph"
          }, {
            model: "heading1",
            view: "h2",
            title: "Heading 1",
            class: "ck-heading_heading1"
          }, {
            model: "heading2",
            view: "h3",
            title: "Heading 2",
            class: "ck-heading_heading2"
          }, {
            model: "heading3",
            view: "h4",
            title: "Heading 3",
            class: "ck-heading_heading3"
          }]
        });
        return _this214;
      }
      _createClass(Wp, [{
        key: "init",
        value: function init() {
          var t = this.editor,
            e = t.config.get("heading.options"),
            n = [];
          var _iterator346 = _createForOfIteratorHelper(e),
            _step346;
          try {
            for (_iterator346.s(); !(_step346 = _iterator346.n()).done;) {
              var _o161 = _step346.value;
              _o161.model !== Gp && (t.model.schema.register(_o161.model, {
                inheritAllFrom: "$block"
              }), t.conversion.elementToElement(_o161), n.push(_o161.model));
            }
          } catch (err) {
            _iterator346.e(err);
          } finally {
            _iterator346.f();
          }
          this._addDefaultH1Conversion(t), t.commands.add("heading", new Up(t, n));
        }
      }, {
        key: "afterInit",
        value: function afterInit() {
          var t = this.editor,
            e = t.commands.get("enter"),
            n = t.config.get("heading.options");
          e && this.listenTo(e, "afterExecute", function (e, o) {
            var i = t.model.document.selection.getFirstPosition().parent;
            n.some(function (t) {
              return i.is("element", t.model);
            }) && !i.is("element", Gp) && 0 === i.childCount && o.writer.rename(i, Gp);
          });
        }
      }, {
        key: "_addDefaultH1Conversion",
        value: function _addDefaultH1Conversion(t) {
          t.conversion.for("upcast").elementToElement({
            model: "heading1",
            view: "h1",
            converterPriority: a.get("low") + 1
          });
        }
      }], [{
        key: "requires",
        get: function get() {
          return [Vp];
        }
      }]);
      return Wp;
    }(Jt);
    var qp = n(42),
      Kp = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Zl()(qp.a, Kp), qp.a.locals;
    var Yp = /*#__PURE__*/function (_Jt34) {
      _inherits(Yp, _Jt34);
      function Yp() {
        _classCallCheck(this, Yp);
        return _possibleConstructorReturn(this, _getPrototypeOf(Yp).apply(this, arguments));
      }
      _createClass(Yp, [{
        key: "init",
        value: function init() {
          var _this215 = this;
          var t = this.editor,
            e = t.t,
            n = function (t) {
              var e = t.t,
                n = {
                  Paragraph: e("Paragraph"),
                  "Heading 1": e("Heading 1"),
                  "Heading 2": e("Heading 2"),
                  "Heading 3": e("Heading 3"),
                  "Heading 4": e("Heading 4"),
                  "Heading 5": e("Heading 5"),
                  "Heading 6": e("Heading 6")
                };
              return t.config.get("heading.options").map(function (t) {
                var e = n[t.title];
                return e && e != t.title && (t.title = e), t;
              });
            }(t),
            o = e("Choose heading"),
            i = e("Heading");
          t.ui.componentFactory.add("heading", function (e) {
            var r = {},
              s = new co(),
              a = t.commands.get("heading"),
              c = t.commands.get("paragraph"),
              l = [a];
            var _iterator347 = _createForOfIteratorHelper(n),
              _step347;
            try {
              var _loop8 = function _loop8() {
                var t = _step347.value;
                var e = {
                  type: "button",
                  model: new Vh({
                    label: t.title,
                    class: t.class,
                    withText: !0
                  })
                };
                "paragraph" === t.model ? (e.model.bind("isOn").to(c, "value"), e.model.set("commandName", "paragraph"), l.push(c)) : (e.model.bind("isOn").to(a, "value", function (e) {
                  return e === t.model;
                }), e.model.set({
                  commandName: "heading",
                  commandValue: t.model
                })), s.add(e), r[t.model] = t.title;
              };
              for (_iterator347.s(); !(_step347 = _iterator347.n()).done;) {
                _loop8();
              }
            } catch (err) {
              _iterator347.e(err);
            } finally {
              _iterator347.f();
            }
            var d = wh(e);
            return Ah(d, s), d.buttonView.set({
              isOn: !1,
              withText: !0,
              tooltip: i
            }), d.extendTemplate({
              attributes: {
                class: ["ck-heading-dropdown"]
              }
            }), d.bind("isEnabled").toMany(l, "isEnabled", function () {
              for (var _len24 = arguments.length, t = new Array(_len24), _key24 = 0; _key24 < _len24; _key24++) {
                t[_key24] = arguments[_key24];
              }
              return t.some(function (t) {
                return t;
              });
            }), d.buttonView.bind("label").to(a, "value", c, "value", function (t, e) {
              var n = t || e && "paragraph";
              return r[n] ? r[n] : o;
            }), _this215.listenTo(d, "execute", function (e) {
              t.execute(e.source.commandName, e.source.commandValue ? {
                value: e.source.commandValue
              } : void 0), t.editing.view.focus();
            }), d;
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "HeadingUI";
        }
      }]);
      return Yp;
    }(Jt);
    var Qp = /*#__PURE__*/function (_Jt35) {
      _inherits(Qp, _Jt35);
      function Qp() {
        _classCallCheck(this, Qp);
        return _possibleConstructorReturn(this, _getPrototypeOf(Qp).apply(this, arguments));
      }
      _createClass(Qp, [{
        key: "init",
        value: function init() {
          var _this216 = this;
          var t = this.editor;
          if (t.plugins.has("BalloonToolbar")) {
            var _e258 = t.plugins.get("BalloonToolbar");
            this.listenTo(_e258, "show", function (e) {
              (function (t) {
                var e = t.getSelectedElement();
                return !(!e || !hm(e));
              })(t.editing.view.document.selection) && e.stop();
            }, {
              priority: "high"
            });
          }
          this._toolbarDefinitions = new Map(), this._balloon = this.editor.plugins.get("ContextualBalloon"), this.on("change:isEnabled", function () {
            _this216._updateToolbarsVisibility();
          }), this.listenTo(t.ui, "update", function () {
            _this216._updateToolbarsVisibility();
          }), this.listenTo(t.ui.focusTracker, "change:isFocused", function () {
            _this216._updateToolbarsVisibility();
          }, {
            priority: "low"
          });
        }
      }, {
        key: "destroy",
        value: function destroy() {
          _get(_getPrototypeOf(Qp.prototype), "destroy", this).call(this);
          var _iterator348 = _createForOfIteratorHelper(this._toolbarDefinitions.values()),
            _step348;
          try {
            for (_iterator348.s(); !(_step348 = _iterator348.n()).done;) {
              var _t275 = _step348.value;
              _t275.view.destroy();
            }
          } catch (err) {
            _iterator348.e(err);
          } finally {
            _iterator348.f();
          }
        }
      }, {
        key: "register",
        value: function register(t, _ref57) {
          var e = _ref57.ariaLabel,
            n = _ref57.items,
            o = _ref57.getRelatedElement,
            _ref57$balloonClassNa = _ref57.balloonClassName,
            i = _ref57$balloonClassNa === void 0 ? "ck-toolbar-container" : _ref57$balloonClassNa;
          if (!n.length) return void Object(c.b)("widget-toolbar-no-items", {
            toolbarId: t
          });
          var r = this.editor,
            s = r.t,
            a = new sh(r.locale);
          if (a.ariaLabel = e || s("Widget toolbar"), this._toolbarDefinitions.has(t)) throw new c.a("widget-toolbar-duplicated", this, {
            toolbarId: t
          });
          a.fillFromConfig(n, r.ui.componentFactory), this._toolbarDefinitions.set(t, {
            view: a,
            getRelatedElement: o,
            balloonClassName: i
          });
        }
      }, {
        key: "_updateToolbarsVisibility",
        value: function _updateToolbarsVisibility() {
          var t = 0,
            e = null,
            n = null;
          var _iterator349 = _createForOfIteratorHelper(this._toolbarDefinitions.values()),
            _step349;
          try {
            for (_iterator349.s(); !(_step349 = _iterator349.n()).done;) {
              var _o162 = _step349.value;
              var _i131 = _o162.getRelatedElement(this.editor.editing.view.document.selection);
              if (this.isEnabled && _i131) {
                if (this.editor.ui.focusTracker.isFocused) {
                  var _r55 = _i131.getAncestors().length;
                  _r55 > t && (t = _r55, e = _i131, n = _o162);
                } else this._isToolbarVisible(_o162) && this._hideToolbar(_o162);
              } else this._isToolbarInBalloon(_o162) && this._hideToolbar(_o162);
            }
          } catch (err) {
            _iterator349.e(err);
          } finally {
            _iterator349.f();
          }
          n && this._showToolbar(n, e);
        }
      }, {
        key: "_hideToolbar",
        value: function _hideToolbar(t) {
          this._balloon.remove(t.view), this.stopListening(this._balloon, "change:visibleView");
        }
      }, {
        key: "_showToolbar",
        value: function _showToolbar(t, e) {
          var _this217 = this;
          this._isToolbarVisible(t) ? $p(this.editor, e) : this._isToolbarInBalloon(t) || (this._balloon.add({
            view: t.view,
            position: Jp(this.editor, e),
            balloonClassName: t.balloonClassName
          }), this.listenTo(this._balloon, "change:visibleView", function () {
            var _iterator350 = _createForOfIteratorHelper(_this217._toolbarDefinitions.values()),
              _step350;
            try {
              for (_iterator350.s(); !(_step350 = _iterator350.n()).done;) {
                var _t276 = _step350.value;
                if (_this217._isToolbarVisible(_t276)) {
                  var _e259 = _t276.getRelatedElement(_this217.editor.editing.view.document.selection);
                  $p(_this217.editor, _e259);
                }
              }
            } catch (err) {
              _iterator350.e(err);
            } finally {
              _iterator350.f();
            }
          }));
        }
      }, {
        key: "_isToolbarVisible",
        value: function _isToolbarVisible(t) {
          return this._balloon.visibleView === t.view;
        }
      }, {
        key: "_isToolbarInBalloon",
        value: function _isToolbarInBalloon(t) {
          return this._balloon.hasView(t.view);
        }
      }], [{
        key: "requires",
        get: function get() {
          return [eu];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "WidgetToolbarRepository";
        }
      }]);
      return Qp;
    }(Jt);
    function $p(t, e) {
      var n = t.plugins.get("ContextualBalloon"),
        o = Jp(t, e);
      n.updatePosition(o);
    }
    function Jp(t, e) {
      var n = t.editing.view,
        o = qh.defaultPositions;
      return {
        target: n.domConverter.mapViewToDom(e),
        positions: [o.northArrowSouth, o.northArrowSouthWest, o.northArrowSouthEast, o.southArrowNorth, o.southArrowNorthWest, o.southArrowNorthEast, wm]
      };
    }
    var Zp = /*#__PURE__*/function () {
      function Zp(t) {
        _classCallCheck(this, Zp);
        this.set("activeHandlePosition", null), this.set("proposedWidthPercents", null), this.set("proposedWidth", null), this.set("proposedHeight", null), this.set("proposedHandleHostWidth", null), this.set("proposedHandleHostHeight", null), this._options = t, this._referenceCoordinates = null;
      }
      _createClass(Zp, [{
        key: "begin",
        value: function begin(t, e, n) {
          var o = new Vs(e);
          this.activeHandlePosition = function (t) {
            var e = ["top-left", "top-right", "bottom-right", "bottom-left"];
            for (var _i132 = 0, _e260 = e; _i132 < _e260.length; _i132++) {
              var _n245 = _e260[_i132];
              if (t.classList.contains(Xp(_n245))) return _n245;
            }
          }(t), this._referenceCoordinates = function (t, e) {
            var n = new Vs(t),
              o = e.split("-"),
              i = {
                x: "right" == o[1] ? n.right : n.left,
                y: "bottom" == o[0] ? n.bottom : n.top
              };
            return i.x += t.ownerDocument.defaultView.scrollX, i.y += t.ownerDocument.defaultView.scrollY, i;
          }(e, function (t) {
            var e = t.split("-"),
              n = {
                top: "bottom",
                bottom: "top",
                left: "right",
                right: "left"
              };
            return "".concat(n[e[0]], "-").concat(n[e[1]]);
          }(this.activeHandlePosition)), this.originalWidth = o.width, this.originalHeight = o.height, this.aspectRatio = o.width / o.height;
          var i = n.style.width;
          i && i.match(/^\d+(\.\d*)?%$/) ? this.originalWidthPercents = parseFloat(i) : this.originalWidthPercents = function (t, e) {
            var n = t.parentElement,
              o = parseFloat(n.ownerDocument.defaultView.getComputedStyle(n).width);
            return e.width / o * 100;
          }(n, o);
        }
      }, {
        key: "update",
        value: function update(t) {
          this.proposedWidth = t.width, this.proposedHeight = t.height, this.proposedWidthPercents = t.widthPercents, this.proposedHandleHostWidth = t.handleHostWidth, this.proposedHandleHostHeight = t.handleHostHeight;
        }
      }]);
      return Zp;
    }();
    function Xp(t) {
      return "ck-widget__resizer__handle-".concat(t);
    }
    $t(Zp, Gt);
    var tf = /*#__PURE__*/function (_ed25) {
      _inherits(tf, _ed25);
      function tf() {
        var _this218;
        _classCallCheck(this, tf);
        _this218 = _possibleConstructorReturn(this, _getPrototypeOf(tf).call(this));
        var t = _this218.bindTemplate;
        _this218.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-size-view", t.to("_viewPosition", function (t) {
              return t ? "ck-orientation-".concat(t) : "";
            })],
            style: {
              display: t.if("_isVisible", "none", function (t) {
                return !t;
              })
            }
          },
          children: [{
            text: t.to("_label")
          }]
        });
        return _this218;
      }
      _createClass(tf, [{
        key: "_bindToState",
        value: function _bindToState(t, e) {
          this.bind("_isVisible").to(e, "proposedWidth", e, "proposedHeight", function (t, e) {
            return null !== t && null !== e;
          }), this.bind("_label").to(e, "proposedHandleHostWidth", e, "proposedHandleHostHeight", e, "proposedWidthPercents", function (e, n, o) {
            return "px" === t.unit ? "".concat(e, "\xD7").concat(n) : "".concat(o, "%");
          }), this.bind("_viewPosition").to(e, "activeHandlePosition", e, "proposedHandleHostWidth", e, "proposedHandleHostHeight", function (t, e, n) {
            return e < 50 || n < 50 ? "above-center" : t;
          });
        }
      }, {
        key: "_dismiss",
        value: function _dismiss() {
          this.unbind(), this._isVisible = !1;
        }
      }]);
      return tf;
    }(ed);
    var ef = /*#__PURE__*/function () {
      function ef(t) {
        var _this219 = this;
        _classCallCheck(this, ef);
        this._options = t, this._domResizerWrapper = null, this._viewResizerWrapper = null, this.set("isEnabled", !0), this.decorate("begin"), this.decorate("cancel"), this.decorate("commit"), this.decorate("updateSize"), this.on("commit", function (t) {
          _this219.state.proposedWidth || _this219.state.proposedWidthPercents || (_this219._cleanup(), t.stop());
        }, {
          priority: "high"
        }), this.on("change:isEnabled", function () {
          _this219.isEnabled && _this219.redraw();
        });
      }
      _createClass(ef, [{
        key: "attach",
        value: function attach() {
          var _this220 = this;
          var t = this,
            e = this._options.viewElement;
          this._options.editor.editing.view.change(function (n) {
            var o = n.createUIElement("div", {
              class: "ck ck-reset_all ck-widget__resizer"
            }, function (e) {
              var n = this.toDomElement(e);
              return t._appendHandles(n), t._appendSizeUI(n), t._domResizerWrapper = n, t.on("change:isEnabled", function (t, e, o) {
                n.style.display = o ? "" : "none";
              }), n.style.display = t.isEnabled ? "" : "none", n;
            });
            n.insert(n.createPositionAt(e, "end"), o), n.addClass("ck-widget_with-resizer", e), _this220._viewResizerWrapper = o;
          });
        }
      }, {
        key: "begin",
        value: function begin(t) {
          this.state = new Zp(this._options), this._sizeView._bindToState(this._options, this.state), this._initialViewWidth = this._options.viewElement.getStyle("width"), this.state.begin(t, this._getHandleHost(), this._getResizeHost());
        }
      }, {
        key: "updateSize",
        value: function updateSize(t) {
          var _this221 = this;
          var e = this._proposeNewSize(t);
          this._options.editor.editing.view.change(function (t) {
            var n = _this221._options.unit || "%",
              o = ("%" === n ? e.widthPercents : e.width) + n;
            t.setStyle("width", o, _this221._options.viewElement);
          });
          var n = this._getHandleHost(),
            o = new Vs(n);
          e.handleHostWidth = Math.round(o.width), e.handleHostHeight = Math.round(o.height);
          var i = new Vs(n);
          e.width = Math.round(i.width), e.height = Math.round(i.height), this.redraw(o), this.state.update(e);
        }
      }, {
        key: "commit",
        value: function commit() {
          var _this222 = this;
          var t = this._options.unit || "%",
            e = ("%" === t ? this.state.proposedWidthPercents : this.state.proposedWidth) + t;
          this._options.editor.editing.view.change(function () {
            _this222._cleanup(), _this222._options.onCommit(e);
          });
        }
      }, {
        key: "cancel",
        value: function cancel() {
          this._cleanup();
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.cancel();
        }
      }, {
        key: "redraw",
        value: function redraw(t) {
          var e = this._domResizerWrapper;
          if (!((n = e) && n.ownerDocument && n.ownerDocument.contains(n))) return;
          var n;
          var o = e.parentElement,
            i = this._getHandleHost(),
            r = this._viewResizerWrapper,
            s = [r.getStyle("width"), r.getStyle("height"), r.getStyle("left"), r.getStyle("top")];
          var a;
          if (o.isSameNode(i)) {
            var _e261 = t || new Vs(i);
            a = [_e261.width + "px", _e261.height + "px", void 0, void 0];
          } else a = [i.offsetWidth + "px", i.offsetHeight + "px", i.offsetLeft + "px", i.offsetTop + "px"];
          "same" !== bo(s, a) && this._options.editor.editing.view.change(function (t) {
            t.setStyle({
              width: a[0],
              height: a[1],
              left: a[2],
              top: a[3]
            }, r);
          });
        }
      }, {
        key: "containsHandle",
        value: function containsHandle(t) {
          return this._domResizerWrapper.contains(t);
        }
      }, {
        key: "_cleanup",
        value: function _cleanup() {
          var _this223 = this;
          this._sizeView._dismiss();
          this._options.editor.editing.view.change(function (t) {
            t.setStyle("width", _this223._initialViewWidth, _this223._options.viewElement);
          });
        }
      }, {
        key: "_proposeNewSize",
        value: function _proposeNewSize(t) {
          var e = this.state,
            n = {
              x: (o = t).pageX,
              y: o.pageY
            };
          var o;
          var i = !this._options.isCentered || this._options.isCentered(this),
            r = {
              x: e._referenceCoordinates.x - (n.x + e.originalWidth),
              y: n.y - e.originalHeight - e._referenceCoordinates.y
            };
          i && e.activeHandlePosition.endsWith("-right") && (r.x = n.x - (e._referenceCoordinates.x + e.originalWidth)), i && (r.x *= 2);
          var s = {
            width: Math.abs(e.originalWidth + r.x),
            height: Math.abs(e.originalHeight + r.y)
          };
          s.dominant = s.width / e.aspectRatio > s.height ? "width" : "height", s.max = s[s.dominant];
          var a = {
            width: s.width,
            height: s.height
          };
          return "width" == s.dominant ? a.height = a.width / e.aspectRatio : a.width = a.height * e.aspectRatio, {
            width: Math.round(a.width),
            height: Math.round(a.height),
            widthPercents: Math.min(Math.round(e.originalWidthPercents / e.originalWidth * a.width * 100) / 100, 100)
          };
        }
      }, {
        key: "_getResizeHost",
        value: function _getResizeHost() {
          var t = this._domResizerWrapper.parentElement;
          return this._options.getResizeHost(t);
        }
      }, {
        key: "_getHandleHost",
        value: function _getHandleHost() {
          var t = this._domResizerWrapper.parentElement;
          return this._options.getHandleHost(t);
        }
      }, {
        key: "_appendHandles",
        value: function _appendHandles(t) {
          var e = ["top-left", "top-right", "bottom-right", "bottom-left"];
          for (var _i133 = 0, _e262 = e; _i133 < _e262.length; _i133++) {
            var _o163 = _e262[_i133];
            t.appendChild(new nd({
              tag: "div",
              attributes: {
                class: "ck-widget__resizer__handle " + (n = _o163, "ck-widget__resizer__handle-".concat(n))
              }
            }).render());
          }
          var n;
        }
      }, {
        key: "_appendSizeUI",
        value: function _appendSizeUI(t) {
          this._sizeView = new tf(), this._sizeView.render(), t.appendChild(this._sizeView.element);
        }
      }], [{
        key: "isResizeHandle",
        value: function isResizeHandle(t) {
          return t.classList.contains("ck-widget__resizer__handle");
        }
      }]);
      return ef;
    }();
    $t(ef, Gt);
    var nf = n(43),
      of = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Zl()(nf.a, of), nf.a.locals;
    $t( /*#__PURE__*/function (_Jt36) {
      _inherits(_class2, _Jt36);
      function _class2() {
        _classCallCheck(this, _class2);
        return _possibleConstructorReturn(this, _getPrototypeOf(_class2).apply(this, arguments));
      }
      _createClass(_class2, [{
        key: "init",
        value: function init() {
          var _this224 = this;
          this.set("visibleResizer", null), this.set("_activeResizer", null), this._resizers = new Map();
          var t = Sr.window.document;
          this.editor.editing.view.addObserver(Tu), this._observer = Object.create(Ur), this.listenTo(this.editor.editing.view.document, "mousedown", this._mouseDownListener.bind(this), {
            priority: "high"
          }), this._observer.listenTo(t, "mousemove", this._mouseMoveListener.bind(this)), this._observer.listenTo(t, "mouseup", this._mouseUpListener.bind(this));
          var e = function e() {
            _this224.visibleResizer && _this224.visibleResizer.redraw();
          };
          this._redrawFocusedResizerThrottled = Om(e, 200), this.on("change:visibleResizer", e), this.editor.ui.on("update", this._redrawFocusedResizerThrottled), this._observer.listenTo(Sr.window, "resize", this._redrawFocusedResizerThrottled);
          var n = this.editor.editing.view.document.selection;
          n.on("change", function () {
            var t = n.getSelectedElement();
            _this224.visibleResizer = _this224.getResizerByViewElement(t) || null;
          });
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this._observer.stopListening();
          var _iterator351 = _createForOfIteratorHelper(this._resizers.values()),
            _step351;
          try {
            for (_iterator351.s(); !(_step351 = _iterator351.n()).done;) {
              var _t277 = _step351.value;
              _t277.destroy();
            }
          } catch (err) {
            _iterator351.e(err);
          } finally {
            _iterator351.f();
          }
          this._redrawFocusedResizerThrottled.cancel();
        }
      }, {
        key: "attachTo",
        value: function attachTo(t) {
          var e = new ef(t),
            n = this.editor.plugins;
          if (e.attach(), n.has("WidgetToolbarRepository")) {
            var _t278 = n.get("WidgetToolbarRepository");
            e.on("begin", function () {
              _t278.forceDisabled("resize");
            }, {
              priority: "lowest"
            }), e.on("cancel", function () {
              _t278.clearForceDisabled("resize");
            }, {
              priority: "highest"
            }), e.on("commit", function () {
              _t278.clearForceDisabled("resize");
            }, {
              priority: "highest"
            });
          }
          this._resizers.set(t.viewElement, e);
          var o = this.editor.editing.view.document.selection.getSelectedElement();
          return this.getResizerByViewElement(o) == e && (this.visibleResizer = e), e;
        }
      }, {
        key: "getResizerByViewElement",
        value: function getResizerByViewElement(t) {
          return this._resizers.get(t);
        }
      }, {
        key: "_getResizerByHandle",
        value: function _getResizerByHandle(t) {
          var _iterator352 = _createForOfIteratorHelper(this._resizers.values()),
            _step352;
          try {
            for (_iterator352.s(); !(_step352 = _iterator352.n()).done;) {
              var _e263 = _step352.value;
              if (_e263.containsHandle(t)) return _e263;
            }
          } catch (err) {
            _iterator352.e(err);
          } finally {
            _iterator352.f();
          }
        }
      }, {
        key: "_mouseDownListener",
        value: function _mouseDownListener(t, e) {
          var n = e.domTarget;
          ef.isResizeHandle(n) && (this._activeResizer = this._getResizerByHandle(n), this._activeResizer && (this._activeResizer.begin(n), t.stop(), e.preventDefault()));
        }
      }, {
        key: "_mouseMoveListener",
        value: function _mouseMoveListener(t, e) {
          this._activeResizer && this._activeResizer.updateSize(e);
        }
      }, {
        key: "_mouseUpListener",
        value: function _mouseUpListener() {
          this._activeResizer && (this._activeResizer.commit(), this._activeResizer = null);
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "WidgetResize";
        }
      }]);
      return _class2;
    }(Jt), Gt);
    var rf = /*#__PURE__*/function (_Xt15) {
      _inherits(rf, _Xt15);
      function rf() {
        _classCallCheck(this, rf);
        return _possibleConstructorReturn(this, _getPrototypeOf(rf).apply(this, arguments));
      }
      _createClass(rf, [{
        key: "refresh",
        value: function refresh() {
          var t = this.editor.plugins.get("ImageUtils").getClosestSelectedImageElement(this.editor.model.document.selection);
          this.isEnabled = !!t, this.isEnabled && t.hasAttribute("alt") ? this.value = t.getAttribute("alt") : this.value = !1;
        }
      }, {
        key: "execute",
        value: function execute(t) {
          var e = this.editor,
            n = e.plugins.get("ImageUtils"),
            o = e.model,
            i = n.getClosestSelectedImageElement(o.document.selection);
          o.change(function (e) {
            e.setAttribute("alt", t.newValue, i);
          });
        }
      }]);
      return rf;
    }(Xt);
    function sf(t, e) {
      var n = t.createEmptyElement("img"),
        o = "imageBlock" === e ? t.createContainerElement("figure", {
          class: "image"
        }) : t.createContainerElement("span", {
          class: "image-inline"
        }, {
          isAllowedInsideAttributeElement: !0
        });
      return t.insert(t.createPositionAt(o, 0), n), o;
    }
    function af(t, e) {
      if (t.plugins.has("ImageInlineEditing") !== t.plugins.has("ImageBlockEditing")) return {
        name: "img",
        attributes: {
          src: !0
        }
      };
      var n = t.plugins.get("ImageUtils");
      return function (t) {
        if (!n.isInlineImageView(t) || !t.hasAttribute("src")) return null;
        return (t.findAncestor(n.isBlockImageView) ? "imageBlock" : "imageInline") !== e ? null : {
          name: !0,
          attributes: ["src"]
        };
      };
    }
    function cf(t, e) {
      var n = Ks(e.getSelectedBlocks());
      return !n || t.isObject(n) || n.isEmpty && "listItem" != n.name ? "imageBlock" : "imageInline";
    }
    var lf = /*#__PURE__*/function (_Jt37) {
      _inherits(lf, _Jt37);
      function lf() {
        _classCallCheck(this, lf);
        return _possibleConstructorReturn(this, _getPrototypeOf(lf).apply(this, arguments));
      }
      _createClass(lf, [{
        key: "isImage",
        value: function isImage(t) {
          return this.isInlineImage(t) || this.isBlockImage(t);
        }
      }, {
        key: "isInlineImageView",
        value: function isInlineImageView(t) {
          return !!t && t.is("element", "img");
        }
      }, {
        key: "isBlockImageView",
        value: function isBlockImageView(t) {
          return !!t && t.is("element", "figure") && t.hasClass("image");
        }
      }, {
        key: "insertImage",
        value: function insertImage() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
          var o = this.editor,
            i = o.model,
            r = i.document.selection;
          n = df(o, e || r, n), t = _objectSpread({}, Object.fromEntries(r.getAttributes()), t);
          for (var _e265 in t) i.schema.checkAttribute(n, _e265) || delete t[_e265];
          return i.change(function (o) {
            var s = o.createElement(n, t);
            return e || "imageInline" == n || (e = bm(r, i)), i.insertContent(s, e), s.parent ? (o.setSelection(s, "on"), s) : null;
          });
        }
      }, {
        key: "getClosestSelectedImageWidget",
        value: function getClosestSelectedImageWidget(t) {
          var e = t.getSelectedElement();
          if (e && this.isImageWidget(e)) return e;
          var n = t.getFirstPosition().parent;
          for (; n;) {
            if (n.is("element") && this.isImageWidget(n)) return n;
            n = n.parent;
          }
          return null;
        }
      }, {
        key: "getClosestSelectedImageElement",
        value: function getClosestSelectedImageElement(t) {
          var e = t.getSelectedElement();
          return this.isImage(e) ? e : t.getFirstPosition().findAncestor("imageBlock");
        }
      }, {
        key: "isImageAllowed",
        value: function isImageAllowed() {
          var t = this.editor.model.document.selection;
          return function (t, e) {
            if ("imageBlock" == df(t, e)) {
              var _n246 = function (t, e) {
                var n = bm(t, e).start.parent;
                if (n.isEmpty && !n.is("element", "$root")) return n.parent;
                return n;
              }(e, t.model);
              if (t.model.schema.checkChild(_n246, "imageBlock")) return !0;
            } else if (t.model.schema.checkChild(e.focus, "imageInline")) return !0;
            return !1;
          }(this.editor, t) && function (t) {
            return _toConsumableArray(t.focus.getAncestors()).every(function (t) {
              return !t.is("element", "imageBlock");
            });
          }(t);
        }
      }, {
        key: "toImageWidget",
        value: function toImageWidget(t, e, n) {
          var _this225 = this;
          e.setCustomProperty("image", !0, t);
          return um(t, e, {
            label: function label() {
              var e = _this225.getViewImageFromWidget(t).getAttribute("alt");
              return e ? "".concat(e, " ").concat(n) : n;
            }
          });
        }
      }, {
        key: "isImageWidget",
        value: function isImageWidget(t) {
          return !!t.getCustomProperty("image") && hm(t);
        }
      }, {
        key: "isBlockImage",
        value: function isBlockImage(t) {
          return !!t && t.is("element", "imageBlock");
        }
      }, {
        key: "isInlineImage",
        value: function isInlineImage(t) {
          return !!t && t.is("element", "imageInline");
        }
      }, {
        key: "getViewImageFromWidget",
        value: function getViewImageFromWidget(t) {
          if (this.isInlineImageView(t)) return t;
          var e = [];
          var _iterator353 = _createForOfIteratorHelper(t.getChildren()),
            _step353;
          try {
            for (_iterator353.s(); !(_step353 = _iterator353.n()).done;) {
              var _n247 = _step353.value;
              e.push(_n247), _n247.is("element") && e.push.apply(e, _toConsumableArray(_n247.getChildren()));
            }
          } catch (err) {
            _iterator353.e(err);
          } finally {
            _iterator353.f();
          }
          return e.find(this.isInlineImageView);
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "ImageUtils";
        }
      }]);
      return lf;
    }(Jt);
    function df(t, e, n) {
      var o = t.model.schema,
        i = t.config.get("image.insert.type");
      return t.plugins.has("ImageBlockEditing") ? t.plugins.has("ImageInlineEditing") ? n || ("inline" === i ? "imageInline" : "block" === i ? "imageBlock" : e.is("selection") ? cf(o, e) : o.checkChild(e, "imageInline") ? "imageInline" : "imageBlock") : "imageBlock" : "imageInline";
    }
    var hf = /*#__PURE__*/function (_Jt38) {
      _inherits(hf, _Jt38);
      function hf() {
        _classCallCheck(this, hf);
        return _possibleConstructorReturn(this, _getPrototypeOf(hf).apply(this, arguments));
      }
      _createClass(hf, [{
        key: "init",
        value: function init() {
          this.editor.commands.add("imageTextAlternative", new rf(this.editor));
        }
      }], [{
        key: "requires",
        get: function get() {
          return [lf];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "ImageTextAlternativeEditing";
        }
      }]);
      return hf;
    }(Jt);
    var uf = n(44),
      gf = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      },
      mf = (Zl()(uf.a, gf), uf.a.locals, n(45)),
      pf = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Zl()(mf.a, pf), mf.a.locals;
    var ff = /*#__PURE__*/function (_ed26) {
      _inherits(ff, _ed26);
      function ff(t) {
        var _this226;
        _classCallCheck(this, ff);
        _this226 = _possibleConstructorReturn(this, _getPrototypeOf(ff).call(this, t));
        var e = _this226.locale.t;
        _this226.focusTracker = new Ys(), _this226.keystrokes = new Qs(), _this226.labeledInput = _this226._createLabeledInputView(), _this226.saveButtonView = _this226._createButton(e("Save"), ql.check, "ck-button-save"), _this226.saveButtonView.type = "submit", _this226.cancelButtonView = _this226._createButton(e("Cancel"), ql.cancel, "ck-button-cancel", "cancel"), _this226._focusables = new $l(), _this226._focusCycler = new Od({
          focusables: _this226._focusables,
          focusTracker: _this226.focusTracker,
          keystrokeHandler: _this226.keystrokes,
          actions: {
            focusPrevious: "shift + tab",
            focusNext: "tab"
          }
        }), _this226.setTemplate({
          tag: "form",
          attributes: {
            class: ["ck", "ck-text-alternative-form", "ck-responsive-form"],
            tabindex: "-1"
          },
          children: [_this226.labeledInput, _this226.saveButtonView, _this226.cancelButtonView]
        }), Yl(_assertThisInitialized(_assertThisInitialized(_this226)));
        return _this226;
      }
      _createClass(ff, [{
        key: "render",
        value: function render() {
          var _this227 = this;
          _get(_getPrototypeOf(ff.prototype), "render", this).call(this), this.keystrokes.listenTo(this.element), Ql({
            view: this
          }), [this.labeledInput, this.saveButtonView, this.cancelButtonView].forEach(function (t) {
            _this227._focusables.add(t), _this227.focusTracker.add(t.element);
          });
        }
      }, {
        key: "_createButton",
        value: function _createButton(t, e, n, o) {
          var i = new Sd(this.locale);
          return i.set({
            label: t,
            icon: e,
            tooltip: !0
          }), i.extendTemplate({
            attributes: {
              class: n
            }
          }), o && i.delegate("execute").to(this, o), i;
        }
      }, {
        key: "_createLabeledInputView",
        value: function _createLabeledInputView() {
          var t = this.locale.t,
            e = new Rh(this.locale, jh);
          return e.label = t("Text alternative"), e;
        }
      }]);
      return ff;
    }(ed);
    function kf(t) {
      var e = t.editing.view,
        n = qh.defaultPositions,
        o = t.plugins.get("ImageUtils");
      return {
        target: e.domConverter.viewToDom(o.getClosestSelectedImageWidget(e.document.selection)),
        positions: [n.northArrowSouth, n.northArrowSouthWest, n.northArrowSouthEast, n.southArrowNorth, n.southArrowNorthWest, n.southArrowNorthEast]
      };
    }
    var bf = /*#__PURE__*/function (_Jt39) {
      _inherits(bf, _Jt39);
      function bf() {
        _classCallCheck(this, bf);
        return _possibleConstructorReturn(this, _getPrototypeOf(bf).apply(this, arguments));
      }
      _createClass(bf, [{
        key: "init",
        value: function init() {
          this._createButton(), this._createForm();
        }
      }, {
        key: "destroy",
        value: function destroy() {
          _get(_getPrototypeOf(bf.prototype), "destroy", this).call(this), this._form.destroy();
        }
      }, {
        key: "_createButton",
        value: function _createButton() {
          var _this228 = this;
          var t = this.editor,
            e = t.t;
          t.ui.componentFactory.add("imageTextAlternative", function (n) {
            var o = t.commands.get("imageTextAlternative"),
              i = new Sd(n);
            return i.set({
              label: e("Change image text alternative"),
              icon: ql.lowVision,
              tooltip: !0
            }), i.bind("isEnabled").to(o, "isEnabled"), _this228.listenTo(i, "execute", function () {
              _this228._showForm();
            }), i;
          });
        }
      }, {
        key: "_createForm",
        value: function _createForm() {
          var _this229 = this;
          var t = this.editor,
            e = t.editing.view.document,
            n = t.plugins.get("ImageUtils");
          this._balloon = this.editor.plugins.get("ContextualBalloon"), this._form = new ff(t.locale), this._form.render(), this.listenTo(this._form, "submit", function () {
            t.execute("imageTextAlternative", {
              newValue: _this229._form.labeledInput.fieldView.element.value
            }), _this229._hideForm(!0);
          }), this.listenTo(this._form, "cancel", function () {
            _this229._hideForm(!0);
          }), this._form.keystrokes.set("Esc", function (t, e) {
            _this229._hideForm(!0), e();
          }), this.listenTo(t.ui, "update", function () {
            n.getClosestSelectedImageWidget(e.selection) ? _this229._isVisible && function (t) {
              var e = t.plugins.get("ContextualBalloon");
              if (t.plugins.get("ImageUtils").getClosestSelectedImageWidget(t.editing.view.document.selection)) {
                var _n248 = kf(t);
                e.updatePosition(_n248);
              }
            }(t) : _this229._hideForm(!0);
          }), Kl({
            emitter: this._form,
            activator: function activator() {
              return _this229._isVisible;
            },
            contextElements: [this._balloon.view.element],
            callback: function callback() {
              return _this229._hideForm();
            }
          });
        }
      }, {
        key: "_showForm",
        value: function _showForm() {
          if (this._isVisible) return;
          var t = this.editor,
            e = t.commands.get("imageTextAlternative"),
            n = this._form.labeledInput;
          this._form.disableCssTransitions(), this._isInBalloon || this._balloon.add({
            view: this._form,
            position: kf(t)
          }), n.fieldView.value = n.fieldView.element.value = e.value || "", this._form.labeledInput.fieldView.select(), this._form.enableCssTransitions();
        }
      }, {
        key: "_hideForm",
        value: function _hideForm(t) {
          this._isInBalloon && (this._form.focusTracker.isFocused && this._form.saveButtonView.focus(), this._balloon.remove(this._form), t && this.editor.editing.view.focus());
        }
      }, {
        key: "_isVisible",
        get: function get() {
          return this._balloon.visibleView === this._form;
        }
      }, {
        key: "_isInBalloon",
        get: function get() {
          return this._balloon.hasView(this._form);
        }
      }], [{
        key: "requires",
        get: function get() {
          return [eu];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "ImageTextAlternativeUI";
        }
      }]);
      return bf;
    }(Jt);
    var wf = /*#__PURE__*/function (_Jt40) {
      _inherits(wf, _Jt40);
      function wf() {
        _classCallCheck(this, wf);
        return _possibleConstructorReturn(this, _getPrototypeOf(wf).apply(this, arguments));
      }
      _createClass(wf, null, [{
        key: "requires",
        get: function get() {
          return [hf, bf];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "ImageTextAlternative";
        }
      }]);
      return wf;
    }(Jt);
    function Cf(t, e) {
      return function (t) {
        t.on("attribute:srcset:".concat(e), n);
      };
      function n(e, n, o) {
        if (!o.consumable.consume(n.item, e.name)) return;
        var i = o.writer,
          r = o.mapper.toViewElement(n.item),
          s = t.getViewImageFromWidget(r);
        if (null === n.attributeNewValue) {
          var _t279 = n.attributeOldValue;
          _t279.data && (i.removeAttribute("srcset", s), i.removeAttribute("sizes", s), _t279.width && i.removeAttribute("width", s));
        } else {
          var _t280 = n.attributeNewValue;
          _t280.data && (i.setAttribute("srcset", _t280.data, s), i.setAttribute("sizes", "100vw", s), _t280.width && i.setAttribute("width", _t280.width, s));
        }
      }
    }
    function Af(t, e, n) {
      return function (t) {
        t.on("attribute:".concat(n, ":").concat(e), o);
      };
      function o(e, n, o) {
        if (!o.consumable.consume(n.item, e.name)) return;
        var i = o.writer,
          r = o.mapper.toViewElement(n.item),
          s = t.getViewImageFromWidget(r);
        i.setAttribute(n.attributeKey, n.attributeNewValue || "", s);
      }
    }
    var _f = /*#__PURE__*/function (_Wr8) {
      _inherits(_f, _Wr8);
      function _f() {
        _classCallCheck(this, _f);
        return _possibleConstructorReturn(this, _getPrototypeOf(_f).apply(this, arguments));
      }
      _createClass(_f, [{
        key: "observe",
        value: function observe(t) {
          var _this230 = this;
          this.listenTo(t, "load", function (t, e) {
            var n = e.target;
            _this230.checkShouldIgnoreEventFromTarget(n) || "IMG" == n.tagName && _this230._fireEvents(e);
          }, {
            useCapture: !0
          });
        }
      }, {
        key: "_fireEvents",
        value: function _fireEvents(t) {
          this.isEnabled && (this.document.fire("layoutChanged"), this.document.fire("imageLoaded", t));
        }
      }]);
      return _f;
    }(Wr);
    var vf = /*#__PURE__*/function (_Xt16) {
      _inherits(vf, _Xt16);
      function vf(t) {
        var _this231;
        _classCallCheck(this, vf);
        _this231 = _possibleConstructorReturn(this, _getPrototypeOf(vf).call(this, t));
        var e = t.config.get("image.insert.type");
        t.plugins.has("ImageBlockEditing") || "block" === e && Object(c.b)("image-block-plugin-required"), t.plugins.has("ImageInlineEditing") || "inline" === e && Object(c.b)("image-inline-plugin-required");
        return _this231;
      }
      _createClass(vf, [{
        key: "refresh",
        value: function refresh() {
          this.isEnabled = this.editor.plugins.get("ImageUtils").isImageAllowed();
        }
      }, {
        key: "execute",
        value: function execute(t) {
          var _this232 = this;
          var e = ho(t.source),
            n = this.editor.model.document.selection,
            o = this.editor.plugins.get("ImageUtils"),
            i = Object.fromEntries(n.getAttributes());
          e.forEach(function (t, e) {
            var r = n.getSelectedElement();
            if (e && r && o.isImage(r)) {
              var _e266 = _this232.editor.model.createPositionAfter(r);
              o.insertImage(_objectSpread({
                src: t
              }, i), _e266);
            } else o.insertImage(_objectSpread({
              src: t
            }, i));
          });
        }
      }]);
      return vf;
    }(Xt);
    var yf = /*#__PURE__*/function (_Jt41) {
      _inherits(yf, _Jt41);
      function yf() {
        _classCallCheck(this, yf);
        return _possibleConstructorReturn(this, _getPrototypeOf(yf).apply(this, arguments));
      }
      _createClass(yf, [{
        key: "init",
        value: function init() {
          var t = this.editor,
            e = t.conversion;
          t.editing.view.addObserver(_f), e.for("upcast").attributeToAttribute({
            view: {
              name: "img",
              key: "alt"
            },
            model: "alt"
          }).attributeToAttribute({
            view: {
              name: "img",
              key: "srcset"
            },
            model: {
              key: "srcset",
              value: function value(t) {
                var e = {
                  data: t.getAttribute("srcset")
                };
                return t.hasAttribute("width") && (e.width = t.getAttribute("width")), e;
              }
            }
          });
          var n = new vf(t);
          t.commands.add("insertImage", n), t.commands.add("imageInsert", n);
        }
      }], [{
        key: "requires",
        get: function get() {
          return [lf];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "ImageEditing";
        }
      }]);
      return yf;
    }(Jt);
    var xf = /*#__PURE__*/function (_Xt17) {
      _inherits(xf, _Xt17);
      function xf(t, e) {
        var _this233;
        _classCallCheck(this, xf);
        _this233 = _possibleConstructorReturn(this, _getPrototypeOf(xf).call(this, t)), _this233._modelElementName = e;
        return _this233;
      }
      _createClass(xf, [{
        key: "refresh",
        value: function refresh() {
          var t = this.editor.plugins.get("ImageUtils"),
            e = t.getClosestSelectedImageElement(this.editor.model.document.selection);
          "imageBlock" === this._modelElementName ? this.isEnabled = t.isInlineImage(e) : this.isEnabled = t.isBlockImage(e);
        }
      }, {
        key: "execute",
        value: function execute() {
          var _this234 = this;
          var t = this.editor,
            e = this.editor.model,
            n = t.plugins.get("ImageUtils"),
            o = n.getClosestSelectedImageElement(e.document.selection),
            i = Object.fromEntries(o.getAttributes());
          return i.src || i.uploadId ? e.change(function (t) {
            var r = Array.from(e.markers).filter(function (t) {
                return t.getRange().containsItem(o);
              }),
              s = n.insertImage(i, e.createSelection(o, "on"), _this234._modelElementName);
            if (!s) return null;
            var a = t.createRangeOn(s);
            var _iterator354 = _createForOfIteratorHelper(r),
              _step354;
            try {
              for (_iterator354.s(); !(_step354 = _iterator354.n()).done;) {
                var _e267 = _step354.value;
                var _n249 = _e267.getRange(),
                  _o164 = "$graveyard" != _n249.root.rootName ? _n249.getJoined(a, !0) : a;
                t.updateMarker(_e267, {
                  range: _o164
                });
              }
            } catch (err) {
              _iterator354.e(err);
            } finally {
              _iterator354.f();
            }
            return {
              oldElement: o,
              newElement: s
            };
          }) : null;
        }
      }]);
      return xf;
    }(Xt);
    var Ef = /*#__PURE__*/function (_Jt42) {
      _inherits(Ef, _Jt42);
      function Ef() {
        _classCallCheck(this, Ef);
        return _possibleConstructorReturn(this, _getPrototypeOf(Ef).apply(this, arguments));
      }
      _createClass(Ef, [{
        key: "init",
        value: function init() {
          var t = this.editor;
          t.model.schema.register("imageBlock", {
            isObject: !0,
            isBlock: !0,
            allowWhere: "$block",
            allowAttributes: ["alt", "src", "srcset"]
          }), this._setupConversion(), t.plugins.has("ImageInlineEditing") && (t.commands.add("imageTypeBlock", new xf(this.editor, "imageBlock")), this._setupClipboardIntegration());
        }
      }, {
        key: "_setupConversion",
        value: function _setupConversion() {
          var t = this.editor,
            e = t.t,
            n = t.conversion,
            o = t.plugins.get("ImageUtils");
          n.for("dataDowncast").elementToElement({
            model: "imageBlock",
            view: function view(t, _ref58) {
              var e = _ref58.writer;
              return sf(e, "imageBlock");
            }
          }), n.for("editingDowncast").elementToElement({
            model: "imageBlock",
            view: function view(t, _ref59) {
              var n = _ref59.writer;
              return o.toImageWidget(sf(n, "imageBlock"), n, e("image widget"));
            }
          }), n.for("downcast").add(Af(o, "imageBlock", "src")).add(Af(o, "imageBlock", "alt")).add(Cf(o, "imageBlock")), n.for("upcast").elementToElement({
            view: af(t, "imageBlock"),
            model: function model(t, _ref60) {
              var e = _ref60.writer;
              return e.createElement("imageBlock", {
                src: t.getAttribute("src")
              });
            }
          }).add(function (t) {
            return function (t) {
              t.on("element:figure", e);
            };
            function e(e, n, o) {
              if (!o.consumable.test(n.viewItem, {
                name: !0,
                classes: "image"
              })) return;
              var i = t.getViewImageFromWidget(n.viewItem);
              if (!i || !i.hasAttribute("src") || !o.consumable.test(i, {
                name: !0
              })) return;
              var r = Ks(o.convertItem(i, n.modelCursor).modelRange.getItems());
              r && (o.convertChildren(n.viewItem, r), o.updateConversionResult(r, n));
            }
          }(o));
        }
      }, {
        key: "_setupClipboardIntegration",
        value: function _setupClipboardIntegration() {
          var t = this.editor,
            e = t.model,
            n = t.editing.view,
            o = t.plugins.get("ImageUtils");
          this.listenTo(t.plugins.get("ClipboardPipeline"), "inputTransformation", function (i, r) {
            var s = Array.from(r.content.getChildren());
            var a;
            if (!s.every(o.isInlineImageView)) return;
            a = r.targetRanges ? t.editing.mapper.toModelRange(r.targetRanges[0]) : e.document.selection.getFirstRange();
            var c = e.createSelection(a);
            if ("imageBlock" === cf(e.schema, c)) {
              var _t281 = new Su(n.document),
                _e268 = s.map(function (e) {
                  return _t281.createElement("figure", {
                    class: "image"
                  }, e);
                });
              r.content = _t281.createDocumentFragment(_e268);
            }
          });
        }
      }], [{
        key: "requires",
        get: function get() {
          return [yf, lf, im];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "ImageBlockEditing";
        }
      }]);
      return Ef;
    }(Jt);
    var Df = n(46),
      Mf = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Zl()(Df.a, Mf), Df.a.locals;
    var If = /*#__PURE__*/function (_Jt43) {
      _inherits(If, _Jt43);
      function If() {
        _classCallCheck(this, If);
        return _possibleConstructorReturn(this, _getPrototypeOf(If).apply(this, arguments));
      }
      _createClass(If, null, [{
        key: "requires",
        get: function get() {
          return [Ef, zm, wf];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "ImageBlock";
        }
      }]);
      return If;
    }(Jt);
    var Tf = /*#__PURE__*/function (_Jt44) {
      _inherits(Tf, _Jt44);
      function Tf() {
        _classCallCheck(this, Tf);
        return _possibleConstructorReturn(this, _getPrototypeOf(Tf).apply(this, arguments));
      }
      _createClass(Tf, [{
        key: "init",
        value: function init() {
          var t = this.editor,
            e = t.model.schema;
          e.register("imageInline", {
            isObject: !0,
            isInline: !0,
            allowWhere: "$text",
            allowAttributes: ["alt", "src", "srcset"]
          }), e.addChildCheck(function (t, e) {
            if (t.endsWith("caption") && "imageInline" === e.name) return !1;
          }), this._setupConversion(), t.plugins.has("ImageBlockEditing") && (t.commands.add("imageTypeInline", new xf(this.editor, "imageInline")), this._setupClipboardIntegration());
        }
      }, {
        key: "_setupConversion",
        value: function _setupConversion() {
          var t = this.editor,
            e = t.t,
            n = t.conversion,
            o = t.plugins.get("ImageUtils");
          n.for("dataDowncast").elementToElement({
            model: "imageInline",
            view: function view(t, _ref61) {
              var e = _ref61.writer;
              return e.createEmptyElement("img");
            }
          }), n.for("editingDowncast").elementToElement({
            model: "imageInline",
            view: function view(t, _ref62) {
              var n = _ref62.writer;
              return o.toImageWidget(sf(n, "imageInline"), n, e("image widget"));
            }
          }), n.for("downcast").add(Af(o, "imageInline", "src")).add(Af(o, "imageInline", "alt")).add(Cf(o, "imageInline")), n.for("upcast").elementToElement({
            view: af(t, "imageInline"),
            model: function model(t, _ref63) {
              var e = _ref63.writer;
              return e.createElement("imageInline", {
                src: t.getAttribute("src")
              });
            }
          });
        }
      }, {
        key: "_setupClipboardIntegration",
        value: function _setupClipboardIntegration() {
          var t = this.editor,
            e = t.model,
            n = t.editing.view,
            o = t.plugins.get("ImageUtils");
          this.listenTo(t.plugins.get("ClipboardPipeline"), "inputTransformation", function (i, r) {
            var s = Array.from(r.content.getChildren());
            var a;
            if (!s.every(o.isBlockImageView)) return;
            a = r.targetRanges ? t.editing.mapper.toModelRange(r.targetRanges[0]) : e.document.selection.getFirstRange();
            var c = e.createSelection(a);
            if ("imageInline" === cf(e.schema, c)) {
              var _t282 = new Su(n.document),
                _e269 = s.map(function (e) {
                  return 1 === e.childCount ? (Array.from(e.getAttributes()).forEach(function (n) {
                    return _t282.setAttribute.apply(_t282, _toConsumableArray(n).concat([o.getViewImageFromWidget(e)]));
                  }), e.getChild(0)) : e;
                });
              r.content = _t282.createDocumentFragment(_e269);
            }
          });
        }
      }], [{
        key: "requires",
        get: function get() {
          return [yf, lf, im];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "ImageInlineEditing";
        }
      }]);
      return Tf;
    }(Jt);
    var Sf = /*#__PURE__*/function (_Jt45) {
      _inherits(Sf, _Jt45);
      function Sf() {
        _classCallCheck(this, Sf);
        return _possibleConstructorReturn(this, _getPrototypeOf(Sf).apply(this, arguments));
      }
      _createClass(Sf, null, [{
        key: "requires",
        get: function get() {
          return [Tf, zm, wf];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "ImageInline";
        }
      }]);
      return Sf;
    }(Jt);
    function Nf(t) {
      var _iterator355 = _createForOfIteratorHelper(t.getChildren()),
        _step355;
      try {
        for (_iterator355.s(); !(_step355 = _iterator355.n()).done;) {
          var _e270 = _step355.value;
          if (_e270 && _e270.is("element", "caption")) return _e270;
        }
      } catch (err) {
        _iterator355.e(err);
      } finally {
        _iterator355.f();
      }
      return null;
    }
    function Bf(t, e) {
      var n = e.getFirstPosition().findAncestor("caption");
      return n && t.isBlockImage(n.parent) ? n : null;
    }
    var Pf = /*#__PURE__*/function (_Xt18) {
      _inherits(Pf, _Xt18);
      function Pf() {
        _classCallCheck(this, Pf);
        return _possibleConstructorReturn(this, _getPrototypeOf(Pf).apply(this, arguments));
      }
      _createClass(Pf, [{
        key: "refresh",
        value: function refresh() {
          var t = this.editor,
            e = t.plugins.get("ImageUtils");
          if (!t.plugins.has(Ef)) return this.isEnabled = !1, void (this.value = !1);
          var n = t.model.document.selection,
            o = n.getSelectedElement();
          if (!o) {
            var _t283 = Bf(e, n);
            return this.isEnabled = !!_t283, void (this.value = !!_t283);
          }
          this.isEnabled = this.editor.plugins.get("ImageUtils").isImage(o), this.isEnabled ? this.value = !!Nf(o) : this.value = !1;
        }
      }, {
        key: "execute",
        value: function execute() {
          var _this235 = this;
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var e = t.focusCaptionOnShow;
          this.editor.model.change(function (t) {
            _this235.value ? _this235._hideImageCaption(t) : _this235._showImageCaption(t, e);
          });
        }
      }, {
        key: "_showImageCaption",
        value: function _showImageCaption(t, e) {
          var n = this.editor.model.document.selection,
            o = this.editor.plugins.get("ImageCaptionEditing");
          var i = n.getSelectedElement();
          var r = o._getSavedCaption(i);
          this.editor.plugins.get("ImageUtils").isInlineImage(i) && (this.editor.execute("imageTypeBlock"), i = n.getSelectedElement());
          var s = r || t.createElement("caption");
          t.append(s, i), e && t.setSelection(s, "in");
        }
      }, {
        key: "_hideImageCaption",
        value: function _hideImageCaption(t) {
          var e = this.editor,
            n = e.model.document.selection,
            o = e.plugins.get("ImageCaptionEditing"),
            i = e.plugins.get("ImageUtils");
          var r,
            s = n.getSelectedElement();
          s ? r = Nf(s) : (r = Bf(i, n), s = r.parent), o._saveCaption(s, r), t.setSelection(s, "on"), t.remove(r);
        }
      }]);
      return Pf;
    }(Xt);
    var zf = /*#__PURE__*/function (_Jt46) {
      _inherits(zf, _Jt46);
      _createClass(zf, null, [{
        key: "requires",
        get: function get() {
          return [lf];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "ImageCaptionEditing";
        }
      }]);
      function zf(t) {
        var _this236;
        _classCallCheck(this, zf);
        _this236 = _possibleConstructorReturn(this, _getPrototypeOf(zf).call(this, t)), _this236._savedCaptionsMap = new WeakMap();
        return _this236;
      }
      _createClass(zf, [{
        key: "init",
        value: function init() {
          var t = this.editor,
            e = t.model.schema;
          e.isRegistered("caption") ? e.extend("caption", {
            allowIn: "imageBlock"
          }) : e.register("caption", {
            allowIn: "imageBlock",
            allowContentOf: "$block",
            isLimit: !0
          }), t.commands.add("toggleImageCaption", new Pf(this.editor)), this._setupConversion(), this._setupImageTypeCommandsIntegration();
        }
      }, {
        key: "_setupConversion",
        value: function _setupConversion() {
          var t = this.editor,
            e = t.editing.view,
            n = t.plugins.get("ImageUtils"),
            o = t.t;
          t.conversion.for("upcast").elementToElement({
            view: function view(t) {
              return function (t, e) {
                return "figcaption" == e.name && t.isBlockImageView(e.parent) ? {
                  name: !0
                } : null;
              }(n, t);
            },
            model: "caption"
          }), t.conversion.for("dataDowncast").elementToElement({
            model: "caption",
            view: function view(t, _ref64) {
              var e = _ref64.writer;
              return n.isBlockImage(t.parent) ? e.createContainerElement("figcaption") : null;
            }
          }), t.conversion.for("editingDowncast").elementToElement({
            model: "caption",
            view: function view(t, _ref65) {
              var i = _ref65.writer;
              if (!n.isBlockImage(t.parent)) return null;
              var r = i.createEditableElement("figcaption");
              i.setCustomProperty("imageCaption", !0, r), gu({
                view: e,
                element: r,
                text: o("Enter image caption"),
                keepOnFocus: !0
              });
              var s = km(r, i);
              return pm(s, i, function (t, e, n) {
                return n.addClass(ho(e.classes), t);
              }, function (t, e, n) {
                return n.removeClass(ho(e.classes), t);
              }), s;
            }
          }), t.editing.mapper.on("modelToViewPosition", Lf(e)), t.data.mapper.on("modelToViewPosition", Lf(e));
        }
      }, {
        key: "_setupImageTypeCommandsIntegration",
        value: function _setupImageTypeCommandsIntegration() {
          var _this237 = this;
          var t = this.editor,
            e = t.plugins.get("ImageUtils"),
            n = t.commands.get("imageTypeInline"),
            o = t.commands.get("imageTypeBlock"),
            i = function i(t) {
              if (!t.return) return;
              var _t$return = t.return,
                n = _t$return.oldElement,
                o = _t$return.newElement;
              if (!n) return;
              if (e.isBlockImage(n)) {
                var _t284 = Nf(n);
                if (_t284) return void _this237._saveCaption(o, _t284);
              }
              var i = _this237._getSavedCaption(n);
              i && _this237._saveCaption(o, i);
            };
          n && this.listenTo(n, "execute", i, {
            priority: "low"
          }), o && this.listenTo(o, "execute", i, {
            priority: "low"
          });
        }
      }, {
        key: "_getSavedCaption",
        value: function _getSavedCaption(t) {
          var e = this._savedCaptionsMap.get(t);
          return e ? ua.fromJSON(e) : null;
        }
      }, {
        key: "_saveCaption",
        value: function _saveCaption(t, e) {
          this._savedCaptionsMap.set(t, e.toJSON());
        }
      }]);
      return zf;
    }(Jt);
    function Lf(t) {
      return function (e, n) {
        var o = n.modelPosition,
          i = o.parent;
        if (!i.is("element", "imageBlock")) return;
        var r = n.mapper.toViewElement(i);
        n.viewPosition = t.createPositionAt(r, o.offset + 1);
      };
    }
    var Of = /*#__PURE__*/function (_Jt47) {
      _inherits(Of, _Jt47);
      function Of() {
        _classCallCheck(this, Of);
        return _possibleConstructorReturn(this, _getPrototypeOf(Of).apply(this, arguments));
      }
      _createClass(Of, [{
        key: "init",
        value: function init() {
          var _this238 = this;
          var t = this.editor,
            e = t.editing.view,
            n = t.plugins.get("ImageUtils"),
            o = t.t;
          t.ui.componentFactory.add("toggleImageCaption", function (i) {
            var r = t.commands.get("toggleImageCaption"),
              s = new Sd(i);
            return s.set({
              icon: ql.caption,
              tooltip: !0,
              isToggleable: !0
            }), s.bind("isOn", "isEnabled").to(r, "value", "isEnabled"), s.bind("label").to(r, "value", function (t) {
              return o(t ? "Toggle caption off" : "Toggle caption on");
            }), _this238.listenTo(s, "execute", function () {
              t.execute("toggleImageCaption", {
                focusCaptionOnShow: !0
              });
              var o = Bf(n, t.model.document.selection);
              if (o) {
                var _n250 = t.editing.mapper.toViewElement(o);
                e.scrollToTheSelection(), e.change(function (t) {
                  t.addClass("image__caption_highlighted", _n250);
                });
              }
            }), s;
          });
        }
      }], [{
        key: "requires",
        get: function get() {
          return [lf];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "ImageCaptionUI";
        }
      }]);
      return Of;
    }(Jt);
    var Rf = n(47),
      jf = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Zl()(Rf.a, jf), Rf.a.locals;
    var Ff = /*#__PURE__*/function (_Xt19) {
      _inherits(Ff, _Xt19);
      function Ff(t, e) {
        var _this239;
        _classCallCheck(this, Ff);
        _this239 = _possibleConstructorReturn(this, _getPrototypeOf(Ff).call(this, t)), _this239._defaultStyles = {
          imageBlock: !1,
          imageInline: !1
        }, _this239._styles = new Map(e.map(function (t) {
          if (t.isDefault) {
            var _iterator356 = _createForOfIteratorHelper(t.modelElements),
              _step356;
            try {
              for (_iterator356.s(); !(_step356 = _iterator356.n()).done;) {
                var _e271 = _step356.value;
                _this239._defaultStyles[_e271] = t.name;
              }
            } catch (err) {
              _iterator356.e(err);
            } finally {
              _iterator356.f();
            }
          }
          return [t.name, t];
        }));
        return _this239;
      }
      _createClass(Ff, [{
        key: "refresh",
        value: function refresh() {
          var t = this.editor.plugins.get("ImageUtils").getClosestSelectedImageElement(this.editor.model.document.selection);
          this.isEnabled = !!t, this.isEnabled ? t.hasAttribute("imageStyle") ? this.value = t.getAttribute("imageStyle") : this.value = this._defaultStyles[t.name] : this.value = !1;
        }
      }, {
        key: "execute",
        value: function execute() {
          var _this240 = this;
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var e = this.editor,
            n = e.model,
            o = e.plugins.get("ImageUtils");
          n.change(function (e) {
            var i = t.value;
            var r = o.getClosestSelectedImageElement(n.document.selection);
            i && _this240.shouldConvertImageType(i, r) && (_this240.editor.execute(o.isBlockImage(r) ? "imageTypeInline" : "imageTypeBlock"), r = o.getClosestSelectedImageElement(n.document.selection)), !i || _this240._styles.get(i).isDefault ? e.removeAttribute("imageStyle", r) : e.setAttribute("imageStyle", i, r);
          });
        }
      }, {
        key: "shouldConvertImageType",
        value: function shouldConvertImageType(t, e) {
          return !this._styles.get(t).modelElements.includes(e.name);
        }
      }]);
      return Ff;
    }(Xt);
    var Vf = ql.objectFullWidth,
      Uf = ql.objectInline,
      Hf = ql.objectLeft,
      Gf = ql.objectRight,
      Wf = ql.objectCenter,
      qf = ql.objectBlockLeft,
      Kf = ql.objectBlockRight,
      Yf = {
        inline: {
          name: "inline",
          title: "In line",
          icon: Uf,
          modelElements: ["imageInline"],
          isDefault: !0
        },
        alignLeft: {
          name: "alignLeft",
          title: "Left aligned image",
          icon: Hf,
          modelElements: ["imageBlock", "imageInline"],
          className: "image-style-align-left"
        },
        alignBlockLeft: {
          name: "alignBlockLeft",
          title: "Left aligned image",
          icon: qf,
          modelElements: ["imageBlock"],
          className: "image-style-block-align-left"
        },
        alignCenter: {
          name: "alignCenter",
          title: "Centered image",
          icon: Wf,
          modelElements: ["imageBlock"],
          className: "image-style-align-center"
        },
        alignRight: {
          name: "alignRight",
          title: "Right aligned image",
          icon: Gf,
          modelElements: ["imageBlock", "imageInline"],
          className: "image-style-align-right"
        },
        alignBlockRight: {
          name: "alignBlockRight",
          title: "Right aligned image",
          icon: Kf,
          modelElements: ["imageBlock"],
          className: "image-style-block-align-right"
        },
        block: {
          name: "block",
          title: "Centered image",
          icon: Wf,
          modelElements: ["imageBlock"],
          isDefault: !0
        },
        side: {
          name: "side",
          title: "Side image",
          icon: Gf,
          modelElements: ["imageBlock"],
          className: "image-style-side"
        }
      },
      Qf = {
        full: Vf,
        left: qf,
        right: Kf,
        center: Wf,
        inlineLeft: Hf,
        inlineRight: Gf,
        inline: Uf
      },
      $f = [{
        name: "imageStyle:wrapText",
        title: "Wrap text",
        defaultItem: "imageStyle:alignLeft",
        items: ["imageStyle:alignLeft", "imageStyle:alignRight"]
      }, {
        name: "imageStyle:breakText",
        title: "Break text",
        defaultItem: "imageStyle:block",
        items: ["imageStyle:alignBlockLeft", "imageStyle:block", "imageStyle:alignBlockRight"]
      }];
    function Jf(t) {
      Object(c.b)("image-style-configuration-definition-invalid", t);
    }
    var Zf = {
      normalizeStyles: function normalizeStyles(t) {
        return (t.configuredStyles.options || []).map(function (t) {
          return function (t) {
            t = "string" == typeof t ? Yf[t] ? _objectSpread({}, Yf[t]) : {
              name: t
            } : function (t, e) {
              var n = _objectSpread({}, e);
              for (var _o166 in t) Object.prototype.hasOwnProperty.call(e, _o166) || (n[_o166] = t[_o166]);
              return n;
            }(Yf[t.name], t);
            "string" == typeof t.icon && (t.icon = Qf[t.icon] || t.icon);
            return t;
          }(t);
        }).filter(function (e) {
          return function (t, _ref66) {
            var e = _ref66.isBlockPluginLoaded,
              n = _ref66.isInlinePluginLoaded;
            var o = t.modelElements,
              i = t.name;
            if (!(o && o.length && i)) return Jf({
              style: t
            }), !1;
            {
              var _i134 = [e ? "imageBlock" : null, n ? "imageInline" : null];
              if (!o.some(function (t) {
                return _i134.includes(t);
              })) return Object(c.b)("image-style-missing-dependency", {
                style: t,
                missingPlugins: o.map(function (t) {
                  return "imageBlock" === t ? "ImageBlockEditing" : "ImageInlineEditing";
                })
              }), !1;
            }
            return !0;
          }(e, t);
        });
      },
      getDefaultStylesConfiguration: function getDefaultStylesConfiguration(t, e) {
        return t && e ? {
          options: ["inline", "alignLeft", "alignRight", "alignCenter", "alignBlockLeft", "alignBlockRight", "block", "side"]
        } : t ? {
          options: ["block", "side"]
        } : e ? {
          options: ["inline", "alignLeft", "alignRight"]
        } : {};
      },
      getDefaultDropdownDefinitions: function getDefaultDropdownDefinitions(t) {
        return t.has("ImageBlockEditing") && t.has("ImageInlineEditing") ? [].concat($f) : [];
      },
      warnInvalidStyle: Jf,
      DEFAULT_OPTIONS: Yf,
      DEFAULT_ICONS: Qf,
      DEFAULT_DROPDOWN_DEFINITIONS: $f
    };
    function Xf(t, e) {
      var _iterator357 = _createForOfIteratorHelper(e),
        _step357;
      try {
        for (_iterator357.s(); !(_step357 = _iterator357.n()).done;) {
          var _n251 = _step357.value;
          if (_n251.name === t) return _n251;
        }
      } catch (err) {
        _iterator357.e(err);
      } finally {
        _iterator357.f();
      }
    }
    var tk = /*#__PURE__*/function (_Jt48) {
      _inherits(tk, _Jt48);
      function tk() {
        _classCallCheck(this, tk);
        return _possibleConstructorReturn(this, _getPrototypeOf(tk).apply(this, arguments));
      }
      _createClass(tk, [{
        key: "init",
        value: function init() {
          var t = Zf.normalizeStyles,
            e = Zf.getDefaultStylesConfiguration,
            n = this.editor,
            o = n.plugins.has("ImageBlockEditing"),
            i = n.plugins.has("ImageInlineEditing");
          n.config.define("image.styles", e(o, i)), this.normalizedStyles = t({
            configuredStyles: n.config.get("image.styles"),
            isBlockPluginLoaded: o,
            isInlinePluginLoaded: i
          }), this._setupConversion(o, i), this._setupPostFixer(), n.commands.add("imageStyle", new Ff(n, this.normalizedStyles));
        }
      }, {
        key: "_setupConversion",
        value: function _setupConversion(t, e) {
          var n = this.editor,
            o = n.model.schema,
            i = (r = this.normalizedStyles, function (t, e, n) {
              if (!n.consumable.consume(e.item, t.name)) return;
              var o = Xf(e.attributeNewValue, r),
                i = Xf(e.attributeOldValue, r),
                s = n.mapper.toViewElement(e.item),
                a = n.writer;
              i && a.removeClass(i.className, s), o && a.addClass(o.className, s);
            });
          var r;
          var s = function (t) {
            var e = {
              imageInline: t.filter(function (t) {
                return !t.isDefault && t.modelElements.includes("imageInline");
              }),
              imageBlock: t.filter(function (t) {
                return !t.isDefault && t.modelElements.includes("imageBlock");
              })
            };
            return function (t, n, o) {
              if (!n.modelRange) return;
              var i = n.viewItem,
                r = Ks(n.modelRange.getItems());
              if (r && o.schema.checkAttribute(r, "imageStyle")) {
                var _iterator358 = _createForOfIteratorHelper(e[r.name]),
                  _step358;
                try {
                  for (_iterator358.s(); !(_step358 = _iterator358.n()).done;) {
                    var _t285 = _step358.value;
                    o.consumable.consume(i, {
                      classes: _t285.className
                    }) && o.writer.setAttribute("imageStyle", _t285.name, r);
                  }
                } catch (err) {
                  _iterator358.e(err);
                } finally {
                  _iterator358.f();
                }
              }
            };
          }(this.normalizedStyles);
          n.editing.downcastDispatcher.on("attribute:imageStyle", i), n.data.downcastDispatcher.on("attribute:imageStyle", i), t && (o.extend("imageBlock", {
            allowAttributes: "imageStyle"
          }), n.data.upcastDispatcher.on("element:figure", s, {
            priority: "low"
          })), e && (o.extend("imageInline", {
            allowAttributes: "imageStyle"
          }), n.data.upcastDispatcher.on("element:img", s, {
            priority: "low"
          }));
        }
      }, {
        key: "_setupPostFixer",
        value: function _setupPostFixer() {
          var t = this.editor,
            e = t.model.document,
            n = t.plugins.get(lf),
            o = new Map(this.normalizedStyles.map(function (t) {
              return [t.name, t];
            }));
          e.registerPostFixer(function (t) {
            var i = !1;
            var _iterator359 = _createForOfIteratorHelper(e.differ.getChanges()),
              _step359;
            try {
              for (_iterator359.s(); !(_step359 = _iterator359.n()).done;) {
                var _r56 = _step359.value;
                if ("insert" == _r56.type || "attribute" == _r56.type && "imageStyle" == _r56.attributeKey) {
                  var _e272 = "insert" == _r56.type ? _r56.position.nodeAfter : _r56.range.start.nodeAfter;
                  if (_e272 && _e272.is("element", "paragraph") && _e272.childCount > 0 && (_e272 = _e272.getChild(0)), !n.isImage(_e272)) continue;
                  var _s33 = _e272.getAttribute("imageStyle");
                  if (!_s33) continue;
                  var _a19 = o.get(_s33);
                  _a19 && _a19.modelElements.includes(_e272.name) || (t.removeAttribute("imageStyle", _e272), i = !0);
                }
              }
            } catch (err) {
              _iterator359.e(err);
            } finally {
              _iterator359.f();
            }
            return i;
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "ImageStyleEditing";
        }
      }, {
        key: "requires",
        get: function get() {
          return [lf];
        }
      }]);
      return tk;
    }(Jt);
    var ek = n(48),
      nk = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Zl()(ek.a, nk), ek.a.locals;
    var ok = /*#__PURE__*/function (_Jt49) {
      _inherits(ok, _Jt49);
      function ok() {
        _classCallCheck(this, ok);
        return _possibleConstructorReturn(this, _getPrototypeOf(ok).apply(this, arguments));
      }
      _createClass(ok, [{
        key: "init",
        value: function init() {
          var t = this.editor.plugins,
            e = this.editor.config.get("image.toolbar") || [],
            n = ik(t.get("ImageStyleEditing").normalizedStyles, this.localizedDefaultStylesTitles);
          var _iterator360 = _createForOfIteratorHelper(n),
            _step360;
          try {
            for (_iterator360.s(); !(_step360 = _iterator360.n()).done;) {
              var _t286 = _step360.value;
              this._createButton(_t286);
            }
          } catch (err) {
            _iterator360.e(err);
          } finally {
            _iterator360.f();
          }
          var o = ik([].concat(_toConsumableArray(e.filter(w)), _toConsumableArray(Zf.getDefaultDropdownDefinitions(t))), this.localizedDefaultStylesTitles);
          var _iterator361 = _createForOfIteratorHelper(o),
            _step361;
          try {
            for (_iterator361.s(); !(_step361 = _iterator361.n()).done;) {
              var _t287 = _step361.value;
              this._createDropdown(_t287, n);
            }
          } catch (err) {
            _iterator361.e(err);
          } finally {
            _iterator361.f();
          }
        }
      }, {
        key: "_createDropdown",
        value: function _createDropdown(t, e) {
          var n = this.editor.ui.componentFactory;
          n.add(t.name, function (o) {
            var i;
            var r = t.defaultItem,
              s = t.items,
              a = t.title,
              c = s.filter(function (t) {
                return e.find(function (_ref67) {
                  var e = _ref67.name;
                  return rk(e) === t;
                });
              }).map(function (t) {
                var e = n.create(t);
                return t === r && (i = e), e;
              });
            s.length !== c.length && Zf.warnInvalidStyle({
              dropdown: t
            });
            var l = wh(o, qd),
              d = l.buttonView;
            return Ch(l, c), d.set({
              label: sk(a, i.label),
              class: null,
              tooltip: !0
            }), d.bind("icon").toMany(c, "isOn", function () {
              for (var _len25 = arguments.length, t = new Array(_len25), _key25 = 0; _key25 < _len25; _key25++) {
                t[_key25] = arguments[_key25];
              }
              var e = t.findIndex(X);
              return e < 0 ? i.icon : c[e].icon;
            }), d.bind("label").toMany(c, "isOn", function () {
              for (var _len26 = arguments.length, t = new Array(_len26), _key26 = 0; _key26 < _len26; _key26++) {
                t[_key26] = arguments[_key26];
              }
              var e = t.findIndex(X);
              return sk(a, e < 0 ? i.label : c[e].label);
            }), d.bind("isOn").toMany(c, "isOn", function () {
              for (var _len27 = arguments.length, t = new Array(_len27), _key27 = 0; _key27 < _len27; _key27++) {
                t[_key27] = arguments[_key27];
              }
              return t.some(X);
            }), d.bind("class").toMany(c, "isOn", function () {
              for (var _len28 = arguments.length, t = new Array(_len28), _key28 = 0; _key28 < _len28; _key28++) {
                t[_key28] = arguments[_key28];
              }
              return t.some(X) ? "ck-splitbutton_flatten" : null;
            }), d.on("execute", function () {
              c.some(function (_ref68) {
                var t = _ref68.isOn;
                return t;
              }) ? l.isOpen = !l.isOpen : i.fire("execute");
            }), l.bind("isEnabled").toMany(c, "isEnabled", function () {
              for (var _len29 = arguments.length, t = new Array(_len29), _key29 = 0; _key29 < _len29; _key29++) {
                t[_key29] = arguments[_key29];
              }
              return t.some(X);
            }), l;
          });
        }
      }, {
        key: "_createButton",
        value: function _createButton(t) {
          var _this241 = this;
          var e = t.name;
          this.editor.ui.componentFactory.add(rk(e), function (n) {
            var o = _this241.editor.commands.get("imageStyle"),
              i = new Sd(n);
            return i.set({
              label: t.title,
              icon: t.icon,
              tooltip: !0,
              isToggleable: !0
            }), i.bind("isEnabled").to(o, "isEnabled"), i.bind("isOn").to(o, "value", function (t) {
              return t === e;
            }), i.on("execute", _this241._executeCommand.bind(_this241, e)), i;
          });
        }
      }, {
        key: "_executeCommand",
        value: function _executeCommand(t) {
          this.editor.execute("imageStyle", {
            value: t
          }), this.editor.editing.view.focus();
        }
      }, {
        key: "localizedDefaultStylesTitles",
        get: function get() {
          var t = this.editor.t;
          return {
            "Wrap text": t("Wrap text"),
            "Break text": t("Break text"),
            "In line": t("In line"),
            "Full size image": t("Full size image"),
            "Side image": t("Side image"),
            "Left aligned image": t("Left aligned image"),
            "Centered image": t("Centered image"),
            "Right aligned image": t("Right aligned image")
          };
        }
      }], [{
        key: "requires",
        get: function get() {
          return [tk];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "ImageStyleUI";
        }
      }]);
      return ok;
    }(Jt);
    function ik(t, e) {
      var _iterator362 = _createForOfIteratorHelper(t),
        _step362;
      try {
        for (_iterator362.s(); !(_step362 = _iterator362.n()).done;) {
          var _n252 = _step362.value;
          e[_n252.title] && (_n252.title = e[_n252.title]);
        }
      } catch (err) {
        _iterator362.e(err);
      } finally {
        _iterator362.f();
      }
      return t;
    }
    function rk(t) {
      return "imageStyle:".concat(t);
    }
    function sk(t, e) {
      return (t ? t + ": " : "") + e;
    }
    var ak = /*#__PURE__*/function () {
      function ak() {
        var _this242 = this;
        _classCallCheck(this, ak);
        var t = new window.FileReader();
        this._reader = t, this._data = void 0, this.set("loaded", 0), t.onprogress = function (t) {
          _this242.loaded = t.loaded;
        };
      }
      _createClass(ak, [{
        key: "read",
        value: function read(t) {
          var _this243 = this;
          var e = this._reader;
          return this.total = t.size, new Promise(function (n, o) {
            e.onload = function () {
              var t = e.result;
              _this243._data = t, n(t);
            }, e.onerror = function () {
              o("error");
            }, e.onabort = function () {
              o("aborted");
            }, _this243._reader.readAsDataURL(t);
          });
        }
      }, {
        key: "abort",
        value: function abort() {
          this._reader.abort();
        }
      }, {
        key: "error",
        get: function get() {
          return this._reader.error;
        }
      }, {
        key: "data",
        get: function get() {
          return this._data;
        }
      }]);
      return ak;
    }();
    $t(ak, Gt);
    var ck = /*#__PURE__*/function (_Jt50) {
      _inherits(ck, _Jt50);
      function ck() {
        _classCallCheck(this, ck);
        return _possibleConstructorReturn(this, _getPrototypeOf(ck).apply(this, arguments));
      }
      _createClass(ck, [{
        key: "init",
        value: function init() {
          var _this244 = this;
          this.loaders = new co(), this.loaders.on("add", function () {
            return _this244._updatePendingAction();
          }), this.loaders.on("remove", function () {
            return _this244._updatePendingAction();
          }), this._loadersMap = new Map(), this._pendingAction = null, this.set("uploaded", 0), this.set("uploadTotal", null), this.bind("uploadedPercent").to(this, "uploaded", this, "uploadTotal", function (t, e) {
            return e ? t / e * 100 : 0;
          });
        }
      }, {
        key: "getLoader",
        value: function getLoader(t) {
          return this._loadersMap.get(t) || null;
        }
      }, {
        key: "createLoader",
        value: function createLoader(t) {
          var _this245 = this;
          if (!this.createUploadAdapter) return Object(c.b)("filerepository-no-upload-adapter"), null;
          var e = new lk(Promise.resolve(t), this.createUploadAdapter);
          return this.loaders.add(e), this._loadersMap.set(t, e), t instanceof Promise && e.file.then(function (t) {
            _this245._loadersMap.set(t, e);
          }).catch(function () {}), e.on("change:uploaded", function () {
            var t = 0;
            var _iterator363 = _createForOfIteratorHelper(_this245.loaders),
              _step363;
            try {
              for (_iterator363.s(); !(_step363 = _iterator363.n()).done;) {
                var _e273 = _step363.value;
                t += _e273.uploaded;
              }
            } catch (err) {
              _iterator363.e(err);
            } finally {
              _iterator363.f();
            }
            _this245.uploaded = t;
          }), e.on("change:uploadTotal", function () {
            var t = 0;
            var _iterator364 = _createForOfIteratorHelper(_this245.loaders),
              _step364;
            try {
              for (_iterator364.s(); !(_step364 = _iterator364.n()).done;) {
                var _e274 = _step364.value;
                _e274.uploadTotal && (t += _e274.uploadTotal);
              }
            } catch (err) {
              _iterator364.e(err);
            } finally {
              _iterator364.f();
            }
            _this245.uploadTotal = t;
          }), e;
        }
      }, {
        key: "destroyLoader",
        value: function destroyLoader(t) {
          var _this246 = this;
          var e = t instanceof lk ? t : this.getLoader(t);
          e._destroy(), this.loaders.remove(e), this._loadersMap.forEach(function (t, n) {
            t === e && _this246._loadersMap.delete(n);
          });
        }
      }, {
        key: "_updatePendingAction",
        value: function _updatePendingAction() {
          var t = this.editor.plugins.get(Wl);
          if (this.loaders.length) {
            if (!this._pendingAction) {
              var _e275 = this.editor.t,
                _n253 = function _n253(t) {
                  return "".concat(_e275("Upload in progress"), " ").concat(parseInt(t), "%.");
                };
              this._pendingAction = t.add(_n253(this.uploadedPercent)), this._pendingAction.bind("message").to(this, "uploadedPercent", _n253);
            }
          } else t.remove(this._pendingAction), this._pendingAction = null;
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "FileRepository";
        }
      }, {
        key: "requires",
        get: function get() {
          return [Wl];
        }
      }]);
      return ck;
    }(Jt);
    $t(ck, Gt);
    var lk = /*#__PURE__*/function () {
      function lk(t, e) {
        _classCallCheck(this, lk);
        this.id = s(), this._filePromiseWrapper = this._createFilePromiseWrapper(t), this._adapter = e(this), this._reader = new ak(), this.set("status", "idle"), this.set("uploaded", 0), this.set("uploadTotal", null), this.bind("uploadedPercent").to(this, "uploaded", this, "uploadTotal", function (t, e) {
          return e ? t / e * 100 : 0;
        }), this.set("uploadResponse", null);
      }
      _createClass(lk, [{
        key: "read",
        value: function read() {
          var _this247 = this;
          if ("idle" != this.status) throw new c.a("filerepository-read-wrong-status", this);
          return this.status = "reading", this.file.then(function (t) {
            return _this247._reader.read(t);
          }).then(function (t) {
            if ("reading" !== _this247.status) throw _this247.status;
            return _this247.status = "idle", t;
          }).catch(function (t) {
            if ("aborted" === t) throw _this247.status = "aborted", "aborted";
            throw _this247.status = "error", _this247._reader.error ? _this247._reader.error : t;
          });
        }
      }, {
        key: "upload",
        value: function upload() {
          var _this248 = this;
          if ("idle" != this.status) throw new c.a("filerepository-upload-wrong-status", this);
          return this.status = "uploading", this.file.then(function () {
            return _this248._adapter.upload();
          }).then(function (t) {
            return _this248.uploadResponse = t, _this248.status = "idle", t;
          }).catch(function (t) {
            if ("aborted" === _this248.status) throw "aborted";
            throw _this248.status = "error", t;
          });
        }
      }, {
        key: "abort",
        value: function abort() {
          var t = this.status;
          this.status = "aborted", this._filePromiseWrapper.isFulfilled ? "reading" == t ? this._reader.abort() : "uploading" == t && this._adapter.abort && this._adapter.abort() : (this._filePromiseWrapper.promise.catch(function () {}), this._filePromiseWrapper.rejecter("aborted")), this._destroy();
        }
      }, {
        key: "_destroy",
        value: function _destroy() {
          this._filePromiseWrapper = void 0, this._reader = void 0, this._adapter = void 0, this.uploadResponse = void 0;
        }
      }, {
        key: "_createFilePromiseWrapper",
        value: function _createFilePromiseWrapper(t) {
          var e = {};
          return e.promise = new Promise(function (n, o) {
            e.rejecter = o, e.isFulfilled = !1, t.then(function (t) {
              e.isFulfilled = !0, n(t);
            }).catch(function (t) {
              e.isFulfilled = !0, o(t);
            });
          }), e;
        }
      }, {
        key: "file",
        get: function get() {
          var _this249 = this;
          return this._filePromiseWrapper ? this._filePromiseWrapper.promise.then(function (t) {
            return _this249._filePromiseWrapper ? t : null;
          }) : Promise.resolve(null);
        }
      }, {
        key: "data",
        get: function get() {
          return this._reader.data;
        }
      }]);
      return lk;
    }();
    $t(lk, Gt);
    var dk = /*#__PURE__*/function (_ed27) {
      _inherits(dk, _ed27);
      function dk(t) {
        var _this250;
        _classCallCheck(this, dk);
        _this250 = _possibleConstructorReturn(this, _getPrototypeOf(dk).call(this, t)), _this250.buttonView = new Sd(t), _this250._fileInputView = new hk(t), _this250._fileInputView.bind("acceptedType").to(_assertThisInitialized(_assertThisInitialized(_this250))), _this250._fileInputView.bind("allowMultipleFiles").to(_assertThisInitialized(_assertThisInitialized(_this250))), _this250._fileInputView.delegate("done").to(_assertThisInitialized(_assertThisInitialized(_this250))), _this250.setTemplate({
          tag: "span",
          attributes: {
            class: "ck-file-dialog-button"
          },
          children: [_this250.buttonView, _this250._fileInputView]
        }), _this250.buttonView.on("execute", function () {
          _this250._fileInputView.open();
        });
        return _this250;
      }
      _createClass(dk, [{
        key: "focus",
        value: function focus() {
          this.buttonView.focus();
        }
      }]);
      return dk;
    }(ed);
    var hk = /*#__PURE__*/function (_ed28) {
      _inherits(hk, _ed28);
      function hk(t) {
        var _this251;
        _classCallCheck(this, hk);
        _this251 = _possibleConstructorReturn(this, _getPrototypeOf(hk).call(this, t)), _this251.set("acceptedType"), _this251.set("allowMultipleFiles", !1);
        var e = _this251.bindTemplate;
        _this251.setTemplate({
          tag: "input",
          attributes: {
            class: ["ck-hidden"],
            type: "file",
            tabindex: "-1",
            accept: e.to("acceptedType"),
            multiple: e.to("allowMultipleFiles")
          },
          on: {
            change: e.to(function () {
              _this251.element && _this251.element.files && _this251.element.files.length && _this251.fire("done", _this251.element.files), _this251.element.value = "";
            })
          }
        });
        return _this251;
      }
      _createClass(hk, [{
        key: "open",
        value: function open() {
          this.element.click();
        }
      }]);
      return hk;
    }(ed);
    var uk = /*#__PURE__*/function () {
      function uk(t, e) {
        _classCallCheck(this, uk);
        this.loader = t, this.options = e;
      }
      _createClass(uk, [{
        key: "upload",
        value: function upload() {
          var _this252 = this;
          return this.loader.file.then(function (t) {
            return new Promise(function (e, n) {
              _this252._initRequest(), _this252._initListeners(e, n, t), _this252._sendRequest(t);
            });
          });
        }
      }, {
        key: "abort",
        value: function abort() {
          this.xhr && this.xhr.abort();
        }
      }, {
        key: "_initRequest",
        value: function _initRequest() {
          var t = this.xhr = new XMLHttpRequest();
          t.open("POST", this.options.uploadUrl, !0), t.responseType = "json";
        }
      }, {
        key: "_initListeners",
        value: function _initListeners(t, e, n) {
          var o = this.xhr,
            i = this.loader,
            r = "Couldn't upload file: ".concat(n.name, ".");
          o.addEventListener("error", function () {
            return e(r);
          }), o.addEventListener("abort", function () {
            return e();
          }), o.addEventListener("load", function () {
            var n = o.response;
            if (!n || n.error) return e(n && n.error && n.error.message ? n.error.message : r);
            var i = n.url ? {
              default: n.url
            } : n.urls;
            t(_objectSpread({}, n, {
              urls: i
            }));
          }), o.upload && o.upload.addEventListener("progress", function (t) {
            t.lengthComputable && (i.uploadTotal = t.total, i.uploaded = t.loaded);
          });
        }
      }, {
        key: "_sendRequest",
        value: function _sendRequest(t) {
          var e = this.options.headers || {},
            n = this.options.withCredentials || !1;
          for (var _i135 = 0, _Object$keys4 = Object.keys(e); _i135 < _Object$keys4.length; _i135++) {
            var _t288 = _Object$keys4[_i135];
            this.xhr.setRequestHeader(_t288, e[_t288]);
          }
          this.xhr.withCredentials = n;
          var o = new FormData();
          o.append("upload", t), this.xhr.send(o);
        }
      }]);
      return uk;
    }();
    function gk(t) {
      var e = t.map(function (t) {
        return t.replace("+", "\\+");
      });
      return new RegExp("^image\\/(".concat(e.join("|"), ")$"));
    }
    function mk(t) {
      return new Promise(function (e, n) {
        var o = t.getAttribute("src");
        fetch(o).then(function (t) {
          return t.blob();
        }).then(function (t) {
          var n = pk(t, o),
            i = n.replace("image/", ""),
            r = new File([t], "image.".concat(i), {
              type: n
            });
          e(r);
        }).catch(function (t) {
          return t && "TypeError" === t.name ? function (t) {
            return function (t) {
              return new Promise(function (e, n) {
                var o = Sr.document.createElement("img");
                o.addEventListener("load", function () {
                  var t = Sr.document.createElement("canvas");
                  t.width = o.width, t.height = o.height;
                  t.getContext("2d").drawImage(o, 0, 0), t.toBlob(function (t) {
                    return t ? e(t) : n();
                  });
                }), o.addEventListener("error", function () {
                  return n();
                }), o.src = t;
              });
            }(t).then(function (e) {
              var n = pk(e, t),
                o = n.replace("image/", "");
              return new File([e], "image.".concat(o), {
                type: n
              });
            });
          }(o).then(e).catch(n) : n(t);
        });
      });
    }
    function pk(t, e) {
      return t.type ? t.type : e.match(/data:(image\/\w+);base64/) ? e.match(/data:(image\/\w+);base64/)[1].toLowerCase() : "image/jpeg";
    }
    var fk = /*#__PURE__*/function (_Jt51) {
      _inherits(fk, _Jt51);
      function fk() {
        _classCallCheck(this, fk);
        return _possibleConstructorReturn(this, _getPrototypeOf(fk).apply(this, arguments));
      }
      _createClass(fk, [{
        key: "init",
        value: function init() {
          var t = this.editor,
            e = t.t,
            n = function n(_n254) {
              var o = new dk(_n254),
                i = t.commands.get("uploadImage"),
                r = t.config.get("image.upload.types"),
                s = gk(r);
              return o.set({
                acceptedType: r.map(function (t) {
                  return "image/".concat(t);
                }).join(","),
                allowMultipleFiles: !0
              }), o.buttonView.set({
                label: e("Insert image"),
                icon: ql.image,
                tooltip: !0
              }), o.buttonView.bind("isEnabled").to(i), o.on("done", function (e, n) {
                var o = Array.from(n).filter(function (t) {
                  return s.test(t.type);
                });
                o.length && t.execute("uploadImage", {
                  file: o
                });
              }), o;
            };
          t.ui.componentFactory.add("uploadImage", n), t.ui.componentFactory.add("imageUpload", n);
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "ImageUploadUI";
        }
      }]);
      return fk;
    }(Jt);
    var kk = n(49),
      bk = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      },
      wk = (Zl()(kk.a, bk), kk.a.locals, n(50)),
      Ck = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      },
      Ak = (Zl()(wk.a, Ck), wk.a.locals, n(51)),
      _k = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Zl()(Ak.a, _k), Ak.a.locals;
    var vk = /*#__PURE__*/function (_Jt52) {
      _inherits(vk, _Jt52);
      _createClass(vk, null, [{
        key: "pluginName",
        get: function get() {
          return "ImageUploadProgress";
        }
      }]);
      function vk(t) {
        var _this253;
        _classCallCheck(this, vk);
        _this253 = _possibleConstructorReturn(this, _getPrototypeOf(vk).call(this, t)), _this253.placeholder = "data:image/svg+xml;utf8," + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 700 250"><rect rx="4"/></svg>');
        return _this253;
      }
      _createClass(vk, [{
        key: "init",
        value: function init() {
          var _this254 = this;
          var t = this.editor;
          t.plugins.has("ImageBlockEditing") && t.editing.downcastDispatcher.on("attribute:uploadStatus:imageBlock", function () {
            return _this254.uploadStatusChange.apply(_this254, arguments);
          }), t.plugins.has("ImageInlineEditing") && t.editing.downcastDispatcher.on("attribute:uploadStatus:imageInline", function () {
            return _this254.uploadStatusChange.apply(_this254, arguments);
          });
        }
      }, {
        key: "uploadStatusChange",
        value: function uploadStatusChange(t, e, n) {
          var o = this.editor,
            i = e.item,
            r = i.getAttribute("uploadId");
          if (!n.consumable.consume(e.item, t.name)) return;
          var s = o.plugins.get("ImageUtils"),
            a = o.plugins.get(ck),
            c = r ? e.attributeNewValue : null,
            l = this.placeholder,
            d = o.editing.mapper.toViewElement(i),
            h = n.writer;
          if ("reading" == c) return yk(d, h), void xk(s, l, d, h);
          if ("uploading" == c) {
            var _t289 = a.loaders.get(r);
            return yk(d, h), void (_t289 ? (Ek(d, h), function (t, e, n, o) {
              var i = function (t) {
                var e = t.createUIElement("div", {
                  class: "ck-progress-bar"
                });
                return t.setCustomProperty("progressBar", !0, e), e;
              }(e);
              e.insert(e.createPositionAt(t, "end"), i), n.on("change:uploadedPercent", function (t, e, n) {
                o.change(function (t) {
                  t.setStyle("width", n + "%", i);
                });
              });
            }(d, h, _t289, o.editing.view), function (t, e, n, o) {
              if (o.data) {
                var _i136 = t.getViewImageFromWidget(e);
                n.setAttribute("src", o.data, _i136);
              }
            }(s, d, h, _t289)) : xk(s, l, d, h));
          }
          "complete" == c && a.loaders.get(r) && function (t, e, n) {
            var o = e.createUIElement("div", {
              class: "ck-image-upload-complete-icon"
            });
            e.insert(e.createPositionAt(t, "end"), o), setTimeout(function () {
              n.change(function (t) {
                return t.remove(t.createRangeOn(o));
              });
            }, 3e3);
          }(d, h, o.editing.view), function (t, e) {
            Mk(t, e, "progressBar");
          }(d, h), Ek(d, h), function (t, e) {
            e.removeClass("ck-appear", t);
          }(d, h);
        }
      }]);
      return vk;
    }(Jt);
    function yk(t, e) {
      t.hasClass("ck-appear") || e.addClass("ck-appear", t);
    }
    function xk(t, e, n, o) {
      n.hasClass("ck-image-upload-placeholder") || o.addClass("ck-image-upload-placeholder", n);
      var i = t.getViewImageFromWidget(n);
      i.getAttribute("src") !== e && o.setAttribute("src", e, i), Dk(n, "placeholder") || o.insert(o.createPositionAfter(i), function (t) {
        var e = t.createUIElement("div", {
          class: "ck-upload-placeholder-loader"
        });
        return t.setCustomProperty("placeholder", !0, e), e;
      }(o));
    }
    function Ek(t, e) {
      t.hasClass("ck-image-upload-placeholder") && e.removeClass("ck-image-upload-placeholder", t), Mk(t, e, "placeholder");
    }
    function Dk(t, e) {
      var _iterator365 = _createForOfIteratorHelper(t.getChildren()),
        _step365;
      try {
        for (_iterator365.s(); !(_step365 = _iterator365.n()).done;) {
          var _n255 = _step365.value;
          if (_n255.getCustomProperty(e)) return _n255;
        }
      } catch (err) {
        _iterator365.e(err);
      } finally {
        _iterator365.f();
      }
    }
    function Mk(t, e, n) {
      var o = Dk(t, n);
      o && e.remove(e.createRangeOn(o));
    }
    var Ik = /*#__PURE__*/function (_Xt20) {
      _inherits(Ik, _Xt20);
      function Ik() {
        _classCallCheck(this, Ik);
        return _possibleConstructorReturn(this, _getPrototypeOf(Ik).apply(this, arguments));
      }
      _createClass(Ik, [{
        key: "refresh",
        value: function refresh() {
          var t = this.editor,
            e = t.plugins.get("ImageUtils"),
            n = t.model.document.selection.getSelectedElement();
          this.isEnabled = e.isImageAllowed() || e.isImage(n);
        }
      }, {
        key: "execute",
        value: function execute(t) {
          var _this255 = this;
          var e = ho(t.file),
            n = this.editor.model.document.selection,
            o = this.editor.plugins.get("ImageUtils"),
            i = Object.fromEntries(n.getAttributes());
          e.forEach(function (t, e) {
            var r = n.getSelectedElement();
            if (e && r && o.isImage(r)) {
              var _e276 = _this255.editor.model.createPositionAfter(r);
              _this255._uploadImage(t, i, _e276);
            } else _this255._uploadImage(t, i);
          });
        }
      }, {
        key: "_uploadImage",
        value: function _uploadImage(t, e, n) {
          var o = this.editor,
            i = o.plugins.get(ck).createLoader(t),
            r = o.plugins.get("ImageUtils");
          i && r.insertImage(_objectSpread({}, e, {
            uploadId: i.id
          }), n);
        }
      }]);
      return Ik;
    }(Xt);
    var Tk = /*#__PURE__*/function (_Jt53) {
      _inherits(Tk, _Jt53);
      _createClass(Tk, null, [{
        key: "requires",
        get: function get() {
          return [ck, Fh, im, lf];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "ImageUploadEditing";
        }
      }]);
      function Tk(t) {
        var _this256;
        _classCallCheck(this, Tk);
        _this256 = _possibleConstructorReturn(this, _getPrototypeOf(Tk).call(this, t)), t.config.define("image", {
          upload: {
            types: ["jpeg", "png", "gif", "bmp", "webp", "tiff"]
          }
        }), _this256._uploadImageElements = new Map();
        return _this256;
      }
      _createClass(Tk, [{
        key: "init",
        value: function init() {
          var _this257 = this;
          var t = this.editor,
            e = t.model.document,
            n = t.conversion,
            o = t.plugins.get(ck),
            i = t.plugins.get("ImageUtils"),
            r = gk(t.config.get("image.upload.types")),
            s = new Ik(t);
          t.commands.add("uploadImage", s), t.commands.add("imageUpload", s), n.for("upcast").attributeToAttribute({
            view: {
              name: "img",
              key: "uploadId"
            },
            model: "uploadId"
          }), this.listenTo(t.editing.view.document, "clipboardInput", function (e, n) {
            if (o = n.dataTransfer, Array.from(o.types).includes("text/html") && "" !== o.getData("text/html")) return;
            var o;
            var i = Array.from(n.dataTransfer.files).filter(function (t) {
              return !!t && r.test(t.type);
            });
            i.length && (e.stop(), t.model.change(function (e) {
              n.targetRanges && e.setSelection(n.targetRanges.map(function (e) {
                return t.editing.mapper.toModelRange(e);
              })), t.model.enqueueChange("default", function () {
                t.execute("uploadImage", {
                  file: i
                });
              });
            }));
          }), this.listenTo(t.plugins.get("ClipboardPipeline"), "inputTransformation", function (e, n) {
            var r = Array.from(t.editing.view.createRangeIn(n.content)).filter(function (t) {
              return function (t, e) {
                return !(!t.isInlineImageView(e) || !e.getAttribute("src")) && (e.getAttribute("src").match(/^data:image\/\w+;base64,/g) || e.getAttribute("src").match(/^blob:/g));
              }(i, t.item) && !t.item.getAttribute("uploadProcessed");
            }).map(function (t) {
              return {
                promise: mk(t.item),
                imageElement: t.item
              };
            });
            if (!r.length) return;
            var s = new Su(t.editing.view.document);
            var _iterator366 = _createForOfIteratorHelper(r),
              _step366;
            try {
              for (_iterator366.s(); !(_step366 = _iterator366.n()).done;) {
                var _t290 = _step366.value;
                s.setAttribute("uploadProcessed", !0, _t290.imageElement);
                var _e277 = o.createLoader(_t290.promise);
                _e277 && (s.setAttribute("src", "", _t290.imageElement), s.setAttribute("uploadId", _e277.id, _t290.imageElement));
              }
            } catch (err) {
              _iterator366.e(err);
            } finally {
              _iterator366.f();
            }
          }), t.editing.view.document.on("dragover", function (t, e) {
            e.preventDefault();
          }), e.on("change", function () {
            var n = e.differ.getChanges({
                includeChangesInGraveyard: !0
              }).reverse(),
              i = new Set();
            var _iterator367 = _createForOfIteratorHelper(n),
              _step367;
            try {
              for (_iterator367.s(); !(_step367 = _iterator367.n()).done;) {
                var _e278 = _step367.value;
                if ("insert" == _e278.type && "$text" != _e278.name) {
                  var _n256 = _e278.position.nodeAfter,
                    _r57 = "$graveyard" == _e278.position.root.rootName;
                  var _iterator368 = _createForOfIteratorHelper(Sk(t, _n256)),
                    _step368;
                  try {
                    for (_iterator368.s(); !(_step368 = _iterator368.n()).done;) {
                      var _e279 = _step368.value;
                      var _t291 = _e279.getAttribute("uploadId");
                      if (!_t291) continue;
                      var _n257 = o.loaders.get(_t291);
                      _n257 && (_r57 ? i.has(_t291) || _n257.abort() : (i.add(_t291), _this257._uploadImageElements.set(_t291, _e279), "idle" == _n257.status && _this257._readAndUpload(_n257)));
                    }
                  } catch (err) {
                    _iterator368.e(err);
                  } finally {
                    _iterator368.f();
                  }
                }
              }
            } catch (err) {
              _iterator367.e(err);
            } finally {
              _iterator367.f();
            }
          }), this.on("uploadComplete", function (t, _ref69) {
            var e = _ref69.imageElement,
              n = _ref69.data;
            var o = n.urls ? n.urls : n;
            _this257.editor.model.change(function (t) {
              t.setAttribute("src", o.default, e), _this257._parseAndSetSrcsetAttributeOnImage(o, e, t);
            });
          }, {
            priority: "low"
          });
        }
      }, {
        key: "afterInit",
        value: function afterInit() {
          var t = this.editor.model.schema;
          this.editor.plugins.has("ImageBlockEditing") && t.extend("imageBlock", {
            allowAttributes: ["uploadId", "uploadStatus"]
          }), this.editor.plugins.has("ImageInlineEditing") && t.extend("imageInline", {
            allowAttributes: ["uploadId", "uploadStatus"]
          });
        }
      }, {
        key: "_readAndUpload",
        value: function _readAndUpload(t) {
          var _this258 = this;
          var e = this.editor,
            n = e.model,
            o = e.locale.t,
            i = e.plugins.get(ck),
            r = e.plugins.get(Fh),
            s = e.plugins.get("ImageUtils"),
            a = this._uploadImageElements;
          return n.enqueueChange("transparent", function (e) {
            e.setAttribute("uploadStatus", "reading", a.get(t.id));
          }), t.read().then(function () {
            var o = t.upload(),
              i = a.get(t.id);
            if (Ri.isSafari) {
              var _t292 = e.editing.mapper.toViewElement(i),
                _n258 = s.getViewImageFromWidget(_t292);
              e.editing.view.once("render", function () {
                if (!_n258.parent) return;
                var t = e.editing.view.domConverter.mapViewToDom(_n258.parent);
                if (!t) return;
                var o = t.style.display;
                t.style.display = "none", t._ckHack = t.offsetHeight, t.style.display = o;
              });
            }
            return n.enqueueChange("transparent", function (t) {
              t.setAttribute("uploadStatus", "uploading", i);
            }), o;
          }).then(function (e) {
            n.enqueueChange("transparent", function (n) {
              var o = a.get(t.id);
              n.setAttribute("uploadStatus", "complete", o), _this258.fire("uploadComplete", {
                data: e,
                imageElement: o
              });
            }), c();
          }).catch(function (e) {
            if ("error" !== t.status && "aborted" !== t.status) throw e;
            "error" == t.status && e && r.showWarning(e, {
              title: o("Upload failed"),
              namespace: "upload"
            }), n.enqueueChange("transparent", function (e) {
              e.remove(a.get(t.id));
            }), c();
          });
          function c() {
            n.enqueueChange("transparent", function (e) {
              var n = a.get(t.id);
              e.removeAttribute("uploadId", n), e.removeAttribute("uploadStatus", n), a.delete(t.id);
            }), i.destroyLoader(t);
          }
        }
      }, {
        key: "_parseAndSetSrcsetAttributeOnImage",
        value: function _parseAndSetSrcsetAttributeOnImage(t, e, n) {
          var o = 0;
          var i = Object.keys(t).filter(function (t) {
            var e = parseInt(t, 10);
            if (!isNaN(e)) return o = Math.max(o, e), !0;
          }).map(function (e) {
            return "".concat(t[e], " ").concat(e, "w");
          }).join(", ");
          "" != i && n.setAttribute("srcset", {
            data: i,
            width: o
          }, e);
        }
      }]);
      return Tk;
    }(Jt);
    function Sk(t, e) {
      var n = t.plugins.get("ImageUtils");
      return Array.from(t.model.createRangeOn(e)).filter(function (t) {
        return n.isImage(t.item);
      }).map(function (t) {
        return t.item;
      });
    }
    var Nk = /*#__PURE__*/function (_Jt54) {
      _inherits(Nk, _Jt54);
      function Nk() {
        _classCallCheck(this, Nk);
        return _possibleConstructorReturn(this, _getPrototypeOf(Nk).apply(this, arguments));
      }
      _createClass(Nk, [{
        key: "init",
        value: function init() {
          var t = this.editor;
          t.commands.add("indent", new ee(t)), t.commands.add("outdent", new ee(t));
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "IndentEditing";
        }
      }]);
      return Nk;
    }(Jt);
    var Bk = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm5 6c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zM2.75 16.5h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 1 0 0 1.5zM1.632 6.95 5.02 9.358a.4.4 0 0 1-.013.661l-3.39 2.207A.4.4 0 0 1 1 11.892V7.275a.4.4 0 0 1 .632-.326z"/></svg>',
      Pk = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm5 6c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zM2.75 16.5h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 1 0 0 1.5zm1.618-9.55L.98 9.358a.4.4 0 0 0 .013.661l3.39 2.207A.4.4 0 0 0 5 11.892V7.275a.4.4 0 0 0-.632-.326z"/></svg>';
    var zk = /*#__PURE__*/function (_Jt55) {
      _inherits(zk, _Jt55);
      function zk() {
        _classCallCheck(this, zk);
        return _possibleConstructorReturn(this, _getPrototypeOf(zk).apply(this, arguments));
      }
      _createClass(zk, [{
        key: "init",
        value: function init() {
          var t = this.editor,
            e = t.locale,
            n = t.t,
            o = "ltr" == e.uiLanguageDirection ? Bk : Pk,
            i = "ltr" == e.uiLanguageDirection ? Pk : Bk;
          this._defineButton("indent", n("Increase indent"), o), this._defineButton("outdent", n("Decrease indent"), i);
        }
      }, {
        key: "_defineButton",
        value: function _defineButton(t, e, n) {
          var _this259 = this;
          var o = this.editor;
          o.ui.componentFactory.add(t, function (i) {
            var r = o.commands.get(t),
              s = new Sd(i);
            return s.set({
              label: e,
              icon: n,
              tooltip: !0
            }), s.bind("isOn", "isEnabled").to(r, "value", "isEnabled"), _this259.listenTo(s, "execute", function () {
              o.execute(t), o.editing.view.focus();
            }), s;
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "IndentUI";
        }
      }]);
      return zk;
    }(Jt);
    var Lk = "italic";
    var Ok = /*#__PURE__*/function (_Jt56) {
      _inherits(Ok, _Jt56);
      function Ok() {
        _classCallCheck(this, Ok);
        return _possibleConstructorReturn(this, _getPrototypeOf(Ok).apply(this, arguments));
      }
      _createClass(Ok, [{
        key: "init",
        value: function init() {
          var t = this.editor;
          t.model.schema.extend("$text", {
            allowAttributes: Lk
          }), t.model.schema.setAttributeProperties(Lk, {
            isFormatting: !0,
            copyOnEnter: !0
          }), t.conversion.attributeToElement({
            model: Lk,
            view: "i",
            upcastAlso: ["em", {
              styles: {
                "font-style": "italic"
              }
            }]
          }), t.commands.add(Lk, new Qg(t, Lk)), t.keystrokes.set("CTRL+I", Lk);
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "ItalicEditing";
        }
      }]);
      return Ok;
    }(Jt);
    var Rk = "italic";
    var jk = /*#__PURE__*/function (_Jt57) {
      _inherits(jk, _Jt57);
      function jk() {
        _classCallCheck(this, jk);
        return _possibleConstructorReturn(this, _getPrototypeOf(jk).apply(this, arguments));
      }
      _createClass(jk, [{
        key: "init",
        value: function init() {
          var _this260 = this;
          var t = this.editor,
            e = t.t;
          t.ui.componentFactory.add(Rk, function (n) {
            var o = t.commands.get(Rk),
              i = new Sd(n);
            return i.set({
              label: e("Italic"),
              icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m9.586 14.633.021.004c-.036.335.095.655.393.962.082.083.173.15.274.201h1.474a.6.6 0 1 1 0 1.2H5.304a.6.6 0 0 1 0-1.2h1.15c.474-.07.809-.182 1.005-.334.157-.122.291-.32.404-.597l2.416-9.55a1.053 1.053 0 0 0-.281-.823 1.12 1.12 0 0 0-.442-.296H8.15a.6.6 0 0 1 0-1.2h6.443a.6.6 0 1 1 0 1.2h-1.195c-.376.056-.65.155-.823.296-.215.175-.423.439-.623.79l-2.366 9.347z"/></svg>',
              keystroke: "CTRL+I",
              tooltip: !0,
              isToggleable: !0
            }), i.bind("isOn", "isEnabled").to(o, "value", "isEnabled"), _this260.listenTo(i, "execute", function () {
              t.execute(Rk), t.editing.view.focus();
            }), i;
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "ItalicUI";
        }
      }]);
      return jk;
    }(Jt);
    var Fk = /*#__PURE__*/function () {
      function Fk() {
        _classCallCheck(this, Fk);
        this._definitions = new Set();
      }
      _createClass(Fk, [{
        key: "add",
        value: function add(t) {
          var _this261 = this;
          Array.isArray(t) ? t.forEach(function (t) {
            return _this261._definitions.add(t);
          }) : this._definitions.add(t);
        }
      }, {
        key: "getDispatcher",
        value: function getDispatcher() {
          var _this262 = this;
          return function (t) {
            t.on("attribute:linkHref", function (t, e, n) {
              if (!n.consumable.test(e.item, "attribute:linkHref")) return;
              var o = n.writer,
                i = o.document.selection;
              var _iterator369 = _createForOfIteratorHelper(_this262._definitions),
                _step369;
              try {
                for (_iterator369.s(); !(_step369 = _iterator369.n()).done;) {
                  var _t293 = _step369.value;
                  var _r58 = o.createAttributeElement("a", _t293.attributes, {
                    priority: 5
                  });
                  o.setCustomProperty("link", !0, _r58), _t293.callback(e.attributeNewValue) ? e.item.is("selection") ? o.wrap(i.getFirstRange(), _r58) : o.wrap(n.mapper.toViewRange(e.range), _r58) : o.unwrap(n.mapper.toViewRange(e.range), _r58);
                }
              } catch (err) {
                _iterator369.e(err);
              } finally {
                _iterator369.f();
              }
            }, {
              priority: "high"
            });
          };
        }
      }, {
        key: "getDispatcherForLinkedImage",
        value: function getDispatcherForLinkedImage() {
          var _this263 = this;
          return function (t) {
            t.on("attribute:linkHref:imageBlock", function (t, e, n) {
              var o = n.mapper.toViewElement(e.item),
                i = Array.from(o.getChildren()).find(function (t) {
                  return "a" === t.name;
                });
              var _iterator370 = _createForOfIteratorHelper(_this263._definitions),
                _step370;
              try {
                for (_iterator370.s(); !(_step370 = _iterator370.n()).done;) {
                  var _t294 = _step370.value;
                  var _o167 = vo(_t294.attributes);
                  if (_t294.callback(e.attributeNewValue)) {
                    var _iterator371 = _createForOfIteratorHelper(_o167),
                      _step371;
                    try {
                      for (_iterator371.s(); !(_step371 = _iterator371.n()).done;) {
                        var _step371$value = _slicedToArray(_step371.value, 2),
                          _t295 = _step371$value[0],
                          _e280 = _step371$value[1];
                        "class" === _t295 ? n.writer.addClass(_e280, i) : n.writer.setAttribute(_t295, _e280, i);
                      }
                    } catch (err) {
                      _iterator371.e(err);
                    } finally {
                      _iterator371.f();
                    }
                  } else {
                    var _iterator372 = _createForOfIteratorHelper(_o167),
                      _step372;
                    try {
                      for (_iterator372.s(); !(_step372 = _iterator372.n()).done;) {
                        var _step372$value = _slicedToArray(_step372.value, 2),
                          _t296 = _step372$value[0],
                          _e281 = _step372$value[1];
                        "class" === _t296 ? n.writer.removeClass(_e281, i) : n.writer.removeAttribute(_t296, i);
                      }
                    } catch (err) {
                      _iterator372.e(err);
                    } finally {
                      _iterator372.f();
                    }
                  }
                }
              } catch (err) {
                _iterator370.e(err);
              } finally {
                _iterator370.f();
              }
            });
          };
        }
      }, {
        key: "length",
        get: function get() {
          return this._definitions.size;
        }
      }]);
      return Fk;
    }();
    var Vk = function Vk(t, e, n) {
        var o = t.length;
        return n = void 0 === n ? o : n, !e && n >= o ? t : Wo(t, e, n);
      },
      Uk = RegExp("[\\u200d\\ud800-\\udfff\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff\\ufe0e\\ufe0f]");
    var Hk = function Hk(t) {
      return Uk.test(t);
    };
    var Gk = function Gk(t) {
        return t.split("");
      },
      Wk = "[\\ud800-\\udfff]",
      qk = "[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]",
      Kk = "\\ud83c[\\udffb-\\udfff]",
      Yk = "[^\\ud800-\\udfff]",
      Qk = "(?:\\ud83c[\\udde6-\\uddff]){2}",
      $k = "[\\ud800-\\udbff][\\udc00-\\udfff]",
      Jk = "(?:" + qk + "|" + Kk + ")" + "?",
      Zk = "[\\ufe0e\\ufe0f]?",
      Xk = Zk + Jk + ("(?:\\u200d(?:" + [Yk, Qk, $k].join("|") + ")" + Zk + Jk + ")*"),
      tb = "(?:" + [Yk + qk + "?", qk, Qk, $k, Wk].join("|") + ")",
      eb = RegExp(Kk + "(?=" + Kk + ")|" + tb + Xk, "g");
    var nb = function nb(t) {
      return t.match(eb) || [];
    };
    var ob = function ob(t) {
      return Hk(t) ? nb(t) : Gk(t);
    };
    var ib = function (t) {
      return function (e) {
        e = Fo(e);
        var n = Hk(e) ? ob(e) : void 0,
          o = n ? n[0] : e.charAt(0),
          i = n ? Vk(n, 1).join("") : e.slice(1);
        return o[t]() + i;
      };
    }("toUpperCase");
    var rb = /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205f\u3000]/g,
      sb = /^(?:(?:https?|ftps?|mailto):|[^a-z]|[a-z+.-]+(?:[^a-z+.:-]|$))/i,
      ab = /^[\S]+@((?![-_])(?:[-\w\u00a1-\uffff]{0,63}[^-_]\.))+(?:[a-z\u00a1-\uffff]{2,})$/i,
      cb = /^((\w+:(\/{2,})?)|(\W))/i,
      lb = "Ctrl+K";
    function db(t, _ref70) {
      var e = _ref70.writer;
      var n = e.createAttributeElement("a", {
        href: t
      }, {
        priority: 5
      });
      return e.setCustomProperty("link", !0, n), n;
    }
    function hb(t) {
      return function (t) {
        return t.replace(rb, "").match(sb);
      }(t = String(t)) ? t : "#";
    }
    function ub(t, e) {
      return !!t && e.checkAttribute(t.name, "linkHref");
    }
    function gb(t, e) {
      var n = (o = t, ab.test(o) ? "mailto:" : e);
      var o;
      var i = !!n && !cb.test(t);
      return t && i ? n + t : t;
    }
    var mb = /*#__PURE__*/function (_Xt21) {
      _inherits(mb, _Xt21);
      function mb(t) {
        var _this264;
        _classCallCheck(this, mb);
        _this264 = _possibleConstructorReturn(this, _getPrototypeOf(mb).call(this, t)), _this264.manualDecorators = new co(), _this264.automaticDecorators = new Fk();
        return _this264;
      }
      _createClass(mb, [{
        key: "restoreManualDecoratorStates",
        value: function restoreManualDecoratorStates() {
          var _iterator373 = _createForOfIteratorHelper(this.manualDecorators),
            _step373;
          try {
            for (_iterator373.s(); !(_step373 = _iterator373.n()).done;) {
              var _t297 = _step373.value;
              _t297.value = this._getDecoratorStateFromModel(_t297.id);
            }
          } catch (err) {
            _iterator373.e(err);
          } finally {
            _iterator373.f();
          }
        }
      }, {
        key: "refresh",
        value: function refresh() {
          var t = this.editor.model,
            e = t.document.selection,
            n = e.getSelectedElement() || Ks(e.getSelectedBlocks());
          ub(n, t.schema) ? (this.value = n.getAttribute("linkHref"), this.isEnabled = t.schema.checkAttribute(n, "linkHref")) : (this.value = e.getAttribute("linkHref"), this.isEnabled = t.schema.checkAttributeInSelection(e, "linkHref"));
          var _iterator374 = _createForOfIteratorHelper(this.manualDecorators),
            _step374;
          try {
            for (_iterator374.s(); !(_step374 = _iterator374.n()).done;) {
              var _t298 = _step374.value;
              _t298.value = this._getDecoratorStateFromModel(_t298.id);
            }
          } catch (err) {
            _iterator374.e(err);
          } finally {
            _iterator374.f();
          }
        }
      }, {
        key: "execute",
        value: function execute(t) {
          var _this265 = this;
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var n = this.editor.model,
            o = n.document.selection,
            i = [],
            r = [];
          for (var _t300 in e) e[_t300] ? i.push(_t300) : r.push(_t300);
          n.change(function (e) {
            if (o.isCollapsed) {
              var _s34 = o.getFirstPosition();
              if (o.hasAttribute("linkHref")) {
                var _a20 = jg(_s34, "linkHref", o.getAttribute("linkHref"), n);
                e.setAttribute("linkHref", t, _a20), i.forEach(function (t) {
                  e.setAttribute(t, !0, _a20);
                }), r.forEach(function (t) {
                  e.removeAttribute(t, _a20);
                }), e.setSelection(e.createPositionAfter(_a20.end.nodeBefore));
              } else if ("" !== t) {
                var _r59 = vo(o.getAttributes());
                _r59.set("linkHref", t), i.forEach(function (t) {
                  _r59.set(t, !0);
                });
                var _n$insertContent = n.insertContent(e.createText(t, _r59), _s34),
                  _a21 = _n$insertContent.end;
                e.setSelection(_a21);
              }
              ["linkHref"].concat(i, r).forEach(function (t) {
                e.removeSelectionAttribute(t);
              });
            } else {
              var _s35 = n.schema.getValidRanges(o.getRanges(), "linkHref"),
                _a22 = [];
              var _iterator375 = _createForOfIteratorHelper(o.getSelectedBlocks()),
                _step375;
              try {
                for (_iterator375.s(); !(_step375 = _iterator375.n()).done;) {
                  var _t301 = _step375.value;
                  n.schema.checkAttribute(_t301, "linkHref") && _a22.push(e.createRangeOn(_t301));
                }
              } catch (err) {
                _iterator375.e(err);
              } finally {
                _iterator375.f();
              }
              var _c11 = _a22.slice();
              var _iterator376 = _createForOfIteratorHelper(_s35),
                _step376;
              try {
                for (_iterator376.s(); !(_step376 = _iterator376.n()).done;) {
                  var _t302 = _step376.value;
                  _this265._isRangeToUpdate(_t302, _a22) && _c11.push(_t302);
                }
              } catch (err) {
                _iterator376.e(err);
              } finally {
                _iterator376.f();
              }
              var _iterator377 = _createForOfIteratorHelper(_c11),
                _step377;
              try {
                var _loop9 = function _loop9() {
                  var n = _step377.value;
                  e.setAttribute("linkHref", t, n), i.forEach(function (t) {
                    e.setAttribute(t, !0, n);
                  }), r.forEach(function (t) {
                    e.removeAttribute(t, n);
                  });
                };
                for (_iterator377.s(); !(_step377 = _iterator377.n()).done;) {
                  _loop9();
                }
              } catch (err) {
                _iterator377.e(err);
              } finally {
                _iterator377.f();
              }
            }
          });
        }
      }, {
        key: "_getDecoratorStateFromModel",
        value: function _getDecoratorStateFromModel(t) {
          var e = this.editor.model,
            n = e.document.selection,
            o = n.getSelectedElement();
          return ub(o, e.schema) ? o.getAttribute(t) : n.getAttribute(t);
        }
      }, {
        key: "_isRangeToUpdate",
        value: function _isRangeToUpdate(t, e) {
          var _iterator378 = _createForOfIteratorHelper(e),
            _step378;
          try {
            for (_iterator378.s(); !(_step378 = _iterator378.n()).done;) {
              var _n259 = _step378.value;
              if (_n259.containsRange(t)) return !1;
            }
          } catch (err) {
            _iterator378.e(err);
          } finally {
            _iterator378.f();
          }
          return !0;
        }
      }]);
      return mb;
    }(Xt);
    var pb = /*#__PURE__*/function (_Xt22) {
      _inherits(pb, _Xt22);
      function pb() {
        _classCallCheck(this, pb);
        return _possibleConstructorReturn(this, _getPrototypeOf(pb).apply(this, arguments));
      }
      _createClass(pb, [{
        key: "refresh",
        value: function refresh() {
          var t = this.editor.model,
            e = t.document.selection,
            n = e.getSelectedElement();
          ub(n, t.schema) ? this.isEnabled = t.schema.checkAttribute(n, "linkHref") : this.isEnabled = t.schema.checkAttributeInSelection(e, "linkHref");
        }
      }, {
        key: "execute",
        value: function execute() {
          var t = this.editor,
            e = this.editor.model,
            n = e.document.selection,
            o = t.commands.get("link");
          e.change(function (t) {
            var i = n.isCollapsed ? [jg(n.getFirstPosition(), "linkHref", n.getAttribute("linkHref"), e)] : e.schema.getValidRanges(n.getRanges(), "linkHref");
            var _iterator379 = _createForOfIteratorHelper(i),
              _step379;
            try {
              for (_iterator379.s(); !(_step379 = _iterator379.n()).done;) {
                var _e282 = _step379.value;
                if (t.removeAttribute("linkHref", _e282), o) {
                  var _iterator380 = _createForOfIteratorHelper(o.manualDecorators),
                    _step380;
                  try {
                    for (_iterator380.s(); !(_step380 = _iterator380.n()).done;) {
                      var _n260 = _step380.value;
                      t.removeAttribute(_n260.id, _e282);
                    }
                  } catch (err) {
                    _iterator380.e(err);
                  } finally {
                    _iterator380.f();
                  }
                }
              }
            } catch (err) {
              _iterator379.e(err);
            } finally {
              _iterator379.f();
            }
          });
        }
      }]);
      return pb;
    }(Xt);
    var fb = function fb(_ref71) {
      var t = _ref71.id,
        e = _ref71.label,
        n = _ref71.attributes,
        o = _ref71.defaultValue;
      _classCallCheck(this, fb);
      this.id = t, this.set("value"), this.defaultValue = o, this.label = e, this.attributes = n;
    };
    $t(fb, Gt);
    var kb = n(52),
      bb = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Zl()(kb.a, bb), kb.a.locals;
    var wb = "automatic",
      Cb = /^(https?:)?\/\//;
    var Ab = /*#__PURE__*/function (_Jt58) {
      _inherits(Ab, _Jt58);
      _createClass(Ab, null, [{
        key: "pluginName",
        get: function get() {
          return "LinkEditing";
        }
      }, {
        key: "requires",
        get: function get() {
          return [yg, kg, im];
        }
      }]);
      function Ab(t) {
        var _this266;
        _classCallCheck(this, Ab);
        _this266 = _possibleConstructorReturn(this, _getPrototypeOf(Ab).call(this, t)), t.config.define("link", {
          addTargetToExternalLinks: !1
        });
        return _this266;
      }
      _createClass(Ab, [{
        key: "init",
        value: function init() {
          var t = this.editor;
          t.model.schema.extend("$text", {
            allowAttributes: "linkHref"
          }), t.conversion.for("dataDowncast").attributeToElement({
            model: "linkHref",
            view: db
          }), t.conversion.for("editingDowncast").attributeToElement({
            model: "linkHref",
            view: function view(t, e) {
              return db(hb(t), e);
            }
          }), t.conversion.for("upcast").elementToAttribute({
            view: {
              name: "a",
              attributes: {
                href: !0
              }
            },
            model: {
              key: "linkHref",
              value: function value(t) {
                return t.getAttribute("href");
              }
            }
          }), t.commands.add("link", new mb(t)), t.commands.add("unlink", new pb(t));
          var e = function (t, e) {
            var n = {
              "Open in a new tab": t("Open in a new tab"),
              Downloadable: t("Downloadable")
            };
            return e.forEach(function (t) {
              return t.label && n[t.label] && (t.label = n[t.label]), t;
            }), e;
          }(t.t, function (t) {
            var e = [];
            if (t) for (var _i137 = 0, _Object$entries2 = Object.entries(t); _i137 < _Object$entries2.length; _i137++) {
              var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i137], 2),
                _n261 = _Object$entries2$_i[0],
                _o168 = _Object$entries2$_i[1];
              var _t303 = Object.assign({}, _o168, {
                id: "link".concat(ib(_n261))
              });
              e.push(_t303);
            }
            return e;
          }(t.config.get("link.decorators")));
          this._enableAutomaticDecorators(e.filter(function (t) {
            return t.mode === wb;
          })), this._enableManualDecorators(e.filter(function (t) {
            return "manual" === t.mode;
          }));
          t.plugins.get(yg).registerAttribute("linkHref"), function (t, e, n, o) {
            var i = t.editing.view,
              r = new Set();
            i.document.registerPostFixer(function (i) {
              var s = t.model.document.selection;
              var a = !1;
              if (s.hasAttribute(e)) {
                var _c12 = jg(s.getFirstPosition(), e, s.getAttribute(e), t.model),
                  _l6 = t.editing.mapper.toViewRange(_c12);
                var _iterator381 = _createForOfIteratorHelper(_l6.getItems()),
                  _step381;
                try {
                  for (_iterator381.s(); !(_step381 = _iterator381.n()).done;) {
                    var _t304 = _step381.value;
                    _t304.is("element", n) && !_t304.hasClass(o) && (i.addClass(o, _t304), r.add(_t304), a = !0);
                  }
                } catch (err) {
                  _iterator381.e(err);
                } finally {
                  _iterator381.f();
                }
              }
              return a;
            }), t.conversion.for("editingDowncast").add(function (t) {
              function e() {
                i.change(function (t) {
                  var _iterator382 = _createForOfIteratorHelper(r.values()),
                    _step382;
                  try {
                    for (_iterator382.s(); !(_step382 = _iterator382.n()).done;) {
                      var _e283 = _step382.value;
                      t.removeClass(o, _e283), r.delete(_e283);
                    }
                  } catch (err) {
                    _iterator382.e(err);
                  } finally {
                    _iterator382.f();
                  }
                });
              }
              t.on("insert", e, {
                priority: "highest"
              }), t.on("remove", e, {
                priority: "highest"
              }), t.on("attribute", e, {
                priority: "highest"
              }), t.on("selection", e, {
                priority: "highest"
              });
            });
          }(t, "linkHref", "a", "ck-link_selected"), this._enableInsertContentSelectionAttributesFixer(), this._enableClickingAfterLink(), this._enableTypingOverLink(), this._handleDeleteContentAfterLink();
        }
      }, {
        key: "_enableAutomaticDecorators",
        value: function _enableAutomaticDecorators(t) {
          var e = this.editor,
            n = e.commands.get("link").automaticDecorators;
          e.config.get("link.addTargetToExternalLinks") && n.add({
            id: "linkIsExternal",
            mode: wb,
            callback: function callback(t) {
              return Cb.test(t);
            },
            attributes: {
              target: "_blank",
              rel: "noopener noreferrer"
            }
          }), n.add(t), n.length && e.conversion.for("downcast").add(n.getDispatcher());
        }
      }, {
        key: "_enableManualDecorators",
        value: function _enableManualDecorators(t) {
          if (!t.length) return;
          var e = this.editor,
            n = e.commands.get("link").manualDecorators;
          t.forEach(function (t) {
            e.model.schema.extend("$text", {
              allowAttributes: t.id
            }), n.add(new fb(t)), e.conversion.for("downcast").attributeToElement({
              model: t.id,
              view: function view(e, _ref72) {
                var o = _ref72.writer;
                if (e) {
                  var _e284 = n.get(t.id).attributes,
                    _i138 = o.createAttributeElement("a", _e284, {
                      priority: 5
                    });
                  return o.setCustomProperty("link", !0, _i138), _i138;
                }
              }
            }), e.conversion.for("upcast").elementToAttribute({
              view: {
                name: "a",
                attributes: n.get(t.id).attributes
              },
              model: {
                key: t.id
              }
            });
          });
        }
      }, {
        key: "_enableInsertContentSelectionAttributesFixer",
        value: function _enableInsertContentSelectionAttributesFixer() {
          var t = this.editor.model,
            e = t.document.selection;
          this.listenTo(t, "insertContent", function () {
            var n = e.anchor.nodeBefore,
              o = e.anchor.nodeAfter;
            e.hasAttribute("linkHref") && n && n.hasAttribute("linkHref") && (o && o.hasAttribute("linkHref") || t.change(function (e) {
              _b(e, yb(t.schema));
            }));
          }, {
            priority: "low"
          });
        }
      }, {
        key: "_enableClickingAfterLink",
        value: function _enableClickingAfterLink() {
          var t = this.editor,
            e = t.model;
          t.editing.view.addObserver(Tu);
          var n = !1;
          this.listenTo(t.editing.view.document, "mousedown", function () {
            n = !0;
          }), this.listenTo(t.editing.view.document, "selectionChange", function () {
            if (!n) return;
            n = !1;
            var t = e.document.selection;
            if (!t.isCollapsed) return;
            if (!t.hasAttribute("linkHref")) return;
            var o = t.getFirstPosition(),
              i = jg(o, "linkHref", t.getAttribute("linkHref"), e);
            (o.isTouching(i.start) || o.isTouching(i.end)) && e.change(function (t) {
              _b(t, yb(e.schema));
            });
          });
        }
      }, {
        key: "_enableTypingOverLink",
        value: function _enableTypingOverLink() {
          var t = this.editor,
            e = t.editing.view;
          var n, o;
          this.listenTo(e.document, "delete", function () {
            o = !0;
          }, {
            priority: "high"
          }), this.listenTo(t.model, "deleteContent", function () {
            var e = t.model.document.selection;
            e.isCollapsed || (o ? o = !1 : vb(t) && function (t) {
              var e = t.document.selection,
                n = e.getFirstPosition(),
                o = e.getLastPosition(),
                i = n.nodeAfter;
              if (!i) return !1;
              if (!i.is("$text")) return !1;
              if (!i.hasAttribute("linkHref")) return !1;
              var r = o.textNode || o.nodeBefore;
              if (i === r) return !0;
              return jg(n, "linkHref", i.getAttribute("linkHref"), t).containsRange(t.createRange(n, o), !0);
            }(t.model) && (n = e.getAttributes()));
          }, {
            priority: "high"
          }), this.listenTo(t.model, "insertContent", function (e, _ref73) {
            var _ref74 = _slicedToArray(_ref73, 1),
              i = _ref74[0];
            o = !1, vb(t) && n && (t.model.change(function (t) {
              var _iterator383 = _createForOfIteratorHelper(n),
                _step383;
              try {
                for (_iterator383.s(); !(_step383 = _iterator383.n()).done;) {
                  var _step383$value = _slicedToArray(_step383.value, 2),
                    _e285 = _step383$value[0],
                    _o169 = _step383$value[1];
                  t.setAttribute(_e285, _o169, i);
                }
              } catch (err) {
                _iterator383.e(err);
              } finally {
                _iterator383.f();
              }
            }), n = null);
          }, {
            priority: "high"
          });
        }
      }, {
        key: "_handleDeleteContentAfterLink",
        value: function _handleDeleteContentAfterLink() {
          var t = this.editor,
            e = t.model,
            n = e.document.selection,
            o = t.editing.view;
          var i = !1,
            r = !1;
          this.listenTo(o.document, "delete", function (t, e) {
            r = e.domEvent.keyCode === Vi.backspace;
          }, {
            priority: "high"
          }), this.listenTo(e, "deleteContent", function () {
            i = !1;
            var t = n.getFirstPosition(),
              o = n.getAttribute("linkHref");
            if (!o) return;
            var r = jg(t, "linkHref", o, e);
            i = r.containsPosition(t) || r.end.isEqual(t);
          }, {
            priority: "high"
          }), this.listenTo(e, "deleteContent", function () {
            r && (r = !1, i || t.model.enqueueChange(function (t) {
              _b(t, yb(e.schema));
            }));
          }, {
            priority: "low"
          });
        }
      }]);
      return Ab;
    }(Jt);
    function _b(t, e) {
      t.removeSelectionAttribute("linkHref");
      var _iterator384 = _createForOfIteratorHelper(e),
        _step384;
      try {
        for (_iterator384.s(); !(_step384 = _iterator384.n()).done;) {
          var _n262 = _step384.value;
          t.removeSelectionAttribute(_n262);
        }
      } catch (err) {
        _iterator384.e(err);
      } finally {
        _iterator384.f();
      }
    }
    function vb(t) {
      return t.plugins.get("Input").isInput(t.model.change(function (t) {
        return t.batch;
      }));
    }
    function yb(t) {
      return t.getDefinition("$text").allowAttributes.filter(function (t) {
        return t.startsWith("link");
      });
    }
    var xb = n(53),
      Eb = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Zl()(xb.a, Eb), xb.a.locals;
    var Db = /*#__PURE__*/function (_ed29) {
      _inherits(Db, _ed29);
      function Db(t, e) {
        var _this267;
        _classCallCheck(this, Db);
        _this267 = _possibleConstructorReturn(this, _getPrototypeOf(Db).call(this, t));
        var n = t.t;
        _this267.focusTracker = new Ys(), _this267.keystrokes = new Qs(), _this267.urlInputView = _this267._createUrlInput(), _this267.saveButtonView = _this267._createButton(n("Save"), ql.check, "ck-button-save"), _this267.saveButtonView.type = "submit", _this267.cancelButtonView = _this267._createButton(n("Cancel"), ql.cancel, "ck-button-cancel", "cancel"), _this267._manualDecoratorSwitches = _this267._createManualDecoratorSwitches(e), _this267.children = _this267._createFormChildren(e.manualDecorators), _this267._focusables = new $l(), _this267._focusCycler = new Od({
          focusables: _this267._focusables,
          focusTracker: _this267.focusTracker,
          keystrokeHandler: _this267.keystrokes,
          actions: {
            focusPrevious: "shift + tab",
            focusNext: "tab"
          }
        });
        var o = ["ck", "ck-link-form", "ck-responsive-form"];
        e.manualDecorators.length && o.push("ck-link-form_layout-vertical", "ck-vertical-form"), _this267.setTemplate({
          tag: "form",
          attributes: {
            class: o,
            tabindex: "-1"
          },
          children: _this267.children
        }), Yl(_assertThisInitialized(_assertThisInitialized(_this267)));
        return _this267;
      }
      _createClass(Db, [{
        key: "getDecoratorSwitchesState",
        value: function getDecoratorSwitchesState() {
          return Array.from(this._manualDecoratorSwitches).reduce(function (t, e) {
            return t[e.name] = e.isOn, t;
          }, {});
        }
      }, {
        key: "render",
        value: function render() {
          var _this268 = this;
          _get(_getPrototypeOf(Db.prototype), "render", this).call(this), Ql({
            view: this
          });
          [this.urlInputView].concat(_toConsumableArray(this._manualDecoratorSwitches), [this.saveButtonView, this.cancelButtonView]).forEach(function (t) {
            _this268._focusables.add(t), _this268.focusTracker.add(t.element);
          }), this.keystrokes.listenTo(this.element);
        }
      }, {
        key: "focus",
        value: function focus() {
          this._focusCycler.focusFirst();
        }
      }, {
        key: "_createUrlInput",
        value: function _createUrlInput() {
          var t = this.locale.t,
            e = new Rh(this.locale, jh);
          return e.label = t("Link URL"), e;
        }
      }, {
        key: "_createButton",
        value: function _createButton(t, e, n, o) {
          var i = new Sd(this.locale);
          return i.set({
            label: t,
            icon: e,
            tooltip: !0
          }), i.extendTemplate({
            attributes: {
              class: n
            }
          }), o && i.delegate("execute").to(this, o), i;
        }
      }, {
        key: "_createManualDecoratorSwitches",
        value: function _createManualDecoratorSwitches(t) {
          var _this269 = this;
          var e = this.createCollection();
          var _iterator385 = _createForOfIteratorHelper(t.manualDecorators),
            _step385;
          try {
            var _loop10 = function _loop10() {
              var n = _step385.value;
              var o = new Pd(_this269.locale);
              o.set({
                name: n.id,
                label: n.label,
                withText: !0
              }), o.bind("isOn").toMany([n, t], "value", function (t, e) {
                return void 0 === e && void 0 === t ? n.defaultValue : t;
              }), o.on("execute", function () {
                n.set("value", !o.isOn);
              }), e.add(o);
            };
            for (_iterator385.s(); !(_step385 = _iterator385.n()).done;) {
              _loop10();
            }
          } catch (err) {
            _iterator385.e(err);
          } finally {
            _iterator385.f();
          }
          return e;
        }
      }, {
        key: "_createFormChildren",
        value: function _createFormChildren(t) {
          var e = this.createCollection();
          if (e.add(this.urlInputView), t.length) {
            var _t305 = new ed();
            _t305.setTemplate({
              tag: "ul",
              children: this._manualDecoratorSwitches.map(function (t) {
                return {
                  tag: "li",
                  children: [t],
                  attributes: {
                    class: ["ck", "ck-list__item"]
                  }
                };
              }),
              attributes: {
                class: ["ck", "ck-reset", "ck-list"]
              }
            }), e.add(_t305);
          }
          return e.add(this.saveButtonView), e.add(this.cancelButtonView), e;
        }
      }]);
      return Db;
    }(ed);
    var Mb = n(54),
      Ib = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Zl()(Mb.a, Ib), Mb.a.locals;
    var Tb = /*#__PURE__*/function (_ed30) {
      _inherits(Tb, _ed30);
      function Tb(t) {
        var _this270;
        _classCallCheck(this, Tb);
        _this270 = _possibleConstructorReturn(this, _getPrototypeOf(Tb).call(this, t));
        var e = t.t;
        _this270.focusTracker = new Ys(), _this270.keystrokes = new Qs(), _this270.previewButtonView = _this270._createPreviewButton(), _this270.unlinkButtonView = _this270._createButton(e("Unlink"), '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m11.077 15 .991-1.416a.75.75 0 1 1 1.229.86l-1.148 1.64a.748.748 0 0 1-.217.206 5.251 5.251 0 0 1-8.503-5.955.741.741 0 0 1 .12-.274l1.147-1.639a.75.75 0 1 1 1.228.86L4.933 10.7l.006.003a3.75 3.75 0 0 0 6.132 4.294l.006.004zm5.494-5.335a.748.748 0 0 1-.12.274l-1.147 1.639a.75.75 0 1 1-1.228-.86l.86-1.23a3.75 3.75 0 0 0-6.144-4.301l-.86 1.229a.75.75 0 0 1-1.229-.86l1.148-1.64a.748.748 0 0 1 .217-.206 5.251 5.251 0 0 1 8.503 5.955zm-4.563-2.532a.75.75 0 0 1 .184 1.045l-3.155 4.505a.75.75 0 1 1-1.229-.86l3.155-4.506a.75.75 0 0 1 1.045-.184zm4.919 10.562-1.414 1.414a.75.75 0 1 1-1.06-1.06l1.414-1.415-1.415-1.414a.75.75 0 0 1 1.061-1.06l1.414 1.414 1.414-1.415a.75.75 0 0 1 1.061 1.061l-1.414 1.414 1.414 1.415a.75.75 0 0 1-1.06 1.06l-1.415-1.414z"/></svg>', "unlink"), _this270.editButtonView = _this270._createButton(e("Edit link"), ql.pencil, "edit"), _this270.set("href"), _this270._focusables = new $l(), _this270._focusCycler = new Od({
          focusables: _this270._focusables,
          focusTracker: _this270.focusTracker,
          keystrokeHandler: _this270.keystrokes,
          actions: {
            focusPrevious: "shift + tab",
            focusNext: "tab"
          }
        }), _this270.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-link-actions", "ck-responsive-form"],
            tabindex: "-1"
          },
          children: [_this270.previewButtonView, _this270.editButtonView, _this270.unlinkButtonView]
        });
        return _this270;
      }
      _createClass(Tb, [{
        key: "render",
        value: function render() {
          var _this271 = this;
          _get(_getPrototypeOf(Tb.prototype), "render", this).call(this);
          [this.previewButtonView, this.editButtonView, this.unlinkButtonView].forEach(function (t) {
            _this271._focusables.add(t), _this271.focusTracker.add(t.element);
          }), this.keystrokes.listenTo(this.element);
        }
      }, {
        key: "focus",
        value: function focus() {
          this._focusCycler.focusFirst();
        }
      }, {
        key: "_createButton",
        value: function _createButton(t, e, n) {
          var o = new Sd(this.locale);
          return o.set({
            label: t,
            icon: e,
            tooltip: !0
          }), o.delegate("execute").to(this, n), o;
        }
      }, {
        key: "_createPreviewButton",
        value: function _createPreviewButton() {
          var t = new Sd(this.locale),
            e = this.bindTemplate,
            n = this.t;
          return t.set({
            withText: !0,
            tooltip: n("Open link in new tab")
          }), t.extendTemplate({
            attributes: {
              class: ["ck", "ck-link-actions__preview"],
              href: e.to("href", function (t) {
                return t && hb(t);
              }),
              target: "_blank",
              rel: "noopener noreferrer"
            }
          }), t.bind("label").to(this, "href", function (t) {
            return t || n("This link has no URL");
          }), t.bind("isEnabled").to(this, "href", function (t) {
            return !!t;
          }), t.template.tag = "a", t.template.eventListeners = {}, t;
        }
      }]);
      return Tb;
    }(ed);
    var Sb = "link-ui";
    var Nb = /*#__PURE__*/function (_Jt59) {
      _inherits(Nb, _Jt59);
      function Nb() {
        _classCallCheck(this, Nb);
        return _possibleConstructorReturn(this, _getPrototypeOf(Nb).apply(this, arguments));
      }
      _createClass(Nb, [{
        key: "init",
        value: function init() {
          var t = this.editor;
          t.editing.view.addObserver(Iu), this.actionsView = this._createActionsView(), this.formView = this._createFormView(), this._balloon = t.plugins.get(eu), this._createToolbarLinkButton(), this._enableUserBalloonInteractions(), t.conversion.for("editingDowncast").markerToHighlight({
            model: Sb,
            view: {
              classes: ["ck-fake-link-selection"]
            }
          }), t.conversion.for("editingDowncast").markerToElement({
            model: Sb,
            view: {
              name: "span",
              classes: ["ck-fake-link-selection", "ck-fake-link-selection_collapsed"]
            }
          });
        }
      }, {
        key: "destroy",
        value: function destroy() {
          _get(_getPrototypeOf(Nb.prototype), "destroy", this).call(this), this.formView.destroy();
        }
      }, {
        key: "_createActionsView",
        value: function _createActionsView() {
          var _this272 = this;
          var t = this.editor,
            e = new Tb(t.locale),
            n = t.commands.get("link"),
            o = t.commands.get("unlink");
          return e.bind("href").to(n, "value"), e.editButtonView.bind("isEnabled").to(n), e.unlinkButtonView.bind("isEnabled").to(o), this.listenTo(e, "edit", function () {
            _this272._addFormView();
          }), this.listenTo(e, "unlink", function () {
            t.execute("unlink"), _this272._hideUI();
          }), e.keystrokes.set("Esc", function (t, e) {
            _this272._hideUI(), e();
          }), e.keystrokes.set(lb, function (t, e) {
            _this272._addFormView(), e();
          }), e;
        }
      }, {
        key: "_createFormView",
        value: function _createFormView() {
          var _this273 = this;
          var t = this.editor,
            e = t.commands.get("link"),
            n = t.config.get("link.defaultProtocol"),
            o = new Db(t.locale, e);
          return o.urlInputView.fieldView.bind("value").to(e, "value"), o.urlInputView.bind("isReadOnly").to(e, "isEnabled", function (t) {
            return !t;
          }), o.saveButtonView.bind("isEnabled").to(e), this.listenTo(o, "submit", function () {
            var e = o.urlInputView.fieldView.element.value,
              i = gb(e, n);
            t.execute("link", i, o.getDecoratorSwitchesState()), _this273._closeFormView();
          }), this.listenTo(o, "cancel", function () {
            _this273._closeFormView();
          }), o.keystrokes.set("Esc", function (t, e) {
            _this273._closeFormView(), e();
          }), o;
        }
      }, {
        key: "_createToolbarLinkButton",
        value: function _createToolbarLinkButton() {
          var _this274 = this;
          var t = this.editor,
            e = t.commands.get("link"),
            n = t.t;
          t.keystrokes.set(lb, function (t, n) {
            n(), e.isEnabled && _this274._showUI(!0);
          }), t.ui.componentFactory.add("link", function (t) {
            var o = new Sd(t);
            return o.isEnabled = !0, o.label = n("Link"), o.icon = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m11.077 15 .991-1.416a.75.75 0 1 1 1.229.86l-1.148 1.64a.748.748 0 0 1-.217.206 5.251 5.251 0 0 1-8.503-5.955.741.741 0 0 1 .12-.274l1.147-1.639a.75.75 0 1 1 1.228.86L4.933 10.7l.006.003a3.75 3.75 0 0 0 6.132 4.294l.006.004zm5.494-5.335a.748.748 0 0 1-.12.274l-1.147 1.639a.75.75 0 1 1-1.228-.86l.86-1.23a3.75 3.75 0 0 0-6.144-4.301l-.86 1.229a.75.75 0 0 1-1.229-.86l1.148-1.64a.748.748 0 0 1 .217-.206 5.251 5.251 0 0 1 8.503 5.955zm-4.563-2.532a.75.75 0 0 1 .184 1.045l-3.155 4.505a.75.75 0 1 1-1.229-.86l3.155-4.506a.75.75 0 0 1 1.045-.184z"/></svg>', o.keystroke = lb, o.tooltip = !0, o.isToggleable = !0, o.bind("isEnabled").to(e, "isEnabled"), o.bind("isOn").to(e, "value", function (t) {
              return !!t;
            }), _this274.listenTo(o, "execute", function () {
              return _this274._showUI(!0);
            }), o;
          });
        }
      }, {
        key: "_enableUserBalloonInteractions",
        value: function _enableUserBalloonInteractions() {
          var _this275 = this;
          var t = this.editor.editing.view.document;
          this.listenTo(t, "click", function () {
            _this275._getSelectedLinkElement() && _this275._showUI();
          }), this.editor.keystrokes.set("Tab", function (t, e) {
            _this275._areActionsVisible && !_this275.actionsView.focusTracker.isFocused && (_this275.actionsView.focus(), e());
          }, {
            priority: "high"
          }), this.editor.keystrokes.set("Esc", function (t, e) {
            _this275._isUIVisible && (_this275._hideUI(), e());
          }), Kl({
            emitter: this.formView,
            activator: function activator() {
              return _this275._isUIInPanel;
            },
            contextElements: [this._balloon.view.element],
            callback: function callback() {
              return _this275._hideUI();
            }
          });
        }
      }, {
        key: "_addActionsView",
        value: function _addActionsView() {
          this._areActionsInPanel || this._balloon.add({
            view: this.actionsView,
            position: this._getBalloonPositionData()
          });
        }
      }, {
        key: "_addFormView",
        value: function _addFormView() {
          if (this._isFormInPanel) return;
          var t = this.editor.commands.get("link");
          this.formView.disableCssTransitions(), this._balloon.add({
            view: this.formView,
            position: this._getBalloonPositionData()
          }), this._balloon.visibleView === this.formView && this.formView.urlInputView.fieldView.select(), this.formView.enableCssTransitions(), this.formView.urlInputView.fieldView.element.value = t.value || "";
        }
      }, {
        key: "_closeFormView",
        value: function _closeFormView() {
          var t = this.editor.commands.get("link");
          t.restoreManualDecoratorStates(), void 0 !== t.value ? this._removeFormView() : this._hideUI();
        }
      }, {
        key: "_removeFormView",
        value: function _removeFormView() {
          this._isFormInPanel && (this.formView.saveButtonView.focus(), this._balloon.remove(this.formView), this.editor.editing.view.focus(), this._hideFakeVisualSelection());
        }
      }, {
        key: "_showUI",
        value: function _showUI() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
          this._getSelectedLinkElement() ? (this._areActionsVisible ? this._addFormView() : this._addActionsView(), t && this._balloon.showStack("main")) : (this._showFakeVisualSelection(), this._addActionsView(), t && this._balloon.showStack("main"), this._addFormView()), this._startUpdatingUI();
        }
      }, {
        key: "_hideUI",
        value: function _hideUI() {
          if (!this._isUIInPanel) return;
          var t = this.editor;
          this.stopListening(t.ui, "update"), this.stopListening(this._balloon, "change:visibleView"), t.editing.view.focus(), this._removeFormView(), this._balloon.remove(this.actionsView), this._hideFakeVisualSelection();
        }
      }, {
        key: "_startUpdatingUI",
        value: function _startUpdatingUI() {
          var _this276 = this;
          var t = this.editor,
            e = t.editing.view.document;
          var n = this._getSelectedLinkElement(),
            o = r();
          var i = function i() {
            var t = _this276._getSelectedLinkElement(),
              e = r();
            n && !t || !n && e !== o ? _this276._hideUI() : _this276._isUIVisible && _this276._balloon.updatePosition(_this276._getBalloonPositionData()), n = t, o = e;
          };
          function r() {
            return e.selection.focus.getAncestors().reverse().find(function (t) {
              return t.is("element");
            });
          }
          this.listenTo(t.ui, "update", i), this.listenTo(this._balloon, "change:visibleView", i);
        }
      }, {
        key: "_getBalloonPositionData",
        value: function _getBalloonPositionData() {
          var _this277 = this;
          var t = this.editor.editing.view,
            e = this.editor.model,
            n = t.document;
          var o = null;
          if (e.markers.has(Sb)) {
            var _e286 = Array.from(this.editor.editing.mapper.markerNameToElements(Sb)),
              _n263 = t.createRange(t.createPositionBefore(_e286[0]), t.createPositionAfter(_e286[_e286.length - 1]));
            o = t.domConverter.viewRangeToDom(_n263);
          } else o = function o() {
            var e = _this277._getSelectedLinkElement();
            return e ? t.domConverter.mapViewToDom(e) : t.domConverter.viewRangeToDom(n.selection.getFirstRange());
          };
          return {
            target: o
          };
        }
      }, {
        key: "_getSelectedLinkElement",
        value: function _getSelectedLinkElement() {
          var t = this.editor.editing.view,
            e = t.document.selection,
            n = e.getSelectedElement();
          if (e.isCollapsed || n && hm(n)) return Bb(e.getFirstPosition());
          {
            var _n264 = e.getFirstRange().getTrimmed(),
              _o170 = Bb(_n264.start),
              _i139 = Bb(_n264.end);
            return _o170 && _o170 == _i139 && t.createRangeIn(_o170).getTrimmed().isEqual(_n264) ? _o170 : null;
          }
        }
      }, {
        key: "_showFakeVisualSelection",
        value: function _showFakeVisualSelection() {
          var t = this.editor.model;
          t.change(function (e) {
            var n = t.document.selection.getFirstRange();
            if (t.markers.has(Sb)) e.updateMarker(Sb, {
              range: n
            });else if (n.start.isAtEnd) {
              var _o171 = n.start.getLastMatchingPosition(function (_ref75) {
                var e = _ref75.item;
                return !t.schema.isContent(e);
              }, {
                boundaries: n
              });
              e.addMarker(Sb, {
                usingOperation: !1,
                affectsData: !1,
                range: e.createRange(_o171, n.end)
              });
            } else e.addMarker(Sb, {
              usingOperation: !1,
              affectsData: !1,
              range: n
            });
          });
        }
      }, {
        key: "_hideFakeVisualSelection",
        value: function _hideFakeVisualSelection() {
          var t = this.editor.model;
          t.markers.has(Sb) && t.change(function (t) {
            t.removeMarker(Sb);
          });
        }
      }, {
        key: "_isFormInPanel",
        get: function get() {
          return this._balloon.hasView(this.formView);
        }
      }, {
        key: "_areActionsInPanel",
        get: function get() {
          return this._balloon.hasView(this.actionsView);
        }
      }, {
        key: "_areActionsVisible",
        get: function get() {
          return this._balloon.visibleView === this.actionsView;
        }
      }, {
        key: "_isUIInPanel",
        get: function get() {
          return this._isFormInPanel || this._areActionsInPanel;
        }
      }, {
        key: "_isUIVisible",
        get: function get() {
          return this._balloon.visibleView == this.formView || this._areActionsVisible;
        }
      }], [{
        key: "requires",
        get: function get() {
          return [eu];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "LinkUI";
        }
      }]);
      return Nb;
    }(Jt);
    function Bb(t) {
      return t.getAncestors().find(function (t) {
        return (e = t).is("attributeElement") && !!e.getCustomProperty("link");
        var e;
      });
    }
    var Pb = new RegExp("(^|\\s)(((?:(?:(?:https?|ftp):)?\\/\\/)(?:\\S+(?::\\S*)?@)?(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(((?!www\\.)|(www\\.))(?![-_])(?:[-_a-z0-9\\u00a1-\\uffff]{1,63}\\.)+(?:[a-z\\u00a1-\\uffff]{2,63})))(?::\\d{2,5})?(?:[/?#]\\S*)?)|((www.|(\\S+@))((?![-_])(?:[-_a-z0-9\\u00a1-\\uffff]{1,63}\\.))+(?:[a-z\\u00a1-\\uffff]{2,63})))$", "i");
    var zb = /*#__PURE__*/function (_Jt60) {
      _inherits(zb, _Jt60);
      function zb() {
        _classCallCheck(this, zb);
        return _possibleConstructorReturn(this, _getPrototypeOf(zb).apply(this, arguments));
      }
      _createClass(zb, [{
        key: "init",
        value: function init() {
          var _this278 = this;
          var t = this.editor.model.document.selection;
          t.on("change:range", function () {
            _this278.isEnabled = !t.anchor.parent.is("element", "codeBlock");
          }), this._enableTypingHandling();
        }
      }, {
        key: "afterInit",
        value: function afterInit() {
          this._enableEnterHandling(), this._enableShiftEnterHandling();
        }
      }, {
        key: "_enableTypingHandling",
        value: function _enableTypingHandling() {
          var _this279 = this;
          var t = this.editor,
            e = new vg(t.model, function (t) {
              if (!function (t) {
                return t.length > 4 && " " === t[t.length - 1] && " " !== t[t.length - 2];
              }(t)) return;
              var e = Lb(t.substr(0, t.length - 1));
              return e ? {
                url: e
              } : void 0;
            }),
            n = t.plugins.get("Input");
          e.on("matched:data", function (e, o) {
            var i = o.batch,
              r = o.range,
              s = o.url;
            if (!n.isInput(i)) return;
            var a = r.end.getShiftedBy(-1),
              c = a.getShiftedBy(-s.length),
              l = t.model.createRange(c, a);
            _this279._applyAutoLink(s, l);
          }), e.bind("isEnabled").to(this);
        }
      }, {
        key: "_enableEnterHandling",
        value: function _enableEnterHandling() {
          var _this280 = this;
          var t = this.editor,
            e = t.model,
            n = t.commands.get("enter");
          n && n.on("execute", function () {
            var t = e.document.selection.getFirstPosition();
            if (!t.parent.previousSibling) return;
            var n = e.createRangeIn(t.parent.previousSibling);
            _this280._checkAndApplyAutoLinkOnRange(n);
          });
        }
      }, {
        key: "_enableShiftEnterHandling",
        value: function _enableShiftEnterHandling() {
          var _this281 = this;
          var t = this.editor,
            e = t.model,
            n = t.commands.get("shiftEnter");
          n && n.on("execute", function () {
            var t = e.document.selection.getFirstPosition(),
              n = e.createRange(e.createPositionAt(t.parent, 0), t.getShiftedBy(-1));
            _this281._checkAndApplyAutoLinkOnRange(n);
          });
        }
      }, {
        key: "_checkAndApplyAutoLinkOnRange",
        value: function _checkAndApplyAutoLinkOnRange(t) {
          var e = this.editor.model,
            _g3 = _g(t, e),
            n = _g3.text,
            o = _g3.range,
            i = Lb(n);
          if (i) {
            var _t306 = e.createRange(o.end.getShiftedBy(-i.length), o.end);
            this._applyAutoLink(i, _t306);
          }
        }
      }, {
        key: "_applyAutoLink",
        value: function _applyAutoLink(t, e) {
          var _this282 = this;
          var n = this.editor.model;
          this.isEnabled && function (t, e) {
            return e.schema.checkAttributeInSelection(e.createSelection(t), "linkHref");
          }(e, n) && n.enqueueChange(function (n) {
            var o = _this282.editor.config.get("link.defaultProtocol"),
              i = gb(t, o);
            n.setAttribute("linkHref", i, e);
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "AutoLink";
        }
      }]);
      return zb;
    }(Jt);
    function Lb(t) {
      var e = Pb.exec(t);
      return e ? e[2] : null;
    }
    var Ob = /*#__PURE__*/function (_Xt23) {
      _inherits(Ob, _Xt23);
      function Ob(t, e) {
        var _this283;
        _classCallCheck(this, Ob);
        _this283 = _possibleConstructorReturn(this, _getPrototypeOf(Ob).call(this, t)), _this283.type = e;
        return _this283;
      }
      _createClass(Ob, [{
        key: "refresh",
        value: function refresh() {
          this.value = this._getValue(), this.isEnabled = this._checkEnabled();
        }
      }, {
        key: "execute",
        value: function execute() {
          var _this284 = this;
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var e = this.editor.model,
            n = e.document,
            o = Array.from(n.selection.getSelectedBlocks()).filter(function (t) {
              return jb(t, e.schema);
            }),
            i = void 0 !== t.forceValue ? !t.forceValue : this.value;
          e.change(function (t) {
            if (i) {
              var _e287 = o[o.length - 1].nextSibling,
                _n265 = Number.POSITIVE_INFINITY,
                _i140 = [];
              for (; _e287 && "listItem" == _e287.name && 0 !== _e287.getAttribute("listIndent");) {
                var _t307 = _e287.getAttribute("listIndent");
                _t307 < _n265 && (_n265 = _t307);
                var _o172 = _t307 - _n265;
                _i140.push({
                  element: _e287,
                  listIndent: _o172
                }), _e287 = _e287.nextSibling;
              }
              _i140 = _i140.reverse();
              var _iterator386 = _createForOfIteratorHelper(_i140),
                _step386;
              try {
                for (_iterator386.s(); !(_step386 = _iterator386.n()).done;) {
                  var _e288 = _step386.value;
                  t.setAttribute("listIndent", _e288.listIndent, _e288.element);
                }
              } catch (err) {
                _iterator386.e(err);
              } finally {
                _iterator386.f();
              }
            }
            if (!i) {
              var _t308 = Number.POSITIVE_INFINITY;
              var _iterator387 = _createForOfIteratorHelper(o),
                _step387;
              try {
                for (_iterator387.s(); !(_step387 = _iterator387.n()).done;) {
                  var _e289 = _step387.value;
                  _e289.is("element", "listItem") && _e289.getAttribute("listIndent") < _t308 && (_t308 = _e289.getAttribute("listIndent"));
                }
              } catch (err) {
                _iterator387.e(err);
              } finally {
                _iterator387.f();
              }
              _t308 = 0 === _t308 ? 1 : _t308, Rb(o, !0, _t308), Rb(o, !1, _t308);
            }
            var _iterator388 = _createForOfIteratorHelper(o.reverse()),
              _step388;
            try {
              for (_iterator388.s(); !(_step388 = _iterator388.n()).done;) {
                var _e290 = _step388.value;
                i && "listItem" == _e290.name ? t.rename(_e290, "paragraph") : i || "listItem" == _e290.name ? i || "listItem" != _e290.name || _e290.getAttribute("listType") == _this284.type || t.setAttribute("listType", _this284.type, _e290) : (t.setAttributes({
                  listType: _this284.type,
                  listIndent: 0
                }, _e290), t.rename(_e290, "listItem"));
              }
            } catch (err) {
              _iterator388.e(err);
            } finally {
              _iterator388.f();
            }
            _this284.fire("_executeCleanup", o);
          });
        }
      }, {
        key: "_getValue",
        value: function _getValue() {
          var t = Ks(this.editor.model.document.selection.getSelectedBlocks());
          return !!t && t.is("element", "listItem") && t.getAttribute("listType") == this.type;
        }
      }, {
        key: "_checkEnabled",
        value: function _checkEnabled() {
          if (this.value) return !0;
          var t = this.editor.model.document.selection,
            e = this.editor.model.schema,
            n = Ks(t.getSelectedBlocks());
          return !!n && jb(n, e);
        }
      }]);
      return Ob;
    }(Xt);
    function Rb(t, e, n) {
      var o = e ? t[0] : t[t.length - 1];
      if (o.is("element", "listItem")) {
        var _i141 = o[e ? "previousSibling" : "nextSibling"],
          _r60 = o.getAttribute("listIndent");
        for (; _i141 && _i141.is("element", "listItem") && _i141.getAttribute("listIndent") >= n;) _r60 > _i141.getAttribute("listIndent") && (_r60 = _i141.getAttribute("listIndent")), _i141.getAttribute("listIndent") == _r60 && t[e ? "unshift" : "push"](_i141), _i141 = _i141[e ? "previousSibling" : "nextSibling"];
      }
    }
    function jb(t, e) {
      return e.checkChild(t.parent, "listItem") && !e.isObject(t);
    }
    var Fb = /*#__PURE__*/function (_Xt24) {
      _inherits(Fb, _Xt24);
      function Fb(t, e) {
        var _this285;
        _classCallCheck(this, Fb);
        _this285 = _possibleConstructorReturn(this, _getPrototypeOf(Fb).call(this, t)), _this285._indentBy = "forward" == e ? 1 : -1;
        return _this285;
      }
      _createClass(Fb, [{
        key: "refresh",
        value: function refresh() {
          this.isEnabled = this._checkEnabled();
        }
      }, {
        key: "execute",
        value: function execute() {
          var _this286 = this;
          var t = this.editor.model,
            e = t.document;
          var n = Array.from(e.selection.getSelectedBlocks());
          t.change(function (t) {
            var e = n[n.length - 1];
            var o = e.nextSibling;
            for (; o && "listItem" == o.name && o.getAttribute("listIndent") > e.getAttribute("listIndent");) n.push(o), o = o.nextSibling;
            _this286._indentBy < 0 && (n = n.reverse());
            var _iterator389 = _createForOfIteratorHelper(n),
              _step389;
            try {
              for (_iterator389.s(); !(_step389 = _iterator389.n()).done;) {
                var _e291 = _step389.value;
                var _n266 = _e291.getAttribute("listIndent") + _this286._indentBy;
                _n266 < 0 ? t.rename(_e291, "paragraph") : t.setAttribute("listIndent", _n266, _e291);
              }
            } catch (err) {
              _iterator389.e(err);
            } finally {
              _iterator389.f();
            }
            _this286.fire("_executeCleanup", n);
          });
        }
      }, {
        key: "_checkEnabled",
        value: function _checkEnabled() {
          var t = Ks(this.editor.model.document.selection.getSelectedBlocks());
          if (!t || !t.is("element", "listItem")) return !1;
          if (this._indentBy > 0) {
            var _e292 = t.getAttribute("listIndent"),
              _n267 = t.getAttribute("listType");
            var _o173 = t.previousSibling;
            for (; _o173 && _o173.is("element", "listItem") && _o173.getAttribute("listIndent") >= _e292;) {
              if (_o173.getAttribute("listIndent") == _e292) return _o173.getAttribute("listType") == _n267;
              _o173 = _o173.previousSibling;
            }
            return !1;
          }
          return !0;
        }
      }]);
      return Fb;
    }(Xt);
    function Vb(t, e) {
      var n = e.mapper,
        o = e.writer,
        i = "numbered" == t.getAttribute("listType") ? "ol" : "ul",
        r = function (t) {
          var e = t.createContainerElement("li");
          return e.getFillerOffset = Kb, e;
        }(o),
        s = o.createContainerElement(i, null);
      return o.insert(o.createPositionAt(s, 0), r), n.bindElements(t, r), r;
    }
    function Ub(t, e, n, o) {
      var i = e.parent,
        r = n.mapper,
        s = n.writer;
      var a = r.toViewPosition(o.createPositionBefore(t));
      var c = Wb(t.previousSibling, {
          sameIndent: !0,
          smallerIndent: !0,
          listIndent: t.getAttribute("listIndent")
        }),
        l = t.previousSibling;
      if (c && c.getAttribute("listIndent") == t.getAttribute("listIndent")) {
        var _t309 = r.toViewElement(c);
        a = s.breakContainer(s.createPositionAfter(_t309));
      } else if (l && "listItem" == l.name) {
        a = r.toViewPosition(o.createPositionAt(l, "end"));
        var _t310 = r.findMappedViewAncestor(a),
          _e293 = function (t) {
            var _iterator390 = _createForOfIteratorHelper(t.getChildren()),
              _step390;
            try {
              for (_iterator390.s(); !(_step390 = _iterator390.n()).done;) {
                var _e294 = _step390.value;
                if ("ul" == _e294.name || "ol" == _e294.name) return _e294;
              }
            } catch (err) {
              _iterator390.e(err);
            } finally {
              _iterator390.f();
            }
            return null;
          }(_t310);
        a = _e293 ? s.createPositionBefore(_e293) : s.createPositionAt(_t310, "end");
      } else a = r.toViewPosition(o.createPositionBefore(t));
      if (a = Gb(a), s.insert(a, i), l && "listItem" == l.name) {
        var _t311 = r.toViewElement(l),
          _n268 = s.createRange(s.createPositionAt(_t311, 0), a).getWalker({
            ignoreElementEnd: !0
          });
        var _iterator391 = _createForOfIteratorHelper(_n268),
          _step391;
        try {
          for (_iterator391.s(); !(_step391 = _iterator391.n()).done;) {
            var _t312 = _step391.value;
            if (_t312.item.is("element", "li")) {
              var _o174 = s.breakContainer(s.createPositionBefore(_t312.item)),
                _i142 = _t312.item.parent,
                _r61 = s.createPositionAt(e, "end");
              Hb(s, _r61.nodeBefore, _r61.nodeAfter), s.move(s.createRangeOn(_i142), _r61), _n268.position = _o174;
            }
          }
        } catch (err) {
          _iterator391.e(err);
        } finally {
          _iterator391.f();
        }
      } else {
        var _n269 = i.nextSibling;
        if (_n269 && (_n269.is("element", "ul") || _n269.is("element", "ol"))) {
          var _o175 = null;
          var _iterator392 = _createForOfIteratorHelper(_n269.getChildren()),
            _step392;
          try {
            for (_iterator392.s(); !(_step392 = _iterator392.n()).done;) {
              var _e295 = _step392.value;
              var _n270 = r.toModelElement(_e295);
              if (!(_n270 && _n270.getAttribute("listIndent") > t.getAttribute("listIndent"))) break;
              _o175 = _e295;
            }
          } catch (err) {
            _iterator392.e(err);
          } finally {
            _iterator392.f();
          }
          _o175 && (s.breakContainer(s.createPositionAfter(_o175)), s.move(s.createRangeOn(_o175.parent), s.createPositionAt(e, "end")));
        }
      }
      Hb(s, i, i.nextSibling), Hb(s, i.previousSibling, i);
    }
    function Hb(t, e, n) {
      return !e || !n || "ul" != e.name && "ol" != e.name || e.name != n.name || e.getAttribute("class") !== n.getAttribute("class") ? null : t.mergeContainers(t.createPositionAfter(e));
    }
    function Gb(t) {
      return t.getLastMatchingPosition(function (t) {
        return t.item.is("uiElement");
      });
    }
    function Wb(t, e) {
      var n = !!e.sameIndent,
        o = !!e.smallerIndent,
        i = e.listIndent;
      var r = t;
      for (; r && "listItem" == r.name;) {
        var _t313 = r.getAttribute("listIndent");
        if (n && i == _t313 || o && i > _t313) return r;
        r = "forward" === e.direction ? r.nextSibling : r.previousSibling;
      }
      return null;
    }
    function qb(t, e, n, o) {
      t.ui.componentFactory.add(e, function (i) {
        var r = t.commands.get(e),
          s = new Sd(i);
        return s.set({
          label: n,
          icon: o,
          tooltip: !0,
          isToggleable: !0
        }), s.bind("isOn", "isEnabled").to(r, "value", "isEnabled"), s.on("execute", function () {
          t.execute(e), t.editing.view.focus();
        }), s;
      });
    }
    function Kb() {
      var t = !this.isEmpty && ("ul" == this.getChild(0).name || "ol" == this.getChild(0).name);
      return this.isEmpty || t ? 0 : gi.call(this);
    }
    function Yb(t) {
      return function (e, n, o) {
        var i = o.consumable;
        if (!i.test(n.item, "insert") || !i.test(n.item, "attribute:listType") || !i.test(n.item, "attribute:listIndent")) return;
        i.consume(n.item, "insert"), i.consume(n.item, "attribute:listType"), i.consume(n.item, "attribute:listIndent");
        var r = n.item;
        Ub(r, Vb(r, o), o, t);
      };
    }
    function Qb(t, e, n) {
      if (!n.consumable.consume(e.item, "attribute:listType")) return;
      var o = n.mapper.toViewElement(e.item),
        i = n.writer;
      i.breakContainer(i.createPositionBefore(o)), i.breakContainer(i.createPositionAfter(o));
      var r = o.parent,
        s = "numbered" == e.attributeNewValue ? "ol" : "ul";
      i.rename(s, r);
    }
    function $b(t, e, n) {
      var o = n.mapper.toViewElement(e.item).parent,
        i = n.writer;
      Hb(i, o, o.nextSibling), Hb(i, o.previousSibling, o);
      var _iterator393 = _createForOfIteratorHelper(e.item.getChildren()),
        _step393;
      try {
        for (_iterator393.s(); !(_step393 = _iterator393.n()).done;) {
          var _t314 = _step393.value;
          n.consumable.consume(_t314, "insert");
        }
      } catch (err) {
        _iterator393.e(err);
      } finally {
        _iterator393.f();
      }
    }
    function Jb(t, e, n) {
      if ("listItem" != e.item.name) {
        var _t315 = n.mapper.toViewPosition(e.range.start);
        var _o176 = n.writer,
          _i143 = [];
        for (; ("ul" == _t315.parent.name || "ol" == _t315.parent.name) && (_t315 = _o176.breakContainer(_t315), "li" == _t315.parent.name);) {
          var _e296 = _t315,
            _n271 = _o176.createPositionAt(_t315.parent, "end");
          if (!_e296.isEqual(_n271)) {
            var _t316 = _o176.remove(_o176.createRange(_e296, _n271));
            _i143.push(_t316);
          }
          _t315 = _o176.createPositionAfter(_t315.parent);
        }
        if (_i143.length > 0) {
          for (var _e298 = 0; _e298 < _i143.length; _e298++) {
            var _n272 = _t315.nodeBefore;
            if (_t315 = _o176.insert(_t315, _i143[_e298]).end, _e298 > 0) {
              var _e299 = Hb(_o176, _n272, _n272.nextSibling);
              _e299 && _e299.parent == _n272 && _t315.offset--;
            }
          }
          Hb(_o176, _t315.nodeBefore, _t315.nodeAfter);
        }
      }
    }
    function Zb(t, e, n) {
      var o = n.mapper.toViewPosition(e.position),
        i = o.nodeBefore,
        r = o.nodeAfter;
      Hb(n.writer, i, r);
    }
    function Xb(t, e, n) {
      if (n.consumable.consume(e.viewItem, {
        name: !0
      })) {
        var _t317 = n.writer,
          _o177 = _t317.createElement("listItem"),
          _i144 = function (t) {
            var e = 0,
              n = t.parent;
            for (; n;) {
              if (n.is("element", "li")) e++;else {
                var _t318 = n.previousSibling;
                _t318 && _t318.is("element", "li") && e++;
              }
              n = n.parent;
            }
            return e;
          }(e.viewItem);
        _t317.setAttribute("listIndent", _i144, _o177);
        var _r62 = e.viewItem.parent && "ol" == e.viewItem.parent.name ? "numbered" : "bulleted";
        if (_t317.setAttribute("listType", _r62, _o177), !n.safeInsert(_o177, e.modelCursor)) return;
        var _s36 = function (t, e, n) {
          var o = n.writer,
            i = n.schema;
          var r = o.createPositionAfter(t);
          var _iterator394 = _createForOfIteratorHelper(e),
            _step394;
          try {
            for (_iterator394.s(); !(_step394 = _iterator394.n()).done;) {
              var _s37 = _step394.value;
              if ("ul" == _s37.name || "ol" == _s37.name) r = n.convertItem(_s37, r).modelCursor;else {
                var _e300 = n.convertItem(_s37, o.createPositionAt(t, "end")),
                  _a23 = _e300.modelRange.start.nodeAfter;
                _a23 && _a23.is("element") && !i.checkChild(t, _a23.name) && (t = _e300.modelCursor.parent.is("element", "listItem") ? _e300.modelCursor.parent : iw(_e300.modelCursor), r = o.createPositionAfter(t));
              }
            }
          } catch (err) {
            _iterator394.e(err);
          } finally {
            _iterator394.f();
          }
          return r;
        }(_o177, e.viewItem.getChildren(), n);
        e.modelRange = _t317.createRange(e.modelCursor, _s36), n.updateConversionResult(_o177, e);
      }
    }
    function tw(t, e, n) {
      if (n.consumable.test(e.viewItem, {
        name: !0
      })) {
        var _t319 = Array.from(e.viewItem.getChildren());
        for (var _i145 = 0, _t320 = _t319; _i145 < _t320.length; _i145++) {
          var _e301 = _t320[_i145];
          !(_e301.is("element", "li") || sw(_e301)) && _e301._remove();
        }
      }
    }
    function ew(t, e, n) {
      if (n.consumable.test(e.viewItem, {
        name: !0
      })) {
        if (0 === e.viewItem.childCount) return;
        var _t321 = _toConsumableArray(e.viewItem.getChildren());
        var _n273 = !1,
          _o178 = !0;
        var _iterator395 = _createForOfIteratorHelper(_t321),
          _step395;
        try {
          for (_iterator395.s(); !(_step395 = _iterator395.n()).done;) {
            var _e302 = _step395.value;
            _n273 && !sw(_e302) && _e302._remove(), _e302.is("$text") ? (_o178 && (_e302._data = _e302.data.trimStart()), _e302.nextSibling && !sw(_e302.nextSibling) || (_e302._data = _e302.data.trimEnd())) : sw(_e302) && (_n273 = !0), _o178 = !1;
          }
        } catch (err) {
          _iterator395.e(err);
        } finally {
          _iterator395.f();
        }
      }
    }
    function nw(t) {
      return function (e, n) {
        if (n.isPhantom) return;
        var o = n.modelPosition.nodeBefore;
        if (o && o.is("element", "listItem")) {
          var _e303 = n.mapper.toViewElement(o),
            _i146 = _e303.getAncestors().find(sw),
            _r63 = t.createPositionAt(_e303, 0).getWalker();
          var _iterator396 = _createForOfIteratorHelper(_r63),
            _step396;
          try {
            for (_iterator396.s(); !(_step396 = _iterator396.n()).done;) {
              var _t322 = _step396.value;
              if ("elementStart" == _t322.type && _t322.item.is("element", "li")) {
                n.viewPosition = _t322.previousPosition;
                break;
              }
              if ("elementEnd" == _t322.type && _t322.item == _i146) {
                n.viewPosition = _t322.nextPosition;
                break;
              }
            }
          } catch (err) {
            _iterator396.e(err);
          } finally {
            _iterator396.f();
          }
        }
      };
    }
    function ow(t, _ref76) {
      var _ref77 = _slicedToArray(_ref76, 2),
        e = _ref77[0],
        n = _ref77[1];
      var o,
        i = e.is("documentFragment") ? e.getChild(0) : e;
      if (o = n ? this.createSelection(n) : this.document.selection, i && i.is("element", "listItem")) {
        var _t323 = o.getFirstPosition();
        var _e304 = null;
        if (_t323.parent.is("element", "listItem") ? _e304 = _t323.parent : _t323.nodeBefore && _t323.nodeBefore.is("element", "listItem") && (_e304 = _t323.nodeBefore), _e304) {
          var _t324 = _e304.getAttribute("listIndent");
          if (_t324 > 0) for (; i && i.is("element", "listItem");) i._setAttribute("listIndent", i.getAttribute("listIndent") + _t324), i = i.nextSibling;
        }
      }
    }
    function iw(t) {
      var e = new ga({
        startPosition: t
      });
      var n;
      do {
        n = e.next();
      } while (!n.value.item.is("element", "listItem"));
      return n.value.item;
    }
    function rw(t, e, n, o, i, r) {
      var s = Wb(e.nodeBefore, {
          sameIndent: !0,
          smallerIndent: !0,
          listIndent: t,
          foo: "b"
        }),
        a = i.mapper,
        c = i.writer,
        l = s ? s.getAttribute("listIndent") : null;
      var d;
      if (s) {
        if (l == t) {
          var _t325 = a.toViewElement(s).parent;
          d = c.createPositionAfter(_t325);
        } else {
          var _t326 = r.createPositionAt(s, "end");
          d = a.toViewPosition(_t326);
        }
      } else d = n;
      d = Gb(d);
      for (var _i147 = 0, _arr = _toConsumableArray(o.getChildren()); _i147 < _arr.length; _i147++) {
        var _t327 = _arr[_i147];
        sw(_t327) && (d = c.move(c.createRangeOn(_t327), d).end, Hb(c, _t327, _t327.nextSibling), Hb(c, _t327.previousSibling, _t327));
      }
    }
    function sw(t) {
      return t.is("element", "ol") || t.is("element", "ul");
    }
    var aw = /*#__PURE__*/function (_Jt61) {
      _inherits(aw, _Jt61);
      function aw() {
        _classCallCheck(this, aw);
        return _possibleConstructorReturn(this, _getPrototypeOf(aw).apply(this, arguments));
      }
      _createClass(aw, [{
        key: "init",
        value: function init() {
          var _this287 = this;
          var t = this.editor;
          t.model.schema.register("listItem", {
            inheritAllFrom: "$block",
            allowAttributes: ["listType", "listIndent"]
          });
          var e = t.data,
            n = t.editing;
          var o;
          t.model.document.registerPostFixer(function (e) {
            return function (t, e) {
              var n = t.document.differ.getChanges(),
                o = new Map();
              var i = !1;
              var _iterator397 = _createForOfIteratorHelper(n),
                _step397;
              try {
                for (_iterator397.s(); !(_step397 = _iterator397.n()).done;) {
                  var _o180 = _step397.value;
                  if ("insert" == _o180.type && "listItem" == _o180.name) r(_o180.position);else if ("insert" == _o180.type && "listItem" != _o180.name) {
                    if ("$text" != _o180.name) {
                      var _n274 = _o180.position.nodeAfter;
                      _n274.hasAttribute("listIndent") && (e.removeAttribute("listIndent", _n274), i = !0), _n274.hasAttribute("listType") && (e.removeAttribute("listType", _n274), i = !0), _n274.hasAttribute("listStyle") && (e.removeAttribute("listStyle", _n274), i = !0);
                      var _iterator399 = _createForOfIteratorHelper(Array.from(t.createRangeIn(_n274)).filter(function (t) {
                          return t.item.is("element", "listItem");
                        })),
                        _step399;
                      try {
                        for (_iterator399.s(); !(_step399 = _iterator399.n()).done;) {
                          var _e308 = _step399.value;
                          r(_e308.previousPosition);
                        }
                      } catch (err) {
                        _iterator399.e(err);
                      } finally {
                        _iterator399.f();
                      }
                    }
                    r(_o180.position.getShiftedBy(_o180.length));
                  } else "remove" == _o180.type && "listItem" == _o180.name ? r(_o180.position) : ("attribute" == _o180.type && "listIndent" == _o180.attributeKey || "attribute" == _o180.type && "listType" == _o180.attributeKey) && r(_o180.range.start);
                }
              } catch (err) {
                _iterator397.e(err);
              } finally {
                _iterator397.f();
              }
              var _iterator398 = _createForOfIteratorHelper(o.values()),
                _step398;
              try {
                for (_iterator398.s(); !(_step398 = _iterator398.n()).done;) {
                  var _t329 = _step398.value;
                  s(_t329), a(_t329);
                }
              } catch (err) {
                _iterator398.e(err);
              } finally {
                _iterator398.f();
              }
              return i;
              function r(t) {
                var e = t.nodeBefore;
                if (e && e.is("element", "listItem")) {
                  var _t328 = e;
                  if (o.has(_t328)) return;
                  for (var _e306 = _t328.previousSibling; _e306 && _e306.is("element", "listItem"); _e306 = _t328.previousSibling) if (_t328 = _e306, o.has(_t328)) return;
                  o.set(e, _t328);
                } else {
                  var _e307 = t.nodeAfter;
                  _e307 && _e307.is("element", "listItem") && o.set(_e307, _e307);
                }
              }
              function s(t) {
                var n = 0,
                  o = null;
                for (; t && t.is("element", "listItem");) {
                  var _r64 = t.getAttribute("listIndent");
                  if (_r64 > n) {
                    var _s38 = void 0;
                    null === o ? (o = _r64 - n, _s38 = n) : (o > _r64 && (o = _r64), _s38 = _r64 - o), e.setAttribute("listIndent", _s38, t), i = !0;
                  } else o = null, n = t.getAttribute("listIndent") + 1;
                  t = t.nextSibling;
                }
              }
              function a(t) {
                var n = [],
                  o = null;
                for (; t && t.is("element", "listItem");) {
                  var _r65 = t.getAttribute("listIndent");
                  if (o && o.getAttribute("listIndent") > _r65 && (n = n.slice(0, _r65 + 1)), 0 != _r65) if (n[_r65]) {
                    var _o179 = n[_r65];
                    t.getAttribute("listType") != _o179 && (e.setAttribute("listType", _o179, t), i = !0);
                  } else n[_r65] = t.getAttribute("listType");
                  o = t, t = t.nextSibling;
                }
              }
            }(t.model, e);
          }), n.mapper.registerViewToModelLength("li", cw), e.mapper.registerViewToModelLength("li", cw), n.mapper.on("modelToViewPosition", nw(n.view)), n.mapper.on("viewToModelPosition", (o = t.model, function (t, e) {
            var n = e.viewPosition,
              i = n.parent,
              r = e.mapper;
            if ("ul" == i.name || "ol" == i.name) {
              if (n.isAtEnd) {
                var _t330 = r.toModelElement(n.nodeBefore),
                  _i148 = r.getModelLength(n.nodeBefore);
                e.modelPosition = o.createPositionBefore(_t330).getShiftedBy(_i148);
              } else {
                var _t331 = r.toModelElement(n.nodeAfter);
                e.modelPosition = o.createPositionBefore(_t331);
              }
              t.stop();
            } else if ("li" == i.name && n.nodeBefore && ("ul" == n.nodeBefore.name || "ol" == n.nodeBefore.name)) {
              var _s39 = r.toModelElement(i);
              var _a24 = 1,
                _c13 = n.nodeBefore;
              for (; _c13 && sw(_c13);) _a24 += r.getModelLength(_c13), _c13 = _c13.previousSibling;
              e.modelPosition = o.createPositionBefore(_s39).getShiftedBy(_a24), t.stop();
            }
          })), e.mapper.on("modelToViewPosition", nw(n.view)), t.conversion.for("editingDowncast").add(function (e) {
            e.on("insert", Jb, {
              priority: "high"
            }), e.on("insert:listItem", Yb(t.model)), e.on("attribute:listType:listItem", Qb, {
              priority: "high"
            }), e.on("attribute:listType:listItem", $b, {
              priority: "low"
            }), e.on("attribute:listIndent:listItem", function (t) {
              return function (e, n, o) {
                if (!o.consumable.consume(n.item, "attribute:listIndent")) return;
                var i = o.mapper.toViewElement(n.item),
                  r = o.writer;
                r.breakContainer(r.createPositionBefore(i)), r.breakContainer(r.createPositionAfter(i));
                var s = i.parent,
                  a = s.previousSibling,
                  c = r.createRangeOn(s);
                r.remove(c), a && a.nextSibling && Hb(r, a, a.nextSibling), rw(n.attributeOldValue + 1, n.range.start, c.start, i, o, t), Ub(n.item, i, o, t);
                var _iterator400 = _createForOfIteratorHelper(n.item.getChildren()),
                  _step400;
                try {
                  for (_iterator400.s(); !(_step400 = _iterator400.n()).done;) {
                    var _t332 = _step400.value;
                    o.consumable.consume(_t332, "insert");
                  }
                } catch (err) {
                  _iterator400.e(err);
                } finally {
                  _iterator400.f();
                }
              };
            }(t.model)), e.on("remove:listItem", function (t) {
              return function (e, n, o) {
                var i = o.mapper.toViewPosition(n.position).getLastMatchingPosition(function (t) {
                    return !t.item.is("element", "li");
                  }).nodeAfter,
                  r = o.writer;
                r.breakContainer(r.createPositionBefore(i)), r.breakContainer(r.createPositionAfter(i));
                var s = i.parent,
                  a = s.previousSibling,
                  c = r.createRangeOn(s),
                  l = r.remove(c);
                a && a.nextSibling && Hb(r, a, a.nextSibling), rw(o.mapper.toModelElement(i).getAttribute("listIndent") + 1, n.position, c.start, i, o, t);
                var _iterator401 = _createForOfIteratorHelper(r.createRangeIn(l).getItems()),
                  _step401;
                try {
                  for (_iterator401.s(); !(_step401 = _iterator401.n()).done;) {
                    var _t333 = _step401.value;
                    o.mapper.unbindViewElement(_t333);
                  }
                } catch (err) {
                  _iterator401.e(err);
                } finally {
                  _iterator401.f();
                }
                e.stop();
              };
            }(t.model)), e.on("remove", Zb, {
              priority: "low"
            });
          }), t.conversion.for("dataDowncast").add(function (e) {
            e.on("insert", Jb, {
              priority: "high"
            }), e.on("insert:listItem", Yb(t.model));
          }), t.conversion.for("upcast").add(function (t) {
            t.on("element:ul", tw, {
              priority: "high"
            }), t.on("element:ol", tw, {
              priority: "high"
            }), t.on("element:li", ew, {
              priority: "high"
            }), t.on("element:li", Xb);
          }), t.model.on("insertContent", ow, {
            priority: "high"
          }), t.commands.add("numberedList", new Ob(t, "numbered")), t.commands.add("bulletedList", new Ob(t, "bulleted")), t.commands.add("indentList", new Fb(t, "forward")), t.commands.add("outdentList", new Fb(t, "backward"));
          var i = n.view.document;
          this.listenTo(i, "enter", function (t, e) {
            var n = _this287.editor.model.document,
              o = n.selection.getLastPosition().parent;
            n.selection.isCollapsed && "listItem" == o.name && o.isEmpty && (_this287.editor.execute("outdentList"), e.preventDefault(), t.stop());
          }, {
            context: "li"
          }), this.listenTo(i, "delete", function (t, e) {
            if ("backward" !== e.direction) return;
            var n = _this287.editor.model.document.selection;
            if (!n.isCollapsed) return;
            var o = n.getFirstPosition();
            if (!o.isAtStart) return;
            var i = o.parent;
            if ("listItem" !== i.name) return;
            i.previousSibling && "listItem" === i.previousSibling.name || (_this287.editor.execute("outdentList"), e.preventDefault(), t.stop());
          }, {
            context: "li"
          });
          var r = function r(t) {
            return function (e, n) {
              _this287.editor.commands.get(t).isEnabled && (_this287.editor.execute(t), n());
            };
          };
          t.keystrokes.set("Tab", r("indentList")), t.keystrokes.set("Shift+Tab", r("outdentList"));
        }
      }, {
        key: "afterInit",
        value: function afterInit() {
          var t = this.editor.commands,
            e = t.get("indent"),
            n = t.get("outdent");
          e && e.registerChildCommand(t.get("indentList")), n && n.registerChildCommand(t.get("outdentList"));
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "ListEditing";
        }
      }, {
        key: "requires",
        get: function get() {
          return [og, Cg];
        }
      }]);
      return aw;
    }(Jt);
    function cw(t) {
      var e = 1;
      var _iterator402 = _createForOfIteratorHelper(t.getChildren()),
        _step402;
      try {
        for (_iterator402.s(); !(_step402 = _iterator402.n()).done;) {
          var _n275 = _step402.value;
          if ("ul" == _n275.name || "ol" == _n275.name) {
            var _iterator403 = _createForOfIteratorHelper(_n275.getChildren()),
              _step403;
            try {
              for (_iterator403.s(); !(_step403 = _iterator403.n()).done;) {
                var _t334 = _step403.value;
                e += cw(_t334);
              }
            } catch (err) {
              _iterator403.e(err);
            } finally {
              _iterator403.f();
            }
          }
        }
      } catch (err) {
        _iterator402.e(err);
      } finally {
        _iterator402.f();
      }
      return e;
    }
    var lw = /*#__PURE__*/function (_Jt62) {
      _inherits(lw, _Jt62);
      function lw() {
        _classCallCheck(this, lw);
        return _possibleConstructorReturn(this, _getPrototypeOf(lw).apply(this, arguments));
      }
      _createClass(lw, [{
        key: "init",
        value: function init() {
          var t = this.editor.t;
          qb(this.editor, "numberedList", t("Numbered List"), '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M7 5.75c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zM3.5 3v5H2V3.7H1v-1h2.5V3zM.343 17.857l2.59-3.257H2.92a.6.6 0 1 0-1.04 0H.302a2 2 0 1 1 3.995 0h-.001c-.048.405-.16.734-.333.988-.175.254-.59.692-1.244 1.312H4.3v1h-4l.043-.043zM7 14.75a.75.75 0 0 1 .75-.75h9.5a.75.75 0 1 1 0 1.5h-9.5a.75.75 0 0 1-.75-.75z"/></svg>'), qb(this.editor, "bulletedList", t("Bulleted List"), '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M7 5.75c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zm-6 0C1 4.784 1.777 4 2.75 4c.966 0 1.75.777 1.75 1.75 0 .966-.777 1.75-1.75 1.75C1.784 7.5 1 6.723 1 5.75zm6 9c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zm-6 0c0-.966.777-1.75 1.75-1.75.966 0 1.75.777 1.75 1.75 0 .966-.777 1.75-1.75 1.75-.966 0-1.75-.777-1.75-1.75z"/></svg>');
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "ListUI";
        }
      }]);
      return lw;
    }(Jt);
    function dw(t, e) {
      return function (t) {
        t.on("attribute:url:media", n);
      };
      function n(n, o, i) {
        if (!i.consumable.consume(o.item, n.name)) return;
        var r = o.attributeNewValue,
          s = i.writer,
          a = i.mapper.toViewElement(o.item),
          c = _toConsumableArray(a.getChildren()).find(function (t) {
            return t.getCustomProperty("media-content");
          });
        s.remove(c);
        var l = t.getMediaViewElement(s, r, e);
        s.insert(s.createPositionAt(a, 0), l);
      }
    }
    function hw(t, e, n, o) {
      var i = t.createContainerElement("figure", {
        class: "media"
      });
      return t.insert(t.createPositionAt(i, 0), e.getMediaViewElement(t, n, o)), i;
    }
    function uw(t) {
      var e = t.getSelectedElement();
      return e && e.is("element", "media") ? e : null;
    }
    function gw(t, e, n) {
      t.change(function (o) {
        var i = o.createElement("media", {
          url: e
        });
        t.insertContent(i, n), o.setSelection(i, "on");
      });
    }
    var mw = /*#__PURE__*/function (_Xt25) {
      _inherits(mw, _Xt25);
      function mw() {
        _classCallCheck(this, mw);
        return _possibleConstructorReturn(this, _getPrototypeOf(mw).apply(this, arguments));
      }
      _createClass(mw, [{
        key: "refresh",
        value: function refresh() {
          var t = this.editor.model,
            e = t.document.selection,
            n = uw(e);
          this.value = n ? n.getAttribute("url") : null, this.isEnabled = function (t) {
            var e = t.getSelectedElement();
            return !!e && "media" === e.name;
          }(e) || function (t, e) {
            var n = bm(t, e).start.parent;
            n.isEmpty && !e.schema.isLimit(n) && (n = n.parent);
            return e.schema.checkChild(n, "media");
          }(e, t);
        }
      }, {
        key: "execute",
        value: function execute(t) {
          var e = this.editor.model,
            n = e.document.selection,
            o = uw(n);
          o ? e.change(function (e) {
            e.setAttribute("url", t, o);
          }) : gw(e, t, bm(n, e));
        }
      }]);
      return mw;
    }(Xt);
    var pw = /*#__PURE__*/function () {
      function pw(t, e) {
        _classCallCheck(this, pw);
        var n = e.providers,
          o = e.extraProviders || [],
          i = new Set(e.removeProviders),
          r = n.concat(o).filter(function (t) {
            var e = t.name;
            return e ? !i.has(e) : (Object(c.b)("media-embed-no-provider-name", {
              provider: t
            }), !1);
          });
        this.locale = t, this.providerDefinitions = r;
      }
      _createClass(pw, [{
        key: "hasMedia",
        value: function hasMedia(t) {
          return !!this._getMedia(t);
        }
      }, {
        key: "getMediaViewElement",
        value: function getMediaViewElement(t, e, n) {
          return this._getMedia(e).getViewElement(t, n);
        }
      }, {
        key: "_getMedia",
        value: function _getMedia(t) {
          if (!t) return new fw(this.locale);
          t = t.trim();
          var _iterator404 = _createForOfIteratorHelper(this.providerDefinitions),
            _step404;
          try {
            for (_iterator404.s(); !(_step404 = _iterator404.n()).done;) {
              var _e309 = _step404.value;
              var _n276 = _e309.html,
                _o181 = ho(_e309.url);
              var _iterator405 = _createForOfIteratorHelper(_o181),
                _step405;
              try {
                for (_iterator405.s(); !(_step405 = _iterator405.n()).done;) {
                  var _e310 = _step405.value;
                  var _o182 = this._getUrlMatches(t, _e310);
                  if (_o182) return new fw(this.locale, t, _o182, _n276);
                }
              } catch (err) {
                _iterator405.e(err);
              } finally {
                _iterator405.f();
              }
            }
          } catch (err) {
            _iterator404.e(err);
          } finally {
            _iterator404.f();
          }
          return null;
        }
      }, {
        key: "_getUrlMatches",
        value: function _getUrlMatches(t, e) {
          var n = t.match(e);
          if (n) return n;
          var o = t.replace(/^https?:\/\//, "");
          return n = o.match(e), n || (o = o.replace(/^www\./, ""), n = o.match(e), n || null);
        }
      }]);
      return pw;
    }();
    var fw = /*#__PURE__*/function () {
      function fw(t, e, n, o) {
        _classCallCheck(this, fw);
        this.url = this._getValidUrl(e), this._t = t.t, this._match = n, this._previewRenderer = o;
      }
      _createClass(fw, [{
        key: "getViewElement",
        value: function getViewElement(t, e) {
          var n = {};
          var o;
          if (e.renderForEditingView || e.renderMediaPreview && this.url && this._previewRenderer) {
            this.url && (n["data-oembed-url"] = this.url), e.renderForEditingView && (n.class = "ck-media__wrapper");
            var _i149 = this._getPreviewHtml(e);
            o = t.createRawElement("div", n, function (t) {
              t.innerHTML = _i149;
            });
          } else this.url && (n.url = this.url), o = t.createEmptyElement(e.elementName, n);
          return t.setCustomProperty("media-content", !0, o), o;
        }
      }, {
        key: "_getPreviewHtml",
        value: function _getPreviewHtml(t) {
          return this._previewRenderer ? this._previewRenderer(this._match) : this.url && t.renderForEditingView ? this._getPlaceholderHtml() : "";
        }
      }, {
        key: "_getPlaceholderHtml",
        value: function _getPlaceholderHtml() {
          var t = new Md(),
            e = new xd();
          t.text = this._t("Open media in new tab"), e.content = '<svg viewBox="0 0 64 42" xmlns="http://www.w3.org/2000/svg"><path d="M47.426 17V3.713L63.102 0v19.389h-.001l.001.272c0 1.595-2.032 3.43-4.538 4.098-2.506.668-4.538-.083-4.538-1.678 0-1.594 2.032-3.43 4.538-4.098.914-.244 2.032-.565 2.888-.603V4.516L49.076 7.447v9.556A1.014 1.014 0 0 0 49 17h-1.574zM29.5 17h-8.343a7.073 7.073 0 1 0-4.657 4.06v3.781H3.3a2.803 2.803 0 0 1-2.8-2.804V8.63a2.803 2.803 0 0 1 2.8-2.805h4.082L8.58 2.768A1.994 1.994 0 0 1 10.435 1.5h8.985c.773 0 1.477.448 1.805 1.149l1.488 3.177H26.7c1.546 0 2.8 1.256 2.8 2.805V17zm-11.637 0H17.5a1 1 0 0 0-1 1v.05A4.244 4.244 0 1 1 17.863 17zm29.684 2c.97 0 .953-.048.953.889v20.743c0 .953.016.905-.953.905H19.453c-.97 0-.953.048-.953-.905V19.89c0-.937-.016-.889.97-.889h28.077zm-4.701 19.338V22.183H24.154v16.155h18.692zM20.6 21.375v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616V37.53H20.6zm24.233-16.155v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615V37.53h-1.615zM29.485 25.283a.4.4 0 0 1 .593-.35l9.05 4.977a.4.4 0 0 1 0 .701l-9.05 4.978a.4.4 0 0 1-.593-.35v-9.956z"/></svg>', e.viewBox = "0 0 64 42";
          return new nd({
            tag: "div",
            attributes: {
              class: "ck ck-reset_all ck-media__placeholder"
            },
            children: [{
              tag: "div",
              attributes: {
                class: "ck-media__placeholder__icon"
              },
              children: [e]
            }, {
              tag: "a",
              attributes: {
                class: "ck-media__placeholder__url",
                target: "_blank",
                rel: "noopener noreferrer",
                href: this.url
              },
              children: [{
                tag: "span",
                attributes: {
                  class: "ck-media__placeholder__url__text"
                },
                children: [this.url]
              }, t]
            }]
          }).render().outerHTML;
        }
      }, {
        key: "_getValidUrl",
        value: function _getValidUrl(t) {
          return t ? t.match(/^https?/) ? t : "https://" + t : null;
        }
      }]);
      return fw;
    }();
    var kw = n(55),
      bw = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Zl()(kw.a, bw), kw.a.locals;
    var ww = /*#__PURE__*/function (_Jt63) {
      _inherits(ww, _Jt63);
      _createClass(ww, null, [{
        key: "pluginName",
        get: function get() {
          return "MediaEmbedEditing";
        }
      }]);
      function ww(t) {
        var _this288;
        _classCallCheck(this, ww);
        _this288 = _possibleConstructorReturn(this, _getPrototypeOf(ww).call(this, t)), t.config.define("mediaEmbed", {
          elementName: "oembed",
          providers: [{
            name: "dailymotion",
            url: /^dailymotion\.com\/video\/(\w+)/,
            html: function html(t) {
              return "<div style=\"position: relative; padding-bottom: 100%; height: 0; \"><iframe src=\"https://www.dailymotion.com/embed/video/".concat(t[1], "\" style=\"position: absolute; width: 100%; height: 100%; top: 0; left: 0;\" frameborder=\"0\" width=\"480\" height=\"270\" allowfullscreen allow=\"autoplay\"></iframe></div>");
            }
          }, {
            name: "spotify",
            url: [/^open\.spotify\.com\/(artist\/\w+)/, /^open\.spotify\.com\/(album\/\w+)/, /^open\.spotify\.com\/(track\/\w+)/],
            html: function html(t) {
              return "<div style=\"position: relative; padding-bottom: 100%; height: 0; padding-bottom: 126%;\"><iframe src=\"https://open.spotify.com/embed/".concat(t[1], "\" style=\"position: absolute; width: 100%; height: 100%; top: 0; left: 0;\" frameborder=\"0\" allowtransparency=\"true\" allow=\"encrypted-media\"></iframe></div>");
            }
          }, {
            name: "youtube",
            url: [/^(?:m\.)?youtube\.com\/watch\?v=([\w-]+)/, /^(?:m\.)?youtube\.com\/v\/([\w-]+)/, /^youtube\.com\/embed\/([\w-]+)/, /^youtu\.be\/([\w-]+)/],
            html: function html(t) {
              return "<div style=\"position: relative; padding-bottom: 100%; height: 0; padding-bottom: 56.2493%;\"><iframe src=\"https://www.youtube.com/embed/".concat(t[1], "\" style=\"position: absolute; width: 100%; height: 100%; top: 0; left: 0;\" frameborder=\"0\" allow=\"autoplay; encrypted-media\" allowfullscreen></iframe></div>");
            }
          }, {
            name: "vimeo",
            url: [/^vimeo\.com\/(\d+)/, /^vimeo\.com\/[^/]+\/[^/]+\/video\/(\d+)/, /^vimeo\.com\/album\/[^/]+\/video\/(\d+)/, /^vimeo\.com\/channels\/[^/]+\/(\d+)/, /^vimeo\.com\/groups\/[^/]+\/videos\/(\d+)/, /^vimeo\.com\/ondemand\/[^/]+\/(\d+)/, /^player\.vimeo\.com\/video\/(\d+)/],
            html: function html(t) {
              return "<div style=\"position: relative; padding-bottom: 100%; height: 0; padding-bottom: 56.2493%;\"><iframe src=\"https://player.vimeo.com/video/".concat(t[1], "\" style=\"position: absolute; width: 100%; height: 100%; top: 0; left: 0;\" frameborder=\"0\" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe></div>");
            }
          }, {
            name: "instagram",
            url: /^instagram\.com\/p\/(\w+)/
          }, {
            name: "twitter",
            url: /^twitter\.com/
          }, {
            name: "googleMaps",
            url: [/^google\.com\/maps/, /^goo\.gl\/maps/, /^maps\.google\.com/, /^maps\.app\.goo\.gl/]
          }, {
            name: "flickr",
            url: /^flickr\.com/
          }, {
            name: "facebook",
            url: /^facebook\.com/
          }]
        }), _this288.registry = new pw(t.locale, t.config.get("mediaEmbed"));
        return _this288;
      }
      _createClass(ww, [{
        key: "init",
        value: function init() {
          var t = this.editor,
            e = t.model.schema,
            n = t.t,
            o = t.conversion,
            i = t.config.get("mediaEmbed.previewsInData"),
            r = t.config.get("mediaEmbed.elementName"),
            s = this.registry;
          t.commands.add("mediaEmbed", new mw(t)), e.register("media", {
            isObject: !0,
            isBlock: !0,
            allowWhere: "$block",
            allowAttributes: ["url"]
          }), o.for("dataDowncast").elementToElement({
            model: "media",
            view: function view(t, _ref78) {
              var e = _ref78.writer;
              var n = t.getAttribute("url");
              return hw(e, s, n, {
                elementName: r,
                renderMediaPreview: n && i
              });
            }
          }), o.for("dataDowncast").add(dw(s, {
            elementName: r,
            renderMediaPreview: i
          })), o.for("editingDowncast").elementToElement({
            model: "media",
            view: function view(t, _ref79) {
              var e = _ref79.writer;
              var o = t.getAttribute("url");
              return function (t, e, n) {
                return e.setCustomProperty("media", !0, t), um(t, e, {
                  label: n
                });
              }(hw(e, s, o, {
                elementName: r,
                renderForEditingView: !0
              }), e, n("media widget"));
            }
          }), o.for("editingDowncast").add(dw(s, {
            elementName: r,
            renderForEditingView: !0
          })), o.for("upcast").elementToElement({
            view: function view(t) {
              return ["oembed", r].includes(t.name) && t.getAttribute("url") ? {
                name: !0
              } : null;
            },
            model: function model(t, _ref80) {
              var e = _ref80.writer;
              var n = t.getAttribute("url");
              if (s.hasMedia(n)) return e.createElement("media", {
                url: n
              });
            }
          }).elementToElement({
            view: {
              name: "div",
              attributes: {
                "data-oembed-url": !0
              }
            },
            model: function model(t, _ref81) {
              var e = _ref81.writer;
              var n = t.getAttribute("data-oembed-url");
              if (s.hasMedia(n)) return e.createElement("media", {
                url: n
              });
            }
          });
        }
      }]);
      return ww;
    }(Jt);
    var Cw = /^(?:http(s)?:\/\/)?[\w-]+\.[\w-.~:/?#[\]@!$&'()*+,;=%]+$/;
    var Aw = /*#__PURE__*/function (_Jt64) {
      _inherits(Aw, _Jt64);
      _createClass(Aw, null, [{
        key: "requires",
        get: function get() {
          return [qm, cp];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "AutoMediaEmbed";
        }
      }]);
      function Aw(t) {
        var _this289;
        _classCallCheck(this, Aw);
        _this289 = _possibleConstructorReturn(this, _getPrototypeOf(Aw).call(this, t)), _this289._timeoutId = null, _this289._positionToInsert = null;
        return _this289;
      }
      _createClass(Aw, [{
        key: "init",
        value: function init() {
          var _this290 = this;
          var t = this.editor,
            e = t.model.document;
          this.listenTo(t.plugins.get("ClipboardPipeline"), "inputTransformation", function () {
            var t = e.selection.getFirstRange(),
              n = kl.fromPosition(t.start);
            n.stickiness = "toPrevious";
            var o = kl.fromPosition(t.end);
            o.stickiness = "toNext", e.once("change:data", function () {
              _this290._embedMediaBetweenPositions(n, o), n.detach(), o.detach();
            }, {
              priority: "high"
            });
          }), t.commands.get("undo").on("execute", function () {
            _this290._timeoutId && (Sr.window.clearTimeout(_this290._timeoutId), _this290._positionToInsert.detach(), _this290._timeoutId = null, _this290._positionToInsert = null);
          }, {
            priority: "high"
          });
        }
      }, {
        key: "_embedMediaBetweenPositions",
        value: function _embedMediaBetweenPositions(t, e) {
          var _this291 = this;
          var n = this.editor,
            o = n.plugins.get(ww).registry,
            i = new Na(t, e),
            r = i.getWalker({
              ignoreElementEnd: !0
            });
          var s = "";
          var _iterator406 = _createForOfIteratorHelper(r),
            _step406;
          try {
            for (_iterator406.s(); !(_step406 = _iterator406.n()).done;) {
              var _t335 = _step406.value;
              _t335.item.is("$textProxy") && (s += _t335.item.data);
            }
          } catch (err) {
            _iterator406.e(err);
          } finally {
            _iterator406.f();
          }
          if (s = s.trim(), !s.match(Cw)) return void i.detach();
          if (!o.hasMedia(s)) return void i.detach();
          n.commands.get("mediaEmbed").isEnabled ? (this._positionToInsert = kl.fromPosition(t), this._timeoutId = Sr.window.setTimeout(function () {
            n.model.change(function (t) {
              var e;
              _this291._timeoutId = null, t.remove(i), i.detach(), "$graveyard" !== _this291._positionToInsert.root.rootName && (e = _this291._positionToInsert), gw(n.model, s, e), _this291._positionToInsert.detach(), _this291._positionToInsert = null;
            });
          }, 100)) : i.detach();
        }
      }]);
      return Aw;
    }(Jt);
    var _w = n(56),
      vw = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Zl()(_w.a, vw), _w.a.locals;
    var yw = /*#__PURE__*/function (_ed31) {
      _inherits(yw, _ed31);
      function yw(t, e) {
        var _this292;
        _classCallCheck(this, yw);
        _this292 = _possibleConstructorReturn(this, _getPrototypeOf(yw).call(this, e));
        var n = e.t;
        _this292.focusTracker = new Ys(), _this292.keystrokes = new Qs(), _this292.set("mediaURLInputValue", ""), _this292.urlInputView = _this292._createUrlInput(), _this292.saveButtonView = _this292._createButton(n("Save"), ql.check, "ck-button-save"), _this292.saveButtonView.type = "submit", _this292.saveButtonView.bind("isEnabled").to(_assertThisInitialized(_assertThisInitialized(_this292)), "mediaURLInputValue", function (t) {
          return !!t;
        }), _this292.cancelButtonView = _this292._createButton(n("Cancel"), ql.cancel, "ck-button-cancel", "cancel"), _this292._focusables = new $l(), _this292._focusCycler = new Od({
          focusables: _this292._focusables,
          focusTracker: _this292.focusTracker,
          keystrokeHandler: _this292.keystrokes,
          actions: {
            focusPrevious: "shift + tab",
            focusNext: "tab"
          }
        }), _this292._validators = t, _this292.setTemplate({
          tag: "form",
          attributes: {
            class: ["ck", "ck-media-form", "ck-responsive-form"],
            tabindex: "-1"
          },
          children: [_this292.urlInputView, _this292.saveButtonView, _this292.cancelButtonView]
        }), Yl(_assertThisInitialized(_assertThisInitialized(_this292)));
        return _this292;
      }
      _createClass(yw, [{
        key: "render",
        value: function render() {
          var _this293 = this;
          _get(_getPrototypeOf(yw.prototype), "render", this).call(this), Ql({
            view: this
          });
          [this.urlInputView, this.saveButtonView, this.cancelButtonView].forEach(function (t) {
            _this293._focusables.add(t), _this293.focusTracker.add(t.element);
          }), this.keystrokes.listenTo(this.element);
          var t = function t(_t336) {
            return _t336.stopPropagation();
          };
          this.keystrokes.set("arrowright", t), this.keystrokes.set("arrowleft", t), this.keystrokes.set("arrowup", t), this.keystrokes.set("arrowdown", t), this.listenTo(this.urlInputView.element, "selectstart", function (t, e) {
            e.stopPropagation();
          }, {
            priority: "high"
          });
        }
      }, {
        key: "focus",
        value: function focus() {
          this._focusCycler.focusFirst();
        }
      }, {
        key: "isValid",
        value: function isValid() {
          this.resetFormStatus();
          var _iterator407 = _createForOfIteratorHelper(this._validators),
            _step407;
          try {
            for (_iterator407.s(); !(_step407 = _iterator407.n()).done;) {
              var _t337 = _step407.value;
              var _e311 = _t337(this);
              if (_e311) return this.urlInputView.errorText = _e311, !1;
            }
          } catch (err) {
            _iterator407.e(err);
          } finally {
            _iterator407.f();
          }
          return !0;
        }
      }, {
        key: "resetFormStatus",
        value: function resetFormStatus() {
          this.urlInputView.errorText = null, this.urlInputView.infoText = this._urlInputViewInfoDefault;
        }
      }, {
        key: "_createUrlInput",
        value: function _createUrlInput() {
          var _this294 = this;
          var t = this.locale.t,
            e = new Rh(this.locale, jh),
            n = e.fieldView;
          return this._urlInputViewInfoDefault = t("Paste the media URL in the input."), this._urlInputViewInfoTip = t("Tip: Paste the URL into the content to embed faster."), e.label = t("Media URL"), e.infoText = this._urlInputViewInfoDefault, n.on("input", function () {
            e.infoText = n.element.value ? _this294._urlInputViewInfoTip : _this294._urlInputViewInfoDefault, _this294.mediaURLInputValue = n.element.value.trim();
          }), e;
        }
      }, {
        key: "_createButton",
        value: function _createButton(t, e, n, o) {
          var i = new Sd(this.locale);
          return i.set({
            label: t,
            icon: e,
            tooltip: !0
          }), i.extendTemplate({
            attributes: {
              class: n
            }
          }), o && i.delegate("execute").to(this, o), i;
        }
      }, {
        key: "url",
        get: function get() {
          return this.urlInputView.fieldView.element.value.trim();
        },
        set: function set(t) {
          this.urlInputView.fieldView.element.value = t.trim();
        }
      }]);
      return yw;
    }(ed);
    var xw = /*#__PURE__*/function (_Jt65) {
      _inherits(xw, _Jt65);
      function xw() {
        _classCallCheck(this, xw);
        return _possibleConstructorReturn(this, _getPrototypeOf(xw).apply(this, arguments));
      }
      _createClass(xw, [{
        key: "init",
        value: function init() {
          var _this295 = this;
          var t = this.editor,
            e = t.commands.get("mediaEmbed"),
            n = t.plugins.get(ww).registry;
          t.ui.componentFactory.add("mediaEmbed", function (o) {
            var i = wh(o),
              r = new yw(function (t, e) {
                return [function (e) {
                  if (!e.url.length) return t("The URL must not be empty.");
                }, function (n) {
                  if (!e.hasMedia(n.url)) return t("This media URL is not supported.");
                }];
              }(t.t, n), t.locale);
            return _this295._setUpDropdown(i, r, e, t), _this295._setUpForm(i, r, e), i;
          });
        }
      }, {
        key: "_setUpDropdown",
        value: function _setUpDropdown(t, e, n) {
          var o = this.editor,
            i = o.t,
            r = t.buttonView;
          function s() {
            o.editing.view.focus(), t.isOpen = !1;
          }
          t.bind("isEnabled").to(n), t.panelView.children.add(e), r.set({
            label: i("Insert media"),
            icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M18.68 3.03c.6 0 .59-.03.59.55v12.84c0 .59.01.56-.59.56H1.29c-.6 0-.59.03-.59-.56V3.58c0-.58-.01-.55.6-.55h17.38zM15.77 15V5H4.2v10h11.57zM2 4v1h1V4H2zm0 2v1h1V6H2zm0 2v1h1V8H2zm0 2v1h1v-1H2zm0 2v1h1v-1H2zm0 2v1h1v-1H2zM17 4v1h1V4h-1zm0 2v1h1V6h-1zm0 2v1h1V8h-1zm0 2v1h1v-1h-1zm0 2v1h1v-1h-1zm0 2v1h1v-1h-1zM7.5 7.177a.4.4 0 0 1 .593-.351l5.133 2.824a.4.4 0 0 1 0 .7l-5.133 2.824a.4.4 0 0 1-.593-.35V7.176v.001z"/></svg>',
            tooltip: !0
          }), r.on("open", function () {
            e.disableCssTransitions(), e.url = n.value || "", e.urlInputView.fieldView.select(), e.focus(), e.enableCssTransitions();
          }, {
            priority: "low"
          }), t.on("submit", function () {
            e.isValid() && (o.execute("mediaEmbed", e.url), s());
          }), t.on("change:isOpen", function () {
            return e.resetFormStatus();
          }), t.on("cancel", function () {
            return s();
          });
        }
      }, {
        key: "_setUpForm",
        value: function _setUpForm(t, e, n) {
          e.delegate("submit", "cancel").to(t), e.urlInputView.bind("value").to(n, "value"), e.urlInputView.bind("isReadOnly").to(n, "isEnabled", function (t) {
            return !t;
          });
        }
      }], [{
        key: "requires",
        get: function get() {
          return [ww];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "MediaEmbedUI";
        }
      }]);
      return xw;
    }(Jt);
    var Ew = n(57),
      Dw = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Zl()(Ew.a, Dw), Ew.a.locals;
    function Mw(t, e) {
      if (!t.childCount) return;
      var n = new Su(t.document),
        o = function (t, e) {
          var n = e.createRangeIn(t),
            o = new yo({
              name: /^p|h\d+$/,
              styles: {
                "mso-list": /.*/
              }
            }),
            i = [];
          var _iterator408 = _createForOfIteratorHelper(n),
            _step408;
          try {
            for (_iterator408.s(); !(_step408 = _iterator408.n()).done;) {
              var _t338 = _step408.value;
              if ("elementStart" === _t338.type && o.match(_t338.item)) {
                var _e312 = Sw(_t338.item);
                i.push({
                  element: _t338.item,
                  id: _e312.id,
                  order: _e312.order,
                  indent: _e312.indent
                });
              }
            }
          } catch (err) {
            _iterator408.e(err);
          } finally {
            _iterator408.f();
          }
          return i;
        }(t, n);
      if (!o.length) return;
      var i = null,
        r = 1;
      o.forEach(function (t, s) {
        var a = function (t, e) {
            if (!t) return !0;
            if (t.id !== e.id) return e.indent - t.indent != 1;
            var n = e.element.previousSibling;
            if (!n) return !0;
            return o = n, !(o.is("element", "ol") || o.is("element", "ul"));
            var o;
          }(o[s - 1], t),
          c = a ? null : o[s - 1],
          l = (h = t, (d = c) ? h.indent - d.indent : h.indent - 1);
        var d, h;
        if (a && (i = null, r = 1), !i || 0 !== l) {
          var _o183 = function (t, e) {
            var n = new RegExp("@list l".concat(t.id, ":level").concat(t.indent, "\\s*({[^}]*)"), "gi"),
              o = /mso-level-number-format:([^;]{0,100});/gi,
              i = n.exec(e);
            var r = "decimal",
              s = "ol";
            if (i && i[1]) {
              var _e313 = o.exec(i[1]);
              if (_e313 && _e313[1] && (r = _e313[1].trim(), s = "bullet" !== r && "image" !== r ? "ol" : "ul"), "bullet" === r) {
                var _e314 = function (t) {
                  var e = function (t) {
                    if (t.getChild(0).is("$text")) return null;
                    var e = t.getChild(0).getChild(0);
                    if (e.is("$text")) return e;
                    return e.getChild(0);
                  }(t);
                  if (!e) return null;
                  var n = e._data;
                  if ("o" === n) return "circle";
                  if ("·" === n) return "disc";
                  if ("§" === n) return "square";
                  return null;
                }(t.element);
                _e314 && (r = _e314);
              }
            }
            return {
              type: s,
              style: Iw(r)
            };
          }(t, e);
          if (i) {
            if (t.indent > r) {
              var _t339 = i.getChild(i.childCount - 1),
                _e315 = _t339.getChild(_t339.childCount - 1);
              i = Tw(_o183, _e315, n), r += 1;
            } else if (t.indent < r) {
              var _e316 = r - t.indent;
              i = function (t, e) {
                var n = t.getAncestors({
                  parentFirst: !0
                });
                var o = null,
                  i = 0;
                var _iterator409 = _createForOfIteratorHelper(n),
                  _step409;
                try {
                  for (_iterator409.s(); !(_step409 = _iterator409.n()).done;) {
                    var _t340 = _step409.value;
                    if ("ul" !== _t340.name && "ol" !== _t340.name || i++, i === e) {
                      o = _t340;
                      break;
                    }
                  }
                } catch (err) {
                  _iterator409.e(err);
                } finally {
                  _iterator409.f();
                }
                return o;
              }(i, _e316), r = parseInt(t.indent);
            }
          } else i = Tw(_o183, t.element, n);
          t.indent <= r && (i.is("element", _o183.type) || (i = n.rename(_o183.type, i)));
        }
        var u = function (t, e) {
          return function (t, e) {
            var n = new yo({
                name: "span",
                styles: {
                  "mso-list": "Ignore"
                }
              }),
              o = e.createRangeIn(t);
            var _iterator410 = _createForOfIteratorHelper(o),
              _step410;
            try {
              for (_iterator410.s(); !(_step410 = _iterator410.n()).done;) {
                var _t341 = _step410.value;
                "elementStart" === _t341.type && n.match(_t341.item) && e.remove(_t341.item);
              }
            } catch (err) {
              _iterator410.e(err);
            } finally {
              _iterator410.f();
            }
          }(t, e), e.rename("li", t);
        }(t.element, n);
        n.appendChild(u, i);
      });
    }
    function Iw(t) {
      switch (t) {
        case "arabic-leading-zero":
          return "decimal-leading-zero";
        case "alpha-upper":
          return "upper-alpha";
        case "alpha-lower":
          return "lower-alpha";
        case "roman-upper":
          return "upper-roman";
        case "roman-lower":
          return "lower-roman";
        case "circle":
        case "disc":
        case "square":
          return t;
        default:
          return null;
      }
    }
    function Tw(t, e, n) {
      var o = e.parent,
        i = n.createElement(t.type),
        r = o.getChildIndex(e) + 1;
      return n.insertChild(r, i, o), t.style && n.setStyle("list-style-type", t.style, i), i;
    }
    function Sw(t) {
      var e = {},
        n = t.getStyle("mso-list");
      if (n) {
        var _t342 = n.match(/(^|\s{1,100})l(\d+)/i),
          _o184 = n.match(/\s{0,100}lfo(\d+)/i),
          _i150 = n.match(/\s{0,100}level(\d+)/i);
        _t342 && _o184 && _i150 && (e.id = _t342[2], e.order = _o184[1], e.indent = _i150[1]);
      }
      return e;
    }
    var Nw = /id=("|')docs-internal-guid-[-0-9a-f]+("|')/i;
    var Bw = /*#__PURE__*/function () {
      function Bw(t) {
        _classCallCheck(this, Bw);
        this.document = t;
      }
      _createClass(Bw, [{
        key: "isActive",
        value: function isActive(t) {
          return Nw.test(t);
        }
      }, {
        key: "execute",
        value: function execute(t) {
          var e = new Su(this.document);
          !function (t, e) {
            var _iterator411 = _createForOfIteratorHelper(t.getChildren()),
              _step411;
            try {
              for (_iterator411.s(); !(_step411 = _iterator411.n()).done;) {
                var _n277 = _step411.value;
                if (_n277.is("element", "b") && "normal" === _n277.getStyle("font-weight")) {
                  var _o185 = t.getChildIndex(_n277);
                  e.remove(_n277), e.insertChild(_o185, _n277.getChildren(), t);
                }
              }
            } catch (err) {
              _iterator411.e(err);
            } finally {
              _iterator411.f();
            }
          }(t.content, e), function (t, e) {
            var _iterator412 = _createForOfIteratorHelper(e.createRangeIn(t)),
              _step412;
            try {
              for (_iterator412.s(); !(_step412 = _iterator412.n()).done;) {
                var _n278 = _step412.value;
                var _t343 = _n278.item;
                if (_t343.is("element", "li")) {
                  var _n279 = _t343.getChild(0);
                  _n279 && _n279.is("element", "p") && e.unwrapElement(_n279);
                }
              }
            } catch (err) {
              _iterator412.e(err);
            } finally {
              _iterator412.f();
            }
          }(t.content, e);
        }
      }]);
      return Bw;
    }();
    function Pw(t) {
      return t.replace(/<span(?: class="Apple-converted-space"|)>(\s+)<\/span>/g, function (t, e) {
        return 1 === e.length ? " " : Array(e.length + 1).join("  ").substr(0, e.length);
      });
    }
    function zw(t, e) {
      var n = new DOMParser(),
        o = function (t) {
          return Pw(Pw(t)).replace(/(<span\s+style=['"]mso-spacerun:yes['"]>[^\S\r\n]*?)[\r\n]+([^\S\r\n]*<\/span>)/g, "$1$2").replace(/<span\s+style=['"]mso-spacerun:yes['"]><\/span>/g, "").replace(/ <\//g, " </").replace(/ <o:p><\/o:p>/g, " <o:p></o:p>").replace(/<o:p>(&nbsp;|\u00A0)<\/o:p>/g, "").replace(/>([^\S\r\n]*[\r\n]\s*)</g, "><");
        }(function (t) {
          var e = "</body>",
            n = "</html>",
            o = t.indexOf(e);
          if (o < 0) return t;
          var i = t.indexOf(n, o + e.length);
          return t.substring(0, o + e.length) + (i >= 0 ? t.substring(i) : "");
        }(t = t.replace(/<!--\[if gte vml 1]>/g, ""))),
        i = n.parseFromString(o, "text/html");
      !function (t) {
        t.querySelectorAll("span[style*=spacerun]").forEach(function (t) {
          var e = t.innerText.length || 0;
          t.innerHTML = Array(e + 1).join("  ").substr(0, e);
        });
      }(i);
      var r = i.body.innerHTML,
        s = function (t, e) {
          var n = new Si(e),
            o = new Or(n, {
              blockFillerMode: "nbsp"
            }),
            i = t.createDocumentFragment(),
            r = t.body.childNodes;
          for (; r.length > 0;) i.appendChild(r[0]);
          return o.domToView(i);
        }(i, e),
        a = function (t) {
          var e = [],
            n = [],
            o = Array.from(t.getElementsByTagName("style"));
          for (var _i151 = 0, _o186 = o; _i151 < _o186.length; _i151++) {
            var _t344 = _o186[_i151];
            _t344.sheet && _t344.sheet.cssRules && _t344.sheet.cssRules.length && (e.push(_t344.sheet), n.push(_t344.innerHTML));
          }
          return {
            styles: e,
            stylesString: n.join(" ")
          };
        }(i);
      return {
        body: s,
        bodyString: r,
        styles: a.styles,
        stylesString: a.stylesString
      };
    }
    function Lw(t, e) {
      if (!t.childCount) return;
      var n = new Su();
      !function (t, e, n) {
        var o = n.createRangeIn(e),
          i = new yo({
            name: "img"
          }),
          r = [];
        var _iterator413 = _createForOfIteratorHelper(o),
          _step413;
        try {
          for (_iterator413.s(); !(_step413 = _iterator413.n()).done;) {
            var _e317 = _step413.value;
            if (i.match(_e317.item)) {
              var _n280 = _e317.item,
                _o187 = _n280.getAttribute("v:shapes") ? _n280.getAttribute("v:shapes").split(" ") : [];
              _o187.length && _o187.every(function (e) {
                return t.indexOf(e) > -1;
              }) ? r.push(_n280) : _n280.getAttribute("src") || r.push(_n280);
            }
          }
        } catch (err) {
          _iterator413.e(err);
        } finally {
          _iterator413.f();
        }
        for (var _i152 = 0, _r66 = r; _i152 < _r66.length; _i152++) {
          var _t345 = _r66[_i152];
          n.remove(_t345);
        }
      }(function (t, e) {
        var n = e.createRangeIn(t),
          o = new yo({
            name: /v:(.+)/
          }),
          i = [];
        var _iterator414 = _createForOfIteratorHelper(n),
          _step414;
        try {
          for (_iterator414.s(); !(_step414 = _iterator414.n()).done;) {
            var _t346 = _step414.value;
            var _e318 = _t346.item,
              _n281 = _e318.previousSibling && _e318.previousSibling.name || null;
            o.match(_e318) && _e318.getAttribute("o:gfxdata") && "v:shapetype" !== _n281 && i.push(_t346.item.getAttribute("id"));
          }
        } catch (err) {
          _iterator414.e(err);
        } finally {
          _iterator414.f();
        }
        return i;
      }(t, n), t, n), function (t, e) {
        var n = e.createRangeIn(t),
          o = new yo({
            name: /v:(.+)/
          }),
          i = [];
        var _iterator415 = _createForOfIteratorHelper(n),
          _step415;
        try {
          for (_iterator415.s(); !(_step415 = _iterator415.n()).done;) {
            var _t348 = _step415.value;
            o.match(_t348.item) && i.push(_t348.item);
          }
        } catch (err) {
          _iterator415.e(err);
        } finally {
          _iterator415.f();
        }
        for (var _i154 = 0, _i153 = i; _i154 < _i153.length; _i154++) {
          var _t347 = _i153[_i154];
          e.remove(_t347);
        }
      }(t, n);
      var o = function (t, e) {
        var n = e.createRangeIn(t),
          o = new yo({
            name: "img"
          }),
          i = [];
        var _iterator416 = _createForOfIteratorHelper(n),
          _step416;
        try {
          for (_iterator416.s(); !(_step416 = _iterator416.n()).done;) {
            var _t349 = _step416.value;
            o.match(_t349.item) && _t349.item.getAttribute("src").startsWith("file://") && i.push(_t349.item);
          }
        } catch (err) {
          _iterator416.e(err);
        } finally {
          _iterator416.f();
        }
        return i;
      }(t, n);
      o.length && function (t, e, n) {
        if (t.length === e.length) for (var _o189 = 0; _o189 < t.length; _o189++) {
          var _i155 = "data:".concat(e[_o189].type, ";base64,").concat(Ow(e[_o189].hex));
          n.setAttribute("src", _i155, t[_o189]);
        }
      }(o, function (t) {
        if (!t) return [];
        var e = /{\\pict[\s\S]+?\\bliptag-?\d+(\\blipupi-?\d+)?({\\\*\\blipuid\s?[\da-fA-F]+)?[\s}]*?/,
          n = new RegExp("(?:(" + e.source + "))([\\da-fA-F\\s]+)\\}", "g"),
          o = t.match(n),
          i = [];
        if (o) {
          var _iterator417 = _createForOfIteratorHelper(o),
            _step417;
          try {
            for (_iterator417.s(); !(_step417 = _iterator417.n()).done;) {
              var _t350 = _step417.value;
              var _n282 = !1;
              _t350.includes("\\pngblip") ? _n282 = "image/png" : _t350.includes("\\jpegblip") && (_n282 = "image/jpeg"), _n282 && i.push({
                hex: _t350.replace(e, "").replace(/[^\da-fA-F]/g, ""),
                type: _n282
              });
            }
          } catch (err) {
            _iterator417.e(err);
          } finally {
            _iterator417.f();
          }
        }
        return i;
      }(e), n);
    }
    function Ow(t) {
      return btoa(t.match(/\w{2}/g).map(function (t) {
        return String.fromCharCode(parseInt(t, 16));
      }).join(""));
    }
    var Rw = /<meta\s*name="?generator"?\s*content="?microsoft\s*word\s*\d+"?\/?>/i,
      jw = /xmlns:o="urn:schemas-microsoft-com/i;
    var Fw = /*#__PURE__*/function () {
      function Fw(t) {
        _classCallCheck(this, Fw);
        this.document = t;
      }
      _createClass(Fw, [{
        key: "isActive",
        value: function isActive(t) {
          return Rw.test(t) || jw.test(t);
        }
      }, {
        key: "execute",
        value: function execute(t) {
          var _zw = zw(t.dataTransfer.getData("text/html"), this.document.stylesProcessor),
            e = _zw.body,
            n = _zw.stylesString;
          Mw(e, n), Lw(e, t.dataTransfer.getData("text/rtf")), t.content = e;
        }
      }]);
      return Fw;
    }();
    function Vw(t, e, n, o) {
      var i = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
      e > i ? o.setAttribute(t, e, n) : o.removeAttribute(t, n);
    }
    function Uw(t, e) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var o = t.createElement("tableCell", n);
      return t.insertElement("paragraph", o), t.insert(o, e), o;
    }
    function Hw(t, e) {
      var n = e.parent.parent,
        o = parseInt(n.getAttribute("headingColumns") || 0),
        _t$getCellLocation = t.getCellLocation(e),
        i = _t$getCellLocation.column;
      return !!o && i < o;
    }
    function Gw() {
      return function (t) {
        t.on("element:table", function (t, e, n) {
          var o = e.viewItem;
          if (!n.consumable.test(o, {
            name: !0
          })) return;
          var _ref82 = function (t) {
              var e = {
                  headingRows: 0,
                  headingColumns: 0
                },
                n = [],
                o = [];
              var i;
              for (var _i156 = 0, _Array$from7 = Array.from(t.getChildren()); _i156 < _Array$from7.length; _i156++) {
                var _r67 = _Array$from7[_i156];
                if ("tbody" === _r67.name || "thead" === _r67.name || "tfoot" === _r67.name) {
                  "thead" !== _r67.name || i || (i = _r67);
                  var _t351 = Array.from(_r67.getChildren()).filter(function (t) {
                    return t.is("element", "tr");
                  });
                  var _iterator418 = _createForOfIteratorHelper(_t351),
                    _step418;
                  try {
                    for (_iterator418.s(); !(_step418 = _iterator418.n()).done;) {
                      var _r68 = _step418.value;
                      if ("thead" === _r68.parent.name && _r68.parent === i) e.headingRows++, n.push(_r68);else {
                        o.push(_r68);
                        var _t352 = qw(_r68);
                        _t352 > e.headingColumns && (e.headingColumns = _t352);
                      }
                    }
                  } catch (err) {
                    _iterator418.e(err);
                  } finally {
                    _iterator418.f();
                  }
                }
              }
              return e.rows = [].concat(n, o), e;
            }(o),
            i = _ref82.rows,
            r = _ref82.headingRows,
            s = _ref82.headingColumns,
            a = {};
          s && (a.headingColumns = s), r && (a.headingRows = r);
          var c = n.writer.createElement("table", a);
          if (n.safeInsert(c, e.modelCursor)) {
            if (n.consumable.consume(o, {
              name: !0
            }), i.forEach(function (t) {
              return n.convertItem(t, n.writer.createPositionAt(c, "end"));
            }), n.convertChildren(o, n.writer.createPositionAt(c, "end")), c.isEmpty) {
              var _t353 = n.writer.createElement("tableRow");
              n.writer.insert(_t353, n.writer.createPositionAt(c, "end")), Uw(n.writer, n.writer.createPositionAt(_t353, "end"));
            }
            n.updateConversionResult(c, e);
          }
        });
      };
    }
    function Ww(t) {
      return function (e) {
        e.on("element:".concat(t), function (t, e, n) {
          if (e.modelRange && e.viewItem.isEmpty) {
            var _t354 = e.modelRange.start.nodeAfter,
              _o190 = n.writer.createPositionAt(_t354, 0);
            n.writer.insertElement("paragraph", _o190);
          }
        }, {
          priority: "low"
        });
      };
    }
    function qw(t) {
      var e = 0,
        n = 0;
      var o = Array.from(t.getChildren()).filter(function (t) {
        return "th" === t.name || "td" === t.name;
      });
      for (; n < o.length && "th" === o[n].name;) {
        var _t355 = o[n];
        e += parseInt(_t355.getAttribute("colspan") || 1), n++;
      }
      return e;
    }
    var Kw = /*#__PURE__*/function () {
      function Kw(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        _classCallCheck(this, Kw);
        this._table = t, this._startRow = void 0 !== e.row ? e.row : e.startRow || 0, this._endRow = void 0 !== e.row ? e.row : e.endRow, this._startColumn = void 0 !== e.column ? e.column : e.startColumn || 0, this._endColumn = void 0 !== e.column ? e.column : e.endColumn, this._includeAllSlots = !!e.includeAllSlots, this._skipRows = new Set(), this._row = 0, this._rowIndex = 0, this._column = 0, this._cellIndex = 0, this._spannedCells = new Map(), this._nextCellAtColumn = -1;
      }
      _createClass(Kw, [{
        key: Symbol.iterator,
        value: function value() {
          return this;
        }
      }, {
        key: "next",
        value: function next() {
          var t = this._table.getChild(this._rowIndex);
          if (!t || this._isOverEndRow()) return {
            done: !0
          };
          if (!t.is("element", "tableRow")) return this._rowIndex++, this.next();
          if (this._isOverEndColumn()) return this._advanceToNextRow();
          var e = null;
          var n = this._getSpanned();
          if (n) this._includeAllSlots && !this._shouldSkipSlot() && (e = this._formatOutValue(n.cell, n.row, n.column));else {
            var _n283 = t.getChild(this._cellIndex);
            if (!_n283) return this._advanceToNextRow();
            var _o191 = parseInt(_n283.getAttribute("colspan") || 1),
              _i157 = parseInt(_n283.getAttribute("rowspan") || 1);
            (_o191 > 1 || _i157 > 1) && this._recordSpans(_n283, _i157, _o191), this._shouldSkipSlot() || (e = this._formatOutValue(_n283)), this._nextCellAtColumn = this._column + _o191;
          }
          return this._column++, this._column == this._nextCellAtColumn && this._cellIndex++, e || this.next();
        }
      }, {
        key: "skipRow",
        value: function skipRow(t) {
          this._skipRows.add(t);
        }
      }, {
        key: "_advanceToNextRow",
        value: function _advanceToNextRow() {
          return this._row++, this._rowIndex++, this._column = 0, this._cellIndex = 0, this._nextCellAtColumn = -1, this.next();
        }
      }, {
        key: "_isOverEndRow",
        value: function _isOverEndRow() {
          return void 0 !== this._endRow && this._row > this._endRow;
        }
      }, {
        key: "_isOverEndColumn",
        value: function _isOverEndColumn() {
          return void 0 !== this._endColumn && this._column > this._endColumn;
        }
      }, {
        key: "_formatOutValue",
        value: function _formatOutValue(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._row;
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this._column;
          return {
            done: !1,
            value: new Yw(this, t, e, n)
          };
        }
      }, {
        key: "_shouldSkipSlot",
        value: function _shouldSkipSlot() {
          var t = this._skipRows.has(this._row),
            e = this._row < this._startRow,
            n = this._column < this._startColumn,
            o = void 0 !== this._endColumn && this._column > this._endColumn;
          return t || e || n || o;
        }
      }, {
        key: "_getSpanned",
        value: function _getSpanned() {
          var t = this._spannedCells.get(this._row);
          return t && t.get(this._column) || null;
        }
      }, {
        key: "_recordSpans",
        value: function _recordSpans(t, e, n) {
          var o = {
            cell: t,
            row: this._row,
            column: this._column
          };
          for (var _t357 = this._row; _t357 < this._row + e; _t357++) for (var _e320 = this._column; _e320 < this._column + n; _e320++) _t357 == this._row && _e320 == this._column || this._markSpannedCell(_t357, _e320, o);
        }
      }, {
        key: "_markSpannedCell",
        value: function _markSpannedCell(t, e, n) {
          this._spannedCells.has(t) || this._spannedCells.set(t, new Map());
          this._spannedCells.get(t).set(e, n);
        }
      }]);
      return Kw;
    }();
    var Yw = /*#__PURE__*/function () {
      function Yw(t, e, n, o) {
        _classCallCheck(this, Yw);
        this.cell = e, this.row = t._row, this.column = t._column, this.cellAnchorRow = n, this.cellAnchorColumn = o, this._cellIndex = t._cellIndex, this._rowIndex = t._rowIndex, this._table = t._table;
      }
      _createClass(Yw, [{
        key: "getPositionBefore",
        value: function getPositionBefore() {
          return this._table.root.document.model.createPositionAt(this._table.getChild(this.row), this._cellIndex);
        }
      }, {
        key: "isAnchor",
        get: function get() {
          return this.row === this.cellAnchorRow && this.column === this.cellAnchorColumn;
        }
      }, {
        key: "cellWidth",
        get: function get() {
          return parseInt(this.cell.getAttribute("colspan") || 1);
        }
      }, {
        key: "cellHeight",
        get: function get() {
          return parseInt(this.cell.getAttribute("rowspan") || 1);
        }
      }, {
        key: "rowIndex",
        get: function get() {
          return this._rowIndex;
        }
      }]);
      return Yw;
    }();
    function Qw() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return function (e) {
        return e.on("insert:table", function (e, n, o) {
          var i = n.item;
          if (!o.consumable.consume(i, "insert")) return;
          o.consumable.consume(i, "attribute:headingRows:table"), o.consumable.consume(i, "attribute:headingColumns:table");
          var r = t && t.asWidget,
            s = o.writer.createContainerElement("figure", {
              class: "table"
            }),
            a = o.writer.createContainerElement("table");
          var c;
          var l, d;
          o.writer.insert(o.writer.createPositionAt(s, 0), a), r && (l = s, (d = o.writer).setCustomProperty("table", !0, l), c = um(l, d, {
            hasSelectionHandle: !0
          }));
          var h = new Kw(i),
            u = {
              headingRows: i.getAttribute("headingRows") || 0,
              headingColumns: i.getAttribute("headingColumns") || 0
            },
            g = new Map();
          var _iterator419 = _createForOfIteratorHelper(h),
            _step419;
          try {
            for (_iterator419.s(); !(_step419 = _iterator419.n()).done;) {
              var _e321 = _step419.value;
              var _n284 = _e321.row,
                _r69 = _e321.cell,
                _s40 = i.getChild(_n284),
                _c14 = g.get(_n284) || tC(a, _s40, _n284, u, o);
              g.set(_n284, _c14), o.consumable.consume(_r69, "insert");
              Xw(_e321, u, o.writer.createPositionAt(_c14, "end"), o, t);
            }
          } catch (err) {
            _iterator419.e(err);
          } finally {
            _iterator419.f();
          }
          var _iterator420 = _createForOfIteratorHelper(i.getChildren()),
            _step420;
          try {
            for (_iterator420.s(); !(_step420 = _iterator420.n()).done;) {
              var _t358 = _step420.value;
              var _e322 = _t358.index;
              _t358.is("element", "tableRow") && !g.has(_e322) && g.set(_e322, tC(a, _t358, _e322, u, o));
            }
          } catch (err) {
            _iterator420.e(err);
          } finally {
            _iterator420.f();
          }
          var m = o.mapper.toViewPosition(n.range.start);
          o.mapper.bindElements(i, r ? c : s), o.writer.insert(m, r ? c : s);
        });
      };
    }
    function $w(t, e) {
      var n = e.writer;
      if (t.parent.is("element", "tableCell")) return Jw(t) ? n.createContainerElement("span", {
        class: "ck-table-bogus-paragraph"
      }) : n.createContainerElement("p");
    }
    function Jw(t) {
      return 1 === t.parent.childCount && !iC(t);
    }
    function Zw(t, e, n) {
      var o = t.cell,
        i = eC(t, e),
        r = n.mapper.toViewElement(o);
      r && r.name !== i && function (t, e, n) {
        var o = n.writer,
          i = n.mapper.toViewElement(t),
          r = km(o.createEditableElement(e, i.getAttributes()), o);
        pm(r, o, function (t, e, n) {
          return n.addClass(ho(e.classes), t);
        }, function (t, e, n) {
          return n.removeClass(ho(e.classes), t);
        }), o.insert(o.createPositionAfter(i), r), o.move(o.createRangeIn(i), o.createPositionAt(r, 0)), o.remove(o.createRangeOn(i)), n.mapper.unbindViewElement(i), n.mapper.bindElements(t, r);
      }(o, i, n);
    }
    function Xw(t, e, n, o, i) {
      var r = i && i.asWidget,
        s = eC(t, e),
        a = r ? km(o.writer.createEditableElement(s), o.writer) : o.writer.createContainerElement(s);
      r && pm(a, o.writer, function (t, e, n) {
        return n.addClass(ho(e.classes), t);
      }, function (t, e, n) {
        return n.removeClass(ho(e.classes), t);
      });
      var c = t.cell,
        l = c.getChild(0),
        d = 1 === c.childCount && "paragraph" === l.name;
      if (o.writer.insert(n, a), o.mapper.bindElements(c, a), !r && d && !iC(l)) {
        var _t359 = c.getChild(0);
        o.consumable.consume(_t359, "insert"), o.mapper.bindElements(_t359, a);
      }
    }
    function tC(t, e, n, o, i) {
      i.consumable.consume(e, "insert");
      var r = e.isEmpty ? i.writer.createEmptyElement("tr") : i.writer.createContainerElement("tr");
      i.mapper.bindElements(e, r);
      var s = o.headingRows,
        a = function (t, e, n) {
          var o = nC(t, e);
          return o || function (t, e, n) {
            var o = n.writer.createContainerElement(t),
              i = n.writer.createPositionAt(e, "tbody" == t ? "end" : 0);
            return n.writer.insert(i, o), o;
          }(t, e, n);
        }(function (t, e) {
          return t < e.headingRows ? "thead" : "tbody";
        }(n, o), t, i),
        c = s > 0 && n >= s ? n - s : n,
        l = i.writer.createPositionAt(a, c);
      return i.writer.insert(l, r), r;
    }
    function eC(t, e) {
      var n = t.row,
        o = t.column,
        i = e.headingColumns,
        r = e.headingRows;
      if (r && r > n) return "th";
      return i && i > o ? "th" : "td";
    }
    function nC(t, e) {
      var _iterator421 = _createForOfIteratorHelper(e.getChildren()),
        _step421;
      try {
        for (_iterator421.s(); !(_step421 = _iterator421.n()).done;) {
          var _n285 = _step421.value;
          if (_n285.name == t) return _n285;
        }
      } catch (err) {
        _iterator421.e(err);
      } finally {
        _iterator421.f();
      }
    }
    function oC(t, e, n) {
      var o = nC(t, e);
      o && 0 === o.childCount && n.writer.remove(n.writer.createRangeOn(o));
    }
    function iC(t) {
      return !!_toConsumableArray(t.getAttributeKeys()).length;
    }
    var rC = /*#__PURE__*/function (_Xt26) {
      _inherits(rC, _Xt26);
      function rC() {
        _classCallCheck(this, rC);
        return _possibleConstructorReturn(this, _getPrototypeOf(rC).apply(this, arguments));
      }
      _createClass(rC, [{
        key: "refresh",
        value: function refresh() {
          var t = this.editor.model,
            e = t.document.selection,
            n = t.schema;
          this.isEnabled = function (t, e) {
            var n = t.getFirstPosition().parent,
              o = n === n.root ? n : n.parent;
            return e.checkChild(o, "table");
          }(e, n);
        }
      }, {
        key: "execute",
        value: function execute() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var e = this.editor.model,
            n = e.document.selection,
            o = this.editor.plugins.get("TableUtils"),
            i = bm(n, e);
          e.change(function (n) {
            var r = o.createTable(n, t);
            e.insertContent(r, i), n.setSelection(n.createPositionAt(r.getNodeByPath([0, 0, 0]), 0));
          });
        }
      }]);
      return rC;
    }(Xt);
    function sC(t) {
      var e = [];
      var _iterator422 = _createForOfIteratorHelper(uC(t.getRanges())),
        _step422;
      try {
        for (_iterator422.s(); !(_step422 = _iterator422.n()).done;) {
          var _n286 = _step422.value;
          var _t360 = _n286.getContainedElement();
          _t360 && _t360.is("element", "tableCell") && e.push(_t360);
        }
      } catch (err) {
        _iterator422.e(err);
      } finally {
        _iterator422.f();
      }
      return e;
    }
    function aC(t) {
      var e = [];
      var _iterator423 = _createForOfIteratorHelper(t.getRanges()),
        _step423;
      try {
        for (_iterator423.s(); !(_step423 = _iterator423.n()).done;) {
          var _n287 = _step423.value;
          var _t361 = _n287.start.findAncestor("tableCell");
          _t361 && e.push(_t361);
        }
      } catch (err) {
        _iterator423.e(err);
      } finally {
        _iterator423.f();
      }
      return e;
    }
    function cC(t) {
      var e = sC(t);
      return e.length ? e : aC(t);
    }
    function lC(t) {
      return gC(t.map(function (t) {
        return t.parent.index;
      }));
    }
    function dC(t) {
      var e = t[0].findAncestor("table");
      return gC(_toConsumableArray(new Kw(e)).filter(function (e) {
        return t.includes(e.cell);
      }).map(function (t) {
        return t.column;
      }));
    }
    function hC(t, e) {
      if (t.length < 2 || !function (t) {
        var e = t[0].findAncestor("table"),
          n = lC(t),
          o = parseInt(e.getAttribute("headingRows") || 0);
        if (!pC(n, o)) return !1;
        var i = parseInt(e.getAttribute("headingColumns") || 0);
        return pC(dC(t), i);
      }(t)) return !1;
      var n = new Set(),
        o = new Set();
      var i = 0;
      var _iterator424 = _createForOfIteratorHelper(t),
        _step424;
      try {
        for (_iterator424.s(); !(_step424 = _iterator424.n()).done;) {
          var _r70 = _step424.value;
          var _e$getCellLocation = e.getCellLocation(_r70),
            _t362 = _e$getCellLocation.row,
            _s41 = _e$getCellLocation.column,
            _a25 = parseInt(_r70.getAttribute("rowspan") || 1),
            _c15 = parseInt(_r70.getAttribute("colspan") || 1);
          n.add(_t362), o.add(_s41), _a25 > 1 && n.add(_t362 + _a25 - 1), _c15 > 1 && o.add(_s41 + _c15 - 1), i += _a25 * _c15;
        }
      } catch (err) {
        _iterator424.e(err);
      } finally {
        _iterator424.f();
      }
      return function (t, e) {
        var n = Array.from(t.values()),
          o = Array.from(e.values()),
          i = Math.max.apply(Math, n),
          r = Math.min.apply(Math, n),
          s = Math.max.apply(Math, o),
          a = Math.min.apply(Math, o);
        return (i - r + 1) * (s - a + 1);
      }(n, o) == i;
    }
    function uC(t) {
      return Array.from(t).sort(mC);
    }
    function gC(t) {
      var e = t.sort(function (t, e) {
        return t - e;
      });
      return {
        first: e[0],
        last: e[e.length - 1]
      };
    }
    function mC(t, e) {
      var n = t.start,
        o = e.start;
      return n.isBefore(o) ? -1 : 1;
    }
    function pC(_ref83, n) {
      var t = _ref83.first,
        e = _ref83.last;
      return t < n === e < n;
    }
    var fC = /*#__PURE__*/function (_Xt27) {
      _inherits(fC, _Xt27);
      function fC(t) {
        var _this296;
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        _classCallCheck(this, fC);
        _this296 = _possibleConstructorReturn(this, _getPrototypeOf(fC).call(this, t)), _this296.order = e.order || "below";
        return _this296;
      }
      _createClass(fC, [{
        key: "refresh",
        value: function refresh() {
          var t = !!cC(this.editor.model.document.selection).length;
          this.isEnabled = t;
        }
      }, {
        key: "execute",
        value: function execute() {
          var t = this.editor,
            e = t.model.document.selection,
            n = t.plugins.get("TableUtils"),
            o = "above" === this.order,
            i = cC(e),
            r = lC(i),
            s = o ? r.first : r.last,
            a = i[0].findAncestor("table");
          n.insertRows(a, {
            at: o ? s : s + 1,
            copyStructureFromAbove: !o
          });
        }
      }]);
      return fC;
    }(Xt);
    var kC = /*#__PURE__*/function (_Xt28) {
      _inherits(kC, _Xt28);
      function kC(t) {
        var _this297;
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        _classCallCheck(this, kC);
        _this297 = _possibleConstructorReturn(this, _getPrototypeOf(kC).call(this, t)), _this297.order = e.order || "right";
        return _this297;
      }
      _createClass(kC, [{
        key: "refresh",
        value: function refresh() {
          var t = !!cC(this.editor.model.document.selection).length;
          this.isEnabled = t;
        }
      }, {
        key: "execute",
        value: function execute() {
          var t = this.editor,
            e = t.model.document.selection,
            n = t.plugins.get("TableUtils"),
            o = "left" === this.order,
            i = cC(e),
            r = dC(i),
            s = o ? r.first : r.last,
            a = i[0].findAncestor("table");
          n.insertColumns(a, {
            columns: 1,
            at: o ? s : s + 1
          });
        }
      }]);
      return kC;
    }(Xt);
    var bC = /*#__PURE__*/function (_Xt29) {
      _inherits(bC, _Xt29);
      function bC(t) {
        var _this298;
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        _classCallCheck(this, bC);
        _this298 = _possibleConstructorReturn(this, _getPrototypeOf(bC).call(this, t)), _this298.direction = e.direction || "horizontally";
        return _this298;
      }
      _createClass(bC, [{
        key: "refresh",
        value: function refresh() {
          var t = cC(this.editor.model.document.selection);
          this.isEnabled = 1 === t.length;
        }
      }, {
        key: "execute",
        value: function execute() {
          var t = cC(this.editor.model.document.selection)[0],
            e = "horizontally" === this.direction,
            n = this.editor.plugins.get("TableUtils");
          e ? n.splitCellHorizontally(t, 2) : n.splitCellVertically(t, 2);
        }
      }]);
      return bC;
    }(Xt);
    function wC(t, e, n) {
      var o = e.startRow,
        i = e.startColumn,
        r = e.endRow,
        s = e.endColumn,
        a = n.createElement("table"),
        c = r - o + 1;
      for (var _t364 = 0; _t364 < c; _t364++) n.insertElement("tableRow", a, "end");
      var l = _toConsumableArray(new Kw(t, {
        startRow: o,
        endRow: r,
        startColumn: i,
        endColumn: s,
        includeAllSlots: !0
      }));
      var _iterator425 = _createForOfIteratorHelper(l),
        _step425;
      try {
        for (_iterator425.s(); !(_step425 = _iterator425.n()).done;) {
          var _step425$value = _step425.value,
            _t365 = _step425$value.row,
            _e323 = _step425$value.column,
            _c16 = _step425$value.cell,
            _d4 = _step425$value.isAnchor,
            _h4 = _step425$value.cellAnchorRow,
            _u3 = _step425$value.cellAnchorColumn;
          var _l7 = _t365 - o,
            _g4 = a.getChild(_l7);
          if (_d4) {
            var _o192 = n.cloneElement(_c16);
            n.append(_o192, _g4), yC(_o192, _t365, _e323, r, s, n);
          } else (_h4 < o || _u3 < i) && Uw(n, n.createPositionAt(_g4, "end"));
        }
      } catch (err) {
        _iterator425.e(err);
      } finally {
        _iterator425.f();
      }
      return function (t, e, n, o, i) {
        var r = parseInt(e.getAttribute("headingRows") || 0);
        if (r > 0) {
          Vw("headingRows", r - n, t, i, 0);
        }
        var s = parseInt(e.getAttribute("headingColumns") || 0);
        if (s > 0) {
          Vw("headingColumns", s - o, t, i, 0);
        }
      }(a, t, o, i, n), a;
    }
    function CC(t, e) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var o = [],
        i = new Kw(t, {
          startRow: n,
          endRow: e - 1
        });
      var _iterator426 = _createForOfIteratorHelper(i),
        _step426;
      try {
        for (_iterator426.s(); !(_step426 = _iterator426.n()).done;) {
          var _t366 = _step426.value;
          var _n288 = _t366.row,
            _i158 = _t366.cellHeight,
            _r71 = _n288 + _i158 - 1;
          _n288 < e && e <= _r71 && o.push(_t366);
        }
      } catch (err) {
        _iterator426.e(err);
      } finally {
        _iterator426.f();
      }
      return o;
    }
    function AC(t, e, n) {
      var o = t.parent,
        i = o.parent,
        r = o.index,
        s = e - r,
        a = {},
        c = parseInt(t.getAttribute("rowspan")) - s;
      c > 1 && (a.rowspan = c);
      var l = parseInt(t.getAttribute("colspan") || 1);
      l > 1 && (a.colspan = l);
      var d = r + s,
        h = _toConsumableArray(new Kw(i, {
          startRow: r,
          endRow: d,
          includeAllSlots: !0
        }));
      var u,
        g = null;
      var _iterator427 = _createForOfIteratorHelper(h),
        _step427;
      try {
        for (_iterator427.s(); !(_step427 = _iterator427.n()).done;) {
          var _e324 = _step427.value;
          var _o193 = _e324.row,
            _i159 = _e324.column,
            _r72 = _e324.cell;
          _r72 === t && void 0 === u && (u = _i159), void 0 !== u && u === _i159 && _o193 === d && (g = Uw(n, _e324.getPositionBefore(), a));
        }
      } catch (err) {
        _iterator427.e(err);
      } finally {
        _iterator427.f();
      }
      return Vw("rowspan", s, t, n), g;
    }
    function _C(t, e) {
      var n = [],
        o = new Kw(t);
      var _iterator428 = _createForOfIteratorHelper(o),
        _step428;
      try {
        for (_iterator428.s(); !(_step428 = _iterator428.n()).done;) {
          var _t367 = _step428.value;
          var _o194 = _t367.column,
            _i160 = _t367.cellWidth,
            _r73 = _o194 + _i160 - 1;
          _o194 < e && e <= _r73 && n.push(_t367);
        }
      } catch (err) {
        _iterator428.e(err);
      } finally {
        _iterator428.f();
      }
      return n;
    }
    function vC(t, e, n, o) {
      var i = n - e,
        r = {},
        s = parseInt(t.getAttribute("colspan")) - i;
      s > 1 && (r.colspan = s);
      var a = parseInt(t.getAttribute("rowspan") || 1);
      a > 1 && (r.rowspan = a);
      var c = Uw(o, o.createPositionAfter(t), r);
      return Vw("colspan", i, t, o), c;
    }
    function yC(t, e, n, o, i, r) {
      var s = parseInt(t.getAttribute("colspan") || 1),
        a = parseInt(t.getAttribute("rowspan") || 1);
      if (n + s - 1 > i) {
        Vw("colspan", i - n + 1, t, r, 1);
      }
      if (e + a - 1 > o) {
        Vw("rowspan", o - e + 1, t, r, 1);
      }
    }
    function xC(t, e) {
      var n = e.getColumns(t),
        o = new Array(n).fill(0);
      var _iterator429 = _createForOfIteratorHelper(new Kw(t)),
        _step429;
      try {
        for (_iterator429.s(); !(_step429 = _iterator429.n()).done;) {
          var _e325 = _step429.value.column;
          o[_e325]++;
        }
      } catch (err) {
        _iterator429.e(err);
      } finally {
        _iterator429.f();
      }
      var i = o.reduce(function (t, e, n) {
        return e ? t : [].concat(_toConsumableArray(t), [n]);
      }, []);
      if (i.length > 0) {
        var _n289 = i[i.length - 1];
        return e.removeColumns(t, {
          at: _n289
        }), !0;
      }
      return !1;
    }
    function EC(t, e) {
      var n = [],
        o = e.getRows(t);
      for (var _e327 = 0; _e327 < o; _e327++) {
        t.getChild(_e327).isEmpty && n.push(_e327);
      }
      if (n.length > 0) {
        var _o195 = n[n.length - 1];
        return e.removeRows(t, {
          at: _o195
        }), !0;
      }
      return !1;
    }
    function DC(t, e) {
      xC(t, e) || EC(t, e);
    }
    function MC(t, e) {
      var n = Array.from(new Kw(t, {
        startColumn: e.firstColumn,
        endColumn: e.lastColumn,
        row: e.lastRow
      }));
      if (n.every(function (_ref84) {
        var t = _ref84.cellHeight;
        return 1 === t;
      })) return e.lastRow;
      var o = n[0].cellHeight - 1;
      return e.lastRow + o;
    }
    function IC(t, e) {
      var n = Array.from(new Kw(t, {
        startRow: e.firstRow,
        endRow: e.lastRow,
        column: e.lastColumn
      }));
      if (n.every(function (_ref85) {
        var t = _ref85.cellWidth;
        return 1 === t;
      })) return e.lastColumn;
      var o = n[0].cellWidth - 1;
      return e.lastColumn + o;
    }
    var TC = /*#__PURE__*/function (_Xt30) {
      _inherits(TC, _Xt30);
      function TC(t, e) {
        var _this299;
        _classCallCheck(this, TC);
        _this299 = _possibleConstructorReturn(this, _getPrototypeOf(TC).call(this, t)), _this299.direction = e.direction, _this299.isHorizontal = "right" == _this299.direction || "left" == _this299.direction;
        return _this299;
      }
      _createClass(TC, [{
        key: "refresh",
        value: function refresh() {
          var t = this._getMergeableCell();
          this.value = t, this.isEnabled = !!t;
        }
      }, {
        key: "execute",
        value: function execute() {
          var _this300 = this;
          var t = this.editor.model,
            e = aC(t.document.selection)[0],
            n = this.value,
            o = this.direction;
          t.change(function (t) {
            var i = "right" == o || "down" == o,
              r = i ? e : n,
              s = i ? n : e,
              a = s.parent;
            !function (t, e, n) {
              SC(t) || (SC(e) && n.remove(n.createRangeIn(e)), n.move(n.createRangeIn(t), n.createPositionAt(e, "end")));
              n.remove(t);
            }(s, r, t);
            var c = _this300.isHorizontal ? "colspan" : "rowspan",
              l = parseInt(e.getAttribute(c) || 1),
              d = parseInt(n.getAttribute(c) || 1);
            t.setAttribute(c, l + d, r), t.setSelection(t.createRangeIn(r));
            var h = _this300.editor.plugins.get("TableUtils");
            DC(a.findAncestor("table"), h);
          });
        }
      }, {
        key: "_getMergeableCell",
        value: function _getMergeableCell() {
          var t = aC(this.editor.model.document.selection)[0];
          if (!t) return;
          var e = this.editor.plugins.get("TableUtils"),
            n = this.isHorizontal ? function (t, e, n) {
              var o = t.parent.parent,
                i = "right" == e ? t.nextSibling : t.previousSibling,
                r = (o.getAttribute("headingColumns") || 0) > 0;
              if (!i) return;
              var s = "right" == e ? t : i,
                a = "right" == e ? i : t,
                _n$getCellLocation = n.getCellLocation(s),
                c = _n$getCellLocation.column,
                _n$getCellLocation2 = n.getCellLocation(a),
                l = _n$getCellLocation2.column,
                d = parseInt(s.getAttribute("colspan") || 1),
                h = Hw(n, s),
                u = Hw(n, a);
              if (r && h != u) return;
              return c + d === l ? i : void 0;
            }(t, this.direction, e) : function (t, e, n) {
              var o = t.parent,
                i = o.parent,
                r = i.getChildIndex(o);
              if ("down" == e && r === n.getRows(i) - 1 || "up" == e && 0 === r) return;
              var s = parseInt(t.getAttribute("rowspan") || 1),
                a = i.getAttribute("headingRows") || 0,
                c = "down" == e && r + s === a,
                l = "up" == e && r === a;
              if (a && (c || l)) return;
              var d = parseInt(t.getAttribute("rowspan") || 1),
                h = "down" == e ? r + d : r,
                u = _toConsumableArray(new Kw(i, {
                  endRow: h
                })),
                g = u.find(function (e) {
                  return e.cell === t;
                }).column,
                m = u.find(function (_ref86) {
                  var t = _ref86.row,
                    n = _ref86.cellHeight,
                    o = _ref86.column;
                  return o === g && ("down" == e ? t === h : h === t + n);
                });
              return m && m.cell;
            }(t, this.direction, e);
          if (!n) return;
          var o = this.isHorizontal ? "rowspan" : "colspan",
            i = parseInt(t.getAttribute(o) || 1);
          return parseInt(n.getAttribute(o) || 1) === i ? n : void 0;
        }
      }]);
      return TC;
    }(Xt);
    function SC(t) {
      return 1 == t.childCount && t.getChild(0).is("element", "paragraph") && t.getChild(0).isEmpty;
    }
    var NC = /*#__PURE__*/function (_Xt31) {
      _inherits(NC, _Xt31);
      function NC() {
        _classCallCheck(this, NC);
        return _possibleConstructorReturn(this, _getPrototypeOf(NC).apply(this, arguments));
      }
      _createClass(NC, [{
        key: "refresh",
        value: function refresh() {
          var t = cC(this.editor.model.document.selection),
            e = t[0];
          if (e) {
            var _n290 = e.findAncestor("table"),
              _o196 = this.editor.plugins.get("TableUtils").getRows(_n290) - 1,
              _i161 = lC(t),
              _r74 = 0 === _i161.first && _i161.last === _o196;
            this.isEnabled = !_r74;
          } else this.isEnabled = !1;
        }
      }, {
        key: "execute",
        value: function execute() {
          var t = this.editor.model,
            e = this.editor.plugins.get("TableUtils"),
            n = cC(t.document.selection),
            o = lC(n),
            i = n[0],
            r = i.findAncestor("table"),
            s = e.getCellLocation(i).column;
          t.change(function (t) {
            var n = o.last - o.first + 1;
            e.removeRows(r, {
              at: o.first,
              rows: n
            });
            var i = function (t, e, n, o) {
              var i = t.getChild(Math.min(e, o - 1));
              var r = i.getChild(0),
                s = 0;
              var _iterator430 = _createForOfIteratorHelper(i.getChildren()),
                _step430;
              try {
                for (_iterator430.s(); !(_step430 = _iterator430.n()).done;) {
                  var _t368 = _step430.value;
                  if (s > n) return r;
                  r = _t368, s += parseInt(_t368.getAttribute("colspan") || 1);
                }
              } catch (err) {
                _iterator430.e(err);
              } finally {
                _iterator430.f();
              }
              return r;
            }(r, o.first, s, e.getRows(r));
            t.setSelection(t.createPositionAt(i, 0));
          });
        }
      }]);
      return NC;
    }(Xt);
    var BC = /*#__PURE__*/function (_Xt32) {
      _inherits(BC, _Xt32);
      function BC() {
        _classCallCheck(this, BC);
        return _possibleConstructorReturn(this, _getPrototypeOf(BC).apply(this, arguments));
      }
      _createClass(BC, [{
        key: "refresh",
        value: function refresh() {
          var t = cC(this.editor.model.document.selection),
            e = t[0];
          if (e) {
            var _n291 = e.findAncestor("table"),
              _o197 = this.editor.plugins.get("TableUtils").getColumns(_n291),
              _dC = dC(t),
              _i162 = _dC.first,
              _r75 = _dC.last;
            this.isEnabled = _r75 - _i162 < _o197 - 1;
          } else this.isEnabled = !1;
        }
      }, {
        key: "execute",
        value: function execute() {
          var _this301 = this;
          var _ref87 = function (t) {
              var e = cC(t),
                n = e[0],
                o = e.pop(),
                i = [n, o];
              return n.isBefore(o) ? i : i.reverse();
            }(this.editor.model.document.selection),
            _ref88 = _slicedToArray(_ref87, 2),
            t = _ref88[0],
            e = _ref88[1],
            n = t.parent.parent,
            o = _toConsumableArray(new Kw(n)),
            i = {
              first: o.find(function (e) {
                return e.cell === t;
              }).column,
              last: o.find(function (t) {
                return t.cell === e;
              }).column
            },
            r = function (t, e, n, o) {
              return parseInt(n.getAttribute("colspan") || 1) > 1 ? n : e.previousSibling || n.nextSibling ? n.nextSibling || e.previousSibling : o.first ? t.reverse().find(function (_ref89) {
                var t = _ref89.column;
                return t < o.first;
              }).cell : t.reverse().find(function (_ref90) {
                var t = _ref90.column;
                return t > o.last;
              }).cell;
            }(o, t, e, i);
          this.editor.model.change(function (t) {
            var e = i.last - i.first + 1;
            _this301.editor.plugins.get("TableUtils").removeColumns(n, {
              at: i.first,
              columns: e
            }), t.setSelection(t.createPositionAt(r, 0));
          });
        }
      }]);
      return BC;
    }(Xt);
    var PC = /*#__PURE__*/function (_Xt33) {
      _inherits(PC, _Xt33);
      function PC() {
        _classCallCheck(this, PC);
        return _possibleConstructorReturn(this, _getPrototypeOf(PC).apply(this, arguments));
      }
      _createClass(PC, [{
        key: "refresh",
        value: function refresh() {
          var _this302 = this;
          var t = cC(this.editor.model.document.selection),
            e = t.length > 0;
          this.isEnabled = e, this.value = e && t.every(function (t) {
            return _this302._isInHeading(t, t.parent.parent);
          });
        }
      }, {
        key: "execute",
        value: function execute() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          if (t.forceValue === this.value) return;
          var e = this.editor.model,
            n = cC(e.document.selection),
            o = n[0].findAncestor("table"),
            _lC = lC(n),
            i = _lC.first,
            r = _lC.last,
            s = this.value ? i : r + 1,
            a = o.getAttribute("headingRows") || 0;
          e.change(function (t) {
            if (s) {
              var _e328 = CC(o, s, s > a ? a : 0);
              var _iterator431 = _createForOfIteratorHelper(_e328),
                _step431;
              try {
                for (_iterator431.s(); !(_step431 = _iterator431.n()).done;) {
                  var _n292 = _step431.value.cell;
                  AC(_n292, s, t);
                }
              } catch (err) {
                _iterator431.e(err);
              } finally {
                _iterator431.f();
              }
            }
            Vw("headingRows", s, o, t, 0);
          });
        }
      }, {
        key: "_isInHeading",
        value: function _isInHeading(t, e) {
          var n = parseInt(e.getAttribute("headingRows") || 0);
          return !!n && t.parent.index < n;
        }
      }]);
      return PC;
    }(Xt);
    var zC = /*#__PURE__*/function (_Xt34) {
      _inherits(zC, _Xt34);
      function zC() {
        _classCallCheck(this, zC);
        return _possibleConstructorReturn(this, _getPrototypeOf(zC).apply(this, arguments));
      }
      _createClass(zC, [{
        key: "refresh",
        value: function refresh() {
          var t = cC(this.editor.model.document.selection),
            e = this.editor.plugins.get("TableUtils"),
            n = t.length > 0;
          this.isEnabled = n, this.value = n && t.every(function (t) {
            return Hw(e, t);
          });
        }
      }, {
        key: "execute",
        value: function execute() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          if (t.forceValue === this.value) return;
          var e = this.editor.model,
            n = cC(e.document.selection),
            o = n[0].findAncestor("table"),
            _dC2 = dC(n),
            i = _dC2.first,
            r = _dC2.last,
            s = this.value ? i : r + 1;
          e.change(function (t) {
            if (s) {
              var _e329 = _C(o, s);
              var _iterator432 = _createForOfIteratorHelper(_e329),
                _step432;
              try {
                for (_iterator432.s(); !(_step432 = _iterator432.n()).done;) {
                  var _step432$value = _step432.value,
                    _n293 = _step432$value.cell,
                    _o198 = _step432$value.column;
                  vC(_n293, _o198, s, t);
                }
              } catch (err) {
                _iterator432.e(err);
              } finally {
                _iterator432.f();
              }
            }
            Vw("headingColumns", s, o, t, 0);
          });
        }
      }]);
      return zC;
    }(Xt);
    var LC = /*#__PURE__*/function (_Jt66) {
      _inherits(LC, _Jt66);
      function LC() {
        _classCallCheck(this, LC);
        return _possibleConstructorReturn(this, _getPrototypeOf(LC).apply(this, arguments));
      }
      _createClass(LC, [{
        key: "init",
        value: function init() {
          this.decorate("insertColumns"), this.decorate("insertRows");
        }
      }, {
        key: "getCellLocation",
        value: function getCellLocation(t) {
          var e = t.parent,
            n = e.parent,
            o = n.getChildIndex(e),
            i = new Kw(n, {
              row: o
            });
          var _iterator433 = _createForOfIteratorHelper(i),
            _step433;
          try {
            for (_iterator433.s(); !(_step433 = _iterator433.n()).done;) {
              var _step433$value = _step433.value,
                _e330 = _step433$value.cell,
                _n294 = _step433$value.row,
                _o199 = _step433$value.column;
              if (_e330 === t) return {
                row: _n294,
                column: _o199
              };
            }
          } catch (err) {
            _iterator433.e(err);
          } finally {
            _iterator433.f();
          }
        }
      }, {
        key: "createTable",
        value: function createTable(t, e) {
          var n = t.createElement("table");
          return OC(t, n, 0, parseInt(e.rows) || 2, parseInt(e.columns) || 2), e.headingRows && Vw("headingRows", e.headingRows, n, t, 0), e.headingColumns && Vw("headingColumns", e.headingColumns, n, t, 0), n;
        }
      }, {
        key: "insertRows",
        value: function insertRows(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var n = this.editor.model,
            o = e.at || 0,
            i = e.rows || 1,
            r = void 0 !== e.copyStructureFromAbove,
            s = e.copyStructureFromAbove ? o - 1 : o,
            a = this.getRows(t),
            l = this.getColumns(t);
          if (o > a) throw new c.a("tableutils-insertrows-insert-out-of-range", this, {
            options: e
          });
          n.change(function (e) {
            var n = t.getAttribute("headingRows") || 0;
            if (n > o && Vw("headingRows", n + i, t, e, 0), !r && (0 === o || o === a)) return void OC(e, t, o, i, l);
            var c = r ? Math.max(o, s) : o,
              d = new Kw(t, {
                endRow: c
              }),
              h = new Array(l).fill(1);
            var _iterator434 = _createForOfIteratorHelper(d),
              _step434;
            try {
              for (_iterator434.s(); !(_step434 = _iterator434.n()).done;) {
                var _step434$value = _step434.value,
                  _t371 = _step434$value.row,
                  _n297 = _step434$value.column,
                  _a26 = _step434$value.cellHeight,
                  _c17 = _step434$value.cellWidth,
                  _l8 = _step434$value.cell;
                var _d5 = _t371 + _a26 - 1,
                  _u4 = _t371 <= s && s <= _d5;
                _t371 < o && o <= _d5 ? (e.setAttribute("rowspan", _a26 + i, _l8), h[_n297] = -_c17) : r && _u4 && (h[_n297] = _c17);
              }
            } catch (err) {
              _iterator434.e(err);
            } finally {
              _iterator434.f();
            }
            for (var _n295 = 0; _n295 < i; _n295++) {
              var _n296 = e.createElement("tableRow");
              e.insert(_n296, t, o);
              for (var _t370 = 0; _t370 < h.length; _t370++) {
                var _o200 = h[_t370],
                  _i163 = e.createPositionAt(_n296, "end");
                _o200 > 0 && Uw(e, _i163, _o200 > 1 ? {
                  colspan: _o200
                } : null), _t370 += Math.abs(_o200) - 1;
              }
            }
          });
        }
      }, {
        key: "insertColumns",
        value: function insertColumns(t) {
          var _this303 = this;
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var n = this.editor.model,
            o = e.at || 0,
            i = e.columns || 1;
          n.change(function (e) {
            var n = t.getAttribute("headingColumns");
            o < n && e.setAttribute("headingColumns", n + i, t);
            var r = _this303.getColumns(t);
            if (0 === o || r === o) {
              var _iterator435 = _createForOfIteratorHelper(t.getChildren()),
                _step435;
              try {
                for (_iterator435.s(); !(_step435 = _iterator435.n()).done;) {
                  var _n298 = _step435.value;
                  _n298.is("element", "tableRow") && RC(i, e, e.createPositionAt(_n298, o ? "end" : 0));
                }
              } catch (err) {
                _iterator435.e(err);
              } finally {
                _iterator435.f();
              }
              return;
            }
            var s = new Kw(t, {
              column: o,
              includeAllSlots: !0
            });
            var _iterator436 = _createForOfIteratorHelper(s),
              _step436;
            try {
              for (_iterator436.s(); !(_step436 = _iterator436.n()).done;) {
                var _t372 = _step436.value;
                var _n299 = _t372.row,
                  _r76 = _t372.cell,
                  _a27 = _t372.cellAnchorColumn,
                  _c18 = _t372.cellAnchorRow,
                  _l9 = _t372.cellWidth,
                  _d6 = _t372.cellHeight;
                if (_a27 < o) {
                  e.setAttribute("colspan", _l9 + i, _r76);
                  var _t373 = _c18 + _d6 - 1;
                  for (var _e332 = _n299; _e332 <= _t373; _e332++) s.skipRow(_e332);
                } else RC(i, e, _t372.getPositionBefore());
              }
            } catch (err) {
              _iterator436.e(err);
            } finally {
              _iterator436.f();
            }
          });
        }
      }, {
        key: "removeRows",
        value: function removeRows(t, e) {
          var _this304 = this;
          var n = this.editor.model,
            o = e.rows || 1,
            i = this.getRows(t),
            r = e.at,
            s = r + o - 1;
          if (s > i - 1) throw new c.a("tableutils-removerows-row-index-out-of-range", this, {
            table: t,
            options: e
          });
          n.change(function (e) {
            var _ref91 = function (t, e, n) {
                var o = new Map(),
                  i = [];
                var _iterator437 = _createForOfIteratorHelper(new Kw(t, {
                    endRow: n
                  })),
                  _step437;
                try {
                  for (_iterator437.s(); !(_step437 = _iterator437.n()).done;) {
                    var _step437$value = _step437.value,
                      _r77 = _step437$value.row,
                      _s42 = _step437$value.column,
                      _a28 = _step437$value.cellHeight,
                      _c19 = _step437$value.cell;
                    var _t374 = _r77 + _a28 - 1;
                    if (_r77 >= e && _r77 <= n && _t374 > n) {
                      var _t375 = _a28 - (n - _r77 + 1);
                      o.set(_s42, {
                        cell: _c19,
                        rowspan: _t375
                      });
                    }
                    if (_r77 < e && _t374 >= e) {
                      var _o201 = void 0;
                      _o201 = _t374 >= n ? n - e + 1 : _t374 - e + 1, i.push({
                        cell: _c19,
                        rowspan: _a28 - _o201
                      });
                    }
                  }
                } catch (err) {
                  _iterator437.e(err);
                } finally {
                  _iterator437.f();
                }
                return {
                  cellsToMove: o,
                  cellsToTrim: i
                };
              }(t, r, s),
              n = _ref91.cellsToMove,
              o = _ref91.cellsToTrim;
            if (n.size) {
              !function (t, e, n, o) {
                var i = _toConsumableArray(new Kw(t, {
                    includeAllSlots: !0,
                    row: e
                  })),
                  r = t.getChild(e);
                var s;
                var _iterator438 = _createForOfIteratorHelper(i),
                  _step438;
                try {
                  for (_iterator438.s(); !(_step438 = _iterator438.n()).done;) {
                    var _step438$value = _step438.value,
                      _t376 = _step438$value.column,
                      _e333 = _step438$value.cell,
                      _a29 = _step438$value.isAnchor;
                    if (n.has(_t376)) {
                      var _n$get = n.get(_t376),
                        _e334 = _n$get.cell,
                        _i164 = _n$get.rowspan,
                        _a30 = s ? o.createPositionAfter(s) : o.createPositionAt(r, 0);
                      o.move(o.createRangeOn(_e334), _a30), Vw("rowspan", _i164, _e334, o), s = _e334;
                    } else _a29 && (s = _e333);
                  }
                } catch (err) {
                  _iterator438.e(err);
                } finally {
                  _iterator438.f();
                }
              }(t, s + 1, n, e);
            }
            for (var _n301 = s; _n301 >= r; _n301--) e.remove(t.getChild(_n301));
            var _iterator439 = _createForOfIteratorHelper(o),
              _step439;
            try {
              for (_iterator439.s(); !(_step439 = _iterator439.n()).done;) {
                var _step439$value = _step439.value,
                  _t377 = _step439$value.rowspan,
                  _n302 = _step439$value.cell;
                Vw("rowspan", _t377, _n302, e);
              }
            } catch (err) {
              _iterator439.e(err);
            } finally {
              _iterator439.f();
            }
            !function (t, e, n, o) {
              var i = t.getAttribute("headingRows") || 0;
              if (e < i) {
                Vw("headingRows", n < i ? i - (n - e + 1) : e, t, o, 0);
              }
            }(t, r, s, e), xC(t, _this304) || EC(t, _this304);
          });
        }
      }, {
        key: "removeColumns",
        value: function removeColumns(t, e) {
          var _this305 = this;
          var n = this.editor.model,
            o = e.at,
            i = e.columns || 1,
            r = e.at + i - 1;
          n.change(function (e) {
            !function (t, e, n) {
              var o = t.getAttribute("headingColumns") || 0;
              if (o && e.first < o) {
                var _i165 = Math.min(o - 1, e.last) - e.first + 1;
                n.setAttribute("headingColumns", o - _i165, t);
              }
            }(t, {
              first: o,
              last: r
            }, e);
            for (var _n304 = r; _n304 >= o; _n304--) for (var _i166 = 0, _arr2 = _toConsumableArray(new Kw(t)); _i166 < _arr2.length; _i166++) {
              var _arr2$_i = _arr2[_i166],
                _o202 = _arr2$_i.cell,
                _i167 = _arr2$_i.column,
                _r78 = _arr2$_i.cellWidth;
              _i167 <= _n304 && _r78 > 1 && _i167 + _r78 > _n304 ? Vw("colspan", _r78 - 1, _o202, e) : _i167 === _n304 && e.remove(_o202);
            }
            EC(t, _this305) || xC(t, _this305);
          });
        }
      }, {
        key: "splitCellVertically",
        value: function splitCellVertically(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
          var n = this.editor.model,
            o = t.parent.parent,
            i = parseInt(t.getAttribute("rowspan") || 1),
            r = parseInt(t.getAttribute("colspan") || 1);
          n.change(function (n) {
            if (r > 1) {
              var _jC = jC(r, e),
                _o203 = _jC.newCellsSpan,
                _s43 = _jC.updatedSpan;
              Vw("colspan", _s43, t, n);
              var _a31 = {};
              _o203 > 1 && (_a31.colspan = _o203), i > 1 && (_a31.rowspan = i);
              RC(r > e ? e - 1 : r - 1, n, n.createPositionAfter(t), _a31);
            }
            if (r < e) {
              var _s44 = e - r,
                _a32 = _toConsumableArray(new Kw(o)),
                _a$find = _a32.find(function (_ref92) {
                  var e = _ref92.cell;
                  return e === t;
                }),
                _c20 = _a$find.column,
                _l10 = _a32.filter(function (_ref93) {
                  var e = _ref93.cell,
                    n = _ref93.cellWidth,
                    o = _ref93.column;
                  return e !== t && o === _c20 || o < _c20 && o + n > _c20;
                });
              var _iterator440 = _createForOfIteratorHelper(_l10),
                _step440;
              try {
                for (_iterator440.s(); !(_step440 = _iterator440.n()).done;) {
                  var _step440$value = _step440.value,
                    _t378 = _step440$value.cell,
                    _e335 = _step440$value.cellWidth;
                  n.setAttribute("colspan", _e335 + _s44, _t378);
                }
              } catch (err) {
                _iterator440.e(err);
              } finally {
                _iterator440.f();
              }
              var _d7 = {};
              i > 1 && (_d7.rowspan = i), RC(_s44, n, n.createPositionAfter(t), _d7);
              var _h5 = o.getAttribute("headingColumns") || 0;
              _h5 > _c20 && Vw("headingColumns", _h5 + _s44, o, n);
            }
          });
        }
      }, {
        key: "splitCellHorizontally",
        value: function splitCellHorizontally(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
          var n = this.editor.model,
            o = t.parent,
            i = o.parent,
            r = i.getChildIndex(o),
            s = parseInt(t.getAttribute("rowspan") || 1),
            a = parseInt(t.getAttribute("colspan") || 1);
          n.change(function (n) {
            if (s > 1) {
              var _o204 = _toConsumableArray(new Kw(i, {
                  startRow: r,
                  endRow: r + s - 1,
                  includeAllSlots: !0
                })),
                _jC2 = jC(s, e),
                _c21 = _jC2.newCellsSpan,
                _l11 = _jC2.updatedSpan;
              Vw("rowspan", _l11, t, n);
              var _o204$find = _o204.find(function (_ref94) {
                  var e = _ref94.cell;
                  return e === t;
                }),
                _d8 = _o204$find.column,
                _h6 = {};
              _c21 > 1 && (_h6.rowspan = _c21), a > 1 && (_h6.colspan = a);
              for (var _i168 = 0, _o205 = _o204; _i168 < _o205.length; _i168++) {
                var _t379 = _o205[_i168];
                var _e336 = _t379.column,
                  _o206 = _t379.row,
                  _i169 = _e336 === _d8,
                  _s45 = (_o206 + r + _l11) % _c21 == 0;
                _o206 >= r + _l11 && _i169 && _s45 && RC(1, n, _t379.getPositionBefore(), _h6);
              }
            }
            if (s < e) {
              var _o207 = e - s,
                _c22 = _toConsumableArray(new Kw(i, {
                  startRow: 0,
                  endRow: r
                }));
              var _iterator441 = _createForOfIteratorHelper(_c22),
                _step441;
              try {
                for (_iterator441.s(); !(_step441 = _iterator441.n()).done;) {
                  var _step441$value = _step441.value,
                    _e337 = _step441$value.cell,
                    _i170 = _step441$value.cellHeight,
                    _s46 = _step441$value.row;
                  if (_e337 !== t && _s46 + _i170 > r) {
                    var _t380 = _i170 + _o207;
                    n.setAttribute("rowspan", _t380, _e337);
                  }
                }
              } catch (err) {
                _iterator441.e(err);
              } finally {
                _iterator441.f();
              }
              var _l12 = {};
              a > 1 && (_l12.colspan = a), OC(n, i, r + 1, _o207, 1, _l12);
              var _d9 = i.getAttribute("headingRows") || 0;
              _d9 > r && Vw("headingRows", _d9 + _o207, i, n);
            }
          });
        }
      }, {
        key: "getColumns",
        value: function getColumns(t) {
          return _toConsumableArray(t.getChild(0).getChildren()).reduce(function (t, e) {
            return t + parseInt(e.getAttribute("colspan") || 1);
          }, 0);
        }
      }, {
        key: "getRows",
        value: function getRows(t) {
          return Array.from(t.getChildren()).reduce(function (t, e) {
            return e.is("element", "tableRow") ? t + 1 : t;
          }, 0);
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "TableUtils";
        }
      }]);
      return LC;
    }(Jt);
    function OC(t, e, n, o, i) {
      var r = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
      for (var _s48 = 0; _s48 < o; _s48++) {
        var _o208 = t.createElement("tableRow");
        t.insert(_o208, e, n), RC(i, t, t.createPositionAt(_o208, "end"), r);
      }
    }
    function RC(t, e, n) {
      var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      for (var _i172 = 0; _i172 < t; _i172++) Uw(e, n, o);
    }
    function jC(t, e) {
      if (t < e) return {
        newCellsSpan: 1,
        updatedSpan: 1
      };
      var n = Math.floor(t / e);
      return {
        newCellsSpan: n,
        updatedSpan: t - n * e + n
      };
    }
    var FC = /*#__PURE__*/function (_Xt35) {
      _inherits(FC, _Xt35);
      function FC() {
        _classCallCheck(this, FC);
        return _possibleConstructorReturn(this, _getPrototypeOf(FC).apply(this, arguments));
      }
      _createClass(FC, [{
        key: "refresh",
        value: function refresh() {
          var t = sC(this.editor.model.document.selection);
          this.isEnabled = hC(t, this.editor.plugins.get(LC));
        }
      }, {
        key: "execute",
        value: function execute() {
          var t = this.editor.model,
            e = this.editor.plugins.get(LC);
          t.change(function (n) {
            var o = sC(t.document.selection),
              i = o.shift(),
              _ref95 = function (t, e, n) {
                var o = 0,
                  i = 0;
                var _iterator442 = _createForOfIteratorHelper(e),
                  _step442;
                try {
                  for (_iterator442.s(); !(_step442 = _iterator442.n()).done;) {
                    var _t381 = _step442.value;
                    var _n$getCellLocation4 = n.getCellLocation(_t381),
                      _e338 = _n$getCellLocation4.row,
                      _r79 = _n$getCellLocation4.column;
                    o = HC(_t381, _r79, o, "colspan"), i = HC(_t381, _e338, i, "rowspan");
                  }
                } catch (err) {
                  _iterator442.e(err);
                } finally {
                  _iterator442.f();
                }
                var _n$getCellLocation3 = n.getCellLocation(t),
                  r = _n$getCellLocation3.row,
                  s = _n$getCellLocation3.column;
                return {
                  mergeWidth: o - s,
                  mergeHeight: i - r
                };
              }(i, o, e),
              r = _ref95.mergeWidth,
              s = _ref95.mergeHeight;
            Vw("colspan", r, i, n), Vw("rowspan", s, i, n);
            var _iterator443 = _createForOfIteratorHelper(o),
              _step443;
            try {
              for (_iterator443.s(); !(_step443 = _iterator443.n()).done;) {
                var _t382 = _step443.value;
                VC(_t382, i, n);
              }
            } catch (err) {
              _iterator443.e(err);
            } finally {
              _iterator443.f();
            }
            DC(i.findAncestor("table"), e), n.setSelection(i, "in");
          });
        }
      }]);
      return FC;
    }(Xt);
    function VC(t, e, n) {
      UC(t) || (UC(e) && n.remove(n.createRangeIn(e)), n.move(n.createRangeIn(t), n.createPositionAt(e, "end"))), n.remove(t);
    }
    function UC(t) {
      return 1 == t.childCount && t.getChild(0).is("element", "paragraph") && t.getChild(0).isEmpty;
    }
    function HC(t, e, n, o) {
      var i = parseInt(t.getAttribute(o) || 1);
      return Math.max(n, e + i);
    }
    var GC = /*#__PURE__*/function (_Xt36) {
      _inherits(GC, _Xt36);
      function GC() {
        _classCallCheck(this, GC);
        return _possibleConstructorReturn(this, _getPrototypeOf(GC).apply(this, arguments));
      }
      _createClass(GC, [{
        key: "refresh",
        value: function refresh() {
          var t = cC(this.editor.model.document.selection);
          this.isEnabled = t.length > 0;
        }
      }, {
        key: "execute",
        value: function execute() {
          var t = this.editor.model,
            e = cC(t.document.selection),
            n = lC(e),
            o = e[0].findAncestor("table"),
            i = [];
          for (var _e340 = n.first; _e340 <= n.last; _e340++) {
            var _iterator444 = _createForOfIteratorHelper(o.getChild(_e340).getChildren()),
              _step444;
            try {
              for (_iterator444.s(); !(_step444 = _iterator444.n()).done;) {
                var _n305 = _step444.value;
                i.push(t.createRangeOn(_n305));
              }
            } catch (err) {
              _iterator444.e(err);
            } finally {
              _iterator444.f();
            }
          }
          t.change(function (t) {
            t.setSelection(i);
          });
        }
      }]);
      return GC;
    }(Xt);
    var WC = /*#__PURE__*/function (_Xt37) {
      _inherits(WC, _Xt37);
      function WC() {
        _classCallCheck(this, WC);
        return _possibleConstructorReturn(this, _getPrototypeOf(WC).apply(this, arguments));
      }
      _createClass(WC, [{
        key: "refresh",
        value: function refresh() {
          var t = cC(this.editor.model.document.selection);
          this.isEnabled = t.length > 0;
        }
      }, {
        key: "execute",
        value: function execute() {
          var t = this.editor.model,
            e = cC(t.document.selection),
            n = e[0],
            o = e.pop(),
            i = n.findAncestor("table"),
            r = this.editor.plugins.get("TableUtils"),
            s = r.getCellLocation(n),
            a = r.getCellLocation(o),
            c = Math.min(s.column, a.column),
            l = Math.max(s.column, a.column),
            d = [];
          var _iterator445 = _createForOfIteratorHelper(new Kw(i, {
              startColumn: c,
              endColumn: l
            })),
            _step445;
          try {
            for (_iterator445.s(); !(_step445 = _iterator445.n()).done;) {
              var _e341 = _step445.value;
              d.push(t.createRangeOn(_e341.cell));
            }
          } catch (err) {
            _iterator445.e(err);
          } finally {
            _iterator445.f();
          }
          t.change(function (t) {
            t.setSelection(d);
          });
        }
      }]);
      return WC;
    }(Xt);
    function qC(t) {
      t.document.registerPostFixer(function (e) {
        return function (t, e) {
          var n = e.document.differ.getChanges();
          var o = !1;
          var i = new Set();
          var _iterator446 = _createForOfIteratorHelper(n),
            _step446;
          try {
            for (_iterator446.s(); !(_step446 = _iterator446.n()).done;) {
              var _e342 = _step446.value;
              var _n306 = void 0;
              "table" == _e342.name && "insert" == _e342.type && (_n306 = _e342.position.nodeAfter), "tableRow" != _e342.name && "tableCell" != _e342.name || (_n306 = _e342.position.findAncestor("table")), QC(_e342) && (_n306 = _e342.range.start.findAncestor("table")), _n306 && !i.has(_n306) && (o = KC(_n306, t) || o, o = YC(_n306, t) || o, i.add(_n306));
            }
          } catch (err) {
            _iterator446.e(err);
          } finally {
            _iterator446.f();
          }
          return o;
        }(e, t);
      });
    }
    function KC(t, e) {
      var n = !1;
      var o = function (t) {
        var e = parseInt(t.getAttribute("headingRows") || 0),
          n = Array.from(t.getChildren()).reduce(function (t, e) {
            return e.is("element", "tableRow") ? t + 1 : t;
          }, 0),
          o = [];
        var _iterator447 = _createForOfIteratorHelper(new Kw(t)),
          _step447;
        try {
          for (_iterator447.s(); !(_step447 = _iterator447.n()).done;) {
            var _step447$value = _step447.value,
              _i173 = _step447$value.row,
              _r80 = _step447$value.cell,
              _s49 = _step447$value.cellHeight;
            if (_s49 < 2) continue;
            var _t383 = _i173 < e ? e : n;
            if (_i173 + _s49 > _t383) {
              var _e343 = _t383 - _i173;
              o.push({
                cell: _r80,
                rowspan: _e343
              });
            }
          }
        } catch (err) {
          _iterator447.e(err);
        } finally {
          _iterator447.f();
        }
        return o;
      }(t);
      if (o.length) {
        n = !0;
        var _iterator448 = _createForOfIteratorHelper(o),
          _step448;
        try {
          for (_iterator448.s(); !(_step448 = _iterator448.n()).done;) {
            var _t384 = _step448.value;
            Vw("rowspan", _t384.rowspan, _t384.cell, e, 1);
          }
        } catch (err) {
          _iterator448.e(err);
        } finally {
          _iterator448.f();
        }
      }
      return n;
    }
    function YC(t, e) {
      var n = !1;
      var o = function (t) {
          var e = new Array(t.childCount).fill(0);
          var _iterator449 = _createForOfIteratorHelper(new Kw(t, {
              includeAllSlots: !0
            })),
            _step449;
          try {
            for (_iterator449.s(); !(_step449 = _iterator449.n()).done;) {
              var _n307 = _step449.value.rowIndex;
              e[_n307]++;
            }
          } catch (err) {
            _iterator449.e(err);
          } finally {
            _iterator449.f();
          }
          return e;
        }(t),
        i = [];
      var _iterator450 = _createForOfIteratorHelper(o.entries()),
        _step450;
      try {
        for (_iterator450.s(); !(_step450 = _iterator450.n()).done;) {
          var _step450$value = _slicedToArray(_step450.value, 2),
            _e344 = _step450$value[0],
            _n311 = _step450$value[1];
          !_n311 && t.getChild(_e344).is("element", "tableRow") && i.push(_e344);
        }
      } catch (err) {
        _iterator450.e(err);
      } finally {
        _iterator450.f();
      }
      if (i.length) {
        n = !0;
        var _iterator451 = _createForOfIteratorHelper(i.reverse()),
          _step451;
        try {
          for (_iterator451.s(); !(_step451 = _iterator451.n()).done;) {
            var _n308 = _step451.value;
            e.remove(t.getChild(_n308)), o.splice(_n308, 1);
          }
        } catch (err) {
          _iterator451.e(err);
        } finally {
          _iterator451.f();
        }
      }
      var r = o.filter(function (e, n) {
          return t.getChild(n).is("element", "tableRow");
        }),
        s = r[0];
      if (!r.every(function (t) {
        return t === s;
      })) {
        var _o209 = r.reduce(function (t, e) {
          return e > t ? e : t;
        }, 0);
        var _iterator452 = _createForOfIteratorHelper(r.entries()),
          _step452;
        try {
          for (_iterator452.s(); !(_step452 = _iterator452.n()).done;) {
            var _step452$value = _slicedToArray(_step452.value, 2),
              _i174 = _step452$value[0],
              _s50 = _step452$value[1];
            var _r81 = _o209 - _s50;
            if (_r81) {
              for (var _n310 = 0; _n310 < _r81; _n310++) Uw(e, e.createPositionAt(t.getChild(_i174), "end"));
              n = !0;
            }
          }
        } catch (err) {
          _iterator452.e(err);
        } finally {
          _iterator452.f();
        }
      }
      return n;
    }
    function QC(t) {
      var e = "attribute" === t.type,
        n = t.attributeKey;
      return e && ("headingRows" === n || "colspan" === n || "rowspan" === n);
    }
    function $C(t) {
      t.document.registerPostFixer(function (e) {
        return function (t, e) {
          var n = e.document.differ.getChanges();
          var o = !1;
          var _iterator453 = _createForOfIteratorHelper(n),
            _step453;
          try {
            for (_iterator453.s(); !(_step453 = _iterator453.n()).done;) {
              var _e345 = _step453.value;
              "insert" == _e345.type && "table" == _e345.name && (o = JC(_e345.position.nodeAfter, t) || o), "insert" == _e345.type && "tableRow" == _e345.name && (o = ZC(_e345.position.nodeAfter, t) || o), "insert" == _e345.type && "tableCell" == _e345.name && (o = XC(_e345.position.nodeAfter, t) || o), tA(_e345) && (o = XC(_e345.position.parent, t) || o);
            }
          } catch (err) {
            _iterator453.e(err);
          } finally {
            _iterator453.f();
          }
          return o;
        }(e, t);
      });
    }
    function JC(t, e) {
      var n = !1;
      var _iterator454 = _createForOfIteratorHelper(t.getChildren()),
        _step454;
      try {
        for (_iterator454.s(); !(_step454 = _iterator454.n()).done;) {
          var _o210 = _step454.value;
          _o210.is("element", "tableRow") && (n = ZC(_o210, e) || n);
        }
      } catch (err) {
        _iterator454.e(err);
      } finally {
        _iterator454.f();
      }
      return n;
    }
    function ZC(t, e) {
      var n = !1;
      var _iterator455 = _createForOfIteratorHelper(t.getChildren()),
        _step455;
      try {
        for (_iterator455.s(); !(_step455 = _iterator455.n()).done;) {
          var _o211 = _step455.value;
          n = XC(_o211, e) || n;
        }
      } catch (err) {
        _iterator455.e(err);
      } finally {
        _iterator455.f();
      }
      return n;
    }
    function XC(t, e) {
      if (0 == t.childCount) return e.insertElement("paragraph", t), !0;
      var n = Array.from(t.getChildren()).filter(function (t) {
        return t.is("$text");
      });
      var _iterator456 = _createForOfIteratorHelper(n),
        _step456;
      try {
        for (_iterator456.s(); !(_step456 = _iterator456.n()).done;) {
          var _t385 = _step456.value;
          e.wrap(e.createRangeOn(_t385), "paragraph");
        }
      } catch (err) {
        _iterator456.e(err);
      } finally {
        _iterator456.f();
      }
      return !!n.length;
    }
    function tA(t) {
      return !(!t.position || !t.position.parent.is("element", "tableCell")) && ("insert" == t.type && "$text" == t.name || "remove" == t.type);
    }
    function eA(t, e) {
      t.document.registerPostFixer(function () {
        return function (t, e) {
          var n = new Set();
          var _iterator457 = _createForOfIteratorHelper(t.getChanges()),
            _step457;
          try {
            for (_iterator457.s(); !(_step457 = _iterator457.n()).done;) {
              var _e346 = _step457.value;
              var _t386 = "attribute" == _e346.type ? _e346.range.start.parent : _e346.position.parent;
              _t386.is("element", "tableCell") && n.add(_t386);
            }
          } catch (err) {
            _iterator457.e(err);
          } finally {
            _iterator457.f();
          }
          var _iterator458 = _createForOfIteratorHelper(n.values()),
            _step458;
          try {
            for (_iterator458.s(); !(_step458 = _iterator458.n()).done;) {
              var _o212 = _step458.value;
              var _iterator459 = _createForOfIteratorHelper(_toConsumableArray(_o212.getChildren()).filter(function (t) {
                  return nA(t, e);
                })),
                _step459;
              try {
                for (_iterator459.s(); !(_step459 = _iterator459.n()).done;) {
                  var _n312 = _step459.value;
                  t.refreshItem(_n312);
                }
              } catch (err) {
                _iterator459.e(err);
              } finally {
                _iterator459.f();
              }
            }
          } catch (err) {
            _iterator458.e(err);
          } finally {
            _iterator458.f();
          }
          return !1;
        }(t.document.differ, e);
      });
    }
    function nA(t, e) {
      if (!t.is("element", "paragraph")) return !1;
      var n = e.toViewElement(t);
      return !!n && Jw(t) !== n.is("element", "span");
    }
    function oA(t) {
      t.document.registerPostFixer(function () {
        return function (t) {
          var e = t.document.differ,
            n = new Set();
          var _iterator460 = _createForOfIteratorHelper(e.getChanges()),
            _step460;
          try {
            for (_iterator460.s(); !(_step460 = _iterator460.n()).done;) {
              var _t388 = _step460.value;
              if ("attribute" != _t388.type) continue;
              var _e347 = _t388.range.start.nodeAfter;
              _e347 && _e347.is("element", "table") && "headingRows" == _t388.attributeKey && n.add(_e347);
            }
          } catch (err) {
            _iterator460.e(err);
          } finally {
            _iterator460.f();
          }
          if (n.size) {
            var _iterator461 = _createForOfIteratorHelper(n.values()),
              _step461;
            try {
              for (_iterator461.s(); !(_step461 = _iterator461.n()).done;) {
                var _t387 = _step461.value;
                e.refreshItem(_t387);
              }
            } catch (err) {
              _iterator461.e(err);
            } finally {
              _iterator461.f();
            }
            return !0;
          }
          return !1;
        }(t);
      });
    }
    var iA = n(58),
      rA = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Zl()(iA.a, rA), iA.a.locals;
    var sA = /*#__PURE__*/function (_Jt67) {
      _inherits(sA, _Jt67);
      function sA() {
        _classCallCheck(this, sA);
        return _possibleConstructorReturn(this, _getPrototypeOf(sA).apply(this, arguments));
      }
      _createClass(sA, [{
        key: "init",
        value: function init() {
          var t = this.editor,
            e = t.model,
            n = e.schema,
            o = t.conversion;
          n.register("table", {
            allowWhere: "$block",
            allowAttributes: ["headingRows", "headingColumns"],
            isObject: !0,
            isBlock: !0
          }), n.register("tableRow", {
            allowIn: "table",
            isLimit: !0
          }), n.register("tableCell", {
            allowIn: "tableRow",
            allowChildren: "$block",
            allowAttributes: ["colspan", "rowspan"],
            isLimit: !0,
            isSelectable: !0
          }), o.for("upcast").add(function (t) {
            t.on("element:figure", function (t, e, n) {
              if (!n.consumable.test(e.viewItem, {
                name: !0,
                classes: "table"
              })) return;
              var o = function (t) {
                var _iterator462 = _createForOfIteratorHelper(t.getChildren()),
                  _step462;
                try {
                  for (_iterator462.s(); !(_step462 = _iterator462.n()).done;) {
                    var _e348 = _step462.value;
                    if (_e348.is("element", "table")) return _e348;
                  }
                } catch (err) {
                  _iterator462.e(err);
                } finally {
                  _iterator462.f();
                }
              }(e.viewItem);
              if (!o || !n.consumable.test(o, {
                name: !0
              })) return;
              var i = Ks(n.convertItem(o, e.modelCursor).modelRange.getItems());
              i && (n.convertChildren(e.viewItem, n.writer.createPositionAt(i, "end")), n.updateConversionResult(i, e));
            });
          }), o.for("upcast").add(Gw()), o.for("editingDowncast").add(Qw({
            asWidget: !0
          })), o.for("dataDowncast").add(Qw()), o.for("upcast").elementToElement({
            model: "tableRow",
            view: "tr"
          }), o.for("upcast").add(function (t) {
            t.on("element:tr", function (t, e) {
              e.viewItem.isEmpty && 0 == e.modelCursor.index && t.stop();
            }, {
              priority: "high"
            });
          }), o.for("editingDowncast").add(function (t) {
            return t.on("insert:tableRow", function (t, e, n) {
              var o = e.item;
              if (!n.consumable.consume(o, "insert")) return;
              var i = o.parent,
                r = function (t) {
                  var _iterator463 = _createForOfIteratorHelper(t.getChildren()),
                    _step463;
                  try {
                    for (_iterator463.s(); !(_step463 = _iterator463.n()).done;) {
                      var _e349 = _step463.value;
                      if ("table" === _e349.name) return _e349;
                    }
                  } catch (err) {
                    _iterator463.e(err);
                  } finally {
                    _iterator463.f();
                  }
                }(n.mapper.toViewElement(i)),
                s = i.getChildIndex(o),
                a = new Kw(i, {
                  row: s
                }),
                c = {
                  headingRows: i.getAttribute("headingRows") || 0,
                  headingColumns: i.getAttribute("headingColumns") || 0
                },
                l = new Map();
              var _iterator464 = _createForOfIteratorHelper(a),
                _step464;
              try {
                for (_iterator464.s(); !(_step464 = _iterator464.n()).done;) {
                  var _t389 = _step464.value;
                  var _e350 = l.get(s) || tC(r, o, s, c, n);
                  l.set(s, _e350), n.consumable.consume(_t389.cell, "insert"), Xw(_t389, c, n.writer.createPositionAt(_e350, "end"), n, {
                    asWidget: !0
                  });
                }
              } catch (err) {
                _iterator464.e(err);
              } finally {
                _iterator464.f();
              }
            });
          }), o.for("editingDowncast").add(function (t) {
            return t.on("remove:tableRow", function (t, e, n) {
              t.stop();
              var o = n.writer,
                i = n.mapper,
                r = i.toViewPosition(e.position).getLastMatchingPosition(function (t) {
                  return !t.item.is("element", "tr");
                }).nodeAfter,
                s = r.parent.parent,
                a = o.createRangeOn(r),
                c = o.remove(a);
              var _iterator465 = _createForOfIteratorHelper(o.createRangeIn(c).getItems()),
                _step465;
              try {
                for (_iterator465.s(); !(_step465 = _iterator465.n()).done;) {
                  var _t390 = _step465.value;
                  i.unbindViewElement(_t390);
                }
              } catch (err) {
                _iterator465.e(err);
              } finally {
                _iterator465.f();
              }
              oC("thead", s, n), oC("tbody", s, n);
            }, {
              priority: "higher"
            });
          }), o.for("upcast").elementToElement({
            model: "tableCell",
            view: "td"
          }), o.for("upcast").elementToElement({
            model: "tableCell",
            view: "th"
          }), o.for("upcast").add(Ww("td")), o.for("upcast").add(Ww("th")), o.for("editingDowncast").add(function (t) {
            return t.on("insert:tableCell", function (t, e, n) {
              var o = e.item;
              if (!n.consumable.consume(o, "insert")) return;
              var i = o.parent,
                r = i.parent,
                s = r.getChildIndex(i),
                a = new Kw(r, {
                  row: s
                }),
                c = {
                  headingRows: r.getAttribute("headingRows") || 0,
                  headingColumns: r.getAttribute("headingColumns") || 0
                };
              var _iterator466 = _createForOfIteratorHelper(a),
                _step466;
              try {
                for (_iterator466.s(); !(_step466 = _iterator466.n()).done;) {
                  var _t391 = _step466.value;
                  if (_t391.cell === o) {
                    var _e351 = n.mapper.toViewElement(i);
                    return void Xw(_t391, c, n.writer.createPositionAt(_e351, i.getChildIndex(o)), n, {
                      asWidget: !0
                    });
                  }
                }
              } catch (err) {
                _iterator466.e(err);
              } finally {
                _iterator466.f();
              }
            });
          }), o.for("editingDowncast").elementToElement({
            model: "paragraph",
            view: $w,
            converterPriority: "high"
          }), o.attributeToAttribute({
            model: "colspan",
            view: "colspan"
          }), o.attributeToAttribute({
            model: "rowspan",
            view: "rowspan"
          }), o.for("editingDowncast").add(function (t) {
            return t.on("attribute:headingColumns:table", function (t, e, n) {
              var o = e.item;
              if (!n.consumable.consume(e.item, t.name)) return;
              var i = {
                  headingRows: o.getAttribute("headingRows") || 0,
                  headingColumns: o.getAttribute("headingColumns") || 0
                },
                r = e.attributeOldValue,
                s = e.attributeNewValue,
                a = (r > s ? r : s) - 1;
              var _iterator467 = _createForOfIteratorHelper(new Kw(o, {
                  endColumn: a
                })),
                _step467;
              try {
                for (_iterator467.s(); !(_step467 = _iterator467.n()).done;) {
                  var _t392 = _step467.value;
                  Zw(_t392, i, n);
                }
              } catch (err) {
                _iterator467.e(err);
              } finally {
                _iterator467.f();
              }
            });
          }), t.commands.add("insertTable", new rC(t)), t.commands.add("insertTableRowAbove", new fC(t, {
            order: "above"
          })), t.commands.add("insertTableRowBelow", new fC(t, {
            order: "below"
          })), t.commands.add("insertTableColumnLeft", new kC(t, {
            order: "left"
          })), t.commands.add("insertTableColumnRight", new kC(t, {
            order: "right"
          })), t.commands.add("removeTableRow", new NC(t)), t.commands.add("removeTableColumn", new BC(t)), t.commands.add("splitTableCellVertically", new bC(t, {
            direction: "vertically"
          })), t.commands.add("splitTableCellHorizontally", new bC(t, {
            direction: "horizontally"
          })), t.commands.add("mergeTableCells", new FC(t)), t.commands.add("mergeTableCellRight", new TC(t, {
            direction: "right"
          })), t.commands.add("mergeTableCellLeft", new TC(t, {
            direction: "left"
          })), t.commands.add("mergeTableCellDown", new TC(t, {
            direction: "down"
          })), t.commands.add("mergeTableCellUp", new TC(t, {
            direction: "up"
          })), t.commands.add("setTableColumnHeader", new zC(t)), t.commands.add("setTableRowHeader", new PC(t)), t.commands.add("selectTableRow", new GC(t)), t.commands.add("selectTableColumn", new WC(t)), oA(e), qC(e), eA(e, t.editing.mapper), $C(e);
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "TableEditing";
        }
      }, {
        key: "requires",
        get: function get() {
          return [LC];
        }
      }]);
      return sA;
    }(Jt);
    var aA = n(59),
      cA = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Zl()(aA.a, cA), aA.a.locals;
    var lA = /*#__PURE__*/function (_ed32) {
      _inherits(lA, _ed32);
      function lA(t) {
        var _this306;
        _classCallCheck(this, lA);
        _this306 = _possibleConstructorReturn(this, _getPrototypeOf(lA).call(this, t));
        var e = _this306.bindTemplate;
        _this306.items = _this306._createGridCollection(), _this306.set("rows", 0), _this306.set("columns", 0), _this306.bind("label").to(_assertThisInitialized(_assertThisInitialized(_this306)), "columns", _assertThisInitialized(_assertThisInitialized(_this306)), "rows", function (t, e) {
          return "".concat(e, " \xD7 ").concat(t);
        }), _this306.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck"]
          },
          children: [{
            tag: "div",
            attributes: {
              class: ["ck-insert-table-dropdown__grid"]
            },
            on: {
              "mouseover@.ck-insert-table-dropdown-grid-box": e.to("boxover")
            },
            children: _this306.items
          }, {
            tag: "div",
            attributes: {
              class: ["ck-insert-table-dropdown__label"]
            },
            children: [{
              text: e.to("label")
            }]
          }],
          on: {
            mousedown: e.to(function (t) {
              t.preventDefault();
            }),
            click: e.to(function () {
              _this306.fire("execute");
            })
          }
        }), _this306.on("boxover", function (t, e) {
          var _e$target$dataset = e.target.dataset,
            n = _e$target$dataset.row,
            o = _e$target$dataset.column;
          _this306.set({
            rows: parseInt(n),
            columns: parseInt(o)
          });
        }), _this306.on("change:columns", function () {
          _this306._highlightGridBoxes();
        }), _this306.on("change:rows", function () {
          _this306._highlightGridBoxes();
        });
        return _this306;
      }
      _createClass(lA, [{
        key: "focus",
        value: function focus() {}
      }, {
        key: "focusLast",
        value: function focusLast() {}
      }, {
        key: "_highlightGridBoxes",
        value: function _highlightGridBoxes() {
          var t = this.rows,
            e = this.columns;
          this.items.map(function (n, o) {
            var i = Math.floor(o / 10) < t && o % 10 < e;
            n.set("isOn", i);
          });
        }
      }, {
        key: "_createGridCollection",
        value: function _createGridCollection() {
          var t = [];
          for (var _e353 = 0; _e353 < 100; _e353++) {
            var _n313 = Math.floor(_e353 / 10),
              _o213 = _e353 % 10;
            t.push(new dA(this.locale, _n313 + 1, _o213 + 1));
          }
          return this.createCollection(t);
        }
      }]);
      return lA;
    }(ed);
    var dA = /*#__PURE__*/function (_ed33) {
      _inherits(dA, _ed33);
      function dA(t, e, n) {
        var _this307;
        _classCallCheck(this, dA);
        _this307 = _possibleConstructorReturn(this, _getPrototypeOf(dA).call(this, t));
        var o = _this307.bindTemplate;
        _this307.set("isOn", !1), _this307.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck-insert-table-dropdown-grid-box", o.if("isOn", "ck-on")],
            "data-row": e,
            "data-column": n
          }
        });
        return _this307;
      }
      return dA;
    }(ed);
    var hA = /*#__PURE__*/function (_Jt68) {
      _inherits(hA, _Jt68);
      function hA() {
        _classCallCheck(this, hA);
        return _possibleConstructorReturn(this, _getPrototypeOf(hA).apply(this, arguments));
      }
      _createClass(hA, [{
        key: "init",
        value: function init() {
          var _this308 = this;
          var t = this.editor,
            e = this.editor.t,
            n = "ltr" === t.locale.contentLanguageDirection;
          t.ui.componentFactory.add("insertTable", function (n) {
            var o = t.commands.get("insertTable"),
              i = wh(n);
            var r;
            return i.bind("isEnabled").to(o), i.buttonView.set({
              icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3 6v3h4V6H3zm0 4v3h4v-3H3zm0 4v3h4v-3H3zm5 3h4v-3H8v3zm5 0h4v-3h-4v3zm4-4v-3h-4v3h4zm0-4V6h-4v3h4zm1.5 8a1.5 1.5 0 0 1-1.5 1.5H3A1.5 1.5 0 0 1 1.5 17V4c.222-.863 1.068-1.5 2-1.5h13c.932 0 1.778.637 2 1.5v13zM12 13v-3H8v3h4zm0-4V6H8v3h4z"/></svg>',
              label: e("Insert table"),
              tooltip: !0
            }), i.on("change:isOpen", function () {
              r || (r = new lA(n), i.panelView.children.add(r), r.delegate("execute").to(i), i.buttonView.on("open", function () {
                r.rows = 0, r.columns = 0;
              }), i.on("execute", function () {
                t.execute("insertTable", {
                  rows: r.rows,
                  columns: r.columns
                }), t.editing.view.focus();
              }));
            }), i;
          }), t.ui.componentFactory.add("tableColumn", function (t) {
            var o = [{
              type: "switchbutton",
              model: {
                commandName: "setTableColumnHeader",
                label: e("Header column"),
                bindIsOn: !0
              }
            }, {
              type: "separator"
            }, {
              type: "button",
              model: {
                commandName: n ? "insertTableColumnLeft" : "insertTableColumnRight",
                label: e("Insert column left")
              }
            }, {
              type: "button",
              model: {
                commandName: n ? "insertTableColumnRight" : "insertTableColumnLeft",
                label: e("Insert column right")
              }
            }, {
              type: "button",
              model: {
                commandName: "removeTableColumn",
                label: e("Delete column")
              }
            }, {
              type: "button",
              model: {
                commandName: "selectTableColumn",
                label: e("Select column")
              }
            }];
            return _this308._prepareDropdown(e("Column"), '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 1h15A1.5 1.5 0 0 1 19 2.5v15a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 1 17.5v-15A1.5 1.5 0 0 1 2.5 1zM2 2v16h16V2H2z" opacity=".6"/><path d="M18 7v1H2V7h16zm0 5v1H2v-1h16z" opacity=".6"/><path d="M14 1v18a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1zm-2 1H8v4h4V2zm0 6H8v4h4V8zm0 6H8v4h4v-4z"/></svg>', o, t);
          }), t.ui.componentFactory.add("tableRow", function (t) {
            var n = [{
              type: "switchbutton",
              model: {
                commandName: "setTableRowHeader",
                label: e("Header row"),
                bindIsOn: !0
              }
            }, {
              type: "separator"
            }, {
              type: "button",
              model: {
                commandName: "insertTableRowAbove",
                label: e("Insert row above")
              }
            }, {
              type: "button",
              model: {
                commandName: "insertTableRowBelow",
                label: e("Insert row below")
              }
            }, {
              type: "button",
              model: {
                commandName: "removeTableRow",
                label: e("Delete row")
              }
            }, {
              type: "button",
              model: {
                commandName: "selectTableRow",
                label: e("Select row")
              }
            }];
            return _this308._prepareDropdown(e("Row"), '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 1h15A1.5 1.5 0 0 1 19 2.5v15a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 1 17.5v-15A1.5 1.5 0 0 1 2.5 1zM2 2v16h16V2H2z" opacity=".6"/><path d="M7 2h1v16H7V2zm5 0h1v16h-1V2z" opacity=".6"/><path d="M1 6h18a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1zm1 2v4h4V8H2zm6 0v4h4V8H8zm6 0v4h4V8h-4z"/></svg>', n, t);
          }), t.ui.componentFactory.add("mergeTableCells", function (t) {
            var o = [{
              type: "button",
              model: {
                commandName: "mergeTableCellUp",
                label: e("Merge cell up")
              }
            }, {
              type: "button",
              model: {
                commandName: n ? "mergeTableCellRight" : "mergeTableCellLeft",
                label: e("Merge cell right")
              }
            }, {
              type: "button",
              model: {
                commandName: "mergeTableCellDown",
                label: e("Merge cell down")
              }
            }, {
              type: "button",
              model: {
                commandName: n ? "mergeTableCellLeft" : "mergeTableCellRight",
                label: e("Merge cell left")
              }
            }, {
              type: "separator"
            }, {
              type: "button",
              model: {
                commandName: "splitTableCellVertically",
                label: e("Split cell vertically")
              }
            }, {
              type: "button",
              model: {
                commandName: "splitTableCellHorizontally",
                label: e("Split cell horizontally")
              }
            }];
            return _this308._prepareMergeSplitButtonDropdown(e("Merge cells"), '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 1h15A1.5 1.5 0 0 1 19 2.5v15a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 1 17.5v-15A1.5 1.5 0 0 1 2.5 1zM2 2v16h16V2H2z" opacity=".6"/><path d="M7 2h1v16H7V2zm5 0h1v7h-1V2zm6 5v1H2V7h16zM8 12v1H2v-1h6z" opacity=".6"/><path d="M7 7h12a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1zm1 2v9h10V9H8z"/></svg>', o, t);
          });
        }
      }, {
        key: "_prepareDropdown",
        value: function _prepareDropdown(t, e, n, o) {
          var i = this.editor,
            r = wh(o),
            s = this._fillDropdownWithListOptions(r, n);
          return r.buttonView.set({
            label: t,
            icon: e,
            tooltip: !0
          }), r.bind("isEnabled").toMany(s, "isEnabled", function () {
            for (var _len30 = arguments.length, t = new Array(_len30), _key30 = 0; _key30 < _len30; _key30++) {
              t[_key30] = arguments[_key30];
            }
            return t.some(function (t) {
              return t;
            });
          }), this.listenTo(r, "execute", function (t) {
            i.execute(t.source.commandName), i.editing.view.focus();
          }), r;
        }
      }, {
        key: "_prepareMergeSplitButtonDropdown",
        value: function _prepareMergeSplitButtonDropdown(t, e, n, o) {
          var i = this.editor,
            r = wh(o, qd),
            s = "mergeTableCells",
            a = i.commands.get(s),
            c = this._fillDropdownWithListOptions(r, n);
          return r.buttonView.set({
            label: t,
            icon: e,
            tooltip: !0,
            isEnabled: !0
          }), r.bind("isEnabled").toMany([a].concat(_toConsumableArray(c)), "isEnabled", function () {
            for (var _len31 = arguments.length, t = new Array(_len31), _key31 = 0; _key31 < _len31; _key31++) {
              t[_key31] = arguments[_key31];
            }
            return t.some(function (t) {
              return t;
            });
          }), this.listenTo(r.buttonView, "execute", function () {
            i.execute(s), i.editing.view.focus();
          }), this.listenTo(r, "execute", function (t) {
            i.execute(t.source.commandName), i.editing.view.focus();
          }), r;
        }
      }, {
        key: "_fillDropdownWithListOptions",
        value: function _fillDropdownWithListOptions(t, e) {
          var n = this.editor,
            o = [],
            i = new co();
          var _iterator468 = _createForOfIteratorHelper(e),
            _step468;
          try {
            for (_iterator468.s(); !(_step468 = _iterator468.n()).done;) {
              var _t393 = _step468.value;
              uA(_t393, n, o, i);
            }
          } catch (err) {
            _iterator468.e(err);
          } finally {
            _iterator468.f();
          }
          return Ah(t, i, n.ui.componentFactory), o;
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "TableUI";
        }
      }]);
      return hA;
    }(Jt);
    function uA(t, e, n, o) {
      var i = t.model = new Vh(t.model),
        _t$model2 = t.model,
        r = _t$model2.commandName,
        s = _t$model2.bindIsOn;
      if ("button" === t.type || "switchbutton" === t.type) {
        var _t394 = e.commands.get(r);
        n.push(_t394), i.set({
          commandName: r
        }), i.bind("isEnabled").to(_t394), s && i.bind("isOn").to(_t394, "value");
      }
      i.set({
        withText: !0
      }), o.add(t);
    }
    var gA = n(60),
      mA = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Zl()(gA.a, mA), gA.a.locals;
    var pA = /*#__PURE__*/function (_Jt69) {
      _inherits(pA, _Jt69);
      function pA() {
        _classCallCheck(this, pA);
        return _possibleConstructorReturn(this, _getPrototypeOf(pA).apply(this, arguments));
      }
      _createClass(pA, [{
        key: "init",
        value: function init() {
          var _this309 = this;
          var t = this.editor.model;
          this.listenTo(t, "deleteContent", function (t, e) {
            return _this309._handleDeleteContent(t, e);
          }, {
            priority: "high"
          }), this._defineSelectionConverter(), this._enablePluginDisabling();
        }
      }, {
        key: "getSelectedTableCells",
        value: function getSelectedTableCells() {
          var t = sC(this.editor.model.document.selection);
          return 0 == t.length ? null : t;
        }
      }, {
        key: "getSelectionAsFragment",
        value: function getSelectionAsFragment() {
          var _this310 = this;
          var t = this.getSelectedTableCells();
          return t ? this.editor.model.change(function (e) {
            var n = e.createDocumentFragment(),
              o = _this310.editor.plugins.get("TableUtils"),
              _dC3 = dC(t),
              i = _dC3.first,
              r = _dC3.last,
              _lC2 = lC(t),
              s = _lC2.first,
              a = _lC2.last,
              c = t[0].findAncestor("table");
            var l = a,
              d = r;
            if (hC(t, o)) {
              var _t395 = {
                firstColumn: i,
                lastColumn: r,
                firstRow: s,
                lastRow: a
              };
              l = MC(c, _t395), d = IC(c, _t395);
            }
            var h = wC(c, {
              startRow: s,
              startColumn: i,
              endRow: l,
              endColumn: d
            }, e);
            return e.insert(h, n, 0), n;
          }) : null;
        }
      }, {
        key: "setCellSelection",
        value: function setCellSelection(t, e) {
          var n = this._getCellsToSelect(t, e);
          this.editor.model.change(function (t) {
            t.setSelection(n.cells.map(function (e) {
              return t.createRangeOn(e);
            }), {
              backward: n.backward
            });
          });
        }
      }, {
        key: "getFocusCell",
        value: function getFocusCell() {
          var t = _toConsumableArray(this.editor.model.document.selection.getRanges()).pop().getContainedElement();
          return t && t.is("element", "tableCell") ? t : null;
        }
      }, {
        key: "getAnchorCell",
        value: function getAnchorCell() {
          var t = Ks(this.editor.model.document.selection.getRanges()).getContainedElement();
          return t && t.is("element", "tableCell") ? t : null;
        }
      }, {
        key: "_defineSelectionConverter",
        value: function _defineSelectionConverter() {
          var _this311 = this;
          var t = this.editor,
            e = new Set();
          t.conversion.for("editingDowncast").add(function (t) {
            return t.on("selection", function (t, n, o) {
              var i = o.writer;
              !function (t) {
                var _iterator469 = _createForOfIteratorHelper(e),
                  _step469;
                try {
                  for (_iterator469.s(); !(_step469 = _iterator469.n()).done;) {
                    var _n314 = _step469.value;
                    t.removeClass("ck-editor__editable_selected", _n314);
                  }
                } catch (err) {
                  _iterator469.e(err);
                } finally {
                  _iterator469.f();
                }
                e.clear();
              }(i);
              var r = _this311.getSelectedTableCells();
              if (!r) return;
              var _iterator470 = _createForOfIteratorHelper(r),
                _step470;
              try {
                for (_iterator470.s(); !(_step470 = _iterator470.n()).done;) {
                  var _t396 = _step470.value;
                  var _n315 = o.mapper.toViewElement(_t396);
                  i.addClass("ck-editor__editable_selected", _n315), e.add(_n315);
                }
              } catch (err) {
                _iterator470.e(err);
              } finally {
                _iterator470.f();
              }
              var s = o.mapper.toViewElement(r[r.length - 1]);
              i.setSelection(s, 0);
            }, {
              priority: "lowest"
            });
          });
        }
      }, {
        key: "_enablePluginDisabling",
        value: function _enablePluginDisabling() {
          var _this312 = this;
          var t = this.editor;
          this.on("change:isEnabled", function () {
            if (!_this312.isEnabled) {
              var _e354 = _this312.getSelectedTableCells();
              if (!_e354) return;
              t.model.change(function (n) {
                var o = n.createPositionAt(_e354[0], 0),
                  i = t.model.schema.getNearestSelectionRange(o);
                n.setSelection(i);
              });
            }
          });
        }
      }, {
        key: "_handleDeleteContent",
        value: function _handleDeleteContent(t, e) {
          var _e355 = _slicedToArray(e, 2),
            n = _e355[0],
            o = _e355[1],
            i = this.editor.model,
            r = !o || "backward" == o.direction,
            s = sC(n);
          s.length && (t.stop(), i.change(function (t) {
            var e = s[r ? s.length - 1 : 0];
            i.change(function (t) {
              var _iterator471 = _createForOfIteratorHelper(s),
                _step471;
              try {
                for (_iterator471.s(); !(_step471 = _iterator471.n()).done;) {
                  var _e356 = _step471.value;
                  i.deleteContent(t.createSelection(_e356, "in"));
                }
              } catch (err) {
                _iterator471.e(err);
              } finally {
                _iterator471.f();
              }
            });
            var o = i.schema.getNearestSelectionRange(t.createPositionAt(e, 0));
            n.is("documentSelection") ? t.setSelection(o) : n.setTo(o);
          }));
        }
      }, {
        key: "_getCellsToSelect",
        value: function _getCellsToSelect(t, e) {
          var n = this.editor.plugins.get("TableUtils"),
            o = n.getCellLocation(t),
            i = n.getCellLocation(e),
            r = Math.min(o.row, i.row),
            s = Math.max(o.row, i.row),
            a = Math.min(o.column, i.column),
            c = Math.max(o.column, i.column),
            l = new Array(s - r + 1).fill(null).map(function () {
              return [];
            }),
            d = {
              startRow: r,
              endRow: s,
              startColumn: a,
              endColumn: c
            };
          var _iterator472 = _createForOfIteratorHelper(new Kw(t.findAncestor("table"), d)),
            _step472;
          try {
            for (_iterator472.s(); !(_step472 = _iterator472.n()).done;) {
              var _step472$value = _step472.value,
                _e357 = _step472$value.row,
                _n316 = _step472$value.cell;
              l[_e357 - r].push(_n316);
            }
          } catch (err) {
            _iterator472.e(err);
          } finally {
            _iterator472.f();
          }
          var h = i.row < o.row,
            u = i.column < o.column;
          return h && l.reverse(), u && l.forEach(function (t) {
            return t.reverse();
          }), {
            cells: l.flat(),
            backward: h || u
          };
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "TableSelection";
        }
      }, {
        key: "requires",
        get: function get() {
          return [LC];
        }
      }]);
      return pA;
    }(Jt);
    var fA = /*#__PURE__*/function (_Jt70) {
      _inherits(fA, _Jt70);
      function fA() {
        _classCallCheck(this, fA);
        return _possibleConstructorReturn(this, _getPrototypeOf(fA).apply(this, arguments));
      }
      _createClass(fA, [{
        key: "init",
        value: function init() {
          var _this313 = this;
          var t = this.editor,
            e = t.editing.view.document;
          this.listenTo(e, "copy", function (t, e) {
            return _this313._onCopyCut(t, e);
          }), this.listenTo(e, "cut", function (t, e) {
            return _this313._onCopyCut(t, e);
          }), this.listenTo(t.model, "insertContent", function (t, e) {
            return _this313._onInsertContent.apply(_this313, [t].concat(_toConsumableArray(e)));
          }, {
            priority: "high"
          }), this.decorate("_replaceTableSlotCell");
        }
      }, {
        key: "_onCopyCut",
        value: function _onCopyCut(t, e) {
          var n = this.editor.plugins.get(pA);
          if (!n.getSelectedTableCells()) return;
          if ("cut" == t.name && this.editor.isReadOnly) return;
          e.preventDefault(), t.stop();
          var o = this.editor.data,
            i = this.editor.editing.view.document,
            r = o.toView(n.getSelectionAsFragment());
          i.fire("clipboardOutput", {
            dataTransfer: e.dataTransfer,
            content: r,
            method: t.name
          });
        }
      }, {
        key: "_onInsertContent",
        value: function _onInsertContent(t, e, n) {
          var _this314 = this;
          if (n && !n.is("documentSelection")) return;
          var o = this.editor.model,
            i = this.editor.plugins.get(LC);
          var r = function (t, e) {
            if (!t.is("documentFragment") && !t.is("element")) return null;
            if (t.is("element", "table")) return t;
            if (1 == t.childCount && t.getChild(0).is("element", "table")) return t.getChild(0);
            var n = e.createRangeIn(t);
            var _iterator473 = _createForOfIteratorHelper(n.getItems()),
              _step473;
            try {
              for (_iterator473.s(); !(_step473 = _iterator473.n()).done;) {
                var _t397 = _step473.value;
                if (_t397.is("element", "table")) {
                  var _o214 = e.createRange(n.start, e.createPositionBefore(_t397));
                  if (e.hasContent(_o214, {
                    ignoreWhitespaces: !0
                  })) return null;
                  var _i175 = e.createRange(e.createPositionAfter(_t397), n.end);
                  return e.hasContent(_i175, {
                    ignoreWhitespaces: !0
                  }) ? null : _t397;
                }
              }
            } catch (err) {
              _iterator473.e(err);
            } finally {
              _iterator473.f();
            }
            return null;
          }(e, o);
          if (!r) return;
          var s = cC(o.document.selection);
          s.length ? (t.stop(), o.change(function (t) {
            var e = {
                width: i.getColumns(r),
                height: i.getRows(r)
              },
              n = function (t, e, n, o) {
                var i = t[0].findAncestor("table"),
                  r = dC(t),
                  s = lC(t),
                  a = {
                    firstColumn: r.first,
                    lastColumn: r.last,
                    firstRow: s.first,
                    lastRow: s.last
                  },
                  c = 1 === t.length;
                c && (a.lastRow += e.height - 1, a.lastColumn += e.width - 1, function (t, e, n, o) {
                  var i = o.getColumns(t),
                    r = o.getRows(t);
                  n > i && o.insertColumns(t, {
                    at: i,
                    columns: n - i
                  });
                  e > r && o.insertRows(t, {
                    at: r,
                    rows: e - r
                  });
                }(i, a.lastRow + 1, a.lastColumn + 1, o));
                c || !hC(t, o) ? function (t, e, n) {
                  var o = e.firstRow,
                    i = e.lastRow,
                    r = e.firstColumn,
                    s = e.lastColumn,
                    a = {
                      first: o,
                      last: i
                    },
                    c = {
                      first: r,
                      last: s
                    };
                  bA(t, r, a, n), bA(t, s + 1, a, n), kA(t, o, c, n), kA(t, i + 1, c, n, o);
                }(i, a, n) : (a.lastRow = MC(i, a), a.lastColumn = IC(i, a));
                return a;
              }(s, e, t, i),
              o = n.lastRow - n.firstRow + 1,
              a = n.lastColumn - n.firstColumn + 1,
              c = {
                startRow: 0,
                startColumn: 0,
                endRow: Math.min(o, e.height) - 1,
                endColumn: Math.min(a, e.width) - 1
              };
            r = wC(r, c, t);
            var l = s[0].findAncestor("table"),
              d = _this314._replaceSelectedCellsWithPasted(r, e, l, n, t);
            if (_this314.editor.plugins.get("TableSelection").isEnabled) {
              var _e358 = uC(d.map(function (e) {
                return t.createRangeOn(e);
              }));
              t.setSelection(_e358);
            } else t.setSelection(d[0], 0);
          })) : DC(r, i);
        }
      }, {
        key: "_replaceSelectedCellsWithPasted",
        value: function _replaceSelectedCellsWithPasted(t, e, n, o, i) {
          var r = e.width,
            s = e.height,
            a = function (t, e, n) {
              var o = new Array(n).fill(null).map(function () {
                return new Array(e).fill(null);
              });
              var _iterator474 = _createForOfIteratorHelper(new Kw(t)),
                _step474;
              try {
                for (_iterator474.s(); !(_step474 = _iterator474.n()).done;) {
                  var _step474$value = _step474.value,
                    _e359 = _step474$value.column,
                    _n317 = _step474$value.row,
                    _i176 = _step474$value.cell;
                  o[_n317][_e359] = _i176;
                }
              } catch (err) {
                _iterator474.e(err);
              } finally {
                _iterator474.f();
              }
              return o;
            }(t, r, s),
            c = _toConsumableArray(new Kw(n, {
              startRow: o.firstRow,
              endRow: o.lastRow,
              startColumn: o.firstColumn,
              endColumn: o.lastColumn,
              includeAllSlots: !0
            })),
            l = [];
          var d;
          for (var _i177 = 0, _c23 = c; _i177 < _c23.length; _i177++) {
            var _t398 = _c23[_i177];
            var _e360 = _t398.row,
              _n318 = _t398.column;
            _n318 === o.firstColumn && (d = _t398.getPositionBefore());
            var _c24 = _e360 - o.firstRow,
              _h7 = _n318 - o.firstColumn,
              _u5 = a[_c24 % s][_h7 % r],
              _g5 = _u5 ? i.cloneElement(_u5) : null,
              _m2 = this._replaceTableSlotCell(_t398, _g5, d, i);
            _m2 && (yC(_m2, _e360, _n318, o.lastRow, o.lastColumn, i), l.push(_m2), d = i.createPositionAfter(_m2));
          }
          var h = parseInt(n.getAttribute("headingRows") || 0),
            u = parseInt(n.getAttribute("headingColumns") || 0),
            g = o.firstRow < h && h <= o.lastRow,
            m = o.firstColumn < u && u <= o.lastColumn;
          if (g) {
            var _t399 = kA(n, h, {
              first: o.firstColumn,
              last: o.lastColumn
            }, i, o.firstRow);
            l.push.apply(l, _toConsumableArray(_t399));
          }
          if (m) {
            var _t400 = bA(n, u, {
              first: o.firstRow,
              last: o.lastRow
            }, i);
            l.push.apply(l, _toConsumableArray(_t400));
          }
          return l;
        }
      }, {
        key: "_replaceTableSlotCell",
        value: function _replaceTableSlotCell(t, e, n, o) {
          var i = t.cell,
            r = t.isAnchor;
          return r && o.remove(i), e ? (o.insert(e, n), e) : null;
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "TableClipboard";
        }
      }, {
        key: "requires",
        get: function get() {
          return [pA, LC];
        }
      }]);
      return fA;
    }(Jt);
    function kA(t, e, n, o) {
      var i = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
      if (e < 1) return;
      return CC(t, e, i).filter(function (_ref96) {
        var t = _ref96.column,
          e = _ref96.cellWidth;
        return wA(t, e, n);
      }).map(function (_ref97) {
        var t = _ref97.cell;
        return AC(t, e, o);
      });
    }
    function bA(t, e, n, o) {
      if (e < 1) return;
      return _C(t, e).filter(function (_ref98) {
        var t = _ref98.row,
          e = _ref98.cellHeight;
        return wA(t, e, n);
      }).map(function (_ref99) {
        var t = _ref99.cell,
          n = _ref99.column;
        return vC(t, n, e, o);
      });
    }
    function wA(t, e, n) {
      var o = t + e - 1,
        i = n.first,
        r = n.last;
      return t >= i && t <= r || t < i && o >= i;
    }
    var CA = /*#__PURE__*/function (_Jt71) {
      _inherits(CA, _Jt71);
      function CA() {
        _classCallCheck(this, CA);
        return _possibleConstructorReturn(this, _getPrototypeOf(CA).apply(this, arguments));
      }
      _createClass(CA, [{
        key: "init",
        value: function init() {
          var _this315 = this;
          var t = this.editor.editing.view.document;
          this.editor.keystrokes.set("Tab", function () {
            return _this315._handleTabOnSelectedTable.apply(_this315, arguments);
          }, {
            priority: "low"
          }), this.editor.keystrokes.set("Tab", this._getTabHandler(!0), {
            priority: "low"
          }), this.editor.keystrokes.set("Shift+Tab", this._getTabHandler(!1), {
            priority: "low"
          }), this.listenTo(t, "arrowKey", function () {
            return _this315._onArrowKey.apply(_this315, arguments);
          }, {
            context: "table"
          });
        }
      }, {
        key: "_handleTabOnSelectedTable",
        value: function _handleTabOnSelectedTable(t, e) {
          var n = this.editor,
            o = n.model.document.selection.getSelectedElement();
          o && o.is("element", "table") && (e(), n.model.change(function (t) {
            t.setSelection(t.createRangeIn(o.getChild(0).getChild(0)));
          }));
        }
      }, {
        key: "_getTabHandler",
        value: function _getTabHandler(t) {
          var _this316 = this;
          var e = this.editor;
          return function (n, o) {
            var i = aC(e.model.document.selection)[0];
            if (i || (i = _this316.editor.plugins.get("TableSelection").getFocusCell()), !i) return;
            o();
            var r = i.parent,
              s = r.parent,
              a = s.getChildIndex(r),
              c = r.getChildIndex(i),
              l = 0 === c;
            if (!t && l && 0 === a) return void e.model.change(function (t) {
              t.setSelection(t.createRangeOn(s));
            });
            var d = _this316.editor.plugins.get("TableUtils"),
              h = c === r.childCount - 1,
              u = a === d.getRows(s) - 1;
            if (t && u && h && (e.execute("insertTableRowBelow"), a === d.getRows(s) - 1)) return void e.model.change(function (t) {
              t.setSelection(t.createRangeOn(s));
            });
            var g;
            if (t && h) {
              var _t401 = s.getChild(a + 1);
              g = _t401.getChild(0);
            } else if (!t && l) {
              var _t402 = s.getChild(a - 1);
              g = _t402.getChild(_t402.childCount - 1);
            } else g = r.getChild(c + (t ? 1 : -1));
            e.model.change(function (t) {
              t.setSelection(t.createRangeIn(g));
            });
          };
        }
      }, {
        key: "_onArrowKey",
        value: function _onArrowKey(t, e) {
          var n = this.editor,
            o = qi(e.keyCode, n.locale.contentLanguageDirection);
          this._handleArrowKeys(o, e.shiftKey) && (e.preventDefault(), e.stopPropagation(), t.stop());
        }
      }, {
        key: "_handleArrowKeys",
        value: function _handleArrowKeys(t, e) {
          var n = this.editor.model.document.selection,
            o = ["right", "down"].includes(t),
            i = sC(n);
          if (i.length) {
            var _n319;
            return _n319 = e ? this.editor.plugins.get("TableSelection").getFocusCell() : o ? i[i.length - 1] : i[0], this._navigateFromCellInDirection(_n319, t, e), !0;
          }
          var r = n.focus.findAncestor("tableCell");
          return !!r && !(e && !n.isCollapsed && n.isBackward == o) && !!this._isSelectionAtCellEdge(n, r, o) && (this._navigateFromCellInDirection(r, t, e), !0);
        }
      }, {
        key: "_isSelectionAtCellEdge",
        value: function _isSelectionAtCellEdge(t, e, n) {
          var o = this.editor.model,
            i = this.editor.model.schema,
            r = n ? t.getLastPosition() : t.getFirstPosition();
          if (!i.getLimitElement(r).is("element", "tableCell")) {
            return o.createPositionAt(e, n ? "end" : 0).isTouching(r);
          }
          var s = o.createSelection(r);
          return o.modifySelection(s, {
            direction: n ? "forward" : "backward"
          }), r.isEqual(s.focus);
        }
      }, {
        key: "_navigateFromCellInDirection",
        value: function _navigateFromCellInDirection(t, e) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
          var o = this.editor.model,
            i = t.findAncestor("table"),
            r = _toConsumableArray(new Kw(i, {
              includeAllSlots: !0
            })),
            _r82 = r[r.length - 1],
            s = _r82.row,
            a = _r82.column,
            c = r.find(function (_ref100) {
              var e = _ref100.cell;
              return e == t;
            });
          var l = c.row,
            d = c.column;
          switch (e) {
            case "left":
              d--;
              break;
            case "up":
              l--;
              break;
            case "right":
              d += c.cellWidth;
              break;
            case "down":
              l += c.cellHeight;
          }
          if (l < 0 || l > s || d < 0 && l <= 0 || d > a && l >= s) return void o.change(function (t) {
            t.setSelection(t.createRangeOn(i));
          });
          d < 0 ? (d = n ? 0 : a, l--) : d > a && (d = n ? a : 0, l++);
          var h = r.find(function (t) {
              return t.row == l && t.column == d;
            }).cell,
            u = ["right", "down"].includes(e),
            g = this.editor.plugins.get("TableSelection");
          if (n && g.isEnabled) {
            var _e361 = g.getAnchorCell() || t;
            g.setCellSelection(_e361, h);
          } else {
            var _t403 = o.createPositionAt(h, u ? 0 : "end");
            o.change(function (e) {
              e.setSelection(_t403);
            });
          }
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "TableKeyboard";
        }
      }, {
        key: "requires",
        get: function get() {
          return [pA];
        }
      }]);
      return CA;
    }(Jt);
    var AA = /*#__PURE__*/function (_ps8) {
      _inherits(AA, _ps8);
      function AA(t) {
        var _this317;
        _classCallCheck(this, AA);
        _this317 = _possibleConstructorReturn(this, _getPrototypeOf(AA).call(this, t)), _this317.domEventType = ["mousemove", "mouseleave"];
        return _this317;
      }
      _createClass(AA, [{
        key: "onDomEvent",
        value: function onDomEvent(t) {
          this.fire(t.type, t);
        }
      }]);
      return AA;
    }(ps);
    var _A = /*#__PURE__*/function (_Jt72) {
      _inherits(_A, _Jt72);
      function _A() {
        _classCallCheck(this, _A);
        return _possibleConstructorReturn(this, _getPrototypeOf(_A).apply(this, arguments));
      }
      _createClass(_A, [{
        key: "init",
        value: function init() {
          this.editor.editing.view.addObserver(AA), this._enableShiftClickSelection(), this._enableMouseDragSelection();
        }
      }, {
        key: "_enableShiftClickSelection",
        value: function _enableShiftClickSelection() {
          var _this318 = this;
          var t = this.editor;
          var e = !1;
          var n = t.plugins.get(pA);
          this.listenTo(t.editing.view.document, "mousedown", function (o, i) {
            if (!_this318.isEnabled || !n.isEnabled) return;
            if (!i.domEvent.shiftKey) return;
            var r = n.getAnchorCell() || aC(t.model.document.selection)[0];
            if (!r) return;
            var s = _this318._getModelTableCellFromDomEvent(i);
            s && vA(r, s) && (e = !0, n.setCellSelection(r, s), i.preventDefault());
          }), this.listenTo(t.editing.view.document, "mouseup", function () {
            e = !1;
          }), this.listenTo(t.editing.view.document, "selectionChange", function (t) {
            e && t.stop();
          }, {
            priority: "highest"
          });
        }
      }, {
        key: "_enableMouseDragSelection",
        value: function _enableMouseDragSelection() {
          var _this319 = this;
          var t = this.editor;
          var e,
            n,
            o = !1,
            i = !1;
          var r = t.plugins.get(pA);
          this.listenTo(t.editing.view.document, "mousedown", function (t, n) {
            _this319.isEnabled && r.isEnabled && (n.domEvent.shiftKey || n.domEvent.ctrlKey || n.domEvent.altKey || (e = _this319._getModelTableCellFromDomEvent(n)));
          }), this.listenTo(t.editing.view.document, "mousemove", function (t, s) {
            if (!s.domEvent.buttons) return;
            if (!e) return;
            var a = _this319._getModelTableCellFromDomEvent(s);
            a && vA(e, a) && (n = a, o || n == e || (o = !0)), o && (i = !0, r.setCellSelection(e, n), s.preventDefault());
          }), this.listenTo(t.editing.view.document, "mouseup", function () {
            o = !1, i = !1, e = null, n = null;
          }), this.listenTo(t.editing.view.document, "selectionChange", function (t) {
            i && t.stop();
          }, {
            priority: "highest"
          });
        }
      }, {
        key: "_getModelTableCellFromDomEvent",
        value: function _getModelTableCellFromDomEvent(t) {
          var e = t.target,
            n = this.editor.editing.view.createPositionAt(e, 0);
          return this.editor.editing.mapper.toModelPosition(n).parent.findAncestor("tableCell", {
            includeSelf: !0
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "TableMouse";
        }
      }, {
        key: "requires",
        get: function get() {
          return [pA];
        }
      }]);
      return _A;
    }(Jt);
    function vA(t, e) {
      return t.parent.parent == e.parent.parent;
    }
    var yA = n(61),
      xA = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Zl()(yA.a, xA), yA.a.locals;
    function EA(t) {
      var e = t.getSelectedElement();
      return e && MA(e) ? e : null;
    }
    function DA(t) {
      var e = t.getFirstPosition().parent;
      for (; e;) {
        if (e.is("element") && MA(e)) return e;
        e = e.parent;
      }
      return null;
    }
    function MA(t) {
      return !!t.getCustomProperty("table") && hm(t);
    }
    var IA = "underline";
    var TA = /*#__PURE__*/function (_Jt73) {
      _inherits(TA, _Jt73);
      function TA() {
        _classCallCheck(this, TA);
        return _possibleConstructorReturn(this, _getPrototypeOf(TA).apply(this, arguments));
      }
      _createClass(TA, [{
        key: "init",
        value: function init() {
          var t = this.editor;
          t.model.schema.extend("$text", {
            allowAttributes: IA
          }), t.model.schema.setAttributeProperties(IA, {
            isFormatting: !0,
            copyOnEnter: !0
          }), t.conversion.attributeToElement({
            model: IA,
            view: "u",
            upcastAlso: {
              styles: {
                "text-decoration": "underline"
              }
            }
          }), t.commands.add(IA, new Qg(t, IA)), t.keystrokes.set("CTRL+U", "underline");
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "UnderlineEditing";
        }
      }]);
      return TA;
    }(Jt);
    var SA = "underline";
    var NA = /*#__PURE__*/function (_Jt74) {
      _inherits(NA, _Jt74);
      function NA() {
        _classCallCheck(this, NA);
        return _possibleConstructorReturn(this, _getPrototypeOf(NA).apply(this, arguments));
      }
      _createClass(NA, [{
        key: "init",
        value: function init() {
          var _this320 = this;
          var t = this.editor,
            e = t.t;
          t.ui.componentFactory.add(SA, function (n) {
            var o = t.commands.get(SA),
              i = new Sd(n);
            return i.set({
              label: e("Underline"),
              icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3 18v-1.5h14V18zm2.2-8V3.6c0-.4.4-.6.8-.6.3 0 .7.2.7.6v6.2c0 2 1.3 2.8 3.2 2.8 1.9 0 3.4-.9 3.4-2.9V3.6c0-.3.4-.5.8-.5.3 0 .7.2.7.5V10c0 2.7-2.2 4-4.9 4-2.6 0-4.7-1.2-4.7-4z"/></svg>',
              keystroke: "CTRL+U",
              tooltip: !0,
              isToggleable: !0
            }), i.bind("isOn", "isEnabled").to(o, "value", "isEnabled"), _this320.listenTo(i, "execute", function () {
              t.execute(SA), t.editing.view.focus();
            }), i;
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "UnderlineUI";
        }
      }]);
      return NA;
    }(Jt);
    var BA = /*#__PURE__*/function (_Xt38) {
      _inherits(BA, _Xt38);
      function BA() {
        _classCallCheck(this, BA);
        return _possibleConstructorReturn(this, _getPrototypeOf(BA).apply(this, arguments));
      }
      _createClass(BA, [{
        key: "refresh",
        value: function refresh() {
          var t = this.editor.model,
            e = t.schema,
            n = t.document.selection;
          this.isEnabled = function (t, e, n) {
            var o = function (t, e) {
              var n = bm(t, e).start.parent;
              if (n.isEmpty && !n.is("element", "$root")) return n.parent;
              return n;
            }(t, n);
            return e.checkChild(o, "rawHtml");
          }(n, e, t);
        }
      }, {
        key: "execute",
        value: function execute() {
          var t = this.editor.model;
          t.change(function (e) {
            var n = e.createElement("rawHtml");
            t.insertContent(n), e.setSelection(n, "on");
          });
        }
      }]);
      return BA;
    }(Xt);
    var PA = /*#__PURE__*/function (_Xt39) {
      _inherits(PA, _Xt39);
      function PA() {
        _classCallCheck(this, PA);
        return _possibleConstructorReturn(this, _getPrototypeOf(PA).apply(this, arguments));
      }
      _createClass(PA, [{
        key: "refresh",
        value: function refresh() {
          var t = zA(this.editor.model.document.selection);
          this.isEnabled = !!t;
        }
      }, {
        key: "execute",
        value: function execute(t) {
          var e = this.editor.model,
            n = zA(e.document.selection);
          e.change(function (e) {
            e.setAttribute("value", t, n);
          });
        }
      }]);
      return PA;
    }(Xt);
    function zA(t) {
      var e = t.getSelectedElement();
      return e && e.is("element", "rawHtml") ? e : null;
    }
    var LA = n(62),
      OA = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    Zl()(LA.a, OA), LA.a.locals;
    var RA = /*#__PURE__*/function (_Jt75) {
      _inherits(RA, _Jt75);
      _createClass(RA, null, [{
        key: "pluginName",
        get: function get() {
          return "HtmlEmbedEditing";
        }
      }]);
      function RA(t) {
        var _this321;
        _classCallCheck(this, RA);
        _this321 = _possibleConstructorReturn(this, _getPrototypeOf(RA).call(this, t)), t.config.define("htmlEmbed", {
          showPreviews: !1,
          sanitizeHtml: function sanitizeHtml(t) {
            return Object(c.b)("html-embed-provide-sanitize-function"), {
              html: t,
              hasChanged: !1
            };
          }
        });
        return _this321;
      }
      _createClass(RA, [{
        key: "init",
        value: function init() {
          var t = this.editor;
          t.model.schema.register("rawHtml", {
            isObject: !0,
            allowWhere: "$block",
            allowAttributes: ["value"]
          }), t.commands.add("updateHtmlEmbed", new PA(t)), t.commands.add("insertHtmlEmbed", new BA(t)), this._setupConversion();
        }
      }, {
        key: "_setupConversion",
        value: function _setupConversion() {
          var t = this.editor,
            e = t.t,
            n = t.editing.view,
            o = t.config.get("htmlEmbed");
          function i(_ref101) {
            var t = _ref101.domElement,
              n = _ref101.editor,
              o = _ref101.state,
              i = _ref101.props;
            t.textContent = "";
            var s = t.ownerDocument;
            var a;
            if (o.isEditable) {
              var _e362 = {
                isDisabled: !1,
                placeholder: i.textareaPlaceholder
              };
              a = r({
                domDocument: s,
                state: o,
                props: _e362
              }), t.append(a);
            } else if (o.showPreviews) {
              var _r83 = {
                sanitizeHtml: i.sanitizeHtml
              };
              t.append(function (_ref102) {
                var t = _ref102.domDocument,
                  n = _ref102.state,
                  o = _ref102.props,
                  i = _ref102.editor;
                var r = o.sanitizeHtml(n.getRawHtmlValue()),
                  s = n.getRawHtmlValue().length > 0 ? e("No preview available") : e("Empty snippet content"),
                  a = Os(t, "div", {
                    class: "ck ck-reset_all raw-html-embed__preview-placeholder"
                  }, s),
                  c = Os(t, "div", {
                    class: "raw-html-embed__preview-content",
                    dir: i.locale.contentLanguageDirection
                  }),
                  l = t.createRange().createContextualFragment(r.html);
                c.appendChild(l);
                return Os(t, "div", {
                  class: "raw-html-embed__preview"
                }, [a, c]);
              }({
                domDocument: s,
                state: o,
                props: _r83,
                editor: n
              }));
            } else {
              var _e363 = {
                isDisabled: !0,
                placeholder: i.textareaPlaceholder
              };
              t.append(r({
                domDocument: s,
                state: o,
                props: _e363
              }));
            }
            var c = {
              onEditClick: i.onEditClick,
              onSaveClick: function onSaveClick() {
                i.onSaveClick(a.value);
              },
              onCancelClick: i.onCancelClick
            };
            t.prepend(function (_ref103) {
              var t = _ref103.editor,
                e = _ref103.domDocument,
                n = _ref103.state,
                o = _ref103.props;
              var i = Os(e, "div", {
                  class: "raw-html-embed__buttons-wrapper"
                }),
                r = jA(t, "edit"),
                s = jA(t, "save"),
                a = jA(t, "cancel");
              if (n.isEditable) {
                var _t404 = s.cloneNode(!0),
                  _e364 = a.cloneNode(!0);
                _t404.addEventListener("click", function (t) {
                  t.preventDefault(), o.onSaveClick();
                }), _e364.addEventListener("click", function (t) {
                  t.preventDefault(), o.onCancelClick();
                }), i.appendChild(_t404), i.appendChild(_e364);
              } else {
                var _t405 = r.cloneNode(!0);
                _t405.addEventListener("click", function (t) {
                  t.preventDefault(), o.onEditClick();
                }), i.appendChild(_t405);
              }
              return i;
            }({
              editor: n,
              domDocument: s,
              state: o,
              props: c
            }));
          }
          function r(_ref104) {
            var t = _ref104.domDocument,
              e = _ref104.state,
              n = _ref104.props;
            var o = Os(t, "textarea", {
              placeholder: n.placeholder,
              class: "ck ck-reset ck-input ck-input-text raw-html-embed__source"
            });
            return o.disabled = n.isDisabled, o.value = e.getRawHtmlValue(), o;
          }
          t.data.registerRawContentMatcher({
            name: "div",
            classes: "raw-html-embed"
          }), t.conversion.for("upcast").elementToElement({
            view: {
              name: "div",
              classes: "raw-html-embed"
            },
            model: function model(t, _ref105) {
              var e = _ref105.writer;
              return e.createElement("rawHtml", {
                value: t.getCustomProperty("$rawContent")
              });
            }
          }), t.conversion.for("dataDowncast").elementToElement({
            model: "rawHtml",
            view: function view(t, _ref106) {
              var e = _ref106.writer;
              return e.createRawElement("div", {
                class: "raw-html-embed"
              }, function (e) {
                e.innerHTML = t.getAttribute("value") || "";
              });
            }
          }), t.conversion.for("editingDowncast").elementToElement({
            triggerBy: {
              attributes: ["value"]
            },
            model: "rawHtml",
            view: function view(r, _ref107) {
              var s = _ref107.writer;
              var a, c, l;
              var d = s.createContainerElement("div", {
                  class: "raw-html-embed",
                  "data-html-embed-label": e("HTML snippet"),
                  dir: t.locale.uiLanguageDirection
                }),
                h = s.createRawElement("div", {
                  class: "raw-html-embed__content-wrapper"
                }, function (e) {
                  a = e, i({
                    domElement: e,
                    editor: t,
                    state: c,
                    props: l
                  }), a.addEventListener("mousedown", function () {
                    if (c.isEditable) {
                      var _e365 = t.model;
                      _e365.document.selection.getSelectedElement() !== r && _e365.change(function (t) {
                        return t.setSelection(r, "on");
                      });
                    }
                  }, !0);
                }),
                u = {
                  makeEditable: function makeEditable() {
                    c = Object.assign({}, c, {
                      isEditable: !0
                    }), i({
                      domElement: a,
                      editor: t,
                      state: c,
                      props: l
                    }), n.change(function (t) {
                      t.setAttribute("data-cke-ignore-events", "true", h);
                    }), a.querySelector("textarea").focus();
                  },
                  save: function save(e) {
                    e !== c.getRawHtmlValue() ? (t.execute("updateHtmlEmbed", e), t.editing.view.focus()) : this.cancel();
                  },
                  cancel: function cancel() {
                    c = Object.assign({}, c, {
                      isEditable: !1
                    }), i({
                      domElement: a,
                      editor: t,
                      state: c,
                      props: l
                    }), t.editing.view.focus(), n.change(function (t) {
                      t.removeAttribute("data-cke-ignore-events", h);
                    });
                  }
                };
              return c = {
                showPreviews: o.showPreviews,
                isEditable: !1,
                getRawHtmlValue: function getRawHtmlValue() {
                  return r.getAttribute("value") || "";
                }
              }, l = {
                sanitizeHtml: o.sanitizeHtml,
                textareaPlaceholder: e("Paste raw HTML here..."),
                onEditClick: function onEditClick() {
                  u.makeEditable();
                },
                onSaveClick: function onSaveClick(t) {
                  u.save(t);
                },
                onCancelClick: function onCancelClick() {
                  u.cancel();
                }
              }, s.insert(s.createPositionAt(d, 0), h), s.setCustomProperty("rawHtmlApi", u, d), s.setCustomProperty("rawHtml", !0, d), um(d, s, {
                widgetLabel: e("HTML snippet"),
                hasSelectionHandle: !0
              });
            }
          });
        }
      }]);
      return RA;
    }(Jt);
    function jA(t, e) {
      var n = t.locale.t,
        o = new Sd(t.locale),
        i = t.commands.get("updateHtmlEmbed");
      return o.set({
        tooltipPosition: "rtl" === t.locale.uiLanguageDirection ? "e" : "w",
        icon: ql.pencil,
        tooltip: !0
      }), o.render(), "edit" === e ? o.set({
        icon: ql.pencil,
        label: n("Edit source"),
        class: "raw-html-embed__edit-button"
      }) : "save" === e ? (o.set({
        icon: ql.check,
        label: n("Save changes"),
        class: "raw-html-embed__save-button"
      }), o.bind("isEnabled").to(i, "isEnabled")) : o.set({
        icon: ql.cancel,
        label: n("Cancel"),
        class: "raw-html-embed__cancel-button"
      }), o.destroy(), o.element.cloneNode(!0);
    }
    var FA = /*#__PURE__*/function (_Jt76) {
      _inherits(FA, _Jt76);
      function FA() {
        _classCallCheck(this, FA);
        return _possibleConstructorReturn(this, _getPrototypeOf(FA).apply(this, arguments));
      }
      _createClass(FA, [{
        key: "init",
        value: function init() {
          var _this322 = this;
          var t = this.editor,
            e = t.t;
          t.ui.componentFactory.add("htmlEmbed", function (n) {
            var o = t.commands.get("insertHtmlEmbed"),
              i = new Sd(n);
            return i.set({
              label: e("Insert HTML"),
              icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M17 0a2 2 0 0 1 2 2v7a1 1 0 0 1 1 1v5a1 1 0 0 1-.883.993l-.118.006L19 17a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2l-.001-1.001-.116-.006A1 1 0 0 1 0 15v-5a1 1 0 0 1 .999-1L1 2a2 2 0 0 1 2-2h14zm.499 15.999h-15L2.5 17a.5.5 0 0 0 .5.5h14a.5.5 0 0 0 .5-.5l-.001-1.001zm-3.478-6.013-.014.014H14v.007l-1.525 1.525-1.46-1.46-.015.013V10h-1v5h1v-3.53l1.428 1.43.048.043.131-.129L14 11.421V15h1v-5h-.965l-.014-.014zM2 10H1v5h1v-2h2v2h1v-5H4v2H2v-2zm7 0H6v1h1v4h1v-4h1v-1zm8 0h-1v5h3v-1h-2v-4zm0-8.5H3a.5.5 0 0 0-.5.5l-.001 6.999h15L17.5 2a.5.5 0 0 0-.5-.5zM10 7v1H4V7h6zm3-2v1H4V5h9zm-3-2v1H4V3h6z"/></svg>',
              tooltip: !0
            }), i.bind("isEnabled").to(o, "isEnabled"), _this322.listenTo(i, "execute", function () {
              t.execute("insertHtmlEmbed"), t.editing.view.focus();
              t.editing.view.document.selection.getSelectedElement().getCustomProperty("rawHtmlApi").makeEditable();
            }), i;
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "HtmlEmbedUI";
        }
      }]);
      return FA;
    }(Jt);
    var VA = /*#__PURE__*/function (_ju) {
      _inherits(VA, _ju);
      function VA() {
        _classCallCheck(this, VA);
        return _possibleConstructorReturn(this, _getPrototypeOf(VA).apply(this, arguments));
      }
      return VA;
    }(ju);
    VA.builtinPlugins = [/*#__PURE__*/function (_Jt77) {
      _inherits(_class3, _Jt77);
      function _class3() {
        _classCallCheck(this, _class3);
        return _possibleConstructorReturn(this, _getPrototypeOf(_class3).apply(this, arguments));
      }
      _createClass(_class3, null, [{
        key: "requires",
        get: function get() {
          return [qu, Yu];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "Alignment";
        }
      }]);
      return _class3;
    }(Jt), /*#__PURE__*/function (_Jt78) {
      _inherits(_class4, _Jt78);
      function _class4() {
        _classCallCheck(this, _class4);
        return _possibleConstructorReturn(this, _getPrototypeOf(_class4).apply(this, arguments));
      }
      _createClass(_class4, [{
        key: "afterInit",
        value: function afterInit() {
          this._addListAutoformats(), this._addBasicStylesAutoformats(), this._addHeadingAutoformats(), this._addBlockQuoteAutoformats(), this._addCodeBlockAutoformats(), this._addHorizontalLineAutoformats();
        }
      }, {
        key: "_addListAutoformats",
        value: function _addListAutoformats() {
          var _this323 = this;
          var t = this.editor.commands;
          t.get("bulletedList") && Qu(this.editor, this, /^[*-]\s$/, "bulletedList"), t.get("numberedList") && Qu(this.editor, this, /^1[.|)]\s$/, "numberedList"), t.get("todoList") && Qu(this.editor, this, /^\[\s?\]\s$/, "todoList"), t.get("checkTodoList") && Qu(this.editor, this, /^\[\s?x\s?\]\s$/, function () {
            _this323.editor.execute("todoList"), _this323.editor.execute("checkTodoList");
          });
        }
      }, {
        key: "_addBasicStylesAutoformats",
        value: function _addBasicStylesAutoformats() {
          var t = this.editor.commands;
          if (t.get("bold")) {
            var _t406 = Zu(this.editor, "bold");
            $u(this.editor, this, /(?:^|\s)(\*\*)([^*]+)(\*\*)$/g, _t406), $u(this.editor, this, /(?:^|\s)(__)([^_]+)(__)$/g, _t406);
          }
          if (t.get("italic")) {
            var _t407 = Zu(this.editor, "italic");
            $u(this.editor, this, /(?:^|\s)(\*)([^*_]+)(\*)$/g, _t407), $u(this.editor, this, /(?:^|\s)(_)([^_]+)(_)$/g, _t407);
          }
          if (t.get("code")) {
            var _t408 = Zu(this.editor, "code");
            $u(this.editor, this, /(`)([^`]+)(`)$/g, _t408);
          }
          if (t.get("strikethrough")) {
            var _t409 = Zu(this.editor, "strikethrough");
            $u(this.editor, this, /(~~)([^~]+)(~~)$/g, _t409);
          }
        }
      }, {
        key: "_addHeadingAutoformats",
        value: function _addHeadingAutoformats() {
          var _this324 = this;
          var t = this.editor.commands.get("heading");
          t && t.modelElements.filter(function (t) {
            return t.match(/^heading[1-6]$/);
          }).forEach(function (e) {
            var n = e[7],
              o = new RegExp("^(#{".concat(n, "})\\s$"));
            Qu(_this324.editor, _this324, o, function () {
              if (!t.isEnabled || t.value === e) return !1;
              _this324.editor.execute("heading", {
                value: e
              });
            });
          });
        }
      }, {
        key: "_addBlockQuoteAutoformats",
        value: function _addBlockQuoteAutoformats() {
          this.editor.commands.get("blockQuote") && Qu(this.editor, this, /^>\s$/, "blockQuote");
        }
      }, {
        key: "_addCodeBlockAutoformats",
        value: function _addCodeBlockAutoformats() {
          this.editor.commands.get("codeBlock") && Qu(this.editor, this, /^```$/, "codeBlock");
        }
      }, {
        key: "_addHorizontalLineAutoformats",
        value: function _addHorizontalLineAutoformats() {
          this.editor.commands.get("horizontalLine") && Qu(this.editor, this, /^---$/, "horizontalLine");
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "Autoformat";
        }
      }]);
      return _class4;
    }(Jt), /*#__PURE__*/function (_Jt79) {
      _inherits(_class5, _Jt79);
      function _class5() {
        _classCallCheck(this, _class5);
        return _possibleConstructorReturn(this, _getPrototypeOf(_class5).apply(this, arguments));
      }
      _createClass(_class5, null, [{
        key: "requires",
        get: function get() {
          return [Wg, Yg];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "BlockQuote";
        }
      }]);
      return _class5;
    }(Jt), /*#__PURE__*/function (_Jt80) {
      _inherits(_class6, _Jt80);
      function _class6() {
        _classCallCheck(this, _class6);
        return _possibleConstructorReturn(this, _getPrototypeOf(_class6).apply(this, arguments));
      }
      _createClass(_class6, null, [{
        key: "requires",
        get: function get() {
          return [Jg, Xg];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "Bold";
        }
      }]);
      return _class6;
    }(Jt), /*#__PURE__*/function (_Jt81) {
      _inherits(_class7, _Jt81);
      function _class7() {
        _classCallCheck(this, _class7);
        return _possibleConstructorReturn(this, _getPrototypeOf(_class7).apply(this, arguments));
      }
      _createClass(_class7, null, [{
        key: "requires",
        get: function get() {
          return [qm, og, Zm, ag, Ag, cp];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "Essentials";
        }
      }]);
      return _class7;
    }(Jt), /*#__PURE__*/function (_Jt82) {
      _inherits(_class8, _Jt82);
      function _class8() {
        _classCallCheck(this, _class8);
        return _possibleConstructorReturn(this, _getPrototypeOf(_class8).apply(this, arguments));
      }
      _createClass(_class8, null, [{
        key: "requires",
        get: function get() {
          return [Cp, _p];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "FontColor";
        }
      }]);
      return _class8;
    }(Jt), /*#__PURE__*/function (_Jt83) {
      _inherits(_class9, _Jt83);
      function _class9() {
        _classCallCheck(this, _class9);
        return _possibleConstructorReturn(this, _getPrototypeOf(_class9).apply(this, arguments));
      }
      _createClass(_class9, null, [{
        key: "requires",
        get: function get() {
          return [Dp, Mp];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "FontFamily";
        }
      }]);
      return _class9;
    }(Jt), /*#__PURE__*/function (_Jt84) {
      _inherits(_class10, _Jt84);
      function _class10() {
        _classCallCheck(this, _class10);
        return _possibleConstructorReturn(this, _getPrototypeOf(_class10).apply(this, arguments));
      }
      _createClass(_class10, null, [{
        key: "requires",
        get: function get() {
          return [Pp, Op];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "FontSize";
        }
      }]);
      return _class10;
    }(Jt), /*#__PURE__*/function (_Jt85) {
      _inherits(_class11, _Jt85);
      function _class11() {
        _classCallCheck(this, _class11);
        return _possibleConstructorReturn(this, _getPrototypeOf(_class11).apply(this, arguments));
      }
      _createClass(_class11, null, [{
        key: "requires",
        get: function get() {
          return [Wp, Yp];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "Heading";
        }
      }]);
      return _class11;
    }(Jt), /*#__PURE__*/function (_Jt86) {
      _inherits(_class12, _Jt86);
      function _class12() {
        _classCallCheck(this, _class12);
        return _possibleConstructorReturn(this, _getPrototypeOf(_class12).apply(this, arguments));
      }
      _createClass(_class12, null, [{
        key: "requires",
        get: function get() {
          return [If, Sf];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "Image";
        }
      }]);
      return _class12;
    }(Jt), /*#__PURE__*/function (_Jt87) {
      _inherits(_class13, _Jt87);
      function _class13() {
        _classCallCheck(this, _class13);
        return _possibleConstructorReturn(this, _getPrototypeOf(_class13).apply(this, arguments));
      }
      _createClass(_class13, null, [{
        key: "requires",
        get: function get() {
          return [zf, Of];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "ImageCaption";
        }
      }]);
      return _class13;
    }(Jt), /*#__PURE__*/function (_Jt88) {
      _inherits(_class14, _Jt88);
      function _class14() {
        _classCallCheck(this, _class14);
        return _possibleConstructorReturn(this, _getPrototypeOf(_class14).apply(this, arguments));
      }
      _createClass(_class14, null, [{
        key: "requires",
        get: function get() {
          return [tk, ok];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "ImageStyle";
        }
      }]);
      return _class14;
    }(Jt), /*#__PURE__*/function (_Jt89) {
      _inherits(_class15, _Jt89);
      function _class15() {
        _classCallCheck(this, _class15);
        return _possibleConstructorReturn(this, _getPrototypeOf(_class15).apply(this, arguments));
      }
      _createClass(_class15, [{
        key: "afterInit",
        value: function afterInit() {
          var t = this.editor,
            e = t.t,
            n = t.plugins.get(Qp),
            o = t.plugins.get("ImageUtils");
          var i;
          n.register("image", {
            ariaLabel: e("Image toolbar"),
            items: (i = t.config.get("image.toolbar") || [], i.map(function (t) {
              return w(t) ? t.name : t;
            })),
            getRelatedElement: function getRelatedElement(t) {
              return o.getClosestSelectedImageWidget(t);
            }
          });
        }
      }], [{
        key: "requires",
        get: function get() {
          return [Qp, lf];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "ImageToolbar";
        }
      }]);
      return _class15;
    }(Jt), /*#__PURE__*/function (_Jt90) {
      _inherits(_class16, _Jt90);
      function _class16() {
        _classCallCheck(this, _class16);
        return _possibleConstructorReturn(this, _getPrototypeOf(_class16).apply(this, arguments));
      }
      _createClass(_class16, null, [{
        key: "pluginName",
        get: function get() {
          return "ImageUpload";
        }
      }, {
        key: "requires",
        get: function get() {
          return [Tk, fk, vk];
        }
      }]);
      return _class16;
    }(Jt), /*#__PURE__*/function (_Jt91) {
      _inherits(_class17, _Jt91);
      function _class17() {
        _classCallCheck(this, _class17);
        return _possibleConstructorReturn(this, _getPrototypeOf(_class17).apply(this, arguments));
      }
      _createClass(_class17, null, [{
        key: "pluginName",
        get: function get() {
          return "Indent";
        }
      }, {
        key: "requires",
        get: function get() {
          return [Nk, zk];
        }
      }]);
      return _class17;
    }(Jt), /*#__PURE__*/function (_Jt92) {
      _inherits(_class18, _Jt92);
      function _class18() {
        _classCallCheck(this, _class18);
        return _possibleConstructorReturn(this, _getPrototypeOf(_class18).apply(this, arguments));
      }
      _createClass(_class18, null, [{
        key: "requires",
        get: function get() {
          return [Ok, jk];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "Italic";
        }
      }]);
      return _class18;
    }(Jt), /*#__PURE__*/function (_Jt93) {
      _inherits(_class19, _Jt93);
      function _class19() {
        _classCallCheck(this, _class19);
        return _possibleConstructorReturn(this, _getPrototypeOf(_class19).apply(this, arguments));
      }
      _createClass(_class19, null, [{
        key: "requires",
        get: function get() {
          return [Ab, Nb, zb];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "Link";
        }
      }]);
      return _class19;
    }(Jt), /*#__PURE__*/function (_Jt94) {
      _inherits(_class20, _Jt94);
      function _class20() {
        _classCallCheck(this, _class20);
        return _possibleConstructorReturn(this, _getPrototypeOf(_class20).apply(this, arguments));
      }
      _createClass(_class20, null, [{
        key: "requires",
        get: function get() {
          return [aw, lw];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "List";
        }
      }]);
      return _class20;
    }(Jt), /*#__PURE__*/function (_Jt95) {
      _inherits(_class21, _Jt95);
      function _class21() {
        _classCallCheck(this, _class21);
        return _possibleConstructorReturn(this, _getPrototypeOf(_class21).apply(this, arguments));
      }
      _createClass(_class21, null, [{
        key: "requires",
        get: function get() {
          return [ww, xw, Aw, zm];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "MediaEmbed";
        }
      }]);
      return _class21;
    }(Jt), Vp, /*#__PURE__*/function (_Jt96) {
      _inherits(_class22, _Jt96);
      function _class22() {
        _classCallCheck(this, _class22);
        return _possibleConstructorReturn(this, _getPrototypeOf(_class22).apply(this, arguments));
      }
      _createClass(_class22, [{
        key: "init",
        value: function init() {
          var t = this.editor,
            e = t.editing.view.document,
            n = [];
          n.push(new Fw(e)), n.push(new Bw(e)), t.plugins.get("ClipboardPipeline").on("inputTransformation", function (t, e) {
            if (e.isTransformedWithPasteFromOffice) return;
            var o = e.dataTransfer.getData("text/html"),
              i = n.find(function (t) {
                return t.isActive(o);
              });
            i && (i.execute(e), e.isTransformedWithPasteFromOffice = !0);
          }, {
            priority: "high"
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "PasteFromOffice";
        }
      }, {
        key: "requires",
        get: function get() {
          return [im];
        }
      }]);
      return _class22;
    }(Jt), /*#__PURE__*/function (_Jt97) {
      _inherits(_class23, _Jt97);
      function _class23() {
        _classCallCheck(this, _class23);
        return _possibleConstructorReturn(this, _getPrototypeOf(_class23).apply(this, arguments));
      }
      _createClass(_class23, [{
        key: "init",
        value: function init() {
          var t = this.editor.config.get("simpleUpload");
          t && (t.uploadUrl ? this.editor.plugins.get(ck).createUploadAdapter = function (e) {
            return new uk(e, t);
          } : Object(c.b)("simple-upload-adapter-missing-uploadurl"));
        }
      }], [{
        key: "requires",
        get: function get() {
          return [ck];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "SimpleUploadAdapter";
        }
      }]);
      return _class23;
    }(Jt), /*#__PURE__*/function (_Jt98) {
      _inherits(_class24, _Jt98);
      function _class24() {
        _classCallCheck(this, _class24);
        return _possibleConstructorReturn(this, _getPrototypeOf(_class24).apply(this, arguments));
      }
      _createClass(_class24, null, [{
        key: "requires",
        get: function get() {
          return [sA, hA, pA, _A, CA, fA, zm];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "Table";
        }
      }]);
      return _class24;
    }(Jt), /*#__PURE__*/function (_Jt99) {
      _inherits(_class25, _Jt99);
      function _class25() {
        _classCallCheck(this, _class25);
        return _possibleConstructorReturn(this, _getPrototypeOf(_class25).apply(this, arguments));
      }
      _createClass(_class25, [{
        key: "afterInit",
        value: function afterInit() {
          var t = this.editor,
            e = t.t,
            n = t.plugins.get(Qp),
            o = t.config.get("table.contentToolbar"),
            i = t.config.get("table.tableToolbar");
          o && n.register("tableContent", {
            ariaLabel: e("Table toolbar"),
            items: o,
            getRelatedElement: DA
          }), i && n.register("table", {
            ariaLabel: e("Table toolbar"),
            items: i,
            getRelatedElement: EA
          });
        }
      }], [{
        key: "requires",
        get: function get() {
          return [Qp];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "TableToolbar";
        }
      }]);
      return _class25;
    }(Jt), /*#__PURE__*/function (_Jt100) {
      _inherits(_class26, _Jt100);
      _createClass(_class26, null, [{
        key: "pluginName",
        get: function get() {
          return "TextTransformation";
        }
      }]);
      function _class26(t) {
        var _this325;
        _classCallCheck(this, _class26);
        _this325 = _possibleConstructorReturn(this, _getPrototypeOf(_class26).call(this, t)), t.config.define("typing", {
          transformations: {
            include: Pg
          }
        });
        return _this325;
      }
      _createClass(_class26, [{
        key: "init",
        value: function init() {
          var _this326 = this;
          var t = this.editor.model.document.selection;
          t.on("change:range", function () {
            _this326.isEnabled = !t.anchor.parent.is("element", "codeBlock");
          }), this._enableTransformationWatchers();
        }
      }, {
        key: "_enableTransformationWatchers",
        value: function _enableTransformationWatchers() {
          var t = this.editor,
            e = t.model,
            n = t.plugins.get("Input"),
            o = function (t) {
              var e = t.extra || [],
                n = t.remove || [],
                o = function o(t) {
                  return !n.includes(t);
                };
              return function (t) {
                var e = new Set();
                var _iterator475 = _createForOfIteratorHelper(t),
                  _step475;
                try {
                  for (_iterator475.s(); !(_step475 = _iterator475.n()).done;) {
                    var _n320 = _step475.value;
                    if (Bg[_n320]) {
                      var _iterator476 = _createForOfIteratorHelper(Bg[_n320]),
                        _step476;
                      try {
                        for (_iterator476.s(); !(_step476 = _iterator476.n()).done;) {
                          var _t410 = _step476.value;
                          e.add(_t410);
                        }
                      } catch (err) {
                        _iterator476.e(err);
                      } finally {
                        _iterator476.f();
                      }
                    } else e.add(_n320);
                  }
                } catch (err) {
                  _iterator475.e(err);
                } finally {
                  _iterator475.f();
                }
                return Array.from(e);
              }(t.include.concat(e).filter(o)).filter(o).map(function (t) {
                return Ng[t] || t;
              }).map(function (t) {
                return {
                  from: zg(t.from),
                  to: Lg(t.to)
                };
              });
            }(t.config.get("typing.transformations")),
            i = new vg(t.model, function (t) {
              var _iterator477 = _createForOfIteratorHelper(o),
                _step477;
              try {
                for (_iterator477.s(); !(_step477 = _iterator477.n()).done;) {
                  var _e366 = _step477.value;
                  if (_e366.from.test(t)) return {
                    normalizedTransformation: _e366
                  };
                }
              } catch (err) {
                _iterator477.e(err);
              } finally {
                _iterator477.f();
              }
            });
          i.on("matched:data", function (t, o) {
            if (!n.isInput(o.batch)) return;
            var _o$normalizedTransfor = o.normalizedTransformation,
              i = _o$normalizedTransfor.from,
              r = _o$normalizedTransfor.to,
              s = i.exec(o.text),
              a = r(s.slice(1)),
              c = o.range;
            var l = s.index;
            e.enqueueChange(function (t) {
              for (var _n322 = 1; _n322 < s.length; _n322++) {
                var _o215 = s[_n322],
                  _i178 = a[_n322 - 1];
                if (null == _i178) {
                  l += _o215.length;
                  continue;
                }
                var _r84 = c.start.getShiftedBy(l),
                  _d10 = e.createRange(_r84, _r84.getShiftedBy(_o215.length)),
                  _h8 = Og(_r84);
                e.insertContent(t.createText(_i178, _h8), _d10), l += _i178.length;
              }
            });
          }), i.bind("isEnabled").to(this);
        }
      }]);
      return _class26;
    }(Jt), /*#__PURE__*/function (_Jt101) {
      _inherits(_class27, _Jt101);
      function _class27() {
        _classCallCheck(this, _class27);
        return _possibleConstructorReturn(this, _getPrototypeOf(_class27).apply(this, arguments));
      }
      _createClass(_class27, null, [{
        key: "requires",
        get: function get() {
          return [TA, NA];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "Underline";
        }
      }]);
      return _class27;
    }(Jt), /*#__PURE__*/function (_Jt102) {
      _inherits(_class28, _Jt102);
      function _class28() {
        _classCallCheck(this, _class28);
        return _possibleConstructorReturn(this, _getPrototypeOf(_class28).apply(this, arguments));
      }
      _createClass(_class28, null, [{
        key: "requires",
        get: function get() {
          return [RA, FA, zm];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "HtmlEmbed";
        }
      }]);
      return _class28;
    }(Jt)];
    e.default = VA;
  }]).default;
});